webpackJsonp([1],{

/***/ "+LB2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+N0q":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAADiUlEQVR4Xu1a30sUURT+zoytEKv1FPQHRIFZRBCB6M4+CJn9ICqDiNTdDaKX3nqRUiz8A4QeAmfXqCcfy4IEdVcI6cEHkyKkB4N+geRD9MO1nBNjaSQ7O3dmdmZn27uvc75zz/nud+7OuWcIVf6jKs8fkgCpgCpnQJZAlQtAHoKyBOxKoG2Qa5frsZcZdXa268+JwWRgYSJFb0Qx5bIrqoD4ELezgvsAtrsKkDGeZ3RMp2jJFT4AkCUBcZ13G4TnBES8xMGMB7kknSzkI67zaQPIEImry0UsL7CKI9lL9LYQ1pIALc09AG6ZIAYWCXgpujgDCgHNa1iGsVKH6HQHfd+Mj6V5jIBWUb8e7C5nE3THEQExnW8T4cofAgZzCboqGsDZEVYXv+Dnhr2BXdkUvd6M19J8hgGdgHpR307tGJhTVbRNdNK70BHgNBk/7C1LIAgF+JGQU5+SACvGpAICOASdytUPe1kCsgQsGJBnQEBnQMsQH1BUbPOjvk2fPwzMP03Seyv/ZT0DtAz3gtHnV/Jrfhl5UtE02UUzoXsTjKX5EQFHfSXgt/OubILuOiLgn2aI8YEI8w4CrQVweN0+UoPo2EX6uhnfkuFGhTEA+NoNzuWjuFaoGTPjse4GM7yHGbOe22FgLpegfQ7IC9S06IVILMPHycA9kLtDymyjFUbrZJJmA83KwWK2d4JNOtdtIZwHY6ewXwUMxoKqYnS8kz4J48pgaEtAGWIKdElJQKB0h3AxqYAQbkqgIUkF2NHdPMSHVFq74haeDDHBYAPZqRRN2fkv9/OiCtDSbM4FzPmAu19FT4bSHGMg6y7zv6hikyGvvkuBL9YLbLSqfk2G4sPcYKxigFy+aosQwMDScgRdzy7QZ0fdYBA3QprOoyC0iyTixYYZN3JJuhk6AmI69xPhupfk7LAMrCjAickEPQkdAWZA8WE+6OTbA7uECzx/le2mj1a4sl6JuUim5BBJgBWlQRyCJd9OFw6lAqQCLBiQJRDQZCim8ykC9rsoXyEIK5jJddPDUP4Najr3gdArlIkHI4PQPtVNj0P3IqSl2dyZYx5yE4Iy0JtLUL8jAko5GcpHsbXQZCbUzZBWqslQkQ8lhbbPZyNfJ0NgjKs1OBfm4YjtnWDDCEd2fEOjk4blv/lY2mf1hcK9rQJCEaWPQUgCfCS3IlxLBVTENvkYpFSAj+RWhOuqV8AvO0RXX1lm+7QAAAAASUVORK5CYII="

/***/ }),

/***/ "+N3V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+g8E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/IOa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/YLi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Yju":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "02nE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "02pT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0sQS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1H7Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2MTM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2tP1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Bm5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3IMD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e3872a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Ziz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3kcQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFDElEQVR4Xu2ZfYhUVRjGf+/MaH6sWmprJppZGPQFYWaUcu+omRUSQklEqTvj9x8V6D9GH2tBGqmYlB/ozLpb/1iBBJZFmXf8gNJENBX61IwEMyvaRc2ZO28cZZd1d92dmb1zd2ru/XfO+zzPec5zztz7HqHMHynz+RMYECSgzB0ItkCZByA4BIMtEGyBMncg2AJlHoDgXyDYAoVsgUl12vssDJAMAyPQR6VrkiSKapZfr+3LsfeniVvIXHJOQHSTjlKXxxCeAIYXQlasGlXSwA8IB1AcN0Jq9wz5Lhe+Dg2IbtL71WUVwt25ABZ5zI8onwAHCHGE3hw+d4FQz/NUapjBZHlAYDrCDShfS5jndsyUPe1puqIBE2p1QMalRmBKkSfVLrwqWWCdZlm+c7Ycy0VLNKmWwmLgQYUtkTCzt8+QM23VtmmAvVFv1xAfCwzNhbBYYxT2ZcPM2jVDDhXCYdfovZplDcJAyfKwM0sOt8RpZYBdo7Zm+UiEXoWQelWjyhoZwbNOVDKdwXxotV51roJaVaZIiEecKnGa411mwNg6HRZOc0CE/p0h9aB2nhOT9R7gNEFYCV0BzHS7cdfu6XKi8YcmA4xTZyvYJ3CHl8T5YqmyMhWXhfnWdTi+WkP2MD5VGNSrgdHbnpF/TE2TAVZSlwi81CFQcQeknBOMp1rMwef5M3G99ktHOCqwwYlLdZMB99VpZfcMPwG9PWfNHdBFuNmpkuO5l+Q/0k5oHOHNsMtN22fLqYsJsJK6RmB+/nAeVijrnLgUX4PZCkM5qsIXqZgskMff0/Bv9fwpQh8Pp5M3VFoZsicuJ/MuLKDASqoxelllBf3FrtHJKNsKwPGsRJW9qbiM8QywA6Bx7+jgcJqTApPFTuhahHl+kbfFo/B8KiZL/dRgJXWvKPvFTqp5MbD8JG/JJVkm7pgl2/3UYCW0ToShJgHfm9PXT/KWXC7ctismR/3UYCf1DYVHjQFphIif5K24hGucKvnLTw12QhciLDEG1CNU+EleEgYkdZHCi2Il9FsRRnalAV2xBaykrjSfy+YQ3AHYXWmACpNSVfKZnxqshG4GrjYJeFuEBX6St+JSFjtxWeanBiupP6PUSjSppmti2kxd9pjGRyom9/glYFyt3hl2OejCqEuvwg38IdDXLwFt8WQi3ND8O72YWuyEVivMScXl+ksfQyWwDRTWmo+TYk7cYI95V/v2uMBxgdecmCy/aMCEDTrIDWM+Q3sUW0A7+G4mzK25trML1WkndCnC0/Vpbtw/V9JNDRE7qa8CLxQK7FFdURsiptlLiH1ZZe7OuNQZzSXXEgNWODFZ5JGhTTAXu0Hd+AbYnYrJk40/tGqKRtIcQujntYC88JT5TlzW5VXTzmBzlXchw1aFAc37gZcloLHeSmgU2Pp/aYtHE3qLwocImoVJO2PyS3OvSvpiBNivwuKC3hIvtb7mqPC6wF4qmOpMk4aWQenoamyDwFSvotgJnC8VVouwxamS8+3hmPea0w2YFK8Chii8nDrBW1fqNP+3LkcVs4KbVTgicFqFU5qlZ0ioBK5TZbTAeMB0mDee684rXz0lf7dnWIcGNBaPrdWRYRcbZYLACHOgAAO7upmqSr0IZ1B+Bw4S4gOG83muV2o5G9CJ+JZ0aWBASS+PD+KCBPhgcklTBAko6eXxQVyQAB9MLmmKIAElvTw+iAsS4IPJJU0RJKCkl8cHcWWfgH8Bn0nBh6kh7FMAAAAASUVORK5CYII="

/***/ }),

/***/ "4B/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPopper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return offset_default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__);





// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/math.js
var round = Math.round;

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
function getDocumentElement(element) {
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;
  return (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)
  );
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/isTableElement.js
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode);
    if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/enums.js
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var placements = /* @__PURE__ */[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/orderModifiers.js
function order(modifiers) {
  var map = /* @__PURE__ */new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a();
  var visited = /* @__PURE__ */new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn2) {
  var pending;
  return function () {
    if (!pending) {
      pending = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve().then(function () {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/format.js
function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/validateModifiers.js
var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(modifier), VALID_PROPERTIES).filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case "name":
          if (typeof modifier.name !== "string") {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', '"' + String(modifier.name) + '"'));
          }
          break;
        case "enabled":
          if (typeof modifier.enabled !== "boolean") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', '"' + String(modifier.enabled) + '"'));
          }
          break;
        case "phase":
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(", "), '"' + String(modifier.phase) + '"'));
          }
          break;
        case "fn":
          if (typeof modifier.fn !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "effect":
          if (modifier.effect != null && typeof modifier.effect !== "function") {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', '"' + String(modifier.fn) + '"'));
          }
          break;
        case "requires":
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', '"' + String(modifier.requires) + '"'));
          }
          break;
        case "requiresIfExists":
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', '"' + String(modifier.requiresIfExists) + '"'));
          }
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + modifier.name + '" modifier, valid properties are ' + VALID_PROPERTIES.map(function (s) {
            return '"' + s + '"';
          }).join(", ") + '; but "' + key + '" was provided.');
      }
      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/uniqueBy.js
function uniqueBy(arr, fn2) {
  var identifiers = /* @__PURE__ */new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a();
  return arr.filter(function (item) {
    var identifier = fn2(item);
    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/getBasePlacement.js
function getBasePlacement(placement) {
  return placement.split("-")[0];
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, existing, current, {
      options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, existing.options, current.options),
      data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(merged).map(function (key) {
    return merged[key];
  });
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split("-")[1];
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/utils/computeOffsets.js
function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
      default:
    }
  }
  return offsets;
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/createPopper.js
var INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        if (true) {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);
          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === "flip";
            });
            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
            }
          }
          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft;
          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
          }
        }
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements,
            reference2 = _state$elements.reference,
            popper2 = _state$elements.popper;
        if (!areValidElements(reference2, popper2)) {
          if (true) {
            console.error(INVALID_ELEMENT_ERROR);
          }
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference2, getOffsetParent(popper2), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper2)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, modifier.data);
        });
        var __debug_loops__ = 0;
        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (true) {
            __debug_loops__ += 1;
            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index],
              fn2 = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      update: debounce(function () {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference, popper)) {
      if (true) {
        console.error(INVALID_ELEMENT_ERROR);
      }
      return instance;
    }
    instance.setOptions(options).then(function (state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options2 = _ref3$options === void 0 ? {} : _ref3$options,
            effect3 = _ref3.effect;
        if (typeof effect3 === "function") {
          var cleanupFn = effect3({
            state: state,
            name: name,
            instance: instance,
            options: options2
          });
          var noopFn = function noopFn2() {};
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/modifiers/eventListeners.js
var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners_default = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {},
  effect: effect,
  data: {}
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets_default = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/modifiers/computeStyles.js
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
      if (getComputedStyle(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
    position: position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  if (true) {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || "";
    if (adaptive && ["transform", "top", "right", "bottom", "left"].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', "\n\n", 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", "\n\n", "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
    }
  }
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.styles.popper, mapToStyles(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.styles.arrow, mapToStyles(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }
  state.attributes.popper = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles_default = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/modifiers/applyStyles.js
function applyStyles(_ref) {
  var state = _ref.state;
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(element.style, style);
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(attributes).forEach(function (name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.elements.arrow.style, initialStyles.arrow);
  }
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function (style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(element.style, style);
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles_default = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect2,
  requires: ["computeStyles"]
};

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/popper-lite.js
var defaultModifiers = [eventListeners_default, popperOffsets_default, computeStyles_default, applyStyles_default];
var createPopper = /* @__PURE__ */popperGenerator({
  defaultModifiers: defaultModifiers
});

// ../../node_modules/.pnpm/@popperjs+core@2.11.6/node_modules/@popperjs/core/lib/modifiers/offset.js
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, rects, {
    placement: placement
  })) : offset2,
      skidding = _ref[0],
      distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name] = data;
}
var offset_default = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};


/***/ }),

/***/ "4WEX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4ht9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/signature_pad/dist/signature_pad.js
var signature_pad = __webpack_require__("hJLJ");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-signature/src/components/vueSignature.vue
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//


/* harmony default export */ var vueSignature = ({
	name: "vueSignature",
	props: {
		sigOption: {
			type: Object,
			default: function _default() {
				return {
					backgroundColor: 'rgb(255,255,255)',
					penColor: 'rgb(0, 0, 0)'
				};
			}
		},
		w: {
			type: String,
			default: "100%"
		},
		h: {
			type: String,
			default: "100%"
		},
		clearOnResize: {
			type: Boolean,
			default: false
		},
		waterMark: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		defaultUrl: {
			type: String,
			default: ""
		}
	},
	data: function data() {
		return {
			sig: function sig() {},
			option: {
				backgroundColor: 'rgb(255,255,255)',
				penColor: 'rgb(0, 0, 0)'
			},
			uid: ""
		};
	},

	watch: {
		disabled: function disabled(val) {
			var _this = this;
			if (_this.sig.off) {
				if (val) {
					_this.sig.off();
				} else {
					_this.sig.on();
				}
			}
		}
	},
	created: function created() {
		var _this = this;
		this.uid = "canvas" + _this._uid;
		var sigOptions = Object.keys(_this.sigOption);
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = sigOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var item = _step.value;

				_this.option[item] = _this.sigOption[item];
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	},

	methods: {
		draw: function draw() {
			var _this = this;
			var canvas = document.getElementById(_this.uid);
			_this.sig = new signature_pad["a" /* default */](canvas, _this.option);
			_this.attachEventListeners();

			function resizeCanvas(c) {
				var url;
				if (!_this.isEmpty()) {
					url = _this.save();
				}
				var ratio = Math.max(window.devicePixelRatio || 1, 1);
				var reg = RegExp(/px/);
				c.width = reg.test(_this.w) ? _this.w.replace(/px/g, "") * ratio : c.offsetWidth * ratio;
				c.height = reg.test(_this.h) ? _this.h.replace(/px/g, "") * ratio : c.offsetHeight * ratio;
				c.getContext("2d").scale(ratio, ratio);
				_this.clear();
				!_this.clearOnResize && url !== undefined && _this.fromDataURL(url);
				Object.keys(_this.waterMark).length && _this.addWaterMark(_this.waterMark);
			}
			window.addEventListener("resize", resizeCanvas(canvas));
			resizeCanvas(canvas);

			if (_this.defaultUrl !== "") {
				_this.fromDataURL(_this.defaultUrl);
			}

			if (_this.disabled) {
				_this.sig.off();
			} else {
				_this.sig.on();
			}
		},
		clear: function clear() {
			var _this = this;
			_this.sig.clear();
		},
		save: function save(format) {
			var _this = this;
			return format ? _this.sig.toDataURL(format) : _this.sig.toDataURL();
			// signaturePad.toDataURL(); // save image as PNG
			// signaturePad.toDataURL("image/jpeg"); // save image as JPEG
			// signaturePad.toDataURL("image/svg+xml"); // save image as SVG
		},
		fromDataURL: function fromDataURL(url) {
			var _this = this;
			_this.sig.fromDataURL(url);
		},
		isEmpty: function isEmpty() {
			var _this = this;
			return _this.sig.isEmpty();
		},
		undo: function undo() {
			var _this = this;
			var data = _this.sig.toData();
			if (data) {
				data.pop();
				_this.sig.fromData(data);
			}
		},
		addWaterMark: function addWaterMark(data) {
			var _this = this;
			if (!(Object.prototype.toString.call(data) == '[object Object]')) {
				throw new Error("Expected Object, got " + (typeof data === 'undefined' ? 'undefined' : _typeof(data)) + ".");
			} else {
				var vCanvas = document.getElementById(_this.uid);

				var textData = {
					text: data.text || '',
					x: data.x || 20,
					y: data.y || 20,
					sx: data.sx || 40,
					sy: data.sy || 40
				};

				var ctx = vCanvas.getContext('2d');
				ctx.font = data.font || '20px sans-serif';
				ctx.fillStyle = data.fillStyle || "#333";
				ctx.strokeStyle = data.strokeStyle || "#333";
				if (data.style == 'all') {
					ctx.fillText(textData.text, textData.x, textData.y);
					ctx.strokeText(textData.text, textData.sx, textData.sy);
				} else if (data.style == 'stroke') {
					ctx.strokeText(textData.text, textData.sx, textData.sy);
				} else {
					ctx.fillText(textData.text, textData.x, textData.y);
				}

				_this.sig._isEmpty = false;
			}
		},
		attachEventListeners: function attachEventListeners() {
			var _this = this;

			_this.sig.addEventListener('beginStroke', function (event) {
				return _this.$emit('beginStroke', event);
			});
			_this.sig.addEventListener('endStroke', function (event) {
				return _this.$emit('endStroke', event);
			});
			_this.sig.addEventListener('beforeUpdateStroke', function (event) {
				return _this.$emit('beforeUpdateStroke', event);
			});
			_this.sig.addEventListener('afterUpdateStroke', function (event) {
				return _this.$emit('afterUpdateStroke', event);
			});
		}
	},
	mounted: function mounted() {
		var _this = this;
		this.$nextTick().then(function () {
			_this.draw();
		});
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-signature/src/components/vueSignature.vue
var vueSignature__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//


/* harmony default export */ var components_vueSignature = ({
	name: "vueSignature",
	props: {
		sigOption: {
			type: Object,
			default: function _default() {
				return {
					backgroundColor: 'rgb(255,255,255)',
					penColor: 'rgb(0, 0, 0)'
				};
			}
		},
		w: {
			type: String,
			default: "100%"
		},
		h: {
			type: String,
			default: "100%"
		},
		clearOnResize: {
			type: Boolean,
			default: false
		},
		waterMark: {
			type: Object,
			default: function _default() {
				return {};
			}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		defaultUrl: {
			type: String,
			default: ""
		}
	},
	data: function data() {
		return {
			sig: function sig() {},
			option: {
				backgroundColor: 'rgb(255,255,255)',
				penColor: 'rgb(0, 0, 0)'
			},
			uid: ""
		};
	},

	watch: {
		disabled: function disabled(val) {
			var _this = this;
			if (_this.sig.off) {
				if (val) {
					_this.sig.off();
				} else {
					_this.sig.on();
				}
			}
		}
	},
	created: function created() {
		var _this = this;
		this.uid = "canvas" + _this._uid;
		var sigOptions = Object.keys(_this.sigOption);
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = sigOptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var item = _step.value;

				_this.option[item] = _this.sigOption[item];
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	},

	methods: {
		draw: function draw() {
			var _this = this;
			var canvas = document.getElementById(_this.uid);
			_this.sig = new signature_pad["a" /* default */](canvas, _this.option);
			_this.attachEventListeners();

			function resizeCanvas(c) {
				var url;
				if (!_this.isEmpty()) {
					url = _this.save();
				}
				var ratio = Math.max(window.devicePixelRatio || 1, 1);
				var reg = RegExp(/px/);
				c.width = reg.test(_this.w) ? _this.w.replace(/px/g, "") * ratio : c.offsetWidth * ratio;
				c.height = reg.test(_this.h) ? _this.h.replace(/px/g, "") * ratio : c.offsetHeight * ratio;
				c.getContext("2d").scale(ratio, ratio);
				_this.clear();
				!_this.clearOnResize && url !== undefined && _this.fromDataURL(url);
				Object.keys(_this.waterMark).length && _this.addWaterMark(_this.waterMark);
			}
			window.addEventListener("resize", resizeCanvas(canvas));
			resizeCanvas(canvas);

			if (_this.defaultUrl !== "") {
				_this.fromDataURL(_this.defaultUrl);
			}

			if (_this.disabled) {
				_this.sig.off();
			} else {
				_this.sig.on();
			}
		},
		clear: function clear() {
			var _this = this;
			_this.sig.clear();
		},
		save: function save(format) {
			var _this = this;
			return format ? _this.sig.toDataURL(format) : _this.sig.toDataURL();
			// signaturePad.toDataURL(); // save image as PNG
			// signaturePad.toDataURL("image/jpeg"); // save image as JPEG
			// signaturePad.toDataURL("image/svg+xml"); // save image as SVG
		},
		fromDataURL: function fromDataURL(url) {
			var _this = this;
			_this.sig.fromDataURL(url);
		},
		isEmpty: function isEmpty() {
			var _this = this;
			return _this.sig.isEmpty();
		},
		undo: function undo() {
			var _this = this;
			var data = _this.sig.toData();
			if (data) {
				data.pop();
				_this.sig.fromData(data);
			}
		},
		addWaterMark: function addWaterMark(data) {
			var _this = this;
			if (!(Object.prototype.toString.call(data) == '[object Object]')) {
				throw new Error("Expected Object, got " + (typeof data === 'undefined' ? 'undefined' : vueSignature__typeof(data)) + ".");
			} else {
				var vCanvas = document.getElementById(_this.uid);

				var textData = {
					text: data.text || '',
					x: data.x || 20,
					y: data.y || 20,
					sx: data.sx || 40,
					sy: data.sy || 40
				};

				var ctx = vCanvas.getContext('2d');
				ctx.font = data.font || '20px sans-serif';
				ctx.fillStyle = data.fillStyle || "#333";
				ctx.strokeStyle = data.strokeStyle || "#333";
				if (data.style == 'all') {
					ctx.fillText(textData.text, textData.x, textData.y);
					ctx.strokeText(textData.text, textData.sx, textData.sy);
				} else if (data.style == 'stroke') {
					ctx.strokeText(textData.text, textData.sx, textData.sy);
				} else {
					ctx.fillText(textData.text, textData.x, textData.y);
				}

				_this.sig._isEmpty = false;
			}
		},
		attachEventListeners: function attachEventListeners() {
			var _this = this;

			_this.sig.addEventListener('beginStroke', function (event) {
				return _this.$emit('beginStroke', event);
			});
			_this.sig.addEventListener('endStroke', function (event) {
				return _this.$emit('endStroke', event);
			});
			_this.sig.addEventListener('beforeUpdateStroke', function (event) {
				return _this.$emit('beforeUpdateStroke', event);
			});
			_this.sig.addEventListener('afterUpdateStroke', function (event) {
				return _this.$emit('afterUpdateStroke', event);
			});
		}
	},
	mounted: function mounted() {
		var _this = this;
		this.$nextTick().then(function () {
			_this.draw();
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-956e2342","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-signature/src/components/vueSignature.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: _vm.w, height: _vm.h }),on:{"touchmove":function($event){$event.preventDefault();}}},[_c('canvas',{staticClass:"canvas",attrs:{"id":_vm.uid,"data-uid":_vm.uid,"disabled":_vm.disabled}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_vueSignature = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-signature/src/components/vueSignature.vue
function injectStyle (ssrContext) {
  __webpack_require__("QJDj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_vueSignature,
  src_components_vueSignature,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_signature_src_components_vueSignature = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4v1l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Hoj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Kku":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5VbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aNE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5cou":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5jbP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5twO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFZklEQVR4Xu2aa4hUZRjHf8/shbQWs1Lzsl0WwbxAhRao657ZzS8qlZQshbTunnETIkWkSAxBuhAZEVRCXmbGCxGtGvil6GI7Z9fLh1jogxcquloqqUWt2WV2zhPvYcZmZse9EDt71jnnywzv5bzP83/+/+e9HaHEHylx/wkACBhQ4ggEEihxAgRJMJBAIIESRyCQQIkTIJgFCkogHNebUbYDc4EbRzhLLgBHEVoTLXI235deANS+rWPL/uK4CBNHuOM55qtyxhXu7LTlXHZFLwDCMd0JrLianM/4osoeJyJNfQMQ1XMIN12NAKCcT0RkXH8M0FzusF/g2faIfDGSQKmP6jQVXgCWZdudsCWH9YUkkAtAiupEq/w4kpzP2NqwSye7KXJsHzQA+R1GGhDhmOYENABgsBIIGJCHWNEloCoNu5mkKaYk4Vz57fyQqJeegdpRVAlYcb1HXJaocNqxZVsvIzdpKDyFRoQ7vLoQmlL2dtpyopBDVlzvR9kiUH25XvlNYaNzii1sErc/IIoCwMw2rRzXzTqFF0UIAV0JW+ZkG1cX03mi7BBhep7RKYXNji0bssutqK4T4dUrOagQd2yxhx0AK6obBNYgTMgyJgeA+p06303RLkKFKr+At7YwQFkIU9P9HknY8q75b+ZwF06kwdyXVOxJVVw6f4m73BRGlE+YdhKitr1ZDvcFwpAzIGuAFMq3aYdyALBi2iGwADjrCnUdLfJVxmgrpgcFGlTpcCJimfJwVNcjvKRK8p8qxhxtlD//k4CKFeO8CDcALydsWT/sAJiNRkh41FWWi9CaLYG5bTqqspuL6WiuTtjyZrbB4Zg+BbxinHUiUmnq6uK6OORyr8IFJyJv5DtoRdWwY7rCa44t64YVgLq4PjThWg7sbZSUFdVt+QDUbdfpoTK8JKdKgxOR9jytvy7CaoXfHVvG9Kfp+VGtKoezIoxWodFpkb3DCkCeM70AMAZXhJht2iVdug5HpDvTx6uDb8zmS+FTx5b7CjmzYI9OLOthGko58AywUJWPpIYl/U2JQ54D+gPgitExU+ItmKSX2axcToL5fcIxXQW8lVX+SXeSB7tWyaX+GONLAMJxvV7Vmwka0g7sSNhickfBp36nzlaXpSizVFgsYHLF17gsTayUY76WQIEEtgi89cAkLy/Ae+Ovo9HkkP6iaeobduitrvAh4knie2qY2pcMfMWAcEyXqfKuNyMoF12IdESkrRflo9oM3IZwLGHLvgL13jRpyiXErPZmOX4l8HwDgBXV50TYmI76O8ly1h5pkp8LGW7FNCpgq3LSiciMAix6WoTNptxNMaOjVU76GoBwTBcCH6eN3JVooQWR3IOXLA+sqC4S4X0vwi4L21fKwUz17K1aUVXOEYQ5KD3UMMr3EghHtROh1ix2zKJH8H57PalKtnY+JmdMRTiqnxknVen2oi0cUte7x1grwgNeZ2VLIiJP+joJmoyP8utAEpyEmNPeLF2mbV1Mq0U5IMLdhfqq0jb6D5o+WCN/+xqA2pjWlENsIAD0lPH4oRXy5eW2Zq1QTZNCDcIsgbEo3ynszl9R+iIHDMTJYrcp6ixQbOcGMl4AQHAq/D+PxRnBFyPh7TqFMk5lS2XQ9wIo+12XjX2ttgaixWK38c4hQjyP8PCgALCi+lNmo1Jso4d6PFVOOxGZnD1OqV2Pm/VDztV/LwDm7dbxFUk+vxo/kEhdw8xDyyVnVVrwExlzBBVKshVlfvr0dajZOWTv947hhcNuBasy+4w+JTBklvj0xcF3gj4NTNHMChhQNKh9OlDAAJ8GpmhmBQwoGtQ+HShggE8DUzSzAgYUDWqfDlTyDPgXuX3cX4e6M1EAAAAASUVORK5CYII="

/***/ }),

/***/ "5xH4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "6L1p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Ztr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6f65":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6lz/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7DAO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Hiq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7jM4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8F+s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8NIx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9lt8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9mUp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AHNf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BQKN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Bdcp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Begl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("lvdZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CMiz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CaxX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ckmr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DHz/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DW6m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EBXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EYVM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EcNG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eg2E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FHgB":
/***/ (function(module, exports) {

module.exports = [{"name":"北京市","value":"110000"},{"name":"天津市","value":"120000"},{"name":"河北省","value":"130000"},{"name":"山西省","value":"140000"},{"name":"内蒙古自治区","value":"150000"},{"name":"辽宁省","value":"210000"},{"name":"吉林省","value":"220000"},{"name":"黑龙江省","value":"230000"},{"name":"上海市","value":"310000"},{"name":"江苏省","value":"320000"},{"name":"浙江省","value":"330000"},{"name":"安徽省","value":"340000"},{"name":"福建省","value":"350000"},{"name":"江西省","value":"360000"},{"name":"山东省","value":"370000"},{"name":"河南省","value":"410000"},{"name":"湖北省","value":"420000"},{"name":"湖南省","value":"430000"},{"name":"广东省","value":"440000"},{"name":"广西壮族自治区","value":"450000"},{"name":"海南省","value":"460000"},{"name":"重庆市","value":"500000"},{"name":"四川省","value":"510000"},{"name":"贵州省","value":"520000"},{"name":"云南省","value":"530000"},{"name":"西藏自治区","value":"540000"},{"name":"陕西省","value":"610000"},{"name":"甘肃省","value":"620000"},{"name":"青海省","value":"630000"},{"name":"宁夏回族自治区","value":"640000"},{"name":"新疆维吾尔自治区","value":"650000"},{"name":"市辖区","value":"110100","parent":"110000"},{"name":"东城区","value":"110101","parent":"110100"},{"name":"西城区","value":"110102","parent":"110100"},{"name":"朝阳区","value":"110105","parent":"110100"},{"name":"丰台区","value":"110106","parent":"110100"},{"name":"石景山区","value":"110107","parent":"110100"},{"name":"海淀区","value":"110108","parent":"110100"},{"name":"门头沟区","value":"110109","parent":"110100"},{"name":"房山区","value":"110111","parent":"110100"},{"name":"通州区","value":"110112","parent":"110100"},{"name":"顺义区","value":"110113","parent":"110100"},{"name":"昌平区","value":"110114","parent":"110100"},{"name":"大兴区","value":"110115","parent":"110100"},{"name":"怀柔区","value":"110116","parent":"110100"},{"name":"平谷区","value":"110117","parent":"110100"},{"name":"密云区","value":"110118","parent":"110100"},{"name":"延庆区","value":"110119","parent":"110100"},{"name":"市辖区","value":"120100","parent":"120000"},{"name":"和平区","value":"120101","parent":"120100"},{"name":"河东区","value":"120102","parent":"120100"},{"name":"河西区","value":"120103","parent":"120100"},{"name":"南开区","value":"120104","parent":"120100"},{"name":"河北区","value":"120105","parent":"120100"},{"name":"红桥区","value":"120106","parent":"120100"},{"name":"东丽区","value":"120110","parent":"120100"},{"name":"西青区","value":"120111","parent":"120100"},{"name":"津南区","value":"120112","parent":"120100"},{"name":"北辰区","value":"120113","parent":"120100"},{"name":"武清区","value":"120114","parent":"120100"},{"name":"宝坻区","value":"120115","parent":"120100"},{"name":"滨海新区","value":"120116","parent":"120100"},{"name":"宁河区","value":"120117","parent":"120100"},{"name":"静海区","value":"120118","parent":"120100"},{"name":"蓟州区","value":"120119","parent":"120100"},{"name":"石家庄市","value":"130100","parent":"130000"},{"name":"唐山市","value":"130200","parent":"130000"},{"name":"秦皇岛市","value":"130300","parent":"130000"},{"name":"邯郸市","value":"130400","parent":"130000"},{"name":"邢台市","value":"130500","parent":"130000"},{"name":"保定市","value":"130600","parent":"130000"},{"name":"张家口市","value":"130700","parent":"130000"},{"name":"承德市","value":"130800","parent":"130000"},{"name":"沧州市","value":"130900","parent":"130000"},{"name":"廊坊市","value":"131000","parent":"130000"},{"name":"衡水市","value":"131100","parent":"130000"},{"name":"定州市","value":"139001","parent":"130000"},{"name":"辛集市","value":"139002","parent":"130000"},{"name":"长安区","value":"130102","parent":"130100"},{"name":"桥西区","value":"130104","parent":"130100"},{"name":"新华区","value":"130105","parent":"130100"},{"name":"井陉矿区","value":"130107","parent":"130100"},{"name":"裕华区","value":"130108","parent":"130100"},{"name":"藁城区","value":"130109","parent":"130100"},{"name":"鹿泉区","value":"130110","parent":"130100"},{"name":"栾城区","value":"130111","parent":"130100"},{"name":"井陉县","value":"130121","parent":"130100"},{"name":"正定县","value":"130123","parent":"130100"},{"name":"行唐县","value":"130125","parent":"130100"},{"name":"灵寿县","value":"130126","parent":"130100"},{"name":"高邑县","value":"130127","parent":"130100"},{"name":"深泽县","value":"130128","parent":"130100"},{"name":"赞皇县","value":"130129","parent":"130100"},{"name":"无极县","value":"130130","parent":"130100"},{"name":"平山县","value":"130131","parent":"130100"},{"name":"元氏县","value":"130132","parent":"130100"},{"name":"赵县","value":"130133","parent":"130100"},{"name":"晋州市","value":"130183","parent":"130100"},{"name":"新乐市","value":"130184","parent":"130100"},{"name":"路南区","value":"130202","parent":"130200"},{"name":"路北区","value":"130203","parent":"130200"},{"name":"古冶区","value":"130204","parent":"130200"},{"name":"开平区","value":"130205","parent":"130200"},{"name":"丰南区","value":"130207","parent":"130200"},{"name":"丰润区","value":"130208","parent":"130200"},{"name":"曹妃甸区","value":"130209","parent":"130200"},{"name":"滦县","value":"130223","parent":"130200"},{"name":"滦南县","value":"130224","parent":"130200"},{"name":"乐亭县","value":"130225","parent":"130200"},{"name":"迁西县","value":"130227","parent":"130200"},{"name":"玉田县","value":"130229","parent":"130200"},{"name":"遵化市","value":"130281","parent":"130200"},{"name":"迁安市","value":"130283","parent":"130200"},{"name":"海港区","value":"130302","parent":"130300"},{"name":"山海关区","value":"130303","parent":"130300"},{"name":"北戴河区","value":"130304","parent":"130300"},{"name":"抚宁区","value":"130306","parent":"130300"},{"name":"青龙满族自治县","value":"130321","parent":"130300"},{"name":"昌黎县","value":"130322","parent":"130300"},{"name":"卢龙县","value":"130324","parent":"130300"},{"name":"邯山区","value":"130402","parent":"130400"},{"name":"丛台区","value":"130403","parent":"130400"},{"name":"复兴区","value":"130404","parent":"130400"},{"name":"峰峰矿区","value":"130406","parent":"130400"},{"name":"邯郸县","value":"130421","parent":"130400"},{"name":"临漳县","value":"130423","parent":"130400"},{"name":"成安县","value":"130424","parent":"130400"},{"name":"大名县","value":"130425","parent":"130400"},{"name":"涉县","value":"130426","parent":"130400"},{"name":"磁县","value":"130427","parent":"130400"},{"name":"肥乡县","value":"130428","parent":"130400"},{"name":"永年县","value":"130429","parent":"130400"},{"name":"邱县","value":"130430","parent":"130400"},{"name":"鸡泽县","value":"130431","parent":"130400"},{"name":"广平县","value":"130432","parent":"130400"},{"name":"馆陶县","value":"130433","parent":"130400"},{"name":"魏县","value":"130434","parent":"130400"},{"name":"曲周县","value":"130435","parent":"130400"},{"name":"武安市","value":"130481","parent":"130400"},{"name":"桥东区","value":"130502","parent":"130500"},{"name":"桥西区","value":"130503","parent":"130500"},{"name":"邢台县","value":"130521","parent":"130500"},{"name":"临城县","value":"130522","parent":"130500"},{"name":"内丘县","value":"130523","parent":"130500"},{"name":"柏乡县","value":"130524","parent":"130500"},{"name":"隆尧县","value":"130525","parent":"130500"},{"name":"任县","value":"130526","parent":"130500"},{"name":"南和县","value":"130527","parent":"130500"},{"name":"宁晋县","value":"130528","parent":"130500"},{"name":"巨鹿县","value":"130529","parent":"130500"},{"name":"新河县","value":"130530","parent":"130500"},{"name":"广宗县","value":"130531","parent":"130500"},{"name":"平乡县","value":"130532","parent":"130500"},{"name":"威县","value":"130533","parent":"130500"},{"name":"清河县","value":"130534","parent":"130500"},{"name":"临西县","value":"130535","parent":"130500"},{"name":"南宫市","value":"130581","parent":"130500"},{"name":"沙河市","value":"130582","parent":"130500"},{"name":"竞秀区","value":"130602","parent":"130600"},{"name":"莲池区","value":"130606","parent":"130600"},{"name":"满城区","value":"130607","parent":"130600"},{"name":"清苑区","value":"130608","parent":"130600"},{"name":"徐水区","value":"130609","parent":"130600"},{"name":"涞水县","value":"130623","parent":"130600"},{"name":"阜平县","value":"130624","parent":"130600"},{"name":"定兴县","value":"130626","parent":"130600"},{"name":"唐县","value":"130627","parent":"130600"},{"name":"高阳县","value":"130628","parent":"130600"},{"name":"容城县","value":"130629","parent":"130600"},{"name":"涞源县","value":"130630","parent":"130600"},{"name":"望都县","value":"130631","parent":"130600"},{"name":"安新县","value":"130632","parent":"130600"},{"name":"易县","value":"130633","parent":"130600"},{"name":"曲阳县","value":"130634","parent":"130600"},{"name":"蠡县","value":"130635","parent":"130600"},{"name":"顺平县","value":"130636","parent":"130600"},{"name":"博野县","value":"130637","parent":"130600"},{"name":"雄县","value":"130638","parent":"130600"},{"name":"涿州市","value":"130681","parent":"130600"},{"name":"安国市","value":"130683","parent":"130600"},{"name":"高碑店市","value":"130684","parent":"130600"},{"name":"桥东区","value":"130702","parent":"130700"},{"name":"桥西区","value":"130703","parent":"130700"},{"name":"宣化区","value":"130705","parent":"130700"},{"name":"下花园区","value":"130706","parent":"130700"},{"name":"万全区","value":"130708","parent":"130700"},{"name":"崇礼区","value":"130709","parent":"130700"},{"name":"张北县","value":"130722","parent":"130700"},{"name":"康保县","value":"130723","parent":"130700"},{"name":"沽源县","value":"130724","parent":"130700"},{"name":"尚义县","value":"130725","parent":"130700"},{"name":"蔚县","value":"130726","parent":"130700"},{"name":"阳原县","value":"130727","parent":"130700"},{"name":"怀安县","value":"130728","parent":"130700"},{"name":"怀来县","value":"130730","parent":"130700"},{"name":"涿鹿县","value":"130731","parent":"130700"},{"name":"赤城县","value":"130732","parent":"130700"},{"name":"双桥区","value":"130802","parent":"130800"},{"name":"双滦区","value":"130803","parent":"130800"},{"name":"鹰手营子矿区","value":"130804","parent":"130800"},{"name":"承德县","value":"130821","parent":"130800"},{"name":"兴隆县","value":"130822","parent":"130800"},{"name":"平泉县","value":"130823","parent":"130800"},{"name":"滦平县","value":"130824","parent":"130800"},{"name":"隆化县","value":"130825","parent":"130800"},{"name":"丰宁满族自治县","value":"130826","parent":"130800"},{"name":"宽城满族自治县","value":"130827","parent":"130800"},{"name":"围场满族蒙古族自治县","value":"130828","parent":"130800"},{"name":"新华区","value":"130902","parent":"130900"},{"name":"运河区","value":"130903","parent":"130900"},{"name":"沧县","value":"130921","parent":"130900"},{"name":"青县","value":"130922","parent":"130900"},{"name":"东光县","value":"130923","parent":"130900"},{"name":"海兴县","value":"130924","parent":"130900"},{"name":"盐山县","value":"130925","parent":"130900"},{"name":"肃宁县","value":"130926","parent":"130900"},{"name":"南皮县","value":"130927","parent":"130900"},{"name":"吴桥县","value":"130928","parent":"130900"},{"name":"献县","value":"130929","parent":"130900"},{"name":"孟村回族自治县","value":"130930","parent":"130900"},{"name":"泊头市","value":"130981","parent":"130900"},{"name":"任丘市","value":"130982","parent":"130900"},{"name":"黄骅市","value":"130983","parent":"130900"},{"name":"河间市","value":"130984","parent":"130900"},{"name":"安次区","value":"131002","parent":"131000"},{"name":"广阳区","value":"131003","parent":"131000"},{"name":"固安县","value":"131022","parent":"131000"},{"name":"永清县","value":"131023","parent":"131000"},{"name":"香河县","value":"131024","parent":"131000"},{"name":"大城县","value":"131025","parent":"131000"},{"name":"文安县","value":"131026","parent":"131000"},{"name":"大厂回族自治县","value":"131028","parent":"131000"},{"name":"霸州市","value":"131081","parent":"131000"},{"name":"三河市","value":"131082","parent":"131000"},{"name":"桃城区","value":"131102","parent":"131100"},{"name":"冀州区","value":"131103","parent":"131100"},{"name":"枣强县","value":"131121","parent":"131100"},{"name":"武邑县","value":"131122","parent":"131100"},{"name":"武强县","value":"131123","parent":"131100"},{"name":"饶阳县","value":"131124","parent":"131100"},{"name":"安平县","value":"131125","parent":"131100"},{"name":"故城县","value":"131126","parent":"131100"},{"name":"景县","value":"131127","parent":"131100"},{"name":"阜城县","value":"131128","parent":"131100"},{"name":"深州市","value":"131182","parent":"131100"},{"name":"太原市","value":"140100","parent":"140000"},{"name":"大同市","value":"140200","parent":"140000"},{"name":"阳泉市","value":"140300","parent":"140000"},{"name":"长治市","value":"140400","parent":"140000"},{"name":"晋城市","value":"140500","parent":"140000"},{"name":"朔州市","value":"140600","parent":"140000"},{"name":"晋中市","value":"140700","parent":"140000"},{"name":"运城市","value":"140800","parent":"140000"},{"name":"忻州市","value":"140900","parent":"140000"},{"name":"临汾市","value":"141000","parent":"140000"},{"name":"吕梁市","value":"141100","parent":"140000"},{"name":"小店区","value":"140105","parent":"140100"},{"name":"迎泽区","value":"140106","parent":"140100"},{"name":"杏花岭区","value":"140107","parent":"140100"},{"name":"尖草坪区","value":"140108","parent":"140100"},{"name":"万柏林区","value":"140109","parent":"140100"},{"name":"晋源区","value":"140110","parent":"140100"},{"name":"清徐县","value":"140121","parent":"140100"},{"name":"阳曲县","value":"140122","parent":"140100"},{"name":"娄烦县","value":"140123","parent":"140100"},{"name":"古交市","value":"140181","parent":"140100"},{"name":"城区","value":"140202","parent":"140200"},{"name":"矿区","value":"140203","parent":"140200"},{"name":"南郊区","value":"140211","parent":"140200"},{"name":"新荣区","value":"140212","parent":"140200"},{"name":"阳高县","value":"140221","parent":"140200"},{"name":"天镇县","value":"140222","parent":"140200"},{"name":"广灵县","value":"140223","parent":"140200"},{"name":"灵丘县","value":"140224","parent":"140200"},{"name":"浑源县","value":"140225","parent":"140200"},{"name":"左云县","value":"140226","parent":"140200"},{"name":"大同县","value":"140227","parent":"140200"},{"name":"城区","value":"140302","parent":"140300"},{"name":"矿区","value":"140303","parent":"140300"},{"name":"郊区","value":"140311","parent":"140300"},{"name":"平定县","value":"140321","parent":"140300"},{"name":"盂县","value":"140322","parent":"140300"},{"name":"城区","value":"140402","parent":"140400"},{"name":"郊区","value":"140411","parent":"140400"},{"name":"长治县","value":"140421","parent":"140400"},{"name":"襄垣县","value":"140423","parent":"140400"},{"name":"屯留县","value":"140424","parent":"140400"},{"name":"平顺县","value":"140425","parent":"140400"},{"name":"黎城县","value":"140426","parent":"140400"},{"name":"壶关县","value":"140427","parent":"140400"},{"name":"长子县","value":"140428","parent":"140400"},{"name":"武乡县","value":"140429","parent":"140400"},{"name":"沁县","value":"140430","parent":"140400"},{"name":"沁源县","value":"140431","parent":"140400"},{"name":"潞城市","value":"140481","parent":"140400"},{"name":"城区","value":"140502","parent":"140500"},{"name":"沁水县","value":"140521","parent":"140500"},{"name":"阳城县","value":"140522","parent":"140500"},{"name":"陵川县","value":"140524","parent":"140500"},{"name":"泽州县","value":"140525","parent":"140500"},{"name":"高平市","value":"140581","parent":"140500"},{"name":"朔城区","value":"140602","parent":"140600"},{"name":"平鲁区","value":"140603","parent":"140600"},{"name":"山阴县","value":"140621","parent":"140600"},{"name":"应县","value":"140622","parent":"140600"},{"name":"右玉县","value":"140623","parent":"140600"},{"name":"怀仁县","value":"140624","parent":"140600"},{"name":"榆次区","value":"140702","parent":"140700"},{"name":"榆社县","value":"140721","parent":"140700"},{"name":"左权县","value":"140722","parent":"140700"},{"name":"和顺县","value":"140723","parent":"140700"},{"name":"昔阳县","value":"140724","parent":"140700"},{"name":"寿阳县","value":"140725","parent":"140700"},{"name":"太谷县","value":"140726","parent":"140700"},{"name":"祁县","value":"140727","parent":"140700"},{"name":"平遥县","value":"140728","parent":"140700"},{"name":"灵石县","value":"140729","parent":"140700"},{"name":"介休市","value":"140781","parent":"140700"},{"name":"盐湖区","value":"140802","parent":"140800"},{"name":"临猗县","value":"140821","parent":"140800"},{"name":"万荣县","value":"140822","parent":"140800"},{"name":"闻喜县","value":"140823","parent":"140800"},{"name":"稷山县","value":"140824","parent":"140800"},{"name":"新绛县","value":"140825","parent":"140800"},{"name":"绛县","value":"140826","parent":"140800"},{"name":"垣曲县","value":"140827","parent":"140800"},{"name":"夏县","value":"140828","parent":"140800"},{"name":"平陆县","value":"140829","parent":"140800"},{"name":"芮城县","value":"140830","parent":"140800"},{"name":"永济市","value":"140881","parent":"140800"},{"name":"河津市","value":"140882","parent":"140800"},{"name":"忻府区","value":"140902","parent":"140900"},{"name":"定襄县","value":"140921","parent":"140900"},{"name":"五台县","value":"140922","parent":"140900"},{"name":"代县","value":"140923","parent":"140900"},{"name":"繁峙县","value":"140924","parent":"140900"},{"name":"宁武县","value":"140925","parent":"140900"},{"name":"静乐县","value":"140926","parent":"140900"},{"name":"神池县","value":"140927","parent":"140900"},{"name":"五寨县","value":"140928","parent":"140900"},{"name":"岢岚县","value":"140929","parent":"140900"},{"name":"河曲县","value":"140930","parent":"140900"},{"name":"保德县","value":"140931","parent":"140900"},{"name":"偏关县","value":"140932","parent":"140900"},{"name":"原平市","value":"140981","parent":"140900"},{"name":"尧都区","value":"141002","parent":"141000"},{"name":"曲沃县","value":"141021","parent":"141000"},{"name":"翼城县","value":"141022","parent":"141000"},{"name":"襄汾县","value":"141023","parent":"141000"},{"name":"洪洞县","value":"141024","parent":"141000"},{"name":"古县","value":"141025","parent":"141000"},{"name":"安泽县","value":"141026","parent":"141000"},{"name":"浮山县","value":"141027","parent":"141000"},{"name":"吉县","value":"141028","parent":"141000"},{"name":"乡宁县","value":"141029","parent":"141000"},{"name":"大宁县","value":"141030","parent":"141000"},{"name":"隰县","value":"141031","parent":"141000"},{"name":"永和县","value":"141032","parent":"141000"},{"name":"蒲县","value":"141033","parent":"141000"},{"name":"汾西县","value":"141034","parent":"141000"},{"name":"侯马市","value":"141081","parent":"141000"},{"name":"霍州市","value":"141082","parent":"141000"},{"name":"离石区","value":"141102","parent":"141100"},{"name":"文水县","value":"141121","parent":"141100"},{"name":"交城县","value":"141122","parent":"141100"},{"name":"兴县","value":"141123","parent":"141100"},{"name":"临县","value":"141124","parent":"141100"},{"name":"柳林县","value":"141125","parent":"141100"},{"name":"石楼县","value":"141126","parent":"141100"},{"name":"岚县","value":"141127","parent":"141100"},{"name":"方山县","value":"141128","parent":"141100"},{"name":"中阳县","value":"141129","parent":"141100"},{"name":"交口县","value":"141130","parent":"141100"},{"name":"孝义市","value":"141181","parent":"141100"},{"name":"汾阳市","value":"141182","parent":"141100"},{"name":"呼和浩特市","value":"150100","parent":"150000"},{"name":"包头市","value":"150200","parent":"150000"},{"name":"乌海市","value":"150300","parent":"150000"},{"name":"赤峰市","value":"150400","parent":"150000"},{"name":"通辽市","value":"150500","parent":"150000"},{"name":"鄂尔多斯市","value":"150600","parent":"150000"},{"name":"呼伦贝尔市","value":"150700","parent":"150000"},{"name":"巴彦淖尔市","value":"150800","parent":"150000"},{"name":"乌兰察布市","value":"150900","parent":"150000"},{"name":"兴安盟","value":"152200","parent":"150000"},{"name":"锡林郭勒盟","value":"152500","parent":"150000"},{"name":"阿拉善盟","value":"152900","parent":"150000"},{"name":"新城区","value":"150102","parent":"150100"},{"name":"回民区","value":"150103","parent":"150100"},{"name":"玉泉区","value":"150104","parent":"150100"},{"name":"赛罕区","value":"150105","parent":"150100"},{"name":"土默特左旗","value":"150121","parent":"150100"},{"name":"托克托县","value":"150122","parent":"150100"},{"name":"和林格尔县","value":"150123","parent":"150100"},{"name":"清水河县","value":"150124","parent":"150100"},{"name":"武川县","value":"150125","parent":"150100"},{"name":"东河区","value":"150202","parent":"150200"},{"name":"昆都仑区","value":"150203","parent":"150200"},{"name":"青山区","value":"150204","parent":"150200"},{"name":"石拐区","value":"150205","parent":"150200"},{"name":"白云鄂博矿区","value":"150206","parent":"150200"},{"name":"九原区","value":"150207","parent":"150200"},{"name":"土默特右旗","value":"150221","parent":"150200"},{"name":"固阳县","value":"150222","parent":"150200"},{"name":"达尔罕茂明安联合旗","value":"150223","parent":"150200"},{"name":"海勃湾区","value":"150302","parent":"150300"},{"name":"海南区","value":"150303","parent":"150300"},{"name":"乌达区","value":"150304","parent":"150300"},{"name":"红山区","value":"150402","parent":"150400"},{"name":"元宝山区","value":"150403","parent":"150400"},{"name":"松山区","value":"150404","parent":"150400"},{"name":"阿鲁科尔沁旗","value":"150421","parent":"150400"},{"name":"巴林左旗","value":"150422","parent":"150400"},{"name":"巴林右旗","value":"150423","parent":"150400"},{"name":"林西县","value":"150424","parent":"150400"},{"name":"克什克腾旗","value":"150425","parent":"150400"},{"name":"翁牛特旗","value":"150426","parent":"150400"},{"name":"喀喇沁旗","value":"150428","parent":"150400"},{"name":"宁城县","value":"150429","parent":"150400"},{"name":"敖汉旗","value":"150430","parent":"150400"},{"name":"科尔沁区","value":"150502","parent":"150500"},{"name":"科尔沁左翼中旗","value":"150521","parent":"150500"},{"name":"科尔沁左翼后旗","value":"150522","parent":"150500"},{"name":"开鲁县","value":"150523","parent":"150500"},{"name":"库伦旗","value":"150524","parent":"150500"},{"name":"奈曼旗","value":"150525","parent":"150500"},{"name":"扎鲁特旗","value":"150526","parent":"150500"},{"name":"霍林郭勒市","value":"150581","parent":"150500"},{"name":"东胜区","value":"150602","parent":"150600"},{"name":"康巴什区","value":"150603","parent":"150600"},{"name":"达拉特旗","value":"150621","parent":"150600"},{"name":"准格尔旗","value":"150622","parent":"150600"},{"name":"鄂托克前旗","value":"150623","parent":"150600"},{"name":"鄂托克旗","value":"150624","parent":"150600"},{"name":"杭锦旗","value":"150625","parent":"150600"},{"name":"乌审旗","value":"150626","parent":"150600"},{"name":"伊金霍洛旗","value":"150627","parent":"150600"},{"name":"海拉尔区","value":"150702","parent":"150700"},{"name":"扎赉诺尔区","value":"150703","parent":"150700"},{"name":"阿荣旗","value":"150721","parent":"150700"},{"name":"莫力达瓦达斡尔族自治旗","value":"150722","parent":"150700"},{"name":"鄂伦春自治旗","value":"150723","parent":"150700"},{"name":"鄂温克族自治旗","value":"150724","parent":"150700"},{"name":"陈巴尔虎旗","value":"150725","parent":"150700"},{"name":"新巴尔虎左旗","value":"150726","parent":"150700"},{"name":"新巴尔虎右旗","value":"150727","parent":"150700"},{"name":"满洲里市","value":"150781","parent":"150700"},{"name":"牙克石市","value":"150782","parent":"150700"},{"name":"扎兰屯市","value":"150783","parent":"150700"},{"name":"额尔古纳市","value":"150784","parent":"150700"},{"name":"根河市","value":"150785","parent":"150700"},{"name":"临河区","value":"150802","parent":"150800"},{"name":"五原县","value":"150821","parent":"150800"},{"name":"磴口县","value":"150822","parent":"150800"},{"name":"乌拉特前旗","value":"150823","parent":"150800"},{"name":"乌拉特中旗","value":"150824","parent":"150800"},{"name":"乌拉特后旗","value":"150825","parent":"150800"},{"name":"杭锦后旗","value":"150826","parent":"150800"},{"name":"集宁区","value":"150902","parent":"150900"},{"name":"卓资县","value":"150921","parent":"150900"},{"name":"化德县","value":"150922","parent":"150900"},{"name":"商都县","value":"150923","parent":"150900"},{"name":"兴和县","value":"150924","parent":"150900"},{"name":"凉城县","value":"150925","parent":"150900"},{"name":"察哈尔右翼前旗","value":"150926","parent":"150900"},{"name":"察哈尔右翼中旗","value":"150927","parent":"150900"},{"name":"察哈尔右翼后旗","value":"150928","parent":"150900"},{"name":"四子王旗","value":"150929","parent":"150900"},{"name":"丰镇市","value":"150981","parent":"150900"},{"name":"乌兰浩特市","value":"152201","parent":"152200"},{"name":"阿尔山市","value":"152202","parent":"152200"},{"name":"科尔沁右翼前旗","value":"152221","parent":"152200"},{"name":"科尔沁右翼中旗","value":"152222","parent":"152200"},{"name":"扎赉特旗","value":"152223","parent":"152200"},{"name":"突泉县","value":"152224","parent":"152200"},{"name":"二连浩特市","value":"152501","parent":"152500"},{"name":"锡林浩特市","value":"152502","parent":"152500"},{"name":"阿巴嘎旗","value":"152522","parent":"152500"},{"name":"苏尼特左旗","value":"152523","parent":"152500"},{"name":"苏尼特右旗","value":"152524","parent":"152500"},{"name":"东乌珠穆沁旗","value":"152525","parent":"152500"},{"name":"西乌珠穆沁旗","value":"152526","parent":"152500"},{"name":"太仆寺旗","value":"152527","parent":"152500"},{"name":"镶黄旗","value":"152528","parent":"152500"},{"name":"正镶白旗","value":"152529","parent":"152500"},{"name":"正蓝旗","value":"152530","parent":"152500"},{"name":"多伦县","value":"152531","parent":"152500"},{"name":"阿拉善左旗","value":"152921","parent":"152900"},{"name":"阿拉善右旗","value":"152922","parent":"152900"},{"name":"额济纳旗","value":"152923","parent":"152900"},{"name":"沈阳市","value":"210100","parent":"210000"},{"name":"大连市","value":"210200","parent":"210000"},{"name":"鞍山市","value":"210300","parent":"210000"},{"name":"抚顺市","value":"210400","parent":"210000"},{"name":"本溪市","value":"210500","parent":"210000"},{"name":"丹东市","value":"210600","parent":"210000"},{"name":"锦州市","value":"210700","parent":"210000"},{"name":"营口市","value":"210800","parent":"210000"},{"name":"阜新市","value":"210900","parent":"210000"},{"name":"辽阳市","value":"211000","parent":"210000"},{"name":"盘锦市","value":"211100","parent":"210000"},{"name":"铁岭市","value":"211200","parent":"210000"},{"name":"朝阳市","value":"211300","parent":"210000"},{"name":"葫芦岛市","value":"211400","parent":"210000"},{"name":"和平区","value":"210102","parent":"210100"},{"name":"沈河区","value":"210103","parent":"210100"},{"name":"大东区","value":"210104","parent":"210100"},{"name":"皇姑区","value":"210105","parent":"210100"},{"name":"铁西区","value":"210106","parent":"210100"},{"name":"苏家屯区","value":"210111","parent":"210100"},{"name":"浑南区","value":"210112","parent":"210100"},{"name":"沈北新区","value":"210113","parent":"210100"},{"name":"于洪区","value":"210114","parent":"210100"},{"name":"辽中区","value":"210115","parent":"210100"},{"name":"康平县","value":"210123","parent":"210100"},{"name":"法库县","value":"210124","parent":"210100"},{"name":"新民市","value":"210181","parent":"210100"},{"name":"中山区","value":"210202","parent":"210200"},{"name":"西岗区","value":"210203","parent":"210200"},{"name":"沙河口区","value":"210204","parent":"210200"},{"name":"甘井子区","value":"210211","parent":"210200"},{"name":"旅顺口区","value":"210212","parent":"210200"},{"name":"金州区","value":"210213","parent":"210200"},{"name":"普兰店区","value":"210214","parent":"210200"},{"name":"长海县","value":"210224","parent":"210200"},{"name":"瓦房店市","value":"210281","parent":"210200"},{"name":"庄河市","value":"210283","parent":"210200"},{"name":"铁东区","value":"210302","parent":"210300"},{"name":"铁西区","value":"210303","parent":"210300"},{"name":"立山区","value":"210304","parent":"210300"},{"name":"千山区","value":"210311","parent":"210300"},{"name":"台安县","value":"210321","parent":"210300"},{"name":"岫岩满族自治县","value":"210323","parent":"210300"},{"name":"海城市","value":"210381","parent":"210300"},{"name":"新抚区","value":"210402","parent":"210400"},{"name":"东洲区","value":"210403","parent":"210400"},{"name":"望花区","value":"210404","parent":"210400"},{"name":"顺城区","value":"210411","parent":"210400"},{"name":"抚顺县","value":"210421","parent":"210400"},{"name":"新宾满族自治县","value":"210422","parent":"210400"},{"name":"清原满族自治县","value":"210423","parent":"210400"},{"name":"平山区","value":"210502","parent":"210500"},{"name":"溪湖区","value":"210503","parent":"210500"},{"name":"明山区","value":"210504","parent":"210500"},{"name":"南芬区","value":"210505","parent":"210500"},{"name":"本溪满族自治县","value":"210521","parent":"210500"},{"name":"桓仁满族自治县","value":"210522","parent":"210500"},{"name":"元宝区","value":"210602","parent":"210600"},{"name":"振兴区","value":"210603","parent":"210600"},{"name":"振安区","value":"210604","parent":"210600"},{"name":"宽甸满族自治县","value":"210624","parent":"210600"},{"name":"东港市","value":"210681","parent":"210600"},{"name":"凤城市","value":"210682","parent":"210600"},{"name":"古塔区","value":"210702","parent":"210700"},{"name":"凌河区","value":"210703","parent":"210700"},{"name":"太和区","value":"210711","parent":"210700"},{"name":"黑山县","value":"210726","parent":"210700"},{"name":"义县","value":"210727","parent":"210700"},{"name":"凌海市","value":"210781","parent":"210700"},{"name":"北镇市","value":"210782","parent":"210700"},{"name":"站前区","value":"210802","parent":"210800"},{"name":"西市区","value":"210803","parent":"210800"},{"name":"鲅鱼圈区","value":"210804","parent":"210800"},{"name":"老边区","value":"210811","parent":"210800"},{"name":"盖州市","value":"210881","parent":"210800"},{"name":"大石桥市","value":"210882","parent":"210800"},{"name":"海州区","value":"210902","parent":"210900"},{"name":"新邱区","value":"210903","parent":"210900"},{"name":"太平区","value":"210904","parent":"210900"},{"name":"清河门区","value":"210905","parent":"210900"},{"name":"细河区","value":"210911","parent":"210900"},{"name":"阜新蒙古族自治县","value":"210921","parent":"210900"},{"name":"彰武县","value":"210922","parent":"210900"},{"name":"白塔区","value":"211002","parent":"211000"},{"name":"文圣区","value":"211003","parent":"211000"},{"name":"宏伟区","value":"211004","parent":"211000"},{"name":"弓长岭区","value":"211005","parent":"211000"},{"name":"太子河区","value":"211011","parent":"211000"},{"name":"辽阳县","value":"211021","parent":"211000"},{"name":"灯塔市","value":"211081","parent":"211000"},{"name":"双台子区","value":"211102","parent":"211100"},{"name":"兴隆台区","value":"211103","parent":"211100"},{"name":"大洼区","value":"211104","parent":"211100"},{"name":"盘山县","value":"211122","parent":"211100"},{"name":"银州区","value":"211202","parent":"211200"},{"name":"清河区","value":"211204","parent":"211200"},{"name":"铁岭县","value":"211221","parent":"211200"},{"name":"西丰县","value":"211223","parent":"211200"},{"name":"昌图县","value":"211224","parent":"211200"},{"name":"调兵山市","value":"211281","parent":"211200"},{"name":"开原市","value":"211282","parent":"211200"},{"name":"双塔区","value":"211302","parent":"211300"},{"name":"龙城区","value":"211303","parent":"211300"},{"name":"朝阳县","value":"211321","parent":"211300"},{"name":"建平县","value":"211322","parent":"211300"},{"name":"喀喇沁左翼蒙古族自治县","value":"211324","parent":"211300"},{"name":"北票市","value":"211381","parent":"211300"},{"name":"凌源市","value":"211382","parent":"211300"},{"name":"连山区","value":"211402","parent":"211400"},{"name":"龙港区","value":"211403","parent":"211400"},{"name":"南票区","value":"211404","parent":"211400"},{"name":"绥中县","value":"211421","parent":"211400"},{"name":"建昌县","value":"211422","parent":"211400"},{"name":"兴城市","value":"211481","parent":"211400"},{"name":"长春市","value":"220100","parent":"220000"},{"name":"吉林市","value":"220200","parent":"220000"},{"name":"四平市","value":"220300","parent":"220000"},{"name":"辽源市","value":"220400","parent":"220000"},{"name":"通化市","value":"220500","parent":"220000"},{"name":"白山市","value":"220600","parent":"220000"},{"name":"松原市","value":"220700","parent":"220000"},{"name":"白城市","value":"220800","parent":"220000"},{"name":"延边朝鲜族自治州","value":"222400","parent":"220000"},{"name":"南关区","value":"220102","parent":"220100"},{"name":"宽城区","value":"220103","parent":"220100"},{"name":"朝阳区","value":"220104","parent":"220100"},{"name":"二道区","value":"220105","parent":"220100"},{"name":"绿园区","value":"220106","parent":"220100"},{"name":"双阳区","value":"220112","parent":"220100"},{"name":"九台区","value":"220113","parent":"220100"},{"name":"农安县","value":"220122","parent":"220100"},{"name":"榆树市","value":"220182","parent":"220100"},{"name":"德惠市","value":"220183","parent":"220100"},{"name":"昌邑区","value":"220202","parent":"220200"},{"name":"龙潭区","value":"220203","parent":"220200"},{"name":"船营区","value":"220204","parent":"220200"},{"name":"丰满区","value":"220211","parent":"220200"},{"name":"永吉县","value":"220221","parent":"220200"},{"name":"蛟河市","value":"220281","parent":"220200"},{"name":"桦甸市","value":"220282","parent":"220200"},{"name":"舒兰市","value":"220283","parent":"220200"},{"name":"磐石市","value":"220284","parent":"220200"},{"name":"铁西区","value":"220302","parent":"220300"},{"name":"铁东区","value":"220303","parent":"220300"},{"name":"梨树县","value":"220322","parent":"220300"},{"name":"伊通满族自治县","value":"220323","parent":"220300"},{"name":"公主岭市","value":"220381","parent":"220300"},{"name":"双辽市","value":"220382","parent":"220300"},{"name":"龙山区","value":"220402","parent":"220400"},{"name":"西安区","value":"220403","parent":"220400"},{"name":"东丰县","value":"220421","parent":"220400"},{"name":"东辽县","value":"220422","parent":"220400"},{"name":"东昌区","value":"220502","parent":"220500"},{"name":"二道江区","value":"220503","parent":"220500"},{"name":"通化县","value":"220521","parent":"220500"},{"name":"辉南县","value":"220523","parent":"220500"},{"name":"柳河县","value":"220524","parent":"220500"},{"name":"梅河口市","value":"220581","parent":"220500"},{"name":"集安市","value":"220582","parent":"220500"},{"name":"浑江区","value":"220602","parent":"220600"},{"name":"江源区","value":"220605","parent":"220600"},{"name":"抚松县","value":"220621","parent":"220600"},{"name":"靖宇县","value":"220622","parent":"220600"},{"name":"长白朝鲜族自治县","value":"220623","parent":"220600"},{"name":"临江市","value":"220681","parent":"220600"},{"name":"宁江区","value":"220702","parent":"220700"},{"name":"前郭尔罗斯蒙古族自治县","value":"220721","parent":"220700"},{"name":"长岭县","value":"220722","parent":"220700"},{"name":"乾安县","value":"220723","parent":"220700"},{"name":"扶余市","value":"220781","parent":"220700"},{"name":"洮北区","value":"220802","parent":"220800"},{"name":"镇赉县","value":"220821","parent":"220800"},{"name":"通榆县","value":"220822","parent":"220800"},{"name":"洮南市","value":"220881","parent":"220800"},{"name":"大安市","value":"220882","parent":"220800"},{"name":"延吉市","value":"222401","parent":"222400"},{"name":"图们市","value":"222402","parent":"222400"},{"name":"敦化市","value":"222403","parent":"222400"},{"name":"珲春市","value":"222404","parent":"222400"},{"name":"龙井市","value":"222405","parent":"222400"},{"name":"和龙市","value":"222406","parent":"222400"},{"name":"汪清县","value":"222424","parent":"222400"},{"name":"安图县","value":"222426","parent":"222400"},{"name":"哈尔滨市","value":"230100","parent":"230000"},{"name":"齐齐哈尔市","value":"230200","parent":"230000"},{"name":"鸡西市","value":"230300","parent":"230000"},{"name":"鹤岗市","value":"230400","parent":"230000"},{"name":"双鸭山市","value":"230500","parent":"230000"},{"name":"大庆市","value":"230600","parent":"230000"},{"name":"伊春市","value":"230700","parent":"230000"},{"name":"佳木斯市","value":"230800","parent":"230000"},{"name":"七台河市","value":"230900","parent":"230000"},{"name":"牡丹江市","value":"231000","parent":"230000"},{"name":"黑河市","value":"231100","parent":"230000"},{"name":"绥化市","value":"231200","parent":"230000"},{"name":"大兴安岭地区","value":"232700","parent":"230000"},{"name":"道里区","value":"230102","parent":"230100"},{"name":"南岗区","value":"230103","parent":"230100"},{"name":"道外区","value":"230104","parent":"230100"},{"name":"平房区","value":"230108","parent":"230100"},{"name":"松北区","value":"230109","parent":"230100"},{"name":"香坊区","value":"230110","parent":"230100"},{"name":"呼兰区","value":"230111","parent":"230100"},{"name":"阿城区","value":"230112","parent":"230100"},{"name":"双城区","value":"230113","parent":"230100"},{"name":"依兰县","value":"230123","parent":"230100"},{"name":"方正县","value":"230124","parent":"230100"},{"name":"宾县","value":"230125","parent":"230100"},{"name":"巴彦县","value":"230126","parent":"230100"},{"name":"木兰县","value":"230127","parent":"230100"},{"name":"通河县","value":"230128","parent":"230100"},{"name":"延寿县","value":"230129","parent":"230100"},{"name":"尚志市","value":"230183","parent":"230100"},{"name":"五常市","value":"230184","parent":"230100"},{"name":"龙沙区","value":"230202","parent":"230200"},{"name":"建华区","value":"230203","parent":"230200"},{"name":"铁锋区","value":"230204","parent":"230200"},{"name":"昂昂溪区","value":"230205","parent":"230200"},{"name":"富拉尔基区","value":"230206","parent":"230200"},{"name":"碾子山区","value":"230207","parent":"230200"},{"name":"梅里斯达斡尔族区","value":"230208","parent":"230200"},{"name":"龙江县","value":"230221","parent":"230200"},{"name":"依安县","value":"230223","parent":"230200"},{"name":"泰来县","value":"230224","parent":"230200"},{"name":"甘南县","value":"230225","parent":"230200"},{"name":"富裕县","value":"230227","parent":"230200"},{"name":"克山县","value":"230229","parent":"230200"},{"name":"克东县","value":"230230","parent":"230200"},{"name":"拜泉县","value":"230231","parent":"230200"},{"name":"讷河市","value":"230281","parent":"230200"},{"name":"鸡冠区","value":"230302","parent":"230300"},{"name":"恒山区","value":"230303","parent":"230300"},{"name":"滴道区","value":"230304","parent":"230300"},{"name":"梨树区","value":"230305","parent":"230300"},{"name":"城子河区","value":"230306","parent":"230300"},{"name":"麻山区","value":"230307","parent":"230300"},{"name":"鸡东县","value":"230321","parent":"230300"},{"name":"虎林市","value":"230381","parent":"230300"},{"name":"密山市","value":"230382","parent":"230300"},{"name":"向阳区","value":"230402","parent":"230400"},{"name":"工农区","value":"230403","parent":"230400"},{"name":"南山区","value":"230404","parent":"230400"},{"name":"兴安区","value":"230405","parent":"230400"},{"name":"东山区","value":"230406","parent":"230400"},{"name":"兴山区","value":"230407","parent":"230400"},{"name":"萝北县","value":"230421","parent":"230400"},{"name":"绥滨县","value":"230422","parent":"230400"},{"name":"尖山区","value":"230502","parent":"230500"},{"name":"岭东区","value":"230503","parent":"230500"},{"name":"四方台区","value":"230505","parent":"230500"},{"name":"宝山区","value":"230506","parent":"230500"},{"name":"集贤县","value":"230521","parent":"230500"},{"name":"友谊县","value":"230522","parent":"230500"},{"name":"宝清县","value":"230523","parent":"230500"},{"name":"饶河县","value":"230524","parent":"230500"},{"name":"萨尔图区","value":"230602","parent":"230600"},{"name":"龙凤区","value":"230603","parent":"230600"},{"name":"让胡路区","value":"230604","parent":"230600"},{"name":"红岗区","value":"230605","parent":"230600"},{"name":"大同区","value":"230606","parent":"230600"},{"name":"肇州县","value":"230621","parent":"230600"},{"name":"肇源县","value":"230622","parent":"230600"},{"name":"林甸县","value":"230623","parent":"230600"},{"name":"杜尔伯特蒙古族自治县","value":"230624","parent":"230600"},{"name":"伊春区","value":"230702","parent":"230700"},{"name":"南岔区","value":"230703","parent":"230700"},{"name":"友好区","value":"230704","parent":"230700"},{"name":"西林区","value":"230705","parent":"230700"},{"name":"翠峦区","value":"230706","parent":"230700"},{"name":"新青区","value":"230707","parent":"230700"},{"name":"美溪区","value":"230708","parent":"230700"},{"name":"金山屯区","value":"230709","parent":"230700"},{"name":"五营区","value":"230710","parent":"230700"},{"name":"乌马河区","value":"230711","parent":"230700"},{"name":"汤旺河区","value":"230712","parent":"230700"},{"name":"带岭区","value":"230713","parent":"230700"},{"name":"乌伊岭区","value":"230714","parent":"230700"},{"name":"红星区","value":"230715","parent":"230700"},{"name":"上甘岭区","value":"230716","parent":"230700"},{"name":"嘉荫县","value":"230722","parent":"230700"},{"name":"铁力市","value":"230781","parent":"230700"},{"name":"向阳区","value":"230803","parent":"230800"},{"name":"前进区","value":"230804","parent":"230800"},{"name":"东风区","value":"230805","parent":"230800"},{"name":"郊区","value":"230811","parent":"230800"},{"name":"桦南县","value":"230822","parent":"230800"},{"name":"桦川县","value":"230826","parent":"230800"},{"name":"汤原县","value":"230828","parent":"230800"},{"name":"同江市","value":"230881","parent":"230800"},{"name":"富锦市","value":"230882","parent":"230800"},{"name":"抚远市","value":"230883","parent":"230800"},{"name":"新兴区","value":"230902","parent":"230900"},{"name":"桃山区","value":"230903","parent":"230900"},{"name":"茄子河区","value":"230904","parent":"230900"},{"name":"勃利县","value":"230921","parent":"230900"},{"name":"东安区","value":"231002","parent":"231000"},{"name":"阳明区","value":"231003","parent":"231000"},{"name":"爱民区","value":"231004","parent":"231000"},{"name":"西安区","value":"231005","parent":"231000"},{"name":"林口县","value":"231025","parent":"231000"},{"name":"绥芬河市","value":"231081","parent":"231000"},{"name":"海林市","value":"231083","parent":"231000"},{"name":"宁安市","value":"231084","parent":"231000"},{"name":"穆棱市","value":"231085","parent":"231000"},{"name":"东宁市","value":"231086","parent":"231000"},{"name":"爱辉区","value":"231102","parent":"231100"},{"name":"嫩江县","value":"231121","parent":"231100"},{"name":"逊克县","value":"231123","parent":"231100"},{"name":"孙吴县","value":"231124","parent":"231100"},{"name":"北安市","value":"231181","parent":"231100"},{"name":"五大连池市","value":"231182","parent":"231100"},{"name":"北林区","value":"231202","parent":"231200"},{"name":"望奎县","value":"231221","parent":"231200"},{"name":"兰西县","value":"231222","parent":"231200"},{"name":"青冈县","value":"231223","parent":"231200"},{"name":"庆安县","value":"231224","parent":"231200"},{"name":"明水县","value":"231225","parent":"231200"},{"name":"绥棱县","value":"231226","parent":"231200"},{"name":"安达市","value":"231281","parent":"231200"},{"name":"肇东市","value":"231282","parent":"231200"},{"name":"海伦市","value":"231283","parent":"231200"},{"name":"呼玛县","value":"232721","parent":"232700"},{"name":"塔河县","value":"232722","parent":"232700"},{"name":"漠河县","value":"232723","parent":"232700"},{"name":"市辖区","value":"310100","parent":"310000"},{"name":"黄浦区","value":"310101","parent":"310100"},{"name":"徐汇区","value":"310104","parent":"310100"},{"name":"长宁区","value":"310105","parent":"310100"},{"name":"静安区","value":"310106","parent":"310100"},{"name":"普陀区","value":"310107","parent":"310100"},{"name":"虹口区","value":"310109","parent":"310100"},{"name":"杨浦区","value":"310110","parent":"310100"},{"name":"闵行区","value":"310112","parent":"310100"},{"name":"宝山区","value":"310113","parent":"310100"},{"name":"嘉定区","value":"310114","parent":"310100"},{"name":"浦东新区","value":"310115","parent":"310100"},{"name":"金山区","value":"310116","parent":"310100"},{"name":"松江区","value":"310117","parent":"310100"},{"name":"青浦区","value":"310118","parent":"310100"},{"name":"奉贤区","value":"310120","parent":"310100"},{"name":"崇明区","value":"310151","parent":"310100"},{"name":"南京市","value":"320100","parent":"320000"},{"name":"无锡市","value":"320200","parent":"320000"},{"name":"徐州市","value":"320300","parent":"320000"},{"name":"常州市","value":"320400","parent":"320000"},{"name":"苏州市","value":"320500","parent":"320000"},{"name":"南通市","value":"320600","parent":"320000"},{"name":"连云港市","value":"320700","parent":"320000"},{"name":"淮安市","value":"320800","parent":"320000"},{"name":"盐城市","value":"320900","parent":"320000"},{"name":"扬州市","value":"321000","parent":"320000"},{"name":"镇江市","value":"321100","parent":"320000"},{"name":"泰州市","value":"321200","parent":"320000"},{"name":"宿迁市","value":"321300","parent":"320000"},{"name":"玄武区","value":"320102","parent":"320100"},{"name":"秦淮区","value":"320104","parent":"320100"},{"name":"建邺区","value":"320105","parent":"320100"},{"name":"鼓楼区","value":"320106","parent":"320100"},{"name":"浦口区","value":"320111","parent":"320100"},{"name":"栖霞区","value":"320113","parent":"320100"},{"name":"雨花台区","value":"320114","parent":"320100"},{"name":"江宁区","value":"320115","parent":"320100"},{"name":"六合区","value":"320116","parent":"320100"},{"name":"溧水区","value":"320117","parent":"320100"},{"name":"高淳区","value":"320118","parent":"320100"},{"name":"锡山区","value":"320205","parent":"320200"},{"name":"惠山区","value":"320206","parent":"320200"},{"name":"滨湖区","value":"320211","parent":"320200"},{"name":"梁溪区","value":"320213","parent":"320200"},{"name":"新吴区","value":"320214","parent":"320200"},{"name":"江阴市","value":"320281","parent":"320200"},{"name":"宜兴市","value":"320282","parent":"320200"},{"name":"鼓楼区","value":"320302","parent":"320300"},{"name":"云龙区","value":"320303","parent":"320300"},{"name":"贾汪区","value":"320305","parent":"320300"},{"name":"泉山区","value":"320311","parent":"320300"},{"name":"铜山区","value":"320312","parent":"320300"},{"name":"丰县","value":"320321","parent":"320300"},{"name":"沛县","value":"320322","parent":"320300"},{"name":"睢宁县","value":"320324","parent":"320300"},{"name":"新沂市","value":"320381","parent":"320300"},{"name":"邳州市","value":"320382","parent":"320300"},{"name":"天宁区","value":"320402","parent":"320400"},{"name":"钟楼区","value":"320404","parent":"320400"},{"name":"新北区","value":"320411","parent":"320400"},{"name":"武进区","value":"320412","parent":"320400"},{"name":"金坛区","value":"320413","parent":"320400"},{"name":"溧阳市","value":"320481","parent":"320400"},{"name":"虎丘区","value":"320505","parent":"320500"},{"name":"吴中区","value":"320506","parent":"320500"},{"name":"相城区","value":"320507","parent":"320500"},{"name":"姑苏区","value":"320508","parent":"320500"},{"name":"吴江区","value":"320509","parent":"320500"},{"name":"常熟市","value":"320581","parent":"320500"},{"name":"张家港市","value":"320582","parent":"320500"},{"name":"昆山市","value":"320583","parent":"320500"},{"name":"太仓市","value":"320585","parent":"320500"},{"name":"崇川区","value":"320602","parent":"320600"},{"name":"港闸区","value":"320611","parent":"320600"},{"name":"通州区","value":"320612","parent":"320600"},{"name":"海安县","value":"320621","parent":"320600"},{"name":"如东县","value":"320623","parent":"320600"},{"name":"启东市","value":"320681","parent":"320600"},{"name":"如皋市","value":"320682","parent":"320600"},{"name":"海门市","value":"320684","parent":"320600"},{"name":"连云区","value":"320703","parent":"320700"},{"name":"海州区","value":"320706","parent":"320700"},{"name":"赣榆区","value":"320707","parent":"320700"},{"name":"东海县","value":"320722","parent":"320700"},{"name":"灌云县","value":"320723","parent":"320700"},{"name":"灌南县","value":"320724","parent":"320700"},{"name":"淮安区","value":"320803","parent":"320800"},{"name":"淮阴区","value":"320804","parent":"320800"},{"name":"清江浦区","value":"320812","parent":"320800"},{"name":"洪泽区","value":"320813","parent":"320800"},{"name":"涟水县","value":"320826","parent":"320800"},{"name":"盱眙县","value":"320830","parent":"320800"},{"name":"金湖县","value":"320831","parent":"320800"},{"name":"亭湖区","value":"320902","parent":"320900"},{"name":"盐都区","value":"320903","parent":"320900"},{"name":"大丰区","value":"320904","parent":"320900"},{"name":"响水县","value":"320921","parent":"320900"},{"name":"滨海县","value":"320922","parent":"320900"},{"name":"阜宁县","value":"320923","parent":"320900"},{"name":"射阳县","value":"320924","parent":"320900"},{"name":"建湖县","value":"320925","parent":"320900"},{"name":"东台市","value":"320981","parent":"320900"},{"name":"广陵区","value":"321002","parent":"321000"},{"name":"邗江区","value":"321003","parent":"321000"},{"name":"江都区","value":"321012","parent":"321000"},{"name":"宝应县","value":"321023","parent":"321000"},{"name":"仪征市","value":"321081","parent":"321000"},{"name":"高邮市","value":"321084","parent":"321000"},{"name":"京口区","value":"321102","parent":"321100"},{"name":"润州区","value":"321111","parent":"321100"},{"name":"丹徒区","value":"321112","parent":"321100"},{"name":"丹阳市","value":"321181","parent":"321100"},{"name":"扬中市","value":"321182","parent":"321100"},{"name":"句容市","value":"321183","parent":"321100"},{"name":"海陵区","value":"321202","parent":"321200"},{"name":"高港区","value":"321203","parent":"321200"},{"name":"姜堰区","value":"321204","parent":"321200"},{"name":"兴化市","value":"321281","parent":"321200"},{"name":"靖江市","value":"321282","parent":"321200"},{"name":"泰兴市","value":"321283","parent":"321200"},{"name":"宿城区","value":"321302","parent":"321300"},{"name":"宿豫区","value":"321311","parent":"321300"},{"name":"沭阳县","value":"321322","parent":"321300"},{"name":"泗阳县","value":"321323","parent":"321300"},{"name":"泗洪县","value":"321324","parent":"321300"},{"name":"杭州市","value":"330100","parent":"330000"},{"name":"宁波市","value":"330200","parent":"330000"},{"name":"温州市","value":"330300","parent":"330000"},{"name":"嘉兴市","value":"330400","parent":"330000"},{"name":"湖州市","value":"330500","parent":"330000"},{"name":"绍兴市","value":"330600","parent":"330000"},{"name":"金华市","value":"330700","parent":"330000"},{"name":"衢州市","value":"330800","parent":"330000"},{"name":"舟山市","value":"330900","parent":"330000"},{"name":"台州市","value":"331000","parent":"330000"},{"name":"丽水市","value":"331100","parent":"330000"},{"name":"上城区","value":"330102","parent":"330100"},{"name":"下城区","value":"330103","parent":"330100"},{"name":"江干区","value":"330104","parent":"330100"},{"name":"拱墅区","value":"330105","parent":"330100"},{"name":"西湖区","value":"330106","parent":"330100"},{"name":"滨江区","value":"330108","parent":"330100"},{"name":"萧山区","value":"330109","parent":"330100"},{"name":"余杭区","value":"330110","parent":"330100"},{"name":"富阳区","value":"330111","parent":"330100"},{"name":"桐庐县","value":"330122","parent":"330100"},{"name":"淳安县","value":"330127","parent":"330100"},{"name":"建德市","value":"330182","parent":"330100"},{"name":"临安市","value":"330185","parent":"330100"},{"name":"海曙区","value":"330203","parent":"330200"},{"name":"江东区","value":"330204","parent":"330200"},{"name":"江北区","value":"330205","parent":"330200"},{"name":"北仑区","value":"330206","parent":"330200"},{"name":"镇海区","value":"330211","parent":"330200"},{"name":"鄞州区","value":"330212","parent":"330200"},{"name":"象山县","value":"330225","parent":"330200"},{"name":"宁海县","value":"330226","parent":"330200"},{"name":"余姚市","value":"330281","parent":"330200"},{"name":"慈溪市","value":"330282","parent":"330200"},{"name":"奉化市","value":"330283","parent":"330200"},{"name":"鹿城区","value":"330302","parent":"330300"},{"name":"龙湾区","value":"330303","parent":"330300"},{"name":"瓯海区","value":"330304","parent":"330300"},{"name":"洞头区","value":"330305","parent":"330300"},{"name":"永嘉县","value":"330324","parent":"330300"},{"name":"平阳县","value":"330326","parent":"330300"},{"name":"苍南县","value":"330327","parent":"330300"},{"name":"文成县","value":"330328","parent":"330300"},{"name":"泰顺县","value":"330329","parent":"330300"},{"name":"瑞安市","value":"330381","parent":"330300"},{"name":"乐清市","value":"330382","parent":"330300"},{"name":"南湖区","value":"330402","parent":"330400"},{"name":"秀洲区","value":"330411","parent":"330400"},{"name":"嘉善县","value":"330421","parent":"330400"},{"name":"海盐县","value":"330424","parent":"330400"},{"name":"海宁市","value":"330481","parent":"330400"},{"name":"平湖市","value":"330482","parent":"330400"},{"name":"桐乡市","value":"330483","parent":"330400"},{"name":"吴兴区","value":"330502","parent":"330500"},{"name":"南浔区","value":"330503","parent":"330500"},{"name":"德清县","value":"330521","parent":"330500"},{"name":"长兴县","value":"330522","parent":"330500"},{"name":"安吉县","value":"330523","parent":"330500"},{"name":"越城区","value":"330602","parent":"330600"},{"name":"柯桥区","value":"330603","parent":"330600"},{"name":"上虞区","value":"330604","parent":"330600"},{"name":"新昌县","value":"330624","parent":"330600"},{"name":"诸暨市","value":"330681","parent":"330600"},{"name":"嵊州市","value":"330683","parent":"330600"},{"name":"婺城区","value":"330702","parent":"330700"},{"name":"金东区","value":"330703","parent":"330700"},{"name":"武义县","value":"330723","parent":"330700"},{"name":"浦江县","value":"330726","parent":"330700"},{"name":"磐安县","value":"330727","parent":"330700"},{"name":"兰溪市","value":"330781","parent":"330700"},{"name":"义乌市","value":"330782","parent":"330700"},{"name":"东阳市","value":"330783","parent":"330700"},{"name":"永康市","value":"330784","parent":"330700"},{"name":"柯城区","value":"330802","parent":"330800"},{"name":"衢江区","value":"330803","parent":"330800"},{"name":"常山县","value":"330822","parent":"330800"},{"name":"开化县","value":"330824","parent":"330800"},{"name":"龙游县","value":"330825","parent":"330800"},{"name":"江山市","value":"330881","parent":"330800"},{"name":"定海区","value":"330902","parent":"330900"},{"name":"普陀区","value":"330903","parent":"330900"},{"name":"岱山县","value":"330921","parent":"330900"},{"name":"嵊泗县","value":"330922","parent":"330900"},{"name":"椒江区","value":"331002","parent":"331000"},{"name":"黄岩区","value":"331003","parent":"331000"},{"name":"路桥区","value":"331004","parent":"331000"},{"name":"玉环县","value":"331021","parent":"331000"},{"name":"三门县","value":"331022","parent":"331000"},{"name":"天台县","value":"331023","parent":"331000"},{"name":"仙居县","value":"331024","parent":"331000"},{"name":"温岭市","value":"331081","parent":"331000"},{"name":"临海市","value":"331082","parent":"331000"},{"name":"莲都区","value":"331102","parent":"331100"},{"name":"青田县","value":"331121","parent":"331100"},{"name":"缙云县","value":"331122","parent":"331100"},{"name":"遂昌县","value":"331123","parent":"331100"},{"name":"松阳县","value":"331124","parent":"331100"},{"name":"云和县","value":"331125","parent":"331100"},{"name":"庆元县","value":"331126","parent":"331100"},{"name":"景宁畲族自治县","value":"331127","parent":"331100"},{"name":"龙泉市","value":"331181","parent":"331100"},{"name":"合肥市","value":"340100","parent":"340000"},{"name":"芜湖市","value":"340200","parent":"340000"},{"name":"蚌埠市","value":"340300","parent":"340000"},{"name":"淮南市","value":"340400","parent":"340000"},{"name":"马鞍山市","value":"340500","parent":"340000"},{"name":"淮北市","value":"340600","parent":"340000"},{"name":"铜陵市","value":"340700","parent":"340000"},{"name":"安庆市","value":"340800","parent":"340000"},{"name":"黄山市","value":"341000","parent":"340000"},{"name":"滁州市","value":"341100","parent":"340000"},{"name":"阜阳市","value":"341200","parent":"340000"},{"name":"宿州市","value":"341300","parent":"340000"},{"name":"六安市","value":"341500","parent":"340000"},{"name":"亳州市","value":"341600","parent":"340000"},{"name":"池州市","value":"341700","parent":"340000"},{"name":"宣城市","value":"341800","parent":"340000"},{"name":"瑶海区","value":"340102","parent":"340100"},{"name":"庐阳区","value":"340103","parent":"340100"},{"name":"蜀山区","value":"340104","parent":"340100"},{"name":"包河区","value":"340111","parent":"340100"},{"name":"长丰县","value":"340121","parent":"340100"},{"name":"肥东县","value":"340122","parent":"340100"},{"name":"肥西县","value":"340123","parent":"340100"},{"name":"庐江县","value":"340124","parent":"340100"},{"name":"巢湖市","value":"340181","parent":"340100"},{"name":"镜湖区","value":"340202","parent":"340200"},{"name":"弋江区","value":"340203","parent":"340200"},{"name":"鸠江区","value":"340207","parent":"340200"},{"name":"三山区","value":"340208","parent":"340200"},{"name":"芜湖县","value":"340221","parent":"340200"},{"name":"繁昌县","value":"340222","parent":"340200"},{"name":"南陵县","value":"340223","parent":"340200"},{"name":"无为县","value":"340225","parent":"340200"},{"name":"龙子湖区","value":"340302","parent":"340300"},{"name":"蚌山区","value":"340303","parent":"340300"},{"name":"禹会区","value":"340304","parent":"340300"},{"name":"淮上区","value":"340311","parent":"340300"},{"name":"怀远县","value":"340321","parent":"340300"},{"name":"五河县","value":"340322","parent":"340300"},{"name":"固镇县","value":"340323","parent":"340300"},{"name":"大通区","value":"340402","parent":"340400"},{"name":"田家庵区","value":"340403","parent":"340400"},{"name":"谢家集区","value":"340404","parent":"340400"},{"name":"八公山区","value":"340405","parent":"340400"},{"name":"潘集区","value":"340406","parent":"340400"},{"name":"凤台县","value":"340421","parent":"340400"},{"name":"寿县","value":"340422","parent":"340400"},{"name":"花山区","value":"340503","parent":"340500"},{"name":"雨山区","value":"340504","parent":"340500"},{"name":"博望区","value":"340506","parent":"340500"},{"name":"当涂县","value":"340521","parent":"340500"},{"name":"含山县","value":"340522","parent":"340500"},{"name":"和县","value":"340523","parent":"340500"},{"name":"杜集区","value":"340602","parent":"340600"},{"name":"相山区","value":"340603","parent":"340600"},{"name":"烈山区","value":"340604","parent":"340600"},{"name":"濉溪县","value":"340621","parent":"340600"},{"name":"铜官区","value":"340705","parent":"340700"},{"name":"义安区","value":"340706","parent":"340700"},{"name":"郊区","value":"340711","parent":"340700"},{"name":"枞阳县","value":"340722","parent":"340700"},{"name":"迎江区","value":"340802","parent":"340800"},{"name":"大观区","value":"340803","parent":"340800"},{"name":"宜秀区","value":"340811","parent":"340800"},{"name":"怀宁县","value":"340822","parent":"340800"},{"name":"潜山县","value":"340824","parent":"340800"},{"name":"太湖县","value":"340825","parent":"340800"},{"name":"宿松县","value":"340826","parent":"340800"},{"name":"望江县","value":"340827","parent":"340800"},{"name":"岳西县","value":"340828","parent":"340800"},{"name":"桐城市","value":"340881","parent":"340800"},{"name":"屯溪区","value":"341002","parent":"341000"},{"name":"黄山区","value":"341003","parent":"341000"},{"name":"徽州区","value":"341004","parent":"341000"},{"name":"歙县","value":"341021","parent":"341000"},{"name":"休宁县","value":"341022","parent":"341000"},{"name":"黟县","value":"341023","parent":"341000"},{"name":"祁门县","value":"341024","parent":"341000"},{"name":"琅琊区","value":"341102","parent":"341100"},{"name":"南谯区","value":"341103","parent":"341100"},{"name":"来安县","value":"341122","parent":"341100"},{"name":"全椒县","value":"341124","parent":"341100"},{"name":"定远县","value":"341125","parent":"341100"},{"name":"凤阳县","value":"341126","parent":"341100"},{"name":"天长市","value":"341181","parent":"341100"},{"name":"明光市","value":"341182","parent":"341100"},{"name":"颍州区","value":"341202","parent":"341200"},{"name":"颍东区","value":"341203","parent":"341200"},{"name":"颍泉区","value":"341204","parent":"341200"},{"name":"临泉县","value":"341221","parent":"341200"},{"name":"太和县","value":"341222","parent":"341200"},{"name":"阜南县","value":"341225","parent":"341200"},{"name":"颍上县","value":"341226","parent":"341200"},{"name":"界首市","value":"341282","parent":"341200"},{"name":"埇桥区","value":"341302","parent":"341300"},{"name":"砀山县","value":"341321","parent":"341300"},{"name":"萧县","value":"341322","parent":"341300"},{"name":"灵璧县","value":"341323","parent":"341300"},{"name":"泗县","value":"341324","parent":"341300"},{"name":"金安区","value":"341502","parent":"341500"},{"name":"裕安区","value":"341503","parent":"341500"},{"name":"叶集区","value":"341504","parent":"341500"},{"name":"霍邱县","value":"341522","parent":"341500"},{"name":"舒城县","value":"341523","parent":"341500"},{"name":"金寨县","value":"341524","parent":"341500"},{"name":"霍山县","value":"341525","parent":"341500"},{"name":"谯城区","value":"341602","parent":"341600"},{"name":"涡阳县","value":"341621","parent":"341600"},{"name":"蒙城县","value":"341622","parent":"341600"},{"name":"利辛县","value":"341623","parent":"341600"},{"name":"贵池区","value":"341702","parent":"341700"},{"name":"东至县","value":"341721","parent":"341700"},{"name":"石台县","value":"341722","parent":"341700"},{"name":"青阳县","value":"341723","parent":"341700"},{"name":"宣州区","value":"341802","parent":"341800"},{"name":"郎溪县","value":"341821","parent":"341800"},{"name":"广德县","value":"341822","parent":"341800"},{"name":"泾县","value":"341823","parent":"341800"},{"name":"绩溪县","value":"341824","parent":"341800"},{"name":"旌德县","value":"341825","parent":"341800"},{"name":"宁国市","value":"341881","parent":"341800"},{"name":"福州市","value":"350100","parent":"350000"},{"name":"厦门市","value":"350200","parent":"350000"},{"name":"莆田市","value":"350300","parent":"350000"},{"name":"三明市","value":"350400","parent":"350000"},{"name":"泉州市","value":"350500","parent":"350000"},{"name":"漳州市","value":"350600","parent":"350000"},{"name":"南平市","value":"350700","parent":"350000"},{"name":"龙岩市","value":"350800","parent":"350000"},{"name":"宁德市","value":"350900","parent":"350000"},{"name":"鼓楼区","value":"350102","parent":"350100"},{"name":"台江区","value":"350103","parent":"350100"},{"name":"仓山区","value":"350104","parent":"350100"},{"name":"马尾区","value":"350105","parent":"350100"},{"name":"晋安区","value":"350111","parent":"350100"},{"name":"闽侯县","value":"350121","parent":"350100"},{"name":"连江县","value":"350122","parent":"350100"},{"name":"罗源县","value":"350123","parent":"350100"},{"name":"闽清县","value":"350124","parent":"350100"},{"name":"永泰县","value":"350125","parent":"350100"},{"name":"平潭县","value":"350128","parent":"350100"},{"name":"福清市","value":"350181","parent":"350100"},{"name":"长乐市","value":"350182","parent":"350100"},{"name":"思明区","value":"350203","parent":"350200"},{"name":"海沧区","value":"350205","parent":"350200"},{"name":"湖里区","value":"350206","parent":"350200"},{"name":"集美区","value":"350211","parent":"350200"},{"name":"同安区","value":"350212","parent":"350200"},{"name":"翔安区","value":"350213","parent":"350200"},{"name":"城厢区","value":"350302","parent":"350300"},{"name":"涵江区","value":"350303","parent":"350300"},{"name":"荔城区","value":"350304","parent":"350300"},{"name":"秀屿区","value":"350305","parent":"350300"},{"name":"仙游县","value":"350322","parent":"350300"},{"name":"梅列区","value":"350402","parent":"350400"},{"name":"三元区","value":"350403","parent":"350400"},{"name":"明溪县","value":"350421","parent":"350400"},{"name":"清流县","value":"350423","parent":"350400"},{"name":"宁化县","value":"350424","parent":"350400"},{"name":"大田县","value":"350425","parent":"350400"},{"name":"尤溪县","value":"350426","parent":"350400"},{"name":"沙县","value":"350427","parent":"350400"},{"name":"将乐县","value":"350428","parent":"350400"},{"name":"泰宁县","value":"350429","parent":"350400"},{"name":"建宁县","value":"350430","parent":"350400"},{"name":"永安市","value":"350481","parent":"350400"},{"name":"鲤城区","value":"350502","parent":"350500"},{"name":"丰泽区","value":"350503","parent":"350500"},{"name":"洛江区","value":"350504","parent":"350500"},{"name":"泉港区","value":"350505","parent":"350500"},{"name":"惠安县","value":"350521","parent":"350500"},{"name":"安溪县","value":"350524","parent":"350500"},{"name":"永春县","value":"350525","parent":"350500"},{"name":"德化县","value":"350526","parent":"350500"},{"name":"金门县","value":"350527","parent":"350500"},{"name":"石狮市","value":"350581","parent":"350500"},{"name":"晋江市","value":"350582","parent":"350500"},{"name":"南安市","value":"350583","parent":"350500"},{"name":"芗城区","value":"350602","parent":"350600"},{"name":"龙文区","value":"350603","parent":"350600"},{"name":"云霄县","value":"350622","parent":"350600"},{"name":"漳浦县","value":"350623","parent":"350600"},{"name":"诏安县","value":"350624","parent":"350600"},{"name":"长泰县","value":"350625","parent":"350600"},{"name":"东山县","value":"350626","parent":"350600"},{"name":"南靖县","value":"350627","parent":"350600"},{"name":"平和县","value":"350628","parent":"350600"},{"name":"华安县","value":"350629","parent":"350600"},{"name":"龙海市","value":"350681","parent":"350600"},{"name":"延平区","value":"350702","parent":"350700"},{"name":"建阳区","value":"350703","parent":"350700"},{"name":"顺昌县","value":"350721","parent":"350700"},{"name":"浦城县","value":"350722","parent":"350700"},{"name":"光泽县","value":"350723","parent":"350700"},{"name":"松溪县","value":"350724","parent":"350700"},{"name":"政和县","value":"350725","parent":"350700"},{"name":"邵武市","value":"350781","parent":"350700"},{"name":"武夷山市","value":"350782","parent":"350700"},{"name":"建瓯市","value":"350783","parent":"350700"},{"name":"新罗区","value":"350802","parent":"350800"},{"name":"永定区","value":"350803","parent":"350800"},{"name":"长汀县","value":"350821","parent":"350800"},{"name":"上杭县","value":"350823","parent":"350800"},{"name":"武平县","value":"350824","parent":"350800"},{"name":"连城县","value":"350825","parent":"350800"},{"name":"漳平市","value":"350881","parent":"350800"},{"name":"蕉城区","value":"350902","parent":"350900"},{"name":"霞浦县","value":"350921","parent":"350900"},{"name":"古田县","value":"350922","parent":"350900"},{"name":"屏南县","value":"350923","parent":"350900"},{"name":"寿宁县","value":"350924","parent":"350900"},{"name":"周宁县","value":"350925","parent":"350900"},{"name":"柘荣县","value":"350926","parent":"350900"},{"name":"福安市","value":"350981","parent":"350900"},{"name":"福鼎市","value":"350982","parent":"350900"},{"name":"南昌市","value":"360100","parent":"360000"},{"name":"景德镇市","value":"360200","parent":"360000"},{"name":"萍乡市","value":"360300","parent":"360000"},{"name":"九江市","value":"360400","parent":"360000"},{"name":"新余市","value":"360500","parent":"360000"},{"name":"鹰潭市","value":"360600","parent":"360000"},{"name":"赣州市","value":"360700","parent":"360000"},{"name":"吉安市","value":"360800","parent":"360000"},{"name":"宜春市","value":"360900","parent":"360000"},{"name":"抚州市","value":"361000","parent":"360000"},{"name":"上饶市","value":"361100","parent":"360000"},{"name":"东湖区","value":"360102","parent":"360100"},{"name":"西湖区","value":"360103","parent":"360100"},{"name":"青云谱区","value":"360104","parent":"360100"},{"name":"湾里区","value":"360105","parent":"360100"},{"name":"青山湖区","value":"360111","parent":"360100"},{"name":"新建区","value":"360112","parent":"360100"},{"name":"南昌县","value":"360121","parent":"360100"},{"name":"安义县","value":"360123","parent":"360100"},{"name":"进贤县","value":"360124","parent":"360100"},{"name":"昌江区","value":"360202","parent":"360200"},{"name":"珠山区","value":"360203","parent":"360200"},{"name":"浮梁县","value":"360222","parent":"360200"},{"name":"乐平市","value":"360281","parent":"360200"},{"name":"安源区","value":"360302","parent":"360300"},{"name":"湘东区","value":"360313","parent":"360300"},{"name":"莲花县","value":"360321","parent":"360300"},{"name":"上栗县","value":"360322","parent":"360300"},{"name":"芦溪县","value":"360323","parent":"360300"},{"name":"濂溪区","value":"360402","parent":"360400"},{"name":"浔阳区","value":"360403","parent":"360400"},{"name":"九江县","value":"360421","parent":"360400"},{"name":"武宁县","value":"360423","parent":"360400"},{"name":"修水县","value":"360424","parent":"360400"},{"name":"永修县","value":"360425","parent":"360400"},{"name":"德安县","value":"360426","parent":"360400"},{"name":"都昌县","value":"360428","parent":"360400"},{"name":"湖口县","value":"360429","parent":"360400"},{"name":"彭泽县","value":"360430","parent":"360400"},{"name":"瑞昌市","value":"360481","parent":"360400"},{"name":"共青城市","value":"360482","parent":"360400"},{"name":"庐山市","value":"360483","parent":"360400"},{"name":"渝水区","value":"360502","parent":"360500"},{"name":"分宜县","value":"360521","parent":"360500"},{"name":"月湖区","value":"360602","parent":"360600"},{"name":"余江县","value":"360622","parent":"360600"},{"name":"贵溪市","value":"360681","parent":"360600"},{"name":"章贡区","value":"360702","parent":"360700"},{"name":"南康区","value":"360703","parent":"360700"},{"name":"赣县","value":"360721","parent":"360700"},{"name":"信丰县","value":"360722","parent":"360700"},{"name":"大余县","value":"360723","parent":"360700"},{"name":"上犹县","value":"360724","parent":"360700"},{"name":"崇义县","value":"360725","parent":"360700"},{"name":"安远县","value":"360726","parent":"360700"},{"name":"龙南县","value":"360727","parent":"360700"},{"name":"定南县","value":"360728","parent":"360700"},{"name":"全南县","value":"360729","parent":"360700"},{"name":"宁都县","value":"360730","parent":"360700"},{"name":"于都县","value":"360731","parent":"360700"},{"name":"兴国县","value":"360732","parent":"360700"},{"name":"会昌县","value":"360733","parent":"360700"},{"name":"寻乌县","value":"360734","parent":"360700"},{"name":"石城县","value":"360735","parent":"360700"},{"name":"瑞金市","value":"360781","parent":"360700"},{"name":"吉州区","value":"360802","parent":"360800"},{"name":"青原区","value":"360803","parent":"360800"},{"name":"吉安县","value":"360821","parent":"360800"},{"name":"吉水县","value":"360822","parent":"360800"},{"name":"峡江县","value":"360823","parent":"360800"},{"name":"新干县","value":"360824","parent":"360800"},{"name":"永丰县","value":"360825","parent":"360800"},{"name":"泰和县","value":"360826","parent":"360800"},{"name":"遂川县","value":"360827","parent":"360800"},{"name":"万安县","value":"360828","parent":"360800"},{"name":"安福县","value":"360829","parent":"360800"},{"name":"永新县","value":"360830","parent":"360800"},{"name":"井冈山市","value":"360881","parent":"360800"},{"name":"袁州区","value":"360902","parent":"360900"},{"name":"奉新县","value":"360921","parent":"360900"},{"name":"万载县","value":"360922","parent":"360900"},{"name":"上高县","value":"360923","parent":"360900"},{"name":"宜丰县","value":"360924","parent":"360900"},{"name":"靖安县","value":"360925","parent":"360900"},{"name":"铜鼓县","value":"360926","parent":"360900"},{"name":"丰城市","value":"360981","parent":"360900"},{"name":"樟树市","value":"360982","parent":"360900"},{"name":"高安市","value":"360983","parent":"360900"},{"name":"临川区","value":"361002","parent":"361000"},{"name":"南城县","value":"361021","parent":"361000"},{"name":"黎川县","value":"361022","parent":"361000"},{"name":"南丰县","value":"361023","parent":"361000"},{"name":"崇仁县","value":"361024","parent":"361000"},{"name":"乐安县","value":"361025","parent":"361000"},{"name":"宜黄县","value":"361026","parent":"361000"},{"name":"金溪县","value":"361027","parent":"361000"},{"name":"资溪县","value":"361028","parent":"361000"},{"name":"东乡县","value":"361029","parent":"361000"},{"name":"广昌县","value":"361030","parent":"361000"},{"name":"信州区","value":"361102","parent":"361100"},{"name":"广丰区","value":"361103","parent":"361100"},{"name":"上饶县","value":"361121","parent":"361100"},{"name":"玉山县","value":"361123","parent":"361100"},{"name":"铅山县","value":"361124","parent":"361100"},{"name":"横峰县","value":"361125","parent":"361100"},{"name":"弋阳县","value":"361126","parent":"361100"},{"name":"余干县","value":"361127","parent":"361100"},{"name":"鄱阳县","value":"361128","parent":"361100"},{"name":"万年县","value":"361129","parent":"361100"},{"name":"婺源县","value":"361130","parent":"361100"},{"name":"德兴市","value":"361181","parent":"361100"},{"name":"济南市","value":"370100","parent":"370000"},{"name":"青岛市","value":"370200","parent":"370000"},{"name":"淄博市","value":"370300","parent":"370000"},{"name":"枣庄市","value":"370400","parent":"370000"},{"name":"东营市","value":"370500","parent":"370000"},{"name":"烟台市","value":"370600","parent":"370000"},{"name":"潍坊市","value":"370700","parent":"370000"},{"name":"济宁市","value":"370800","parent":"370000"},{"name":"泰安市","value":"370900","parent":"370000"},{"name":"威海市","value":"371000","parent":"370000"},{"name":"日照市","value":"371100","parent":"370000"},{"name":"莱芜市","value":"371200","parent":"370000"},{"name":"临沂市","value":"371300","parent":"370000"},{"name":"德州市","value":"371400","parent":"370000"},{"name":"聊城市","value":"371500","parent":"370000"},{"name":"滨州市","value":"371600","parent":"370000"},{"name":"菏泽市","value":"371700","parent":"370000"},{"name":"历下区","value":"370102","parent":"370100"},{"name":"市中区","value":"370103","parent":"370100"},{"name":"槐荫区","value":"370104","parent":"370100"},{"name":"天桥区","value":"370105","parent":"370100"},{"name":"历城区","value":"370112","parent":"370100"},{"name":"长清区","value":"370113","parent":"370100"},{"name":"平阴县","value":"370124","parent":"370100"},{"name":"济阳县","value":"370125","parent":"370100"},{"name":"商河县","value":"370126","parent":"370100"},{"name":"章丘市","value":"370181","parent":"370100"},{"name":"市南区","value":"370202","parent":"370200"},{"name":"市北区","value":"370203","parent":"370200"},{"name":"黄岛区","value":"370211","parent":"370200"},{"name":"崂山区","value":"370212","parent":"370200"},{"name":"李沧区","value":"370213","parent":"370200"},{"name":"城阳区","value":"370214","parent":"370200"},{"name":"胶州市","value":"370281","parent":"370200"},{"name":"即墨市","value":"370282","parent":"370200"},{"name":"平度市","value":"370283","parent":"370200"},{"name":"莱西市","value":"370285","parent":"370200"},{"name":"淄川区","value":"370302","parent":"370300"},{"name":"张店区","value":"370303","parent":"370300"},{"name":"博山区","value":"370304","parent":"370300"},{"name":"临淄区","value":"370305","parent":"370300"},{"name":"周村区","value":"370306","parent":"370300"},{"name":"桓台县","value":"370321","parent":"370300"},{"name":"高青县","value":"370322","parent":"370300"},{"name":"沂源县","value":"370323","parent":"370300"},{"name":"市中区","value":"370402","parent":"370400"},{"name":"薛城区","value":"370403","parent":"370400"},{"name":"峄城区","value":"370404","parent":"370400"},{"name":"台儿庄区","value":"370405","parent":"370400"},{"name":"山亭区","value":"370406","parent":"370400"},{"name":"滕州市","value":"370481","parent":"370400"},{"name":"东营区","value":"370502","parent":"370500"},{"name":"河口区","value":"370503","parent":"370500"},{"name":"垦利区","value":"370505","parent":"370500"},{"name":"利津县","value":"370522","parent":"370500"},{"name":"广饶县","value":"370523","parent":"370500"},{"name":"芝罘区","value":"370602","parent":"370600"},{"name":"福山区","value":"370611","parent":"370600"},{"name":"牟平区","value":"370612","parent":"370600"},{"name":"莱山区","value":"370613","parent":"370600"},{"name":"长岛县","value":"370634","parent":"370600"},{"name":"龙口市","value":"370681","parent":"370600"},{"name":"莱阳市","value":"370682","parent":"370600"},{"name":"莱州市","value":"370683","parent":"370600"},{"name":"蓬莱市","value":"370684","parent":"370600"},{"name":"招远市","value":"370685","parent":"370600"},{"name":"栖霞市","value":"370686","parent":"370600"},{"name":"海阳市","value":"370687","parent":"370600"},{"name":"潍城区","value":"370702","parent":"370700"},{"name":"寒亭区","value":"370703","parent":"370700"},{"name":"坊子区","value":"370704","parent":"370700"},{"name":"奎文区","value":"370705","parent":"370700"},{"name":"临朐县","value":"370724","parent":"370700"},{"name":"昌乐县","value":"370725","parent":"370700"},{"name":"青州市","value":"370781","parent":"370700"},{"name":"诸城市","value":"370782","parent":"370700"},{"name":"寿光市","value":"370783","parent":"370700"},{"name":"安丘市","value":"370784","parent":"370700"},{"name":"高密市","value":"370785","parent":"370700"},{"name":"昌邑市","value":"370786","parent":"370700"},{"name":"任城区","value":"370811","parent":"370800"},{"name":"兖州区","value":"370812","parent":"370800"},{"name":"微山县","value":"370826","parent":"370800"},{"name":"鱼台县","value":"370827","parent":"370800"},{"name":"金乡县","value":"370828","parent":"370800"},{"name":"嘉祥县","value":"370829","parent":"370800"},{"name":"汶上县","value":"370830","parent":"370800"},{"name":"泗水县","value":"370831","parent":"370800"},{"name":"梁山县","value":"370832","parent":"370800"},{"name":"曲阜市","value":"370881","parent":"370800"},{"name":"邹城市","value":"370883","parent":"370800"},{"name":"泰山区","value":"370902","parent":"370900"},{"name":"岱岳区","value":"370911","parent":"370900"},{"name":"宁阳县","value":"370921","parent":"370900"},{"name":"东平县","value":"370923","parent":"370900"},{"name":"新泰市","value":"370982","parent":"370900"},{"name":"肥城市","value":"370983","parent":"370900"},{"name":"环翠区","value":"371002","parent":"371000"},{"name":"文登区","value":"371003","parent":"371000"},{"name":"荣成市","value":"371082","parent":"371000"},{"name":"乳山市","value":"371083","parent":"371000"},{"name":"东港区","value":"371102","parent":"371100"},{"name":"岚山区","value":"371103","parent":"371100"},{"name":"五莲县","value":"371121","parent":"371100"},{"name":"莒县","value":"371122","parent":"371100"},{"name":"莱城区","value":"371202","parent":"371200"},{"name":"钢城区","value":"371203","parent":"371200"},{"name":"兰山区","value":"371302","parent":"371300"},{"name":"罗庄区","value":"371311","parent":"371300"},{"name":"河东区","value":"371312","parent":"371300"},{"name":"沂南县","value":"371321","parent":"371300"},{"name":"郯城县","value":"371322","parent":"371300"},{"name":"沂水县","value":"371323","parent":"371300"},{"name":"兰陵县","value":"371324","parent":"371300"},{"name":"费县","value":"371325","parent":"371300"},{"name":"平邑县","value":"371326","parent":"371300"},{"name":"莒南县","value":"371327","parent":"371300"},{"name":"蒙阴县","value":"371328","parent":"371300"},{"name":"临沭县","value":"371329","parent":"371300"},{"name":"德城区","value":"371402","parent":"371400"},{"name":"陵城区","value":"371403","parent":"371400"},{"name":"宁津县","value":"371422","parent":"371400"},{"name":"庆云县","value":"371423","parent":"371400"},{"name":"临邑县","value":"371424","parent":"371400"},{"name":"齐河县","value":"371425","parent":"371400"},{"name":"平原县","value":"371426","parent":"371400"},{"name":"夏津县","value":"371427","parent":"371400"},{"name":"武城县","value":"371428","parent":"371400"},{"name":"乐陵市","value":"371481","parent":"371400"},{"name":"禹城市","value":"371482","parent":"371400"},{"name":"东昌府区","value":"371502","parent":"371500"},{"name":"阳谷县","value":"371521","parent":"371500"},{"name":"莘县","value":"371522","parent":"371500"},{"name":"茌平县","value":"371523","parent":"371500"},{"name":"东阿县","value":"371524","parent":"371500"},{"name":"冠县","value":"371525","parent":"371500"},{"name":"高唐县","value":"371526","parent":"371500"},{"name":"临清市","value":"371581","parent":"371500"},{"name":"滨城区","value":"371602","parent":"371600"},{"name":"沾化区","value":"371603","parent":"371600"},{"name":"惠民县","value":"371621","parent":"371600"},{"name":"阳信县","value":"371622","parent":"371600"},{"name":"无棣县","value":"371623","parent":"371600"},{"name":"博兴县","value":"371625","parent":"371600"},{"name":"邹平县","value":"371626","parent":"371600"},{"name":"牡丹区","value":"371702","parent":"371700"},{"name":"定陶区","value":"371703","parent":"371700"},{"name":"曹县","value":"371721","parent":"371700"},{"name":"单县","value":"371722","parent":"371700"},{"name":"成武县","value":"371723","parent":"371700"},{"name":"巨野县","value":"371724","parent":"371700"},{"name":"郓城县","value":"371725","parent":"371700"},{"name":"鄄城县","value":"371726","parent":"371700"},{"name":"东明县","value":"371728","parent":"371700"},{"name":"郑州市","value":"410100","parent":"410000"},{"name":"开封市","value":"410200","parent":"410000"},{"name":"洛阳市","value":"410300","parent":"410000"},{"name":"平顶山市","value":"410400","parent":"410000"},{"name":"安阳市","value":"410500","parent":"410000"},{"name":"鹤壁市","value":"410600","parent":"410000"},{"name":"新乡市","value":"410700","parent":"410000"},{"name":"焦作市","value":"410800","parent":"410000"},{"name":"濮阳市","value":"410900","parent":"410000"},{"name":"许昌市","value":"411000","parent":"410000"},{"name":"漯河市","value":"411100","parent":"410000"},{"name":"三门峡市","value":"411200","parent":"410000"},{"name":"南阳市","value":"411300","parent":"410000"},{"name":"商丘市","value":"411400","parent":"410000"},{"name":"信阳市","value":"411500","parent":"410000"},{"name":"周口市","value":"411600","parent":"410000"},{"name":"驻马店市","value":"411700","parent":"410000"},{"name":"济源市","value":"419001","parent":"410000"},{"name":"中原区","value":"410102","parent":"410100"},{"name":"二七区","value":"410103","parent":"410100"},{"name":"管城回族区","value":"410104","parent":"410100"},{"name":"金水区","value":"410105","parent":"410100"},{"name":"上街区","value":"410106","parent":"410100"},{"name":"惠济区","value":"410108","parent":"410100"},{"name":"中牟县","value":"410122","parent":"410100"},{"name":"巩义市","value":"410181","parent":"410100"},{"name":"荥阳市","value":"410182","parent":"410100"},{"name":"新密市","value":"410183","parent":"410100"},{"name":"新郑市","value":"410184","parent":"410100"},{"name":"登封市","value":"410185","parent":"410100"},{"name":"龙亭区","value":"410202","parent":"410200"},{"name":"顺河回族区","value":"410203","parent":"410200"},{"name":"鼓楼区","value":"410204","parent":"410200"},{"name":"禹王台区","value":"410205","parent":"410200"},{"name":"金明区","value":"410211","parent":"410200"},{"name":"祥符区","value":"410212","parent":"410200"},{"name":"杞县","value":"410221","parent":"410200"},{"name":"通许县","value":"410222","parent":"410200"},{"name":"尉氏县","value":"410223","parent":"410200"},{"name":"兰考县","value":"410225","parent":"410200"},{"name":"老城区","value":"410302","parent":"410300"},{"name":"西工区","value":"410303","parent":"410300"},{"name":"瀍河回族区","value":"410304","parent":"410300"},{"name":"涧西区","value":"410305","parent":"410300"},{"name":"吉利区","value":"410306","parent":"410300"},{"name":"洛龙区","value":"410311","parent":"410300"},{"name":"孟津县","value":"410322","parent":"410300"},{"name":"新安县","value":"410323","parent":"410300"},{"name":"栾川县","value":"410324","parent":"410300"},{"name":"嵩县","value":"410325","parent":"410300"},{"name":"汝阳县","value":"410326","parent":"410300"},{"name":"宜阳县","value":"410327","parent":"410300"},{"name":"洛宁县","value":"410328","parent":"410300"},{"name":"伊川县","value":"410329","parent":"410300"},{"name":"偃师市","value":"410381","parent":"410300"},{"name":"新华区","value":"410402","parent":"410400"},{"name":"卫东区","value":"410403","parent":"410400"},{"name":"石龙区","value":"410404","parent":"410400"},{"name":"湛河区","value":"410411","parent":"410400"},{"name":"宝丰县","value":"410421","parent":"410400"},{"name":"叶县","value":"410422","parent":"410400"},{"name":"鲁山县","value":"410423","parent":"410400"},{"name":"郏县","value":"410425","parent":"410400"},{"name":"舞钢市","value":"410481","parent":"410400"},{"name":"汝州市","value":"410482","parent":"410400"},{"name":"文峰区","value":"410502","parent":"410500"},{"name":"北关区","value":"410503","parent":"410500"},{"name":"殷都区","value":"410505","parent":"410500"},{"name":"龙安区","value":"410506","parent":"410500"},{"name":"安阳县","value":"410522","parent":"410500"},{"name":"汤阴县","value":"410523","parent":"410500"},{"name":"滑县","value":"410526","parent":"410500"},{"name":"内黄县","value":"410527","parent":"410500"},{"name":"林州市","value":"410581","parent":"410500"},{"name":"鹤山区","value":"410602","parent":"410600"},{"name":"山城区","value":"410603","parent":"410600"},{"name":"淇滨区","value":"410611","parent":"410600"},{"name":"浚县","value":"410621","parent":"410600"},{"name":"淇县","value":"410622","parent":"410600"},{"name":"红旗区","value":"410702","parent":"410700"},{"name":"卫滨区","value":"410703","parent":"410700"},{"name":"凤泉区","value":"410704","parent":"410700"},{"name":"牧野区","value":"410711","parent":"410700"},{"name":"新乡县","value":"410721","parent":"410700"},{"name":"获嘉县","value":"410724","parent":"410700"},{"name":"原阳县","value":"410725","parent":"410700"},{"name":"延津县","value":"410726","parent":"410700"},{"name":"封丘县","value":"410727","parent":"410700"},{"name":"长垣县","value":"410728","parent":"410700"},{"name":"卫辉市","value":"410781","parent":"410700"},{"name":"辉县市","value":"410782","parent":"410700"},{"name":"解放区","value":"410802","parent":"410800"},{"name":"中站区","value":"410803","parent":"410800"},{"name":"马村区","value":"410804","parent":"410800"},{"name":"山阳区","value":"410811","parent":"410800"},{"name":"修武县","value":"410821","parent":"410800"},{"name":"博爱县","value":"410822","parent":"410800"},{"name":"武陟县","value":"410823","parent":"410800"},{"name":"温县","value":"410825","parent":"410800"},{"name":"沁阳市","value":"410882","parent":"410800"},{"name":"孟州市","value":"410883","parent":"410800"},{"name":"华龙区","value":"410902","parent":"410900"},{"name":"清丰县","value":"410922","parent":"410900"},{"name":"南乐县","value":"410923","parent":"410900"},{"name":"范县","value":"410926","parent":"410900"},{"name":"台前县","value":"410927","parent":"410900"},{"name":"濮阳县","value":"410928","parent":"410900"},{"name":"魏都区","value":"411002","parent":"411000"},{"name":"许昌县","value":"411023","parent":"411000"},{"name":"鄢陵县","value":"411024","parent":"411000"},{"name":"襄城县","value":"411025","parent":"411000"},{"name":"禹州市","value":"411081","parent":"411000"},{"name":"长葛市","value":"411082","parent":"411000"},{"name":"源汇区","value":"411102","parent":"411100"},{"name":"郾城区","value":"411103","parent":"411100"},{"name":"召陵区","value":"411104","parent":"411100"},{"name":"舞阳县","value":"411121","parent":"411100"},{"name":"临颍县","value":"411122","parent":"411100"},{"name":"湖滨区","value":"411202","parent":"411200"},{"name":"陕州区","value":"411203","parent":"411200"},{"name":"渑池县","value":"411221","parent":"411200"},{"name":"卢氏县","value":"411224","parent":"411200"},{"name":"义马市","value":"411281","parent":"411200"},{"name":"灵宝市","value":"411282","parent":"411200"},{"name":"宛城区","value":"411302","parent":"411300"},{"name":"卧龙区","value":"411303","parent":"411300"},{"name":"南召县","value":"411321","parent":"411300"},{"name":"方城县","value":"411322","parent":"411300"},{"name":"西峡县","value":"411323","parent":"411300"},{"name":"镇平县","value":"411324","parent":"411300"},{"name":"内乡县","value":"411325","parent":"411300"},{"name":"淅川县","value":"411326","parent":"411300"},{"name":"社旗县","value":"411327","parent":"411300"},{"name":"唐河县","value":"411328","parent":"411300"},{"name":"新野县","value":"411329","parent":"411300"},{"name":"桐柏县","value":"411330","parent":"411300"},{"name":"邓州市","value":"411381","parent":"411300"},{"name":"梁园区","value":"411402","parent":"411400"},{"name":"睢阳区","value":"411403","parent":"411400"},{"name":"民权县","value":"411421","parent":"411400"},{"name":"睢县","value":"411422","parent":"411400"},{"name":"宁陵县","value":"411423","parent":"411400"},{"name":"柘城县","value":"411424","parent":"411400"},{"name":"虞城县","value":"411425","parent":"411400"},{"name":"夏邑县","value":"411426","parent":"411400"},{"name":"永城市","value":"411481","parent":"411400"},{"name":"浉河区","value":"411502","parent":"411500"},{"name":"平桥区","value":"411503","parent":"411500"},{"name":"罗山县","value":"411521","parent":"411500"},{"name":"光山县","value":"411522","parent":"411500"},{"name":"新县","value":"411523","parent":"411500"},{"name":"商城县","value":"411524","parent":"411500"},{"name":"固始县","value":"411525","parent":"411500"},{"name":"潢川县","value":"411526","parent":"411500"},{"name":"淮滨县","value":"411527","parent":"411500"},{"name":"息县","value":"411528","parent":"411500"},{"name":"川汇区","value":"411602","parent":"411600"},{"name":"扶沟县","value":"411621","parent":"411600"},{"name":"西华县","value":"411622","parent":"411600"},{"name":"商水县","value":"411623","parent":"411600"},{"name":"沈丘县","value":"411624","parent":"411600"},{"name":"郸城县","value":"411625","parent":"411600"},{"name":"淮阳县","value":"411626","parent":"411600"},{"name":"太康县","value":"411627","parent":"411600"},{"name":"鹿邑县","value":"411628","parent":"411600"},{"name":"项城市","value":"411681","parent":"411600"},{"name":"驿城区","value":"411702","parent":"411700"},{"name":"西平县","value":"411721","parent":"411700"},{"name":"上蔡县","value":"411722","parent":"411700"},{"name":"平舆县","value":"411723","parent":"411700"},{"name":"正阳县","value":"411724","parent":"411700"},{"name":"确山县","value":"411725","parent":"411700"},{"name":"泌阳县","value":"411726","parent":"411700"},{"name":"汝南县","value":"411727","parent":"411700"},{"name":"遂平县","value":"411728","parent":"411700"},{"name":"新蔡县","value":"411729","parent":"411700"},{"name":"武汉市","value":"420100","parent":"420000"},{"name":"黄石市","value":"420200","parent":"420000"},{"name":"十堰市","value":"420300","parent":"420000"},{"name":"宜昌市","value":"420500","parent":"420000"},{"name":"襄阳市","value":"420600","parent":"420000"},{"name":"鄂州市","value":"420700","parent":"420000"},{"name":"荆门市","value":"420800","parent":"420000"},{"name":"孝感市","value":"420900","parent":"420000"},{"name":"荆州市","value":"421000","parent":"420000"},{"name":"黄冈市","value":"421100","parent":"420000"},{"name":"咸宁市","value":"421200","parent":"420000"},{"name":"随州市","value":"421300","parent":"420000"},{"name":"恩施土家族苗族自治州","value":"422800","parent":"420000"},{"name":"仙桃市","value":"429004","parent":"420000"},{"name":"潜江市","value":"429005","parent":"420000"},{"name":"天门市","value":"429006","parent":"420000"},{"name":"神农架林区","value":"429021","parent":"420000"},{"name":"江岸区","value":"420102","parent":"420100"},{"name":"江汉区","value":"420103","parent":"420100"},{"name":"硚口区","value":"420104","parent":"420100"},{"name":"汉阳区","value":"420105","parent":"420100"},{"name":"武昌区","value":"420106","parent":"420100"},{"name":"青山区","value":"420107","parent":"420100"},{"name":"洪山区","value":"420111","parent":"420100"},{"name":"东西湖区","value":"420112","parent":"420100"},{"name":"汉南区","value":"420113","parent":"420100"},{"name":"蔡甸区","value":"420114","parent":"420100"},{"name":"江夏区","value":"420115","parent":"420100"},{"name":"黄陂区","value":"420116","parent":"420100"},{"name":"新洲区","value":"420117","parent":"420100"},{"name":"黄石港区","value":"420202","parent":"420200"},{"name":"西塞山区","value":"420203","parent":"420200"},{"name":"下陆区","value":"420204","parent":"420200"},{"name":"铁山区","value":"420205","parent":"420200"},{"name":"阳新县","value":"420222","parent":"420200"},{"name":"大冶市","value":"420281","parent":"420200"},{"name":"茅箭区","value":"420302","parent":"420300"},{"name":"张湾区","value":"420303","parent":"420300"},{"name":"郧阳区","value":"420304","parent":"420300"},{"name":"郧西县","value":"420322","parent":"420300"},{"name":"竹山县","value":"420323","parent":"420300"},{"name":"竹溪县","value":"420324","parent":"420300"},{"name":"房县","value":"420325","parent":"420300"},{"name":"丹江口市","value":"420381","parent":"420300"},{"name":"西陵区","value":"420502","parent":"420500"},{"name":"伍家岗区","value":"420503","parent":"420500"},{"name":"点军区","value":"420504","parent":"420500"},{"name":"猇亭区","value":"420505","parent":"420500"},{"name":"夷陵区","value":"420506","parent":"420500"},{"name":"远安县","value":"420525","parent":"420500"},{"name":"兴山县","value":"420526","parent":"420500"},{"name":"秭归县","value":"420527","parent":"420500"},{"name":"长阳土家族自治县","value":"420528","parent":"420500"},{"name":"五峰土家族自治县","value":"420529","parent":"420500"},{"name":"宜都市","value":"420581","parent":"420500"},{"name":"当阳市","value":"420582","parent":"420500"},{"name":"枝江市","value":"420583","parent":"420500"},{"name":"襄城区","value":"420602","parent":"420600"},{"name":"樊城区","value":"420606","parent":"420600"},{"name":"襄州区","value":"420607","parent":"420600"},{"name":"南漳县","value":"420624","parent":"420600"},{"name":"谷城县","value":"420625","parent":"420600"},{"name":"保康县","value":"420626","parent":"420600"},{"name":"老河口市","value":"420682","parent":"420600"},{"name":"枣阳市","value":"420683","parent":"420600"},{"name":"宜城市","value":"420684","parent":"420600"},{"name":"梁子湖区","value":"420702","parent":"420700"},{"name":"华容区","value":"420703","parent":"420700"},{"name":"鄂城区","value":"420704","parent":"420700"},{"name":"东宝区","value":"420802","parent":"420800"},{"name":"掇刀区","value":"420804","parent":"420800"},{"name":"京山县","value":"420821","parent":"420800"},{"name":"沙洋县","value":"420822","parent":"420800"},{"name":"钟祥市","value":"420881","parent":"420800"},{"name":"孝南区","value":"420902","parent":"420900"},{"name":"孝昌县","value":"420921","parent":"420900"},{"name":"大悟县","value":"420922","parent":"420900"},{"name":"云梦县","value":"420923","parent":"420900"},{"name":"应城市","value":"420981","parent":"420900"},{"name":"安陆市","value":"420982","parent":"420900"},{"name":"汉川市","value":"420984","parent":"420900"},{"name":"沙市区","value":"421002","parent":"421000"},{"name":"荆州区","value":"421003","parent":"421000"},{"name":"公安县","value":"421022","parent":"421000"},{"name":"监利县","value":"421023","parent":"421000"},{"name":"江陵县","value":"421024","parent":"421000"},{"name":"石首市","value":"421081","parent":"421000"},{"name":"洪湖市","value":"421083","parent":"421000"},{"name":"松滋市","value":"421087","parent":"421000"},{"name":"黄州区","value":"421102","parent":"421100"},{"name":"团风县","value":"421121","parent":"421100"},{"name":"红安县","value":"421122","parent":"421100"},{"name":"罗田县","value":"421123","parent":"421100"},{"name":"英山县","value":"421124","parent":"421100"},{"name":"浠水县","value":"421125","parent":"421100"},{"name":"蕲春县","value":"421126","parent":"421100"},{"name":"黄梅县","value":"421127","parent":"421100"},{"name":"麻城市","value":"421181","parent":"421100"},{"name":"武穴市","value":"421182","parent":"421100"},{"name":"咸安区","value":"421202","parent":"421200"},{"name":"嘉鱼县","value":"421221","parent":"421200"},{"name":"通城县","value":"421222","parent":"421200"},{"name":"崇阳县","value":"421223","parent":"421200"},{"name":"通山县","value":"421224","parent":"421200"},{"name":"赤壁市","value":"421281","parent":"421200"},{"name":"曾都区","value":"421303","parent":"421300"},{"name":"随县","value":"421321","parent":"421300"},{"name":"广水市","value":"421381","parent":"421300"},{"name":"恩施市","value":"422801","parent":"422800"},{"name":"利川市","value":"422802","parent":"422800"},{"name":"建始县","value":"422822","parent":"422800"},{"name":"巴东县","value":"422823","parent":"422800"},{"name":"宣恩县","value":"422825","parent":"422800"},{"name":"咸丰县","value":"422826","parent":"422800"},{"name":"来凤县","value":"422827","parent":"422800"},{"name":"鹤峰县","value":"422828","parent":"422800"},{"name":"长沙市","value":"430100","parent":"430000"},{"name":"株洲市","value":"430200","parent":"430000"},{"name":"湘潭市","value":"430300","parent":"430000"},{"name":"衡阳市","value":"430400","parent":"430000"},{"name":"邵阳市","value":"430500","parent":"430000"},{"name":"岳阳市","value":"430600","parent":"430000"},{"name":"常德市","value":"430700","parent":"430000"},{"name":"张家界市","value":"430800","parent":"430000"},{"name":"益阳市","value":"430900","parent":"430000"},{"name":"郴州市","value":"431000","parent":"430000"},{"name":"永州市","value":"431100","parent":"430000"},{"name":"怀化市","value":"431200","parent":"430000"},{"name":"娄底市","value":"431300","parent":"430000"},{"name":"湘西土家族苗族自治州","value":"433100","parent":"430000"},{"name":"芙蓉区","value":"430102","parent":"430100"},{"name":"天心区","value":"430103","parent":"430100"},{"name":"岳麓区","value":"430104","parent":"430100"},{"name":"开福区","value":"430105","parent":"430100"},{"name":"雨花区","value":"430111","parent":"430100"},{"name":"望城区","value":"430112","parent":"430100"},{"name":"长沙县","value":"430121","parent":"430100"},{"name":"宁乡县","value":"430124","parent":"430100"},{"name":"浏阳市","value":"430181","parent":"430100"},{"name":"荷塘区","value":"430202","parent":"430200"},{"name":"芦淞区","value":"430203","parent":"430200"},{"name":"石峰区","value":"430204","parent":"430200"},{"name":"天元区","value":"430211","parent":"430200"},{"name":"株洲县","value":"430221","parent":"430200"},{"name":"攸县","value":"430223","parent":"430200"},{"name":"茶陵县","value":"430224","parent":"430200"},{"name":"炎陵县","value":"430225","parent":"430200"},{"name":"醴陵市","value":"430281","parent":"430200"},{"name":"雨湖区","value":"430302","parent":"430300"},{"name":"岳塘区","value":"430304","parent":"430300"},{"name":"湘潭县","value":"430321","parent":"430300"},{"name":"湘乡市","value":"430381","parent":"430300"},{"name":"韶山市","value":"430382","parent":"430300"},{"name":"珠晖区","value":"430405","parent":"430400"},{"name":"雁峰区","value":"430406","parent":"430400"},{"name":"石鼓区","value":"430407","parent":"430400"},{"name":"蒸湘区","value":"430408","parent":"430400"},{"name":"南岳区","value":"430412","parent":"430400"},{"name":"衡阳县","value":"430421","parent":"430400"},{"name":"衡南县","value":"430422","parent":"430400"},{"name":"衡山县","value":"430423","parent":"430400"},{"name":"衡东县","value":"430424","parent":"430400"},{"name":"祁东县","value":"430426","parent":"430400"},{"name":"耒阳市","value":"430481","parent":"430400"},{"name":"常宁市","value":"430482","parent":"430400"},{"name":"双清区","value":"430502","parent":"430500"},{"name":"大祥区","value":"430503","parent":"430500"},{"name":"北塔区","value":"430511","parent":"430500"},{"name":"邵东县","value":"430521","parent":"430500"},{"name":"新邵县","value":"430522","parent":"430500"},{"name":"邵阳县","value":"430523","parent":"430500"},{"name":"隆回县","value":"430524","parent":"430500"},{"name":"洞口县","value":"430525","parent":"430500"},{"name":"绥宁县","value":"430527","parent":"430500"},{"name":"新宁县","value":"430528","parent":"430500"},{"name":"城步苗族自治县","value":"430529","parent":"430500"},{"name":"武冈市","value":"430581","parent":"430500"},{"name":"岳阳楼区","value":"430602","parent":"430600"},{"name":"云溪区","value":"430603","parent":"430600"},{"name":"君山区","value":"430611","parent":"430600"},{"name":"岳阳县","value":"430621","parent":"430600"},{"name":"华容县","value":"430623","parent":"430600"},{"name":"湘阴县","value":"430624","parent":"430600"},{"name":"平江县","value":"430626","parent":"430600"},{"name":"汨罗市","value":"430681","parent":"430600"},{"name":"临湘市","value":"430682","parent":"430600"},{"name":"武陵区","value":"430702","parent":"430700"},{"name":"鼎城区","value":"430703","parent":"430700"},{"name":"安乡县","value":"430721","parent":"430700"},{"name":"汉寿县","value":"430722","parent":"430700"},{"name":"澧县","value":"430723","parent":"430700"},{"name":"临澧县","value":"430724","parent":"430700"},{"name":"桃源县","value":"430725","parent":"430700"},{"name":"石门县","value":"430726","parent":"430700"},{"name":"津市市","value":"430781","parent":"430700"},{"name":"永定区","value":"430802","parent":"430800"},{"name":"武陵源区","value":"430811","parent":"430800"},{"name":"慈利县","value":"430821","parent":"430800"},{"name":"桑植县","value":"430822","parent":"430800"},{"name":"资阳区","value":"430902","parent":"430900"},{"name":"赫山区","value":"430903","parent":"430900"},{"name":"南县","value":"430921","parent":"430900"},{"name":"桃江县","value":"430922","parent":"430900"},{"name":"安化县","value":"430923","parent":"430900"},{"name":"沅江市","value":"430981","parent":"430900"},{"name":"北湖区","value":"431002","parent":"431000"},{"name":"苏仙区","value":"431003","parent":"431000"},{"name":"桂阳县","value":"431021","parent":"431000"},{"name":"宜章县","value":"431022","parent":"431000"},{"name":"永兴县","value":"431023","parent":"431000"},{"name":"嘉禾县","value":"431024","parent":"431000"},{"name":"临武县","value":"431025","parent":"431000"},{"name":"汝城县","value":"431026","parent":"431000"},{"name":"桂东县","value":"431027","parent":"431000"},{"name":"安仁县","value":"431028","parent":"431000"},{"name":"资兴市","value":"431081","parent":"431000"},{"name":"零陵区","value":"431102","parent":"431100"},{"name":"冷水滩区","value":"431103","parent":"431100"},{"name":"祁阳县","value":"431121","parent":"431100"},{"name":"东安县","value":"431122","parent":"431100"},{"name":"双牌县","value":"431123","parent":"431100"},{"name":"道县","value":"431124","parent":"431100"},{"name":"江永县","value":"431125","parent":"431100"},{"name":"宁远县","value":"431126","parent":"431100"},{"name":"蓝山县","value":"431127","parent":"431100"},{"name":"新田县","value":"431128","parent":"431100"},{"name":"江华瑶族自治县","value":"431129","parent":"431100"},{"name":"鹤城区","value":"431202","parent":"431200"},{"name":"中方县","value":"431221","parent":"431200"},{"name":"沅陵县","value":"431222","parent":"431200"},{"name":"辰溪县","value":"431223","parent":"431200"},{"name":"溆浦县","value":"431224","parent":"431200"},{"name":"会同县","value":"431225","parent":"431200"},{"name":"麻阳苗族自治县","value":"431226","parent":"431200"},{"name":"新晃侗族自治县","value":"431227","parent":"431200"},{"name":"芷江侗族自治县","value":"431228","parent":"431200"},{"name":"靖州苗族侗族自治县","value":"431229","parent":"431200"},{"name":"通道侗族自治县","value":"431230","parent":"431200"},{"name":"洪江市","value":"431281","parent":"431200"},{"name":"娄星区","value":"431302","parent":"431300"},{"name":"双峰县","value":"431321","parent":"431300"},{"name":"新化县","value":"431322","parent":"431300"},{"name":"冷水江市","value":"431381","parent":"431300"},{"name":"涟源市","value":"431382","parent":"431300"},{"name":"吉首市","value":"433101","parent":"433100"},{"name":"泸溪县","value":"433122","parent":"433100"},{"name":"凤凰县","value":"433123","parent":"433100"},{"name":"花垣县","value":"433124","parent":"433100"},{"name":"保靖县","value":"433125","parent":"433100"},{"name":"古丈县","value":"433126","parent":"433100"},{"name":"永顺县","value":"433127","parent":"433100"},{"name":"龙山县","value":"433130","parent":"433100"},{"name":"广州市","value":"440100","parent":"440000"},{"name":"韶关市","value":"440200","parent":"440000"},{"name":"深圳市","value":"440300","parent":"440000"},{"name":"珠海市","value":"440400","parent":"440000"},{"name":"汕头市","value":"440500","parent":"440000"},{"name":"佛山市","value":"440600","parent":"440000"},{"name":"江门市","value":"440700","parent":"440000"},{"name":"湛江市","value":"440800","parent":"440000"},{"name":"茂名市","value":"440900","parent":"440000"},{"name":"肇庆市","value":"441200","parent":"440000"},{"name":"惠州市","value":"441300","parent":"440000"},{"name":"梅州市","value":"441400","parent":"440000"},{"name":"汕尾市","value":"441500","parent":"440000"},{"name":"河源市","value":"441600","parent":"440000"},{"name":"阳江市","value":"441700","parent":"440000"},{"name":"清远市","value":"441800","parent":"440000"},{"name":"东莞市","value":"441900","parent":"440000"},{"name":"中山市","value":"442000","parent":"440000"},{"name":"潮州市","value":"445100","parent":"440000"},{"name":"揭阳市","value":"445200","parent":"440000"},{"name":"云浮市","value":"445300","parent":"440000"},{"name":"荔湾区","value":"440103","parent":"440100"},{"name":"越秀区","value":"440104","parent":"440100"},{"name":"海珠区","value":"440105","parent":"440100"},{"name":"天河区","value":"440106","parent":"440100"},{"name":"白云区","value":"440111","parent":"440100"},{"name":"黄埔区","value":"440112","parent":"440100"},{"name":"番禺区","value":"440113","parent":"440100"},{"name":"花都区","value":"440114","parent":"440100"},{"name":"南沙区","value":"440115","parent":"440100"},{"name":"从化区","value":"440117","parent":"440100"},{"name":"增城区","value":"440118","parent":"440100"},{"name":"武江区","value":"440203","parent":"440200"},{"name":"浈江区","value":"440204","parent":"440200"},{"name":"曲江区","value":"440205","parent":"440200"},{"name":"始兴县","value":"440222","parent":"440200"},{"name":"仁化县","value":"440224","parent":"440200"},{"name":"翁源县","value":"440229","parent":"440200"},{"name":"乳源瑶族自治县","value":"440232","parent":"440200"},{"name":"新丰县","value":"440233","parent":"440200"},{"name":"乐昌市","value":"440281","parent":"440200"},{"name":"南雄市","value":"440282","parent":"440200"},{"name":"罗湖区","value":"440303","parent":"440300"},{"name":"福田区","value":"440304","parent":"440300"},{"name":"南山区","value":"440305","parent":"440300"},{"name":"宝安区","value":"440306","parent":"440300"},{"name":"龙岗区","value":"440307","parent":"440300"},{"name":"盐田区","value":"440308","parent":"440300"},{"name":"香洲区","value":"440402","parent":"440400"},{"name":"斗门区","value":"440403","parent":"440400"},{"name":"金湾区","value":"440404","parent":"440400"},{"name":"龙湖区","value":"440507","parent":"440500"},{"name":"金平区","value":"440511","parent":"440500"},{"name":"濠江区","value":"440512","parent":"440500"},{"name":"潮阳区","value":"440513","parent":"440500"},{"name":"潮南区","value":"440514","parent":"440500"},{"name":"澄海区","value":"440515","parent":"440500"},{"name":"南澳县","value":"440523","parent":"440500"},{"name":"禅城区","value":"440604","parent":"440600"},{"name":"南海区","value":"440605","parent":"440600"},{"name":"顺德区","value":"440606","parent":"440600"},{"name":"三水区","value":"440607","parent":"440600"},{"name":"高明区","value":"440608","parent":"440600"},{"name":"蓬江区","value":"440703","parent":"440700"},{"name":"江海区","value":"440704","parent":"440700"},{"name":"新会区","value":"440705","parent":"440700"},{"name":"台山市","value":"440781","parent":"440700"},{"name":"开平市","value":"440783","parent":"440700"},{"name":"鹤山市","value":"440784","parent":"440700"},{"name":"恩平市","value":"440785","parent":"440700"},{"name":"赤坎区","value":"440802","parent":"440800"},{"name":"霞山区","value":"440803","parent":"440800"},{"name":"坡头区","value":"440804","parent":"440800"},{"name":"麻章区","value":"440811","parent":"440800"},{"name":"遂溪县","value":"440823","parent":"440800"},{"name":"徐闻县","value":"440825","parent":"440800"},{"name":"廉江市","value":"440881","parent":"440800"},{"name":"雷州市","value":"440882","parent":"440800"},{"name":"吴川市","value":"440883","parent":"440800"},{"name":"茂南区","value":"440902","parent":"440900"},{"name":"电白区","value":"440904","parent":"440900"},{"name":"高州市","value":"440981","parent":"440900"},{"name":"化州市","value":"440982","parent":"440900"},{"name":"信宜市","value":"440983","parent":"440900"},{"name":"端州区","value":"441202","parent":"441200"},{"name":"鼎湖区","value":"441203","parent":"441200"},{"name":"高要区","value":"441204","parent":"441200"},{"name":"广宁县","value":"441223","parent":"441200"},{"name":"怀集县","value":"441224","parent":"441200"},{"name":"封开县","value":"441225","parent":"441200"},{"name":"德庆县","value":"441226","parent":"441200"},{"name":"四会市","value":"441284","parent":"441200"},{"name":"惠城区","value":"441302","parent":"441300"},{"name":"惠阳区","value":"441303","parent":"441300"},{"name":"博罗县","value":"441322","parent":"441300"},{"name":"惠东县","value":"441323","parent":"441300"},{"name":"龙门县","value":"441324","parent":"441300"},{"name":"梅江区","value":"441402","parent":"441400"},{"name":"梅县区","value":"441403","parent":"441400"},{"name":"大埔县","value":"441422","parent":"441400"},{"name":"丰顺县","value":"441423","parent":"441400"},{"name":"五华县","value":"441424","parent":"441400"},{"name":"平远县","value":"441426","parent":"441400"},{"name":"蕉岭县","value":"441427","parent":"441400"},{"name":"兴宁市","value":"441481","parent":"441400"},{"name":"城区","value":"441502","parent":"441500"},{"name":"海丰县","value":"441521","parent":"441500"},{"name":"陆河县","value":"441523","parent":"441500"},{"name":"陆丰市","value":"441581","parent":"441500"},{"name":"源城区","value":"441602","parent":"441600"},{"name":"紫金县","value":"441621","parent":"441600"},{"name":"龙川县","value":"441622","parent":"441600"},{"name":"连平县","value":"441623","parent":"441600"},{"name":"和平县","value":"441624","parent":"441600"},{"name":"东源县","value":"441625","parent":"441600"},{"name":"江城区","value":"441702","parent":"441700"},{"name":"阳东区","value":"441704","parent":"441700"},{"name":"阳西县","value":"441721","parent":"441700"},{"name":"阳春市","value":"441781","parent":"441700"},{"name":"清城区","value":"441802","parent":"441800"},{"name":"清新区","value":"441803","parent":"441800"},{"name":"佛冈县","value":"441821","parent":"441800"},{"name":"阳山县","value":"441823","parent":"441800"},{"name":"连山壮族瑶族自治县","value":"441825","parent":"441800"},{"name":"连南瑶族自治县","value":"441826","parent":"441800"},{"name":"英德市","value":"441881","parent":"441800"},{"name":"连州市","value":"441882","parent":"441800"},{"name":"湘桥区","value":"445102","parent":"445100"},{"name":"潮安区","value":"445103","parent":"445100"},{"name":"饶平县","value":"445122","parent":"445100"},{"name":"榕城区","value":"445202","parent":"445200"},{"name":"揭东区","value":"445203","parent":"445200"},{"name":"揭西县","value":"445222","parent":"445200"},{"name":"惠来县","value":"445224","parent":"445200"},{"name":"普宁市","value":"445281","parent":"445200"},{"name":"云城区","value":"445302","parent":"445300"},{"name":"云安区","value":"445303","parent":"445300"},{"name":"新兴县","value":"445321","parent":"445300"},{"name":"郁南县","value":"445322","parent":"445300"},{"name":"罗定市","value":"445381","parent":"445300"},{"name":"南宁市","value":"450100","parent":"450000"},{"name":"柳州市","value":"450200","parent":"450000"},{"name":"桂林市","value":"450300","parent":"450000"},{"name":"梧州市","value":"450400","parent":"450000"},{"name":"北海市","value":"450500","parent":"450000"},{"name":"防城港市","value":"450600","parent":"450000"},{"name":"钦州市","value":"450700","parent":"450000"},{"name":"贵港市","value":"450800","parent":"450000"},{"name":"玉林市","value":"450900","parent":"450000"},{"name":"百色市","value":"451000","parent":"450000"},{"name":"贺州市","value":"451100","parent":"450000"},{"name":"河池市","value":"451200","parent":"450000"},{"name":"来宾市","value":"451300","parent":"450000"},{"name":"崇左市","value":"451400","parent":"450000"},{"name":"兴宁区","value":"450102","parent":"450100"},{"name":"青秀区","value":"450103","parent":"450100"},{"name":"江南区","value":"450105","parent":"450100"},{"name":"西乡塘区","value":"450107","parent":"450100"},{"name":"良庆区","value":"450108","parent":"450100"},{"name":"邕宁区","value":"450109","parent":"450100"},{"name":"武鸣区","value":"450110","parent":"450100"},{"name":"隆安县","value":"450123","parent":"450100"},{"name":"马山县","value":"450124","parent":"450100"},{"name":"上林县","value":"450125","parent":"450100"},{"name":"宾阳县","value":"450126","parent":"450100"},{"name":"横县","value":"450127","parent":"450100"},{"name":"城中区","value":"450202","parent":"450200"},{"name":"鱼峰区","value":"450203","parent":"450200"},{"name":"柳南区","value":"450204","parent":"450200"},{"name":"柳北区","value":"450205","parent":"450200"},{"name":"柳江区","value":"450206","parent":"450200"},{"name":"柳城县","value":"450222","parent":"450200"},{"name":"鹿寨县","value":"450223","parent":"450200"},{"name":"融安县","value":"450224","parent":"450200"},{"name":"融水苗族自治县","value":"450225","parent":"450200"},{"name":"三江侗族自治县","value":"450226","parent":"450200"},{"name":"秀峰区","value":"450302","parent":"450300"},{"name":"叠彩区","value":"450303","parent":"450300"},{"name":"象山区","value":"450304","parent":"450300"},{"name":"七星区","value":"450305","parent":"450300"},{"name":"雁山区","value":"450311","parent":"450300"},{"name":"临桂区","value":"450312","parent":"450300"},{"name":"阳朔县","value":"450321","parent":"450300"},{"name":"灵川县","value":"450323","parent":"450300"},{"name":"全州县","value":"450324","parent":"450300"},{"name":"兴安县","value":"450325","parent":"450300"},{"name":"永福县","value":"450326","parent":"450300"},{"name":"灌阳县","value":"450327","parent":"450300"},{"name":"龙胜各族自治县","value":"450328","parent":"450300"},{"name":"资源县","value":"450329","parent":"450300"},{"name":"平乐县","value":"450330","parent":"450300"},{"name":"荔浦县","value":"450331","parent":"450300"},{"name":"恭城瑶族自治县","value":"450332","parent":"450300"},{"name":"万秀区","value":"450403","parent":"450400"},{"name":"长洲区","value":"450405","parent":"450400"},{"name":"龙圩区","value":"450406","parent":"450400"},{"name":"苍梧县","value":"450421","parent":"450400"},{"name":"藤县","value":"450422","parent":"450400"},{"name":"蒙山县","value":"450423","parent":"450400"},{"name":"岑溪市","value":"450481","parent":"450400"},{"name":"海城区","value":"450502","parent":"450500"},{"name":"银海区","value":"450503","parent":"450500"},{"name":"铁山港区","value":"450512","parent":"450500"},{"name":"合浦县","value":"450521","parent":"450500"},{"name":"港口区","value":"450602","parent":"450600"},{"name":"防城区","value":"450603","parent":"450600"},{"name":"上思县","value":"450621","parent":"450600"},{"name":"东兴市","value":"450681","parent":"450600"},{"name":"钦南区","value":"450702","parent":"450700"},{"name":"钦北区","value":"450703","parent":"450700"},{"name":"灵山县","value":"450721","parent":"450700"},{"name":"浦北县","value":"450722","parent":"450700"},{"name":"港北区","value":"450802","parent":"450800"},{"name":"港南区","value":"450803","parent":"450800"},{"name":"覃塘区","value":"450804","parent":"450800"},{"name":"平南县","value":"450821","parent":"450800"},{"name":"桂平市","value":"450881","parent":"450800"},{"name":"玉州区","value":"450902","parent":"450900"},{"name":"福绵区","value":"450903","parent":"450900"},{"name":"容县","value":"450921","parent":"450900"},{"name":"陆川县","value":"450922","parent":"450900"},{"name":"博白县","value":"450923","parent":"450900"},{"name":"兴业县","value":"450924","parent":"450900"},{"name":"北流市","value":"450981","parent":"450900"},{"name":"右江区","value":"451002","parent":"451000"},{"name":"田阳县","value":"451021","parent":"451000"},{"name":"田东县","value":"451022","parent":"451000"},{"name":"平果县","value":"451023","parent":"451000"},{"name":"德保县","value":"451024","parent":"451000"},{"name":"那坡县","value":"451026","parent":"451000"},{"name":"凌云县","value":"451027","parent":"451000"},{"name":"乐业县","value":"451028","parent":"451000"},{"name":"田林县","value":"451029","parent":"451000"},{"name":"西林县","value":"451030","parent":"451000"},{"name":"隆林各族自治县","value":"451031","parent":"451000"},{"name":"靖西市","value":"451081","parent":"451000"},{"name":"八步区","value":"451102","parent":"451100"},{"name":"平桂区","value":"451103","parent":"451100"},{"name":"昭平县","value":"451121","parent":"451100"},{"name":"钟山县","value":"451122","parent":"451100"},{"name":"富川瑶族自治县","value":"451123","parent":"451100"},{"name":"金城江区","value":"451202","parent":"451200"},{"name":"南丹县","value":"451221","parent":"451200"},{"name":"天峨县","value":"451222","parent":"451200"},{"name":"凤山县","value":"451223","parent":"451200"},{"name":"东兰县","value":"451224","parent":"451200"},{"name":"罗城仫佬族自治县","value":"451225","parent":"451200"},{"name":"环江毛南族自治县","value":"451226","parent":"451200"},{"name":"巴马瑶族自治县","value":"451227","parent":"451200"},{"name":"都安瑶族自治县","value":"451228","parent":"451200"},{"name":"大化瑶族自治县","value":"451229","parent":"451200"},{"name":"宜州市","value":"451281","parent":"451200"},{"name":"兴宾区","value":"451302","parent":"451300"},{"name":"忻城县","value":"451321","parent":"451300"},{"name":"象州县","value":"451322","parent":"451300"},{"name":"武宣县","value":"451323","parent":"451300"},{"name":"金秀瑶族自治县","value":"451324","parent":"451300"},{"name":"合山市","value":"451381","parent":"451300"},{"name":"江州区","value":"451402","parent":"451400"},{"name":"扶绥县","value":"451421","parent":"451400"},{"name":"宁明县","value":"451422","parent":"451400"},{"name":"龙州县","value":"451423","parent":"451400"},{"name":"大新县","value":"451424","parent":"451400"},{"name":"天等县","value":"451425","parent":"451400"},{"name":"凭祥市","value":"451481","parent":"451400"},{"name":"海口市","value":"460100","parent":"460000"},{"name":"三亚市","value":"460200","parent":"460000"},{"name":"三沙市","value":"460300","parent":"460000"},{"name":"儋州市","value":"460400","parent":"460000"},{"name":"五指山市","value":"469001","parent":"460000"},{"name":"琼海市","value":"469002","parent":"460000"},{"name":"文昌市","value":"469005","parent":"460000"},{"name":"万宁市","value":"469006","parent":"460000"},{"name":"东方市","value":"469007","parent":"460000"},{"name":"定安县","value":"469021","parent":"460000"},{"name":"屯昌县","value":"469022","parent":"460000"},{"name":"澄迈县","value":"469023","parent":"460000"},{"name":"临高县","value":"469024","parent":"460000"},{"name":"白沙黎族自治县","value":"469025","parent":"460000"},{"name":"昌江黎族自治县","value":"469026","parent":"460000"},{"name":"乐东黎族自治县","value":"469027","parent":"460000"},{"name":"陵水黎族自治县","value":"469028","parent":"460000"},{"name":"保亭黎族苗族自治县","value":"469029","parent":"460000"},{"name":"琼中黎族苗族自治县","value":"469030","parent":"460000"},{"name":"秀英区","value":"460105","parent":"460100"},{"name":"龙华区","value":"460106","parent":"460100"},{"name":"琼山区","value":"460107","parent":"460100"},{"name":"美兰区","value":"460108","parent":"460100"},{"name":"海棠区","value":"460202","parent":"460200"},{"name":"吉阳区","value":"460203","parent":"460200"},{"name":"天涯区","value":"460204","parent":"460200"},{"name":"崖州区","value":"460205","parent":"460200"},{"name":"市辖区","value":"500100","parent":"500000"},{"name":"县","value":"500200","parent":"500000"},{"name":"万州区","value":"500101","parent":"500100"},{"name":"涪陵区","value":"500102","parent":"500100"},{"name":"渝中区","value":"500103","parent":"500100"},{"name":"大渡口区","value":"500104","parent":"500100"},{"name":"江北区","value":"500105","parent":"500100"},{"name":"沙坪坝区","value":"500106","parent":"500100"},{"name":"九龙坡区","value":"500107","parent":"500100"},{"name":"南岸区","value":"500108","parent":"500100"},{"name":"北碚区","value":"500109","parent":"500100"},{"name":"綦江区","value":"500110","parent":"500100"},{"name":"大足区","value":"500111","parent":"500100"},{"name":"渝北区","value":"500112","parent":"500100"},{"name":"巴南区","value":"500113","parent":"500100"},{"name":"黔江区","value":"500114","parent":"500100"},{"name":"长寿区","value":"500115","parent":"500100"},{"name":"江津区","value":"500116","parent":"500100"},{"name":"合川区","value":"500117","parent":"500100"},{"name":"永川区","value":"500118","parent":"500100"},{"name":"南川区","value":"500119","parent":"500100"},{"name":"璧山区","value":"500120","parent":"500100"},{"name":"铜梁区","value":"500151","parent":"500100"},{"name":"潼南区","value":"500152","parent":"500100"},{"name":"荣昌区","value":"500153","parent":"500100"},{"name":"开州区","value":"500154","parent":"500100"},{"name":"梁平县","value":"500228","parent":"500200"},{"name":"城口县","value":"500229","parent":"500200"},{"name":"丰都县","value":"500230","parent":"500200"},{"name":"垫江县","value":"500231","parent":"500200"},{"name":"武隆县","value":"500232","parent":"500200"},{"name":"忠县","value":"500233","parent":"500200"},{"name":"云阳县","value":"500235","parent":"500200"},{"name":"奉节县","value":"500236","parent":"500200"},{"name":"巫山县","value":"500237","parent":"500200"},{"name":"巫溪县","value":"500238","parent":"500200"},{"name":"石柱土家族自治县","value":"500240","parent":"500200"},{"name":"秀山土家族苗族自治县","value":"500241","parent":"500200"},{"name":"酉阳土家族苗族自治县","value":"500242","parent":"500200"},{"name":"彭水苗族土家族自治县","value":"500243","parent":"500200"},{"name":"成都市","value":"510100","parent":"510000"},{"name":"自贡市","value":"510300","parent":"510000"},{"name":"攀枝花市","value":"510400","parent":"510000"},{"name":"泸州市","value":"510500","parent":"510000"},{"name":"德阳市","value":"510600","parent":"510000"},{"name":"绵阳市","value":"510700","parent":"510000"},{"name":"广元市","value":"510800","parent":"510000"},{"name":"遂宁市","value":"510900","parent":"510000"},{"name":"内江市","value":"511000","parent":"510000"},{"name":"乐山市","value":"511100","parent":"510000"},{"name":"南充市","value":"511300","parent":"510000"},{"name":"眉山市","value":"511400","parent":"510000"},{"name":"宜宾市","value":"511500","parent":"510000"},{"name":"广安市","value":"511600","parent":"510000"},{"name":"达州市","value":"511700","parent":"510000"},{"name":"雅安市","value":"511800","parent":"510000"},{"name":"巴中市","value":"511900","parent":"510000"},{"name":"资阳市","value":"512000","parent":"510000"},{"name":"阿坝藏族羌族自治州","value":"513200","parent":"510000"},{"name":"甘孜藏族自治州","value":"513300","parent":"510000"},{"name":"凉山彝族自治州","value":"513400","parent":"510000"},{"name":"锦江区","value":"510104","parent":"510100"},{"name":"青羊区","value":"510105","parent":"510100"},{"name":"金牛区","value":"510106","parent":"510100"},{"name":"武侯区","value":"510107","parent":"510100"},{"name":"成华区","value":"510108","parent":"510100"},{"name":"龙泉驿区","value":"510112","parent":"510100"},{"name":"青白江区","value":"510113","parent":"510100"},{"name":"新都区","value":"510114","parent":"510100"},{"name":"温江区","value":"510115","parent":"510100"},{"name":"双流区","value":"510116","parent":"510100"},{"name":"金堂县","value":"510121","parent":"510100"},{"name":"郫县","value":"510124","parent":"510100"},{"name":"大邑县","value":"510129","parent":"510100"},{"name":"蒲江县","value":"510131","parent":"510100"},{"name":"新津县","value":"510132","parent":"510100"},{"name":"都江堰市","value":"510181","parent":"510100"},{"name":"彭州市","value":"510182","parent":"510100"},{"name":"邛崃市","value":"510183","parent":"510100"},{"name":"崇州市","value":"510184","parent":"510100"},{"name":"简阳市","value":"510185","parent":"510100"},{"name":"自流井区","value":"510302","parent":"510300"},{"name":"贡井区","value":"510303","parent":"510300"},{"name":"大安区","value":"510304","parent":"510300"},{"name":"沿滩区","value":"510311","parent":"510300"},{"name":"荣县","value":"510321","parent":"510300"},{"name":"富顺县","value":"510322","parent":"510300"},{"name":"东区","value":"510402","parent":"510400"},{"name":"西区","value":"510403","parent":"510400"},{"name":"仁和区","value":"510411","parent":"510400"},{"name":"米易县","value":"510421","parent":"510400"},{"name":"盐边县","value":"510422","parent":"510400"},{"name":"江阳区","value":"510502","parent":"510500"},{"name":"纳溪区","value":"510503","parent":"510500"},{"name":"龙马潭区","value":"510504","parent":"510500"},{"name":"泸县","value":"510521","parent":"510500"},{"name":"合江县","value":"510522","parent":"510500"},{"name":"叙永县","value":"510524","parent":"510500"},{"name":"古蔺县","value":"510525","parent":"510500"},{"name":"旌阳区","value":"510603","parent":"510600"},{"name":"中江县","value":"510623","parent":"510600"},{"name":"罗江县","value":"510626","parent":"510600"},{"name":"广汉市","value":"510681","parent":"510600"},{"name":"什邡市","value":"510682","parent":"510600"},{"name":"绵竹市","value":"510683","parent":"510600"},{"name":"涪城区","value":"510703","parent":"510700"},{"name":"游仙区","value":"510704","parent":"510700"},{"name":"安州区","value":"510705","parent":"510700"},{"name":"三台县","value":"510722","parent":"510700"},{"name":"盐亭县","value":"510723","parent":"510700"},{"name":"梓潼县","value":"510725","parent":"510700"},{"name":"北川羌族自治县","value":"510726","parent":"510700"},{"name":"平武县","value":"510727","parent":"510700"},{"name":"江油市","value":"510781","parent":"510700"},{"name":"利州区","value":"510802","parent":"510800"},{"name":"昭化区","value":"510811","parent":"510800"},{"name":"朝天区","value":"510812","parent":"510800"},{"name":"旺苍县","value":"510821","parent":"510800"},{"name":"青川县","value":"510822","parent":"510800"},{"name":"剑阁县","value":"510823","parent":"510800"},{"name":"苍溪县","value":"510824","parent":"510800"},{"name":"船山区","value":"510903","parent":"510900"},{"name":"安居区","value":"510904","parent":"510900"},{"name":"蓬溪县","value":"510921","parent":"510900"},{"name":"射洪县","value":"510922","parent":"510900"},{"name":"大英县","value":"510923","parent":"510900"},{"name":"市中区","value":"511002","parent":"511000"},{"name":"东兴区","value":"511011","parent":"511000"},{"name":"威远县","value":"511024","parent":"511000"},{"name":"资中县","value":"511025","parent":"511000"},{"name":"隆昌县","value":"511028","parent":"511000"},{"name":"市中区","value":"511102","parent":"511100"},{"name":"沙湾区","value":"511111","parent":"511100"},{"name":"五通桥区","value":"511112","parent":"511100"},{"name":"金口河区","value":"511113","parent":"511100"},{"name":"犍为县","value":"511123","parent":"511100"},{"name":"井研县","value":"511124","parent":"511100"},{"name":"夹江县","value":"511126","parent":"511100"},{"name":"沐川县","value":"511129","parent":"511100"},{"name":"峨边彝族自治县","value":"511132","parent":"511100"},{"name":"马边彝族自治县","value":"511133","parent":"511100"},{"name":"峨眉山市","value":"511181","parent":"511100"},{"name":"顺庆区","value":"511302","parent":"511300"},{"name":"高坪区","value":"511303","parent":"511300"},{"name":"嘉陵区","value":"511304","parent":"511300"},{"name":"南部县","value":"511321","parent":"511300"},{"name":"营山县","value":"511322","parent":"511300"},{"name":"蓬安县","value":"511323","parent":"511300"},{"name":"仪陇县","value":"511324","parent":"511300"},{"name":"西充县","value":"511325","parent":"511300"},{"name":"阆中市","value":"511381","parent":"511300"},{"name":"东坡区","value":"511402","parent":"511400"},{"name":"彭山区","value":"511403","parent":"511400"},{"name":"仁寿县","value":"511421","parent":"511400"},{"name":"洪雅县","value":"511423","parent":"511400"},{"name":"丹棱县","value":"511424","parent":"511400"},{"name":"青神县","value":"511425","parent":"511400"},{"name":"翠屏区","value":"511502","parent":"511500"},{"name":"南溪区","value":"511503","parent":"511500"},{"name":"宜宾县","value":"511521","parent":"511500"},{"name":"江安县","value":"511523","parent":"511500"},{"name":"长宁县","value":"511524","parent":"511500"},{"name":"高县","value":"511525","parent":"511500"},{"name":"珙县","value":"511526","parent":"511500"},{"name":"筠连县","value":"511527","parent":"511500"},{"name":"兴文县","value":"511528","parent":"511500"},{"name":"屏山县","value":"511529","parent":"511500"},{"name":"广安区","value":"511602","parent":"511600"},{"name":"前锋区","value":"511603","parent":"511600"},{"name":"岳池县","value":"511621","parent":"511600"},{"name":"武胜县","value":"511622","parent":"511600"},{"name":"邻水县","value":"511623","parent":"511600"},{"name":"华蓥市","value":"511681","parent":"511600"},{"name":"通川区","value":"511702","parent":"511700"},{"name":"达川区","value":"511703","parent":"511700"},{"name":"宣汉县","value":"511722","parent":"511700"},{"name":"开江县","value":"511723","parent":"511700"},{"name":"大竹县","value":"511724","parent":"511700"},{"name":"渠县","value":"511725","parent":"511700"},{"name":"万源市","value":"511781","parent":"511700"},{"name":"雨城区","value":"511802","parent":"511800"},{"name":"名山区","value":"511803","parent":"511800"},{"name":"荥经县","value":"511822","parent":"511800"},{"name":"汉源县","value":"511823","parent":"511800"},{"name":"石棉县","value":"511824","parent":"511800"},{"name":"天全县","value":"511825","parent":"511800"},{"name":"芦山县","value":"511826","parent":"511800"},{"name":"宝兴县","value":"511827","parent":"511800"},{"name":"巴州区","value":"511902","parent":"511900"},{"name":"恩阳区","value":"511903","parent":"511900"},{"name":"通江县","value":"511921","parent":"511900"},{"name":"南江县","value":"511922","parent":"511900"},{"name":"平昌县","value":"511923","parent":"511900"},{"name":"雁江区","value":"512002","parent":"512000"},{"name":"安岳县","value":"512021","parent":"512000"},{"name":"乐至县","value":"512022","parent":"512000"},{"name":"马尔康市","value":"513201","parent":"513200"},{"name":"汶川县","value":"513221","parent":"513200"},{"name":"理县","value":"513222","parent":"513200"},{"name":"茂县","value":"513223","parent":"513200"},{"name":"松潘县","value":"513224","parent":"513200"},{"name":"九寨沟县","value":"513225","parent":"513200"},{"name":"金川县","value":"513226","parent":"513200"},{"name":"小金县","value":"513227","parent":"513200"},{"name":"黑水县","value":"513228","parent":"513200"},{"name":"壤塘县","value":"513230","parent":"513200"},{"name":"阿坝县","value":"513231","parent":"513200"},{"name":"若尔盖县","value":"513232","parent":"513200"},{"name":"红原县","value":"513233","parent":"513200"},{"name":"康定市","value":"513301","parent":"513300"},{"name":"泸定县","value":"513322","parent":"513300"},{"name":"丹巴县","value":"513323","parent":"513300"},{"name":"九龙县","value":"513324","parent":"513300"},{"name":"雅江县","value":"513325","parent":"513300"},{"name":"道孚县","value":"513326","parent":"513300"},{"name":"炉霍县","value":"513327","parent":"513300"},{"name":"甘孜县","value":"513328","parent":"513300"},{"name":"新龙县","value":"513329","parent":"513300"},{"name":"德格县","value":"513330","parent":"513300"},{"name":"白玉县","value":"513331","parent":"513300"},{"name":"石渠县","value":"513332","parent":"513300"},{"name":"色达县","value":"513333","parent":"513300"},{"name":"理塘县","value":"513334","parent":"513300"},{"name":"巴塘县","value":"513335","parent":"513300"},{"name":"乡城县","value":"513336","parent":"513300"},{"name":"稻城县","value":"513337","parent":"513300"},{"name":"得荣县","value":"513338","parent":"513300"},{"name":"西昌市","value":"513401","parent":"513400"},{"name":"木里藏族自治县","value":"513422","parent":"513400"},{"name":"盐源县","value":"513423","parent":"513400"},{"name":"德昌县","value":"513424","parent":"513400"},{"name":"会理县","value":"513425","parent":"513400"},{"name":"会东县","value":"513426","parent":"513400"},{"name":"宁南县","value":"513427","parent":"513400"},{"name":"普格县","value":"513428","parent":"513400"},{"name":"布拖县","value":"513429","parent":"513400"},{"name":"金阳县","value":"513430","parent":"513400"},{"name":"昭觉县","value":"513431","parent":"513400"},{"name":"喜德县","value":"513432","parent":"513400"},{"name":"冕宁县","value":"513433","parent":"513400"},{"name":"越西县","value":"513434","parent":"513400"},{"name":"甘洛县","value":"513435","parent":"513400"},{"name":"美姑县","value":"513436","parent":"513400"},{"name":"雷波县","value":"513437","parent":"513400"},{"name":"贵阳市","value":"520100","parent":"520000"},{"name":"六盘水市","value":"520200","parent":"520000"},{"name":"遵义市","value":"520300","parent":"520000"},{"name":"安顺市","value":"520400","parent":"520000"},{"name":"毕节市","value":"520500","parent":"520000"},{"name":"铜仁市","value":"520600","parent":"520000"},{"name":"黔西南布依族苗族自治州","value":"522300","parent":"520000"},{"name":"黔东南苗族侗族自治州","value":"522600","parent":"520000"},{"name":"黔南布依族苗族自治州","value":"522700","parent":"520000"},{"name":"南明区","value":"520102","parent":"520100"},{"name":"云岩区","value":"520103","parent":"520100"},{"name":"花溪区","value":"520111","parent":"520100"},{"name":"乌当区","value":"520112","parent":"520100"},{"name":"白云区","value":"520113","parent":"520100"},{"name":"观山湖区","value":"520115","parent":"520100"},{"name":"开阳县","value":"520121","parent":"520100"},{"name":"息烽县","value":"520122","parent":"520100"},{"name":"修文县","value":"520123","parent":"520100"},{"name":"清镇市","value":"520181","parent":"520100"},{"name":"钟山区","value":"520201","parent":"520200"},{"name":"六枝特区","value":"520203","parent":"520200"},{"name":"水城县","value":"520221","parent":"520200"},{"name":"盘县","value":"520222","parent":"520200"},{"name":"红花岗区","value":"520302","parent":"520300"},{"name":"汇川区","value":"520303","parent":"520300"},{"name":"播州区","value":"520304","parent":"520300"},{"name":"桐梓县","value":"520322","parent":"520300"},{"name":"绥阳县","value":"520323","parent":"520300"},{"name":"正安县","value":"520324","parent":"520300"},{"name":"道真仡佬族苗族自治县","value":"520325","parent":"520300"},{"name":"务川仡佬族苗族自治县","value":"520326","parent":"520300"},{"name":"凤冈县","value":"520327","parent":"520300"},{"name":"湄潭县","value":"520328","parent":"520300"},{"name":"余庆县","value":"520329","parent":"520300"},{"name":"习水县","value":"520330","parent":"520300"},{"name":"赤水市","value":"520381","parent":"520300"},{"name":"仁怀市","value":"520382","parent":"520300"},{"name":"西秀区","value":"520402","parent":"520400"},{"name":"平坝区","value":"520403","parent":"520400"},{"name":"普定县","value":"520422","parent":"520400"},{"name":"镇宁布依族苗族自治县","value":"520423","parent":"520400"},{"name":"关岭布依族苗族自治县","value":"520424","parent":"520400"},{"name":"紫云苗族布依族自治县","value":"520425","parent":"520400"},{"name":"七星关区","value":"520502","parent":"520500"},{"name":"大方县","value":"520521","parent":"520500"},{"name":"黔西县","value":"520522","parent":"520500"},{"name":"金沙县","value":"520523","parent":"520500"},{"name":"织金县","value":"520524","parent":"520500"},{"name":"纳雍县","value":"520525","parent":"520500"},{"name":"威宁彝族回族苗族自治县","value":"520526","parent":"520500"},{"name":"赫章县","value":"520527","parent":"520500"},{"name":"碧江区","value":"520602","parent":"520600"},{"name":"万山区","value":"520603","parent":"520600"},{"name":"江口县","value":"520621","parent":"520600"},{"name":"玉屏侗族自治县","value":"520622","parent":"520600"},{"name":"石阡县","value":"520623","parent":"520600"},{"name":"思南县","value":"520624","parent":"520600"},{"name":"印江土家族苗族自治县","value":"520625","parent":"520600"},{"name":"德江县","value":"520626","parent":"520600"},{"name":"沿河土家族自治县","value":"520627","parent":"520600"},{"name":"松桃苗族自治县","value":"520628","parent":"520600"},{"name":"兴义市","value":"522301","parent":"522300"},{"name":"兴仁县","value":"522322","parent":"522300"},{"name":"普安县","value":"522323","parent":"522300"},{"name":"晴隆县","value":"522324","parent":"522300"},{"name":"贞丰县","value":"522325","parent":"522300"},{"name":"望谟县","value":"522326","parent":"522300"},{"name":"册亨县","value":"522327","parent":"522300"},{"name":"安龙县","value":"522328","parent":"522300"},{"name":"凯里市","value":"522601","parent":"522600"},{"name":"黄平县","value":"522622","parent":"522600"},{"name":"施秉县","value":"522623","parent":"522600"},{"name":"三穗县","value":"522624","parent":"522600"},{"name":"镇远县","value":"522625","parent":"522600"},{"name":"岑巩县","value":"522626","parent":"522600"},{"name":"天柱县","value":"522627","parent":"522600"},{"name":"锦屏县","value":"522628","parent":"522600"},{"name":"剑河县","value":"522629","parent":"522600"},{"name":"台江县","value":"522630","parent":"522600"},{"name":"黎平县","value":"522631","parent":"522600"},{"name":"榕江县","value":"522632","parent":"522600"},{"name":"从江县","value":"522633","parent":"522600"},{"name":"雷山县","value":"522634","parent":"522600"},{"name":"麻江县","value":"522635","parent":"522600"},{"name":"丹寨县","value":"522636","parent":"522600"},{"name":"都匀市","value":"522701","parent":"522700"},{"name":"福泉市","value":"522702","parent":"522700"},{"name":"荔波县","value":"522722","parent":"522700"},{"name":"贵定县","value":"522723","parent":"522700"},{"name":"瓮安县","value":"522725","parent":"522700"},{"name":"独山县","value":"522726","parent":"522700"},{"name":"平塘县","value":"522727","parent":"522700"},{"name":"罗甸县","value":"522728","parent":"522700"},{"name":"长顺县","value":"522729","parent":"522700"},{"name":"龙里县","value":"522730","parent":"522700"},{"name":"惠水县","value":"522731","parent":"522700"},{"name":"三都水族自治县","value":"522732","parent":"522700"},{"name":"昆明市","value":"530100","parent":"530000"},{"name":"曲靖市","value":"530300","parent":"530000"},{"name":"玉溪市","value":"530400","parent":"530000"},{"name":"保山市","value":"530500","parent":"530000"},{"name":"昭通市","value":"530600","parent":"530000"},{"name":"丽江市","value":"530700","parent":"530000"},{"name":"普洱市","value":"530800","parent":"530000"},{"name":"临沧市","value":"530900","parent":"530000"},{"name":"楚雄彝族自治州","value":"532300","parent":"530000"},{"name":"红河哈尼族彝族自治州","value":"532500","parent":"530000"},{"name":"文山壮族苗族自治州","value":"532600","parent":"530000"},{"name":"西双版纳傣族自治州","value":"532800","parent":"530000"},{"name":"大理白族自治州","value":"532900","parent":"530000"},{"name":"德宏傣族景颇族自治州","value":"533100","parent":"530000"},{"name":"怒江傈僳族自治州","value":"533300","parent":"530000"},{"name":"迪庆藏族自治州","value":"533400","parent":"530000"},{"name":"五华区","value":"530102","parent":"530100"},{"name":"盘龙区","value":"530103","parent":"530100"},{"name":"官渡区","value":"530111","parent":"530100"},{"name":"西山区","value":"530112","parent":"530100"},{"name":"东川区","value":"530113","parent":"530100"},{"name":"呈贡区","value":"530114","parent":"530100"},{"name":"晋宁县","value":"530122","parent":"530100"},{"name":"富民县","value":"530124","parent":"530100"},{"name":"宜良县","value":"530125","parent":"530100"},{"name":"石林彝族自治县","value":"530126","parent":"530100"},{"name":"嵩明县","value":"530127","parent":"530100"},{"name":"禄劝彝族苗族自治县","value":"530128","parent":"530100"},{"name":"寻甸回族彝族自治县","value":"530129","parent":"530100"},{"name":"安宁市","value":"530181","parent":"530100"},{"name":"麒麟区","value":"530302","parent":"530300"},{"name":"沾益区","value":"530303","parent":"530300"},{"name":"马龙县","value":"530321","parent":"530300"},{"name":"陆良县","value":"530322","parent":"530300"},{"name":"师宗县","value":"530323","parent":"530300"},{"name":"罗平县","value":"530324","parent":"530300"},{"name":"富源县","value":"530325","parent":"530300"},{"name":"会泽县","value":"530326","parent":"530300"},{"name":"宣威市","value":"530381","parent":"530300"},{"name":"红塔区","value":"530402","parent":"530400"},{"name":"江川区","value":"530403","parent":"530400"},{"name":"澄江县","value":"530422","parent":"530400"},{"name":"通海县","value":"530423","parent":"530400"},{"name":"华宁县","value":"530424","parent":"530400"},{"name":"易门县","value":"530425","parent":"530400"},{"name":"峨山彝族自治县","value":"530426","parent":"530400"},{"name":"新平彝族傣族自治县","value":"530427","parent":"530400"},{"name":"元江哈尼族彝族傣族自治县","value":"530428","parent":"530400"},{"name":"隆阳区","value":"530502","parent":"530500"},{"name":"施甸县","value":"530521","parent":"530500"},{"name":"龙陵县","value":"530523","parent":"530500"},{"name":"昌宁县","value":"530524","parent":"530500"},{"name":"腾冲市","value":"530581","parent":"530500"},{"name":"昭阳区","value":"530602","parent":"530600"},{"name":"鲁甸县","value":"530621","parent":"530600"},{"name":"巧家县","value":"530622","parent":"530600"},{"name":"盐津县","value":"530623","parent":"530600"},{"name":"大关县","value":"530624","parent":"530600"},{"name":"永善县","value":"530625","parent":"530600"},{"name":"绥江县","value":"530626","parent":"530600"},{"name":"镇雄县","value":"530627","parent":"530600"},{"name":"彝良县","value":"530628","parent":"530600"},{"name":"威信县","value":"530629","parent":"530600"},{"name":"水富县","value":"530630","parent":"530600"},{"name":"古城区","value":"530702","parent":"530700"},{"name":"玉龙纳西族自治县","value":"530721","parent":"530700"},{"name":"永胜县","value":"530722","parent":"530700"},{"name":"华坪县","value":"530723","parent":"530700"},{"name":"宁蒗彝族自治县","value":"530724","parent":"530700"},{"name":"思茅区","value":"530802","parent":"530800"},{"name":"宁洱哈尼族彝族自治县","value":"530821","parent":"530800"},{"name":"墨江哈尼族自治县","value":"530822","parent":"530800"},{"name":"景东彝族自治县","value":"530823","parent":"530800"},{"name":"景谷傣族彝族自治县","value":"530824","parent":"530800"},{"name":"镇沅彝族哈尼族拉祜族自治县","value":"530825","parent":"530800"},{"name":"江城哈尼族彝族自治县","value":"530826","parent":"530800"},{"name":"孟连傣族拉祜族佤族自治县","value":"530827","parent":"530800"},{"name":"澜沧拉祜族自治县","value":"530828","parent":"530800"},{"name":"西盟佤族自治县","value":"530829","parent":"530800"},{"name":"临翔区","value":"530902","parent":"530900"},{"name":"凤庆县","value":"530921","parent":"530900"},{"name":"云县","value":"530922","parent":"530900"},{"name":"永德县","value":"530923","parent":"530900"},{"name":"镇康县","value":"530924","parent":"530900"},{"name":"双江拉祜族佤族布朗族傣族自治县","value":"530925","parent":"530900"},{"name":"耿马傣族佤族自治县","value":"530926","parent":"530900"},{"name":"沧源佤族自治县","value":"530927","parent":"530900"},{"name":"楚雄市","value":"532301","parent":"532300"},{"name":"双柏县","value":"532322","parent":"532300"},{"name":"牟定县","value":"532323","parent":"532300"},{"name":"南华县","value":"532324","parent":"532300"},{"name":"姚安县","value":"532325","parent":"532300"},{"name":"大姚县","value":"532326","parent":"532300"},{"name":"永仁县","value":"532327","parent":"532300"},{"name":"元谋县","value":"532328","parent":"532300"},{"name":"武定县","value":"532329","parent":"532300"},{"name":"禄丰县","value":"532331","parent":"532300"},{"name":"个旧市","value":"532501","parent":"532500"},{"name":"开远市","value":"532502","parent":"532500"},{"name":"蒙自市","value":"532503","parent":"532500"},{"name":"弥勒市","value":"532504","parent":"532500"},{"name":"屏边苗族自治县","value":"532523","parent":"532500"},{"name":"建水县","value":"532524","parent":"532500"},{"name":"石屏县","value":"532525","parent":"532500"},{"name":"泸西县","value":"532527","parent":"532500"},{"name":"元阳县","value":"532528","parent":"532500"},{"name":"红河县","value":"532529","parent":"532500"},{"name":"金平苗族瑶族傣族自治县","value":"532530","parent":"532500"},{"name":"绿春县","value":"532531","parent":"532500"},{"name":"河口瑶族自治县","value":"532532","parent":"532500"},{"name":"文山市","value":"532601","parent":"532600"},{"name":"砚山县","value":"532622","parent":"532600"},{"name":"西畴县","value":"532623","parent":"532600"},{"name":"麻栗坡县","value":"532624","parent":"532600"},{"name":"马关县","value":"532625","parent":"532600"},{"name":"丘北县","value":"532626","parent":"532600"},{"name":"广南县","value":"532627","parent":"532600"},{"name":"富宁县","value":"532628","parent":"532600"},{"name":"景洪市","value":"532801","parent":"532800"},{"name":"勐海县","value":"532822","parent":"532800"},{"name":"勐腊县","value":"532823","parent":"532800"},{"name":"大理市","value":"532901","parent":"532900"},{"name":"漾濞彝族自治县","value":"532922","parent":"532900"},{"name":"祥云县","value":"532923","parent":"532900"},{"name":"宾川县","value":"532924","parent":"532900"},{"name":"弥渡县","value":"532925","parent":"532900"},{"name":"南涧彝族自治县","value":"532926","parent":"532900"},{"name":"巍山彝族回族自治县","value":"532927","parent":"532900"},{"name":"永平县","value":"532928","parent":"532900"},{"name":"云龙县","value":"532929","parent":"532900"},{"name":"洱源县","value":"532930","parent":"532900"},{"name":"剑川县","value":"532931","parent":"532900"},{"name":"鹤庆县","value":"532932","parent":"532900"},{"name":"瑞丽市","value":"533102","parent":"533100"},{"name":"芒市","value":"533103","parent":"533100"},{"name":"梁河县","value":"533122","parent":"533100"},{"name":"盈江县","value":"533123","parent":"533100"},{"name":"陇川县","value":"533124","parent":"533100"},{"name":"泸水市","value":"533301","parent":"533300"},{"name":"福贡县","value":"533323","parent":"533300"},{"name":"贡山独龙族怒族自治县","value":"533324","parent":"533300"},{"name":"兰坪白族普米族自治县","value":"533325","parent":"533300"},{"name":"香格里拉市","value":"533401","parent":"533400"},{"name":"德钦县","value":"533422","parent":"533400"},{"name":"维西傈僳族自治县","value":"533423","parent":"533400"},{"name":"拉萨市","value":"540100","parent":"540000"},{"name":"日喀则市","value":"540200","parent":"540000"},{"name":"昌都市","value":"540300","parent":"540000"},{"name":"林芝市","value":"540400","parent":"540000"},{"name":"山南市","value":"540500","parent":"540000"},{"name":"那曲地区","value":"542400","parent":"540000"},{"name":"阿里地区","value":"542500","parent":"540000"},{"name":"城关区","value":"540102","parent":"540100"},{"name":"堆龙德庆区","value":"540103","parent":"540100"},{"name":"林周县","value":"540121","parent":"540100"},{"name":"当雄县","value":"540122","parent":"540100"},{"name":"尼木县","value":"540123","parent":"540100"},{"name":"曲水县","value":"540124","parent":"540100"},{"name":"达孜县","value":"540126","parent":"540100"},{"name":"墨竹工卡县","value":"540127","parent":"540100"},{"name":"桑珠孜区","value":"540202","parent":"540200"},{"name":"南木林县","value":"540221","parent":"540200"},{"name":"江孜县","value":"540222","parent":"540200"},{"name":"定日县","value":"540223","parent":"540200"},{"name":"萨迦县","value":"540224","parent":"540200"},{"name":"拉孜县","value":"540225","parent":"540200"},{"name":"昂仁县","value":"540226","parent":"540200"},{"name":"谢通门县","value":"540227","parent":"540200"},{"name":"白朗县","value":"540228","parent":"540200"},{"name":"仁布县","value":"540229","parent":"540200"},{"name":"康马县","value":"540230","parent":"540200"},{"name":"定结县","value":"540231","parent":"540200"},{"name":"仲巴县","value":"540232","parent":"540200"},{"name":"亚东县","value":"540233","parent":"540200"},{"name":"吉隆县","value":"540234","parent":"540200"},{"name":"聂拉木县","value":"540235","parent":"540200"},{"name":"萨嘎县","value":"540236","parent":"540200"},{"name":"岗巴县","value":"540237","parent":"540200"},{"name":"卡若区","value":"540302","parent":"540300"},{"name":"江达县","value":"540321","parent":"540300"},{"name":"贡觉县","value":"540322","parent":"540300"},{"name":"类乌齐县","value":"540323","parent":"540300"},{"name":"丁青县","value":"540324","parent":"540300"},{"name":"察雅县","value":"540325","parent":"540300"},{"name":"八宿县","value":"540326","parent":"540300"},{"name":"左贡县","value":"540327","parent":"540300"},{"name":"芒康县","value":"540328","parent":"540300"},{"name":"洛隆县","value":"540329","parent":"540300"},{"name":"边坝县","value":"540330","parent":"540300"},{"name":"巴宜区","value":"540402","parent":"540400"},{"name":"工布江达县","value":"540421","parent":"540400"},{"name":"米林县","value":"540422","parent":"540400"},{"name":"墨脱县","value":"540423","parent":"540400"},{"name":"波密县","value":"540424","parent":"540400"},{"name":"察隅县","value":"540425","parent":"540400"},{"name":"朗县","value":"540426","parent":"540400"},{"name":"乃东区","value":"540502","parent":"540500"},{"name":"扎囊县","value":"540521","parent":"540500"},{"name":"贡嘎县","value":"540522","parent":"540500"},{"name":"桑日县","value":"540523","parent":"540500"},{"name":"琼结县","value":"540524","parent":"540500"},{"name":"曲松县","value":"540525","parent":"540500"},{"name":"措美县","value":"540526","parent":"540500"},{"name":"洛扎县","value":"540527","parent":"540500"},{"name":"加查县","value":"540528","parent":"540500"},{"name":"隆子县","value":"540529","parent":"540500"},{"name":"错那县","value":"540530","parent":"540500"},{"name":"浪卡子县","value":"540531","parent":"540500"},{"name":"那曲县","value":"542421","parent":"542400"},{"name":"嘉黎县","value":"542422","parent":"542400"},{"name":"比如县","value":"542423","parent":"542400"},{"name":"聂荣县","value":"542424","parent":"542400"},{"name":"安多县","value":"542425","parent":"542400"},{"name":"申扎县","value":"542426","parent":"542400"},{"name":"索县","value":"542427","parent":"542400"},{"name":"班戈县","value":"542428","parent":"542400"},{"name":"巴青县","value":"542429","parent":"542400"},{"name":"尼玛县","value":"542430","parent":"542400"},{"name":"双湖县","value":"542431","parent":"542400"},{"name":"普兰县","value":"542521","parent":"542500"},{"name":"札达县","value":"542522","parent":"542500"},{"name":"噶尔县","value":"542523","parent":"542500"},{"name":"日土县","value":"542524","parent":"542500"},{"name":"革吉县","value":"542525","parent":"542500"},{"name":"改则县","value":"542526","parent":"542500"},{"name":"措勤县","value":"542527","parent":"542500"},{"name":"西安市","value":"610100","parent":"610000"},{"name":"铜川市","value":"610200","parent":"610000"},{"name":"宝鸡市","value":"610300","parent":"610000"},{"name":"咸阳市","value":"610400","parent":"610000"},{"name":"渭南市","value":"610500","parent":"610000"},{"name":"延安市","value":"610600","parent":"610000"},{"name":"汉中市","value":"610700","parent":"610000"},{"name":"榆林市","value":"610800","parent":"610000"},{"name":"安康市","value":"610900","parent":"610000"},{"name":"商洛市","value":"611000","parent":"610000"},{"name":"新城区","value":"610102","parent":"610100"},{"name":"碑林区","value":"610103","parent":"610100"},{"name":"莲湖区","value":"610104","parent":"610100"},{"name":"灞桥区","value":"610111","parent":"610100"},{"name":"未央区","value":"610112","parent":"610100"},{"name":"雁塔区","value":"610113","parent":"610100"},{"name":"阎良区","value":"610114","parent":"610100"},{"name":"临潼区","value":"610115","parent":"610100"},{"name":"长安区","value":"610116","parent":"610100"},{"name":"高陵区","value":"610117","parent":"610100"},{"name":"蓝田县","value":"610122","parent":"610100"},{"name":"周至县","value":"610124","parent":"610100"},{"name":"户县","value":"610125","parent":"610100"},{"name":"王益区","value":"610202","parent":"610200"},{"name":"印台区","value":"610203","parent":"610200"},{"name":"耀州区","value":"610204","parent":"610200"},{"name":"宜君县","value":"610222","parent":"610200"},{"name":"渭滨区","value":"610302","parent":"610300"},{"name":"金台区","value":"610303","parent":"610300"},{"name":"陈仓区","value":"610304","parent":"610300"},{"name":"凤翔县","value":"610322","parent":"610300"},{"name":"岐山县","value":"610323","parent":"610300"},{"name":"扶风县","value":"610324","parent":"610300"},{"name":"眉县","value":"610326","parent":"610300"},{"name":"陇县","value":"610327","parent":"610300"},{"name":"千阳县","value":"610328","parent":"610300"},{"name":"麟游县","value":"610329","parent":"610300"},{"name":"凤县","value":"610330","parent":"610300"},{"name":"太白县","value":"610331","parent":"610300"},{"name":"秦都区","value":"610402","parent":"610400"},{"name":"杨陵区","value":"610403","parent":"610400"},{"name":"渭城区","value":"610404","parent":"610400"},{"name":"三原县","value":"610422","parent":"610400"},{"name":"泾阳县","value":"610423","parent":"610400"},{"name":"乾县","value":"610424","parent":"610400"},{"name":"礼泉县","value":"610425","parent":"610400"},{"name":"永寿县","value":"610426","parent":"610400"},{"name":"彬县","value":"610427","parent":"610400"},{"name":"长武县","value":"610428","parent":"610400"},{"name":"旬邑县","value":"610429","parent":"610400"},{"name":"淳化县","value":"610430","parent":"610400"},{"name":"武功县","value":"610431","parent":"610400"},{"name":"兴平市","value":"610481","parent":"610400"},{"name":"临渭区","value":"610502","parent":"610500"},{"name":"华州区","value":"610503","parent":"610500"},{"name":"潼关县","value":"610522","parent":"610500"},{"name":"大荔县","value":"610523","parent":"610500"},{"name":"合阳县","value":"610524","parent":"610500"},{"name":"澄城县","value":"610525","parent":"610500"},{"name":"蒲城县","value":"610526","parent":"610500"},{"name":"白水县","value":"610527","parent":"610500"},{"name":"富平县","value":"610528","parent":"610500"},{"name":"韩城市","value":"610581","parent":"610500"},{"name":"华阴市","value":"610582","parent":"610500"},{"name":"宝塔区","value":"610602","parent":"610600"},{"name":"安塞区","value":"610603","parent":"610600"},{"name":"延长县","value":"610621","parent":"610600"},{"name":"延川县","value":"610622","parent":"610600"},{"name":"子长县","value":"610623","parent":"610600"},{"name":"志丹县","value":"610625","parent":"610600"},{"name":"吴起县","value":"610626","parent":"610600"},{"name":"甘泉县","value":"610627","parent":"610600"},{"name":"富县","value":"610628","parent":"610600"},{"name":"洛川县","value":"610629","parent":"610600"},{"name":"宜川县","value":"610630","parent":"610600"},{"name":"黄龙县","value":"610631","parent":"610600"},{"name":"黄陵县","value":"610632","parent":"610600"},{"name":"汉台区","value":"610702","parent":"610700"},{"name":"南郑县","value":"610721","parent":"610700"},{"name":"城固县","value":"610722","parent":"610700"},{"name":"洋县","value":"610723","parent":"610700"},{"name":"西乡县","value":"610724","parent":"610700"},{"name":"勉县","value":"610725","parent":"610700"},{"name":"宁强县","value":"610726","parent":"610700"},{"name":"略阳县","value":"610727","parent":"610700"},{"name":"镇巴县","value":"610728","parent":"610700"},{"name":"留坝县","value":"610729","parent":"610700"},{"name":"佛坪县","value":"610730","parent":"610700"},{"name":"榆阳区","value":"610802","parent":"610800"},{"name":"横山区","value":"610803","parent":"610800"},{"name":"神木县","value":"610821","parent":"610800"},{"name":"府谷县","value":"610822","parent":"610800"},{"name":"靖边县","value":"610824","parent":"610800"},{"name":"定边县","value":"610825","parent":"610800"},{"name":"绥德县","value":"610826","parent":"610800"},{"name":"米脂县","value":"610827","parent":"610800"},{"name":"佳县","value":"610828","parent":"610800"},{"name":"吴堡县","value":"610829","parent":"610800"},{"name":"清涧县","value":"610830","parent":"610800"},{"name":"子洲县","value":"610831","parent":"610800"},{"name":"汉滨区","value":"610902","parent":"610900"},{"name":"汉阴县","value":"610921","parent":"610900"},{"name":"石泉县","value":"610922","parent":"610900"},{"name":"宁陕县","value":"610923","parent":"610900"},{"name":"紫阳县","value":"610924","parent":"610900"},{"name":"岚皋县","value":"610925","parent":"610900"},{"name":"平利县","value":"610926","parent":"610900"},{"name":"镇坪县","value":"610927","parent":"610900"},{"name":"旬阳县","value":"610928","parent":"610900"},{"name":"白河县","value":"610929","parent":"610900"},{"name":"商州区","value":"611002","parent":"611000"},{"name":"洛南县","value":"611021","parent":"611000"},{"name":"丹凤县","value":"611022","parent":"611000"},{"name":"商南县","value":"611023","parent":"611000"},{"name":"山阳县","value":"611024","parent":"611000"},{"name":"镇安县","value":"611025","parent":"611000"},{"name":"柞水县","value":"611026","parent":"611000"},{"name":"兰州市","value":"620100","parent":"620000"},{"name":"嘉峪关市","value":"620200","parent":"620000"},{"name":"金昌市","value":"620300","parent":"620000"},{"name":"白银市","value":"620400","parent":"620000"},{"name":"天水市","value":"620500","parent":"620000"},{"name":"武威市","value":"620600","parent":"620000"},{"name":"张掖市","value":"620700","parent":"620000"},{"name":"平凉市","value":"620800","parent":"620000"},{"name":"酒泉市","value":"620900","parent":"620000"},{"name":"庆阳市","value":"621000","parent":"620000"},{"name":"定西市","value":"621100","parent":"620000"},{"name":"陇南市","value":"621200","parent":"620000"},{"name":"临夏回族自治州","value":"622900","parent":"620000"},{"name":"甘南藏族自治州","value":"623000","parent":"620000"},{"name":"城关区","value":"620102","parent":"620100"},{"name":"七里河区","value":"620103","parent":"620100"},{"name":"西固区","value":"620104","parent":"620100"},{"name":"安宁区","value":"620105","parent":"620100"},{"name":"红古区","value":"620111","parent":"620100"},{"name":"永登县","value":"620121","parent":"620100"},{"name":"皋兰县","value":"620122","parent":"620100"},{"name":"榆中县","value":"620123","parent":"620100"},{"name":"金川区","value":"620302","parent":"620300"},{"name":"永昌县","value":"620321","parent":"620300"},{"name":"白银区","value":"620402","parent":"620400"},{"name":"平川区","value":"620403","parent":"620400"},{"name":"靖远县","value":"620421","parent":"620400"},{"name":"会宁县","value":"620422","parent":"620400"},{"name":"景泰县","value":"620423","parent":"620400"},{"name":"秦州区","value":"620502","parent":"620500"},{"name":"麦积区","value":"620503","parent":"620500"},{"name":"清水县","value":"620521","parent":"620500"},{"name":"秦安县","value":"620522","parent":"620500"},{"name":"甘谷县","value":"620523","parent":"620500"},{"name":"武山县","value":"620524","parent":"620500"},{"name":"张家川回族自治县","value":"620525","parent":"620500"},{"name":"凉州区","value":"620602","parent":"620600"},{"name":"民勤县","value":"620621","parent":"620600"},{"name":"古浪县","value":"620622","parent":"620600"},{"name":"天祝藏族自治县","value":"620623","parent":"620600"},{"name":"甘州区","value":"620702","parent":"620700"},{"name":"肃南裕固族自治县","value":"620721","parent":"620700"},{"name":"民乐县","value":"620722","parent":"620700"},{"name":"临泽县","value":"620723","parent":"620700"},{"name":"高台县","value":"620724","parent":"620700"},{"name":"山丹县","value":"620725","parent":"620700"},{"name":"崆峒区","value":"620802","parent":"620800"},{"name":"泾川县","value":"620821","parent":"620800"},{"name":"灵台县","value":"620822","parent":"620800"},{"name":"崇信县","value":"620823","parent":"620800"},{"name":"华亭县","value":"620824","parent":"620800"},{"name":"庄浪县","value":"620825","parent":"620800"},{"name":"静宁县","value":"620826","parent":"620800"},{"name":"肃州区","value":"620902","parent":"620900"},{"name":"金塔县","value":"620921","parent":"620900"},{"name":"瓜州县","value":"620922","parent":"620900"},{"name":"肃北蒙古族自治县","value":"620923","parent":"620900"},{"name":"阿克塞哈萨克族自治县","value":"620924","parent":"620900"},{"name":"玉门市","value":"620981","parent":"620900"},{"name":"敦煌市","value":"620982","parent":"620900"},{"name":"西峰区","value":"621002","parent":"621000"},{"name":"庆城县","value":"621021","parent":"621000"},{"name":"环县","value":"621022","parent":"621000"},{"name":"华池县","value":"621023","parent":"621000"},{"name":"合水县","value":"621024","parent":"621000"},{"name":"正宁县","value":"621025","parent":"621000"},{"name":"宁县","value":"621026","parent":"621000"},{"name":"镇原县","value":"621027","parent":"621000"},{"name":"安定区","value":"621102","parent":"621100"},{"name":"通渭县","value":"621121","parent":"621100"},{"name":"陇西县","value":"621122","parent":"621100"},{"name":"渭源县","value":"621123","parent":"621100"},{"name":"临洮县","value":"621124","parent":"621100"},{"name":"漳县","value":"621125","parent":"621100"},{"name":"岷县","value":"621126","parent":"621100"},{"name":"武都区","value":"621202","parent":"621200"},{"name":"成县","value":"621221","parent":"621200"},{"name":"文县","value":"621222","parent":"621200"},{"name":"宕昌县","value":"621223","parent":"621200"},{"name":"康县","value":"621224","parent":"621200"},{"name":"西和县","value":"621225","parent":"621200"},{"name":"礼县","value":"621226","parent":"621200"},{"name":"徽县","value":"621227","parent":"621200"},{"name":"两当县","value":"621228","parent":"621200"},{"name":"临夏市","value":"622901","parent":"622900"},{"name":"临夏县","value":"622921","parent":"622900"},{"name":"康乐县","value":"622922","parent":"622900"},{"name":"永靖县","value":"622923","parent":"622900"},{"name":"广河县","value":"622924","parent":"622900"},{"name":"和政县","value":"622925","parent":"622900"},{"name":"东乡族自治县","value":"622926","parent":"622900"},{"name":"积石山保安族东乡族撒拉族自治县","value":"622927","parent":"622900"},{"name":"合作市","value":"623001","parent":"623000"},{"name":"临潭县","value":"623021","parent":"623000"},{"name":"卓尼县","value":"623022","parent":"623000"},{"name":"舟曲县","value":"623023","parent":"623000"},{"name":"迭部县","value":"623024","parent":"623000"},{"name":"玛曲县","value":"623025","parent":"623000"},{"name":"碌曲县","value":"623026","parent":"623000"},{"name":"夏河县","value":"623027","parent":"623000"},{"name":"西宁市","value":"630100","parent":"630000"},{"name":"海东市","value":"630200","parent":"630000"},{"name":"海北藏族自治州","value":"632200","parent":"630000"},{"name":"黄南藏族自治州","value":"632300","parent":"630000"},{"name":"海南藏族自治州","value":"632500","parent":"630000"},{"name":"果洛藏族自治州","value":"632600","parent":"630000"},{"name":"玉树藏族自治州","value":"632700","parent":"630000"},{"name":"海西蒙古族藏族自治州","value":"632800","parent":"630000"},{"name":"城东区","value":"630102","parent":"630100"},{"name":"城中区","value":"630103","parent":"630100"},{"name":"城西区","value":"630104","parent":"630100"},{"name":"城北区","value":"630105","parent":"630100"},{"name":"大通回族土族自治县","value":"630121","parent":"630100"},{"name":"湟中县","value":"630122","parent":"630100"},{"name":"湟源县","value":"630123","parent":"630100"},{"name":"乐都区","value":"630202","parent":"630200"},{"name":"平安区","value":"630203","parent":"630200"},{"name":"民和回族土族自治县","value":"630222","parent":"630200"},{"name":"互助土族自治县","value":"630223","parent":"630200"},{"name":"化隆回族自治县","value":"630224","parent":"630200"},{"name":"循化撒拉族自治县","value":"630225","parent":"630200"},{"name":"门源回族自治县","value":"632221","parent":"632200"},{"name":"祁连县","value":"632222","parent":"632200"},{"name":"海晏县","value":"632223","parent":"632200"},{"name":"刚察县","value":"632224","parent":"632200"},{"name":"同仁县","value":"632321","parent":"632300"},{"name":"尖扎县","value":"632322","parent":"632300"},{"name":"泽库县","value":"632323","parent":"632300"},{"name":"河南蒙古族自治县","value":"632324","parent":"632300"},{"name":"共和县","value":"632521","parent":"632500"},{"name":"同德县","value":"632522","parent":"632500"},{"name":"贵德县","value":"632523","parent":"632500"},{"name":"兴海县","value":"632524","parent":"632500"},{"name":"贵南县","value":"632525","parent":"632500"},{"name":"玛沁县","value":"632621","parent":"632600"},{"name":"班玛县","value":"632622","parent":"632600"},{"name":"甘德县","value":"632623","parent":"632600"},{"name":"达日县","value":"632624","parent":"632600"},{"name":"久治县","value":"632625","parent":"632600"},{"name":"玛多县","value":"632626","parent":"632600"},{"name":"玉树市","value":"632701","parent":"632700"},{"name":"杂多县","value":"632722","parent":"632700"},{"name":"称多县","value":"632723","parent":"632700"},{"name":"治多县","value":"632724","parent":"632700"},{"name":"囊谦县","value":"632725","parent":"632700"},{"name":"曲麻莱县","value":"632726","parent":"632700"},{"name":"格尔木市","value":"632801","parent":"632800"},{"name":"德令哈市","value":"632802","parent":"632800"},{"name":"乌兰县","value":"632821","parent":"632800"},{"name":"都兰县","value":"632822","parent":"632800"},{"name":"天峻县","value":"632823","parent":"632800"},{"name":"银川市","value":"640100","parent":"640000"},{"name":"石嘴山市","value":"640200","parent":"640000"},{"name":"吴忠市","value":"640300","parent":"640000"},{"name":"固原市","value":"640400","parent":"640000"},{"name":"中卫市","value":"640500","parent":"640000"},{"name":"兴庆区","value":"640104","parent":"640100"},{"name":"西夏区","value":"640105","parent":"640100"},{"name":"金凤区","value":"640106","parent":"640100"},{"name":"永宁县","value":"640121","parent":"640100"},{"name":"贺兰县","value":"640122","parent":"640100"},{"name":"灵武市","value":"640181","parent":"640100"},{"name":"大武口区","value":"640202","parent":"640200"},{"name":"惠农区","value":"640205","parent":"640200"},{"name":"平罗县","value":"640221","parent":"640200"},{"name":"利通区","value":"640302","parent":"640300"},{"name":"红寺堡区","value":"640303","parent":"640300"},{"name":"盐池县","value":"640323","parent":"640300"},{"name":"同心县","value":"640324","parent":"640300"},{"name":"青铜峡市","value":"640381","parent":"640300"},{"name":"原州区","value":"640402","parent":"640400"},{"name":"西吉县","value":"640422","parent":"640400"},{"name":"隆德县","value":"640423","parent":"640400"},{"name":"泾源县","value":"640424","parent":"640400"},{"name":"彭阳县","value":"640425","parent":"640400"},{"name":"沙坡头区","value":"640502","parent":"640500"},{"name":"中宁县","value":"640521","parent":"640500"},{"name":"海原县","value":"640522","parent":"640500"},{"name":"乌鲁木齐市","value":"650100","parent":"650000"},{"name":"克拉玛依市","value":"650200","parent":"650000"},{"name":"吐鲁番市","value":"650400","parent":"650000"},{"name":"哈密市","value":"650500","parent":"650000"},{"name":"昌吉回族自治州","value":"652300","parent":"650000"},{"name":"博尔塔拉蒙古自治州","value":"652700","parent":"650000"},{"name":"巴音郭楞蒙古自治州","value":"652800","parent":"650000"},{"name":"阿克苏地区","value":"652900","parent":"650000"},{"name":"克孜勒苏柯尔克孜自治州","value":"653000","parent":"650000"},{"name":"喀什地区","value":"653100","parent":"650000"},{"name":"和田地区","value":"653200","parent":"650000"},{"name":"伊犁哈萨克自治州","value":"654000","parent":"650000"},{"name":"塔城地区","value":"654200","parent":"650000"},{"name":"阿勒泰地区","value":"654300","parent":"650000"},{"name":"石河子市","value":"659001","parent":"650000"},{"name":"阿拉尔市","value":"659002","parent":"650000"},{"name":"图木舒克市","value":"659003","parent":"650000"},{"name":"五家渠市","value":"659004","parent":"650000"},{"name":"铁门关市","value":"659006","parent":"650000"},{"name":"天山区","value":"650102","parent":"650100"},{"name":"沙依巴克区","value":"650103","parent":"650100"},{"name":"新市区","value":"650104","parent":"650100"},{"name":"水磨沟区","value":"650105","parent":"650100"},{"name":"头屯河区","value":"650106","parent":"650100"},{"name":"达坂城区","value":"650107","parent":"650100"},{"name":"米东区","value":"650109","parent":"650100"},{"name":"乌鲁木齐县","value":"650121","parent":"650100"},{"name":"独山子区","value":"650202","parent":"650200"},{"name":"克拉玛依区","value":"650203","parent":"650200"},{"name":"白碱滩区","value":"650204","parent":"650200"},{"name":"乌尔禾区","value":"650205","parent":"650200"},{"name":"高昌区","value":"650402","parent":"650400"},{"name":"鄯善县","value":"650421","parent":"650400"},{"name":"托克逊县","value":"650422","parent":"650400"},{"name":"伊州区","value":"650502","parent":"650500"},{"name":"巴里坤哈萨克自治县","value":"650521","parent":"650500"},{"name":"伊吾县","value":"650522","parent":"650500"},{"name":"昌吉市","value":"652301","parent":"652300"},{"name":"阜康市","value":"652302","parent":"652300"},{"name":"呼图壁县","value":"652323","parent":"652300"},{"name":"玛纳斯县","value":"652324","parent":"652300"},{"name":"奇台县","value":"652325","parent":"652300"},{"name":"吉木萨尔县","value":"652327","parent":"652300"},{"name":"木垒哈萨克自治县","value":"652328","parent":"652300"},{"name":"博乐市","value":"652701","parent":"652700"},{"name":"阿拉山口市","value":"652702","parent":"652700"},{"name":"精河县","value":"652722","parent":"652700"},{"name":"温泉县","value":"652723","parent":"652700"},{"name":"库尔勒市","value":"652801","parent":"652800"},{"name":"轮台县","value":"652822","parent":"652800"},{"name":"尉犁县","value":"652823","parent":"652800"},{"name":"若羌县","value":"652824","parent":"652800"},{"name":"且末县","value":"652825","parent":"652800"},{"name":"焉耆回族自治县","value":"652826","parent":"652800"},{"name":"和静县","value":"652827","parent":"652800"},{"name":"和硕县","value":"652828","parent":"652800"},{"name":"博湖县","value":"652829","parent":"652800"},{"name":"阿克苏市","value":"652901","parent":"652900"},{"name":"温宿县","value":"652922","parent":"652900"},{"name":"库车县","value":"652923","parent":"652900"},{"name":"沙雅县","value":"652924","parent":"652900"},{"name":"新和县","value":"652925","parent":"652900"},{"name":"拜城县","value":"652926","parent":"652900"},{"name":"乌什县","value":"652927","parent":"652900"},{"name":"阿瓦提县","value":"652928","parent":"652900"},{"name":"柯坪县","value":"652929","parent":"652900"},{"name":"阿图什市","value":"653001","parent":"653000"},{"name":"阿克陶县","value":"653022","parent":"653000"},{"name":"阿合奇县","value":"653023","parent":"653000"},{"name":"乌恰县","value":"653024","parent":"653000"},{"name":"喀什市","value":"653101","parent":"653100"},{"name":"疏附县","value":"653121","parent":"653100"},{"name":"疏勒县","value":"653122","parent":"653100"},{"name":"英吉沙县","value":"653123","parent":"653100"},{"name":"泽普县","value":"653124","parent":"653100"},{"name":"莎车县","value":"653125","parent":"653100"},{"name":"叶城县","value":"653126","parent":"653100"},{"name":"麦盖提县","value":"653127","parent":"653100"},{"name":"岳普湖县","value":"653128","parent":"653100"},{"name":"伽师县","value":"653129","parent":"653100"},{"name":"巴楚县","value":"653130","parent":"653100"},{"name":"塔什库尔干塔吉克自治县","value":"653131","parent":"653100"},{"name":"和田市","value":"653201","parent":"653200"},{"name":"和田县","value":"653221","parent":"653200"},{"name":"墨玉县","value":"653222","parent":"653200"},{"name":"皮山县","value":"653223","parent":"653200"},{"name":"洛浦县","value":"653224","parent":"653200"},{"name":"策勒县","value":"653225","parent":"653200"},{"name":"于田县","value":"653226","parent":"653200"},{"name":"民丰县","value":"653227","parent":"653200"},{"name":"伊宁市","value":"654002","parent":"654000"},{"name":"奎屯市","value":"654003","parent":"654000"},{"name":"霍尔果斯市","value":"654004","parent":"654000"},{"name":"伊宁县","value":"654021","parent":"654000"},{"name":"察布查尔锡伯自治县","value":"654022","parent":"654000"},{"name":"霍城县","value":"654023","parent":"654000"},{"name":"巩留县","value":"654024","parent":"654000"},{"name":"新源县","value":"654025","parent":"654000"},{"name":"昭苏县","value":"654026","parent":"654000"},{"name":"特克斯县","value":"654027","parent":"654000"},{"name":"尼勒克县","value":"654028","parent":"654000"},{"name":"塔城市","value":"654201","parent":"654200"},{"name":"乌苏市","value":"654202","parent":"654200"},{"name":"额敏县","value":"654221","parent":"654200"},{"name":"沙湾县","value":"654223","parent":"654200"},{"name":"托里县","value":"654224","parent":"654200"},{"name":"裕民县","value":"654225","parent":"654200"},{"name":"和布克赛尔蒙古自治县","value":"654226","parent":"654200"},{"name":"阿勒泰市","value":"654301","parent":"654300"},{"name":"布尔津县","value":"654321","parent":"654300"},{"name":"富蕴县","value":"654322","parent":"654300"},{"name":"福海县","value":"654323","parent":"654300"},{"name":"哈巴河县","value":"654324","parent":"654300"},{"name":"青河县","value":"654325","parent":"654300"},{"name":"吉木乃县","value":"654326","parent":"654300"},{"name":"中西區","value":"810001","parent":"810000"},{"name":"灣仔區","value":"810002","parent":"810000"},{"name":"東區","value":"810003","parent":"810000"},{"name":"南區","value":"810004","parent":"810000"},{"name":"油尖旺區","value":"810005","parent":"810000"},{"name":"深水埗區","value":"810006","parent":"810000"},{"name":"九龍城區","value":"810007","parent":"810000"},{"name":"黃大仙區","value":"810008","parent":"810000"},{"name":"觀塘區","value":"810009","parent":"810000"},{"name":"荃灣區","value":"810010","parent":"810000"},{"name":"屯門區","value":"810011","parent":"810000"},{"name":"元朗區","value":"810012","parent":"810000"},{"name":"北區","value":"810013","parent":"810000"},{"name":"大埔區","value":"810014","parent":"810000"},{"name":"西貢區","value":"810015","parent":"810000"},{"name":"沙田區","value":"810016","parent":"810000"},{"name":"葵青區","value":"810017","parent":"810000"},{"name":"離島區","value":"810018","parent":"810000"},{"name":"花地瑪堂區","value":"820001","parent":"820000"},{"name":"花王堂區","value":"820002","parent":"820000"},{"name":"望德堂區","value":"820003","parent":"820000"},{"name":"大堂區","value":"820004","parent":"820000"},{"name":"風順堂區","value":"820005","parent":"820000"},{"name":"嘉模堂區","value":"820006","parent":"820000"},{"name":"路氹填海區","value":"820007","parent":"820000"},{"name":"聖方濟各堂區","value":"820008","parent":"820000"},{"name":"--","value":"--","parent":"139000"},{"name":"--","value":"--","parent":"139001"},{"name":"--","value":"--","parent":"139002"},{"name":"--","value":"--","parent":"419000"},{"name":"--","value":"--","parent":"419001"},{"name":"--","value":"--","parent":"429000"},{"name":"--","value":"--","parent":"429004"},{"name":"--","value":"--","parent":"429005"},{"name":"--","value":"--","parent":"429006"},{"name":"--","value":"--","parent":"429021"},{"name":"--","value":"--","parent":"441900"},{"name":"--","value":"--","parent":"442000"},{"name":"--","value":"--","parent":"460300"},{"name":"--","value":"--","parent":"460400"},{"name":"--","value":"--","parent":"469000"},{"name":"--","value":"--","parent":"469001"},{"name":"--","value":"--","parent":"469002"},{"name":"--","value":"--","parent":"469005"},{"name":"--","value":"--","parent":"469006"},{"name":"--","value":"--","parent":"469007"},{"name":"--","value":"--","parent":"469021"},{"name":"--","value":"--","parent":"469022"},{"name":"--","value":"--","parent":"469023"},{"name":"--","value":"--","parent":"469024"},{"name":"--","value":"--","parent":"469025"},{"name":"--","value":"--","parent":"469026"},{"name":"--","value":"--","parent":"469027"},{"name":"--","value":"--","parent":"469028"},{"name":"--","value":"--","parent":"469029"},{"name":"--","value":"--","parent":"469030"},{"name":"--","value":"--","parent":"620200"},{"name":"--","value":"--","parent":"659000"},{"name":"--","value":"--","parent":"659001"},{"name":"--","value":"--","parent":"659002"},{"name":"--","value":"--","parent":"659003"},{"name":"--","value":"--","parent":"659004"},{"name":"--","value":"--","parent":"659006"}]

/***/ }),

/***/ "G/kn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G6U3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GhsE":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAEHklEQVR4XuWb21UbMRCG/3EDgQpiKghUkKWCkAqCl7wHKghUEHiPbaggpALkCuJUEKeCkAasnFnt+hDwrjSj1fqmF3wOkq35NKu5LmHHB61K/mxs98jiDf/+Q06TVe1jJQCysT2ExQOAvVLwRxCOzYCmXYPoHACfPCx+PRG+knlmcjrYfgBDewrCeKmgFgNzRrddQuheA0aWT79fI+TU5HS0tQCysc3KZ79eRncXmK4gdKoB2cjeA3jnEe7O5HS6dQCyse2Xl59fNsKBGdDMPzF+RmcakI3sNYBPQVu2uDJndBk0N3JSlwD+LDF9ddvvzCR2AiBrMn11CDoyid0AGNkfAA6F2mpMTsfCNeLpyQEEmb66bROOUrvH6QGMLHt2H8RH4xYkN4lJAYhMX70W7JsBPSoBepelBTC0lyB89u6iaUJik5gWwMhKTN9KTGIyACrTV4dgjvfmI7Eb3fpIAqAh5tcKMIOzCK3fBa0CKC+9twDOFXbfB4ezRdcgTNqMExoBPM3bsRtrqXRm5thD9dmltaROjk/Y0P8zFKcVFlP03GeyWITTvnxjAaBQWQ5ULLLyl6u/oRvZlHkODBWAbviRogTP66bAKO4VEoWpmyJa6D4tLhgAqwNfXLs4JruuAVd8B/QxxxSEVzulAhZ/0UO/sgKHmMPsDAQnfMah9sIPKMpVc9yCXL1ua4fFT/RwUjlT/zlChUl0mrCdEJzwfPILl/qFJ1j6BZzB1SYx1lV5liZXal3hrfIPGnIKzbGAJpu7bufvyS57o8EiqTnH/cZZCHfT82XXWGf0AiiDpc0ykxa/S+G9DRdBABYR4yZYiCU3fdNTGQxgAcGC09y+Cu+qboI7EM4lmSMRgEqqLC7XnwqOqoagAlBoQ1itP5Wwz79XJbzLjShH2enFNb/Vj4h+AjWAUgvs6qUHTE5qOdQLd14DWi18xKpRRC+BXgPWyxLcmJy4FiEeMQCa+v3EG4lcoO4vVAFopewdKfGL5QRVGV0H4Ks9QQ/f2pYh6vuUDZY6AJKWtyipBIuVfQRaAJqmJ4E0qqkTk5O4pKcFsBYO0HNMGodIDCCq60t1sIJFintADqCNvp9KJk5cuIjktUDM+qkWF+aMOKEbPOQA2qklTkC4rNJVpVZxb3BsjfK7yekkWHpNNJjFND5xng44r3srJBta9ua4s0xbpns0Oe0nAxAZAN2Up97Y5xNdlxCGxqJHoDghwhcJYQCs7pym8iYon35vmY3mniBZlUoYGMkASLJAHnUPhah4LETZISmA0AAoSN2DIbhX7ULLdSKHSAZgaLmPoEklVeouAMFFGt9jkRTA8t7fltQ9GESTtRDGBCIN4A0uSYmLc/GhgjbNq7EW4sSIGEABgdtq3MuPsza7NjVgYveiAqDZ6Lqu+QfUP7ZxbjgxsgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "Gp28":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HH82":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hgxa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hngr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IM0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IUU3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JvV8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KOQG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KdGT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kywb":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAACrUlEQVR4Xu1bz0tUURT+zht0KAUXVhBUu1Yth1xE86MwqE24kDaZ4Jvi0Q9cu5y/ITIYU4nRNlHkrhYJ7zVBSM2yVcsiEDQotJzeOCfezCwktHdHncan36wG7rnn3PO9+/Oc7wia+eXUypzEbQWuiiDeTNdWy6qiLMAL10YeImpqT0wFE3k93N2BVwIkTfu0Q06B4oqPyyVHfprYNwYgPaXjIrhjorTdMqp46GXlrsk4jADoz2tPpQPLAGKqqEIwtNSN5x+vyW8TI62WOfNUO3tXMWgpCsEYoSgfWkXPy1Eph9k2AiA5qX0xCwsNZa9dWy6FKW5He3pa5wW4WLOtOOtm5UPYOIwASE1qyrLgNZTNurbcCFPcjvbMlM5CcL3mvyDljUgxbBwEIAyhoJ0zgEuAewA3QZ4CPAZ5D+BFiDfBOgK8CvMtwMcQX4N8Dpu8Iv+3DOMBDIgwIsSQGGOCDIoyKsywOPMCTIwwM8TUGHODTI4yO8z0OPkBJEiQIUKKTFhckhyhMITIESJJiiwx0uTIEyRPkDzBXeUJZh7pCcQwByABxaICT1YqGCs54pscy1vJRCY5mp7WN39Xnigw4dni7HsAkjN6PObj62aOlqvofXdTvm0XhEjMgHMFPdZZweKmTvo46jqytK8BCJzbYgkUPVtS23U+6BeJGVAb6MZNsO5xCesYcG/JlwMBQM1JVTlfwOng79thfGqm1i/yp8BOvvK/+kZmCUQOgAuPNaFV1EvQFPNuVvpb5cRO9G4sm1NBnzci78P0GUWErtzX+K8ufEe9Xni9Khhe7sKzvVI42RjfoApmBBBV+GtxHFkYkh+7AkDjiHkAgVE5apjRlrcrxt2s3DOxYzQDAkUHvni6hmZOrfQpOFAM7LXyeQBrUMy5nzGBnFRNvn4g8wec5ftfTmpkqQAAAABJRU5ErkJggg=="

/***/ }),

/***/ "M5Ib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MFbL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mxix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);

// CONCATENATED MODULE: ./src/plugin/axios.js

/**
 * http配置
 */


// axios 配置
axios_default.a.defaults.timeout = 5000;

// axios.defaults.baseURL = api.baseRequestUrl
// http request 拦截器
axios_default.a.interceptors.request.use(function (config) {
  config.headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  return config;
}, function (err) {
  return promise_default.a.reject(err);
});

// // 添加一个响应拦截器
// axios.interceptors.response.use(
//   function(res) {
//     if (!res.data.success) {
//       if (res.data.code === '410') {
//       }
//       return res
//     }
//     return res
//   },
//   function(err) {
//     console.info('error-')
//     return Promise.reject(err)
//   }
// )

/* harmony default export */ var plugin_axios = (axios_default.a);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'home'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'home'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc6d4a3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("hqDL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./src/service/api/api-const.js
var api_const = __webpack_require__("oHqA");
var api_const_default = /*#__PURE__*/__webpack_require__.n(api_const);

// CONCATENATED MODULE: ./src/service/api/http.js



// import store from '@/store'
// import * as types from '@/store/mutation-types'
// import router from '@/router'


// axios 配置
axios_default.a.defaults.timeout = 20000;

if (false) {
    axios.defaults.baseURL = "";
} else {
    // 开发环境使用代理，baseURL 为空字符串（相对路径）
    // 生产环境使用完整的 API 地址
    axios_default.a.defaults.baseURL = api_const["baseRequestUrl"] || '';
}
// axios.defaults.baseURL = api.baseRequestUrl;
// http request 拦截器
axios_default.a.interceptors.request.use(function (config) {
    // 如果使用的是 FormData，不要设置 Content-Type，让浏览器自动设置
    // 否则会触发 CORS 预检请求
    if (!(config.data instanceof FormData)) {
        config.headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
    }
    // if (Lockr.get('token')) { // 判断是否存在token，如果存在的话，则每个http header都加上token
    //     axios.defaults.headers.Authorization = Lockr.get('token')
    // }
    return config;
}, function (err) {
    return promise_default.a.reject(err);
});
// 添加一个响应拦截器
axios_default.a.interceptors.response.use(function (res) {
    if (!res.data.success) {
        if (res.data.code == '410') {
            Util.setCookie('user_token', '');
        }
        return res;
    }
    return res;
}, function (err) {
    return promise_default.a.reject(err);
});

/* harmony default export */ var http = (axios_default.a);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/js-base64/base64.js
var base64 = __webpack_require__("xrTZ");
var base64_default = /*#__PURE__*/__webpack_require__.n(base64);

// CONCATENATED MODULE: ./src/service/api/http-tools.js





//post request
function fetchPost(url, param) {
    // 调试：打印完整的请求 URL
    var fullUrl = http.defaults.baseURL ? http.defaults.baseURL + url : url;
    console.log('[API Request] URL:', url);
    console.log('[API Request] BaseURL:', http.defaults.baseURL);
    console.log('[API Request] Full URL:', fullUrl);

    var parseData = stringify_default()(param);
    var formData = new FormData();
    formData.append("data", encodeURI(base64["Base64"].encode(parseData)));
    return new promise_default.a(function (resolve, reject) {
        http.post(url, formData).then(function (response) {
            var data = base64["Base64"].decode(response.data);
            var jsonData = JSON.parse(data);

            // 只在本地和测试环境打印响应数据
            if (false) {
                console.log('[APIresponse' + url + '] Data:', jsonData);
            }
            resolve(jsonData);
        }, function (err) {
            // 详细的错误信息
            var fullUrl = http.defaults.baseURL ? http.defaults.baseURL + url : url;
            console.error('[API Error] Request failed:', {
                url: url,
                baseURL: http.defaults.baseURL,
                fullUrl: fullUrl,
                status: err.response && err.response.status,
                statusText: err.response && err.response.statusText,
                data: err.response && err.response.data,
                message: err.message,
                config: err.config
            });
            reject(err);
        }).catch(function (error) {
            var fullUrl = http.defaults.baseURL ? http.defaults.baseURL + url : url;
            console.error('[API Error] Catch error:', {
                url: url,
                baseURL: http.defaults.baseURL,
                fullUrl: fullUrl,
                error: error
            });
            reject(error);
        });
    });
}

//post file request
function fetchPostFile(url, param, files) {
    var parseData = stringify_default()(param);
    var formData = new FormData();
    formData.append("data", encodeURI(base64["Base64"].encode(parseData)));
    var oldImgUrls = [];
    for (var i = 0; i < files.length; i++) {
        if (files[i].file) {

            formData.append(files[i].id + "_imgKey_" + (i + 1), files[i].file, files[i].id + "_fileName." + files[i].file.type.split("/")[1]);
        } else {
            var imgs = {
                id: files[i].id,
                url: files[i].url,
                key: files[i].id + "_imgKey_" + (i + 1) + "_url"
            };
            var obj = stringify_default()(imgs);
            oldImgUrls.push(obj);
        }
    }
    if (oldImgUrls.length > 0) {
        formData.append("old_image", oldImgUrls);
    }
    return new promise_default.a(function (resolve, reject) {
        var config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        http.post(url, formData, config).then(function (response) {
            var data = base64["Base64"].decode(response.data);
            var jsonData = JSON.parse(data);
            resolve(jsonData);
        }, function (err) {
            reject(err);
        }).catch(function (error) {
            reject(error);
        });
    });
}

function resetFetchPost(url, param) {
    param = lib_default.a.stringify(param);
    return new promise_default.a(function (resolve, reject) {
        http.post(url, param).then(function (response) {
            resolve(response.data);
        }, function (err) {
            reject(err);
        }).catch(function (error) {
            reject(error);
        });
    });
}
//文件上传
// export function fetchUpload(url, param) {
//     let tmpParam
//     if(param){
//         param.append('token', Util.getCookie('user_token'))
//         tmpParam = param
//     }else{
//         let formdata = new FormData()
//         formdata.append('token', Util.getCookie('user_token'))
//         tmpParam = formdata
//     }
//     return new Promise((resolve, reject) => {
//         let config = {
//             headers: {
//                 'Content-Type': 'multipart/form-data'
//             }
//         }
//         axios.post(url, tmpParam, config)
//             .then(response => {
//                 resolve(response.data)
//             }, err => {
//                 reject(err)
//             })
//             .catch((error) => {
//                 reject(error)
//             })
//     })
// }

//get request
function fetchGet(url, param) {
    appendToken(param);
    return new promise_default.a(function (resolve, reject) {
        http.get(url, {
            params: param
        }).then(function (response) {
            resolve(response.data);
        }, function (err) {
            reject(err);
        }).catch(function (error) {
            reject(error);
        });
    });
}

//并发顺序请求
function fetchPostAll(arrayRequest) {
    var p = promise_default.a.all(arrayRequest, function (resolve, reject) {});
    return p.then(function (val) {
        return new promise_default.a(function (resolve, reject) {
            resolve(val);
        });
    });
}

//追回token
// function appendToken(param){
//     let tmpParam
//     if(param){
//         param.token =  Util.getCookie('user_token')
//         tmpParam = param
//     }else{
//         tmpParam = {'token':Util.getCookie('user_token')}
//     }
//     return tmpParam
// }

//post file 新表单
function newFormfetchPostFile(url, param, files, fieldName) {
    var parseData = stringify_default()(param);
    var formData = new FormData();
    formData.append("data", encodeURI(base64["Base64"].encode(parseData)));
    var oldImgUrls = [];
    for (var i = 0; i < files.length; i++) {
        console.info(files[i]);
        if (files[i].file) {
            formData.append(fieldName + "_imgKey_" + (i + 1), files[i].file, files[i].id + "_fileName." + files[i].file.type.split("/")[1]);
        }
    }
    return new promise_default.a(function (resolve, reject) {
        var config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        http.post(url, formData, config).then(function (response) {
            var data = base64["Base64"].decode(response.data);
            var jsonData = JSON.parse(data);
            resolve(jsonData);
        }, function (err) {
            reject(err);
        }).catch(function (error) {
            reject(error);
        });
    });
}

//宝宝足印上传多个file
function fetchPostFileFootprint(url, param, filesIn, filseOut) {
    var parseData = stringify_default()(param);
    var formData = new FormData();
    formData.append("data", encodeURI(base64["Base64"].encode(parseData)));
    var oldImgUrls = [];
    for (var i = 0; i < filesIn.length; i++) {
        console.info(filesIn[i]);
        if (filesIn[i].file) {
            formData.append("infoot_imgKey_" + (i + 1), filesIn[i].file, filesIn[i].id + "_fileName." + filesIn[i].file.type.split("/")[1]);
        }
    }
    for (var _i = 0; _i < filseOut.length; _i++) {
        console.info(filseOut[_i]);
        if (filseOut[_i].file) {
            formData.append("outfoot_imgKey_" + (_i + 1), filseOut[_i].file, filseOut[_i].id + "_fileName." + filseOut[_i].file.type.split("/")[1]);
        }
    }
    return new promise_default.a(function (resolve, reject) {
        var config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        http.post(url, formData, config).then(function (response) {
            var data = base64["Base64"].decode(response.data);
            var jsonData = JSON.parse(data);
            resolve(jsonData);
        }, function (err) {
            reject(err);
        }).catch(function (error) {
            reject(error);
        });
    });
}
// CONCATENATED MODULE: ./src/service/api/repository/login-api.js


/* harmony default export */ var login_api = ({
    login: function login(params) {
        return fetchPost(api_const["loginUrl"], params);
    }
});
// CONCATENATED MODULE: ./src/service/api/repository/monthLive-api.js


/* harmony default export */ var monthLive_api = ({
    monthLive: function monthLive(params) {
        return fetchPost(api_const["momEvaluationSheetUrl"], params);
    },
    setMonthLive: function setMonthLive(params, files) {
        return fetchPostFile(api_const["setMomEvaluationSheetUrl"], params, files);
    },
    babyList: function babyList(params) {
        return fetchPost(api_const["babyListUrl"], params);
    },
    otherFormList: function otherFormList(params) {
        return fetchPost(api_const["otherFormListUrl"], params);
    }
});
// CONCATENATED MODULE: ./src/service/api/repository/memberList-api.js


/* harmony default export */ var memberList_api = ({
    memberList: function memberList(params) {
        return fetchPost(api_const["member_listUrl"], params);
    },
    memberDetail: function memberDetail(params) {
        return fetchPost(api_const["detial_memberUrl"], params);
    },
    leaveCustom: function leaveCustom(params) {
        return fetchPost(api_const["leaveMemberUrl"], params);
    },
    getBatchList: function getBatchList(params, tableId) {
        if (tableId == 3 || tableId == 4 || tableId == 1 || tableId == 7) {
            return fetchPost(api_const["getBatchBabyHeathRecordList"], params);
        } else {
            return fetchPost(api_const["getBatchMatarnalHeathRecordList"], params);
        }
    },
    getBatchMatarnalHeathRecordList: function getBatchMatarnalHeathRecordList(params) {
        return fetchPost(api_const["getBatchMatarnalHeathRecordList"], params);
    },
    getBatchBabyHeathRecordList: function getBatchBabyHeathRecordList(params) {
        return fetchPost(api_const["getBatchBabyHeathRecordList"], params);
    },
    batchAddBabyNursOne: function batchAddBabyNursOne(params) {
        return fetchPost(api_const["batchAddBabyNursOne"], params);
    },
    batchAddBabyNursTwo: function batchAddBabyNursTwo(params) {
        return fetchPost(api_const["batchAddBabyNursTwo"], params);
    },
    batchHeathRecord: function batchHeathRecord(params) {
        return fetchPost(api_const["batchHeathRecord"], params);
    },
    batchAddMaternalEverydayPhysiology: function batchAddMaternalEverydayPhysiology(params) {

        return fetchPost(api_const["batchAddMaternalEverydayPhysiology"], params);
    },
    batchAddMaterRehNursEvalData: function batchAddMaterRehNursEvalData(params) {
        return fetchPost(api_const["batchAddMaterRehNursEvalData"], params);
    },
    batchMatarnalHeathRecord: function batchMatarnalHeathRecord(params) {
        return fetchPost(api_const["batchMatarnalHeathRecord"], params);
    },
    batchBabyHeathRecord: function batchBabyHeathRecord(params) {
        return fetchPost(api_const["batchBabyHeathRecord"], params);
    },
    batchAddBabyCareOpera: function batchAddBabyCareOpera(params) {
        return fetchPost(api_const["batchAddBabyCareOpera"], params);
    },
    batchHeathRecordDetail: function batchHeathRecordDetail(params) {
        return fetchPost(api_const["batchHeathRecordDetail"], params);
    }
});
// CONCATENATED MODULE: ./src/service/api/repository/checkRoom-api.js


/* harmony default export */ var checkRoom_api = ({
    roundFormList: function roundFormList(params) {
        return fetchPost(api_const["roundFormListUrl"], params);
    },
    memberInfo: function memberInfo(params) {
        return fetchPost(api_const["livingMemberTopUrl"], params);
    },
    getGroupList: function getGroupList(params) {
        return fetchPost(api_const["getGroupListUrl"], params);
    },
    roundAllList: function roundAllList(params) {
        return fetchPost(api_const["roundAllListUrl"], params);
    },
    addRecordFrom: function addRecordFrom(params) {
        return fetchPost(api_const["addRecordFormUrl"], params);
    },
    setRoundRecord: function setRoundRecord(params, files) {
        return fetchPostFile(api_const["setRoundRecordUrl"], params, files);
    },
    detailOtherForm: function detailOtherForm(params, files) {
        return fetchPost(api_const["detailOtherFormUrl"], params);
    },
    setOtherForm: function setOtherForm(params, files) {
        return fetchPostFile(api_const["setOtherFormUrl"], params, files);
    },
    getBreastMilkRecored: function getBreastMilkRecored(params) {
        return fetchPost(api_const["getBreastMilkRecoredUrl"], params);
    },
    getColumnList: function getColumnList(params) {
        return fetchPost(api_const["columnListUrl"], params);
    },
    getCheckInfo: function getCheckInfo(params) {
        return fetchPost(api_const["getCheckInfoUrl"], params);
    },

    //喂药委托书添加
    addFeedDrugEntrust: function addFeedDrugEntrust(params) {
        return fetchPost(api_const["addFeedDrugEntrustUrl"], params);
    },

    //喂药委托书查询list数据
    getFeedDrugEntrustUrlList: function getFeedDrugEntrustUrlList(params) {
        return fetchPost(api_const["feedDrugEntrustUrl"], params);
    },

    //喂药委托书详情数据
    detailFeedDrugEntrustDetail: function detailFeedDrugEntrustDetail(params) {
        return fetchPost(api_const["detailFeedDrugEntrustDetailUrl"], params);
    },

    //喂药委托书数据更新
    updateFeedDrugEntrust: function updateFeedDrugEntrust(params) {
        return fetchPost(api_const["updateFeedDrugEntrustUrl"], params);
    },

    //月子基本护理常识添加
    addConfinementSense: function addConfinementSense(params) {
        return fetchPost(api_const["addConfinementSenseUrl"], params);
    },

    //月子基本护理常识数据
    getConfinementSenseListUrlList: function getConfinementSenseListUrlList(params) {
        return fetchPost(api_const["confinementSenseListUrl"], params);
    },

    //月子基本护理常识详情数据
    confinementSenseDetail: function confinementSenseDetail(params) {
        return fetchPost(api_const["confinementSenseDetailUrl"], params);
    },

    //月子基本护理常识数据更新
    updateConfinementSense: function updateConfinementSense(params) {
        return fetchPost(api_const["updateConfinementSenseUrl"], params);
    },

    //获取查房人
    getAgentListFn: function getAgentListFn(params) {
        return fetchPost(api_const["getAgentList"], params);
    },

    //获取所用表格列表
    getFormTypeListFn: function getFormTypeListFn(params) {
        return fetchPost(api_const["getFormTypeList"], params);
    },

    //获取查房记录相关表格数据列表
    getFormDataListFn: function getFormDataListFn(params) {
        return fetchPost(api_const["getFormDataList"], params);
    }
});
// CONCATENATED MODULE: ./src/service/api/repository/babyLive-api.js


/* harmony default export */ var babyLive_api = ({
    babyEvaluationSheet: function babyEvaluationSheet(params) {
        return fetchPost(api_const["babyEvaluationSheetUrl"], params);
    },
    setBabyEvaluationSheet: function setBabyEvaluationSheet(params, files) {
        return fetchPostFile(api_const["setBabyEvaluationSheetUrl"], params, files);
    },
    getBabeMedicationList: function getBabeMedicationList(params) {
        return fetchPost(api_const["getBabeMedicationListUrl"], params);
    },
    addBabeMedicationList: function addBabeMedicationList(params) {
        return fetchPost(api_const["addBabeMedicationListUrl"], params);
    },
    getBabeSignList: function getBabeSignList(params) {
        return fetchPost(api_const["getBabeSignListUrl"], params);
    },
    addBabeSign: function addBabeSign(params) {
        return fetchPost(api_const["addBabeSignUrl"], params);
    },
    getBreastMilkRecored: function getBreastMilkRecored(params) {
        return fetchPost(api_const["getBreastMilkRecoredUrl"], params);
    },
    addBreastMilk: function addBreastMilk(params) {
        return fetchPost(api_const["addBreastMilkUrl"], params);
    },
    getBabeFeedRecored: function getBabeFeedRecored(params) {
        return fetchPost(api_const["getBabeFeedRecoredUrl"], params);
    },
    addBabeFeedRecored: function addBabeFeedRecored(params) {
        return fetchPost(api_const["addBabeFeedRecoredUrl"], params);
    }
});
// CONCATENATED MODULE: ./src/service/api/repository/bbForm-api.js


/* harmony default export */ var bbForm_api = ({
    //婴儿护理操作记录表添加
    addBabyCareOperaData: function addBabyCareOperaData(params) {
        return fetchPost(api_const["addBabyCareOperaDataUrl"], params);
    },

    //婴儿护理操作记录表查询list数据
    getBabyCareOperalist: function getBabyCareOperalist(params) {
        return fetchPost(api_const["getBabyCareOperalistUrl"], params);
    },

    //婴儿护理操作记录表详情数据
    getBabyCareOperaFind: function getBabyCareOperaFind(params) {
        return fetchPost(api_const["getBabyCareOperaFindUrl"], params);
    },

    //婴儿护理操作记录表数据更新
    updateBabyCareOperaData: function updateBabyCareOperaData(params) {
        return fetchPost(api_const["updateBabyCareOperaDataUrl"], params);
    },

    //婴儿护理记录单（1）添加
    addBabyNursOneData: function addBabyNursOneData(params) {
        return fetchPost(api_const["addBabyNursOneDataUrl"], params);
    },

    //婴儿护理记录单（1）查询list数据
    getBabyNursOneDataList: function getBabyNursOneDataList(params) {
        return fetchPost(api_const["getBabyNursOneDataListUrl"], params);
    },

    //婴儿护理记录单（1）详情数据
    getBabyNursOneFind: function getBabyNursOneFind(params) {
        return fetchPost(api_const["getBabyNursOneFindUrl"], params);
    },

    //婴儿护理记录单（1）数据更新
    updateBabyNursOneData: function updateBabyNursOneData(params) {
        return fetchPost(api_const["updateBabyNursOneDataUrl"], params);
    },

    //婴儿护理记录单（2）添加
    addBabyNursTwoData: function addBabyNursTwoData(params) {
        return fetchPost(api_const["addBabyNursTwoDataUrl"], params);
    },

    //婴儿护理记录单（2）查询list数据
    getBabyNursTwoDataList: function getBabyNursTwoDataList(params) {
        return fetchPost(api_const["getBabyNursTwoDataListUrl"], params);
    },

    //婴儿护理记录单（2）详情数据
    getBabyNursTwoFind: function getBabyNursTwoFind(params) {
        return fetchPost(api_const["getBabyNursTwoFindUrl"], params);
    },

    //婴儿护理记录单（2）数据更新
    updateBabyNursTwoData: function updateBabyNursTwoData(params) {
        return fetchPost(api_const["updateBabyNursTwoDataUrl"], params);
    },

    //婴儿喂养记录单添加
    addBabyFeedingRecordData: function addBabyFeedingRecordData(params) {
        return fetchPost(api_const["addBabyFeedingRecordDataUrl"], params);
    },

    //婴儿喂养记录单查询list数据
    getBabyFeedingRecordList: function getBabyFeedingRecordList(params) {
        return fetchPost(api_const["getBabyFeedingRecordListUrl"], params);
    },

    //婴儿喂养记录单详情数据
    getBabyFeedingRecordFind: function getBabyFeedingRecordFind(params) {
        return fetchPost(api_const["getBabyFeedingRecordFindUrl"], params);
    },

    //婴儿喂养记录单数据更新
    updateBabyFeedingRecordData: function updateBabyFeedingRecordData(params) {
        return fetchPost(api_const["updateBabyFeedingRecordDataUrl"], params);
    },

    //产妇每日生理护理记录添加
    addMaternalEverydayPhysiology: function addMaternalEverydayPhysiology(params) {
        return fetchPost(api_const["addMaternalEverydayPhysiologyUrl"], params);
    },

    //产妇每日生理护理记录查询list数据
    getMaternalEverydayPhysiologyList: function getMaternalEverydayPhysiologyList(params) {
        return fetchPost(api_const["getMaternalEverydayPhysiologyListUrl"], params);
    },

    //产妇每日生理护理记录详情数据
    getMaternalEverydayPhysiologyFind: function getMaternalEverydayPhysiologyFind(params) {
        return fetchPost(api_const["getMaternalEverydayPhysiologyFindUrl"], params);
    },

    //产妇每日生理护理记录数据更新
    updateMaternalEverydayPhysiology: function updateMaternalEverydayPhysiology(params) {
        return fetchPost(api_const["updateMaternalEverydayPhysiologyUrl"], params);
    },

    //产妇膳食记录添加
    addMaternalMealRecordsData: function addMaternalMealRecordsData(params) {
        return fetchPost(api_const["addMaternalMealRecordsDataUrl"], params);
    },

    //产妇膳食记录查询list数据
    getMaternalMealRecordsList: function getMaternalMealRecordsList(params) {
        return fetchPost(api_const["getMaternalMealRecordsListUrl"], params);
    },

    //产妇膳食记录详情数据
    getMaternalMealRecordsFind: function getMaternalMealRecordsFind(params) {
        return fetchPost(api_const["getMaternalMealRecordsFindUrl"], params);
    },

    //产妇膳食记录数据更新
    updateMaternalMealRecordsData: function updateMaternalMealRecordsData(params) {
        return fetchPost(api_const["updateMaternalMealRecordsDataUrl"], params);
    },

    //产妇康复护理评估记录单添加
    addMaterRehNursEvalData: function addMaterRehNursEvalData(params) {
        return fetchPost(api_const["addMaterRehNursEvalDataUrl"], params);
    },

    //产妇康复护理评估记录单查询list数据
    getMaterRehNursEvalList: function getMaterRehNursEvalList(params) {
        return fetchPost(api_const["getMaterRehNursEvalListUrl"], params);
    },

    //产妇康复护理评估记录单详情数据
    getMaterRehNursEvalFind: function getMaterRehNursEvalFind(params) {
        return fetchPost(api_const["getMaterRehNursEvalFindUrl"], params);
    },

    //产妇康复护理评估记录单数据更新
    updateMaterRehNursEvalData: function updateMaterRehNursEvalData(params) {
        return fetchPost(api_const["updateMaterRehNursEvalDataUrl"], params);
    }
});
// CONCATENATED MODULE: ./src/service/api/repository/otherForm-api.js


/* harmony default export */ var otherForm_api = ({
    //获取固定表单数据状态
    getFormStatus: function getFormStatus(params) {
        return fetchPost(api_const["getFormStatusUrl"], params);
    },

    //新生儿入住评估单添加
    addNewBornCheckAssessData: function addNewBornCheckAssessData(params) {
        return fetchPost(api_const["addNewBornCheckAssessDataUrl"], params);
    },

    //新生儿入住评估单详情
    getNewBornCheckAssessFind: function getNewBornCheckAssessFind(params) {
        return fetchPost(api_const["getNewBornCheckAssessFindUrl"], params);
    },

    //新生儿入住评估单编辑
    updateNewBornCheckAssessData: function updateNewBornCheckAssessData(params) {
        return fetchPost(api_const["updateNewBornCheckAssessDataUrl"], params);
    },

    //新生儿满月评估单添加
    addNewbornFullmoonAssessData: function addNewbornFullmoonAssessData(params) {
        return fetchPost(api_const["addNewbornFullmoonAssessDataUrl"], params);
    },

    //新生儿满月评估单详情
    getNewbornFullmoonAssessFind: function getNewbornFullmoonAssessFind(params) {
        return fetchPost(api_const["getNewbornFullmoonAssessFindUrl"], params);
    },

    //新生儿满月评估单编辑
    updateNewNewbornFullmoonAssessData: function updateNewNewbornFullmoonAssessData(params) {
        return fetchPost(api_const["updateNewNewbornFullmoonAssessDataUrl"], params);
    },

    //妈妈入住评估单添加
    addMaterCheckAssessData: function addMaterCheckAssessData(params) {
        return fetchPost(api_const["addMaterCheckAssessDataUrl"], params);
    },

    //妈妈入住评估单详情
    getMaterCheckAssessFind: function getMaterCheckAssessFind(params) {
        return fetchPost(api_const["getMaterCheckAssessFindUrl"], params);
    },

    //妈妈入住评估单编辑
    updateMaterCheckAssessData: function updateMaterCheckAssessData(params) {
        return fetchPost(api_const["updateMaterCheckAssessDataUrl"], params);
    },

    //出院证明填写/编辑
    updateMaternalLeaveProveRecor: function updateMaternalLeaveProveRecor(params, files, fieldName) {
        return newFormfetchPostFile(api_const["updateMaternalLeaveProveRecordUrl"], params, files, fieldName);
    },

    //出院证明详情
    getMaternalLeaveProveRecord: function getMaternalLeaveProveRecord(params) {
        return fetchPost(api_const["MaternalLeaveProveRecordUrl"], params);
    },

    //医院就诊单编辑
    updateMaternalHospitalChecklistRecord: function updateMaternalHospitalChecklistRecord(params, files, fieldName) {
        return newFormfetchPostFile(api_const["updateMaternalHospitalChecklistRecordUrl"], params, files, fieldName);
    },

    //医院就诊单详情
    getMaternalHospitalChecklistRecord: function getMaternalHospitalChecklistRecord(params) {
        return fetchPost(api_const["MaternalHospitalChecklistRecordUrl"], params);
    },

    //宝宝足印编辑
    updateBabyFootRecord: function updateBabyFootRecord(params, filesIn, filesOut) {
        return fetchPostFileFootprint(api_const["updateBabyFootRecordUrl"], params, filesIn, filesOut);
    },

    //宝宝足印详情
    getBabyFootRecord: function getBabyFootRecord(params) {
        return fetchPost(api_const["getBabyFootRecordUrl"], params);
    },
    getSpecialReport: function getSpecialReport(params) {
        return fetchPost(api_const["getSpecialReport"], params);
    },
    getSpecialReportRoom: function getSpecialReportRoom(params) {
        return fetchPost(api_const["getSpecialReportRoom"], params);
    },
    getSpecialReportMeal: function getSpecialReportMeal(params) {
        return fetchPost(api_const["getSpecialReportMeal"], params);
    },

    //获取汇报人列表
    getAgentList: function getAgentList(params) {
        return fetchPost(api_const["getMaternalAgentList"], params);
    },
    getDepartmentList: function getDepartmentList(params) {
        return fetchPost(api_const["getDepartmentList"], params);
    },
    specialReportAdd: function specialReportAdd(params) {
        return fetchPost(api_const["specialReportAdd"], params);
    },
    specialReportAddRoom: function specialReportAddRoom(params) {
        return fetchPost(api_const["specialReportAddRoom"], params);
    },
    specialReportAddMeal: function specialReportAddMeal(params) {
        return fetchPost(api_const["specialReportAddMeal"], params);
    },
    getPositionList: function getPositionList(params) {
        return fetchPost(api_const["getPositionList"], params);
    }
});
// CONCATENATED MODULE: ./src/service/api/repository/chritmasForm-api.js


/* harmony default export */ var chritmasForm_api = ({
    //（产妇）健康咨询记录表添加
    addMatarnalHeathRecord: function addMatarnalHeathRecord(params) {
        return fetchPost(api_const["addMatarnalHeathRecordUrl"], params);
    },

    //（产妇）健康咨询记录表查询list数据
    matarnalHeathRecordList: function matarnalHeathRecordList(params) {
        return fetchPost(api_const["matarnalHeathRecordUrl"], params);
    },

    //（产妇）健康咨询记录表详情数据
    getMatarnalHeathRecord: function getMatarnalHeathRecord(params) {
        return fetchPost(api_const["getMatarnalHeathRecordUrl"], params);
    },

    //（产妇）健康咨询记录表更新
    updateMatarnalHeathRecord: function updateMatarnalHeathRecord(params) {
        return fetchPost(api_const["updateMatarnalHeathRecordUrl"], params);
    },


    //（新生儿）健康咨询记录表添加
    addBabyHeathRecord: function addBabyHeathRecord(params) {
        return fetchPost(api_const["addBabyHeathRecordUrl"], params);
    },

    //（新生儿）健康咨询记录表查询list数据
    BabyHeathRecord: function BabyHeathRecord(params) {
        return fetchPost(api_const["BabyHeathRecordUrl"], params);
    },

    //（新生儿）健康咨询记录表详情数据
    getBabyHeathRecord: function getBabyHeathRecord(params) {
        return fetchPost(api_const["getBabyHeathRecordUrl"], params);
    },

    //（新生儿）健康咨询记录表更新
    updateBabyHeathRecord: function updateBabyHeathRecord(params) {
        return fetchPost(api_const["updateBabyHeathRecordUrl"], params);
    },


    //产妇特殊护理记录添加
    addMatarnalSpecialNursingRecord: function addMatarnalSpecialNursingRecord(params) {
        return fetchPost(api_const["addMatarnalSpecialNursingRecordUrl"], params);
    },

    //产妇特殊护理记录list数据
    MatarnalSpecialNursingRecord: function MatarnalSpecialNursingRecord(params) {
        return fetchPost(api_const["MatarnalSpecialNursingRecordUrl"], params);
    },

    //产妇特殊护理记录详情数据
    getMatarnalSpecialNursingRecord: function getMatarnalSpecialNursingRecord(params) {
        return fetchPost(api_const["getMatarnalSpecialNursingRecordUrl"], params);
    },

    //产妇特殊护理记录更新
    updateMatarnalSpecialNursingRecord: function updateMatarnalSpecialNursingRecord(params) {
        return fetchPost(api_const["updateMatarnalSpecialNursingRecordUrl"], params);
    },


    //婴儿特殊护理记录添加
    addBabySpecialNursingRecord: function addBabySpecialNursingRecord(params) {
        return fetchPost(api_const["addBabySpecialNursingRecordUrl"], params);
    },

    //婴儿特殊护理记录list数据
    babySpecialNursingRecord: function babySpecialNursingRecord(params) {
        return fetchPost(api_const["babySpecialNursingRecordUrl"], params);
    },

    //婴儿特殊护理记录详情数据
    getBabySpecialNursingRecord: function getBabySpecialNursingRecord(params) {
        return fetchPost(api_const["getBabySpecialNursingRecordUrl"], params);
    },

    //婴儿特殊护理记录更新
    updateBabySpecialNursingRecord: function updateBabySpecialNursingRecord(params) {
        return fetchPost(api_const["updateBabySpecialNursingRecordUrl"], params);
    }
});
// CONCATENATED MODULE: ./src/service/api/repository/index.js









/* harmony default export */ var repository = ({
  loginApi: login_api,
  monthLiveApi: monthLive_api,
  memberListApi: memberList_api,
  checkRoomApi: checkRoom_api,
  babyLiveApi: babyLive_api,
  bbFormApi: bbForm_api,
  otherFormApi: otherForm_api,
  chritmasFormApi: chritmasForm_api
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 引入本地封装的 vConsole（只需引入即可完成初始化）
// import '@/libs/vconsole.js'

/* harmony default export */ var components_login = ({
  name: 'login',
  data: function data() {
    return {
      group: {
        acount: '', //13720180033
        password: '' //123123
      }
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('app', ['login']), {
    Login: function Login() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var params, res, data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.group.acount == '')) {
                  _context.next = 3;
                  break;
                }

                _this.$vux.toast.show({
                  type: 'cancel',
                  text: '请输入账号'
                });
                return _context.abrupt('return');

              case 3:
                if (!(_this.group.password == '')) {
                  _context.next = 6;
                  break;
                }

                _this.$vux.toast.show({
                  type: 'cancel',
                  text: '请输入密码'
                });
                return _context.abrupt('return');

              case 6:
                params = {
                  username: _this.group.acount,
                  password: _this.group.password,
                  token: ''
                };
                _context.prev = 7;
                _context.next = 10;
                return _this.login(params);

              case 10:
                res = _context.sent;

                console.info('login action result:', res);

                if (res && res.success) {
                  data = res.data || {};


                  _this.$vux.toast.show({
                    type: 'success',
                    text: '登录成功'
                  });

                  // 保持与原有逻辑兼容：继续写入 Cookie，方便旧代码读取
                  if (data.token) _this.$cookie.set('token', data.token);
                  if (data.id) _this.$cookie.set('id', data.id);
                  if (data.store_id) _this.$cookie.set('store_id', data.store_id);

                  setTimeout(function () {
                    _this.$router.push({ path: '/maternal_file' });
                  }, 1000);
                } else {
                  _this.$vux.toast.show({
                    type: 'cancel',
                    text: res && res.message || '登录失败'
                  });
                }
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](7);

                console.error('login error:', _context.t0);
                _this.$vux.toast.show({
                  type: 'cancel',
                  text: _context.t0.message || '网络错误，请重试'
                });

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[7, 15]]);
      }))();
    }
  }),
  created: function created() {
    console.info('欢迎登录');
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// 引入本地封装的 vConsole（只需引入即可完成初始化）
// import '@/libs/vconsole.js'

/* harmony default export */ var selectortype_script_index_0_src_components_login = ({
  name: 'login',
  data: function data() {
    return {
      group: {
        acount: '', //13720180033
        password: '' //123123
      }
    };
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('app', ['login']), {
    Login: function Login() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var params, res, data;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.group.acount == '')) {
                  _context.next = 3;
                  break;
                }

                _this.$vux.toast.show({
                  type: 'cancel',
                  text: '请输入账号'
                });
                return _context.abrupt('return');

              case 3:
                if (!(_this.group.password == '')) {
                  _context.next = 6;
                  break;
                }

                _this.$vux.toast.show({
                  type: 'cancel',
                  text: '请输入密码'
                });
                return _context.abrupt('return');

              case 6:
                params = {
                  username: _this.group.acount,
                  password: _this.group.password,
                  token: ''
                };
                _context.prev = 7;
                _context.next = 10;
                return _this.login(params);

              case 10:
                res = _context.sent;

                console.info('login action result:', res);

                if (res && res.success) {
                  data = res.data || {};


                  _this.$vux.toast.show({
                    type: 'success',
                    text: '登录成功'
                  });

                  // 保持与原有逻辑兼容：继续写入 Cookie，方便旧代码读取
                  if (data.token) _this.$cookie.set('token', data.token);
                  if (data.id) _this.$cookie.set('id', data.id);
                  if (data.store_id) _this.$cookie.set('store_id', data.store_id);

                  setTimeout(function () {
                    _this.$router.push({ path: '/maternal_file' });
                  }, 1000);
                } else {
                  _this.$vux.toast.show({
                    type: 'cancel',
                    text: res && res.message || '登录失败'
                  });
                }
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](7);

                console.error('login error:', _context.t0);
                _this.$vux.toast.show({
                  type: 'cancel',
                  text: _context.t0.message || '网络错误，请重试'
                });

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[7, 15]]);
      }))();
    }
  }),
  created: function created() {
    console.info('欢迎登录');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86cd7b24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{directives:[{name:"drag",rawName:"v-drag"}],staticClass:"login-con",staticStyle:{"position":"absolute"}},[_c('div',{staticClass:"formList"},[_c('group',{attrs:{"title":"欢迎登录","label-width":"4em"}},[_c('x-input',{staticClass:"f-14",attrs:{"title":"账号：","type":"tel","min":11,"max":11,"required":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.Login.apply(null, arguments)}},model:{value:(_vm.group.acount),callback:function ($$v) {_vm.$set(_vm.group, "acount", $$v)},expression:"group.acount"}}),_vm._v(" "),_c('x-input',{staticClass:"f-14",attrs:{"title":"密码：","type":"password","required":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.Login.apply(null, arguments)}},model:{value:(_vm.group.password),callback:function ($$v) {_vm.$set(_vm.group, "password", $$v)},expression:"group.password"}})],1),_vm._v(" "),_c('x-button',{staticClass:"logon-btn f-14",attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.Login.apply(null, arguments)}}},[_vm._v("\n        登录\n      ")])],1)])])}
var login_staticRenderFns = []
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_login = (login_esExports);
// CONCATENATED MODULE: ./src/components/login.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("Gp28")
  __webpack_require__("5aNE")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  selectortype_script_index_0_src_components_login,
  selectortype_template_index_0_src_components_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var src_components_login = (login_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var libs_base = __webpack_require__("f6Hi");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2282ea60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tip/index.vue
var tip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-group-tip",style:({'text-align':_vm.align})},[_vm._t("default")],2)}
var tip_staticRenderFns = []
var tip_esExports = { render: tip_render, staticRenderFns: tip_staticRenderFns }
/* harmony default export */ var src_components_tip = (tip_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tip/index.vue
function tip_injectStyle (ssrContext) {
  __webpack_require__("cu/V")
}
var tip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tip___vue_template_functional__ = false
/* styles */
var tip___vue_styles__ = tip_injectStyle
/* scopeId */
var tip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tip___vue_module_identifier__ = null
var tip_Component = tip_normalizeComponent(
  components_tip,
  src_components_tip,
  tip___vue_template_functional__,
  tip___vue_styles__,
  tip___vue_scopeId__,
  tip___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_tip = (tip_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed96448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("5VbK")
}
var icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (icon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d40071a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("uyKd")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("q5lo");

// EXTERNAL MODULE: ./node_modules/array-shuffle/index.js
var array_shuffle = __webpack_require__("HHx2");
var array_shuffle_default = /*#__PURE__*/__webpack_require__.n(array_shuffle);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [libs_base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [libs_base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = checklist_pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["d" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["d" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = checklist_pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["d" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function checklist_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a680c1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checklist/index.vue
var checklist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.disabled ? 'vux-checklist-disabled' : ''},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}],staticClass:"weui-cells__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("after-title"),_vm._v(" "),_c('div',{staticClass:"weui-cells weui-cells_checkbox"},_vm._l((_vm.currentOptions),function(one,index){return _c('label',{staticClass:"weui-cell weui-check_label",class:{
        'vux-checklist-label-left': _vm.labelPosition === 'left'
      },attrs:{"for":("checkbox_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__hd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"checkbox","name":("vux-checkbox-" + _vm.uuid),"id":_vm.disabled ? '' : ("checkbox_" + _vm.uuid + "_" + index),"disabled":_vm.isDisabled(_vm.getKey(one))},domProps:{"value":_vm.getKey(one),"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,_vm.getKey(one))>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.getKey(one),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),_c('i',{staticClass:"weui-icon-checked vux-checklist-icon-checked"})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getValue(one))}}),_vm._v(" "),(_vm.getInlineDesc(one))?_c('inline-desc',[_vm._v(_vm._s(_vm.getInlineDesc(one)))]):_vm._e()],1)])}),0),_vm._v(" "),_vm._t("footer")],2)}
var checklist_staticRenderFns = []
var checklist_esExports = { render: checklist_render, staticRenderFns: checklist_staticRenderFns }
/* harmony default export */ var src_components_checklist = (checklist_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checklist/index.vue
function checklist_injectStyle (ssrContext) {
  __webpack_require__("2MTM")
}
var checklist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checklist___vue_template_functional__ = false
/* styles */
var checklist___vue_styles__ = checklist_injectStyle
/* scopeId */
var checklist___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checklist___vue_module_identifier__ = null
var checklist_Component = checklist_normalizeComponent(
  components_checklist,
  src_components_checklist,
  checklist___vue_template_functional__,
  checklist___vue_styles__,
  checklist___vue_scopeId__,
  checklist___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_checklist = (checklist_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/range/powerange.js + 10 modules
var powerange = __webpack_require__("oCMX");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/range/index.vue
//
//
//
//
//
//



/* harmony default export */ var range = ({
  name: 'range',
  props: {
    decimal: Boolean,
    value: {
      default: 0,
      type: Number
    },
    min: {
      type: Number,
      default: 0
    },
    minHTML: String,
    maxHTML: String,
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    disabled: Boolean,
    disabledOpacity: Number,
    rangeBarHeight: {
      type: Number,
      default: 1
    },
    rangeHandleHeight: {
      type: Number,
      default: 30
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  mounted: function mounted() {
    var _this2 = this;

    var _this = this;
    this.$nextTick(function () {
      var options = {
        callback: function callback(value) {
          _this.currentValue = value;
        },
        decimal: _this2.decimal,
        start: _this2.currentValue,
        min: _this2.min,
        max: _this2.max,
        minHTML: _this2.minHTML,
        maxHTML: _this2.maxHTML,
        disable: _this2.disabled,
        disabledOpacity: _this2.disabledOpacity,
        initialBarWidth: window.getComputedStyle(_this2.$el.parentNode).width.replace('px', '') - 80,
        onTouchstart: function onTouchstart(e) {
          _this.$emit('on-touchstart', e);
        },
        onTouchend: function onTouchend(e) {
          _this.$emit('on-touchend', e);
        }
      };
      if (_this2.step !== 0) {
        options.step = _this2.step;
      }
      _this2.range = new powerange["a" /* default */](_this2.$el.querySelector('.vux-range-input'), options);
      var handleTop = (_this2.rangeHandleHeight - _this2.rangeBarHeight) / 2;
      _this2.$el.querySelector('.range-handle').style.top = '-' + handleTop + 'px';
      _this2.$el.querySelector('.range-bar').style.height = _this2.rangeBarHeight + 'px';
      _this2.handleOrientationchange = function () {
        _this2.update();
      };
      window.addEventListener('orientationchange', _this2.handleOrientationchange, false);
    });
  },

  methods: {
    update: function update() {
      console.log('update', this.currentValue);
      var value = this.currentValue;
      if (value < this.min) {
        value = this.min;
      }
      if (value > this.max) {
        value = this.max;
      }
      this.range.reInit({
        min: this.min,
        max: this.max,
        step: this.step,
        value: value
      });
      this.currentValue = value;
      this.range.setStart(this.currentValue);
      this.range.setStep();
    }
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      this.range && this.range.setStart(val);
      this.$emit('input', val);
      this.$emit('on-change', val);
    },
    value: function value(val) {
      this.currentValue = val;
    },
    min: function min() {
      this.update();
    },
    step: function step() {
      this.update();
    },
    max: function max() {
      this.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/range/index.vue
//
//
//
//
//
//



/* harmony default export */ var components_range = ({
  name: 'range',
  props: {
    decimal: Boolean,
    value: {
      default: 0,
      type: Number
    },
    min: {
      type: Number,
      default: 0
    },
    minHTML: String,
    maxHTML: String,
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    disabled: Boolean,
    disabledOpacity: Number,
    rangeBarHeight: {
      type: Number,
      default: 1
    },
    rangeHandleHeight: {
      type: Number,
      default: 30
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  mounted: function mounted() {
    var _this2 = this;

    var _this = this;
    this.$nextTick(function () {
      var options = {
        callback: function callback(value) {
          _this.currentValue = value;
        },
        decimal: _this2.decimal,
        start: _this2.currentValue,
        min: _this2.min,
        max: _this2.max,
        minHTML: _this2.minHTML,
        maxHTML: _this2.maxHTML,
        disable: _this2.disabled,
        disabledOpacity: _this2.disabledOpacity,
        initialBarWidth: window.getComputedStyle(_this2.$el.parentNode).width.replace('px', '') - 80,
        onTouchstart: function onTouchstart(e) {
          _this.$emit('on-touchstart', e);
        },
        onTouchend: function onTouchend(e) {
          _this.$emit('on-touchend', e);
        }
      };
      if (_this2.step !== 0) {
        options.step = _this2.step;
      }
      _this2.range = new powerange["a" /* default */](_this2.$el.querySelector('.vux-range-input'), options);
      var handleTop = (_this2.rangeHandleHeight - _this2.rangeBarHeight) / 2;
      _this2.$el.querySelector('.range-handle').style.top = '-' + handleTop + 'px';
      _this2.$el.querySelector('.range-bar').style.height = _this2.rangeBarHeight + 'px';
      _this2.handleOrientationchange = function () {
        _this2.update();
      };
      window.addEventListener('orientationchange', _this2.handleOrientationchange, false);
    });
  },

  methods: {
    update: function update() {
      console.log('update', this.currentValue);
      var value = this.currentValue;
      if (value < this.min) {
        value = this.min;
      }
      if (value > this.max) {
        value = this.max;
      }
      this.range.reInit({
        min: this.min,
        max: this.max,
        step: this.step,
        value: value
      });
      this.currentValue = value;
      this.range.setStart(this.currentValue);
      this.range.setStep();
    }
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      this.range && this.range.setStart(val);
      this.$emit('input', val);
      this.$emit('on-change', val);
    },
    value: function value(val) {
      this.currentValue = val;
    },
    min: function min() {
      this.update();
    },
    step: function step() {
      this.update();
    },
    max: function max() {
      this.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78bcb783","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/range/index.vue
var range_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-range-input-box",staticStyle:{"position":"relative","margin-right":"30px","margin-left":"50px"}},[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentValue),expression:"currentValue",modifiers:{"number":true}}],staticClass:"vux-range-input",domProps:{"value":(_vm.currentValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentValue=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])}
var range_staticRenderFns = []
var range_esExports = { render: range_render, staticRenderFns: range_staticRenderFns }
/* harmony default export */ var src_components_range = (range_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/range/index.vue
function range_injectStyle (ssrContext) {
  __webpack_require__("P3La")
}
var range_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var range___vue_template_functional__ = false
/* styles */
var range___vue_styles__ = range_injectStyle
/* scopeId */
var range___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var range___vue_module_identifier__ = null
var range_Component = range_normalizeComponent(
  components_range,
  src_components_range,
  range___vue_template_functional__,
  range___vue_styles__,
  range___vue_scopeId__,
  range___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_range = (range_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/rater/index.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var rater = ({
  name: 'rater',
  created: function created() {
    this.currentValue = parseFloat(this.value);
  },
  mounted: function mounted() {
    this.updateStyle();
  },

  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 5
    },
    value: {
      type: [Number, String],
      default: 0
    },
    disabled: Boolean,
    star: {
      type: String,
      default: '★'
    },
    activeColor: {
      type: String,
      default: '#fc6'
    },
    margin: {
      type: Number,
      default: 2
    },
    fontSize: {
      type: Number,
      default: 25
    }
  },
  computed: {
    sliceValue: function sliceValue() {
      var _val = this.currentValue.toFixed(2).split('.');
      return _val.length === 1 ? [_val[0], 0] : _val;
    },
    cutIndex: function cutIndex() {
      return this.sliceValue[0] * 1;
    },
    cutPercent: function cutPercent() {
      return this.sliceValue[1] * 1;
    }
  },
  methods: {
    handleClick: function handleClick(i, force) {
      if (!this.disabled || force) {
        if (this.currentValue === i + 1) {
          this.currentValue = i < this.min ? this.min : i;
          this.updateStyle();
        } else {
          this.currentValue = i + 1 < this.min ? this.min : i + 1;
        }
      }
    },
    updateStyle: function updateStyle() {
      for (var j = 0; j < this.max; j++) {
        if (j <= this.currentValue - 1) {
          this.$set(this.colors, j, this.activeColor);
        } else {
          this.$set(this.colors, j, '#ccc');
        }
      }
    }
  },
  data: function data() {
    return {
      colors: [],
      currentValue: 0
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      this.updateStyle();
      this.$emit('input', val);
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/rater/index.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_rater = ({
  name: 'rater',
  created: function created() {
    this.currentValue = parseFloat(this.value);
  },
  mounted: function mounted() {
    this.updateStyle();
  },

  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 5
    },
    value: {
      type: [Number, String],
      default: 0
    },
    disabled: Boolean,
    star: {
      type: String,
      default: '★'
    },
    activeColor: {
      type: String,
      default: '#fc6'
    },
    margin: {
      type: Number,
      default: 2
    },
    fontSize: {
      type: Number,
      default: 25
    }
  },
  computed: {
    sliceValue: function sliceValue() {
      var _val = this.currentValue.toFixed(2).split('.');
      return _val.length === 1 ? [_val[0], 0] : _val;
    },
    cutIndex: function cutIndex() {
      return this.sliceValue[0] * 1;
    },
    cutPercent: function cutPercent() {
      return this.sliceValue[1] * 1;
    }
  },
  methods: {
    handleClick: function handleClick(i, force) {
      if (!this.disabled || force) {
        if (this.currentValue === i + 1) {
          this.currentValue = i < this.min ? this.min : i;
          this.updateStyle();
        } else {
          this.currentValue = i + 1 < this.min ? this.min : i + 1;
        }
      }
    },
    updateStyle: function updateStyle() {
      for (var j = 0; j < this.max; j++) {
        if (j <= this.currentValue - 1) {
          this.$set(this.colors, j, this.activeColor);
        } else {
          this.$set(this.colors, j, '#ccc');
        }
      }
    }
  },
  data: function data() {
    return {
      colors: [],
      currentValue: 0
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      this.updateStyle();
      this.$emit('input', val);
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67454fc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/rater/index.vue
var rater_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-rater"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticStyle:{"display":"none"},domProps:{"value":(_vm.currentValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_vm._l((_vm.max),function(i){return _c('a',{staticClass:"vux-rater-box",class:{'is-active':_vm.currentValue > i-1},style:({color: _vm.colors && _vm.colors[i-1] ? _vm.colors[i-1] : '#ccc',marginRight:_vm.margin+'px',fontSize: _vm.fontSize + 'px', width: _vm.fontSize + 'px', height: _vm.fontSize + 'px', lineHeight: _vm.fontSize + 'px'}),on:{"click":function($event){return _vm.handleClick(i-1)}}},[_c('span',{staticClass:"vux-rater-inner"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.star)}}),(_vm.cutPercent > 0 && _vm.cutIndex === i-1)?_c('span',{staticClass:"vux-rater-outer",style:({color: _vm.activeColor, width: _vm.cutPercent + '%'}),domProps:{"innerHTML":_vm._s(_vm.star)}}):_vm._e()])])})],2)}
var rater_staticRenderFns = []
var rater_esExports = { render: rater_render, staticRenderFns: rater_staticRenderFns }
/* harmony default export */ var src_components_rater = (rater_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/rater/index.vue
function rater_injectStyle (ssrContext) {
  __webpack_require__("pjcA")
}
var rater_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var rater___vue_template_functional__ = false
/* styles */
var rater___vue_styles__ = rater_injectStyle
/* scopeId */
var rater___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var rater___vue_module_identifier__ = null
var rater_Component = rater_normalizeComponent(
  components_rater,
  src_components_rater,
  rater___vue_template_functional__,
  rater___vue_styles__,
  rater___vue_scopeId__,
  rater___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_rater = (rater_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/name2value.js
var name2value = __webpack_require__("dH7R");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js + 2 modules
var scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa2c7d66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}),1)],1)}
var picker_staticRenderFns = []
var picker_esExports = { render: picker_render, staticRenderFns: picker_staticRenderFns }
/* harmony default export */ var src_components_picker = (picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function picker_injectStyle (ssrContext) {
  __webpack_require__("Q7uw")
}
var picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var picker___vue_template_functional__ = false
/* styles */
var picker___vue_styles__ = picker_injectStyle
/* scopeId */
var picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var picker___vue_module_identifier__ = null
var picker_Component = picker_normalizeComponent(
  components_picker,
  src_components_picker,
  picker___vue_template_functional__,
  picker___vue_styles__,
  picker___vue_scopeId__,
  picker___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-921916da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",function(){return [_vm._v(_vm._s(_vm.inlineDesc))]})],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]}),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("uwyH")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696d4120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("gsj7")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27223f69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var popup_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){return _vm.$emit('on-click-left')}}},[_vm._t("left-text",function(){return [_vm._v(_vm._s(_vm.leftText))]})],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){return _vm.$emit('on-click-right')}}},[_vm._t("right-text",function(){return [_vm._v(_vm._s(_vm.rightText))]})],2)])}
var popup_header_staticRenderFns = []
var popup_header_esExports = { render: popup_header_render, staticRenderFns: popup_header_staticRenderFns }
/* harmony default export */ var src_components_popup_header = (popup_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function popup_header_injectStyle (ssrContext) {
  __webpack_require__("XZOv")
}
var popup_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_header___vue_template_functional__ = false
/* styles */
var popup_header___vue_styles__ = popup_header_injectStyle
/* scopeId */
var popup_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_header___vue_module_identifier__ = null
var popup_header_Component = popup_header_normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  popup_header___vue_template_functional__,
  popup_header___vue_styles__,
  popup_header___vue_scopeId__,
  popup_header___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = (popup_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/array2String.js
var array2String = __webpack_require__("LsKW");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = popup_picker_getObject(val);
        this.currentValue = popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', popup_picker_getObject(val));
      this.$emit('on-change', popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var components_popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var components_popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = components_popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = components_popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = components_popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = components_popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = components_popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = components_popup_picker_getObject(val);
        this.currentValue = components_popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', components_popup_picker_getObject(val));
      this.$emit('on-change', components_popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: components_popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413ccea6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-picker/index.vue
var popup_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()]},{"labelClass":"weui-label","labelStyle":_vm.labelStyles,"labelTitle":_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){return _vm.onHide(false)},"on-click-right":function($event){return _vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var popup_picker_staticRenderFns = []
var popup_picker_esExports = { render: popup_picker_render, staticRenderFns: popup_picker_staticRenderFns }
/* harmony default export */ var src_components_popup_picker = (popup_picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-picker/index.vue
function popup_picker_injectStyle (ssrContext) {
  __webpack_require__("5jbP")
}
var popup_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_picker___vue_template_functional__ = false
/* styles */
var popup_picker___vue_styles__ = popup_picker_injectStyle
/* scopeId */
var popup_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_picker___vue_module_identifier__ = null
var popup_picker_Component = popup_picker_normalizeComponent(
  components_popup_picker,
  src_components_popup_picker,
  popup_picker___vue_template_functional__,
  popup_picker___vue_styles__,
  popup_picker___vue_scopeId__,
  popup_picker___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_popup_picker = (popup_picker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-address/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var x_address = ({
  name: 'x-address',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Number,
      default: function _default() {
        return 3;
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    popupTitle: String,
    show: Boolean,
    disabled: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = Object(name2value["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('[VUX] Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = Object(name2value["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-address/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_x_address = ({
  name: 'x-address',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Number,
      default: function _default() {
        return 3;
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    popupTitle: String,
    show: Boolean,
    disabled: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = Object(name2value["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('[VUX] Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = Object(name2value["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e0cd6bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-address/index.vue
var x_address_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-picker',{attrs:{"fixed-columns":_vm.hideDistrict ? 2 : 0,"columns":_vm.columns,"data":_vm.list,"title":_vm.title,"show-name":"","inline-desc":_vm.inlineDesc,"placeholder":_vm.placeholder,"value-text-align":_vm.valueTextAlign,"confirm-text":_vm.confirmText,"cancel-text":_vm.cancelText,"display-format":_vm.displayFormat,"popup-style":_vm.popupStyle,"popup-title":_vm.popupTitle,"show":_vm.showValue,"disabled":_vm.disabled},on:{"update:show":function($event){_vm.showValue=$event},"on-shadow-change":_vm.onShadowChange,"on-hide":_vm.emitHide,"on-show":function($event){return _vm.$emit('on-show')}},scopedSlots:_vm._u([{key:"title",fn:function(props){return [_vm._t("title",function(){return [(props.labelTitle)?_c('label',{class:[props.labelClass,_vm.labelClass],style:(props.labelStyle),domProps:{"innerHTML":_vm._s(props.labelTitle)}}):_vm._e()]},{"labelClass":props.labelClass,"labelStyle":props.labelStyles,"labelTitle":props.title})]}}],null,true),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})}
var x_address_staticRenderFns = []
var x_address_esExports = { render: x_address_render, staticRenderFns: x_address_staticRenderFns }
/* harmony default export */ var src_components_x_address = (x_address_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-address/index.vue
var x_address_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_address___vue_template_functional__ = false
/* styles */
var x_address___vue_styles__ = null
/* scopeId */
var x_address___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_address___vue_module_identifier__ = null
var x_address_Component = x_address_normalizeComponent(
  components_x_address,
  src_components_x_address,
  x_address___vue_template_functional__,
  x_address___vue_styles__,
  x_address___vue_scopeId__,
  x_address___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_address = (x_address_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/datas/china_address_v4.json
var china_address_v4 = __webpack_require__("FHgB");
var china_address_v4_default = /*#__PURE__*/__webpack_require__.n(china_address_v4);

// EXTERNAL MODULE: ./node_modules/vux/node_modules/big.js/big.js
var big = __webpack_require__("GL6u");
var big_default = /*#__PURE__*/__webpack_require__.n(big);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17ee4921","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-number/index.vue
var x_number_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell"},[_c('div',[_c('p',{class:_vm.labelClass,style:({width: _vm.$parent.labelWidth, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readonly),expression:"!readonly"}],staticClass:"weui-cell__ft vux-cell-primary",class:{'vux-number-round': _vm.buttonStyle === 'round'},staticStyle:{"font-size":"0"}},[_c('div',{style:({float:_vm.align})},[_c('a',{staticClass:"vux-number-selector vux-number-selector-sub",class:{'vux-number-disabled':_vm.disabledMin},on:{"click":_vm.sub}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}},[_c('defs'),_c('path',{attrs:{"d":"M863.74455 544.00086 163.424056 544.00086c-17.664722 0-32.00086-14.336138-32.00086-32.00086s14.336138-32.00086 32.00086-32.00086l700.320495 0c17.695686 0 31.99914 14.336138 31.99914 32.00086S881.440237 544.00086 863.74455 544.00086z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentValue),expression:"currentValue",modifiers:{"number":true}}],staticClass:"vux-number-input",style:({width: _vm.width}),attrs:{"name":_vm.name,"readonly":!_vm.fillable,"pattern":"[0-9]*","type":"number"},domProps:{"value":(_vm.currentValue)},on:{"blur":[_vm.blur,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.currentValue=_vm._n($event.target.value)}}}),_vm._v(" "),_c('a',{staticClass:"vux-number-selector vux-number-selector-plus",class:{'vux-number-disabled':_vm.disabledMax},on:{"click":_vm.add}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20"}},[_c('defs'),_c('path',{attrs:{"d":"M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readonly),expression:"readonly"}],staticClass:"weui-cell__ft vux-cell-primary"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var x_number_staticRenderFns = []
var x_number_esExports = { render: x_number_render, staticRenderFns: x_number_staticRenderFns }
/* harmony default export */ var src_components_x_number = (x_number_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-number/index.vue
function x_number_injectStyle (ssrContext) {
  __webpack_require__("YqUT")
}
var x_number_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_number___vue_template_functional__ = false
/* styles */
var x_number___vue_styles__ = x_number_injectStyle
/* scopeId */
var x_number___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_number___vue_module_identifier__ = null
var x_number_Component = x_number_normalizeComponent(
  components_x_number,
  src_components_x_number,
  x_number___vue_template_functional__,
  x_number___vue_styles__,
  x_number___vue_scopeId__,
  x_number___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_number = (x_number_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7829af00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-switch/index.vue
var x_switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-switch weui-cell weui-cell_switch"},[_c('div',{staticClass:"weui-cell__bd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyle),domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-switch",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),(_vm.preventDefault)?_c('div',{staticClass:"vux-x-switch-overlay",on:{"click":_vm.onClick}}):_vm._e()])])}
var x_switch_staticRenderFns = []
var x_switch_esExports = { render: x_switch_render, staticRenderFns: x_switch_staticRenderFns }
/* harmony default export */ var src_components_x_switch = (x_switch_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-switch/index.vue
function x_switch_injectStyle (ssrContext) {
  __webpack_require__("WZDK")
}
var x_switch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_switch___vue_template_functional__ = false
/* styles */
var x_switch___vue_styles__ = x_switch_injectStyle
/* scopeId */
var x_switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_switch___vue_module_identifier__ = null
var x_switch_Component = x_switch_normalizeComponent(
  components_x_switch,
  src_components_x_switch,
  x_switch___vue_template_functional__,
  x_switch___vue_styles__,
  x_switch___vue_scopeId__,
  x_switch___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_switch = (x_switch_Component.exports);

// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("JnrT");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var x_textarea = ({
  name: 'x-textarea',
  minxins: [libs_base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        if (newVal.length > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = this.currentValue ? this.currentValue.length : 0;
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var components_x_textarea = ({
  name: 'x-textarea',
  minxins: [libs_base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        if (newVal.length > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = this.currentValue ? this.currentValue.length : 0;
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7667bbe5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-textarea/index.vue
var x_textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-x-textarea"},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'), textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",staticClass:"weui-textarea",style:(_vm.textareaStyle),attrs:{"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.max},domProps:{"value":(_vm.currentValue)},on:{"focus":function($event){return _vm.$emit('on-focus')},"blur":function($event){return _vm.$emit('on-blur')},"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCounter && _vm.max),expression:"showCounter && max"}],staticClass:"weui-textarea-counter",on:{"click":_vm.focus}},[_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("/"+_vm._s(_vm.max)+"\n    ")])])])}
var x_textarea_staticRenderFns = []
var x_textarea_esExports = { render: x_textarea_render, staticRenderFns: x_textarea_staticRenderFns }
/* harmony default export */ var src_components_x_textarea = (x_textarea_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-textarea/index.vue
function x_textarea_injectStyle (ssrContext) {
  __webpack_require__("Mxix")
}
var x_textarea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_textarea___vue_template_functional__ = false
/* styles */
var x_textarea___vue_styles__ = x_textarea_injectStyle
/* scopeId */
var x_textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_textarea___vue_module_identifier__ = null
var x_textarea_Component = x_textarea_normalizeComponent(
  components_x_textarea,
  src_components_x_textarea,
  x_textarea___vue_template_functional__,
  x_textarea___vue_styles__,
  x_textarea___vue_scopeId__,
  x_textarea___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_textarea = (x_textarea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283ca23f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("QlJb")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var grid_grid = ({
  name: 'grid',
  methods: {
    countColumn: function countColumn() {
      this.childrenSize = this.$children.length;
      this.$children.forEach(function (c, index) {
        return c.index = index;
      });
    }
  },
  props: {
    rows: {
      type: Number,
      validator: function validator() {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] Grid rows 属性已经废弃，使用 cols 代替。单行列数为自动计算');
        }
        return true;
      }
    },
    cols: {
      type: Number
    },
    showLrBorders: {
      type: Boolean,
      default: true
    },
    showVerticalDividers: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    column: function column() {
      return this.cols || this.childrenSize;
    }
  },
  data: function data() {
    return {
      childrenSize: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06a8526d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid.vue
var grid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-grids",class:{
    'vux-grid-no-lr-borders': !_vm.showLrBorders
  }},[_vm._t("default")],2)}
var grid_staticRenderFns = []
var grid_esExports = { render: grid_render, staticRenderFns: grid_staticRenderFns }
/* harmony default export */ var components_grid_grid = (grid_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid.vue
function grid_injectStyle (ssrContext) {
  __webpack_require__("JvV8")
}
var grid_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid___vue_template_functional__ = false
/* styles */
var grid___vue_styles__ = grid_injectStyle
/* scopeId */
var grid___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid___vue_module_identifier__ = null
var grid_Component = grid_normalizeComponent(
  grid_grid,
  components_grid_grid,
  grid___vue_template_functional__,
  grid___vue_styles__,
  grid___vue_scopeId__,
  grid___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid = (grid_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["b" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/grid/grid-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var grid_grid_item = ({
  name: 'grid-item',
  props: ['icon', 'label', 'link', 'disabled'],
  created: function created() {
    this.$parent.countColumn();
  },
  mounted: function mounted() {
    this.$slots.icon && (this.hasIconSlot = true);
    this.$slots.label && (this.hasLabelSlot = true);
  },
  destroyed: function destroyed() {
    this.$parent.countColumn();
  },

  computed: {
    isLast: function isLast() {
      return !((this.index + 1) % this.$parent.column);
    },
    style: function style() {
      var column = this.$parent.column;
      if (!column || column === 3) {
        return;
      }
      var styles = {};
      styles.width = 100 / column + '%';
      return styles;
    }
  },
  methods: {
    onClick: function onClick() {
      if (!this.disabled && !this.$parent.disabled) {
        this.$emit('on-item-click');
        Object(router["b" /* go */])(this.link, this.$router);
      }
    }
  },
  data: function data() {
    return {
      index: 0,
      hasIconSlot: false,
      hasLabelSlot: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-681f818f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/grid/grid-item.vue
var grid_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"weui-grid",class:{
    'vux-grid-item-no-border': (_vm.isLast && !_vm.$parent.showLrBorders) || (!_vm.isLast && !_vm.$parent.showVerticalDividers),
  },style:(_vm.style),attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[(_vm.hasIconSlot || _vm.icon)?_c('div',{staticClass:"weui-grid__icon"},[_vm._t("icon",function(){return [_c('img',{attrs:{"src":_vm.icon,"alt":""}})]})],2):_vm._e(),_vm._v(" "),(_vm.hasLabelSlot || _vm.label)?_c('p',{staticClass:"weui-grid__label"},[_vm._t("label",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})]})],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var grid_item_staticRenderFns = []
var grid_item_esExports = { render: grid_item_render, staticRenderFns: grid_item_staticRenderFns }
/* harmony default export */ var components_grid_grid_item = (grid_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/grid/grid-item.vue
function grid_item_injectStyle (ssrContext) {
  __webpack_require__("Ckmr")
}
var grid_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var grid_item___vue_template_functional__ = false
/* styles */
var grid_item___vue_styles__ = grid_item_injectStyle
/* scopeId */
var grid_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var grid_item___vue_module_identifier__ = null
var grid_item_Component = grid_item_normalizeComponent(
  grid_grid_item,
  components_grid_grid_item,
  grid_item___vue_template_functional__,
  grid_item___vue_styles__,
  grid_item___vue_scopeId__,
  grid_item___vue_module_identifier__
)

/* harmony default export */ var src_components_grid_grid_item = (grid_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe.js
var photoswipe = __webpack_require__("i7N3");
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/x-photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__("72M0");
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
        _this.photoswipe = null;
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      if (this.photoswipe) {
        return this.photoswipe.getCurrentIndex();
      }
    },
    close: function close() {
      this.photoswipe && this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe && this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe && this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe && this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/previewer/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_previewer = ({
  name: 'previewer',
  computed: {
    imgs: function imgs() {
      return this.list.map(function (one) {
        if (!one.msrc) {
          one.msrc = one.src;
        }
        if (typeof one.w === 'undefined') {
          one.w = 0;
          one.h = 0;
        }
        return one;
      });
    }
  },
  watch: {
    imgs: function imgs(newVal, oldVal) {
      if (!this.photoswipe) {
        return;
      }
      if (newVal.length && newVal.length - oldVal.length === -1) {
        var index = this.photoswipe.getCurrentIndex();
        this.photoswipe.invalidateCurrItems();
        this.photoswipe.items.splice(index, 1);
        var goToIndex = index;
        if (goToIndex > this.photoswipe.items.length - 1) {
          goToIndex = 0;
        }
        this.photoswipe.goTo(goToIndex);
        this.photoswipe.updateSize(true);
        this.photoswipe.ui.update();
      } else if (!newVal.length) {
        this.close();
      }
    }
  },
  methods: {
    init: function init(index) {
      var self = this;
      var showItem = this.imgs[index];
      if (!showItem.w || !showItem.h || showItem.w < 5 || showItem.h < 5) {
        var img = new Image();
        img.onload = function () {
          showItem.w = this.width;
          showItem.h = this.height;
          self.doInit(index);
        };
        img.src = showItem.src;
      } else {
        this.doInit(index);
      }
    },
    doInit: function doInit(index) {
      var _this = this;

      var self = this;
      var options = object_assign_default()({
        history: false,
        shareEl: false,
        tapToClose: true,
        index: index
      }, this.options);
      this.photoswipe = new photoswipe_default.a(this.$el, photoswipe_ui_default_default.a, this.imgs, options);

      this.photoswipe.listen('gettingData', function (index, item) {
        if (!item.w || !item.h || item.w < 1 || item.h < 1) {
          var img = new Image();
          img.onload = function () {
            item.w = this.width;
            item.h = this.height;
            self.photoswipe.updateSize(true);
          };
          img.src = item.src;
        }
      });

      this.photoswipe.init();
      this.photoswipe.listen('close', function () {
        _this.$emit('on-close');
        _this.photoswipe = null;
      });
      this.photoswipe.listen('afterChange', function (a, b) {
        _this.$emit('on-index-change', {
          currentIndex: _this.photoswipe.getCurrentIndex()
        });
      });
    },
    show: function show(index) {
      this.init(index);
    },
    getCurrentIndex: function getCurrentIndex() {
      if (this.photoswipe) {
        return this.photoswipe.getCurrentIndex();
      }
    },
    close: function close() {
      this.photoswipe && this.photoswipe.close();
    },
    goTo: function goTo(index) {
      this.photoswipe && this.photoswipe.goTo(index);
    },
    prev: function prev() {
      this.photoswipe && this.photoswipe.prev();
    },
    next: function next() {
      this.photoswipe && this.photoswipe.next();
    }
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df9eff9a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/previewer/index.vue
var previewer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp vux-previewer",attrs:{"tabindex":"-1","role":"dialog","aria-hidden":"true"}},[_c('div',{staticClass:"pswp__bg"}),_vm._v(" "),_c('div',{staticClass:"pswp__scroll-wrap"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pswp__ui pswp__ui--hidden"},[_c('div',{staticClass:"pswp__top-bar"},[_c('div',{staticClass:"pswp__counter"}),_vm._v(" "),_vm._t("button-after"),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--close",attrs:{"title":"Close (Esc)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--share",attrs:{"title":"Share"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--fs",attrs:{"title":"Toggle fullscreen"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--zoom",attrs:{"title":"Zoom in/out"}}),_vm._v(" "),_vm._t("button-before"),_vm._v(" "),_vm._m(1)],2),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--left",attrs:{"title":"Previous (arrow left)"}}),_vm._v(" "),_c('button',{staticClass:"pswp__button pswp__button--arrow--right",attrs:{"title":"Next (arrow right)"}}),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_vm._t("wrap-after")],2)}
var previewer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__container"},[_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"}),_vm._v(" "),_c('div',{staticClass:"pswp__item"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__preloader"},[_c('div',{staticClass:"pswp__preloader__icn"},[_c('div',{staticClass:"pswp__preloader__cut"},[_c('div',{staticClass:"pswp__preloader__donut"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__share-modal pswp__share-modal--hidden pswp__single-tap"},[_c('div',{staticClass:"pswp__share-tooltip"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pswp__caption"},[_c('div',{staticClass:"pswp__caption__center"})])}]
var previewer_esExports = { render: previewer_render, staticRenderFns: previewer_staticRenderFns }
/* harmony default export */ var src_components_previewer = (previewer_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/previewer/index.vue
function previewer_injectStyle (ssrContext) {
  __webpack_require__("xhby")
  __webpack_require__("z/9y")
}
var previewer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var previewer___vue_template_functional__ = false
/* styles */
var previewer___vue_styles__ = previewer_injectStyle
/* scopeId */
var previewer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var previewer___vue_module_identifier__ = null
var previewer_Component = previewer_normalizeComponent(
  components_previewer,
  src_components_previewer,
  previewer___vue_template_functional__,
  previewer___vue_styles__,
  previewer___vue_scopeId__,
  previewer___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_previewer = (previewer_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-upload-component/dist/vue-upload-component.js
var vue_upload_component = __webpack_require__("1Wvq");
var vue_upload_component_default = /*#__PURE__*/__webpack_require__.n(vue_upload_component);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/form.vue
















/* harmony default export */ var design_form = ({
  name: 'month_form',
  components: {
    Checklist: vux_src_components_checklist,
    Range: vux_src_components_range,
    Rater: vux_src_components_rater,
    XAddress: vux_src_components_x_address,
    XNumber: vux_src_components_x_number,
    XSwitch: vux_src_components_x_switch,
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    Previewer: vux_src_components_previewer,
    FileUpload: vue_upload_component_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      a: 1,
      files: [],
      imgUploadItem: [], //TODO:和预览view数据一致，会被修改属性，会报错不影响，待优化处理
      id: this.$route.query.id,
      commonList: ['China', 'Japan', 'America'],
      checklist002: ['China', 'Japan'],

      list1: [['小米', 'iPhone', '华为', '情怀', '三星', '其他', '不告诉你']],
      value1: ['iPhone'],

      date: '',
      data1: 0,
      data3: 5,

      addressValue: [],
      addressData: china_address_v4_default.a,

      numberValue: 12,
      switchValue: '1',

      showSignature: true,
      showCSignature: true,
      option: {
        penColor: 'rgb(0, 0, 0)'
      },
      selectText: '',
      selectTextItem: 'submit',
      signDialog: false
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    },
    editName: function editName() {
      this.showSignature = false;
    },
    edit: function edit() {},
    selectTextHandle: function selectTextHandle() {

      this.selectText = this.selectText + this.selectTextItem;
    },

    inputFile: function inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {

        console.log('response', newFile.response);
        if (newFile.xhr) {

          console.log('status', newFile.xhr.status);
        }
      }
    },
    inputFilter: function inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {

        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      newFile.blob = '';
      var URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);

        this.imgUploadItem.push({
          src: newFile.blob,
          index: this.imgUploadItem.length + 1
        });
      }
    },

    previewImage: function previewImage(index) {
      this.$refs.previewer.show(index);
    },
    deleteImgHandle: function deleteImgHandle(item) {
      this.imgUploadItem = this.imgUploadItem.filter(function (tmp) {
        return tmp.index != item.index;
      });
    },
    signImageClear: function signImageClear() {
      var sigRef = this.$refs['signature'];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.into_intermediate_nurse_sign = '';
    },
    fullScreenSign: function fullScreenSign() {
      this.signDialog = true;
    },
    clearCName: function clearCName() {
      var signature = 'signature';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {

        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.into_intermediate_nurse_sign = '';
    },
    saveCName: function saveCName() {
      var signature = 'signature';
      var sigRef = this.$refs[signature];

      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      var png = comp && comp.save ? comp.save() : '';
      var bold = Util.dataURItoBlob(png);
      this.signDialog = false;
    }
  },
  created: function created() {
    if (this.$route.query.a) {
      this.a = this.$route.query.a;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/form.vue
















/* harmony default export */ var components_design_form = ({
  name: 'month_form',
  components: {
    Checklist: vux_src_components_checklist,
    Range: vux_src_components_range,
    Rater: vux_src_components_rater,
    XAddress: vux_src_components_x_address,
    XNumber: vux_src_components_x_number,
    XSwitch: vux_src_components_x_switch,
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    Previewer: vux_src_components_previewer,
    FileUpload: vue_upload_component_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      a: 1,
      files: [],
      imgUploadItem: [], //TODO:和预览view数据一致，会被修改属性，会报错不影响，待优化处理
      id: this.$route.query.id,
      commonList: ['China', 'Japan', 'America'],
      checklist002: ['China', 'Japan'],

      list1: [['小米', 'iPhone', '华为', '情怀', '三星', '其他', '不告诉你']],
      value1: ['iPhone'],

      date: '',
      data1: 0,
      data3: 5,

      addressValue: [],
      addressData: china_address_v4_default.a,

      numberValue: 12,
      switchValue: '1',

      showSignature: true,
      showCSignature: true,
      option: {
        penColor: 'rgb(0, 0, 0)'
      },
      selectText: '',
      selectTextItem: 'submit',
      signDialog: false
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    },
    editName: function editName() {
      this.showSignature = false;
    },
    edit: function edit() {},
    selectTextHandle: function selectTextHandle() {

      this.selectText = this.selectText + this.selectTextItem;
    },

    inputFile: function inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {

        console.log('response', newFile.response);
        if (newFile.xhr) {

          console.log('status', newFile.xhr.status);
        }
      }
    },
    inputFilter: function inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {

        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      newFile.blob = '';
      var URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);

        this.imgUploadItem.push({
          src: newFile.blob,
          index: this.imgUploadItem.length + 1
        });
      }
    },

    previewImage: function previewImage(index) {
      this.$refs.previewer.show(index);
    },
    deleteImgHandle: function deleteImgHandle(item) {
      this.imgUploadItem = this.imgUploadItem.filter(function (tmp) {
        return tmp.index != item.index;
      });
    },
    signImageClear: function signImageClear() {
      var sigRef = this.$refs['signature'];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.into_intermediate_nurse_sign = '';
    },
    fullScreenSign: function fullScreenSign() {
      this.signDialog = true;
    },
    clearCName: function clearCName() {
      var signature = 'signature';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {

        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.into_intermediate_nurse_sign = '';
    },
    saveCName: function saveCName() {
      var signature = 'signature';
      var sigRef = this.$refs[signature];

      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      var png = comp && comp.save ? comp.save() : '';
      var bold = Util.dataURItoBlob(png);
      this.signDialog = false;
    }
  },
  created: function created() {
    if (this.$route.query.a) {
      this.a = this.$route.query.a;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3227725d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/form.vue
var form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",staticStyle:{"width":"360px","overflow-y":"scroll"}},[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("宝宝表单")]),_vm._v(" "),_c('group',{attrs:{"title":"封面"}},[_c('img',{staticStyle:{"width":"100vw","height":"200px"},attrs:{"src":__webpack_require__("m1Fl"),"alt":""}})]),_vm._v(" "),_c('group',{attrs:{"title":"描述文本"}},[_c('div',{staticClass:"des-text"},[_c('span',[_vm._v("关关雎鸠，在河之洲。窈窕淑女，君子好逑。参差荇菜，左右流之。窈窕淑女，寤寐求之。")])])]),_vm._v(" "),_c('group',{attrs:{"title":"输入框"}},[_c('x-input',{attrs:{"name":"username","value":"503"}},[_c('span',{attrs:{"slot":"right"},slot:"right"},[_vm._v("/次")])])],1),_vm._v(" "),_c('group',{attrs:{"title":"单选框/复选框"}},[_c('checklist',{attrs:{"options":_vm.commonList},model:{value:(_vm.checklist002),callback:function ($$v) {_vm.checklist002=$$v},expression:"checklist002"}})],1),_vm._v(" "),_c('group',{attrs:{"title":"picker"}},[_c('popup-picker',{attrs:{"title":"皮肤","data":_vm.list1},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}})],1),_vm._v(" "),_c('group',{attrs:{"title":"日期"}},[_c('datetime',{attrs:{"title":"日期"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),_c('group',{attrs:{"title":"范围选择"}},[_c('cell',{attrs:{"title":"Default","inline-desc":'value: '+_vm.data1,"primary":"content"}},[_c('range',{model:{value:(_vm.data1),callback:function ($$v) {_vm.data1=$$v},expression:"data1"}})],1)],1),_vm._v(" "),_c('group',{attrs:{"title":"评分插件"}},[_c('cell',{attrs:{"title":"评分"}},[_c('rater',{model:{value:(_vm.data3),callback:function ($$v) {_vm.data3=$$v},expression:"data3"}})],1)],1),_vm._v(" "),_c('group',{attrs:{"title":"省市区"}},[_c('x-address',{attrs:{"title":"省市区","list":_vm.addressData,"placeholder":"请选择地址"},model:{value:(_vm.addressValue),callback:function ($$v) {_vm.addressValue=$$v},expression:"addressValue"}})],1),_vm._v(" "),_c('group',{attrs:{"title":"手机号"}},[_c('x-input',{attrs:{"title":"手机号","placeholder":"请输入手机号"}}),_vm._v(" "),_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"短信验证码","placeholder":"请输入短信验证码"}},[_c('x-button',{attrs:{"slot":"right","type":"primary","mini":""},slot:"right"},[_vm._v("发送验证码")])],1)],1),_vm._v(" "),_c('group',{attrs:{"title":"数字"}},[_c('x-number',{staticClass:"number-input",attrs:{"title":"数字","value":10,"button-style":"round","fillable":""}})],1),_vm._v(" "),_c('group',{attrs:{"title":"开关"}},[_c('x-switch',{attrs:{"title":"开关","value-map":['0', '1']},model:{value:(_vm.switchValue),callback:function ($$v) {_vm.switchValue=$$v},expression:"switchValue"}})],1),_vm._v(" "),_c('group',{attrs:{"title":"文本框"}},[_c('x-textarea',{attrs:{"max":200,"placeholder":"请输入文本"}})],1),_vm._v(" "),_c('group',{attrs:{"title":"签名"}},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("i/tN"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("i/tN"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("i/tN"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"signButton"},[_c('x-button',{attrs:{"gradients":['#A644FF', '#FC5BC4'],"mini":""},nativeOn:{"click":function($event){return _vm.fullScreenSign.apply(null, arguments)}}},[_vm._v("全屏签")]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveCName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearCName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}],attrs:{"id":"signDialog"}},[_c('x-dialog',{staticClass:"dialog-demo",model:{value:(_vm.signDialog),callback:function ($$v) {_vm.signDialog=$$v},expression:"signDialog"}},[_c('div',{staticClass:"img-box"},[_c('vueSignature',{ref:"signature",staticStyle:{"left":"0px","top":"0px","position":"absolute","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100vw',"h":'90vh'}}),_vm._v(" "),_c('div',{staticClass:"signButton",staticStyle:{"margin-top":"90vh"}},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveCName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearCName.apply(null, arguments)}}},[_vm._v("清除")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"default","mini":""},nativeOn:{"click":function($event){_vm.signDialog=false}}},[_vm._v("取消/关闭")])],1)],1),_vm._v(" "),_c('div',{on:{"click":function($event){_vm.signDialog=false}}},[_c('span',{staticClass:"vux-close"})])])],1)]),_vm._v(" "),_c('group',{attrs:{"title":"文本侯选框"}},[_c('div',{staticClass:"slide-box"},[_c('div',{staticClass:"slide-within"},_vm._l((17),function(i){return _c('div',{key:i,staticClass:"slide-item"},[_c('x-button',{attrs:{"mini":"","gradients":['#FF5E3A', '#FF9500']},nativeOn:{"click":function($event){return _vm.selectTextHandle.apply(null, arguments)}},model:{value:(_vm.selectTextItem),callback:function ($$v) {_vm.selectTextItem=$$v},expression:"selectTextItem"}},[_vm._v(_vm._s(_vm.selectTextItem))])],1)}),0)]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"输入/选择侯选词"},model:{value:(_vm.selectText),callback:function ($$v) {_vm.selectText=$$v},expression:"selectText"}})],1),_vm._v(" "),_c('group',{attrs:{"title":"图片上传"}},[_c('grid',{staticClass:"upload-img",attrs:{"cols":3,"show-lr-borders":true}},[_vm._l((_vm.imgUploadItem),function(item){return _c('grid-item',{key:item.src},[_c('img',{staticClass:"delete-img",attrs:{"src":__webpack_require__("kalI"),"alt":""},on:{"click":function($event){return _vm.deleteImgHandle(item)}}}),_vm._v(" "),_c('img',{staticStyle:{"width":"84px","height":"84px"},attrs:{"src":item.src,"alt":""},on:{"click":function($event){return _vm.previewImage(item.index)}}})])}),_vm._v(" "),_c('grid-item',[_c('file-upload',{ref:"upload",attrs:{"multiple":true,"post-action":"/post.method","put-action":"/put.method"},on:{"input-file":_vm.inputFile,"input-filter":_vm.inputFilter},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_c('img',{staticStyle:{"width":"84px"},attrs:{"src":__webpack_require__("XGdK")}})])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.imgUploadItem}})],1)],2)],1)],1)}
var form_staticRenderFns = []
var form_esExports = { render: form_render, staticRenderFns: form_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_design_form = (form_esExports);
// CONCATENATED MODULE: ./src/components/design/form.vue
function form_injectStyle (ssrContext) {
  __webpack_require__("8F+s")
}
var form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var form___vue_template_functional__ = false
/* styles */
var form___vue_styles__ = form_injectStyle
/* scopeId */
var form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var form___vue_module_identifier__ = null
var form_Component = form_normalizeComponent(
  components_design_form,
  selectortype_template_index_0_src_components_design_form,
  form___vue_template_functional__,
  form___vue_styles__,
  form___vue_scopeId__,
  form___vue_module_identifier__
)

/* harmony default export */ var src_components_design_form = (form_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue + 3 modules
var flexbox_flexbox = __webpack_require__("YxJB");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue + 3 modules
var flexbox_item = __webpack_require__("3Lt7");

// EXTERNAL MODULE: ./node_modules/vux/src/datas/vux_component_list.json
var vux_component_list = __webpack_require__("XDUe");
var vux_component_list_default = /*#__PURE__*/__webpack_require__.n(vux_component_list);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-mobile.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var sy_mobile = ({});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-mobile.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var control_sy_mobile = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-674ad5da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-mobile.vue
var sy_mobile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"手机号"}},[_c('x-input',{attrs:{"title":"手机号","placeholder":"请输入手机号"}}),_vm._v(" "),_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"短信验证码","placeholder":"请输入短信验证码"}},[_c('x-button',{attrs:{"slot":"right","type":"primary","mini":""},slot:"right"},[_vm._v("发送验证码")])],1)],1)],1)}
var sy_mobile_staticRenderFns = []
var sy_mobile_esExports = { render: sy_mobile_render, staticRenderFns: sy_mobile_staticRenderFns }
/* harmony default export */ var components_control_sy_mobile = (sy_mobile_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-mobile.vue
function sy_mobile_injectStyle (ssrContext) {
  __webpack_require__("yphJ")
}
var sy_mobile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_mobile___vue_template_functional__ = false
/* styles */
var sy_mobile___vue_styles__ = sy_mobile_injectStyle
/* scopeId */
var sy_mobile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_mobile___vue_module_identifier__ = null
var sy_mobile_Component = sy_mobile_normalizeComponent(
  control_sy_mobile,
  components_control_sy_mobile,
  sy_mobile___vue_template_functional__,
  sy_mobile___vue_styles__,
  sy_mobile___vue_scopeId__,
  sy_mobile___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_mobile = (sy_mobile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-input.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var sy_input = ({});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-input.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var control_sy_input = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-191e344b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-input.vue
var sy_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"输入框"}},[_c('x-input',{attrs:{"name":"username","value":"503"}},[_c('span',{attrs:{"slot":"right"},slot:"right"},[_vm._v("/次")])])],1)],1)}
var sy_input_staticRenderFns = []
var sy_input_esExports = { render: sy_input_render, staticRenderFns: sy_input_staticRenderFns }
/* harmony default export */ var components_control_sy_input = (sy_input_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-input.vue
function sy_input_injectStyle (ssrContext) {
  __webpack_require__("t2ar")
}
var sy_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_input___vue_template_functional__ = false
/* styles */
var sy_input___vue_styles__ = sy_input_injectStyle
/* scopeId */
var sy_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_input___vue_module_identifier__ = null
var sy_input_Component = sy_input_normalizeComponent(
  control_sy_input,
  components_control_sy_input,
  sy_input___vue_template_functional__,
  sy_input___vue_styles__,
  sy_input___vue_scopeId__,
  sy_input___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_input = (sy_input_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-address.vue




/* harmony default export */ var sy_address = ({
  components: {
    XAddress: vux_src_components_x_address
  },
  data: function data() {
    return {
      addressSelectModel: [],
      addressListModel: china_address_v4_default.a
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-address.vue




/* harmony default export */ var control_sy_address = ({
  components: {
    XAddress: vux_src_components_x_address
  },
  data: function data() {
    return {
      addressSelectModel: [],
      addressListModel: china_address_v4_default.a
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4b0870","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-address.vue
var sy_address_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"省市区"}},[_c('x-address',{attrs:{"title":"省市区","list":_vm.addressListModel,"placeholder":"请选择地址"},model:{value:(_vm.addressSelectModel),callback:function ($$v) {_vm.addressSelectModel=$$v},expression:"addressSelectModel"}})],1)],1)}
var sy_address_staticRenderFns = []
var sy_address_esExports = { render: sy_address_render, staticRenderFns: sy_address_staticRenderFns }
/* harmony default export */ var components_control_sy_address = (sy_address_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-address.vue
function sy_address_injectStyle (ssrContext) {
  __webpack_require__("eDIT")
}
var sy_address_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_address___vue_template_functional__ = false
/* styles */
var sy_address___vue_styles__ = sy_address_injectStyle
/* scopeId */
var sy_address___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_address___vue_module_identifier__ = null
var sy_address_Component = sy_address_normalizeComponent(
  control_sy_address,
  components_control_sy_address,
  sy_address___vue_template_functional__,
  sy_address___vue_styles__,
  sy_address___vue_scopeId__,
  sy_address___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_address = (sy_address_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-check.vue



/* harmony default export */ var sy_check = ({
  components: {
    Checklist: vux_src_components_checklist
  },
  data: function data() {
    return {
      checkListModel: ['China', 'Japan', 'America'],
      checkSelectModel: ['China', 'Japan']
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-check.vue



/* harmony default export */ var control_sy_check = ({
  components: {
    Checklist: vux_src_components_checklist
  },
  data: function data() {
    return {
      checkListModel: ['China', 'Japan', 'America'],
      checkSelectModel: ['China', 'Japan']
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b57052ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-check.vue
var sy_check_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"单选框/复选框"}},[_c('checklist',{attrs:{"options":_vm.checkListModel},model:{value:(_vm.checkSelectModel),callback:function ($$v) {_vm.checkSelectModel=$$v},expression:"checkSelectModel"}})],1)],1)}
var sy_check_staticRenderFns = []
var sy_check_esExports = { render: sy_check_render, staticRenderFns: sy_check_staticRenderFns }
/* harmony default export */ var components_control_sy_check = (sy_check_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-check.vue
function sy_check_injectStyle (ssrContext) {
  __webpack_require__("i9fr")
}
var sy_check_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_check___vue_template_functional__ = false
/* styles */
var sy_check___vue_styles__ = sy_check_injectStyle
/* scopeId */
var sy_check___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_check___vue_module_identifier__ = null
var sy_check_Component = sy_check_normalizeComponent(
  control_sy_check,
  components_control_sy_check,
  sy_check___vue_template_functional__,
  sy_check___vue_styles__,
  sy_check___vue_scopeId__,
  sy_check___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_check = (sy_check_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-cover.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var sy_cover = ({
    name: 'sy-cover',
    methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-cover.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var control_sy_cover = ({
    name: 'sy-cover',
    methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c5266c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-cover.vue
var sy_cover_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"封面"}},[_c('img',{staticStyle:{"width":"100vw","height":"200px"},attrs:{"src":__webpack_require__("m1Fl"),"alt":""}})])],1)}
var sy_cover_staticRenderFns = []
var sy_cover_esExports = { render: sy_cover_render, staticRenderFns: sy_cover_staticRenderFns }
/* harmony default export */ var components_control_sy_cover = (sy_cover_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-cover.vue
function sy_cover_injectStyle (ssrContext) {
  __webpack_require__("UNFf")
}
var sy_cover_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_cover___vue_template_functional__ = false
/* styles */
var sy_cover___vue_styles__ = sy_cover_injectStyle
/* scopeId */
var sy_cover___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_cover___vue_module_identifier__ = null
var sy_cover_Component = sy_cover_normalizeComponent(
  control_sy_cover,
  components_control_sy_cover,
  sy_cover___vue_template_functional__,
  sy_cover___vue_styles__,
  sy_cover___vue_scopeId__,
  sy_cover___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_cover = (sy_cover_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-date.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var sy_date = ({
    data: function data() {
        return {
            dateModel: ''
        };
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-date.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var control_sy_date = ({
    data: function data() {
        return {
            dateModel: ''
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23378c5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-date.vue
var sy_date_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"日期"}},[_c('datetime',{attrs:{"title":"日期"},model:{value:(_vm.dateModel),callback:function ($$v) {_vm.dateModel=$$v},expression:"dateModel"}})],1)],1)}
var sy_date_staticRenderFns = []
var sy_date_esExports = { render: sy_date_render, staticRenderFns: sy_date_staticRenderFns }
/* harmony default export */ var components_control_sy_date = (sy_date_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-date.vue
function sy_date_injectStyle (ssrContext) {
  __webpack_require__("kbqr")
}
var sy_date_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_date___vue_template_functional__ = false
/* styles */
var sy_date___vue_styles__ = sy_date_injectStyle
/* scopeId */
var sy_date___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_date___vue_module_identifier__ = null
var sy_date_Component = sy_date_normalizeComponent(
  control_sy_date,
  components_control_sy_date,
  sy_date___vue_template_functional__,
  sy_date___vue_styles__,
  sy_date___vue_scopeId__,
  sy_date___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_date = (sy_date_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-description-text.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var sy_description_text = ({});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-description-text.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var control_sy_description_text = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-154c769e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-description-text.vue
var sy_description_text_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"描述文本"}},[_c('div',{staticClass:"des-text"},[_c('span',[_vm._v("关关雎鸠，在河之洲。窈窕淑女，君子好逑。参差荇菜，左右流之。窈窕淑女，寤寐求之。")])])])],1)}
var sy_description_text_staticRenderFns = []
var sy_description_text_esExports = { render: sy_description_text_render, staticRenderFns: sy_description_text_staticRenderFns }
/* harmony default export */ var components_control_sy_description_text = (sy_description_text_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-description-text.vue
function sy_description_text_injectStyle (ssrContext) {
  __webpack_require__("vT6z")
}
var sy_description_text_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_description_text___vue_template_functional__ = false
/* styles */
var sy_description_text___vue_styles__ = sy_description_text_injectStyle
/* scopeId */
var sy_description_text___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_description_text___vue_module_identifier__ = null
var sy_description_text_Component = sy_description_text_normalizeComponent(
  control_sy_description_text,
  components_control_sy_description_text,
  sy_description_text___vue_template_functional__,
  sy_description_text___vue_styles__,
  sy_description_text___vue_scopeId__,
  sy_description_text___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_description_text = (sy_description_text_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-fileupload.vue







/* harmony default export */ var sy_fileupload = ({
  components: {
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    Previewer: vux_src_components_previewer,
    FileUpload: vue_upload_component_default.a
  },
  data: function data() {
    return {
      files: [],
      imgUploadItem: [] //TODO:和预览view数据一致，会被修改属性，会报错不影响，待优化处理
    };
  },

  methods: {
    inputFile: function inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {

        console.log('response', newFile.response);
        if (newFile.xhr) {

          console.log('status', newFile.xhr.status);
        }
      }
    },
    inputFilter: function inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {

        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      newFile.blob = '';
      var URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);

        this.imgUploadItem.push({
          src: newFile.blob,
          index: this.imgUploadItem.length + 1
        });
      }
    },

    previewImage: function previewImage(index) {
      this.$refs.previewer.show(index);
    },
    deleteImgHandle: function deleteImgHandle(item) {
      this.imgUploadItem = this.imgUploadItem.filter(function (tmp) {
        return tmp.index != item.index;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-fileupload.vue







/* harmony default export */ var control_sy_fileupload = ({
  components: {
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    Previewer: vux_src_components_previewer,
    FileUpload: vue_upload_component_default.a
  },
  data: function data() {
    return {
      files: [],
      imgUploadItem: [] //TODO:和预览view数据一致，会被修改属性，会报错不影响，待优化处理
    };
  },

  methods: {
    inputFile: function inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {

        console.log('response', newFile.response);
        if (newFile.xhr) {

          console.log('status', newFile.xhr.status);
        }
      }
    },
    inputFilter: function inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {

        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      newFile.blob = '';
      var URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);

        this.imgUploadItem.push({
          src: newFile.blob,
          index: this.imgUploadItem.length + 1
        });
      }
    },

    previewImage: function previewImage(index) {
      this.$refs.previewer.show(index);
    },
    deleteImgHandle: function deleteImgHandle(item) {
      this.imgUploadItem = this.imgUploadItem.filter(function (tmp) {
        return tmp.index != item.index;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a9716c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-fileupload.vue
var sy_fileupload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"图片上传"}},[_c('grid',{staticClass:"upload-img",attrs:{"cols":3,"show-lr-borders":true}},[_vm._l((_vm.imgUploadItem),function(item){return _c('grid-item',{key:item.src},[_c('img',{staticClass:"delete-img",attrs:{"src":__webpack_require__("kalI"),"alt":""},on:{"click":function($event){return _vm.deleteImgHandle(item)}}}),_vm._v(" "),_c('img',{staticStyle:{"width":"84px","height":"84px"},attrs:{"src":item.src,"alt":""},on:{"click":function($event){return _vm.previewImage(item.index)}}})])}),_vm._v(" "),_c('grid-item',[_c('file-upload',{ref:"upload",attrs:{"multiple":true,"post-action":"/post.method","put-action":"/put.method"},on:{"input-file":_vm.inputFile,"input-filter":_vm.inputFilter},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}},[_c('img',{staticStyle:{"width":"84px"},attrs:{"src":__webpack_require__("XGdK")}})])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('previewer',{ref:"previewer",attrs:{"list":_vm.imgUploadItem}})],1)],2)],1)],1)}
var sy_fileupload_staticRenderFns = []
var sy_fileupload_esExports = { render: sy_fileupload_render, staticRenderFns: sy_fileupload_staticRenderFns }
/* harmony default export */ var components_control_sy_fileupload = (sy_fileupload_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-fileupload.vue
function sy_fileupload_injectStyle (ssrContext) {
  __webpack_require__("VDa7")
}
var sy_fileupload_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_fileupload___vue_template_functional__ = false
/* styles */
var sy_fileupload___vue_styles__ = sy_fileupload_injectStyle
/* scopeId */
var sy_fileupload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_fileupload___vue_module_identifier__ = null
var sy_fileupload_Component = sy_fileupload_normalizeComponent(
  control_sy_fileupload,
  components_control_sy_fileupload,
  sy_fileupload___vue_template_functional__,
  sy_fileupload___vue_styles__,
  sy_fileupload___vue_scopeId__,
  sy_fileupload___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_fileupload = (sy_fileupload_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-header.vue
//
//
//
//
//
//

/* harmony default export */ var sy_header = ({
    name: 'sy-header',
    methods: {
        goBack: function goBack() {}
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-header.vue
//
//
//
//
//
//

/* harmony default export */ var control_sy_header = ({
    name: 'sy-header',
    methods: {
        goBack: function goBack() {}
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc02bb5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-header.vue
var sy_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true},"id":"header-bar"},on:{"on-click-back":_vm.goBack}},[_vm._v("宝宝表单")])],1)}
var sy_header_staticRenderFns = []
var sy_header_esExports = { render: sy_header_render, staticRenderFns: sy_header_staticRenderFns }
/* harmony default export */ var components_control_sy_header = (sy_header_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-header.vue
function sy_header_injectStyle (ssrContext) {
  __webpack_require__("fwaT")
}
var sy_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_header___vue_template_functional__ = false
/* styles */
var sy_header___vue_styles__ = sy_header_injectStyle
/* scopeId */
var sy_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_header___vue_module_identifier__ = null
var sy_header_Component = sy_header_normalizeComponent(
  control_sy_header,
  components_control_sy_header,
  sy_header___vue_template_functional__,
  sy_header___vue_styles__,
  sy_header___vue_scopeId__,
  sy_header___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_header = (sy_header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-picker.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var sy_picker = ({
    data: function data() {
        return {
            pickerListModel: [['小米', 'iPhone', '华为', '情怀', '三星', '其他', '不告诉你']],
            pickerSelectModel: ['iPhone']
        };
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-picker.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var control_sy_picker = ({
    data: function data() {
        return {
            pickerListModel: [['小米', 'iPhone', '华为', '情怀', '三星', '其他', '不告诉你']],
            pickerSelectModel: ['iPhone']
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-911c06dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-picker.vue
var sy_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"picker"}},[_c('popup-picker',{attrs:{"title":"皮肤","data":_vm.pickerListModel},model:{value:(_vm.pickerSelectModel),callback:function ($$v) {_vm.pickerSelectModel=$$v},expression:"pickerSelectModel"}})],1)],1)}
var sy_picker_staticRenderFns = []
var sy_picker_esExports = { render: sy_picker_render, staticRenderFns: sy_picker_staticRenderFns }
/* harmony default export */ var components_control_sy_picker = (sy_picker_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-picker.vue
function sy_picker_injectStyle (ssrContext) {
  __webpack_require__("Wh6R")
}
var sy_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_picker___vue_template_functional__ = false
/* styles */
var sy_picker___vue_styles__ = sy_picker_injectStyle
/* scopeId */
var sy_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_picker___vue_module_identifier__ = null
var sy_picker_Component = sy_picker_normalizeComponent(
  control_sy_picker,
  components_control_sy_picker,
  sy_picker___vue_template_functional__,
  sy_picker___vue_styles__,
  sy_picker___vue_scopeId__,
  sy_picker___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_picker = (sy_picker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-range.vue



/* harmony default export */ var sy_range = ({
  components: {
    Range: vux_src_components_range
  },
  data: function data() {
    return {
      data1: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-range.vue



/* harmony default export */ var control_sy_range = ({
  components: {
    Range: vux_src_components_range
  },
  data: function data() {
    return {
      data1: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f9a4802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-range.vue
var sy_range_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"范围选择"}},[_c('cell',{attrs:{"title":"Default","inline-desc":'value: '+_vm.data1,"primary":"content"}},[_c('range',{model:{value:(_vm.data1),callback:function ($$v) {_vm.data1=$$v},expression:"data1"}})],1)],1)],1)}
var sy_range_staticRenderFns = []
var sy_range_esExports = { render: sy_range_render, staticRenderFns: sy_range_staticRenderFns }
/* harmony default export */ var components_control_sy_range = (sy_range_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-range.vue
function sy_range_injectStyle (ssrContext) {
  __webpack_require__("Ne3k")
}
var sy_range_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_range___vue_template_functional__ = false
/* styles */
var sy_range___vue_styles__ = sy_range_injectStyle
/* scopeId */
var sy_range___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_range___vue_module_identifier__ = null
var sy_range_Component = sy_range_normalizeComponent(
  control_sy_range,
  components_control_sy_range,
  sy_range___vue_template_functional__,
  sy_range___vue_styles__,
  sy_range___vue_scopeId__,
  sy_range___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_range = (sy_range_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-rater.vue



/* harmony default export */ var sy_rater = ({
  components: {
    Rater: vux_src_components_rater
  },
  data: function data() {
    return {
      raterModel: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-rater.vue



/* harmony default export */ var control_sy_rater = ({
  components: {
    Rater: vux_src_components_rater
  },
  data: function data() {
    return {
      raterModel: 3
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c441dad4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-rater.vue
var sy_rater_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"评分插件"}},[_c('cell',{attrs:{"title":"评分"}},[_c('rater',{model:{value:(_vm.raterModel),callback:function ($$v) {_vm.raterModel=$$v},expression:"raterModel"}})],1)],1)],1)}
var sy_rater_staticRenderFns = []
var sy_rater_esExports = { render: sy_rater_render, staticRenderFns: sy_rater_staticRenderFns }
/* harmony default export */ var components_control_sy_rater = (sy_rater_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-rater.vue
function sy_rater_injectStyle (ssrContext) {
  __webpack_require__("Otsi")
}
var sy_rater_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_rater___vue_template_functional__ = false
/* styles */
var sy_rater___vue_styles__ = sy_rater_injectStyle
/* scopeId */
var sy_rater___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_rater___vue_module_identifier__ = null
var sy_rater_Component = sy_rater_normalizeComponent(
  control_sy_rater,
  components_control_sy_rater,
  sy_rater___vue_template_functional__,
  sy_rater___vue_styles__,
  sy_rater___vue_scopeId__,
  sy_rater___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_rater = (sy_rater_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-select-text.vue



/* harmony default export */ var sy_select_text = ({
  components: {
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      selectTextItem: 'submit',
      selectText: ''
    };
  },

  methods: {
    selectTextHandle: function selectTextHandle() {
      //文本侯选点击
      this.selectText = this.selectText + this.selectTextItem;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-select-text.vue



/* harmony default export */ var control_sy_select_text = ({
  components: {
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      selectTextItem: 'submit',
      selectText: ''
    };
  },

  methods: {
    selectTextHandle: function selectTextHandle() {
      //文本侯选点击
      this.selectText = this.selectText + this.selectTextItem;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f4f5e64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-select-text.vue
var sy_select_text_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"文本侯选框"}},[_c('div',{staticClass:"slide-box"},[_c('div',{staticClass:"slide-within"},_vm._l((17),function(i){return _c('div',{key:i,staticClass:"slide-item"},[_c('x-button',{attrs:{"mini":"","gradients":['#FF5E3A', '#FF9500']},nativeOn:{"click":function($event){return _vm.selectTextHandle.apply(null, arguments)}},model:{value:(_vm.selectTextItem),callback:function ($$v) {_vm.selectTextItem=$$v},expression:"selectTextItem"}},[_vm._v(_vm._s(_vm.selectTextItem))])],1)}),0)]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"输入/选择侯选词"},model:{value:(_vm.selectText),callback:function ($$v) {_vm.selectText=$$v},expression:"selectText"}})],1)],1)}
var sy_select_text_staticRenderFns = []
var sy_select_text_esExports = { render: sy_select_text_render, staticRenderFns: sy_select_text_staticRenderFns }
/* harmony default export */ var components_control_sy_select_text = (sy_select_text_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-select-text.vue
function sy_select_text_injectStyle (ssrContext) {
  __webpack_require__("wntg")
}
var sy_select_text_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_select_text___vue_template_functional__ = false
/* styles */
var sy_select_text___vue_styles__ = sy_select_text_injectStyle
/* scopeId */
var sy_select_text___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_select_text___vue_module_identifier__ = null
var sy_select_text_Component = sy_select_text_normalizeComponent(
  control_sy_select_text,
  components_control_sy_select_text,
  sy_select_text___vue_template_functional__,
  sy_select_text___vue_styles__,
  sy_select_text___vue_scopeId__,
  sy_select_text___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_select_text = (sy_select_text_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-sign.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var sy_sign = ({
    data: function data() {
        return {
            signOption: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-sign.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var control_sy_sign = ({
    data: function data() {
        return {
            signOption: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee13522","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-sign.vue
var sy_sign_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"签名"}},[_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("i/tN"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("i/tN"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("i/tN"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.signOption,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"signButton"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveCName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearCName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])],1)}
var sy_sign_staticRenderFns = []
var sy_sign_esExports = { render: sy_sign_render, staticRenderFns: sy_sign_staticRenderFns }
/* harmony default export */ var components_control_sy_sign = (sy_sign_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-sign.vue
function sy_sign_injectStyle (ssrContext) {
  __webpack_require__("EcNG")
}
var sy_sign_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_sign___vue_template_functional__ = false
/* styles */
var sy_sign___vue_styles__ = sy_sign_injectStyle
/* scopeId */
var sy_sign___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_sign___vue_module_identifier__ = null
var sy_sign_Component = sy_sign_normalizeComponent(
  control_sy_sign,
  components_control_sy_sign,
  sy_sign___vue_template_functional__,
  sy_sign___vue_styles__,
  sy_sign___vue_scopeId__,
  sy_sign___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_sign = (sy_sign_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-switch.vue



/* harmony default export */ var sy_switch = ({
  components: {
    XSwitch: vux_src_components_x_switch
  },
  data: function data() {
    return {
      switchModel: '1'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-switch.vue



/* harmony default export */ var control_sy_switch = ({
  components: {
    XSwitch: vux_src_components_x_switch
  },
  data: function data() {
    return {
      switchModel: '1'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e39283fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-switch.vue
var sy_switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"开关"}},[_c('x-switch',{attrs:{"title":"开关","value-map":['0', '1']},model:{value:(_vm.switchModel),callback:function ($$v) {_vm.switchModel=$$v},expression:"switchModel"}})],1)],1)}
var sy_switch_staticRenderFns = []
var sy_switch_esExports = { render: sy_switch_render, staticRenderFns: sy_switch_staticRenderFns }
/* harmony default export */ var components_control_sy_switch = (sy_switch_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-switch.vue
function sy_switch_injectStyle (ssrContext) {
  __webpack_require__("Begl")
}
var sy_switch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_switch___vue_template_functional__ = false
/* styles */
var sy_switch___vue_styles__ = sy_switch_injectStyle
/* scopeId */
var sy_switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_switch___vue_module_identifier__ = null
var sy_switch_Component = sy_switch_normalizeComponent(
  control_sy_switch,
  components_control_sy_switch,
  sy_switch___vue_template_functional__,
  sy_switch___vue_styles__,
  sy_switch___vue_scopeId__,
  sy_switch___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_switch = (sy_switch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-text.vue



/* harmony default export */ var sy_text = ({
  components: {
    XTextarea: vux_src_components_x_textarea
  }

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-text.vue



/* harmony default export */ var control_sy_text = ({
  components: {
    XTextarea: vux_src_components_x_textarea
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff2b2a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-text.vue
var sy_text_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"文本框"}},[_c('x-textarea',{attrs:{"max":200,"placeholder":"请输入文本"}})],1)],1)}
var sy_text_staticRenderFns = []
var sy_text_esExports = { render: sy_text_render, staticRenderFns: sy_text_staticRenderFns }
/* harmony default export */ var components_control_sy_text = (sy_text_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-text.vue
function sy_text_injectStyle (ssrContext) {
  __webpack_require__("xAxC")
}
var sy_text_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_text___vue_template_functional__ = false
/* styles */
var sy_text___vue_styles__ = sy_text_injectStyle
/* scopeId */
var sy_text___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_text___vue_module_identifier__ = null
var sy_text_Component = sy_text_normalizeComponent(
  control_sy_text,
  components_control_sy_text,
  sy_text___vue_template_functional__,
  sy_text___vue_styles__,
  sy_text___vue_scopeId__,
  sy_text___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_text = (sy_text_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/form_add.vue























/* harmony default export */ var form_add = ({
  name: 'demoList',
  components: {
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    SyMobile: design_components_control_sy_mobile,
    SyInput: design_components_control_sy_input,
    SyAddress: design_components_control_sy_address,
    SyCheck: design_components_control_sy_check,
    SyCover: design_components_control_sy_cover,
    SyDate: design_components_control_sy_date,
    SyDescriptionText: design_components_control_sy_description_text,
    SyFileupload: design_components_control_sy_fileupload,
    SyHeader: design_components_control_sy_header,
    SyPicker: design_components_control_sy_picker,
    SyRange: design_components_control_sy_range,
    SyRater: design_components_control_sy_rater,
    SySelectText: design_components_control_sy_select_text,
    SySign: design_components_control_sy_sign,
    SySwitch: design_components_control_sy_switch,
    SyText: design_components_control_sy_text

  },
  mounted: function mounted() {},

  methods: {},
  data: function data() {
    return {
      dynamicControlArray: [{ name: '封面', type: 'SyCover', control: design_components_control_sy_cover }, { name: '手机号', type: 'SyMobile', control: design_components_control_sy_mobile }, { name: '输入框', type: 'SyInput', control: design_components_control_sy_input }, { name: '省市区', type: 'SyAddress', control: design_components_control_sy_address }, { name: '单选/多选', type: 'SyCheck', control: design_components_control_sy_check }, { name: '日期', type: 'SyDate', control: design_components_control_sy_date }, { name: '文本', type: 'SyDescriptionText', control: design_components_control_sy_description_text }, { name: '图片上传', type: 'SyFileupload', control: design_components_control_sy_fileupload }, { name: '头部', type: 'SyHeader', control: design_components_control_sy_header }, { name: '选择项', type: 'SyPicker', control: design_components_control_sy_picker }, { name: '范围选择', type: 'SyRange', control: design_components_control_sy_range }, { name: '评分', type: 'SyRater', control: design_components_control_sy_rater }, { name: '文本侯选', type: 'SySelectText', control: design_components_control_sy_select_text }, { name: '签名', type: 'SySign', control: design_components_control_sy_sign }, { name: '开关', type: 'SySwitch', control: design_components_control_sy_switch }, { name: '文本描述', type: 'SyText', control: design_components_control_sy_text }],
      formControlMenu: [{
        name: '封面',
        icon: __webpack_require__("Q68+")
      }, {
        name: '描述文本',
        icon: __webpack_require__("ap5H")
      }, {
        name: '输入框',
        icon: __webpack_require__("XMBc")
      }, {
        name: '单选框/复选框',
        icon: __webpack_require__("gZ0m")
      }, {
        name: 'picker选择框',
        icon: __webpack_require__("+N0q")
      }, {
        name: '范围选择',
        icon: __webpack_require__("uu8v")
      }, {
        name: '评分插件',
        icon: __webpack_require__("GhsE")
      }, {
        name: '省市区',
        icon: __webpack_require__("oV47")
      }, {
        name: '手机号',
        icon: __webpack_require__("Kywb")
      }, {
        name: '数字',
        icon: __webpack_require__("5twO")
      }, {
        name: '开关',
        icon: __webpack_require__("3kcQ")
      }, {
        name: '签名',
        icon: __webpack_require__("t3On")
      }, {
        name: '文本侯选框',
        icon: __webpack_require__("5xH4")
      }]
    };
  },

  computed: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/form_add.vue























/* harmony default export */ var design_form_add = ({
  name: 'demoList',
  components: {
    Flexbox: flexbox_flexbox["a" /* default */],
    FlexboxItem: flexbox_item["a" /* default */],
    SyMobile: design_components_control_sy_mobile,
    SyInput: design_components_control_sy_input,
    SyAddress: design_components_control_sy_address,
    SyCheck: design_components_control_sy_check,
    SyCover: design_components_control_sy_cover,
    SyDate: design_components_control_sy_date,
    SyDescriptionText: design_components_control_sy_description_text,
    SyFileupload: design_components_control_sy_fileupload,
    SyHeader: design_components_control_sy_header,
    SyPicker: design_components_control_sy_picker,
    SyRange: design_components_control_sy_range,
    SyRater: design_components_control_sy_rater,
    SySelectText: design_components_control_sy_select_text,
    SySign: design_components_control_sy_sign,
    SySwitch: design_components_control_sy_switch,
    SyText: design_components_control_sy_text

  },
  mounted: function mounted() {},

  methods: {},
  data: function data() {
    return {
      dynamicControlArray: [{ name: '封面', type: 'SyCover', control: design_components_control_sy_cover }, { name: '手机号', type: 'SyMobile', control: design_components_control_sy_mobile }, { name: '输入框', type: 'SyInput', control: design_components_control_sy_input }, { name: '省市区', type: 'SyAddress', control: design_components_control_sy_address }, { name: '单选/多选', type: 'SyCheck', control: design_components_control_sy_check }, { name: '日期', type: 'SyDate', control: design_components_control_sy_date }, { name: '文本', type: 'SyDescriptionText', control: design_components_control_sy_description_text }, { name: '图片上传', type: 'SyFileupload', control: design_components_control_sy_fileupload }, { name: '头部', type: 'SyHeader', control: design_components_control_sy_header }, { name: '选择项', type: 'SyPicker', control: design_components_control_sy_picker }, { name: '范围选择', type: 'SyRange', control: design_components_control_sy_range }, { name: '评分', type: 'SyRater', control: design_components_control_sy_rater }, { name: '文本侯选', type: 'SySelectText', control: design_components_control_sy_select_text }, { name: '签名', type: 'SySign', control: design_components_control_sy_sign }, { name: '开关', type: 'SySwitch', control: design_components_control_sy_switch }, { name: '文本描述', type: 'SyText', control: design_components_control_sy_text }],
      formControlMenu: [{
        name: '封面',
        icon: __webpack_require__("Q68+")
      }, {
        name: '描述文本',
        icon: __webpack_require__("ap5H")
      }, {
        name: '输入框',
        icon: __webpack_require__("XMBc")
      }, {
        name: '单选框/复选框',
        icon: __webpack_require__("gZ0m")
      }, {
        name: 'picker选择框',
        icon: __webpack_require__("+N0q")
      }, {
        name: '范围选择',
        icon: __webpack_require__("uu8v")
      }, {
        name: '评分插件',
        icon: __webpack_require__("GhsE")
      }, {
        name: '省市区',
        icon: __webpack_require__("oV47")
      }, {
        name: '手机号',
        icon: __webpack_require__("Kywb")
      }, {
        name: '数字',
        icon: __webpack_require__("5twO")
      }, {
        name: '开关',
        icon: __webpack_require__("3kcQ")
      }, {
        name: '签名',
        icon: __webpack_require__("t3On")
      }, {
        name: '文本侯选框',
        icon: __webpack_require__("5xH4")
      }]
    };
  },

  computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b8792f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/form_add.vue
var form_add_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"left"},[_vm._m(0),_vm._v(" "),_c('grid',{attrs:{"cols":2}},_vm._l((_vm.formControlMenu),function(item){return _c('grid-item',{key:item.name,attrs:{"label":item.name}},[_c('img',{attrs:{"slot":"icon","src":item.icon},slot:"icon"})])}),1)],1),_vm._v(" "),_c('div',{staticClass:"center"},_vm._l((_vm.dynamicControlArray),function(item){return _c(item.type,{key:item.type,tag:"component"})}),1),_vm._v(" "),_vm._m(1)])}
var form_add_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('b',[_vm._v("控件选择")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right"},[_c('div',{staticClass:"title"},[_c('b',[_vm._v("字段属性")])]),_vm._v(" "),_c('div')])}]
var form_add_esExports = { render: form_add_render, staticRenderFns: form_add_staticRenderFns }
/* harmony default export */ var components_design_form_add = (form_add_esExports);
// CONCATENATED MODULE: ./src/components/design/form_add.vue
function form_add_injectStyle (ssrContext) {
  __webpack_require__("pf3F")
}
var form_add_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var form_add___vue_template_functional__ = false
/* styles */
var form_add___vue_styles__ = form_add_injectStyle
/* scopeId */
var form_add___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var form_add___vue_module_identifier__ = null
var form_add_Component = form_add_normalizeComponent(
  design_form_add,
  components_design_form_add,
  form_add___vue_template_functional__,
  form_add___vue_styles__,
  form_add___vue_scopeId__,
  form_add___vue_module_identifier__
)

/* harmony default export */ var src_components_design_form_add = (form_add_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/form_design.vue
















/* harmony default export */ var form_design = ({
  name: 'month_form',
  components: {
    Checklist: vux_src_components_checklist,
    Range: vux_src_components_range,
    Rater: vux_src_components_rater,
    XAddress: vux_src_components_x_address,
    XNumber: vux_src_components_x_number,
    XSwitch: vux_src_components_x_switch,
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    Previewer: vux_src_components_previewer,
    FileUpload: vue_upload_component_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      a: 1,
      files: [],
      imgUploadItem: [], //TODO:和预览view数据一致，会被修改属性，会报错不影响，待优化处理
      id: this.$route.query.id,
      commonList: ['China', 'Japan', 'America'],
      checklist002: ['China', 'Japan'],

      list1: [['小米', 'iPhone', '华为', '情怀', '三星', '其他', '不告诉你']],
      value1: ['iPhone'],

      date: '',
      data1: 0,
      data3: 5,

      addressValue: [],
      addressData: china_address_v4_default.a,

      numberValue: 12,
      switchValue: '1',

      showSignature: true,
      showCSignature: true,
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      selectText: '',
      selectTextItem: 'submit'
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    },
    editName: function editName() {
      this.showSignature = false;
    },
    edit: function edit() {},
    selectTextHandle: function selectTextHandle() {
      //文本侯选点击
      this.selectText = this.selectText + this.selectTextItem;
    },

    inputFile: function inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {

        console.log('response', newFile.response);
        if (newFile.xhr) {

          console.log('status', newFile.xhr.status);
        }
      }
    },
    inputFilter: function inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {

        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      newFile.blob = '';
      var URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);

        this.imgUploadItem.push({
          src: newFile.blob,
          index: this.imgUploadItem.length + 1
        });
      }
    },

    previewImage: function previewImage(index) {
      this.$refs.previewer.show(index);
    },
    deleteImgHandle: function deleteImgHandle(item) {
      this.imgUploadItem = this.imgUploadItem.filter(function (tmp) {
        return tmp.index != item.index;
      });
    }
  },
  created: function created() {
    if (this.$route.query.a) {
      this.a = this.$route.query.a;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/form_design.vue
















/* harmony default export */ var design_form_design = ({
  name: 'month_form',
  components: {
    Checklist: vux_src_components_checklist,
    Range: vux_src_components_range,
    Rater: vux_src_components_rater,
    XAddress: vux_src_components_x_address,
    XNumber: vux_src_components_x_number,
    XSwitch: vux_src_components_x_switch,
    XTextarea: vux_src_components_x_textarea,
    XButton: vux_src_components_x_button,
    Grid: src_components_grid_grid,
    GridItem: src_components_grid_grid_item,
    Previewer: vux_src_components_previewer,
    FileUpload: vue_upload_component_default.a
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  data: function data() {
    return {
      a: 1,
      files: [],
      imgUploadItem: [], //TODO:和预览view数据一致，会被修改属性，会报错不影响，待优化处理
      id: this.$route.query.id,
      commonList: ['China', 'Japan', 'America'],
      checklist002: ['China', 'Japan'],

      list1: [['小米', 'iPhone', '华为', '情怀', '三星', '其他', '不告诉你']],
      value1: ['iPhone'],

      date: '',
      data1: 0,
      data3: 5,

      addressValue: [],
      addressData: china_address_v4_default.a,

      numberValue: 12,
      switchValue: '1',

      showSignature: true,
      showCSignature: true,
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      selectText: '',
      selectTextItem: 'submit'
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    },
    editName: function editName() {
      this.showSignature = false;
    },
    edit: function edit() {},
    selectTextHandle: function selectTextHandle() {
      //文本侯选点击
      this.selectText = this.selectText + this.selectTextItem;
    },

    inputFile: function inputFile(newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {

        console.log('response', newFile.response);
        if (newFile.xhr) {

          console.log('status', newFile.xhr.status);
        }
      }
    },
    inputFilter: function inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {

        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      newFile.blob = '';
      var URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);

        this.imgUploadItem.push({
          src: newFile.blob,
          index: this.imgUploadItem.length + 1
        });
      }
    },

    previewImage: function previewImage(index) {
      this.$refs.previewer.show(index);
    },
    deleteImgHandle: function deleteImgHandle(item) {
      this.imgUploadItem = this.imgUploadItem.filter(function (tmp) {
        return tmp.index != item.index;
      });
    }
  },
  created: function created() {
    if (this.$route.query.a) {
      this.a = this.$route.query.a;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b4a154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/form_design.vue
var form_design_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true},"id":"header-bar"},on:{"on-click-back":_vm.goBack}},[_vm._v("宝宝表单")]),_vm._v(" "),_c('group',{attrs:{"title":"封面"}},[_c('img',{staticStyle:{"width":"100vw","height":"200px"},attrs:{"src":__webpack_require__("m1Fl"),"alt":""}})]),_vm._v(" "),_c('group',{attrs:{"title":"描述文本"}},[_c('div',{staticClass:"des-text"},[_c('span',[_vm._v("关关雎鸠，在河之洲。窈窕淑女，君子好逑。参差荇菜，左右流之。窈窕淑女，寤寐求之。")])])]),_vm._v(" "),_c('group',{attrs:{"title":"输入框"}},[_c('x-input',{attrs:{"name":"username","value":"503"}},[_c('span',{attrs:{"slot":"right"},slot:"right"},[_vm._v("/次")])])],1),_vm._v(" "),_c('group',{attrs:{"title":"单选框/复选框"}},[_c('checklist',{attrs:{"options":_vm.commonList},model:{value:(_vm.checklist002),callback:function ($$v) {_vm.checklist002=$$v},expression:"checklist002"}})],1)],1)}
var form_design_staticRenderFns = []
var form_design_esExports = { render: form_design_render, staticRenderFns: form_design_staticRenderFns }
/* harmony default export */ var components_design_form_design = (form_design_esExports);
// CONCATENATED MODULE: ./src/components/design/form_design.vue
function form_design_injectStyle (ssrContext) {
  __webpack_require__("z8tP")
}
var form_design_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var form_design___vue_template_functional__ = false
/* styles */
var form_design___vue_styles__ = form_design_injectStyle
/* scopeId */
var form_design___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var form_design___vue_module_identifier__ = null
var form_design_Component = form_design_normalizeComponent(
  design_form_design,
  components_design_form_design,
  form_design___vue_template_functional__,
  form_design___vue_styles__,
  form_design___vue_scopeId__,
  form_design___vue_module_identifier__
)

/* harmony default export */ var src_components_design_form_design = (form_design_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-number.vue



/* harmony default export */ var sy_number = ({
  components: {
    XNumber: vux_src_components_x_number
  },
  data: function data() {
    return {
      numberModel: 10
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control/sy-number.vue



/* harmony default export */ var control_sy_number = ({
  components: {
    XNumber: vux_src_components_x_number
  },
  data: function data() {
    return {
      numberModel: 10
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b831b8d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control/sy-number.vue
var sy_number_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"数字"}},[_c('x-number',{staticClass:"number-input",attrs:{"title":"数字","value":_vm.numberModel,"button-style":"round","fillable":""}})],1)],1)}
var sy_number_staticRenderFns = []
var sy_number_esExports = { render: sy_number_render, staticRenderFns: sy_number_staticRenderFns }
/* harmony default export */ var components_control_sy_number = (sy_number_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control/sy-number.vue
function sy_number_injectStyle (ssrContext) {
  __webpack_require__("ujcB")
}
var sy_number_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_number___vue_template_functional__ = false
/* styles */
var sy_number___vue_styles__ = sy_number_injectStyle
/* scopeId */
var sy_number___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sy_number___vue_module_identifier__ = null
var sy_number_Component = sy_number_normalizeComponent(
  control_sy_number,
  components_control_sy_number,
  sy_number___vue_template_functional__,
  sy_number___vue_styles__,
  sy_number___vue_scopeId__,
  sy_number___vue_module_identifier__
)

/* harmony default export */ var design_components_control_sy_number = (sy_number_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control_attribute/sy-address-attr.vue



/* harmony default export */ var sy_address_attr = ({
  components: {
    XSwitch: vux_src_components_x_switch
  },
  data: function data() {
    return {
      value: '1'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/design/components/control_attribute/sy-address-attr.vue



/* harmony default export */ var control_attribute_sy_address_attr = ({
  components: {
    XSwitch: vux_src_components_x_switch
  },
  data: function data() {
    return {
      value: '1'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77e6070a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/design/components/control_attribute/sy-address-attr.vue
var sy_address_attr_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('group',{attrs:{"title":"标题"}},[_c('x-input',{attrs:{"name":"username","placeholder":"请输入标题"}})],1),_vm._v(" "),_c('group',{attrs:{"title":"是否必填"}},[_c('x-switch',{attrs:{"title":"是否必填"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)}
var sy_address_attr_staticRenderFns = []
var sy_address_attr_esExports = { render: sy_address_attr_render, staticRenderFns: sy_address_attr_staticRenderFns }
/* harmony default export */ var components_control_attribute_sy_address_attr = (sy_address_attr_esExports);
// CONCATENATED MODULE: ./src/components/design/components/control_attribute/sy-address-attr.vue
function sy_address_attr_injectStyle (ssrContext) {
  __webpack_require__("Hgxa")
}
var sy_address_attr_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sy_address_attr___vue_template_functional__ = false
/* styles */
var sy_address_attr___vue_styles__ = sy_address_attr_injectStyle
/* scopeId */
var sy_address_attr___vue_scopeId__ = "data-v-77e6070a"
/* moduleIdentifier (server only) */
var sy_address_attr___vue_module_identifier__ = null
var sy_address_attr_Component = sy_address_attr_normalizeComponent(
  control_attribute_sy_address_attr,
  components_control_attribute_sy_address_attr,
  sy_address_attr___vue_template_functional__,
  sy_address_attr___vue_styles__,
  sy_address_attr___vue_scopeId__,
  sy_address_attr___vue_module_identifier__
)

/* harmony default export */ var design_components_control_attribute_sy_address_attr = (sy_address_attr_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base_info_header.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var base_info_header = ({
    name: 'base_info_header',
    props: {
        maternalId: {
            type: String,
            required: false
        },
        otherFormDetail: {
            type: String,
            required: false
        }
    },
    data: function data() {
        return {
            baseInfo: {
                name: '',
                liveTime: '',
                room_name: '',
                phone: '',
                package: '',
                ready_leave_date: '',
                birth_type_val: '',
                birth_type_arr: [{
                    label: '顺产',
                    value: 1
                }, {
                    label: '剖腹产',
                    value: 2
                }, {
                    label: '流产',
                    value: 3
                }, {
                    label: '不知道',
                    value: 0
                }]
            }
        };
    },

    methods: {
        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日';
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.maternalId
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                if (res.errcode == 1) {
                    var birth_type = '';
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = get_iterator_default()(_this.baseInfo.birth_type_arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            if (item.value == res.data.birth_type) {
                                birth_type = item.label;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this.baseInfo.name = res.data.name;
                    _this.baseInfo.phone = res.data.phone;
                    _this.baseInfo.package = res.data.package_name;
                    _this.baseInfo.liveTime = _this.formatDateTime(res.data.live_time);
                    _this.baseInfo.room_name = res.data.room_name;
                    _this.baseInfo.ready_leave_date = _this.formatDateTime(res.data.ready_leave_date);
                    _this.baseInfo.birth_type_val = birth_type;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        }
    },
    created: function created() {
        this.apiMemberInfo();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base_info_header.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_base_info_header = ({
    name: 'base_info_header',
    props: {
        maternalId: {
            type: String,
            required: false
        },
        otherFormDetail: {
            type: String,
            required: false
        }
    },
    data: function data() {
        return {
            baseInfo: {
                name: '',
                liveTime: '',
                room_name: '',
                phone: '',
                package: '',
                ready_leave_date: '',
                birth_type_val: '',
                birth_type_arr: [{
                    label: '顺产',
                    value: 1
                }, {
                    label: '剖腹产',
                    value: 2
                }, {
                    label: '流产',
                    value: 3
                }, {
                    label: '不知道',
                    value: 0
                }]
            }
        };
    },

    methods: {
        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日';
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.maternalId
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                if (res.errcode == 1) {
                    var birth_type = '';
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = get_iterator_default()(_this.baseInfo.birth_type_arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            if (item.value == res.data.birth_type) {
                                birth_type = item.label;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this.baseInfo.name = res.data.name;
                    _this.baseInfo.phone = res.data.phone;
                    _this.baseInfo.package = res.data.package_name;
                    _this.baseInfo.liveTime = _this.formatDateTime(res.data.live_time);
                    _this.baseInfo.room_name = res.data.room_name;
                    _this.baseInfo.ready_leave_date = _this.formatDateTime(res.data.ready_leave_date);
                    _this.baseInfo.birth_type_val = birth_type;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        }
    },
    created: function created() {
        this.apiMemberInfo();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c47ffff","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base_info_header.vue
var base_info_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.otherFormDetail)?_c('div',{staticClass:"baseInfo vux-1px"},[_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("产妇姓名："+_vm._s(_vm.baseInfo.name))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("入住日期："+_vm._s(_vm.baseInfo.liveTime))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("房间号："+_vm._s(_vm.baseInfo.room_name))])])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("联系电话："+_vm._s(_vm.baseInfo.phone))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("预定套餐："+_vm._s(_vm.baseInfo.package))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"})])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("离院日期："+_vm._s(_vm.baseInfo.ready_leave_date))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("分娩方式："+_vm._s(_vm.baseInfo.birth_type_val))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"})])],1)],1):_c('div',{staticClass:"baseInfo vux-1px"},[_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("产妇姓名："+_vm._s(_vm.baseInfo.name))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("入住日期："+_vm._s(_vm.baseInfo.liveTime))])])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("联系电话："+_vm._s(_vm.baseInfo.phone))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("预定套餐："+_vm._s(_vm.baseInfo.package))])])],1)],1)])}
var base_info_header_staticRenderFns = []
var base_info_header_esExports = { render: base_info_header_render, staticRenderFns: base_info_header_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_base_info_header = (base_info_header_esExports);
// CONCATENATED MODULE: ./src/components/base_info_header.vue
function base_info_header_injectStyle (ssrContext) {
  __webpack_require__("XNOG")
}
var base_info_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var base_info_header___vue_template_functional__ = false
/* styles */
var base_info_header___vue_styles__ = base_info_header_injectStyle
/* scopeId */
var base_info_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var base_info_header___vue_module_identifier__ = null
var base_info_header_Component = base_info_header_normalizeComponent(
  components_base_info_header,
  selectortype_template_index_0_src_components_base_info_header,
  base_info_header___vue_template_functional__,
  base_info_header___vue_styles__,
  base_info_header___vue_scopeId__,
  base_info_header___vue_module_identifier__
)

/* harmony default export */ var src_components_base_info_header = (base_info_header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/month_live.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var month_live = ({
  name: 'month_live',
  components: {
    baseInfoHeader: src_components_base_info_header
  },
  data: function data() {
    return {
      indexList: '',
      showSearch: true,
      has_answer: '', //是否填过答案
      id: this.$route.query.id,
      member_column_list: [], //表单数组
      column_list: [], //表单数组
      is_drapList: false,
      //孕妇列表
      maternal_list: [],
      //签名
      is_edit: '', //是否显示
      tmpImageUpload: {},
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      host: api_const["host"],
      pinyin_array: []
    };
  },

  methods: {
    //获取查房人列表
    apiGetCfrList: function apiGetCfrList() {
      var _this = this;

      var params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id')
      };
      Api.checkRoomApi.getCheckInfo(params).then(function (res) {
        console.info("获取查房人列表");
        console.info(res);
        if (res.errcode == 1) {
          _this.cfr_list(res.data.nurser_name);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //替换所有换行符
    replaceAllNewLine: function replaceAllNewLine(content) {
      var string = content;
      try {
        string = string.replace(/\r\n/g, "<br>");
        string = string.replace(/\n/g, "<br>");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },


    //替换br成换行
    replaceAllBr: function replaceAllBr(content) {
      var string = content;
      try {
        string = string.replace("<br>", "\n").replace("<br>", "\n");
        string = string.replace("<br>", "\n");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },
    textareaBlur: function textareaBlur(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.column_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column_list_item = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(column_list_item.row_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var row_list_item = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = get_iterator_default()(row_list_item.content), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var content_item = _step3.value;

                  if (content_item.id == id) {
                    content_item.my_answer = this.replaceAllBr(content_item.my_answer);
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(arr), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    selece_cfr: function selece_cfr(name, id) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.column_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var column_list_item = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(column_list_item.row_list), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var row_list_item = _step6.value;
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = get_iterator_default()(row_list_item.content), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var content_item = _step7.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.indexList = '';
                  }
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    selectPeople: function selectPeople(id) {
      if (this.indexList) {
        this.indexList = '';
        return;
      }
      this.indexList = id;
    },
    arrar_sort: function arrar_sort(newArr, oldArr) {
      var newList = [];
      var pyArrSort = newArr.sort();
      var i = 0;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(pyArrSort), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = get_iterator_default()(oldArr), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var list = _step9.value;

              if (item == list.pinyin) {
                newList[i] = list;
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          i++;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return newList;
    },
    cfr_list: function cfr_list(arr) {
      if (arr.length) {
        var nurser_name_arr = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = get_iterator_default()(arr), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var item = _step10.value;

            var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
            var obj = {
              name: [item.user_name],
              pinyin: _py
            };
            nurser_name_arr.push(obj);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var pyArr = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = get_iterator_default()(nurser_name_arr), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var _item = _step11.value;

            var obj = {
              name: _item.name,
              pinyin: _item.pinyin
            };
            var is_have = this.isInArray(pyArr, _item.pinyin);
            if (!is_have) {
              //不存在
              pyArr.push(_item.pinyin);
              this.pinyin_array.push(_item.pinyin);
              this.pinyin_array.sort();
              this.maternal_list.push(obj);
            } else {
              //存在
              var _index = pyArr.indexOf(_item.pinyin);
              this.maternal_list[_index].name.push(_item.name.join(''));
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
        console.info(this.maternal_list);
      }
    },

    //请求孕妇表单配置信息
    apiMonthLive: function apiMonthLive() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.monthLiveApi.monthLive(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this2.has_answer = res.data.has_answer;
          _this2.member_column_list = res.data.column_list;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = get_iterator_default()(res.data.form_data.column_list), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var column_list_item = _step12.value;
              var _iteratorNormalCompletion13 = true;
              var _didIteratorError13 = false;
              var _iteratorError13 = undefined;

              try {
                for (var _iterator13 = get_iterator_default()(column_list_item.row_list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                  var row_list_item = _step13.value;
                  var _iteratorNormalCompletion14 = true;
                  var _didIteratorError14 = false;
                  var _iteratorError14 = undefined;

                  try {
                    for (var _iterator14 = get_iterator_default()(row_list_item.content), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                      var content_item = _step14.value;
                      var _iteratorNormalCompletion15 = true;
                      var _didIteratorError15 = false;
                      var _iteratorError15 = undefined;

                      try {
                        for (var _iterator15 = get_iterator_default()(_this2.member_column_list), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                          var item = _step15.value;

                          if (content_item.column_name == item.name) {
                            content_item.tip = item.value;
                            _this2.$vux.loading.hide();
                          }
                        }
                      } catch (err) {
                        _didIteratorError15 = true;
                        _iteratorError15 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion15 && _iterator15.return) {
                            _iterator15.return();
                          }
                        } finally {
                          if (_didIteratorError15) {
                            throw _iteratorError15;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                      }
                    } finally {
                      if (_didIteratorError14) {
                        throw _iteratorError14;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion13 && _iterator13.return) {
                    _iterator13.return();
                  }
                } finally {
                  if (_didIteratorError13) {
                    throw _iteratorError13;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          _this2.column_list = res.data.form_data.column_list;
          _this2.cfr_list(res.data.nurser_name);
          // this.apiGetCfrList()
          //孕妇列表
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //是否提交过答案
    editForm: function editForm() {
      this.has_answer = '2';
    },
    input_focus: function input_focus(id) {
      this.is_drapList = id;
    },
    menuClick: function menuClick(name, id) {
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = get_iterator_default()(this.column_list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var column_list_item = _step16.value;
          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = get_iterator_default()(column_list_item.row_list), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var row_list_item = _step17.value;
              var _iteratorNormalCompletion18 = true;
              var _didIteratorError18 = false;
              var _iteratorError18 = undefined;

              try {
                for (var _iterator18 = get_iterator_default()(row_list_item.content), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                  var content_item = _step18.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.is_drapList = '';
                  }
                }
              } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion18 && _iterator18.return) {
                    _iterator18.return();
                  }
                } finally {
                  if (_didIteratorError18) {
                    throw _iteratorError18;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }
    },

    //保存签名
    save: function save(id) {
      var signature = 'signature' + id;
      var png = this.$refs[signature][0].save();
      var jpeg = this.$refs[signature][0].save('image/jpeg');
      var svg = this.$refs[signature][0].save('image/svg+xml');
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = get_iterator_default()(this.column_list), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var column_list_item = _step19.value;
          var _iteratorNormalCompletion20 = true;
          var _didIteratorError20 = false;
          var _iteratorError20 = undefined;

          try {
            for (var _iterator20 = get_iterator_default()(column_list_item.row_list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
              var row_list_item = _step20.value;
              var _iteratorNormalCompletion21 = true;
              var _didIteratorError21 = false;
              var _iteratorError21 = undefined;

              try {
                for (var _iterator21 = get_iterator_default()(row_list_item.content), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                  var content_item = _step21.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [encodeURI(png)];
                    this.is_edit = '';
                  }
                }
              } catch (err) {
                _didIteratorError21 = true;
                _iteratorError21 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion21 && _iterator21.return) {
                    _iterator21.return();
                  }
                } finally {
                  if (_didIteratorError21) {
                    throw _iteratorError21;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError20 = true;
            _iteratorError20 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion20 && _iterator20.return) {
                _iterator20.return();
              }
            } finally {
              if (_didIteratorError20) {
                throw _iteratorError20;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }
    },

    //清除签名
    clear: function clear(id) {
      var signature = 'signature' + id;
      var refs = this.$refs[signature][0].clear();
    },

    //编辑签名
    edit_signature: function edit_signature(id) {
      this.is_edit = id;
    },

    //图片上传
    fileImage: function fileImage(e) {
      var file = e.target.files[0];
      var item_id = e.target.id;
      var that = this;
      lrz(file).then(function (rst) {
        // 处理成功会执行
        var _iteratorNormalCompletion22 = true;
        var _didIteratorError22 = false;
        var _iteratorError22 = undefined;

        try {
          for (var _iterator22 = get_iterator_default()(that.column_list), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
            var column_list_item = _step22.value;
            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
              for (var _iterator23 = get_iterator_default()(column_list_item.row_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                var row_list_item = _step23.value;
                var _iteratorNormalCompletion24 = true;
                var _didIteratorError24 = false;
                var _iteratorError24 = undefined;

                try {
                  for (var _iterator24 = get_iterator_default()(row_list_item.content), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                    var content_item = _step24.value;

                    if (content_item.id == item_id) {
                      if (content_item.my_answer.length == 10) {
                        that.$vux.toast.show({
                          type: 'cancel',
                          text: '最多上传10张图片'
                        });
                        return;
                      }
                      content_item.my_answer.push(rst.base64);
                    }
                  }
                } catch (err) {
                  _didIteratorError24 = true;
                  _iteratorError24 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion24 && _iterator24.return) {
                      _iterator24.return();
                    }
                  } finally {
                    if (_didIteratorError24) {
                      throw _iteratorError24;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError23 = true;
              _iteratorError23 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion23 && _iterator23.return) {
                  _iterator23.return();
                }
              } finally {
                if (_didIteratorError23) {
                  throw _iteratorError23;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError22 = true;
          _iteratorError22 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion22 && _iterator22.return) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError22) {
              throw _iteratorError22;
            }
          }
        }
      }).catch(function (err) {
        console.info(err);
        that.$vux.toast.show({
          type: 'cancel',
          text: '网络错误'
        });
        // 处理失败会执行
      });
    },

    //删除图片
    delImg: function delImg(index, id) {
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = get_iterator_default()(this.column_list), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var column_list_item = _step25.value;
          var _iteratorNormalCompletion26 = true;
          var _didIteratorError26 = false;
          var _iteratorError26 = undefined;

          try {
            for (var _iterator26 = get_iterator_default()(column_list_item.row_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
              var row_list_item = _step26.value;
              var _iteratorNormalCompletion27 = true;
              var _didIteratorError27 = false;
              var _iteratorError27 = undefined;

              try {
                for (var _iterator27 = get_iterator_default()(row_list_item.content), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                  var content_item = _step27.value;

                  if (content_item.id == id) {
                    content_item.my_answer.splice(index, 1);
                  }
                }
              } catch (err) {
                _didIteratorError27 = true;
                _iteratorError27 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion27 && _iterator27.return) {
                    _iterator27.return();
                  }
                } finally {
                  if (_didIteratorError27) {
                    throw _iteratorError27;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError26 = true;
            _iteratorError26 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                _iterator26.return();
              }
            } finally {
              if (_didIteratorError26) {
                throw _iteratorError26;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }
    },

    //提交
    submitForm: function submitForm() {
      var _this3 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      //answer 
      var answer_list_arr = [];
      //图片上传
      var imgs_upload = [];
      // imgs_upload.push(this.tmpImageUpload);
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = get_iterator_default()(this.column_list), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var column_list_item = _step28.value;
          var _iteratorNormalCompletion29 = true;
          var _didIteratorError29 = false;
          var _iteratorError29 = undefined;

          try {
            for (var _iterator29 = get_iterator_default()(column_list_item.row_list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
              var row_list_item = _step29.value;
              var _iteratorNormalCompletion30 = true;
              var _didIteratorError30 = false;
              var _iteratorError30 = undefined;

              try {
                for (var _iterator30 = get_iterator_default()(row_list_item.content), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                  var content_item = _step30.value;


                  var obj = {
                    id: content_item.id,
                    answer: content_item.my_answer
                  };
                  if (content_item.type == "6") {
                    content_item.my_answer = this.replaceAllNewLine(content_item.my_answer);
                  }
                  if (content_item.type == "11" || content_item.type == '10') {
                    var _iteratorNormalCompletion31 = true;
                    var _didIteratorError31 = false;
                    var _iteratorError31 = undefined;

                    try {
                      for (var _iterator31 = get_iterator_default()(obj.answer), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                        var val = _step31.value;

                        var bold = '';
                        if (val.indexOf("http:") != -1 || val.indexOf("https:") != -1 || val.indexOf("Uploads/pad/") != -1) {
                          //  TODO:跨域，无法转dataurl
                          //  let url = Conf.baseUrl + val;
                          //   Util.convertImgToDataURLviaCanvas(url,function(res){
                          //     console.info('res:',res)
                          //   },"image/jpeg");
                          imgs_upload.push({
                            id: obj.id,
                            file: null,
                            url: val
                          });
                        } else {
                          bold = Util.dataURItoBlob(val);
                          imgs_upload.push({
                            id: obj.id,
                            file: bold
                          });
                        }
                      }
                    } catch (err) {
                      _didIteratorError31 = true;
                      _iteratorError31 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion31 && _iterator31.return) {
                          _iterator31.return();
                        }
                      } finally {
                        if (_didIteratorError31) {
                          throw _iteratorError31;
                        }
                      }
                    }

                    if (content_item.my_answer != '') {
                      answer_list_arr.push({
                        id: obj.id,
                        type: content_item.type
                      });
                    }
                  } else {
                    answer_list_arr.push(obj);
                  }
                }
              } catch (err) {
                _didIteratorError30 = true;
                _iteratorError30 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion30 && _iterator30.return) {
                    _iterator30.return();
                  }
                } finally {
                  if (_didIteratorError30) {
                    throw _iteratorError30;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError29 = true;
            _iteratorError29 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion29 && _iterator29.return) {
                _iterator29.return();
              }
            } finally {
              if (_didIteratorError29) {
                throw _iteratorError29;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        answer_list: answer_list_arr
      };
      console.info(answer_list_arr);
      Api.monthLiveApi.setMonthLive(params, imgs_upload).then(function (res) {
        if (res.errcode == 1) {
          _this3.$router.replace({
            path: '/success',
            query: {
              id: _this3.$route.query.id,
              name: 'month_live',
              tabVal: _this3.$route.query.tabVal
            }
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    this.apiMonthLive();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/month_live.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_month_live = ({
  name: 'month_live',
  components: {
    baseInfoHeader: src_components_base_info_header
  },
  data: function data() {
    return {
      indexList: '',
      showSearch: true,
      has_answer: '', //是否填过答案
      id: this.$route.query.id,
      member_column_list: [], //表单数组
      column_list: [], //表单数组
      is_drapList: false,
      //孕妇列表
      maternal_list: [],
      //签名
      is_edit: '', //是否显示
      tmpImageUpload: {},
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      host: api_const["host"],
      pinyin_array: []
    };
  },

  methods: {
    //获取查房人列表
    apiGetCfrList: function apiGetCfrList() {
      var _this = this;

      var params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id')
      };
      Api.checkRoomApi.getCheckInfo(params).then(function (res) {
        console.info("获取查房人列表");
        console.info(res);
        if (res.errcode == 1) {
          _this.cfr_list(res.data.nurser_name);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //替换所有换行符
    replaceAllNewLine: function replaceAllNewLine(content) {
      var string = content;
      try {
        string = string.replace(/\r\n/g, "<br>");
        string = string.replace(/\n/g, "<br>");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },


    //替换br成换行
    replaceAllBr: function replaceAllBr(content) {
      var string = content;
      try {
        string = string.replace("<br>", "\n").replace("<br>", "\n");
        string = string.replace("<br>", "\n");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },
    textareaBlur: function textareaBlur(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.column_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column_list_item = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(column_list_item.row_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var row_list_item = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = get_iterator_default()(row_list_item.content), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var content_item = _step3.value;

                  if (content_item.id == id) {
                    content_item.my_answer = this.replaceAllBr(content_item.my_answer);
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(arr), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    selece_cfr: function selece_cfr(name, id) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.column_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var column_list_item = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(column_list_item.row_list), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var row_list_item = _step6.value;
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = get_iterator_default()(row_list_item.content), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var content_item = _step7.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.indexList = '';
                  }
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    selectPeople: function selectPeople(id) {
      if (this.indexList) {
        this.indexList = '';
        return;
      }
      this.indexList = id;
    },
    arrar_sort: function arrar_sort(newArr, oldArr) {
      var newList = [];
      var pyArrSort = newArr.sort();
      var i = 0;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(pyArrSort), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = get_iterator_default()(oldArr), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var list = _step9.value;

              if (item == list.pinyin) {
                newList[i] = list;
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          i++;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return newList;
    },
    cfr_list: function cfr_list(arr) {
      if (arr.length) {
        var nurser_name_arr = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = get_iterator_default()(arr), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var item = _step10.value;

            var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
            var obj = {
              name: [item.user_name],
              pinyin: _py
            };
            nurser_name_arr.push(obj);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var pyArr = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = get_iterator_default()(nurser_name_arr), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var _item = _step11.value;

            var obj = {
              name: _item.name,
              pinyin: _item.pinyin
            };
            var is_have = this.isInArray(pyArr, _item.pinyin);
            if (!is_have) {
              //不存在
              pyArr.push(_item.pinyin);
              this.pinyin_array.push(_item.pinyin);
              this.pinyin_array.sort();
              this.maternal_list.push(obj);
            } else {
              //存在
              var _index = pyArr.indexOf(_item.pinyin);
              this.maternal_list[_index].name.push(_item.name.join(''));
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
        console.info(this.maternal_list);
      }
    },

    //请求孕妇表单配置信息
    apiMonthLive: function apiMonthLive() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.monthLiveApi.monthLive(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this2.has_answer = res.data.has_answer;
          _this2.member_column_list = res.data.column_list;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = get_iterator_default()(res.data.form_data.column_list), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var column_list_item = _step12.value;
              var _iteratorNormalCompletion13 = true;
              var _didIteratorError13 = false;
              var _iteratorError13 = undefined;

              try {
                for (var _iterator13 = get_iterator_default()(column_list_item.row_list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                  var row_list_item = _step13.value;
                  var _iteratorNormalCompletion14 = true;
                  var _didIteratorError14 = false;
                  var _iteratorError14 = undefined;

                  try {
                    for (var _iterator14 = get_iterator_default()(row_list_item.content), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                      var content_item = _step14.value;
                      var _iteratorNormalCompletion15 = true;
                      var _didIteratorError15 = false;
                      var _iteratorError15 = undefined;

                      try {
                        for (var _iterator15 = get_iterator_default()(_this2.member_column_list), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                          var item = _step15.value;

                          if (content_item.column_name == item.name) {
                            content_item.tip = item.value;
                            _this2.$vux.loading.hide();
                          }
                        }
                      } catch (err) {
                        _didIteratorError15 = true;
                        _iteratorError15 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion15 && _iterator15.return) {
                            _iterator15.return();
                          }
                        } finally {
                          if (_didIteratorError15) {
                            throw _iteratorError15;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                      }
                    } finally {
                      if (_didIteratorError14) {
                        throw _iteratorError14;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion13 && _iterator13.return) {
                    _iterator13.return();
                  }
                } finally {
                  if (_didIteratorError13) {
                    throw _iteratorError13;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          _this2.column_list = res.data.form_data.column_list;
          _this2.cfr_list(res.data.nurser_name);
          // this.apiGetCfrList()
          //孕妇列表
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //是否提交过答案
    editForm: function editForm() {
      this.has_answer = '2';
    },
    input_focus: function input_focus(id) {
      this.is_drapList = id;
    },
    menuClick: function menuClick(name, id) {
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = get_iterator_default()(this.column_list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var column_list_item = _step16.value;
          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = get_iterator_default()(column_list_item.row_list), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var row_list_item = _step17.value;
              var _iteratorNormalCompletion18 = true;
              var _didIteratorError18 = false;
              var _iteratorError18 = undefined;

              try {
                for (var _iterator18 = get_iterator_default()(row_list_item.content), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                  var content_item = _step18.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.is_drapList = '';
                  }
                }
              } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion18 && _iterator18.return) {
                    _iterator18.return();
                  }
                } finally {
                  if (_didIteratorError18) {
                    throw _iteratorError18;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }
    },

    //保存签名
    save: function save(id) {
      var signature = 'signature' + id;
      var png = this.$refs[signature][0].save();
      var jpeg = this.$refs[signature][0].save('image/jpeg');
      var svg = this.$refs[signature][0].save('image/svg+xml');
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = get_iterator_default()(this.column_list), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var column_list_item = _step19.value;
          var _iteratorNormalCompletion20 = true;
          var _didIteratorError20 = false;
          var _iteratorError20 = undefined;

          try {
            for (var _iterator20 = get_iterator_default()(column_list_item.row_list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
              var row_list_item = _step20.value;
              var _iteratorNormalCompletion21 = true;
              var _didIteratorError21 = false;
              var _iteratorError21 = undefined;

              try {
                for (var _iterator21 = get_iterator_default()(row_list_item.content), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                  var content_item = _step21.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [encodeURI(png)];
                    this.is_edit = '';
                  }
                }
              } catch (err) {
                _didIteratorError21 = true;
                _iteratorError21 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion21 && _iterator21.return) {
                    _iterator21.return();
                  }
                } finally {
                  if (_didIteratorError21) {
                    throw _iteratorError21;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError20 = true;
            _iteratorError20 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion20 && _iterator20.return) {
                _iterator20.return();
              }
            } finally {
              if (_didIteratorError20) {
                throw _iteratorError20;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }
    },

    //清除签名
    clear: function clear(id) {
      var signature = 'signature' + id;
      var refs = this.$refs[signature][0].clear();
    },

    //编辑签名
    edit_signature: function edit_signature(id) {
      this.is_edit = id;
    },

    //图片上传
    fileImage: function fileImage(e) {
      var file = e.target.files[0];
      var item_id = e.target.id;
      var that = this;
      lrz(file).then(function (rst) {
        // 处理成功会执行
        var _iteratorNormalCompletion22 = true;
        var _didIteratorError22 = false;
        var _iteratorError22 = undefined;

        try {
          for (var _iterator22 = get_iterator_default()(that.column_list), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
            var column_list_item = _step22.value;
            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
              for (var _iterator23 = get_iterator_default()(column_list_item.row_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                var row_list_item = _step23.value;
                var _iteratorNormalCompletion24 = true;
                var _didIteratorError24 = false;
                var _iteratorError24 = undefined;

                try {
                  for (var _iterator24 = get_iterator_default()(row_list_item.content), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                    var content_item = _step24.value;

                    if (content_item.id == item_id) {
                      if (content_item.my_answer.length == 10) {
                        that.$vux.toast.show({
                          type: 'cancel',
                          text: '最多上传10张图片'
                        });
                        return;
                      }
                      content_item.my_answer.push(rst.base64);
                    }
                  }
                } catch (err) {
                  _didIteratorError24 = true;
                  _iteratorError24 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion24 && _iterator24.return) {
                      _iterator24.return();
                    }
                  } finally {
                    if (_didIteratorError24) {
                      throw _iteratorError24;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError23 = true;
              _iteratorError23 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion23 && _iterator23.return) {
                  _iterator23.return();
                }
              } finally {
                if (_didIteratorError23) {
                  throw _iteratorError23;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError22 = true;
          _iteratorError22 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion22 && _iterator22.return) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError22) {
              throw _iteratorError22;
            }
          }
        }
      }).catch(function (err) {
        console.info(err);
        that.$vux.toast.show({
          type: 'cancel',
          text: '网络错误'
        });
        // 处理失败会执行
      });
    },

    //删除图片
    delImg: function delImg(index, id) {
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = get_iterator_default()(this.column_list), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var column_list_item = _step25.value;
          var _iteratorNormalCompletion26 = true;
          var _didIteratorError26 = false;
          var _iteratorError26 = undefined;

          try {
            for (var _iterator26 = get_iterator_default()(column_list_item.row_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
              var row_list_item = _step26.value;
              var _iteratorNormalCompletion27 = true;
              var _didIteratorError27 = false;
              var _iteratorError27 = undefined;

              try {
                for (var _iterator27 = get_iterator_default()(row_list_item.content), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                  var content_item = _step27.value;

                  if (content_item.id == id) {
                    content_item.my_answer.splice(index, 1);
                  }
                }
              } catch (err) {
                _didIteratorError27 = true;
                _iteratorError27 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion27 && _iterator27.return) {
                    _iterator27.return();
                  }
                } finally {
                  if (_didIteratorError27) {
                    throw _iteratorError27;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError26 = true;
            _iteratorError26 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                _iterator26.return();
              }
            } finally {
              if (_didIteratorError26) {
                throw _iteratorError26;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }
    },

    //提交
    submitForm: function submitForm() {
      var _this3 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      //answer 
      var answer_list_arr = [];
      //图片上传
      var imgs_upload = [];
      // imgs_upload.push(this.tmpImageUpload);
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = get_iterator_default()(this.column_list), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var column_list_item = _step28.value;
          var _iteratorNormalCompletion29 = true;
          var _didIteratorError29 = false;
          var _iteratorError29 = undefined;

          try {
            for (var _iterator29 = get_iterator_default()(column_list_item.row_list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
              var row_list_item = _step29.value;
              var _iteratorNormalCompletion30 = true;
              var _didIteratorError30 = false;
              var _iteratorError30 = undefined;

              try {
                for (var _iterator30 = get_iterator_default()(row_list_item.content), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                  var content_item = _step30.value;


                  var obj = {
                    id: content_item.id,
                    answer: content_item.my_answer
                  };
                  if (content_item.type == "6") {
                    content_item.my_answer = this.replaceAllNewLine(content_item.my_answer);
                  }
                  if (content_item.type == "11" || content_item.type == '10') {
                    var _iteratorNormalCompletion31 = true;
                    var _didIteratorError31 = false;
                    var _iteratorError31 = undefined;

                    try {
                      for (var _iterator31 = get_iterator_default()(obj.answer), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                        var val = _step31.value;

                        var bold = '';
                        if (val.indexOf("http:") != -1 || val.indexOf("https:") != -1 || val.indexOf("Uploads/pad/") != -1) {
                          //  TODO:跨域，无法转dataurl
                          //  let url = Conf.baseUrl + val;
                          //   Util.convertImgToDataURLviaCanvas(url,function(res){
                          //     console.info('res:',res)
                          //   },"image/jpeg");
                          imgs_upload.push({
                            id: obj.id,
                            file: null,
                            url: val
                          });
                        } else {
                          bold = Util.dataURItoBlob(val);
                          imgs_upload.push({
                            id: obj.id,
                            file: bold
                          });
                        }
                      }
                    } catch (err) {
                      _didIteratorError31 = true;
                      _iteratorError31 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion31 && _iterator31.return) {
                          _iterator31.return();
                        }
                      } finally {
                        if (_didIteratorError31) {
                          throw _iteratorError31;
                        }
                      }
                    }

                    if (content_item.my_answer != '') {
                      answer_list_arr.push({
                        id: obj.id,
                        type: content_item.type
                      });
                    }
                  } else {
                    answer_list_arr.push(obj);
                  }
                }
              } catch (err) {
                _didIteratorError30 = true;
                _iteratorError30 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion30 && _iterator30.return) {
                    _iterator30.return();
                  }
                } finally {
                  if (_didIteratorError30) {
                    throw _iteratorError30;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError29 = true;
            _iteratorError29 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion29 && _iterator29.return) {
                _iterator29.return();
              }
            } finally {
              if (_didIteratorError29) {
                throw _iteratorError29;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        answer_list: answer_list_arr
      };
      console.info(answer_list_arr);
      Api.monthLiveApi.setMonthLive(params, imgs_upload).then(function (res) {
        if (res.errcode == 1) {
          _this3.$router.replace({
            path: '/success',
            query: {
              id: _this3.$route.query.id,
              name: 'month_live',
              tabVal: _this3.$route.query.tabVal
            }
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    this.apiMonthLive();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd59a0d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/month_live.vue
var month_live_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("妈妈入住评估表")]),_vm._v(" "),_c('div',{staticClass:"month_main"},[_c('base-info-header',{attrs:{"maternalId":_vm.id}}),_vm._v(" "),(_vm.has_answer == '1')?_c('div',[_c('div',{staticClass:"over-height"},_vm._l((_vm.column_list),function(column_list_item,index){return (column_list_item.is_show_column == 1)?_c('group',{key:index,attrs:{"title":column_list_item.column_name,"label-width":"10em"}},_vm._l((column_list_item.row_list),function(row_list_item,index){return _c('div',{key:index},_vm._l((row_list_item.content),function(content_item,index){return _c('div',{key:index,staticClass:"vux-1px-b"},[(content_item.type == '1')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):(content_item.question == '' && row_list_item.title == '')?_c('x-input',{attrs:{"title":content_item.tip+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '2')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 4px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"4px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px"}},[_vm._v("\n                        "+_vm._s(content_item.my_answer[0])+"\n                      ")])])])]):_vm._e(),_vm._v(" "),(content_item.type == '3')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},_vm._l((content_item.my_answer),function(val,index){return _c('div',{key:index,staticStyle:{"display":"inline-block","line-height":"36px"}},[_vm._v(_vm._s(val)+"，")])}),0)])]):_vm._e(),_vm._v(" "),(content_item.type == '4')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '5')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '6')?_c('div',[(content_item.question)?_c('x-textarea',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-textarea',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '7')?_c('div',[_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '8')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '9')?_c('div',[_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.detail_tip),callback:function ($$v) {_vm.$set(content_item, "detail_tip", $$v)},expression:"content_item.detail_tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '10')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),(content_item.my_answer[0])?_c('div',{staticStyle:{"line-height":"36px","flex":"1"}},[(content_item.my_answer[0].length>100)?_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}}):_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":_vm.host+content_item.my_answer[0],"alt":""}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(content_item.type == '11')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',[(content_item.my_answer.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((content_item.my_answer),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}})])}),0):_vm._e()])])]):_vm._e(),_vm._v(" "),(content_item.type == '12')?_c('div',[(content_item.question)?_c('cell',{attrs:{"title":content_item.question+ '：',"value-align":"left"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('cell',{attrs:{"title":row_list_item.title+ '：',"value-align":"left"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e()])}),0)}),0):_vm._e()}),1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"15px"},attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.editForm.apply(null, arguments)}}},[_vm._v("修改")])],1):_c('div',[_c('div',{staticClass:"over-height"},_vm._l((_vm.column_list),function(column_list_item,index){return (column_list_item.is_show_column == 1)?_c('group',{key:index,attrs:{"title":column_list_item.column_name,"label-width":"9em"}},_vm._l((column_list_item.row_list),function(row_list_item,index){return _c('div',{key:index},_vm._l((row_list_item.content),function(content_item,index){return _c('div',{key:index,staticClass:"vux-1px-b"},[(content_item.type == '1')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"placeholder":content_item.tip+content_item.unit},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):(content_item.question == '' && row_list_item.title == '')?_c('x-input',{attrs:{"title":content_item.tip+ '：',"placeholder":content_item.tip+content_item.unit},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip+content_item.unit},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '2')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}},_vm._l((content_item.answer),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '3')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(content_item.my_answer),callback:function ($$v) {_vm.$set(content_item, "my_answer", $$v)},expression:"content_item.my_answer"}},_vm._l((content_item.answer),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '4')?_c('div',[(content_item.question)?_c('selector',{attrs:{"title":content_item.question,"options":content_item.answer,"placeholder":content_item.tip+content_item.unit},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('selector',{attrs:{"title":row_list_item.title,"options":content_item.answer,"placeholder":content_item.tip+content_item.unit},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '5')?_c('div',[_c('datetime',{attrs:{"start-date":"1900-01-01","title":content_item.question,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '6')?_c('div',[(content_item.question)?_c('x-textarea',{attrs:{"title":content_item.question,"placeholder":content_item.tip+content_item.unit},on:{"on-blur":function($event){return _vm.textareaBlur(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-textarea',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip+content_item.unit},on:{"on-blur":function($event){return _vm.textareaBlur(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '7')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":"","placeholder":content_item.tip+content_item.unit},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}}):_c('x-input',{attrs:{"title":row_list_item.title,"disabled":"","placeholder":content_item.tip+content_item.unit},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '8')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"placeholder":content_item.tip+content_item.unit},on:{"on-focus":function($event){return _vm.input_focus(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip+content_item.unit,"id":content_item.id},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_drapList == content_item.id),expression:"is_drapList == content_item.id"}],staticClass:"drapList vux-1px"},_vm._l((content_item.answer),function(option,index){return _c('cell',{key:index,attrs:{"value":option,"value-align":"left"},nativeOn:{"click":function($event){return _vm.menuClick(option,content_item.id)}}})}),1)],1):_vm._e(),_vm._v(" "),(content_item.type == '9')?_c('div',[_c('x-input',{attrs:{"title":content_item.question,"disabled":"","placeholder":content_item.tip+content_item.unit},model:{value:(content_item.detail_tip),callback:function ($$v) {_vm.$set(content_item, "detail_tip", $$v)},expression:"content_item.detail_tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '10')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","flex":"1"}},[(_vm.is_edit != content_item.id)?_c('div',[(content_item.my_answer[0])?_c('div',[(content_item.my_answer[0].length>100)?_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}}):_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":_vm.host+content_item.my_answer[0],"alt":""}})]):_c('div',[_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"t_r pd-10"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit_signature(content_item.id)}}},[_vm._v("编辑签名")])],1)]):_c('div',[_c('vueSignature',{ref:'signature' + content_item.id,refInFor:true,staticClass:"vueSignature",attrs:{"sigOption":_vm.option,"w":'100%',"h":'400px'}}),_vm._v(" "),_c('div',{staticClass:"t_r pd-10"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save(content_item.id)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear(content_item.id)}}},[_vm._v("清除")])],1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '11')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png","id":content_item.id},on:{"change":_vm.fileImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})])]),_vm._v(" "),(content_item.my_answer.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((content_item.my_answer),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[(item.length>100)?_c('img',{staticClass:"img",attrs:{"src":item,"width":"84","height":"84","alt":""}}):_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(index,content_item.id)}}})])}),0):_vm._e()])])]):_vm._e(),_vm._v(" "),(content_item.type == '12')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px","position":"relative"}},[(content_item.question)?_c('div',{staticStyle:{"width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('div',{staticStyle:{"display":"flex"}},[(content_item.my_answer[0])?_c('div',{staticStyle:{"line-height":"29px","margin-right":"10px"}},[_vm._v(_vm._s(content_item.my_answer[0]))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople(content_item.id)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"},{name:"show",rawName:"v-show",value:(_vm.indexList == content_item.id),expression:"indexList == content_item.id"}],staticClass:"mtIndexList"},[_c('div',{staticStyle:{"text-align":"right","padding-right":"24px"}},[_c('x-button',{attrs:{"type":"default","mini":""},nativeOn:{"click":function($event){_vm.indexList = ''}}},[_vm._v("关闭")])],1),_vm._v(" "),_c('ul',{staticClass:"mtIndexListBox"},[_vm._l((_vm.maternal_list),function(item){return _c('li',{key:item.pinyin,attrs:{"id":item.pinyin}},[_c('p',{staticClass:"index_title"},[_vm._v(_vm._s(item.pinyin))]),_vm._v(" "),_c('dl',{staticStyle:{"padding-right":"30px"}},_vm._l((item.name),function(option,index){return _c('dd',{key:index,staticStyle:{"display":"inline-block"}},[_c('a',{staticStyle:{"display":"inline-block","color":"#333","padding":"10px 20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.selece_cfr(option,content_item.id)}}},[_vm._v(_vm._s(option))])])}),0)])}),_vm._v(" "),_c('div',{staticClass:"fixed_right_pinyin"},_vm._l((_vm.pinyin_array),function(item,index){return _c('a',{key:index,attrs:{"href":'#'+ item}},[_vm._v(_vm._s(item))])}),0)],2)])])])])]):_vm._e()])}),0)}),0):_vm._e()}),1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"15px"},attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)],1)}
var month_live_staticRenderFns = []
var month_live_esExports = { render: month_live_render, staticRenderFns: month_live_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_month_live = (month_live_esExports);
// CONCATENATED MODULE: ./src/components/month_live.vue
function month_live_injectStyle (ssrContext) {
  __webpack_require__("bsmt")
}
var month_live_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var month_live___vue_template_functional__ = false
/* styles */
var month_live___vue_styles__ = month_live_injectStyle
/* scopeId */
var month_live___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var month_live___vue_module_identifier__ = null
var month_live_Component = month_live_normalizeComponent(
  components_month_live,
  selectortype_template_index_0_src_components_month_live,
  month_live___vue_template_functional__,
  month_live___vue_styles__,
  month_live___vue_scopeId__,
  month_live___vue_module_identifier__
)

/* harmony default export */ var src_components_month_live = (month_live_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/success.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var success = ({
  name: 'success',
  data: function data() {
    return {
      buttons: [],
      back_home_link: '',
      detail_link: ''
    };
  },

  methods: {
    backHomeClick: function backHomeClick() {
      this.$router.replace(this.back_home_link);
    },
    seeDetailClick: function seeDetailClick() {
      this.$router.replace(this.detail_link);
    }
  },
  created: function created() {
    this.back_home_link = '/maternal_service?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;

    var name = this.$route.query.name;
    console.log(name);
    switch (name) {
      case 'month_live':
        this.detail_link = '/month_live?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'add_from_record':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'detail_other_form':
        this.detail_link = 'detail_other_form?answer_id=' + this.$route.query.answer_id + '&form_id=' + this.$route.query.form_id + '&id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'baby_live':
        this.detail_link = '/baby_live?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'other_form_detail':
        this.detail_link = '/other_form_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal + '&form_id=' + this.$route.query.form_id;
        break;
      // case 'bb_form_a':
      // this.detail_link = './bb_form?a=2'
      case 'bb_form_f':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_b':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_c':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_a':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_b':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_c':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_d':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_a':
        this.detail_link = './maternal_form_a_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_a_edit':
        this.detail_link = './maternal_form_a_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_e':
        this.detail_link = '/bb_form_e_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_e_edit':
        this.detail_link = '/bb_form_e_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_d':
        this.detail_link = '/bb_form_d_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_d_edit':
        this.detail_link = '/bb_form_d_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_one':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_two':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_three':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_four':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_six':
        this.detail_link = '/christmas_form_six_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_six_edit':
        this.detail_link = '/christmas_form_six_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_seven':
        this.detail_link = '/christmas_form_seven_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_seven_edit':
        this.detail_link = '/christmas_form_seven_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_eight':
        this.detail_link = '/christmas_form_eight_detail?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_eight_edit':
        this.detail_link = '/christmas_form_eight_detail?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'medicine_commissioned':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'basic_nursing':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/success.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_success = ({
  name: 'success',
  data: function data() {
    return {
      buttons: [],
      back_home_link: '',
      detail_link: ''
    };
  },

  methods: {
    backHomeClick: function backHomeClick() {
      this.$router.replace(this.back_home_link);
    },
    seeDetailClick: function seeDetailClick() {
      this.$router.replace(this.detail_link);
    }
  },
  created: function created() {
    this.back_home_link = '/maternal_service?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;

    var name = this.$route.query.name;
    console.log(name);
    switch (name) {
      case 'month_live':
        this.detail_link = '/month_live?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'add_from_record':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'detail_other_form':
        this.detail_link = 'detail_other_form?answer_id=' + this.$route.query.answer_id + '&form_id=' + this.$route.query.form_id + '&id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'baby_live':
        this.detail_link = '/baby_live?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'other_form_detail':
        this.detail_link = '/other_form_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal + '&form_id=' + this.$route.query.form_id;
        break;
      // case 'bb_form_a':
      // this.detail_link = './bb_form?a=2'
      case 'bb_form_f':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_b':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_c':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_a':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_b':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_c':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_d':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_a':
        this.detail_link = './maternal_form_a_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_a_edit':
        this.detail_link = './maternal_form_a_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_e':
        this.detail_link = '/bb_form_e_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_e_edit':
        this.detail_link = '/bb_form_e_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_d':
        this.detail_link = '/bb_form_d_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_d_edit':
        this.detail_link = '/bb_form_d_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_one':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_two':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_three':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_four':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_six':
        this.detail_link = '/christmas_form_six_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_six_edit':
        this.detail_link = '/christmas_form_six_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_seven':
        this.detail_link = '/christmas_form_seven_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_seven_edit':
        this.detail_link = '/christmas_form_seven_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_eight':
        this.detail_link = '/christmas_form_eight_detail?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_eight_edit':
        this.detail_link = '/christmas_form_eight_detail?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'medicine_commissioned':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'basic_nursing':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8602ba2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/success.vue
var success_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('msg',[_c('template',{slot:"buttons"},[_c('h2',{staticClass:"weui-msg__title"},[_vm._v("数据更新成功")]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.backHomeClick.apply(null, arguments)}}},[_vm._v("返回主页")]),_vm._v(" "),_c('x-button',{nativeOn:{"click":function($event){return _vm.seeDetailClick.apply(null, arguments)}}},[_vm._v("查看详情")])],1)],2)],1)}
var success_staticRenderFns = []
var success_esExports = { render: success_render, staticRenderFns: success_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_success = (success_esExports);
// CONCATENATED MODULE: ./src/components/success.vue
var success_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var success___vue_template_functional__ = false
/* styles */
var success___vue_styles__ = null
/* scopeId */
var success___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var success___vue_module_identifier__ = null
var success_Component = success_normalizeComponent(
  components_success,
  selectortype_template_index_0_src_components_success,
  success___vue_template_functional__,
  success___vue_styles__,
  success___vue_scopeId__,
  success___vue_module_identifier__
)

/* harmony default export */ var src_components_success = (success_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_file.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var pulldownDefaultConfig = {
  content: '下拉刷新',
  height: 40,
  autoRefresh: false,
  downContent: '下拉刷新',
  upContent: '释放后刷新',
  loadingContent: '正在刷新...',
  clsPrefix: 'xs-plugin-pulldown-'
};
var pullupDefaultConfig = {
  content: '上拉加载更多',
  pullUpHeight: 60,
  height: 40,
  autoRefresh: false,
  downContent: '释放后加载',
  upContent: '上拉加载更多',
  loadingContent: '加载中...',
  clsPrefix: 'xs-plugin-pullup-'
  // import BScroll from "better-scroll";
};/* harmony default export */ var maternal_file = ({
  name: 'maternal_file',
  data: function data() {
    return {
      confirm_show: false,
      buttonTabVal: 0,
      results: [],
      keyword: '',
      panel_type: '1',
      memberList: [],
      floor_arr: [],
      sort: '2',
      sort_text: '倒序',
      page: '1',
      pullupDefaultConfig: pullupDefaultConfig,
      pulldownDefaultConfig: pulldownDefaultConfig
    };
  },

  methods: {
    //查看30天内离院的客户
    go_leave_custom: function go_leave_custom() {
      this.$router.push({
        path: './leave_custom_list'
      });
    },
    toBatch: function toBatch() {
      this.$router.push({
        path: './batch_service'
      });
    },

    //倒序顺序
    sortSearchBtn: function sortSearchBtn() {
      if (this.sort == '2') {
        this.sort = '1';
        this.sort_text = '顺序';
        this.refresh();
        return;
      }
      if (this.sort == '1') {
        this.sort = '2';
        this.sort_text = '倒序';
        this.refresh();
        return;
      }
    },

    //tab切换
    tabChange: function tabChange(index) {
      var that = this;
      this.buttonTabVal = index;
      this.keyword = '';
      if (index == 1) {
        this.sort = '1';
      }
      this.refresh();
    },
    panelClick: function panelClick(item) {
      this.$router.push({
        path: './maternal_service',
        query: {
          id: item.id
        }
      });
    },

    //时间戳转日期格式
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },

    //点击搜索
    searchBtn: function searchBtn() {
      var that = this;
      this.$nextTick(function () {
        that.$refs.scrollerBottom.reset({ top: 0 });
        that.refresh();
      });
    },

    //清空搜索
    clearSearch: function clearSearch() {
      this.keyword = '';
      this.refresh();
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },

    //请求数据
    apiMemberList: function apiMemberList(str) {
      var _this = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var that = this;
      var params = {
        token: this.$cookie.get('token'),
        type: '4',
        keyword: this.keyword,
        rule: this.buttonTabVal == 0 ? '1' : '2',
        sort: this.sort,
        page: this.page
      };
      console.info(params);
      Api.memberListApi.memberList(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this.page++;
          _this.$nextTick(function () {
            that.$refs.scrollerBottom.reset();
          });
          if (res.data.list.length) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(res.data.list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                var list_arr = [];
                if (item.list.length) {
                  var _iteratorNormalCompletion3 = true;
                  var _didIteratorError3 = false;
                  var _iteratorError3 = undefined;

                  try {
                    for (var _iterator3 = get_iterator_default()(item.list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                      var option = _step3.value;

                      var _desc = '电话：' + option.phone + '&nbsp;&nbsp;&nbsp;&nbsp;时间：' + _this.formatDateTime(option.live_time) + '&nbsp;&nbsp;&nbsp;&nbsp;套餐：' + option.package_name + '&nbsp;&nbsp;&nbsp;&nbsp;房号：' + option.room_name;
                      var options = {
                        id: option.id,
                        src: __webpack_require__("ptd0"),
                        fallbackSrc: __webpack_require__("ptd0"),
                        title: option.name,
                        desc: _desc,
                        phone: option.phone,
                        package: option.package_name
                      };
                      list_arr.push(options);
                    }
                  } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                      }
                    } finally {
                      if (_didIteratorError3) {
                        throw _iteratorError3;
                      }
                    }
                  }
                }
                var obj = {
                  floor: item.floor,
                  key: item.key,
                  list: list_arr
                };
                var is_have = _this.isInArray(_this.floor_arr, item.floor);
                if (!is_have) {
                  //楼层不在数组
                  _this.floor_arr.push(item.floor);
                  _this.memberList.push(obj);
                } else {
                  //存在楼层
                  var _index = _this.floor_arr.indexOf(item.floor);
                  var _iteratorNormalCompletion4 = true;
                  var _didIteratorError4 = false;
                  var _iteratorError4 = undefined;

                  try {
                    for (var _iterator4 = get_iterator_default()(obj.list), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                      var val = _step4.value;

                      _this.memberList[_index].list.push(val);
                    }
                  } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                      }
                    } finally {
                      if (_didIteratorError4) {
                        throw _iteratorError4;
                      }
                    }
                  }
                }
                _this.$refs.scrollerBottom.donePullup();
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (str == 'refresh') {
              _this.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
              _this.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
            }
            if (res.data.page.page == res.data.page.page_count) {
              _this.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
            } else {
              _this.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
            }
          }
          _this.$vux.loading.hide();
        } else {
          _this.$vux.loading.hide();
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //下拉刷新
    refresh: function refresh() {
      this.memberList = [];
      this.page = '1';
      this.floor_arr = [];
      this.apiMemberList('refresh');
    },

    //上拉加载
    loadMore: function loadMore() {
      this.apiMemberList();
    },
    goBack: function goBack() {
      this.confirm_show = true;
    },
    onConfirm: function onConfirm() {
      this.$router.push({
        path: '/'
      });
      this.$cookie.set('token', '');
      this.$cookie.set('id', '');
    },

    //判断手机横竖屏状态：
    hengshuping: function hengshuping() {
      if (window.orientation == 180 || window.orientation == 0) {
        alert('请使用横屏才能达到最佳浏览效果');
      }
    }
  },
  created: function created() {
    // let that = this
    // this.$nextTick(() => {
    //     that.$refs.scrollerBottom.reset({top: 0})
    // })
    this.apiMemberList();
    // 添加事件监听
    // window.addEventListener('orientationchange',function(){
    //     that.hengshuping()
    // },false);
    // window.onscroll = function(){
    //     //变量scrollTop是滚动条滚动时，距离顶部的距离
    //     // var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //     //变量windowHeight是可视区的高度
    //     var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
    //     //变量scrollHeight是滚动条的总高度
    //     var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight
    //     //滚动条到底部的条件
    //     if(scrollTop+windowHeight==scrollHeight){
    //         //写后台加载数据的函数
    //         // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight)
    //         that.loadMore()
    //     }
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_file.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var maternal_file_pulldownDefaultConfig = {
  content: '下拉刷新',
  height: 40,
  autoRefresh: false,
  downContent: '下拉刷新',
  upContent: '释放后刷新',
  loadingContent: '正在刷新...',
  clsPrefix: 'xs-plugin-pulldown-'
};
var maternal_file_pullupDefaultConfig = {
  content: '上拉加载更多',
  pullUpHeight: 60,
  height: 40,
  autoRefresh: false,
  downContent: '释放后加载',
  upContent: '上拉加载更多',
  loadingContent: '加载中...',
  clsPrefix: 'xs-plugin-pullup-'
  // import BScroll from "better-scroll";
};/* harmony default export */ var components_maternal_file = ({
  name: 'maternal_file',
  data: function data() {
    return {
      confirm_show: false,
      buttonTabVal: 0,
      results: [],
      keyword: '',
      panel_type: '1',
      memberList: [],
      floor_arr: [],
      sort: '2',
      sort_text: '倒序',
      page: '1',
      pullupDefaultConfig: maternal_file_pullupDefaultConfig,
      pulldownDefaultConfig: maternal_file_pulldownDefaultConfig
    };
  },

  methods: {
    //查看30天内离院的客户
    go_leave_custom: function go_leave_custom() {
      this.$router.push({
        path: './leave_custom_list'
      });
    },
    toBatch: function toBatch() {
      this.$router.push({
        path: './batch_service'
      });
    },

    //倒序顺序
    sortSearchBtn: function sortSearchBtn() {
      if (this.sort == '2') {
        this.sort = '1';
        this.sort_text = '顺序';
        this.refresh();
        return;
      }
      if (this.sort == '1') {
        this.sort = '2';
        this.sort_text = '倒序';
        this.refresh();
        return;
      }
    },

    //tab切换
    tabChange: function tabChange(index) {
      var that = this;
      this.buttonTabVal = index;
      this.keyword = '';
      if (index == 1) {
        this.sort = '1';
      }
      this.refresh();
    },
    panelClick: function panelClick(item) {
      this.$router.push({
        path: './maternal_service',
        query: {
          id: item.id
        }
      });
    },

    //时间戳转日期格式
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },

    //点击搜索
    searchBtn: function searchBtn() {
      var that = this;
      this.$nextTick(function () {
        that.$refs.scrollerBottom.reset({ top: 0 });
        that.refresh();
      });
    },

    //清空搜索
    clearSearch: function clearSearch() {
      this.keyword = '';
      this.refresh();
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },

    //请求数据
    apiMemberList: function apiMemberList(str) {
      var _this = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var that = this;
      var params = {
        token: this.$cookie.get('token'),
        type: '4',
        keyword: this.keyword,
        rule: this.buttonTabVal == 0 ? '1' : '2',
        sort: this.sort,
        page: this.page
      };
      console.info(params);
      Api.memberListApi.memberList(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this.page++;
          _this.$nextTick(function () {
            that.$refs.scrollerBottom.reset();
          });
          if (res.data.list.length) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(res.data.list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                var list_arr = [];
                if (item.list.length) {
                  var _iteratorNormalCompletion3 = true;
                  var _didIteratorError3 = false;
                  var _iteratorError3 = undefined;

                  try {
                    for (var _iterator3 = get_iterator_default()(item.list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                      var option = _step3.value;

                      var _desc = '电话：' + option.phone + '&nbsp;&nbsp;&nbsp;&nbsp;时间：' + _this.formatDateTime(option.live_time) + '&nbsp;&nbsp;&nbsp;&nbsp;套餐：' + option.package_name + '&nbsp;&nbsp;&nbsp;&nbsp;房号：' + option.room_name;
                      var options = {
                        id: option.id,
                        src: __webpack_require__("ptd0"),
                        fallbackSrc: __webpack_require__("ptd0"),
                        title: option.name,
                        desc: _desc,
                        phone: option.phone,
                        package: option.package_name
                      };
                      list_arr.push(options);
                    }
                  } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                      }
                    } finally {
                      if (_didIteratorError3) {
                        throw _iteratorError3;
                      }
                    }
                  }
                }
                var obj = {
                  floor: item.floor,
                  key: item.key,
                  list: list_arr
                };
                var is_have = _this.isInArray(_this.floor_arr, item.floor);
                if (!is_have) {
                  //楼层不在数组
                  _this.floor_arr.push(item.floor);
                  _this.memberList.push(obj);
                } else {
                  //存在楼层
                  var _index = _this.floor_arr.indexOf(item.floor);
                  var _iteratorNormalCompletion4 = true;
                  var _didIteratorError4 = false;
                  var _iteratorError4 = undefined;

                  try {
                    for (var _iterator4 = get_iterator_default()(obj.list), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                      var val = _step4.value;

                      _this.memberList[_index].list.push(val);
                    }
                  } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                      }
                    } finally {
                      if (_didIteratorError4) {
                        throw _iteratorError4;
                      }
                    }
                  }
                }
                _this.$refs.scrollerBottom.donePullup();
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (str == 'refresh') {
              _this.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
              _this.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
            }
            if (res.data.page.page == res.data.page.page_count) {
              _this.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
            } else {
              _this.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
            }
          }
          _this.$vux.loading.hide();
        } else {
          _this.$vux.loading.hide();
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //下拉刷新
    refresh: function refresh() {
      this.memberList = [];
      this.page = '1';
      this.floor_arr = [];
      this.apiMemberList('refresh');
    },

    //上拉加载
    loadMore: function loadMore() {
      this.apiMemberList();
    },
    goBack: function goBack() {
      this.confirm_show = true;
    },
    onConfirm: function onConfirm() {
      this.$router.push({
        path: '/'
      });
      this.$cookie.set('token', '');
      this.$cookie.set('id', '');
    },

    //判断手机横竖屏状态：
    hengshuping: function hengshuping() {
      if (window.orientation == 180 || window.orientation == 0) {
        alert('请使用横屏才能达到最佳浏览效果');
      }
    }
  },
  created: function created() {
    // let that = this
    // this.$nextTick(() => {
    //     that.$refs.scrollerBottom.reset({top: 0})
    // })
    this.apiMemberList();
    // 添加事件监听
    // window.addEventListener('orientationchange',function(){
    //     that.hengshuping()
    // },false);
    // window.onscroll = function(){
    //     //变量scrollTop是滚动条滚动时，距离顶部的距离
    //     // var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //     //变量windowHeight是可视区的高度
    //     var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
    //     //变量scrollHeight是滚动条的总高度
    //     var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight
    //     //滚动条到底部的条件
    //     if(scrollTop+windowHeight==scrollHeight){
    //         //写后台加载数据的函数
    //         // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight)
    //         that.loadMore()
    //     }
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ffa831c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_file.vue
var maternal_file_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{
      showBack: true,
      preventGoBack: true,
      backText: '退出登录',
    }},on:{"on-click-back":_vm.goBack}},[_vm._v("产妇档案"),_c('a',{attrs:{"slot":"right"},on:{"click":_vm.go_leave_custom},slot:"right"},[_vm._v("查看30天内离院的客户")])]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"search-content"},[_c('button-tab',{model:{value:(_vm.buttonTabVal),callback:function ($$v) {_vm.buttonTabVal=$$v},expression:"buttonTabVal"}},[_c('button-tab-item',{on:{"on-item-click":_vm.tabChange}},[_vm._v("按楼层展示")]),_vm._v(" "),_c('button-tab-item',{on:{"on-item-click":_vm.tabChange}},[_vm._v("按入住时间展示")])],1),_vm._v(" "),_c('group',[_c('x-input',{attrs:{"placeholder":"请输入姓名、手机号、房间号进行搜索"},on:{"on-click-clear-icon":_vm.clearSearch},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}},[_c('x-button',{attrs:{"slot":"right","gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.searchBtn.apply(null, arguments)}},slot:"right"},[_vm._v("搜索")]),_vm._v(" "),_c('x-button',{staticClass:"sortSearchBtn",attrs:{"slot":"right","gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.sortSearchBtn.apply(null, arguments)}},slot:"right"},[_vm._v(_vm._s(_vm.sort_text))]),_vm._v(" "),_c('x-button',{staticClass:"sortSearchBtn",attrs:{"slot":"right","gradients":['#F0B22D', '#F0B22D'],"mini":""},nativeOn:{"click":function($event){return _vm.toBatch.apply(null, arguments)}},slot:"right"},[_vm._v("批量操作")])],1)],1)],1),_vm._v(" "),_c('scroller',{ref:"scrollerBottom",attrs:{"use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"use-pulldown":"","pulldown-config":_vm.pulldownDefaultConfig,"lock-x":"","height":"-135"},on:{"on-pullup-loading":_vm.loadMore,"on-pulldown-loading":_vm.refresh}},[_c('div',_vm._l((_vm.memberList),function(item,index){return _c('panel',{key:index,staticClass:"sheng-panel",attrs:{"header":item.floor,"id":item.floor,"list":item.list,"type":_vm.panel_type},on:{"on-click-item":_vm.panelClick}})}),1)]),_vm._v(" "),(_vm.floor_arr.length)?_c('div',{staticClass:"position_fixed"},_vm._l((_vm.floor_arr),function(item,index){return _c('a',{key:index,staticClass:"floor",attrs:{"href":'#' + item}},[_vm._v(_vm._s(item))])}),0):_vm._e()],1),_vm._v(" "),_c('confirm',{attrs:{"title":"信息提示"},on:{"on-confirm":_vm.onConfirm},model:{value:(_vm.confirm_show),callback:function ($$v) {_vm.confirm_show=$$v},expression:"confirm_show"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("退出登录？")])])],1)}
var maternal_file_staticRenderFns = []
var maternal_file_esExports = { render: maternal_file_render, staticRenderFns: maternal_file_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_file = (maternal_file_esExports);
// CONCATENATED MODULE: ./src/components/maternal_file.vue
function maternal_file_injectStyle (ssrContext) {
  __webpack_require__("zQxN")
}
var maternal_file_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_file___vue_template_functional__ = false
/* styles */
var maternal_file___vue_styles__ = maternal_file_injectStyle
/* scopeId */
var maternal_file___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_file___vue_module_identifier__ = null
var maternal_file_Component = maternal_file_normalizeComponent(
  components_maternal_file,
  selectortype_template_index_0_src_components_maternal_file,
  maternal_file___vue_template_functional__,
  maternal_file___vue_styles__,
  maternal_file___vue_scopeId__,
  maternal_file___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_file = (maternal_file_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_service.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var maternal_service = ({
    name: 'maternal_service',
    data: function data() {
        return {
            buttonTabVal: 0,
            base_info: {
                id: this.$route.query.id,
                member_id: '', // 会员ID，从用户基本信息中获取
                name: '',
                phone: '',
                package: '',
                macheck_id: '',
                leave_id: '', //出院
                checklist_id: '', //月子期间医院就诊单
                order_total_id: '' //订单ID
            },
            baby_list: []
        };
    },

    methods: {
        toFormEight: function toFormEight(item) {
            console.info(item);
            if (item.live_time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝未入住'
                });
                return;
            }
            if (item.foot_id == '') {
                this.$router.push({
                    path: './christmas_form_eight',
                    query: {
                        id: this.base_info.id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal
                    }
                });
            } else {
                this.$router.push({
                    path: './christmas_form_eight_detail',
                    query: {
                        id: this.base_info.id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal
                    }
                });
            }
        },
        toFormE: function toFormE(item) {
            // :link="item.ch_id==''?'./bb_form_e?id='+ base_info.id+'&child_id='+item.id +'&tabVal=' + buttonTabVal 
            // : './bb_form_e_detail?id='+ base_info.id + '&form_id='+item.ch_id+'&child_id='+item.id +'&tabVal=' + buttonTabVal "
            console.info(item);
            if (item.live_time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝未入住'
                });
                return;
            }
            if (item.ch_id == '') {
                this.$router.push({
                    path: './bb_form_e',
                    query: {
                        id: this.base_info.id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal,
                        baby_name: item.name,
                        baby_sex: item.sex == '1' ? '男' : '女'
                    }
                });
            } else {
                this.$router.push({
                    path: './bb_form_e_detail',
                    query: {
                        id: this.base_info.id,
                        form_id: item.ch_id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal
                    }
                });
            }
        },
        toFormD: function toFormD(item) {
            //     link="item.full_id==''?'./bb_form_d?id='+ base_info.id+'&child_id='+item.id +'&tabVal=' + buttonTabVal : 
            //    './bb_form_d_detail' +'?id='+ base_info.id + '&form_id='+item.full_id+'&child_id='+item.id +'&tabVal=' + buttonTabVal " 
            console.info(item);
            if (item.live_time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝未入住'
                });
                return;
            }
            if (item.full_id == '') {
                this.$router.push({
                    path: './bb_form_d',
                    query: {
                        id: this.base_info.id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal,
                        baby_name: item.name,
                        baby_sex: item.sex == '1' ? '男' : '女'
                    }
                });
            } else {
                this.$router.push({
                    path: './bb_form_d_detail',
                    query: {
                        id: this.base_info.id,
                        form_id: item.full_id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal
                    }
                });
            }
        },

        //tab切换
        tabChange: function tabChange(index) {
            this.buttonTabVal = index;
        },
        toSpecial: function toSpecial() {
            // 打印 base_info 的全部信息
            console.log('base_info 全部信息：', this.base_info);
            console.log('base_info.member_id：', this.base_info.member_id);
            console.log('base_info.id：', this.base_info.id);
            console.log('base_info.name：', this.base_info.name);
            console.log('base_info.phone：', this.base_info.phone);
            console.log('base_info.order_total_id：', this.base_info.order_total_id);

            this.$router.push({
                path: './maternal_special',
                query: {
                    id: this.$route.query.id, // route.query.id 是 maternal_info_id
                    member_id: this.base_info.member_id, // member_id 从用户基本信息中获取
                    tabVal: this.buttonTabVal,
                    maternal_info_id: this.$route.query.id, // maternal_info_id 就是 route.query.id
                    store_id: this.$cookie.get('store_id'), // 从 Cookie 获取 store_id
                    order_total_id: this.base_info.order_total_id || '' // 从 base_info 获取 order_total_id
                }
            });
        },
        toSpecialRoom: function toSpecialRoom() {
            // 打印 base_info 的全部信息
            console.log('base_info 全部信息：', this.base_info);
            console.log('base_info.member_id：', this.base_info.member_id);
            console.log('base_info.id：', this.base_info.id);
            console.log('base_info.name：', this.base_info.name);
            console.log('base_info.phone：', this.base_info.phone);
            console.log('base_info.order_total_id：', this.base_info.order_total_id);

            this.$router.push({
                path: './maternal_special_room',
                query: {
                    id: this.$route.query.id, // route.query.id 是 maternal_info_id
                    member_id: this.base_info.member_id, // member_id 从用户基本信息中获取
                    tabVal: this.buttonTabVal,
                    maternal_info_id: this.$route.query.id, // maternal_info_id 就是 route.query.id
                    store_id: this.$cookie.get('store_id'), // 从 Cookie 获取 store_id
                    order_total_id: this.base_info.order_total_id || '' // 从 base_info 获取 order_total_id
                }
            });
        },
        toSpecialMeal: function toSpecialMeal() {
            // 打印 base_info 的全部信息
            console.log('base_info 全部信息：', this.base_info);
            console.log('base_info.member_id：', this.base_info.member_id);
            console.log('base_info.id：', this.base_info.id);
            console.log('base_info.name：', this.base_info.name);
            console.log('base_info.phone：', this.base_info.phone);
            console.log('base_info.order_total_id：', this.base_info.order_total_id);

            this.$router.push({
                path: './maternal_special_meal',
                query: {
                    id: this.$route.query.id, // route.query.id 是 maternal_info_id
                    member_id: this.base_info.member_id, // member_id 从用户基本信息中获取
                    tabVal: this.buttonTabVal,
                    maternal_info_id: this.$route.query.id, // maternal_info_id 就是 route.query.id
                    store_id: this.$cookie.get('store_id'), // 从 Cookie 获取 store_id
                    order_total_id: this.base_info.order_total_id || '' // 从 base_info 获取 order_total_id
                }
            });
        },
        get_baby_list: function get_baby_list() {
            var _this = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info('宝宝基本信息', res);
                if (res.errcode == 1) {
                    _this.baby_list = res.data;
                    _this.$vux.loading.hide();
                } else {
                    _this.$vux.loading.hide();
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info('用户基本信息', res);
                console.info('用户基本信息 - 完整返回数据:', stringify_default()(res.data, null, 2));
                if (res.errcode == 1) {
                    _this2.base_info.member_id = res.data.member_id || res.data.id || ''; // 会员ID
                    _this2.base_info.name = res.data.name;
                    _this2.base_info.phone = res.data.phone;
                    _this2.base_info.package = res.data.package_name;
                    _this2.base_info.macheck_id = res.data.macheck_id;
                    _this2.base_info.leave_id = res.data.leave_id;
                    _this2.base_info.checklist_id = res.data.checklist_id;
                    _this2.base_info.order_total_id = res.data.order_total_id;
                    // // 检查是否有 order_total_id
                    // if(res.data.order_total_id){
                    //     this.base_info.order_total_id = res.data.order_total_id
                    //     console.info('找到 order_total_id:', res.data.order_total_id)
                    // } else {
                    //     console.warn('API 返回数据中没有 order_total_id 字段')
                    //     console.info('API 返回的所有字段:', Object.keys(res.data))
                    // }
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_file'
            });
        }
    },
    created: function created() {
        this.get_baby_list();
        this.apiMemberInfo();
        for (var i = 0; i < 4; i++) {
            if (this.$route.query.tabVal == i) {
                this.buttonTabVal = i;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_service.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_maternal_service = ({
    name: 'maternal_service',
    data: function data() {
        return {
            buttonTabVal: 0,
            base_info: {
                id: this.$route.query.id,
                member_id: '', // 会员ID，从用户基本信息中获取
                name: '',
                phone: '',
                package: '',
                macheck_id: '',
                leave_id: '', //出院
                checklist_id: '', //月子期间医院就诊单
                order_total_id: '' //订单ID
            },
            baby_list: []
        };
    },

    methods: {
        toFormEight: function toFormEight(item) {
            console.info(item);
            if (item.live_time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝未入住'
                });
                return;
            }
            if (item.foot_id == '') {
                this.$router.push({
                    path: './christmas_form_eight',
                    query: {
                        id: this.base_info.id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal
                    }
                });
            } else {
                this.$router.push({
                    path: './christmas_form_eight_detail',
                    query: {
                        id: this.base_info.id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal
                    }
                });
            }
        },
        toFormE: function toFormE(item) {
            // :link="item.ch_id==''?'./bb_form_e?id='+ base_info.id+'&child_id='+item.id +'&tabVal=' + buttonTabVal 
            // : './bb_form_e_detail?id='+ base_info.id + '&form_id='+item.ch_id+'&child_id='+item.id +'&tabVal=' + buttonTabVal "
            console.info(item);
            if (item.live_time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝未入住'
                });
                return;
            }
            if (item.ch_id == '') {
                this.$router.push({
                    path: './bb_form_e',
                    query: {
                        id: this.base_info.id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal,
                        baby_name: item.name,
                        baby_sex: item.sex == '1' ? '男' : '女'
                    }
                });
            } else {
                this.$router.push({
                    path: './bb_form_e_detail',
                    query: {
                        id: this.base_info.id,
                        form_id: item.ch_id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal
                    }
                });
            }
        },
        toFormD: function toFormD(item) {
            //     link="item.full_id==''?'./bb_form_d?id='+ base_info.id+'&child_id='+item.id +'&tabVal=' + buttonTabVal : 
            //    './bb_form_d_detail' +'?id='+ base_info.id + '&form_id='+item.full_id+'&child_id='+item.id +'&tabVal=' + buttonTabVal " 
            console.info(item);
            if (item.live_time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝未入住'
                });
                return;
            }
            if (item.full_id == '') {
                this.$router.push({
                    path: './bb_form_d',
                    query: {
                        id: this.base_info.id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal,
                        baby_name: item.name,
                        baby_sex: item.sex == '1' ? '男' : '女'
                    }
                });
            } else {
                this.$router.push({
                    path: './bb_form_d_detail',
                    query: {
                        id: this.base_info.id,
                        form_id: item.full_id,
                        child_id: item.id,
                        tabVal: this.buttonTabVal
                    }
                });
            }
        },

        //tab切换
        tabChange: function tabChange(index) {
            this.buttonTabVal = index;
        },
        toSpecial: function toSpecial() {
            // 打印 base_info 的全部信息
            console.log('base_info 全部信息：', this.base_info);
            console.log('base_info.member_id：', this.base_info.member_id);
            console.log('base_info.id：', this.base_info.id);
            console.log('base_info.name：', this.base_info.name);
            console.log('base_info.phone：', this.base_info.phone);
            console.log('base_info.order_total_id：', this.base_info.order_total_id);

            this.$router.push({
                path: './maternal_special',
                query: {
                    id: this.$route.query.id, // route.query.id 是 maternal_info_id
                    member_id: this.base_info.member_id, // member_id 从用户基本信息中获取
                    tabVal: this.buttonTabVal,
                    maternal_info_id: this.$route.query.id, // maternal_info_id 就是 route.query.id
                    store_id: this.$cookie.get('store_id'), // 从 Cookie 获取 store_id
                    order_total_id: this.base_info.order_total_id || '' // 从 base_info 获取 order_total_id
                }
            });
        },
        toSpecialRoom: function toSpecialRoom() {
            // 打印 base_info 的全部信息
            console.log('base_info 全部信息：', this.base_info);
            console.log('base_info.member_id：', this.base_info.member_id);
            console.log('base_info.id：', this.base_info.id);
            console.log('base_info.name：', this.base_info.name);
            console.log('base_info.phone：', this.base_info.phone);
            console.log('base_info.order_total_id：', this.base_info.order_total_id);

            this.$router.push({
                path: './maternal_special_room',
                query: {
                    id: this.$route.query.id, // route.query.id 是 maternal_info_id
                    member_id: this.base_info.member_id, // member_id 从用户基本信息中获取
                    tabVal: this.buttonTabVal,
                    maternal_info_id: this.$route.query.id, // maternal_info_id 就是 route.query.id
                    store_id: this.$cookie.get('store_id'), // 从 Cookie 获取 store_id
                    order_total_id: this.base_info.order_total_id || '' // 从 base_info 获取 order_total_id
                }
            });
        },
        toSpecialMeal: function toSpecialMeal() {
            // 打印 base_info 的全部信息
            console.log('base_info 全部信息：', this.base_info);
            console.log('base_info.member_id：', this.base_info.member_id);
            console.log('base_info.id：', this.base_info.id);
            console.log('base_info.name：', this.base_info.name);
            console.log('base_info.phone：', this.base_info.phone);
            console.log('base_info.order_total_id：', this.base_info.order_total_id);

            this.$router.push({
                path: './maternal_special_meal',
                query: {
                    id: this.$route.query.id, // route.query.id 是 maternal_info_id
                    member_id: this.base_info.member_id, // member_id 从用户基本信息中获取
                    tabVal: this.buttonTabVal,
                    maternal_info_id: this.$route.query.id, // maternal_info_id 就是 route.query.id
                    store_id: this.$cookie.get('store_id'), // 从 Cookie 获取 store_id
                    order_total_id: this.base_info.order_total_id || '' // 从 base_info 获取 order_total_id
                }
            });
        },
        get_baby_list: function get_baby_list() {
            var _this = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info('宝宝基本信息', res);
                if (res.errcode == 1) {
                    _this.baby_list = res.data;
                    _this.$vux.loading.hide();
                } else {
                    _this.$vux.loading.hide();
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info('用户基本信息', res);
                console.info('用户基本信息 - 完整返回数据:', stringify_default()(res.data, null, 2));
                if (res.errcode == 1) {
                    _this2.base_info.member_id = res.data.member_id || res.data.id || ''; // 会员ID
                    _this2.base_info.name = res.data.name;
                    _this2.base_info.phone = res.data.phone;
                    _this2.base_info.package = res.data.package_name;
                    _this2.base_info.macheck_id = res.data.macheck_id;
                    _this2.base_info.leave_id = res.data.leave_id;
                    _this2.base_info.checklist_id = res.data.checklist_id;
                    _this2.base_info.order_total_id = res.data.order_total_id;
                    // // 检查是否有 order_total_id
                    // if(res.data.order_total_id){
                    //     this.base_info.order_total_id = res.data.order_total_id
                    //     console.info('找到 order_total_id:', res.data.order_total_id)
                    // } else {
                    //     console.warn('API 返回数据中没有 order_total_id 字段')
                    //     console.info('API 返回的所有字段:', Object.keys(res.data))
                    // }
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_file'
            });
        }
    },
    created: function created() {
        this.get_baby_list();
        this.apiMemberInfo();
        for (var i = 0; i < 4; i++) {
            if (this.$route.query.tabVal == i) {
                this.buttonTabVal = i;
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a62afb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_service.vue
var maternal_service_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true,backText:'孕妇档案'}},on:{"on-click-back":_vm.goBack}},[_vm._v("妈妈和宝宝服务")]),_vm._v(" "),_c('div',{staticClass:"service_main"},[_c('button-tab',{staticStyle:{"margin-bottom":"10px"},model:{value:(_vm.buttonTabVal),callback:function ($$v) {_vm.buttonTabVal=$$v},expression:"buttonTabVal"}},[_c('button-tab-item',{on:{"on-item-click":_vm.tabChange}},[_vm._v("妈妈服务")]),_vm._v(" "),_vm._l((_vm.baby_list),function(item){return _c('button-tab-item',{key:item.id,on:{"on-item-click":_vm.tabChange}},[_vm._v(_vm._s(item.name)+"服务")])})],2),_vm._v(" "),(_vm.buttonTabVal == 0)?_c('div',[_c('flexbox',{staticClass:"base_info"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo t_c"},[_vm._v("妈妈姓名："+_vm._s(_vm.base_info.name))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo t_c"},[_vm._v("电话："+_vm._s(_vm.base_info.phone))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo t_c"},[_vm._v("套餐："+_vm._s(_vm.base_info.package))])])],1),_vm._v(" "),_c('group-title',[_vm._v("妈妈服务列表")]),_vm._v(" "),_c('grid',{staticClass:"grid",attrs:{"cols":5}},[_c('grid-item',{attrs:{"label":"查房服务","link":'./check_room_service?id=' + this.$route.query.id + '&tabVal=' + _vm.buttonTabVal}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("at4z")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{attrs:{"label":"项目安排"}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("UiQC")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{attrs:{"label":"项目操作"}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("BQKN")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{attrs:{"label":"其他表单","link":'./other_form_list?id=' + this.$route.query.id + '&tabVal=' + _vm.buttonTabVal}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("skRI")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{staticStyle:{"background":"#f5f5f5"},attrs:{"label":"母亲入住评估单","link":_vm.base_info.macheck_id==''?'./maternal_form_a?id='+ _vm.base_info.id + '&tabVal=' + _vm.buttonTabVal :'./maternal_form_a_detail?id='+ _vm.base_info.id+'&form_id='+_vm.base_info.macheck_id+ '&tabVal=' + _vm.buttonTabVal}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("skRI")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{staticStyle:{"background":"#f5f5f5"},attrs:{"label":"出所指导","link":'./christmas_form_five?id='+ _vm.base_info.id + '&tabVal=' + _vm.buttonTabVal}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("skRI")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{staticStyle:{"background":"#f5f5f5"},attrs:{"label":"出院证明","link":_vm.base_info.leave_id!=''?'./christmas_form_six_detail?id='+ _vm.base_info.id + '&tabVal=' + _vm.buttonTabVal:'./christmas_form_six?id='+ _vm.base_info.id + '&tabVal=' + _vm.buttonTabVal}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("skRI")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{staticStyle:{"background":"#f5f5f5"},attrs:{"label":"月子期间医院就诊检查单黏贴处","link":_vm.base_info.checklist_id!=''?'./christmas_form_seven_detail?id='+ _vm.base_info.id + '&tabVal=' + _vm.buttonTabVal:'./christmas_form_seven?id='+ _vm.base_info.id + '&tabVal=' + _vm.buttonTabVal}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("skRI")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{staticStyle:{"background":"#f5f5f5"},attrs:{"label":"特情上报(护理)"},on:{"on-item-click":function($event){return _vm.toSpecial()}}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("UiQC")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{staticStyle:{"background":"#f5f5f5"},attrs:{"label":"特情上报(客房)"},on:{"on-item-click":function($event){return _vm.toSpecialRoom()}}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("UiQC")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{staticStyle:{"background":"#f5f5f5"},attrs:{"label":"特情上报(餐饮)"},on:{"on-item-click":function($event){return _vm.toSpecialMeal()}}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("UiQC")},slot:"icon"})])],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.baby_list),function(item,index){return _c('div',{key:item.id},[(_vm.buttonTabVal == index+1)?_c('div',[_c('flexbox',{staticClass:"base_info"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo t_c"},[_vm._v("宝宝姓名："+_vm._s(item.name))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo t_c"},[_vm._v("妈妈姓名："+_vm._s(_vm.base_info.name))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo t_c"},[_vm._v("电话："+_vm._s(_vm.base_info.phone))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo t_c"},[_vm._v("套餐："+_vm._s(_vm.base_info.package))])])],1),_vm._v(" "),_c('group-title',[_vm._v("宝宝服务列表")]),_vm._v(" "),_c('grid',{staticClass:"grid",attrs:{"cols":5}},[_c('grid-item',{attrs:{"label":"宝宝入住评估","link":'./baby_live?id='+ _vm.base_info.id + '&child_id=' + item.id + '&tabVal=' + _vm.buttonTabVal}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("Vizg")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{attrs:{"label":"服药登记","link":'./baby_medication_list?id='+ _vm.base_info.id + '&child_id=' + item.id + '&tabVal=' + _vm.buttonTabVal}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("UeZg")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{attrs:{"label":"项目操作"}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("iJRN")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{attrs:{"label":"体质记录","link":'./baby_sign_list?id='+ _vm.base_info.id + '&child_id=' + item.id + '&tabVal=' + _vm.buttonTabVal}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("n37m")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{attrs:{"label":"母乳存放","link":'./baby_breast_milk_list?id='+ _vm.base_info.id + '&child_id=' + item.id + '&tabVal=' + _vm.buttonTabVal}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("W9Hj")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{attrs:{"label":"喂养记录","link":'./baby_feed_list?id='+ _vm.base_info.id + '&child_id=' + item.id + '&tabVal=' + _vm.buttonTabVal}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("RsuY")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{staticStyle:{"background":"#f5f5f5"},attrs:{"label":"新生儿入住评估单"},on:{"on-item-click":function($event){return _vm.toFormE(item)}}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("Vizg")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{staticStyle:{"background":"#f5f5f5"},attrs:{"label":"新生儿满月评估单"},on:{"on-item-click":function($event){return _vm.toFormD(item)}}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("Vizg")},slot:"icon"})]),_vm._v(" "),_c('grid-item',{staticStyle:{"background":"#f5f5f5"},attrs:{"label":"宝宝足印（出/入会所）"},on:{"on-item-click":function($event){return _vm.toFormEight(item)}}},[_c('img',{attrs:{"slot":"icon","src":__webpack_require__("Vizg")},slot:"icon"})])],1)],1):_vm._e()])})],2)],1)}
var maternal_service_staticRenderFns = []
var maternal_service_esExports = { render: maternal_service_render, staticRenderFns: maternal_service_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_service = (maternal_service_esExports);
// CONCATENATED MODULE: ./src/components/maternal_service.vue
function maternal_service_injectStyle (ssrContext) {
  __webpack_require__("7jM4")
}
var maternal_service_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_service___vue_template_functional__ = false
/* styles */
var maternal_service___vue_styles__ = maternal_service_injectStyle
/* scopeId */
var maternal_service___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_service___vue_module_identifier__ = null
var maternal_service_Component = maternal_service_normalizeComponent(
  components_maternal_service,
  selectortype_template_index_0_src_components_maternal_service,
  maternal_service___vue_template_functional__,
  maternal_service___vue_styles__,
  maternal_service___vue_scopeId__,
  maternal_service___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_service = (maternal_service_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_special.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var maternal_special = ({
  name: 'maternal_special',
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      tag: '',
      warning_level: '1', // 预警等级：1-低级（默认），2-中级，3-高级，4-紧急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],
      remark: '',
      agent_list: [],
      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      agent_id: '' }, defineProperty_default()(_ref, 'agent_list', []), defineProperty_default()(_ref, 'department_id', 786), defineProperty_default()(_ref, 'departmentSelected', ''), defineProperty_default()(_ref, 'positionSelected', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'showAgentPicker', false), defineProperty_default()(_ref, 'postdepartment', []), defineProperty_default()(_ref, 'departments', []), defineProperty_default()(_ref, 'department', ''), defineProperty_default()(_ref, 'positions', []), defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },


  methods: {
    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },
    confirm: function confirm() {
      var _params,
          _this = this;

      // 日期已经有默认值，不需要再检查是否为空
      // if (this.date == '') {
      //   this.$vux.toast.show({
      //     type: 'cancel',
      //     text: '请选择日期',
      //   });
      //   return false;
      // }

      // 验证汇报人是否已选择
      // 检查 agent_id 是否为空字符串、null、undefined
      // 注意：使用 == '' 可以同时匹配 '' 和 null/undefined，但为了更严格，使用 ===
      var agentIdEmpty = this.agent_id === '' || this.agent_id === null || this.agent_id === undefined || String(this.agent_id).trim() === '';

      if (agentIdEmpty) {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择汇报人'
        });
        return false;
      }

      if (this.tag == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择特殊标签'
        });
        return false;
      }

      if (this.remark == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请填写备注'
        });
        return false;
      }

      this.$vux.loading.show({
        text: '正在提交'
      });
      var params = (_params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        date: this.date
      }, defineProperty_default()(_params, 'department_id', this.department_id), defineProperty_default()(_params, 'agent_id', this.agent_id), defineProperty_default()(_params, 'tag_id', this.tag), defineProperty_default()(_params, 'warning_level', this.warning_level), defineProperty_default()(_params, 'remark', this.remark), defineProperty_default()(_params, 'agent_ids', this.selectAgent.map(function (agent) {
        return agent.id;
      })), _params);
      // console.log('params', params);
      Api.otherFormApi.specialReportAdd(params).then(function (res) {
        // console.log('res', res);
        _this.$vux.loading.hide();

        if (res.errcode == 1) {
          _this.$vux.toast.show({
            type: 'success',
            text: '提交成功'
          });

          setTimeout(function () {
            _this.goBack();
          }, 1000);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      }).catch(function (err) {
        // console.error('API 请求失败:', err);
        _this.$vux.loading.hide();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        _this.$vux.toast.show({
          type: 'cancel',
          text: errorMsg
        });
      });
    },
    apiSpecialReport: function apiSpecialReport() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
        // 调用 API 获取特情上报相关数据（汇报人列表、特殊标签列表）
      };Api.otherFormApi.getSpecialReport(params).then(function (res) {
        // console.log('res', res);
        // 接口返回成功（errcode == 1 表示成功）
        if (res.errcode == 1) {
          // 清空现有数据，避免数据残留
          _this2.tag_List = [];
          _this2.agent_list = [];

          // 从接口返回数据中获取汇报人列表和特殊标签列表
          _this2.agent_list = res.data.agent_list;
          _this2.tag_List = res.data.tag_List;

          // 为特殊标签列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.name）
          _this2.tag_List.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });

          // 为汇报人列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.user_name）
          _this2.agent_list.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });

          // 检查当前用户是否在汇报人列表中
          // 如果 agent_id 已设置（在 created 钩子中默认设置为当前登录用户ID）
          if (_this2.agent_id) {
            // console.log('this.agent_id', this.agent_id)
            // 在汇报人列表中查找当前用户
            var currentAgent = _this2.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this2.agent_id);
            });
            // console.log('currentAgent', currentAgent)

            if (currentAgent) {
              // 如果当前用户在列表中，说明可以正常显示和选择
              // 注意：这里不需要设置 agent_id，因为它已经在 created 钩子中设置为当前用户ID了
              // 选择器组件会自动根据 agent_id 的值匹配对应的选项
            } else {
              // 如果当前用户不在汇报人列表中，清空 agent_id，让用户手动选择
              // 这样可以避免选择器显示异常（选中一个不在选项中的值）
              _this2.agent_id = '';
              console.log('当前用户不在汇报人列表中，已清空默认选择');

              // 注意：由于 selector 组件使用了 v-model="agent_id"（第7行），
              // Vue 的响应式系统会自动检测到 agent_id 的变化并更新组件显示
              // 不需要手动调用 $forceUpdate() 或 $nextTick()，v-model 会自动处理更新
            }
          }

          // 隐藏加载提示
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiDeportment: function apiDeportment() {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this3.departments = res.data;
          _this3.departments.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiAgentList: function apiAgentList() {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this4.agents = res.data;
          _this4.agents.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });
          _this4.$vux.loading.hide();
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this5 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: department_id
      };
      Api.otherFormApi.getPositionList(params).then(function (res) {
        if (res.errcode == 1) {
          _this5.positions = res.data;
          _this5.positions.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this5.$vux.loading.hide();
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
    },
    chooseAgent: function chooseAgent() {
      // 实现员工选择逻辑

    },
    cancel: function cancel() {
      // 实现取消逻辑
      this.goBack();
    },
    submitForm: function submitForm() {},
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    changeAgents: function changeAgents(value, key) {
      this.selectAgId = value;
      console.log(value, key);
    },
    dialog_confirm: function dialog_confirm() {
      var _this6 = this;

      this.showChangeAgentPanel = false;
      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this6.selectAgId;
      });
      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);
    },
    changeDepartment: function changeDepartment(value) {
      console.log('选择了部门', value);
      this.selectDpId = value;
      this.apiPostionList(value);
    },
    changePositions: function changePositions(value) {
      console.log('选择了职位', value);
      this.selectPsId = value;
      this.apiAgentList();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    },

    //转base64
    convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], {
        type: 'image/png'
      });
    }
  },
  created: function created() {
    // 默认设置汇报人为当前登录用户
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }

    this.apiSpecialReport();
    this.apiDeportment();
    // this.apiAgentList();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_special.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_maternal_special = ({
  name: 'maternal_special',
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      tag: '',
      warning_level: '1', // 预警等级：1-低级（默认），2-中级，3-高级，4-紧急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],
      remark: '',
      agent_list: [],
      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      agent_id: '' }, defineProperty_default()(_ref, 'agent_list', []), defineProperty_default()(_ref, 'department_id', 786), defineProperty_default()(_ref, 'departmentSelected', ''), defineProperty_default()(_ref, 'positionSelected', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'showAgentPicker', false), defineProperty_default()(_ref, 'postdepartment', []), defineProperty_default()(_ref, 'departments', []), defineProperty_default()(_ref, 'department', ''), defineProperty_default()(_ref, 'positions', []), defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },


  methods: {
    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },
    confirm: function confirm() {
      var _params,
          _this = this;

      // 日期已经有默认值，不需要再检查是否为空
      // if (this.date == '') {
      //   this.$vux.toast.show({
      //     type: 'cancel',
      //     text: '请选择日期',
      //   });
      //   return false;
      // }

      // 验证汇报人是否已选择
      // 检查 agent_id 是否为空字符串、null、undefined
      // 注意：使用 == '' 可以同时匹配 '' 和 null/undefined，但为了更严格，使用 ===
      var agentIdEmpty = this.agent_id === '' || this.agent_id === null || this.agent_id === undefined || String(this.agent_id).trim() === '';

      if (agentIdEmpty) {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择汇报人'
        });
        return false;
      }

      if (this.tag == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择特殊标签'
        });
        return false;
      }

      if (this.remark == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请填写备注'
        });
        return false;
      }

      this.$vux.loading.show({
        text: '正在提交'
      });
      var params = (_params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        date: this.date
      }, defineProperty_default()(_params, 'department_id', this.department_id), defineProperty_default()(_params, 'agent_id', this.agent_id), defineProperty_default()(_params, 'tag_id', this.tag), defineProperty_default()(_params, 'warning_level', this.warning_level), defineProperty_default()(_params, 'remark', this.remark), defineProperty_default()(_params, 'agent_ids', this.selectAgent.map(function (agent) {
        return agent.id;
      })), _params);
      // console.log('params', params);
      Api.otherFormApi.specialReportAdd(params).then(function (res) {
        // console.log('res', res);
        _this.$vux.loading.hide();

        if (res.errcode == 1) {
          _this.$vux.toast.show({
            type: 'success',
            text: '提交成功'
          });

          setTimeout(function () {
            _this.goBack();
          }, 1000);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      }).catch(function (err) {
        // console.error('API 请求失败:', err);
        _this.$vux.loading.hide();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        _this.$vux.toast.show({
          type: 'cancel',
          text: errorMsg
        });
      });
    },
    apiSpecialReport: function apiSpecialReport() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
        // 调用 API 获取特情上报相关数据（汇报人列表、特殊标签列表）
      };Api.otherFormApi.getSpecialReport(params).then(function (res) {
        // console.log('res', res);
        // 接口返回成功（errcode == 1 表示成功）
        if (res.errcode == 1) {
          // 清空现有数据，避免数据残留
          _this2.tag_List = [];
          _this2.agent_list = [];

          // 从接口返回数据中获取汇报人列表和特殊标签列表
          _this2.agent_list = res.data.agent_list;
          _this2.tag_List = res.data.tag_List;

          // 为特殊标签列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.name）
          _this2.tag_List.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });

          // 为汇报人列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.user_name）
          _this2.agent_list.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });

          // 检查当前用户是否在汇报人列表中
          // 如果 agent_id 已设置（在 created 钩子中默认设置为当前登录用户ID）
          if (_this2.agent_id) {
            // console.log('this.agent_id', this.agent_id)
            // 在汇报人列表中查找当前用户
            var currentAgent = _this2.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this2.agent_id);
            });
            // console.log('currentAgent', currentAgent)

            if (currentAgent) {
              // 如果当前用户在列表中，说明可以正常显示和选择
              // 注意：这里不需要设置 agent_id，因为它已经在 created 钩子中设置为当前用户ID了
              // 选择器组件会自动根据 agent_id 的值匹配对应的选项
            } else {
              // 如果当前用户不在汇报人列表中，清空 agent_id，让用户手动选择
              // 这样可以避免选择器显示异常（选中一个不在选项中的值）
              _this2.agent_id = '';
              console.log('当前用户不在汇报人列表中，已清空默认选择');

              // 注意：由于 selector 组件使用了 v-model="agent_id"（第7行），
              // Vue 的响应式系统会自动检测到 agent_id 的变化并更新组件显示
              // 不需要手动调用 $forceUpdate() 或 $nextTick()，v-model 会自动处理更新
            }
          }

          // 隐藏加载提示
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiDeportment: function apiDeportment() {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this3.departments = res.data;
          _this3.departments.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiAgentList: function apiAgentList() {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this4.agents = res.data;
          _this4.agents.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });
          _this4.$vux.loading.hide();
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this5 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: department_id
      };
      Api.otherFormApi.getPositionList(params).then(function (res) {
        if (res.errcode == 1) {
          _this5.positions = res.data;
          _this5.positions.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this5.$vux.loading.hide();
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
    },
    chooseAgent: function chooseAgent() {
      // 实现员工选择逻辑

    },
    cancel: function cancel() {
      // 实现取消逻辑
      this.goBack();
    },
    submitForm: function submitForm() {},
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    changeAgents: function changeAgents(value, key) {
      this.selectAgId = value;
      console.log(value, key);
    },
    dialog_confirm: function dialog_confirm() {
      var _this6 = this;

      this.showChangeAgentPanel = false;
      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this6.selectAgId;
      });
      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);
    },
    changeDepartment: function changeDepartment(value) {
      console.log('选择了部门', value);
      this.selectDpId = value;
      this.apiPostionList(value);
    },
    changePositions: function changePositions(value) {
      console.log('选择了职位', value);
      this.selectPsId = value;
      this.apiAgentList();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    },

    //转base64
    convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], {
        type: 'image/png'
      });
    }
  },
  created: function created() {
    // 默认设置汇报人为当前登录用户
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }

    this.apiSpecialReport();
    this.apiDeportment();
    // this.apiAgentList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e1901e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_special.vue
var maternal_special_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{ showBack: true, preventGoBack: true, backText: '孕妇档案' }},on:{"on-click-back":_vm.goBack}},[_vm._v("特情上报(护理)")]),_vm._v(" "),_c('group',[_c('datetime',{attrs:{"title":"日期："},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('selector',{attrs:{"title":"汇报人：","options":_vm.agent_list,"required":""},model:{value:(_vm.agent_id),callback:function ($$v) {_vm.agent_id=$$v},expression:"agent_id"}}),_vm._v(" "),_c('selector',{attrs:{"title":"特殊标签：","options":_vm.tag_List,"required":""},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"备注：","placeholder":"500字（含）以内","required":""},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}}),_vm._v(" "),_c('div',{staticClass:"warning-level-group"},[_c('div',{staticClass:"weui-label warning-level-label"},[_vm._v("预警等级：")]),_vm._v(" "),_c('div',{staticClass:"tag-group"},[_c('checker',{attrs:{"default-item-class":"tag-item","selected-item-class":"tag-item-selected"},model:{value:(_vm.warning_level),callback:function ($$v) {_vm.warning_level=$$v},expression:"warning_level"}},_vm._l((_vm.warningLevelOptions),function(item){return _c('checker-item',{key:item.value,attrs:{"value":item.value}},[_vm._v("\n              "+_vm._s(item.label)+"\n            ")])}),1)],1)])],1),_vm._v(" "),_c('group',[_c('cell',{attrs:{"is-link":"","title":"上报给："},nativeOn:{"click":function($event){return _vm.showChageAgent.apply(null, arguments)}}},[_vm._v("添加")]),_vm._v(" "),_vm._l((_vm.selectAgent),function(agent,index){return _c('div',{key:index,staticClass:"agent-tag"},[_c('x-button',{attrs:{"type":"primary","plain":"","mini":""}},[_vm._v(_vm._s(agent.name))]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-close-empty",attrs:{"type":"ios-close-empty","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 512 512"},on:{"click":function($event){return _vm.removeAgent(agent.id)}}},[_c('path',{staticClass:"st0",attrs:{"d":"M340.2 160l-84.4 84.3-84-83.9-11.8 11.8 84 83.8-84 83.9 11.8 11.7 84-83.8 84.4 84.2 11.8-11.7-84.4-84.3 84.4-84.2z"}})])],1)}),_vm._v(" "),(_vm.showChangeAgentPanel)?_c('cell-box',[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"center","justify-items":"center"}},[_c('selector',{attrs:{"title":"部门","placeholder":"选择","options":_vm.departments},on:{"on-change":_vm.changeDepartment},model:{value:(_vm.department),callback:function ($$v) {_vm.department=$$v},expression:"department"}}),_vm._v(" "),_c('selector',{attrs:{"title":"职位","placeholder":"选择","options":_vm.positions},on:{"on-change":_vm.changePositions},model:{value:(_vm.position),callback:function ($$v) {_vm.position=$$v},expression:"position"}}),_vm._v(" "),_c('selector',{attrs:{"title":"员工","placeholder":"选择","options":_vm.agents},on:{"on-change":_vm.changeAgents},model:{value:(_vm.agent),callback:function ($$v) {_vm.agent=$$v},expression:"agent"}}),_vm._v(" "),_c('flexbox',{staticStyle:{"width":"200px"}},[_c('flexbox-item',{staticStyle:{"padding":"10px"}},[_c('x-button',{staticClass:"b_btn_style",attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"type":"default","action-type":"submit","mini":""},nativeOn:{"click":function($event){return _vm.dialog_confirm.apply(null, arguments)}}},[_vm._v("确认")])],1),_vm._v(" "),_c('flexbox-item',{staticStyle:{"padding":"10px"}},[_c('x-button',{staticClass:"b_btn_style",attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.dialog_cancel.apply(null, arguments)}}},[_vm._v("取消")])],1)],1)],1)]):_vm._e()],2),_vm._v(" "),_c('div',{staticStyle:{"padding":"30px","display":"flex","flex-direction":"row"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm.apply(null, arguments)}}},[_vm._v("确定")])],1)],1)}
var maternal_special_staticRenderFns = []
var maternal_special_esExports = { render: maternal_special_render, staticRenderFns: maternal_special_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_special = (maternal_special_esExports);
// CONCATENATED MODULE: ./src/components/maternal_special.vue
function maternal_special_injectStyle (ssrContext) {
  __webpack_require__("KdGT")
}
var maternal_special_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_special___vue_template_functional__ = false
/* styles */
var maternal_special___vue_styles__ = maternal_special_injectStyle
/* scopeId */
var maternal_special___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_special___vue_module_identifier__ = null
var maternal_special_Component = maternal_special_normalizeComponent(
  components_maternal_special,
  selectortype_template_index_0_src_components_maternal_special,
  maternal_special___vue_template_functional__,
  maternal_special___vue_styles__,
  maternal_special___vue_scopeId__,
  maternal_special___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_special = (maternal_special_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_special_room.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var maternal_special_room = ({
  name: 'maternal_special_room',
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      tag: '',
      warning_level: '1', // 预警等级：1-低级（默认），2-中级，3-高级，4-紧急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],
      remark: '',
      agent_list: [],
      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      agent_id: '' }, defineProperty_default()(_ref, 'agent_list', []), defineProperty_default()(_ref, 'department_id', 792), defineProperty_default()(_ref, 'departmentSelected', ''), defineProperty_default()(_ref, 'positionSelected', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'showAgentPicker', false), defineProperty_default()(_ref, 'postdepartment', []), defineProperty_default()(_ref, 'departments', []), defineProperty_default()(_ref, 'department', ''), defineProperty_default()(_ref, 'positions', []), defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },


  methods: {
    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },
    confirm: function confirm() {
      var _params,
          _this = this;

      // 日期已经有默认值，不需要再检查是否为空
      // if (this.date == '') {
      //   this.$vux.toast.show({
      //     type: 'cancel',
      //     text: '请选择日期',
      //   });
      //   return false;
      // }

      // 验证汇报人是否已选择
      // 检查 agent_id 是否为空字符串、null、undefined
      // 注意：使用 == '' 可以同时匹配 '' 和 null/undefined，但为了更严格，使用 ===
      var agentIdEmpty = this.agent_id === '' || this.agent_id === null || this.agent_id === undefined || String(this.agent_id).trim() === '';

      if (agentIdEmpty) {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择汇报人'
        });
        return false;
      }

      if (this.tag == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择特殊标签'
        });
        return false;
      }

      if (this.remark == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请填写备注'
        });
        return false;
      }

      this.$vux.loading.show({
        text: '正在提交'
      });
      var params = (_params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        date: this.date
      }, defineProperty_default()(_params, 'department_id', this.department_id), defineProperty_default()(_params, 'agent_id', this.agent_id), defineProperty_default()(_params, 'tag_id', this.tag), defineProperty_default()(_params, 'warning_level', this.warning_level), defineProperty_default()(_params, 'remark', this.remark), defineProperty_default()(_params, 'agent_ids', this.selectAgent.map(function (agent) {
        return agent.id;
      })), _params);
      // console.log('params', params);
      Api.otherFormApi.specialReportAddRoom(params).then(function (res) {
        //  console.log('res', res);
        _this.$vux.loading.hide();

        if (res.errcode == 1) {
          _this.$vux.toast.show({
            type: 'success',
            text: '提交成功'
          });

          setTimeout(function () {
            _this.goBack();
          }, 1000);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      }).catch(function (err) {
        //  console.error('API 请求失败:', err);
        _this.$vux.loading.hide();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        _this.$vux.toast.show({
          type: 'cancel',
          text: errorMsg
        });
      });
    },
    apiSpecialReportRoom: function apiSpecialReportRoom() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
        // 调用 API 获取特情上报相关数据（汇报人列表、特殊标签列表）
      };Api.otherFormApi.getSpecialReportRoom(params).then(function (res) {
        // console.log('res', res);
        // 接口返回成功（errcode == 1 表示成功）
        if (res.errcode == 1) {
          // 清空现有数据，避免数据残留
          _this2.tag_List = [];
          _this2.agent_list = [];

          // 从接口返回数据中获取汇报人列表和特殊标签列表

          _this2.agent_list = res.data.agent_list;
          _this2.tag_List = res.data.tag_List;

          // 为特殊标签列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.name）

          _this2.tag_List.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });

          // 为汇报人列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.user_name）
          _this2.agent_list.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });

          // 检查当前用户是否在汇报人列表中
          // 如果 agent_id 已设置（在 created 钩子中默认设置为当前登录用户ID）
          if (_this2.agent_id) {
            // console.log('this.agent_id', this.agent_id)
            // 在汇报人列表中查找当前用户
            var currentAgent = _this2.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this2.agent_id);
            });
            // console.log('currentAgent', currentAgent)

            if (currentAgent) {
              // 如果当前用户在列表中，说明可以正常显示和选择
              // 注意：这里不需要设置 agent_id，因为它已经在 created 钩子中设置为当前用户ID了
              // 选择器组件会自动根据 agent_id 的值匹配对应的选项
            } else {
              // 如果当前用户不在汇报人列表中，清空 agent_id，让用户手动选择
              // 这样可以避免选择器显示异常（选中一个不在选项中的值）
              _this2.agent_id = '';
              console.log('当前用户不在汇报人列表中，已清空默认选择');

              // 注意：由于 selector 组件使用了 v-model="agent_id"（第7行），
              // Vue 的响应式系统会自动检测到 agent_id 的变化并更新组件显示
              // 不需要手动调用 $forceUpdate() 或 $nextTick()，v-model 会自动处理更新
            }
          }

          // 隐藏加载提示
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiDeportment: function apiDeportment() {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this3.departments = res.data;
          _this3.departments.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiAgentList: function apiAgentList() {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this4.agents = res.data;
          _this4.agents.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });
          _this4.$vux.loading.hide();
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this5 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: department_id
      };
      Api.otherFormApi.getPositionList(params).then(function (res) {
        if (res.errcode == 1) {
          _this5.positions = res.data;
          _this5.positions.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this5.$vux.loading.hide();
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
    },
    chooseAgent: function chooseAgent() {
      // 实现员工选择逻辑

    },
    cancel: function cancel() {
      // 实现取消逻辑
      this.goBack();
    },
    submitForm: function submitForm() {},
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    changeAgents: function changeAgents(value, key) {
      this.selectAgId = value;
      console.log(value, key);
    },
    dialog_confirm: function dialog_confirm() {
      var _this6 = this;

      this.showChangeAgentPanel = false;
      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this6.selectAgId;
      });
      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);
    },
    changeDepartment: function changeDepartment(value) {
      console.log('选择了部门', value);
      this.selectDpId = value;
      this.apiPostionList(value);
    },
    changePositions: function changePositions(value) {
      console.log('选择了职位', value);
      this.selectPsId = value;
      this.apiAgentList();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    },

    //转base64
    convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], {
        type: 'image/png'
      });
    }
  },
  created: function created() {
    // 默认设置汇报人为当前登录用户
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }

    this.apiSpecialReportRoom();
    this.apiDeportment();
    // this.apiAgentList();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_special_room.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_maternal_special_room = ({
  name: 'maternal_special_room',
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      tag: '',
      warning_level: '1', // 预警等级：1-低级（默认），2-中级，3-高级，4-紧急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],
      remark: '',
      agent_list: [],
      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      agent_id: '' }, defineProperty_default()(_ref, 'agent_list', []), defineProperty_default()(_ref, 'department_id', 792), defineProperty_default()(_ref, 'departmentSelected', ''), defineProperty_default()(_ref, 'positionSelected', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'showAgentPicker', false), defineProperty_default()(_ref, 'postdepartment', []), defineProperty_default()(_ref, 'departments', []), defineProperty_default()(_ref, 'department', ''), defineProperty_default()(_ref, 'positions', []), defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },


  methods: {
    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },
    confirm: function confirm() {
      var _params,
          _this = this;

      // 日期已经有默认值，不需要再检查是否为空
      // if (this.date == '') {
      //   this.$vux.toast.show({
      //     type: 'cancel',
      //     text: '请选择日期',
      //   });
      //   return false;
      // }

      // 验证汇报人是否已选择
      // 检查 agent_id 是否为空字符串、null、undefined
      // 注意：使用 == '' 可以同时匹配 '' 和 null/undefined，但为了更严格，使用 ===
      var agentIdEmpty = this.agent_id === '' || this.agent_id === null || this.agent_id === undefined || String(this.agent_id).trim() === '';

      if (agentIdEmpty) {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择汇报人'
        });
        return false;
      }

      if (this.tag == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择特殊标签'
        });
        return false;
      }

      if (this.remark == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请填写备注'
        });
        return false;
      }

      this.$vux.loading.show({
        text: '正在提交'
      });
      var params = (_params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        date: this.date
      }, defineProperty_default()(_params, 'department_id', this.department_id), defineProperty_default()(_params, 'agent_id', this.agent_id), defineProperty_default()(_params, 'tag_id', this.tag), defineProperty_default()(_params, 'warning_level', this.warning_level), defineProperty_default()(_params, 'remark', this.remark), defineProperty_default()(_params, 'agent_ids', this.selectAgent.map(function (agent) {
        return agent.id;
      })), _params);
      // console.log('params', params);
      Api.otherFormApi.specialReportAddRoom(params).then(function (res) {
        //  console.log('res', res);
        _this.$vux.loading.hide();

        if (res.errcode == 1) {
          _this.$vux.toast.show({
            type: 'success',
            text: '提交成功'
          });

          setTimeout(function () {
            _this.goBack();
          }, 1000);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      }).catch(function (err) {
        //  console.error('API 请求失败:', err);
        _this.$vux.loading.hide();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        _this.$vux.toast.show({
          type: 'cancel',
          text: errorMsg
        });
      });
    },
    apiSpecialReportRoom: function apiSpecialReportRoom() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
        // 调用 API 获取特情上报相关数据（汇报人列表、特殊标签列表）
      };Api.otherFormApi.getSpecialReportRoom(params).then(function (res) {
        // console.log('res', res);
        // 接口返回成功（errcode == 1 表示成功）
        if (res.errcode == 1) {
          // 清空现有数据，避免数据残留
          _this2.tag_List = [];
          _this2.agent_list = [];

          // 从接口返回数据中获取汇报人列表和特殊标签列表

          _this2.agent_list = res.data.agent_list;
          _this2.tag_List = res.data.tag_List;

          // 为特殊标签列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.name）

          _this2.tag_List.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });

          // 为汇报人列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.user_name）
          _this2.agent_list.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });

          // 检查当前用户是否在汇报人列表中
          // 如果 agent_id 已设置（在 created 钩子中默认设置为当前登录用户ID）
          if (_this2.agent_id) {
            // console.log('this.agent_id', this.agent_id)
            // 在汇报人列表中查找当前用户
            var currentAgent = _this2.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this2.agent_id);
            });
            // console.log('currentAgent', currentAgent)

            if (currentAgent) {
              // 如果当前用户在列表中，说明可以正常显示和选择
              // 注意：这里不需要设置 agent_id，因为它已经在 created 钩子中设置为当前用户ID了
              // 选择器组件会自动根据 agent_id 的值匹配对应的选项
            } else {
              // 如果当前用户不在汇报人列表中，清空 agent_id，让用户手动选择
              // 这样可以避免选择器显示异常（选中一个不在选项中的值）
              _this2.agent_id = '';
              console.log('当前用户不在汇报人列表中，已清空默认选择');

              // 注意：由于 selector 组件使用了 v-model="agent_id"（第7行），
              // Vue 的响应式系统会自动检测到 agent_id 的变化并更新组件显示
              // 不需要手动调用 $forceUpdate() 或 $nextTick()，v-model 会自动处理更新
            }
          }

          // 隐藏加载提示
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiDeportment: function apiDeportment() {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this3.departments = res.data;
          _this3.departments.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiAgentList: function apiAgentList() {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this4.agents = res.data;
          _this4.agents.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });
          _this4.$vux.loading.hide();
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this5 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: department_id
      };
      Api.otherFormApi.getPositionList(params).then(function (res) {
        if (res.errcode == 1) {
          _this5.positions = res.data;
          _this5.positions.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this5.$vux.loading.hide();
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
    },
    chooseAgent: function chooseAgent() {
      // 实现员工选择逻辑

    },
    cancel: function cancel() {
      // 实现取消逻辑
      this.goBack();
    },
    submitForm: function submitForm() {},
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    changeAgents: function changeAgents(value, key) {
      this.selectAgId = value;
      console.log(value, key);
    },
    dialog_confirm: function dialog_confirm() {
      var _this6 = this;

      this.showChangeAgentPanel = false;
      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this6.selectAgId;
      });
      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);
    },
    changeDepartment: function changeDepartment(value) {
      console.log('选择了部门', value);
      this.selectDpId = value;
      this.apiPostionList(value);
    },
    changePositions: function changePositions(value) {
      console.log('选择了职位', value);
      this.selectPsId = value;
      this.apiAgentList();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    },

    //转base64
    convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], {
        type: 'image/png'
      });
    }
  },
  created: function created() {
    // 默认设置汇报人为当前登录用户
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }

    this.apiSpecialReportRoom();
    this.apiDeportment();
    // this.apiAgentList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-431d7b5f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_special_room.vue
var maternal_special_room_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{ showBack: true, preventGoBack: true, backText: '孕妇档案' }},on:{"on-click-back":_vm.goBack}},[_vm._v("特情上报(客房)")]),_vm._v(" "),_c('group',[_c('datetime',{attrs:{"title":"日期："},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('selector',{attrs:{"title":"汇报人：","options":_vm.agent_list,"required":""},model:{value:(_vm.agent_id),callback:function ($$v) {_vm.agent_id=$$v},expression:"agent_id"}}),_vm._v(" "),_c('selector',{attrs:{"title":"特殊标签：","options":_vm.tag_List,"required":""},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"备注：","placeholder":"500字（含）以内","required":""},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}}),_vm._v(" "),_c('div',{staticClass:"warning-level-group"},[_c('div',{staticClass:"weui-label warning-level-label"},[_vm._v("预警等级：")]),_vm._v(" "),_c('div',{staticClass:"tag-group"},[_c('checker',{attrs:{"default-item-class":"tag-item","selected-item-class":"tag-item-selected"},model:{value:(_vm.warning_level),callback:function ($$v) {_vm.warning_level=$$v},expression:"warning_level"}},_vm._l((_vm.warningLevelOptions),function(item){return _c('checker-item',{key:item.value,attrs:{"value":item.value}},[_vm._v("\n              "+_vm._s(item.label)+"\n            ")])}),1)],1)])],1),_vm._v(" "),_c('group',[_c('cell',{attrs:{"is-link":"","title":"上报给："},nativeOn:{"click":function($event){return _vm.showChageAgent.apply(null, arguments)}}},[_vm._v("添加")]),_vm._v(" "),_vm._l((_vm.selectAgent),function(agent,index){return _c('div',{key:index,staticClass:"agent-tag"},[_c('x-button',{attrs:{"type":"primary","plain":"","mini":""}},[_vm._v(_vm._s(agent.name))]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-close-empty",attrs:{"type":"ios-close-empty","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 512 512"},on:{"click":function($event){return _vm.removeAgent(agent.id)}}},[_c('path',{staticClass:"st0",attrs:{"d":"M340.2 160l-84.4 84.3-84-83.9-11.8 11.8 84 83.8-84 83.9 11.8 11.7 84-83.8 84.4 84.2 11.8-11.7-84.4-84.3 84.4-84.2z"}})])],1)}),_vm._v(" "),(_vm.showChangeAgentPanel)?_c('cell-box',[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"center","justify-items":"center"}},[_c('selector',{attrs:{"title":"部门","placeholder":"选择","options":_vm.departments},on:{"on-change":_vm.changeDepartment},model:{value:(_vm.department),callback:function ($$v) {_vm.department=$$v},expression:"department"}}),_vm._v(" "),_c('selector',{attrs:{"title":"职位","placeholder":"选择","options":_vm.positions},on:{"on-change":_vm.changePositions},model:{value:(_vm.position),callback:function ($$v) {_vm.position=$$v},expression:"position"}}),_vm._v(" "),_c('selector',{attrs:{"title":"员工","placeholder":"选择","options":_vm.agents},on:{"on-change":_vm.changeAgents},model:{value:(_vm.agent),callback:function ($$v) {_vm.agent=$$v},expression:"agent"}}),_vm._v(" "),_c('flexbox',{staticStyle:{"width":"200px"}},[_c('flexbox-item',{staticStyle:{"padding":"10px"}},[_c('x-button',{staticClass:"b_btn_style",attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"type":"default","action-type":"submit","mini":""},nativeOn:{"click":function($event){return _vm.dialog_confirm.apply(null, arguments)}}},[_vm._v("确认")])],1),_vm._v(" "),_c('flexbox-item',{staticStyle:{"padding":"10px"}},[_c('x-button',{staticClass:"b_btn_style",attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.dialog_cancel.apply(null, arguments)}}},[_vm._v("取消")])],1)],1)],1)]):_vm._e()],2),_vm._v(" "),_c('div',{staticStyle:{"padding":"30px","display":"flex","flex-direction":"row"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm.apply(null, arguments)}}},[_vm._v("确定")])],1)],1)}
var maternal_special_room_staticRenderFns = []
var maternal_special_room_esExports = { render: maternal_special_room_render, staticRenderFns: maternal_special_room_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_special_room = (maternal_special_room_esExports);
// CONCATENATED MODULE: ./src/components/maternal_special_room.vue
function maternal_special_room_injectStyle (ssrContext) {
  __webpack_require__("/YLi")
}
var maternal_special_room_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_special_room___vue_template_functional__ = false
/* styles */
var maternal_special_room___vue_styles__ = maternal_special_room_injectStyle
/* scopeId */
var maternal_special_room___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_special_room___vue_module_identifier__ = null
var maternal_special_room_Component = maternal_special_room_normalizeComponent(
  components_maternal_special_room,
  selectortype_template_index_0_src_components_maternal_special_room,
  maternal_special_room___vue_template_functional__,
  maternal_special_room___vue_styles__,
  maternal_special_room___vue_scopeId__,
  maternal_special_room___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_special_room = (maternal_special_room_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_special_meal.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var maternal_special_meal = ({
  name: 'maternal_special_meal',
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      tag: '',
      warning_level: '1', // 预警等级：1-低级（默认），2-中级，3-高级，4-紧急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],
      remark: '',
      agent_list: [],
      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      agent_id: '' }, defineProperty_default()(_ref, 'agent_list', []), defineProperty_default()(_ref, 'department_id', 790), defineProperty_default()(_ref, 'departmentSelected', ''), defineProperty_default()(_ref, 'positionSelected', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'showAgentPicker', false), defineProperty_default()(_ref, 'postdepartment', []), defineProperty_default()(_ref, 'departments', []), defineProperty_default()(_ref, 'department', ''), defineProperty_default()(_ref, 'positions', []), defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },


  methods: {
    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },
    confirm: function confirm() {
      var _params,
          _this = this;

      // 日期已经有默认值，不需要再检查是否为空
      // if (this.date == '') {
      //   this.$vux.toast.show({
      //     type: 'cancel',
      //     text: '请选择日期',
      //   });
      //   return false;
      // }

      // 验证汇报人是否已选择
      // 检查 agent_id 是否为空字符串、null、undefined
      // 注意：使用 == '' 可以同时匹配 '' 和 null/undefined，但为了更严格，使用 ===
      var agentIdEmpty = this.agent_id === '' || this.agent_id === null || this.agent_id === undefined || String(this.agent_id).trim() === '';

      if (agentIdEmpty) {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择汇报人'
        });
        return false;
      }

      if (this.tag == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择特殊标签'
        });
        return false;
      }

      if (this.remark == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请填写备注'
        });
        return false;
      }

      this.$vux.loading.show({
        text: '正在提交'
      });
      var params = (_params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        date: this.date
      }, defineProperty_default()(_params, 'department_id', this.department_id), defineProperty_default()(_params, 'agent_id', this.agent_id), defineProperty_default()(_params, 'tag_id', this.tag), defineProperty_default()(_params, 'warning_level', this.warning_level), defineProperty_default()(_params, 'remark', this.remark), defineProperty_default()(_params, 'agent_ids', this.selectAgent.map(function (agent) {
        return agent.id;
      })), _params);
      // console.log('params', params);
      Api.otherFormApi.specialReportAddMeal(params).then(function (res) {
        //  console.log('res', res);
        _this.$vux.loading.hide();

        if (res.errcode == 1) {
          _this.$vux.toast.show({
            type: 'success',
            text: '提交成功'
          });

          setTimeout(function () {
            _this.goBack();
          }, 1000);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      }).catch(function (err) {
        //  console.error('API 请求失败:', err);
        _this.$vux.loading.hide();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        _this.$vux.toast.show({
          type: 'cancel',
          text: errorMsg
        });
      });
    },
    apiSpecialReportMeal: function apiSpecialReportMeal() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
      };
      Api.otherFormApi.getSpecialReportMeal(params).then(function (res) {
        // console.log('res', res);
        if (res.errcode == 1) {
          // 清空现有数据，避免数据残留
          _this2.tag_List = [];
          _this2.agent_list = [];

          // 从接口返回数据中获取汇报人列表和特殊标签列表

          _this2.agent_list = res.data.agent_list;
          _this2.tag_List = res.data.tag_List;

          // 为特殊标签列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.name）

          _this2.tag_List.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });

          // 为汇报人列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.user_name）
          _this2.agent_list.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });

          // 检查当前用户是否在汇报人列表中
          // 如果 agent_id 已设置（在 created 钩子中默认设置为当前登录用户ID）
          if (_this2.agent_id) {
            // console.log('this.agent_id', this.agent_id)
            // 在汇报人列表中查找当前用户
            var currentAgent = _this2.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this2.agent_id);
            });
            // console.log('currentAgent', currentAgent)

            if (currentAgent) {
              // 如果当前用户在列表中，说明可以正常显示和选择
              // 注意：这里不需要设置 agent_id，因为它已经在 created 钩子中设置为当前用户ID了
              // 选择器组件会自动根据 agent_id 的值匹配对应的选项
            } else {
              // 如果当前用户不在汇报人列表中，清空 agent_id，让用户手动选择
              // 这样可以避免选择器显示异常（选中一个不在选项中的值）
              _this2.agent_id = '';
              console.log('当前用户不在汇报人列表中，已清空默认选择');

              // 注意：由于 selector 组件使用了 v-model="agent_id"（第7行），
              // Vue 的响应式系统会自动检测到 agent_id 的变化并更新组件显示
              // 不需要手动调用 $forceUpdate() 或 $nextTick()，v-model 会自动处理更新
            }
          }

          // 隐藏加载提示
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiDeportment: function apiDeportment() {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this3.departments = res.data;
          _this3.departments.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiAgentList: function apiAgentList() {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this4.agents = res.data;
          _this4.agents.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });
          _this4.$vux.loading.hide();
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this5 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: department_id
      };
      Api.otherFormApi.getPositionList(params).then(function (res) {
        if (res.errcode == 1) {
          _this5.positions = res.data;
          _this5.positions.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this5.$vux.loading.hide();
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
    },
    chooseAgent: function chooseAgent() {
      // 实现员工选择逻辑

    },
    cancel: function cancel() {
      // 实现取消逻辑
      this.goBack();
    },
    submitForm: function submitForm() {},
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    changeAgents: function changeAgents(value, key) {
      this.selectAgId = value;
      console.log(value, key);
    },
    dialog_confirm: function dialog_confirm() {
      var _this6 = this;

      this.showChangeAgentPanel = false;
      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this6.selectAgId;
      });
      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);
    },
    changeDepartment: function changeDepartment(value) {
      console.log('选择了部门', value);
      this.selectDpId = value;
      this.apiPostionList(value);
    },
    changePositions: function changePositions(value) {
      console.log('选择了职位', value);
      this.selectPsId = value;
      this.apiAgentList();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    },

    //转base64
    convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], {
        type: 'image/png'
      });
    }
  },
  created: function created() {
    // 默认设置汇报人为当前登录用户
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }

    this.apiSpecialReportMeal();
    this.apiDeportment();
    // this.apiAgentList();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_special_meal.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_maternal_special_meal = ({
  name: 'maternal_special_meal',
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      tag: '',
      warning_level: '1', // 预警等级：1-低级（默认），2-中级，3-高级，4-紧急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],
      remark: '',
      agent_list: [],
      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      agent_id: '' }, defineProperty_default()(_ref, 'agent_list', []), defineProperty_default()(_ref, 'department_id', 790), defineProperty_default()(_ref, 'departmentSelected', ''), defineProperty_default()(_ref, 'positionSelected', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'showAgentPicker', false), defineProperty_default()(_ref, 'postdepartment', []), defineProperty_default()(_ref, 'departments', []), defineProperty_default()(_ref, 'department', ''), defineProperty_default()(_ref, 'positions', []), defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },


  methods: {
    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },
    confirm: function confirm() {
      var _params,
          _this = this;

      // 日期已经有默认值，不需要再检查是否为空
      // if (this.date == '') {
      //   this.$vux.toast.show({
      //     type: 'cancel',
      //     text: '请选择日期',
      //   });
      //   return false;
      // }

      // 验证汇报人是否已选择
      // 检查 agent_id 是否为空字符串、null、undefined
      // 注意：使用 == '' 可以同时匹配 '' 和 null/undefined，但为了更严格，使用 ===
      var agentIdEmpty = this.agent_id === '' || this.agent_id === null || this.agent_id === undefined || String(this.agent_id).trim() === '';

      if (agentIdEmpty) {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择汇报人'
        });
        return false;
      }

      if (this.tag == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择特殊标签'
        });
        return false;
      }

      if (this.remark == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请填写备注'
        });
        return false;
      }

      this.$vux.loading.show({
        text: '正在提交'
      });
      var params = (_params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        date: this.date
      }, defineProperty_default()(_params, 'department_id', this.department_id), defineProperty_default()(_params, 'agent_id', this.agent_id), defineProperty_default()(_params, 'tag_id', this.tag), defineProperty_default()(_params, 'warning_level', this.warning_level), defineProperty_default()(_params, 'remark', this.remark), defineProperty_default()(_params, 'agent_ids', this.selectAgent.map(function (agent) {
        return agent.id;
      })), _params);
      // console.log('params', params);
      Api.otherFormApi.specialReportAddMeal(params).then(function (res) {
        //  console.log('res', res);
        _this.$vux.loading.hide();

        if (res.errcode == 1) {
          _this.$vux.toast.show({
            type: 'success',
            text: '提交成功'
          });

          setTimeout(function () {
            _this.goBack();
          }, 1000);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      }).catch(function (err) {
        //  console.error('API 请求失败:', err);
        _this.$vux.loading.hide();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        _this.$vux.toast.show({
          type: 'cancel',
          text: errorMsg
        });
      });
    },
    apiSpecialReportMeal: function apiSpecialReportMeal() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
      };
      Api.otherFormApi.getSpecialReportMeal(params).then(function (res) {
        // console.log('res', res);
        if (res.errcode == 1) {
          // 清空现有数据，避免数据残留
          _this2.tag_List = [];
          _this2.agent_list = [];

          // 从接口返回数据中获取汇报人列表和特殊标签列表

          _this2.agent_list = res.data.agent_list;
          _this2.tag_List = res.data.tag_List;

          // 为特殊标签列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.name）

          _this2.tag_List.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });

          // 为汇报人列表中的每个元素添加 key 和 value 属性
          // key: 用于选择器组件的值绑定（对应 element.id）
          // value: 用于选择器组件的显示文本（对应 element.user_name）
          _this2.agent_list.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });

          // 检查当前用户是否在汇报人列表中
          // 如果 agent_id 已设置（在 created 钩子中默认设置为当前登录用户ID）
          if (_this2.agent_id) {
            // console.log('this.agent_id', this.agent_id)
            // 在汇报人列表中查找当前用户
            var currentAgent = _this2.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this2.agent_id);
            });
            // console.log('currentAgent', currentAgent)

            if (currentAgent) {
              // 如果当前用户在列表中，说明可以正常显示和选择
              // 注意：这里不需要设置 agent_id，因为它已经在 created 钩子中设置为当前用户ID了
              // 选择器组件会自动根据 agent_id 的值匹配对应的选项
            } else {
              // 如果当前用户不在汇报人列表中，清空 agent_id，让用户手动选择
              // 这样可以避免选择器显示异常（选中一个不在选项中的值）
              _this2.agent_id = '';
              console.log('当前用户不在汇报人列表中，已清空默认选择');

              // 注意：由于 selector 组件使用了 v-model="agent_id"（第7行），
              // Vue 的响应式系统会自动检测到 agent_id 的变化并更新组件显示
              // 不需要手动调用 $forceUpdate() 或 $nextTick()，v-model 会自动处理更新
            }
          }

          // 隐藏加载提示
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiDeportment: function apiDeportment() {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this3.departments = res.data;
          _this3.departments.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiAgentList: function apiAgentList() {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this4.agents = res.data;
          _this4.agents.forEach(function (element) {
            element.key = element.id, element.value = element.user_name;
          });
          _this4.$vux.loading.hide();
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this5 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: department_id
      };
      Api.otherFormApi.getPositionList(params).then(function (res) {
        if (res.errcode == 1) {
          _this5.positions = res.data;
          _this5.positions.forEach(function (element) {
            element.key = element.id, element.value = element.name;
          });
          _this5.$vux.loading.hide();
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
    },
    chooseAgent: function chooseAgent() {
      // 实现员工选择逻辑

    },
    cancel: function cancel() {
      // 实现取消逻辑
      this.goBack();
    },
    submitForm: function submitForm() {},
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    changeAgents: function changeAgents(value, key) {
      this.selectAgId = value;
      console.log(value, key);
    },
    dialog_confirm: function dialog_confirm() {
      var _this6 = this;

      this.showChangeAgentPanel = false;
      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this6.selectAgId;
      });
      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);
    },
    changeDepartment: function changeDepartment(value) {
      console.log('选择了部门', value);
      this.selectDpId = value;
      this.apiPostionList(value);
    },
    changePositions: function changePositions(value) {
      console.log('选择了职位', value);
      this.selectPsId = value;
      this.apiAgentList();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    },

    //转base64
    convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], {
        type: 'image/png'
      });
    }
  },
  created: function created() {
    // 默认设置汇报人为当前登录用户
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }

    this.apiSpecialReportMeal();
    this.apiDeportment();
    // this.apiAgentList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1643f3d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_special_meal.vue
var maternal_special_meal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{ showBack: true, preventGoBack: true, backText: '孕妇档案' }},on:{"on-click-back":_vm.goBack}},[_vm._v("特情上报(餐饮)")]),_vm._v(" "),_c('group',[_c('datetime',{attrs:{"title":"日期："},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('selector',{attrs:{"title":"汇报人：","options":_vm.agent_list,"required":""},model:{value:(_vm.agent_id),callback:function ($$v) {_vm.agent_id=$$v},expression:"agent_id"}}),_vm._v(" "),_c('selector',{attrs:{"title":"特殊标签：","options":_vm.tag_List,"required":""},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"备注：","placeholder":"500字（含）以内","required":""},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}}),_vm._v(" "),_c('div',{staticClass:"warning-level-group"},[_c('div',{staticClass:"weui-label warning-level-label"},[_vm._v("预警等级：")]),_vm._v(" "),_c('div',{staticClass:"tag-group"},[_c('checker',{attrs:{"default-item-class":"tag-item","selected-item-class":"tag-item-selected"},model:{value:(_vm.warning_level),callback:function ($$v) {_vm.warning_level=$$v},expression:"warning_level"}},_vm._l((_vm.warningLevelOptions),function(item){return _c('checker-item',{key:item.value,attrs:{"value":item.value}},[_vm._v("\n              "+_vm._s(item.label)+"\n            ")])}),1)],1)])],1),_vm._v(" "),_c('group',[_c('cell',{attrs:{"is-link":"","title":"上报给："},nativeOn:{"click":function($event){return _vm.showChageAgent.apply(null, arguments)}}},[_vm._v("添加")]),_vm._v(" "),_vm._l((_vm.selectAgent),function(agent,index){return _c('div',{key:index,staticClass:"agent-tag"},[_c('x-button',{attrs:{"type":"primary","plain":"","mini":""}},[_vm._v(_vm._s(agent.name))]),_vm._v(" "),_c('svg',{staticClass:"vux-x-icon vux-x-icon-ios-close-empty",attrs:{"type":"ios-close-empty","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 512 512"},on:{"click":function($event){return _vm.removeAgent(agent.id)}}},[_c('path',{staticClass:"st0",attrs:{"d":"M340.2 160l-84.4 84.3-84-83.9-11.8 11.8 84 83.8-84 83.9 11.8 11.7 84-83.8 84.4 84.2 11.8-11.7-84.4-84.3 84.4-84.2z"}})])],1)}),_vm._v(" "),(_vm.showChangeAgentPanel)?_c('cell-box',[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"center","justify-items":"center"}},[_c('selector',{attrs:{"title":"部门","placeholder":"选择","options":_vm.departments},on:{"on-change":_vm.changeDepartment},model:{value:(_vm.department),callback:function ($$v) {_vm.department=$$v},expression:"department"}}),_vm._v(" "),_c('selector',{attrs:{"title":"职位","placeholder":"选择","options":_vm.positions},on:{"on-change":_vm.changePositions},model:{value:(_vm.position),callback:function ($$v) {_vm.position=$$v},expression:"position"}}),_vm._v(" "),_c('selector',{attrs:{"title":"员工","placeholder":"选择","options":_vm.agents},on:{"on-change":_vm.changeAgents},model:{value:(_vm.agent),callback:function ($$v) {_vm.agent=$$v},expression:"agent"}}),_vm._v(" "),_c('flexbox',{staticStyle:{"width":"200px"}},[_c('flexbox-item',{staticStyle:{"padding":"10px"}},[_c('x-button',{staticClass:"b_btn_style",attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"type":"default","action-type":"submit","mini":""},nativeOn:{"click":function($event){return _vm.dialog_confirm.apply(null, arguments)}}},[_vm._v("确认")])],1),_vm._v(" "),_c('flexbox-item',{staticStyle:{"padding":"10px"}},[_c('x-button',{staticClass:"b_btn_style",attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.dialog_cancel.apply(null, arguments)}}},[_vm._v("取消")])],1)],1)],1)]):_vm._e()],2),_vm._v(" "),_c('div',{staticStyle:{"padding":"30px","display":"flex","flex-direction":"row"}},[_c('x-button',{attrs:{"type":"primary"},nativeOn:{"click":function($event){return _vm.confirm.apply(null, arguments)}}},[_vm._v("确定")])],1)],1)}
var maternal_special_meal_staticRenderFns = []
var maternal_special_meal_esExports = { render: maternal_special_meal_render, staticRenderFns: maternal_special_meal_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_special_meal = (maternal_special_meal_esExports);
// CONCATENATED MODULE: ./src/components/maternal_special_meal.vue
function maternal_special_meal_injectStyle (ssrContext) {
  __webpack_require__("6Ztr")
}
var maternal_special_meal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_special_meal___vue_template_functional__ = false
/* styles */
var maternal_special_meal___vue_styles__ = maternal_special_meal_injectStyle
/* scopeId */
var maternal_special_meal___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_special_meal___vue_module_identifier__ = null
var maternal_special_meal_Component = maternal_special_meal_normalizeComponent(
  components_maternal_special_meal,
  selectortype_template_index_0_src_components_maternal_special_meal,
  maternal_special_meal___vue_template_functional__,
  maternal_special_meal___vue_styles__,
  maternal_special_meal___vue_scopeId__,
  maternal_special_meal___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_special_meal = (maternal_special_meal_Component.exports);

// EXTERNAL MODULE: ./node_modules/vant/es/index.js + 163 modules
var es = __webpack_require__("Fd2+");

// EXTERNAL MODULE: ./node_modules/vant/es/nav-bar/style/index.js
var style = __webpack_require__("FO5P");

// EXTERNAL MODULE: ./node_modules/vant/es/cell/style/index.js
var cell_style = __webpack_require__("OWWB");

// EXTERNAL MODULE: ./node_modules/vant/es/cell-group/style/index.js
var cell_group_style = __webpack_require__("i0mo");

// EXTERNAL MODULE: ./node_modules/vant/es/form/style/index.js
var form_style = __webpack_require__("81cA");

// EXTERNAL MODULE: ./node_modules/vant/es/field/style/index.js
var field_style = __webpack_require__("MY4N");

// EXTERNAL MODULE: ./node_modules/vant/es/button/style/index.js
var button_style = __webpack_require__("3Lne");

// EXTERNAL MODULE: ./node_modules/vant/es/icon/style/index.js
var icon_style = __webpack_require__("k3b4");

// EXTERNAL MODULE: ./node_modules/vant/es/tag/style/index.js
var tag_style = __webpack_require__("3ab0");

// EXTERNAL MODULE: ./node_modules/vant/es/popup/style/index.js
var popup_style = __webpack_require__("mMXg");

// EXTERNAL MODULE: ./node_modules/vant/es/picker/style/index.js
var picker_style = __webpack_require__("nI2B");

// EXTERNAL MODULE: ./node_modules/vant/es/datetime-picker/style/index.js
var datetime_picker_style = __webpack_require__("dKK0");

// EXTERNAL MODULE: ./node_modules/vant/es/toast/style/index.js
var toast_style = __webpack_require__("eqfM");

// EXTERNAL MODULE: ./node_modules/vant/es/loading/style/index.js
var loading_style = __webpack_require__("nOaS");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsVant/ssReport/maternal_special.vue






var _components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入 Vant 组件

// Vant 2.x 中 Loading 使用 Toast.loading() 方式
// import { Loading } from 'vant'  // Loading 在 Vant 2.x 中不是函数式 API

// 引入 Vant 组件样式
// 注意：虽然 babel-plugin-import 配置了 style: true，但为了确保样式正确加载，显式引入样式
// Vant 2.x 的样式路径（根据 babel-plugin-import 配置的 libraryDirectory: "es"）














/* harmony default export */ var ssReport_maternal_special = ({
  name: 'maternal_special_vant',
  components: (_components = {}, defineProperty_default()(_components, es["h" /* NavBar */].name, es["h" /* NavBar */]), defineProperty_default()(_components, es["b" /* Cell */].name, es["b" /* Cell */]), defineProperty_default()(_components, es["c" /* CellGroup */].name, es["c" /* CellGroup */]), defineProperty_default()(_components, es["f" /* Form */].name, es["f" /* Form */]), defineProperty_default()(_components, es["e" /* Field */].name, es["e" /* Field */]), defineProperty_default()(_components, es["a" /* Button */].name, es["a" /* Button */]), defineProperty_default()(_components, es["g" /* Icon */].name, es["g" /* Icon */]), defineProperty_default()(_components, es["k" /* Tag */].name, es["k" /* Tag */]), defineProperty_default()(_components, es["j" /* Popup */].name, es["j" /* Popup */]), defineProperty_default()(_components, es["i" /* Picker */].name, es["i" /* Picker */]), defineProperty_default()(_components, es["d" /* DatetimePicker */].name, es["d" /* DatetimePicker */]), _components),
  // Vant 2.x 中 Loading 使用 Toast.loading() 方式，不需要单独注册
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      currentDate: new Date(), // 日期选择器的当前值
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2100, 11, 31),
      showDatePicker: false,

      tag: '',
      tagDisplayName: '',
      showTagPicker: false,

      warning_level: '1', // 预警等级：1-关注（默认），2-提醒，3-紧急，4-特急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],

      remark: '',
      agent_list: [],
      agent_id: '',
      agentDisplayName: '',
      showAgentPicker: false,

      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      // 部门ID：默认从 store 中获取（在 created 钩子中设置）
      department_id: '',

      departments: [],
      department: '',
      departmentDisplayName: '',
      showDepartmentPicker: false,

      positions: []
    }, defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'positionDisplayName', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'agentSelectDisplayName', ''), defineProperty_default()(_ref, 'showAgentSelectPicker', false), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },

  computed: {
    // 汇报人选择器数据格式转换
    agentColumns: function agentColumns() {
      return this.agent_list.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    },

    // 特殊标签选择器数据格式转换
    tagColumns: function tagColumns() {
      return this.tag_List.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器数据格式转换
    departmentColumns: function departmentColumns() {
      return this.departments.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器默认选中当前用户部门
    departmentDefaultIndex: function departmentDefaultIndex() {
      var _this = this;

      if (!this.department_id) {
        return 0;
      }
      var index = this.departments.findIndex(function (item) {
        var itemValue = item.key || item.id;
        console.log('itemValue', itemValue);
        return String(itemValue) === String(_this.department_id);
      });
      return index === -1 ? 0 : index;
    },

    // 职位选择器数据格式转换
    positionColumns: function positionColumns() {
      return this.positions.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 员工选择器数据格式转换
    agentSelectColumns: function agentSelectColumns() {
      return this.agents.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    }
  },
  methods: {
    // 拉取当前用户信息（通过 @store.$userInfo）
    fetchUserInfo: function fetchUserInfo() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, url, res, body, user;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                id = _this2.$cookie.get('id');

                if (id) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                // 通过 @store 的 userInfo 工具生成接口 URL
                url = _this2.$store.$userInfo.getUserInfoUrl({
                  id: id,
                  key: _this2.$cookie.get('token')
                });
                _context.next = 7;
                return _this2.$http.get(url);

              case 7:
                res = _context.sent;

                // 后端约定：{ errcode: 1, data: { ...用户信息... } }
                body = res && res.data ? res.data : res;

                if (body && body.errcode === 1 && body.data) {
                  user = body.data;
                  // 根据返回结构按需保存到本页面（这里先用到 department_id）

                  if (user.department_id) {
                    _this2.department_id = user.department_id;
                  }
                  // 如有需要，可在此扩展更多字段
                }
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                console.error('fetchUserInfo error:', _context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    },

    // 从 store 的 app 模块获取 actions（使用 mapActions）
    // ...mapActions('app', [
    //   'setUserInfo',        // 设置用户信息
    //   'setUserDepartment',  // 设置部门信息
    //   'resetAppState'       // 重置应用状态
    // ]),

    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },


    // 日期选择确认
    onDateConfirm: function onDateConfirm(value) {
      var date = new Date(value);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var day = date.getDate();
      day = day < 10 ? '0' + day : day;
      this.date = year + '-' + month + '-' + day;
      // date 字段的值会自动同步（因为 v-model="date"）
      this.showDatePicker = false;
    },


    // 汇报人选择确认
    onAgentConfirm: function onAgentConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentPicker = false;
        return;
      }

      // 设置汇报人ID和显示名称
      this.agent_id = agentId;

      // 查找显示名称
      var selected = this.agent_list.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentDisplayName = selected ? selected.value || selected.user_name : this.agentColumns[index] && this.agentColumns[index].text || '';

      this.showAgentPicker = false;
    },


    // 特殊标签选择确认
    onTagConfirm: function onTagConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var tagId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!tagId) {
        this.showTagPicker = false;
        return;
      }

      // 设置特殊标签ID和显示名称
      this.tag = tagId;

      // 查找显示名称
      var selected = this.tag_List.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(tagId);
      });
      this.tagDisplayName = selected ? selected.value || selected.name : this.tagColumns[index] && this.tagColumns[index].text || '';

      this.showTagPicker = false;
    },


    // 部门选择确认
    onDepartmentConfirm: function onDepartmentConfirm(value, index) {
      // Vant 2.x Picker 单列选择器的 confirm 事件返回两个参数：(value, index)
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var departmentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!departmentId) {
        es["l" /* Toast */].fail('请选择有效的部门');
        this.showDepartmentPicker = false;
        return;
      }

      // 设置部门ID和显示名称
      this.selectDpId = departmentId;

      // 查找显示名称
      var selected = this.departments.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(departmentId);
      });
      this.departmentDisplayName = selected ? selected.value || selected.name : this.departmentColumns[index] && this.departmentColumns[index].text || '';

      // 清空职位和员工选择
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];

      // 加载职位列表
      this.apiPostionList(this.selectDpId);
      this.showDepartmentPicker = false;
    },


    // 职位选择确认
    onPositionConfirm: function onPositionConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var positionId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!positionId) {
        this.showPositionPicker = false;
        return;
      }

      // 设置职位ID和显示名称
      this.selectPsId = positionId;

      // 查找显示名称
      var selected = this.positions.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(positionId);
      });
      this.positionDisplayName = selected ? selected.value || selected.name : this.positionColumns[index] && this.positionColumns[index].text || '';

      // 清空员工选择
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.agents = [];

      // 加载员工列表
      this.apiAgentList();
      this.showPositionPicker = false;
    },


    // 员工选择确认
    onAgentSelectConfirm: function onAgentSelectConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentSelectPicker = false;
        return;
      }

      // 设置员工ID和显示名称
      this.selectAgId = agentId;

      // 查找显示名称
      var selected = this.agents.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentSelectDisplayName = selected ? selected.value || selected.user_name : this.agentSelectColumns[index] && this.agentSelectColumns[index].text || '';

      this.showAgentSelectPicker = false;
    },


    // 表单提交处理
    onSubmit: function onSubmit() {
      var _this3 = this;

      // 检查 form ref 是否存在
      if (!this.$refs.form) {
        console.error('Form ref 不存在');
        es["l" /* Toast */].fail('表单初始化失败');
        return;
      }

      // 使用 Form 组件进行表单验证
      this.$refs.form.validate().then(function () {
        // 验证通过，提交表单数据
        // 注意：对于只读选择器字段，Form 获取的是显示名称，所以直接从 data 中获取实际值
        _this3.submitForm();
      }).catch(function (err) {
        // 验证失败，Form 组件会自动显示错误信息
        console.log('表单验证失败:', err);
        Object(es["l" /* Toast */])('请完善表单信息');
      });
    },


    // 实际提交表单数据的方法
    submitForm: function submitForm() {
      var _this4 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在提交',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });

      // 构建提交参数
      // Form 组件主要用于验证，实际值从 data 中获取
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        // 表单字段值（Form 已验证这些字段不为空）
        date: this.date,
        agent_id: this.agent_id,
        tag_id: this.tag,
        remark: this.remark,
        // 非表单字段
        warning_level: this.warning_level, // 预警等级（Tag 组件，不在 Form Field 中）
        agent_ids: this.selectAgent.map(function (agent) {
          return agent.id;
        }) // 上报给（不在 Form Field 中）
      };
      console.log('params', params);
      Api.otherFormApi.specialReportAdd(params).then(function (res) {
        console.log('res', res);
        // 关闭加载提示
        es["l" /* Toast */].clear();

        if (res.errcode == 1) {
          es["l" /* Toast */].success('提交成功');

          setTimeout(function () {
            _this4.goBack();
          }, 1000);
        } else {
          es["l" /* Toast */].fail(res.errinfo || '提交失败');
        }
      }).catch(function (err) {
        console.error('API 请求失败:', err);
        // 关闭加载提示
        es["l" /* Toast */].clear();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        es["l" /* Toast */].fail(errorMsg);
      });
    },
    apiSpecialReport: function apiSpecialReport() {
      var _this5 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在加载',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
      };
      Api.otherFormApi.getSpecialReport(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this5.tag_List = [];
          _this5.agent_list = [];

          _this5.agent_list = res.data.agent_list;
          _this5.tag_List = res.data.tag_List;

          _this5.tag_List.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          _this5.agent_list.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });

          // 如果 agent_id 已设置（默认当前用户），设置显示名称
          if (_this5.agent_id) {
            var currentAgent = _this5.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this5.agent_id);
            });
            if (currentAgent) {
              _this5.agentDisplayName = currentAgent.value || currentAgent.user_name;
            }
          }

          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiDeportment: function apiDeportment() {
      var _this6 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this6.departments = res.data;
          _this6.departments.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiAgentList: function apiAgentList() {
      var _this7 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this7.agents = res.data;
          _this7.agents.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this8 = this;

      // 确保 department_id 是原始值，不是响应式对象
      var deptId = department_id && (typeof department_id === 'undefined' ? 'undefined' : typeof_default()(department_id)) === 'object' && !Array.isArray(department_id) ? department_id.value : department_id;

      if (!deptId) {
        es["l" /* Toast */].fail('部门ID不能为空');
        return;
      }

      es["l" /* Toast */].loading({
        message: '正在加载职位列表',
        forbidClick: true,
        duration: 0
      });

      var params = {
        token: this.$cookie.get('token'),
        department_id: deptId
      };

      Api.otherFormApi.getPositionList(params).then(function (res) {
        es["l" /* Toast */].clear();
        if (res.errcode == 1) {
          _this8.positions = res.data || [];
          _this8.positions.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
        } else {
          es["l" /* Toast */].fail(res.errinfo || '加载职位列表失败');
        }
      }).catch(function (err) {
        es["l" /* Toast */].clear();
        var errorMsg = '加载职位列表失败';
        if (err.response) {
          errorMsg = err.response.status === 404 ? '职位列表接口不存在(404)，请检查API配置' : '\u52A0\u8F7D\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
        } else if (err.request) {
          errorMsg = '网络错误，请检查网络连接';
        }
        es["l" /* Toast */].fail(errorMsg);
        console.error('职位列表API请求失败:', err);
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
      // 重置选择状态
      this.selectDpId = '';
      this.departmentDisplayName = '';
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    dialog_confirm: function dialog_confirm() {
      var _this9 = this;

      if (!this.selectAgId) {
        Object(es["l" /* Toast */])('请选择员工');
        return;
      }

      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (!selectAg) {
        Object(es["l" /* Toast */])('员工信息不存在');
        return;
      }

      // 检查是否已添加
      var exists = this.selectAgent.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (exists) {
        Object(es["l" /* Toast */])('该员工已添加');
        return;
      }

      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);

      // 关闭面板并重置选择
      this.dialog_cancel();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    }
  },
  created: function created() {
    // 从 Cookie 获取当前用户 ID（兼容现有代码）
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }

    // 页面打开时请求 userInfo
    this.fetchUserInfo();

    this.apiSpecialReport();
    this.apiDeportment();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsVant/ssReport/maternal_special.vue






var maternal_special__components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入 Vant 组件

// Vant 2.x 中 Loading 使用 Toast.loading() 方式
// import { Loading } from 'vant'  // Loading 在 Vant 2.x 中不是函数式 API

// 引入 Vant 组件样式
// 注意：虽然 babel-plugin-import 配置了 style: true，但为了确保样式正确加载，显式引入样式
// Vant 2.x 的样式路径（根据 babel-plugin-import 配置的 libraryDirectory: "es"）














/* harmony default export */ var componentsVant_ssReport_maternal_special = ({
  name: 'maternal_special_vant',
  components: (maternal_special__components = {}, defineProperty_default()(maternal_special__components, es["h" /* NavBar */].name, es["h" /* NavBar */]), defineProperty_default()(maternal_special__components, es["b" /* Cell */].name, es["b" /* Cell */]), defineProperty_default()(maternal_special__components, es["c" /* CellGroup */].name, es["c" /* CellGroup */]), defineProperty_default()(maternal_special__components, es["f" /* Form */].name, es["f" /* Form */]), defineProperty_default()(maternal_special__components, es["e" /* Field */].name, es["e" /* Field */]), defineProperty_default()(maternal_special__components, es["a" /* Button */].name, es["a" /* Button */]), defineProperty_default()(maternal_special__components, es["g" /* Icon */].name, es["g" /* Icon */]), defineProperty_default()(maternal_special__components, es["k" /* Tag */].name, es["k" /* Tag */]), defineProperty_default()(maternal_special__components, es["j" /* Popup */].name, es["j" /* Popup */]), defineProperty_default()(maternal_special__components, es["i" /* Picker */].name, es["i" /* Picker */]), defineProperty_default()(maternal_special__components, es["d" /* DatetimePicker */].name, es["d" /* DatetimePicker */]), maternal_special__components),
  // Vant 2.x 中 Loading 使用 Toast.loading() 方式，不需要单独注册
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      currentDate: new Date(), // 日期选择器的当前值
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2100, 11, 31),
      showDatePicker: false,

      tag: '',
      tagDisplayName: '',
      showTagPicker: false,

      warning_level: '1', // 预警等级：1-关注（默认），2-提醒，3-紧急，4-特急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],

      remark: '',
      agent_list: [],
      agent_id: '',
      agentDisplayName: '',
      showAgentPicker: false,

      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      // 部门ID：默认从 store 中获取（在 created 钩子中设置）
      department_id: '',

      departments: [],
      department: '',
      departmentDisplayName: '',
      showDepartmentPicker: false,

      positions: []
    }, defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'positionDisplayName', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'agentSelectDisplayName', ''), defineProperty_default()(_ref, 'showAgentSelectPicker', false), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },

  computed: {
    // 汇报人选择器数据格式转换
    agentColumns: function agentColumns() {
      return this.agent_list.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    },

    // 特殊标签选择器数据格式转换
    tagColumns: function tagColumns() {
      return this.tag_List.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器数据格式转换
    departmentColumns: function departmentColumns() {
      return this.departments.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器默认选中当前用户部门
    departmentDefaultIndex: function departmentDefaultIndex() {
      var _this = this;

      if (!this.department_id) {
        return 0;
      }
      var index = this.departments.findIndex(function (item) {
        var itemValue = item.key || item.id;
        console.log('itemValue', itemValue);
        return String(itemValue) === String(_this.department_id);
      });
      return index === -1 ? 0 : index;
    },

    // 职位选择器数据格式转换
    positionColumns: function positionColumns() {
      return this.positions.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 员工选择器数据格式转换
    agentSelectColumns: function agentSelectColumns() {
      return this.agents.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    }
  },
  methods: {
    // 拉取当前用户信息（通过 @store.$userInfo）
    fetchUserInfo: function fetchUserInfo() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, url, res, body, user;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                id = _this2.$cookie.get('id');

                if (id) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                // 通过 @store 的 userInfo 工具生成接口 URL
                url = _this2.$store.$userInfo.getUserInfoUrl({
                  id: id,
                  key: _this2.$cookie.get('token')
                });
                _context.next = 7;
                return _this2.$http.get(url);

              case 7:
                res = _context.sent;

                // 后端约定：{ errcode: 1, data: { ...用户信息... } }
                body = res && res.data ? res.data : res;

                if (body && body.errcode === 1 && body.data) {
                  user = body.data;
                  // 根据返回结构按需保存到本页面（这里先用到 department_id）

                  if (user.department_id) {
                    _this2.department_id = user.department_id;
                  }
                  // 如有需要，可在此扩展更多字段
                }
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                console.error('fetchUserInfo error:', _context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    },

    // 从 store 的 app 模块获取 actions（使用 mapActions）
    // ...mapActions('app', [
    //   'setUserInfo',        // 设置用户信息
    //   'setUserDepartment',  // 设置部门信息
    //   'resetAppState'       // 重置应用状态
    // ]),

    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },


    // 日期选择确认
    onDateConfirm: function onDateConfirm(value) {
      var date = new Date(value);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var day = date.getDate();
      day = day < 10 ? '0' + day : day;
      this.date = year + '-' + month + '-' + day;
      // date 字段的值会自动同步（因为 v-model="date"）
      this.showDatePicker = false;
    },


    // 汇报人选择确认
    onAgentConfirm: function onAgentConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentPicker = false;
        return;
      }

      // 设置汇报人ID和显示名称
      this.agent_id = agentId;

      // 查找显示名称
      var selected = this.agent_list.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentDisplayName = selected ? selected.value || selected.user_name : this.agentColumns[index] && this.agentColumns[index].text || '';

      this.showAgentPicker = false;
    },


    // 特殊标签选择确认
    onTagConfirm: function onTagConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var tagId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!tagId) {
        this.showTagPicker = false;
        return;
      }

      // 设置特殊标签ID和显示名称
      this.tag = tagId;

      // 查找显示名称
      var selected = this.tag_List.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(tagId);
      });
      this.tagDisplayName = selected ? selected.value || selected.name : this.tagColumns[index] && this.tagColumns[index].text || '';

      this.showTagPicker = false;
    },


    // 部门选择确认
    onDepartmentConfirm: function onDepartmentConfirm(value, index) {
      // Vant 2.x Picker 单列选择器的 confirm 事件返回两个参数：(value, index)
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var departmentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!departmentId) {
        es["l" /* Toast */].fail('请选择有效的部门');
        this.showDepartmentPicker = false;
        return;
      }

      // 设置部门ID和显示名称
      this.selectDpId = departmentId;

      // 查找显示名称
      var selected = this.departments.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(departmentId);
      });
      this.departmentDisplayName = selected ? selected.value || selected.name : this.departmentColumns[index] && this.departmentColumns[index].text || '';

      // 清空职位和员工选择
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];

      // 加载职位列表
      this.apiPostionList(this.selectDpId);
      this.showDepartmentPicker = false;
    },


    // 职位选择确认
    onPositionConfirm: function onPositionConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var positionId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!positionId) {
        this.showPositionPicker = false;
        return;
      }

      // 设置职位ID和显示名称
      this.selectPsId = positionId;

      // 查找显示名称
      var selected = this.positions.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(positionId);
      });
      this.positionDisplayName = selected ? selected.value || selected.name : this.positionColumns[index] && this.positionColumns[index].text || '';

      // 清空员工选择
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.agents = [];

      // 加载员工列表
      this.apiAgentList();
      this.showPositionPicker = false;
    },


    // 员工选择确认
    onAgentSelectConfirm: function onAgentSelectConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentSelectPicker = false;
        return;
      }

      // 设置员工ID和显示名称
      this.selectAgId = agentId;

      // 查找显示名称
      var selected = this.agents.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentSelectDisplayName = selected ? selected.value || selected.user_name : this.agentSelectColumns[index] && this.agentSelectColumns[index].text || '';

      this.showAgentSelectPicker = false;
    },


    // 表单提交处理
    onSubmit: function onSubmit() {
      var _this3 = this;

      // 检查 form ref 是否存在
      if (!this.$refs.form) {
        console.error('Form ref 不存在');
        es["l" /* Toast */].fail('表单初始化失败');
        return;
      }

      // 使用 Form 组件进行表单验证
      this.$refs.form.validate().then(function () {
        // 验证通过，提交表单数据
        // 注意：对于只读选择器字段，Form 获取的是显示名称，所以直接从 data 中获取实际值
        _this3.submitForm();
      }).catch(function (err) {
        // 验证失败，Form 组件会自动显示错误信息
        console.log('表单验证失败:', err);
        Object(es["l" /* Toast */])('请完善表单信息');
      });
    },


    // 实际提交表单数据的方法
    submitForm: function submitForm() {
      var _this4 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在提交',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });

      // 构建提交参数
      // Form 组件主要用于验证，实际值从 data 中获取
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        // 表单字段值（Form 已验证这些字段不为空）
        date: this.date,
        agent_id: this.agent_id,
        tag_id: this.tag,
        remark: this.remark,
        // 非表单字段
        warning_level: this.warning_level, // 预警等级（Tag 组件，不在 Form Field 中）
        agent_ids: this.selectAgent.map(function (agent) {
          return agent.id;
        }) // 上报给（不在 Form Field 中）
      };
      console.log('params', params);
      Api.otherFormApi.specialReportAdd(params).then(function (res) {
        console.log('res', res);
        // 关闭加载提示
        es["l" /* Toast */].clear();

        if (res.errcode == 1) {
          es["l" /* Toast */].success('提交成功');

          setTimeout(function () {
            _this4.goBack();
          }, 1000);
        } else {
          es["l" /* Toast */].fail(res.errinfo || '提交失败');
        }
      }).catch(function (err) {
        console.error('API 请求失败:', err);
        // 关闭加载提示
        es["l" /* Toast */].clear();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        es["l" /* Toast */].fail(errorMsg);
      });
    },
    apiSpecialReport: function apiSpecialReport() {
      var _this5 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在加载',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
      };
      Api.otherFormApi.getSpecialReport(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this5.tag_List = [];
          _this5.agent_list = [];

          _this5.agent_list = res.data.agent_list;
          _this5.tag_List = res.data.tag_List;

          _this5.tag_List.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          _this5.agent_list.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });

          // 如果 agent_id 已设置（默认当前用户），设置显示名称
          if (_this5.agent_id) {
            var currentAgent = _this5.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this5.agent_id);
            });
            if (currentAgent) {
              _this5.agentDisplayName = currentAgent.value || currentAgent.user_name;
            }
          }

          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiDeportment: function apiDeportment() {
      var _this6 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this6.departments = res.data;
          _this6.departments.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiAgentList: function apiAgentList() {
      var _this7 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this7.agents = res.data;
          _this7.agents.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this8 = this;

      // 确保 department_id 是原始值，不是响应式对象
      var deptId = department_id && (typeof department_id === 'undefined' ? 'undefined' : typeof_default()(department_id)) === 'object' && !Array.isArray(department_id) ? department_id.value : department_id;

      if (!deptId) {
        es["l" /* Toast */].fail('部门ID不能为空');
        return;
      }

      es["l" /* Toast */].loading({
        message: '正在加载职位列表',
        forbidClick: true,
        duration: 0
      });

      var params = {
        token: this.$cookie.get('token'),
        department_id: deptId
      };

      Api.otherFormApi.getPositionList(params).then(function (res) {
        es["l" /* Toast */].clear();
        if (res.errcode == 1) {
          _this8.positions = res.data || [];
          _this8.positions.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
        } else {
          es["l" /* Toast */].fail(res.errinfo || '加载职位列表失败');
        }
      }).catch(function (err) {
        es["l" /* Toast */].clear();
        var errorMsg = '加载职位列表失败';
        if (err.response) {
          errorMsg = err.response.status === 404 ? '职位列表接口不存在(404)，请检查API配置' : '\u52A0\u8F7D\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
        } else if (err.request) {
          errorMsg = '网络错误，请检查网络连接';
        }
        es["l" /* Toast */].fail(errorMsg);
        console.error('职位列表API请求失败:', err);
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
      // 重置选择状态
      this.selectDpId = '';
      this.departmentDisplayName = '';
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    dialog_confirm: function dialog_confirm() {
      var _this9 = this;

      if (!this.selectAgId) {
        Object(es["l" /* Toast */])('请选择员工');
        return;
      }

      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (!selectAg) {
        Object(es["l" /* Toast */])('员工信息不存在');
        return;
      }

      // 检查是否已添加
      var exists = this.selectAgent.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (exists) {
        Object(es["l" /* Toast */])('该员工已添加');
        return;
      }

      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);

      // 关闭面板并重置选择
      this.dialog_cancel();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    }
  },
  created: function created() {
    // 从 Cookie 获取当前用户 ID（兼容现有代码）
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }

    // 页面打开时请求 userInfo
    this.fetchUserInfo();

    this.apiSpecialReport();
    this.apiDeportment();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-127668b3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/componentsVant/ssReport/maternal_special.vue
var ssReport_maternal_special_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"特情上报","left-text":"孕妇档案","left-arrow":""},on:{"click-left":_vm.goBack}}),_vm._v(" "),_c('van-form',{ref:"form",on:{"submit":_vm.onSubmit}},[_c('van-cell-group',[_c('van-field',{attrs:{"name":"date","label":"日期","placeholder":"请选择日期","readonly":"","required":"","rules":[{ validator: function () { return this$1.date !== ''; }, message: '请选择日期' }]},on:{"click":function($event){_vm.showDatePicker = true}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showDatePicker),callback:function ($$v) {_vm.showDatePicker=$$v},expression:"showDatePicker"}},[_c('van-datetime-picker',{attrs:{"type":"date","min-date":_vm.minDate,"max-date":_vm.maxDate,"show-toolbar":"","title":"选择日期","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onDateConfirm,"cancel":function($event){_vm.showDatePicker = false}},model:{value:(_vm.currentDate),callback:function ($$v) {_vm.currentDate=$$v},expression:"currentDate"}})],1),_vm._v(" "),_c('van-field',{attrs:{"name":"agent_id","label":"汇报人：","placeholder":"请选择汇报人","readonly":"","required":"","rules":[{ validator: function () { return this$1.agent_id !== ''; }, message: '请选择汇报人' }]},on:{"click":function($event){_vm.showAgentPicker = true}},model:{value:(_vm.agentDisplayName),callback:function ($$v) {_vm.agentDisplayName=$$v},expression:"agentDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showAgentPicker),callback:function ($$v) {_vm.showAgentPicker=$$v},expression:"showAgentPicker"}},[_c('van-picker',{attrs:{"columns":_vm.agentColumns,"show-toolbar":"","title":"选择汇报人","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onAgentConfirm,"cancel":function($event){_vm.showAgentPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"name":"tag","label":"特殊标签：","placeholder":"请选择特殊标签","readonly":"","required":"","rules":[{ validator: function () { return this$1.tag !== ''; }, message: '请选择特殊标签' }]},on:{"click":function($event){_vm.showTagPicker = true}},model:{value:(_vm.tagDisplayName),callback:function ($$v) {_vm.tagDisplayName=$$v},expression:"tagDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showTagPicker),callback:function ($$v) {_vm.showTagPicker=$$v},expression:"showTagPicker"}},[_c('van-picker',{attrs:{"columns":_vm.tagColumns,"show-toolbar":"","title":"选择特殊标签","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onTagConfirm,"cancel":function($event){_vm.showTagPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"name":"remark","type":"textarea","label":"备注：","placeholder":"500字（含）以内","required":"","rules":[{ required: true, message: '请填写备注' }],"maxlength":500,"show-word-limit":"","rows":"3","autosize":""},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}}),_vm._v(" "),_c('div',{staticClass:"warning-level-group"},[_c('div',{staticClass:"warning-level-label"},[_vm._v("预警等级：")]),_vm._v(" "),_c('div',{staticClass:"tag-group"},_vm._l((_vm.warningLevelOptions),function(item){return _c('van-tag',{key:item.value,staticClass:"warning-tag-item",attrs:{"type":_vm.warning_level === item.value ? 'primary' : 'default',"plain":_vm.warning_level !== item.value,"size":"large"},on:{"click":function($event){_vm.warning_level = item.value}}},[_vm._v("\n            "+_vm._s(item.label)+"\n          ")])}),1)])],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-cell',{attrs:{"title":"上报给：","value":"添加","is-link":""},on:{"click":_vm.showChageAgent}}),_vm._v(" "),_c('div',{staticClass:"agent-tags-container"},[(_vm.selectAgent.length)?_vm._l((_vm.selectAgent),function(agent,index){return _c('van-tag',{key:index,staticClass:"agent-tag-item",attrs:{"plain":"true","type":"primary","size":"medium"}},[_c('span',[_vm._v(_vm._s(agent.name))]),_vm._v(" "),_c('van-icon',{staticClass:"agent-tag-close",attrs:{"name":"cross"},on:{"click":function($event){$event.stopPropagation();return _vm.removeAgent(agent.id)}}})],1)}):[_c('span',{staticClass:"agent-tag-empty"},[_vm._v("未添加记录")])]],2),_vm._v(" "),(_vm.showChangeAgentPanel)?_c('div',{staticClass:"agent-select-panel"},[_c('div',{staticClass:"agent-select-row"},[_c('van-field',{attrs:{"label":"部门","placeholder":"选择","readonly":""},on:{"click":function($event){_vm.showDepartmentPicker = true}},model:{value:(_vm.departmentDisplayName),callback:function ($$v) {_vm.departmentDisplayName=$$v},expression:"departmentDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showDepartmentPicker),callback:function ($$v) {_vm.showDepartmentPicker=$$v},expression:"showDepartmentPicker"}},[_c('van-picker',{attrs:{"columns":_vm.departmentColumns,"default-index":_vm.departmentDefaultIndex,"show-toolbar":"","title":"选择部门","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onDepartmentConfirm,"cancel":function($event){_vm.showDepartmentPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"label":"职位","placeholder":"选择","readonly":"","disabled":!_vm.selectDpId},on:{"click":function($event){_vm.showPositionPicker = true}},model:{value:(_vm.positionDisplayName),callback:function ($$v) {_vm.positionDisplayName=$$v},expression:"positionDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showPositionPicker),callback:function ($$v) {_vm.showPositionPicker=$$v},expression:"showPositionPicker"}},[_c('van-picker',{attrs:{"columns":_vm.positionColumns,"show-toolbar":"","title":"选择职位","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onPositionConfirm,"cancel":function($event){_vm.showPositionPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"label":"员工","placeholder":"选择","readonly":"","disabled":!_vm.selectPsId},on:{"click":function($event){_vm.showAgentSelectPicker = true}},model:{value:(_vm.agentSelectDisplayName),callback:function ($$v) {_vm.agentSelectDisplayName=$$v},expression:"agentSelectDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showAgentSelectPicker),callback:function ($$v) {_vm.showAgentSelectPicker=$$v},expression:"showAgentSelectPicker"}},[_c('van-picker',{attrs:{"columns":_vm.agentSelectColumns,"show-toolbar":"","title":"选择员工","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onAgentSelectConfirm,"cancel":function($event){_vm.showAgentSelectPicker = false}}})],1)],1),_vm._v(" "),_c('div',{staticClass:"agent-select-buttons"},[_c('van-button',{staticClass:"confirm-btn",attrs:{"type":"default","size":"small"},on:{"click":_vm.dialog_confirm}},[_vm._v("确认")]),_vm._v(" "),_c('van-button',{staticClass:"cancel-btn",attrs:{"type":"warning","size":"small"},on:{"click":_vm.dialog_cancel}},[_vm._v("取消")])],1)]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"submit-button-container"},[_c('van-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("确定")])],1)],1)}
var ssReport_maternal_special_staticRenderFns = []
var ssReport_maternal_special_esExports = { render: ssReport_maternal_special_render, staticRenderFns: ssReport_maternal_special_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_componentsVant_ssReport_maternal_special = (ssReport_maternal_special_esExports);
// CONCATENATED MODULE: ./src/componentsVant/ssReport/maternal_special.vue
function ssReport_maternal_special_injectStyle (ssrContext) {
  __webpack_require__("np8t")
}
var ssReport_maternal_special_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ssReport_maternal_special___vue_template_functional__ = false
/* styles */
var ssReport_maternal_special___vue_styles__ = ssReport_maternal_special_injectStyle
/* scopeId */
var ssReport_maternal_special___vue_scopeId__ = "data-v-127668b3"
/* moduleIdentifier (server only) */
var ssReport_maternal_special___vue_module_identifier__ = null
var ssReport_maternal_special_Component = ssReport_maternal_special_normalizeComponent(
  componentsVant_ssReport_maternal_special,
  selectortype_template_index_0_src_componentsVant_ssReport_maternal_special,
  ssReport_maternal_special___vue_template_functional__,
  ssReport_maternal_special___vue_styles__,
  ssReport_maternal_special___vue_scopeId__,
  ssReport_maternal_special___vue_module_identifier__
)

/* harmony default export */ var src_componentsVant_ssReport_maternal_special = (ssReport_maternal_special_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsVant/ssReport/maternal_special_room.vue






var maternal_special_room__components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入 Vant 组件

// Vant 2.x 中 Loading 使用 Toast.loading() 方式
// import { Loading } from 'vant'  // Loading 在 Vant 2.x 中不是函数式 API

// 引入 Vant 组件样式
// 注意：虽然 babel-plugin-import 配置了 style: true，但为了确保样式正确加载，显式引入样式
// Vant 2.x 的样式路径（根据 babel-plugin-import 配置的 libraryDirectory: "es"）














/* harmony default export */ var ssReport_maternal_special_room = ({
  name: 'maternal_special_room_vant',
  components: (maternal_special_room__components = {}, defineProperty_default()(maternal_special_room__components, es["h" /* NavBar */].name, es["h" /* NavBar */]), defineProperty_default()(maternal_special_room__components, es["b" /* Cell */].name, es["b" /* Cell */]), defineProperty_default()(maternal_special_room__components, es["c" /* CellGroup */].name, es["c" /* CellGroup */]), defineProperty_default()(maternal_special_room__components, es["f" /* Form */].name, es["f" /* Form */]), defineProperty_default()(maternal_special_room__components, es["e" /* Field */].name, es["e" /* Field */]), defineProperty_default()(maternal_special_room__components, es["a" /* Button */].name, es["a" /* Button */]), defineProperty_default()(maternal_special_room__components, es["g" /* Icon */].name, es["g" /* Icon */]), defineProperty_default()(maternal_special_room__components, es["k" /* Tag */].name, es["k" /* Tag */]), defineProperty_default()(maternal_special_room__components, es["j" /* Popup */].name, es["j" /* Popup */]), defineProperty_default()(maternal_special_room__components, es["i" /* Picker */].name, es["i" /* Picker */]), defineProperty_default()(maternal_special_room__components, es["d" /* DatetimePicker */].name, es["d" /* DatetimePicker */]), maternal_special_room__components),
  // Vant 2.x 中 Loading 使用 Toast.loading() 方式，不需要单独注册
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      currentDate: new Date(), // 日期选择器的当前值
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2100, 11, 31),
      showDatePicker: false,

      tag: '',
      tagDisplayName: '',
      showTagPicker: false,

      warning_level: '1', // 预警等级：1-关注（默认），2-提醒，3-紧急，4-特急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],

      remark: '',
      agent_list: [],
      agent_id: '',
      agentDisplayName: '',
      showAgentPicker: false,

      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      // 部门ID：默认从 store 中获取（在 created 钩子中设置）
      department_id: '',

      departments: [],
      department: '',
      departmentDisplayName: '',
      showDepartmentPicker: false,

      positions: []
    }, defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'positionDisplayName', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'agentSelectDisplayName', ''), defineProperty_default()(_ref, 'showAgentSelectPicker', false), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },

  computed: {
    // 汇报人选择器数据格式转换
    agentColumns: function agentColumns() {
      return this.agent_list.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    },

    // 特殊标签选择器数据格式转换
    tagColumns: function tagColumns() {
      return this.tag_List.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器数据格式转换
    departmentColumns: function departmentColumns() {
      return this.departments.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器默认选中当前用户部门
    departmentDefaultIndex: function departmentDefaultIndex() {
      var _this = this;

      if (!this.department_id) {
        return 0;
      }
      var index = this.departments.findIndex(function (item) {
        var itemValue = item.key || item.id;
        console.log('itemValue', itemValue);
        return String(itemValue) === String(_this.department_id);
      });
      return index === -1 ? 0 : index;
    },

    // 职位选择器数据格式转换
    positionColumns: function positionColumns() {
      return this.positions.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 员工选择器数据格式转换
    agentSelectColumns: function agentSelectColumns() {
      return this.agents.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    }
  },
  methods: {
    // 拉取当前用户信息（通过 @store.$userInfo）
    fetchUserInfo: function fetchUserInfo() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, url, res, body, user;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                id = _this2.$cookie.get('id');

                if (id) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                // 通过 @store 的 userInfo 工具生成接口 URL
                url = _this2.$store.$userInfo.getUserInfoUrl({
                  id: id,
                  key: _this2.$cookie.get('token')
                });
                _context.next = 7;
                return _this2.$http.get(url);

              case 7:
                res = _context.sent;

                // 后端约定：{ errcode: 1, data: { ...用户信息... } }
                body = res && res.data ? res.data : res;

                if (body && body.errcode === 1 && body.data) {
                  user = body.data;
                  // 根据返回结构按需保存到本页面（这里先用到 department_id）

                  if (user.department_id) {
                    _this2.department_id = user.department_id;
                  }
                  // 如有需要，可在此扩展更多字段
                }
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                console.error('fetchUserInfo error:', _context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    },

    // 从 store 的 app 模块获取 actions（使用 mapActions）
    // ...mapActions('app', [
    //   'setUserInfo',        // 设置用户信息
    //   'setUserDepartment',  // 设置部门信息
    //   'resetAppState'       // 重置应用状态
    // ]),

    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },


    // 日期选择确认
    onDateConfirm: function onDateConfirm(value) {
      var date = new Date(value);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var day = date.getDate();
      day = day < 10 ? '0' + day : day;
      this.date = year + '-' + month + '-' + day;
      // date 字段的值会自动同步（因为 v-model="date"）
      this.showDatePicker = false;
    },


    // 汇报人选择确认
    onAgentConfirm: function onAgentConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentPicker = false;
        return;
      }

      // 设置汇报人ID和显示名称
      this.agent_id = agentId;

      // 查找显示名称
      var selected = this.agent_list.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentDisplayName = selected ? selected.value || selected.user_name : this.agentColumns[index] && this.agentColumns[index].text || '';

      this.showAgentPicker = false;
    },


    // 特殊标签选择确认
    onTagConfirm: function onTagConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var tagId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!tagId) {
        this.showTagPicker = false;
        return;
      }

      // 设置特殊标签ID和显示名称
      this.tag = tagId;

      // 查找显示名称
      var selected = this.tag_List.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(tagId);
      });
      this.tagDisplayName = selected ? selected.value || selected.name : this.tagColumns[index] && this.tagColumns[index].text || '';

      this.showTagPicker = false;
    },


    // 部门选择确认
    onDepartmentConfirm: function onDepartmentConfirm(value, index) {
      // Vant 2.x Picker 单列选择器的 confirm 事件返回两个参数：(value, index)
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var departmentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!departmentId) {
        es["l" /* Toast */].fail('请选择有效的部门');
        this.showDepartmentPicker = false;
        return;
      }

      // 设置部门ID和显示名称
      this.selectDpId = departmentId;

      // 查找显示名称
      var selected = this.departments.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(departmentId);
      });
      this.departmentDisplayName = selected ? selected.value || selected.name : this.departmentColumns[index] && this.departmentColumns[index].text || '';

      // 清空职位和员工选择
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];

      // 加载职位列表
      this.apiPostionList(this.selectDpId);
      this.showDepartmentPicker = false;
    },


    // 职位选择确认
    onPositionConfirm: function onPositionConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var positionId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!positionId) {
        this.showPositionPicker = false;
        return;
      }

      // 设置职位ID和显示名称
      this.selectPsId = positionId;

      // 查找显示名称
      var selected = this.positions.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(positionId);
      });
      this.positionDisplayName = selected ? selected.value || selected.name : this.positionColumns[index] && this.positionColumns[index].text || '';

      // 清空员工选择
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.agents = [];

      // 加载员工列表
      this.apiAgentList();
      this.showPositionPicker = false;
    },


    // 员工选择确认
    onAgentSelectConfirm: function onAgentSelectConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentSelectPicker = false;
        return;
      }

      // 设置员工ID和显示名称
      this.selectAgId = agentId;

      // 查找显示名称
      var selected = this.agents.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentSelectDisplayName = selected ? selected.value || selected.user_name : this.agentSelectColumns[index] && this.agentSelectColumns[index].text || '';

      this.showAgentSelectPicker = false;
    },


    // 表单提交处理
    onSubmit: function onSubmit() {
      var _this3 = this;

      // 检查 form ref 是否存在
      if (!this.$refs.form) {
        console.error('Form ref 不存在');
        es["l" /* Toast */].fail('表单初始化失败');
        return;
      }

      // 使用 Form 组件进行表单验证
      this.$refs.form.validate().then(function () {
        // 验证通过，提交表单数据
        // 注意：对于只读选择器字段，Form 获取的是显示名称，所以直接从 data 中获取实际值
        _this3.submitForm();
      }).catch(function (err) {
        // 验证失败，Form 组件会自动显示错误信息
        console.log('表单验证失败:', err);
        Object(es["l" /* Toast */])('请完善表单信息');
      });
    },


    // 实际提交表单数据的方法
    submitForm: function submitForm() {
      var _this4 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在提交',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });

      // 构建提交参数
      // Form 组件主要用于验证，实际值从 data 中获取
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        // 表单字段值（Form 已验证这些字段不为空）
        date: this.date,
        agent_id: this.agent_id,
        tag_id: this.tag,
        remark: this.remark,
        // 非表单字段
        warning_level: this.warning_level, // 预警等级（Tag 组件，不在 Form Field 中）
        agent_ids: this.selectAgent.map(function (agent) {
          return agent.id;
        }) // 上报给（不在 Form Field 中）
      };
      console.log('params', params);
      Api.otherFormApi.specialReportAddRoom(params).then(function (res) {
        console.log('res', res);
        // 关闭加载提示
        es["l" /* Toast */].clear();

        if (res.errcode == 1) {
          es["l" /* Toast */].success('提交成功');

          setTimeout(function () {
            _this4.goBack();
          }, 1000);
        } else {
          es["l" /* Toast */].fail(res.errinfo || '提交失败');
        }
      }).catch(function (err) {
        console.error('API 请求失败:', err);
        // 关闭加载提示
        es["l" /* Toast */].clear();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        es["l" /* Toast */].fail(errorMsg);
      });
    },
    apiSpecialReportRoom: function apiSpecialReportRoom() {
      var _this5 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在加载',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
      };
      Api.otherFormApi.getSpecialReportRoom(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this5.tag_List = [];
          _this5.agent_list = [];

          _this5.agent_list = res.data.agent_list;
          _this5.tag_List = res.data.tag_List;

          _this5.tag_List.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          _this5.agent_list.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });

          // 如果 agent_id 已设置（默认当前用户），设置显示名称
          if (_this5.agent_id) {
            var currentAgent = _this5.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this5.agent_id);
            });
            if (currentAgent) {
              _this5.agentDisplayName = currentAgent.value || currentAgent.user_name;
            }
          }

          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiDeportment: function apiDeportment() {
      var _this6 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this6.departments = res.data;
          _this6.departments.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiAgentList: function apiAgentList() {
      var _this7 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this7.agents = res.data;
          _this7.agents.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this8 = this;

      // 确保 department_id 是原始值，不是响应式对象
      var deptId = department_id && (typeof department_id === 'undefined' ? 'undefined' : typeof_default()(department_id)) === 'object' && !Array.isArray(department_id) ? department_id.value : department_id;

      if (!deptId) {
        es["l" /* Toast */].fail('部门ID不能为空');
        return;
      }

      es["l" /* Toast */].loading({
        message: '正在加载职位列表',
        forbidClick: true,
        duration: 0
      });

      var params = {
        token: this.$cookie.get('token'),
        department_id: deptId
      };

      Api.otherFormApi.getPositionList(params).then(function (res) {
        es["l" /* Toast */].clear();
        if (res.errcode == 1) {
          _this8.positions = res.data || [];
          _this8.positions.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
        } else {
          es["l" /* Toast */].fail(res.errinfo || '加载职位列表失败');
        }
      }).catch(function (err) {
        es["l" /* Toast */].clear();
        var errorMsg = '加载职位列表失败';
        if (err.response) {
          errorMsg = err.response.status === 404 ? '职位列表接口不存在(404)，请检查API配置' : '\u52A0\u8F7D\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
        } else if (err.request) {
          errorMsg = '网络错误，请检查网络连接';
        }
        es["l" /* Toast */].fail(errorMsg);
        console.error('职位列表API请求失败:', err);
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
      // 重置选择状态
      this.selectDpId = '';
      this.departmentDisplayName = '';
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    dialog_confirm: function dialog_confirm() {
      var _this9 = this;

      if (!this.selectAgId) {
        Object(es["l" /* Toast */])('请选择员工');
        return;
      }

      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (!selectAg) {
        Object(es["l" /* Toast */])('员工信息不存在');
        return;
      }

      // 检查是否已添加
      var exists = this.selectAgent.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (exists) {
        Object(es["l" /* Toast */])('该员工已添加');
        return;
      }

      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);

      // 关闭面板并重置选择
      this.dialog_cancel();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    }
  },
  created: function created() {
    // 从 Cookie 获取当前用户 ID（兼容现有代码）
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }
    // 页面打开时请求 userInfo
    this.fetchUserInfo();
    this.apiSpecialReportRoom();
    this.apiDeportment();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsVant/ssReport/maternal_special_room.vue






var ssReport_maternal_special_room__components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入 Vant 组件

// Vant 2.x 中 Loading 使用 Toast.loading() 方式
// import { Loading } from 'vant'  // Loading 在 Vant 2.x 中不是函数式 API

// 引入 Vant 组件样式
// 注意：虽然 babel-plugin-import 配置了 style: true，但为了确保样式正确加载，显式引入样式
// Vant 2.x 的样式路径（根据 babel-plugin-import 配置的 libraryDirectory: "es"）














/* harmony default export */ var componentsVant_ssReport_maternal_special_room = ({
  name: 'maternal_special_room_vant',
  components: (ssReport_maternal_special_room__components = {}, defineProperty_default()(ssReport_maternal_special_room__components, es["h" /* NavBar */].name, es["h" /* NavBar */]), defineProperty_default()(ssReport_maternal_special_room__components, es["b" /* Cell */].name, es["b" /* Cell */]), defineProperty_default()(ssReport_maternal_special_room__components, es["c" /* CellGroup */].name, es["c" /* CellGroup */]), defineProperty_default()(ssReport_maternal_special_room__components, es["f" /* Form */].name, es["f" /* Form */]), defineProperty_default()(ssReport_maternal_special_room__components, es["e" /* Field */].name, es["e" /* Field */]), defineProperty_default()(ssReport_maternal_special_room__components, es["a" /* Button */].name, es["a" /* Button */]), defineProperty_default()(ssReport_maternal_special_room__components, es["g" /* Icon */].name, es["g" /* Icon */]), defineProperty_default()(ssReport_maternal_special_room__components, es["k" /* Tag */].name, es["k" /* Tag */]), defineProperty_default()(ssReport_maternal_special_room__components, es["j" /* Popup */].name, es["j" /* Popup */]), defineProperty_default()(ssReport_maternal_special_room__components, es["i" /* Picker */].name, es["i" /* Picker */]), defineProperty_default()(ssReport_maternal_special_room__components, es["d" /* DatetimePicker */].name, es["d" /* DatetimePicker */]), ssReport_maternal_special_room__components),
  // Vant 2.x 中 Loading 使用 Toast.loading() 方式，不需要单独注册
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      currentDate: new Date(), // 日期选择器的当前值
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2100, 11, 31),
      showDatePicker: false,

      tag: '',
      tagDisplayName: '',
      showTagPicker: false,

      warning_level: '1', // 预警等级：1-关注（默认），2-提醒，3-紧急，4-特急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],

      remark: '',
      agent_list: [],
      agent_id: '',
      agentDisplayName: '',
      showAgentPicker: false,

      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      // 部门ID：默认从 store 中获取（在 created 钩子中设置）
      department_id: '',

      departments: [],
      department: '',
      departmentDisplayName: '',
      showDepartmentPicker: false,

      positions: []
    }, defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'positionDisplayName', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'agentSelectDisplayName', ''), defineProperty_default()(_ref, 'showAgentSelectPicker', false), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },

  computed: {
    // 汇报人选择器数据格式转换
    agentColumns: function agentColumns() {
      return this.agent_list.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    },

    // 特殊标签选择器数据格式转换
    tagColumns: function tagColumns() {
      return this.tag_List.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器数据格式转换
    departmentColumns: function departmentColumns() {
      return this.departments.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器默认选中当前用户部门
    departmentDefaultIndex: function departmentDefaultIndex() {
      var _this = this;

      if (!this.department_id) {
        return 0;
      }
      var index = this.departments.findIndex(function (item) {
        var itemValue = item.key || item.id;
        console.log('itemValue', itemValue);
        return String(itemValue) === String(_this.department_id);
      });
      return index === -1 ? 0 : index;
    },

    // 职位选择器数据格式转换
    positionColumns: function positionColumns() {
      return this.positions.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 员工选择器数据格式转换
    agentSelectColumns: function agentSelectColumns() {
      return this.agents.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    }
  },
  methods: {
    // 拉取当前用户信息（通过 @store.$userInfo）
    fetchUserInfo: function fetchUserInfo() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, url, res, body, user;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                id = _this2.$cookie.get('id');

                if (id) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                // 通过 @store 的 userInfo 工具生成接口 URL
                url = _this2.$store.$userInfo.getUserInfoUrl({
                  id: id,
                  key: _this2.$cookie.get('token')
                });
                _context.next = 7;
                return _this2.$http.get(url);

              case 7:
                res = _context.sent;

                // 后端约定：{ errcode: 1, data: { ...用户信息... } }
                body = res && res.data ? res.data : res;

                if (body && body.errcode === 1 && body.data) {
                  user = body.data;
                  // 根据返回结构按需保存到本页面（这里先用到 department_id）

                  if (user.department_id) {
                    _this2.department_id = user.department_id;
                  }
                  // 如有需要，可在此扩展更多字段
                }
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                console.error('fetchUserInfo error:', _context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    },

    // 从 store 的 app 模块获取 actions（使用 mapActions）
    // ...mapActions('app', [
    //   'setUserInfo',        // 设置用户信息
    //   'setUserDepartment',  // 设置部门信息
    //   'resetAppState'       // 重置应用状态
    // ]),

    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },


    // 日期选择确认
    onDateConfirm: function onDateConfirm(value) {
      var date = new Date(value);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var day = date.getDate();
      day = day < 10 ? '0' + day : day;
      this.date = year + '-' + month + '-' + day;
      // date 字段的值会自动同步（因为 v-model="date"）
      this.showDatePicker = false;
    },


    // 汇报人选择确认
    onAgentConfirm: function onAgentConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentPicker = false;
        return;
      }

      // 设置汇报人ID和显示名称
      this.agent_id = agentId;

      // 查找显示名称
      var selected = this.agent_list.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentDisplayName = selected ? selected.value || selected.user_name : this.agentColumns[index] && this.agentColumns[index].text || '';

      this.showAgentPicker = false;
    },


    // 特殊标签选择确认
    onTagConfirm: function onTagConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var tagId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!tagId) {
        this.showTagPicker = false;
        return;
      }

      // 设置特殊标签ID和显示名称
      this.tag = tagId;

      // 查找显示名称
      var selected = this.tag_List.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(tagId);
      });
      this.tagDisplayName = selected ? selected.value || selected.name : this.tagColumns[index] && this.tagColumns[index].text || '';

      this.showTagPicker = false;
    },


    // 部门选择确认
    onDepartmentConfirm: function onDepartmentConfirm(value, index) {
      // Vant 2.x Picker 单列选择器的 confirm 事件返回两个参数：(value, index)
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var departmentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!departmentId) {
        es["l" /* Toast */].fail('请选择有效的部门');
        this.showDepartmentPicker = false;
        return;
      }

      // 设置部门ID和显示名称
      this.selectDpId = departmentId;

      // 查找显示名称
      var selected = this.departments.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(departmentId);
      });
      this.departmentDisplayName = selected ? selected.value || selected.name : this.departmentColumns[index] && this.departmentColumns[index].text || '';

      // 清空职位和员工选择
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];

      // 加载职位列表
      this.apiPostionList(this.selectDpId);
      this.showDepartmentPicker = false;
    },


    // 职位选择确认
    onPositionConfirm: function onPositionConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var positionId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!positionId) {
        this.showPositionPicker = false;
        return;
      }

      // 设置职位ID和显示名称
      this.selectPsId = positionId;

      // 查找显示名称
      var selected = this.positions.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(positionId);
      });
      this.positionDisplayName = selected ? selected.value || selected.name : this.positionColumns[index] && this.positionColumns[index].text || '';

      // 清空员工选择
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.agents = [];

      // 加载员工列表
      this.apiAgentList();
      this.showPositionPicker = false;
    },


    // 员工选择确认
    onAgentSelectConfirm: function onAgentSelectConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentSelectPicker = false;
        return;
      }

      // 设置员工ID和显示名称
      this.selectAgId = agentId;

      // 查找显示名称
      var selected = this.agents.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentSelectDisplayName = selected ? selected.value || selected.user_name : this.agentSelectColumns[index] && this.agentSelectColumns[index].text || '';

      this.showAgentSelectPicker = false;
    },


    // 表单提交处理
    onSubmit: function onSubmit() {
      var _this3 = this;

      // 检查 form ref 是否存在
      if (!this.$refs.form) {
        console.error('Form ref 不存在');
        es["l" /* Toast */].fail('表单初始化失败');
        return;
      }

      // 使用 Form 组件进行表单验证
      this.$refs.form.validate().then(function () {
        // 验证通过，提交表单数据
        // 注意：对于只读选择器字段，Form 获取的是显示名称，所以直接从 data 中获取实际值
        _this3.submitForm();
      }).catch(function (err) {
        // 验证失败，Form 组件会自动显示错误信息
        console.log('表单验证失败:', err);
        Object(es["l" /* Toast */])('请完善表单信息');
      });
    },


    // 实际提交表单数据的方法
    submitForm: function submitForm() {
      var _this4 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在提交',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });

      // 构建提交参数
      // Form 组件主要用于验证，实际值从 data 中获取
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        // 表单字段值（Form 已验证这些字段不为空）
        date: this.date,
        agent_id: this.agent_id,
        tag_id: this.tag,
        remark: this.remark,
        // 非表单字段
        warning_level: this.warning_level, // 预警等级（Tag 组件，不在 Form Field 中）
        agent_ids: this.selectAgent.map(function (agent) {
          return agent.id;
        }) // 上报给（不在 Form Field 中）
      };
      console.log('params', params);
      Api.otherFormApi.specialReportAddRoom(params).then(function (res) {
        console.log('res', res);
        // 关闭加载提示
        es["l" /* Toast */].clear();

        if (res.errcode == 1) {
          es["l" /* Toast */].success('提交成功');

          setTimeout(function () {
            _this4.goBack();
          }, 1000);
        } else {
          es["l" /* Toast */].fail(res.errinfo || '提交失败');
        }
      }).catch(function (err) {
        console.error('API 请求失败:', err);
        // 关闭加载提示
        es["l" /* Toast */].clear();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        es["l" /* Toast */].fail(errorMsg);
      });
    },
    apiSpecialReportRoom: function apiSpecialReportRoom() {
      var _this5 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在加载',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
      };
      Api.otherFormApi.getSpecialReportRoom(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this5.tag_List = [];
          _this5.agent_list = [];

          _this5.agent_list = res.data.agent_list;
          _this5.tag_List = res.data.tag_List;

          _this5.tag_List.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          _this5.agent_list.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });

          // 如果 agent_id 已设置（默认当前用户），设置显示名称
          if (_this5.agent_id) {
            var currentAgent = _this5.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this5.agent_id);
            });
            if (currentAgent) {
              _this5.agentDisplayName = currentAgent.value || currentAgent.user_name;
            }
          }

          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiDeportment: function apiDeportment() {
      var _this6 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this6.departments = res.data;
          _this6.departments.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiAgentList: function apiAgentList() {
      var _this7 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this7.agents = res.data;
          _this7.agents.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this8 = this;

      // 确保 department_id 是原始值，不是响应式对象
      var deptId = department_id && (typeof department_id === 'undefined' ? 'undefined' : typeof_default()(department_id)) === 'object' && !Array.isArray(department_id) ? department_id.value : department_id;

      if (!deptId) {
        es["l" /* Toast */].fail('部门ID不能为空');
        return;
      }

      es["l" /* Toast */].loading({
        message: '正在加载职位列表',
        forbidClick: true,
        duration: 0
      });

      var params = {
        token: this.$cookie.get('token'),
        department_id: deptId
      };

      Api.otherFormApi.getPositionList(params).then(function (res) {
        es["l" /* Toast */].clear();
        if (res.errcode == 1) {
          _this8.positions = res.data || [];
          _this8.positions.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
        } else {
          es["l" /* Toast */].fail(res.errinfo || '加载职位列表失败');
        }
      }).catch(function (err) {
        es["l" /* Toast */].clear();
        var errorMsg = '加载职位列表失败';
        if (err.response) {
          errorMsg = err.response.status === 404 ? '职位列表接口不存在(404)，请检查API配置' : '\u52A0\u8F7D\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
        } else if (err.request) {
          errorMsg = '网络错误，请检查网络连接';
        }
        es["l" /* Toast */].fail(errorMsg);
        console.error('职位列表API请求失败:', err);
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
      // 重置选择状态
      this.selectDpId = '';
      this.departmentDisplayName = '';
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    dialog_confirm: function dialog_confirm() {
      var _this9 = this;

      if (!this.selectAgId) {
        Object(es["l" /* Toast */])('请选择员工');
        return;
      }

      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (!selectAg) {
        Object(es["l" /* Toast */])('员工信息不存在');
        return;
      }

      // 检查是否已添加
      var exists = this.selectAgent.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (exists) {
        Object(es["l" /* Toast */])('该员工已添加');
        return;
      }

      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);

      // 关闭面板并重置选择
      this.dialog_cancel();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    }
  },
  created: function created() {
    // 从 Cookie 获取当前用户 ID（兼容现有代码）
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }
    // 页面打开时请求 userInfo
    this.fetchUserInfo();
    this.apiSpecialReportRoom();
    this.apiDeportment();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07006087","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/componentsVant/ssReport/maternal_special_room.vue
var ssReport_maternal_special_room_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"特情上报(客房)","left-text":"孕妇档案","left-arrow":""},on:{"click-left":_vm.goBack}}),_vm._v(" "),_c('van-form',{ref:"form",on:{"submit":_vm.onSubmit}},[_c('van-cell-group',[_c('van-field',{attrs:{"name":"date","label":"日期","placeholder":"请选择日期","readonly":"","required":"","rules":[{ validator: function () { return this$1.date !== ''; }, message: '请选择日期' }]},on:{"click":function($event){_vm.showDatePicker = true}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showDatePicker),callback:function ($$v) {_vm.showDatePicker=$$v},expression:"showDatePicker"}},[_c('van-datetime-picker',{attrs:{"type":"date","min-date":_vm.minDate,"max-date":_vm.maxDate,"show-toolbar":"","title":"选择日期","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onDateConfirm,"cancel":function($event){_vm.showDatePicker = false}},model:{value:(_vm.currentDate),callback:function ($$v) {_vm.currentDate=$$v},expression:"currentDate"}})],1),_vm._v(" "),_c('van-field',{attrs:{"name":"agent_id","label":"汇报人：","placeholder":"请选择汇报人","readonly":"","required":"","rules":[{ validator: function () { return this$1.agent_id !== ''; }, message: '请选择汇报人' }]},on:{"click":function($event){_vm.showAgentPicker = true}},model:{value:(_vm.agentDisplayName),callback:function ($$v) {_vm.agentDisplayName=$$v},expression:"agentDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showAgentPicker),callback:function ($$v) {_vm.showAgentPicker=$$v},expression:"showAgentPicker"}},[_c('van-picker',{attrs:{"columns":_vm.agentColumns,"show-toolbar":"","title":"选择汇报人","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onAgentConfirm,"cancel":function($event){_vm.showAgentPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"name":"tag","label":"特殊标签：","placeholder":"请选择特殊标签","readonly":"","required":"","rules":[{ validator: function () { return this$1.tag !== ''; }, message: '请选择特殊标签' }]},on:{"click":function($event){_vm.showTagPicker = true}},model:{value:(_vm.tagDisplayName),callback:function ($$v) {_vm.tagDisplayName=$$v},expression:"tagDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showTagPicker),callback:function ($$v) {_vm.showTagPicker=$$v},expression:"showTagPicker"}},[_c('van-picker',{attrs:{"columns":_vm.tagColumns,"show-toolbar":"","title":"选择特殊标签","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onTagConfirm,"cancel":function($event){_vm.showTagPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"name":"remark","type":"textarea","label":"备注：","placeholder":"500字（含）以内","required":"","rules":[{ required: true, message: '请填写备注' }],"maxlength":500,"show-word-limit":"","rows":"3","autosize":""},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}}),_vm._v(" "),_c('div',{staticClass:"warning-level-group"},[_c('div',{staticClass:"warning-level-label"},[_vm._v("预警等级：")]),_vm._v(" "),_c('div',{staticClass:"tag-group"},_vm._l((_vm.warningLevelOptions),function(item){return _c('van-tag',{key:item.value,staticClass:"warning-tag-item",attrs:{"type":_vm.warning_level === item.value ? 'primary' : 'default',"plain":_vm.warning_level !== item.value,"size":"large"},on:{"click":function($event){_vm.warning_level = item.value}}},[_vm._v("\n            "+_vm._s(item.label)+"\n          ")])}),1)])],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-cell',{attrs:{"title":"上报给：","value":"添加","is-link":""},on:{"click":_vm.showChageAgent}}),_vm._v(" "),_c('div',{staticClass:"agent-tags-container"},[(_vm.selectAgent.length)?_vm._l((_vm.selectAgent),function(agent,index){return _c('van-tag',{key:index,staticClass:"agent-tag-item",attrs:{"plain":"true","type":"primary","size":"medium"}},[_c('span',[_vm._v(_vm._s(agent.name))]),_vm._v(" "),_c('van-icon',{staticClass:"agent-tag-close",attrs:{"name":"cross"},on:{"click":function($event){$event.stopPropagation();return _vm.removeAgent(agent.id)}}})],1)}):[_c('span',{staticClass:"agent-tag-empty"},[_vm._v("未添加记录")])]],2),_vm._v(" "),(_vm.showChangeAgentPanel)?_c('div',{staticClass:"agent-select-panel"},[_c('div',{staticClass:"agent-select-row"},[_c('van-field',{attrs:{"label":"部门","placeholder":"选择","readonly":""},on:{"click":function($event){_vm.showDepartmentPicker = true}},model:{value:(_vm.departmentDisplayName),callback:function ($$v) {_vm.departmentDisplayName=$$v},expression:"departmentDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showDepartmentPicker),callback:function ($$v) {_vm.showDepartmentPicker=$$v},expression:"showDepartmentPicker"}},[_c('van-picker',{attrs:{"columns":_vm.departmentColumns,"default-index":_vm.departmentDefaultIndex,"show-toolbar":"","title":"选择部门","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onDepartmentConfirm,"cancel":function($event){_vm.showDepartmentPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"label":"职位","placeholder":"选择","readonly":"","disabled":!_vm.selectDpId},on:{"click":function($event){_vm.showPositionPicker = true}},model:{value:(_vm.positionDisplayName),callback:function ($$v) {_vm.positionDisplayName=$$v},expression:"positionDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showPositionPicker),callback:function ($$v) {_vm.showPositionPicker=$$v},expression:"showPositionPicker"}},[_c('van-picker',{attrs:{"columns":_vm.positionColumns,"show-toolbar":"","title":"选择职位","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onPositionConfirm,"cancel":function($event){_vm.showPositionPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"label":"员工","placeholder":"选择","readonly":"","disabled":!_vm.selectPsId},on:{"click":function($event){_vm.showAgentSelectPicker = true}},model:{value:(_vm.agentSelectDisplayName),callback:function ($$v) {_vm.agentSelectDisplayName=$$v},expression:"agentSelectDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showAgentSelectPicker),callback:function ($$v) {_vm.showAgentSelectPicker=$$v},expression:"showAgentSelectPicker"}},[_c('van-picker',{attrs:{"columns":_vm.agentSelectColumns,"show-toolbar":"","title":"选择员工","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onAgentSelectConfirm,"cancel":function($event){_vm.showAgentSelectPicker = false}}})],1)],1),_vm._v(" "),_c('div',{staticClass:"agent-select-buttons"},[_c('van-button',{staticClass:"confirm-btn",attrs:{"type":"default","size":"small"},on:{"click":_vm.dialog_confirm}},[_vm._v("确认")]),_vm._v(" "),_c('van-button',{staticClass:"cancel-btn",attrs:{"type":"warning","size":"small"},on:{"click":_vm.dialog_cancel}},[_vm._v("取消")])],1)]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"submit-button-container"},[_c('van-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("确定")])],1)],1)}
var ssReport_maternal_special_room_staticRenderFns = []
var ssReport_maternal_special_room_esExports = { render: ssReport_maternal_special_room_render, staticRenderFns: ssReport_maternal_special_room_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_componentsVant_ssReport_maternal_special_room = (ssReport_maternal_special_room_esExports);
// CONCATENATED MODULE: ./src/componentsVant/ssReport/maternal_special_room.vue
function ssReport_maternal_special_room_injectStyle (ssrContext) {
  __webpack_require__("r4pl")
}
var ssReport_maternal_special_room_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ssReport_maternal_special_room___vue_template_functional__ = false
/* styles */
var ssReport_maternal_special_room___vue_styles__ = ssReport_maternal_special_room_injectStyle
/* scopeId */
var ssReport_maternal_special_room___vue_scopeId__ = "data-v-07006087"
/* moduleIdentifier (server only) */
var ssReport_maternal_special_room___vue_module_identifier__ = null
var ssReport_maternal_special_room_Component = ssReport_maternal_special_room_normalizeComponent(
  componentsVant_ssReport_maternal_special_room,
  selectortype_template_index_0_src_componentsVant_ssReport_maternal_special_room,
  ssReport_maternal_special_room___vue_template_functional__,
  ssReport_maternal_special_room___vue_styles__,
  ssReport_maternal_special_room___vue_scopeId__,
  ssReport_maternal_special_room___vue_module_identifier__
)

/* harmony default export */ var src_componentsVant_ssReport_maternal_special_room = (ssReport_maternal_special_room_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsVant/ssReport/maternal_special_meal.vue






var maternal_special_meal__components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入 Vant 组件

// Vant 2.x 中 Loading 使用 Toast.loading() 方式
// import { Loading } from 'vant'  // Loading 在 Vant 2.x 中不是函数式 API

// 引入 Vant 组件样式
// 注意：虽然 babel-plugin-import 配置了 style: true，但为了确保样式正确加载，显式引入样式
// Vant 2.x 的样式路径（根据 babel-plugin-import 配置的 libraryDirectory: "es"）














/* harmony default export */ var ssReport_maternal_special_meal = ({
  name: 'maternal_special_meal_vant',
  components: (maternal_special_meal__components = {}, defineProperty_default()(maternal_special_meal__components, es["h" /* NavBar */].name, es["h" /* NavBar */]), defineProperty_default()(maternal_special_meal__components, es["b" /* Cell */].name, es["b" /* Cell */]), defineProperty_default()(maternal_special_meal__components, es["c" /* CellGroup */].name, es["c" /* CellGroup */]), defineProperty_default()(maternal_special_meal__components, es["f" /* Form */].name, es["f" /* Form */]), defineProperty_default()(maternal_special_meal__components, es["e" /* Field */].name, es["e" /* Field */]), defineProperty_default()(maternal_special_meal__components, es["a" /* Button */].name, es["a" /* Button */]), defineProperty_default()(maternal_special_meal__components, es["g" /* Icon */].name, es["g" /* Icon */]), defineProperty_default()(maternal_special_meal__components, es["k" /* Tag */].name, es["k" /* Tag */]), defineProperty_default()(maternal_special_meal__components, es["j" /* Popup */].name, es["j" /* Popup */]), defineProperty_default()(maternal_special_meal__components, es["i" /* Picker */].name, es["i" /* Picker */]), defineProperty_default()(maternal_special_meal__components, es["d" /* DatetimePicker */].name, es["d" /* DatetimePicker */]), maternal_special_meal__components),
  // Vant 2.x 中 Loading 使用 Toast.loading() 方式，不需要单独注册
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      currentDate: new Date(), // 日期选择器的当前值
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2100, 11, 31),
      showDatePicker: false,

      tag: '',
      tagDisplayName: '',
      showTagPicker: false,

      warning_level: '1', // 预警等级：1-关注（默认），2-提醒，3-紧急，4-特急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],

      remark: '',
      agent_list: [],
      agent_id: '',
      agentDisplayName: '',
      showAgentPicker: false,

      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      // 部门ID：默认从 store 中获取（在 created 钩子中设置）
      department_id: '',

      departments: [],
      department: '',
      departmentDisplayName: '',
      showDepartmentPicker: false,

      positions: []
    }, defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'positionDisplayName', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'agentSelectDisplayName', ''), defineProperty_default()(_ref, 'showAgentSelectPicker', false), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },

  computed: {
    // 汇报人选择器数据格式转换
    agentColumns: function agentColumns() {
      return this.agent_list.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    },

    // 特殊标签选择器数据格式转换
    tagColumns: function tagColumns() {
      return this.tag_List.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器数据格式转换
    departmentColumns: function departmentColumns() {
      return this.departments.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器默认选中当前用户部门
    departmentDefaultIndex: function departmentDefaultIndex() {
      var _this = this;

      if (!this.department_id) {
        return 0;
      }
      var index = this.departments.findIndex(function (item) {
        var itemValue = item.key || item.id;
        console.log('itemValue', itemValue);
        return String(itemValue) === String(_this.department_id);
      });
      return index === -1 ? 0 : index;
    },

    // 职位选择器数据格式转换
    positionColumns: function positionColumns() {
      return this.positions.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 员工选择器数据格式转换
    agentSelectColumns: function agentSelectColumns() {
      return this.agents.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    }
  },
  methods: {
    // 拉取当前用户信息（通过 @store.$userInfo）
    fetchUserInfo: function fetchUserInfo() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, url, res, body, user;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                id = _this2.$cookie.get('id');

                if (id) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                // 通过 @store 的 userInfo 工具生成接口 URL
                url = _this2.$store.$userInfo.getUserInfoUrl({
                  id: id,
                  key: _this2.$cookie.get('token')
                });
                _context.next = 7;
                return _this2.$http.get(url);

              case 7:
                res = _context.sent;

                // 后端约定：{ errcode: 1, data: { ...用户信息... } }
                body = res && res.data ? res.data : res;

                if (body && body.errcode === 1 && body.data) {
                  user = body.data;
                  // 根据返回结构按需保存到本页面（这里先用到 department_id）

                  if (user.department_id) {
                    _this2.department_id = user.department_id;
                  }
                  // 如有需要，可在此扩展更多字段
                }
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                console.error('fetchUserInfo error:', _context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    },

    // 从 store 的 app 模块获取 actions（使用 mapActions）
    // ...mapActions('app', [
    //   'setUserInfo',        // 设置用户信息
    //   'setUserDepartment',  // 设置部门信息
    //   'resetAppState'       // 重置应用状态
    // ]),

    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },


    // 日期选择确认
    onDateConfirm: function onDateConfirm(value) {
      var date = new Date(value);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var day = date.getDate();
      day = day < 10 ? '0' + day : day;
      this.date = year + '-' + month + '-' + day;
      // date 字段的值会自动同步（因为 v-model="date"）
      this.showDatePicker = false;
    },


    // 汇报人选择确认
    onAgentConfirm: function onAgentConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentPicker = false;
        return;
      }

      // 设置汇报人ID和显示名称
      this.agent_id = agentId;

      // 查找显示名称
      var selected = this.agent_list.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentDisplayName = selected ? selected.value || selected.user_name : this.agentColumns[index] && this.agentColumns[index].text || '';

      this.showAgentPicker = false;
    },


    // 特殊标签选择确认
    onTagConfirm: function onTagConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var tagId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!tagId) {
        this.showTagPicker = false;
        return;
      }

      // 设置特殊标签ID和显示名称
      this.tag = tagId;

      // 查找显示名称
      var selected = this.tag_List.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(tagId);
      });
      this.tagDisplayName = selected ? selected.value || selected.name : this.tagColumns[index] && this.tagColumns[index].text || '';

      this.showTagPicker = false;
    },


    // 部门选择确认
    onDepartmentConfirm: function onDepartmentConfirm(value, index) {
      // Vant 2.x Picker 单列选择器的 confirm 事件返回两个参数：(value, index)
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var departmentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!departmentId) {
        es["l" /* Toast */].fail('请选择有效的部门');
        this.showDepartmentPicker = false;
        return;
      }

      // 设置部门ID和显示名称
      this.selectDpId = departmentId;

      // 查找显示名称
      var selected = this.departments.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(departmentId);
      });
      this.departmentDisplayName = selected ? selected.value || selected.name : this.departmentColumns[index] && this.departmentColumns[index].text || '';

      // 清空职位和员工选择
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];

      // 加载职位列表
      this.apiPostionList(this.selectDpId);
      this.showDepartmentPicker = false;
    },


    // 职位选择确认
    onPositionConfirm: function onPositionConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var positionId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!positionId) {
        this.showPositionPicker = false;
        return;
      }

      // 设置职位ID和显示名称
      this.selectPsId = positionId;

      // 查找显示名称
      var selected = this.positions.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(positionId);
      });
      this.positionDisplayName = selected ? selected.value || selected.name : this.positionColumns[index] && this.positionColumns[index].text || '';

      // 清空员工选择
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.agents = [];

      // 加载员工列表
      this.apiAgentList();
      this.showPositionPicker = false;
    },


    // 员工选择确认
    onAgentSelectConfirm: function onAgentSelectConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentSelectPicker = false;
        return;
      }

      // 设置员工ID和显示名称
      this.selectAgId = agentId;

      // 查找显示名称
      var selected = this.agents.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentSelectDisplayName = selected ? selected.value || selected.user_name : this.agentSelectColumns[index] && this.agentSelectColumns[index].text || '';

      this.showAgentSelectPicker = false;
    },


    // 表单提交处理
    onSubmit: function onSubmit() {
      var _this3 = this;

      // 检查 form ref 是否存在
      if (!this.$refs.form) {
        console.error('Form ref 不存在');
        es["l" /* Toast */].fail('表单初始化失败');
        return;
      }

      // 使用 Form 组件进行表单验证
      this.$refs.form.validate().then(function () {
        // 验证通过，提交表单数据
        // 注意：对于只读选择器字段，Form 获取的是显示名称，所以直接从 data 中获取实际值
        _this3.submitForm();
      }).catch(function (err) {
        // 验证失败，Form 组件会自动显示错误信息
        console.log('表单验证失败:', err);
        Object(es["l" /* Toast */])('请完善表单信息');
      });
    },


    // 实际提交表单数据的方法
    submitForm: function submitForm() {
      var _this4 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在提交',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });

      // 构建提交参数
      // Form 组件主要用于验证，实际值从 data 中获取
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        // 表单字段值（Form 已验证这些字段不为空）
        date: this.date,
        agent_id: this.agent_id,
        tag_id: this.tag,
        remark: this.remark,
        // 非表单字段
        warning_level: this.warning_level, // 预警等级（Tag 组件，不在 Form Field 中）
        agent_ids: this.selectAgent.map(function (agent) {
          return agent.id;
        }) // 上报给（不在 Form Field 中）
      };
      console.log('params', params);
      Api.otherFormApi.specialReportAddMeal(params).then(function (res) {
        console.log('res', res);
        // 关闭加载提示
        es["l" /* Toast */].clear();

        if (res.errcode == 1) {
          es["l" /* Toast */].success('提交成功');

          setTimeout(function () {
            _this4.goBack();
          }, 1000);
        } else {
          es["l" /* Toast */].fail(res.errinfo || '提交失败');
        }
      }).catch(function (err) {
        console.error('API 请求失败:', err);
        // 关闭加载提示
        es["l" /* Toast */].clear();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        es["l" /* Toast */].fail(errorMsg);
      });
    },
    apiSpecialReportMeal: function apiSpecialReportMeal() {
      var _this5 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在加载',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
      };
      Api.otherFormApi.getSpecialReportMeal(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this5.tag_List = [];
          _this5.agent_list = [];

          _this5.agent_list = res.data.agent_list;
          _this5.tag_List = res.data.tag_List;

          _this5.tag_List.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          _this5.agent_list.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });

          // 如果 agent_id 已设置（默认当前用户），设置显示名称
          if (_this5.agent_id) {
            var currentAgent = _this5.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this5.agent_id);
            });
            if (currentAgent) {
              _this5.agentDisplayName = currentAgent.value || currentAgent.user_name;
            }
          }

          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiDeportment: function apiDeportment() {
      var _this6 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this6.departments = res.data;
          _this6.departments.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiAgentList: function apiAgentList() {
      var _this7 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this7.agents = res.data;
          _this7.agents.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this8 = this;

      // 确保 department_id 是原始值，不是响应式对象
      var deptId = department_id && (typeof department_id === 'undefined' ? 'undefined' : typeof_default()(department_id)) === 'object' && !Array.isArray(department_id) ? department_id.value : department_id;

      if (!deptId) {
        es["l" /* Toast */].fail('部门ID不能为空');
        return;
      }

      es["l" /* Toast */].loading({
        message: '正在加载职位列表',
        forbidClick: true,
        duration: 0
      });

      var params = {
        token: this.$cookie.get('token'),
        department_id: deptId
      };

      Api.otherFormApi.getPositionList(params).then(function (res) {
        es["l" /* Toast */].clear();
        if (res.errcode == 1) {
          _this8.positions = res.data || [];
          _this8.positions.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
        } else {
          es["l" /* Toast */].fail(res.errinfo || '加载职位列表失败');
        }
      }).catch(function (err) {
        es["l" /* Toast */].clear();
        var errorMsg = '加载职位列表失败';
        if (err.response) {
          errorMsg = err.response.status === 404 ? '职位列表接口不存在(404)，请检查API配置' : '\u52A0\u8F7D\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
        } else if (err.request) {
          errorMsg = '网络错误，请检查网络连接';
        }
        es["l" /* Toast */].fail(errorMsg);
        console.error('职位列表API请求失败:', err);
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
      // 重置选择状态
      this.selectDpId = '';
      this.departmentDisplayName = '';
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    dialog_confirm: function dialog_confirm() {
      var _this9 = this;

      if (!this.selectAgId) {
        Object(es["l" /* Toast */])('请选择员工');
        return;
      }

      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (!selectAg) {
        Object(es["l" /* Toast */])('员工信息不存在');
        return;
      }

      // 检查是否已添加
      var exists = this.selectAgent.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (exists) {
        Object(es["l" /* Toast */])('该员工已添加');
        return;
      }

      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);

      // 关闭面板并重置选择
      this.dialog_cancel();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    }
  },
  created: function created() {
    // 从 Cookie 获取当前用户 ID（兼容现有代码）
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }
    // 页面打开时请求 userInfo
    this.fetchUserInfo();
    this.apiSpecialReportMeal();
    this.apiDeportment();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsVant/ssReport/maternal_special_meal.vue






var ssReport_maternal_special_meal__components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入 Vant 组件

// Vant 2.x 中 Loading 使用 Toast.loading() 方式
// import { Loading } from 'vant'  // Loading 在 Vant 2.x 中不是函数式 API

// 引入 Vant 组件样式
// 注意：虽然 babel-plugin-import 配置了 style: true，但为了确保样式正确加载，显式引入样式
// Vant 2.x 的样式路径（根据 babel-plugin-import 配置的 libraryDirectory: "es"）














/* harmony default export */ var componentsVant_ssReport_maternal_special_meal = ({
  name: 'maternal_special_meal_vant',
  components: (ssReport_maternal_special_meal__components = {}, defineProperty_default()(ssReport_maternal_special_meal__components, es["h" /* NavBar */].name, es["h" /* NavBar */]), defineProperty_default()(ssReport_maternal_special_meal__components, es["b" /* Cell */].name, es["b" /* Cell */]), defineProperty_default()(ssReport_maternal_special_meal__components, es["c" /* CellGroup */].name, es["c" /* CellGroup */]), defineProperty_default()(ssReport_maternal_special_meal__components, es["f" /* Form */].name, es["f" /* Form */]), defineProperty_default()(ssReport_maternal_special_meal__components, es["e" /* Field */].name, es["e" /* Field */]), defineProperty_default()(ssReport_maternal_special_meal__components, es["a" /* Button */].name, es["a" /* Button */]), defineProperty_default()(ssReport_maternal_special_meal__components, es["g" /* Icon */].name, es["g" /* Icon */]), defineProperty_default()(ssReport_maternal_special_meal__components, es["k" /* Tag */].name, es["k" /* Tag */]), defineProperty_default()(ssReport_maternal_special_meal__components, es["j" /* Popup */].name, es["j" /* Popup */]), defineProperty_default()(ssReport_maternal_special_meal__components, es["i" /* Picker */].name, es["i" /* Picker */]), defineProperty_default()(ssReport_maternal_special_meal__components, es["d" /* DatetimePicker */].name, es["d" /* DatetimePicker */]), ssReport_maternal_special_meal__components),
  // Vant 2.x 中 Loading 使用 Toast.loading() 方式，不需要单独注册
  data: function data() {
    var _ref;

    // 获取当天日期，格式：YYYY-MM-DD
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    var day = today.getDate();
    day = day < 10 ? '0' + day : day;
    var todayDate = year + '-' + month + '-' + day;

    return _ref = {
      date: todayDate, // 默认设置为当天日期
      currentDate: new Date(), // 日期选择器的当前值
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(2100, 11, 31),
      showDatePicker: false,

      tag: '',
      tagDisplayName: '',
      showTagPicker: false,

      warning_level: '1', // 预警等级：1-关注（默认），2-提醒，3-紧急，4-特急
      // 预警等级选项
      warningLevelOptions: [{ value: '1', label: '关注' }, { value: '2', label: '提醒' }, { value: '3', label: '紧急' }, { value: '4', label: '特急' }],

      remark: '',
      agent_list: [],
      agent_id: '',
      agentDisplayName: '',
      showAgentPicker: false,

      tag_List: [],
      showChangeAgentPanel: false,
      position: '',
      // 部门ID：默认从 store 中获取（在 created 钩子中设置）
      department_id: '',

      departments: [],
      department: '',
      departmentDisplayName: '',
      showDepartmentPicker: false,

      positions: []
    }, defineProperty_default()(_ref, 'position', ''), defineProperty_default()(_ref, 'positionDisplayName', ''), defineProperty_default()(_ref, 'showPositionPicker', false), defineProperty_default()(_ref, 'agents', []), defineProperty_default()(_ref, 'agent', ''), defineProperty_default()(_ref, 'agentSelectDisplayName', ''), defineProperty_default()(_ref, 'showAgentSelectPicker', false), defineProperty_default()(_ref, 'selectDpId', ''), defineProperty_default()(_ref, 'selectPsId', ''), defineProperty_default()(_ref, 'selectAgId', ''), defineProperty_default()(_ref, 'selectAgent', []), _ref;
  },

  computed: {
    // 汇报人选择器数据格式转换
    agentColumns: function agentColumns() {
      return this.agent_list.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    },

    // 特殊标签选择器数据格式转换
    tagColumns: function tagColumns() {
      return this.tag_List.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器数据格式转换
    departmentColumns: function departmentColumns() {
      return this.departments.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 部门选择器默认选中当前用户部门
    departmentDefaultIndex: function departmentDefaultIndex() {
      var _this = this;

      if (!this.department_id) {
        return 0;
      }
      var index = this.departments.findIndex(function (item) {
        var itemValue = item.key || item.id;
        console.log('itemValue', itemValue);
        return String(itemValue) === String(_this.department_id);
      });
      return index === -1 ? 0 : index;
    },

    // 职位选择器数据格式转换
    positionColumns: function positionColumns() {
      return this.positions.map(function (item) {
        return {
          text: item.value || item.name,
          value: item.key || item.id
        };
      });
    },

    // 员工选择器数据格式转换
    agentSelectColumns: function agentSelectColumns() {
      return this.agents.map(function (item) {
        return {
          text: item.value || item.user_name,
          value: item.key || item.id
        };
      });
    }
  },
  methods: {
    // 拉取当前用户信息（通过 @store.$userInfo）
    fetchUserInfo: function fetchUserInfo() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var id, url, res, body, user;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                id = _this2.$cookie.get('id');

                if (id) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                // 通过 @store 的 userInfo 工具生成接口 URL
                url = _this2.$store.$userInfo.getUserInfoUrl({
                  id: id,
                  key: _this2.$cookie.get('token')
                });
                _context.next = 7;
                return _this2.$http.get(url);

              case 7:
                res = _context.sent;

                // 后端约定：{ errcode: 1, data: { ...用户信息... } }
                body = res && res.data ? res.data : res;

                if (body && body.errcode === 1 && body.data) {
                  user = body.data;
                  // 根据返回结构按需保存到本页面（这里先用到 department_id）

                  if (user.department_id) {
                    _this2.department_id = user.department_id;
                  }
                  // 如有需要，可在此扩展更多字段
                }
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](0);

                console.error('fetchUserInfo error:', _context.t0);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    },

    // 从 store 的 app 模块获取 actions（使用 mapActions）
    // ...mapActions('app', [
    //   'setUserInfo',        // 设置用户信息
    //   'setUserDepartment',  // 设置部门信息
    //   'resetAppState'       // 重置应用状态
    // ]),

    // 处理 order_total_id：如果是逗号分隔的多个 ID，取最大的一个
    getOrderTotalId: function getOrderTotalId() {
      var orderTotalId = this.$route.query.order_total_id;
      if (!orderTotalId) {
        return '';
      }
      // 检查是否包含逗号（多个 ID）
      if (orderTotalId.indexOf(',') !== -1) {
        // 分割成数组，转换为数字，取最大值
        var ids = orderTotalId.split(',').map(function (id) {
          return parseInt(id.trim(), 10);
        }).filter(function (id) {
          return !isNaN(id);
        });
        if (ids.length > 0) {
          return Math.max.apply(Math, toConsumableArray_default()(ids)).toString();
        }
      }
      // 单个 ID 或无效值，直接返回
      return orderTotalId;
    },


    // 日期选择确认
    onDateConfirm: function onDateConfirm(value) {
      var date = new Date(value);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var day = date.getDate();
      day = day < 10 ? '0' + day : day;
      this.date = year + '-' + month + '-' + day;
      // date 字段的值会自动同步（因为 v-model="date"）
      this.showDatePicker = false;
    },


    // 汇报人选择确认
    onAgentConfirm: function onAgentConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentPicker = false;
        return;
      }

      // 设置汇报人ID和显示名称
      this.agent_id = agentId;

      // 查找显示名称
      var selected = this.agent_list.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentDisplayName = selected ? selected.value || selected.user_name : this.agentColumns[index] && this.agentColumns[index].text || '';

      this.showAgentPicker = false;
    },


    // 特殊标签选择确认
    onTagConfirm: function onTagConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var tagId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!tagId) {
        this.showTagPicker = false;
        return;
      }

      // 设置特殊标签ID和显示名称
      this.tag = tagId;

      // 查找显示名称
      var selected = this.tag_List.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(tagId);
      });
      this.tagDisplayName = selected ? selected.value || selected.name : this.tagColumns[index] && this.tagColumns[index].text || '';

      this.showTagPicker = false;
    },


    // 部门选择确认
    onDepartmentConfirm: function onDepartmentConfirm(value, index) {
      // Vant 2.x Picker 单列选择器的 confirm 事件返回两个参数：(value, index)
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var departmentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!departmentId) {
        es["l" /* Toast */].fail('请选择有效的部门');
        this.showDepartmentPicker = false;
        return;
      }

      // 设置部门ID和显示名称
      this.selectDpId = departmentId;

      // 查找显示名称
      var selected = this.departments.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(departmentId);
      });
      this.departmentDisplayName = selected ? selected.value || selected.name : this.departmentColumns[index] && this.departmentColumns[index].text || '';

      // 清空职位和员工选择
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];

      // 加载职位列表
      this.apiPostionList(this.selectDpId);
      this.showDepartmentPicker = false;
    },


    // 职位选择确认
    onPositionConfirm: function onPositionConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var positionId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!positionId) {
        this.showPositionPicker = false;
        return;
      }

      // 设置职位ID和显示名称
      this.selectPsId = positionId;

      // 查找显示名称
      var selected = this.positions.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(positionId);
      });
      this.positionDisplayName = selected ? selected.value || selected.name : this.positionColumns[index] && this.positionColumns[index].text || '';

      // 清空员工选择
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.agents = [];

      // 加载员工列表
      this.apiAgentList();
      this.showPositionPicker = false;
    },


    // 员工选择确认
    onAgentSelectConfirm: function onAgentSelectConfirm(value, index) {
      // value 可能是对象（Vue Observer），需要提取 value.value 作为实际ID
      var agentId = value && (typeof value === 'undefined' ? 'undefined' : typeof_default()(value)) === 'object' && !Array.isArray(value) ? value.value : value;

      if (!agentId) {
        this.showAgentSelectPicker = false;
        return;
      }

      // 设置员工ID和显示名称
      this.selectAgId = agentId;

      // 查找显示名称
      var selected = this.agents.find(function (item) {
        var itemValue = item.key || item.id;
        return String(itemValue) === String(agentId);
      });
      this.agentSelectDisplayName = selected ? selected.value || selected.user_name : this.agentSelectColumns[index] && this.agentSelectColumns[index].text || '';

      this.showAgentSelectPicker = false;
    },


    // 表单提交处理
    onSubmit: function onSubmit() {
      var _this3 = this;

      // 检查 form ref 是否存在
      if (!this.$refs.form) {
        console.error('Form ref 不存在');
        es["l" /* Toast */].fail('表单初始化失败');
        return;
      }

      // 使用 Form 组件进行表单验证
      this.$refs.form.validate().then(function () {
        // 验证通过，提交表单数据
        // 注意：对于只读选择器字段，Form 获取的是显示名称，所以直接从 data 中获取实际值
        _this3.submitForm();
      }).catch(function (err) {
        // 验证失败，Form 组件会自动显示错误信息
        console.log('表单验证失败:', err);
        Object(es["l" /* Toast */])('请完善表单信息');
      });
    },


    // 实际提交表单数据的方法
    submitForm: function submitForm() {
      var _this4 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在提交',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });

      // 构建提交参数
      // Form 组件主要用于验证，实际值从 data 中获取
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        store_id: this.$route.query.store_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId(),
        // 表单字段值（Form 已验证这些字段不为空）
        date: this.date,
        agent_id: this.agent_id,
        tag_id: this.tag,
        remark: this.remark,
        // 非表单字段
        warning_level: this.warning_level, // 预警等级（Tag 组件，不在 Form Field 中）
        agent_ids: this.selectAgent.map(function (agent) {
          return agent.id;
        }) // 上报给（不在 Form Field 中）
      };
      console.log('params', params);
      Api.otherFormApi.specialReportAddMeal(params).then(function (res) {
        console.log('res', res);
        // 关闭加载提示
        es["l" /* Toast */].clear();

        if (res.errcode == 1) {
          es["l" /* Toast */].success('提交成功');

          setTimeout(function () {
            _this4.goBack();
          }, 1000);
        } else {
          es["l" /* Toast */].fail(res.errinfo || '提交失败');
        }
      }).catch(function (err) {
        console.error('API 请求失败:', err);
        // 关闭加载提示
        es["l" /* Toast */].clear();
        // 显示详细的错误信息
        var errorMsg = '提交失败';
        if (err.response) {
          // 服务器返回了响应
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
          console.error('Response data:', err.response.data);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          errorMsg = '提交失败: 网络错误，请检查网络连接';
          console.error('Request:', err.request);
        } else {
          // 其他错误
          errorMsg = '\u63D0\u4EA4\u5931\u8D25: ' + err.message;
        }
        es["l" /* Toast */].fail(errorMsg);
      });
    },
    apiSpecialReportMeal: function apiSpecialReportMeal() {
      var _this5 = this;

      // Vant 2.x 使用 Toast.loading() 显示加载提示
      es["l" /* Toast */].loading({
        message: '正在加载',
        forbidClick: true,
        duration: 0 // 持续显示，直到手动关闭
      });
      var params = {
        token: this.$cookie.get('token'),
        department_id: this.department_id,
        member_id: this.$route.query.member_id,
        maternal_info_id: this.$route.query.maternal_info_id,
        order_total_id: this.getOrderTotalId()
      };
      Api.otherFormApi.getSpecialReportMeal(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this5.tag_List = [];
          _this5.agent_list = [];

          _this5.agent_list = res.data.agent_list;
          _this5.tag_List = res.data.tag_List;

          _this5.tag_List.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          _this5.agent_list.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });

          // 如果 agent_id 已设置（默认当前用户），设置显示名称
          if (_this5.agent_id) {
            var currentAgent = _this5.agent_list.find(function (item) {
              var itemValue = item.key || item.id;
              return String(itemValue) === String(_this5.agent_id);
            });
            if (currentAgent) {
              _this5.agentDisplayName = currentAgent.value || currentAgent.user_name;
            }
          }

          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiDeportment: function apiDeportment() {
      var _this6 = this;

      var params = {
        token: this.$cookie.get('token')
      };
      Api.otherFormApi.getDepartmentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this6.departments = res.data;
          _this6.departments.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiAgentList: function apiAgentList() {
      var _this7 = this;

      var params = {
        token: this.$cookie.get('token'),
        department_id: this.selectDpId,
        position_id: this.selectPsId
      };
      Api.otherFormApi.getAgentList(params).then(function (res) {
        console.log('res', res);
        if (res.errcode == 1) {
          _this7.agents = res.data;
          _this7.agents.forEach(function (element) {
            element.key = element.id;
            element.value = element.user_name;
          });
          // 关闭加载提示
          es["l" /* Toast */].clear();
        } else {
          // 关闭加载提示
          es["l" /* Toast */].clear();
          es["l" /* Toast */].fail(res.errinfo || '加载失败');
        }
      }).catch(function (err) {
        // 关闭加载提示
        es["l" /* Toast */].clear();
        es["l" /* Toast */].fail('加载失败');
        console.error('API 请求失败:', err);
      });
    },
    apiPostionList: function apiPostionList(department_id) {
      var _this8 = this;

      // 确保 department_id 是原始值，不是响应式对象
      var deptId = department_id && (typeof department_id === 'undefined' ? 'undefined' : typeof_default()(department_id)) === 'object' && !Array.isArray(department_id) ? department_id.value : department_id;

      if (!deptId) {
        es["l" /* Toast */].fail('部门ID不能为空');
        return;
      }

      es["l" /* Toast */].loading({
        message: '正在加载职位列表',
        forbidClick: true,
        duration: 0
      });

      var params = {
        token: this.$cookie.get('token'),
        department_id: deptId
      };

      Api.otherFormApi.getPositionList(params).then(function (res) {
        es["l" /* Toast */].clear();
        if (res.errcode == 1) {
          _this8.positions = res.data || [];
          _this8.positions.forEach(function (element) {
            element.key = element.id;
            element.value = element.name;
          });
        } else {
          es["l" /* Toast */].fail(res.errinfo || '加载职位列表失败');
        }
      }).catch(function (err) {
        es["l" /* Toast */].clear();
        var errorMsg = '加载职位列表失败';
        if (err.response) {
          errorMsg = err.response.status === 404 ? '职位列表接口不存在(404)，请检查API配置' : '\u52A0\u8F7D\u5931\u8D25: ' + err.response.status + ' ' + err.response.statusText;
        } else if (err.request) {
          errorMsg = '网络错误，请检查网络连接';
        }
        es["l" /* Toast */].fail(errorMsg);
        console.error('职位列表API请求失败:', err);
      });
    },
    showChageAgent: function showChageAgent() {
      this.showChangeAgentPanel = true;
    },
    dialog_cancel: function dialog_cancel() {
      this.showChangeAgentPanel = false;
      // 重置选择状态
      this.selectDpId = '';
      this.departmentDisplayName = '';
      this.selectPsId = '';
      this.positionDisplayName = '';
      this.selectAgId = '';
      this.agentSelectDisplayName = '';
      this.positions = [];
      this.agents = [];
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.maternal_info_id
        }
      });
    },
    dialog_confirm: function dialog_confirm() {
      var _this9 = this;

      if (!this.selectAgId) {
        Object(es["l" /* Toast */])('请选择员工');
        return;
      }

      var selectAg = this.agents.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (!selectAg) {
        Object(es["l" /* Toast */])('员工信息不存在');
        return;
      }

      // 检查是否已添加
      var exists = this.selectAgent.find(function (agent) {
        return agent.id === _this9.selectAgId;
      });
      if (exists) {
        Object(es["l" /* Toast */])('该员工已添加');
        return;
      }

      this.selectAgent.push({
        id: this.selectAgId,
        name: selectAg.user_name
      });
      console.log('选择了员工', this.selectAgent);

      // 关闭面板并重置选择
      this.dialog_cancel();
    },
    removeAgent: function removeAgent(agentId) {
      console.log('删除', agentId);
      var index = this.selectAgent.findIndex(function (agent) {
        return agent.id === agentId;
      });
      if (index !== -1) {
        this.selectAgent.splice(index, 1);
      }
    }
  },
  created: function created() {
    // 从 Cookie 获取当前用户 ID（兼容现有代码）
    var currentUserId = this.$cookie.get('id');
    if (currentUserId) {
      this.agent_id = currentUserId;
    }
    // 页面打开时请求 userInfo
    this.fetchUserInfo();
    this.apiSpecialReportMeal();
    this.apiDeportment();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4991d984","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/componentsVant/ssReport/maternal_special_meal.vue
var ssReport_maternal_special_meal_render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-nav-bar',{attrs:{"title":"特情上报(餐饮)","left-text":"孕妇档案","left-arrow":""},on:{"click-left":_vm.goBack}}),_vm._v(" "),_c('van-form',{ref:"form",on:{"submit":_vm.onSubmit}},[_c('van-cell-group',[_c('van-field',{attrs:{"name":"date","label":"日期","placeholder":"请选择日期","readonly":"","required":"","rules":[{ validator: function () { return this$1.date !== ''; }, message: '请选择日期' }]},on:{"click":function($event){_vm.showDatePicker = true}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showDatePicker),callback:function ($$v) {_vm.showDatePicker=$$v},expression:"showDatePicker"}},[_c('van-datetime-picker',{attrs:{"type":"date","min-date":_vm.minDate,"max-date":_vm.maxDate,"show-toolbar":"","title":"选择日期","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onDateConfirm,"cancel":function($event){_vm.showDatePicker = false}},model:{value:(_vm.currentDate),callback:function ($$v) {_vm.currentDate=$$v},expression:"currentDate"}})],1),_vm._v(" "),_c('van-field',{attrs:{"name":"agent_id","label":"汇报人：","placeholder":"请选择汇报人","readonly":"","required":"","rules":[{ validator: function () { return this$1.agent_id !== ''; }, message: '请选择汇报人' }]},on:{"click":function($event){_vm.showAgentPicker = true}},model:{value:(_vm.agentDisplayName),callback:function ($$v) {_vm.agentDisplayName=$$v},expression:"agentDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showAgentPicker),callback:function ($$v) {_vm.showAgentPicker=$$v},expression:"showAgentPicker"}},[_c('van-picker',{attrs:{"columns":_vm.agentColumns,"show-toolbar":"","title":"选择汇报人","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onAgentConfirm,"cancel":function($event){_vm.showAgentPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"name":"tag","label":"特殊标签：","placeholder":"请选择特殊标签","readonly":"","required":"","rules":[{ validator: function () { return this$1.tag !== ''; }, message: '请选择特殊标签' }]},on:{"click":function($event){_vm.showTagPicker = true}},model:{value:(_vm.tagDisplayName),callback:function ($$v) {_vm.tagDisplayName=$$v},expression:"tagDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showTagPicker),callback:function ($$v) {_vm.showTagPicker=$$v},expression:"showTagPicker"}},[_c('van-picker',{attrs:{"columns":_vm.tagColumns,"show-toolbar":"","title":"选择特殊标签","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onTagConfirm,"cancel":function($event){_vm.showTagPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"name":"remark","type":"textarea","label":"备注：","placeholder":"500字（含）以内","required":"","rules":[{ required: true, message: '请填写备注' }],"maxlength":500,"show-word-limit":"","rows":"3","autosize":""},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}}),_vm._v(" "),_c('div',{staticClass:"warning-level-group"},[_c('div',{staticClass:"warning-level-label"},[_vm._v("预警等级：")]),_vm._v(" "),_c('div',{staticClass:"tag-group"},_vm._l((_vm.warningLevelOptions),function(item){return _c('van-tag',{key:item.value,staticClass:"warning-tag-item",attrs:{"type":_vm.warning_level === item.value ? 'primary' : 'default',"plain":_vm.warning_level !== item.value,"size":"large"},on:{"click":function($event){_vm.warning_level = item.value}}},[_vm._v("\n            "+_vm._s(item.label)+"\n          ")])}),1)])],1)],1),_vm._v(" "),_c('van-cell-group',[_c('van-cell',{attrs:{"title":"上报给：","value":"添加","is-link":""},on:{"click":_vm.showChageAgent}}),_vm._v(" "),_c('div',{staticClass:"agent-tags-container"},[(_vm.selectAgent.length)?_vm._l((_vm.selectAgent),function(agent,index){return _c('van-tag',{key:index,staticClass:"agent-tag-item",attrs:{"plain":"true","type":"primary","size":"medium"}},[_c('span',[_vm._v(_vm._s(agent.name))]),_vm._v(" "),_c('van-icon',{staticClass:"agent-tag-close",attrs:{"name":"cross"},on:{"click":function($event){$event.stopPropagation();return _vm.removeAgent(agent.id)}}})],1)}):[_c('span',{staticClass:"agent-tag-empty"},[_vm._v("未添加记录")])]],2),_vm._v(" "),(_vm.showChangeAgentPanel)?_c('div',{staticClass:"agent-select-panel"},[_c('div',{staticClass:"agent-select-row"},[_c('van-field',{attrs:{"label":"部门","placeholder":"选择","readonly":""},on:{"click":function($event){_vm.showDepartmentPicker = true}},model:{value:(_vm.departmentDisplayName),callback:function ($$v) {_vm.departmentDisplayName=$$v},expression:"departmentDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showDepartmentPicker),callback:function ($$v) {_vm.showDepartmentPicker=$$v},expression:"showDepartmentPicker"}},[_c('van-picker',{attrs:{"columns":_vm.departmentColumns,"default-index":_vm.departmentDefaultIndex,"show-toolbar":"","title":"选择部门","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onDepartmentConfirm,"cancel":function($event){_vm.showDepartmentPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"label":"职位","placeholder":"选择","readonly":"","disabled":!_vm.selectDpId},on:{"click":function($event){_vm.showPositionPicker = true}},model:{value:(_vm.positionDisplayName),callback:function ($$v) {_vm.positionDisplayName=$$v},expression:"positionDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showPositionPicker),callback:function ($$v) {_vm.showPositionPicker=$$v},expression:"showPositionPicker"}},[_c('van-picker',{attrs:{"columns":_vm.positionColumns,"show-toolbar":"","title":"选择职位","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onPositionConfirm,"cancel":function($event){_vm.showPositionPicker = false}}})],1),_vm._v(" "),_c('van-field',{attrs:{"label":"员工","placeholder":"选择","readonly":"","disabled":!_vm.selectPsId},on:{"click":function($event){_vm.showAgentSelectPicker = true}},model:{value:(_vm.agentSelectDisplayName),callback:function ($$v) {_vm.agentSelectDisplayName=$$v},expression:"agentSelectDisplayName"}}),_vm._v(" "),_c('van-popup',{attrs:{"position":"bottom"},model:{value:(_vm.showAgentSelectPicker),callback:function ($$v) {_vm.showAgentSelectPicker=$$v},expression:"showAgentSelectPicker"}},[_c('van-picker',{attrs:{"columns":_vm.agentSelectColumns,"show-toolbar":"","title":"选择员工","confirm-button-text":"确定","cancel-button-text":"取消"},on:{"confirm":_vm.onAgentSelectConfirm,"cancel":function($event){_vm.showAgentSelectPicker = false}}})],1)],1),_vm._v(" "),_c('div',{staticClass:"agent-select-buttons"},[_c('van-button',{staticClass:"confirm-btn",attrs:{"type":"default","size":"small"},on:{"click":_vm.dialog_confirm}},[_vm._v("确认")]),_vm._v(" "),_c('van-button',{staticClass:"cancel-btn",attrs:{"type":"warning","size":"small"},on:{"click":_vm.dialog_cancel}},[_vm._v("取消")])],1)]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"submit-button-container"},[_c('van-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("确定")])],1)],1)}
var ssReport_maternal_special_meal_staticRenderFns = []
var ssReport_maternal_special_meal_esExports = { render: ssReport_maternal_special_meal_render, staticRenderFns: ssReport_maternal_special_meal_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_componentsVant_ssReport_maternal_special_meal = (ssReport_maternal_special_meal_esExports);
// CONCATENATED MODULE: ./src/componentsVant/ssReport/maternal_special_meal.vue
function ssReport_maternal_special_meal_injectStyle (ssrContext) {
  __webpack_require__("DHz/")
}
var ssReport_maternal_special_meal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ssReport_maternal_special_meal___vue_template_functional__ = false
/* styles */
var ssReport_maternal_special_meal___vue_styles__ = ssReport_maternal_special_meal_injectStyle
/* scopeId */
var ssReport_maternal_special_meal___vue_scopeId__ = "data-v-4991d984"
/* moduleIdentifier (server only) */
var ssReport_maternal_special_meal___vue_module_identifier__ = null
var ssReport_maternal_special_meal_Component = ssReport_maternal_special_meal_normalizeComponent(
  componentsVant_ssReport_maternal_special_meal,
  selectortype_template_index_0_src_componentsVant_ssReport_maternal_special_meal,
  ssReport_maternal_special_meal___vue_template_functional__,
  ssReport_maternal_special_meal___vue_styles__,
  ssReport_maternal_special_meal___vue_scopeId__,
  ssReport_maternal_special_meal___vue_module_identifier__
)

/* harmony default export */ var src_componentsVant_ssReport_maternal_special_meal = (ssReport_maternal_special_meal_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/batch_service.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var batch_service = ({
  name: 'batch_service',
  data: function data() {
    return {
      buttonTabVal: 0,
      base_info: {
        id: this.$route.query.id,
        name: '',
        phone: '',
        package: '',
        macheck_id: '',
        leave_id: '', //出院
        checklist_id: '' //月子期间医院就诊单
      },
      baby_list: []
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_file'
      });
    },
    toBatchRecord: function toBatchRecord() {
      this.$router.push({
        path: './batch_record'
      });
    }
  },
  created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/batch_service.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_batch_service = ({
  name: 'batch_service',
  data: function data() {
    return {
      buttonTabVal: 0,
      base_info: {
        id: this.$route.query.id,
        name: '',
        phone: '',
        package: '',
        macheck_id: '',
        leave_id: '', //出院
        checklist_id: '' //月子期间医院就诊单
      },
      baby_list: []
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_file'
      });
    },
    toBatchRecord: function toBatchRecord() {
      this.$router.push({
        path: './batch_record'
      });
    }
  },
  created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291bdcf3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/batch_service.vue
var batch_service_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{ showBack: true, preventGoBack: true, backText: '返回' }},on:{"on-click-back":_vm.goBack}},[_vm._v("批量操作")]),_vm._v(" "),_c('div',{staticClass:"action_panel"},[_c('div',{staticClass:"title"},[_vm._v("请选择需要批量处理的表单")]),_vm._v(" "),_c('div',{staticClass:"action_btn"},[_c('x-button',{staticClass:"sortSearchBtn",attrs:{"slot":"right","gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.toBatchRecord.apply(null, arguments)}},slot:"right"},[_vm._v("查看处理记录")])],1)]),_vm._v(" "),_c('div',{staticClass:"broder_line01"},[_c('router-link',{attrs:{"to":{
        path: './batch_table',
        query: { tableId: 7 },
      }}},[_vm._v("\n      1.《婴儿护理操作记录表》\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"broder_line01"},[_c('router-link',{attrs:{"to":{
        path: './batch_table',
        query: { tableId: 3 },
      }}},[_vm._v("\n      2.《婴儿护理记录单（1）》\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"broder_line01"},[_c('router-link',{attrs:{"to":{
        path: './batch_table',
        query: { tableId: 4 },
      }}},[_vm._v("\n      3.《婴儿护理记录单（2）》\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"broder_line01"},[_c('router-link',{attrs:{"to":{
        path: './batch_table',
        query: { tableId: 5 },
      }}},[_vm._v("\n      4.《产妇每日生理护理记录表》\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"broder_line01"},[_c('router-link',{attrs:{"to":{
        path: './batch_table',
        query: { tableId: 6 },
      }}},[_vm._v("\n      5.《产妇康复护理评估记录单》\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"broder_line01"},[_c('router-link',{attrs:{"to":{
        path: './batch_table',
        query: { tableId: 2 },
      }}},[_vm._v("\n      6.《产妇健康咨询记录表》\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"broder_line01"},[_c('router-link',{attrs:{"to":{
        path: './batch_table',
        query: { tableId: 1 },
      }}},[_vm._v("\n      7.《新生儿健康咨询记录表》\n    ")])],1)],1)}
var batch_service_staticRenderFns = []
var batch_service_esExports = { render: batch_service_render, staticRenderFns: batch_service_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_batch_service = (batch_service_esExports);
// CONCATENATED MODULE: ./src/components/batch_service.vue
function batch_service_injectStyle (ssrContext) {
  __webpack_require__("RSXB")
}
var batch_service_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var batch_service___vue_template_functional__ = false
/* styles */
var batch_service___vue_styles__ = batch_service_injectStyle
/* scopeId */
var batch_service___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var batch_service___vue_module_identifier__ = null
var batch_service_Component = batch_service_normalizeComponent(
  components_batch_service,
  selectortype_template_index_0_src_components_batch_service,
  batch_service___vue_template_functional__,
  batch_service___vue_styles__,
  batch_service___vue_scopeId__,
  batch_service___vue_module_identifier__
)

/* harmony default export */ var src_components_batch_service = (batch_service_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var components_load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e08a3ca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/load-more/index.vue
var load_more_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-loadmore weui-loadmore",class:{'weui-loadmore_line':!_vm.showLoading, 'weui-loadmore_dot': !_vm.showLoading && !_vm.tip}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tip || !_vm.showLoading),expression:"tip || !showLoading"}],staticClass:"weui-loadmore__tips"},[_vm._v(_vm._s(_vm.tip))])])}
var load_more_staticRenderFns = []
var load_more_esExports = { render: load_more_render, staticRenderFns: load_more_staticRenderFns }
/* harmony default export */ var src_components_load_more = (load_more_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/load-more/index.vue
function load_more_injectStyle (ssrContext) {
  __webpack_require__("gA6p")
}
var load_more_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var load_more___vue_template_functional__ = false
/* styles */
var load_more___vue_styles__ = load_more_injectStyle
/* scopeId */
var load_more___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var load_more___vue_module_identifier__ = null
var load_more_Component = load_more_normalizeComponent(
  components_load_more,
  src_components_load_more,
  load_more___vue_template_functional__,
  load_more___vue_styles__,
  load_more___vue_scopeId__,
  load_more___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_load_more = (load_more_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/batch_record.vue



/* harmony default export */ var batch_record = ({
  components: {
    LoadMore: vux_src_components_load_more
  },
  name: 'batch_service',
  data: function data() {
    return {
      buttonTabVal: 0,
      start_date: '',
      end_date: '',
      haveMore: false,
      page: 1,
      use_table: 0,
      min_date: '',
      tip: '点击加载更多',
      data_list: []
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_file'
      });
    },
    onMore: function onMore() {
      this.apiRecordList(true);
    },
    onchange: function onchange() {
      this.page = 1;
      console.log('onchange');
      this.apiRecordList(false);
    },
    apiRecordList: function apiRecordList(more) {
      var _this = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      if (!more) {
        this.data_list = [];
      }
      var that = this;
      var params = {
        token: this.$cookie.get('token'),
        page: this.page,
        use_table: this.use_table

      };

      if (this.start_date != '') {
        params.start_date = this.start_date;
      }
      if (this.end_date != '') {
        params.end_date = this.end_date;
      }

      console.log('params', params);
      Api.memberListApi.batchHeathRecord(params).then(function (res) {
        console.log(res);
        if (res.errcode == 1) {
          var dataList = res.data.list;
          dataList.forEach(function (item) {
            _this.data_list.push(item);
          });
          if (res.data.page.page_count > _this.page) {
            _this.page++;
            _this.haveMore = true;
          } else {
            _this.haveMore = false;
          }
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
        _this.$vux.loading.hide();
      });
    },
    start_date_congirm: function start_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.min_date = value;
      this.start_date = value;
      this.onchange();
    },
    end_date_congirm: function end_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.end_date = value;
      this.onchange();
    }
  },
  created: function created() {
    this.apiRecordList(false);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/batch_record.vue



/* harmony default export */ var components_batch_record = ({
  components: {
    LoadMore: vux_src_components_load_more
  },
  name: 'batch_service',
  data: function data() {
    return {
      buttonTabVal: 0,
      start_date: '',
      end_date: '',
      haveMore: false,
      page: 1,
      use_table: 0,
      min_date: '',
      tip: '点击加载更多',
      data_list: []
    };
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_file'
      });
    },
    onMore: function onMore() {
      this.apiRecordList(true);
    },
    onchange: function onchange() {
      this.page = 1;
      console.log('onchange');
      this.apiRecordList(false);
    },
    apiRecordList: function apiRecordList(more) {
      var _this = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      if (!more) {
        this.data_list = [];
      }
      var that = this;
      var params = {
        token: this.$cookie.get('token'),
        page: this.page,
        use_table: this.use_table

      };

      if (this.start_date != '') {
        params.start_date = this.start_date;
      }
      if (this.end_date != '') {
        params.end_date = this.end_date;
      }

      console.log('params', params);
      Api.memberListApi.batchHeathRecord(params).then(function (res) {
        console.log(res);
        if (res.errcode == 1) {
          var dataList = res.data.list;
          dataList.forEach(function (item) {
            _this.data_list.push(item);
          });
          if (res.data.page.page_count > _this.page) {
            _this.page++;
            _this.haveMore = true;
          } else {
            _this.haveMore = false;
          }
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
        _this.$vux.loading.hide();
      });
    },
    start_date_congirm: function start_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.min_date = value;
      this.start_date = value;
      this.onchange();
    },
    end_date_congirm: function end_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.end_date = value;
      this.onchange();
    }
  },
  created: function created() {
    this.apiRecordList(false);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b8d6f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/batch_record.vue
var batch_record_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{ showBack: true, preventGoBack: true, backText: '返回' }},on:{"on-click-back":_vm.goBack}},[_vm._v("批量操作")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"search_panel"},[_c('flexbox',[_c('flexbox-item',{staticStyle:{"flex":"0.2"}},[_vm._v("所用表格:")]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"flex":"0.8"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.use_table),expression:"use_table"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.use_table=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.onchange]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("请选择")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("产妇健康咨询记录表")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("新生儿健康咨询记录表")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("婴儿护理记录单（1）")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("婴儿护理记录单（2）")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("产妇每日生理护理记录表")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("产妇康复护理评估记录单")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("婴儿护理操作记录表")])])])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',{staticStyle:{"flex":"0.6"}},[_c('div',{staticClass:"flex-demo—date"},[_c('datetime',{attrs:{"title":"查房日期：","placeholder":"请选择日期"},on:{"on-confirm":_vm.start_date_congirm},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}})],1)]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"flex":"0.4"}},[_c('div',{staticClass:"flex-demo—date"},[_c('datetime',{attrs:{"title":"至：","start-date":_vm.min_date,"placeholder":"请选择日期"},on:{"on-confirm":_vm.end_date_congirm},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}})],1)])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"10px"}},[_c('x-table',{staticStyle:{"background-color":"#fff"},attrs:{"cell-bordered":false,"content-bordered":false}},[_c('thead',[_c('tr',{staticStyle:{"background-color":"#f7f7f7"}},[_c('th',[_vm._v("序号")]),_vm._v(" "),_c('th',[_vm._v("查房日期")]),_vm._v(" "),_c('th',[_vm._v("所用表格")]),_vm._v(" "),_c('th',[_vm._v("班次")]),_vm._v(" "),_c('th',[_vm._v("查房人")]),_vm._v(" "),_c('th',[_vm._v("操作人")]),_vm._v(" "),_c('th',[_vm._v("操作时间")]),_vm._v(" "),_c('th',[_vm._v("操作")])])]),_vm._v(" "),_vm._l((_vm.data_list),function(item,index){return _c('tbody',{key:index},[_c('tr',[_c('td',[_vm._v(_vm._s(item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.advisory_date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.use_table_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.shifts_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.advisory_agent_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.agent_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.created_at))]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{
                path: './batch_record_detail?id=' + item.id,
              }}},[_vm._v("查看明细")])],1)])])})],2),_vm._v(" "),(_vm.haveMore)?_c('load-more',{attrs:{"show-loading":false,"tip":_vm.tip,"background-color":"#fbf9fe"},nativeOn:{"click":function($event){return _vm.onMore.apply(null, arguments)}}}):_vm._e()],1)],1)}
var batch_record_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action_panel"},[_c('div',{staticClass:"title"},[_vm._v("批量处理记录")])])}]
var batch_record_esExports = { render: batch_record_render, staticRenderFns: batch_record_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_batch_record = (batch_record_esExports);
// CONCATENATED MODULE: ./src/components/batch_record.vue
function batch_record_injectStyle (ssrContext) {
  __webpack_require__("EYVM")
}
var batch_record_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var batch_record___vue_template_functional__ = false
/* styles */
var batch_record___vue_styles__ = batch_record_injectStyle
/* scopeId */
var batch_record___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var batch_record___vue_module_identifier__ = null
var batch_record_Component = batch_record_normalizeComponent(
  components_batch_record,
  selectortype_template_index_0_src_components_batch_record,
  batch_record___vue_template_functional__,
  batch_record___vue_styles__,
  batch_record___vue_scopeId__,
  batch_record___vue_module_identifier__
)

/* harmony default export */ var src_components_batch_record = (batch_record_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var check_icon = ({
  name: 'check-icon',
  components: {
    Icon: vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/check-icon/index.vue
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_check_icon = ({
  name: 'check-icon',
  components: {
    Icon: vux_src_components_icon
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('update:value', !this.value);
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dacecb72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/check-icon/index.vue
var check_icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-check-icon",on:{"click":_vm.updateValue}},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'default' && _vm.value),expression:"type === 'default' && value"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'plain' && _vm.value),expression:"type === 'plain' && value"}],attrs:{"type":"success_circle"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.value),expression:"!value"}],attrs:{"type":"circle"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var check_icon_staticRenderFns = []
var check_icon_esExports = { render: check_icon_render, staticRenderFns: check_icon_staticRenderFns }
/* harmony default export */ var src_components_check_icon = (check_icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/check-icon/index.vue
function check_icon_injectStyle (ssrContext) {
  __webpack_require__("sVG7")
}
var check_icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var check_icon___vue_template_functional__ = false
/* styles */
var check_icon___vue_styles__ = check_icon_injectStyle
/* scopeId */
var check_icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var check_icon___vue_module_identifier__ = null
var check_icon_Component = check_icon_normalizeComponent(
  components_check_icon,
  src_components_check_icon,
  check_icon___vue_template_functional__,
  check_icon___vue_styles__,
  check_icon___vue_scopeId__,
  check_icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_check_icon = (check_icon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347cf7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var group_staticRenderFns = []
var group_esExports = { render: group_render, staticRenderFns: group_staticRenderFns }
/* harmony default export */ var src_components_group = (group_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function group_injectStyle (ssrContext) {
  __webpack_require__("uWE6")
}
var group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group___vue_template_functional__ = false
/* styles */
var group___vue_styles__ = group_injectStyle
/* scopeId */
var group___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group___vue_module_identifier__ = null
var group_Component = group_normalizeComponent(
  components_group,
  src_components_group,
  group___vue_template_functional__,
  group___vue_styles__,
  group___vue_scopeId__,
  group___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = (group_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/radio/props.js
var radio_props = __webpack_require__("Zor0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_radio = ({
  name: 'radio',
  mixins: [libs_base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_components_radio = ({
  name: 'radio',
  mixins: [libs_base["a" /* default */]],
  filters: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  props: Object(radio_props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["e" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = radio_contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["c" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function radio_contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0506500e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/radio/index.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",function(){return [_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])]},{"icon":one.icon,"label":_vm.getValue(one),"index":index,"selected":_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){return _vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var vux_src_components_radio = (radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/radio/index.vue
function radio_injectStyle (ssrContext) {
  __webpack_require__("HH82")
}
var radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = radio_injectStyle
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  src_components_radio,
  vux_src_components_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_radio = (radio_Component.exports);

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var _cellProps = Object(props["a" /* default */])();
delete _cellProps.value;

/* harmony default export */ var popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, _cellProps, Object(radio_props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var popup_radio__cellProps = Object(props["a" /* default */])();
delete popup_radio__cellProps.value;

/* harmony default export */ var components_popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, popup_radio__cellProps, Object(radio_props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f92ebd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-radio/index.vue
var popup_radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{attrs:{"title":_vm.title,"value":_vm.currentValue,"is-link":!_vm.readonly,"value-align":_vm.valueAlign,"border-intent":_vm.borderIntent},nativeOn:{"click":function($event){return _vm.show.apply(null, arguments)}}},[(!_vm.displayValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.displayValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayValue))]):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"icon"},slot:"icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{staticStyle:{"background-color":"#fff"},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_vm._t("popup-header",null,{"options":_vm.options,"value":_vm.currentValue}),_vm._v(" "),_c('radio',{attrs:{"options":_vm.options,"fill-mode":false},on:{"on-change":_vm.onValueChange},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_vm._t("each-item",function(){return [_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(props.icon),expression:"props.icon"}],staticClass:"vux-radio-icon",attrs:{"src":props.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label"},[_vm._v(_vm._s(props.label))])])]},{"icon":props.icon,"label":props.label,"index":props.index})]}}],null,true),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],2)],1)])}
var popup_radio_staticRenderFns = []
var popup_radio_esExports = { render: popup_radio_render, staticRenderFns: popup_radio_staticRenderFns }
/* harmony default export */ var src_components_popup_radio = (popup_radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-radio/index.vue
function popup_radio_injectStyle (ssrContext) {
  __webpack_require__("IM0P")
}
var popup_radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_radio___vue_template_functional__ = false
/* styles */
var popup_radio___vue_styles__ = popup_radio_injectStyle
/* scopeId */
var popup_radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_radio___vue_module_identifier__ = null
var popup_radio_Component = popup_radio_normalizeComponent(
  components_popup_radio,
  src_components_popup_radio,
  popup_radio___vue_template_functional__,
  popup_radio___vue_styles__,
  popup_radio___vue_scopeId__,
  popup_radio___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_radio = (popup_radio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(router["b" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell-box/index.vue
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_cell_box = ({
  name: 'cell-box',
  props: {
    isLink: Boolean,
    link: [String, Object],
    borderIntent: {
      type: Boolean,
      default: true
    },
    noFlex: Boolean,
    alignItems: String
  },
  computed: {
    style: function style() {
      if (this.alignItems) {
        return {
          'align-items': this.alignItems
        };
      }
    },
    className: function className() {
      return {
        'vux-tap-active': this.isLink || !!this.link,
        'weui-cell_access': this.isLink || !!this.link,
        'vux-cell-no-border-intent': !this.borderIntent
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.link && Object(router["b" /* go */])(this.link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65737ba9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell-box/index.vue
var cell_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box weui-cell",class:_vm.className,style:(_vm.style),on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var cell_box_staticRenderFns = []
var cell_box_esExports = { render: cell_box_render, staticRenderFns: cell_box_staticRenderFns }
/* harmony default export */ var src_components_cell_box = (cell_box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell-box/index.vue
function cell_box_injectStyle (ssrContext) {
  __webpack_require__("tZYb")
}
var cell_box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell_box___vue_template_functional__ = false
/* styles */
var cell_box___vue_styles__ = cell_box_injectStyle
/* scopeId */
var cell_box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell_box___vue_module_identifier__ = null
var cell_box_Component = cell_box_normalizeComponent(
  components_cell_box,
  src_components_cell_box,
  cell_box___vue_template_functional__,
  cell_box___vue_styles__,
  cell_box___vue_scopeId__,
  cell_box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell_box = (cell_box_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/batch_record_detail.vue







/* harmony default export */ var batch_record_detail = ({
  name: 'batch_record_detail',
  components: {
    CheckIcon: vux_src_components_check_icon,
    PopupRadio: vux_src_components_popup_radio,
    Checklist: vux_src_components_checklist,
    CellBox: vux_src_components_cell_box
  },
  data: function data() {
    return {
      isBaby: false,
      buttonTabVal: 0,
      start_date: '',
      end_date: '',
      page: 1,
      use_table: 0,
      min_date: '',
      memberList: [],
      data_list: [],
      detail: null,
      warn: 0,
      normal: 0
    };
  },

  methods: {
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },
    goBack: function goBack() {
      this.$router.push({
        path: './batch_record'
      });
    },
    change: function change(val, label) {},
    apiRecordList: function apiRecordList() {
      var _this = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var that = this;
      var params = {
        token: this.$cookie.get('token'),
        id: this.$route.query.id
      };
      console.log('params', params);
      Api.memberListApi.batchHeathRecordDetail(params).then(function (res) {
        console.log('batchHeathRecordDetail', res);
        if (res.errcode == 1) {
          _this.memberList = res.data.list;
          _this.detail = res.data.base;
          if (_this.detail.use_table == 3 || _this.detail.use_table == 4 || _this.detail.use_table == 1) {
            _this.isBaby = true;
          }
          _this.memberList.sort(function (a, b) {
            return parseInt(a.state) < parseInt(b.state);
          });
          _this.memberList.forEach(function (item) {
            var _desc = '电话：' + item.phone + ' 时间：' + _this.formatDateTime(item.live_time) + ' 套餐：' + item.package_name + ' 房号：' + item.room;
            if (item.state == 2) {
              _this.warn++;
            }
            if (item.state == 1) {
              _this.normal++;
              item.isSelect = true;
            } else {
              item.isSelect = false;
            }
            item.key = item.id;
            item.value = item.name;
            item.inlineDesc = _desc;
          });
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
        _this.$vux.loading.hide();
      });
    },
    start_date_congirm: function start_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.min_date = value;
      this.start_date = value;
      console.info('选择开始日期');
      this.forFormIDUseMethod();
    },
    end_date_congirm: function end_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.end_date = value;
      console.info('选择结束日期');
      this.forFormIDUseMethod();
    },
    forFormIDUseMethod: function forFormIDUseMethod() {}
  },
  created: function created() {
    this.apiRecordList();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/batch_record_detail.vue







/* harmony default export */ var components_batch_record_detail = ({
  name: 'batch_record_detail',
  components: {
    CheckIcon: vux_src_components_check_icon,
    PopupRadio: vux_src_components_popup_radio,
    Checklist: vux_src_components_checklist,
    CellBox: vux_src_components_cell_box
  },
  data: function data() {
    return {
      isBaby: false,
      buttonTabVal: 0,
      start_date: '',
      end_date: '',
      page: 1,
      use_table: 0,
      min_date: '',
      memberList: [],
      data_list: [],
      detail: null,
      warn: 0,
      normal: 0
    };
  },

  methods: {
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },
    goBack: function goBack() {
      this.$router.push({
        path: './batch_record'
      });
    },
    change: function change(val, label) {},
    apiRecordList: function apiRecordList() {
      var _this = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var that = this;
      var params = {
        token: this.$cookie.get('token'),
        id: this.$route.query.id
      };
      console.log('params', params);
      Api.memberListApi.batchHeathRecordDetail(params).then(function (res) {
        console.log('batchHeathRecordDetail', res);
        if (res.errcode == 1) {
          _this.memberList = res.data.list;
          _this.detail = res.data.base;
          if (_this.detail.use_table == 3 || _this.detail.use_table == 4 || _this.detail.use_table == 1) {
            _this.isBaby = true;
          }
          _this.memberList.sort(function (a, b) {
            return parseInt(a.state) < parseInt(b.state);
          });
          _this.memberList.forEach(function (item) {
            var _desc = '电话：' + item.phone + ' 时间：' + _this.formatDateTime(item.live_time) + ' 套餐：' + item.package_name + ' 房号：' + item.room;
            if (item.state == 2) {
              _this.warn++;
            }
            if (item.state == 1) {
              _this.normal++;
              item.isSelect = true;
            } else {
              item.isSelect = false;
            }
            item.key = item.id;
            item.value = item.name;
            item.inlineDesc = _desc;
          });
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
        _this.$vux.loading.hide();
      });
    },
    start_date_congirm: function start_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.min_date = value;
      this.start_date = value;
      console.info('选择开始日期');
      this.forFormIDUseMethod();
    },
    end_date_congirm: function end_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.end_date = value;
      console.info('选择结束日期');
      this.forFormIDUseMethod();
    },
    forFormIDUseMethod: function forFormIDUseMethod() {}
  },
  created: function created() {
    this.apiRecordList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ca6181e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/batch_record_detail.vue
var batch_record_detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{ showBack: true, preventGoBack: true, backText: '返回' }},on:{"on-click-back":_vm.goBack}},[_vm._v("批量处理记录")]),_vm._v(" "),(this.detail != null)?_c('div',{staticClass:"detail"},[_c('div',{staticClass:"row"},[_c('flexbox',[_c('flexbox-item',{staticStyle:{"flex":"0.2"}},[_vm._v("查房日期:")]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"flex":"0.8"}},[_vm._v(_vm._s(this.detail.advisory_date))])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',{staticStyle:{"flex":"0.2"}},[_vm._v("所用表格:")]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"flex":"0.8"}},[_vm._v(_vm._s(this.detail.use_table_name))])],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('flexbox',[_c('flexbox-item',{staticStyle:{"flex":"0.2"}},[_vm._v("班次:")]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"flex":"0.8"}},[_vm._v(_vm._s(this.detail.shifts_name))])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',{staticStyle:{"flex":"0.2"}},[_vm._v("查房人:")]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"flex":"0.8"}},[_vm._v(_vm._s(this.detail.advisory_agent_name))])],1)],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('flexbox',[_c('flexbox-item',{staticStyle:{"flex":"0.2"}},[_vm._v("操作人:")]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"flex":"0.8"}},[_vm._v(_vm._s(this.detail.agent_name))])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',{staticStyle:{"flex":"0.2"}},[_vm._v("操作时间:")]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"flex":"0.8"}},[_vm._v(_vm._s(this.detail.created_at))])],1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"detail-total"},[_c('flexbox',[_c('flexbox-item',{staticStyle:{"flex":"0.3"}},[_vm._v("总入住:"+_vm._s(this.memberList.length))]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"flex":"0.3"}},[_vm._v("已选异常:"+_vm._s(this.warn))]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"flex":"0.3"}},[_vm._v("正常:"+_vm._s(this.normal))])],1)],1),_vm._v(" "),_c('div',[(_vm.detail != null)?_c('div',[(_vm.detail.use_table == 3 )?_c('flexbox',{staticStyle:{"background-color":"#ffffff","border-bottom":"1px solid #888","padding":"10px"},attrs:{"gutter":0}},[_c('flexbox-item',{attrs:{"span":1 / 4,"order":4,"align":"center"}},[_vm._v("体温（℃）\n        ")]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1 / 4,"order":3,"align":"center"}},[_vm._v("\n          体重（g）\n        ")]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1 / 2,"order":2,"align":"center"}},[_vm._v("\n          基本信息\n        ")])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.memberList),function(row,index){return _c('div',{key:index},[_c('flexbox',{staticStyle:{"background-color":"#ffffff","border-bottom":"1px solid #888","padding":"10px"},attrs:{"gutter":0}},[(_vm.detail.use_table == 3 )?_c('flexbox-item',{attrs:{"span":1 / 4,"order":3,"align":"center"}},[_c('div',[_c('span',[_vm._v(_vm._s(row.weight))])])]):_vm._e(),_vm._v(" "),(_vm.detail.use_table == 3 || _vm.detail.use_table == 4)?_c('flexbox-item',{attrs:{"span":1 / 4,"order":4,"align":"center"}},[_c('span',[_vm._v(_vm._s(row.temperature))])]):_vm._e(),_vm._v(" "),_c('flexbox-item',{attrs:{"span":_vm.detail.use_table == '3'  ? 1 / 2 : '',"order":2}},[_c('flexbox',[_c('flexbox-item',{attrs:{"span":1}},[_c('p',[_c('check-icon',{attrs:{"name":'c-' + row.key,"value":row.isSelect},on:{"update:value":function($event){return _vm.$set(row, "isSelect", $event)}},nativeOn:{"click":function($event){return _vm.change.apply(null, arguments)}}})],1)]),_vm._v(" "),_c('flexbox-item',[_c('flexbox',{attrs:{"orient":"vertical"}},[_c('flexbox-item',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(row.name)+"\n                    "),(_vm.isBaby)?_c('span',{staticStyle:{"color":"blue"}},[_vm._v("("+_vm._s(row.child_name)+")")]):_vm._e()]),_vm._v(" "),_c('flexbox-item',[_c('span',{staticStyle:{"color":"#888888"}},[_vm._v(_vm._s(row.inlineDesc))])])],1)],1)],1)],1)],1)],1)})],2):_vm._e()])],1)}
var batch_record_detail_staticRenderFns = []
var batch_record_detail_esExports = { render: batch_record_detail_render, staticRenderFns: batch_record_detail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_batch_record_detail = (batch_record_detail_esExports);
// CONCATENATED MODULE: ./src/components/batch_record_detail.vue
function batch_record_detail_injectStyle (ssrContext) {
  __webpack_require__("/Yju")
}
var batch_record_detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var batch_record_detail___vue_template_functional__ = false
/* styles */
var batch_record_detail___vue_styles__ = batch_record_detail_injectStyle
/* scopeId */
var batch_record_detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var batch_record_detail___vue_module_identifier__ = null
var batch_record_detail_Component = batch_record_detail_normalizeComponent(
  components_batch_record_detail,
  selectortype_template_index_0_src_components_batch_record_detail,
  batch_record_detail___vue_template_functional__,
  batch_record_detail___vue_styles__,
  batch_record_detail___vue_scopeId__,
  batch_record_detail___vue_module_identifier__
)

/* harmony default export */ var src_components_batch_record_detail = (batch_record_detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cfrList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var cfrList = ({
    name: 'cfrList',
    data: function data() {
        return {
            nurser_name: [],
            maternal_list: [], //查房人列表
            pinyin_array: [] //查房人列表拼音顺序
        };
    },

    props: {
        list_id: {
            type: String,
            required: true
        },
        showCfrList: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        apiGetCfrList: function apiGetCfrList() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                store_id: this.$cookie.get('store_id')
            };
            console.log(params);
            Api.checkRoomApi.getCheckInfo(params).then(function (res) {
                console.info("获取查房人列表", res);
                if (res.errcode == 1) {
                    _this.nurser_name = res.data.nurser_name; //过滤了离院，
                    _this.cfr_list(res.data.nurser_name);
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //组装查房人
        cfr_list: function cfr_list(arr) {
            if (arr.length) {
                var nurser_name_arr = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = get_iterator_default()(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
                        var obj = {
                            name: [item.user_name],
                            pinyin: _py
                        };
                        nurser_name_arr.push(obj);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                var pyArr = [];
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = get_iterator_default()(nurser_name_arr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _item = _step2.value;

                        var obj = {
                            name: _item.name,
                            pinyin: _item.pinyin
                        };
                        var is_have = this.isInArray(pyArr, _item.pinyin);
                        if (!is_have) {
                            //不存在
                            pyArr.push(_item.pinyin);
                            this.pinyin_array.push(_item.pinyin);
                            this.pinyin_array.sort();
                            this.maternal_list.push(obj);
                        } else {
                            //存在
                            var _index = pyArr.indexOf(_item.pinyin);
                            this.maternal_list[_index].name.push(_item.name.join(''));
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
                console.info(this.maternal_list);
            }
        },

        //数组排序
        arrar_sort: function arrar_sort(newArr, oldArr) {
            var newList = [];
            var pyArrSort = newArr.sort();
            var i = 0;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = get_iterator_default()(pyArrSort), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var item = _step3.value;
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = get_iterator_default()(oldArr), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var list = _step4.value;

                            if (item == list.pinyin) {
                                newList[i] = list;
                            }
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    i++;
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return newList;
        },


        //判断元素是否在数组上
        isInArray: function isInArray(arr, value) {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = get_iterator_default()(arr), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var item = _step5.value;

                    if (value === item) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            return false;
        },

        //关闭
        closeCfrList: function closeCfrList() {
            this.$emit("cfrListEven", false);
        },

        //点击查房人
        selece_cfr: function selece_cfr(name) {
            console.info(this.nurser_name);
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = get_iterator_default()(this.nurser_name), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var item = _step6.value;

                    if (name == item.user_name) {
                        this.$emit("cfrListEven", false, item);
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }
        }
    },
    created: function created() {
        console.info(this.list_id);
        this.apiGetCfrList();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/cfrList.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_cfrList = ({
    name: 'cfrList',
    data: function data() {
        return {
            nurser_name: [],
            maternal_list: [], //查房人列表
            pinyin_array: [] //查房人列表拼音顺序
        };
    },

    props: {
        list_id: {
            type: String,
            required: true
        },
        showCfrList: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        apiGetCfrList: function apiGetCfrList() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                store_id: this.$cookie.get('store_id')
            };
            console.log(params);
            Api.checkRoomApi.getCheckInfo(params).then(function (res) {
                console.info("获取查房人列表", res);
                if (res.errcode == 1) {
                    _this.nurser_name = res.data.nurser_name; //过滤了离院，
                    _this.cfr_list(res.data.nurser_name);
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //组装查房人
        cfr_list: function cfr_list(arr) {
            if (arr.length) {
                var nurser_name_arr = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = get_iterator_default()(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;

                        var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
                        var obj = {
                            name: [item.user_name],
                            pinyin: _py
                        };
                        nurser_name_arr.push(obj);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                var pyArr = [];
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = get_iterator_default()(nurser_name_arr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _item = _step2.value;

                        var obj = {
                            name: _item.name,
                            pinyin: _item.pinyin
                        };
                        var is_have = this.isInArray(pyArr, _item.pinyin);
                        if (!is_have) {
                            //不存在
                            pyArr.push(_item.pinyin);
                            this.pinyin_array.push(_item.pinyin);
                            this.pinyin_array.sort();
                            this.maternal_list.push(obj);
                        } else {
                            //存在
                            var _index = pyArr.indexOf(_item.pinyin);
                            this.maternal_list[_index].name.push(_item.name.join(''));
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
                console.info(this.maternal_list);
            }
        },

        //数组排序
        arrar_sort: function arrar_sort(newArr, oldArr) {
            var newList = [];
            var pyArrSort = newArr.sort();
            var i = 0;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = get_iterator_default()(pyArrSort), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var item = _step3.value;
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = get_iterator_default()(oldArr), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var list = _step4.value;

                            if (item == list.pinyin) {
                                newList[i] = list;
                            }
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }

                    i++;
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return newList;
        },


        //判断元素是否在数组上
        isInArray: function isInArray(arr, value) {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = get_iterator_default()(arr), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var item = _step5.value;

                    if (value === item) {
                        return true;
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            return false;
        },

        //关闭
        closeCfrList: function closeCfrList() {
            this.$emit("cfrListEven", false);
        },

        //点击查房人
        selece_cfr: function selece_cfr(name) {
            console.info(this.nurser_name);
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = get_iterator_default()(this.nurser_name), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var item = _step6.value;

                    if (name == item.user_name) {
                        this.$emit("cfrListEven", false, item);
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }
        }
    },
    created: function created() {
        console.info(this.list_id);
        this.apiGetCfrList();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b2f0888","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cfrList.vue
var cfrList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"},{name:"show",rawName:"v-show",value:(_vm.showCfrList),expression:"showCfrList"}],staticClass:"mtIndexList"},[_c('div',{staticStyle:{"text-align":"right","padding-right":"24px"}},[_c('x-button',{attrs:{"type":"default","mini":""},nativeOn:{"click":function($event){return _vm.closeCfrList.apply(null, arguments)}}},[_vm._v("关闭")])],1),_vm._v(" "),_c('ul',{staticClass:"mtIndexListBox"},[_vm._l((_vm.maternal_list),function(item){return _c('li',{key:item.pinyin,attrs:{"id":item.pinyin}},[_c('p',{staticClass:"index_title"},[_vm._v(_vm._s(item.pinyin))]),_vm._v(" "),_c('dl',{staticStyle:{"padding-right":"30px"}},_vm._l((item.name),function(option,index){return _c('dd',{key:index,staticStyle:{"display":"inline-block"}},[_c('a',{staticStyle:{"display":"inline-block","color":"#333","padding":"10px 20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.selece_cfr(option)}}},[_vm._v(_vm._s(option))])])}),0)])}),_vm._v(" "),_c('div',{staticClass:"fixed_right_pinyin"},_vm._l((_vm.pinyin_array),function(item,index){return _c('a',{key:index,attrs:{"href":'#'+ item}},[_vm._v(_vm._s(item))])}),0)],2)])])}
var cfrList_staticRenderFns = []
var cfrList_esExports = { render: cfrList_render, staticRenderFns: cfrList_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_cfrList = (cfrList_esExports);
// CONCATENATED MODULE: ./src/components/cfrList.vue
function cfrList_injectStyle (ssrContext) {
  __webpack_require__("Uz5z")
}
var cfrList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cfrList___vue_template_functional__ = false
/* styles */
var cfrList___vue_styles__ = cfrList_injectStyle
/* scopeId */
var cfrList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cfrList___vue_module_identifier__ = null
var cfrList_Component = cfrList_normalizeComponent(
  components_cfrList,
  selectortype_template_index_0_src_components_cfrList,
  cfrList___vue_template_functional__,
  cfrList___vue_styles__,
  cfrList___vue_scopeId__,
  cfrList___vue_module_identifier__
)

/* harmony default export */ var src_components_cfrList = (cfrList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/batch_table.vue



var batch_table_pulldownDefaultConfig = {
  content: '下拉刷新',
  height: 40,
  autoRefresh: false,
  downContent: '下拉刷新',
  upContent: '释放后刷新',
  loadingContent: '正在刷新...',
  clsPrefix: 'xs-plugin-pulldown-'
};
var batch_table_pullupDefaultConfig = {
  content: '上拉加载更多',
  pullUpHeight: 60,
  height: 40,
  autoRefresh: false,
  downContent: '释放后加载',
  upContent: '上拉加载更多',
  loadingContent: '加载中...',
  clsPrefix: 'xs-plugin-pullup-'
};







/* harmony default export */ var batch_table = ({
  name: 'batch_table',
  components: {
    CheckIcon: vux_src_components_check_icon,
    cfr: src_components_cfrList,
    PopupRadio: vux_src_components_popup_radio,
    Checklist: vux_src_components_checklist
  },
  data: function data() {
    var _form, _ref;

    return _ref = {
      tableId: 0,
      tableName: '',
      isBaby: false,
      subtitle1: '',
      subtitle2: '',
      list_id: '',
      shifts: '',
      total: 0,
      normal: 0,
      warn: 0,
      warnUser: []
    }, defineProperty_default()(_ref, 'list_id', ''), defineProperty_default()(_ref, 'showCfrList', false), defineProperty_default()(_ref, 'cfrText', ''), defineProperty_default()(_ref, 'postFun', {}), defineProperty_default()(_ref, 'form', (_form = {
      room: '',
      hand_card: '',
      baby_id: '',
      momName: '',
      sex: ''
    }, defineProperty_default()(_form, 'momName', ''), defineProperty_default()(_form, 'birth_type', ''), defineProperty_default()(_form, 'record_date', this.currentDate()), defineProperty_default()(_form, 'record_hour', ''), defineProperty_default()(_form, 'detail', ''), defineProperty_default()(_form, 'agent_id', ''), defineProperty_default()(_form, 'agent_sign', ''), defineProperty_default()(_form, 'shifts', ''), _form)), defineProperty_default()(_ref, 'baby_list', []), defineProperty_default()(_ref, 'showSignature', true), defineProperty_default()(_ref, 'option', {
      penColor: 'rgb(0, 0, 0)'
    }), defineProperty_default()(_ref, 'get_host', host.host), defineProperty_default()(_ref, 'showDialog', false), defineProperty_default()(_ref, 'buttonTabVal', 0), defineProperty_default()(_ref, 'results', []), defineProperty_default()(_ref, 'keyword', ''), defineProperty_default()(_ref, 'panel_type', '1'), defineProperty_default()(_ref, 'memberList', []), defineProperty_default()(_ref, 'memberAllList', []), defineProperty_default()(_ref, 'floor_arr', []), defineProperty_default()(_ref, 'sort', '2'), defineProperty_default()(_ref, 'sort_text', '倒序'), defineProperty_default()(_ref, 'page', '1'), defineProperty_default()(_ref, 'pullupDefaultConfig', batch_table_pullupDefaultConfig), defineProperty_default()(_ref, 'pulldownDefaultConfig', batch_table_pulldownDefaultConfig), _ref;
  },

  methods: {
    go_leave_custom: function go_leave_custom() {
      this.$router.push({
        path: './leave_custom_list'
      });
    },
    toBatch: function toBatch() {
      this.$router.push({
        path: './batch_service'
      });
    },
    change: function change() {
      var _this = this;

      this.normal = 0;
      this.memberList.forEach(function (item) {
        if (item.isSelect) {
          item.state = 1;
          _this.normal++;
        } else {
          item.state = 2;
        }
      });
      this.warn = this.total - this.normal;

      this.memberList.sort(function (a, b) {
        return a.state - b.state;
      });

      console.log('change', this.memberList);
    },
    dialog_exit: function dialog_exit() {
      this.showDialog = false;
    },
    selectPeople: function selectPeople() {
      this.showCfrList = true;
    },
    cfrListEven: function cfrListEven(val, item) {
      this.showCfrList = val;
      if (item) {
        this.form.agent_id = item.id;
        console.log('this.form.agent_id', this.form.agent_id);
        this.cfrText = item.user_name;

        if (this.tableId > 2) {

          this.memberList.forEach(function (member) {
            var staff_ids = member.staff_ids;
            var isSelected = false;
            staff_ids.forEach(function (id) {
              if (parseInt(id) == parseInt(item.id)) {
                isSelected = true;
              }
            });
            if (isSelected) {
              member.state = 1;
              member.isSelect = true;
            } else {
              member.state = 2;
              member.isSelect = false;
            }
          });

          this.change();
        }
      }
    },
    currentDate: function currentDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return year + '-' + month + '-' + day;
    },
    submit: function submit() {
      this.showDialog = true;
    },
    dialog_confirm: function dialog_confirm() {
      var _this2 = this;

      if (this.form.agent_sign == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请提交签名'
        });
        return;
      }
      if (this.form.shifts == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择班次'
        });
        return;
      }
      if (this.form.agent_id == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择查房人'
        });
        return;
      }

      this.$vux.loading.show({
        text: '正在提交'
      });
      var that = this;

      var postData = {
        store_id: this.$cookie.get('store_id'),
        advisory_agent_sign: this.form.agent_sign,
        advisory_agent_id: this.form.agent_id,
        token: this.$cookie.get('token'),
        shifts: this.form.shifts,
        advisory_date: this.form.record_date
      };

      if (this.isBaby) {
        postData.child = this.memberList;
      } else {
        postData.maternal_info = this.memberList;
      }

      console.log(this.memberList);

      this.postFun(postData, this.tableId).then(function (res) {
        if (res.errcode == 1) {
          var id = res.data.id;
          _this2.$vux.loading.hide();
          _this2.showDialog = false;
          _this2.$router.push({
            path: './batch_success?id=' + id
          });
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    sortSearchBtn: function sortSearchBtn() {},
    tabChange: function tabChange(index) {
      var that = this;
      this.buttonTabVal = index;
      this.keyword = '';
      if (index == 1) {
        this.sort = '1';
      }
      this.refresh();
    },
    panelClick: function panelClick(item) {},
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },
    searchReset: function searchReset() {
      this.keyword = '';
      this.searchBtn();
    },
    searchBtn: function searchBtn() {
      var _this3 = this;

      this.memberList = [];

      this.memberAllList.forEach(function (item) {
        var hasKey = false;

        if (_this3.keyword != '') {
          hasKey = item.phone.indexOf(_this3.keyword) != -1 || item.room.indexOf(_this3.keyword) != -1 || item.name.indexOf(_this3.keyword) != -1;
          console.log('hasKey', hasKey, item.state);
          if (hasKey) {
            _this3.memberList.push(item);
          }
        } else {

          _this3.memberList.push(item);
        }
        _this3.memberList.sort(function (a, b) {
          return a.state - b.state;
        });
      });
    },
    clearSearch: function clearSearch() {
      this.keyword = '';
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    save: function save() {
      var signature = 'signature1';
      console.info(this.$refs[signature]);
      var png = this.$refs[signature].save();
      this.form.agent_sign = encodeURI(png);
      this.showSignature = true;
    },
    edit: function edit() {
      this.showSignature = false;
      this.form.agent_sign = '';
    },
    clear: function clear() {
      var signature = 'signature1';
      var refs = this.$refs[signature].clear();
      this.form.agent_sign = '';
    },
    apiBatchMemberList: function apiBatchMemberList(str) {
      var _this4 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var that = this;
      var params = {
        token: this.$cookie.get('token'),
        type: '4',
        keyword: this.keyword,
        store_id: this.$cookie.get('store_id'),
        page: this.page
      };
      Api.memberListApi.getBatchList(params, this.tableId).then(function (res) {
        _this4.memberList = [];
        _this4.memberAllList = [];
        if (res.errcode == 1) {

          _this4.total = res.data.length;
          _this4.normal = res.data.length;
          if (res.data.length) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                if (_this4.tableId == 1 || _this4.tableId == 2) {
                  item.state = 1;
                  item.isSelect = true;
                } else {
                  item.state = 2;
                  item.isSelect = false;
                }

                var _desc = '电话：' + item.phone + ' 时间：' + _this4.formatDateTime(item.live_time) + ' 套餐：' + item.package_name + ' 房号：' + item.room;

                item.key = item.id;
                item.value = item.name;
                item.inlineDesc = _desc;
                item.temperature = '';
                item.weight = '';
                console.log('staff_id', item.staff_id);

                _this4.memberList.push(item);
                _this4.memberAllList.push(item);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
          _this4.$vux.loading.hide();
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    refresh: function refresh() {
      this.memberList = [];
      this.memberAllList = [];
      this.page = '1';
      this.floor_arr = [];
      this.apiBatchMemberList('refresh');
    },
    loadMore: function loadMore() {
      this.apiBatchMemberList();
    },
    goBack: function goBack() {
      this.$router.push({
        path: './batch_service'
      });
    },
    onConfirm: function onConfirm() {
      this.$router.push({
        path: '/'
      });
      this.$cookie.set('token', '');
      this.$cookie.set('id', '');
    },
    hengshuping: function hengshuping() {
      if (window.orientation == 180 || window.orientation == 0) {
        alert('请使用横屏才能达到最佳浏览效果');
      }
    },
    initData: function initData() {
      this.tableId = parseInt(this.$route.query.tableId);

      if (this.tableId == 3 || this.tableId == 4 || this.tableId == 1 || this.tableId == 7) {
        this.isBaby = true;
      }

      if (this.isBaby) {
        this.subtitle1 = '1.勾选客户为<span style="color:red">正常</span>客户宝宝，会自动进行批量处理；（注意多胎情况）';
        this.subtitle2 = '2.非勾选客户为<span style="color:red">异常</span>客户宝宝，需单独填写记录；';
      }

      if (this.tableId == 2 || this.tableId == 5 || this.tableId == 6) {
        this.subtitle1 = '1.勾选客户为<span style="color:red">正常</span>客户，需单独填写记录；';
        this.subtitle2 = '2.非勾选客户为<span style="color:red">异常</span>客户，会自动进行批量处理';
      }
      switch (this.tableId) {
        case 3:
          this.postFun = Api.memberListApi.batchAddBabyNursOne;
          this.tableName = '《婴儿护理记录单（1）》';
          break;
        case 4:
          this.postFun = Api.memberListApi.batchAddBabyNursTwo;
          this.tableName = '《婴儿护理记录单（2）》';
          break;
        case 5:
          this.postFun = Api.memberListApi.batchAddMaternalEverydayPhysiology;
          this.tableName = '《产妇每日生理护理记录表》';
          break;
        case 6:
          this.postFun = Api.memberListApi.batchAddMaterRehNursEvalData;
          this.tableName = '《产妇康复护理评估记录单》';
          break;
        case 2:
          this.postFun = Api.memberListApi.batchMatarnalHeathRecord;
          this.tableName = '《产妇健康咨询记录表》';
          break;
        case 1:
          this.postFun = Api.memberListApi.batchBabyHeathRecord;
          this.tableName = '《新生儿健康咨询记录表》';
          break;
        case 7:
          this.postFun = Api.memberListApi.batchAddBabyCareOpera;
          this.tableName = '《婴儿护理操作记录表》';
          break;
      }

      console.log('this.tableName', this.tableName);
      console.log('this.subtitle1', this.subtitle1);
    }
  },

  created: function created() {

    this.initData();
    this.apiBatchMemberList();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/batch_table.vue



var components_batch_table_pulldownDefaultConfig = {
  content: '下拉刷新',
  height: 40,
  autoRefresh: false,
  downContent: '下拉刷新',
  upContent: '释放后刷新',
  loadingContent: '正在刷新...',
  clsPrefix: 'xs-plugin-pulldown-'
};
var components_batch_table_pullupDefaultConfig = {
  content: '上拉加载更多',
  pullUpHeight: 60,
  height: 40,
  autoRefresh: false,
  downContent: '释放后加载',
  upContent: '上拉加载更多',
  loadingContent: '加载中...',
  clsPrefix: 'xs-plugin-pullup-'
};







/* harmony default export */ var components_batch_table = ({
  name: 'batch_table',
  components: {
    CheckIcon: vux_src_components_check_icon,
    cfr: src_components_cfrList,
    PopupRadio: vux_src_components_popup_radio,
    Checklist: vux_src_components_checklist
  },
  data: function data() {
    var _form, _ref;

    return _ref = {
      tableId: 0,
      tableName: '',
      isBaby: false,
      subtitle1: '',
      subtitle2: '',
      list_id: '',
      shifts: '',
      total: 0,
      normal: 0,
      warn: 0,
      warnUser: []
    }, defineProperty_default()(_ref, 'list_id', ''), defineProperty_default()(_ref, 'showCfrList', false), defineProperty_default()(_ref, 'cfrText', ''), defineProperty_default()(_ref, 'postFun', {}), defineProperty_default()(_ref, 'form', (_form = {
      room: '',
      hand_card: '',
      baby_id: '',
      momName: '',
      sex: ''
    }, defineProperty_default()(_form, 'momName', ''), defineProperty_default()(_form, 'birth_type', ''), defineProperty_default()(_form, 'record_date', this.currentDate()), defineProperty_default()(_form, 'record_hour', ''), defineProperty_default()(_form, 'detail', ''), defineProperty_default()(_form, 'agent_id', ''), defineProperty_default()(_form, 'agent_sign', ''), defineProperty_default()(_form, 'shifts', ''), _form)), defineProperty_default()(_ref, 'baby_list', []), defineProperty_default()(_ref, 'showSignature', true), defineProperty_default()(_ref, 'option', {
      penColor: 'rgb(0, 0, 0)'
    }), defineProperty_default()(_ref, 'get_host', host.host), defineProperty_default()(_ref, 'showDialog', false), defineProperty_default()(_ref, 'buttonTabVal', 0), defineProperty_default()(_ref, 'results', []), defineProperty_default()(_ref, 'keyword', ''), defineProperty_default()(_ref, 'panel_type', '1'), defineProperty_default()(_ref, 'memberList', []), defineProperty_default()(_ref, 'memberAllList', []), defineProperty_default()(_ref, 'floor_arr', []), defineProperty_default()(_ref, 'sort', '2'), defineProperty_default()(_ref, 'sort_text', '倒序'), defineProperty_default()(_ref, 'page', '1'), defineProperty_default()(_ref, 'pullupDefaultConfig', components_batch_table_pullupDefaultConfig), defineProperty_default()(_ref, 'pulldownDefaultConfig', components_batch_table_pulldownDefaultConfig), _ref;
  },

  methods: {
    go_leave_custom: function go_leave_custom() {
      this.$router.push({
        path: './leave_custom_list'
      });
    },
    toBatch: function toBatch() {
      this.$router.push({
        path: './batch_service'
      });
    },
    change: function change() {
      var _this = this;

      this.normal = 0;
      this.memberList.forEach(function (item) {
        if (item.isSelect) {
          item.state = 1;
          _this.normal++;
        } else {
          item.state = 2;
        }
      });
      this.warn = this.total - this.normal;

      this.memberList.sort(function (a, b) {
        return a.state - b.state;
      });

      console.log('change', this.memberList);
    },
    dialog_exit: function dialog_exit() {
      this.showDialog = false;
    },
    selectPeople: function selectPeople() {
      this.showCfrList = true;
    },
    cfrListEven: function cfrListEven(val, item) {
      this.showCfrList = val;
      if (item) {
        this.form.agent_id = item.id;
        console.log('this.form.agent_id', this.form.agent_id);
        this.cfrText = item.user_name;

        if (this.tableId > 2) {

          this.memberList.forEach(function (member) {
            var staff_ids = member.staff_ids;
            var isSelected = false;
            staff_ids.forEach(function (id) {
              if (parseInt(id) == parseInt(item.id)) {
                isSelected = true;
              }
            });
            if (isSelected) {
              member.state = 1;
              member.isSelect = true;
            } else {
              member.state = 2;
              member.isSelect = false;
            }
          });

          this.change();
        }
      }
    },
    currentDate: function currentDate() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return year + '-' + month + '-' + day;
    },
    submit: function submit() {
      this.showDialog = true;
    },
    dialog_confirm: function dialog_confirm() {
      var _this2 = this;

      if (this.form.agent_sign == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请提交签名'
        });
        return;
      }
      if (this.form.shifts == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择班次'
        });
        return;
      }
      if (this.form.agent_id == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择查房人'
        });
        return;
      }

      this.$vux.loading.show({
        text: '正在提交'
      });
      var that = this;

      var postData = {
        store_id: this.$cookie.get('store_id'),
        advisory_agent_sign: this.form.agent_sign,
        advisory_agent_id: this.form.agent_id,
        token: this.$cookie.get('token'),
        shifts: this.form.shifts,
        advisory_date: this.form.record_date
      };

      if (this.isBaby) {
        postData.child = this.memberList;
      } else {
        postData.maternal_info = this.memberList;
      }

      console.log(this.memberList);

      this.postFun(postData, this.tableId).then(function (res) {
        if (res.errcode == 1) {
          var id = res.data.id;
          _this2.$vux.loading.hide();
          _this2.showDialog = false;
          _this2.$router.push({
            path: './batch_success?id=' + id
          });
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    sortSearchBtn: function sortSearchBtn() {},
    tabChange: function tabChange(index) {
      var that = this;
      this.buttonTabVal = index;
      this.keyword = '';
      if (index == 1) {
        this.sort = '1';
      }
      this.refresh();
    },
    panelClick: function panelClick(item) {},
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },
    searchReset: function searchReset() {
      this.keyword = '';
      this.searchBtn();
    },
    searchBtn: function searchBtn() {
      var _this3 = this;

      this.memberList = [];

      this.memberAllList.forEach(function (item) {
        var hasKey = false;

        if (_this3.keyword != '') {
          hasKey = item.phone.indexOf(_this3.keyword) != -1 || item.room.indexOf(_this3.keyword) != -1 || item.name.indexOf(_this3.keyword) != -1;
          console.log('hasKey', hasKey, item.state);
          if (hasKey) {
            _this3.memberList.push(item);
          }
        } else {

          _this3.memberList.push(item);
        }
        _this3.memberList.sort(function (a, b) {
          return a.state - b.state;
        });
      });
    },
    clearSearch: function clearSearch() {
      this.keyword = '';
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    },
    save: function save() {
      var signature = 'signature1';
      console.info(this.$refs[signature]);
      var png = this.$refs[signature].save();
      this.form.agent_sign = encodeURI(png);
      this.showSignature = true;
    },
    edit: function edit() {
      this.showSignature = false;
      this.form.agent_sign = '';
    },
    clear: function clear() {
      var signature = 'signature1';
      var refs = this.$refs[signature].clear();
      this.form.agent_sign = '';
    },
    apiBatchMemberList: function apiBatchMemberList(str) {
      var _this4 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var that = this;
      var params = {
        token: this.$cookie.get('token'),
        type: '4',
        keyword: this.keyword,
        store_id: this.$cookie.get('store_id'),
        page: this.page
      };
      Api.memberListApi.getBatchList(params, this.tableId).then(function (res) {
        _this4.memberList = [];
        _this4.memberAllList = [];
        if (res.errcode == 1) {

          _this4.total = res.data.length;
          _this4.normal = res.data.length;
          if (res.data.length) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                if (_this4.tableId == 1 || _this4.tableId == 2) {
                  item.state = 1;
                  item.isSelect = true;
                } else {
                  item.state = 2;
                  item.isSelect = false;
                }

                var _desc = '电话：' + item.phone + ' 时间：' + _this4.formatDateTime(item.live_time) + ' 套餐：' + item.package_name + ' 房号：' + item.room;

                item.key = item.id;
                item.value = item.name;
                item.inlineDesc = _desc;
                item.temperature = '';
                item.weight = '';
                console.log('staff_id', item.staff_id);

                _this4.memberList.push(item);
                _this4.memberAllList.push(item);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
          _this4.$vux.loading.hide();
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    refresh: function refresh() {
      this.memberList = [];
      this.memberAllList = [];
      this.page = '1';
      this.floor_arr = [];
      this.apiBatchMemberList('refresh');
    },
    loadMore: function loadMore() {
      this.apiBatchMemberList();
    },
    goBack: function goBack() {
      this.$router.push({
        path: './batch_service'
      });
    },
    onConfirm: function onConfirm() {
      this.$router.push({
        path: '/'
      });
      this.$cookie.set('token', '');
      this.$cookie.set('id', '');
    },
    hengshuping: function hengshuping() {
      if (window.orientation == 180 || window.orientation == 0) {
        alert('请使用横屏才能达到最佳浏览效果');
      }
    },
    initData: function initData() {
      this.tableId = parseInt(this.$route.query.tableId);

      if (this.tableId == 3 || this.tableId == 4 || this.tableId == 1 || this.tableId == 7) {
        this.isBaby = true;
      }

      if (this.isBaby) {
        this.subtitle1 = '1.勾选客户为<span style="color:red">正常</span>客户宝宝，会自动进行批量处理；（注意多胎情况）';
        this.subtitle2 = '2.非勾选客户为<span style="color:red">异常</span>客户宝宝，需单独填写记录；';
      }

      if (this.tableId == 2 || this.tableId == 5 || this.tableId == 6) {
        this.subtitle1 = '1.勾选客户为<span style="color:red">正常</span>客户，需单独填写记录；';
        this.subtitle2 = '2.非勾选客户为<span style="color:red">异常</span>客户，会自动进行批量处理';
      }
      switch (this.tableId) {
        case 3:
          this.postFun = Api.memberListApi.batchAddBabyNursOne;
          this.tableName = '《婴儿护理记录单（1）》';
          break;
        case 4:
          this.postFun = Api.memberListApi.batchAddBabyNursTwo;
          this.tableName = '《婴儿护理记录单（2）》';
          break;
        case 5:
          this.postFun = Api.memberListApi.batchAddMaternalEverydayPhysiology;
          this.tableName = '《产妇每日生理护理记录表》';
          break;
        case 6:
          this.postFun = Api.memberListApi.batchAddMaterRehNursEvalData;
          this.tableName = '《产妇康复护理评估记录单》';
          break;
        case 2:
          this.postFun = Api.memberListApi.batchMatarnalHeathRecord;
          this.tableName = '《产妇健康咨询记录表》';
          break;
        case 1:
          this.postFun = Api.memberListApi.batchBabyHeathRecord;
          this.tableName = '《新生儿健康咨询记录表》';
          break;
        case 7:
          this.postFun = Api.memberListApi.batchAddBabyCareOpera;
          this.tableName = '《婴儿护理操作记录表》';
          break;
      }

      console.log('this.tableName', this.tableName);
      console.log('this.subtitle1', this.subtitle1);
    }
  },

  created: function created() {

    this.initData();
    this.apiBatchMemberList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-532446e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/batch_table.vue
var batch_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"batch_table"},[_c('div',{staticClass:"batch_table_dock"},[_c('x-header',{attrs:{"left-options":{
        showBack: true,
        preventGoBack: true,
        backText: '返回',
      }},on:{"on-click-back":_vm.goBack}},[_vm._v("批量操作")]),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('p',{staticClass:"title"},[_vm._v("\n        请勾选正常客户，批量处理"),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.tableName))])]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.subtitle1)}})]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.subtitle2)}})])]),_vm._v(" "),_c('div',{staticClass:"search-content2"},[_c('flexbox',[_c('flexbox-item',{attrs:{"span":1 / 5}},[(_vm.tableId > 2)?_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"value"},[_vm._v("\n                "+_vm._s(_vm.cfrText)+"\n                "),_c('x-button',{attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople.apply(null, arguments)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('cfr',{attrs:{"list_id":_vm.list_id,"showCfrList":_vm.showCfrList},on:{"cfrListEven":_vm.cfrListEven}})],1):_vm._e()]),_vm._v(" "),_c('flexbox-item',[_c('x-input',{staticClass:"weui-vcode",attrs:{"placeholder":"请输入姓名、手机号、房间号进行搜索"},on:{"on-click-clear-icon":_vm.clearSearch},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}},[_c('x-button',{attrs:{"slot":"right","gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.searchBtn.apply(null, arguments)}},slot:"right"},[_vm._v("搜索")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-left":"10px"},attrs:{"slot":"right","gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.searchReset.apply(null, arguments)}},slot:"right"},[_vm._v("清空搜索")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"batch_table_main"},[(_vm.tableId == 3)?_c('flexbox',{staticStyle:{"background-color":"#ffffff","border-bottom":"1px solid #888","padding":"10px"},attrs:{"gutter":0}},[_c('flexbox-item',{attrs:{"span":1 / 4,"order":4,"align":"center"}},[_vm._v("体温（℃）\n      ")]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1 / 4,"order":3,"align":"center"}},[_vm._v("\n        体重（g）\n      ")]),_vm._v(" "),_c('flexbox-item',{attrs:{"span":1 / 2,"order":2,"align":"center"}},[_vm._v("\n        基本信息\n      ")])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.memberList),function(row,index){return _c('div',{key:index},[_c('flexbox',{staticStyle:{"background-color":"#ffffff","border-bottom":"1px solid #888","padding":"10px"},attrs:{"gutter":0}},[(_vm.tableId == 3)?_c('flexbox-item',{attrs:{"span":1 / 4,"order":3,"align":"center"}},[_c('div',[_c('x-input',{staticClass:"vux-c-input",attrs:{"placeholder":" ","name":'w-' + row.key,"text-align":"center"},model:{value:(row.weight),callback:function ($$v) {_vm.$set(row, "weight", $$v)},expression:"row.weight"}})],1)]):_vm._e(),_vm._v(" "),(_vm.tableId == 3)?_c('flexbox-item',{attrs:{"span":1 / 4,"order":4,"align":"center"}},[_c('x-input',{staticClass:"vux-c-input",attrs:{"placeholder":" ","name":'s-' + row.key,"text-align":"center"},model:{value:(row.temperature),callback:function ($$v) {_vm.$set(row, "temperature", $$v)},expression:"row.temperature"}})],1):_vm._e(),_vm._v(" "),_c('flexbox-item',{attrs:{"span":_vm.tableId == 3 ? 1 / 2 : '',"order":2}},[_c('flexbox',[_c('flexbox-item',{attrs:{"span":1}},[_c('p',[_c('check-icon',{attrs:{"name":'c-' + row.key,"value":row.isSelect},on:{"update:value":function($event){return _vm.$set(row, "isSelect", $event)}},nativeOn:{"click":function($event){return _vm.change.apply(null, arguments)}}})],1)]),_vm._v(" "),_c('flexbox-item',[_c('flexbox',{attrs:{"orient":"vertical"}},[_c('flexbox-item',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(row.value)+"\n                  "),(_vm.isBaby)?_c('span',{staticStyle:{"color":"blue"}},[_vm._v("("+_vm._s(row.child_name)+")")]):_vm._e()]),_vm._v(" "),_c('flexbox-item',[_c('span',{staticStyle:{"color":"#888888"}},[_vm._v(_vm._s(row.inlineDesc))])])],1)],1)],1)],1)],1)],1)}),_vm._v(" "),(_vm.floor_arr.length)?_c('div',{staticClass:"position_fixed"},_vm._l((_vm.floor_arr),function(item,index){return _c('a',{key:index,staticClass:"floor",attrs:{"href":'#' + item}},[_vm._v(_vm._s(item))])}),0):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}],staticClass:"christmas_form_one"},[_c('x-dialog',{attrs:{"dialog-style":{
        'max-width': '100%',
        width: '90%',
        height: 'auto',
        'background-color': '#fff',
      }},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('group',{staticClass:"editContent01"},[(_vm.tableId == 1 || _vm.tableId == 2)?_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"0","line-height":"29px"}},[_vm._v("\n              查房人：\n            ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n              "+_vm._s(_vm.cfrText)+"\n              "),_c('x-button',{attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople.apply(null, arguments)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('cfr',{attrs:{"list_id":_vm.list_id,"showCfrList":_vm.showCfrList},on:{"cfrListEven":_vm.cfrListEven}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("查房时间：")]),_vm._v(" "),_c('div',{staticClass:"label",staticStyle:{"margin-top":"0px"}},[_c('datetime',{attrs:{"title":"","placeholder":"请选择查房时间","ormat":"yyyy-MM-dd"},model:{value:(_vm.form.record_date),callback:function ($$v) {_vm.$set(_vm.form, "record_date", $$v)},expression:"form.record_date"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0px1important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px","padding-left":"0px"}},[_vm._v("\n              班次：\n            ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("晚班")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0pximportant"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0px"}},[_vm._v("签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.agent_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.agent_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('flexbox',[_c('flexbox-item',{staticStyle:{"padding":"10px"}},[_c('x-button',{staticClass:"b_btn_style",attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"type":"default","action-type":"submit"},nativeOn:{"click":function($event){return _vm.dialog_confirm.apply(null, arguments)}}},[_vm._v("确认")])],1),_vm._v(" "),_c('flexbox-item',{staticStyle:{"padding":"10px"}},[_c('x-button',{staticClass:"b_btn_style",staticStyle:{"color":"#999"},attrs:{"type":"default"},nativeOn:{"click":function($event){return _vm.dialog_exit.apply(null, arguments)}}},[_vm._v("取消")])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"footer01"},[_c('div',{staticClass:"left"},[_c('div',[_c('span',[_vm._v("总在住："+_vm._s(_vm.total))]),_vm._v(" "),_c('span',[_vm._v("已选正常："+_vm._s(_vm.normal))]),_vm._v(" "),_c('span',[_vm._v("异常："+_vm._s(_vm.warn)+" ")])]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("确认总在住、异常、正常人数是否正确")])]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('x-button',{attrs:{"slot":"right","gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.submit.apply(null, arguments)}},slot:"right"},[_vm._v("确定处理")])],1)])])}
var batch_table_staticRenderFns = []
var batch_table_esExports = { render: batch_table_render, staticRenderFns: batch_table_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_batch_table = (batch_table_esExports);
// CONCATENATED MODULE: ./src/components/batch_table.vue
function batch_table_injectStyle (ssrContext) {
  __webpack_require__("fPd8")
}
var batch_table_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var batch_table___vue_template_functional__ = false
/* styles */
var batch_table___vue_styles__ = batch_table_injectStyle
/* scopeId */
var batch_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var batch_table___vue_module_identifier__ = null
var batch_table_Component = batch_table_normalizeComponent(
  components_batch_table,
  selectortype_template_index_0_src_components_batch_table,
  batch_table___vue_template_functional__,
  batch_table___vue_styles__,
  batch_table___vue_scopeId__,
  batch_table___vue_module_identifier__
)

/* harmony default export */ var src_components_batch_table = (batch_table_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/batch_success.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var batch_success = ({
  name: 'success',
  data: function data() {
    return {
      buttons: [],
      back_home_link: '',
      detail_link: ''
    };
  },

  methods: {
    backHomeClick: function backHomeClick() {
      // this.$router.replace(this.back_home_link)
      this.$router.push({
        path: './maternal_file'
      });
    },
    seeDetailClick: function seeDetailClick() {
      var path = './batch_record_detail?id=' + this.$route.query.id;

      console.log(path);

      this.$router.push({
        path: path
      });
    }
  },
  created: function created() {
    this.back_home_link = '/maternal_service?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;

    var name = this.$route.query.name;
    console.log(name);
    switch (name) {
      case 'month_live':
        this.detail_link = '/month_live?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'add_from_record':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'detail_other_form':
        this.detail_link = 'detail_other_form?answer_id=' + this.$route.query.answer_id + '&form_id=' + this.$route.query.form_id + '&id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'baby_live':
        this.detail_link = '/baby_live?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'other_form_detail':
        this.detail_link = '/other_form_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal + '&form_id=' + this.$route.query.form_id;
        break;
      // case 'bb_form_a':
      // this.detail_link = './bb_form?a=2'
      case 'bb_form_f':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_b':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_c':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_a':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_b':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_c':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_d':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_a':
        this.detail_link = './maternal_form_a_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_a_edit':
        this.detail_link = './maternal_form_a_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_e':
        this.detail_link = '/bb_form_e_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_e_edit':
        this.detail_link = '/bb_form_e_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_d':
        this.detail_link = '/bb_form_d_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_d_edit':
        this.detail_link = '/bb_form_d_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_one':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_two':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_three':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_four':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_six':
        this.detail_link = '/christmas_form_six_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_six_edit':
        this.detail_link = '/christmas_form_six_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_seven':
        this.detail_link = '/christmas_form_seven_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_seven_edit':
        this.detail_link = '/christmas_form_seven_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_eight':
        this.detail_link = '/christmas_form_eight_detail?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_eight_edit':
        this.detail_link = '/christmas_form_eight_detail?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'medicine_commissioned':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'basic_nursing':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/batch_success.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_batch_success = ({
  name: 'success',
  data: function data() {
    return {
      buttons: [],
      back_home_link: '',
      detail_link: ''
    };
  },

  methods: {
    backHomeClick: function backHomeClick() {
      // this.$router.replace(this.back_home_link)
      this.$router.push({
        path: './maternal_file'
      });
    },
    seeDetailClick: function seeDetailClick() {
      var path = './batch_record_detail?id=' + this.$route.query.id;

      console.log(path);

      this.$router.push({
        path: path
      });
    }
  },
  created: function created() {
    this.back_home_link = '/maternal_service?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;

    var name = this.$route.query.name;
    console.log(name);
    switch (name) {
      case 'month_live':
        this.detail_link = '/month_live?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'add_from_record':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'detail_other_form':
        this.detail_link = 'detail_other_form?answer_id=' + this.$route.query.answer_id + '&form_id=' + this.$route.query.form_id + '&id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'baby_live':
        this.detail_link = '/baby_live?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'other_form_detail':
        this.detail_link = '/other_form_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal + '&form_id=' + this.$route.query.form_id;
        break;
      // case 'bb_form_a':
      // this.detail_link = './bb_form?a=2'
      case 'bb_form_f':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_b':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_c':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_a':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_b':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_c':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_d':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_a':
        this.detail_link = './maternal_form_a_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'maternal_form_a_edit':
        this.detail_link = './maternal_form_a_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_e':
        this.detail_link = '/bb_form_e_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_e_edit':
        this.detail_link = '/bb_form_e_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_d':
        this.detail_link = '/bb_form_d_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'bb_form_d_edit':
        this.detail_link = '/bb_form_d_detail?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_one':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_two':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_three':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_four':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_six':
        this.detail_link = '/christmas_form_six_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_six_edit':
        this.detail_link = '/christmas_form_six_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_seven':
        this.detail_link = '/christmas_form_seven_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_seven_edit':
        this.detail_link = '/christmas_form_seven_detail?id=' + this.$route.query.id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_eight':
        this.detail_link = '/christmas_form_eight_detail?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'christmas_form_eight_edit':
        this.detail_link = '/christmas_form_eight_detail?id=' + this.$route.query.id + '&child_id=' + this.$route.query.child_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'medicine_commissioned':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
      case 'basic_nursing':
        this.detail_link = '/check_room_service?id=' + this.$route.query.id + '&form_id=' + this.$route.query.form_id + '&tabVal=' + this.$route.query.tabVal;
        break;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc30e5ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/batch_success.vue
var batch_success_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('msg',[_c('template',{slot:"buttons"},[_c('h2',{staticClass:"weui-msg__title"},[_vm._v("数据更新成功")]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.backHomeClick.apply(null, arguments)}}},[_vm._v("返回主页")]),_vm._v(" "),_c('x-button',{nativeOn:{"click":function($event){return _vm.seeDetailClick.apply(null, arguments)}}},[_vm._v("查看详情")])],1)],2)],1)}
var batch_success_staticRenderFns = []
var batch_success_esExports = { render: batch_success_render, staticRenderFns: batch_success_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_batch_success = (batch_success_esExports);
// CONCATENATED MODULE: ./src/components/batch_success.vue
var batch_success_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var batch_success___vue_template_functional__ = false
/* styles */
var batch_success___vue_styles__ = null
/* scopeId */
var batch_success___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var batch_success___vue_module_identifier__ = null
var batch_success_Component = batch_success_normalizeComponent(
  components_batch_success,
  selectortype_template_index_0_src_components_batch_success,
  batch_success___vue_template_functional__,
  batch_success___vue_styles__,
  batch_success___vue_scopeId__,
  batch_success___vue_module_identifier__
)

/* harmony default export */ var src_components_batch_success = (batch_success_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_info_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var maternal_info_detail = ({
    name: 'maternal_info_detail',
    data: function data() {
        return {
            memberDetailList: {
                name: '',
                group_name: '',
                sex: '',
                channel_name: '',
                phone: '',
                consult_time: '',
                birthday: '',
                address: '',
                remark: '',
                family_info: [],
                nation: '',
                birth_place: '',
                height: '',
                weight: '',
                education: '',
                job: '',
                child_birth: '',
                hospital: ''
            }
        };
    },

    methods: {
        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },

        //请求孕妇个人信息
        apiMemberDetail: function apiMemberDetail() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.id
            };
            console.info(params);
            Api.memberListApi.memberDetail(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    var data = res.data;
                    //基本信息
                    _this.memberDetailList.name = data.name;
                    _this.memberDetailList.group_name = data.group_name;
                    _this.memberDetailList.sex = data.sex == '1' ? '男' : '女';
                    _this.memberDetailList.channel_name = data.channel_name;
                    _this.memberDetailList.phone = data.phone;
                    _this.memberDetailList.consult_time = _this.formatDateTime(data.consult_time);
                    _this.memberDetailList.birthday = _this.formatDateTime(data.birthday);
                    _this.memberDetailList.address = data.district_str + data.address;
                    _this.memberDetailList.remark = data.remark;
                    //家属信息
                    _this.memberDetailList.family_info = data.family_info;
                    //其他信息
                    _this.memberDetailList.nation = data.nation;
                    _this.memberDetailList.birth_place = data.birth_place;
                    _this.memberDetailList.height = data.height;
                    _this.memberDetailList.weight = data.weight;
                    _this.memberDetailList.education = data.education;
                    _this.memberDetailList.job = data.job;
                    //孕妇信息
                    _this.memberDetailList.child_birth = _this.formatDateTime(data.child_birth);
                    _this.memberDetailList.hospital = data.hospital;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        edit: function edit() {
            this.$router.push({
                path: '/edit_maternal_info'

            });
        }
    },
    created: function created() {
        this.apiMemberDetail();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_info_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_maternal_info_detail = ({
    name: 'maternal_info_detail',
    data: function data() {
        return {
            memberDetailList: {
                name: '',
                group_name: '',
                sex: '',
                channel_name: '',
                phone: '',
                consult_time: '',
                birthday: '',
                address: '',
                remark: '',
                family_info: [],
                nation: '',
                birth_place: '',
                height: '',
                weight: '',
                education: '',
                job: '',
                child_birth: '',
                hospital: ''
            }
        };
    },

    methods: {
        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },

        //请求孕妇个人信息
        apiMemberDetail: function apiMemberDetail() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.id
            };
            console.info(params);
            Api.memberListApi.memberDetail(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    var data = res.data;
                    //基本信息
                    _this.memberDetailList.name = data.name;
                    _this.memberDetailList.group_name = data.group_name;
                    _this.memberDetailList.sex = data.sex == '1' ? '男' : '女';
                    _this.memberDetailList.channel_name = data.channel_name;
                    _this.memberDetailList.phone = data.phone;
                    _this.memberDetailList.consult_time = _this.formatDateTime(data.consult_time);
                    _this.memberDetailList.birthday = _this.formatDateTime(data.birthday);
                    _this.memberDetailList.address = data.district_str + data.address;
                    _this.memberDetailList.remark = data.remark;
                    //家属信息
                    _this.memberDetailList.family_info = data.family_info;
                    //其他信息
                    _this.memberDetailList.nation = data.nation;
                    _this.memberDetailList.birth_place = data.birth_place;
                    _this.memberDetailList.height = data.height;
                    _this.memberDetailList.weight = data.weight;
                    _this.memberDetailList.education = data.education;
                    _this.memberDetailList.job = data.job;
                    //孕妇信息
                    _this.memberDetailList.child_birth = _this.formatDateTime(data.child_birth);
                    _this.memberDetailList.hospital = data.hospital;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        edit: function edit() {
            this.$router.push({
                path: '/edit_maternal_info'

            });
        }
    },
    created: function created() {
        this.apiMemberDetail();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3390af8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_info_detail.vue
var maternal_info_detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"weui-cells__title"},[_vm._v("基本信息")]),_vm._v(" "),_c('div',{staticClass:"section_con"},[_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("姓名："+_vm._s(_vm.memberDetailList.name))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("用户分组："+_vm._s(_vm.memberDetailList.group_name))])])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("性别："+_vm._s(_vm.memberDetailList.sex))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("渠道："+_vm._s(_vm.memberDetailList.channel_name))])])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("手机："+_vm._s(_vm.memberDetailList.phone))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("咨询日期："+_vm._s(_vm.memberDetailList.consult_time))])])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("出生日期："+_vm._s(_vm.memberDetailList.birthday))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("家庭住址："+_vm._s(_vm.memberDetailList.address))])])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("备注："+_vm._s(_vm.memberDetailList.remark))])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"weui-cells__title"},[_vm._v("其他信息")]),_vm._v(" "),_c('div',{staticClass:"section_con"},[_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("民族："+_vm._s(_vm.memberDetailList.nation))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("籍贯："+_vm._s(_vm.memberDetailList.birth_place))])])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("身高："+_vm._s(_vm.memberDetailList.height)+"CM")])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("体重："+_vm._s(_vm.memberDetailList.weight)+"KG")])])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("学历："+_vm._s(_vm.memberDetailList.education))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("职业："+_vm._s(_vm.memberDetailList.job))])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"weui-cells__title"},[_vm._v("孕妇信息")]),_vm._v(" "),_c('div',{staticClass:"section_con"},[_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("预产期："+_vm._s(_vm.memberDetailList.child_birth))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("分娩医院："+_vm._s(_vm.memberDetailList.hospital))])])],1),_vm._v(" "),_vm._l((_vm.memberDetailList.family_info),function(item,index){return _c('flexbox',{key:index,staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("家属名字："+_vm._s(item.name))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("家属关系："+_vm._s(item.relation))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo"},[_vm._v("家属电话："+_vm._s(item.phone))])])],1)})],2)]),_vm._v(" "),_c('router-link',{staticClass:"edit-btn",attrs:{"to":""}},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("修改")])],1)],1)}
var maternal_info_detail_staticRenderFns = []
var maternal_info_detail_esExports = { render: maternal_info_detail_render, staticRenderFns: maternal_info_detail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_info_detail = (maternal_info_detail_esExports);
// CONCATENATED MODULE: ./src/components/maternal_info_detail.vue
function maternal_info_detail_injectStyle (ssrContext) {
  __webpack_require__("Eg2E")
}
var maternal_info_detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_info_detail___vue_template_functional__ = false
/* styles */
var maternal_info_detail___vue_styles__ = maternal_info_detail_injectStyle
/* scopeId */
var maternal_info_detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_info_detail___vue_module_identifier__ = null
var maternal_info_detail_Component = maternal_info_detail_normalizeComponent(
  components_maternal_info_detail,
  selectortype_template_index_0_src_components_maternal_info_detail,
  maternal_info_detail___vue_template_functional__,
  maternal_info_detail___vue_styles__,
  maternal_info_detail___vue_scopeId__,
  maternal_info_detail___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_info_detail = (maternal_info_detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/check_room_service.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var check_room_service_pulldownDefaultConfig = {
  content: '下拉刷新',
  height: 40,
  autoRefresh: false,
  downContent: '下拉刷新',
  upContent: '释放后刷新',
  loadingContent: '正在刷新...',
  clsPrefix: 'xs-plugin-pulldown-'
};
var check_room_service_pullupDefaultConfig = {
  content: '上拉加载更多',
  pullUpHeight: 60,
  height: 40,
  autoRefresh: false,
  downContent: '释放后加载',
  upContent: '上拉加载更多',
  loadingContent: '加载中...',
  clsPrefix: 'xs-plugin-pullup-'
};

/* harmony default export */ var check_room_service = ({
  name: 'check_room_service',
  data: function data() {
    return {
      get_host: host.host,
      tab_index: 0,
      babySelectShow: false, //宝宝筛选显示
      showFormList: true, //显示表单列表
      personalMemberInfo: [],
      form_list: [],
      data_list: [], //表单数组
      start_date: '', //开始日期
      end_date: '', //结束日期
      shift_value: '', //班次值
      shift_arr: [], //班次选项
      min_date: '', //最小日期限制
      memberInfo: {
        room_name: '',
        name: '',
        phone: '',
        package: '',
        liveDate: '',
        childBirth: '',
        birthType: '',
        babyType: [{
          label: '顺产',
          value: '1'
        }, {
          label: '剖宫产',
          value: '2'
        }, {
          label: '小产',
          value: '3'
        }, {
          label: '不知道',
          value: '0'
        }]
      },
      form_id: '',
      from_title: '',
      page: '1',
      host: api_const["host"],
      pullupDefaultConfig: check_room_service_pullupDefaultConfig,
      pulldownDefaultConfig: check_room_service_pulldownDefaultConfig,
      newForm: [{
        id: 1001,
        name: '婴儿护理操作记录表',
        style: true
      }, {
        id: 1002,
        name: '婴儿护理记录单(1)',
        style: true
      }, {
        id: 1003,
        name: '婴儿护理记录单(2)',
        style: true
      }, {
        id: 1004,
        name: '婴儿喂养记录单',
        style: true
      }, {
        id: 1005,
        name: '产妇每日生理护理记录表',
        style: true
      }, {
        id: 1006,
        name: '产妇膳食记录表',
        style: true
      }, {
        id: 1007,
        name: '产妇康复护理评估记录单',
        style: true
      }, {
        id: 1008,
        name: '产妇健康咨询记录表',
        style: true
      }, {
        id: 1009,
        name: '新生儿健康咨询记录表',
        style: true
      }, {
        id: 1010,
        name: '产妇特殊护理记录表',
        style: true
      }, {
        id: 1011,
        name: '婴儿特殊护理记录表',
        style: true
      }, {
        id: 1012,
        name: '喂药委托书(新)',
        style: true
      }, {
        id: 1013,
        name: '月子基本护理常识(新)',
        style: true
      }, {
        id: 1014,
        name: '查房记录(新)',
        style: true
      }],
      formListDetailList: [],
      formListDetailListPage: 1,
      nurser_name: [], //查房人列表
      baby_list: [], //宝宝列表
      get_baby_id: '',
      cfrText: ''
    };
  },

  methods: {
    //清除表单
    clearFrom: function clearFrom() {
      console.info('清除表单');
      this.forFormIDUseMethod('tab');
    },

    //添加记录
    addRecord: function addRecord() {
      var formId = parseInt(this.form_id);
      console.info(formId);
      var query = {
        id: this.$route.query.id,
        form_id: formId,
        tabVal: this.$route.query.tabVal
      };
      switch (formId) {
        case 1001:
          this.$router.push({
            path: '/bb_form_f',
            query: query
          });
          break;
        case 1002:
          this.$router.push({
            path: '/bb_form_b',
            query: query
          });
          break;
        case 1003:
          this.$router.push({
            path: '/bb_form_c',
            query: query
          });
          break;
        case 1004:
          this.$router.push({
            path: '/bb_form_a',
            query: query
          });
          break;
        case 1005:
          this.$router.push({
            path: '/maternal_form_d',
            query: query
          });
          break;
        case 1006:
          this.$router.push({
            path: '/maternal_form_b',
            query: query
          });
          break;
        case 1007:
          this.$router.push({
            path: '/maternal_form_c',
            query: query
          });
          break;
        case 1008:
          this.$router.push({
            path: '/christmas_form_one',
            query: query
          });
          break;
        case 1009:
          this.$router.push({
            path: '/christmas_form_two',
            query: query
          });
          break;
        case 1010:
          this.$router.push({
            path: '/christmas_form_three',
            query: query
          });
          break;
        case 1011:
          this.$router.push({
            path: '/christmas_form_four',
            query: query
          });
          break;
        case 1012:
          this.$router.push({
            path: '/medicine_commissioned',
            query: query
          });
          break;
        case 1013:
          this.$router.push({
            path: '/basic_nursing',
            query: query
          });
          break;
        case 1014:
          this.$router.push({
            path: '/new_check_room_record',
            query: query
          });
          break;
        default:
          this.$router.push({
            path: '/add_from_record',
            query: query
          });
      }
    },

    //时间戳转日期格式
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },

    //点击查房表
    tabItem: function tabItem(index) {
      this.form_id = this.form_list[index].id;
      this.from_title = this.form_list[index].name;
      if (this.form_list[index].id == '999') {
        this.$router.push({
          path: '/check_room_record',
          query: {
            id: this.$route.query.id,
            tabVal: this.$route.query.tabVal
          }
        });
        return;
      }
      this.forFormIDUseMethod('tab');
    },

    //选择开始日期
    start_date_congirm: function start_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.min_date = value;
      this.start_date = value;
      console.info('选择开始日期');
      this.forFormIDUseMethod();
    },

    //选择结束日期
    end_date_congirm: function end_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.end_date = value;
      console.info('选择结束日期');
      this.forFormIDUseMethod();
    },

    //选择班次
    plantPickerChange: function plantPickerChange(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      console.info('选择班次');
      this.forFormIDUseMethod();
    },

    //选择宝宝
    babyPickerChange: function babyPickerChange(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (value == item.name) {
            if (item.live_time == '0') {
              this.$vux.toast.show({
                type: 'cancel',
                text: item.name + '暂未入住'
              });
              return;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.forFormIDUseMethod();
    },

    //获取表单查房列表
    apiFormList: function apiFormList() {
      var _this = this;

      var that = this;
      var params = {
        token: this.$cookie.get('token')
      };
      Api.checkRoomApi.roundFormList(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this.form_list = res.data;
          // this.form_list.push({
          //     id: '999',
          //     name: '查房记录'
          // })
          var arr = [].concat(toConsumableArray_default()(_this.newForm), toConsumableArray_default()(_this.form_list));
          _this.form_list = arr;
          var id_arr = [];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(_this.form_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              id_arr.push(parseInt(item.id));
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (_this.$route.query.form_id) {
            //查看详情赋值查房单ID
            _this.form_id = _this.$route.query.form_id;
            var get_form_index = id_arr.indexOf(parseInt(_this.$route.query.form_id));
            _this.tab_index = get_form_index;
            _this.from_title = _this.form_list[get_form_index].name;
          } else {
            //初始化赋值表查房单ID
            _this.form_id = _this.newForm[0].id;
            _this.from_title = _this.newForm[0].name;
          }
          _this.forFormIDUseMethod('login');
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求用户基本信息
    apiMemberInfo: function apiMemberInfo() {
      var _this2 = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.memberInfo(params).then(function (res) {
        console.info('请求用户基本信息', res);
        if (res.errcode == 1) {
          _this2.memberInfo.room_name = res.data.room_name;
          _this2.memberInfo.name = res.data.name;
          _this2.memberInfo.phone = res.data.phone;
          _this2.memberInfo.package = res.data.package_name;
          _this2.memberInfo.liveDate = _this2.formatDateTime(res.data.live_time);
          _this2.memberInfo.childBirth = _this2.formatDateTime(res.data.child_birth);
          var birthType = '';
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = get_iterator_default()(_this2.memberInfo.babyType), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var item = _step3.value;

              if (res.data.birth_type == item.value) {
                birthType = item.label;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          _this2.memberInfo.birthType = birthType;
        } else {
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    dateFormat: function dateFormat(_date) {
      var date = new Date(_date);
      var time = Date.parse(date) / 1000;
      return time;
    },

    //获取自定义表单列表
    apiGroupList: function apiGroupList(str) {
      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.form_id,
        stime: this.start_date == '' ? '' : this.dateFormat(this.start_date + ' 00:00:00:000'),
        etime: this.end_date == '' ? '' : this.dateFormat(this.end_date + ' 23:59:59:999'),
        plans: this.shift_value,
        page: this.page,
        isWap: '1'
      };
      var that = this;
      console.info(params);
      Api.checkRoomApi.getGroupList(params).then(function (res) {
        console.info('自定义表单', res);
        if (res.errcode == 1) {
          that.page++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = get_iterator_default()(res.data.list), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var item = _step4.value;

                that.data_list.push(item);
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = get_iterator_default()(that.data_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var _item = _step5.value;
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                  for (var _iterator6 = get_iterator_default()(_item.form_data), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var item0 = _step6.value;
                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                      for (var _iterator7 = get_iterator_default()(item0.row_list), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                        var item1 = _step7.value;
                        var _iteratorNormalCompletion8 = true;
                        var _didIteratorError8 = false;
                        var _iteratorError8 = undefined;

                        try {
                          for (var _iterator8 = get_iterator_default()(item1.content), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                            var item2 = _step8.value;
                            var _iteratorNormalCompletion9 = true;
                            var _didIteratorError9 = false;
                            var _iteratorError9 = undefined;

                            try {
                              for (var _iterator9 = get_iterator_default()(that.personalMemberInfo), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                var val = _step9.value;

                                if (item2.column_name == val.name) {
                                  item2.my_answer[0] = val.value;
                                }
                              }
                            } catch (err) {
                              _didIteratorError9 = true;
                              _iteratorError9 = err;
                            } finally {
                              try {
                                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                  _iterator9.return();
                                }
                              } finally {
                                if (_didIteratorError9) {
                                  throw _iteratorError9;
                                }
                              }
                            }
                          }
                        } catch (err) {
                          _didIteratorError8 = true;
                          _iteratorError8 = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                              _iterator8.return();
                            }
                          } finally {
                            if (_didIteratorError8) {
                              throw _iteratorError8;
                            }
                          }
                        }
                      }
                    } catch (err) {
                      _didIteratorError7 = true;
                      _iteratorError7 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                          _iterator7.return();
                        }
                      } finally {
                        if (_didIteratorError7) {
                          throw _iteratorError7;
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError6 = true;
                  _iteratorError6 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                      _iterator6.return();
                    }
                  } finally {
                    if (_didIteratorError6) {
                      throw _iteratorError6;
                    }
                  }
                }
              }
              // this.personalMemberInfo
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }

            that.shift_arr = res.data.plans_list;
            if (str == 'refresh') {
              that.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
              that.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
            }
            if (res.data.page.page == res.data.page.page_count) {
              that.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
            } else {
              that.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
            }
          } else {
            that.$vux.toast.show({
              type: 'cancel',
              text: '暂无更多数据'
            });
          }
          that.$vux.loading.hide();
        } else {
          that.$vux.loading.hide();
          that.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //编辑记录表
    editForm: function editForm(answer_id) {
      this.$router.push({
        path: './add_from_record',
        query: {
          id: this.$route.query.id,
          form_id: this.form_id,
          answer_id: answer_id,
          tabVal: this.$route.query.tabVal
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    },

    //自定义表单下拉刷新
    refresh: function refresh() {
      this.data_list = [];
      this.page = '1';
      this.apiGroupList('refresh');
    },

    //自定义表单上拉加载
    loadMore: function loadMore() {
      this.apiGroupList();
    },

    //固定表单下拉刷新
    refresh2: function refresh2() {
      this.formListDetailList = [];
      this.formListDetailListPage = 1;
      console.info('固定表单下拉刷新');
      this.forFormIDUseMethod();
    },

    //固定表单上拉加载
    loadMore2: function loadMore2() {
      console.info('固定表单上拉加载');
      this.forFormIDUseMethod();
    },

    //请求答案列表
    getAnswerList: function getAnswerList() {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.getColumnList(params).then(function (res) {
        console.log('请求答案列表', res);
        if (res.errcode == 1) {
          _this3.personalMemberInfo = res.data;
        } else {
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求婴儿护理操作记录表所有列表
    apiBabyCare: function apiBabyCare(str, handle) {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getBabyCareOperalist(params).then(function (res) {
        console.info('请求婴儿护理操作记录表', res);
        if (res.data) {
          var shift_value = _this4.$route.query.shifts_value;
          _this4.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
              for (var _iterator10 = get_iterator_default()(res.data.shifts_count_list), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                var item = _step10.value;

                _this4.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this4.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError10 = true;
              _iteratorError10 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                  _iterator10.return();
                }
              } finally {
                if (_didIteratorError10) {
                  throw _iteratorError10;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this4.formListDetailListPage);
          _this4.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
              for (var _iterator11 = get_iterator_default()(res.data.list), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                var _item2 = _step11.value;

                _this4.formListDetailList.push(_item2);
              }
            } catch (err) {
              _didIteratorError11 = true;
              _iteratorError11 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                  _iterator11.return();
                }
              } finally {
                if (_didIteratorError11) {
                  throw _iteratorError11;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this4.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this4.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }

          if (res.data.page.page == res.data.page.page_count) {
            _this4.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this4.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this4.$vux.loading.hide();
          return;
        } else if (res.errcode == 400) {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求婴儿护理记录单（1）所有列表
    apiBabyRecord: function apiBabyRecord(str, handle) {
      var _this5 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getBabyNursOneDataList(params).then(function (res) {
        console.info('请求婴儿护理记录单（1）', res);
        if (res.data) {
          var shift_value = _this5.$route.query.shifts_value;
          _this5.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
              for (var _iterator12 = get_iterator_default()(res.data.shifts_count_list), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var item = _step12.value;

                _this5.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this5.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError12 = true;
              _iteratorError12 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                  _iterator12.return();
                }
              } finally {
                if (_didIteratorError12) {
                  throw _iteratorError12;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this5.formListDetailListPage);
          _this5.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
              for (var _iterator13 = get_iterator_default()(res.data.list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                var _item3 = _step13.value;

                var cfrText = '';
                if (_this5.nurser_name.length) {
                  var _iteratorNormalCompletion14 = true;
                  var _didIteratorError14 = false;
                  var _iteratorError14 = undefined;

                  try {
                    for (var _iterator14 = get_iterator_default()(_this5.nurser_name), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                      var val = _step14.value;

                      if (_item3.check_id == val.id) {
                        cfrText = val.user_name;
                      }
                    }
                  } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                      }
                    } finally {
                      if (_didIteratorError14) {
                        throw _iteratorError14;
                      }
                    }
                  }
                }
                _item3.cfrText = cfrText;

                if (_item3.front_case == 1) {
                  _item3.front_case = '平坦';
                } else if (_item3.front_case == 2) {
                  _item3.front_case = '肿胀';
                } else if (_item3.front_case == 3) {
                  _item3.front_case = '凹陷';
                } else {
                  _item3.front_case = '';
                }
                if (_item3.skin_colour == '1') {
                  _item3.skin_colour = '红润';
                } else if (_item3.skin_colour == '2') {
                  _item3.skin_colour = '黄染';
                }
                if (_item3.front_fontanelle == '1') {
                  _item3.front_fontanelle = '平坦';
                } else if (_item3.front_fontanelle == '2') {
                  _item3.front_fontanelle = '肿胀';
                } else if (_item3.front_fontanelle == '3') {
                  _item3.front_fontanelle = '凹陷';
                }
                _this5.formListDetailList.push(_item3);
              }
            } catch (err) {
              _didIteratorError13 = true;
              _iteratorError13 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion13 && _iterator13.return) {
                  _iterator13.return();
                }
              } finally {
                if (_didIteratorError13) {
                  throw _iteratorError13;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this5.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this5.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this5.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this5.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this5.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求婴儿护理记录单（2）所有列表
    apiBabyRecordTwo: function apiBabyRecordTwo(str, handle) {
      var _this6 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getBabyNursTwoDataList(params).then(function (res) {
        console.info('请求婴儿护理记录单（2）', res);
        if (res.data) {
          var shift_value = _this6.$route.query.shifts_value;
          _this6.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
              for (var _iterator15 = get_iterator_default()(res.data.shifts_count_list), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                var item = _step15.value;

                _this6.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this6.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError15 = true;
              _iteratorError15 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion15 && _iterator15.return) {
                  _iterator15.return();
                }
              } finally {
                if (_didIteratorError15) {
                  throw _iteratorError15;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this6.formListDetailListPage);
          _this6.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion16 = true;
            var _didIteratorError16 = false;
            var _iteratorError16 = undefined;

            try {
              for (var _iterator16 = get_iterator_default()(res.data.list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                var val = _step16.value;

                var cfrText = '';
                if (_this6.nurser_name.length) {
                  var _iteratorNormalCompletion17 = true;
                  var _didIteratorError17 = false;
                  var _iteratorError17 = undefined;

                  try {
                    for (var _iterator17 = get_iterator_default()(_this6.nurser_name), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                      var _item4 = _step17.value;

                      if (val.check_id == _item4.id) {
                        cfrText = _item4.user_name;
                      }
                    }
                  } catch (err) {
                    _didIteratorError17 = true;
                    _iteratorError17 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion17 && _iterator17.return) {
                        _iterator17.return();
                      }
                    } finally {
                      if (_didIteratorError17) {
                        throw _iteratorError17;
                      }
                    }
                  }
                }
                val.cfrText = cfrText;
                var skinArr = [];
                if (val.skin.length) {
                  var _iteratorNormalCompletion18 = true;
                  var _didIteratorError18 = false;
                  var _iteratorError18 = undefined;

                  try {
                    for (var _iterator18 = get_iterator_default()(val.skin), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                      var _item5 = _step18.value;

                      if (_item5 == '1') {
                        skinArr.push('正常');
                      } else if (_item5 == '2') {
                        skinArr.push('黄疸');
                      } else if (_item5 == '3') {
                        skinArr.push('糜烂');
                      } else if (_item5 == '4') {
                        skinArr.push('脓疱疹');
                      } else if (_item5 == '5') {
                        skinArr.push('湿疹');
                      } else if (_item5 == '6') {
                        skinArr.push('尿布疹');
                      }
                    }
                  } catch (err) {
                    _didIteratorError18 = true;
                    _iteratorError18 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion18 && _iterator18.return) {
                        _iterator18.return();
                      }
                    } finally {
                      if (_didIteratorError18) {
                        throw _iteratorError18;
                      }
                    }
                  }

                  val.skin = skinArr.join(',');
                }
                if (val.eye == '1') {
                  val.eye = '正常';
                } else if (val.eye == '2') {
                  val.eye = '分泌物';
                }

                if (val.oral == '1') {
                  val.oral = '光滑';
                } else if (val.oral == '2') {
                  val.oral = '破溃';
                } else if (val.oral == '3') {
                  val.oral = '鹅口疮';
                }

                if (val.umbilical == '1') {
                  val.umbilical = '干燥';
                } else if (val.umbilical == '2') {
                  val.umbilical = '出血';
                } else if (val.umbilical == '3') {
                  val.umbilical = '脱落';
                } else if (val.umbilical == '4') {
                  val.umbilical = '分泌物';
                }

                if (val.tension_of_limbs == '1') {
                  val.tension_of_limbs = '良好';
                } else if (val.tension_of_limbs == '2') {
                  val.tension_of_limbs = '受限';
                }

                if (val.nerve_reflex == '1') {
                  val.nerve_reflex = '正常';
                } else if (val.nerve_reflex == '2') {
                  val.nerve_reflex = '迟钝';
                }
                _this6.formListDetailList.push(val);
              }
            } catch (err) {
              _didIteratorError16 = true;
              _iteratorError16 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion16 && _iterator16.return) {
                  _iterator16.return();
                }
              } finally {
                if (_didIteratorError16) {
                  throw _iteratorError16;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this6.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this6.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this6.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this6.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this6.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this6.$vux.loading.hide();
          _this6.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this6.$vux.loading.hide();
          _this6.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求婴儿喂养记录单所有列表
    apiGetBabyFeedingRecordList: function apiGetBabyFeedingRecordList(str, handle) {
      var _this7 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getBabyFeedingRecordList(params).then(function (res) {
        console.info('请求婴儿喂养记录单', res);
        if (res.data) {
          var shift_value = _this7.$route.query.shifts_value;
          _this7.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion19 = true;
            var _didIteratorError19 = false;
            var _iteratorError19 = undefined;

            try {
              for (var _iterator19 = get_iterator_default()(res.data.shifts_count_list), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                var item = _step19.value;

                _this7.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this7.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError19 = true;
              _iteratorError19 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion19 && _iterator19.return) {
                  _iterator19.return();
                }
              } finally {
                if (_didIteratorError19) {
                  throw _iteratorError19;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this7.formListDetailListPage);
          _this7.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion20 = true;
            var _didIteratorError20 = false;
            var _iteratorError20 = undefined;

            try {
              for (var _iterator20 = get_iterator_default()(res.data.list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
                var _item6 = _step20.value;

                _this7.formListDetailList.push(_item6);
              }
            } catch (err) {
              _didIteratorError20 = true;
              _iteratorError20 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion20 && _iterator20.return) {
                  _iterator20.return();
                }
              } finally {
                if (_didIteratorError20) {
                  throw _iteratorError20;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this7.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this7.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this7.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this7.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this7.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this7.$vux.loading.hide();
          _this7.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this7.$vux.loading.hide();
          _this7.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求产妇膳食记录表所有列表
    apiGetMaternalMealRecordsList: function apiGetMaternalMealRecordsList(str, handle) {
      var _this8 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getMaternalMealRecordsList(params).then(function (res) {
        console.info(res);
        if (res.data) {
          var shift_value = _this8.$route.query.shifts_value;
          _this8.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion21 = true;
            var _didIteratorError21 = false;
            var _iteratorError21 = undefined;

            try {
              for (var _iterator21 = get_iterator_default()(res.data.shifts_count_list), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                var item = _step21.value;

                _this8.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this8.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError21 = true;
              _iteratorError21 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion21 && _iterator21.return) {
                  _iterator21.return();
                }
              } finally {
                if (_didIteratorError21) {
                  throw _iteratorError21;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this8.formListDetailListPage);
          _this8.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion22 = true;
            var _didIteratorError22 = false;
            var _iteratorError22 = undefined;

            try {
              for (var _iterator22 = get_iterator_default()(res.data.list), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                var _item7 = _step22.value;

                _this8.formListDetailList.push(_item7);
              }
            } catch (err) {
              _didIteratorError22 = true;
              _iteratorError22 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion22 && _iterator22.return) {
                  _iterator22.return();
                }
              } finally {
                if (_didIteratorError22) {
                  throw _iteratorError22;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this8.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this8.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this8.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this8.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this8.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this8.$vux.loading.hide();
          _this8.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this8.$vux.loading.hide();
          _this8.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求产妇康复护理评估记录表所有列表
    apiGetMaterRehNursEvalList: function apiGetMaterRehNursEvalList(str, handle) {
      var _this9 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getMaterRehNursEvalList(params).then(function (res) {
        console.info('请求产妇康复护理评估记录表', res);
        if (res.data) {
          var shift_value = _this9.$route.query.shifts_value;
          _this9.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
              for (var _iterator23 = get_iterator_default()(res.data.shifts_count_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                var item = _step23.value;

                _this9.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this9.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError23 = true;
              _iteratorError23 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion23 && _iterator23.return) {
                  _iterator23.return();
                }
              } finally {
                if (_didIteratorError23) {
                  throw _iteratorError23;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this9.formListDetailListPage);
          _this9.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion24 = true;
            var _didIteratorError24 = false;
            var _iteratorError24 = undefined;

            try {
              for (var _iterator24 = get_iterator_default()(res.data.list), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                var val = _step24.value;

                var cfrText = '';
                if (_this9.nurser_name.length) {
                  var _iteratorNormalCompletion25 = true;
                  var _didIteratorError25 = false;
                  var _iteratorError25 = undefined;

                  try {
                    for (var _iterator25 = get_iterator_default()(_this9.nurser_name), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                      var _item8 = _step25.value;

                      if (val.check_id == _item8.id) {
                        cfrText = _item8.user_name;
                      }
                    }
                  } catch (err) {
                    _didIteratorError25 = true;
                    _iteratorError25 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion25 && _iterator25.return) {
                        _iterator25.return();
                      }
                    } finally {
                      if (_didIteratorError25) {
                        throw _iteratorError25;
                      }
                    }
                  }
                }
                val.cfrText = cfrText;
                _this9.formListDetailList.push(val);
              }
            } catch (err) {
              _didIteratorError24 = true;
              _iteratorError24 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion24 && _iterator24.return) {
                  _iterator24.return();
                }
              } finally {
                if (_didIteratorError24) {
                  throw _iteratorError24;
                }
              }
            }
          }

          if (str == 'refresh') {
            _this9.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this9.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this9.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this9.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this9.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this9.$vux.loading.hide();
          _this9.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this9.$vux.loading.hide();
          _this9.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求产妇每日生理护理记录所有列表
    apiGetMaternalEverydayPhysiologyList: function apiGetMaternalEverydayPhysiologyList(str, handle) {
      var _this10 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getMaternalEverydayPhysiologyList(params).then(function (res) {
        console.info('请求产妇每日生理护理记录', res);
        if (res.data) {
          var shift_value = _this10.$route.query.shifts_value;
          _this10.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion26 = true;
            var _didIteratorError26 = false;
            var _iteratorError26 = undefined;

            try {
              for (var _iterator26 = get_iterator_default()(res.data.shifts_count_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
                var item = _step26.value;

                _this10.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this10.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError26 = true;
              _iteratorError26 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion26 && _iterator26.return) {
                  _iterator26.return();
                }
              } finally {
                if (_didIteratorError26) {
                  throw _iteratorError26;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this10.formListDetailListPage);
          _this10.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion27 = true;
            var _didIteratorError27 = false;
            var _iteratorError27 = undefined;

            try {
              for (var _iterator27 = get_iterator_default()(res.data.list), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                var _item9 = _step27.value;

                if (_item9.diet == '1') {
                  _item9.diet = '普通';
                } else if (_item9.diet == '2') {
                  _item9.diet = '特殊';
                }
                if (_item9.sport == '1') {
                  _item9.sport = '舒适';
                } else if (_item9.sport == '2') {
                  _item9.sport = '较累';
                }
                if (_item9.sport_text == '') {
                  _item9.sport = _item9.sport;
                } else {
                  _item9.sport = _item9.sport + '：' + _item9.sport_text;
                }
                _item9.sport = _item9.sport + _item9.sport_text;
                _this10.formListDetailList.push(_item9);
              }
            } catch (err) {
              _didIteratorError27 = true;
              _iteratorError27 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion27 && _iterator27.return) {
                  _iterator27.return();
                }
              } finally {
                if (_didIteratorError27) {
                  throw _iteratorError27;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this10.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this10.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this10.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this10.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this10.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this10.$vux.loading.hide();
          _this10.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this10.$vux.loading.hide();
          _this10.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求产妇健康咨询记录表
    apiGetMatarnalHeathRecordList: function apiGetMatarnalHeathRecordList(str, handle) {
      var _this11 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value.substring(0, 2) == '早班' ? '1' : this.shift_value.substring(0, 2) == '中班' ? '2' : this.shift_value.substring(0, 2) == '晚班' ? '3' : '',
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.chritmasFormApi.matarnalHeathRecordList(params).then(function (res) {
        console.info('请求产妇健康咨询记录表', res);
        if (res.data) {
          var shift_value = _this11.$route.query.shifts_value;
          _this11.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion28 = true;
            var _didIteratorError28 = false;
            var _iteratorError28 = undefined;

            try {
              for (var _iterator28 = get_iterator_default()(res.data.shifts_count_list), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                var item = _step28.value;

                _this11.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this11.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError28 = true;
              _iteratorError28 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion28 && _iterator28.return) {
                  _iterator28.return();
                }
              } finally {
                if (_didIteratorError28) {
                  throw _iteratorError28;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this11.formListDetailListPage);
          _this11.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion29 = true;
            var _didIteratorError29 = false;
            var _iteratorError29 = undefined;

            try {
              for (var _iterator29 = get_iterator_default()(res.data.list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
                var _item10 = _step29.value;

                var cfrText = '';
                var _iteratorNormalCompletion30 = true;
                var _didIteratorError30 = false;
                var _iteratorError30 = undefined;

                try {
                  for (var _iterator30 = get_iterator_default()(_this11.nurser_name), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                    var val = _step30.value;

                    if (val.id == _item10.agent_id) {
                      cfrText = val.user_name;
                    }
                  }
                } catch (err) {
                  _didIteratorError30 = true;
                  _iteratorError30 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion30 && _iterator30.return) {
                      _iterator30.return();
                    }
                  } finally {
                    if (_didIteratorError30) {
                      throw _iteratorError30;
                    }
                  }
                }

                var obj = {
                  delivery_type: _item10.delivery_type,
                  advisory_date: _item10.advisory_date == '0000-00-00' ? '' : _item10.advisory_date,
                  agent_id: cfrText,
                  agent_sign: _item10.agent_sign,
                  breast: _item10.breast == '1' ? '左硬结' : _item10.breast == '2' ? '右硬结' : _item10.breast == '3' ? '无异常' : _item10.breast == '4' ? '正常' : _item10.breast == '5' ? '双侧硬结' : '',
                  chapped_nipple: _item10.chapped_nipple == '1' ? '有' : _item10.chapped_nipple == '2' ? '无' : '',
                  healing: _item10.healing == '1' ? '良好' : _item10.healing == '2' ? '不良' : '',
                  id: _item10.id,
                  lochia_amount: _item10.lochia_amount,
                  lochia_color: _item10.lochia_color == '1' ? '暗红' : _item10.lochia_color == '2' ? '鲜红' : _item10.lochia_color == '3' ? '白色' : _item10.lochia_color == '4' ? '正常' : '',
                  lochia_taste: _item10.lochia_taste == '1' ? '有' : _item10.lochia_taste == '2' ? '无' : '',
                  milk_amount: _item10.milk_amount == '1' ? '多' : _item10.milk_amount == '2' ? '中' : _item10.milk_amount == '3' ? '少' : '回奶',
                  pee: _item10.pee == '1' ? '有' : _item10.pee == '2' ? '无' : '',
                  postpartum_days: _item10.postpartum_days == '0' ? '' : _item10.postpartum_days,
                  shifts: _item10.shifts == '1' ? '早班' : _item10.shifts == '2' ? '中班' : _item10.shifts == '3' ? '晚班' : '',
                  special_case: _item10.special_case,
                  stool: _item10.stool == '1' ? '正常' : _item10.stool == '2' ? '异常' : '',
                  //    uterus_place:item.uterus_place == "1" ? "脐上指" : item.uterus_place == "2" ? "脐下指" : item.uterus_place == "3" ? "完全入盘" : item.uterus_place == "4" ? "完全入盘" : '',
                  uterus_place: _item10.uterus_place
                };
                _this11.formListDetailList.push(obj);
              }
            } catch (err) {
              _didIteratorError29 = true;
              _iteratorError29 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion29 && _iterator29.return) {
                  _iterator29.return();
                }
              } finally {
                if (_didIteratorError29) {
                  throw _iteratorError29;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this11.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this11.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this11.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this11.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this11.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this11.$vux.loading.hide();
          _this11.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this11.$vux.loading.hide();
          _this11.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求(新生儿)健康咨询记录表列表
    apiGetBabyHeathRecordList: function apiGetBabyHeathRecordList(str, handle) {
      var _this12 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        baby_id: this.get_baby_id,
        shifts: this.shift_value.substring(0, 2) == '早班' ? '1' : this.shift_value.substring(0, 2) == '中班' ? '2' : this.shift_value.substring(0, 2) == '晚班' ? '3' : '',
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.chritmasFormApi.BabyHeathRecord(params).then(function (res) {
        console.info('请求(新生儿)健康咨询记录表列表', res);
        if (res.data) {
          var shift_value = _this12.$route.query.shifts_value;
          _this12.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion31 = true;
            var _didIteratorError31 = false;
            var _iteratorError31 = undefined;

            try {
              for (var _iterator31 = get_iterator_default()(res.data.shifts_count_list), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                var item = _step31.value;

                _this12.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this12.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError31 = true;
              _iteratorError31 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion31 && _iterator31.return) {
                  _iterator31.return();
                }
              } finally {
                if (_didIteratorError31) {
                  throw _iteratorError31;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this12.formListDetailListPage);
          _this12.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion32 = true;
            var _didIteratorError32 = false;
            var _iteratorError32 = undefined;

            try {
              for (var _iterator32 = get_iterator_default()(res.data.list), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
                var _item11 = _step32.value;
                var _iteratorNormalCompletion33 = true;
                var _didIteratorError33 = false;
                var _iteratorError33 = undefined;

                try {
                  for (var _iterator33 = get_iterator_default()(_this12.nurser_name), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
                    var val = _step33.value;

                    if (val.id == _item11.agent_id) {
                      _item11.agent_id = val.user_name;
                    }
                  }
                } catch (err) {
                  _didIteratorError33 = true;
                  _iteratorError33 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion33 && _iterator33.return) {
                      _iterator33.return();
                    }
                  } finally {
                    if (_didIteratorError33) {
                      throw _iteratorError33;
                    }
                  }
                }

                if (_item11.shifts == '1') {
                  _item11.shifts = '早班';
                } else if (_item11.shifts == '2') {
                  _item11.shifts = '中班';
                } else if (_item11.shifts == '3') {
                  _item11.shifts = '晚班';
                }
                var _iteratorNormalCompletion34 = true;
                var _didIteratorError34 = false;
                var _iteratorError34 = undefined;

                try {
                  for (var _iterator34 = get_iterator_default()(_this12.baby_list), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
                    var child = _step34.value;

                    if (_item11.baby_id == child.id) {
                      _item11.liveData = _this12.formatDateTime(child.live_time);
                      _item11.baby_name = child.name;
                    }
                  }
                } catch (err) {
                  _didIteratorError34 = true;
                  _iteratorError34 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion34 && _iterator34.return) {
                      _iterator34.return();
                    }
                  } finally {
                    if (_didIteratorError34) {
                      throw _iteratorError34;
                    }
                  }
                }

                if (_item11.advisory_date == '0000-00-00') {
                  _item11.advisory_date = '';
                }
                if (_item11.birth_day == '0') {
                  _item11.birth_day = '';
                }
                if (_item11.jaundice == '0') {
                  _item11.jaundice = '';
                }
                if (_item11.shifts == '0') {
                  _item11.shifts = '';
                }
                // if(item.deal == '1'){
                //     item.deal = '加强脐带部护理'
                // }else if(item.deal == '2'){
                //     item.deal = '加强母乳喂养'
                // }
                _this12.formListDetailList.push(_item11);
              }
            } catch (err) {
              _didIteratorError32 = true;
              _iteratorError32 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion32 && _iterator32.return) {
                  _iterator32.return();
                }
              } finally {
                if (_didIteratorError32) {
                  throw _iteratorError32;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this12.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this12.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this12.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this12.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this12.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this12.$vux.loading.hide();
          _this12.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this12.$vux.loading.hide();
          _this12.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求产妇特殊护理记录表
    apiGetMatarnalSpecialNursingRecordList: function apiGetMatarnalSpecialNursingRecordList(str, handle) {
      var _this13 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value.substring(0, 2) == '早班' ? '1' : this.shift_value.substring(0, 2) == '中班' ? '2' : this.shift_value.substring(0, 2) == '晚班' ? '3' : '',
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.chritmasFormApi.MatarnalSpecialNursingRecord(params).then(function (res) {
        console.info('请求产妇特殊护理记录表', res);
        if (res.data) {
          var shift_value = _this13.$route.query.shifts_value;
          _this13.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion35 = true;
            var _didIteratorError35 = false;
            var _iteratorError35 = undefined;

            try {
              for (var _iterator35 = get_iterator_default()(res.data.shifts_count_list), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
                var item = _step35.value;

                _this13.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this13.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError35 = true;
              _iteratorError35 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion35 && _iterator35.return) {
                  _iterator35.return();
                }
              } finally {
                if (_didIteratorError35) {
                  throw _iteratorError35;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this13.formListDetailListPage);
          _this13.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion36 = true;
            var _didIteratorError36 = false;
            var _iteratorError36 = undefined;

            try {
              for (var _iterator36 = get_iterator_default()(res.data.list), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
                var _item12 = _step36.value;
                var _iteratorNormalCompletion37 = true;
                var _didIteratorError37 = false;
                var _iteratorError37 = undefined;

                try {
                  for (var _iterator37 = get_iterator_default()(_this13.nurser_name), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
                    var val = _step37.value;

                    if (val.id == _item12.agent_id) {
                      _item12.agent_id = val.user_name;
                    }
                  }
                } catch (err) {
                  _didIteratorError37 = true;
                  _iteratorError37 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion37 && _iterator37.return) {
                      _iterator37.return();
                    }
                  } finally {
                    if (_didIteratorError37) {
                      throw _iteratorError37;
                    }
                  }
                }

                if (_item12.shifts == '1') {
                  _item12.shifts = '早班';
                } else if (_item12.shifts == '2') {
                  _item12.shifts = '中班';
                } else if (_item12.shifts == '3') {
                  _item12.shifts = '晚班';
                }
                if (_item12.record_date == '0000-00-00') {
                  _item12.record_date = '';
                }
                if (_item12.shifts == '0') {
                  _item12.shifts = '';
                }
                _this13.formListDetailList.push(_item12);
              }
            } catch (err) {
              _didIteratorError36 = true;
              _iteratorError36 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion36 && _iterator36.return) {
                  _iterator36.return();
                }
              } finally {
                if (_didIteratorError36) {
                  throw _iteratorError36;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this13.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this13.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this13.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this13.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this13.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this13.$vux.loading.hide();
          _this13.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this13.$vux.loading.hide();
          _this13.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求婴儿特殊护理记录表
    apiGetbabySpecialNursingRecordList: function apiGetbabySpecialNursingRecordList(str, handle) {
      var _this14 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        baby_id: this.get_baby_id,
        shifts: this.shift_value.substring(0, 2) == '早班' ? '1' : this.shift_value.substring(0, 2) == '中班' ? '2' : this.shift_value.substring(0, 2) == '晚班' ? '3' : '',
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.chritmasFormApi.babySpecialNursingRecord(params).then(function (res) {
        console.info('请求婴儿特殊护理记录表', res);
        if (res.data) {
          var shift_value = _this14.$route.query.shifts_value;
          _this14.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion38 = true;
            var _didIteratorError38 = false;
            var _iteratorError38 = undefined;

            try {
              for (var _iterator38 = get_iterator_default()(res.data.shifts_count_list), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
                var item = _step38.value;

                _this14.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this14.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError38 = true;
              _iteratorError38 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion38 && _iterator38.return) {
                  _iterator38.return();
                }
              } finally {
                if (_didIteratorError38) {
                  throw _iteratorError38;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this14.formListDetailListPage);
          _this14.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion39 = true;
            var _didIteratorError39 = false;
            var _iteratorError39 = undefined;

            try {
              for (var _iterator39 = get_iterator_default()(res.data.list), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
                var _item13 = _step39.value;
                var _iteratorNormalCompletion40 = true;
                var _didIteratorError40 = false;
                var _iteratorError40 = undefined;

                try {
                  for (var _iterator40 = get_iterator_default()(_this14.nurser_name), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
                    var val = _step40.value;

                    if (val.id == _item13.agent_id) {
                      _item13.agent_id = val.user_name;
                    }
                  }
                } catch (err) {
                  _didIteratorError40 = true;
                  _iteratorError40 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion40 && _iterator40.return) {
                      _iterator40.return();
                    }
                  } finally {
                    if (_didIteratorError40) {
                      throw _iteratorError40;
                    }
                  }
                }

                if (_item13.shifts == '1') {
                  _item13.shifts = '早班';
                } else if (_item13.shifts == '2') {
                  _item13.shifts = '中班';
                } else if (_item13.shifts == '3') {
                  _item13.shifts = '晚班';
                }
                var _iteratorNormalCompletion41 = true;
                var _didIteratorError41 = false;
                var _iteratorError41 = undefined;

                try {
                  for (var _iterator41 = get_iterator_default()(_this14.baby_list), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
                    var child = _step41.value;

                    if (_item13.baby_id == child.id) {
                      _item13.sex = child.sex == '1' ? '男' : '女';
                      _item13.baby_name = child.name;
                    }
                  }
                } catch (err) {
                  _didIteratorError41 = true;
                  _iteratorError41 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion41 && _iterator41.return) {
                      _iterator41.return();
                    }
                  } finally {
                    if (_didIteratorError41) {
                      throw _iteratorError41;
                    }
                  }
                }

                if (_item13.record_date == '0000-00-00') {
                  _item13.record_date = '';
                }
                if (_item13.postpartum_days == '0') {
                  _item13.postpartum_days = '';
                }
                if (_item13.breast == '0') {
                  _item13.breast = '';
                }
                if (_item13.shifts == '0') {
                  _item13.shifts = '';
                }
                _this14.formListDetailList.push(_item13);
              }
            } catch (err) {
              _didIteratorError39 = true;
              _iteratorError39 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion39 && _iterator39.return) {
                  _iterator39.return();
                }
              } finally {
                if (_didIteratorError39) {
                  throw _iteratorError39;
                }
              }
            }
          }
          if (str == 'refresh') {
            console.info('启用上拉加载插件');
            _this14.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this14.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this14.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this14.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this14.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this14.$vux.loading.hide();
          _this14.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this14.$vux.loading.hide();
          _this14.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求喂药委托书
    apiGetFeedDrugEntrustUrlListList: function apiGetFeedDrugEntrustUrlListList(str, handle) {
      var _this15 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.checkRoomApi.getFeedDrugEntrustUrlList(params).then(function (res) {
        console.info('请求喂药委托书', res);
        if (res.data) {
          var shift_value = _this15.$route.query.shifts_value;
          _this15.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion42 = true;
            var _didIteratorError42 = false;
            var _iteratorError42 = undefined;

            try {
              for (var _iterator42 = get_iterator_default()(res.data.shifts_count_list), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
                var item = _step42.value;

                _this15.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this15.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError42 = true;
              _iteratorError42 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion42 && _iterator42.return) {
                  _iterator42.return();
                }
              } finally {
                if (_didIteratorError42) {
                  throw _iteratorError42;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this15.formListDetailListPage);
          _this15.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion43 = true;
            var _didIteratorError43 = false;
            var _iteratorError43 = undefined;

            try {
              for (var _iterator43 = get_iterator_default()(res.data.list), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
                var _item14 = _step43.value;

                _this15.formListDetailList.push(_item14);
              }
            } catch (err) {
              _didIteratorError43 = true;
              _iteratorError43 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion43 && _iterator43.return) {
                  _iterator43.return();
                }
              } finally {
                if (_didIteratorError43) {
                  throw _iteratorError43;
                }
              }
            }
          }
          if (str == 'refresh') {
            console.info('启用上拉加载插件');
            _this15.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this15.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this15.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this15.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this15.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this15.$vux.loading.hide();
          _this15.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this15.$vux.loading.hide();
          _this15.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求月子基本护理常识
    apiGetConfinementSenseListUrlList: function apiGetConfinementSenseListUrlList(str, handle) {
      var _this16 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.checkRoomApi.getConfinementSenseListUrlList(params).then(function (res) {
        console.info('请求月子基本护理常识', res);
        if (res.data) {
          var shift_value = _this16.$route.query.shifts_value;
          _this16.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion44 = true;
            var _didIteratorError44 = false;
            var _iteratorError44 = undefined;

            try {
              for (var _iterator44 = get_iterator_default()(res.data.shifts_count_list), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
                var item = _step44.value;

                _this16.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this16.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError44 = true;
              _iteratorError44 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion44 && _iterator44.return) {
                  _iterator44.return();
                }
              } finally {
                if (_didIteratorError44) {
                  throw _iteratorError44;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this16.formListDetailListPage);
          _this16.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion45 = true;
            var _didIteratorError45 = false;
            var _iteratorError45 = undefined;

            try {
              for (var _iterator45 = get_iterator_default()(res.data.list), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
                var _item15 = _step45.value;

                _this16.formListDetailList.push(_item15);
              }
            } catch (err) {
              _didIteratorError45 = true;
              _iteratorError45 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion45 && _iterator45.return) {
                  _iterator45.return();
                }
              } finally {
                if (_didIteratorError45) {
                  throw _iteratorError45;
                }
              }
            }
          }
          if (str == 'refresh') {
            console.info('启用上拉加载插件');
            _this16.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this16.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this16.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this16.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this16.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this16.$vux.loading.hide();
          _this16.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this16.$vux.loading.hide();
          _this16.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //新增表单点击详情进入详情页
    editFormDetailList: function editFormDetailList(id) {
      var form_id = parseInt(this.form_id);
      var query = {
        id: this.$route.query.id,
        form_id: this.form_id,
        list_id: id,
        tabVal: this.$route.query.tabVal
      };
      switch (form_id) {
        case 1001:
          this.$router.push({
            path: './bb_form_f',
            query: query
          });
          break;
        case 1002:
          this.$router.push({
            path: './bb_form_b',
            query: query
          });
          break;
        case 1003:
          this.$router.push({
            path: './bb_form_c',
            query: query
          });
          break;
        case 1004:
          this.$router.push({
            path: './bb_form_a',
            query: query
          });
          break;
        case 1005:
          this.$router.push({
            path: './maternal_form_d',
            query: query
          });
          break;
        case 1006:
          this.$router.push({
            path: './maternal_form_b',
            query: query
          });
          break;
        case 1007:
          this.$router.push({
            path: './maternal_form_c',
            query: query
          });
          break;
        case 1008:
          this.$router.push({
            path: './christmas_form_one',
            query: query
          });
          break;
        case 1009:
          this.$router.push({
            path: './christmas_form_two',
            query: query
          });
          break;
        case 1010:
          this.$router.push({
            path: './christmas_form_three',
            query: query
          });
          break;
        case 1011:
          this.$router.push({
            path: './christmas_form_four',
            query: query
          });
          break;
        case 1012:
          this.$router.push({
            path: './medicine_commissioned',
            query: query
          });
          break;
        case 1013:
          this.$router.push({
            path: './basic_nursing',
            query: query
          });
          break;
      }
    },

    //根据表单ID执行不同方法
    forFormIDUseMethod: function forFormIDUseMethod(handle) {
      console.info('根据表单ID执行不同方法');
      var form_id = parseInt(this.form_id);
      if (form_id === 1001 || form_id === 1002 || form_id === 1003 || form_id === 1004 || form_id === 1009 || form_id === 1011) {
        this.babySelectShow = true;
      }
      if (handle == 'tab') {
        console.log('如果是点击tab');
        // 如果是点击tab
        this.formListDetailList = [];
        this.formListDetailListPage = 1;
        this.start_date = '';
        this.end_date = '';
        this.shift_value = '';
        this.get_baby_id = '';
      }
      // let s_arr =  ['早班','中班','晚班']
      // this.shift_arr = s_arr
      switch (form_id) {
        case 1001:
          this.showFormList = false;
          this.apiBabyCare('refresh', handle);
          break;
        case 1002:
          this.showFormList = false;
          this.apiBabyRecord('refresh', handle);

          break;
        case 1003:
          this.showFormList = false;
          this.apiBabyRecordTwo('refresh', handle);
          break;
        case 1004:
          this.showFormList = false;
          this.apiGetBabyFeedingRecordList('refresh', handle);
          break;
        case 1005:
          this.showFormList = false;
          this.apiGetMaternalEverydayPhysiologyList('refresh', handle);
          break;
        case 1006:
          this.showFormList = false;
          this.apiGetMaternalMealRecordsList('refresh', handle);
          break;
        case 1007:
          this.showFormList = false;
          this.apiGetMaterRehNursEvalList('refresh', handle);
          break;
        case 1008:
          this.showFormList = false;
          this.apiGetCfrList('christmas_form_one', handle);
          break;
        case 1009:
          this.showFormList = false;
          this.apiGetCfrList('christmas_form_two', handle);
          break;
        case 1010:
          this.showFormList = false;
          this.apiGetCfrList('christmas_form_three', handle);
          break;
        case 1011:
          this.showFormList = false;
          this.apiGetCfrList('christmas_form_four', handle);
          break;
        case 1012:
          this.showFormList = false;
          this.apiGetFeedDrugEntrustUrlListList('refresh', handle);
          break;
        case 1013:
          this.showFormList = false;
          this.apiGetConfinementSenseListUrlList('refresh', handle);
          break;
        case 1014:
          this.$router.push({
            path: '/new_check_room_record',
            query: {
              id: this.$route.query.id,
              tabVal: this.$route.query.tabVal
            }
          });
          break;
        default:
          //自定义表单内容
          this.showFormList = true;
          this.getAnswerList(); //个人信息获取的答案
          this.refresh();
      }
    },

    //获取查房人列表
    apiGetCfrList: function apiGetCfrList(name) {
      var _this17 = this;

      var params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id')
      };
      Api.checkRoomApi.getCheckInfo(params).then(function (res) {
        console.info('获取查房人列表');
        console.info(res);
        if (res.errcode == 1) {
          _this17.nurser_name = res.data.nurser_name; //过滤了离院，
          //
          if (name == 'christmas_form_one') {
            _this17.apiGetMatarnalHeathRecordList('refresh');
          } else if (name == 'christmas_form_two') {
            _this17.apiGetBabyHeathRecordList('refresh');
          } else if (name == 'christmas_form_three') {
            _this17.apiGetMatarnalSpecialNursingRecordList('refresh');
          } else if (name == 'christmas_form_four') {
            _this17.apiGetbabySpecialNursingRecordList('refresh');
          }
        } else {
          _this17.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //获取宝宝数量
    get_baby_list: function get_baby_list() {
      var _this18 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.monthLiveApi.babyList(params).then(function (res) {
        console.info('获取宝宝数量');
        console.info(res);
        if (res.errcode == 1) {
          _this18.baby_list = res.data;
          _this18.$vux.loading.hide();
        } else {
          _this18.$vux.loading.hide();
          _this18.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    }
  },
  created: function created() {
    var start_date = this.$route.query.start_date;
    console.log(start_date);
    if (start_date) {
      this.start_date = start_date;
    }
    var end_date = this.$route.query.end_date;
    if (end_date) {
      this.end_date = end_date;
    }
    this.get_baby_list();
    this.apiGetCfrList(); //获取查房人列表
    this.apiMemberInfo(); //基础信息
    this.apiFormList(); //表单列表
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/check_room_service.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var components_check_room_service_pulldownDefaultConfig = {
  content: '下拉刷新',
  height: 40,
  autoRefresh: false,
  downContent: '下拉刷新',
  upContent: '释放后刷新',
  loadingContent: '正在刷新...',
  clsPrefix: 'xs-plugin-pulldown-'
};
var components_check_room_service_pullupDefaultConfig = {
  content: '上拉加载更多',
  pullUpHeight: 60,
  height: 40,
  autoRefresh: false,
  downContent: '释放后加载',
  upContent: '上拉加载更多',
  loadingContent: '加载中...',
  clsPrefix: 'xs-plugin-pullup-'
};

/* harmony default export */ var components_check_room_service = ({
  name: 'check_room_service',
  data: function data() {
    return {
      get_host: host.host,
      tab_index: 0,
      babySelectShow: false, //宝宝筛选显示
      showFormList: true, //显示表单列表
      personalMemberInfo: [],
      form_list: [],
      data_list: [], //表单数组
      start_date: '', //开始日期
      end_date: '', //结束日期
      shift_value: '', //班次值
      shift_arr: [], //班次选项
      min_date: '', //最小日期限制
      memberInfo: {
        room_name: '',
        name: '',
        phone: '',
        package: '',
        liveDate: '',
        childBirth: '',
        birthType: '',
        babyType: [{
          label: '顺产',
          value: '1'
        }, {
          label: '剖宫产',
          value: '2'
        }, {
          label: '小产',
          value: '3'
        }, {
          label: '不知道',
          value: '0'
        }]
      },
      form_id: '',
      from_title: '',
      page: '1',
      host: api_const["host"],
      pullupDefaultConfig: components_check_room_service_pullupDefaultConfig,
      pulldownDefaultConfig: components_check_room_service_pulldownDefaultConfig,
      newForm: [{
        id: 1001,
        name: '婴儿护理操作记录表',
        style: true
      }, {
        id: 1002,
        name: '婴儿护理记录单(1)',
        style: true
      }, {
        id: 1003,
        name: '婴儿护理记录单(2)',
        style: true
      }, {
        id: 1004,
        name: '婴儿喂养记录单',
        style: true
      }, {
        id: 1005,
        name: '产妇每日生理护理记录表',
        style: true
      }, {
        id: 1006,
        name: '产妇膳食记录表',
        style: true
      }, {
        id: 1007,
        name: '产妇康复护理评估记录单',
        style: true
      }, {
        id: 1008,
        name: '产妇健康咨询记录表',
        style: true
      }, {
        id: 1009,
        name: '新生儿健康咨询记录表',
        style: true
      }, {
        id: 1010,
        name: '产妇特殊护理记录表',
        style: true
      }, {
        id: 1011,
        name: '婴儿特殊护理记录表',
        style: true
      }, {
        id: 1012,
        name: '喂药委托书(新)',
        style: true
      }, {
        id: 1013,
        name: '月子基本护理常识(新)',
        style: true
      }, {
        id: 1014,
        name: '查房记录(新)',
        style: true
      }],
      formListDetailList: [],
      formListDetailListPage: 1,
      nurser_name: [], //查房人列表
      baby_list: [], //宝宝列表
      get_baby_id: '',
      cfrText: ''
    };
  },

  methods: {
    //清除表单
    clearFrom: function clearFrom() {
      console.info('清除表单');
      this.forFormIDUseMethod('tab');
    },

    //添加记录
    addRecord: function addRecord() {
      var formId = parseInt(this.form_id);
      console.info(formId);
      var query = {
        id: this.$route.query.id,
        form_id: formId,
        tabVal: this.$route.query.tabVal
      };
      switch (formId) {
        case 1001:
          this.$router.push({
            path: '/bb_form_f',
            query: query
          });
          break;
        case 1002:
          this.$router.push({
            path: '/bb_form_b',
            query: query
          });
          break;
        case 1003:
          this.$router.push({
            path: '/bb_form_c',
            query: query
          });
          break;
        case 1004:
          this.$router.push({
            path: '/bb_form_a',
            query: query
          });
          break;
        case 1005:
          this.$router.push({
            path: '/maternal_form_d',
            query: query
          });
          break;
        case 1006:
          this.$router.push({
            path: '/maternal_form_b',
            query: query
          });
          break;
        case 1007:
          this.$router.push({
            path: '/maternal_form_c',
            query: query
          });
          break;
        case 1008:
          this.$router.push({
            path: '/christmas_form_one',
            query: query
          });
          break;
        case 1009:
          this.$router.push({
            path: '/christmas_form_two',
            query: query
          });
          break;
        case 1010:
          this.$router.push({
            path: '/christmas_form_three',
            query: query
          });
          break;
        case 1011:
          this.$router.push({
            path: '/christmas_form_four',
            query: query
          });
          break;
        case 1012:
          this.$router.push({
            path: '/medicine_commissioned',
            query: query
          });
          break;
        case 1013:
          this.$router.push({
            path: '/basic_nursing',
            query: query
          });
          break;
        case 1014:
          this.$router.push({
            path: '/new_check_room_record',
            query: query
          });
          break;
        default:
          this.$router.push({
            path: '/add_from_record',
            query: query
          });
      }
    },

    //时间戳转日期格式
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },

    //点击查房表
    tabItem: function tabItem(index) {
      this.form_id = this.form_list[index].id;
      this.from_title = this.form_list[index].name;
      if (this.form_list[index].id == '999') {
        this.$router.push({
          path: '/check_room_record',
          query: {
            id: this.$route.query.id,
            tabVal: this.$route.query.tabVal
          }
        });
        return;
      }
      this.forFormIDUseMethod('tab');
    },

    //选择开始日期
    start_date_congirm: function start_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.min_date = value;
      this.start_date = value;
      console.info('选择开始日期');
      this.forFormIDUseMethod();
    },

    //选择结束日期
    end_date_congirm: function end_date_congirm(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      this.end_date = value;
      console.info('选择结束日期');
      this.forFormIDUseMethod();
    },

    //选择班次
    plantPickerChange: function plantPickerChange(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      console.info('选择班次');
      this.forFormIDUseMethod();
    },

    //选择宝宝
    babyPickerChange: function babyPickerChange(value) {
      this.formListDetailListPage = 1;
      this.formListDetailList = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (value == item.name) {
            if (item.live_time == '0') {
              this.$vux.toast.show({
                type: 'cancel',
                text: item.name + '暂未入住'
              });
              return;
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.forFormIDUseMethod();
    },

    //获取表单查房列表
    apiFormList: function apiFormList() {
      var _this = this;

      var that = this;
      var params = {
        token: this.$cookie.get('token')
      };
      Api.checkRoomApi.roundFormList(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this.form_list = res.data;
          // this.form_list.push({
          //     id: '999',
          //     name: '查房记录'
          // })
          var arr = [].concat(toConsumableArray_default()(_this.newForm), toConsumableArray_default()(_this.form_list));
          _this.form_list = arr;
          var id_arr = [];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(_this.form_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              id_arr.push(parseInt(item.id));
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (_this.$route.query.form_id) {
            //查看详情赋值查房单ID
            _this.form_id = _this.$route.query.form_id;
            var get_form_index = id_arr.indexOf(parseInt(_this.$route.query.form_id));
            _this.tab_index = get_form_index;
            _this.from_title = _this.form_list[get_form_index].name;
          } else {
            //初始化赋值表查房单ID
            _this.form_id = _this.newForm[0].id;
            _this.from_title = _this.newForm[0].name;
          }
          _this.forFormIDUseMethod('login');
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求用户基本信息
    apiMemberInfo: function apiMemberInfo() {
      var _this2 = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.memberInfo(params).then(function (res) {
        console.info('请求用户基本信息', res);
        if (res.errcode == 1) {
          _this2.memberInfo.room_name = res.data.room_name;
          _this2.memberInfo.name = res.data.name;
          _this2.memberInfo.phone = res.data.phone;
          _this2.memberInfo.package = res.data.package_name;
          _this2.memberInfo.liveDate = _this2.formatDateTime(res.data.live_time);
          _this2.memberInfo.childBirth = _this2.formatDateTime(res.data.child_birth);
          var birthType = '';
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = get_iterator_default()(_this2.memberInfo.babyType), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var item = _step3.value;

              if (res.data.birth_type == item.value) {
                birthType = item.label;
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          _this2.memberInfo.birthType = birthType;
        } else {
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    dateFormat: function dateFormat(_date) {
      var date = new Date(_date);
      var time = Date.parse(date) / 1000;
      return time;
    },

    //获取自定义表单列表
    apiGroupList: function apiGroupList(str) {
      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.form_id,
        stime: this.start_date == '' ? '' : this.dateFormat(this.start_date + ' 00:00:00:000'),
        etime: this.end_date == '' ? '' : this.dateFormat(this.end_date + ' 23:59:59:999'),
        plans: this.shift_value,
        page: this.page,
        isWap: '1'
      };
      var that = this;
      console.info(params);
      Api.checkRoomApi.getGroupList(params).then(function (res) {
        console.info('自定义表单', res);
        if (res.errcode == 1) {
          that.page++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
              for (var _iterator4 = get_iterator_default()(res.data.list), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var item = _step4.value;

                that.data_list.push(item);
              }
            } catch (err) {
              _didIteratorError4 = true;
              _iteratorError4 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }
              } finally {
                if (_didIteratorError4) {
                  throw _iteratorError4;
                }
              }
            }

            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = get_iterator_default()(that.data_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var _item = _step5.value;
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                  for (var _iterator6 = get_iterator_default()(_item.form_data), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var item0 = _step6.value;
                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                      for (var _iterator7 = get_iterator_default()(item0.row_list), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                        var item1 = _step7.value;
                        var _iteratorNormalCompletion8 = true;
                        var _didIteratorError8 = false;
                        var _iteratorError8 = undefined;

                        try {
                          for (var _iterator8 = get_iterator_default()(item1.content), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                            var item2 = _step8.value;
                            var _iteratorNormalCompletion9 = true;
                            var _didIteratorError9 = false;
                            var _iteratorError9 = undefined;

                            try {
                              for (var _iterator9 = get_iterator_default()(that.personalMemberInfo), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                                var val = _step9.value;

                                if (item2.column_name == val.name) {
                                  item2.my_answer[0] = val.value;
                                }
                              }
                            } catch (err) {
                              _didIteratorError9 = true;
                              _iteratorError9 = err;
                            } finally {
                              try {
                                if (!_iteratorNormalCompletion9 && _iterator9.return) {
                                  _iterator9.return();
                                }
                              } finally {
                                if (_didIteratorError9) {
                                  throw _iteratorError9;
                                }
                              }
                            }
                          }
                        } catch (err) {
                          _didIteratorError8 = true;
                          _iteratorError8 = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion8 && _iterator8.return) {
                              _iterator8.return();
                            }
                          } finally {
                            if (_didIteratorError8) {
                              throw _iteratorError8;
                            }
                          }
                        }
                      }
                    } catch (err) {
                      _didIteratorError7 = true;
                      _iteratorError7 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion7 && _iterator7.return) {
                          _iterator7.return();
                        }
                      } finally {
                        if (_didIteratorError7) {
                          throw _iteratorError7;
                        }
                      }
                    }
                  }
                } catch (err) {
                  _didIteratorError6 = true;
                  _iteratorError6 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                      _iterator6.return();
                    }
                  } finally {
                    if (_didIteratorError6) {
                      throw _iteratorError6;
                    }
                  }
                }
              }
              // this.personalMemberInfo
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }

            that.shift_arr = res.data.plans_list;
            if (str == 'refresh') {
              that.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
              that.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
            }
            if (res.data.page.page == res.data.page.page_count) {
              that.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
            } else {
              that.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
            }
          } else {
            that.$vux.toast.show({
              type: 'cancel',
              text: '暂无更多数据'
            });
          }
          that.$vux.loading.hide();
        } else {
          that.$vux.loading.hide();
          that.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //编辑记录表
    editForm: function editForm(answer_id) {
      this.$router.push({
        path: './add_from_record',
        query: {
          id: this.$route.query.id,
          form_id: this.form_id,
          answer_id: answer_id,
          tabVal: this.$route.query.tabVal
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    },

    //自定义表单下拉刷新
    refresh: function refresh() {
      this.data_list = [];
      this.page = '1';
      this.apiGroupList('refresh');
    },

    //自定义表单上拉加载
    loadMore: function loadMore() {
      this.apiGroupList();
    },

    //固定表单下拉刷新
    refresh2: function refresh2() {
      this.formListDetailList = [];
      this.formListDetailListPage = 1;
      console.info('固定表单下拉刷新');
      this.forFormIDUseMethod();
    },

    //固定表单上拉加载
    loadMore2: function loadMore2() {
      console.info('固定表单上拉加载');
      this.forFormIDUseMethod();
    },

    //请求答案列表
    getAnswerList: function getAnswerList() {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.getColumnList(params).then(function (res) {
        console.log('请求答案列表', res);
        if (res.errcode == 1) {
          _this3.personalMemberInfo = res.data;
        } else {
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求婴儿护理操作记录表所有列表
    apiBabyCare: function apiBabyCare(str, handle) {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getBabyCareOperalist(params).then(function (res) {
        console.info('请求婴儿护理操作记录表', res);
        if (res.data) {
          var shift_value = _this4.$route.query.shifts_value;
          _this4.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
              for (var _iterator10 = get_iterator_default()(res.data.shifts_count_list), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                var item = _step10.value;

                _this4.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this4.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError10 = true;
              _iteratorError10 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                  _iterator10.return();
                }
              } finally {
                if (_didIteratorError10) {
                  throw _iteratorError10;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this4.formListDetailListPage);
          _this4.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion11 = true;
            var _didIteratorError11 = false;
            var _iteratorError11 = undefined;

            try {
              for (var _iterator11 = get_iterator_default()(res.data.list), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                var _item2 = _step11.value;

                _this4.formListDetailList.push(_item2);
              }
            } catch (err) {
              _didIteratorError11 = true;
              _iteratorError11 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion11 && _iterator11.return) {
                  _iterator11.return();
                }
              } finally {
                if (_didIteratorError11) {
                  throw _iteratorError11;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this4.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this4.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }

          if (res.data.page.page == res.data.page.page_count) {
            _this4.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this4.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this4.$vux.loading.hide();
          return;
        } else if (res.errcode == 400) {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求婴儿护理记录单（1）所有列表
    apiBabyRecord: function apiBabyRecord(str, handle) {
      var _this5 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getBabyNursOneDataList(params).then(function (res) {
        console.info('请求婴儿护理记录单（1）', res);
        if (res.data) {
          var shift_value = _this5.$route.query.shifts_value;
          _this5.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
              for (var _iterator12 = get_iterator_default()(res.data.shifts_count_list), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var item = _step12.value;

                _this5.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this5.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError12 = true;
              _iteratorError12 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                  _iterator12.return();
                }
              } finally {
                if (_didIteratorError12) {
                  throw _iteratorError12;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this5.formListDetailListPage);
          _this5.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
              for (var _iterator13 = get_iterator_default()(res.data.list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                var _item3 = _step13.value;

                var cfrText = '';
                if (_this5.nurser_name.length) {
                  var _iteratorNormalCompletion14 = true;
                  var _didIteratorError14 = false;
                  var _iteratorError14 = undefined;

                  try {
                    for (var _iterator14 = get_iterator_default()(_this5.nurser_name), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                      var val = _step14.value;

                      if (_item3.check_id == val.id) {
                        cfrText = val.user_name;
                      }
                    }
                  } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                      }
                    } finally {
                      if (_didIteratorError14) {
                        throw _iteratorError14;
                      }
                    }
                  }
                }
                _item3.cfrText = cfrText;

                if (_item3.front_case == 1) {
                  _item3.front_case = '平坦';
                } else if (_item3.front_case == 2) {
                  _item3.front_case = '肿胀';
                } else if (_item3.front_case == 3) {
                  _item3.front_case = '凹陷';
                } else {
                  _item3.front_case = '';
                }
                if (_item3.skin_colour == '1') {
                  _item3.skin_colour = '红润';
                } else if (_item3.skin_colour == '2') {
                  _item3.skin_colour = '黄染';
                }
                if (_item3.front_fontanelle == '1') {
                  _item3.front_fontanelle = '平坦';
                } else if (_item3.front_fontanelle == '2') {
                  _item3.front_fontanelle = '肿胀';
                } else if (_item3.front_fontanelle == '3') {
                  _item3.front_fontanelle = '凹陷';
                }
                _this5.formListDetailList.push(_item3);
              }
            } catch (err) {
              _didIteratorError13 = true;
              _iteratorError13 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion13 && _iterator13.return) {
                  _iterator13.return();
                }
              } finally {
                if (_didIteratorError13) {
                  throw _iteratorError13;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this5.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this5.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this5.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this5.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this5.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求婴儿护理记录单（2）所有列表
    apiBabyRecordTwo: function apiBabyRecordTwo(str, handle) {
      var _this6 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getBabyNursTwoDataList(params).then(function (res) {
        console.info('请求婴儿护理记录单（2）', res);
        if (res.data) {
          var shift_value = _this6.$route.query.shifts_value;
          _this6.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
              for (var _iterator15 = get_iterator_default()(res.data.shifts_count_list), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                var item = _step15.value;

                _this6.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this6.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError15 = true;
              _iteratorError15 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion15 && _iterator15.return) {
                  _iterator15.return();
                }
              } finally {
                if (_didIteratorError15) {
                  throw _iteratorError15;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this6.formListDetailListPage);
          _this6.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion16 = true;
            var _didIteratorError16 = false;
            var _iteratorError16 = undefined;

            try {
              for (var _iterator16 = get_iterator_default()(res.data.list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                var val = _step16.value;

                var cfrText = '';
                if (_this6.nurser_name.length) {
                  var _iteratorNormalCompletion17 = true;
                  var _didIteratorError17 = false;
                  var _iteratorError17 = undefined;

                  try {
                    for (var _iterator17 = get_iterator_default()(_this6.nurser_name), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
                      var _item4 = _step17.value;

                      if (val.check_id == _item4.id) {
                        cfrText = _item4.user_name;
                      }
                    }
                  } catch (err) {
                    _didIteratorError17 = true;
                    _iteratorError17 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion17 && _iterator17.return) {
                        _iterator17.return();
                      }
                    } finally {
                      if (_didIteratorError17) {
                        throw _iteratorError17;
                      }
                    }
                  }
                }
                val.cfrText = cfrText;
                var skinArr = [];
                if (val.skin.length) {
                  var _iteratorNormalCompletion18 = true;
                  var _didIteratorError18 = false;
                  var _iteratorError18 = undefined;

                  try {
                    for (var _iterator18 = get_iterator_default()(val.skin), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                      var _item5 = _step18.value;

                      if (_item5 == '1') {
                        skinArr.push('正常');
                      } else if (_item5 == '2') {
                        skinArr.push('黄疸');
                      } else if (_item5 == '3') {
                        skinArr.push('糜烂');
                      } else if (_item5 == '4') {
                        skinArr.push('脓疱疹');
                      } else if (_item5 == '5') {
                        skinArr.push('湿疹');
                      } else if (_item5 == '6') {
                        skinArr.push('尿布疹');
                      }
                    }
                  } catch (err) {
                    _didIteratorError18 = true;
                    _iteratorError18 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion18 && _iterator18.return) {
                        _iterator18.return();
                      }
                    } finally {
                      if (_didIteratorError18) {
                        throw _iteratorError18;
                      }
                    }
                  }

                  val.skin = skinArr.join(',');
                }
                if (val.eye == '1') {
                  val.eye = '正常';
                } else if (val.eye == '2') {
                  val.eye = '分泌物';
                }

                if (val.oral == '1') {
                  val.oral = '光滑';
                } else if (val.oral == '2') {
                  val.oral = '破溃';
                } else if (val.oral == '3') {
                  val.oral = '鹅口疮';
                }

                if (val.umbilical == '1') {
                  val.umbilical = '干燥';
                } else if (val.umbilical == '2') {
                  val.umbilical = '出血';
                } else if (val.umbilical == '3') {
                  val.umbilical = '脱落';
                } else if (val.umbilical == '4') {
                  val.umbilical = '分泌物';
                }

                if (val.tension_of_limbs == '1') {
                  val.tension_of_limbs = '良好';
                } else if (val.tension_of_limbs == '2') {
                  val.tension_of_limbs = '受限';
                }

                if (val.nerve_reflex == '1') {
                  val.nerve_reflex = '正常';
                } else if (val.nerve_reflex == '2') {
                  val.nerve_reflex = '迟钝';
                }
                _this6.formListDetailList.push(val);
              }
            } catch (err) {
              _didIteratorError16 = true;
              _iteratorError16 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion16 && _iterator16.return) {
                  _iterator16.return();
                }
              } finally {
                if (_didIteratorError16) {
                  throw _iteratorError16;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this6.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this6.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this6.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this6.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this6.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this6.$vux.loading.hide();
          _this6.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this6.$vux.loading.hide();
          _this6.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求婴儿喂养记录单所有列表
    apiGetBabyFeedingRecordList: function apiGetBabyFeedingRecordList(str, handle) {
      var _this7 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        baby_id: this.get_baby_id,
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getBabyFeedingRecordList(params).then(function (res) {
        console.info('请求婴儿喂养记录单', res);
        if (res.data) {
          var shift_value = _this7.$route.query.shifts_value;
          _this7.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion19 = true;
            var _didIteratorError19 = false;
            var _iteratorError19 = undefined;

            try {
              for (var _iterator19 = get_iterator_default()(res.data.shifts_count_list), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                var item = _step19.value;

                _this7.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this7.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError19 = true;
              _iteratorError19 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion19 && _iterator19.return) {
                  _iterator19.return();
                }
              } finally {
                if (_didIteratorError19) {
                  throw _iteratorError19;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this7.formListDetailListPage);
          _this7.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion20 = true;
            var _didIteratorError20 = false;
            var _iteratorError20 = undefined;

            try {
              for (var _iterator20 = get_iterator_default()(res.data.list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
                var _item6 = _step20.value;

                _this7.formListDetailList.push(_item6);
              }
            } catch (err) {
              _didIteratorError20 = true;
              _iteratorError20 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion20 && _iterator20.return) {
                  _iterator20.return();
                }
              } finally {
                if (_didIteratorError20) {
                  throw _iteratorError20;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this7.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this7.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this7.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this7.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this7.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this7.$vux.loading.hide();
          _this7.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this7.$vux.loading.hide();
          _this7.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求产妇膳食记录表所有列表
    apiGetMaternalMealRecordsList: function apiGetMaternalMealRecordsList(str, handle) {
      var _this8 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getMaternalMealRecordsList(params).then(function (res) {
        console.info(res);
        if (res.data) {
          var shift_value = _this8.$route.query.shifts_value;
          _this8.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion21 = true;
            var _didIteratorError21 = false;
            var _iteratorError21 = undefined;

            try {
              for (var _iterator21 = get_iterator_default()(res.data.shifts_count_list), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                var item = _step21.value;

                _this8.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this8.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError21 = true;
              _iteratorError21 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion21 && _iterator21.return) {
                  _iterator21.return();
                }
              } finally {
                if (_didIteratorError21) {
                  throw _iteratorError21;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this8.formListDetailListPage);
          _this8.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion22 = true;
            var _didIteratorError22 = false;
            var _iteratorError22 = undefined;

            try {
              for (var _iterator22 = get_iterator_default()(res.data.list), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                var _item7 = _step22.value;

                _this8.formListDetailList.push(_item7);
              }
            } catch (err) {
              _didIteratorError22 = true;
              _iteratorError22 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion22 && _iterator22.return) {
                  _iterator22.return();
                }
              } finally {
                if (_didIteratorError22) {
                  throw _iteratorError22;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this8.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this8.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this8.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this8.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this8.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this8.$vux.loading.hide();
          _this8.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this8.$vux.loading.hide();
          _this8.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求产妇康复护理评估记录表所有列表
    apiGetMaterRehNursEvalList: function apiGetMaterRehNursEvalList(str, handle) {
      var _this9 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getMaterRehNursEvalList(params).then(function (res) {
        console.info('请求产妇康复护理评估记录表', res);
        if (res.data) {
          var shift_value = _this9.$route.query.shifts_value;
          _this9.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
              for (var _iterator23 = get_iterator_default()(res.data.shifts_count_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                var item = _step23.value;

                _this9.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this9.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError23 = true;
              _iteratorError23 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion23 && _iterator23.return) {
                  _iterator23.return();
                }
              } finally {
                if (_didIteratorError23) {
                  throw _iteratorError23;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this9.formListDetailListPage);
          _this9.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion24 = true;
            var _didIteratorError24 = false;
            var _iteratorError24 = undefined;

            try {
              for (var _iterator24 = get_iterator_default()(res.data.list), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                var val = _step24.value;

                var cfrText = '';
                if (_this9.nurser_name.length) {
                  var _iteratorNormalCompletion25 = true;
                  var _didIteratorError25 = false;
                  var _iteratorError25 = undefined;

                  try {
                    for (var _iterator25 = get_iterator_default()(_this9.nurser_name), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                      var _item8 = _step25.value;

                      if (val.check_id == _item8.id) {
                        cfrText = _item8.user_name;
                      }
                    }
                  } catch (err) {
                    _didIteratorError25 = true;
                    _iteratorError25 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion25 && _iterator25.return) {
                        _iterator25.return();
                      }
                    } finally {
                      if (_didIteratorError25) {
                        throw _iteratorError25;
                      }
                    }
                  }
                }
                val.cfrText = cfrText;
                _this9.formListDetailList.push(val);
              }
            } catch (err) {
              _didIteratorError24 = true;
              _iteratorError24 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion24 && _iterator24.return) {
                  _iterator24.return();
                }
              } finally {
                if (_didIteratorError24) {
                  throw _iteratorError24;
                }
              }
            }
          }

          if (str == 'refresh') {
            _this9.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this9.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this9.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this9.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this9.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this9.$vux.loading.hide();
          _this9.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this9.$vux.loading.hide();
          _this9.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求产妇每日生理护理记录所有列表
    apiGetMaternalEverydayPhysiologyList: function apiGetMaternalEverydayPhysiologyList(str, handle) {
      var _this10 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value == undefined ? '' : this.shift_value.substring(0, 2),
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.bbFormApi.getMaternalEverydayPhysiologyList(params).then(function (res) {
        console.info('请求产妇每日生理护理记录', res);
        if (res.data) {
          var shift_value = _this10.$route.query.shifts_value;
          _this10.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion26 = true;
            var _didIteratorError26 = false;
            var _iteratorError26 = undefined;

            try {
              for (var _iterator26 = get_iterator_default()(res.data.shifts_count_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
                var item = _step26.value;

                _this10.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this10.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError26 = true;
              _iteratorError26 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion26 && _iterator26.return) {
                  _iterator26.return();
                }
              } finally {
                if (_didIteratorError26) {
                  throw _iteratorError26;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this10.formListDetailListPage);
          _this10.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion27 = true;
            var _didIteratorError27 = false;
            var _iteratorError27 = undefined;

            try {
              for (var _iterator27 = get_iterator_default()(res.data.list), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                var _item9 = _step27.value;

                if (_item9.diet == '1') {
                  _item9.diet = '普通';
                } else if (_item9.diet == '2') {
                  _item9.diet = '特殊';
                }
                if (_item9.sport == '1') {
                  _item9.sport = '舒适';
                } else if (_item9.sport == '2') {
                  _item9.sport = '较累';
                }
                if (_item9.sport_text == '') {
                  _item9.sport = _item9.sport;
                } else {
                  _item9.sport = _item9.sport + '：' + _item9.sport_text;
                }
                _item9.sport = _item9.sport + _item9.sport_text;
                _this10.formListDetailList.push(_item9);
              }
            } catch (err) {
              _didIteratorError27 = true;
              _iteratorError27 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion27 && _iterator27.return) {
                  _iterator27.return();
                }
              } finally {
                if (_didIteratorError27) {
                  throw _iteratorError27;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this10.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this10.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this10.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this10.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this10.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this10.$vux.loading.hide();
          _this10.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this10.$vux.loading.hide();
          _this10.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求产妇健康咨询记录表
    apiGetMatarnalHeathRecordList: function apiGetMatarnalHeathRecordList(str, handle) {
      var _this11 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value.substring(0, 2) == '早班' ? '1' : this.shift_value.substring(0, 2) == '中班' ? '2' : this.shift_value.substring(0, 2) == '晚班' ? '3' : '',
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.chritmasFormApi.matarnalHeathRecordList(params).then(function (res) {
        console.info('请求产妇健康咨询记录表', res);
        if (res.data) {
          var shift_value = _this11.$route.query.shifts_value;
          _this11.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion28 = true;
            var _didIteratorError28 = false;
            var _iteratorError28 = undefined;

            try {
              for (var _iterator28 = get_iterator_default()(res.data.shifts_count_list), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                var item = _step28.value;

                _this11.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this11.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError28 = true;
              _iteratorError28 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion28 && _iterator28.return) {
                  _iterator28.return();
                }
              } finally {
                if (_didIteratorError28) {
                  throw _iteratorError28;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this11.formListDetailListPage);
          _this11.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion29 = true;
            var _didIteratorError29 = false;
            var _iteratorError29 = undefined;

            try {
              for (var _iterator29 = get_iterator_default()(res.data.list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
                var _item10 = _step29.value;

                var cfrText = '';
                var _iteratorNormalCompletion30 = true;
                var _didIteratorError30 = false;
                var _iteratorError30 = undefined;

                try {
                  for (var _iterator30 = get_iterator_default()(_this11.nurser_name), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                    var val = _step30.value;

                    if (val.id == _item10.agent_id) {
                      cfrText = val.user_name;
                    }
                  }
                } catch (err) {
                  _didIteratorError30 = true;
                  _iteratorError30 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion30 && _iterator30.return) {
                      _iterator30.return();
                    }
                  } finally {
                    if (_didIteratorError30) {
                      throw _iteratorError30;
                    }
                  }
                }

                var obj = {
                  delivery_type: _item10.delivery_type,
                  advisory_date: _item10.advisory_date == '0000-00-00' ? '' : _item10.advisory_date,
                  agent_id: cfrText,
                  agent_sign: _item10.agent_sign,
                  breast: _item10.breast == '1' ? '左硬结' : _item10.breast == '2' ? '右硬结' : _item10.breast == '3' ? '无异常' : _item10.breast == '4' ? '正常' : _item10.breast == '5' ? '双侧硬结' : '',
                  chapped_nipple: _item10.chapped_nipple == '1' ? '有' : _item10.chapped_nipple == '2' ? '无' : '',
                  healing: _item10.healing == '1' ? '良好' : _item10.healing == '2' ? '不良' : '',
                  id: _item10.id,
                  lochia_amount: _item10.lochia_amount,
                  lochia_color: _item10.lochia_color == '1' ? '暗红' : _item10.lochia_color == '2' ? '鲜红' : _item10.lochia_color == '3' ? '白色' : _item10.lochia_color == '4' ? '正常' : '',
                  lochia_taste: _item10.lochia_taste == '1' ? '有' : _item10.lochia_taste == '2' ? '无' : '',
                  milk_amount: _item10.milk_amount == '1' ? '多' : _item10.milk_amount == '2' ? '中' : _item10.milk_amount == '3' ? '少' : '回奶',
                  pee: _item10.pee == '1' ? '有' : _item10.pee == '2' ? '无' : '',
                  postpartum_days: _item10.postpartum_days == '0' ? '' : _item10.postpartum_days,
                  shifts: _item10.shifts == '1' ? '早班' : _item10.shifts == '2' ? '中班' : _item10.shifts == '3' ? '晚班' : '',
                  special_case: _item10.special_case,
                  stool: _item10.stool == '1' ? '正常' : _item10.stool == '2' ? '异常' : '',
                  //    uterus_place:item.uterus_place == "1" ? "脐上指" : item.uterus_place == "2" ? "脐下指" : item.uterus_place == "3" ? "完全入盘" : item.uterus_place == "4" ? "完全入盘" : '',
                  uterus_place: _item10.uterus_place
                };
                _this11.formListDetailList.push(obj);
              }
            } catch (err) {
              _didIteratorError29 = true;
              _iteratorError29 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion29 && _iterator29.return) {
                  _iterator29.return();
                }
              } finally {
                if (_didIteratorError29) {
                  throw _iteratorError29;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this11.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this11.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this11.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this11.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this11.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this11.$vux.loading.hide();
          _this11.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this11.$vux.loading.hide();
          _this11.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求(新生儿)健康咨询记录表列表
    apiGetBabyHeathRecordList: function apiGetBabyHeathRecordList(str, handle) {
      var _this12 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        baby_id: this.get_baby_id,
        shifts: this.shift_value.substring(0, 2) == '早班' ? '1' : this.shift_value.substring(0, 2) == '中班' ? '2' : this.shift_value.substring(0, 2) == '晚班' ? '3' : '',
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.chritmasFormApi.BabyHeathRecord(params).then(function (res) {
        console.info('请求(新生儿)健康咨询记录表列表', res);
        if (res.data) {
          var shift_value = _this12.$route.query.shifts_value;
          _this12.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion31 = true;
            var _didIteratorError31 = false;
            var _iteratorError31 = undefined;

            try {
              for (var _iterator31 = get_iterator_default()(res.data.shifts_count_list), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                var item = _step31.value;

                _this12.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this12.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError31 = true;
              _iteratorError31 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion31 && _iterator31.return) {
                  _iterator31.return();
                }
              } finally {
                if (_didIteratorError31) {
                  throw _iteratorError31;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this12.formListDetailListPage);
          _this12.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion32 = true;
            var _didIteratorError32 = false;
            var _iteratorError32 = undefined;

            try {
              for (var _iterator32 = get_iterator_default()(res.data.list), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
                var _item11 = _step32.value;
                var _iteratorNormalCompletion33 = true;
                var _didIteratorError33 = false;
                var _iteratorError33 = undefined;

                try {
                  for (var _iterator33 = get_iterator_default()(_this12.nurser_name), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
                    var val = _step33.value;

                    if (val.id == _item11.agent_id) {
                      _item11.agent_id = val.user_name;
                    }
                  }
                } catch (err) {
                  _didIteratorError33 = true;
                  _iteratorError33 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion33 && _iterator33.return) {
                      _iterator33.return();
                    }
                  } finally {
                    if (_didIteratorError33) {
                      throw _iteratorError33;
                    }
                  }
                }

                if (_item11.shifts == '1') {
                  _item11.shifts = '早班';
                } else if (_item11.shifts == '2') {
                  _item11.shifts = '中班';
                } else if (_item11.shifts == '3') {
                  _item11.shifts = '晚班';
                }
                var _iteratorNormalCompletion34 = true;
                var _didIteratorError34 = false;
                var _iteratorError34 = undefined;

                try {
                  for (var _iterator34 = get_iterator_default()(_this12.baby_list), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
                    var child = _step34.value;

                    if (_item11.baby_id == child.id) {
                      _item11.liveData = _this12.formatDateTime(child.live_time);
                      _item11.baby_name = child.name;
                    }
                  }
                } catch (err) {
                  _didIteratorError34 = true;
                  _iteratorError34 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion34 && _iterator34.return) {
                      _iterator34.return();
                    }
                  } finally {
                    if (_didIteratorError34) {
                      throw _iteratorError34;
                    }
                  }
                }

                if (_item11.advisory_date == '0000-00-00') {
                  _item11.advisory_date = '';
                }
                if (_item11.birth_day == '0') {
                  _item11.birth_day = '';
                }
                if (_item11.jaundice == '0') {
                  _item11.jaundice = '';
                }
                if (_item11.shifts == '0') {
                  _item11.shifts = '';
                }
                // if(item.deal == '1'){
                //     item.deal = '加强脐带部护理'
                // }else if(item.deal == '2'){
                //     item.deal = '加强母乳喂养'
                // }
                _this12.formListDetailList.push(_item11);
              }
            } catch (err) {
              _didIteratorError32 = true;
              _iteratorError32 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion32 && _iterator32.return) {
                  _iterator32.return();
                }
              } finally {
                if (_didIteratorError32) {
                  throw _iteratorError32;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this12.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this12.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this12.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this12.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this12.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this12.$vux.loading.hide();
          _this12.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this12.$vux.loading.hide();
          _this12.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求产妇特殊护理记录表
    apiGetMatarnalSpecialNursingRecordList: function apiGetMatarnalSpecialNursingRecordList(str, handle) {
      var _this13 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        shifts: this.shift_value.substring(0, 2) == '早班' ? '1' : this.shift_value.substring(0, 2) == '中班' ? '2' : this.shift_value.substring(0, 2) == '晚班' ? '3' : '',
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.chritmasFormApi.MatarnalSpecialNursingRecord(params).then(function (res) {
        console.info('请求产妇特殊护理记录表', res);
        if (res.data) {
          var shift_value = _this13.$route.query.shifts_value;
          _this13.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion35 = true;
            var _didIteratorError35 = false;
            var _iteratorError35 = undefined;

            try {
              for (var _iterator35 = get_iterator_default()(res.data.shifts_count_list), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
                var item = _step35.value;

                _this13.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this13.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError35 = true;
              _iteratorError35 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion35 && _iterator35.return) {
                  _iterator35.return();
                }
              } finally {
                if (_didIteratorError35) {
                  throw _iteratorError35;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this13.formListDetailListPage);
          _this13.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion36 = true;
            var _didIteratorError36 = false;
            var _iteratorError36 = undefined;

            try {
              for (var _iterator36 = get_iterator_default()(res.data.list), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
                var _item12 = _step36.value;
                var _iteratorNormalCompletion37 = true;
                var _didIteratorError37 = false;
                var _iteratorError37 = undefined;

                try {
                  for (var _iterator37 = get_iterator_default()(_this13.nurser_name), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
                    var val = _step37.value;

                    if (val.id == _item12.agent_id) {
                      _item12.agent_id = val.user_name;
                    }
                  }
                } catch (err) {
                  _didIteratorError37 = true;
                  _iteratorError37 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion37 && _iterator37.return) {
                      _iterator37.return();
                    }
                  } finally {
                    if (_didIteratorError37) {
                      throw _iteratorError37;
                    }
                  }
                }

                if (_item12.shifts == '1') {
                  _item12.shifts = '早班';
                } else if (_item12.shifts == '2') {
                  _item12.shifts = '中班';
                } else if (_item12.shifts == '3') {
                  _item12.shifts = '晚班';
                }
                if (_item12.record_date == '0000-00-00') {
                  _item12.record_date = '';
                }
                if (_item12.shifts == '0') {
                  _item12.shifts = '';
                }
                _this13.formListDetailList.push(_item12);
              }
            } catch (err) {
              _didIteratorError36 = true;
              _iteratorError36 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion36 && _iterator36.return) {
                  _iterator36.return();
                }
              } finally {
                if (_didIteratorError36) {
                  throw _iteratorError36;
                }
              }
            }
          }
          if (str == 'refresh') {
            _this13.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this13.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this13.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this13.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this13.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this13.$vux.loading.hide();
          _this13.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this13.$vux.loading.hide();
          _this13.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求婴儿特殊护理记录表
    apiGetbabySpecialNursingRecordList: function apiGetbabySpecialNursingRecordList(str, handle) {
      var _this14 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id,
        baby_id: this.get_baby_id,
        shifts: this.shift_value.substring(0, 2) == '早班' ? '1' : this.shift_value.substring(0, 2) == '中班' ? '2' : this.shift_value.substring(0, 2) == '晚班' ? '3' : '',
        stime: this.start_date,
        etime: this.end_date
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.chritmasFormApi.babySpecialNursingRecord(params).then(function (res) {
        console.info('请求婴儿特殊护理记录表', res);
        if (res.data) {
          var shift_value = _this14.$route.query.shifts_value;
          _this14.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion38 = true;
            var _didIteratorError38 = false;
            var _iteratorError38 = undefined;

            try {
              for (var _iterator38 = get_iterator_default()(res.data.shifts_count_list), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
                var item = _step38.value;

                _this14.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this14.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError38 = true;
              _iteratorError38 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion38 && _iterator38.return) {
                  _iterator38.return();
                }
              } finally {
                if (_didIteratorError38) {
                  throw _iteratorError38;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this14.formListDetailListPage);
          _this14.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion39 = true;
            var _didIteratorError39 = false;
            var _iteratorError39 = undefined;

            try {
              for (var _iterator39 = get_iterator_default()(res.data.list), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
                var _item13 = _step39.value;
                var _iteratorNormalCompletion40 = true;
                var _didIteratorError40 = false;
                var _iteratorError40 = undefined;

                try {
                  for (var _iterator40 = get_iterator_default()(_this14.nurser_name), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
                    var val = _step40.value;

                    if (val.id == _item13.agent_id) {
                      _item13.agent_id = val.user_name;
                    }
                  }
                } catch (err) {
                  _didIteratorError40 = true;
                  _iteratorError40 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion40 && _iterator40.return) {
                      _iterator40.return();
                    }
                  } finally {
                    if (_didIteratorError40) {
                      throw _iteratorError40;
                    }
                  }
                }

                if (_item13.shifts == '1') {
                  _item13.shifts = '早班';
                } else if (_item13.shifts == '2') {
                  _item13.shifts = '中班';
                } else if (_item13.shifts == '3') {
                  _item13.shifts = '晚班';
                }
                var _iteratorNormalCompletion41 = true;
                var _didIteratorError41 = false;
                var _iteratorError41 = undefined;

                try {
                  for (var _iterator41 = get_iterator_default()(_this14.baby_list), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
                    var child = _step41.value;

                    if (_item13.baby_id == child.id) {
                      _item13.sex = child.sex == '1' ? '男' : '女';
                      _item13.baby_name = child.name;
                    }
                  }
                } catch (err) {
                  _didIteratorError41 = true;
                  _iteratorError41 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion41 && _iterator41.return) {
                      _iterator41.return();
                    }
                  } finally {
                    if (_didIteratorError41) {
                      throw _iteratorError41;
                    }
                  }
                }

                if (_item13.record_date == '0000-00-00') {
                  _item13.record_date = '';
                }
                if (_item13.postpartum_days == '0') {
                  _item13.postpartum_days = '';
                }
                if (_item13.breast == '0') {
                  _item13.breast = '';
                }
                if (_item13.shifts == '0') {
                  _item13.shifts = '';
                }
                _this14.formListDetailList.push(_item13);
              }
            } catch (err) {
              _didIteratorError39 = true;
              _iteratorError39 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion39 && _iterator39.return) {
                  _iterator39.return();
                }
              } finally {
                if (_didIteratorError39) {
                  throw _iteratorError39;
                }
              }
            }
          }
          if (str == 'refresh') {
            console.info('启用上拉加载插件');
            _this14.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this14.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this14.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this14.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this14.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this14.$vux.loading.hide();
          _this14.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this14.$vux.loading.hide();
          _this14.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求喂药委托书
    apiGetFeedDrugEntrustUrlListList: function apiGetFeedDrugEntrustUrlListList(str, handle) {
      var _this15 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.checkRoomApi.getFeedDrugEntrustUrlList(params).then(function (res) {
        console.info('请求喂药委托书', res);
        if (res.data) {
          var shift_value = _this15.$route.query.shifts_value;
          _this15.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion42 = true;
            var _didIteratorError42 = false;
            var _iteratorError42 = undefined;

            try {
              for (var _iterator42 = get_iterator_default()(res.data.shifts_count_list), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
                var item = _step42.value;

                _this15.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this15.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError42 = true;
              _iteratorError42 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion42 && _iterator42.return) {
                  _iterator42.return();
                }
              } finally {
                if (_didIteratorError42) {
                  throw _iteratorError42;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this15.formListDetailListPage);
          _this15.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion43 = true;
            var _didIteratorError43 = false;
            var _iteratorError43 = undefined;

            try {
              for (var _iterator43 = get_iterator_default()(res.data.list), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
                var _item14 = _step43.value;

                _this15.formListDetailList.push(_item14);
              }
            } catch (err) {
              _didIteratorError43 = true;
              _iteratorError43 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion43 && _iterator43.return) {
                  _iterator43.return();
                }
              } finally {
                if (_didIteratorError43) {
                  throw _iteratorError43;
                }
              }
            }
          }
          if (str == 'refresh') {
            console.info('启用上拉加载插件');
            _this15.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this15.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this15.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this15.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this15.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this15.$vux.loading.hide();
          _this15.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this15.$vux.loading.hide();
          _this15.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求月子基本护理常识
    apiGetConfinementSenseListUrlList: function apiGetConfinementSenseListUrlList(str, handle) {
      var _this16 = this;

      var params = {
        token: this.$cookie.get('token'),
        page: this.formListDetailListPage,
        maternal_info_id: this.$route.query.id
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      console.info(params);
      Api.checkRoomApi.getConfinementSenseListUrlList(params).then(function (res) {
        console.info('请求月子基本护理常识', res);
        if (res.data) {
          var shift_value = _this16.$route.query.shifts_value;
          _this16.shift_arr = [];
          if (res.data.shifts_count_list) {
            var _iteratorNormalCompletion44 = true;
            var _didIteratorError44 = false;
            var _iteratorError44 = undefined;

            try {
              for (var _iterator44 = get_iterator_default()(res.data.shifts_count_list), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
                var item = _step44.value;

                _this16.shift_arr.push(item.shifts + '(' + item.count + ')');
                if (shift_value && handle == 'login') {
                  if (item.shifts == shift_value) {
                    _this16.shift_value = item.shifts + '(' + item.count + ')';
                  }
                }
              }
            } catch (err) {
              _didIteratorError44 = true;
              _iteratorError44 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion44 && _iterator44.return) {
                  _iterator44.return();
                }
              } finally {
                if (_didIteratorError44) {
                  throw _iteratorError44;
                }
              }
            }
          }
        }
        if (res.errcode == 200) {
          console.info('页数：' + _this16.formListDetailListPage);
          _this16.formListDetailListPage++;
          if (res.data.list.length) {
            var _iteratorNormalCompletion45 = true;
            var _didIteratorError45 = false;
            var _iteratorError45 = undefined;

            try {
              for (var _iterator45 = get_iterator_default()(res.data.list), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
                var _item15 = _step45.value;

                _this16.formListDetailList.push(_item15);
              }
            } catch (err) {
              _didIteratorError45 = true;
              _iteratorError45 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion45 && _iterator45.return) {
                  _iterator45.return();
                }
              } finally {
                if (_didIteratorError45) {
                  throw _iteratorError45;
                }
              }
            }
          }
          if (str == 'refresh') {
            console.info('启用上拉加载插件');
            _this16.$refs.scrollerBottom2.enablePullup(); //启用上拉加载插件
            _this16.$refs.scrollerBottom2.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
          }
          if (res.data.page.page == res.data.page.page_count) {
            _this16.$refs.scrollerBottom2.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
          } else {
            _this16.$refs.scrollerBottom2.donePullup(); //设置上拉加载操作完成，在数据加载后执行
          }
          _this16.$vux.loading.hide();
        } else if (res.errcode == 400) {
          _this16.$vux.loading.hide();
          _this16.$vux.toast.show({
            type: 'cancel',
            text: '暂无数据'
          });
        } else {
          _this16.$vux.loading.hide();
          _this16.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //新增表单点击详情进入详情页
    editFormDetailList: function editFormDetailList(id) {
      var form_id = parseInt(this.form_id);
      var query = {
        id: this.$route.query.id,
        form_id: this.form_id,
        list_id: id,
        tabVal: this.$route.query.tabVal
      };
      switch (form_id) {
        case 1001:
          this.$router.push({
            path: './bb_form_f',
            query: query
          });
          break;
        case 1002:
          this.$router.push({
            path: './bb_form_b',
            query: query
          });
          break;
        case 1003:
          this.$router.push({
            path: './bb_form_c',
            query: query
          });
          break;
        case 1004:
          this.$router.push({
            path: './bb_form_a',
            query: query
          });
          break;
        case 1005:
          this.$router.push({
            path: './maternal_form_d',
            query: query
          });
          break;
        case 1006:
          this.$router.push({
            path: './maternal_form_b',
            query: query
          });
          break;
        case 1007:
          this.$router.push({
            path: './maternal_form_c',
            query: query
          });
          break;
        case 1008:
          this.$router.push({
            path: './christmas_form_one',
            query: query
          });
          break;
        case 1009:
          this.$router.push({
            path: './christmas_form_two',
            query: query
          });
          break;
        case 1010:
          this.$router.push({
            path: './christmas_form_three',
            query: query
          });
          break;
        case 1011:
          this.$router.push({
            path: './christmas_form_four',
            query: query
          });
          break;
        case 1012:
          this.$router.push({
            path: './medicine_commissioned',
            query: query
          });
          break;
        case 1013:
          this.$router.push({
            path: './basic_nursing',
            query: query
          });
          break;
      }
    },

    //根据表单ID执行不同方法
    forFormIDUseMethod: function forFormIDUseMethod(handle) {
      console.info('根据表单ID执行不同方法');
      var form_id = parseInt(this.form_id);
      if (form_id === 1001 || form_id === 1002 || form_id === 1003 || form_id === 1004 || form_id === 1009 || form_id === 1011) {
        this.babySelectShow = true;
      }
      if (handle == 'tab') {
        console.log('如果是点击tab');
        // 如果是点击tab
        this.formListDetailList = [];
        this.formListDetailListPage = 1;
        this.start_date = '';
        this.end_date = '';
        this.shift_value = '';
        this.get_baby_id = '';
      }
      // let s_arr =  ['早班','中班','晚班']
      // this.shift_arr = s_arr
      switch (form_id) {
        case 1001:
          this.showFormList = false;
          this.apiBabyCare('refresh', handle);
          break;
        case 1002:
          this.showFormList = false;
          this.apiBabyRecord('refresh', handle);

          break;
        case 1003:
          this.showFormList = false;
          this.apiBabyRecordTwo('refresh', handle);
          break;
        case 1004:
          this.showFormList = false;
          this.apiGetBabyFeedingRecordList('refresh', handle);
          break;
        case 1005:
          this.showFormList = false;
          this.apiGetMaternalEverydayPhysiologyList('refresh', handle);
          break;
        case 1006:
          this.showFormList = false;
          this.apiGetMaternalMealRecordsList('refresh', handle);
          break;
        case 1007:
          this.showFormList = false;
          this.apiGetMaterRehNursEvalList('refresh', handle);
          break;
        case 1008:
          this.showFormList = false;
          this.apiGetCfrList('christmas_form_one', handle);
          break;
        case 1009:
          this.showFormList = false;
          this.apiGetCfrList('christmas_form_two', handle);
          break;
        case 1010:
          this.showFormList = false;
          this.apiGetCfrList('christmas_form_three', handle);
          break;
        case 1011:
          this.showFormList = false;
          this.apiGetCfrList('christmas_form_four', handle);
          break;
        case 1012:
          this.showFormList = false;
          this.apiGetFeedDrugEntrustUrlListList('refresh', handle);
          break;
        case 1013:
          this.showFormList = false;
          this.apiGetConfinementSenseListUrlList('refresh', handle);
          break;
        case 1014:
          this.$router.push({
            path: '/new_check_room_record',
            query: {
              id: this.$route.query.id,
              tabVal: this.$route.query.tabVal
            }
          });
          break;
        default:
          //自定义表单内容
          this.showFormList = true;
          this.getAnswerList(); //个人信息获取的答案
          this.refresh();
      }
    },

    //获取查房人列表
    apiGetCfrList: function apiGetCfrList(name) {
      var _this17 = this;

      var params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id')
      };
      Api.checkRoomApi.getCheckInfo(params).then(function (res) {
        console.info('获取查房人列表');
        console.info(res);
        if (res.errcode == 1) {
          _this17.nurser_name = res.data.nurser_name; //过滤了离院，
          //
          if (name == 'christmas_form_one') {
            _this17.apiGetMatarnalHeathRecordList('refresh');
          } else if (name == 'christmas_form_two') {
            _this17.apiGetBabyHeathRecordList('refresh');
          } else if (name == 'christmas_form_three') {
            _this17.apiGetMatarnalSpecialNursingRecordList('refresh');
          } else if (name == 'christmas_form_four') {
            _this17.apiGetbabySpecialNursingRecordList('refresh');
          }
        } else {
          _this17.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //获取宝宝数量
    get_baby_list: function get_baby_list() {
      var _this18 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.monthLiveApi.babyList(params).then(function (res) {
        console.info('获取宝宝数量');
        console.info(res);
        if (res.errcode == 1) {
          _this18.baby_list = res.data;
          _this18.$vux.loading.hide();
        } else {
          _this18.$vux.loading.hide();
          _this18.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    }
  },
  created: function created() {
    var start_date = this.$route.query.start_date;
    console.log(start_date);
    if (start_date) {
      this.start_date = start_date;
    }
    var end_date = this.$route.query.end_date;
    if (end_date) {
      this.end_date = end_date;
    }
    this.get_baby_list();
    this.apiGetCfrList(); //获取查房人列表
    this.apiMemberInfo(); //基础信息
    this.apiFormList(); //表单列表
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9f34302","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/check_room_service.vue
var check_room_service_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{ showBack: true, preventGoBack: true }},on:{"on-click-back":_vm.goBack}},[_vm._v("查房服务")]),_vm._v(" "),_c('div',{staticClass:"check_room_main"},[_c('div',{staticClass:"left_menu",staticStyle:{"width":"21vw"}},[_c('tab',{attrs:{"scroll-threshold":4}},_vm._l((_vm.form_list),function(item,index){return _c('tab-item',{key:item.id,style:(item.style == true
              ? 'background:#f5f5f5;border-bottom:1px solid #e5e5e5'
              : ''),attrs:{"selected":index == _vm.tab_index,"active-class":"activeClass"},on:{"on-item-click":_vm.tabItem}},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])}),1)],1),_vm._v(" "),_c('div',{staticClass:"right_content",staticStyle:{"width":"70vw","height":"calc(100vh - 46px)","overflow-y":"scroll"}},[_c('div',{staticClass:"con"},[_c('flexbox',[_c('flexbox-item',{staticStyle:{"flex":"0.8"}},[_c('div',{staticClass:"flex-demo—date"},[_c('datetime',{attrs:{"title":"查房日期：","placeholder":"请选择日期"},on:{"on-confirm":_vm.start_date_congirm},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}})],1)]),_vm._v(" "),_c('flexbox-item',{staticStyle:{"flex":"0.8"}},[_c('div',{staticClass:"flex-demo—date"},[_c('datetime',{attrs:{"title":"至：","start-date":_vm.min_date,"placeholder":"请选择日期"},on:{"on-confirm":_vm.end_date_congirm},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}})],1)]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"flex-demo—date"},[_c('div',[_vm._v("班次：")]),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},on:{"on-change":_vm.plantPickerChange},model:{value:(_vm.shift_value),callback:function ($$v) {_vm.shift_value=$$v},expression:"shift_value"}},_vm._l((_vm.shift_arr),function(item){return _c('checker-item',{key:item,attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)])],1),_vm._v(" "),_c('flexbox',{staticClass:"search"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo—date",staticStyle:{"padding-left":"10px"}},[_c('div',[_vm._v("宝宝：")]),_vm._v(" "),_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},on:{"on-change":_vm.babyPickerChange},model:{value:(_vm.get_baby_id),callback:function ($$v) {_vm.get_baby_id=$$v},expression:"get_baby_id"}},_vm._l((_vm.baby_list),function(item){return _c('checker-item',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}),1)],1)]),_vm._v(" "),_c('flexbox-item',[_c('div',[_c('x-button',{attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.clearFrom.apply(null, arguments)}}},[_vm._v("清空筛选")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.addRecord.apply(null, arguments)}}},[_vm._v("添加记录")])],1)])],1),_vm._v(" "),_c('flexbox',{staticClass:"basePersonInfo"},[_c('flexbox-item',[_c('div',{staticClass:"pl-10 nowrap"},[_vm._v("孕妇姓名:"+_vm._s(_vm.memberInfo.name))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"nowrap"},[_vm._v("孕妇电话:"+_vm._s(_vm.memberInfo.phone))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"nowrap"},[_vm._v("套餐:"+_vm._s(_vm.memberInfo.package))])])],1),_vm._v(" "),_c('flexbox',{staticClass:"basePersonInfo"},[_c('flexbox-item',[_c('div',{staticClass:"pl-10 nowrap"},[_vm._v("入住日期:"+_vm._s(_vm.memberInfo.liveDate))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"nowrap"},[_vm._v("分娩日期:"+_vm._s(_vm.memberInfo.childBirth))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"nowrap"},[_vm._v("分娩方式:"+_vm._s(_vm.memberInfo.birthType))])])],1),_vm._v(" "),_c('div',{staticClass:"from_title",staticStyle:{"padding":"5px"}},[_vm._v("\n          "+_vm._s(_vm.from_title)+"记录\n        ")]),_vm._v(" "),(_vm.showFormList)?_c('scroller',{ref:"scrollerBottom",attrs:{"use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"use-pulldown":"","pulldown-config":_vm.pulldownDefaultConfig,"lock-x":"","height":"-254"},on:{"on-pullup-loading":_vm.loadMore,"on-pulldown-loading":_vm.refresh}},[_c('div',{staticClass:"record_from_list_scroll"},_vm._l((_vm.data_list),function(data_list_item,index){return _c('div',{key:index,staticStyle:{"border":"1px solid #1d62f0","margin-bottom":"20px","padding":"10px","position":"relative"}},[_c('x-button',{staticClass:"editForm",attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editForm(data_list_item.answer_id)}}},[_vm._v("编辑")]),_vm._v(" "),_vm._l((data_list_item.form_data),function(column_list_item,index){return (column_list_item.is_show_column == 2)?_c('group',{key:index,attrs:{"title":column_list_item.column_name,"label-width":"10em"}},_vm._l((column_list_item.row_list),function(row_list_item,index){return _c('div',{key:index},_vm._l((row_list_item.content),function(content_item,index){return _c('div',{key:index,staticClass:"vux-1px-b"},[(content_item.type == '1')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '2')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 4px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"4px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v("\n                            "+_vm._s(content_item.question + '：')+"\n                          ")]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v("\n                            "+_vm._s(row_list_item.title + '：')+"\n                          ")]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px"}},[_vm._v("\n                            "+_vm._s(content_item.my_answer[0])+"\n                          ")])])])]):_vm._e(),_vm._v(" "),(content_item.type == '3')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v("\n                          "+_vm._s(content_item.question + '：')+"\n                        ")]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v("\n                          "+_vm._s(row_list_item.title + '：')+"\n                        ")]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},_vm._l((content_item.my_answer),function(val,index){return _c('div',{key:index,staticStyle:{"display":"inline-block","line-height":"36px"}},[_vm._v("\n                            "+_vm._s(val)+"，\n                          ")])}),0)])]):_vm._e(),_vm._v(" "),(content_item.type == '4')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '5')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(_vm.from_title == '贵宾入住告知书')?_c('div',[(content_item.type == '6')?_c('div',[_c('x-textarea',{attrs:{"value":content_item.tip,"disabled":"","autosize":""}})],1):_vm._e()]):_c('div',[(content_item.type == '6')?_c('div',[(content_item.question)?_c('x-textarea',{attrs:{"title":content_item.question + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-textarea',{attrs:{"title":row_list_item.title + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e()]),_vm._v(" "),(content_item.type == '7')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '8')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '9')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title + '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '10')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v("\n                          "+_vm._s(content_item.question + '：')+"\n                        ")]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v("\n                          "+_vm._s(row_list_item.title + '：')+"\n                        ")]),_vm._v(" "),(content_item.my_answer[0])?_c('div',{staticStyle:{"line-height":"36px","flex":"1"}},[(content_item.my_answer[0].length > 100)?_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}}):_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":_vm.host + content_item.my_answer[0],"alt":""}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(content_item.type == '11')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v("\n                          "+_vm._s(content_item.question + '：')+"\n                        ")]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v("\n                          "+_vm._s(row_list_item.title + '：')+"\n                        ")]),_vm._v(" "),_c('div',[(content_item.my_answer.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((content_item.my_answer),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host + item,"width":"84","height":"84","alt":""}})])}),0):_vm._e()])])]):_vm._e(),_vm._v(" "),(content_item.type == '12')?_c('div',[(content_item.question)?_c('cell',{attrs:{"title":content_item.question + '：',"value-align":"left"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('cell',{attrs:{"title":row_list_item.title,"value-align":"left"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e()])}),0)}),0):_vm._e()})],2)}),0)]):_c('scroller',{ref:"scrollerBottom2",attrs:{"use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"use-pulldown":"","pulldown-config":_vm.pulldownDefaultConfig,"lock-x":"","height":"-254"},on:{"on-pullup-loading":_vm.loadMore2,"on-pulldown-loading":_vm.refresh2}},[(_vm.form_id == 1001)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(item.room_number),callback:function ($$v) {_vm.$set(item, "room_number", $$v)},expression:"item.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","disabled":"","placeholder":"请输入手卡号"},model:{value:(item.id_card),callback:function ($$v) {_vm.$set(item, "id_card", $$v)},expression:"item.id_card"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":"","placeholder":"请输入姓名"},model:{value:(item.baby_name),callback:function ($$v) {_vm.$set(item, "baby_name", $$v)},expression:"item.baby_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","disabled":"","placeholder":"请输入性别"},model:{value:(item.baby_gender),callback:function ($$v) {_vm.$set(item, "baby_gender", $$v)},expression:"item.baby_gender"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","disabled":"","placeholder":"请输入母亲姓名"},model:{value:(item.mom_name),callback:function ($$v) {_vm.$set(item, "mom_name", $$v)},expression:"item.mom_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"日期：","disabled":"","placeholder":"日期："},model:{value:(item.cat_date),callback:function ($$v) {_vm.$set(item, "cat_date", $$v)},expression:"item.cat_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生天数(天)：","disabled":"","placeholder":"请输入出生天数"},model:{value:(item.birth_day_num),callback:function ($$v) {_vm.$set(item, "birth_day_num", $$v)},expression:"item.birth_day_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体温(℃)：","disabled":"","placeholder":"请输入体温（单位：℃）"},model:{value:(item.temperature),callback:function ($$v) {_vm.$set(item, "temperature", $$v)},expression:"item.temperature"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体重(g)：","disabled":"","placeholder":"请输入体重(单位：kg)"},model:{value:(item.weight),callback:function ($$v) {_vm.$set(item, "weight", $$v)},expression:"item.weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"脐护(次)：","disabled":"","placeholder":"请输入脐护次数(单位：次)"},model:{value:(item.umb_protection_num),callback:function ($$v) {_vm.$set(item, "umb_protection_num", $$v)},expression:"item.umb_protection_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"洗澡(次)：","disabled":"","placeholder":"请输入洗澡次数(单位：次)"},model:{value:(item.take_shower_num),callback:function ($$v) {_vm.$set(item, "take_shower_num", $$v)},expression:"item.take_shower_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"游泳(次)：","disabled":"","placeholder":"请输入游泳次数(单位：次)"},model:{value:(item.swim_num),callback:function ($$v) {_vm.$set(item, "swim_num", $$v)},expression:"item.swim_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"抚触(次)：","disabled":"","placeholder":"请输入抚触次数(单位：次)"},model:{value:(item.touch_num),callback:function ($$v) {_vm.$set(item, "touch_num", $$v)},expression:"item.touch_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"早教(次)：","disabled":"","placeholder":"请输入早教次数(单位：次)"},model:{value:(item.massage_num),callback:function ($$v) {_vm.$set(item, "massage_num", $$v)},expression:"item.massage_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"SPA(次)：","disabled":"","placeholder":"请输入SPA次数(单位：次)"},model:{value:(item.spa_num),callback:function ($$v) {_vm.$set(item, "spa_num", $$v)},expression:"item.spa_num"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"其他情况：：","disabled":"","placeholder":"请输入其他情况"},model:{value:(item.other_situation),callback:function ($$v) {_vm.$set(item, "other_situation", $$v)},expression:"item.other_situation"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("操作者：")]),_vm._v(" "),(item.opera_name)?_c('div',{staticClass:"value"},[(item.opera_name.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.opera_name,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.opera_name,"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('x-input',{attrs:{"title":"班次：","disabled":""},model:{value:(item.shifts),callback:function ($$v) {_vm.$set(item, "shifts", $$v)},expression:"item.shifts"}})],1)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1002)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(item.room_number),callback:function ($$v) {_vm.$set(item, "room_number", $$v)},expression:"item.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","disabled":"","placeholder":"请输入手卡号"},model:{value:(item.id_card),callback:function ($$v) {_vm.$set(item, "id_card", $$v)},expression:"item.id_card"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":"","placeholder":"请输入姓名"},model:{value:(item.baby_name),callback:function ($$v) {_vm.$set(item, "baby_name", $$v)},expression:"item.baby_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","disabled":"","placeholder":"请输入性别"},model:{value:(item.baby_gender),callback:function ($$v) {_vm.$set(item, "baby_gender", $$v)},expression:"item.baby_gender"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","disabled":"","placeholder":"请输入母亲姓名"},model:{value:(item.mom_name),callback:function ($$v) {_vm.$set(item, "mom_name", $$v)},expression:"item.mom_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"日期：","disabled":"","placeholder":"日期："},model:{value:(item.cat_date),callback:function ($$v) {_vm.$set(item, "cat_date", $$v)},expression:"item.cat_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生天数(天)：","disabled":"","placeholder":"请输入出生天数"},model:{value:(item.birth_day_num),callback:function ($$v) {_vm.$set(item, "birth_day_num", $$v)},expression:"item.birth_day_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体重(g)：","disabled":"","placeholder":"请输入体重(单位：g)"},model:{value:(item.weight),callback:function ($$v) {_vm.$set(item, "weight", $$v)},expression:"item.weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身长(cm)：","disabled":"","placeholder":"请输入身长(单位：cm)"},model:{value:(item.length),callback:function ($$v) {_vm.$set(item, "length", $$v)},expression:"item.length"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"哭声：","disabled":"","placeholder":"请输入哭声"},model:{value:(item.cry),callback:function ($$v) {_vm.$set(item, "cry", $$v)},expression:"item.cry"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体温(℃)：","disabled":"","placeholder":"请输入体温（单位：℃）"},model:{value:(item.temperature),callback:function ($$v) {_vm.$set(item, "temperature", $$v)},expression:"item.temperature"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"小便(次)：","disabled":"","placeholder":"请输入小便（单位：次）"},model:{value:(item.urine_num),callback:function ($$v) {_vm.$set(item, "urine_num", $$v)},expression:"item.urine_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"大便次数(次)：","disabled":"","placeholder":"请输入大便次数（单位：次）"},model:{value:(item.shit_num),callback:function ($$v) {_vm.$set(item, "shit_num", $$v)},expression:"item.shit_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"大便颜色：","disabled":"","placeholder":"请输入大便颜色"},model:{value:(item.shit_colour),callback:function ($$v) {_vm.$set(item, "shit_colour", $$v)},expression:"item.shit_colour"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"大便性质：","disabled":"","placeholder":"请输入大便性质"},model:{value:(item.shit_nature),callback:function ($$v) {_vm.$set(item, "shit_nature", $$v)},expression:"item.shit_nature"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"前囟：","disabled":"","placeholder":""},model:{value:(item.front_fontanelle),callback:function ($$v) {_vm.$set(item, "front_fontanelle", $$v)},expression:"item.front_fontanelle"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"肤色：","disabled":"","placeholder":"请输入肤色"},model:{value:(item.skin_colour),callback:function ($$v) {_vm.$set(item, "skin_colour", $$v)},expression:"item.skin_colour"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"指导意见：","disabled":"","placeholder":"请输入指导意见"},model:{value:(item.guiding_pinions),callback:function ($$v) {_vm.$set(item, "guiding_pinions", $$v)},expression:"item.guiding_pinions"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("签名：")]),_vm._v(" "),(item.autograph)?_c('div',{staticClass:"value"},[(item.autograph.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.autograph,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.autograph,"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('x-input',{attrs:{"title":"查房人：","disabled":""},model:{value:(item.staff_name),callback:function ($$v) {_vm.$set(item, "staff_name", $$v)},expression:"item.staff_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"班次：","disabled":""},model:{value:(item.shifts),callback:function ($$v) {_vm.$set(item, "shifts", $$v)},expression:"item.shifts"}})],1)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1003)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"房号：","disabled":""},model:{value:(item.room_number),callback:function ($$v) {_vm.$set(item, "room_number", $$v)},expression:"item.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","disabled":""},model:{value:(item.id_card),callback:function ($$v) {_vm.$set(item, "id_card", $$v)},expression:"item.id_card"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"日期：","disabled":""},model:{value:(item.cat_date),callback:function ($$v) {_vm.$set(item, "cat_date", $$v)},expression:"item.cat_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":""},model:{value:(item.baby_name),callback:function ($$v) {_vm.$set(item, "baby_name", $$v)},expression:"item.baby_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","disabled":""},model:{value:(item.baby_gender),callback:function ($$v) {_vm.$set(item, "baby_gender", $$v)},expression:"item.baby_gender"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","disabled":""},model:{value:(item.mom_name),callback:function ($$v) {_vm.$set(item, "mom_name", $$v)},expression:"item.mom_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"皮肤：","disabled":""},model:{value:(item.skin),callback:function ($$v) {_vm.$set(item, "skin", $$v)},expression:"item.skin"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"眼睛：","disabled":""},model:{value:(item.eye),callback:function ($$v) {_vm.$set(item, "eye", $$v)},expression:"item.eye"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"口腔：","disabled":""},model:{value:(item.oral),callback:function ($$v) {_vm.$set(item, "oral", $$v)},expression:"item.oral"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"脐带：","disabled":""},model:{value:(item.umbilical),callback:function ($$v) {_vm.$set(item, "umbilical", $$v)},expression:"item.umbilical"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"呕吐：","disabled":""},model:{value:(item.vomit),callback:function ($$v) {_vm.$set(item, "vomit", $$v)},expression:"item.vomit"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"四肢张力：","disabled":""},model:{value:(item.tension_of_limbs),callback:function ($$v) {_vm.$set(item, "tension_of_limbs", $$v)},expression:"item.tension_of_limbs"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"神经反射：","disabled":""},model:{value:(item.nerve_reflex),callback:function ($$v) {_vm.$set(item, "nerve_reflex", $$v)},expression:"item.nerve_reflex"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"经皮胆红素(mg/dl)：","disabled":"","placeholder":"请输入经皮胆红素"},model:{value:(item.transcutaneous_bilirubin),callback:function ($$v) {_vm.$set(item, "transcutaneous_bilirubin", $$v)},expression:"item.transcutaneous_bilirubin"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"指导意见：","disabled":""},model:{value:(item.guiding_pinions),callback:function ($$v) {_vm.$set(item, "guiding_pinions", $$v)},expression:"item.guiding_pinions"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("签名：")]),_vm._v(" "),(item.autograph)?_c('div',{staticClass:"value"},[(item.autograph.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.autograph,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.autograph,"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('x-input',{attrs:{"title":"班次：","disabled":""},model:{value:(item.shifts),callback:function ($$v) {_vm.$set(item, "shifts", $$v)},expression:"item.shifts"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"查房人：","disabled":""},model:{value:(item.staff_name),callback:function ($$v) {_vm.$set(item, "staff_name", $$v)},expression:"item.staff_name"}})],1)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1004)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"房号：","disabled":""},model:{value:(item.room_number),callback:function ($$v) {_vm.$set(item, "room_number", $$v)},expression:"item.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","disabled":""},model:{value:(item.id_card),callback:function ($$v) {_vm.$set(item, "id_card", $$v)},expression:"item.id_card"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":""},model:{value:(item.baby_name),callback:function ($$v) {_vm.$set(item, "baby_name", $$v)},expression:"item.baby_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","disabled":""},model:{value:(item.sex),callback:function ($$v) {_vm.$set(item, "sex", $$v)},expression:"item.sex"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","disabled":""},model:{value:(item.mom_name),callback:function ($$v) {_vm.$set(item, "mom_name", $$v)},expression:"item.mom_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"日期：","disabled":""},model:{value:(item.cat_date),callback:function ($$v) {_vm.$set(item, "cat_date", $$v)},expression:"item.cat_date"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"母乳喂养(自喂:min)：","disabled":""},model:{value:(item.breast_feeding_auto),callback:function ($$v) {_vm.$set(item, "breast_feeding_auto", $$v)},expression:"item.breast_feeding_auto"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"母乳喂养(人喂:ml)：","disabled":""},model:{value:(item.breast_feeding_people),callback:function ($$v) {_vm.$set(item, "breast_feeding_people", $$v)},expression:"item.breast_feeding_people"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"人工喂养(人喂:min)：","disabled":""},model:{value:(item.people_feeding_peo),callback:function ($$v) {_vm.$set(item, "people_feeding_peo", $$v)},expression:"item.people_feeding_peo"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"人工喂养(配方奶:ml)：","disabled":""},model:{value:(item.people_feeding_formula),callback:function ($$v) {_vm.$set(item, "people_feeding_formula", $$v)},expression:"item.people_feeding_formula"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"饮水：","disabled":""},model:{value:(item.drinking_water),callback:function ($$v) {_vm.$set(item, "drinking_water", $$v)},expression:"item.drinking_water"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"其他：","disabled":""},model:{value:(item.other_desc),callback:function ($$v) {_vm.$set(item, "other_desc", $$v)},expression:"item.other_desc"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("签名：")]),_vm._v(" "),(item.autograph)?_c('div',{staticClass:"value"},[(item.autograph.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.autograph,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.autograph,"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('x-input',{attrs:{"title":"班次：","disabled":""},model:{value:(item.shifts),callback:function ($$v) {_vm.$set(item, "shifts", $$v)},expression:"item.shifts"}})],1)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1005)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"房号：","disabled":""},model:{value:(item.room_number),callback:function ($$v) {_vm.$set(item, "room_number", $$v)},expression:"item.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":""},model:{value:(item.mom_name),callback:function ($$v) {_vm.$set(item, "mom_name", $$v)},expression:"item.mom_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":""},model:{value:(item.delivery_type),callback:function ($$v) {_vm.$set(item, "delivery_type", $$v)},expression:"item.delivery_type"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"饮食：","disabled":""},model:{value:(item.diet),callback:function ($$v) {_vm.$set(item, "diet", $$v)},expression:"item.diet"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"睡眠：","disabled":""},model:{value:(item.sleep_time),callback:function ($$v) {_vm.$set(item, "sleep_time", $$v)},expression:"item.sleep_time"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"小便：","disabled":""},model:{value:(item.urine_num),callback:function ($$v) {_vm.$set(item, "urine_num", $$v)},expression:"item.urine_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"大便：","disabled":""},model:{value:(item.shit_num),callback:function ($$v) {_vm.$set(item, "shit_num", $$v)},expression:"item.shit_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"盥洗（刷牙）：","disabled":""},model:{value:(item.wash_brush),callback:function ($$v) {_vm.$set(item, "wash_brush", $$v)},expression:"item.wash_brush"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"盥洗（洗头）：","disabled":""},model:{value:(item.wash_hair),callback:function ($$v) {_vm.$set(item, "wash_hair", $$v)},expression:"item.wash_hair"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"盥洗（沐浴）：","disabled":""},model:{value:(item.wash_bath),callback:function ($$v) {_vm.$set(item, "wash_bath", $$v)},expression:"item.wash_bath"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"盥洗（会阴清洗）：","disabled":""},model:{value:(item.wash_clean),callback:function ($$v) {_vm.$set(item, "wash_clean", $$v)},expression:"item.wash_clean"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"运动（时间）：","disabled":""},model:{value:(item.sport_time),callback:function ($$v) {_vm.$set(item, "sport_time", $$v)},expression:"item.sport_time"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"运动（运动后评估）：","disabled":""},model:{value:(item.sport),callback:function ($$v) {_vm.$set(item, "sport", $$v)},expression:"item.sport"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"指导意见：","disabled":""},model:{value:(item.guiding_pinions),callback:function ($$v) {_vm.$set(item, "guiding_pinions", $$v)},expression:"item.guiding_pinions"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("签名：")]),_vm._v(" "),(item.autograph)?_c('div',{staticClass:"value"},[(item.autograph.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.autograph,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.autograph,"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('x-input',{attrs:{"title":"班次：","disabled":""},model:{value:(item.shifts),callback:function ($$v) {_vm.$set(item, "shifts", $$v)},expression:"item.shifts"}})],1)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1006)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"房号：","disabled":""},model:{value:(item.room_number),callback:function ($$v) {_vm.$set(item, "room_number", $$v)},expression:"item.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":""},model:{value:(item.mom_name),callback:function ($$v) {_vm.$set(item, "mom_name", $$v)},expression:"item.mom_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":""},model:{value:(item.delivery_type),callback:function ($$v) {_vm.$set(item, "delivery_type", $$v)},expression:"item.delivery_type"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"日期：","disabled":""},model:{value:(item.cat_date),callback:function ($$v) {_vm.$set(item, "cat_date", $$v)},expression:"item.cat_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"餐数：","disabled":""},model:{value:(item.number_of_meal),callback:function ($$v) {_vm.$set(item, "number_of_meal", $$v)},expression:"item.number_of_meal"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"进食情况：","disabled":""},model:{value:(item.eating_situation),callback:function ($$v) {_vm.$set(item, "eating_situation", $$v)},expression:"item.eating_situation"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"饮食特点（普通）：","disabled":""},model:{value:(item.trait_common),callback:function ($$v) {_vm.$set(item, "trait_common", $$v)},expression:"item.trait_common"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"饮食特点（特殊）：","disabled":""},model:{value:(item.trait_special),callback:function ($$v) {_vm.$set(item, "trait_special", $$v)},expression:"item.trait_special"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput3",attrs:{"title":"一日营养方案（碳水化合物:g）：","disabled":""},model:{value:(item.plan_carbohydrate),callback:function ($$v) {_vm.$set(item, "plan_carbohydrate", $$v)},expression:"item.plan_carbohydrate"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一日营养方案（蔬菜类:g）：","disabled":""},model:{value:(item.plan_vegetables),callback:function ($$v) {_vm.$set(item, "plan_vegetables", $$v)},expression:"item.plan_vegetables"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一日营养方案（水果类:g）：","disabled":""},model:{value:(item.plan_fruits),callback:function ($$v) {_vm.$set(item, "plan_fruits", $$v)},expression:"item.plan_fruits"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一日营养方案（肉类:g）：","disabled":""},model:{value:(item.plan_meat),callback:function ($$v) {_vm.$set(item, "plan_meat", $$v)},expression:"item.plan_meat"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一日营养方案（禽类:g）：","disabled":""},model:{value:(item.plan_birds),callback:function ($$v) {_vm.$set(item, "plan_birds", $$v)},expression:"item.plan_birds"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一日营养方案（鱼类:g）：","disabled":""},model:{value:(item.plan_fish),callback:function ($$v) {_vm.$set(item, "plan_fish", $$v)},expression:"item.plan_fish"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一日营养方案（蛋类:g）：","disabled":""},model:{value:(item.plan_egg),callback:function ($$v) {_vm.$set(item, "plan_egg", $$v)},expression:"item.plan_egg"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一日营养方案（豆制品类:g）：","disabled":""},model:{value:(item.plan_bean_products),callback:function ($$v) {_vm.$set(item, "plan_bean_products", $$v)},expression:"item.plan_bean_products"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一日营养方案（牛奶:g）：","disabled":""},model:{value:(item.plan_milk),callback:function ($$v) {_vm.$set(item, "plan_milk", $$v)},expression:"item.plan_milk"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一日营养方案（奶制品类:g）：","disabled":""},model:{value:(item.plan_dairy),callback:function ($$v) {_vm.$set(item, "plan_dairy", $$v)},expression:"item.plan_dairy"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一日营养方案（油类:g）：","disabled":""},model:{value:(item.plan_oils),callback:function ($$v) {_vm.$set(item, "plan_oils", $$v)},expression:"item.plan_oils"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一日营养方案（中药材:g）：","disabled":""},model:{value:(item.plan_traditional_chinese_medicine),callback:function ($$v) {_vm.$set(item, "plan_traditional_chinese_medicine", $$v)},expression:"item.plan_traditional_chinese_medicine"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"班次：","disabled":""},model:{value:(item.shifts),callback:function ($$v) {_vm.$set(item, "shifts", $$v)},expression:"item.shifts"}})],1)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1007)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"房号：","disabled":""},model:{value:(item.room_number),callback:function ($$v) {_vm.$set(item, "room_number", $$v)},expression:"item.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":""},model:{value:(item.maternal_name),callback:function ($$v) {_vm.$set(item, "maternal_name", $$v)},expression:"item.maternal_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":""},model:{value:(item.childbirth_way),callback:function ($$v) {_vm.$set(item, "childbirth_way", $$v)},expression:"item.childbirth_way"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"日期：","disabled":""},model:{value:(item.day_time),callback:function ($$v) {_vm.$set(item, "day_time", $$v)},expression:"item.day_time"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"产后天数(天)：","disabled":""},model:{value:(item.ponal_days_num),callback:function ($$v) {_vm.$set(item, "ponal_days_num", $$v)},expression:"item.ponal_days_num"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一般情况（体温:℃）：","disabled":""},model:{value:(item.coly_temperature),callback:function ($$v) {_vm.$set(item, "coly_temperature", $$v)},expression:"item.coly_temperature"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一般情况（脉搏:次/分）：","disabled":""},model:{value:(item.coly_pulse),callback:function ($$v) {_vm.$set(item, "coly_pulse", $$v)},expression:"item.coly_pulse"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"一般情况（体重:g）：","disabled":""},model:{value:(item.coly_weight),callback:function ($$v) {_vm.$set(item, "coly_weight", $$v)},expression:"item.coly_weight"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"生殖系统（宫底高）：","disabled":""},model:{value:(item.resys_gdg),callback:function ($$v) {_vm.$set(item, "resys_gdg", $$v)},expression:"item.resys_gdg"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"生殖系统（切口情况）：","disabled":"","value":item.resys_in_codin == '1'
                    ? '良好'
                    : item.resys_in_codin == '2'
                    ? '不良'
                    : '其他'}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"生殖系统（恶露）（量）：","disabled":"","value":item.resys_e_num == '1'
                    ? '少'
                    : item.resys_e_num == '2'
                    ? '中'
                    : item.resys_e_num == '3'
                    ? '多'
                    : item.resys_e_num == '5'
                    ? '正常'
                    : '无'}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"生殖系统（恶露）（色）：","disabled":"","value":item.resys_e_color == '1'
                    ? '暗红'
                    : item.resys_e_color == '2'
                    ? '鲜红'
                    : item.resys_e_color == '3'
                    ? '白色'
                    : item.resys_e_color == '5'
                    ? '正常'
                    : '无'}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"生殖系统（恶露）（嗅）：","disabled":"","value":item.resys_e_sniff == '1' ? '有' : '无'}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"乳房（乳汁量）：","disabled":"","value":item.bre_mike_num == '1'
                    ? '多'
                    : item.bre_mike_num == '2'
                    ? '中'
                    : item.bre_mike_num == '3'
                    ? '少'
                    : '回奶'}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"乳房（胀痛）：","disabled":"","value":item.bre_dis_pain == '1'
                    ? '无'
                    : item.bre_dis_pain == '2'
                    ? '左侧'
                    : item.bre_dis_pain == '3'
                    ? '右侧'
                    : '双侧'}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"乳房（乳头皲裂）：","disabled":"","value":item.bre_rup_nipple == '1'
                    ? '无'
                    : item.bre_rup_nipple == '2'
                    ? '左侧'
                    : item.bre_rup_nipple == '3'
                    ? '右侧'
                    : '双侧'}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"指导意见：","disabled":""},model:{value:(item.guid_opons),callback:function ($$v) {_vm.$set(item, "guid_opons", $$v)},expression:"item.guid_opons"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("签名：")]),_vm._v(" "),(item.autograph)?_c('div',{staticClass:"value"},[(item.autograph.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.autograph,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.autograph,"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('x-input',{attrs:{"title":"班次：","disabled":""},model:{value:(item.shifts),callback:function ($$v) {_vm.$set(item, "shifts", $$v)},expression:"item.shifts"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"查房人：","disabled":""},model:{value:(item.staff_name),callback:function ($$v) {_vm.$set(item, "staff_name", $$v)},expression:"item.staff_name"}})],1)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1008)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(_vm.memberInfo.room_name),callback:function ($$v) {_vm.$set(_vm.memberInfo, "room_name", $$v)},expression:"memberInfo.room_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":""},model:{value:(_vm.memberInfo.name),callback:function ($$v) {_vm.$set(_vm.memberInfo, "name", $$v)},expression:"memberInfo.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"入住日期：","disabled":""},model:{value:(_vm.memberInfo.liveDate),callback:function ($$v) {_vm.$set(_vm.memberInfo, "liveDate", $$v)},expression:"memberInfo.liveDate"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩日期：","disabled":""},model:{value:(_vm.memberInfo.childBirth),callback:function ($$v) {_vm.$set(_vm.memberInfo, "childBirth", $$v)},expression:"memberInfo.childBirth"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":""},model:{value:(item.delivery_type),callback:function ($$v) {_vm.$set(item, "delivery_type", $$v)},expression:"item.delivery_type"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"健康咨询日期："},model:{value:(item.advisory_date),callback:function ($$v) {_vm.$set(item, "advisory_date", $$v)},expression:"item.advisory_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"产后天数：","disabled":""},model:{value:(item.postpartum_days),callback:function ($$v) {_vm.$set(item, "postpartum_days", $$v)},expression:"item.postpartum_days"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"术口愈合情况：","disabled":""},model:{value:(item.healing),callback:function ($$v) {_vm.$set(item, "healing", $$v)},expression:"item.healing"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"宫底位置：","disabled":""},model:{value:(item.uterus_place),callback:function ($$v) {_vm.$set(item, "uterus_place", $$v)},expression:"item.uterus_place"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"恶露情况(量)：","disabled":""},model:{value:(item.lochia_amount),callback:function ($$v) {_vm.$set(item, "lochia_amount", $$v)},expression:"item.lochia_amount"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"恶露情况(色)：","disabled":""},model:{value:(item.lochia_color),callback:function ($$v) {_vm.$set(item, "lochia_color", $$v)},expression:"item.lochia_color"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"恶露情况(味)：","disabled":""},model:{value:(item.lochia_taste),callback:function ($$v) {_vm.$set(item, "lochia_taste", $$v)},expression:"item.lochia_taste"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"乳头皲裂：","disabled":""},model:{value:(item.chapped_nipple),callback:function ($$v) {_vm.$set(item, "chapped_nipple", $$v)},expression:"item.chapped_nipple"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"乳房情况：","disabled":""},model:{value:(item.breast),callback:function ($$v) {_vm.$set(item, "breast", $$v)},expression:"item.breast"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"乳汁量：","disabled":""},model:{value:(item.milk_amount),callback:function ($$v) {_vm.$set(item, "milk_amount", $$v)},expression:"item.milk_amount"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"大便：","disabled":""},model:{value:(item.stool),callback:function ($$v) {_vm.$set(item, "stool", $$v)},expression:"item.stool"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"小便：","disabled":""},model:{value:(item.pee),callback:function ($$v) {_vm.$set(item, "pee", $$v)},expression:"item.pee"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"特殊情况：","disabled":""},model:{value:(item.special_case),callback:function ($$v) {_vm.$set(item, "special_case", $$v)},expression:"item.special_case"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"查房人：","disabled":""},model:{value:(item.staff_name),callback:function ($$v) {_vm.$set(item, "staff_name", $$v)},expression:"item.staff_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"班次：","disabled":""},model:{value:(item.shifts),callback:function ($$v) {_vm.$set(item, "shifts", $$v)},expression:"item.shifts"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("签名：")]),_vm._v(" "),(item.agent_sign)?_c('div',{staticClass:"value"},[(item.agent_sign.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.agent_sign,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.agent_sign,"alt":""}})]):_vm._e()])])],1)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1009)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"房号：","disabled":""},model:{value:(_vm.memberInfo.room_name),callback:function ($$v) {_vm.$set(_vm.memberInfo, "room_name", $$v)},expression:"memberInfo.room_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"宝宝姓名：","disabled":""},model:{value:(item.baby_name),callback:function ($$v) {_vm.$set(item, "baby_name", $$v)},expression:"item.baby_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"入住日期：","disabled":""},model:{value:(item.liveData),callback:function ($$v) {_vm.$set(item, "liveData", $$v)},expression:"item.liveData"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"健康咨询日期：","disabled":""},model:{value:(item.advisory_date),callback:function ($$v) {_vm.$set(item, "advisory_date", $$v)},expression:"item.advisory_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生天数：","disabled":""},model:{value:(item.birth_day),callback:function ($$v) {_vm.$set(item, "birth_day", $$v)},expression:"item.birth_day"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"黄疸：","disabled":""},model:{value:(item.jaundice),callback:function ($$v) {_vm.$set(item, "jaundice", $$v)},expression:"item.jaundice"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"一般情况(头面部)：","disabled":""},model:{value:(item.head_face),callback:function ($$v) {_vm.$set(item, "head_face", $$v)},expression:"item.head_face"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"一般情况(心率)：","disabled":""},model:{value:(item.heart_rate),callback:function ($$v) {_vm.$set(item, "heart_rate", $$v)},expression:"item.heart_rate"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"一般情况(呼吸)：","disabled":""},model:{value:(item.breathing),callback:function ($$v) {_vm.$set(item, "breathing", $$v)},expression:"item.breathing"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"一般情况(四肢)：","disabled":""},model:{value:(item.limbs),callback:function ($$v) {_vm.$set(item, "limbs", $$v)},expression:"item.limbs"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"一般情况(腹部)：","disabled":""},model:{value:(item.abdomen),callback:function ($$v) {_vm.$set(item, "abdomen", $$v)},expression:"item.abdomen"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"一般情况(臀部)：","disabled":""},model:{value:(item.hip),callback:function ($$v) {_vm.$set(item, "hip", $$v)},expression:"item.hip"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"一般情况(生殖器)：","disabled":""},model:{value:(item.genitals),callback:function ($$v) {_vm.$set(item, "genitals", $$v)},expression:"item.genitals"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"特殊情况：","disabled":""},model:{value:(item.special_case),callback:function ($$v) {_vm.$set(item, "special_case", $$v)},expression:"item.special_case"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"处理：","disabled":""},model:{value:(item.deal),callback:function ($$v) {_vm.$set(item, "deal", $$v)},expression:"item.deal"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"班次：","disabled":""},model:{value:(item.shifts),callback:function ($$v) {_vm.$set(item, "shifts", $$v)},expression:"item.shifts"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"查房人：","disabled":""},model:{value:(item.staff_name),callback:function ($$v) {_vm.$set(item, "staff_name", $$v)},expression:"item.staff_name"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("签名：")]),_vm._v(" "),(item.agent_sign)?_c('div',{staticClass:"value"},[(item.agent_sign.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.agent_sign,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.agent_sign,"alt":""}})]):_vm._e()])])],1)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1010)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"房号：","disabled":""},model:{value:(_vm.memberInfo.room_name),callback:function ($$v) {_vm.$set(_vm.memberInfo, "room_name", $$v)},expression:"memberInfo.room_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":""},model:{value:(_vm.memberInfo.name),callback:function ($$v) {_vm.$set(_vm.memberInfo, "name", $$v)},expression:"memberInfo.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":""},model:{value:(item.delivery_type),callback:function ($$v) {_vm.$set(item, "delivery_type", $$v)},expression:"item.delivery_type"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"日期：","disabled":""},model:{value:(item.record_date),callback:function ($$v) {_vm.$set(item, "record_date", $$v)},expression:"item.record_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"时间：","disabled":""},model:{value:(item.record_hour),callback:function ($$v) {_vm.$set(item, "record_hour", $$v)},expression:"item.record_hour"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"护理记录：","disabled":""},model:{value:(item.detail),callback:function ($$v) {_vm.$set(item, "detail", $$v)},expression:"item.detail"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"班次：","disabled":""},model:{value:(item.shifts),callback:function ($$v) {_vm.$set(item, "shifts", $$v)},expression:"item.shifts"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"查房人：","disabled":""},model:{value:(item.staff_name),callback:function ($$v) {_vm.$set(item, "staff_name", $$v)},expression:"item.staff_name"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("签名：")]),_vm._v(" "),(item.agent_sign)?_c('div',{staticClass:"value"},[(item.agent_sign.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.agent_sign,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.agent_sign,"alt":""}})]):_vm._e()])])],1)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1011)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"房号：","disabled":""},model:{value:(_vm.memberInfo.room_name),callback:function ($$v) {_vm.$set(_vm.memberInfo, "room_name", $$v)},expression:"memberInfo.room_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","disabled":""},model:{value:(item.hand_card),callback:function ($$v) {_vm.$set(item, "hand_card", $$v)},expression:"item.hand_card"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"宝宝姓名：","disabled":""},model:{value:(item.baby_name),callback:function ($$v) {_vm.$set(item, "baby_name", $$v)},expression:"item.baby_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"宝宝性别：","disabled":""},model:{value:(item.sex),callback:function ($$v) {_vm.$set(item, "sex", $$v)},expression:"item.sex"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","disabled":""},model:{value:(_vm.memberInfo.name),callback:function ($$v) {_vm.$set(_vm.memberInfo, "name", $$v)},expression:"memberInfo.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":""},model:{value:(_vm.memberInfo.birthType),callback:function ($$v) {_vm.$set(_vm.memberInfo, "birthType", $$v)},expression:"memberInfo.birthType"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"日期：","disabled":""},model:{value:(item.record_date),callback:function ($$v) {_vm.$set(item, "record_date", $$v)},expression:"item.record_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"时间：","disabled":""},model:{value:(item.record_hour),callback:function ($$v) {_vm.$set(item, "record_hour", $$v)},expression:"item.record_hour"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"护理记录：","disabled":""},model:{value:(item.detail),callback:function ($$v) {_vm.$set(item, "detail", $$v)},expression:"item.detail"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"班次：","disabled":""},model:{value:(item.shifts),callback:function ($$v) {_vm.$set(item, "shifts", $$v)},expression:"item.shifts"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"查房人：","disabled":""},model:{value:(item.staff_name),callback:function ($$v) {_vm.$set(item, "staff_name", $$v)},expression:"item.staff_name"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("签名：")]),_vm._v(" "),(item.agent_sign)?_c('div',{staticClass:"value"},[(item.agent_sign.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.agent_sign,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.agent_sign,"alt":""}})]):_vm._e()])])],1)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1012)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"本人为：","disabled":""},model:{value:(item.room_number),callback:function ($$v) {_vm.$set(item, "room_number", $$v)},expression:"item.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"入住产妇：","disabled":""},model:{value:(item.maternal_name),callback:function ($$v) {_vm.$set(item, "maternal_name", $$v)},expression:"item.maternal_name"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput4",attrs:{"title":"现正式委托责任护士遵医嘱为本人之：","disabled":"","value":item.entrust_man == '1'
                    ? '子'
                    : item.entrust_man == '2'
                    ? '女'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"title shengStyleInput3",attrs:{"title":"以下喂服新生儿药物","disabled":""}}),_vm._v(" "),_vm._l((item.drug_matter),function(k,i){return _c('div',{key:i,staticClass:"vux-1px-t"},[_c('x-input',{attrs:{"title":i + 1 + '.' + '药名：',"disabled":""},model:{value:(k.drug_name),callback:function ($$v) {_vm.$set(k, "drug_name", $$v)},expression:"k.drug_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"使用方法：","disabled":""},model:{value:(k.use_method),callback:function ($$v) {_vm.$set(k, "use_method", $$v)},expression:"k.use_method"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"服用剂量：","disabled":""},model:{value:(k.take_dost),callback:function ($$v) {_vm.$set(k, "take_dost", $$v)},expression:"k.take_dost"}})],1)}),_vm._v(" "),_c('x-input',{attrs:{"title":"喂药时间：","disabled":""},model:{value:(item.entrust_time),callback:function ($$v) {_vm.$set(item, "entrust_time", $$v)},expression:"item.entrust_time"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("家属签名：")]),_vm._v(" "),(item.family_sign)?_c('div',{staticClass:"value"},[(item.family_sign.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.family_sign,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.family_sign,"alt":""}})]):_vm._e()])]),_vm._v(" "),_vm._l((item.nurse_sign),function(k,i){return _c('div',{key:i + 'a',staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("\n                    责任护士签名：\n                  ")]),_vm._v(" "),(k)?_c('div',{staticClass:"value"},[(k.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":k,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + k,"alt":""}})]):_vm._e()])])}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("\n                    护士组长签名：\n                  ")]),_vm._v(" "),(item.group_nurse_sign)?_c('div',{staticClass:"value"},[(item.group_nurse_sign.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.group_nurse_sign,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.group_nurse_sign,"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("\n                    护士长签名：\n                  ")]),_vm._v(" "),(item.nurse_long_sign)?_c('div',{staticClass:"value"},[(item.nurse_long_sign.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.nurse_long_sign,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.nurse_long_sign,"alt":""}})]):_vm._e()])])],2)}),1):_vm._e(),_vm._v(" "),(_vm.form_id == 1013)?_c('div',{staticClass:"shengFormListDetailList"},_vm._l((_vm.formListDetailList),function(item,index){return _c('group',{key:index,staticClass:"shengEditContent"},[_c('div',{staticClass:"Obtn"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.from_title))]),_vm._v(" "),_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.id)}}},[_vm._v("编辑")])],1),_vm._v(" "),_c('x-textarea',{attrs:{"disabled":""},model:{value:(item.base_sense),callback:function ($$v) {_vm.$set(item, "base_sense", $$v)},expression:"item.base_sense"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"1.母乳喂养的姿势：","disabled":"","value":item.feed_raise_posture == '1'
                    ? '是'
                    : item.feed_raise_posture == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"2.宝宝拍嗝的方法：","disabled":"","value":item.hiccup_method == '1'
                    ? '是'
                    : item.hiccup_method == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"3.产妇乳房护理指导：","disabled":"","value":item.nursing_guidance == '1'
                    ? '是'
                    : item.nursing_guidance == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"4.如何预防乳腺炎：","disabled":"","value":item.preven_mastitis == '1'
                    ? '是'
                    : item.preven_mastitis == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"5.如何更换尿片：","disabled":"","value":item.change_diapers == '1'
                    ? '是'
                    : item.change_diapers == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"6.如何洗屁股：","disabled":"","value":item.wash_ass == '1'
                    ? '是'
                    : item.wash_ass == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"7.奶瓶的喂养方法：","disabled":"","value":item.milk_feed_method == '1'
                    ? '是'
                    : item.milk_feed_method == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"8.宝宝晒太阳的方法：","disabled":"","value":item.baby_sun_method == '1'
                    ? '是'
                    : item.baby_sun_method == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"9.母乳的存放和解冻方法：","disabled":"","value":item.breast_milk_method == '1'
                    ? '是'
                    : item.breast_milk_method == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"10.产褥操的指导：","disabled":"","value":item.puerperal_guidance == '1'
                    ? '是'
                    : item.puerperal_guidance == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"11.奶粉的冲调方法：","disabled":"","value":item.milk_punch_method == '1'
                    ? '是'
                    : item.milk_punch_method == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"12.如何给宝宝穿脱衣服：","disabled":"","value":item.baby_undress == '1'
                    ? '是'
                    : item.baby_undress == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"13.回奶观察指导：","disabled":"","value":item.return_milk_guidance == '1'
                    ? '是'
                    : item.return_milk_guidance == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"14.宝宝理胎发后如何处理：","disabled":"","value":item.baby_after_hair == '1'
                    ? '是'
                    : item.baby_after_hair == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"15.如何给宝宝洗澡：","disabled":"","value":item.baby_bath == '1'
                    ? '是'
                    : item.baby_bath == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"16.出会所指导：","disabled":"","value":item.meeting_guidance == '1'
                    ? '是'
                    : item.meeting_guidance == '2'
                    ? '否'
                    : ''}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput",attrs:{"title":"您有宝贵的建议吗？","disabled":""},model:{value:(item.valuable_proposal),callback:function ($$v) {_vm.$set(item, "valuable_proposal", $$v)},expression:"item.valuable_proposal"}}),_vm._v(" "),_c('x-input',{staticClass:"shengStyleInput2",attrs:{"title":"月子期间有出现病理现象：","disabled":""},model:{value:(item.illness_phenomenon),callback:function ($$v) {_vm.$set(item, "illness_phenomenon", $$v)},expression:"item.illness_phenomenon"}}),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("\n                    产妇确认签名：\n                  ")]),_vm._v(" "),(item.maternal_sign)?_c('div',{staticClass:"value"},[(item.maternal_sign.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.maternal_sign,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.maternal_sign,"alt":""}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"listItem",staticStyle:{"padding-left":"15px !important"}},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0 !important"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0"}},[_vm._v("护士签名：")]),_vm._v(" "),(item.nursing_sign)?_c('div',{staticClass:"value"},[(item.nursing_sign.indexOf(_vm.get_host) != -1)?_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":item.nursing_sign,"alt":""}}):_c('img',{staticClass:"showImage",staticStyle:{"max-width":"100%"},attrs:{"src":_vm.get_host + item.nursing_sign,"alt":""}})]):_vm._e()])])],1)}),1):_vm._e()])],1)])])],1)}
var check_room_service_staticRenderFns = []
var check_room_service_esExports = { render: check_room_service_render, staticRenderFns: check_room_service_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_check_room_service = (check_room_service_esExports);
// CONCATENATED MODULE: ./src/components/check_room_service.vue
function check_room_service_injectStyle (ssrContext) {
  __webpack_require__("QQJx")
}
var check_room_service_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var check_room_service___vue_template_functional__ = false
/* styles */
var check_room_service___vue_styles__ = check_room_service_injectStyle
/* scopeId */
var check_room_service___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var check_room_service___vue_module_identifier__ = null
var check_room_service_Component = check_room_service_normalizeComponent(
  components_check_room_service,
  selectortype_template_index_0_src_components_check_room_service,
  check_room_service___vue_template_functional__,
  check_room_service___vue_styles__,
  check_room_service___vue_scopeId__,
  check_room_service___vue_module_identifier__
)

/* harmony default export */ var src_components_check_room_service = (check_room_service_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/check_room_record.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var check_room_record = ({
    name: "check_room_record",
    data: function data() {
        return {
            date: '',
            form_type: '',
            form_type_options: [],
            keyword: '',
            page: '1',
            id: this.$route.query.id,
            tabVal: this.$route.query.tabVal,
            listData: [],
            pullupDefaultConfig: {
                content: '上拉加载更多',
                pullUpHeight: 60,
                height: 40,
                autoRefresh: false,
                downContent: '释放后加载',
                upContent: '上拉加载更多',
                loadingContent: '加载中...',
                clsPrefix: 'xs-plugin-pullup-'
            },
            pulldownDefaultConfig: {
                content: '下拉刷新',
                height: 40,
                autoRefresh: false,
                downContent: '下拉刷新',
                upContent: '释放后刷新',
                loadingContent: '正在刷新...',
                clsPrefix: 'xs-plugin-pulldown-'
            }
        };
    },

    methods: {
        // dateOnConfirm(value){
        //     this.date = value
        //     this.refresh()
        // },
        //获取表单查房列表
        apiFormList: function apiFormList() {
            var _this = this;

            var that = this;
            var params = {
                token: this.$cookie.get('token')
            };
            Api.checkRoomApi.roundFormList(params).then(function (res) {
                if (res.errcode == 1) {
                    if (res.data.length) {
                        _this.form_type_options = [];
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                _this.form_type_options.push({
                                    key: item.id,
                                    value: item.name
                                });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日';
        },
        cInput: function cInput() {
            this.keyword = '';
            this.refresh();
        },
        searchBtn: function searchBtn() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.scrollerBottom.reset({ top: 0 });
                _this2.refresh();
            });
        },
        clearBtn: function clearBtn() {
            var that = this;
            that.keyword = '';
            that.form_type = '';
            that.date = '';
            this.refresh();
            this.$vux.toast.show({
                type: 'success',
                text: '已清空'
            });
        },

        // select_form_change(value){
        //     console.info('哇靠')
        //     this.form_type = value
        //     this.refresh()
        // },
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this3 = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id,
                keyword: this.keyword,
                date: this.date,
                form_type: this.form_type,
                page: this.page
                // console.log(params)
            };Api.checkRoomApi.roundAllList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.page++;
                    _this3.$nextTick(function () {
                        _this3.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = get_iterator_default()(res.data.list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var item = _step2.value;

                                var createTime = _this3.formatDateTime(item.create_time);
                                if (createTime.indexOf("NaN") === -1) {
                                    createTime = _this3.formatDateTime(item.create_time);
                                } else {
                                    createTime = '';
                                }
                                var obj = {
                                    create_time: createTime,
                                    form_id: item.form_id,
                                    form_name: item.form_name,
                                    id: item.id,
                                    maternal_info_id: item.maternal_info_id,
                                    user_name: item.user_name
                                };
                                _this3.listData.push(obj);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
                            _this3.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
                        } else {
                            _this3.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
                        }
                        if (res.data.page.page == res.data.page.page_count) {
                            _this3.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行   
                        }
                    } else {
                        var arr = [];
                        for (var i in res.data.list) {
                            arr.push(res.data.list[i]);
                        }
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = get_iterator_default()(arr), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var _item = _step3.value;

                                var createTime = _this3.formatDateTime(_item.create_time);
                                if (createTime.indexOf("NaN") === -1) {
                                    createTime = _this3.formatDateTime(_item.create_time);
                                } else {
                                    createTime = '';
                                }
                                var _obj = {
                                    create_time: createTime,
                                    form_id: _item.form_id,
                                    form_name: _item.form_name,
                                    id: _item.id,
                                    maternal_info_id: _item.maternal_info_id,
                                    user_name: _item.user_name
                                };
                                _this3.listData.push(_obj);
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }

                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
                            _this3.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
                        } else {
                            _this3.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
                        }
                        if (res.data.page.page == res.data.page.page_count) {
                            _this3.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行   
                        }
                    }
                    _this3.$vux.loading.hide();
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData = [];
            this.page = '1';
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        }
    },
    created: function created() {
        // this.$nextTick(() => {
        //     this.$refs.scrollerBottom.reset({top: 0})
        // })
        this.apiFormList();
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/check_room_record.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_check_room_record = ({
    name: "check_room_record",
    data: function data() {
        return {
            date: '',
            form_type: '',
            form_type_options: [],
            keyword: '',
            page: '1',
            id: this.$route.query.id,
            tabVal: this.$route.query.tabVal,
            listData: [],
            pullupDefaultConfig: {
                content: '上拉加载更多',
                pullUpHeight: 60,
                height: 40,
                autoRefresh: false,
                downContent: '释放后加载',
                upContent: '上拉加载更多',
                loadingContent: '加载中...',
                clsPrefix: 'xs-plugin-pullup-'
            },
            pulldownDefaultConfig: {
                content: '下拉刷新',
                height: 40,
                autoRefresh: false,
                downContent: '下拉刷新',
                upContent: '释放后刷新',
                loadingContent: '正在刷新...',
                clsPrefix: 'xs-plugin-pulldown-'
            }
        };
    },

    methods: {
        // dateOnConfirm(value){
        //     this.date = value
        //     this.refresh()
        // },
        //获取表单查房列表
        apiFormList: function apiFormList() {
            var _this = this;

            var that = this;
            var params = {
                token: this.$cookie.get('token')
            };
            Api.checkRoomApi.roundFormList(params).then(function (res) {
                if (res.errcode == 1) {
                    if (res.data.length) {
                        _this.form_type_options = [];
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                _this.form_type_options.push({
                                    key: item.id,
                                    value: item.name
                                });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日';
        },
        cInput: function cInput() {
            this.keyword = '';
            this.refresh();
        },
        searchBtn: function searchBtn() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.scrollerBottom.reset({ top: 0 });
                _this2.refresh();
            });
        },
        clearBtn: function clearBtn() {
            var that = this;
            that.keyword = '';
            that.form_type = '';
            that.date = '';
            this.refresh();
            this.$vux.toast.show({
                type: 'success',
                text: '已清空'
            });
        },

        // select_form_change(value){
        //     console.info('哇靠')
        //     this.form_type = value
        //     this.refresh()
        // },
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this3 = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id,
                keyword: this.keyword,
                date: this.date,
                form_type: this.form_type,
                page: this.page
                // console.log(params)
            };Api.checkRoomApi.roundAllList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.page++;
                    _this3.$nextTick(function () {
                        _this3.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = get_iterator_default()(res.data.list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var item = _step2.value;

                                var createTime = _this3.formatDateTime(item.create_time);
                                if (createTime.indexOf("NaN") === -1) {
                                    createTime = _this3.formatDateTime(item.create_time);
                                } else {
                                    createTime = '';
                                }
                                var obj = {
                                    create_time: createTime,
                                    form_id: item.form_id,
                                    form_name: item.form_name,
                                    id: item.id,
                                    maternal_info_id: item.maternal_info_id,
                                    user_name: item.user_name
                                };
                                _this3.listData.push(obj);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }

                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
                            _this3.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
                        } else {
                            _this3.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
                        }
                        if (res.data.page.page == res.data.page.page_count) {
                            _this3.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行   
                        }
                    } else {
                        var arr = [];
                        for (var i in res.data.list) {
                            arr.push(res.data.list[i]);
                        }
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = get_iterator_default()(arr), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var _item = _step3.value;

                                var createTime = _this3.formatDateTime(_item.create_time);
                                if (createTime.indexOf("NaN") === -1) {
                                    createTime = _this3.formatDateTime(_item.create_time);
                                } else {
                                    createTime = '';
                                }
                                var _obj = {
                                    create_time: createTime,
                                    form_id: _item.form_id,
                                    form_name: _item.form_name,
                                    id: _item.id,
                                    maternal_info_id: _item.maternal_info_id,
                                    user_name: _item.user_name
                                };
                                _this3.listData.push(_obj);
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }

                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
                            _this3.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
                        } else {
                            _this3.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
                        }
                        if (res.data.page.page == res.data.page.page_count) {
                            _this3.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行   
                        }
                    }
                    _this3.$vux.loading.hide();
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData = [];
            this.page = '1';
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        }
    },
    created: function created() {
        // this.$nextTick(() => {
        //     this.$refs.scrollerBottom.reset({top: 0})
        // })
        this.apiFormList();
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62283d38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/check_room_record.vue
var check_room_record_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("查房记录")]),_vm._v(" "),_c('div',{staticClass:"main1"},[_c('flexbox',[_c('flexbox-item',[_c('group',[_c('x-input',{staticStyle:{"font-szie":"12px"},attrs:{"placeholder":"请输入查房人名称"},on:{"on-click-clear-icon":_vm.cInput},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}})],1)],1),_vm._v(" "),_c('flexbox-item',[_c('group',[_c('datetime',{attrs:{"placeholder":"请选择日期"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('flexbox-item',[_c('group',[_c('selector',{attrs:{"placeholder":"查房类型","options":_vm.form_type_options},model:{value:(_vm.form_type),callback:function ($$v) {_vm.form_type=$$v},expression:"form_type"}})],1)],1),_vm._v(" "),_c('flexbox-item',{staticStyle:{"margin-left":"0px"}},[_c('x-button',{staticStyle:{"margin-top":"18px","margin-left":"20px"},attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.searchBtn.apply(null, arguments)}}},[_vm._v("搜索")])],1),_vm._v(" "),_c('flexbox-item',{staticStyle:{"margin-left":"0px"}},[_c('x-button',{staticStyle:{"margin-top":"18px"},attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.clearBtn.apply(null, arguments)}}},[_vm._v("清空筛选")])],1)],1),_vm._v(" "),_c('div',{staticClass:"sheng-table vux-1px"},[_vm._m(0),_vm._v(" "),_c('scroller',{ref:"scrollerBottom",staticClass:"tbody",attrs:{"use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"use-pulldown":"","pulldown-config":_vm.pulldownDefaultConfig,"lock-x":"","height":"-180"},on:{"on-pullup-loading":_vm.loadMore,"on-pulldown-loading":_vm.refresh}},[_c('div',_vm._l((_vm.listData),function(item,index){return _c('li',{key:index,staticClass:"vux-1px-b"},[_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"30%"}},[_vm._v(_vm._s(item.create_time))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"25%"}},[_vm._v(_vm._s(item.form_name))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v(_vm._s(item.user_name))]),_vm._v(" "),_c('div',{staticStyle:{"width":"20%"}},[_c('router-link',{attrs:{"to":{path: './detail_other_form?answer_id=' + item.id +'&form_id=' + item.form_id +'&id=' +_vm.id +'&tabVal=' +_vm.tabVal}}},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""}},[_vm._v(_vm._s(item.create_time ? '查看详情' : '填写表单'))])],1)],1)])}),0)])],1)],1)],1)}
var check_room_record_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"thead"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v("序号")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"30%"}},[_vm._v("查房时间")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"25%"}},[_vm._v("所用表格")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v("查房人")]),_vm._v(" "),_c('li',{staticStyle:{"width":"20%"}},[_vm._v("操作")])])}]
var check_room_record_esExports = { render: check_room_record_render, staticRenderFns: check_room_record_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_check_room_record = (check_room_record_esExports);
// CONCATENATED MODULE: ./src/components/check_room_record.vue
function check_room_record_injectStyle (ssrContext) {
  __webpack_require__("gZbD")
}
var check_room_record_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var check_room_record___vue_template_functional__ = false
/* styles */
var check_room_record___vue_styles__ = check_room_record_injectStyle
/* scopeId */
var check_room_record___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var check_room_record___vue_module_identifier__ = null
var check_room_record_Component = check_room_record_normalizeComponent(
  components_check_room_record,
  selectortype_template_index_0_src_components_check_room_record,
  check_room_record___vue_template_functional__,
  check_room_record___vue_styles__,
  check_room_record___vue_scopeId__,
  check_room_record___vue_module_identifier__
)

/* harmony default export */ var src_components_check_room_record = (check_room_record_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/add_from_record.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var add_from_record = ({
  name: 'add_from_record',
  data: function data() {
    return {
      memberInfo: {
        name: '',
        phone: '',
        package: '',
        liveDate: '',
        childBirth: '',
        birthType: '',
        babyType: [{
          label: '顺产',
          value: '1'
        }, {
          label: '剖宫产',
          value: '2'
        }, {
          label: '早产',
          value: '3'
        }, {
          label: '不知道',
          value: '0'
        }]
      },
      form_name: '',
      indexList: '',
      showSearch: true,
      has_answer: '', //是否填过答案
      id: this.$route.query.id,
      member_column_list: [], //表单数组
      column_list: [], //表单数组
      is_drapList: false,
      //孕妇列表
      maternal_list: [],
      //签名
      is_edit: true, //是否显示
      tmpImageUpload: {},
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      host: api_const["host"],
      pinyin_array: []
    };
  },

  methods: {
    //替换所有换行符
    replaceAllNewLine: function replaceAllNewLine(content) {
      var string = content;
      try {
        string = string.replace(/\r\n/g, "<br>");
        string = string.replace(/\n/g, "<br>");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },


    //替换br成换行
    replaceAllBr: function replaceAllBr(content) {
      var string = content;
      try {
        string = string.replace("<br>", "\n").replace("<br>", "\n");
        string = string.replace("<br>", "\n");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },
    textareaBlur: function textareaBlur(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.column_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column_list_item = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(column_list_item.row_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var row_list_item = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = get_iterator_default()(row_list_item.content), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var content_item = _step3.value;

                  if (content_item.id == id) {
                    content_item.my_answer = this.replaceAllBr(content_item.my_answer);
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },

    //时间戳转日期格式    
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '年' + m + '月' + d + '日';
    },

    //请求用户基本信息
    apiMemberInfo: function apiMemberInfo() {
      var _this = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.memberInfo(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this.memberInfo.name = res.data.name;
          _this.memberInfo.phone = res.data.phone;
          _this.memberInfo.package = res.data.package_name;
          _this.memberInfo.liveDate = _this.formatDateTime(res.data.live_time);
          _this.memberInfo.childBirth = _this.formatDateTime(res.data.child_birth);
          var birthType = '';
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = get_iterator_default()(_this.memberInfo.babyType), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var item = _step4.value;

              if (res.data.birth_type == item.value) {
                birthType = item.label;
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          _this.memberInfo.birthType = birthType;
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(arr), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return false;
    },

    //打开选择查房人
    selece_cfr: function selece_cfr(name, id) {
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = get_iterator_default()(this.column_list), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var column_list_item = _step6.value;
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = get_iterator_default()(column_list_item.row_list), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var row_list_item = _step7.value;
              var _iteratorNormalCompletion8 = true;
              var _didIteratorError8 = false;
              var _iteratorError8 = undefined;

              try {
                for (var _iterator8 = get_iterator_default()(row_list_item.content), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                  var content_item = _step8.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.indexList = '';
                  }
                }
              } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                  }
                } finally {
                  if (_didIteratorError8) {
                    throw _iteratorError8;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    },

    //选择查房人
    selectPeople: function selectPeople(id) {
      if (this.indexList) {
        this.indexList = '';
        return;
      }
      this.indexList = id;
    },

    //数组排序
    arrar_sort: function arrar_sort(newArr, oldArr) {
      var newList = [];
      var pyArrSort = newArr.sort();
      var i = 0;
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = get_iterator_default()(pyArrSort), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var item = _step9.value;
          var _iteratorNormalCompletion10 = true;
          var _didIteratorError10 = false;
          var _iteratorError10 = undefined;

          try {
            for (var _iterator10 = get_iterator_default()(oldArr), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
              var list = _step10.value;

              if (item == list.pinyin) {
                newList[i] = list;
              }
            }
          } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
              }
            } finally {
              if (_didIteratorError10) {
                throw _iteratorError10;
              }
            }
          }

          i++;
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return newList;
    },
    cfr_list: function cfr_list(arr) {
      if (arr.length) {
        var nurser_name_arr = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = get_iterator_default()(arr), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var item = _step11.value;

            var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
            var obj = {
              name: [item.user_name],
              pinyin: _py
            };
            nurser_name_arr.push(obj);
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        var pyArr = [];
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
          for (var _iterator12 = get_iterator_default()(nurser_name_arr), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var _item = _step12.value;

            var obj = {
              name: _item.name,
              pinyin: _item.pinyin
            };
            var is_have = this.isInArray(pyArr, _item.pinyin);
            if (!is_have) {
              //不存在
              pyArr.push(_item.pinyin);
              this.pinyin_array.push(_item.pinyin);
              this.pinyin_array.sort();
              this.maternal_list.push(obj);
            } else {
              //存在
              var _index = pyArr.indexOf(_item.pinyin);
              this.maternal_list[_index].name.push(_item.name.join(''));
            }
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }

        this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
      }
    },

    //请求孕妇表单配置信息
    apiFromList: function apiFromList() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id
        //编辑进来的添加一个参数
      };if (this.$route.query.answer_id) {
        params.answer_id = this.$route.query.answer_id;
      }
      console.info(params);
      Api.checkRoomApi.addRecordFrom(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this2.has_answer = res.data.has_answer;
          _this2.form_name = res.data.form_data.name;
          _this2.member_column_list = res.data.column_list;
          var _iteratorNormalCompletion13 = true;
          var _didIteratorError13 = false;
          var _iteratorError13 = undefined;

          try {
            for (var _iterator13 = get_iterator_default()(res.data.form_data.column_list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
              var column_list_item = _step13.value;
              var _iteratorNormalCompletion14 = true;
              var _didIteratorError14 = false;
              var _iteratorError14 = undefined;

              try {
                for (var _iterator14 = get_iterator_default()(column_list_item.row_list), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                  var row_list_item = _step14.value;
                  var _iteratorNormalCompletion15 = true;
                  var _didIteratorError15 = false;
                  var _iteratorError15 = undefined;

                  try {
                    for (var _iterator15 = get_iterator_default()(row_list_item.content), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                      var content_item = _step15.value;
                      var _iteratorNormalCompletion16 = true;
                      var _didIteratorError16 = false;
                      var _iteratorError16 = undefined;

                      try {
                        for (var _iterator16 = get_iterator_default()(_this2.member_column_list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                          var item = _step16.value;

                          if (content_item.column_name == item.name) {
                            content_item.tip = item.value;
                          }
                        }
                      } catch (err) {
                        _didIteratorError16 = true;
                        _iteratorError16 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion16 && _iterator16.return) {
                            _iterator16.return();
                          }
                        } finally {
                          if (_didIteratorError16) {
                            throw _iteratorError16;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError15 = true;
                    _iteratorError15 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion15 && _iterator15.return) {
                        _iterator15.return();
                      }
                    } finally {
                      if (_didIteratorError15) {
                        throw _iteratorError15;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError14 = true;
                _iteratorError14 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion14 && _iterator14.return) {
                    _iterator14.return();
                  }
                } finally {
                  if (_didIteratorError14) {
                    throw _iteratorError14;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError13 = true;
            _iteratorError13 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion13 && _iterator13.return) {
                _iterator13.return();
              }
            } finally {
              if (_didIteratorError13) {
                throw _iteratorError13;
              }
            }
          }

          _this2.column_list = res.data.form_data.column_list;
          //孕妇列表
          _this2.cfr_list(res.data.nurser_name);
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    input_focus: function input_focus(id) {
      this.is_drapList = id;
    },
    menuClick: function menuClick(name, id) {
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = get_iterator_default()(this.column_list), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var column_list_item = _step17.value;
          var _iteratorNormalCompletion18 = true;
          var _didIteratorError18 = false;
          var _iteratorError18 = undefined;

          try {
            for (var _iterator18 = get_iterator_default()(column_list_item.row_list), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
              var row_list_item = _step18.value;
              var _iteratorNormalCompletion19 = true;
              var _didIteratorError19 = false;
              var _iteratorError19 = undefined;

              try {
                for (var _iterator19 = get_iterator_default()(row_list_item.content), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                  var content_item = _step19.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.is_drapList = '';
                  }
                }
              } catch (err) {
                _didIteratorError19 = true;
                _iteratorError19 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion19 && _iterator19.return) {
                    _iterator19.return();
                  }
                } finally {
                  if (_didIteratorError19) {
                    throw _iteratorError19;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError18 = true;
            _iteratorError18 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion18 && _iterator18.return) {
                _iterator18.return();
              }
            } finally {
              if (_didIteratorError18) {
                throw _iteratorError18;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }
    },

    //保存签名
    save: function save(id) {
      var signature = 'signature' + id;
      var png = this.$refs[signature][0].save();
      var jpeg = this.$refs[signature][0].save('image/jpeg');
      var svg = this.$refs[signature][0].save('image/svg+xml');
      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;

      try {
        for (var _iterator20 = get_iterator_default()(this.column_list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var column_list_item = _step20.value;
          var _iteratorNormalCompletion21 = true;
          var _didIteratorError21 = false;
          var _iteratorError21 = undefined;

          try {
            for (var _iterator21 = get_iterator_default()(column_list_item.row_list), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
              var row_list_item = _step21.value;
              var _iteratorNormalCompletion22 = true;
              var _didIteratorError22 = false;
              var _iteratorError22 = undefined;

              try {
                for (var _iterator22 = get_iterator_default()(row_list_item.content), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                  var content_item = _step22.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [encodeURI(png)];
                    this.is_edit = '';
                  }
                }
              } catch (err) {
                _didIteratorError22 = true;
                _iteratorError22 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion22 && _iterator22.return) {
                    _iterator22.return();
                  }
                } finally {
                  if (_didIteratorError22) {
                    throw _iteratorError22;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError21 = true;
            _iteratorError21 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion21 && _iterator21.return) {
                _iterator21.return();
              }
            } finally {
              if (_didIteratorError21) {
                throw _iteratorError21;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }
    },

    //清除签名
    clear: function clear(id) {
      var signature = 'signature' + id;
      var refs = this.$refs[signature][0].clear();
    },

    //编辑签名
    edit_signature: function edit_signature(id) {
      this.is_edit = id;
    },

    //图片上传
    fileImage: function fileImage(e) {
      var file = e.target.files[0];
      var item_id = e.target.id;
      console.info(item_id);
      var that = this;
      lrz(file).then(function (rst) {
        // 处理成功会执行
        var _iteratorNormalCompletion23 = true;
        var _didIteratorError23 = false;
        var _iteratorError23 = undefined;

        try {
          for (var _iterator23 = get_iterator_default()(that.column_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
            var column_list_item = _step23.value;
            var _iteratorNormalCompletion24 = true;
            var _didIteratorError24 = false;
            var _iteratorError24 = undefined;

            try {
              for (var _iterator24 = get_iterator_default()(column_list_item.row_list), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                var row_list_item = _step24.value;
                var _iteratorNormalCompletion25 = true;
                var _didIteratorError25 = false;
                var _iteratorError25 = undefined;

                try {
                  for (var _iterator25 = get_iterator_default()(row_list_item.content), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                    var content_item = _step25.value;

                    if (content_item.id == item_id) {
                      if (content_item.my_answer.length == 10) {
                        that.$vux.toast.show({
                          type: 'cancel',
                          text: '最多上传10张图片'
                        });
                        return;
                      }
                      content_item.my_answer.push(rst.base64);
                      console.info("content_item", content_item);
                    }
                  }
                } catch (err) {
                  _didIteratorError25 = true;
                  _iteratorError25 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion25 && _iterator25.return) {
                      _iterator25.return();
                    }
                  } finally {
                    if (_didIteratorError25) {
                      throw _iteratorError25;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError24 = true;
              _iteratorError24 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion24 && _iterator24.return) {
                  _iterator24.return();
                }
              } finally {
                if (_didIteratorError24) {
                  throw _iteratorError24;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError23 = true;
          _iteratorError23 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion23 && _iterator23.return) {
              _iterator23.return();
            }
          } finally {
            if (_didIteratorError23) {
              throw _iteratorError23;
            }
          }
        }
      }).catch(function (err) {
        console.info(err);
        that.$vux.toast.show({
          type: 'cancel',
          text: '网络错误'
        });
        // 处理失败会执行
      });
    },

    //删除图片
    delImg: function delImg(index, id) {
      console.info("indexId", index, id);
      var _iteratorNormalCompletion26 = true;
      var _didIteratorError26 = false;
      var _iteratorError26 = undefined;

      try {
        for (var _iterator26 = get_iterator_default()(this.column_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
          var column_list_item = _step26.value;
          var _iteratorNormalCompletion27 = true;
          var _didIteratorError27 = false;
          var _iteratorError27 = undefined;

          try {
            for (var _iterator27 = get_iterator_default()(column_list_item.row_list), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
              var row_list_item = _step27.value;
              var _iteratorNormalCompletion28 = true;
              var _didIteratorError28 = false;
              var _iteratorError28 = undefined;

              try {
                for (var _iterator28 = get_iterator_default()(row_list_item.content), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                  var content_item = _step28.value;

                  if (content_item.id == id) {
                    content_item.my_answer.splice(index, 1);
                  }
                }
              } catch (err) {
                _didIteratorError28 = true;
                _iteratorError28 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion28 && _iterator28.return) {
                    _iterator28.return();
                  }
                } finally {
                  if (_didIteratorError28) {
                    throw _iteratorError28;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError27 = true;
            _iteratorError27 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion27 && _iterator27.return) {
                _iterator27.return();
              }
            } finally {
              if (_didIteratorError27) {
                throw _iteratorError27;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError26 = true;
        _iteratorError26 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion26 && _iterator26.return) {
            _iterator26.return();
          }
        } finally {
          if (_didIteratorError26) {
            throw _iteratorError26;
          }
        }
      }
    },

    //提交
    submitForm: function submitForm() {
      var _this3 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      //answer 
      var answer_list_arr = [];
      //图片上传
      var imgs_upload = [];
      // imgs_upload.push(this.tmpImageUpload);
      var _iteratorNormalCompletion29 = true;
      var _didIteratorError29 = false;
      var _iteratorError29 = undefined;

      try {
        for (var _iterator29 = get_iterator_default()(this.column_list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
          var column_list_item = _step29.value;
          var _iteratorNormalCompletion30 = true;
          var _didIteratorError30 = false;
          var _iteratorError30 = undefined;

          try {
            for (var _iterator30 = get_iterator_default()(column_list_item.row_list), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
              var row_list_item = _step30.value;
              var _iteratorNormalCompletion31 = true;
              var _didIteratorError31 = false;
              var _iteratorError31 = undefined;

              try {
                for (var _iterator31 = get_iterator_default()(row_list_item.content), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                  var content_item = _step31.value;


                  var obj = {
                    id: content_item.id,
                    answer: content_item.my_answer
                  };
                  console.info("objobj", obj);
                  if (content_item.type == "6") {
                    content_item.my_answer = this.replaceAllNewLine(content_item.my_answer);
                  }
                  if (content_item.type == "11" || content_item.type == '10') {
                    var _iteratorNormalCompletion32 = true;
                    var _didIteratorError32 = false;
                    var _iteratorError32 = undefined;

                    try {
                      for (var _iterator32 = get_iterator_default()(obj.answer), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
                        var val = _step32.value;

                        var bold = '';
                        if (val.indexOf("http:") != -1 || val.indexOf("https:") != -1 || val.indexOf("Uploads/pad/") != -1) {
                          //  TODO:跨域，无法转dataurl
                          //  let url = Conf.baseUrl + val;
                          //   Util.convertImgToDataURLviaCanvas(url,function(res){
                          //     console.info('res:',res)
                          //   },"image/jpeg");
                          imgs_upload.push({
                            id: obj.id,
                            file: null,
                            url: val
                          });
                        } else {
                          bold = Util.dataURItoBlob(val);
                          imgs_upload.push({
                            id: obj.id,
                            file: bold
                          });
                        }
                        // console.info(imgs_upload)
                      }
                      //answer_list_arr.push({"asd":imgs_upload})
                    } catch (err) {
                      _didIteratorError32 = true;
                      _iteratorError32 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion32 && _iterator32.return) {
                          _iterator32.return();
                        }
                      } finally {
                        if (_didIteratorError32) {
                          throw _iteratorError32;
                        }
                      }
                    }

                    if (content_item.my_answer != '') {
                      answer_list_arr.push({
                        id: obj.id,
                        type: content_item.type
                      });
                    }
                  } else {
                    answer_list_arr.push(obj);
                  }
                }
              } catch (err) {
                _didIteratorError31 = true;
                _iteratorError31 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion31 && _iterator31.return) {
                    _iterator31.return();
                  }
                } finally {
                  if (_didIteratorError31) {
                    throw _iteratorError31;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError30 = true;
            _iteratorError30 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion30 && _iterator30.return) {
                _iterator30.return();
              }
            } finally {
              if (_didIteratorError30) {
                throw _iteratorError30;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError29 = true;
        _iteratorError29 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion29 && _iterator29.return) {
            _iterator29.return();
          }
        } finally {
          if (_didIteratorError29) {
            throw _iteratorError29;
          }
        }
      }

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id,
        notice_user: this.notice_user,
        answer_list: answer_list_arr
      };
      console.info("answer_list_arr", answer_list_arr);
      //编辑进来的添加一个参数
      if (this.$route.query.answer_id) {
        params.answer_id = this.$route.query.answer_id;
      }
      console.info("imgs_upload", imgs_upload);
      Api.checkRoomApi.setRoundRecord(params, imgs_upload).then(function (res) {

        if (res.errcode == 1) {
          _this3.$router.replace({
            path: '/success',
            query: {
              id: _this3.$route.query.id,
              form_id: _this3.$route.query.form_id,
              name: 'add_from_record',
              tabVal: _this3.$route.query.tabVal
            }
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    this.apiMemberInfo();
    this.apiFromList();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/add_from_record.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_add_from_record = ({
  name: 'add_from_record',
  data: function data() {
    return {
      memberInfo: {
        name: '',
        phone: '',
        package: '',
        liveDate: '',
        childBirth: '',
        birthType: '',
        babyType: [{
          label: '顺产',
          value: '1'
        }, {
          label: '剖宫产',
          value: '2'
        }, {
          label: '早产',
          value: '3'
        }, {
          label: '不知道',
          value: '0'
        }]
      },
      form_name: '',
      indexList: '',
      showSearch: true,
      has_answer: '', //是否填过答案
      id: this.$route.query.id,
      member_column_list: [], //表单数组
      column_list: [], //表单数组
      is_drapList: false,
      //孕妇列表
      maternal_list: [],
      //签名
      is_edit: true, //是否显示
      tmpImageUpload: {},
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      host: api_const["host"],
      pinyin_array: []
    };
  },

  methods: {
    //替换所有换行符
    replaceAllNewLine: function replaceAllNewLine(content) {
      var string = content;
      try {
        string = string.replace(/\r\n/g, "<br>");
        string = string.replace(/\n/g, "<br>");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },


    //替换br成换行
    replaceAllBr: function replaceAllBr(content) {
      var string = content;
      try {
        string = string.replace("<br>", "\n").replace("<br>", "\n");
        string = string.replace("<br>", "\n");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },
    textareaBlur: function textareaBlur(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.column_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column_list_item = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(column_list_item.row_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var row_list_item = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = get_iterator_default()(row_list_item.content), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var content_item = _step3.value;

                  if (content_item.id == id) {
                    content_item.my_answer = this.replaceAllBr(content_item.my_answer);
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },

    //时间戳转日期格式    
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '年' + m + '月' + d + '日';
    },

    //请求用户基本信息
    apiMemberInfo: function apiMemberInfo() {
      var _this = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.memberInfo(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this.memberInfo.name = res.data.name;
          _this.memberInfo.phone = res.data.phone;
          _this.memberInfo.package = res.data.package_name;
          _this.memberInfo.liveDate = _this.formatDateTime(res.data.live_time);
          _this.memberInfo.childBirth = _this.formatDateTime(res.data.child_birth);
          var birthType = '';
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = get_iterator_default()(_this.memberInfo.babyType), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var item = _step4.value;

              if (res.data.birth_type == item.value) {
                birthType = item.label;
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }

          _this.memberInfo.birthType = birthType;
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(arr), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var item = _step5.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return false;
    },

    //打开选择查房人
    selece_cfr: function selece_cfr(name, id) {
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = get_iterator_default()(this.column_list), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var column_list_item = _step6.value;
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = get_iterator_default()(column_list_item.row_list), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var row_list_item = _step7.value;
              var _iteratorNormalCompletion8 = true;
              var _didIteratorError8 = false;
              var _iteratorError8 = undefined;

              try {
                for (var _iterator8 = get_iterator_default()(row_list_item.content), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                  var content_item = _step8.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.indexList = '';
                  }
                }
              } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                  }
                } finally {
                  if (_didIteratorError8) {
                    throw _iteratorError8;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    },

    //选择查房人
    selectPeople: function selectPeople(id) {
      if (this.indexList) {
        this.indexList = '';
        return;
      }
      this.indexList = id;
    },

    //数组排序
    arrar_sort: function arrar_sort(newArr, oldArr) {
      var newList = [];
      var pyArrSort = newArr.sort();
      var i = 0;
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = get_iterator_default()(pyArrSort), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var item = _step9.value;
          var _iteratorNormalCompletion10 = true;
          var _didIteratorError10 = false;
          var _iteratorError10 = undefined;

          try {
            for (var _iterator10 = get_iterator_default()(oldArr), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
              var list = _step10.value;

              if (item == list.pinyin) {
                newList[i] = list;
              }
            }
          } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion10 && _iterator10.return) {
                _iterator10.return();
              }
            } finally {
              if (_didIteratorError10) {
                throw _iteratorError10;
              }
            }
          }

          i++;
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return newList;
    },
    cfr_list: function cfr_list(arr) {
      if (arr.length) {
        var nurser_name_arr = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = get_iterator_default()(arr), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var item = _step11.value;

            var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
            var obj = {
              name: [item.user_name],
              pinyin: _py
            };
            nurser_name_arr.push(obj);
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        var pyArr = [];
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
          for (var _iterator12 = get_iterator_default()(nurser_name_arr), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var _item = _step12.value;

            var obj = {
              name: _item.name,
              pinyin: _item.pinyin
            };
            var is_have = this.isInArray(pyArr, _item.pinyin);
            if (!is_have) {
              //不存在
              pyArr.push(_item.pinyin);
              this.pinyin_array.push(_item.pinyin);
              this.pinyin_array.sort();
              this.maternal_list.push(obj);
            } else {
              //存在
              var _index = pyArr.indexOf(_item.pinyin);
              this.maternal_list[_index].name.push(_item.name.join(''));
            }
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }

        this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
      }
    },

    //请求孕妇表单配置信息
    apiFromList: function apiFromList() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id
        //编辑进来的添加一个参数
      };if (this.$route.query.answer_id) {
        params.answer_id = this.$route.query.answer_id;
      }
      console.info(params);
      Api.checkRoomApi.addRecordFrom(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this2.has_answer = res.data.has_answer;
          _this2.form_name = res.data.form_data.name;
          _this2.member_column_list = res.data.column_list;
          var _iteratorNormalCompletion13 = true;
          var _didIteratorError13 = false;
          var _iteratorError13 = undefined;

          try {
            for (var _iterator13 = get_iterator_default()(res.data.form_data.column_list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
              var column_list_item = _step13.value;
              var _iteratorNormalCompletion14 = true;
              var _didIteratorError14 = false;
              var _iteratorError14 = undefined;

              try {
                for (var _iterator14 = get_iterator_default()(column_list_item.row_list), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                  var row_list_item = _step14.value;
                  var _iteratorNormalCompletion15 = true;
                  var _didIteratorError15 = false;
                  var _iteratorError15 = undefined;

                  try {
                    for (var _iterator15 = get_iterator_default()(row_list_item.content), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                      var content_item = _step15.value;
                      var _iteratorNormalCompletion16 = true;
                      var _didIteratorError16 = false;
                      var _iteratorError16 = undefined;

                      try {
                        for (var _iterator16 = get_iterator_default()(_this2.member_column_list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
                          var item = _step16.value;

                          if (content_item.column_name == item.name) {
                            content_item.tip = item.value;
                          }
                        }
                      } catch (err) {
                        _didIteratorError16 = true;
                        _iteratorError16 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion16 && _iterator16.return) {
                            _iterator16.return();
                          }
                        } finally {
                          if (_didIteratorError16) {
                            throw _iteratorError16;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError15 = true;
                    _iteratorError15 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion15 && _iterator15.return) {
                        _iterator15.return();
                      }
                    } finally {
                      if (_didIteratorError15) {
                        throw _iteratorError15;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError14 = true;
                _iteratorError14 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion14 && _iterator14.return) {
                    _iterator14.return();
                  }
                } finally {
                  if (_didIteratorError14) {
                    throw _iteratorError14;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError13 = true;
            _iteratorError13 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion13 && _iterator13.return) {
                _iterator13.return();
              }
            } finally {
              if (_didIteratorError13) {
                throw _iteratorError13;
              }
            }
          }

          _this2.column_list = res.data.form_data.column_list;
          //孕妇列表
          _this2.cfr_list(res.data.nurser_name);
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    input_focus: function input_focus(id) {
      this.is_drapList = id;
    },
    menuClick: function menuClick(name, id) {
      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = get_iterator_default()(this.column_list), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var column_list_item = _step17.value;
          var _iteratorNormalCompletion18 = true;
          var _didIteratorError18 = false;
          var _iteratorError18 = undefined;

          try {
            for (var _iterator18 = get_iterator_default()(column_list_item.row_list), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
              var row_list_item = _step18.value;
              var _iteratorNormalCompletion19 = true;
              var _didIteratorError19 = false;
              var _iteratorError19 = undefined;

              try {
                for (var _iterator19 = get_iterator_default()(row_list_item.content), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
                  var content_item = _step19.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.is_drapList = '';
                  }
                }
              } catch (err) {
                _didIteratorError19 = true;
                _iteratorError19 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion19 && _iterator19.return) {
                    _iterator19.return();
                  }
                } finally {
                  if (_didIteratorError19) {
                    throw _iteratorError19;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError18 = true;
            _iteratorError18 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion18 && _iterator18.return) {
                _iterator18.return();
              }
            } finally {
              if (_didIteratorError18) {
                throw _iteratorError18;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }
    },

    //保存签名
    save: function save(id) {
      var signature = 'signature' + id;
      var png = this.$refs[signature][0].save();
      var jpeg = this.$refs[signature][0].save('image/jpeg');
      var svg = this.$refs[signature][0].save('image/svg+xml');
      var _iteratorNormalCompletion20 = true;
      var _didIteratorError20 = false;
      var _iteratorError20 = undefined;

      try {
        for (var _iterator20 = get_iterator_default()(this.column_list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
          var column_list_item = _step20.value;
          var _iteratorNormalCompletion21 = true;
          var _didIteratorError21 = false;
          var _iteratorError21 = undefined;

          try {
            for (var _iterator21 = get_iterator_default()(column_list_item.row_list), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
              var row_list_item = _step21.value;
              var _iteratorNormalCompletion22 = true;
              var _didIteratorError22 = false;
              var _iteratorError22 = undefined;

              try {
                for (var _iterator22 = get_iterator_default()(row_list_item.content), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
                  var content_item = _step22.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [encodeURI(png)];
                    this.is_edit = '';
                  }
                }
              } catch (err) {
                _didIteratorError22 = true;
                _iteratorError22 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion22 && _iterator22.return) {
                    _iterator22.return();
                  }
                } finally {
                  if (_didIteratorError22) {
                    throw _iteratorError22;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError21 = true;
            _iteratorError21 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion21 && _iterator21.return) {
                _iterator21.return();
              }
            } finally {
              if (_didIteratorError21) {
                throw _iteratorError21;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError20 = true;
        _iteratorError20 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion20 && _iterator20.return) {
            _iterator20.return();
          }
        } finally {
          if (_didIteratorError20) {
            throw _iteratorError20;
          }
        }
      }
    },

    //清除签名
    clear: function clear(id) {
      var signature = 'signature' + id;
      var refs = this.$refs[signature][0].clear();
    },

    //编辑签名
    edit_signature: function edit_signature(id) {
      this.is_edit = id;
    },

    //图片上传
    fileImage: function fileImage(e) {
      var file = e.target.files[0];
      var item_id = e.target.id;
      console.info(item_id);
      var that = this;
      lrz(file).then(function (rst) {
        // 处理成功会执行
        var _iteratorNormalCompletion23 = true;
        var _didIteratorError23 = false;
        var _iteratorError23 = undefined;

        try {
          for (var _iterator23 = get_iterator_default()(that.column_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
            var column_list_item = _step23.value;
            var _iteratorNormalCompletion24 = true;
            var _didIteratorError24 = false;
            var _iteratorError24 = undefined;

            try {
              for (var _iterator24 = get_iterator_default()(column_list_item.row_list), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                var row_list_item = _step24.value;
                var _iteratorNormalCompletion25 = true;
                var _didIteratorError25 = false;
                var _iteratorError25 = undefined;

                try {
                  for (var _iterator25 = get_iterator_default()(row_list_item.content), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
                    var content_item = _step25.value;

                    if (content_item.id == item_id) {
                      if (content_item.my_answer.length == 10) {
                        that.$vux.toast.show({
                          type: 'cancel',
                          text: '最多上传10张图片'
                        });
                        return;
                      }
                      content_item.my_answer.push(rst.base64);
                      console.info("content_item", content_item);
                    }
                  }
                } catch (err) {
                  _didIteratorError25 = true;
                  _iteratorError25 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion25 && _iterator25.return) {
                      _iterator25.return();
                    }
                  } finally {
                    if (_didIteratorError25) {
                      throw _iteratorError25;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError24 = true;
              _iteratorError24 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion24 && _iterator24.return) {
                  _iterator24.return();
                }
              } finally {
                if (_didIteratorError24) {
                  throw _iteratorError24;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError23 = true;
          _iteratorError23 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion23 && _iterator23.return) {
              _iterator23.return();
            }
          } finally {
            if (_didIteratorError23) {
              throw _iteratorError23;
            }
          }
        }
      }).catch(function (err) {
        console.info(err);
        that.$vux.toast.show({
          type: 'cancel',
          text: '网络错误'
        });
        // 处理失败会执行
      });
    },

    //删除图片
    delImg: function delImg(index, id) {
      console.info("indexId", index, id);
      var _iteratorNormalCompletion26 = true;
      var _didIteratorError26 = false;
      var _iteratorError26 = undefined;

      try {
        for (var _iterator26 = get_iterator_default()(this.column_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
          var column_list_item = _step26.value;
          var _iteratorNormalCompletion27 = true;
          var _didIteratorError27 = false;
          var _iteratorError27 = undefined;

          try {
            for (var _iterator27 = get_iterator_default()(column_list_item.row_list), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
              var row_list_item = _step27.value;
              var _iteratorNormalCompletion28 = true;
              var _didIteratorError28 = false;
              var _iteratorError28 = undefined;

              try {
                for (var _iterator28 = get_iterator_default()(row_list_item.content), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
                  var content_item = _step28.value;

                  if (content_item.id == id) {
                    content_item.my_answer.splice(index, 1);
                  }
                }
              } catch (err) {
                _didIteratorError28 = true;
                _iteratorError28 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion28 && _iterator28.return) {
                    _iterator28.return();
                  }
                } finally {
                  if (_didIteratorError28) {
                    throw _iteratorError28;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError27 = true;
            _iteratorError27 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion27 && _iterator27.return) {
                _iterator27.return();
              }
            } finally {
              if (_didIteratorError27) {
                throw _iteratorError27;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError26 = true;
        _iteratorError26 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion26 && _iterator26.return) {
            _iterator26.return();
          }
        } finally {
          if (_didIteratorError26) {
            throw _iteratorError26;
          }
        }
      }
    },

    //提交
    submitForm: function submitForm() {
      var _this3 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      //answer 
      var answer_list_arr = [];
      //图片上传
      var imgs_upload = [];
      // imgs_upload.push(this.tmpImageUpload);
      var _iteratorNormalCompletion29 = true;
      var _didIteratorError29 = false;
      var _iteratorError29 = undefined;

      try {
        for (var _iterator29 = get_iterator_default()(this.column_list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
          var column_list_item = _step29.value;
          var _iteratorNormalCompletion30 = true;
          var _didIteratorError30 = false;
          var _iteratorError30 = undefined;

          try {
            for (var _iterator30 = get_iterator_default()(column_list_item.row_list), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
              var row_list_item = _step30.value;
              var _iteratorNormalCompletion31 = true;
              var _didIteratorError31 = false;
              var _iteratorError31 = undefined;

              try {
                for (var _iterator31 = get_iterator_default()(row_list_item.content), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                  var content_item = _step31.value;


                  var obj = {
                    id: content_item.id,
                    answer: content_item.my_answer
                  };
                  console.info("objobj", obj);
                  if (content_item.type == "6") {
                    content_item.my_answer = this.replaceAllNewLine(content_item.my_answer);
                  }
                  if (content_item.type == "11" || content_item.type == '10') {
                    var _iteratorNormalCompletion32 = true;
                    var _didIteratorError32 = false;
                    var _iteratorError32 = undefined;

                    try {
                      for (var _iterator32 = get_iterator_default()(obj.answer), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
                        var val = _step32.value;

                        var bold = '';
                        if (val.indexOf("http:") != -1 || val.indexOf("https:") != -1 || val.indexOf("Uploads/pad/") != -1) {
                          //  TODO:跨域，无法转dataurl
                          //  let url = Conf.baseUrl + val;
                          //   Util.convertImgToDataURLviaCanvas(url,function(res){
                          //     console.info('res:',res)
                          //   },"image/jpeg");
                          imgs_upload.push({
                            id: obj.id,
                            file: null,
                            url: val
                          });
                        } else {
                          bold = Util.dataURItoBlob(val);
                          imgs_upload.push({
                            id: obj.id,
                            file: bold
                          });
                        }
                        // console.info(imgs_upload)
                      }
                      //answer_list_arr.push({"asd":imgs_upload})
                    } catch (err) {
                      _didIteratorError32 = true;
                      _iteratorError32 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion32 && _iterator32.return) {
                          _iterator32.return();
                        }
                      } finally {
                        if (_didIteratorError32) {
                          throw _iteratorError32;
                        }
                      }
                    }

                    if (content_item.my_answer != '') {
                      answer_list_arr.push({
                        id: obj.id,
                        type: content_item.type
                      });
                    }
                  } else {
                    answer_list_arr.push(obj);
                  }
                }
              } catch (err) {
                _didIteratorError31 = true;
                _iteratorError31 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion31 && _iterator31.return) {
                    _iterator31.return();
                  }
                } finally {
                  if (_didIteratorError31) {
                    throw _iteratorError31;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError30 = true;
            _iteratorError30 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion30 && _iterator30.return) {
                _iterator30.return();
              }
            } finally {
              if (_didIteratorError30) {
                throw _iteratorError30;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError29 = true;
        _iteratorError29 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion29 && _iterator29.return) {
            _iterator29.return();
          }
        } finally {
          if (_didIteratorError29) {
            throw _iteratorError29;
          }
        }
      }

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id,
        notice_user: this.notice_user,
        answer_list: answer_list_arr
      };
      console.info("answer_list_arr", answer_list_arr);
      //编辑进来的添加一个参数
      if (this.$route.query.answer_id) {
        params.answer_id = this.$route.query.answer_id;
      }
      console.info("imgs_upload", imgs_upload);
      Api.checkRoomApi.setRoundRecord(params, imgs_upload).then(function (res) {

        if (res.errcode == 1) {
          _this3.$router.replace({
            path: '/success',
            query: {
              id: _this3.$route.query.id,
              form_id: _this3.$route.query.form_id,
              name: 'add_from_record',
              tabVal: _this3.$route.query.tabVal
            }
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    this.apiMemberInfo();
    this.apiFromList();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f88da9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/add_from_record.vue
var add_from_record_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v(_vm._s(_vm.form_name))]),_vm._v(" "),_c('div',{staticClass:"_main"},[_c('div',{staticClass:"baseInfo"},[_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"_item"},[_vm._v("孕妇姓名:"+_vm._s(_vm.memberInfo.name))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"_item"},[_vm._v("孕妇电话:"+_vm._s(_vm.memberInfo.phone))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"_item"},[_vm._v("套餐:"+_vm._s(_vm.memberInfo.package))])])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"_item"},[_vm._v("入住日期:"+_vm._s(_vm.memberInfo.liveDate))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"_item"},[_vm._v("分娩日期:"+_vm._s(_vm.memberInfo.childBirth))])]),_vm._v(" "),_c('flexbox-item',[_c('div',{staticClass:"_item"},[_vm._v("分娩方式:"+_vm._s(_vm.memberInfo.birthType))])])],1)],1),_vm._v(" "),_vm._l((_vm.column_list),function(column_list_item,index){return (column_list_item.is_show_column == 1)?_c('group',{key:index,attrs:{"title":column_list_item.column_name,"label-width":"9em"}},_vm._l((column_list_item.row_list),function(row_list_item,index){return _c('div',{key:index},_vm._l((row_list_item.content),function(content_item,index){return _c('div',{key:index,staticClass:"vux-1px-b"},[(content_item.type == '1')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"placeholder":content_item.tip+content_item.unit},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):(content_item.question == '' && row_list_item.title == '')?_c('x-input',{attrs:{"title":content_item.tip+ '：',"placeholder":content_item.tip+content_item.unit},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip+content_item.unit},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '2')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}},_vm._l((content_item.answer),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '3')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(content_item.my_answer),callback:function ($$v) {_vm.$set(content_item, "my_answer", $$v)},expression:"content_item.my_answer"}},_vm._l((content_item.answer),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '4')?_c('div',[(content_item.question)?_c('selector',{attrs:{"title":content_item.question,"options":content_item.answer,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('selector',{attrs:{"title":row_list_item.title,"options":content_item.answer,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '5')?_c('div',[_c('datetime',{attrs:{"start-date":"1900-01-01","title":content_item.question,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(_vm.form_name == '贵宾入住告知书')?_c('div',[(content_item.type == '6')?_c('div',[_c('x-textarea',{attrs:{"value":content_item.tip,"autosize":""},on:{"on-blur":function($event){return _vm.textareaBlur(content_item.id)}}})],1):_vm._e()]):_c('div',[(content_item.type == '6')?_c('div',[(content_item.question)?_c('x-textarea',{attrs:{"title":content_item.question,"placeholder":content_item.tip+content_item.unit},on:{"on-blur":function($event){return _vm.textareaBlur(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-textarea',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip+content_item.unit},on:{"on-blur":function($event){return _vm.textareaBlur(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e()]),_vm._v(" "),(content_item.type == '7')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"disabled":"","placeholder":content_item.tip+content_item.unit},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}}):_c('x-input',{attrs:{"title":row_list_item.title,"disabled":"","placeholder":content_item.tip+content_item.unit},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '8')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"placeholder":content_item.tip+content_item.unit},on:{"on-focus":function($event){return _vm.input_focus(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip+content_item.unit,"id":content_item.id},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_drapList == content_item.id),expression:"is_drapList == content_item.id"}],staticClass:"drapList vux-1px"},_vm._l((content_item.answer),function(option,index){return _c('cell',{key:index,attrs:{"value":option,"value-align":"left"},nativeOn:{"click":function($event){return _vm.menuClick(option,content_item.id)}}})}),1)],1):_vm._e(),_vm._v(" "),(content_item.type == '9')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"placeholder":content_item.tip+content_item.unit,"disabled":""},model:{value:(content_item.detail_tip),callback:function ($$v) {_vm.$set(content_item, "detail_tip", $$v)},expression:"content_item.detail_tip"}}):_c('x-input',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip+content_item.unit},model:{value:(content_item.detail_tip),callback:function ($$v) {_vm.$set(content_item, "detail_tip", $$v)},expression:"content_item.detail_tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '10')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","flex":"1"}},[(_vm.is_edit != content_item.id)?_c('div',[(content_item.my_answer[0])?_c('div',[(content_item.my_answer[0].length>100)?_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}}):_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":_vm.host+content_item.my_answer[0],"alt":""}})]):_c('div',[_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"t_r pd-10"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit_signature(content_item.id)}}},[_vm._v("编辑签名")])],1)]):_c('div',[_c('vueSignature',{ref:'signature' + content_item.id,refInFor:true,staticClass:"vueSignature",attrs:{"sigOption":_vm.option,"w":'100%',"h":'400px'}}),_vm._v(" "),_c('div',{staticClass:"t_r pd-10"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save(content_item.id)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear(content_item.id)}}},[_vm._v("清除")])],1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '11')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png","id":content_item.id},on:{"change":_vm.fileImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})])]),_vm._v(" "),(content_item.my_answer.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((content_item.my_answer),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[(item.length>100)?_c('img',{staticClass:"img",attrs:{"src":item,"width":"84","height":"84","alt":""}}):_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(index,content_item.id)}}})])}),0):_vm._e()])])]):_vm._e(),_vm._v(" "),(content_item.type == '12')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('div',{staticStyle:{"display":"flex"}},[(content_item.my_answer[0])?_c('div',{staticStyle:{"line-height":"29px","margin-right":"10px"}},[_vm._v(_vm._s(content_item.my_answer[0]))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople(content_item.id)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"},{name:"show",rawName:"v-show",value:(_vm.indexList == content_item.id),expression:"indexList == content_item.id"}],staticClass:"mtIndexList"},[_c('div',{staticStyle:{"text-align":"right","padding-right":"24px"}},[_c('x-button',{attrs:{"type":"default","mini":""},nativeOn:{"click":function($event){_vm.indexList = ''}}},[_vm._v("关闭")])],1),_vm._v(" "),_c('ul',{staticClass:"mtIndexListBox"},[_vm._l((_vm.maternal_list),function(item){return _c('li',{key:item.pinyin,attrs:{"id":item.pinyin}},[_c('p',{staticClass:"index_title"},[_vm._v(_vm._s(item.pinyin))]),_vm._v(" "),_c('dl',{staticStyle:{"padding-right":"30px"}},_vm._l((item.name),function(option,index){return _c('dd',{key:index,staticStyle:{"display":"inline-block"}},[_c('a',{staticStyle:{"display":"inline-block","color":"#333","padding":"10px 20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.selece_cfr(option,content_item.id)}}},[_vm._v(_vm._s(option))])])}),0)])}),_vm._v(" "),_c('div',{staticClass:"fixed_right_pinyin"},_vm._l((_vm.pinyin_array),function(item,index){return _c('a',{key:index,attrs:{"href":'#'+ item}},[_vm._v(_vm._s(item))])}),0)],2)])])])])]):_vm._e()])}),0)}),0):_vm._e()}),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"15px"},attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],2)],1)}
var add_from_record_staticRenderFns = []
var add_from_record_esExports = { render: add_from_record_render, staticRenderFns: add_from_record_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_add_from_record = (add_from_record_esExports);
// CONCATENATED MODULE: ./src/components/add_from_record.vue
function add_from_record_injectStyle (ssrContext) {
  __webpack_require__("CaxX")
}
var add_from_record_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var add_from_record___vue_template_functional__ = false
/* styles */
var add_from_record___vue_styles__ = add_from_record_injectStyle
/* scopeId */
var add_from_record___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var add_from_record___vue_module_identifier__ = null
var add_from_record_Component = add_from_record_normalizeComponent(
  components_add_from_record,
  selectortype_template_index_0_src_components_add_from_record,
  add_from_record___vue_template_functional__,
  add_from_record___vue_styles__,
  add_from_record___vue_scopeId__,
  add_from_record___vue_module_identifier__
)

/* harmony default export */ var src_components_add_from_record = (add_from_record_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/detail_other_form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var detail_other_form = ({
  name: 'detail_other_form',
  components: {
    baseInfoHeader: src_components_base_info_header
  },
  data: function data() {
    return {
      form_name: '',
      indexList: '',
      showSearch: true,
      has_answer: '', //是否填过答案
      id: this.$route.query.id,
      member_column_list: [], //表单数组
      column_list: [], //表单数组
      is_drapList: false,
      //孕妇列表
      maternal_list: [],
      //签名
      is_edit: true, //是否显示
      tmpImageUpload: {},
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      host: api_const["host"],
      pinyin_array: []
    };
  },

  methods: {
    //替换所有换行符
    replaceAllNewLine: function replaceAllNewLine(content) {
      var string = content;
      try {
        string = string.replace(/\r\n/g, "<br>");
        string = string.replace(/\n/g, "<br>");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },


    //替换br成换行
    replaceAllBr: function replaceAllBr(content) {
      var string = content;
      try {
        string = string.replace("<br>", "\n").replace("<br>", "\n");
        string = string.replace("<br>", "\n");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },
    textareaBlur: function textareaBlur(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.column_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column_list_item = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(column_list_item.row_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var row_list_item = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = get_iterator_default()(row_list_item.content), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var content_item = _step3.value;

                  if (content_item.id == id) {
                    content_item.my_answer = this.replaceAllBr(content_item.my_answer);
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(arr), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    selece_cfr: function selece_cfr(name, id) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.column_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var column_list_item = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(column_list_item.row_list), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var row_list_item = _step6.value;
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = get_iterator_default()(row_list_item.content), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var content_item = _step7.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.indexList = '';
                  }
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    selectPeople: function selectPeople(id) {
      if (this.indexList) {
        this.indexList = '';
        return;
      }
      this.indexList = id;
    },
    arrar_sort: function arrar_sort(newArr, oldArr) {
      var newList = [];
      var pyArrSort = newArr.sort();
      var i = 0;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(pyArrSort), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = get_iterator_default()(oldArr), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var list = _step9.value;

              if (item == list.pinyin) {
                newList[i] = list;
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          i++;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return newList;
    },
    cfr_list: function cfr_list(arr) {
      if (arr.length) {
        var nurser_name_arr = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = get_iterator_default()(arr), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var item = _step10.value;

            var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
            var obj = {
              name: [item.user_name],
              pinyin: _py
            };
            nurser_name_arr.push(obj);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var pyArr = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = get_iterator_default()(nurser_name_arr), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var _item = _step11.value;

            var obj = {
              name: _item.name,
              pinyin: _item.pinyin
            };
            var is_have = this.isInArray(pyArr, _item.pinyin);
            if (!is_have) {
              //不存在
              pyArr.push(_item.pinyin);
              this.pinyin_array.push(_item.pinyin);
              this.pinyin_array.sort();
              this.maternal_list.push(obj);
            } else {
              //存在
              var _index = pyArr.indexOf(_item.pinyin);
              this.maternal_list[_index].name.push(_item.name.join(''));
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
      }
    },

    //请求孕妇表单配置信息
    apiMonthLive: function apiMonthLive() {
      var _this = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id,
        answer_id: this.$route.query.answer_id
      };
      console.log(params);
      Api.checkRoomApi.addRecordFrom(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this.has_answer = res.data.has_answer;
          _this.form_name = res.data.form_data.name;
          _this.member_column_list = res.data.column_list;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = get_iterator_default()(res.data.form_data.column_list), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var column_list_item = _step12.value;
              var _iteratorNormalCompletion13 = true;
              var _didIteratorError13 = false;
              var _iteratorError13 = undefined;

              try {
                for (var _iterator13 = get_iterator_default()(column_list_item.row_list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                  var row_list_item = _step13.value;
                  var _iteratorNormalCompletion14 = true;
                  var _didIteratorError14 = false;
                  var _iteratorError14 = undefined;

                  try {
                    for (var _iterator14 = get_iterator_default()(row_list_item.content), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                      var content_item = _step14.value;
                      var _iteratorNormalCompletion15 = true;
                      var _didIteratorError15 = false;
                      var _iteratorError15 = undefined;

                      try {
                        for (var _iterator15 = get_iterator_default()(_this.member_column_list), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                          var item = _step15.value;

                          if (content_item.column_name == item.name) {
                            content_item.tip = item.value;
                            _this.$vux.loading.hide();
                          }
                        }
                      } catch (err) {
                        _didIteratorError15 = true;
                        _iteratorError15 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion15 && _iterator15.return) {
                            _iterator15.return();
                          }
                        } finally {
                          if (_didIteratorError15) {
                            throw _iteratorError15;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                      }
                    } finally {
                      if (_didIteratorError14) {
                        throw _iteratorError14;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion13 && _iterator13.return) {
                    _iterator13.return();
                  }
                } finally {
                  if (_didIteratorError13) {
                    throw _iteratorError13;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          _this.column_list = res.data.form_data.column_list;
          //孕妇列表
          _this.cfr_list(res.data.nurser_name);
        } else {
          _this.$vux.loading.hide();
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //是否提交过答案
    editForm: function editForm() {
      this.has_answer = '2';
    },
    input_focus: function input_focus(id) {
      this.is_drapList = id;
    },
    menuClick: function menuClick(name, id) {
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = get_iterator_default()(this.column_list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var column_list_item = _step16.value;
          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = get_iterator_default()(column_list_item.row_list), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var row_list_item = _step17.value;
              var _iteratorNormalCompletion18 = true;
              var _didIteratorError18 = false;
              var _iteratorError18 = undefined;

              try {
                for (var _iterator18 = get_iterator_default()(row_list_item.content), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                  var content_item = _step18.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.is_drapList = '';
                  }
                }
              } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion18 && _iterator18.return) {
                    _iterator18.return();
                  }
                } finally {
                  if (_didIteratorError18) {
                    throw _iteratorError18;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }
    },

    //保存签名
    save: function save(id) {
      var signature = 'signature' + id;
      var png = this.$refs[signature][0].save();
      var jpeg = this.$refs[signature][0].save('image/jpeg');
      var svg = this.$refs[signature][0].save('image/svg+xml');
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = get_iterator_default()(this.column_list), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var column_list_item = _step19.value;
          var _iteratorNormalCompletion20 = true;
          var _didIteratorError20 = false;
          var _iteratorError20 = undefined;

          try {
            for (var _iterator20 = get_iterator_default()(column_list_item.row_list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
              var row_list_item = _step20.value;
              var _iteratorNormalCompletion21 = true;
              var _didIteratorError21 = false;
              var _iteratorError21 = undefined;

              try {
                for (var _iterator21 = get_iterator_default()(row_list_item.content), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                  var content_item = _step21.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [encodeURI(png)];
                    this.is_edit = '';
                  }
                }
              } catch (err) {
                _didIteratorError21 = true;
                _iteratorError21 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion21 && _iterator21.return) {
                    _iterator21.return();
                  }
                } finally {
                  if (_didIteratorError21) {
                    throw _iteratorError21;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError20 = true;
            _iteratorError20 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion20 && _iterator20.return) {
                _iterator20.return();
              }
            } finally {
              if (_didIteratorError20) {
                throw _iteratorError20;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }
    },

    //清除签名
    clear: function clear(id) {
      var signature = 'signature' + id;
      var refs = this.$refs[signature][0].clear();
    },

    //编辑签名
    edit_signature: function edit_signature(id) {
      this.is_edit = id;
    },

    //图片上传
    fileImage: function fileImage(e) {
      var file = e.target.files[0];
      var item_id = e.target.id;
      var that = this;
      lrz(file).then(function (rst) {
        // 处理成功会执行
        var _iteratorNormalCompletion22 = true;
        var _didIteratorError22 = false;
        var _iteratorError22 = undefined;

        try {
          for (var _iterator22 = get_iterator_default()(that.column_list), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
            var column_list_item = _step22.value;
            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
              for (var _iterator23 = get_iterator_default()(column_list_item.row_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                var row_list_item = _step23.value;
                var _iteratorNormalCompletion24 = true;
                var _didIteratorError24 = false;
                var _iteratorError24 = undefined;

                try {
                  for (var _iterator24 = get_iterator_default()(row_list_item.content), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                    var content_item = _step24.value;

                    if (content_item.id == item_id) {
                      if (content_item.my_answer.length == 10) {
                        that.$vux.toast.show({
                          type: 'cancel',
                          text: '最多上传10张图片'
                        });
                        return;
                      }
                      content_item.my_answer.push(rst.base64);
                    }
                  }
                } catch (err) {
                  _didIteratorError24 = true;
                  _iteratorError24 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion24 && _iterator24.return) {
                      _iterator24.return();
                    }
                  } finally {
                    if (_didIteratorError24) {
                      throw _iteratorError24;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError23 = true;
              _iteratorError23 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion23 && _iterator23.return) {
                  _iterator23.return();
                }
              } finally {
                if (_didIteratorError23) {
                  throw _iteratorError23;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError22 = true;
          _iteratorError22 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion22 && _iterator22.return) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError22) {
              throw _iteratorError22;
            }
          }
        }
      }).catch(function (err) {
        console.info(err);
        that.$vux.toast.show({
          type: 'cancel',
          text: '网络错误'
        });
        // 处理失败会执行
      });
    },

    //删除图片
    delImg: function delImg(index, id) {
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = get_iterator_default()(this.column_list), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var column_list_item = _step25.value;
          var _iteratorNormalCompletion26 = true;
          var _didIteratorError26 = false;
          var _iteratorError26 = undefined;

          try {
            for (var _iterator26 = get_iterator_default()(column_list_item.row_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
              var row_list_item = _step26.value;
              var _iteratorNormalCompletion27 = true;
              var _didIteratorError27 = false;
              var _iteratorError27 = undefined;

              try {
                for (var _iterator27 = get_iterator_default()(row_list_item.content), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                  var content_item = _step27.value;

                  if (content_item.id == id) {
                    content_item.my_answer.splice(index, 1);
                  }
                }
              } catch (err) {
                _didIteratorError27 = true;
                _iteratorError27 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion27 && _iterator27.return) {
                    _iterator27.return();
                  }
                } finally {
                  if (_didIteratorError27) {
                    throw _iteratorError27;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError26 = true;
            _iteratorError26 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                _iterator26.return();
              }
            } finally {
              if (_didIteratorError26) {
                throw _iteratorError26;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }
    },

    //提交
    submitForm: function submitForm() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      //answer 
      var answer_list_arr = [];
      //图片上传
      var imgs_upload = [];
      // imgs_upload.push(this.tmpImageUpload);
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = get_iterator_default()(this.column_list), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var column_list_item = _step28.value;
          var _iteratorNormalCompletion29 = true;
          var _didIteratorError29 = false;
          var _iteratorError29 = undefined;

          try {
            for (var _iterator29 = get_iterator_default()(column_list_item.row_list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
              var row_list_item = _step29.value;
              var _iteratorNormalCompletion30 = true;
              var _didIteratorError30 = false;
              var _iteratorError30 = undefined;

              try {
                for (var _iterator30 = get_iterator_default()(row_list_item.content), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                  var content_item = _step30.value;


                  var obj = {
                    id: content_item.id,
                    answer: content_item.my_answer
                  };
                  if (content_item.type == "6") {
                    content_item.my_answer = this.replaceAllNewLine(content_item.my_answer);
                  }
                  if (content_item.type == "11" || content_item.type == '10') {
                    var _iteratorNormalCompletion31 = true;
                    var _didIteratorError31 = false;
                    var _iteratorError31 = undefined;

                    try {
                      for (var _iterator31 = get_iterator_default()(obj.answer), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                        var val = _step31.value;

                        var bold = '';
                        if (val.indexOf("http:") != -1 || val.indexOf("https:") != -1 || val.indexOf("Uploads/pad/") != -1) {
                          //  TODO:跨域，无法转dataurl
                          //  let url = Conf.baseUrl + val;
                          //   Util.convertImgToDataURLviaCanvas(url,function(res){
                          //     console.info('res:',res)
                          //   },"image/jpeg");
                          imgs_upload.push({
                            id: obj.id,
                            file: null,
                            url: val
                          });
                        } else {
                          bold = Util.dataURItoBlob(val);
                          imgs_upload.push({
                            id: obj.id,
                            file: bold
                          });
                        }
                      }
                    } catch (err) {
                      _didIteratorError31 = true;
                      _iteratorError31 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion31 && _iterator31.return) {
                          _iterator31.return();
                        }
                      } finally {
                        if (_didIteratorError31) {
                          throw _iteratorError31;
                        }
                      }
                    }

                    if (content_item.my_answer != '') {
                      answer_list_arr.push({
                        id: obj.id,
                        type: content_item.type
                      });
                    }
                  } else {
                    answer_list_arr.push(obj);
                  }
                }
              } catch (err) {
                _didIteratorError30 = true;
                _iteratorError30 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion30 && _iterator30.return) {
                    _iterator30.return();
                  }
                } finally {
                  if (_didIteratorError30) {
                    throw _iteratorError30;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError29 = true;
            _iteratorError29 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion29 && _iterator29.return) {
                _iterator29.return();
              }
            } finally {
              if (_didIteratorError29) {
                throw _iteratorError29;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id,
        answer_list: answer_list_arr,
        answer_id: this.$route.query.answer_id
      };
      Api.checkRoomApi.setRoundRecord(params, imgs_upload).then(function (res) {
        if (res.errcode == 1) {
          _this2.$router.replace({
            path: '/success',
            query: {
              id: _this2.$route.query.id,
              form_id: _this2.$route.query.form_id,
              name: 'detail_other_form',
              tabVal: _this2.$route.query.tabVal,
              answer_id: _this2.$route.query.answer_id
            }
          });
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    this.apiMonthLive();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/detail_other_form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_detail_other_form = ({
  name: 'detail_other_form',
  components: {
    baseInfoHeader: src_components_base_info_header
  },
  data: function data() {
    return {
      form_name: '',
      indexList: '',
      showSearch: true,
      has_answer: '', //是否填过答案
      id: this.$route.query.id,
      member_column_list: [], //表单数组
      column_list: [], //表单数组
      is_drapList: false,
      //孕妇列表
      maternal_list: [],
      //签名
      is_edit: true, //是否显示
      tmpImageUpload: {},
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      host: api_const["host"],
      pinyin_array: []
    };
  },

  methods: {
    //替换所有换行符
    replaceAllNewLine: function replaceAllNewLine(content) {
      var string = content;
      try {
        string = string.replace(/\r\n/g, "<br>");
        string = string.replace(/\n/g, "<br>");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },


    //替换br成换行
    replaceAllBr: function replaceAllBr(content) {
      var string = content;
      try {
        string = string.replace("<br>", "\n").replace("<br>", "\n");
        string = string.replace("<br>", "\n");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },
    textareaBlur: function textareaBlur(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.column_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column_list_item = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(column_list_item.row_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var row_list_item = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = get_iterator_default()(row_list_item.content), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var content_item = _step3.value;

                  if (content_item.id == id) {
                    content_item.my_answer = this.replaceAllBr(content_item.my_answer);
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(arr), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    selece_cfr: function selece_cfr(name, id) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.column_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var column_list_item = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(column_list_item.row_list), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var row_list_item = _step6.value;
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = get_iterator_default()(row_list_item.content), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var content_item = _step7.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.indexList = '';
                  }
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    selectPeople: function selectPeople(id) {
      if (this.indexList) {
        this.indexList = '';
        return;
      }
      this.indexList = id;
    },
    arrar_sort: function arrar_sort(newArr, oldArr) {
      var newList = [];
      var pyArrSort = newArr.sort();
      var i = 0;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(pyArrSort), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = get_iterator_default()(oldArr), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var list = _step9.value;

              if (item == list.pinyin) {
                newList[i] = list;
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          i++;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return newList;
    },
    cfr_list: function cfr_list(arr) {
      if (arr.length) {
        var nurser_name_arr = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = get_iterator_default()(arr), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var item = _step10.value;

            var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
            var obj = {
              name: [item.user_name],
              pinyin: _py
            };
            nurser_name_arr.push(obj);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var pyArr = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = get_iterator_default()(nurser_name_arr), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var _item = _step11.value;

            var obj = {
              name: _item.name,
              pinyin: _item.pinyin
            };
            var is_have = this.isInArray(pyArr, _item.pinyin);
            if (!is_have) {
              //不存在
              pyArr.push(_item.pinyin);
              this.pinyin_array.push(_item.pinyin);
              this.pinyin_array.sort();
              this.maternal_list.push(obj);
            } else {
              //存在
              var _index = pyArr.indexOf(_item.pinyin);
              this.maternal_list[_index].name.push(_item.name.join(''));
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
      }
    },

    //请求孕妇表单配置信息
    apiMonthLive: function apiMonthLive() {
      var _this = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id,
        answer_id: this.$route.query.answer_id
      };
      console.log(params);
      Api.checkRoomApi.addRecordFrom(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this.has_answer = res.data.has_answer;
          _this.form_name = res.data.form_data.name;
          _this.member_column_list = res.data.column_list;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = get_iterator_default()(res.data.form_data.column_list), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var column_list_item = _step12.value;
              var _iteratorNormalCompletion13 = true;
              var _didIteratorError13 = false;
              var _iteratorError13 = undefined;

              try {
                for (var _iterator13 = get_iterator_default()(column_list_item.row_list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                  var row_list_item = _step13.value;
                  var _iteratorNormalCompletion14 = true;
                  var _didIteratorError14 = false;
                  var _iteratorError14 = undefined;

                  try {
                    for (var _iterator14 = get_iterator_default()(row_list_item.content), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                      var content_item = _step14.value;
                      var _iteratorNormalCompletion15 = true;
                      var _didIteratorError15 = false;
                      var _iteratorError15 = undefined;

                      try {
                        for (var _iterator15 = get_iterator_default()(_this.member_column_list), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                          var item = _step15.value;

                          if (content_item.column_name == item.name) {
                            content_item.tip = item.value;
                            _this.$vux.loading.hide();
                          }
                        }
                      } catch (err) {
                        _didIteratorError15 = true;
                        _iteratorError15 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion15 && _iterator15.return) {
                            _iterator15.return();
                          }
                        } finally {
                          if (_didIteratorError15) {
                            throw _iteratorError15;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                      }
                    } finally {
                      if (_didIteratorError14) {
                        throw _iteratorError14;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion13 && _iterator13.return) {
                    _iterator13.return();
                  }
                } finally {
                  if (_didIteratorError13) {
                    throw _iteratorError13;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          _this.column_list = res.data.form_data.column_list;
          //孕妇列表
          _this.cfr_list(res.data.nurser_name);
        } else {
          _this.$vux.loading.hide();
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //是否提交过答案
    editForm: function editForm() {
      this.has_answer = '2';
    },
    input_focus: function input_focus(id) {
      this.is_drapList = id;
    },
    menuClick: function menuClick(name, id) {
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = get_iterator_default()(this.column_list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var column_list_item = _step16.value;
          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = get_iterator_default()(column_list_item.row_list), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var row_list_item = _step17.value;
              var _iteratorNormalCompletion18 = true;
              var _didIteratorError18 = false;
              var _iteratorError18 = undefined;

              try {
                for (var _iterator18 = get_iterator_default()(row_list_item.content), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                  var content_item = _step18.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.is_drapList = '';
                  }
                }
              } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion18 && _iterator18.return) {
                    _iterator18.return();
                  }
                } finally {
                  if (_didIteratorError18) {
                    throw _iteratorError18;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }
    },

    //保存签名
    save: function save(id) {
      var signature = 'signature' + id;
      var png = this.$refs[signature][0].save();
      var jpeg = this.$refs[signature][0].save('image/jpeg');
      var svg = this.$refs[signature][0].save('image/svg+xml');
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = get_iterator_default()(this.column_list), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var column_list_item = _step19.value;
          var _iteratorNormalCompletion20 = true;
          var _didIteratorError20 = false;
          var _iteratorError20 = undefined;

          try {
            for (var _iterator20 = get_iterator_default()(column_list_item.row_list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
              var row_list_item = _step20.value;
              var _iteratorNormalCompletion21 = true;
              var _didIteratorError21 = false;
              var _iteratorError21 = undefined;

              try {
                for (var _iterator21 = get_iterator_default()(row_list_item.content), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                  var content_item = _step21.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [encodeURI(png)];
                    this.is_edit = '';
                  }
                }
              } catch (err) {
                _didIteratorError21 = true;
                _iteratorError21 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion21 && _iterator21.return) {
                    _iterator21.return();
                  }
                } finally {
                  if (_didIteratorError21) {
                    throw _iteratorError21;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError20 = true;
            _iteratorError20 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion20 && _iterator20.return) {
                _iterator20.return();
              }
            } finally {
              if (_didIteratorError20) {
                throw _iteratorError20;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }
    },

    //清除签名
    clear: function clear(id) {
      var signature = 'signature' + id;
      var refs = this.$refs[signature][0].clear();
    },

    //编辑签名
    edit_signature: function edit_signature(id) {
      this.is_edit = id;
    },

    //图片上传
    fileImage: function fileImage(e) {
      var file = e.target.files[0];
      var item_id = e.target.id;
      var that = this;
      lrz(file).then(function (rst) {
        // 处理成功会执行
        var _iteratorNormalCompletion22 = true;
        var _didIteratorError22 = false;
        var _iteratorError22 = undefined;

        try {
          for (var _iterator22 = get_iterator_default()(that.column_list), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
            var column_list_item = _step22.value;
            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
              for (var _iterator23 = get_iterator_default()(column_list_item.row_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                var row_list_item = _step23.value;
                var _iteratorNormalCompletion24 = true;
                var _didIteratorError24 = false;
                var _iteratorError24 = undefined;

                try {
                  for (var _iterator24 = get_iterator_default()(row_list_item.content), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                    var content_item = _step24.value;

                    if (content_item.id == item_id) {
                      if (content_item.my_answer.length == 10) {
                        that.$vux.toast.show({
                          type: 'cancel',
                          text: '最多上传10张图片'
                        });
                        return;
                      }
                      content_item.my_answer.push(rst.base64);
                    }
                  }
                } catch (err) {
                  _didIteratorError24 = true;
                  _iteratorError24 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion24 && _iterator24.return) {
                      _iterator24.return();
                    }
                  } finally {
                    if (_didIteratorError24) {
                      throw _iteratorError24;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError23 = true;
              _iteratorError23 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion23 && _iterator23.return) {
                  _iterator23.return();
                }
              } finally {
                if (_didIteratorError23) {
                  throw _iteratorError23;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError22 = true;
          _iteratorError22 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion22 && _iterator22.return) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError22) {
              throw _iteratorError22;
            }
          }
        }
      }).catch(function (err) {
        console.info(err);
        that.$vux.toast.show({
          type: 'cancel',
          text: '网络错误'
        });
        // 处理失败会执行
      });
    },

    //删除图片
    delImg: function delImg(index, id) {
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = get_iterator_default()(this.column_list), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var column_list_item = _step25.value;
          var _iteratorNormalCompletion26 = true;
          var _didIteratorError26 = false;
          var _iteratorError26 = undefined;

          try {
            for (var _iterator26 = get_iterator_default()(column_list_item.row_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
              var row_list_item = _step26.value;
              var _iteratorNormalCompletion27 = true;
              var _didIteratorError27 = false;
              var _iteratorError27 = undefined;

              try {
                for (var _iterator27 = get_iterator_default()(row_list_item.content), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                  var content_item = _step27.value;

                  if (content_item.id == id) {
                    content_item.my_answer.splice(index, 1);
                  }
                }
              } catch (err) {
                _didIteratorError27 = true;
                _iteratorError27 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion27 && _iterator27.return) {
                    _iterator27.return();
                  }
                } finally {
                  if (_didIteratorError27) {
                    throw _iteratorError27;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError26 = true;
            _iteratorError26 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                _iterator26.return();
              }
            } finally {
              if (_didIteratorError26) {
                throw _iteratorError26;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }
    },

    //提交
    submitForm: function submitForm() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      //answer 
      var answer_list_arr = [];
      //图片上传
      var imgs_upload = [];
      // imgs_upload.push(this.tmpImageUpload);
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = get_iterator_default()(this.column_list), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var column_list_item = _step28.value;
          var _iteratorNormalCompletion29 = true;
          var _didIteratorError29 = false;
          var _iteratorError29 = undefined;

          try {
            for (var _iterator29 = get_iterator_default()(column_list_item.row_list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
              var row_list_item = _step29.value;
              var _iteratorNormalCompletion30 = true;
              var _didIteratorError30 = false;
              var _iteratorError30 = undefined;

              try {
                for (var _iterator30 = get_iterator_default()(row_list_item.content), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                  var content_item = _step30.value;


                  var obj = {
                    id: content_item.id,
                    answer: content_item.my_answer
                  };
                  if (content_item.type == "6") {
                    content_item.my_answer = this.replaceAllNewLine(content_item.my_answer);
                  }
                  if (content_item.type == "11" || content_item.type == '10') {
                    var _iteratorNormalCompletion31 = true;
                    var _didIteratorError31 = false;
                    var _iteratorError31 = undefined;

                    try {
                      for (var _iterator31 = get_iterator_default()(obj.answer), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                        var val = _step31.value;

                        var bold = '';
                        if (val.indexOf("http:") != -1 || val.indexOf("https:") != -1 || val.indexOf("Uploads/pad/") != -1) {
                          //  TODO:跨域，无法转dataurl
                          //  let url = Conf.baseUrl + val;
                          //   Util.convertImgToDataURLviaCanvas(url,function(res){
                          //     console.info('res:',res)
                          //   },"image/jpeg");
                          imgs_upload.push({
                            id: obj.id,
                            file: null,
                            url: val
                          });
                        } else {
                          bold = Util.dataURItoBlob(val);
                          imgs_upload.push({
                            id: obj.id,
                            file: bold
                          });
                        }
                      }
                    } catch (err) {
                      _didIteratorError31 = true;
                      _iteratorError31 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion31 && _iterator31.return) {
                          _iterator31.return();
                        }
                      } finally {
                        if (_didIteratorError31) {
                          throw _iteratorError31;
                        }
                      }
                    }

                    if (content_item.my_answer != '') {
                      answer_list_arr.push({
                        id: obj.id,
                        type: content_item.type
                      });
                    }
                  } else {
                    answer_list_arr.push(obj);
                  }
                }
              } catch (err) {
                _didIteratorError30 = true;
                _iteratorError30 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion30 && _iterator30.return) {
                    _iterator30.return();
                  }
                } finally {
                  if (_didIteratorError30) {
                    throw _iteratorError30;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError29 = true;
            _iteratorError29 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion29 && _iterator29.return) {
                _iterator29.return();
              }
            } finally {
              if (_didIteratorError29) {
                throw _iteratorError29;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id,
        answer_list: answer_list_arr,
        answer_id: this.$route.query.answer_id
      };
      Api.checkRoomApi.setRoundRecord(params, imgs_upload).then(function (res) {
        if (res.errcode == 1) {
          _this2.$router.replace({
            path: '/success',
            query: {
              id: _this2.$route.query.id,
              form_id: _this2.$route.query.form_id,
              name: 'detail_other_form',
              tabVal: _this2.$route.query.tabVal,
              answer_id: _this2.$route.query.answer_id
            }
          });
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    this.apiMonthLive();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8da4eba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail_other_form.vue
var detail_other_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v(_vm._s(_vm.form_name))]),_vm._v(" "),_c('div',{staticClass:"detail_form_main"},[_c('base-info-header',{attrs:{"maternalId":_vm.id}}),_vm._v(" "),(_vm.has_answer == '1')?_c('div',[_c('div',{staticClass:"over-height"},_vm._l((_vm.column_list),function(column_list_item,index){return (column_list_item.is_show_column == 1)?_c('group',{key:index,attrs:{"title":column_list_item.column_name,"label-width":"10em"}},_vm._l((column_list_item.row_list),function(row_list_item,index){return _c('div',{key:index},_vm._l((row_list_item.content),function(content_item,index){return _c('div',{key:index,staticClass:"vux-1px-b"},[(content_item.type == '1')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '2')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 4px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"4px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px"}},[_vm._v("\n                        "+_vm._s(content_item.my_answer[0])+"\n                      ")])])])]):_vm._e(),_vm._v(" "),(content_item.type == '3')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},_vm._l((content_item.my_answer),function(val,index){return _c('div',{key:index,staticStyle:{"display":"inline-block","line-height":"36px"}},[_vm._v(_vm._s(val)+"，")])}),0)])]):_vm._e(),_vm._v(" "),(content_item.type == '4')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '5')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '6')?_c('div',[(content_item.question)?_c('x-textarea',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-textarea',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '7')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '8')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '9')?_c('div',[_c('x-input',{attrs:{"title":content_item.question,"disabled":""},model:{value:(content_item.detail_tip),callback:function ($$v) {_vm.$set(content_item, "detail_tip", $$v)},expression:"content_item.detail_tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '10')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),(content_item.my_answer[0])?_c('div',{staticStyle:{"line-height":"36px","flex":"1"}},[(content_item.my_answer[0].length>100)?_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}}):_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":_vm.host+content_item.my_answer[0],"alt":""}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(content_item.type == '11')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',[(content_item.my_answer.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((content_item.my_answer),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}})])}),0):_vm._e()])])]):_vm._e(),_vm._v(" "),(content_item.type == '12')?_c('div',[(content_item.question)?_c('cell',{attrs:{"title":content_item.question+ '：',"value-align":"left"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('cell',{attrs:{"title":row_list_item.title,"value-align":"left"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e()])}),0)}),0):_vm._e()}),1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"15px"},attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.editForm.apply(null, arguments)}}},[_vm._v("修改")])],1):_c('div',[_c('div',{staticClass:"over-height"},_vm._l((_vm.column_list),function(column_list_item,index){return (column_list_item.is_show_column == 1)?_c('group',{key:index,attrs:{"title":column_list_item.column_name,"label-width":"9em"}},_vm._l((column_list_item.row_list),function(row_list_item,index){return _c('div',{key:index},_vm._l((row_list_item.content),function(content_item,index){return _c('div',{key:index,staticClass:"vux-1px-b"},[(content_item.type == '1')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '2')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}},_vm._l((content_item.answer),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '3')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(content_item.my_answer),callback:function ($$v) {_vm.$set(content_item, "my_answer", $$v)},expression:"content_item.my_answer"}},_vm._l((content_item.answer),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '4')?_c('div',[(content_item.question)?_c('selector',{attrs:{"title":content_item.question+ '：',"options":content_item.answer,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('selector',{attrs:{"title":row_list_item.title+ '：',"options":content_item.answer,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '5')?_c('div',[_c('datetime',{attrs:{"start-date":"1900-01-01","title":content_item.question+ '：',"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '6')?_c('div',[(content_item.question)?_c('x-textarea',{attrs:{"title":content_item.question,"placeholder":content_item.tip},on:{"on-blur":function($event){return _vm.textareaBlur(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-textarea',{attrs:{"title":row_list_item.title+ '：',"placeholder":content_item.tip},on:{"on-blur":function($event){return _vm.textareaBlur(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '7')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '8')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"placeholder":content_item.tip},on:{"on-focus":function($event){return _vm.input_focus(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"placeholder":content_item.tip,"id":content_item.id},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_drapList == content_item.id),expression:"is_drapList == content_item.id"}],staticClass:"drapList vux-1px"},_vm._l((content_item.answer),function(option,index){return _c('cell',{key:index,attrs:{"value":option,"value-align":"left"},nativeOn:{"click":function($event){return _vm.menuClick(option,content_item.id)}}})}),1)],1):_vm._e(),_vm._v(" "),(content_item.type == '9')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"placeholder":content_item.tip,"disabled":""},model:{value:(content_item.detail_tip),callback:function ($$v) {_vm.$set(content_item, "detail_tip", $$v)},expression:"content_item.detail_tip"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：'},model:{value:(content_item.detail_tip),callback:function ($$v) {_vm.$set(content_item, "detail_tip", $$v)},expression:"content_item.detail_tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '10')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","flex":"1"}},[(_vm.is_edit != content_item.id)?_c('div',[(content_item.my_answer[0])?_c('div',[(content_item.my_answer[0].length>100)?_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}}):_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":_vm.host+content_item.my_answer[0],"alt":""}})]):_c('div',[_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"t_r pd-10"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit_signature(content_item.id)}}},[_vm._v("编辑签名")])],1)]):_c('div',[_c('vueSignature',{ref:'signature' + content_item.id,refInFor:true,staticClass:"vueSignature",attrs:{"sigOption":_vm.option,"w":'100%',"h":'400px'}}),_vm._v(" "),_c('div',{staticClass:"t_r pd-10"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save(content_item.id)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear(content_item.id)}}},[_vm._v("清除")])],1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '11')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png","id":content_item.id},on:{"change":_vm.fileImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})])]),_vm._v(" "),(content_item.my_answer.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((content_item.my_answer),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[(item.length>100)?_c('img',{staticClass:"img",attrs:{"src":item,"width":"84","height":"84","alt":""}}):_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(index,content_item.id)}}})])}),0):_vm._e()])])]):_vm._e(),_vm._v(" "),(content_item.type == '12')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"width":"9em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"width":"9em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('div',{staticStyle:{"display":"flex"}},[(content_item.my_answer[0])?_c('div',{staticStyle:{"line-height":"29px","margin-right":"10px"}},[_vm._v(_vm._s(content_item.my_answer[0]))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople(content_item.id)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"},{name:"show",rawName:"v-show",value:(_vm.indexList == content_item.id),expression:"indexList == content_item.id"}],staticClass:"mtIndexList"},[_c('div',{staticStyle:{"text-align":"right","padding-right":"24px"}},[_c('x-button',{attrs:{"type":"default","mini":""},nativeOn:{"click":function($event){_vm.indexList = ''}}},[_vm._v("关闭")])],1),_vm._v(" "),_c('ul',{staticClass:"mtIndexListBox"},[_vm._l((_vm.maternal_list),function(item){return _c('li',{key:item.pinyin,attrs:{"id":item.pinyin}},[_c('p',{staticClass:"index_title"},[_vm._v(_vm._s(item.pinyin))]),_vm._v(" "),_c('dl',{staticStyle:{"padding-right":"30px"}},_vm._l((item.name),function(option,index){return _c('dd',{key:index,staticStyle:{"display":"inline-block"}},[_c('a',{staticStyle:{"display":"inline-block","color":"#333","padding":"10px 20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.selece_cfr(option,content_item.id)}}},[_vm._v(_vm._s(option))])])}),0)])}),_vm._v(" "),_c('div',{staticClass:"fixed_right_pinyin"},_vm._l((_vm.pinyin_array),function(item,index){return _c('a',{key:index,attrs:{"href":'#'+ item}},[_vm._v(_vm._s(item))])}),0)],2)])])])])]):_vm._e()])}),0)}),0):_vm._e()}),1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"15px"},attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)],1)}
var detail_other_form_staticRenderFns = []
var detail_other_form_esExports = { render: detail_other_form_render, staticRenderFns: detail_other_form_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_detail_other_form = (detail_other_form_esExports);
// CONCATENATED MODULE: ./src/components/detail_other_form.vue
function detail_other_form_injectStyle (ssrContext) {
  __webpack_require__("ibYt")
}
var detail_other_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var detail_other_form___vue_template_functional__ = false
/* styles */
var detail_other_form___vue_styles__ = detail_other_form_injectStyle
/* scopeId */
var detail_other_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var detail_other_form___vue_module_identifier__ = null
var detail_other_form_Component = detail_other_form_normalizeComponent(
  components_detail_other_form,
  selectortype_template_index_0_src_components_detail_other_form,
  detail_other_form___vue_template_functional__,
  detail_other_form___vue_styles__,
  detail_other_form___vue_scopeId__,
  detail_other_form___vue_module_identifier__
)

/* harmony default export */ var src_components_detail_other_form = (detail_other_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/baby_live.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var baby_live = ({
  name: 'baby_live',
  components: {
    baseInfoHeader: src_components_base_info_header
  },
  data: function data() {
    return {
      indexList: '',
      showSearch: true,
      has_answer: '', //是否填过答案
      id: this.$route.query.id,
      member_column_list: [], //表单数组
      column_list: [], //表单数组
      is_drapList: false,
      //孕妇列表
      maternal_list: [],
      //签名
      is_edit: true, //是否显示
      tmpImageUpload: {},
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      host: api_const["host"],
      pinyin_array: []
    };
  },

  methods: {
    //替换所有换行符
    replaceAllNewLine: function replaceAllNewLine(content) {
      var string = content;
      try {
        string = string.replace(/\r\n/g, "<br>");
        string = string.replace(/\n/g, "<br>");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },


    //替换br成换行
    replaceAllBr: function replaceAllBr(content) {
      var string = content;
      try {
        string = string.replace("<br>", "\n").replace("<br>", "\n");
        string = string.replace("<br>", "\n");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },
    textareaBlur: function textareaBlur(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.column_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column_list_item = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(column_list_item.row_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var row_list_item = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = get_iterator_default()(row_list_item.content), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var content_item = _step3.value;

                  if (content_item.id == id) {
                    content_item.my_answer = this.replaceAllBr(content_item.my_answer);
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(arr), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    selece_cfr: function selece_cfr(name, id) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.column_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var column_list_item = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(column_list_item.row_list), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var row_list_item = _step6.value;
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = get_iterator_default()(row_list_item.content), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var content_item = _step7.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.indexList = '';
                  }
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    selectPeople: function selectPeople(id) {
      if (this.indexList) {
        this.indexList = '';
        return;
      }
      this.indexList = id;
    },
    arrar_sort: function arrar_sort(newArr, oldArr) {
      var newList = [];
      var pyArrSort = newArr.sort();
      var i = 0;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(pyArrSort), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = get_iterator_default()(oldArr), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var list = _step9.value;

              if (item == list.pinyin) {
                newList[i] = list;
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          i++;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return newList;
    },
    cfr_list: function cfr_list(arr) {
      if (arr.length) {
        var nurser_name_arr = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = get_iterator_default()(arr), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var item = _step10.value;

            var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
            var obj = {
              name: [item.user_name],
              pinyin: _py
            };
            nurser_name_arr.push(obj);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var pyArr = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = get_iterator_default()(nurser_name_arr), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var _item = _step11.value;

            var obj = {
              name: _item.name,
              pinyin: _item.pinyin
            };
            var is_have = this.isInArray(pyArr, _item.pinyin);
            if (!is_have) {
              //不存在
              pyArr.push(_item.pinyin);
              this.pinyin_array.push(_item.pinyin);
              this.pinyin_array.sort();
              this.maternal_list.push(obj);
            } else {
              //存在
              var _index = pyArr.indexOf(_item.pinyin);
              this.maternal_list[_index].name.push(_item.name.join(''));
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
      }
    },

    //获取查房人列表
    apiGetCfrList: function apiGetCfrList() {
      var _this = this;

      var params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id')
      };
      Api.checkRoomApi.getCheckInfo(params).then(function (res) {
        console.info("获取查房人列表");
        console.info(res);
        if (res.errcode == 1) {
          _this.cfr_list(res.data.nurser_name);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求孕妇表单配置信息
    apiBabyLive: function apiBabyLive() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        child_id: this.$route.query.child_id
      };
      Api.babyLiveApi.babyEvaluationSheet(params).then(function (res) {
        console.log('宝宝入住', res);
        if (res.errcode == 1) {
          _this2.has_answer = res.data.has_answer;
          _this2.member_column_list = res.data.column_list;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = get_iterator_default()(res.data.form_data.column_list), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var column_list_item = _step12.value;
              var _iteratorNormalCompletion13 = true;
              var _didIteratorError13 = false;
              var _iteratorError13 = undefined;

              try {
                for (var _iterator13 = get_iterator_default()(column_list_item.row_list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                  var row_list_item = _step13.value;
                  var _iteratorNormalCompletion14 = true;
                  var _didIteratorError14 = false;
                  var _iteratorError14 = undefined;

                  try {
                    for (var _iterator14 = get_iterator_default()(row_list_item.content), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                      var content_item = _step14.value;
                      var _iteratorNormalCompletion15 = true;
                      var _didIteratorError15 = false;
                      var _iteratorError15 = undefined;

                      try {
                        for (var _iterator15 = get_iterator_default()(_this2.member_column_list), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                          var item = _step15.value;

                          if (content_item.column_name == item.name) {
                            content_item.tip = item.value;
                            _this2.$vux.loading.hide();
                          }
                        }
                      } catch (err) {
                        _didIteratorError15 = true;
                        _iteratorError15 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion15 && _iterator15.return) {
                            _iterator15.return();
                          }
                        } finally {
                          if (_didIteratorError15) {
                            throw _iteratorError15;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                      }
                    } finally {
                      if (_didIteratorError14) {
                        throw _iteratorError14;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion13 && _iterator13.return) {
                    _iterator13.return();
                  }
                } finally {
                  if (_didIteratorError13) {
                    throw _iteratorError13;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          _this2.column_list = res.data.form_data.column_list;
          //孕妇列表
          _this2.cfr_list(res.data.nurser_name);
          // this.apiGetCfrList()
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //是否提交过答案
    editForm: function editForm() {
      this.has_answer = '2';
    },
    input_focus: function input_focus(id) {
      this.is_drapList = id;
    },
    menuClick: function menuClick(name, id) {
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = get_iterator_default()(this.column_list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var column_list_item = _step16.value;
          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = get_iterator_default()(column_list_item.row_list), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var row_list_item = _step17.value;
              var _iteratorNormalCompletion18 = true;
              var _didIteratorError18 = false;
              var _iteratorError18 = undefined;

              try {
                for (var _iterator18 = get_iterator_default()(row_list_item.content), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                  var content_item = _step18.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.is_drapList = '';
                  }
                }
              } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion18 && _iterator18.return) {
                    _iterator18.return();
                  }
                } finally {
                  if (_didIteratorError18) {
                    throw _iteratorError18;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }
    },

    //保存签名
    save: function save(id) {
      var signature = 'signature' + id;
      var png = this.$refs[signature][0].save();
      var jpeg = this.$refs[signature][0].save('image/jpeg');
      var svg = this.$refs[signature][0].save('image/svg+xml');
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = get_iterator_default()(this.column_list), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var column_list_item = _step19.value;
          var _iteratorNormalCompletion20 = true;
          var _didIteratorError20 = false;
          var _iteratorError20 = undefined;

          try {
            for (var _iterator20 = get_iterator_default()(column_list_item.row_list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
              var row_list_item = _step20.value;
              var _iteratorNormalCompletion21 = true;
              var _didIteratorError21 = false;
              var _iteratorError21 = undefined;

              try {
                for (var _iterator21 = get_iterator_default()(row_list_item.content), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                  var content_item = _step21.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [encodeURI(png)];
                    this.is_edit = '';
                  }
                }
              } catch (err) {
                _didIteratorError21 = true;
                _iteratorError21 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion21 && _iterator21.return) {
                    _iterator21.return();
                  }
                } finally {
                  if (_didIteratorError21) {
                    throw _iteratorError21;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError20 = true;
            _iteratorError20 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion20 && _iterator20.return) {
                _iterator20.return();
              }
            } finally {
              if (_didIteratorError20) {
                throw _iteratorError20;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }
    },

    //清除签名
    clear: function clear(id) {
      var signature = 'signature' + id;
      var refs = this.$refs[signature][0].clear();
    },

    //编辑签名
    edit_signature: function edit_signature(id) {
      this.is_edit = id;
    },

    //图片上传
    fileImage: function fileImage(e) {
      var file = e.target.files[0];
      var item_id = e.target.id;
      var that = this;
      lrz(file).then(function (rst) {
        // 处理成功会执行
        var _iteratorNormalCompletion22 = true;
        var _didIteratorError22 = false;
        var _iteratorError22 = undefined;

        try {
          for (var _iterator22 = get_iterator_default()(that.column_list), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
            var column_list_item = _step22.value;
            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
              for (var _iterator23 = get_iterator_default()(column_list_item.row_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                var row_list_item = _step23.value;
                var _iteratorNormalCompletion24 = true;
                var _didIteratorError24 = false;
                var _iteratorError24 = undefined;

                try {
                  for (var _iterator24 = get_iterator_default()(row_list_item.content), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                    var content_item = _step24.value;

                    if (content_item.id == item_id) {
                      if (content_item.my_answer.length == 10) {
                        that.$vux.toast.show({
                          type: 'cancel',
                          text: '最多上传10张图片'
                        });
                        return;
                      }
                      content_item.my_answer.push(rst.base64);
                    }
                  }
                } catch (err) {
                  _didIteratorError24 = true;
                  _iteratorError24 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion24 && _iterator24.return) {
                      _iterator24.return();
                    }
                  } finally {
                    if (_didIteratorError24) {
                      throw _iteratorError24;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError23 = true;
              _iteratorError23 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion23 && _iterator23.return) {
                  _iterator23.return();
                }
              } finally {
                if (_didIteratorError23) {
                  throw _iteratorError23;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError22 = true;
          _iteratorError22 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion22 && _iterator22.return) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError22) {
              throw _iteratorError22;
            }
          }
        }
      }).catch(function (err) {
        console.info(err);
        that.$vux.toast.show({
          type: 'cancel',
          text: '网络错误'
        });
        // 处理失败会执行
      });
    },

    //删除图片
    delImg: function delImg(index, id) {
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = get_iterator_default()(this.column_list), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var column_list_item = _step25.value;
          var _iteratorNormalCompletion26 = true;
          var _didIteratorError26 = false;
          var _iteratorError26 = undefined;

          try {
            for (var _iterator26 = get_iterator_default()(column_list_item.row_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
              var row_list_item = _step26.value;
              var _iteratorNormalCompletion27 = true;
              var _didIteratorError27 = false;
              var _iteratorError27 = undefined;

              try {
                for (var _iterator27 = get_iterator_default()(row_list_item.content), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                  var content_item = _step27.value;

                  if (content_item.id == id) {
                    content_item.my_answer.splice(index, 1);
                  }
                }
              } catch (err) {
                _didIteratorError27 = true;
                _iteratorError27 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion27 && _iterator27.return) {
                    _iterator27.return();
                  }
                } finally {
                  if (_didIteratorError27) {
                    throw _iteratorError27;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError26 = true;
            _iteratorError26 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                _iterator26.return();
              }
            } finally {
              if (_didIteratorError26) {
                throw _iteratorError26;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }
    },

    //提交
    submitForm: function submitForm() {
      var _this3 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      //answer 
      var answer_list_arr = [];
      //图片上传
      var imgs_upload = [];
      // imgs_upload.push(this.tmpImageUpload);
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = get_iterator_default()(this.column_list), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var column_list_item = _step28.value;
          var _iteratorNormalCompletion29 = true;
          var _didIteratorError29 = false;
          var _iteratorError29 = undefined;

          try {
            for (var _iterator29 = get_iterator_default()(column_list_item.row_list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
              var row_list_item = _step29.value;
              var _iteratorNormalCompletion30 = true;
              var _didIteratorError30 = false;
              var _iteratorError30 = undefined;

              try {
                for (var _iterator30 = get_iterator_default()(row_list_item.content), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                  var content_item = _step30.value;


                  var obj = {
                    id: content_item.id,
                    answer: content_item.my_answer
                  };
                  if (content_item.type == "6") {
                    content_item.my_answer = this.replaceAllNewLine(content_item.my_answer);
                  }
                  if (content_item.type == "11" || content_item.type == '10') {
                    var _iteratorNormalCompletion31 = true;
                    var _didIteratorError31 = false;
                    var _iteratorError31 = undefined;

                    try {
                      for (var _iterator31 = get_iterator_default()(obj.answer), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                        var val = _step31.value;

                        var bold = '';
                        if (val.indexOf("http:") != -1 || val.indexOf("https:") != -1 || val.indexOf("Uploads/pad/") != -1) {
                          //  TODO:跨域，无法转dataurl
                          //  let url = Conf.baseUrl + val;
                          //   Util.convertImgToDataURLviaCanvas(url,function(res){
                          //     console.info('res:',res)
                          //   },"image/jpeg");
                          imgs_upload.push({
                            id: obj.id,
                            file: null,
                            url: val
                          });
                        } else {
                          bold = Util.dataURItoBlob(val);
                          imgs_upload.push({
                            id: obj.id,
                            file: bold
                          });
                        }
                      }
                    } catch (err) {
                      _didIteratorError31 = true;
                      _iteratorError31 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion31 && _iterator31.return) {
                          _iterator31.return();
                        }
                      } finally {
                        if (_didIteratorError31) {
                          throw _iteratorError31;
                        }
                      }
                    }

                    if (content_item.my_answer != '') {
                      answer_list_arr.push({
                        id: obj.id,
                        type: content_item.type
                      });
                    }
                  } else {
                    answer_list_arr.push(obj);
                  }
                }
              } catch (err) {
                _didIteratorError30 = true;
                _iteratorError30 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion30 && _iterator30.return) {
                    _iterator30.return();
                  }
                } finally {
                  if (_didIteratorError30) {
                    throw _iteratorError30;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError29 = true;
            _iteratorError29 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion29 && _iterator29.return) {
                _iterator29.return();
              }
            } finally {
              if (_didIteratorError29) {
                throw _iteratorError29;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var params = {
        token: this.$cookie.get('token'),
        child_id: this.$route.query.child_id,
        answer_list: answer_list_arr
      };
      Api.babyLiveApi.setBabyEvaluationSheet(params, imgs_upload).then(function (res) {
        if (res.errcode == 1) {
          _this3.$router.replace({
            path: '/success',
            query: {
              id: _this3.$route.query.id,
              child_id: _this3.$route.query.child_id,
              name: 'baby_live',
              tabVal: _this3.$route.query.tabVal
            }
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    this.apiBabyLive();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/baby_live.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_baby_live = ({
  name: 'baby_live',
  components: {
    baseInfoHeader: src_components_base_info_header
  },
  data: function data() {
    return {
      indexList: '',
      showSearch: true,
      has_answer: '', //是否填过答案
      id: this.$route.query.id,
      member_column_list: [], //表单数组
      column_list: [], //表单数组
      is_drapList: false,
      //孕妇列表
      maternal_list: [],
      //签名
      is_edit: true, //是否显示
      tmpImageUpload: {},
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      host: api_const["host"],
      pinyin_array: []
    };
  },

  methods: {
    //替换所有换行符
    replaceAllNewLine: function replaceAllNewLine(content) {
      var string = content;
      try {
        string = string.replace(/\r\n/g, "<br>");
        string = string.replace(/\n/g, "<br>");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },


    //替换br成换行
    replaceAllBr: function replaceAllBr(content) {
      var string = content;
      try {
        string = string.replace("<br>", "\n").replace("<br>", "\n");
        string = string.replace("<br>", "\n");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },
    textareaBlur: function textareaBlur(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.column_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column_list_item = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(column_list_item.row_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var row_list_item = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = get_iterator_default()(row_list_item.content), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var content_item = _step3.value;

                  if (content_item.id == id) {
                    content_item.my_answer = this.replaceAllBr(content_item.my_answer);
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(arr), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    selece_cfr: function selece_cfr(name, id) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.column_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var column_list_item = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(column_list_item.row_list), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var row_list_item = _step6.value;
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = get_iterator_default()(row_list_item.content), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var content_item = _step7.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.indexList = '';
                  }
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    selectPeople: function selectPeople(id) {
      if (this.indexList) {
        this.indexList = '';
        return;
      }
      this.indexList = id;
    },
    arrar_sort: function arrar_sort(newArr, oldArr) {
      var newList = [];
      var pyArrSort = newArr.sort();
      var i = 0;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(pyArrSort), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = get_iterator_default()(oldArr), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var list = _step9.value;

              if (item == list.pinyin) {
                newList[i] = list;
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          i++;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return newList;
    },
    cfr_list: function cfr_list(arr) {
      if (arr.length) {
        var nurser_name_arr = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = get_iterator_default()(arr), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var item = _step10.value;

            var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
            var obj = {
              name: [item.user_name],
              pinyin: _py
            };
            nurser_name_arr.push(obj);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var pyArr = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = get_iterator_default()(nurser_name_arr), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var _item = _step11.value;

            var obj = {
              name: _item.name,
              pinyin: _item.pinyin
            };
            var is_have = this.isInArray(pyArr, _item.pinyin);
            if (!is_have) {
              //不存在
              pyArr.push(_item.pinyin);
              this.pinyin_array.push(_item.pinyin);
              this.pinyin_array.sort();
              this.maternal_list.push(obj);
            } else {
              //存在
              var _index = pyArr.indexOf(_item.pinyin);
              this.maternal_list[_index].name.push(_item.name.join(''));
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
      }
    },

    //获取查房人列表
    apiGetCfrList: function apiGetCfrList() {
      var _this = this;

      var params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id')
      };
      Api.checkRoomApi.getCheckInfo(params).then(function (res) {
        console.info("获取查房人列表");
        console.info(res);
        if (res.errcode == 1) {
          _this.cfr_list(res.data.nurser_name);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求孕妇表单配置信息
    apiBabyLive: function apiBabyLive() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        child_id: this.$route.query.child_id
      };
      Api.babyLiveApi.babyEvaluationSheet(params).then(function (res) {
        console.log('宝宝入住', res);
        if (res.errcode == 1) {
          _this2.has_answer = res.data.has_answer;
          _this2.member_column_list = res.data.column_list;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = get_iterator_default()(res.data.form_data.column_list), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var column_list_item = _step12.value;
              var _iteratorNormalCompletion13 = true;
              var _didIteratorError13 = false;
              var _iteratorError13 = undefined;

              try {
                for (var _iterator13 = get_iterator_default()(column_list_item.row_list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                  var row_list_item = _step13.value;
                  var _iteratorNormalCompletion14 = true;
                  var _didIteratorError14 = false;
                  var _iteratorError14 = undefined;

                  try {
                    for (var _iterator14 = get_iterator_default()(row_list_item.content), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                      var content_item = _step14.value;
                      var _iteratorNormalCompletion15 = true;
                      var _didIteratorError15 = false;
                      var _iteratorError15 = undefined;

                      try {
                        for (var _iterator15 = get_iterator_default()(_this2.member_column_list), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                          var item = _step15.value;

                          if (content_item.column_name == item.name) {
                            content_item.tip = item.value;
                            _this2.$vux.loading.hide();
                          }
                        }
                      } catch (err) {
                        _didIteratorError15 = true;
                        _iteratorError15 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion15 && _iterator15.return) {
                            _iterator15.return();
                          }
                        } finally {
                          if (_didIteratorError15) {
                            throw _iteratorError15;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                      }
                    } finally {
                      if (_didIteratorError14) {
                        throw _iteratorError14;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion13 && _iterator13.return) {
                    _iterator13.return();
                  }
                } finally {
                  if (_didIteratorError13) {
                    throw _iteratorError13;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          _this2.column_list = res.data.form_data.column_list;
          //孕妇列表
          _this2.cfr_list(res.data.nurser_name);
          // this.apiGetCfrList()
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //是否提交过答案
    editForm: function editForm() {
      this.has_answer = '2';
    },
    input_focus: function input_focus(id) {
      this.is_drapList = id;
    },
    menuClick: function menuClick(name, id) {
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = get_iterator_default()(this.column_list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var column_list_item = _step16.value;
          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = get_iterator_default()(column_list_item.row_list), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var row_list_item = _step17.value;
              var _iteratorNormalCompletion18 = true;
              var _didIteratorError18 = false;
              var _iteratorError18 = undefined;

              try {
                for (var _iterator18 = get_iterator_default()(row_list_item.content), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                  var content_item = _step18.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.is_drapList = '';
                  }
                }
              } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion18 && _iterator18.return) {
                    _iterator18.return();
                  }
                } finally {
                  if (_didIteratorError18) {
                    throw _iteratorError18;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }
    },

    //保存签名
    save: function save(id) {
      var signature = 'signature' + id;
      var png = this.$refs[signature][0].save();
      var jpeg = this.$refs[signature][0].save('image/jpeg');
      var svg = this.$refs[signature][0].save('image/svg+xml');
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = get_iterator_default()(this.column_list), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var column_list_item = _step19.value;
          var _iteratorNormalCompletion20 = true;
          var _didIteratorError20 = false;
          var _iteratorError20 = undefined;

          try {
            for (var _iterator20 = get_iterator_default()(column_list_item.row_list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
              var row_list_item = _step20.value;
              var _iteratorNormalCompletion21 = true;
              var _didIteratorError21 = false;
              var _iteratorError21 = undefined;

              try {
                for (var _iterator21 = get_iterator_default()(row_list_item.content), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                  var content_item = _step21.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [encodeURI(png)];
                    this.is_edit = '';
                  }
                }
              } catch (err) {
                _didIteratorError21 = true;
                _iteratorError21 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion21 && _iterator21.return) {
                    _iterator21.return();
                  }
                } finally {
                  if (_didIteratorError21) {
                    throw _iteratorError21;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError20 = true;
            _iteratorError20 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion20 && _iterator20.return) {
                _iterator20.return();
              }
            } finally {
              if (_didIteratorError20) {
                throw _iteratorError20;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }
    },

    //清除签名
    clear: function clear(id) {
      var signature = 'signature' + id;
      var refs = this.$refs[signature][0].clear();
    },

    //编辑签名
    edit_signature: function edit_signature(id) {
      this.is_edit = id;
    },

    //图片上传
    fileImage: function fileImage(e) {
      var file = e.target.files[0];
      var item_id = e.target.id;
      var that = this;
      lrz(file).then(function (rst) {
        // 处理成功会执行
        var _iteratorNormalCompletion22 = true;
        var _didIteratorError22 = false;
        var _iteratorError22 = undefined;

        try {
          for (var _iterator22 = get_iterator_default()(that.column_list), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
            var column_list_item = _step22.value;
            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
              for (var _iterator23 = get_iterator_default()(column_list_item.row_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                var row_list_item = _step23.value;
                var _iteratorNormalCompletion24 = true;
                var _didIteratorError24 = false;
                var _iteratorError24 = undefined;

                try {
                  for (var _iterator24 = get_iterator_default()(row_list_item.content), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                    var content_item = _step24.value;

                    if (content_item.id == item_id) {
                      if (content_item.my_answer.length == 10) {
                        that.$vux.toast.show({
                          type: 'cancel',
                          text: '最多上传10张图片'
                        });
                        return;
                      }
                      content_item.my_answer.push(rst.base64);
                    }
                  }
                } catch (err) {
                  _didIteratorError24 = true;
                  _iteratorError24 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion24 && _iterator24.return) {
                      _iterator24.return();
                    }
                  } finally {
                    if (_didIteratorError24) {
                      throw _iteratorError24;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError23 = true;
              _iteratorError23 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion23 && _iterator23.return) {
                  _iterator23.return();
                }
              } finally {
                if (_didIteratorError23) {
                  throw _iteratorError23;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError22 = true;
          _iteratorError22 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion22 && _iterator22.return) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError22) {
              throw _iteratorError22;
            }
          }
        }
      }).catch(function (err) {
        console.info(err);
        that.$vux.toast.show({
          type: 'cancel',
          text: '网络错误'
        });
        // 处理失败会执行
      });
    },

    //删除图片
    delImg: function delImg(index, id) {
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = get_iterator_default()(this.column_list), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var column_list_item = _step25.value;
          var _iteratorNormalCompletion26 = true;
          var _didIteratorError26 = false;
          var _iteratorError26 = undefined;

          try {
            for (var _iterator26 = get_iterator_default()(column_list_item.row_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
              var row_list_item = _step26.value;
              var _iteratorNormalCompletion27 = true;
              var _didIteratorError27 = false;
              var _iteratorError27 = undefined;

              try {
                for (var _iterator27 = get_iterator_default()(row_list_item.content), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                  var content_item = _step27.value;

                  if (content_item.id == id) {
                    content_item.my_answer.splice(index, 1);
                  }
                }
              } catch (err) {
                _didIteratorError27 = true;
                _iteratorError27 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion27 && _iterator27.return) {
                    _iterator27.return();
                  }
                } finally {
                  if (_didIteratorError27) {
                    throw _iteratorError27;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError26 = true;
            _iteratorError26 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                _iterator26.return();
              }
            } finally {
              if (_didIteratorError26) {
                throw _iteratorError26;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }
    },

    //提交
    submitForm: function submitForm() {
      var _this3 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      //answer 
      var answer_list_arr = [];
      //图片上传
      var imgs_upload = [];
      // imgs_upload.push(this.tmpImageUpload);
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = get_iterator_default()(this.column_list), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var column_list_item = _step28.value;
          var _iteratorNormalCompletion29 = true;
          var _didIteratorError29 = false;
          var _iteratorError29 = undefined;

          try {
            for (var _iterator29 = get_iterator_default()(column_list_item.row_list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
              var row_list_item = _step29.value;
              var _iteratorNormalCompletion30 = true;
              var _didIteratorError30 = false;
              var _iteratorError30 = undefined;

              try {
                for (var _iterator30 = get_iterator_default()(row_list_item.content), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                  var content_item = _step30.value;


                  var obj = {
                    id: content_item.id,
                    answer: content_item.my_answer
                  };
                  if (content_item.type == "6") {
                    content_item.my_answer = this.replaceAllNewLine(content_item.my_answer);
                  }
                  if (content_item.type == "11" || content_item.type == '10') {
                    var _iteratorNormalCompletion31 = true;
                    var _didIteratorError31 = false;
                    var _iteratorError31 = undefined;

                    try {
                      for (var _iterator31 = get_iterator_default()(obj.answer), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                        var val = _step31.value;

                        var bold = '';
                        if (val.indexOf("http:") != -1 || val.indexOf("https:") != -1 || val.indexOf("Uploads/pad/") != -1) {
                          //  TODO:跨域，无法转dataurl
                          //  let url = Conf.baseUrl + val;
                          //   Util.convertImgToDataURLviaCanvas(url,function(res){
                          //     console.info('res:',res)
                          //   },"image/jpeg");
                          imgs_upload.push({
                            id: obj.id,
                            file: null,
                            url: val
                          });
                        } else {
                          bold = Util.dataURItoBlob(val);
                          imgs_upload.push({
                            id: obj.id,
                            file: bold
                          });
                        }
                      }
                    } catch (err) {
                      _didIteratorError31 = true;
                      _iteratorError31 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion31 && _iterator31.return) {
                          _iterator31.return();
                        }
                      } finally {
                        if (_didIteratorError31) {
                          throw _iteratorError31;
                        }
                      }
                    }

                    if (content_item.my_answer != '') {
                      answer_list_arr.push({
                        id: obj.id,
                        type: content_item.type
                      });
                    }
                  } else {
                    answer_list_arr.push(obj);
                  }
                }
              } catch (err) {
                _didIteratorError30 = true;
                _iteratorError30 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion30 && _iterator30.return) {
                    _iterator30.return();
                  }
                } finally {
                  if (_didIteratorError30) {
                    throw _iteratorError30;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError29 = true;
            _iteratorError29 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion29 && _iterator29.return) {
                _iterator29.return();
              }
            } finally {
              if (_didIteratorError29) {
                throw _iteratorError29;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var params = {
        token: this.$cookie.get('token'),
        child_id: this.$route.query.child_id,
        answer_list: answer_list_arr
      };
      Api.babyLiveApi.setBabyEvaluationSheet(params, imgs_upload).then(function (res) {
        if (res.errcode == 1) {
          _this3.$router.replace({
            path: '/success',
            query: {
              id: _this3.$route.query.id,
              child_id: _this3.$route.query.child_id,
              name: 'baby_live',
              tabVal: _this3.$route.query.tabVal
            }
          });
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    this.apiBabyLive();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8e6df814","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/baby_live.vue
var baby_live_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("宝宝入住评估表")]),_vm._v(" "),_c('div',{staticClass:"baby_main"},[_c('base-info-header',{attrs:{"maternalId":_vm.id}}),_vm._v(" "),(_vm.has_answer == '1')?_c('div',[_c('div',{staticClass:"over-height"},_vm._l((_vm.column_list),function(column_list_item,index){return (column_list_item.is_show_column == 1)?_c('group',{key:index,attrs:{"title":column_list_item.column_name,"label-width":"10em"}},_vm._l((column_list_item.row_list),function(row_list_item,index){return _c('div',{key:index},_vm._l((row_list_item.content),function(content_item,index){return _c('div',{key:index,staticClass:"vux-1px-b"},[(content_item.type == '1')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):(content_item.question == '' && row_list_item.title == '')?_c('x-input',{attrs:{"title":content_item.tip+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '2')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 4px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"4px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px"}},[_vm._v("\n                        "+_vm._s(content_item.my_answer[0])+"\n                      ")])])])]):_vm._e(),_vm._v(" "),(content_item.type == '3')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},_vm._l((content_item.my_answer),function(val,index){return _c('div',{key:index,staticStyle:{"display":"inline-block","line-height":"36px"}},[_vm._v(_vm._s(val)+"，")])}),0)])]):_vm._e(),_vm._v(" "),(content_item.type == '4')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '5')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '6')?_c('div',[(content_item.question)?_c('x-textarea',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-textarea',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '7')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"disabled":""},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}}):_c('x-input',{attrs:{"title":row_list_item.title,"disabled":""},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '8')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '9')?_c('div',[_c('x-input',{attrs:{"title":content_item.question,"disabled":""},model:{value:(content_item.detail_tip),callback:function ($$v) {_vm.$set(content_item, "detail_tip", $$v)},expression:"content_item.detail_tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '10')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),(content_item.my_answer[0])?_c('div',{staticStyle:{"line-height":"36px","flex":"1"}},[(content_item.my_answer[0].length>100)?_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}}):_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":_vm.host+content_item.my_answer[0],"alt":""}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(content_item.type == '11')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',[(content_item.my_answer.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((content_item.my_answer),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}})])}),0):_vm._e()])])]):_vm._e(),_vm._v(" "),(content_item.type == '12')?_c('div',[(content_item.question)?_c('cell',{attrs:{"title":content_item.question+ '：',"value-align":"left"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('cell',{attrs:{"title":row_list_item.title,"value-align":"left"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e()])}),0)}),0):_vm._e()}),1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"15px"},attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.editForm.apply(null, arguments)}}},[_vm._v("修改")])],1):_c('div',[_c('div',{staticClass:"over-height"},_vm._l((_vm.column_list),function(column_list_item,index){return (column_list_item.is_show_column == 1)?_c('group',{key:index,attrs:{"title":column_list_item.column_name,"label-width":"9em"}},_vm._l((column_list_item.row_list),function(row_list_item,index){return _c('div',{key:index},_vm._l((row_list_item.content),function(content_item,index){return _c('div',{key:index,staticClass:"vux-1px-b"},[(content_item.type == '1')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):(content_item.question == '' && row_list_item.title == '')?_c('x-input',{attrs:{"title":content_item.tip+ '：',"placeholder":content_item.tip+content_item.unit},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip+content_item.unit},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '2')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}},_vm._l((content_item.answer),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '3')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(content_item.my_answer),callback:function ($$v) {_vm.$set(content_item, "my_answer", $$v)},expression:"content_item.my_answer"}},_vm._l((content_item.answer),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '4')?_c('div',[(content_item.question)?_c('selector',{attrs:{"title":content_item.question,"options":content_item.answer,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('selector',{attrs:{"title":row_list_item.title,"options":content_item.answer,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '5')?_c('div',[_c('datetime',{attrs:{"start-date":"1900-01-01","title":content_item.question,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '6')?_c('div',[(content_item.question)?_c('x-textarea',{attrs:{"title":content_item.question,"placeholder":content_item.tip+content_item.unit},on:{"on-blur":function($event){return _vm.textareaBlur(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-textarea',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip+content_item.unit},on:{"on-blur":function($event){return _vm.textareaBlur(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '7')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"disabled":"","placeholder":content_item.tip+content_item.unit},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}}):_c('x-input',{attrs:{"title":row_list_item.title,"disabled":"","placeholder":content_item.tip+content_item.unit},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '8')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"placeholder":content_item.tip+content_item.unit},on:{"on-focus":function($event){return _vm.input_focus(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip+content_item.unit,"id":content_item.id},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_drapList == content_item.id),expression:"is_drapList == content_item.id"}],staticClass:"drapList vux-1px"},_vm._l((content_item.answer),function(option,index){return _c('cell',{key:index,attrs:{"value":option,"value-align":"left"},nativeOn:{"click":function($event){return _vm.menuClick(option,content_item.id)}}})}),1)],1):_vm._e(),_vm._v(" "),(content_item.type == '9')?_c('div',[_c('x-input',{attrs:{"title":content_item.question,"disabled":"","placeholder":content_item.tip+content_item.unit},model:{value:(content_item.detail_tip),callback:function ($$v) {_vm.$set(content_item, "detail_tip", $$v)},expression:"content_item.detail_tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '10')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","flex":"1"}},[(_vm.is_edit != content_item.id)?_c('div',[(content_item.my_answer[0])?_c('div',[(content_item.my_answer[0].length>100)?_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}}):_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":_vm.host+content_item.my_answer[0],"alt":""}})]):_c('div',[_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"t_r pd-10"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit_signature(content_item.id)}}},[_vm._v("编辑签名")])],1)]):_c('div',[_c('vueSignature',{ref:'signature'+content_item.id,refInFor:true,staticClass:"vueSignature",attrs:{"sigOption":_vm.option,"w":'100%',"h":'400px'}}),_vm._v(" "),_c('div',{staticClass:"t_r pd-10"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save(content_item.id)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear(content_item.id)}}},[_vm._v("清除")])],1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '11')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png","id":content_item.id},on:{"change":_vm.fileImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})])]),_vm._v(" "),(content_item.my_answer.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((content_item.my_answer),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[(item.length>100)?_c('img',{staticClass:"img",attrs:{"src":item,"width":"84","height":"84","alt":""}}):_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(index,content_item.id)}}})])}),0):_vm._e()])])]):_vm._e(),_vm._v(" "),(content_item.type == '12')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('div',{staticStyle:{"display":"flex"}},[(content_item.my_answer[0])?_c('div',{staticStyle:{"line-height":"29px","margin-right":"10px"}},[_vm._v(_vm._s(content_item.my_answer[0]))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople(content_item.id)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"},{name:"show",rawName:"v-show",value:(_vm.indexList == content_item.id),expression:"indexList == content_item.id"}],staticClass:"mtIndexList"},[_c('div',{staticStyle:{"text-align":"right","padding-right":"24px"}},[_c('x-button',{attrs:{"type":"default","mini":""},nativeOn:{"click":function($event){_vm.indexList = ''}}},[_vm._v("关闭")])],1),_vm._v(" "),_c('ul',{staticClass:"mtIndexListBox"},[_vm._l((_vm.maternal_list),function(item){return _c('li',{key:item.pinyin,attrs:{"id":item.pinyin}},[_c('p',{staticClass:"index_title"},[_vm._v(_vm._s(item.pinyin))]),_vm._v(" "),_c('dl',{staticStyle:{"padding-right":"30px"}},_vm._l((item.name),function(option,index){return _c('dd',{key:index,staticStyle:{"display":"inline-block"}},[_c('a',{staticStyle:{"display":"inline-block","color":"#333","padding":"10px 20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.selece_cfr(option,content_item.id)}}},[_vm._v(_vm._s(option))])])}),0)])}),_vm._v(" "),_c('div',{staticClass:"fixed_right_pinyin"},_vm._l((_vm.pinyin_array),function(item,index){return _c('a',{key:index,attrs:{"href":'#'+ item}},[_vm._v(_vm._s(item))])}),0)],2)])])])])]):_vm._e()])}),0)}),0):_vm._e()}),1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"15px"},attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)],1)}
var baby_live_staticRenderFns = []
var baby_live_esExports = { render: baby_live_render, staticRenderFns: baby_live_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_baby_live = (baby_live_esExports);
// CONCATENATED MODULE: ./src/components/baby_live.vue
function baby_live_injectStyle (ssrContext) {
  __webpack_require__("hK0y")
}
var baby_live_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var baby_live___vue_template_functional__ = false
/* styles */
var baby_live___vue_styles__ = baby_live_injectStyle
/* scopeId */
var baby_live___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var baby_live___vue_module_identifier__ = null
var baby_live_Component = baby_live_normalizeComponent(
  components_baby_live,
  selectortype_template_index_0_src_components_baby_live,
  baby_live___vue_template_functional__,
  baby_live___vue_styles__,
  baby_live___vue_scopeId__,
  baby_live___vue_module_identifier__
)

/* harmony default export */ var src_components_baby_live = (baby_live_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/baby_medication_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var baby_medication_list_pulldownDefaultConfig = {
    content: '下拉刷新',
    height: 40,
    autoRefresh: false,
    downContent: '下拉刷新',
    upContent: '释放后刷新',
    loadingContent: '正在刷新...',
    clsPrefix: 'xs-plugin-pulldown-'
};
var baby_medication_list_pullupDefaultConfig = {
    content: '上拉加载更多',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: '释放后加载',
    upContent: '上拉加载更多',
    loadingContent: '加载中...',
    clsPrefix: 'xs-plugin-pullup-'
};
/* harmony default export */ var baby_medication_list = ({
    name: "baby_medication_list",
    data: function data() {
        return {
            keyword: '',
            page: '1',
            listData: [],
            pullupDefaultConfig: baby_medication_list_pullupDefaultConfig,
            pulldownDefaultConfig: baby_medication_list_pulldownDefaultConfig,
            showDialog: false,
            group: {
                drug_name: '',
                dosage: '',
                date: '',
                remark: ''
            }
        };
    },

    methods: {
        //添加记录打开dialog
        addRecord: function addRecord() {
            this.showDialog = true;
        },

        //添加记录确认
        dialog_confirm: function dialog_confirm() {
            var _this = this;

            if (this.group.drug_name == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入药品名称'
                });
                return;
            }
            if (this.group.dosage == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入使用剂量'
                });
                return;
            }
            var re = /^[0-9]+.?[0-9]*/;
            if (!re.test(this.group.dosage)) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入正确格式'
                });
                return;
            }
            if (this.group.date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择服药时间'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                drug_name: this.group.drug_name,
                dosage: this.group.dosage,
                date: this.group.date,
                remark: this.group.remark
            };
            Api.babyLiveApi.addBabeMedicationList(params).then(function (res) {
                if (res.errcode == 1) {
                    _this.$vux.toast.show({
                        type: 'success',
                        text: res.errinfo
                    });
                    _this.showDialog = false;
                    _this.refresh();
                    _this.group.drug_name = '';
                    _this.group.dosage = '';
                    _this.group.date = '';
                    _this.group.remark = '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //dialog隐藏
        dialog_exit: function dialog_exit() {
            this.showDialog = false;
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日' + h + ':' + minute + ':' + second;
        },

        //清楚筛选
        clearSearch: function clearSearch() {
            this.keyword = '';
            this.refresh();
        },

        //筛选
        searchBtn: function searchBtn() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.scrollerBottom.reset({ top: 0 });
                _this2.refresh();
            });
        },

        //请求列表数据
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                query: this.keyword,
                page: this.page
            };
            Api.babyLiveApi.getBabeMedicationList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.page++;
                    _this3.$nextTick(function () {
                        _this3.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                var obj = {
                                    user_name: item.user_name,
                                    drug_name: item.drug_name,
                                    child_id: item.child_id,
                                    dosage: item.dosage,
                                    date: item.date,
                                    remark: item.remark
                                };
                                _this3.listData.push(obj);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this3.$refs.scrollerBottom.donePullup();
                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup();
                            _this3.$refs.scrollerBottom.donePulldown();
                        }
                        if (_this3.page > res.data.page.page_count) {
                            // 禁用上拉加载，在没有更多数据时执行
                            _this3.$refs.scrollerBottom.disablePullup();
                        }
                    }
                } else {
                    _this3.listData = [];
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData.length = 0;
            this.page = '1';
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.$refs.scrollerBottom.reset({ top: 0 });
        });
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/baby_medication_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var components_baby_medication_list_pulldownDefaultConfig = {
    content: '下拉刷新',
    height: 40,
    autoRefresh: false,
    downContent: '下拉刷新',
    upContent: '释放后刷新',
    loadingContent: '正在刷新...',
    clsPrefix: 'xs-plugin-pulldown-'
};
var components_baby_medication_list_pullupDefaultConfig = {
    content: '上拉加载更多',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: '释放后加载',
    upContent: '上拉加载更多',
    loadingContent: '加载中...',
    clsPrefix: 'xs-plugin-pullup-'
};
/* harmony default export */ var components_baby_medication_list = ({
    name: "baby_medication_list",
    data: function data() {
        return {
            keyword: '',
            page: '1',
            listData: [],
            pullupDefaultConfig: components_baby_medication_list_pullupDefaultConfig,
            pulldownDefaultConfig: components_baby_medication_list_pulldownDefaultConfig,
            showDialog: false,
            group: {
                drug_name: '',
                dosage: '',
                date: '',
                remark: ''
            }
        };
    },

    methods: {
        //添加记录打开dialog
        addRecord: function addRecord() {
            this.showDialog = true;
        },

        //添加记录确认
        dialog_confirm: function dialog_confirm() {
            var _this = this;

            if (this.group.drug_name == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入药品名称'
                });
                return;
            }
            if (this.group.dosage == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入使用剂量'
                });
                return;
            }
            var re = /^[0-9]+.?[0-9]*/;
            if (!re.test(this.group.dosage)) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入正确格式'
                });
                return;
            }
            if (this.group.date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择服药时间'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                drug_name: this.group.drug_name,
                dosage: this.group.dosage,
                date: this.group.date,
                remark: this.group.remark
            };
            Api.babyLiveApi.addBabeMedicationList(params).then(function (res) {
                if (res.errcode == 1) {
                    _this.$vux.toast.show({
                        type: 'success',
                        text: res.errinfo
                    });
                    _this.showDialog = false;
                    _this.refresh();
                    _this.group.drug_name = '';
                    _this.group.dosage = '';
                    _this.group.date = '';
                    _this.group.remark = '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //dialog隐藏
        dialog_exit: function dialog_exit() {
            this.showDialog = false;
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日' + h + ':' + minute + ':' + second;
        },

        //清楚筛选
        clearSearch: function clearSearch() {
            this.keyword = '';
            this.refresh();
        },

        //筛选
        searchBtn: function searchBtn() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.scrollerBottom.reset({ top: 0 });
                _this2.refresh();
            });
        },

        //请求列表数据
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                query: this.keyword,
                page: this.page
            };
            Api.babyLiveApi.getBabeMedicationList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.page++;
                    _this3.$nextTick(function () {
                        _this3.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                var obj = {
                                    user_name: item.user_name,
                                    drug_name: item.drug_name,
                                    child_id: item.child_id,
                                    dosage: item.dosage,
                                    date: item.date,
                                    remark: item.remark
                                };
                                _this3.listData.push(obj);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this3.$refs.scrollerBottom.donePullup();
                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup();
                            _this3.$refs.scrollerBottom.donePulldown();
                        }
                        if (_this3.page > res.data.page.page_count) {
                            // 禁用上拉加载，在没有更多数据时执行
                            _this3.$refs.scrollerBottom.disablePullup();
                        }
                    }
                } else {
                    _this3.listData = [];
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData.length = 0;
            this.page = '1';
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.$refs.scrollerBottom.reset({ top: 0 });
        });
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf3ab944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/baby_medication_list.vue
var baby_medication_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("宝宝服药登记表")]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('group',[_c('x-input',{attrs:{"placeholder":"请输入状态、药品名称、使用药量、操作人"},on:{"on-click-clear-icon":_vm.clearSearch},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}},[_c('x-button',{attrs:{"slot":"right","gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.searchBtn.apply(null, arguments)}},slot:"right"},[_vm._v("搜索")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0px","margin-left":"10px"},attrs:{"slot":"right","gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.addRecord.apply(null, arguments)}},slot:"right"},[_vm._v("添加记录")])],1)],1),_vm._v(" "),_c('div',{staticClass:"sheng-table vux-1px"},[_vm._m(0),_vm._v(" "),_c('scroller',{ref:"scrollerBottom",staticClass:"tbody",attrs:{"use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"use-pulldown":"","pulldown-config":_vm.pulldownDefaultConfig,"lock-x":"","height":"-180"},on:{"on-pullup-loading":_vm.loadMore,"on-pulldown-loading":_vm.refresh}},[_c('div',_vm._l((_vm.listData),function(item,index){return _c('li',{key:item.id,staticClass:"vux-1px-b"},[_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"8%"}},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v(_vm._s(item.drug_name))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"14%"}},[_vm._v(_vm._s(item.dosage))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"25%"}},[_vm._v(_vm._s(item.date))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"13%"}},[_vm._v(_vm._s(item.user_name))]),_vm._v(" "),_c('div',{staticStyle:{"width":"20%"}},[_vm._v(_vm._s(item.remark))])])}),0)])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('x-dialog',{attrs:{"dialog-style":{'max-width': '100%', width: '400px', height: 'auto', 'background-color': '#fff'}},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('group',{attrs:{"title":"添加宝宝服药记录","label-width":"5em"}},[_c('x-input',{attrs:{"title":"药品名称：","placeholder":"请输入"},model:{value:(_vm.group.drug_name),callback:function ($$v) {_vm.$set(_vm.group, "drug_name", $$v)},expression:"group.drug_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"使用剂量：","placeholder":"请输入（单位：ml）"},model:{value:(_vm.group.dosage),callback:function ($$v) {_vm.$set(_vm.group, "dosage", $$v)},expression:"group.dosage"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"服药时间：","placeholder":"请选择","format":"YYYY-MM-DD HH:mm"},model:{value:(_vm.group.date),callback:function ($$v) {_vm.$set(_vm.group, "date", $$v)},expression:"group.date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"备注信息：","placeholder":"请输入"},model:{value:(_vm.group.remark),callback:function ($$v) {_vm.$set(_vm.group, "remark", $$v)},expression:"group.remark"}})],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('x-button',{staticClass:"b_btn_style",staticStyle:{"color":"#19D5FD","border-right":"1px solid #eee!important"},attrs:{"type":"default","action-type":"submit"},nativeOn:{"click":function($event){return _vm.dialog_confirm.apply(null, arguments)}}},[_vm._v("确认")])],1),_vm._v(" "),_c('flexbox-item',[_c('x-button',{staticClass:"b_btn_style",staticStyle:{"color":"#999"},attrs:{"type":"default"},nativeOn:{"click":function($event){return _vm.dialog_exit.apply(null, arguments)}}},[_vm._v("取消")])],1)],1)],1)],1)],1)],1)}
var baby_medication_list_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"thead"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"8%"}},[_vm._v("序号")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v("药品名称")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"14%"}},[_vm._v("使用剂量(ml)")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"25%"}},[_vm._v("服药时间")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"13%"}},[_vm._v("操作人")]),_vm._v(" "),_c('li',{staticStyle:{"width":"20%"}},[_vm._v("备注")])])}]
var baby_medication_list_esExports = { render: baby_medication_list_render, staticRenderFns: baby_medication_list_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_baby_medication_list = (baby_medication_list_esExports);
// CONCATENATED MODULE: ./src/components/baby_medication_list.vue
function baby_medication_list_injectStyle (ssrContext) {
  __webpack_require__("5cou")
}
var baby_medication_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var baby_medication_list___vue_template_functional__ = false
/* styles */
var baby_medication_list___vue_styles__ = baby_medication_list_injectStyle
/* scopeId */
var baby_medication_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var baby_medication_list___vue_module_identifier__ = null
var baby_medication_list_Component = baby_medication_list_normalizeComponent(
  components_baby_medication_list,
  selectortype_template_index_0_src_components_baby_medication_list,
  baby_medication_list___vue_template_functional__,
  baby_medication_list___vue_styles__,
  baby_medication_list___vue_scopeId__,
  baby_medication_list___vue_module_identifier__
)

/* harmony default export */ var src_components_baby_medication_list = (baby_medication_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/baby_sign_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var baby_sign_list_pulldownDefaultConfig = {
    content: '下拉刷新',
    height: 40,
    autoRefresh: false,
    downContent: '下拉刷新',
    upContent: '释放后刷新',
    loadingContent: '正在刷新...',
    clsPrefix: 'xs-plugin-pulldown-'
};
var baby_sign_list_pullupDefaultConfig = {
    content: '上拉加载更多',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: '释放后加载',
    upContent: '上拉加载更多',
    loadingContent: '加载中...',
    clsPrefix: 'xs-plugin-pullup-'
};
/* harmony default export */ var baby_sign_list = ({
    name: "baby_sign_list",
    data: function data() {
        return {
            keyword: '',
            page: '1',
            listData: [],
            pullupDefaultConfig: baby_sign_list_pullupDefaultConfig,
            pulldownDefaultConfig: baby_sign_list_pulldownDefaultConfig,
            showDialog: false,
            group: {
                temperature: '',
                weight: '',
                jaundice: ''
            }
        };
    },

    methods: {
        //添加记录打开dialog
        addRecord: function addRecord() {
            this.showDialog = true;
        },

        //添加记录确认
        dialog_confirm: function dialog_confirm() {
            var _this = this;

            if (this.group.temperature == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入体温值'
                });
                return;
            }
            if (this.group.weight == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入体重值'
                });
                return;
            }
            if (this.group.jaundice == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入黄疸值'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                weight: this.group.weight,
                temperature: this.group.temperature,
                jaundice: this.group.jaundice
            };
            Api.babyLiveApi.addBabeSign(params).then(function (res) {
                if (res.errcode == 1) {
                    _this.$vux.toast.show({
                        type: 'success',
                        text: res.errinfo
                    });
                    _this.showDialog = false;
                    _this.refresh();
                    _this.group.weight = '';
                    _this.group.jaundice = '';
                    _this.group.temperature = '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //dialog隐藏
        dialog_exit: function dialog_exit() {
            this.showDialog = false;
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日' + h + ':' + minute + ':' + second;
        },

        //清楚筛选
        clearSearch: function clearSearch() {
            this.keyword = '';
            this.refresh();
        },

        //筛选
        searchBtn: function searchBtn() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.scrollerBottom.reset({ top: 0 });
                _this2.refresh();
            });
        },

        //请求列表数据
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                query: this.keyword,
                page: this.page
            };
            Api.babyLiveApi.getBabeSignList(params).then(function (res) {
                if (res.errcode == 1) {
                    _this3.page++;
                    _this3.$nextTick(function () {
                        _this3.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                var obj = {
                                    temperature: item.temperature,
                                    child_id: item.child_id,
                                    user_name: item.user_name,
                                    weight: item.weight,
                                    jaundice: item.jaundice,
                                    birth_day: item.birth_day,
                                    record_time: item.record_time
                                };
                                _this3.listData.push(obj);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this3.$refs.scrollerBottom.donePullup();
                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup();
                            _this3.$refs.scrollerBottom.donePulldown();
                        }
                        if (_this3.page > res.data.page.page_count) {
                            // 禁用上拉加载，在没有更多数据时执行
                            _this3.$refs.scrollerBottom.disablePullup();
                        }
                    }
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData.length = 0;
            this.page = '1';
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.$refs.scrollerBottom.reset({ top: 0 });
        });
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/baby_sign_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var components_baby_sign_list_pulldownDefaultConfig = {
    content: '下拉刷新',
    height: 40,
    autoRefresh: false,
    downContent: '下拉刷新',
    upContent: '释放后刷新',
    loadingContent: '正在刷新...',
    clsPrefix: 'xs-plugin-pulldown-'
};
var components_baby_sign_list_pullupDefaultConfig = {
    content: '上拉加载更多',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: '释放后加载',
    upContent: '上拉加载更多',
    loadingContent: '加载中...',
    clsPrefix: 'xs-plugin-pullup-'
};
/* harmony default export */ var components_baby_sign_list = ({
    name: "baby_sign_list",
    data: function data() {
        return {
            keyword: '',
            page: '1',
            listData: [],
            pullupDefaultConfig: components_baby_sign_list_pullupDefaultConfig,
            pulldownDefaultConfig: components_baby_sign_list_pulldownDefaultConfig,
            showDialog: false,
            group: {
                temperature: '',
                weight: '',
                jaundice: ''
            }
        };
    },

    methods: {
        //添加记录打开dialog
        addRecord: function addRecord() {
            this.showDialog = true;
        },

        //添加记录确认
        dialog_confirm: function dialog_confirm() {
            var _this = this;

            if (this.group.temperature == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入体温值'
                });
                return;
            }
            if (this.group.weight == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入体重值'
                });
                return;
            }
            if (this.group.jaundice == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入黄疸值'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                weight: this.group.weight,
                temperature: this.group.temperature,
                jaundice: this.group.jaundice
            };
            Api.babyLiveApi.addBabeSign(params).then(function (res) {
                if (res.errcode == 1) {
                    _this.$vux.toast.show({
                        type: 'success',
                        text: res.errinfo
                    });
                    _this.showDialog = false;
                    _this.refresh();
                    _this.group.weight = '';
                    _this.group.jaundice = '';
                    _this.group.temperature = '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //dialog隐藏
        dialog_exit: function dialog_exit() {
            this.showDialog = false;
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日' + h + ':' + minute + ':' + second;
        },

        //清楚筛选
        clearSearch: function clearSearch() {
            this.keyword = '';
            this.refresh();
        },

        //筛选
        searchBtn: function searchBtn() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.scrollerBottom.reset({ top: 0 });
                _this2.refresh();
            });
        },

        //请求列表数据
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                query: this.keyword,
                page: this.page
            };
            Api.babyLiveApi.getBabeSignList(params).then(function (res) {
                if (res.errcode == 1) {
                    _this3.page++;
                    _this3.$nextTick(function () {
                        _this3.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                var obj = {
                                    temperature: item.temperature,
                                    child_id: item.child_id,
                                    user_name: item.user_name,
                                    weight: item.weight,
                                    jaundice: item.jaundice,
                                    birth_day: item.birth_day,
                                    record_time: item.record_time
                                };
                                _this3.listData.push(obj);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this3.$refs.scrollerBottom.donePullup();
                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup();
                            _this3.$refs.scrollerBottom.donePulldown();
                        }
                        if (_this3.page > res.data.page.page_count) {
                            // 禁用上拉加载，在没有更多数据时执行
                            _this3.$refs.scrollerBottom.disablePullup();
                        }
                    }
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData.length = 0;
            this.page = '1';
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.$refs.scrollerBottom.reset({ top: 0 });
        });
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ca6ea4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/baby_sign_list.vue
var baby_sign_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("宝宝体质记录表")]),_vm._v(" "),_c('div',{staticClass:"pd-10"},[_c('x-button',{staticStyle:{"margin-top":"10px","margin-left":"10px"},attrs:{"slot":"right","gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.addRecord.apply(null, arguments)}},slot:"right"},[_vm._v("添加记录")]),_vm._v(" "),_c('div',{staticClass:"sheng-table vux-1px"},[_vm._m(0),_vm._v(" "),_c('scroller',{ref:"scrollerBottom",staticClass:"tbody",attrs:{"use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"use-pulldown":"","pulldown-config":_vm.pulldownDefaultConfig,"lock-x":"","height":"-150"},on:{"on-pullup-loading":_vm.loadMore,"on-pulldown-loading":_vm.refresh}},[_c('div',_vm._l((_vm.listData),function(item,index){return _c('li',{key:item.id,staticClass:"vux-1px-b"},[_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v(_vm._s(item.temperature))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v(_vm._s(item.weight))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v(_vm._s(item.jaundice))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"12%"}},[_vm._v(_vm._s(item.birth_day))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"17%"}},[_vm._v(_vm._s(item.user_name))]),_vm._v(" "),_c('div',{staticStyle:{"width":"28%"}},[_vm._v(_vm._s(item.record_time))])])}),0)])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('x-dialog',{attrs:{"dialog-style":{'max-width': '100%', width: '400px', height: 'auto', 'background-color': '#fff'}},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('group',{attrs:{"title":"添加宝宝体质记录","label-width":"5em"}},[_c('x-input',{attrs:{"title":"体温值：","placeholder":"请输入(单位：℃)"},model:{value:(_vm.group.temperature),callback:function ($$v) {_vm.$set(_vm.group, "temperature", $$v)},expression:"group.temperature"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体重值：","placeholder":"请输入（单位：KG）"},model:{value:(_vm.group.weight),callback:function ($$v) {_vm.$set(_vm.group, "weight", $$v)},expression:"group.weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"黄疸值：","placeholder":"请输入（单位：mg/dl）"},model:{value:(_vm.group.jaundice),callback:function ($$v) {_vm.$set(_vm.group, "jaundice", $$v)},expression:"group.jaundice"}})],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('x-button',{staticClass:"b_btn_style",staticStyle:{"color":"#19D5FD","border-right":"1px solid #eee!important"},attrs:{"type":"default","action-type":"submit"},nativeOn:{"click":function($event){return _vm.dialog_confirm.apply(null, arguments)}}},[_vm._v("确认")])],1),_vm._v(" "),_c('flexbox-item',[_c('x-button',{staticClass:"b_btn_style",staticStyle:{"color":"#999"},attrs:{"type":"default"},nativeOn:{"click":function($event){return _vm.dialog_exit.apply(null, arguments)}}},[_vm._v("取消")])],1)],1)],1)],1)],1)],1)}
var baby_sign_list_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"thead"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v("序号")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v("体温值(℃)")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v("体重值(KG)")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v("黄疸值(mg)")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"12%"}},[_vm._v("出生天数")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"17%"}},[_vm._v("操作人")]),_vm._v(" "),_c('li',{staticStyle:{"width":"28%"}},[_vm._v("记录时间")])])}]
var baby_sign_list_esExports = { render: baby_sign_list_render, staticRenderFns: baby_sign_list_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_baby_sign_list = (baby_sign_list_esExports);
// CONCATENATED MODULE: ./src/components/baby_sign_list.vue
function baby_sign_list_injectStyle (ssrContext) {
  __webpack_require__("Hngr")
}
var baby_sign_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var baby_sign_list___vue_template_functional__ = false
/* styles */
var baby_sign_list___vue_styles__ = baby_sign_list_injectStyle
/* scopeId */
var baby_sign_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var baby_sign_list___vue_module_identifier__ = null
var baby_sign_list_Component = baby_sign_list_normalizeComponent(
  components_baby_sign_list,
  selectortype_template_index_0_src_components_baby_sign_list,
  baby_sign_list___vue_template_functional__,
  baby_sign_list___vue_styles__,
  baby_sign_list___vue_scopeId__,
  baby_sign_list___vue_module_identifier__
)

/* harmony default export */ var src_components_baby_sign_list = (baby_sign_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/baby_breast_milk_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var baby_breast_milk_list_pulldownDefaultConfig = {
    content: '下拉刷新',
    height: 40,
    autoRefresh: false,
    downContent: '下拉刷新',
    upContent: '释放后刷新',
    loadingContent: '正在刷新...',
    clsPrefix: 'xs-plugin-pulldown-'
};
var baby_breast_milk_list_pullupDefaultConfig = {
    content: '上拉加载更多',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: '释放后加载',
    upContent: '上拉加载更多',
    loadingContent: '加载中...',
    clsPrefix: 'xs-plugin-pullup-'
};
/* harmony default export */ var baby_breast_milk_list = ({
    name: "baby_medication_list",
    data: function data() {
        return {
            keyword: '',
            page: '1',
            listData: [],
            pullupDefaultConfig: baby_breast_milk_list_pullupDefaultConfig,
            pulldownDefaultConfig: baby_breast_milk_list_pulldownDefaultConfig,
            showDialog: false,
            group: {
                capacity: '',
                storage_type: '冰冻'
            }
        };
    },

    methods: {
        //添加记录打开dialog
        addMilk: function addMilk() {
            this.showDialog = true;
        },

        //添加记录确认
        dialog_confirm: function dialog_confirm() {
            var _this = this;

            if (this.group.capacity == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入母乳量'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                maternal_id: this.$route.query.id,
                capacity: this.group.capacity,
                storage_type: this.group.storage_type
            };
            console.info(params);
            Api.babyLiveApi.addBreastMilk(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.$vux.toast.show({
                        type: 'success',
                        text: res.errinfo
                    });
                    _this.showDialog = false;
                    _this.refresh();
                    _this.group.capacity = '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //dialog隐藏
        dialog_exit: function dialog_exit() {
            this.showDialog = false;
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日' + h + ':' + minute + ':' + second;
        },

        //清楚筛选
        clearSearch: function clearSearch() {
            this.keyword = '';
            this.refresh();
        },

        //筛选
        searchBtn: function searchBtn() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.scrollerBottom.reset({ top: 0 });
                _this2.refresh();
            });
        },

        //请求列表数据
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_id: this.$route.query.id,
                query: this.keyword,
                page: this.page
            };
            console.info(params);
            Api.babyLiveApi.getBreastMilkRecored(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.page++;
                    _this3.$nextTick(function () {
                        _this3.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                var obj = {
                                    user_name: item.user_name,
                                    maternal_id: item.maternal_id,
                                    child_id: item.child_id,
                                    capacity: item.capacity,
                                    use_type: item.use_type,
                                    overplus_capacity: item.overplus_capacity,
                                    change_time: item.change_time,
                                    storage_type: item.storage_type
                                };
                                _this3.listData.push(obj);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this3.$refs.scrollerBottom.donePullup();
                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup();
                            _this3.$refs.scrollerBottom.donePulldown();
                        }
                        if (_this3.page > res.data.page.page_count) {
                            // 禁用上拉加载，在没有更多数据时执行
                            _this3.$refs.scrollerBottom.disablePullup();
                        }
                    }
                } else {
                    _this3.listData = [];
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData.length = 0;
            this.page = '1';
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.$refs.scrollerBottom.reset({ top: 0 });
        });
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/baby_breast_milk_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var components_baby_breast_milk_list_pulldownDefaultConfig = {
    content: '下拉刷新',
    height: 40,
    autoRefresh: false,
    downContent: '下拉刷新',
    upContent: '释放后刷新',
    loadingContent: '正在刷新...',
    clsPrefix: 'xs-plugin-pulldown-'
};
var components_baby_breast_milk_list_pullupDefaultConfig = {
    content: '上拉加载更多',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: '释放后加载',
    upContent: '上拉加载更多',
    loadingContent: '加载中...',
    clsPrefix: 'xs-plugin-pullup-'
};
/* harmony default export */ var components_baby_breast_milk_list = ({
    name: "baby_medication_list",
    data: function data() {
        return {
            keyword: '',
            page: '1',
            listData: [],
            pullupDefaultConfig: components_baby_breast_milk_list_pullupDefaultConfig,
            pulldownDefaultConfig: components_baby_breast_milk_list_pulldownDefaultConfig,
            showDialog: false,
            group: {
                capacity: '',
                storage_type: '冰冻'
            }
        };
    },

    methods: {
        //添加记录打开dialog
        addMilk: function addMilk() {
            this.showDialog = true;
        },

        //添加记录确认
        dialog_confirm: function dialog_confirm() {
            var _this = this;

            if (this.group.capacity == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入母乳量'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                maternal_id: this.$route.query.id,
                capacity: this.group.capacity,
                storage_type: this.group.storage_type
            };
            console.info(params);
            Api.babyLiveApi.addBreastMilk(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.$vux.toast.show({
                        type: 'success',
                        text: res.errinfo
                    });
                    _this.showDialog = false;
                    _this.refresh();
                    _this.group.capacity = '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //dialog隐藏
        dialog_exit: function dialog_exit() {
            this.showDialog = false;
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日' + h + ':' + minute + ':' + second;
        },

        //清楚筛选
        clearSearch: function clearSearch() {
            this.keyword = '';
            this.refresh();
        },

        //筛选
        searchBtn: function searchBtn() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.scrollerBottom.reset({ top: 0 });
                _this2.refresh();
            });
        },

        //请求列表数据
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_id: this.$route.query.id,
                query: this.keyword,
                page: this.page
            };
            console.info(params);
            Api.babyLiveApi.getBreastMilkRecored(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.page++;
                    _this3.$nextTick(function () {
                        _this3.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                var obj = {
                                    user_name: item.user_name,
                                    maternal_id: item.maternal_id,
                                    child_id: item.child_id,
                                    capacity: item.capacity,
                                    use_type: item.use_type,
                                    overplus_capacity: item.overplus_capacity,
                                    change_time: item.change_time,
                                    storage_type: item.storage_type
                                };
                                _this3.listData.push(obj);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this3.$refs.scrollerBottom.donePullup();
                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup();
                            _this3.$refs.scrollerBottom.donePulldown();
                        }
                        if (_this3.page > res.data.page.page_count) {
                            // 禁用上拉加载，在没有更多数据时执行
                            _this3.$refs.scrollerBottom.disablePullup();
                        }
                    }
                } else {
                    _this3.listData = [];
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData.length = 0;
            this.page = '1';
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.$refs.scrollerBottom.reset({ top: 0 });
        });
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59a1ea03","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/baby_breast_milk_list.vue
var baby_breast_milk_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("母乳存放记录表")]),_vm._v(" "),_c('div',{staticClass:"pd-10"},[_c('group',[_c('x-input',{attrs:{"placeholder":"请输入母乳量、操作人"},on:{"on-click-clear-icon":_vm.clearSearch},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}},[_c('x-button',{attrs:{"slot":"right","gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.searchBtn.apply(null, arguments)}},slot:"right"},[_vm._v("搜索")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0px","margin-left":"10px"},attrs:{"slot":"right","gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.addMilk.apply(null, arguments)}},slot:"right"},[_vm._v("存奶")])],1)],1),_vm._v(" "),_c('div',{staticClass:"sheng-table vux-1px"},[_vm._m(0),_vm._v(" "),_c('scroller',{ref:"scrollerBottom",staticClass:"tbody",attrs:{"use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"use-pulldown":"","pulldown-config":_vm.pulldownDefaultConfig,"lock-x":"","height":"-180"},on:{"on-pullup-loading":_vm.loadMore,"on-pulldown-loading":_vm.refresh}},[_c('div',_vm._l((_vm.listData),function(item){return _c('li',{key:item.id,staticClass:"vux-1px-b"},[_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"18%"}},[_vm._v(_vm._s(item.capacity))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"18%"}},[_vm._v(_vm._s(item.overplus_capacity))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"13%"}},[_vm._v(_vm._s(item.storage_type))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"13%"}},[_vm._v(_vm._s(item.use_type == '1' ? '存放' : '取出'))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v(_vm._s(item.user_name))]),_vm._v(" "),_c('div',{staticStyle:{"width":"23%"}},[_vm._v(_vm._s(item.change_time))])])}),0)])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('x-dialog',{attrs:{"dialog-style":{'max-width': '100%', width: '300px', height: 'auto', 'background-color': '#fff'}},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('group',{attrs:{"title":"存奶","label-width":"5em"}},[_c('x-input',{attrs:{"title":"母乳量：","placeholder":"请输入（单位：ml）"},model:{value:(_vm.group.capacity),callback:function ($$v) {_vm.$set(_vm.group, "capacity", $$v)},expression:"group.capacity"}}),_vm._v(" "),_c('div',{staticClass:"vux-1px-t",staticStyle:{"display":"flex","padding":"10px 15px"}},[_c('div',{staticStyle:{"line-height":"36px"}},[_vm._v("存放方式：")]),_vm._v(" "),_c('div',[_c('checker',{attrs:{"type":"radio","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.group.storage_type),callback:function ($$v) {_vm.$set(_vm.group, "storage_type", $$v)},expression:"group.storage_type"}},[_c('checker-item',{attrs:{"value":"冰冻"}},[_vm._v("冰冻")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"保鲜"}},[_vm._v("保鲜")])],1)],1)])],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('x-button',{staticClass:"b_btn_style",staticStyle:{"color":"#19D5FD","border-right":"1px solid #eee!important"},attrs:{"type":"default","action-type":"submit"},nativeOn:{"click":function($event){return _vm.dialog_confirm.apply(null, arguments)}}},[_vm._v("确认")])],1),_vm._v(" "),_c('flexbox-item',[_c('x-button',{staticClass:"b_btn_style",staticStyle:{"color":"#999"},attrs:{"type":"default"},nativeOn:{"click":function($event){return _vm.dialog_exit.apply(null, arguments)}}},[_vm._v("取消")])],1)],1)],1)],1)],1)],1)}
var baby_breast_milk_list_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"thead"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"18%"}},[_vm._v("存入母乳量(ml)")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"18%"}},[_vm._v("母乳剩余量(ml)")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"13%"}},[_vm._v("存放方式")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"13%"}},[_vm._v("使用情况")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v("操作人")]),_vm._v(" "),_c('li',{staticStyle:{"width":"23%"}},[_vm._v("变动时间")])])}]
var baby_breast_milk_list_esExports = { render: baby_breast_milk_list_render, staticRenderFns: baby_breast_milk_list_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_baby_breast_milk_list = (baby_breast_milk_list_esExports);
// CONCATENATED MODULE: ./src/components/baby_breast_milk_list.vue
function baby_breast_milk_list_injectStyle (ssrContext) {
  __webpack_require__("5Kku")
}
var baby_breast_milk_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var baby_breast_milk_list___vue_template_functional__ = false
/* styles */
var baby_breast_milk_list___vue_styles__ = baby_breast_milk_list_injectStyle
/* scopeId */
var baby_breast_milk_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var baby_breast_milk_list___vue_module_identifier__ = null
var baby_breast_milk_list_Component = baby_breast_milk_list_normalizeComponent(
  components_baby_breast_milk_list,
  selectortype_template_index_0_src_components_baby_breast_milk_list,
  baby_breast_milk_list___vue_template_functional__,
  baby_breast_milk_list___vue_styles__,
  baby_breast_milk_list___vue_scopeId__,
  baby_breast_milk_list___vue_module_identifier__
)

/* harmony default export */ var src_components_baby_breast_milk_list = (baby_breast_milk_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/baby_feed_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var baby_feed_list_pulldownDefaultConfig = {
    content: '下拉刷新',
    height: 40,
    autoRefresh: false,
    downContent: '下拉刷新',
    upContent: '释放后刷新',
    loadingContent: '正在刷新...',
    clsPrefix: 'xs-plugin-pulldown-'
};
var baby_feed_list_pullupDefaultConfig = {
    content: '上拉加载更多',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: '释放后加载',
    upContent: '上拉加载更多',
    loadingContent: '加载中...',
    clsPrefix: 'xs-plugin-pullup-'
};
/* harmony default export */ var baby_feed_list = ({
    name: "baby_medication_list",
    data: function data() {
        return {
            keyword: '',
            page: '1',
            listData: [],
            pullupDefaultConfig: baby_feed_list_pullupDefaultConfig,
            pulldownDefaultConfig: baby_feed_list_pulldownDefaultConfig,
            showDialog: false,
            group: {
                feed_capacity: '',
                milk_capacity: '',
                water_capacity: '',
                pee_times: '',
                bowel_times: '',
                bowel_condition: ''
            }
        };
    },

    methods: {
        //添加记录打开dialog
        addRecord: function addRecord() {
            this.showDialog = true;
        },

        //添加记录确认
        dialog_confirm: function dialog_confirm() {
            var _this = this;

            if (this.group.feed_capacity == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入母乳量'
                });
                return;
            }
            if (this.group.milk_capacity == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入牛奶亮量'
                });
                return;
            }
            if (this.group.water_capacity == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入水'
                });
                return;
            }
            if (this.group.pee_times == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入小便次数'
                });
                return;
            }
            if (this.group.bowel_times == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便次数'
                });
                return;
            }
            if (this.group.bowel_condition == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便情况'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                feed_capacity: this.group.feed_capacity,
                milk_capacity: this.group.milk_capacity,
                water_capacity: this.group.water_capacity,
                pee_times: this.group.pee_times,
                bowel_times: this.group.bowel_times,
                bowel_condition: this.group.bowel_condition
            };
            console.info(params);
            Api.babyLiveApi.addBabeFeedRecored(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.$vux.toast.show({
                        type: 'success',
                        text: res.errinfo
                    });
                    _this.showDialog = false;
                    _this.refresh();
                    _this.group.feed_capacity = '';
                    _this.group.milk_capacity = '';
                    _this.group.water_capacity = '';
                    _this.group.pee_times = '';
                    _this.group.bowel_times = '';
                    _this.group.bowel_condition = '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //dialog隐藏
        dialog_exit: function dialog_exit() {
            this.showDialog = false;
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日' + h + ':' + minute + ':' + second;
        },

        //清楚筛选
        clearSearch: function clearSearch() {
            this.keyword = '';
            this.refresh();
        },

        //筛选
        searchBtn: function searchBtn() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.scrollerBottom.reset({ top: 0 });
                _this2.refresh();
            });
        },

        //请求列表数据
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                query: this.keyword,
                page: this.page
            };
            console.info(params);
            Api.babyLiveApi.getBabeFeedRecored(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.page++;
                    _this3.$nextTick(function () {
                        _this3.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                var obj = {
                                    agent_id: item.agent_id,
                                    bowel_condition: item.bowel_condition,
                                    bowel_times: item.bowel_times,
                                    breast_milk_id: item.breast_milk_id,
                                    child_id: item.child_id,
                                    create_time: item.create_time,
                                    feed_capacity: item.feed_capacity,
                                    id: item.id,
                                    milk_capacity: item.milk_capacity,
                                    overplus_milk: item.overplus_milk,
                                    pee_times: item.pee_times,
                                    store_id: item.store_id,
                                    user_name: item.user_name,
                                    water_capacity: item.water_capacity
                                };
                                _this3.listData.push(obj);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this3.$refs.scrollerBottom.donePullup();
                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup();
                            _this3.$refs.scrollerBottom.donePulldown();
                        }
                        if (_this3.page > res.data.page.page_count) {
                            // 禁用上拉加载，在没有更多数据时执行
                            _this3.$refs.scrollerBottom.disablePullup();
                        }
                    }
                } else {
                    _this3.listData = [];
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData.length = 0;
            this.page = '1';
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.$refs.scrollerBottom.reset({ top: 0 });
        });
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/baby_feed_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var components_baby_feed_list_pulldownDefaultConfig = {
    content: '下拉刷新',
    height: 40,
    autoRefresh: false,
    downContent: '下拉刷新',
    upContent: '释放后刷新',
    loadingContent: '正在刷新...',
    clsPrefix: 'xs-plugin-pulldown-'
};
var components_baby_feed_list_pullupDefaultConfig = {
    content: '上拉加载更多',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: '释放后加载',
    upContent: '上拉加载更多',
    loadingContent: '加载中...',
    clsPrefix: 'xs-plugin-pullup-'
};
/* harmony default export */ var components_baby_feed_list = ({
    name: "baby_medication_list",
    data: function data() {
        return {
            keyword: '',
            page: '1',
            listData: [],
            pullupDefaultConfig: components_baby_feed_list_pullupDefaultConfig,
            pulldownDefaultConfig: components_baby_feed_list_pulldownDefaultConfig,
            showDialog: false,
            group: {
                feed_capacity: '',
                milk_capacity: '',
                water_capacity: '',
                pee_times: '',
                bowel_times: '',
                bowel_condition: ''
            }
        };
    },

    methods: {
        //添加记录打开dialog
        addRecord: function addRecord() {
            this.showDialog = true;
        },

        //添加记录确认
        dialog_confirm: function dialog_confirm() {
            var _this = this;

            if (this.group.feed_capacity == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入母乳量'
                });
                return;
            }
            if (this.group.milk_capacity == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入牛奶亮量'
                });
                return;
            }
            if (this.group.water_capacity == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入水'
                });
                return;
            }
            if (this.group.pee_times == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入小便次数'
                });
                return;
            }
            if (this.group.bowel_times == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便次数'
                });
                return;
            }
            if (this.group.bowel_condition == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便情况'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                feed_capacity: this.group.feed_capacity,
                milk_capacity: this.group.milk_capacity,
                water_capacity: this.group.water_capacity,
                pee_times: this.group.pee_times,
                bowel_times: this.group.bowel_times,
                bowel_condition: this.group.bowel_condition
            };
            console.info(params);
            Api.babyLiveApi.addBabeFeedRecored(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.$vux.toast.show({
                        type: 'success',
                        text: res.errinfo
                    });
                    _this.showDialog = false;
                    _this.refresh();
                    _this.group.feed_capacity = '';
                    _this.group.milk_capacity = '';
                    _this.group.water_capacity = '';
                    _this.group.pee_times = '';
                    _this.group.bowel_times = '';
                    _this.group.bowel_condition = '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //dialog隐藏
        dialog_exit: function dialog_exit() {
            this.showDialog = false;
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日' + h + ':' + minute + ':' + second;
        },

        //清楚筛选
        clearSearch: function clearSearch() {
            this.keyword = '';
            this.refresh();
        },

        //筛选
        searchBtn: function searchBtn() {
            var _this2 = this;

            this.$nextTick(function () {
                _this2.$refs.scrollerBottom.reset({ top: 0 });
                _this2.refresh();
            });
        },

        //请求列表数据
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                child_id: this.$route.query.child_id,
                query: this.keyword,
                page: this.page
            };
            console.info(params);
            Api.babyLiveApi.getBabeFeedRecored(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.page++;
                    _this3.$nextTick(function () {
                        _this3.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                var obj = {
                                    agent_id: item.agent_id,
                                    bowel_condition: item.bowel_condition,
                                    bowel_times: item.bowel_times,
                                    breast_milk_id: item.breast_milk_id,
                                    child_id: item.child_id,
                                    create_time: item.create_time,
                                    feed_capacity: item.feed_capacity,
                                    id: item.id,
                                    milk_capacity: item.milk_capacity,
                                    overplus_milk: item.overplus_milk,
                                    pee_times: item.pee_times,
                                    store_id: item.store_id,
                                    user_name: item.user_name,
                                    water_capacity: item.water_capacity
                                };
                                _this3.listData.push(obj);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        _this3.$refs.scrollerBottom.donePullup();
                        if (str == 'refresh') {
                            _this3.$refs.scrollerBottom.enablePullup();
                            _this3.$refs.scrollerBottom.donePulldown();
                        }
                        if (_this3.page > res.data.page.page_count) {
                            // 禁用上拉加载，在没有更多数据时执行
                            _this3.$refs.scrollerBottom.disablePullup();
                        }
                    }
                } else {
                    _this3.listData = [];
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData.length = 0;
            this.page = '1';
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        this.$nextTick(function () {
            _this4.$refs.scrollerBottom.reset({ top: 0 });
        });
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9df3b402","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/baby_feed_list.vue
var baby_feed_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("宝宝喂养记录表")]),_vm._v(" "),_c('div',{staticClass:"pd-10"},[_c('group',[_c('x-input',{attrs:{"placeholder":"请输入母乳量、牛奶、水、大小便次数、操作人"},on:{"on-click-clear-icon":_vm.clearSearch},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}},[_c('x-button',{attrs:{"slot":"right","gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.searchBtn.apply(null, arguments)}},slot:"right"},[_vm._v("搜索")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0px","margin-left":"10px"},attrs:{"slot":"right","gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.addRecord.apply(null, arguments)}},slot:"right"},[_vm._v("添加记录")])],1)],1),_vm._v(" "),_c('div',{staticClass:"sheng-table vux-1px"},[_vm._m(0),_vm._v(" "),_c('scroller',{ref:"scrollerBottom",staticClass:"tbody",attrs:{"use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"use-pulldown":"","pulldown-config":_vm.pulldownDefaultConfig,"lock-x":"","height":"-180"},on:{"on-pullup-loading":_vm.loadMore,"on-pulldown-loading":_vm.refresh}},[_c('div',_vm._l((_vm.listData),function(item){return _c('li',{key:item.id,staticClass:"vux-1px-b"},[_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"12%"}},[_vm._v(_vm._s(item.overplus_milk))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"12%"}},[_vm._v(_vm._s(item.milk_capacity))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"11%"}},[_vm._v(_vm._s(item.water_capacity))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v(_vm._s(item.pee_times))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v(_vm._s(item.bowel_times))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v(_vm._s(item.bowel_condition))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v(_vm._s(item.user_name))]),_vm._v(" "),_c('div',{staticStyle:{"width":"25%"}},[_vm._v(_vm._s(item.create_time))])])}),0)])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('x-dialog',{attrs:{"dialog-style":{'max-width': '100%', width: '400px', height: 'auto', 'background-color': '#fff'}},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('group',{attrs:{"title":"添加宝宝喂养记录","label-width":"5em"}},[_c('x-input',{attrs:{"title":"母乳量：","placeholder":"请输入（单位：ml）"},model:{value:(_vm.group.feed_capacity),callback:function ($$v) {_vm.$set(_vm.group, "feed_capacity", $$v)},expression:"group.feed_capacity"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"牛奶量：","placeholder":"请输入（单位：ml）"},model:{value:(_vm.group.milk_capacity),callback:function ($$v) {_vm.$set(_vm.group, "milk_capacity", $$v)},expression:"group.milk_capacity"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"水：","placeholder":"请输入（单位：ml）"},model:{value:(_vm.group.water_capacity),callback:function ($$v) {_vm.$set(_vm.group, "water_capacity", $$v)},expression:"group.water_capacity"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"小便次数：","placeholder":"请输入"},model:{value:(_vm.group.pee_times),callback:function ($$v) {_vm.$set(_vm.group, "pee_times", $$v)},expression:"group.pee_times"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"大便次数：","placeholder":"请输入"},model:{value:(_vm.group.bowel_times),callback:function ($$v) {_vm.$set(_vm.group, "bowel_times", $$v)},expression:"group.bowel_times"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"大便情况：","placeholder":"请输入"},model:{value:(_vm.group.bowel_condition),callback:function ($$v) {_vm.$set(_vm.group, "bowel_condition", $$v)},expression:"group.bowel_condition"}})],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',[_c('x-button',{staticClass:"b_btn_style",staticStyle:{"color":"#19D5FD","border-right":"1px solid #eee!important"},attrs:{"type":"default","action-type":"submit"},nativeOn:{"click":function($event){return _vm.dialog_confirm.apply(null, arguments)}}},[_vm._v("确认")])],1),_vm._v(" "),_c('flexbox-item',[_c('x-button',{staticClass:"b_btn_style",staticStyle:{"color":"#999"},attrs:{"type":"default"},nativeOn:{"click":function($event){return _vm.dialog_exit.apply(null, arguments)}}},[_vm._v("取消")])],1)],1)],1)],1)],1)],1)}
var baby_feed_list_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"thead"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"12%"}},[_vm._v("母乳量(ml)")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"12%"}},[_vm._v("牛奶量(ml)")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"11%"}},[_vm._v("水(ml)")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v("小便次数")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v("大便次数")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v("大便情况")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v("操作人")]),_vm._v(" "),_c('li',{staticStyle:{"width":"25%"}},[_vm._v("记录时间")])])}]
var baby_feed_list_esExports = { render: baby_feed_list_render, staticRenderFns: baby_feed_list_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_baby_feed_list = (baby_feed_list_esExports);
// CONCATENATED MODULE: ./src/components/baby_feed_list.vue
function baby_feed_list_injectStyle (ssrContext) {
  __webpack_require__("hvNj")
}
var baby_feed_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var baby_feed_list___vue_template_functional__ = false
/* styles */
var baby_feed_list___vue_styles__ = baby_feed_list_injectStyle
/* scopeId */
var baby_feed_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var baby_feed_list___vue_module_identifier__ = null
var baby_feed_list_Component = baby_feed_list_normalizeComponent(
  components_baby_feed_list,
  selectortype_template_index_0_src_components_baby_feed_list,
  baby_feed_list___vue_template_functional__,
  baby_feed_list___vue_styles__,
  baby_feed_list___vue_scopeId__,
  baby_feed_list___vue_module_identifier__
)

/* harmony default export */ var src_components_baby_feed_list = (baby_feed_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/other_form_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var other_form_list = ({
    name: "other_form_list",
    data: function data() {
        return {
            a: 1,
            listData: [],
            isWrite: { //判断是否已经填写表单
                bbFormE: '',
                bbFormD: '',
                maternalFormA: ''
            },
            id: this.$route.query.id,
            tabVal: this.$route.query.tabVal
        };
    },

    methods: {
        //查询固定表单是否填写
        getNewForm: function getNewForm(typeNum) {
            var _this = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id,
                form_type: typeNum
            };
            Api.otherFormApi.getFormStatus(params).then(function (res) {
                _this.$vux.loading.hide();
                console.info("是否填过此表单", res);
                if (typeNum == '10') {
                    if (res.errcode == 200) {
                        _this.isWrite.maternalFormA = res.data.id;
                    } else {
                        _this.isWrite.maternalFormA = '';
                    }
                }
                if (typeNum == '11') {
                    if (res.errcode == 200) {
                        _this.isWrite.bbFormE = res.data.id;
                    } else {
                        _this.isWrite.bbFormE = '';
                    }
                }
                if (typeNum == '12') {
                    if (res.errcode == 200) {
                        _this.isWrite.bbFormD = res.data.id;
                    } else {
                        _this.isWrite.bbFormD = '';
                    }
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        },
        apiOtherFormList: function apiOtherFormList() {
            var _this2 = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            console.info(params);
            Api.monthLiveApi.otherFormList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            var time = '';
                            if (item.create_time != '0') {
                                time = _this2.formatDateTime(item.create_time);
                            }
                            var obj = {
                                create_time: time,
                                id: item.id,
                                name: item.name,
                                user_name: item.user_name
                            };
                            _this2.listData.push(obj);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.$vux.loading.hide();
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //查看表格
        writeForm: function writeForm(form_id) {
            var marternal_id = this.$route.query.id;
            this.$router.push({
                path: './detail_other_form',
                query: {
                    id: marternal_id,
                    form_id: form_id
                }
            });
        },
        toForm: function toForm(form_id) {
            console.info(form_id);
            switch (form_id) {
                case '11':
                    this.$router.push({
                        path: '/bb_form_e',
                        query: {
                            id: this.$route.query.id
                        }
                    });
                    break;
                case '10':
                    this.$router.push({
                        path: '/maternal_form_a',
                        query: {
                            id: this.$route.query.id
                        }
                    });
                    break;
                case '12':
                    this.$router.push({
                        path: '/bb_form_d',
                        query: {
                            id: this.$route.query.id

                        }
                    });
                    break;
            }
        },
        toFormDetail: function toFormDetail(type, formId) {
            switch (type) {
                case '11':
                    this.$router.push({
                        path: '/bb_form_e_detail',
                        query: {
                            id: this.$route.query.id,
                            form_id: formId
                        }
                    });
                    break;
                case '10':
                    this.$router.push({
                        path: '/maternal_form_a_detail',
                        query: {
                            id: this.$route.query.id,
                            form_id: formId
                        }
                    });
                    break;
                case '12':
                    this.$router.push({
                        path: '/bb_form_d_detail',
                        query: {
                            id: this.$route.query.id,
                            form_id: formId
                        }
                    });
                    break;
            }
        }
    },
    created: function created() {
        this.getNewForm('10');
        this.getNewForm('11');
        this.getNewForm('12');
    },
    mounted: function mounted() {
        this.apiOtherFormList();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/other_form_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_other_form_list = ({
    name: "other_form_list",
    data: function data() {
        return {
            a: 1,
            listData: [],
            isWrite: { //判断是否已经填写表单
                bbFormE: '',
                bbFormD: '',
                maternalFormA: ''
            },
            id: this.$route.query.id,
            tabVal: this.$route.query.tabVal
        };
    },

    methods: {
        //查询固定表单是否填写
        getNewForm: function getNewForm(typeNum) {
            var _this = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id,
                form_type: typeNum
            };
            Api.otherFormApi.getFormStatus(params).then(function (res) {
                _this.$vux.loading.hide();
                console.info("是否填过此表单", res);
                if (typeNum == '10') {
                    if (res.errcode == 200) {
                        _this.isWrite.maternalFormA = res.data.id;
                    } else {
                        _this.isWrite.maternalFormA = '';
                    }
                }
                if (typeNum == '11') {
                    if (res.errcode == 200) {
                        _this.isWrite.bbFormE = res.data.id;
                    } else {
                        _this.isWrite.bbFormE = '';
                    }
                }
                if (typeNum == '12') {
                    if (res.errcode == 200) {
                        _this.isWrite.bbFormD = res.data.id;
                    } else {
                        _this.isWrite.bbFormD = '';
                    }
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        },
        apiOtherFormList: function apiOtherFormList() {
            var _this2 = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            console.info(params);
            Api.monthLiveApi.otherFormList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            var time = '';
                            if (item.create_time != '0') {
                                time = _this2.formatDateTime(item.create_time);
                            }
                            var obj = {
                                create_time: time,
                                id: item.id,
                                name: item.name,
                                user_name: item.user_name
                            };
                            _this2.listData.push(obj);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.$vux.loading.hide();
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //查看表格
        writeForm: function writeForm(form_id) {
            var marternal_id = this.$route.query.id;
            this.$router.push({
                path: './detail_other_form',
                query: {
                    id: marternal_id,
                    form_id: form_id
                }
            });
        },
        toForm: function toForm(form_id) {
            console.info(form_id);
            switch (form_id) {
                case '11':
                    this.$router.push({
                        path: '/bb_form_e',
                        query: {
                            id: this.$route.query.id
                        }
                    });
                    break;
                case '10':
                    this.$router.push({
                        path: '/maternal_form_a',
                        query: {
                            id: this.$route.query.id
                        }
                    });
                    break;
                case '12':
                    this.$router.push({
                        path: '/bb_form_d',
                        query: {
                            id: this.$route.query.id

                        }
                    });
                    break;
            }
        },
        toFormDetail: function toFormDetail(type, formId) {
            switch (type) {
                case '11':
                    this.$router.push({
                        path: '/bb_form_e_detail',
                        query: {
                            id: this.$route.query.id,
                            form_id: formId
                        }
                    });
                    break;
                case '10':
                    this.$router.push({
                        path: '/maternal_form_a_detail',
                        query: {
                            id: this.$route.query.id,
                            form_id: formId
                        }
                    });
                    break;
                case '12':
                    this.$router.push({
                        path: '/bb_form_d_detail',
                        query: {
                            id: this.$route.query.id,
                            form_id: formId
                        }
                    });
                    break;
            }
        }
    },
    created: function created() {
        this.getNewForm('10');
        this.getNewForm('11');
        this.getNewForm('12');
    },
    mounted: function mounted() {
        this.apiOtherFormList();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c655be2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/other_form_list.vue
var other_form_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("其他表单")]),_vm._v(" "),_c('div',{staticClass:"other_form_main"},[_c('div',{staticClass:"sheng-table vux-1px"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"tbody"},_vm._l((_vm.listData),function(item,index){return _c('li',{key:item.id,staticClass:"vux-1px-b"},[_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v(_vm._s(item.user_name))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"35%"}},[_vm._v(_vm._s(item.create_time))]),_vm._v(" "),_c('div',{staticStyle:{"width":"15%"}},[_c('router-link',{attrs:{"to":{path: './other_form_detail?id=' + _vm.id +'&form_id=' + item.id +'&tabVal=' + _vm.tabVal}}},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""}},[_vm._v(_vm._s(item.create_time == '' ? '填写表单' : '查看详情'))])],1)],1)])}),0)])])],1)}
var other_form_list_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"thead"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v("序号")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v("表单名称")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v("最后操作人")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"35%"}},[_vm._v("最近一次操作时间")]),_vm._v(" "),_c('li',{staticStyle:{"width":"15%"}},[_vm._v("操作")])])}]
var other_form_list_esExports = { render: other_form_list_render, staticRenderFns: other_form_list_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_other_form_list = (other_form_list_esExports);
// CONCATENATED MODULE: ./src/components/other_form_list.vue
function other_form_list_injectStyle (ssrContext) {
  __webpack_require__("6lz/")
}
var other_form_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var other_form_list___vue_template_functional__ = false
/* styles */
var other_form_list___vue_styles__ = other_form_list_injectStyle
/* scopeId */
var other_form_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var other_form_list___vue_module_identifier__ = null
var other_form_list_Component = other_form_list_normalizeComponent(
  components_other_form_list,
  selectortype_template_index_0_src_components_other_form_list,
  other_form_list___vue_template_functional__,
  other_form_list___vue_styles__,
  other_form_list___vue_scopeId__,
  other_form_list___vue_module_identifier__
)

/* harmony default export */ var src_components_other_form_list = (other_form_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/other_form_detail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var other_form_detail = ({
  name: 'other_form_detail',
  components: {
    baseInfoHeader: src_components_base_info_header
  },
  data: function data() {
    return {
      form_name: '',
      indexList: '',
      showSearch: true,
      has_answer: '', //是否填过答案
      id: this.$route.query.id,
      member_column_list: [], //表单数组
      column_list: [], //表单数组
      is_drapList: false,
      //孕妇列表
      maternal_list: [],
      //签名
      is_edit: true, //是否显示
      tmpImageUpload: {},
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      host: api_const["host"],
      pinyin_array: []
    };
  },

  methods: {
    //替换所有换行符
    replaceAllNewLine: function replaceAllNewLine(content) {
      var string = content;
      try {
        string = string.replace(/\r\n/g, "<br>");
        string = string.replace(/\n/g, "<br>");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },


    //替换br成换行
    replaceAllBr: function replaceAllBr(content) {
      var string = content;
      try {
        string = string.replace("<br>", "\n").replace("<br>", "\n");
        string = string.replace("<br>", "\n");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },
    textareaBlur: function textareaBlur(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.column_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column_list_item = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(column_list_item.row_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var row_list_item = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = get_iterator_default()(row_list_item.content), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var content_item = _step3.value;

                  if (content_item.id == id) {
                    content_item.my_answer = this.replaceAllBr(content_item.my_answer);
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(arr), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    selece_cfr: function selece_cfr(name, id) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.column_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var column_list_item = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(column_list_item.row_list), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var row_list_item = _step6.value;
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = get_iterator_default()(row_list_item.content), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var content_item = _step7.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.indexList = '';
                  }
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    selectPeople: function selectPeople(id) {
      if (this.indexList) {
        this.indexList = '';
        return;
      }
      this.indexList = id;
    },
    arrar_sort: function arrar_sort(newArr, oldArr) {
      var newList = [];
      var pyArrSort = newArr.sort();
      var i = 0;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(pyArrSort), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = get_iterator_default()(oldArr), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var list = _step9.value;

              if (item == list.pinyin) {
                newList[i] = list;
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          i++;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return newList;
    },
    cfr_list: function cfr_list(arr) {
      if (arr.length) {
        var nurser_name_arr = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = get_iterator_default()(arr), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var item = _step10.value;

            var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
            var obj = {
              name: [item.user_name],
              pinyin: _py
            };
            nurser_name_arr.push(obj);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var pyArr = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = get_iterator_default()(nurser_name_arr), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var _item = _step11.value;

            var obj = {
              name: _item.name,
              pinyin: _item.pinyin
            };
            var is_have = this.isInArray(pyArr, _item.pinyin);
            if (!is_have) {
              //不存在
              pyArr.push(_item.pinyin);
              this.pinyin_array.push(_item.pinyin);
              this.pinyin_array.sort();
              this.maternal_list.push(obj);
            } else {
              //存在
              var _index = pyArr.indexOf(_item.pinyin);
              this.maternal_list[_index].name.push(_item.name.join(''));
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
      }
    },

    //请求孕妇表单配置信息
    apiBabyLive: function apiBabyLive() {
      var _this = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id
      };
      Api.checkRoomApi.detailOtherForm(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this.has_answer = res.data.has_answer;
          _this.form_name = res.data.form_data.name;
          _this.member_column_list = res.data.column_list;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = get_iterator_default()(res.data.form_data.column_list), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var column_list_item = _step12.value;
              var _iteratorNormalCompletion13 = true;
              var _didIteratorError13 = false;
              var _iteratorError13 = undefined;

              try {
                for (var _iterator13 = get_iterator_default()(column_list_item.row_list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                  var row_list_item = _step13.value;
                  var _iteratorNormalCompletion14 = true;
                  var _didIteratorError14 = false;
                  var _iteratorError14 = undefined;

                  try {
                    for (var _iterator14 = get_iterator_default()(row_list_item.content), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                      var content_item = _step14.value;
                      var _iteratorNormalCompletion15 = true;
                      var _didIteratorError15 = false;
                      var _iteratorError15 = undefined;

                      try {
                        for (var _iterator15 = get_iterator_default()(_this.member_column_list), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                          var item = _step15.value;

                          if (content_item.column_name == item.name) {
                            content_item.tip = item.value;
                          }
                        }
                      } catch (err) {
                        _didIteratorError15 = true;
                        _iteratorError15 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion15 && _iterator15.return) {
                            _iterator15.return();
                          }
                        } finally {
                          if (_didIteratorError15) {
                            throw _iteratorError15;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                      }
                    } finally {
                      if (_didIteratorError14) {
                        throw _iteratorError14;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion13 && _iterator13.return) {
                    _iterator13.return();
                  }
                } finally {
                  if (_didIteratorError13) {
                    throw _iteratorError13;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          _this.column_list = res.data.form_data.column_list;
          //孕妇列表
          if (res.data.nurser_name) {
            _this.cfr_list(res.data.nurser_name);
          }
          _this.$vux.loading.hide();
        } else {
          _this.$vux.loading.hide();
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //是否提交过答案
    editForm: function editForm() {
      this.has_answer = '2';
    },
    input_focus: function input_focus(id) {
      this.is_drapList = id;
    },
    menuClick: function menuClick(name, id) {
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = get_iterator_default()(this.column_list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var column_list_item = _step16.value;
          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = get_iterator_default()(column_list_item.row_list), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var row_list_item = _step17.value;
              var _iteratorNormalCompletion18 = true;
              var _didIteratorError18 = false;
              var _iteratorError18 = undefined;

              try {
                for (var _iterator18 = get_iterator_default()(row_list_item.content), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                  var content_item = _step18.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.is_drapList = '';
                  }
                }
              } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion18 && _iterator18.return) {
                    _iterator18.return();
                  }
                } finally {
                  if (_didIteratorError18) {
                    throw _iteratorError18;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }
    },

    //保存签名
    save: function save(id) {
      var signature = 'signature' + id;
      var png = this.$refs[signature][0].save();
      var jpeg = this.$refs[signature][0].save('image/jpeg');
      var svg = this.$refs[signature][0].save('image/svg+xml');
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = get_iterator_default()(this.column_list), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var column_list_item = _step19.value;
          var _iteratorNormalCompletion20 = true;
          var _didIteratorError20 = false;
          var _iteratorError20 = undefined;

          try {
            for (var _iterator20 = get_iterator_default()(column_list_item.row_list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
              var row_list_item = _step20.value;
              var _iteratorNormalCompletion21 = true;
              var _didIteratorError21 = false;
              var _iteratorError21 = undefined;

              try {
                for (var _iterator21 = get_iterator_default()(row_list_item.content), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                  var content_item = _step21.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [encodeURI(png)];
                    this.is_edit = '';
                  }
                }
              } catch (err) {
                _didIteratorError21 = true;
                _iteratorError21 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion21 && _iterator21.return) {
                    _iterator21.return();
                  }
                } finally {
                  if (_didIteratorError21) {
                    throw _iteratorError21;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError20 = true;
            _iteratorError20 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion20 && _iterator20.return) {
                _iterator20.return();
              }
            } finally {
              if (_didIteratorError20) {
                throw _iteratorError20;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }
    },

    //清除签名
    clear: function clear(id) {
      var signature = 'signature' + id;
      var refs = this.$refs[signature][0].clear();
    },

    //编辑签名
    edit_signature: function edit_signature(id) {
      this.is_edit = id;
    },

    //图片上传
    fileImage: function fileImage(e) {
      var file = e.target.files[0];
      var item_id = e.target.id;
      var that = this;
      lrz(file).then(function (rst) {
        // 处理成功会执行
        var _iteratorNormalCompletion22 = true;
        var _didIteratorError22 = false;
        var _iteratorError22 = undefined;

        try {
          for (var _iterator22 = get_iterator_default()(that.column_list), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
            var column_list_item = _step22.value;
            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
              for (var _iterator23 = get_iterator_default()(column_list_item.row_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                var row_list_item = _step23.value;
                var _iteratorNormalCompletion24 = true;
                var _didIteratorError24 = false;
                var _iteratorError24 = undefined;

                try {
                  for (var _iterator24 = get_iterator_default()(row_list_item.content), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                    var content_item = _step24.value;

                    if (content_item.id == item_id) {
                      if (content_item.my_answer.length == 10) {
                        that.$vux.toast.show({
                          type: 'cancel',
                          text: '最多上传10张图片'
                        });
                        return;
                      }
                      content_item.my_answer.push(rst.base64);
                    }
                  }
                } catch (err) {
                  _didIteratorError24 = true;
                  _iteratorError24 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion24 && _iterator24.return) {
                      _iterator24.return();
                    }
                  } finally {
                    if (_didIteratorError24) {
                      throw _iteratorError24;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError23 = true;
              _iteratorError23 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion23 && _iterator23.return) {
                  _iterator23.return();
                }
              } finally {
                if (_didIteratorError23) {
                  throw _iteratorError23;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError22 = true;
          _iteratorError22 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion22 && _iterator22.return) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError22) {
              throw _iteratorError22;
            }
          }
        }
      }).catch(function (err) {
        that.$vux.toast.show({
          type: 'cancel',
          text: '网络错误'
        });
        // 处理失败会执行
      });
    },

    //删除图片
    delImg: function delImg(index, id) {
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = get_iterator_default()(this.column_list), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var column_list_item = _step25.value;
          var _iteratorNormalCompletion26 = true;
          var _didIteratorError26 = false;
          var _iteratorError26 = undefined;

          try {
            for (var _iterator26 = get_iterator_default()(column_list_item.row_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
              var row_list_item = _step26.value;
              var _iteratorNormalCompletion27 = true;
              var _didIteratorError27 = false;
              var _iteratorError27 = undefined;

              try {
                for (var _iterator27 = get_iterator_default()(row_list_item.content), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                  var content_item = _step27.value;

                  if (content_item.id == id) {
                    content_item.my_answer.splice(index, 1);
                  }
                }
              } catch (err) {
                _didIteratorError27 = true;
                _iteratorError27 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion27 && _iterator27.return) {
                    _iterator27.return();
                  }
                } finally {
                  if (_didIteratorError27) {
                    throw _iteratorError27;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError26 = true;
            _iteratorError26 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                _iterator26.return();
              }
            } finally {
              if (_didIteratorError26) {
                throw _iteratorError26;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }
    },

    //提交
    submitForm: function submitForm() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      //answer 
      var answer_list_arr = [];
      //图片上传
      var imgs_upload = [];
      // imgs_upload.push(this.tmpImageUpload);
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = get_iterator_default()(this.column_list), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var column_list_item = _step28.value;
          var _iteratorNormalCompletion29 = true;
          var _didIteratorError29 = false;
          var _iteratorError29 = undefined;

          try {
            for (var _iterator29 = get_iterator_default()(column_list_item.row_list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
              var row_list_item = _step29.value;
              var _iteratorNormalCompletion30 = true;
              var _didIteratorError30 = false;
              var _iteratorError30 = undefined;

              try {
                for (var _iterator30 = get_iterator_default()(row_list_item.content), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                  var content_item = _step30.value;


                  var obj = {
                    id: content_item.id,
                    answer: content_item.my_answer
                  };
                  if (content_item.type == "6") {
                    content_item.my_answer = this.replaceAllNewLine(content_item.my_answer);
                  }
                  if (content_item.type == "11" || content_item.type == '10') {
                    var _iteratorNormalCompletion31 = true;
                    var _didIteratorError31 = false;
                    var _iteratorError31 = undefined;

                    try {
                      for (var _iterator31 = get_iterator_default()(obj.answer), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                        var val = _step31.value;

                        var bold = '';
                        if (val.indexOf("http:") != -1 || val.indexOf("https:") != -1 || val.indexOf("Uploads/pad/") != -1) {
                          //  TODO:跨域，无法转dataurl
                          //  let url = Conf.baseUrl + val;
                          //   Util.convertImgToDataURLviaCanvas(url,function(res){
                          //     console.info('res:',res)
                          //   },"image/jpeg");
                          imgs_upload.push({
                            id: obj.id,
                            file: null,
                            url: val
                          });
                        } else {
                          bold = Util.dataURItoBlob(val);
                          console.info(bold);
                          imgs_upload.push({
                            id: obj.id,
                            file: bold
                          });
                        }
                      }
                    } catch (err) {
                      _didIteratorError31 = true;
                      _iteratorError31 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion31 && _iterator31.return) {
                          _iterator31.return();
                        }
                      } finally {
                        if (_didIteratorError31) {
                          throw _iteratorError31;
                        }
                      }
                    }

                    if (content_item.my_answer != '') {
                      answer_list_arr.push({
                        id: obj.id,
                        type: content_item.type
                      });
                    }
                  } else {
                    answer_list_arr.push(obj);
                  }
                }
              } catch (err) {
                _didIteratorError30 = true;
                _iteratorError30 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion30 && _iterator30.return) {
                    _iterator30.return();
                  }
                } finally {
                  if (_didIteratorError30) {
                    throw _iteratorError30;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError29 = true;
            _iteratorError29 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion29 && _iterator29.return) {
                _iterator29.return();
              }
            } finally {
              if (_didIteratorError29) {
                throw _iteratorError29;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id,
        answer_list: answer_list_arr
      };

      Api.checkRoomApi.setOtherForm(params, imgs_upload).then(function (res) {
        if (res.errcode == 1) {
          _this2.$router.replace({
            path: '/success',
            query: {
              id: _this2.$route.query.id,
              form_id: _this2.$route.query.form_id,
              name: 'other_form_detail',
              tabVal: _this2.$route.query.tabVal
            }
          });
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    }
  },
  created: function created() {
    this.apiBabyLive();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/other_form_detail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_other_form_detail = ({
  name: 'other_form_detail',
  components: {
    baseInfoHeader: src_components_base_info_header
  },
  data: function data() {
    return {
      form_name: '',
      indexList: '',
      showSearch: true,
      has_answer: '', //是否填过答案
      id: this.$route.query.id,
      member_column_list: [], //表单数组
      column_list: [], //表单数组
      is_drapList: false,
      //孕妇列表
      maternal_list: [],
      //签名
      is_edit: true, //是否显示
      tmpImageUpload: {},
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      host: api_const["host"],
      pinyin_array: []
    };
  },

  methods: {
    //替换所有换行符
    replaceAllNewLine: function replaceAllNewLine(content) {
      var string = content;
      try {
        string = string.replace(/\r\n/g, "<br>");
        string = string.replace(/\n/g, "<br>");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },


    //替换br成换行
    replaceAllBr: function replaceAllBr(content) {
      var string = content;
      try {
        string = string.replace("<br>", "\n").replace("<br>", "\n");
        string = string.replace("<br>", "\n");
      } catch (e) {
        // alert(e.message);    
      }
      return string;
    },
    textareaBlur: function textareaBlur(id) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(this.column_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var column_list_item = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(column_list_item.row_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var row_list_item = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = get_iterator_default()(row_list_item.content), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var content_item = _step3.value;

                  if (content_item.id == id) {
                    content_item.my_answer = this.replaceAllBr(content_item.my_answer);
                  }
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    isInArray: function isInArray(arr, value) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = get_iterator_default()(arr), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var item = _step4.value;

          if (value === item) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return false;
    },
    selece_cfr: function selece_cfr(name, id) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = get_iterator_default()(this.column_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var column_list_item = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(column_list_item.row_list), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var row_list_item = _step6.value;
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = get_iterator_default()(row_list_item.content), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var content_item = _step7.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.indexList = '';
                  }
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    },
    selectPeople: function selectPeople(id) {
      if (this.indexList) {
        this.indexList = '';
        return;
      }
      this.indexList = id;
    },
    arrar_sort: function arrar_sort(newArr, oldArr) {
      var newList = [];
      var pyArrSort = newArr.sort();
      var i = 0;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(pyArrSort), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var item = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = get_iterator_default()(oldArr), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var list = _step9.value;

              if (item == list.pinyin) {
                newList[i] = list;
              }
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }

          i++;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return newList;
    },
    cfr_list: function cfr_list(arr) {
      if (arr.length) {
        var nurser_name_arr = [];
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = get_iterator_default()(arr), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var item = _step10.value;

            var _py = py.ConvertPinyin(item.user_name).substr(0, 1).toUpperCase();
            var obj = {
              name: [item.user_name],
              pinyin: _py
            };
            nurser_name_arr.push(obj);
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }

        var pyArr = [];
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = get_iterator_default()(nurser_name_arr), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var _item = _step11.value;

            var obj = {
              name: _item.name,
              pinyin: _item.pinyin
            };
            var is_have = this.isInArray(pyArr, _item.pinyin);
            if (!is_have) {
              //不存在
              pyArr.push(_item.pinyin);
              this.pinyin_array.push(_item.pinyin);
              this.pinyin_array.sort();
              this.maternal_list.push(obj);
            } else {
              //存在
              var _index = pyArr.indexOf(_item.pinyin);
              this.maternal_list[_index].name.push(_item.name.join(''));
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        this.maternal_list = this.arrar_sort(pyArr, this.maternal_list);
      }
    },

    //请求孕妇表单配置信息
    apiBabyLive: function apiBabyLive() {
      var _this = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id
      };
      Api.checkRoomApi.detailOtherForm(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this.has_answer = res.data.has_answer;
          _this.form_name = res.data.form_data.name;
          _this.member_column_list = res.data.column_list;
          var _iteratorNormalCompletion12 = true;
          var _didIteratorError12 = false;
          var _iteratorError12 = undefined;

          try {
            for (var _iterator12 = get_iterator_default()(res.data.form_data.column_list), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
              var column_list_item = _step12.value;
              var _iteratorNormalCompletion13 = true;
              var _didIteratorError13 = false;
              var _iteratorError13 = undefined;

              try {
                for (var _iterator13 = get_iterator_default()(column_list_item.row_list), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                  var row_list_item = _step13.value;
                  var _iteratorNormalCompletion14 = true;
                  var _didIteratorError14 = false;
                  var _iteratorError14 = undefined;

                  try {
                    for (var _iterator14 = get_iterator_default()(row_list_item.content), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                      var content_item = _step14.value;
                      var _iteratorNormalCompletion15 = true;
                      var _didIteratorError15 = false;
                      var _iteratorError15 = undefined;

                      try {
                        for (var _iterator15 = get_iterator_default()(_this.member_column_list), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                          var item = _step15.value;

                          if (content_item.column_name == item.name) {
                            content_item.tip = item.value;
                          }
                        }
                      } catch (err) {
                        _didIteratorError15 = true;
                        _iteratorError15 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion15 && _iterator15.return) {
                            _iterator15.return();
                          }
                        } finally {
                          if (_didIteratorError15) {
                            throw _iteratorError15;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError14 = true;
                    _iteratorError14 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                      }
                    } finally {
                      if (_didIteratorError14) {
                        throw _iteratorError14;
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError13 = true;
                _iteratorError13 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion13 && _iterator13.return) {
                    _iterator13.return();
                  }
                } finally {
                  if (_didIteratorError13) {
                    throw _iteratorError13;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion12 && _iterator12.return) {
                _iterator12.return();
              }
            } finally {
              if (_didIteratorError12) {
                throw _iteratorError12;
              }
            }
          }

          _this.column_list = res.data.form_data.column_list;
          //孕妇列表
          if (res.data.nurser_name) {
            _this.cfr_list(res.data.nurser_name);
          }
          _this.$vux.loading.hide();
        } else {
          _this.$vux.loading.hide();
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //是否提交过答案
    editForm: function editForm() {
      this.has_answer = '2';
    },
    input_focus: function input_focus(id) {
      this.is_drapList = id;
    },
    menuClick: function menuClick(name, id) {
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = get_iterator_default()(this.column_list), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var column_list_item = _step16.value;
          var _iteratorNormalCompletion17 = true;
          var _didIteratorError17 = false;
          var _iteratorError17 = undefined;

          try {
            for (var _iterator17 = get_iterator_default()(column_list_item.row_list), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
              var row_list_item = _step17.value;
              var _iteratorNormalCompletion18 = true;
              var _didIteratorError18 = false;
              var _iteratorError18 = undefined;

              try {
                for (var _iterator18 = get_iterator_default()(row_list_item.content), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
                  var content_item = _step18.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [name];
                    this.is_drapList = '';
                  }
                }
              } catch (err) {
                _didIteratorError18 = true;
                _iteratorError18 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion18 && _iterator18.return) {
                    _iterator18.return();
                  }
                } finally {
                  if (_didIteratorError18) {
                    throw _iteratorError18;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError17 = true;
            _iteratorError17 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion17 && _iterator17.return) {
                _iterator17.return();
              }
            } finally {
              if (_didIteratorError17) {
                throw _iteratorError17;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }
    },

    //保存签名
    save: function save(id) {
      var signature = 'signature' + id;
      var png = this.$refs[signature][0].save();
      var jpeg = this.$refs[signature][0].save('image/jpeg');
      var svg = this.$refs[signature][0].save('image/svg+xml');
      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = get_iterator_default()(this.column_list), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var column_list_item = _step19.value;
          var _iteratorNormalCompletion20 = true;
          var _didIteratorError20 = false;
          var _iteratorError20 = undefined;

          try {
            for (var _iterator20 = get_iterator_default()(column_list_item.row_list), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
              var row_list_item = _step20.value;
              var _iteratorNormalCompletion21 = true;
              var _didIteratorError21 = false;
              var _iteratorError21 = undefined;

              try {
                for (var _iterator21 = get_iterator_default()(row_list_item.content), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
                  var content_item = _step21.value;

                  if (content_item.id == id) {
                    content_item.my_answer = [encodeURI(png)];
                    this.is_edit = '';
                  }
                }
              } catch (err) {
                _didIteratorError21 = true;
                _iteratorError21 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion21 && _iterator21.return) {
                    _iterator21.return();
                  }
                } finally {
                  if (_didIteratorError21) {
                    throw _iteratorError21;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError20 = true;
            _iteratorError20 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion20 && _iterator20.return) {
                _iterator20.return();
              }
            } finally {
              if (_didIteratorError20) {
                throw _iteratorError20;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }
    },

    //清除签名
    clear: function clear(id) {
      var signature = 'signature' + id;
      var refs = this.$refs[signature][0].clear();
    },

    //编辑签名
    edit_signature: function edit_signature(id) {
      this.is_edit = id;
    },

    //图片上传
    fileImage: function fileImage(e) {
      var file = e.target.files[0];
      var item_id = e.target.id;
      var that = this;
      lrz(file).then(function (rst) {
        // 处理成功会执行
        var _iteratorNormalCompletion22 = true;
        var _didIteratorError22 = false;
        var _iteratorError22 = undefined;

        try {
          for (var _iterator22 = get_iterator_default()(that.column_list), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
            var column_list_item = _step22.value;
            var _iteratorNormalCompletion23 = true;
            var _didIteratorError23 = false;
            var _iteratorError23 = undefined;

            try {
              for (var _iterator23 = get_iterator_default()(column_list_item.row_list), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
                var row_list_item = _step23.value;
                var _iteratorNormalCompletion24 = true;
                var _didIteratorError24 = false;
                var _iteratorError24 = undefined;

                try {
                  for (var _iterator24 = get_iterator_default()(row_list_item.content), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
                    var content_item = _step24.value;

                    if (content_item.id == item_id) {
                      if (content_item.my_answer.length == 10) {
                        that.$vux.toast.show({
                          type: 'cancel',
                          text: '最多上传10张图片'
                        });
                        return;
                      }
                      content_item.my_answer.push(rst.base64);
                    }
                  }
                } catch (err) {
                  _didIteratorError24 = true;
                  _iteratorError24 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion24 && _iterator24.return) {
                      _iterator24.return();
                    }
                  } finally {
                    if (_didIteratorError24) {
                      throw _iteratorError24;
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError23 = true;
              _iteratorError23 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion23 && _iterator23.return) {
                  _iterator23.return();
                }
              } finally {
                if (_didIteratorError23) {
                  throw _iteratorError23;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError22 = true;
          _iteratorError22 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion22 && _iterator22.return) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError22) {
              throw _iteratorError22;
            }
          }
        }
      }).catch(function (err) {
        that.$vux.toast.show({
          type: 'cancel',
          text: '网络错误'
        });
        // 处理失败会执行
      });
    },

    //删除图片
    delImg: function delImg(index, id) {
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = get_iterator_default()(this.column_list), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var column_list_item = _step25.value;
          var _iteratorNormalCompletion26 = true;
          var _didIteratorError26 = false;
          var _iteratorError26 = undefined;

          try {
            for (var _iterator26 = get_iterator_default()(column_list_item.row_list), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
              var row_list_item = _step26.value;
              var _iteratorNormalCompletion27 = true;
              var _didIteratorError27 = false;
              var _iteratorError27 = undefined;

              try {
                for (var _iterator27 = get_iterator_default()(row_list_item.content), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
                  var content_item = _step27.value;

                  if (content_item.id == id) {
                    content_item.my_answer.splice(index, 1);
                  }
                }
              } catch (err) {
                _didIteratorError27 = true;
                _iteratorError27 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion27 && _iterator27.return) {
                    _iterator27.return();
                  }
                } finally {
                  if (_didIteratorError27) {
                    throw _iteratorError27;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError26 = true;
            _iteratorError26 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion26 && _iterator26.return) {
                _iterator26.return();
              }
            } finally {
              if (_didIteratorError26) {
                throw _iteratorError26;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }
    },

    //提交
    submitForm: function submitForm() {
      var _this2 = this;

      this.$vux.loading.show({
        text: '正在加载'
      });
      //answer 
      var answer_list_arr = [];
      //图片上传
      var imgs_upload = [];
      // imgs_upload.push(this.tmpImageUpload);
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = get_iterator_default()(this.column_list), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var column_list_item = _step28.value;
          var _iteratorNormalCompletion29 = true;
          var _didIteratorError29 = false;
          var _iteratorError29 = undefined;

          try {
            for (var _iterator29 = get_iterator_default()(column_list_item.row_list), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
              var row_list_item = _step29.value;
              var _iteratorNormalCompletion30 = true;
              var _didIteratorError30 = false;
              var _iteratorError30 = undefined;

              try {
                for (var _iterator30 = get_iterator_default()(row_list_item.content), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
                  var content_item = _step30.value;


                  var obj = {
                    id: content_item.id,
                    answer: content_item.my_answer
                  };
                  if (content_item.type == "6") {
                    content_item.my_answer = this.replaceAllNewLine(content_item.my_answer);
                  }
                  if (content_item.type == "11" || content_item.type == '10') {
                    var _iteratorNormalCompletion31 = true;
                    var _didIteratorError31 = false;
                    var _iteratorError31 = undefined;

                    try {
                      for (var _iterator31 = get_iterator_default()(obj.answer), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
                        var val = _step31.value;

                        var bold = '';
                        if (val.indexOf("http:") != -1 || val.indexOf("https:") != -1 || val.indexOf("Uploads/pad/") != -1) {
                          //  TODO:跨域，无法转dataurl
                          //  let url = Conf.baseUrl + val;
                          //   Util.convertImgToDataURLviaCanvas(url,function(res){
                          //     console.info('res:',res)
                          //   },"image/jpeg");
                          imgs_upload.push({
                            id: obj.id,
                            file: null,
                            url: val
                          });
                        } else {
                          bold = Util.dataURItoBlob(val);
                          console.info(bold);
                          imgs_upload.push({
                            id: obj.id,
                            file: bold
                          });
                        }
                      }
                    } catch (err) {
                      _didIteratorError31 = true;
                      _iteratorError31 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion31 && _iterator31.return) {
                          _iterator31.return();
                        }
                      } finally {
                        if (_didIteratorError31) {
                          throw _iteratorError31;
                        }
                      }
                    }

                    if (content_item.my_answer != '') {
                      answer_list_arr.push({
                        id: obj.id,
                        type: content_item.type
                      });
                    }
                  } else {
                    answer_list_arr.push(obj);
                  }
                }
              } catch (err) {
                _didIteratorError30 = true;
                _iteratorError30 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion30 && _iterator30.return) {
                    _iterator30.return();
                  }
                } finally {
                  if (_didIteratorError30) {
                    throw _iteratorError30;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError29 = true;
            _iteratorError29 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion29 && _iterator29.return) {
                _iterator29.return();
              }
            } finally {
              if (_didIteratorError29) {
                throw _iteratorError29;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id,
        form_id: this.$route.query.form_id,
        answer_list: answer_list_arr
      };

      Api.checkRoomApi.setOtherForm(params, imgs_upload).then(function (res) {
        if (res.errcode == 1) {
          _this2.$router.replace({
            path: '/success',
            query: {
              id: _this2.$route.query.id,
              form_id: _this2.$route.query.form_id,
              name: 'other_form_detail',
              tabVal: _this2.$route.query.tabVal
            }
          });
          _this2.$vux.loading.hide();
        } else {
          _this2.$vux.loading.hide();
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    }
  },
  created: function created() {
    this.apiBabyLive();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de582532","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/other_form_detail.vue
var other_form_detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v(_vm._s(_vm.form_name))]),_vm._v(" "),_c('div',{staticClass:"other_form_main"},[_c('base-info-header',{attrs:{"maternalId":_vm.id}}),_vm._v(" "),(_vm.has_answer == '1')?_c('div',[_c('div',{staticClass:"over-height"},_vm._l((_vm.column_list),function(column_list_item,index){return (column_list_item.is_show_column == 1)?_c('group',{key:index,attrs:{"title":column_list_item.column_name,"label-width":"10em"}},_vm._l((column_list_item.row_list),function(row_list_item,index){return _c('div',{key:index},_vm._l((row_list_item.content),function(content_item,index){return _c('div',{key:index,staticClass:"vux-1px-b"},[(content_item.type == '1')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):(content_item.question == '' && row_list_item.title == '')?_c('x-input',{attrs:{"title":content_item.tip+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '2')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 4px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"4px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px"}},[_vm._v("\n                        "+_vm._s(content_item.my_answer[0])+"\n                      ")])])])]):_vm._e(),_vm._v(" "),(content_item.type == '3')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},_vm._l((content_item.my_answer),function(val,index){return _c('div',{key:index,staticStyle:{"display":"inline-block","line-height":"36px"}},[_vm._v(_vm._s(val)+"，")])}),0)])]):_vm._e(),_vm._v(" "),(content_item.type == '4')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '5')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '6')?_c('div',[(content_item.question)?_c('x-textarea',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-textarea',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '7')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"disabled":""},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}}):_c('x-input',{attrs:{"title":content_item.question,"disabled":""},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '8')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title+ '：',"disabled":""},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '9')?_c('div',[_c('x-input',{attrs:{"title":content_item.question,"disabled":""},model:{value:(content_item.detail_tip),callback:function ($$v) {_vm.$set(content_item, "detail_tip", $$v)},expression:"content_item.detail_tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '10')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),(content_item.my_answer[0])?_c('div',{staticStyle:{"line-height":"36px","flex":"1"}},[(content_item.my_answer[0].length>100)?_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}}):_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":_vm.host+content_item.my_answer[0],"alt":""}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(content_item.type == '11')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(content_item.question+ '：'))]):_c('div',{staticStyle:{"line-height":"36px","width":"10em"}},[_vm._v(_vm._s(row_list_item.title+ '：'))]),_vm._v(" "),_c('div',[(content_item.my_answer.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((content_item.my_answer),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}})])}),0):_vm._e()])])]):_vm._e(),_vm._v(" "),(content_item.type == '12')?_c('div',[(content_item.question)?_c('cell',{attrs:{"title":content_item.question+ '：',"value-align":"left"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('cell',{attrs:{"title":row_list_item.title,"value-align":"left"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e()])}),0)}),0):_vm._e()}),1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"15px"},attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.editForm.apply(null, arguments)}}},[_vm._v("修改")])],1):_c('div',[_c('div',{staticClass:"over-height"},_vm._l((_vm.column_list),function(column_list_item,index){return (column_list_item.is_show_column == 1)?_c('group',{key:index,attrs:{"title":column_list_item.column_name,"label-width":"9em"}},_vm._l((column_list_item.row_list),function(row_list_item,index){return _c('div',{key:index},_vm._l((row_list_item.content),function(content_item,index){return _c('div',{key:index,staticClass:"vux-1px-b"},[(content_item.type == '1')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):(content_item.question == '' && row_list_item.title == '')?_c('x-input',{attrs:{"title":content_item.tip+ '：'},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '2')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}},_vm._l((content_item.answer),function(item,index){return _c('checker-item',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '3')?_c('div',[_c('div',{staticStyle:{"padding-left":"15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(content_item.my_answer),callback:function ($$v) {_vm.$set(content_item, "my_answer", $$v)},expression:"content_item.my_answer"}},_vm._l((content_item.answer),function(item,index){return _c('checker-item',{key:index,staticStyle:{"margin-bottom":"9px"},attrs:{"value":item}},[_vm._v(_vm._s(item))])}),1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '4')?_c('div',[(content_item.question)?_c('selector',{attrs:{"title":content_item.question,"options":content_item.answer,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('selector',{attrs:{"title":row_list_item.title,"options":content_item.answer,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '5')?_c('div',[_c('datetime',{attrs:{"start-date":"1900-01-01","title":content_item.question,"placeholder":content_item.tip},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '6')?_c('div',[(content_item.question)?_c('x-textarea',{attrs:{"title":content_item.question,"placeholder":content_item.tip},on:{"on-blur":function($event){return _vm.textareaBlur(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-textarea',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip},on:{"on-blur":function($event){return _vm.textareaBlur(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '7')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"disabled":""},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}}):_c('x-input',{attrs:{"title":content_item.question,"disabled":""},model:{value:(content_item.tip),callback:function ($$v) {_vm.$set(content_item, "tip", $$v)},expression:"content_item.tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '8')?_c('div',[(content_item.question)?_c('x-input',{attrs:{"title":content_item.question,"placeholder":content_item.tip},on:{"on-focus":function($event){return _vm.input_focus(content_item.id)}},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}):_c('x-input',{attrs:{"title":row_list_item.title,"placeholder":content_item.tip,"id":content_item.id},model:{value:(content_item.my_answer[0]),callback:function ($$v) {_vm.$set(content_item.my_answer, 0, $$v)},expression:"content_item.my_answer[0]"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_drapList == content_item.id),expression:"is_drapList == content_item.id"}],staticClass:"drapList vux-1px"},_vm._l((content_item.answer),function(option,index){return _c('cell',{key:index,attrs:{"value":option,"value-align":"left"},nativeOn:{"click":function($event){return _vm.menuClick(option,content_item.id)}}})}),1)],1):_vm._e(),_vm._v(" "),(content_item.type == '9')?_c('div',[_c('x-input',{attrs:{"title":content_item.question,"placeholder":content_item.tip,"disabled":""},model:{value:(content_item.detail_tip),callback:function ($$v) {_vm.$set(content_item, "detail_tip", $$v)},expression:"content_item.detail_tip"}})],1):_vm._e(),_vm._v(" "),(content_item.type == '10')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","flex":"1"}},[(_vm.is_edit != content_item.id)?_c('div',[(content_item.my_answer[0])?_c('div',[(content_item.my_answer[0].length>100)?_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}}):_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":_vm.host+content_item.my_answer[0],"alt":""}})]):_c('div',[_c('img',{staticStyle:{"height":"400px","width":"100%","border":"1px solid #eee"},attrs:{"src":content_item.my_answer[0],"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"t_r pd-10"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit_signature(content_item.id)}}},[_vm._v("编辑签名")])],1)]):_c('div',[_c('vueSignature',{ref:'signature' + content_item.id,refInFor:true,staticClass:"vueSignature",attrs:{"sigOption":_vm.option,"w":'100%',"h":'400px'}}),_vm._v(" "),_c('div',{staticClass:"t_r pd-10"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save(content_item.id)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear(content_item.id)}}},[_vm._v("清除")])],1)],1)])])]):_vm._e(),_vm._v(" "),(content_item.type == '11')?_c('div',[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[(content_item.question)?_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png","id":content_item.id},on:{"change":_vm.fileImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})])]),_vm._v(" "),(content_item.my_answer.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((content_item.my_answer),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[(item.length>100)?_c('img',{staticClass:"img",attrs:{"src":item,"width":"84","height":"84","alt":""}}):_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(index,content_item.id)}}})])}),0):_vm._e()])])]):_vm._e(),_vm._v(" "),(content_item.type == '12')?_c('div',[_c('div',{staticStyle:{"padding":"0 0 9px 15px"}},[_c('div',{staticStyle:{"display":"flex","padding-top":"9px"}},[(content_item.question)?_c('div',{staticStyle:{"width":"9em"}},[_vm._v(_vm._s(content_item.question))]):_c('div',{staticStyle:{"width":"9em"}},[_vm._v(_vm._s(row_list_item.title))]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('div',{staticStyle:{"display":"flex"}},[(content_item.my_answer[0])?_c('div',{staticStyle:{"line-height":"29px","margin-right":"10px"}},[_vm._v(_vm._s(content_item.my_answer[0]))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"flex":"1"}},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople(content_item.id)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"},{name:"show",rawName:"v-show",value:(_vm.indexList == content_item.id),expression:"indexList == content_item.id"}],staticClass:"mtIndexList"},[_c('div',{staticStyle:{"text-align":"right","padding-right":"24px"}},[_c('x-button',{attrs:{"type":"default","mini":""},nativeOn:{"click":function($event){_vm.indexList = ''}}},[_vm._v("关闭")])],1),_vm._v(" "),(_vm.maternal_list.length)?_c('div',[_c('ul',{staticClass:"mtIndexListBox"},[_vm._l((_vm.maternal_list),function(item){return _c('li',{key:item.pinyin,attrs:{"id":item.pinyin}},[_c('p',{staticClass:"index_title"},[_vm._v(_vm._s(item.pinyin))]),_vm._v(" "),_c('dl',{staticStyle:{"padding-right":"30px"}},_vm._l((item.name),function(option,index){return _c('dd',{key:index,staticStyle:{"display":"inline-block"}},[_c('a',{staticStyle:{"display":"inline-block","color":"#333","padding":"10px 20px"},attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.selece_cfr(option,content_item.id)}}},[_vm._v(_vm._s(option))])])}),0)])}),_vm._v(" "),_c('div',{staticClass:"fixed_right_pinyin"},_vm._l((_vm.pinyin_array),function(item,index){return _c('a',{key:index,attrs:{"href":'#'+ item}},[_vm._v(_vm._s(item))])}),0)],2)]):_c('div',[_c('div',{staticClass:"no_check_people vux-1px"},[_vm._v("暂无查房人")])])])])])])]):_vm._e()])}),0)}),0):_vm._e()}),1),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"15px"},attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)],1)}
var other_form_detail_staticRenderFns = []
var other_form_detail_esExports = { render: other_form_detail_render, staticRenderFns: other_form_detail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_other_form_detail = (other_form_detail_esExports);
// CONCATENATED MODULE: ./src/components/other_form_detail.vue
function other_form_detail_injectStyle (ssrContext) {
  __webpack_require__("UGZS")
}
var other_form_detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var other_form_detail___vue_template_functional__ = false
/* styles */
var other_form_detail___vue_styles__ = other_form_detail_injectStyle
/* scopeId */
var other_form_detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var other_form_detail___vue_module_identifier__ = null
var other_form_detail_Component = other_form_detail_normalizeComponent(
  components_other_form_detail,
  selectortype_template_index_0_src_components_other_form_detail,
  other_form_detail___vue_template_functional__,
  other_form_detail___vue_styles__,
  other_form_detail___vue_scopeId__,
  other_form_detail___vue_module_identifier__
)

/* harmony default export */ var src_components_other_form_detail = (other_form_detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/leave_custom_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var leave_custom_list_pulldownDefaultConfig = {
    content: '下拉刷新',
    height: 40,
    autoRefresh: false,
    downContent: '下拉刷新',
    upContent: '释放后刷新',
    loadingContent: '正在刷新...',
    clsPrefix: 'xs-plugin-pulldown-'
};
var leave_custom_list_pullupDefaultConfig = {
    content: '上拉加载更多',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: '释放后加载',
    upContent: '上拉加载更多',
    loadingContent: '加载中...',
    clsPrefix: 'xs-plugin-pullup-'
    // import BScroll from "better-scroll";
};/* harmony default export */ var leave_custom_list = ({
    name: 'leave_custom_list',
    data: function data() {
        return {
            // results: [],
            keyword: '',
            panel_type: '1',
            memberList: [],
            page: '1',
            pullupDefaultConfig: leave_custom_list_pullupDefaultConfig,
            pulldownDefaultConfig: leave_custom_list_pulldownDefaultConfig
        };
    },

    methods: {
        go_live_custom: function go_live_custom() {
            this.$router.push({
                path: './maternal_file'
            });
        },
        panelClick: function panelClick(item) {
            console.info(item);
            this.$router.push({
                path: './maternal_service',
                query: {
                    id: item.id
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },

        //点击搜索
        searchBtn: function searchBtn() {
            this.refresh();
            // this.$nextTick(() => {
            //     that.$refs.scrollerBottom.reset({top: 0})
            //     that.refresh()
            // })
        },

        //清空搜索
        clearSearch: function clearSearch() {
            this.keyword = '';
            this.refresh();
        },

        //请求数据
        apiMemberList: function apiMemberList(str) {
            var _this = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var that = this;
            var params = {
                token: this.$cookie.get('token'),
                keyword: this.keyword,
                page: this.page
            };
            console.info(params);
            Api.memberListApi.leaveCustom(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.page++;
                    _this.$nextTick(function () {
                        that.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                var _desc = '电话：' + item.phone + '&nbsp;&nbsp;&nbsp;&nbsp;房号：' + item.room_name;
                                var options = {
                                    id: item.maternal_info_id,
                                    src: __webpack_require__("ptd0"),
                                    fallbackSrc: __webpack_require__("ptd0"),
                                    title: item.member_name,
                                    desc: _desc,
                                    phone: item.phone
                                };
                                _this.memberList.push(options);
                                _this.$refs.scrollerBottom.donePullup();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        if (str == 'refresh') {
                            _this.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
                            _this.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
                        }
                        if (res.data.page.record_page == res.data.page.page_count) {
                            _this.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
                        } else {
                            _this.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
                        }
                    }
                    _this.$vux.loading.hide();
                } else {
                    _this.$vux.loading.hide();
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // //下拉刷新
        refresh: function refresh() {
            this.memberList = [];
            this.page = '1';
            // this.floor_arr = []
            this.apiMemberList('refresh');
        },

        // //上拉加载
        loadMore: function loadMore() {
            this.apiMemberList();
        }
    },
    created: function created() {
        var that = this;
        this.$nextTick(function () {
            that.$refs.scrollerBottom.reset({ top: 0 });
        });
        this.apiMemberList();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/leave_custom_list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var components_leave_custom_list_pulldownDefaultConfig = {
    content: '下拉刷新',
    height: 40,
    autoRefresh: false,
    downContent: '下拉刷新',
    upContent: '释放后刷新',
    loadingContent: '正在刷新...',
    clsPrefix: 'xs-plugin-pulldown-'
};
var components_leave_custom_list_pullupDefaultConfig = {
    content: '上拉加载更多',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: '释放后加载',
    upContent: '上拉加载更多',
    loadingContent: '加载中...',
    clsPrefix: 'xs-plugin-pullup-'
    // import BScroll from "better-scroll";
};/* harmony default export */ var components_leave_custom_list = ({
    name: 'leave_custom_list',
    data: function data() {
        return {
            // results: [],
            keyword: '',
            panel_type: '1',
            memberList: [],
            page: '1',
            pullupDefaultConfig: components_leave_custom_list_pullupDefaultConfig,
            pulldownDefaultConfig: components_leave_custom_list_pulldownDefaultConfig
        };
    },

    methods: {
        go_live_custom: function go_live_custom() {
            this.$router.push({
                path: './maternal_file'
            });
        },
        panelClick: function panelClick(item) {
            console.info(item);
            this.$router.push({
                path: './maternal_service',
                query: {
                    id: item.id
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },

        //点击搜索
        searchBtn: function searchBtn() {
            this.refresh();
            // this.$nextTick(() => {
            //     that.$refs.scrollerBottom.reset({top: 0})
            //     that.refresh()
            // })
        },

        //清空搜索
        clearSearch: function clearSearch() {
            this.keyword = '';
            this.refresh();
        },

        //请求数据
        apiMemberList: function apiMemberList(str) {
            var _this = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var that = this;
            var params = {
                token: this.$cookie.get('token'),
                keyword: this.keyword,
                page: this.page
            };
            console.info(params);
            Api.memberListApi.leaveCustom(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.page++;
                    _this.$nextTick(function () {
                        that.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data.list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                var _desc = '电话：' + item.phone + '&nbsp;&nbsp;&nbsp;&nbsp;房号：' + item.room_name;
                                var options = {
                                    id: item.maternal_info_id,
                                    src: __webpack_require__("ptd0"),
                                    fallbackSrc: __webpack_require__("ptd0"),
                                    title: item.member_name,
                                    desc: _desc,
                                    phone: item.phone
                                };
                                _this.memberList.push(options);
                                _this.$refs.scrollerBottom.donePullup();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }

                        if (str == 'refresh') {
                            _this.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
                            _this.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
                        }
                        if (res.data.page.record_page == res.data.page.page_count) {
                            _this.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
                        } else {
                            _this.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
                        }
                    }
                    _this.$vux.loading.hide();
                } else {
                    _this.$vux.loading.hide();
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // //下拉刷新
        refresh: function refresh() {
            this.memberList = [];
            this.page = '1';
            // this.floor_arr = []
            this.apiMemberList('refresh');
        },

        // //上拉加载
        loadMore: function loadMore() {
            this.apiMemberList();
        }
    },
    created: function created() {
        var that = this;
        this.$nextTick(function () {
            that.$refs.scrollerBottom.reset({ top: 0 });
        });
        this.apiMemberList();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-184a42c7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leave_custom_list.vue
var leave_custom_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("产妇档案"),_c('a',{attrs:{"slot":"right"},on:{"click":_vm.go_live_custom},slot:"right"},[_vm._v("查看在住客户")])]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"search-content"},[_c('group',[_c('x-input',{attrs:{"placeholder":"请输入姓名、手机号进行搜索"},on:{"on-click-clear-icon":_vm.clearSearch},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}},[_c('x-button',{attrs:{"slot":"right","gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.searchBtn.apply(null, arguments)}},slot:"right"},[_vm._v("搜索")])],1)],1)],1),_vm._v(" "),_c('scroller',{ref:"scrollerBottom",attrs:{"use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"use-pulldown":"","pulldown-config":_vm.pulldownDefaultConfig,"lock-x":"","height":"-135"},on:{"on-pullup-loading":_vm.loadMore,"on-pulldown-loading":_vm.refresh}},[_c('div',[_c('panel',{staticClass:"sheng-panel",attrs:{"list":_vm.memberList,"type":_vm.panel_type},on:{"on-click-item":_vm.panelClick}})],1)])],1)],1)}
var leave_custom_list_staticRenderFns = []
var leave_custom_list_esExports = { render: leave_custom_list_render, staticRenderFns: leave_custom_list_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_leave_custom_list = (leave_custom_list_esExports);
// CONCATENATED MODULE: ./src/components/leave_custom_list.vue
function leave_custom_list_injectStyle (ssrContext) {
  __webpack_require__("kwyy")
}
var leave_custom_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var leave_custom_list___vue_template_functional__ = false
/* styles */
var leave_custom_list___vue_styles__ = leave_custom_list_injectStyle
/* scopeId */
var leave_custom_list___vue_scopeId__ = "data-v-184a42c7"
/* moduleIdentifier (server only) */
var leave_custom_list___vue_module_identifier__ = null
var leave_custom_list_Component = leave_custom_list_normalizeComponent(
  components_leave_custom_list,
  selectortype_template_index_0_src_components_leave_custom_list,
  leave_custom_list___vue_template_functional__,
  leave_custom_list___vue_styles__,
  leave_custom_list___vue_scopeId__,
  leave_custom_list___vue_module_identifier__
)

/* harmony default export */ var src_components_leave_custom_list = (leave_custom_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var maternal_form_list = ({
    name: "maternal_form_list",
    data: function data() {
        return {
            a: 1,
            listData: [{ name: '母亲入住评估单', id: 1 }, { name: '产妇膳食记录表', id: 2 }, { name: '产妇康复护理评估记录单', id: 3 }, { name: '产妇每日生理护理记录表', id: 4 }]
            // id: this.$route.query.id,
            // tabVal: this.$route.query.tabVal
        };
    },

    methods: {
        //填写表单

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        },

        //查看表格
        writeForm: function writeForm(type) {
            console.info(type);
            if (type == 1) {
                this.$router.push({
                    path: '/maternal_form_a',
                    query: {
                        type: this.a
                    }
                });
            }
            if (type == 2) {
                this.$router.push({
                    path: '/maternal_form_b',
                    query: {
                        type: this.a
                    }
                });
            }
            if (type == 3) {
                this.$router.push({
                    path: '/maternal_form_c',
                    query: {
                        type: this.a
                    }
                });
            }
            if (type == 4) {
                this.$router.push({
                    path: '/maternal_form_d',
                    query: {
                        type: this.a
                    }
                });
            }
            // let marternal_id = this.$route.query.id
            // this.$router.push({
            //     path: './detail_other_form',
            //     query: {
            //         id: marternal_id,
            //         form_id: form_id
            //     }
            // })
        }
    },
    created: function created() {
        if (this.$route.query.a) {
            this.a = this.$route.query.a;
        }
    },
    mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_list.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_maternal_form_list = ({
    name: "maternal_form_list",
    data: function data() {
        return {
            a: 1,
            listData: [{ name: '母亲入住评估单', id: 1 }, { name: '产妇膳食记录表', id: 2 }, { name: '产妇康复护理评估记录单', id: 3 }, { name: '产妇每日生理护理记录表', id: 4 }]
            // id: this.$route.query.id,
            // tabVal: this.$route.query.tabVal
        };
    },

    methods: {
        //填写表单

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
        },

        //查看表格
        writeForm: function writeForm(type) {
            console.info(type);
            if (type == 1) {
                this.$router.push({
                    path: '/maternal_form_a',
                    query: {
                        type: this.a
                    }
                });
            }
            if (type == 2) {
                this.$router.push({
                    path: '/maternal_form_b',
                    query: {
                        type: this.a
                    }
                });
            }
            if (type == 3) {
                this.$router.push({
                    path: '/maternal_form_c',
                    query: {
                        type: this.a
                    }
                });
            }
            if (type == 4) {
                this.$router.push({
                    path: '/maternal_form_d',
                    query: {
                        type: this.a
                    }
                });
            }
            // let marternal_id = this.$route.query.id
            // this.$router.push({
            //     path: './detail_other_form',
            //     query: {
            //         id: marternal_id,
            //         form_id: form_id
            //     }
            // })
        }
    },
    created: function created() {
        if (this.$route.query.a) {
            this.a = this.$route.query.a;
        }
    },
    mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3dcabc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_form_list.vue
var maternal_form_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("妈妈固定表单")]),_vm._v(" "),_c('div',{staticClass:"other_form_main"},[_c('div',{staticClass:"tableStyle vux-1px"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"tbody"},_vm._l((_vm.listData),function(item,index){return _c('li',{key:item.id,staticClass:"vux-1px-b"},[_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"60%"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticStyle:{"width":"20%"}},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.writeForm(item.id)}}},[_vm._v("填写表单")])],1)])}),0)])])],1)}
var maternal_form_list_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"thead"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v("序号")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"60%"}},[_vm._v("表单名称")]),_vm._v(" "),_c('li',{staticStyle:{"width":"20%"}},[_vm._v("操作")])])}]
var maternal_form_list_esExports = { render: maternal_form_list_render, staticRenderFns: maternal_form_list_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_form_list = (maternal_form_list_esExports);
// CONCATENATED MODULE: ./src/components/maternal_form_list.vue
function maternal_form_list_injectStyle (ssrContext) {
  __webpack_require__("g016")
}
var maternal_form_list_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_form_list___vue_template_functional__ = false
/* styles */
var maternal_form_list___vue_styles__ = maternal_form_list_injectStyle
/* scopeId */
var maternal_form_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_form_list___vue_module_identifier__ = null
var maternal_form_list_Component = maternal_form_list_normalizeComponent(
  components_maternal_form_list,
  selectortype_template_index_0_src_components_maternal_form_list,
  maternal_form_list___vue_template_functional__,
  maternal_form_list___vue_styles__,
  maternal_form_list___vue_scopeId__,
  maternal_form_list___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_form_list = (maternal_form_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker_checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5beda2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker.vue
var checker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-box"},[_vm._t("default")],2)}
var checker_staticRenderFns = []
var checker_esExports = { render: checker_render, staticRenderFns: checker_staticRenderFns }
/* harmony default export */ var components_checker_checker = (checker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker.vue
function checker_injectStyle (ssrContext) {
  __webpack_require__("9mUp")
}
var checker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker___vue_template_functional__ = false
/* styles */
var checker___vue_styles__ = checker_injectStyle
/* scopeId */
var checker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker___vue_module_identifier__ = null
var checker_Component = checker_normalizeComponent(
  checker_checker,
  components_checker_checker,
  checker___vue_template_functional__,
  checker___vue_styles__,
  checker___vue_scopeId__,
  checker___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker = (checker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && checker_item_isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return checker_item_isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function checker_item_isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1942c497","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker-item.vue
var checker_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-item",class:_vm.classNames,on:{"click":_vm.select}},[_vm._t("default")],2)}
var checker_item_staticRenderFns = []
var checker_item_esExports = { render: checker_item_render, staticRenderFns: checker_item_staticRenderFns }
/* harmony default export */ var components_checker_checker_item = (checker_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker-item.vue
function checker_item_injectStyle (ssrContext) {
  __webpack_require__("Bdcp")
}
var checker_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker_item___vue_template_functional__ = false
/* styles */
var checker_item___vue_styles__ = checker_item_injectStyle
/* scopeId */
var checker_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker_item___vue_module_identifier__ = null
var checker_item_Component = checker_item_normalizeComponent(
  checker_checker_item,
  components_checker_checker_item,
  checker_item___vue_template_functional__,
  checker_item___vue_styles__,
  checker_item___vue_scopeId__,
  checker_item___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker_item = (checker_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_a.vue




/* harmony default export */ var maternal_form_a = ({
  components: {
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item
  },
  name: 'maternal_form_a',
  data: function data() {
    return {
      type: '',
      showSignature: false,
      showUserSignature: false,
      form: {
        room_number: '',
        entry_time: '',
        name: '',
        age: '',
        blood_type: '',
        national: '',
        native_place: '',
        maternity_hospital: '',
        maternity_date: '',
        maternity_type: '',
        leave_hos_smary: '',
        medication_history: '',
        allergy_history: '',
        leave_hos_diagnosis: '',
        pregnancy_illness: '',
        maternity_special_case: '',
        acute_disease_treat: '',
        contagion_stage: '',
        spirit_history: '',
        heart_assess: '',
        have_heart_case: '',
        have_heart_desc: '',
        character_type: '',
        emotion: '',
        appetite: '',
        diet_require: '',
        diet_require_other: '',
        diet_hobby_status: '',
        has_diet_hobby_desc: '',
        allergy_food: '',
        micturition_case: '',
        micturition_num: '',
        urination_pain: '',
        defecation_case: '',
        defecation_num: '',
        do_recovery_know: '',
        attend_pregnancy_edu: '',
        family_do_maternal_att: '',
        family_other_desc: '',
        temperature: '',
        blood_pressure: '',
        pulse_num: '',
        breathing_num: '',
        weight: '',
        complexion: '',
        mouth_mucosa: '',
        activity: '',
        lochia_colour: '',
        lochia_amount: '',
        lochia_sniff: '',
        lochia_gdg: '',
        incision_case: '',
        incision_case_desc: '',
        breast_case: '',
        papilla_case: '',
        milk_case: '',
        milk_other_case: '',
        special_find: '',
        maternal_nursing_check: [],
        maternal_nursing_want: '',
        autograph: '',
        customer_sign: '',
        assess_time: ''
      },
      option: {
        penColor: "rgb(0, 0, 0)"
      }
    };
  },

  methods: {
    save: function save() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      if (!comp || !comp.save) return;
      var png = comp.save();
      this.form.autograph = encodeURI(png);
      this.showSignature = true;
    },
    edit: function edit() {
      this.showSignature = false;
      this.form.autograph = '';
    },
    clear: function clear() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.autograph = '';
    },
    saveUserName: function saveUserName() {
      var signature = 'signature2';
      var sigRef = this.$refs[signature];
      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      if (!comp || !comp.save) return;
      var png = comp.save();
      this.form.customer_sign = encodeURI(png);
      this.showUserSignature = true;
    },
    editUserName: function editUserName() {
      this.showUserSignature = false;
      this.form.customer_sign = '';
    },
    clearUserName: function clearUserName() {
      var signature = 'signature2';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.customer_sign = '';
    },
    submitForm: function submitForm() {
      var _this = this;

      var that = this;
      this.form.token = this.$cookie.get('token');
      this.form.number_id = this.$cookie.get('id');
      this.form.maternal_info_id = this.$route.query.id;
      this.form.store_id = this.$cookie.get('store_id');
      var params = this.form;

      if (params.room_number == '' || params.entry_time == '' || params.name == '' || params.age == '' || params.blood_type == '' || params.national == '' || params.native_place == '' || params.maternity_hospital == '' || params.maternity_date == '' || params.maternity_type == '' || params.leave_hos_smary == '' || params.medication_history == '' || params.allergy_history == '' || params.leave_hos_diagnosis == '' || params.pregnancy_illness == '' || params.maternity_special_case == '' || params.acute_disease_treat == '' || params.contagion_stage == '' || params.spirit_history == '' || params.heart_assess == '' || params.character_type == '' || params.emotion == '' || params.appetite == '' || params.diet_require == '' || params.diet_hobby_status == '' || params.allergy_food == '' || params.micturition_case == '' || params.micturition_num == '' || params.urination_pain == '' || params.defecation_case == '' || params.do_recovery_know == '' || params.attend_pregnancy_edu == '' || params.family_do_maternal_att == '' || params.temperature == '' || params.blood_pressure == '' || params.pulse_num == '' || params.breathing_num == '' || params.weight == '' || params.complexion == '' || params.mouth_mucosa == '' || params.activity == '' || params.lochia_colour == '' || params.lochia_amount == '' || params.lochia_sniff == '' || params.lochia_gdg == '' || params.incision_case == '' || params.incision_case_desc == '' || params.breast_case == '' || params.papilla_case == '' || params.milk_case == '' || params.milk_other_case == '' || params.special_find == '' || params.maternal_nursing_check.length == 0 || params.autograph == '' || params.customer_sign == '' || params.assess_time == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请完善表单'
        });
        return;
      }
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.otherFormApi.addMaterCheckAssessData(params).then(function (res) {
        _this.$vux.loading.hide();
        console.info(res);
        if (res.errcode == 200) {
          _this.$router.replace({
            path: '/success',
            query: {
              id: _this.$route.query.id,
              form_id: res.data.id,
              tabVal: _this.$route.query.tabVal,
              name: 'maternal_form_a'
            }
          });
        }
      });
    },
    apiMemberInfo: function apiMemberInfo() {
      var _this2 = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.memberInfo(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this2.form.name = res.data.name;
          _this2.form.room_number = res.data.room_name;
          _this2.form.maternity_type = res.data.birth_type;
        } else {
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    this.apiMemberInfo();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_a.vue




/* harmony default export */ var components_maternal_form_a = ({
  components: {
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item
  },
  name: 'maternal_form_a',
  data: function data() {
    return {
      type: '',
      showSignature: false,
      showUserSignature: false,
      form: {
        room_number: '',
        entry_time: '',
        name: '',
        age: '',
        blood_type: '',
        national: '',
        native_place: '',
        maternity_hospital: '',
        maternity_date: '',
        maternity_type: '',
        leave_hos_smary: '',
        medication_history: '',
        allergy_history: '',
        leave_hos_diagnosis: '',
        pregnancy_illness: '',
        maternity_special_case: '',
        acute_disease_treat: '',
        contagion_stage: '',
        spirit_history: '',
        heart_assess: '',
        have_heart_case: '',
        have_heart_desc: '',
        character_type: '',
        emotion: '',
        appetite: '',
        diet_require: '',
        diet_require_other: '',
        diet_hobby_status: '',
        has_diet_hobby_desc: '',
        allergy_food: '',
        micturition_case: '',
        micturition_num: '',
        urination_pain: '',
        defecation_case: '',
        defecation_num: '',
        do_recovery_know: '',
        attend_pregnancy_edu: '',
        family_do_maternal_att: '',
        family_other_desc: '',
        temperature: '',
        blood_pressure: '',
        pulse_num: '',
        breathing_num: '',
        weight: '',
        complexion: '',
        mouth_mucosa: '',
        activity: '',
        lochia_colour: '',
        lochia_amount: '',
        lochia_sniff: '',
        lochia_gdg: '',
        incision_case: '',
        incision_case_desc: '',
        breast_case: '',
        papilla_case: '',
        milk_case: '',
        milk_other_case: '',
        special_find: '',
        maternal_nursing_check: [],
        maternal_nursing_want: '',
        autograph: '',
        customer_sign: '',
        assess_time: ''
      },
      option: {
        penColor: "rgb(0, 0, 0)"
      }
    };
  },

  methods: {
    save: function save() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      if (!comp || !comp.save) return;
      var png = comp.save();
      this.form.autograph = encodeURI(png);
      this.showSignature = true;
    },
    edit: function edit() {
      this.showSignature = false;
      this.form.autograph = '';
    },
    clear: function clear() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.autograph = '';
    },
    saveUserName: function saveUserName() {
      var signature = 'signature2';
      var sigRef = this.$refs[signature];
      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      if (!comp || !comp.save) return;
      var png = comp.save();
      this.form.customer_sign = encodeURI(png);
      this.showUserSignature = true;
    },
    editUserName: function editUserName() {
      this.showUserSignature = false;
      this.form.customer_sign = '';
    },
    clearUserName: function clearUserName() {
      var signature = 'signature2';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.customer_sign = '';
    },
    submitForm: function submitForm() {
      var _this = this;

      var that = this;
      this.form.token = this.$cookie.get('token');
      this.form.number_id = this.$cookie.get('id');
      this.form.maternal_info_id = this.$route.query.id;
      this.form.store_id = this.$cookie.get('store_id');
      var params = this.form;

      if (params.room_number == '' || params.entry_time == '' || params.name == '' || params.age == '' || params.blood_type == '' || params.national == '' || params.native_place == '' || params.maternity_hospital == '' || params.maternity_date == '' || params.maternity_type == '' || params.leave_hos_smary == '' || params.medication_history == '' || params.allergy_history == '' || params.leave_hos_diagnosis == '' || params.pregnancy_illness == '' || params.maternity_special_case == '' || params.acute_disease_treat == '' || params.contagion_stage == '' || params.spirit_history == '' || params.heart_assess == '' || params.character_type == '' || params.emotion == '' || params.appetite == '' || params.diet_require == '' || params.diet_hobby_status == '' || params.allergy_food == '' || params.micturition_case == '' || params.micturition_num == '' || params.urination_pain == '' || params.defecation_case == '' || params.do_recovery_know == '' || params.attend_pregnancy_edu == '' || params.family_do_maternal_att == '' || params.temperature == '' || params.blood_pressure == '' || params.pulse_num == '' || params.breathing_num == '' || params.weight == '' || params.complexion == '' || params.mouth_mucosa == '' || params.activity == '' || params.lochia_colour == '' || params.lochia_amount == '' || params.lochia_sniff == '' || params.lochia_gdg == '' || params.incision_case == '' || params.incision_case_desc == '' || params.breast_case == '' || params.papilla_case == '' || params.milk_case == '' || params.milk_other_case == '' || params.special_find == '' || params.maternal_nursing_check.length == 0 || params.autograph == '' || params.customer_sign == '' || params.assess_time == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请完善表单'
        });
        return;
      }
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.otherFormApi.addMaterCheckAssessData(params).then(function (res) {
        _this.$vux.loading.hide();
        console.info(res);
        if (res.errcode == 200) {
          _this.$router.replace({
            path: '/success',
            query: {
              id: _this.$route.query.id,
              form_id: res.data.id,
              tabVal: _this.$route.query.tabVal,
              name: 'maternal_form_a'
            }
          });
        }
      });
    },
    apiMemberInfo: function apiMemberInfo() {
      var _this2 = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.memberInfo(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this2.form.name = res.data.name;
          _this2.form.room_number = res.data.room_name;
          _this2.form.maternity_type = res.data.birth_type;
        } else {
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    this.apiMemberInfo();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78f225d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_form_a.vue
var maternal_form_a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maternalFormA"},[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("母亲入住评估单")]),_vm._v(" "),_c('div',[_c('group',{staticClass:"maternaleditContent listCom shengStyleForm"},[_c('x-input',{attrs:{"title":"房号：","placeholder":"请输入房号","readonly":""},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"label"},[_vm._v("入所时间：")]),_vm._v(" "),_c('div',{staticClass:"label",staticStyle:{"margin-top":"0px"}},[_c('datetime',{attrs:{"title":"","placeholder":"请选择入所时间"},model:{value:(_vm.form.entry_time),callback:function ($$v) {_vm.$set(_vm.form, "entry_time", $$v)},expression:"form.entry_time"}})],1)]),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","placeholder":"请输入姓名","readonly":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"年龄：","placeholder":"请输入年龄"},model:{value:(_vm.form.age),callback:function ($$v) {_vm.$set(_vm.form, "age", $$v)},expression:"form.age"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"血型：","placeholder":"请输入血型"},model:{value:(_vm.form.blood_type),callback:function ($$v) {_vm.$set(_vm.form, "blood_type", $$v)},expression:"form.blood_type"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"民族：","placeholder":"请输入民族"},model:{value:(_vm.form.national),callback:function ($$v) {_vm.$set(_vm.form, "national", $$v)},expression:"form.national"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"籍贯：","placeholder":"请输入籍贯"},model:{value:(_vm.form.native_place),callback:function ($$v) {_vm.$set(_vm.form, "native_place", $$v)},expression:"form.native_place"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩医院：","placeholder":"请输入"},model:{value:(_vm.form.maternity_hospital),callback:function ($$v) {_vm.$set(_vm.form, "maternity_hospital", $$v)},expression:"form.maternity_hospital"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"label"},[_vm._v("分娩日期：")]),_vm._v(" "),_c('div',{staticClass:"label",staticStyle:{"margin-top":"0px"}},[_c('datetime',{attrs:{"title":"","placeholder":"请选择分娩日期："},model:{value:(_vm.form.maternity_date),callback:function ($$v) {_vm.$set(_vm.form, "maternity_date", $$v)},expression:"form.maternity_date"}})],1)]),_vm._v(" "),(_vm.form.maternity_type == 1)?_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","value":"经阴道"}}):_vm._e(),_vm._v(" "),(_vm.form.maternity_type == 2)?_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","value":"剖宫产"}}):_vm._e(),_vm._v(" "),(_vm.form.maternity_type == 3)?_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","value":"小产"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("出院小结：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.leave_hos_smary),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_smary", $$v)},expression:"form.leave_hos_smary"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('x-input',{attrs:{"title":"用药史：","placeholder":"请输入"},model:{value:(_vm.form.medication_history),callback:function ($$v) {_vm.$set(_vm.form, "medication_history", $$v)},expression:"form.medication_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"过敏史：","placeholder":"请输入"},model:{value:(_vm.form.allergy_history),callback:function ($$v) {_vm.$set(_vm.form, "allergy_history", $$v)},expression:"form.allergy_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出院诊断：","placeholder":"请输入"},model:{value:(_vm.form.leave_hos_diagnosis),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_diagnosis", $$v)},expression:"form.leave_hos_diagnosis"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"孕期并发症，合并症：","placeholder":"请输入"},model:{value:(_vm.form.pregnancy_illness),callback:function ($$v) {_vm.$set(_vm.form, "pregnancy_illness", $$v)},expression:"form.pregnancy_illness"}}),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.maternity_special_case),callback:function ($$v) {_vm.$set(_vm.form, "maternity_special_case", $$v)},expression:"form.maternity_special_case"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("分娩特殊情况（产时产后出血，产伤，分娩异常情况及处理）：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("急性疾病治疗期：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.acute_disease_treat),callback:function ($$v) {_vm.$set(_vm.form, "acute_disease_treat", $$v)},expression:"form.acute_disease_treat"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("传染病传染期：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.contagion_stage),callback:function ($$v) {_vm.$set(_vm.form, "contagion_stage", $$v)},expression:"form.contagion_stage"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-left":"14px"}},[_vm._v("精神疾病史：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.spirit_history),callback:function ($$v) {_vm.$set(_vm.form, "spirit_history", $$v)},expression:"form.spirit_history"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("心理评估：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.heart_assess),callback:function ($$v) {_vm.$set(_vm.form, "heart_assess", $$v)},expression:"form.heart_assess"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"14px"}},[_vm._v("如有做心理评估：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.have_heart_case),callback:function ($$v) {_vm.$set(_vm.form, "have_heart_case", $$v)},expression:"form.have_heart_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")])],1)],1),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"margin-top":"6px"}},[_c('x-input',{attrs:{"title":"如有心理疾病请描述","placeholder":"如有心理疾病请描述"},model:{value:(_vm.form.have_heart_desc),callback:function ($$v) {_vm.$set(_vm.form, "have_heart_desc", $$v)},expression:"form.have_heart_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("性格类型：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.character_type),callback:function ($$v) {_vm.$set(_vm.form, "character_type", $$v)},expression:"form.character_type"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("主动外向")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("被动内向")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("情绪：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.emotion),callback:function ($$v) {_vm.$set(_vm.form, "emotion", $$v)},expression:"form.emotion"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("稳定")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("兴奋")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("郁闷")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("焦虑")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("恐惧")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("食欲：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.appetite),callback:function ($$v) {_vm.$set(_vm.form, "appetite", $$v)},expression:"form.appetite"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("不佳")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("厌食")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("饮食要求：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.diet_require),callback:function ($$v) {_vm.$set(_vm.form, "diet_require", $$v)},expression:"form.diet_require"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("普食")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("其他")])],1)],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"","placeholder":"如有其他饮食要求请输入"},model:{value:(_vm.form.diet_require_other),callback:function ($$v) {_vm.$set(_vm.form, "diet_require_other", $$v)},expression:"form.diet_require_other"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("饮食嗜好：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.diet_hobby_status),callback:function ($$v) {_vm.$set(_vm.form, "diet_hobby_status", $$v)},expression:"form.diet_hobby_status"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1)],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"","placeholder":"如有饮食嗜好请输入"},model:{value:(_vm.form.has_diet_hobby_desc),callback:function ($$v) {_vm.$set(_vm.form, "has_diet_hobby_desc", $$v)},expression:"form.has_diet_hobby_desc"}})],1)]),_vm._v(" "),_c('x-input',{attrs:{"title":"过敏食物：","placeholder":"请输入"},model:{value:(_vm.form.allergy_food),callback:function ($$v) {_vm.$set(_vm.form, "allergy_food", $$v)},expression:"form.allergy_food"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px","margin-left":"14px"}},[_vm._v("排尿：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.micturition_case),callback:function ($$v) {_vm.$set(_vm.form, "micturition_case", $$v)},expression:"form.micturition_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("尿频")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px","margin-left":"14px"}},[_vm._v("排尿次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.micturition_num),expression:"form.micturition_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.micturition_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "micturition_num", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("尿痛：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.urination_pain),callback:function ($$v) {_vm.$set(_vm.form, "urination_pain", $$v)},expression:"form.urination_pain"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("排便：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.defecation_case),callback:function ($$v) {_vm.$set(_vm.form, "defecation_case", $$v)},expression:"form.defecation_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("便秘")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("腹泻")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("未排")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px","margin-left":"0px"}},[_vm._v("排便次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.defecation_num),expression:"form.defecation_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.defecation_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "defecation_num", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("对康复知识：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.do_recovery_know),callback:function ($$v) {_vm.$set(_vm.form, "do_recovery_know", $$v)},expression:"form.do_recovery_know"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("熟悉")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("了解")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("不了解")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("参加孕期教育：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.attend_pregnancy_edu),callback:function ($$v) {_vm.$set(_vm.form, "attend_pregnancy_edu", $$v)},expression:"form.attend_pregnancy_edu"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("共同")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("本人")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("家属")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("家属对产妇态度：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.family_do_maternal_att),callback:function ($$v) {_vm.$set(_vm.form, "family_do_maternal_att", $$v)},expression:"form.family_do_maternal_att"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("恰当的关怀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("不关心")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("过于关心")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("其他")])],1)],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"","placeholder":"如有其他请输入"},model:{value:(_vm.form.family_other_desc),callback:function ($$v) {_vm.$set(_vm.form, "family_other_desc", $$v)},expression:"form.family_other_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticStyle:{"margin":"10px auto"}},[_vm._v("入所检查")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：℃)"},model:{value:(_vm.form.temperature),callback:function ($$v) {_vm.$set(_vm.form, "temperature", $$v)},expression:"form.temperature"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("体温(℃)：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：mmHg)"},model:{value:(_vm.form.blood_pressure),callback:function ($$v) {_vm.$set(_vm.form, "blood_pressure", $$v)},expression:"form.blood_pressure"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("血压(mmHg)：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：次/分)"},model:{value:(_vm.form.pulse_num),callback:function ($$v) {_vm.$set(_vm.form, "pulse_num", $$v)},expression:"form.pulse_num"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("脉搏(次/分)：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：次/分)"},model:{value:(_vm.form.breathing_num),callback:function ($$v) {_vm.$set(_vm.form, "breathing_num", $$v)},expression:"form.breathing_num"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("呼吸(次/分)：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：kg)"},model:{value:(_vm.form.weight),callback:function ($$v) {_vm.$set(_vm.form, "weight", $$v)},expression:"form.weight"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("体重(kg)：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("面色：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.complexion),callback:function ($$v) {_vm.$set(_vm.form, "complexion", $$v)},expression:"form.complexion"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红润")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("苍白")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("黄染")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("口腔黏膜：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.mouth_mucosa),callback:function ($$v) {_vm.$set(_vm.form, "mouth_mucosa", $$v)},expression:"form.mouth_mucosa"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("完整")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("溃疡")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("活动：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.activity),callback:function ($$v) {_vm.$set(_vm.form, "activity", $$v)},expression:"form.activity"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("受限")])],1)],1)]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.lochia_colour),callback:function ($$v) {_vm.$set(_vm.form, "lochia_colour", $$v)},expression:"form.lochia_colour"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("恶露（色）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.lochia_amount),callback:function ($$v) {_vm.$set(_vm.form, "lochia_amount", $$v)},expression:"form.lochia_amount"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("恶露（量）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.lochia_sniff),callback:function ($$v) {_vm.$set(_vm.form, "lochia_sniff", $$v)},expression:"form.lochia_sniff"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("恶露（嗅）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.lochia_gdg),callback:function ($$v) {_vm.$set(_vm.form, "lochia_gdg", $$v)},expression:"form.lochia_gdg"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("宫底高度：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("切口情况：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.incision_case),callback:function ($$v) {_vm.$set(_vm.form, "incision_case", $$v)},expression:"form.incision_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("腹壁")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("会阴侧切")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("会阴正中")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("无切口")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("切口情况（描述）：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.incision_case_desc),callback:function ($$v) {_vm.$set(_vm.form, "incision_case_desc", $$v)},expression:"form.incision_case_desc"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("肿")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("痛")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("渗出")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("无异常")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("乳房：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.breast_case),callback:function ($$v) {_vm.$set(_vm.form, "breast_case", $$v)},expression:"form.breast_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("饱胀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("平坦")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("肿胀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("副乳")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("乳头：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.papilla_case),callback:function ($$v) {_vm.$set(_vm.form, "papilla_case", $$v)},expression:"form.papilla_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("内陷")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("皲裂")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("水泡")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("乳汁：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.milk_case),callback:function ($$v) {_vm.$set(_vm.form, "milk_case", $$v)},expression:"form.milk_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("多")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("中")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("少")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.milk_other_case),callback:function ($$v) {_vm.$set(_vm.form, "milk_other_case", $$v)},expression:"form.milk_other_case"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("乳房其他情况：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.special_find),callback:function ($$v) {_vm.$set(_vm.form, "special_find", $$v)},expression:"form.special_find"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("特殊发现：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("产妇护理要点：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.maternal_nursing_check),callback:function ($$v) {_vm.$set(_vm.form, "maternal_nursing_check", $$v)},expression:"form.maternal_nursing_check"}},[_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"1"}},[_vm._v("观察恶露量，颜色和气味")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"2"}},[_vm._v("保证室内有新鲜空气，保持充足的睡眠")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"3"}},[_vm._v("产妇要保持心情愉悦")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"4"}},[_vm._v("剖宫产产妇要检查子宫缝合的伤口愈合情况")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"5"}},[_vm._v("顺产产妇要观察宫缩情况并注意会阴部伤口的清洁")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"6"}},[_vm._v("让婴儿早吸吮，保持乳房清洁")])],1)],1)]),_vm._v(" "),_c('x-textarea',{attrs:{"title":"产妇护理要点描述（不足书写请加附页）：","placeholder":"请输入"},model:{value:(_vm.form.maternal_nursing_want),callback:function ($$v) {_vm.$set(_vm.form, "maternal_nursing_want", $$v)},expression:"form.maternal_nursing_want"}}),_vm._v(" "),_c('div',{staticClass:"listCom"},[_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("护士签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.autograph)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.autograph,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listCom"},[_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("客户签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showUserSignature)?_c('div',[(_vm.form.customer_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.customer_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editUserName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveUserName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearUserName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"label"},[_vm._v("评估时间：")]),_vm._v(" "),_c('div',{staticClass:"label",staticStyle:{"margin-top":"0px"}},[_c('datetime',{attrs:{"title":"","placeholder":"请选择评估时间"},model:{value:(_vm.form.assess_time),callback:function ($$v) {_vm.$set(_vm.form, "assess_time", $$v)},expression:"form.assess_time"}})],1)]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)],1)}
var maternal_form_a_staticRenderFns = []
var maternal_form_a_esExports = { render: maternal_form_a_render, staticRenderFns: maternal_form_a_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_form_a = (maternal_form_a_esExports);
// CONCATENATED MODULE: ./src/components/maternal_form_a.vue
function maternal_form_a_injectStyle (ssrContext) {
  __webpack_require__("zOyP")
}
var maternal_form_a_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_form_a___vue_template_functional__ = false
/* styles */
var maternal_form_a___vue_styles__ = maternal_form_a_injectStyle
/* scopeId */
var maternal_form_a___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_form_a___vue_module_identifier__ = null
var maternal_form_a_Component = maternal_form_a_normalizeComponent(
  components_maternal_form_a,
  selectortype_template_index_0_src_components_maternal_form_a,
  maternal_form_a___vue_template_functional__,
  maternal_form_a___vue_styles__,
  maternal_form_a___vue_scopeId__,
  maternal_form_a___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_form_a = (maternal_form_a_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_a_detail.vue




/* harmony default export */ var maternal_form_a_detail = ({
  components: {
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item
  },
  name: 'maternal_form_a_detail',
  data: function data() {
    return {
      get_host: host.host,
      type: '',
      showSignature: false,
      showUserSignature: false,
      form: {
        room_number: '',
        entry_time: '',
        name: '',
        age: '',
        blood_type: '',
        national: '',
        native_place: '',
        maternity_hospital: '',
        maternity_date: '',
        maternity_type: '',
        leave_hos_smary: '',
        medication_history: '',
        allergy_history: '',
        leave_hos_diagnosis: '',
        pregnancy_illness: '',
        maternity_special_case: '',
        acute_disease_treat: '',
        contagion_stage: '',
        spirit_history: '',
        heart_assess: '',
        have_heart_case: '',
        have_heart_desc: '',
        character_type: '',
        emotion: '',
        appetite: '',
        diet_require: '',
        diet_require_other: '',
        diet_hobby_status: '',
        has_diet_hobby_desc: '',
        allergy_food: '',
        micturition_case: '',
        micturition_num: '',
        urination_pain: '',
        defecation_case: '',
        defecation_num: '',
        do_recovery_know: '',
        attend_pregnancy_edu: '',
        family_do_maternal_att: '',
        family_other_desc: '',
        temperature: '',
        blood_pressure: '',
        pulse_num: '',
        breathing_num: '',
        weight: '',
        complexion: '',
        mouth_mucosa: '',
        activity: '',
        lochia_colour: '',
        lochia_amount: '',
        lochia_sniff: '',
        lochia_gdg: '',
        incision_case: '',
        incision_case_desc: '',
        breast_case: '',
        papilla_case: '',
        milk_case: '',
        milk_other_case: '',
        special_find: '',
        maternal_nursing_check: '',
        maternal_nursing_want: '',
        autograph: '',
        customer_sign: '',
        assess_time: ''
      },
      option: {
        penColor: "rgb(0, 0, 0)"
      }
    };
  },

  methods: {
    save: function save() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      if (!comp || !comp.save) return;
      var png = comp.save();
      this.form.autograph = encodeURI(png);
      this.showSignature = true;
    },
    edit: function edit() {
      this.showSignature = false;
    },
    clear: function clear() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.autograph = '';
    },
    saveUserName: function saveUserName() {
      var signature = 'signature2';
      var sigRef = this.$refs[signature];
      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      if (!comp || !comp.save) return;
      var png = comp.save();
      this.form.customer_sign = encodeURI(png);
      this.showUserSignature = true;
    },
    editUserName: function editUserName() {
      this.showUserSignature = false;
      this.form.customer_sign = '';
    },
    clearUserName: function clearUserName() {
      var signature = 'signature2';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.customer_sign = '';
    },
    submitForm: function submitForm() {
      this.$router.replace({
        path: '/maternal_form_a_edit',
        query: {
          id: this.$route.query.id,
          form_id: this.$route.query.form_id,
          tabVal: this.$route.query.tabVal
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    var _this = this;

    var params = {
      token: this.$cookie.get('token'),
      id: this.$route.query.form_id
    };
    this.$vux.loading.show({
      text: '正在加载'
    });
    console.info(params);
    Api.otherFormApi.getMaterCheckAssessFind(params).then(function (res) {
      _this.$vux.loading.hide();
      console.info("详情", res.data);
      if (res.errcode == 200) {
        var data = res.data;
        _this.form.room_number = data.room_number, _this.form.entry_time = data.entry_time, _this.form.name = data.name, _this.form.age = data.age, _this.form.blood_type = data.blood_type, _this.form.national = data.national, _this.form.native_place = data.native_place, _this.form.maternity_hospital = data.maternity_hospital, _this.form.maternity_date = data.maternity_date, _this.form.maternity_type = data.maternity_type == '1' ? '经阴道' : data.maternity_type == '2' ? '剖宫产' : data.maternity_type == '3' ? '小产' : '', _this.form.leave_hos_smary = data.leave_hos_smary == '1' ? '有' : data.leave_hos_smary == '2' ? '无' : '', _this.form.medication_history = data.medication_history, _this.form.allergy_history = data.allergy_history, _this.form.leave_hos_diagnosis = data.leave_hos_diagnosis, _this.form.pregnancy_illness = data.pregnancy_illness, _this.form.maternity_special_case = data.maternity_special_case, _this.form.acute_disease_treat = data.acute_disease_treat == "2" ? '否' : data.acute_disease_treat == "1" ? '是' : '', _this.form.contagion_stage = data.contagion_stage == "2" ? '否' : data.contagion_stage == "1" ? '是' : '', _this.form.spirit_history = data.spirit_history == "2" ? '无' : data.spirit_history == "1" ? '有' : '', _this.form.heart_assess = data.heart_assess == "2" ? '无' : data.heart_assess == "1" ? '有' : data.heart_assess == "3" ? '正常' : '', _this.form.have_heart_desc = data.have_heart_desc, _this.form.have_heart_case = data.have_heart_case == "1" ? '正常' : '';
        _this.form.character_type = data.character_type == "1" ? '主动外向' : data.character_type == "2" ? '被动内向' : '', _this.form.emotion = data.emotion == "1" ? '稳定' : data.emotion == "2" ? '兴奋' : data.emotion == "3" ? '郁闷' : data.emotion == "4" ? '焦虑' : data.emotion == "5" ? '恐惧' : '', _this.form.appetite = data.appetite == "1" ? '正常' : data.appetite == "2" ? '不佳' : '', _this.form.diet_require = data.diet_require == "1" ? '普食' : data.diet_require == "2" ? '其他' : '', _this.form.diet_require_other = data.diet_require_other, _this.form.diet_hobby_status = data.diet_hobby_status == "1" ? '有' : data.diet_hobby_status == "2" ? '无' : '', _this.form.has_diet_hobby_desc = data.has_diet_hobby_desc, _this.form.allergy_food = data.allergy_food, _this.form.micturition_case = data.micturition_case == "1" ? '正常' : data.micturition_case == "2" ? '尿频' : '', _this.form.micturition_num = data.micturition_num;
        _this.form.urination_pain = data.urination_pain == "1" ? '有' : data.urination_pain == "2" ? '无' : '', _this.form.defecation_case = data.defecation_case == "1" ? '正常' : data.defecation_case == "2" ? '便秘' : data.defecation_case == "3" ? '腹泻' : data.defecation_case == "4" ? '未排' : '', _this.form.defecation_num = data.defecation_num, _this.form.do_recovery_know = data.do_recovery_know == "1" ? '熟悉' : data.do_recovery_know == "2" ? '了解' : data.do_recovery_know == "3" ? '不了解' : '', _this.form.attend_pregnancy_edu = data.attend_pregnancy_edu == "1" ? '共同' : data.attend_pregnancy_edu == "2" ? '本人' : data.attend_pregnancy_edu == "3" ? '家属' : '', _this.form.family_do_maternal_att = data.family_do_maternal_att == "1" ? '恰当的关心' : data.family_do_maternal_att == "2" ? '不关心' : data.family_do_maternal_att == "3" ? '过于关心' : data.family_do_maternal_att == "4" ? '其他' : '', _this.form.family_other_desc = data.family_other_desc, _this.form.temperature = data.temperature, _this.form.blood_pressure = data.blood_pressure, _this.form.pulse_num = data.pulse_num, _this.form.breathing_num = data.breathing_num, _this.form.weight = data.weight, _this.form.complexion = data.complexion == "1" ? '红润' : data.complexion == "2" ? '苍白' : data.complexion == "3" ? '黄染' : '', _this.form.mouth_mucosa = data.mouth_mucosa == "1" ? '完整' : data.mouth_mucosa == "2" ? '溃疡' : '', _this.form.activity = data.activity == "1" ? '良好' : data.activity == "2" ? '受限' : '', _this.form.lochia_colour = data.lochia_colour, _this.form.lochia_amount = data.lochia_amount, _this.form.lochia_sniff = data.lochia_sniff, _this.form.lochia_gdg = data.lochia_gdg, _this.form.incision_case = data.incision_case == "1" ? '腹壁' : data.incision_case == "2" ? '会阴侧切' : data.incision_case == "3" ? '会阴正中' : data.incision_case == "4" ? '无切口' : '', _this.form.incision_case_desc = data.incision_case_desc == "1" ? '红' : data.incision_case_desc == "2" ? '肿' : data.incision_case_desc == "3" ? '痛' : data.incision_case_desc == "4" ? '渗出' : data.incision_case_desc == "5" ? '无异常' : '', _this.form.breast_case = data.breast_case == "1" ? '正常' : data.breast_case == "2" ? '饱胀' : data.breast_case == "3" ? '平坦' : data.breast_case == "4" ? '肿胀' : data.breast_case == "5" ? '副乳' : '', _this.form.papilla_case = data.papilla_case == "1" ? '正常' : data.papilla_case == "2" ? '内陷' : data.papilla_case == "3" ? '皲裂' : data.papilla_case == "4" ? '水泡' : '', _this.form.milk_case = data.milk_case == "1" ? '多' : data.milk_case == "2" ? '中' : data.milk_case == "3" ? '少' : data.milk_case == "4" ? '无' : '', _this.form.milk_other_case = data.milk_other_case, _this.form.special_find = data.special_find, _this.form.maternal_nursing_want = data.maternal_nursing_want, _this.form.autograph = data.autograph.indexOf(_this.get_host) != -1 ? data.autograph : _this.get_host + data.autograph;
        _this.form.customer_sign = data.customer_sign.indexOf(_this.get_host) != -1 ? data.customer_sign : _this.get_host + data.customer_sign;
        _this.form.assess_time = data.assess_time;
        var Arr = res.data.maternal_nursing_check;
        for (var i = 0; i < Arr.length; i++) {
          if (Arr[i] == '1') {
            Arr[i] = '观察恶露量，颜色和气味';
          } else if (Arr[i] == '2') {
            Arr[i] = '保证室内有新鲜空气，保持充足的睡眠';
          } else if (Arr[i] == '3') {
            Arr[i] = '产妇要保持心情愉悦';
          } else if (Arr[i] == '4') {
            Arr[i] = '剖宫产产妇要检查子宫缝合的伤口愈合情况';
          } else if (Arr[i] == '5') {
            Arr[i] = '顺产产妇要观察宫缩情况并注意会阴部伤口的清洁';
          } else if (Arr[i] == '6') {
            Arr[i] = '让婴儿早吸吮，保持乳房清洁';
          }
          _this.form.maternal_nursing_check = Arr.join();
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_a_detail.vue




/* harmony default export */ var components_maternal_form_a_detail = ({
  components: {
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item
  },
  name: 'maternal_form_a_detail',
  data: function data() {
    return {
      get_host: host.host,
      type: '',
      showSignature: false,
      showUserSignature: false,
      form: {
        room_number: '',
        entry_time: '',
        name: '',
        age: '',
        blood_type: '',
        national: '',
        native_place: '',
        maternity_hospital: '',
        maternity_date: '',
        maternity_type: '',
        leave_hos_smary: '',
        medication_history: '',
        allergy_history: '',
        leave_hos_diagnosis: '',
        pregnancy_illness: '',
        maternity_special_case: '',
        acute_disease_treat: '',
        contagion_stage: '',
        spirit_history: '',
        heart_assess: '',
        have_heart_case: '',
        have_heart_desc: '',
        character_type: '',
        emotion: '',
        appetite: '',
        diet_require: '',
        diet_require_other: '',
        diet_hobby_status: '',
        has_diet_hobby_desc: '',
        allergy_food: '',
        micturition_case: '',
        micturition_num: '',
        urination_pain: '',
        defecation_case: '',
        defecation_num: '',
        do_recovery_know: '',
        attend_pregnancy_edu: '',
        family_do_maternal_att: '',
        family_other_desc: '',
        temperature: '',
        blood_pressure: '',
        pulse_num: '',
        breathing_num: '',
        weight: '',
        complexion: '',
        mouth_mucosa: '',
        activity: '',
        lochia_colour: '',
        lochia_amount: '',
        lochia_sniff: '',
        lochia_gdg: '',
        incision_case: '',
        incision_case_desc: '',
        breast_case: '',
        papilla_case: '',
        milk_case: '',
        milk_other_case: '',
        special_find: '',
        maternal_nursing_check: '',
        maternal_nursing_want: '',
        autograph: '',
        customer_sign: '',
        assess_time: ''
      },
      option: {
        penColor: "rgb(0, 0, 0)"
      }
    };
  },

  methods: {
    save: function save() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      if (!comp || !comp.save) return;
      var png = comp.save();
      this.form.autograph = encodeURI(png);
      this.showSignature = true;
    },
    edit: function edit() {
      this.showSignature = false;
    },
    clear: function clear() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.autograph = '';
    },
    saveUserName: function saveUserName() {
      var signature = 'signature2';
      var sigRef = this.$refs[signature];
      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      if (!comp || !comp.save) return;
      var png = comp.save();
      this.form.customer_sign = encodeURI(png);
      this.showUserSignature = true;
    },
    editUserName: function editUserName() {
      this.showUserSignature = false;
      this.form.customer_sign = '';
    },
    clearUserName: function clearUserName() {
      var signature = 'signature2';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.customer_sign = '';
    },
    submitForm: function submitForm() {
      this.$router.replace({
        path: '/maternal_form_a_edit',
        query: {
          id: this.$route.query.id,
          form_id: this.$route.query.form_id,
          tabVal: this.$route.query.tabVal
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    var _this = this;

    var params = {
      token: this.$cookie.get('token'),
      id: this.$route.query.form_id
    };
    this.$vux.loading.show({
      text: '正在加载'
    });
    console.info(params);
    Api.otherFormApi.getMaterCheckAssessFind(params).then(function (res) {
      _this.$vux.loading.hide();
      console.info("详情", res.data);
      if (res.errcode == 200) {
        var data = res.data;
        _this.form.room_number = data.room_number, _this.form.entry_time = data.entry_time, _this.form.name = data.name, _this.form.age = data.age, _this.form.blood_type = data.blood_type, _this.form.national = data.national, _this.form.native_place = data.native_place, _this.form.maternity_hospital = data.maternity_hospital, _this.form.maternity_date = data.maternity_date, _this.form.maternity_type = data.maternity_type == '1' ? '经阴道' : data.maternity_type == '2' ? '剖宫产' : data.maternity_type == '3' ? '小产' : '', _this.form.leave_hos_smary = data.leave_hos_smary == '1' ? '有' : data.leave_hos_smary == '2' ? '无' : '', _this.form.medication_history = data.medication_history, _this.form.allergy_history = data.allergy_history, _this.form.leave_hos_diagnosis = data.leave_hos_diagnosis, _this.form.pregnancy_illness = data.pregnancy_illness, _this.form.maternity_special_case = data.maternity_special_case, _this.form.acute_disease_treat = data.acute_disease_treat == "2" ? '否' : data.acute_disease_treat == "1" ? '是' : '', _this.form.contagion_stage = data.contagion_stage == "2" ? '否' : data.contagion_stage == "1" ? '是' : '', _this.form.spirit_history = data.spirit_history == "2" ? '无' : data.spirit_history == "1" ? '有' : '', _this.form.heart_assess = data.heart_assess == "2" ? '无' : data.heart_assess == "1" ? '有' : data.heart_assess == "3" ? '正常' : '', _this.form.have_heart_desc = data.have_heart_desc, _this.form.have_heart_case = data.have_heart_case == "1" ? '正常' : '';
        _this.form.character_type = data.character_type == "1" ? '主动外向' : data.character_type == "2" ? '被动内向' : '', _this.form.emotion = data.emotion == "1" ? '稳定' : data.emotion == "2" ? '兴奋' : data.emotion == "3" ? '郁闷' : data.emotion == "4" ? '焦虑' : data.emotion == "5" ? '恐惧' : '', _this.form.appetite = data.appetite == "1" ? '正常' : data.appetite == "2" ? '不佳' : '', _this.form.diet_require = data.diet_require == "1" ? '普食' : data.diet_require == "2" ? '其他' : '', _this.form.diet_require_other = data.diet_require_other, _this.form.diet_hobby_status = data.diet_hobby_status == "1" ? '有' : data.diet_hobby_status == "2" ? '无' : '', _this.form.has_diet_hobby_desc = data.has_diet_hobby_desc, _this.form.allergy_food = data.allergy_food, _this.form.micturition_case = data.micturition_case == "1" ? '正常' : data.micturition_case == "2" ? '尿频' : '', _this.form.micturition_num = data.micturition_num;
        _this.form.urination_pain = data.urination_pain == "1" ? '有' : data.urination_pain == "2" ? '无' : '', _this.form.defecation_case = data.defecation_case == "1" ? '正常' : data.defecation_case == "2" ? '便秘' : data.defecation_case == "3" ? '腹泻' : data.defecation_case == "4" ? '未排' : '', _this.form.defecation_num = data.defecation_num, _this.form.do_recovery_know = data.do_recovery_know == "1" ? '熟悉' : data.do_recovery_know == "2" ? '了解' : data.do_recovery_know == "3" ? '不了解' : '', _this.form.attend_pregnancy_edu = data.attend_pregnancy_edu == "1" ? '共同' : data.attend_pregnancy_edu == "2" ? '本人' : data.attend_pregnancy_edu == "3" ? '家属' : '', _this.form.family_do_maternal_att = data.family_do_maternal_att == "1" ? '恰当的关心' : data.family_do_maternal_att == "2" ? '不关心' : data.family_do_maternal_att == "3" ? '过于关心' : data.family_do_maternal_att == "4" ? '其他' : '', _this.form.family_other_desc = data.family_other_desc, _this.form.temperature = data.temperature, _this.form.blood_pressure = data.blood_pressure, _this.form.pulse_num = data.pulse_num, _this.form.breathing_num = data.breathing_num, _this.form.weight = data.weight, _this.form.complexion = data.complexion == "1" ? '红润' : data.complexion == "2" ? '苍白' : data.complexion == "3" ? '黄染' : '', _this.form.mouth_mucosa = data.mouth_mucosa == "1" ? '完整' : data.mouth_mucosa == "2" ? '溃疡' : '', _this.form.activity = data.activity == "1" ? '良好' : data.activity == "2" ? '受限' : '', _this.form.lochia_colour = data.lochia_colour, _this.form.lochia_amount = data.lochia_amount, _this.form.lochia_sniff = data.lochia_sniff, _this.form.lochia_gdg = data.lochia_gdg, _this.form.incision_case = data.incision_case == "1" ? '腹壁' : data.incision_case == "2" ? '会阴侧切' : data.incision_case == "3" ? '会阴正中' : data.incision_case == "4" ? '无切口' : '', _this.form.incision_case_desc = data.incision_case_desc == "1" ? '红' : data.incision_case_desc == "2" ? '肿' : data.incision_case_desc == "3" ? '痛' : data.incision_case_desc == "4" ? '渗出' : data.incision_case_desc == "5" ? '无异常' : '', _this.form.breast_case = data.breast_case == "1" ? '正常' : data.breast_case == "2" ? '饱胀' : data.breast_case == "3" ? '平坦' : data.breast_case == "4" ? '肿胀' : data.breast_case == "5" ? '副乳' : '', _this.form.papilla_case = data.papilla_case == "1" ? '正常' : data.papilla_case == "2" ? '内陷' : data.papilla_case == "3" ? '皲裂' : data.papilla_case == "4" ? '水泡' : '', _this.form.milk_case = data.milk_case == "1" ? '多' : data.milk_case == "2" ? '中' : data.milk_case == "3" ? '少' : data.milk_case == "4" ? '无' : '', _this.form.milk_other_case = data.milk_other_case, _this.form.special_find = data.special_find, _this.form.maternal_nursing_want = data.maternal_nursing_want, _this.form.autograph = data.autograph.indexOf(_this.get_host) != -1 ? data.autograph : _this.get_host + data.autograph;
        _this.form.customer_sign = data.customer_sign.indexOf(_this.get_host) != -1 ? data.customer_sign : _this.get_host + data.customer_sign;
        _this.form.assess_time = data.assess_time;
        var Arr = res.data.maternal_nursing_check;
        for (var i = 0; i < Arr.length; i++) {
          if (Arr[i] == '1') {
            Arr[i] = '观察恶露量，颜色和气味';
          } else if (Arr[i] == '2') {
            Arr[i] = '保证室内有新鲜空气，保持充足的睡眠';
          } else if (Arr[i] == '3') {
            Arr[i] = '产妇要保持心情愉悦';
          } else if (Arr[i] == '4') {
            Arr[i] = '剖宫产产妇要检查子宫缝合的伤口愈合情况';
          } else if (Arr[i] == '5') {
            Arr[i] = '顺产产妇要观察宫缩情况并注意会阴部伤口的清洁';
          } else if (Arr[i] == '6') {
            Arr[i] = '让婴儿早吸吮，保持乳房清洁';
          }
          _this.form.maternal_nursing_check = Arr.join();
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae4c183a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_form_a_detail.vue
var maternal_form_a_detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maternalFormADetail"},[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("妈妈入住评估单")]),_vm._v(" "),_c('div',[_c('group',{staticClass:"maternaleditContent listCom shengForm2"},[_c('x-input',{attrs:{"title":"房号：","readonly":""},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml",staticStyle:{"padding":"0px","margin-left":"14px"}},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("入所时间：")]),_vm._v(" "),_c('div',{staticClass:"label",staticStyle:{"margin-top":"0px"}},[_c('datetime',{attrs:{"title":"","readonly":""},model:{value:(_vm.form.entry_time),callback:function ($$v) {_vm.$set(_vm.form, "entry_time", $$v)},expression:"form.entry_time"}})],1)]),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","readonly":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"年龄：","readonly":""},model:{value:(_vm.form.age),callback:function ($$v) {_vm.$set(_vm.form, "age", $$v)},expression:"form.age"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"血型：","readonly":""},model:{value:(_vm.form.blood_type),callback:function ($$v) {_vm.$set(_vm.form, "blood_type", $$v)},expression:"form.blood_type"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"民族：","readonly":""},model:{value:(_vm.form.national),callback:function ($$v) {_vm.$set(_vm.form, "national", $$v)},expression:"form.national"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"籍贯：","readonly":""},model:{value:(_vm.form.native_place),callback:function ($$v) {_vm.$set(_vm.form, "native_place", $$v)},expression:"form.native_place"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩医院：","readonly":""},model:{value:(_vm.form.maternity_hospital),callback:function ($$v) {_vm.$set(_vm.form, "maternity_hospital", $$v)},expression:"form.maternity_hospital"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("分娩日期：")]),_vm._v(" "),_c('div',{staticClass:"label",staticStyle:{"margin-top":"0px"}},[_c('datetime',{attrs:{"title":"","readonly":""},model:{value:(_vm.form.maternity_date),callback:function ($$v) {_vm.$set(_vm.form, "maternity_date", $$v)},expression:"form.maternity_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("分娩方式：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.maternity_type),callback:function ($$v) {_vm.$set(_vm.form, "maternity_type", $$v)},expression:"form.maternity_type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("出院小结：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.leave_hos_smary),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_smary", $$v)},expression:"form.leave_hos_smary"}})],1)]),_vm._v(" "),_c('x-input',{attrs:{"title":"用药史：","readonly":""},model:{value:(_vm.form.medication_history),callback:function ($$v) {_vm.$set(_vm.form, "medication_history", $$v)},expression:"form.medication_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"过敏史：","readonly":""},model:{value:(_vm.form.allergy_history),callback:function ($$v) {_vm.$set(_vm.form, "allergy_history", $$v)},expression:"form.allergy_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出院诊断：","readonly":""},model:{value:(_vm.form.leave_hos_diagnosis),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_diagnosis", $$v)},expression:"form.leave_hos_diagnosis"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"孕期并发症，合并症：","readonly":""},model:{value:(_vm.form.pregnancy_illness),callback:function ($$v) {_vm.$set(_vm.form, "pregnancy_illness", $$v)},expression:"form.pregnancy_illness"}}),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.maternity_special_case),callback:function ($$v) {_vm.$set(_vm.form, "maternity_special_case", $$v)},expression:"form.maternity_special_case"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("分娩特殊情况（产时产后出血，产伤，分娩异常情况及处理）：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("急性疾病治疗期：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.acute_disease_treat),callback:function ($$v) {_vm.$set(_vm.form, "acute_disease_treat", $$v)},expression:"form.acute_disease_treat"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("传染病传染期：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.contagion_stage),callback:function ($$v) {_vm.$set(_vm.form, "contagion_stage", $$v)},expression:"form.contagion_stage"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("精神疾病史：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.spirit_history),callback:function ($$v) {_vm.$set(_vm.form, "spirit_history", $$v)},expression:"form.spirit_history"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("心理评估：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.heart_assess),callback:function ($$v) {_vm.$set(_vm.form, "heart_assess", $$v)},expression:"form.heart_assess"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"14px"}},[_vm._v("如有做心理评估：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.have_heart_case),callback:function ($$v) {_vm.$set(_vm.form, "have_heart_case", $$v)},expression:"form.have_heart_case"}})],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"有心理疾病：","readonly":""},model:{value:(_vm.form.have_heart_desc),callback:function ($$v) {_vm.$set(_vm.form, "have_heart_desc", $$v)},expression:"form.have_heart_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("性格类型：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.character_type),callback:function ($$v) {_vm.$set(_vm.form, "character_type", $$v)},expression:"form.character_type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("情绪：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.emotion),callback:function ($$v) {_vm.$set(_vm.form, "emotion", $$v)},expression:"form.emotion"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("食欲：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.appetite),callback:function ($$v) {_vm.$set(_vm.form, "appetite", $$v)},expression:"form.appetite"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("饮食要求：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.diet_require),callback:function ($$v) {_vm.$set(_vm.form, "diet_require", $$v)},expression:"form.diet_require"}})],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"","readonly":""},model:{value:(_vm.form.diet_require_other),callback:function ($$v) {_vm.$set(_vm.form, "diet_require_other", $$v)},expression:"form.diet_require_other"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("饮食嗜好：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.diet_hobby_status),callback:function ($$v) {_vm.$set(_vm.form, "diet_hobby_status", $$v)},expression:"form.diet_hobby_status"}})],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"","readonly":""},model:{value:(_vm.form.has_diet_hobby_desc),callback:function ($$v) {_vm.$set(_vm.form, "has_diet_hobby_desc", $$v)},expression:"form.has_diet_hobby_desc"}})],1)]),_vm._v(" "),_c('x-input',{attrs:{"title":"过敏食物：","placeholder":"请输入"},model:{value:(_vm.form.allergy_food),callback:function ($$v) {_vm.$set(_vm.form, "allergy_food", $$v)},expression:"form.allergy_food"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("排尿：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.micturition_case),callback:function ($$v) {_vm.$set(_vm.form, "micturition_case", $$v)},expression:"form.micturition_case"}})],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"次数(次/日)：","readonly":""},model:{value:(_vm.form.micturition_num),callback:function ($$v) {_vm.$set(_vm.form, "micturition_num", $$v)},expression:"form.micturition_num"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("尿痛：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.urination_pain),callback:function ($$v) {_vm.$set(_vm.form, "urination_pain", $$v)},expression:"form.urination_pain"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("排便：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.defecation_case),callback:function ($$v) {_vm.$set(_vm.form, "defecation_case", $$v)},expression:"form.defecation_case"}})],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"次数(次/日)：","readonly":""},model:{value:(_vm.form.defecation_num),callback:function ($$v) {_vm.$set(_vm.form, "defecation_num", $$v)},expression:"form.defecation_num"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("对康复知识：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.do_recovery_know),callback:function ($$v) {_vm.$set(_vm.form, "do_recovery_know", $$v)},expression:"form.do_recovery_know"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("参加孕期教育：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.attend_pregnancy_edu),callback:function ($$v) {_vm.$set(_vm.form, "attend_pregnancy_edu", $$v)},expression:"form.attend_pregnancy_edu"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("家属对产妇态度：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.family_do_maternal_att),callback:function ($$v) {_vm.$set(_vm.form, "family_do_maternal_att", $$v)},expression:"form.family_do_maternal_att"}})],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"","readonly":""},model:{value:(_vm.form.family_other_desc),callback:function ($$v) {_vm.$set(_vm.form, "family_other_desc", $$v)},expression:"form.family_other_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticStyle:{"margin":"10px auto"}},[_vm._v("入所检查")])]),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.temperature),callback:function ($$v) {_vm.$set(_vm.form, "temperature", $$v)},expression:"form.temperature"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("体温(℃)：")])]),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.blood_pressure),callback:function ($$v) {_vm.$set(_vm.form, "blood_pressure", $$v)},expression:"form.blood_pressure"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("血压(mmHg)：")])]),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.pulse_num),callback:function ($$v) {_vm.$set(_vm.form, "pulse_num", $$v)},expression:"form.pulse_num"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("脉搏(次/分)：")])]),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.breathing_num),callback:function ($$v) {_vm.$set(_vm.form, "breathing_num", $$v)},expression:"form.breathing_num"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("呼吸(次/分)：")])]),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.weight),callback:function ($$v) {_vm.$set(_vm.form, "weight", $$v)},expression:"form.weight"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("体重(kg)：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("面色：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.complexion),callback:function ($$v) {_vm.$set(_vm.form, "complexion", $$v)},expression:"form.complexion"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("口腔黏膜：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.mouth_mucosa),callback:function ($$v) {_vm.$set(_vm.form, "mouth_mucosa", $$v)},expression:"form.mouth_mucosa"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("活动：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.activity),callback:function ($$v) {_vm.$set(_vm.form, "activity", $$v)},expression:"form.activity"}})],1)]),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.lochia_colour),callback:function ($$v) {_vm.$set(_vm.form, "lochia_colour", $$v)},expression:"form.lochia_colour"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("恶露（色）：")])]),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.lochia_amount),callback:function ($$v) {_vm.$set(_vm.form, "lochia_amount", $$v)},expression:"form.lochia_amount"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("恶露（量）：")])]),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.lochia_sniff),callback:function ($$v) {_vm.$set(_vm.form, "lochia_sniff", $$v)},expression:"form.lochia_sniff"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("恶露（嗅）：")])]),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.lochia_gdg),callback:function ($$v) {_vm.$set(_vm.form, "lochia_gdg", $$v)},expression:"form.lochia_gdg"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("宫底高度：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("切口情况：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.incision_case),callback:function ($$v) {_vm.$set(_vm.form, "incision_case", $$v)},expression:"form.incision_case"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("切口情况（描述）：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.incision_case_desc),callback:function ($$v) {_vm.$set(_vm.form, "incision_case_desc", $$v)},expression:"form.incision_case_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("乳房：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.breast_case),callback:function ($$v) {_vm.$set(_vm.form, "breast_case", $$v)},expression:"form.breast_case"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("乳头：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.papilla_case),callback:function ($$v) {_vm.$set(_vm.form, "papilla_case", $$v)},expression:"form.papilla_case"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("乳汁：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.milk_case),callback:function ($$v) {_vm.$set(_vm.form, "milk_case", $$v)},expression:"form.milk_case"}})],1)]),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.milk_other_case),callback:function ($$v) {_vm.$set(_vm.form, "milk_other_case", $$v)},expression:"form.milk_other_case"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("乳房其他情况：")])]),_vm._v(" "),_c('x-input',{attrs:{"readonly":""},model:{value:(_vm.form.special_find),callback:function ($$v) {_vm.$set(_vm.form, "special_find", $$v)},expression:"form.special_find"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("特殊发现：")])]),_vm._v(" "),_c('x-textarea',{attrs:{"readonly":""},model:{value:(_vm.form.maternal_nursing_check),callback:function ($$v) {_vm.$set(_vm.form, "maternal_nursing_check", $$v)},expression:"form.maternal_nursing_check"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("产妇护理要点：")])]),_vm._v(" "),_c('x-textarea',{attrs:{"title":"产妇护理要点描述（不足书写请加附页）：","readonly":""},model:{value:(_vm.form.maternal_nursing_want),callback:function ($$v) {_vm.$set(_vm.form, "maternal_nursing_want", $$v)},expression:"form.maternal_nursing_want"}}),_vm._v(" "),_c('div',{staticClass:"listCom"},[_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("护士签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',[_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.autograph,"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"listCom"},[_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("客户签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',[_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.customer_sign,"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("评估时间：")]),_vm._v(" "),_c('div',{staticClass:"label",staticStyle:{"margin-top":"0px"}},[_c('datetime',{attrs:{"title":"","readonly":""},model:{value:(_vm.form.assess_time),callback:function ($$v) {_vm.$set(_vm.form, "assess_time", $$v)},expression:"form.assess_time"}})],1)]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("修改")])],1)],1)],1)}
var maternal_form_a_detail_staticRenderFns = []
var maternal_form_a_detail_esExports = { render: maternal_form_a_detail_render, staticRenderFns: maternal_form_a_detail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_form_a_detail = (maternal_form_a_detail_esExports);
// CONCATENATED MODULE: ./src/components/maternal_form_a_detail.vue
function maternal_form_a_detail_injectStyle (ssrContext) {
  __webpack_require__("EBXz")
}
var maternal_form_a_detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_form_a_detail___vue_template_functional__ = false
/* styles */
var maternal_form_a_detail___vue_styles__ = maternal_form_a_detail_injectStyle
/* scopeId */
var maternal_form_a_detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_form_a_detail___vue_module_identifier__ = null
var maternal_form_a_detail_Component = maternal_form_a_detail_normalizeComponent(
  components_maternal_form_a_detail,
  selectortype_template_index_0_src_components_maternal_form_a_detail,
  maternal_form_a_detail___vue_template_functional__,
  maternal_form_a_detail___vue_styles__,
  maternal_form_a_detail___vue_scopeId__,
  maternal_form_a_detail___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_form_a_detail = (maternal_form_a_detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_a_edit.vue




/* harmony default export */ var maternal_form_a_edit = ({
  components: {
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item
  },
  name: 'maternal_form_a_edit',
  data: function data() {
    return {
      get_host: host.host,
      type: '',
      showSignature: true,
      showUserSignature: true,
      form: {
        maternal_nursing_check: []
      },
      option: {
        penColor: "rgb(0, 0, 0)"
      }
    };
  },

  methods: {
    save: function save() {
      var signature = 'signature1';
      console.info(this.$refs[signature]);
      var png = this.$refs[signature].save();
      this.form.autograph = encodeURI(png);
      this.showSignature = true;
    },
    edit: function edit() {
      this.showSignature = false;
      this.form.autograph = '';
    },
    clear: function clear() {
      var signature = 'signature1';
      var refs = this.$refs[signature].clear();
      this.form.autograph = '';
    },
    saveUserName: function saveUserName() {
      var signature = 'signature2';
      console.info(this.$refs[signature]);
      var png = this.$refs[signature].save();
      this.form.customer_sign = encodeURI(png);
      this.showUserSignature = true;
    },
    editUserName: function editUserName() {
      this.showUserSignature = false;
      this.form.customer_sign = '';
    },
    clearUserName: function clearUserName() {
      var signature = 'signature2';
      var refs = this.$refs[signature].clear();
      this.form.customer_sign = '';
    },
    submitForm: function submitForm() {
      var _this = this;

      this.form.token = this.$cookie.get('token');
      this.form.number_id = this.$cookie.get('id');
      this.form.maternal_info_id = this.$route.query.id;
      this.form.id = this.$route.query.form_id;
      this.form.store_id = this.$cookie.get('store_id');
      this.form.autograph = this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host, '') : this.form.autograph;
      this.form.customer_sign = this.form.customer_sign.indexOf(this.get_host) != -1 ? this.form.customer_sign.replace(this.get_host, '') : this.form.customer_sign;
      var params = this.form;
      if (params.room_number == '' || params.entry_time == '' || params.name == '' || params.age == '' || params.blood_type == '' || params.national == '' || params.native_place == '' || params.maternity_hospital == '' || params.maternity_date == '' || params.maternity_type == '' || params.leave_hos_smary == '' || params.medication_history == '' || params.allergy_history == '' || params.leave_hos_diagnosis == '' || params.pregnancy_illness == '' || params.maternity_special_case == '' || params.acute_disease_treat == '' || params.contagion_stage == '' || params.spirit_history == '' || params.heart_assess == '' || params.character_type == '' || params.emotion == '' || params.appetite == '' || params.diet_require == '' || params.diet_hobby_status == '' || params.allergy_food == '' || params.micturition_case == '' || params.micturition_num == '' || params.urination_pain == '' || params.defecation_case == '' || params.do_recovery_know == '' || params.attend_pregnancy_edu == '' || params.family_do_maternal_att == '' || params.temperature == '' || params.blood_pressure == '' || params.pulse_num == '' || params.breathing_num == '' || params.weight == '' || params.complexion == '' || params.mouth_mucosa == '' || params.activity == '' || params.lochia_colour == '' || params.lochia_amount == '' || params.lochia_sniff == '' || params.lochia_gdg == '' || params.incision_case == '' || params.incision_case_desc == '' || params.breast_case == '' || params.papilla_case == '' || params.milk_case == '' || params.milk_other_case == '' || params.special_find == '' || params.maternal_nursing_check.length == 0 || params.autograph == '' || params.customer_sign == '' || params.assess_time == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请完善表单'
        });
        return;
      }
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.otherFormApi.updateMaterCheckAssessData(params).then(function (res) {
        _this.$vux.loading.hide();
        console.info(res);
        if (res.errcode == 200) {
          _this.$router.replace({
            path: '/success',
            query: {
              id: _this.$route.query.id,
              tabVal: _this.$route.query.tabVal,
              form_id: res.data.id,
              name: 'maternal_form_a'
            }
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    var _this2 = this;

    var params = {
      token: this.$cookie.get('token'),
      id: this.$route.query.form_id
    };
    this.$vux.loading.show({
      text: '正在加载'
    });
    console.info(params);
    Api.otherFormApi.getMaterCheckAssessFind(params).then(function (res) {
      _this2.$vux.loading.hide();
      console.info("详情", res.data);
      if (res.errcode == 200) {
        _this2.form = res.data;
        _this2.form.maternal_nursing_check = res.data.maternal_nursing_check;
        _this2.form.autograph = res.data.autograph.indexOf(_this2.get_host) != -1 ? res.data.autograph : _this2.get_host + res.data.autograph;
        _this2.form.customer_sign = res.data.customer_sign.indexOf(_this2.get_host) != -1 ? res.data.customer_sign : _this2.get_host + res.data.customer_sign;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_a_edit.vue




/* harmony default export */ var components_maternal_form_a_edit = ({
  components: {
    Checker: src_components_checker_checker,
    CheckerItem: src_components_checker_checker_item
  },
  name: 'maternal_form_a_edit',
  data: function data() {
    return {
      get_host: host.host,
      type: '',
      showSignature: true,
      showUserSignature: true,
      form: {
        maternal_nursing_check: []
      },
      option: {
        penColor: "rgb(0, 0, 0)"
      }
    };
  },

  methods: {
    save: function save() {
      var signature = 'signature1';
      console.info(this.$refs[signature]);
      var png = this.$refs[signature].save();
      this.form.autograph = encodeURI(png);
      this.showSignature = true;
    },
    edit: function edit() {
      this.showSignature = false;
      this.form.autograph = '';
    },
    clear: function clear() {
      var signature = 'signature1';
      var refs = this.$refs[signature].clear();
      this.form.autograph = '';
    },
    saveUserName: function saveUserName() {
      var signature = 'signature2';
      console.info(this.$refs[signature]);
      var png = this.$refs[signature].save();
      this.form.customer_sign = encodeURI(png);
      this.showUserSignature = true;
    },
    editUserName: function editUserName() {
      this.showUserSignature = false;
      this.form.customer_sign = '';
    },
    clearUserName: function clearUserName() {
      var signature = 'signature2';
      var refs = this.$refs[signature].clear();
      this.form.customer_sign = '';
    },
    submitForm: function submitForm() {
      var _this = this;

      this.form.token = this.$cookie.get('token');
      this.form.number_id = this.$cookie.get('id');
      this.form.maternal_info_id = this.$route.query.id;
      this.form.id = this.$route.query.form_id;
      this.form.store_id = this.$cookie.get('store_id');
      this.form.autograph = this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host, '') : this.form.autograph;
      this.form.customer_sign = this.form.customer_sign.indexOf(this.get_host) != -1 ? this.form.customer_sign.replace(this.get_host, '') : this.form.customer_sign;
      var params = this.form;
      if (params.room_number == '' || params.entry_time == '' || params.name == '' || params.age == '' || params.blood_type == '' || params.national == '' || params.native_place == '' || params.maternity_hospital == '' || params.maternity_date == '' || params.maternity_type == '' || params.leave_hos_smary == '' || params.medication_history == '' || params.allergy_history == '' || params.leave_hos_diagnosis == '' || params.pregnancy_illness == '' || params.maternity_special_case == '' || params.acute_disease_treat == '' || params.contagion_stage == '' || params.spirit_history == '' || params.heart_assess == '' || params.character_type == '' || params.emotion == '' || params.appetite == '' || params.diet_require == '' || params.diet_hobby_status == '' || params.allergy_food == '' || params.micturition_case == '' || params.micturition_num == '' || params.urination_pain == '' || params.defecation_case == '' || params.do_recovery_know == '' || params.attend_pregnancy_edu == '' || params.family_do_maternal_att == '' || params.temperature == '' || params.blood_pressure == '' || params.pulse_num == '' || params.breathing_num == '' || params.weight == '' || params.complexion == '' || params.mouth_mucosa == '' || params.activity == '' || params.lochia_colour == '' || params.lochia_amount == '' || params.lochia_sniff == '' || params.lochia_gdg == '' || params.incision_case == '' || params.incision_case_desc == '' || params.breast_case == '' || params.papilla_case == '' || params.milk_case == '' || params.milk_other_case == '' || params.special_find == '' || params.maternal_nursing_check.length == 0 || params.autograph == '' || params.customer_sign == '' || params.assess_time == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请完善表单'
        });
        return;
      }
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.otherFormApi.updateMaterCheckAssessData(params).then(function (res) {
        _this.$vux.loading.hide();
        console.info(res);
        if (res.errcode == 200) {
          _this.$router.replace({
            path: '/success',
            query: {
              id: _this.$route.query.id,
              tabVal: _this.$route.query.tabVal,
              form_id: res.data.id,
              name: 'maternal_form_a'
            }
          });
        }
      });
    },
    goBack: function goBack() {
      this.$router.push({
        path: './maternal_service',
        query: {
          tabVal: this.$route.query.tabVal,
          id: this.$route.query.id
        }
      });
    }
  },
  created: function created() {
    var _this2 = this;

    var params = {
      token: this.$cookie.get('token'),
      id: this.$route.query.form_id
    };
    this.$vux.loading.show({
      text: '正在加载'
    });
    console.info(params);
    Api.otherFormApi.getMaterCheckAssessFind(params).then(function (res) {
      _this2.$vux.loading.hide();
      console.info("详情", res.data);
      if (res.errcode == 200) {
        _this2.form = res.data;
        _this2.form.maternal_nursing_check = res.data.maternal_nursing_check;
        _this2.form.autograph = res.data.autograph.indexOf(_this2.get_host) != -1 ? res.data.autograph : _this2.get_host + res.data.autograph;
        _this2.form.customer_sign = res.data.customer_sign.indexOf(_this2.get_host) != -1 ? res.data.customer_sign : _this2.get_host + res.data.customer_sign;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19cf1d53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_form_a_edit.vue
var maternal_form_a_edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maternalFormAEdit"},[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("母亲入住评估单")]),_vm._v(" "),_c('div',[_c('group',{staticClass:"maternaleditContent listCom shengForm3"},[_c('x-input',{attrs:{"title":"房号：","placeholder":"请输入房号","readonly":""},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("入所时间：")]),_vm._v(" "),_c('div',{staticClass:"label",staticStyle:{"margin-top":"0px"}},[_c('datetime',{attrs:{"title":"","placeholder":"请选择入所时间"},model:{value:(_vm.form.entry_time),callback:function ($$v) {_vm.$set(_vm.form, "entry_time", $$v)},expression:"form.entry_time"}})],1)]),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","placeholder":"请输入姓名","readonly":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"年龄：","placeholder":"请输入年龄"},model:{value:(_vm.form.age),callback:function ($$v) {_vm.$set(_vm.form, "age", $$v)},expression:"form.age"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"血型：","placeholder":"请输入血型"},model:{value:(_vm.form.blood_type),callback:function ($$v) {_vm.$set(_vm.form, "blood_type", $$v)},expression:"form.blood_type"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"民族：","placeholder":"请输入民族"},model:{value:(_vm.form.national),callback:function ($$v) {_vm.$set(_vm.form, "national", $$v)},expression:"form.national"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"籍贯：","placeholder":"请输入籍贯"},model:{value:(_vm.form.native_place),callback:function ($$v) {_vm.$set(_vm.form, "native_place", $$v)},expression:"form.native_place"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩医院：","placeholder":"请输入"},model:{value:(_vm.form.maternity_hospital),callback:function ($$v) {_vm.$set(_vm.form, "maternity_hospital", $$v)},expression:"form.maternity_hospital"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("分娩日期：")]),_vm._v(" "),_c('div',{staticClass:"label",staticStyle:{"margin-top":"0px"}},[_c('datetime',{attrs:{"title":"","placeholder":"请选择分娩日期："},model:{value:(_vm.form.maternity_date),callback:function ($$v) {_vm.$set(_vm.form, "maternity_date", $$v)},expression:"form.maternity_date"}})],1)]),_vm._v(" "),(_vm.form.maternity_type == 1)?_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","value":"经阴道"}}):_vm._e(),_vm._v(" "),(_vm.form.maternity_type == 2)?_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","value":"剖宫产"}}):_vm._e(),_vm._v(" "),(_vm.form.maternity_type == 3)?_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","value":"小产"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("出院小结：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.leave_hos_smary),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_smary", $$v)},expression:"form.leave_hos_smary"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('x-input',{attrs:{"title":"用药史：","placeholder":"请输入"},model:{value:(_vm.form.medication_history),callback:function ($$v) {_vm.$set(_vm.form, "medication_history", $$v)},expression:"form.medication_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"过敏史：","placeholder":"请输入"},model:{value:(_vm.form.allergy_history),callback:function ($$v) {_vm.$set(_vm.form, "allergy_history", $$v)},expression:"form.allergy_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出院诊断：","placeholder":"请输入"},model:{value:(_vm.form.leave_hos_diagnosis),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_diagnosis", $$v)},expression:"form.leave_hos_diagnosis"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"孕期并发症，合并症：","placeholder":"请输入"},model:{value:(_vm.form.pregnancy_illness),callback:function ($$v) {_vm.$set(_vm.form, "pregnancy_illness", $$v)},expression:"form.pregnancy_illness"}}),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.maternity_special_case),callback:function ($$v) {_vm.$set(_vm.form, "maternity_special_case", $$v)},expression:"form.maternity_special_case"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("分娩特殊情况（产时产后出血，产伤，分娩异常情况及处理）：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("急性疾病治疗期：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.acute_disease_treat),callback:function ($$v) {_vm.$set(_vm.form, "acute_disease_treat", $$v)},expression:"form.acute_disease_treat"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("传染病传染期：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.contagion_stage),callback:function ($$v) {_vm.$set(_vm.form, "contagion_stage", $$v)},expression:"form.contagion_stage"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("精神疾病史：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.spirit_history),callback:function ($$v) {_vm.$set(_vm.form, "spirit_history", $$v)},expression:"form.spirit_history"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("心理评估：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.heart_assess),callback:function ($$v) {_vm.$set(_vm.form, "heart_assess", $$v)},expression:"form.heart_assess"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"14px"}},[_vm._v("如有做心理评估：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.have_heart_case),callback:function ($$v) {_vm.$set(_vm.form, "have_heart_case", $$v)},expression:"form.have_heart_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")])],1)],1),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"margin-top":"6px"}},[_c('x-input',{attrs:{"title":"如有心理疾病请描述","placeholder":"如有心理疾病请描述"},model:{value:(_vm.form.have_heart_desc),callback:function ($$v) {_vm.$set(_vm.form, "have_heart_desc", $$v)},expression:"form.have_heart_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("性格类型：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.character_type),callback:function ($$v) {_vm.$set(_vm.form, "character_type", $$v)},expression:"form.character_type"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("主动外向")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("被动内向")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("情绪：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.emotion),callback:function ($$v) {_vm.$set(_vm.form, "emotion", $$v)},expression:"form.emotion"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("稳定")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("兴奋")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("郁闷")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("焦虑")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("恐惧")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("食欲：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.appetite),callback:function ($$v) {_vm.$set(_vm.form, "appetite", $$v)},expression:"form.appetite"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("不佳")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("厌食")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("饮食要求：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.diet_require),callback:function ($$v) {_vm.$set(_vm.form, "diet_require", $$v)},expression:"form.diet_require"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("普食")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("其他")])],1)],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"","placeholder":"如有其他饮食要求请输入"},model:{value:(_vm.form.diet_require_other),callback:function ($$v) {_vm.$set(_vm.form, "diet_require_other", $$v)},expression:"form.diet_require_other"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("饮食嗜好：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.diet_hobby_status),callback:function ($$v) {_vm.$set(_vm.form, "diet_hobby_status", $$v)},expression:"form.diet_hobby_status"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1)],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"","placeholder":"如有饮食嗜好请输入"},model:{value:(_vm.form.has_diet_hobby_desc),callback:function ($$v) {_vm.$set(_vm.form, "has_diet_hobby_desc", $$v)},expression:"form.has_diet_hobby_desc"}})],1)]),_vm._v(" "),_c('x-input',{attrs:{"title":"过敏食物：","placeholder":"请输入"},model:{value:(_vm.form.allergy_food),callback:function ($$v) {_vm.$set(_vm.form, "allergy_food", $$v)},expression:"form.allergy_food"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("排尿：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.micturition_case),callback:function ($$v) {_vm.$set(_vm.form, "micturition_case", $$v)},expression:"form.micturition_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("尿频")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px","margin-left":"0px"}},[_vm._v("排尿次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.micturition_num),expression:"form.micturition_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.micturition_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "micturition_num", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("尿痛：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.urination_pain),callback:function ($$v) {_vm.$set(_vm.form, "urination_pain", $$v)},expression:"form.urination_pain"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("排便：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.defecation_case),callback:function ($$v) {_vm.$set(_vm.form, "defecation_case", $$v)},expression:"form.defecation_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("便秘")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("腹泻")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("未排")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px","margin-left":"0px"}},[_vm._v("排便次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.defecation_num),expression:"form.defecation_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.defecation_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "defecation_num", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("对康复知识：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.do_recovery_know),callback:function ($$v) {_vm.$set(_vm.form, "do_recovery_know", $$v)},expression:"form.do_recovery_know"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("熟悉")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("了解")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("不了解")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("参加孕期教育：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.attend_pregnancy_edu),callback:function ($$v) {_vm.$set(_vm.form, "attend_pregnancy_edu", $$v)},expression:"form.attend_pregnancy_edu"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("共同")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("本人")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("家属")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("家属对产妇态度：")]),_vm._v(" "),_c('div',{staticClass:"label"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.family_do_maternal_att),callback:function ($$v) {_vm.$set(_vm.form, "family_do_maternal_att", $$v)},expression:"form.family_do_maternal_att"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("恰当的关怀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("不关心")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("过于关心")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("其他")])],1)],1),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{attrs:{"title":"","placeholder":"如有其他请输入"},model:{value:(_vm.form.family_other_desc),callback:function ($$v) {_vm.$set(_vm.form, "family_other_desc", $$v)},expression:"form.family_other_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticStyle:{"margin":"10px auto"}},[_vm._v("入所检查")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：℃)"},model:{value:(_vm.form.temperature),callback:function ($$v) {_vm.$set(_vm.form, "temperature", $$v)},expression:"form.temperature"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("体温(℃)：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：mmHg)"},model:{value:(_vm.form.blood_pressure),callback:function ($$v) {_vm.$set(_vm.form, "blood_pressure", $$v)},expression:"form.blood_pressure"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("血压(mmHg)：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：次/分)"},model:{value:(_vm.form.pulse_num),callback:function ($$v) {_vm.$set(_vm.form, "pulse_num", $$v)},expression:"form.pulse_num"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("脉搏(次/分)：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：次/分)"},model:{value:(_vm.form.breathing_num),callback:function ($$v) {_vm.$set(_vm.form, "breathing_num", $$v)},expression:"form.breathing_num"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("呼吸(次/分)：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：kg)"},model:{value:(_vm.form.weight),callback:function ($$v) {_vm.$set(_vm.form, "weight", $$v)},expression:"form.weight"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("体重(kg)：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("面色：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.complexion),callback:function ($$v) {_vm.$set(_vm.form, "complexion", $$v)},expression:"form.complexion"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红润")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("苍白")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("黄染")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("口腔黏膜：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.mouth_mucosa),callback:function ($$v) {_vm.$set(_vm.form, "mouth_mucosa", $$v)},expression:"form.mouth_mucosa"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("完整")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("溃疡")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("活动：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.activity),callback:function ($$v) {_vm.$set(_vm.form, "activity", $$v)},expression:"form.activity"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("受限")])],1)],1)]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.lochia_colour),callback:function ($$v) {_vm.$set(_vm.form, "lochia_colour", $$v)},expression:"form.lochia_colour"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("恶露（色）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.lochia_amount),callback:function ($$v) {_vm.$set(_vm.form, "lochia_amount", $$v)},expression:"form.lochia_amount"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("恶露（量）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.lochia_sniff),callback:function ($$v) {_vm.$set(_vm.form, "lochia_sniff", $$v)},expression:"form.lochia_sniff"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("恶露（嗅）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.lochia_gdg),callback:function ($$v) {_vm.$set(_vm.form, "lochia_gdg", $$v)},expression:"form.lochia_gdg"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("宫底高度：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("切口情况：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.incision_case),callback:function ($$v) {_vm.$set(_vm.form, "incision_case", $$v)},expression:"form.incision_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("腹壁")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("会阴侧切")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("会阴正中")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("无切口")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("切口情况（描述）：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.incision_case_desc),callback:function ($$v) {_vm.$set(_vm.form, "incision_case_desc", $$v)},expression:"form.incision_case_desc"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("肿")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("痛")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("渗出")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("无异常")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("乳房：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.breast_case),callback:function ($$v) {_vm.$set(_vm.form, "breast_case", $$v)},expression:"form.breast_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("饱胀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("平坦")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("肿胀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("副乳")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("乳头：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.papilla_case),callback:function ($$v) {_vm.$set(_vm.form, "papilla_case", $$v)},expression:"form.papilla_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("内陷")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("皲裂")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("水泡")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("乳汁：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.milk_case),callback:function ($$v) {_vm.$set(_vm.form, "milk_case", $$v)},expression:"form.milk_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("多")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("中")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("少")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.milk_other_case),callback:function ($$v) {_vm.$set(_vm.form, "milk_other_case", $$v)},expression:"form.milk_other_case"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("乳房其他情况：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.special_find),callback:function ($$v) {_vm.$set(_vm.form, "special_find", $$v)},expression:"form.special_find"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("特殊发现：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("产妇护理要点：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.maternal_nursing_check),callback:function ($$v) {_vm.$set(_vm.form, "maternal_nursing_check", $$v)},expression:"form.maternal_nursing_check"}},[_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"1"}},[_vm._v("观察恶露量，颜色和气味")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"2"}},[_vm._v("保证室内有新鲜空气，保持充足的睡眠")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"3"}},[_vm._v("产妇要保持心情愉悦")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"4"}},[_vm._v("剖宫产产妇要检查子宫缝合的伤口愈合情况")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"5"}},[_vm._v("顺产产妇要观察宫缩情况并注意会阴部伤口的清洁")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin-top":"5px"},attrs:{"value":"6"}},[_vm._v("让婴儿早吸吮，保持乳房清洁")])],1)],1)]),_vm._v(" "),_c('x-textarea',{attrs:{"title":"产妇护理要点描述（不足书写请加附页）：","placeholder":"请输入"},model:{value:(_vm.form.maternal_nursing_want),callback:function ($$v) {_vm.$set(_vm.form, "maternal_nursing_want", $$v)},expression:"form.maternal_nursing_want"}}),_vm._v(" "),_c('div',{staticClass:"listCom"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护士签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.autograph)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.autograph,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listCom"},[_c('div',{staticClass:"item vux-1px-t ml"},[_c('div',{staticClass:"label"},[_vm._v("客户签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showUserSignature)?_c('div',[(_vm.form.customer_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.customer_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editUserName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveUserName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearUserName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("评估时间：")]),_vm._v(" "),_c('div',{staticClass:"label",staticStyle:{"margin-top":"0px"}},[_c('datetime',{attrs:{"title":"","placeholder":"请选择评估时间"},model:{value:(_vm.form.assess_time),callback:function ($$v) {_vm.$set(_vm.form, "assess_time", $$v)},expression:"form.assess_time"}})],1)]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交修改")])],1)],1)],1)}
var maternal_form_a_edit_staticRenderFns = []
var maternal_form_a_edit_esExports = { render: maternal_form_a_edit_render, staticRenderFns: maternal_form_a_edit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_form_a_edit = (maternal_form_a_edit_esExports);
// CONCATENATED MODULE: ./src/components/maternal_form_a_edit.vue
function maternal_form_a_edit_injectStyle (ssrContext) {
  __webpack_require__("YRdQ")
}
var maternal_form_a_edit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_form_a_edit___vue_template_functional__ = false
/* styles */
var maternal_form_a_edit___vue_styles__ = maternal_form_a_edit_injectStyle
/* scopeId */
var maternal_form_a_edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_form_a_edit___vue_module_identifier__ = null
var maternal_form_a_edit_Component = maternal_form_a_edit_normalizeComponent(
  components_maternal_form_a_edit,
  selectortype_template_index_0_src_components_maternal_form_a_edit,
  maternal_form_a_edit___vue_template_functional__,
  maternal_form_a_edit___vue_styles__,
  maternal_form_a_edit___vue_scopeId__,
  maternal_form_a_edit___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_form_a_edit = (maternal_form_a_edit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_b.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var maternal_form_b = ({
    name: 'maternal_form_b',
    data: function data() {
        return {
            showSignature: false,
            form: {
                room_number: '',
                mom_name: '',
                delivery_type: '',
                cat_date: '',
                number_of_meal: '',
                eating_situation: '',
                trait_common: '',
                trait_special: '',
                plan_carbohydrate: '',
                plan_vegetables: '',
                plan_fruits: '',
                plan_meat: '',
                plan_birds: '',
                plan_fish: '',
                plan_egg: '',
                plan_bean_products: '',
                plan_milk: '',
                plan_dairy: '',
                plan_oils: '',
                plan_traditional_chinese_medicine: '',
                shifts: ''
            },
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : '';
                    _this.form.mom_name = res.data.name;
                    _this.form.room_number = res.data.room_name;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 保存
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.signature = encodeURI(png);
            this.showSignature = true;
        },

        //编辑
        edit: function edit() {
            this.showSignature = false;
        },

        //清除
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.signature = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getMaternalMealRecordsFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this2.form.room_number = data.room_number;
                    _this2.form.mom_name = data.mom_name;
                    _this2.form.delivery_type = data.delivery_type;
                    _this2.form.cat_date = data.cat_date;
                    _this2.form.number_of_meal = data.number_of_meal;
                    _this2.form.eating_situation = data.eating_situation;
                    _this2.form.trait_common = data.trait_common;
                    _this2.form.trait_special = data.trait_special;
                    _this2.form.plan_carbohydrate = data.plan_carbohydrate;
                    _this2.form.plan_vegetables = data.plan_vegetables;
                    _this2.form.plan_fruits = data.plan_fruits;
                    _this2.form.plan_meat = data.plan_meat;
                    _this2.form.plan_birds = data.plan_birds;
                    _this2.form.plan_fish = data.plan_fish;
                    _this2.form.plan_egg = data.plan_egg;
                    _this2.form.plan_bean_products = data.plan_bean_products;
                    _this2.form.plan_milk = data.plan_milk;
                    _this2.form.plan_dairy = data.plan_dairy;
                    _this2.form.plan_oils = data.plan_oils;
                    _this2.form.plan_traditional_chinese_medicine = data.plan_traditional_chinese_medicine;
                    _this2.form.shifts = data.shifts;
                    _this2.showSignature = true;
                    _this2.$vux.loading.hide();
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room_number,
                mom_name: this.form.mom_name,
                delivery_type: this.form.delivery_type,
                cat_date: this.form.cat_date,
                number_of_meal: this.form.number_of_meal,
                eating_situation: this.form.eating_situation,
                trait_common: this.form.trait_common,
                trait_special: this.form.trait_special,
                plan_carbohydrate: this.form.plan_carbohydrate,
                plan_vegetables: this.form.plan_vegetables,
                plan_fruits: this.form.plan_fruits,
                plan_meat: this.form.plan_meat,
                plan_birds: this.form.plan_birds,
                plan_fish: this.form.plan_fish,
                plan_egg: this.form.plan_egg,
                plan_bean_products: this.form.plan_bean_products,
                plan_milk: this.form.plan_milk,
                plan_dairy: this.form.plan_dairy,
                plan_oils: this.form.plan_oils,
                plan_traditional_chinese_medicine: this.form.plan_traditional_chinese_medicine,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addMaternalMealRecordsData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this3.$vux.loading.hide();
                    _this3.$router.replace({
                        path: '/success',
                        query: {
                            id: _this3.$route.query.id,
                            form_id: _this3.$route.query.form_id,
                            tabVal: _this3.$route.query.tabVal,
                            name: 'maternal_form_b'
                        }
                    });
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this4 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room_number,
                mom_name: this.form.mom_name,
                delivery_type: this.form.delivery_type,
                cat_date: this.form.cat_date,
                number_of_meal: this.form.number_of_meal,
                eating_situation: this.form.eating_situation,
                trait_common: this.form.trait_common,
                trait_special: this.form.trait_special,
                plan_carbohydrate: this.form.plan_carbohydrate,
                plan_vegetables: this.form.plan_vegetables,
                plan_fruits: this.form.plan_fruits,
                plan_meat: this.form.plan_meat,
                plan_birds: this.form.plan_birds,
                plan_fish: this.form.plan_fish,
                plan_egg: this.form.plan_egg,
                plan_bean_products: this.form.plan_bean_products,
                plan_milk: this.form.plan_milk,
                plan_dairy: this.form.plan_dairy,
                plan_oils: this.form.plan_oils,
                plan_traditional_chinese_medicine: this.form.plan_traditional_chinese_medicine,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateMaternalMealRecordsData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'maternal_form_b'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            var form = this.form;
            if (form.room_number == '' || form.mom_name == '' || form.delivery_type == '' || form.shifts == '' || form.cat_date == '' || form.number_of_meal == '' || form.eating_situation == '' || form.trait_common == '' || form.trait_special == '' || form.plan_carbohydrate == '' || form.plan_vegetables == '' || form.plan_fruits == '' || form.plan_meat == '' || form.plan_birds == '' || form.plan_fish == '' || form.plan_egg == '' || form.plan_bean_products == '' || form.plan_milk == '' || form.plan_dairy == '' || form.plan_oils == '' || form.plan_traditional_chinese_medicine == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请完善所有表单'
                });
                return;
            }
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    },
    created: function created() {
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            this.apiMemberInfo();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_b.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_maternal_form_b = ({
    name: 'maternal_form_b',
    data: function data() {
        return {
            showSignature: false,
            form: {
                room_number: '',
                mom_name: '',
                delivery_type: '',
                cat_date: '',
                number_of_meal: '',
                eating_situation: '',
                trait_common: '',
                trait_special: '',
                plan_carbohydrate: '',
                plan_vegetables: '',
                plan_fruits: '',
                plan_meat: '',
                plan_birds: '',
                plan_fish: '',
                plan_egg: '',
                plan_bean_products: '',
                plan_milk: '',
                plan_dairy: '',
                plan_oils: '',
                plan_traditional_chinese_medicine: '',
                shifts: ''
            },
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : '';
                    _this.form.mom_name = res.data.name;
                    _this.form.room_number = res.data.room_name;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 保存
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.signature = encodeURI(png);
            this.showSignature = true;
        },

        //编辑
        edit: function edit() {
            this.showSignature = false;
        },

        //清除
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.signature = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getMaternalMealRecordsFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this2.form.room_number = data.room_number;
                    _this2.form.mom_name = data.mom_name;
                    _this2.form.delivery_type = data.delivery_type;
                    _this2.form.cat_date = data.cat_date;
                    _this2.form.number_of_meal = data.number_of_meal;
                    _this2.form.eating_situation = data.eating_situation;
                    _this2.form.trait_common = data.trait_common;
                    _this2.form.trait_special = data.trait_special;
                    _this2.form.plan_carbohydrate = data.plan_carbohydrate;
                    _this2.form.plan_vegetables = data.plan_vegetables;
                    _this2.form.plan_fruits = data.plan_fruits;
                    _this2.form.plan_meat = data.plan_meat;
                    _this2.form.plan_birds = data.plan_birds;
                    _this2.form.plan_fish = data.plan_fish;
                    _this2.form.plan_egg = data.plan_egg;
                    _this2.form.plan_bean_products = data.plan_bean_products;
                    _this2.form.plan_milk = data.plan_milk;
                    _this2.form.plan_dairy = data.plan_dairy;
                    _this2.form.plan_oils = data.plan_oils;
                    _this2.form.plan_traditional_chinese_medicine = data.plan_traditional_chinese_medicine;
                    _this2.form.shifts = data.shifts;
                    _this2.showSignature = true;
                    _this2.$vux.loading.hide();
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room_number,
                mom_name: this.form.mom_name,
                delivery_type: this.form.delivery_type,
                cat_date: this.form.cat_date,
                number_of_meal: this.form.number_of_meal,
                eating_situation: this.form.eating_situation,
                trait_common: this.form.trait_common,
                trait_special: this.form.trait_special,
                plan_carbohydrate: this.form.plan_carbohydrate,
                plan_vegetables: this.form.plan_vegetables,
                plan_fruits: this.form.plan_fruits,
                plan_meat: this.form.plan_meat,
                plan_birds: this.form.plan_birds,
                plan_fish: this.form.plan_fish,
                plan_egg: this.form.plan_egg,
                plan_bean_products: this.form.plan_bean_products,
                plan_milk: this.form.plan_milk,
                plan_dairy: this.form.plan_dairy,
                plan_oils: this.form.plan_oils,
                plan_traditional_chinese_medicine: this.form.plan_traditional_chinese_medicine,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addMaternalMealRecordsData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this3.$vux.loading.hide();
                    _this3.$router.replace({
                        path: '/success',
                        query: {
                            id: _this3.$route.query.id,
                            form_id: _this3.$route.query.form_id,
                            tabVal: _this3.$route.query.tabVal,
                            name: 'maternal_form_b'
                        }
                    });
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this4 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room_number,
                mom_name: this.form.mom_name,
                delivery_type: this.form.delivery_type,
                cat_date: this.form.cat_date,
                number_of_meal: this.form.number_of_meal,
                eating_situation: this.form.eating_situation,
                trait_common: this.form.trait_common,
                trait_special: this.form.trait_special,
                plan_carbohydrate: this.form.plan_carbohydrate,
                plan_vegetables: this.form.plan_vegetables,
                plan_fruits: this.form.plan_fruits,
                plan_meat: this.form.plan_meat,
                plan_birds: this.form.plan_birds,
                plan_fish: this.form.plan_fish,
                plan_egg: this.form.plan_egg,
                plan_bean_products: this.form.plan_bean_products,
                plan_milk: this.form.plan_milk,
                plan_dairy: this.form.plan_dairy,
                plan_oils: this.form.plan_oils,
                plan_traditional_chinese_medicine: this.form.plan_traditional_chinese_medicine,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateMaternalMealRecordsData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'maternal_form_b'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            var form = this.form;
            if (form.room_number == '' || form.mom_name == '' || form.delivery_type == '' || form.shifts == '' || form.cat_date == '' || form.number_of_meal == '' || form.eating_situation == '' || form.trait_common == '' || form.trait_special == '' || form.plan_carbohydrate == '' || form.plan_vegetables == '' || form.plan_fruits == '' || form.plan_meat == '' || form.plan_birds == '' || form.plan_fish == '' || form.plan_egg == '' || form.plan_bean_products == '' || form.plan_milk == '' || form.plan_dairy == '' || form.plan_oils == '' || form.plan_traditional_chinese_medicine == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请完善所有表单'
                });
                return;
            }
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    },
    created: function created() {
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            this.apiMemberInfo();
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76638a18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_form_b.vue
var maternal_form_b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maternalFormB"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("产妇膳食记录表")]),_vm._v(" "),_c('div',[_c('group',{staticClass:"editContent listItem"},[_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":"","placeholder":"请输入姓名"},model:{value:(_vm.form.mom_name),callback:function ($$v) {_vm.$set(_vm.form, "mom_name", $$v)},expression:"form.mom_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","value":_vm.form.delivery_type}}),_vm._v(" "),_c('datetime',{attrs:{"title":"日期："},model:{value:(_vm.form.cat_date),callback:function ($$v) {_vm.$set(_vm.form, "cat_date", $$v)},expression:"form.cat_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"餐数：","placeholder":"请输入（单位：次）"},model:{value:(_vm.form.number_of_meal),callback:function ($$v) {_vm.$set(_vm.form, "number_of_meal", $$v)},expression:"form.number_of_meal"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"进食情况：","placeholder":"请输入"},model:{value:(_vm.form.eating_situation),callback:function ($$v) {_vm.$set(_vm.form, "eating_situation", $$v)},expression:"form.eating_situation"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"饮食特点（普通）：","placeholder":"请输入"},model:{value:(_vm.form.trait_common),callback:function ($$v) {_vm.$set(_vm.form, "trait_common", $$v)},expression:"form.trait_common"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"饮食特点（特殊）：","placeholder":"请输入"},model:{value:(_vm.form.trait_special),callback:function ($$v) {_vm.$set(_vm.form, "trait_special", $$v)},expression:"form.trait_special"}}),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：g)"},model:{value:(_vm.form.plan_carbohydrate),callback:function ($$v) {_vm.$set(_vm.form, "plan_carbohydrate", $$v)},expression:"form.plan_carbohydrate"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（碳水化合物:g）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：g)"},model:{value:(_vm.form.plan_vegetables),callback:function ($$v) {_vm.$set(_vm.form, "plan_vegetables", $$v)},expression:"form.plan_vegetables"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（蔬菜类:g）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：g)"},model:{value:(_vm.form.plan_fruits),callback:function ($$v) {_vm.$set(_vm.form, "plan_fruits", $$v)},expression:"form.plan_fruits"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（水果类:g）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：g)"},model:{value:(_vm.form.plan_meat),callback:function ($$v) {_vm.$set(_vm.form, "plan_meat", $$v)},expression:"form.plan_meat"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（肉类:g）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：g)"},model:{value:(_vm.form.plan_birds),callback:function ($$v) {_vm.$set(_vm.form, "plan_birds", $$v)},expression:"form.plan_birds"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（禽类:g）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：g)"},model:{value:(_vm.form.plan_fish),callback:function ($$v) {_vm.$set(_vm.form, "plan_fish", $$v)},expression:"form.plan_fish"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（鱼类:g）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：g) "},model:{value:(_vm.form.plan_egg),callback:function ($$v) {_vm.$set(_vm.form, "plan_egg", $$v)},expression:"form.plan_egg"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（蛋类:g）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：g)"},model:{value:(_vm.form.plan_bean_products),callback:function ($$v) {_vm.$set(_vm.form, "plan_bean_products", $$v)},expression:"form.plan_bean_products"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（豆制品类:g）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：ml)"},model:{value:(_vm.form.plan_milk),callback:function ($$v) {_vm.$set(_vm.form, "plan_milk", $$v)},expression:"form.plan_milk"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（牛奶:g）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：g)"},model:{value:(_vm.form.plan_dairy),callback:function ($$v) {_vm.$set(_vm.form, "plan_dairy", $$v)},expression:"form.plan_dairy"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（奶制品类:g）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：g)"},model:{value:(_vm.form.plan_oils),callback:function ($$v) {_vm.$set(_vm.form, "plan_oils", $$v)},expression:"form.plan_oils"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（油类:g）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：g)"},model:{value:(_vm.form.plan_traditional_chinese_medicine),callback:function ($$v) {_vm.$set(_vm.form, "plan_traditional_chinese_medicine", $$v)},expression:"form.plan_traditional_chinese_medicine"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一日营养方案（中药材:g）：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px","padding-left":"5px"}},[_vm._v("班次：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"早班"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"中班"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"晚班"}},[_vm._v("晚班")])],1)],1)]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)],1)}
var maternal_form_b_staticRenderFns = []
var maternal_form_b_esExports = { render: maternal_form_b_render, staticRenderFns: maternal_form_b_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_form_b = (maternal_form_b_esExports);
// CONCATENATED MODULE: ./src/components/maternal_form_b.vue
function maternal_form_b_injectStyle (ssrContext) {
  __webpack_require__("s8bT")
}
var maternal_form_b_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_form_b___vue_template_functional__ = false
/* styles */
var maternal_form_b___vue_styles__ = maternal_form_b_injectStyle
/* scopeId */
var maternal_form_b___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_form_b___vue_module_identifier__ = null
var maternal_form_b_Component = maternal_form_b_normalizeComponent(
  components_maternal_form_b,
  selectortype_template_index_0_src_components_maternal_form_b,
  maternal_form_b___vue_template_functional__,
  maternal_form_b___vue_styles__,
  maternal_form_b___vue_scopeId__,
  maternal_form_b___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_form_b = (maternal_form_b_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_c.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var maternal_form_c = ({
  components: {
    cfr: src_components_cfrList
  },
  name: 'maternal_form_c',
  data: function data() {
    return {
      list_id: '',
      showCfrList: false,
      showSignature: false,
      cfrText: '',
      form: {
        room_number: '',
        maternal_name: '',
        childbirth_way: '',
        day_time: '',
        ponal_days_num: '',
        coly_temperature: '',
        coly_pulse: '',
        coly_weight: '',
        resys_gdg: '',
        resys_in_codin: '1',
        resys_e_num: '1',
        resys_e_color: '1',
        resys_e_sniff: '2',
        bre_mike_num: '2',
        bre_dis_pain: '1',
        bre_rup_nipple: '1',
        guid_opons: '',
        autograph: '',
        shifts: '',
        check_id: ''
      },
      option: {
        penColor: 'rgb(0, 0, 0)'
      },
      nurser_name: [],
      get_host: host.host,
      child_birth: ''
    };
  },

  methods: {
    GetNumberOfDays: function GetNumberOfDays(date1, date2) {
      //获得天数
      //date1：开始日期，date2结束日期
      var a1 = Date.parse(new Date(date1));
      var a2 = Date.parse(new Date(date2));
      var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24)); //核心：时间戳相减，然后除以天数
      return day;
    },
    change_date: function change_date(value) {
      console.log(this.child_birth);
      this.apiMemberInfo(value);
    },

    //获取查房人列表
    apiGetCfrList: function apiGetCfrList() {
      var _this = this;

      var params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id')
      };
      Api.checkRoomApi.getCheckInfo(params).then(function (res) {
        console.info('获取查房人列表', res);
        if (res.errcode == 1) {
          _this.nurser_name = res.data.nurser_name; //过滤了离院，
          _this.apiDetail();
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //点击选择查房人
    selectPeople: function selectPeople() {
      this.showCfrList = true;
    },

    //赋值查房人ID
    cfrListEven: function cfrListEven(val, item) {
      this.showCfrList = val;
      console.info(item);
      if (item) {
        this.form.check_id = item.id;
        this.cfrText = item.user_name;
      }
    },

    //时间戳转日期格式
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },

    //请求用户基本信息
    apiMemberInfo: function apiMemberInfo(value) {
      var _this2 = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.memberInfo(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this2.form.childbirth_way = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : '';
          _this2.form.maternal_name = res.data.name;
          _this2.form.room_number = res.data.room_name;
          _this2.child_birth = _this2.formatDateTime(res.data.child_birth);
          if (value) {
            var day = _this2.GetNumberOfDays(_this2.child_birth, value) + 1;
            _this2.form.ponal_days_num = day;
          }
        } else {
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    // 保存
    save: function save() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      if (!comp || !comp.save) return;
      var png = comp.save();
      this.form.autograph = encodeURI(png);
      this.showSignature = true;
    },

    //编辑
    edit: function edit() {
      this.showSignature = false;
      this.form.autograph = '';
    },

    //清除
    clear: function clear() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.autograph = '';
    },

    //请求详情数据
    apiDetail: function apiDetail() {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token'),
        id: this.$route.query.list_id
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.bbFormApi.getMaterRehNursEvalFind(params).then(function (res) {
        console.info(res);
        if (res.errcode == 200) {
          var data = res.data;
          _this3.form.room_number = data.room_number;
          _this3.form.maternal_name = data.maternal_name;
          _this3.form.childbirth_way = data.childbirth_way;
          _this3.form.day_time = data.day_time;
          _this3.form.ponal_days_num = data.ponal_days_num;
          _this3.form.coly_temperature = data.coly_temperature;
          _this3.form.coly_pulse = data.coly_pulse;
          _this3.form.coly_weight = data.coly_weight;
          _this3.form.resys_gdg = data.resys_gdg;
          _this3.form.resys_in_codin = data.resys_in_codin;
          _this3.form.resys_e_num = data.resys_e_num;
          _this3.form.resys_e_color = data.resys_e_color;
          _this3.form.resys_e_sniff = data.resys_e_sniff;
          _this3.form.bre_mike_num = data.bre_mike_num;
          _this3.form.bre_dis_pain = data.bre_dis_pain;
          _this3.form.bre_rup_nipple = data.bre_rup_nipple;
          _this3.form.guid_opons = data.guid_opons;
          _this3.form.autograph = data.autograph.indexOf(_this3.get_host) != -1 ? data.autograph : _this3.get_host + data.autograph;
          _this3.form.shifts = data.shifts;
          _this3.form.check_id = data.check_id;
          _this3.showSignature = true;
          _this3.$vux.loading.hide();
          if (_this3.nurser_name.length) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = get_iterator_default()(_this3.nurser_name), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (item.id == data.check_id) {
                  _this3.cfrText = item.user_name;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求添加数据
    apiAddForm: function apiAddForm() {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        number_id: this.$cookie.get('id'),
        maternal_info_id: this.$route.query.id,
        store_id: this.$cookie.get('store_id'),
        room_number: this.form.room_number,
        maternal_name: this.form.maternal_name,
        childbirth_way: this.form.childbirth_way,
        day_time: this.form.day_time,
        ponal_days_num: this.form.ponal_days_num,
        coly_temperature: this.form.coly_temperature,
        coly_pulse: this.form.coly_pulse,
        coly_weight: this.form.coly_weight,
        resys_gdg: this.form.resys_gdg,
        resys_in_codin: this.form.resys_in_codin,
        resys_e_num: this.form.resys_e_num,
        resys_e_color: this.form.resys_e_color,
        resys_e_sniff: this.form.resys_e_sniff,
        bre_mike_num: this.form.bre_mike_num,
        bre_dis_pain: this.form.bre_dis_pain,
        bre_rup_nipple: this.form.bre_rup_nipple,
        guid_opons: this.form.guid_opons,
        autograph: this.form.autograph,
        shifts: this.form.shifts,
        check_id: this.form.check_id
      };
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.bbFormApi.addMaterRehNursEvalData(params).then(function (res) {
        console.info(res);
        if (res.errcode == 200) {
          _this4.$vux.loading.hide();
          _this4.$router.replace({
            path: '/success',
            query: {
              id: _this4.$route.query.id,
              form_id: _this4.$route.query.form_id,
              tabVal: _this4.$route.query.tabVal,
              name: 'maternal_form_c'
            }
          });
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    // 请求更新数据
    apiUpdateForm: function apiUpdateForm() {
      var _this5 = this;

      var params = {
        token: this.$cookie.get('token'),
        id: this.$route.query.list_id,
        number_id: this.$cookie.get('id'),
        maternal_info_id: this.$route.query.id,
        store_id: this.$cookie.get('store_id'),
        room_number: this.form.room_number,
        maternal_name: this.form.maternal_name,
        childbirth_way: this.form.childbirth_way,
        day_time: this.form.day_time,
        ponal_days_num: this.form.ponal_days_num,
        coly_temperature: this.form.coly_temperature,
        coly_pulse: this.form.coly_pulse,
        coly_weight: this.form.coly_weight,
        resys_gdg: this.form.resys_gdg,
        resys_in_codin: this.form.resys_in_codin,
        resys_e_num: this.form.resys_e_num,
        resys_e_color: this.form.resys_e_color,
        resys_e_sniff: this.form.resys_e_sniff,
        bre_mike_num: this.form.bre_mike_num,
        bre_dis_pain: this.form.bre_dis_pain,
        bre_rup_nipple: this.form.bre_rup_nipple,
        guid_opons: this.form.guid_opons,
        autograph: this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host, '') : this.form.autograph,
        shifts: this.form.shifts,
        check_id: this.form.check_id
      };
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.bbFormApi.updateMaterRehNursEvalData(params).then(function (res) {
        console.info(res);
        if (res.errcode == 200) {
          _this5.$vux.loading.hide();
          _this5.$router.replace({
            path: '/success',
            query: {
              id: _this5.$route.query.id,
              form_id: _this5.$route.query.form_id,
              tabVal: _this5.$route.query.tabVal,
              name: 'maternal_form_c'
            }
          });
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    submitForm: function submitForm() {
      var form = this.form;
      console.log(form);
      if (form.room_number == '' || form.maternal_name == '' || form.check_id == '' || form.shifts == '' || form.childbirth_way == '' || form.day_time == '' || form.ponal_days_num == '' || form.coly_temperature == '' || form.coly_pulse == '' || form.coly_weight == '' || form.resys_gdg == '' || form.resys_in_codin == '' || form.resys_e_num == '' || form.resys_e_color == '' || form.resys_e_sniff == '' || form.bre_mike_num == '' || form.bre_dis_pain == '' || form.bre_rup_nipple == '' || form.guid_opons == '' || form.autograph == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请完善所有表单'
        });
        return;
      }
      if (this.$route.query.list_id) {
        console.info('请求更新数据');
        this.apiUpdateForm();
      } else {
        console.info('请求添加数据');
        this.apiAddForm();
      }
    }
  },
  created: function created() {
    this.apiMemberInfo();
    if (this.$route.query.list_id) {
      this.apiGetCfrList();
      this.list_id = this.$route.query.list_id;
    } else {
      this.list_id = '';
      this.form.guid_opons = '母乳喂养、母婴同室';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_c.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_maternal_form_c = ({
  components: {
    cfr: src_components_cfrList
  },
  name: 'maternal_form_c',
  data: function data() {
    return {
      list_id: '',
      showCfrList: false,
      showSignature: false,
      cfrText: '',
      form: {
        room_number: '',
        maternal_name: '',
        childbirth_way: '',
        day_time: '',
        ponal_days_num: '',
        coly_temperature: '',
        coly_pulse: '',
        coly_weight: '',
        resys_gdg: '',
        resys_in_codin: '1',
        resys_e_num: '1',
        resys_e_color: '1',
        resys_e_sniff: '2',
        bre_mike_num: '2',
        bre_dis_pain: '1',
        bre_rup_nipple: '1',
        guid_opons: '',
        autograph: '',
        shifts: '',
        check_id: ''
      },
      option: {
        penColor: 'rgb(0, 0, 0)'
      },
      nurser_name: [],
      get_host: host.host,
      child_birth: ''
    };
  },

  methods: {
    GetNumberOfDays: function GetNumberOfDays(date1, date2) {
      //获得天数
      //date1：开始日期，date2结束日期
      var a1 = Date.parse(new Date(date1));
      var a2 = Date.parse(new Date(date2));
      var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24)); //核心：时间戳相减，然后除以天数
      return day;
    },
    change_date: function change_date(value) {
      console.log(this.child_birth);
      this.apiMemberInfo(value);
    },

    //获取查房人列表
    apiGetCfrList: function apiGetCfrList() {
      var _this = this;

      var params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id')
      };
      Api.checkRoomApi.getCheckInfo(params).then(function (res) {
        console.info('获取查房人列表', res);
        if (res.errcode == 1) {
          _this.nurser_name = res.data.nurser_name; //过滤了离院，
          _this.apiDetail();
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //点击选择查房人
    selectPeople: function selectPeople() {
      this.showCfrList = true;
    },

    //赋值查房人ID
    cfrListEven: function cfrListEven(val, item) {
      this.showCfrList = val;
      console.info(item);
      if (item) {
        this.form.check_id = item.id;
        this.cfrText = item.user_name;
      }
    },

    //时间戳转日期格式
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },

    //请求用户基本信息
    apiMemberInfo: function apiMemberInfo(value) {
      var _this2 = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.memberInfo(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this2.form.childbirth_way = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : '';
          _this2.form.maternal_name = res.data.name;
          _this2.form.room_number = res.data.room_name;
          _this2.child_birth = _this2.formatDateTime(res.data.child_birth);
          if (value) {
            var day = _this2.GetNumberOfDays(_this2.child_birth, value) + 1;
            _this2.form.ponal_days_num = day;
          }
        } else {
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    // 保存
    save: function save() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
      if (!comp || !comp.save) return;
      var png = comp.save();
      this.form.autograph = encodeURI(png);
      this.showSignature = true;
    },

    //编辑
    edit: function edit() {
      this.showSignature = false;
      this.form.autograph = '';
    },

    //清除
    clear: function clear() {
      var signature = 'signature1';
      var sigRef = this.$refs[signature];
      if (Array.isArray(sigRef)) {
        sigRef.forEach(function (c) {
          return c && c.clear && c.clear();
        });
      } else if (sigRef && sigRef.clear) {
        sigRef.clear();
      }
      this.form.autograph = '';
    },

    //请求详情数据
    apiDetail: function apiDetail() {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token'),
        id: this.$route.query.list_id
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.bbFormApi.getMaterRehNursEvalFind(params).then(function (res) {
        console.info(res);
        if (res.errcode == 200) {
          var data = res.data;
          _this3.form.room_number = data.room_number;
          _this3.form.maternal_name = data.maternal_name;
          _this3.form.childbirth_way = data.childbirth_way;
          _this3.form.day_time = data.day_time;
          _this3.form.ponal_days_num = data.ponal_days_num;
          _this3.form.coly_temperature = data.coly_temperature;
          _this3.form.coly_pulse = data.coly_pulse;
          _this3.form.coly_weight = data.coly_weight;
          _this3.form.resys_gdg = data.resys_gdg;
          _this3.form.resys_in_codin = data.resys_in_codin;
          _this3.form.resys_e_num = data.resys_e_num;
          _this3.form.resys_e_color = data.resys_e_color;
          _this3.form.resys_e_sniff = data.resys_e_sniff;
          _this3.form.bre_mike_num = data.bre_mike_num;
          _this3.form.bre_dis_pain = data.bre_dis_pain;
          _this3.form.bre_rup_nipple = data.bre_rup_nipple;
          _this3.form.guid_opons = data.guid_opons;
          _this3.form.autograph = data.autograph.indexOf(_this3.get_host) != -1 ? data.autograph : _this3.get_host + data.autograph;
          _this3.form.shifts = data.shifts;
          _this3.form.check_id = data.check_id;
          _this3.showSignature = true;
          _this3.$vux.loading.hide();
          if (_this3.nurser_name.length) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = get_iterator_default()(_this3.nurser_name), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (item.id == data.check_id) {
                  _this3.cfrText = item.user_name;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    //请求添加数据
    apiAddForm: function apiAddForm() {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        number_id: this.$cookie.get('id'),
        maternal_info_id: this.$route.query.id,
        store_id: this.$cookie.get('store_id'),
        room_number: this.form.room_number,
        maternal_name: this.form.maternal_name,
        childbirth_way: this.form.childbirth_way,
        day_time: this.form.day_time,
        ponal_days_num: this.form.ponal_days_num,
        coly_temperature: this.form.coly_temperature,
        coly_pulse: this.form.coly_pulse,
        coly_weight: this.form.coly_weight,
        resys_gdg: this.form.resys_gdg,
        resys_in_codin: this.form.resys_in_codin,
        resys_e_num: this.form.resys_e_num,
        resys_e_color: this.form.resys_e_color,
        resys_e_sniff: this.form.resys_e_sniff,
        bre_mike_num: this.form.bre_mike_num,
        bre_dis_pain: this.form.bre_dis_pain,
        bre_rup_nipple: this.form.bre_rup_nipple,
        guid_opons: this.form.guid_opons,
        autograph: this.form.autograph,
        shifts: this.form.shifts,
        check_id: this.form.check_id
      };
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.bbFormApi.addMaterRehNursEvalData(params).then(function (res) {
        console.info(res);
        if (res.errcode == 200) {
          _this4.$vux.loading.hide();
          _this4.$router.replace({
            path: '/success',
            query: {
              id: _this4.$route.query.id,
              form_id: _this4.$route.query.form_id,
              tabVal: _this4.$route.query.tabVal,
              name: 'maternal_form_c'
            }
          });
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },

    // 请求更新数据
    apiUpdateForm: function apiUpdateForm() {
      var _this5 = this;

      var params = {
        token: this.$cookie.get('token'),
        id: this.$route.query.list_id,
        number_id: this.$cookie.get('id'),
        maternal_info_id: this.$route.query.id,
        store_id: this.$cookie.get('store_id'),
        room_number: this.form.room_number,
        maternal_name: this.form.maternal_name,
        childbirth_way: this.form.childbirth_way,
        day_time: this.form.day_time,
        ponal_days_num: this.form.ponal_days_num,
        coly_temperature: this.form.coly_temperature,
        coly_pulse: this.form.coly_pulse,
        coly_weight: this.form.coly_weight,
        resys_gdg: this.form.resys_gdg,
        resys_in_codin: this.form.resys_in_codin,
        resys_e_num: this.form.resys_e_num,
        resys_e_color: this.form.resys_e_color,
        resys_e_sniff: this.form.resys_e_sniff,
        bre_mike_num: this.form.bre_mike_num,
        bre_dis_pain: this.form.bre_dis_pain,
        bre_rup_nipple: this.form.bre_rup_nipple,
        guid_opons: this.form.guid_opons,
        autograph: this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host, '') : this.form.autograph,
        shifts: this.form.shifts,
        check_id: this.form.check_id
      };
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.bbFormApi.updateMaterRehNursEvalData(params).then(function (res) {
        console.info(res);
        if (res.errcode == 200) {
          _this5.$vux.loading.hide();
          _this5.$router.replace({
            path: '/success',
            query: {
              id: _this5.$route.query.id,
              form_id: _this5.$route.query.form_id,
              tabVal: _this5.$route.query.tabVal,
              name: 'maternal_form_c'
            }
          });
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    submitForm: function submitForm() {
      var form = this.form;
      console.log(form);
      if (form.room_number == '' || form.maternal_name == '' || form.check_id == '' || form.shifts == '' || form.childbirth_way == '' || form.day_time == '' || form.ponal_days_num == '' || form.coly_temperature == '' || form.coly_pulse == '' || form.coly_weight == '' || form.resys_gdg == '' || form.resys_in_codin == '' || form.resys_e_num == '' || form.resys_e_color == '' || form.resys_e_sniff == '' || form.bre_mike_num == '' || form.bre_dis_pain == '' || form.bre_rup_nipple == '' || form.guid_opons == '' || form.autograph == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请完善所有表单'
        });
        return;
      }
      if (this.$route.query.list_id) {
        console.info('请求更新数据');
        this.apiUpdateForm();
      } else {
        console.info('请求添加数据');
        this.apiAddForm();
      }
    }
  },
  created: function created() {
    this.apiMemberInfo();
    if (this.$route.query.list_id) {
      this.apiGetCfrList();
      this.list_id = this.$route.query.list_id;
    } else {
      this.list_id = '';
      this.form.guid_opons = '母乳喂养、母婴同室';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ef20be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_form_c.vue
var maternal_form_c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maternalFormC"},[_c('x-header',{attrs:{"left-options":{ showBack: true }}},[_vm._v("产妇康复护理评估记录单")]),_vm._v(" "),_c('div',[_c('group',{staticClass:"editContent listCom"},[_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":"","placeholder":"请输入姓名"},model:{value:(_vm.form.maternal_name),callback:function ($$v) {_vm.$set(_vm.form, "maternal_name", $$v)},expression:"form.maternal_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","value":_vm.form.childbirth_way}}),_vm._v(" "),_c('datetime',{attrs:{"title":"日期："},on:{"on-change":_vm.change_date},model:{value:(_vm.form.day_time),callback:function ($$v) {_vm.$set(_vm.form, "day_time", $$v)},expression:"form.day_time"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"产后天数(天)：","disabled":""},model:{value:(_vm.form.ponal_days_num),callback:function ($$v) {_vm.$set(_vm.form, "ponal_days_num", $$v)},expression:"form.ponal_days_num"}}),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：℃)"},model:{value:(_vm.form.coly_temperature),callback:function ($$v) {_vm.$set(_vm.form, "coly_temperature", $$v)},expression:"form.coly_temperature"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一般情况（体温:℃）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：次/分)"},model:{value:(_vm.form.coly_pulse),callback:function ($$v) {_vm.$set(_vm.form, "coly_pulse", $$v)},expression:"form.coly_pulse"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一般情况（脉搏:次/分）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入(单位：kg)"},model:{value:(_vm.form.coly_weight),callback:function ($$v) {_vm.$set(_vm.form, "coly_weight", $$v)},expression:"form.coly_weight"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("一般情况（体重:kg）：")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.resys_gdg),callback:function ($$v) {_vm.$set(_vm.form, "resys_gdg", $$v)},expression:"form.resys_gdg"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("生殖系统（宫底高）：")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"5px"}},[_vm._v("\n          生殖系统（切口情况）：\n        ")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"flex":"none"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.resys_in_codin),callback:function ($$v) {_vm.$set(_vm.form, "resys_in_codin", $$v)},expression:"form.resys_in_codin"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("不良")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("其他")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","padding-left":"10px","color":"#999"}},[_vm._v("\n          "+_vm._s(_vm.form.resys_in_codin == '1'
              ? '良好'
              : _vm.form.resys_in_codin == '2'
              ? '不良'
              : _vm.form.resys_in_codin == '3'
              ? '其他'
              : _vm.form.resys_in_codin)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"5px"}},[_vm._v("\n          生殖系统（恶露）（量）：\n        ")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"flex":"none"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.resys_e_num),callback:function ($$v) {_vm.$set(_vm.form, "resys_e_num", $$v)},expression:"form.resys_e_num"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("少")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("中")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("多")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("正常")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","padding-left":"10px","color":"#999"}},[_vm._v("\n          "+_vm._s(_vm.form.resys_e_num == '1'
              ? '少'
              : _vm.form.resys_e_num == '2'
              ? '中'
              : _vm.form.resys_e_num == '3'
              ? '多'
              : _vm.form.resys_e_num == '5'
              ? '正常'
              : _vm.form.resys_e_num == '4'
              ? '无'
              : _vm.form.resys_e_num)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"5px"}},[_vm._v("\n          生殖系统（恶露）（色）：\n        ")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"flex":"none"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.resys_e_color),callback:function ($$v) {_vm.$set(_vm.form, "resys_e_color", $$v)},expression:"form.resys_e_color"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("暗红")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("鲜红")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("白色")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("正常")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","padding-left":"10px","color":"#999"}},[_vm._v("\n          "+_vm._s(_vm.form.resys_e_color == '1'
              ? '暗红'
              : _vm.form.resys_e_color == '2'
              ? '鲜红'
              : _vm.form.resys_e_color == '3'
              ? '白色'
              : _vm.form.resys_e_color == '4'
              ? '无'
              : _vm.form.resys_e_color == '5'
              ? '正常'
              : _vm.form.resys_e_color)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"5px"}},[_vm._v("\n          生殖系统（恶露）（嗅）：\n        ")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"flex":"none"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.resys_e_sniff),callback:function ($$v) {_vm.$set(_vm.form, "resys_e_sniff", $$v)},expression:"form.resys_e_sniff"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","padding-left":"10px","color":"#999"}},[_vm._v("\n          "+_vm._s(_vm.form.resys_e_sniff == '1'
              ? '有'
              : _vm.form.resys_e_sniff == '2'
              ? '无'
              : _vm.form.resys_e_sniff)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"5px"}},[_vm._v("乳房（乳汁量）：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"flex":"none"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.bre_mike_num),callback:function ($$v) {_vm.$set(_vm.form, "bre_mike_num", $$v)},expression:"form.bre_mike_num"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("多")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("中")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("少")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("回奶")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","padding-left":"10px","color":"#999"}},[_vm._v("\n          "+_vm._s(_vm.form.bre_mike_num == '1'
              ? '多'
              : _vm.form.bre_mike_num == '2'
              ? '中'
              : _vm.form.bre_mike_num == '3'
              ? '少'
              : _vm.form.bre_mike_num == '4'
              ? '回奶'
              : _vm.form.bre_mike_num)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"5px"}},[_vm._v("乳房（胀痛）：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"flex":"none"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.bre_dis_pain),callback:function ($$v) {_vm.$set(_vm.form, "bre_dis_pain", $$v)},expression:"form.bre_dis_pain"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("左侧")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("右侧")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("双侧")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","padding-left":"10px","color":"#999"}},[_vm._v("\n          "+_vm._s(_vm.form.bre_dis_pain == '1'
              ? '无'
              : _vm.form.bre_dis_pain == '2'
              ? '左侧'
              : _vm.form.bre_dis_pain == '3'
              ? '右侧'
              : _vm.form.bre_dis_pain == '4'
              ? '双侧'
              : _vm.form.bre_dis_pain)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"5px"}},[_vm._v("乳房（乳头皲裂）：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"flex":"none"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.bre_rup_nipple),callback:function ($$v) {_vm.$set(_vm.form, "bre_rup_nipple", $$v)},expression:"form.bre_rup_nipple"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("左侧")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("右侧")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("双侧")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","padding-left":"10px","color":"#999"}},[_vm._v("\n          "+_vm._s(_vm.form.bre_rup_nipple == '1'
              ? '无'
              : _vm.form.bre_rup_nipple == '2'
              ? '左侧'
              : _vm.form.bre_rup_nipple == '3'
              ? '右侧'
              : _vm.form.bre_rup_nipple == '4'
              ? '双侧'
              : _vm.form.bre_dis_pain)+"\n        ")])]),_vm._v(" "),_c('x-input',{attrs:{"placeholder":"请输入"},model:{value:(_vm.form.guid_opons),callback:function ($$v) {_vm.$set(_vm.form, "guid_opons", $$v)},expression:"form.guid_opons"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("指导意见：")])]),_vm._v(" "),_c('div',{staticClass:"listCom"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"5px"}},[_vm._v("签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.autograph)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.autograph,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listCom"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"5px"}},[_vm._v("班次：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"早班"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"中班"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"晚班"}},[_vm._v("晚班")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listCom"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"0","padding-left":"5px"}},[_vm._v("\n            查房人：\n          ")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n            "+_vm._s(_vm.cfrText)+"\n            "),_c('x-button',{attrs:{"gradients":['#2d8cf0', '#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople.apply(null, arguments)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('cfr',{attrs:{"list_id":_vm.list_id,"showCfrList":_vm.showCfrList},on:{"cfrListEven":_vm.cfrListEven}})],1),_vm._v(" "),_c('x-textarea',{attrs:{"title":"注：","disabled":"","value":"1、体温、脉搏应每日测量一次，三天均正常后为每周监测，异常者每日监测。2、评估切口愈合情况，如有异常及时就医，指导会阴清洁，如有感染常规护理。3、做好个人卫生及卫生宣教。4、24小时母婴同室，母婴分离时间每天不超过1小时/24小时，鼓励按需哺乳。5、做好乳房护理。6、产后个性化的运动康复"}}),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0', '#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)],1)}
var maternal_form_c_staticRenderFns = []
var maternal_form_c_esExports = { render: maternal_form_c_render, staticRenderFns: maternal_form_c_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_form_c = (maternal_form_c_esExports);
// CONCATENATED MODULE: ./src/components/maternal_form_c.vue
function maternal_form_c_injectStyle (ssrContext) {
  __webpack_require__("MFbL")
}
var maternal_form_c_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_form_c___vue_template_functional__ = false
/* styles */
var maternal_form_c___vue_styles__ = maternal_form_c_injectStyle
/* scopeId */
var maternal_form_c___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_form_c___vue_module_identifier__ = null
var maternal_form_c_Component = maternal_form_c_normalizeComponent(
  components_maternal_form_c,
  selectortype_template_index_0_src_components_maternal_form_c,
  maternal_form_c___vue_template_functional__,
  maternal_form_c___vue_styles__,
  maternal_form_c___vue_scopeId__,
  maternal_form_c___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_form_c = (maternal_form_c_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_d.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var maternal_form_d = ({
    name: 'maternal_form_d',
    data: function data() {
        return {
            showSignature: false,
            form: {
                room_number: '',
                mom_name: '',
                delivery_type: '',
                cat_date: '',
                diet: '',
                // diet_ordinary:'',
                // diet_special:'',
                sleep_time: '8',
                urine_num: '6',
                shit_num: '1',
                wash_brush: '3',
                wash_hair: '0',
                wash_bath: '1',
                wash_clean: '3',
                sport_time: '20',
                // sport_assess:'',
                sport: '1',
                sport_text: '',
                // other_case:'',
                guiding_pinions: '',
                autograph: '',
                shifts: ''
            },
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            get_host: host.host
        };
    },

    methods: {
        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info('请求用户基本信息', res);
                if (res.errcode == 1) {
                    _this.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : '';
                    _this.form.mom_name = res.data.name;
                    _this.form.room_number = res.data.room_name;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 保存
        save: function save() {
            var signature = 'signature1';
            var png = this.$refs[signature].save();
            this.form.autograph = encodeURI(png);
            this.showSignature = true;
        },

        //编辑
        edit: function edit() {
            this.showSignature = false;
            this.form.autograph = '';
        },

        //清除
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.autograph = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getMaternalEverydayPhysiologyFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this2.form.room_number = data.room_number;
                    _this2.form.mom_name = data.mom_name;
                    _this2.form.delivery_type = data.delivery_type;
                    _this2.form.cat_date = data.cat_date;
                    _this2.form.diet = data.diet;
                    // this.form.diet_ordinary = data.diet_ordinary
                    // this.form.diet_special = data.diet_special
                    _this2.form.sleep_time = data.sleep_time;
                    _this2.form.urine_num = data.urine_num;
                    _this2.form.shit_num = data.shit_num;
                    _this2.form.wash_brush = data.wash_brush;
                    _this2.form.wash_hair = data.wash_hair;
                    _this2.form.wash_bath = data.wash_bath;
                    _this2.form.wash_clean = data.wash_clean;
                    _this2.form.sport_time = data.sport_time;
                    // this.form.sport_assess = data.sport_assess
                    _this2.form.sport = data.sport;
                    _this2.form.sport_text = data.sport_text;
                    // this.form.other_case = data.other_case
                    _this2.form.guiding_pinions = data.guiding_pinions;
                    _this2.form.autograph = data.autograph.indexOf(_this2.get_host) != -1 ? data.autograph : _this2.get_host + data.autograph;
                    _this2.form.shifts = data.shifts;
                    _this2.showSignature = true;
                    _this2.$vux.loading.hide();
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room_number,
                mom_name: this.form.mom_name,
                delivery_type: this.form.delivery_type,
                cat_date: this.form.cat_date,
                diet: this.form.diet,
                // diet_ordinary:this.form.diet_ordinary,
                // diet_special:this.form.diet_special,
                sleep_time: this.form.sleep_time,
                urine_num: this.form.urine_num,
                shit_num: this.form.shit_num,
                wash_brush: this.form.wash_brush,
                wash_hair: this.form.wash_hair,
                wash_bath: this.form.wash_bath,
                wash_clean: this.form.wash_clean,
                sport_time: this.form.sport_time,
                // sport_assess:this.form.sport_assess,
                sport: this.form.sport,
                sport_text: this.form.sport_text,
                // other_case:this.form.other_case,
                guiding_pinions: this.form.guiding_pinions,
                autograph: this.form.autograph,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addMaternalEverydayPhysiology(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this3.$vux.loading.hide();
                    _this3.$router.replace({
                        path: '/success',
                        query: {
                            id: _this3.$route.query.id,
                            form_id: _this3.$route.query.form_id,
                            tabVal: _this3.$route.query.tabVal,
                            name: 'maternal_form_d'
                        }
                    });
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this4 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room_number,
                mom_name: this.form.mom_name,
                delivery_type: this.form.delivery_type,
                cat_date: this.form.cat_date,
                diet: this.form.diet,
                sleep_time: this.form.sleep_time,
                urine_num: this.form.urine_num,
                shit_num: this.form.shit_num,
                wash_brush: this.form.wash_brush,
                wash_hair: this.form.wash_hair,
                wash_bath: this.form.wash_bath,
                wash_clean: this.form.wash_clean,
                sport_time: this.form.sport_time,
                // sport_assess:this.form.sport_assess,
                sport: this.form.sport,
                sport_text: this.form.sport_text,
                // other_case:this.form.other_case,
                guiding_pinions: this.form.guiding_pinions,
                autograph: this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host, '') : this.form.autograph,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateMaternalEverydayPhysiology(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'maternal_form_d'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            var form = this.form;
            if (form.delivery_type == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择分娩方式'
                });
                return;
            }
            if (form.cat_date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择日期'
                });
                return;
            }
            if (form.diet == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择饮食'
                });
                return;
            }
            if (form.sleep_time == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入睡眠'
                });
                return;
            }
            if (form.urine_num == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入小便'
                });
                return;
            }
            if (form.shit_num == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便'
                });
                return;
            }
            if (form.wash_brush == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入刷牙'
                });
                return;
            }
            if (form.wash_hair == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入洗头'
                });
                return;
            }
            if (form.wash_bath == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入沐浴'
                });
                return;
            }
            if (form.wash_clean == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入会阴清洁'
                });
                return;
            }
            if (form.sport_time == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入运动时间'
                });
                return;
            }
            if (form.sport == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择运动后评估'
                });
                return;
            }
            if (form.guiding_pinions == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入指导意见'
                });
                return;
            }
            if (form.autograph == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入签名'
                });
                return;
            }
            if (form.shifts == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择班次'
                });
                return;
            }

            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    },
    mounted: function mounted() {
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            this.apiMemberInfo();
            this.form.guiding_pinions = '母乳喂养、母婴同室';
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/maternal_form_d.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_maternal_form_d = ({
    name: 'maternal_form_d',
    data: function data() {
        return {
            showSignature: false,
            form: {
                room_number: '',
                mom_name: '',
                delivery_type: '',
                cat_date: '',
                diet: '',
                // diet_ordinary:'',
                // diet_special:'',
                sleep_time: '8',
                urine_num: '6',
                shit_num: '1',
                wash_brush: '3',
                wash_hair: '0',
                wash_bath: '1',
                wash_clean: '3',
                sport_time: '20',
                // sport_assess:'',
                sport: '1',
                sport_text: '',
                // other_case:'',
                guiding_pinions: '',
                autograph: '',
                shifts: ''
            },
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            get_host: host.host
        };
    },

    methods: {
        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info('请求用户基本信息', res);
                if (res.errcode == 1) {
                    _this.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : '';
                    _this.form.mom_name = res.data.name;
                    _this.form.room_number = res.data.room_name;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 保存
        save: function save() {
            var signature = 'signature1';
            var png = this.$refs[signature].save();
            this.form.autograph = encodeURI(png);
            this.showSignature = true;
        },

        //编辑
        edit: function edit() {
            this.showSignature = false;
            this.form.autograph = '';
        },

        //清除
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.autograph = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getMaternalEverydayPhysiologyFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this2.form.room_number = data.room_number;
                    _this2.form.mom_name = data.mom_name;
                    _this2.form.delivery_type = data.delivery_type;
                    _this2.form.cat_date = data.cat_date;
                    _this2.form.diet = data.diet;
                    // this.form.diet_ordinary = data.diet_ordinary
                    // this.form.diet_special = data.diet_special
                    _this2.form.sleep_time = data.sleep_time;
                    _this2.form.urine_num = data.urine_num;
                    _this2.form.shit_num = data.shit_num;
                    _this2.form.wash_brush = data.wash_brush;
                    _this2.form.wash_hair = data.wash_hair;
                    _this2.form.wash_bath = data.wash_bath;
                    _this2.form.wash_clean = data.wash_clean;
                    _this2.form.sport_time = data.sport_time;
                    // this.form.sport_assess = data.sport_assess
                    _this2.form.sport = data.sport;
                    _this2.form.sport_text = data.sport_text;
                    // this.form.other_case = data.other_case
                    _this2.form.guiding_pinions = data.guiding_pinions;
                    _this2.form.autograph = data.autograph.indexOf(_this2.get_host) != -1 ? data.autograph : _this2.get_host + data.autograph;
                    _this2.form.shifts = data.shifts;
                    _this2.showSignature = true;
                    _this2.$vux.loading.hide();
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room_number,
                mom_name: this.form.mom_name,
                delivery_type: this.form.delivery_type,
                cat_date: this.form.cat_date,
                diet: this.form.diet,
                // diet_ordinary:this.form.diet_ordinary,
                // diet_special:this.form.diet_special,
                sleep_time: this.form.sleep_time,
                urine_num: this.form.urine_num,
                shit_num: this.form.shit_num,
                wash_brush: this.form.wash_brush,
                wash_hair: this.form.wash_hair,
                wash_bath: this.form.wash_bath,
                wash_clean: this.form.wash_clean,
                sport_time: this.form.sport_time,
                // sport_assess:this.form.sport_assess,
                sport: this.form.sport,
                sport_text: this.form.sport_text,
                // other_case:this.form.other_case,
                guiding_pinions: this.form.guiding_pinions,
                autograph: this.form.autograph,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addMaternalEverydayPhysiology(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this3.$vux.loading.hide();
                    _this3.$router.replace({
                        path: '/success',
                        query: {
                            id: _this3.$route.query.id,
                            form_id: _this3.$route.query.form_id,
                            tabVal: _this3.$route.query.tabVal,
                            name: 'maternal_form_d'
                        }
                    });
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this4 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room_number,
                mom_name: this.form.mom_name,
                delivery_type: this.form.delivery_type,
                cat_date: this.form.cat_date,
                diet: this.form.diet,
                sleep_time: this.form.sleep_time,
                urine_num: this.form.urine_num,
                shit_num: this.form.shit_num,
                wash_brush: this.form.wash_brush,
                wash_hair: this.form.wash_hair,
                wash_bath: this.form.wash_bath,
                wash_clean: this.form.wash_clean,
                sport_time: this.form.sport_time,
                // sport_assess:this.form.sport_assess,
                sport: this.form.sport,
                sport_text: this.form.sport_text,
                // other_case:this.form.other_case,
                guiding_pinions: this.form.guiding_pinions,
                autograph: this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host, '') : this.form.autograph,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateMaternalEverydayPhysiology(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'maternal_form_d'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            var form = this.form;
            if (form.delivery_type == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择分娩方式'
                });
                return;
            }
            if (form.cat_date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择日期'
                });
                return;
            }
            if (form.diet == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择饮食'
                });
                return;
            }
            if (form.sleep_time == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入睡眠'
                });
                return;
            }
            if (form.urine_num == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入小便'
                });
                return;
            }
            if (form.shit_num == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便'
                });
                return;
            }
            if (form.wash_brush == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入刷牙'
                });
                return;
            }
            if (form.wash_hair == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入洗头'
                });
                return;
            }
            if (form.wash_bath == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入沐浴'
                });
                return;
            }
            if (form.wash_clean == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入会阴清洁'
                });
                return;
            }
            if (form.sport_time == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入运动时间'
                });
                return;
            }
            if (form.sport == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择运动后评估'
                });
                return;
            }
            if (form.guiding_pinions == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入指导意见'
                });
                return;
            }
            if (form.autograph == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入签名'
                });
                return;
            }
            if (form.shifts == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择班次'
                });
                return;
            }

            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    },
    mounted: function mounted() {
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            this.apiMemberInfo();
            this.form.guiding_pinions = '母乳喂养、母婴同室';
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0afe37a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/maternal_form_d.vue
var maternal_form_d_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maternalFormD"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("产妇每日生理护理记录表")]),_vm._v(" "),_c('div',[_c('group',{staticClass:"editContent listItem"},[_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号","value":_vm.form.room_number}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":"","placeholder":"请输入姓名","value":_vm.form.mom_name}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","value":_vm.form.delivery_type}}),_vm._v(" "),_c('datetime',{attrs:{"title":"日期："},model:{value:(_vm.form.cat_date),callback:function ($$v) {_vm.$set(_vm.form, "cat_date", $$v)},expression:"form.cat_date"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("饮食：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.diet),callback:function ($$v) {_vm.$set(_vm.form, "diet", $$v)},expression:"form.diet"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("普通")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("特殊")])],1)],1)]),_vm._v(" "),_c('x-input',{attrs:{"title":"睡眠：","placeholder":"请输入(单位：小时)"},model:{value:(_vm.form.sleep_time),callback:function ($$v) {_vm.$set(_vm.form, "sleep_time", $$v)},expression:"form.sleep_time"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"小便：","placeholder":"请输入(单位：次)"},model:{value:(_vm.form.urine_num),callback:function ($$v) {_vm.$set(_vm.form, "urine_num", $$v)},expression:"form.urine_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"大便：","placeholder":"请输入(单位：次)"},model:{value:(_vm.form.shit_num),callback:function ($$v) {_vm.$set(_vm.form, "shit_num", $$v)},expression:"form.shit_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"盥洗（刷牙）：","placeholder":"请输入(单位：次)"},model:{value:(_vm.form.wash_brush),callback:function ($$v) {_vm.$set(_vm.form, "wash_brush", $$v)},expression:"form.wash_brush"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"盥洗（洗头）：","placeholder":"请输入(单位：次)"},model:{value:(_vm.form.wash_hair),callback:function ($$v) {_vm.$set(_vm.form, "wash_hair", $$v)},expression:"form.wash_hair"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"盥洗（沐浴）：","placeholder":"请输入(单位：次)"},model:{value:(_vm.form.wash_bath),callback:function ($$v) {_vm.$set(_vm.form, "wash_bath", $$v)},expression:"form.wash_bath"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"盥洗（会阴清洗）：","placeholder":"请输入(单位：次)"},model:{value:(_vm.form.wash_clean),callback:function ($$v) {_vm.$set(_vm.form, "wash_clean", $$v)},expression:"form.wash_clean"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"运动（时间）：","placeholder":"请输入（单位：分钟）"},model:{value:(_vm.form.sport_time),callback:function ($$v) {_vm.$set(_vm.form, "sport_time", $$v)},expression:"form.sport_time"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("运动（运动后评估）：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.sport),callback:function ($$v) {_vm.$set(_vm.form, "sport", $$v)},expression:"form.sport"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("舒适")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("较累")])],1)],1),_vm._v(" "),_c('x-input',{staticClass:"sportDesx",attrs:{"title":"","placeholder":"请描述"},model:{value:(_vm.form.sport_text),callback:function ($$v) {_vm.$set(_vm.form, "sport_text", $$v)},expression:"form.sport_text"}})],1),_vm._v(" "),_c('x-textarea',{attrs:{"title":"指导意见：","placeholder":"请输入指导意见"},model:{value:(_vm.form.guiding_pinions),callback:function ($$v) {_vm.$set(_vm.form, "guiding_pinions", $$v)},expression:"form.guiding_pinions"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.autograph)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.autograph,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("班次：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"早班"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"中班"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"晚班"}},[_vm._v("晚班")])],1)],1)]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)],1)}
var maternal_form_d_staticRenderFns = []
var maternal_form_d_esExports = { render: maternal_form_d_render, staticRenderFns: maternal_form_d_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_maternal_form_d = (maternal_form_d_esExports);
// CONCATENATED MODULE: ./src/components/maternal_form_d.vue
function maternal_form_d_injectStyle (ssrContext) {
  __webpack_require__("twwr")
}
var maternal_form_d_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var maternal_form_d___vue_template_functional__ = false
/* styles */
var maternal_form_d___vue_styles__ = maternal_form_d_injectStyle
/* scopeId */
var maternal_form_d___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var maternal_form_d___vue_module_identifier__ = null
var maternal_form_d_Component = maternal_form_d_normalizeComponent(
  components_maternal_form_d,
  selectortype_template_index_0_src_components_maternal_form_d,
  maternal_form_d___vue_template_functional__,
  maternal_form_d___vue_styles__,
  maternal_form_d___vue_scopeId__,
  maternal_form_d___vue_module_identifier__
)

/* harmony default export */ var src_components_maternal_form_d = (maternal_form_d_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bb_form = ({
    name: 'month_form',
    data: function data() {
        return {
            a: 1,
            id: this.$route.query.id
        };
    },

    methods: {
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },
        edit: function edit() {}
    },
    created: function created() {
        if (this.$route.query.a) {
            this.a = this.$route.query.a;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_bb_form = ({
    name: 'month_form',
    data: function data() {
        return {
            a: 1,
            id: this.$route.query.id
        };
    },

    methods: {
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },
        edit: function edit() {}
    },
    created: function created() {
        if (this.$route.query.a) {
            this.a = this.$route.query.a;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6566805a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bb_form.vue
var bb_form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("宝宝表单")]),_vm._v(" "),_c('div',{staticClass:"sheng2-table vux-1px"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"tbody vux-1px-b"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"9%"}},[_vm._v("1")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"70%"}},[_vm._v("婴儿喂养记录单")]),_vm._v(" "),_c('li',{staticStyle:{"width":"20%"}},[_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0','#2d8cf0'],"link":'./bb_form_a?a='+_vm.a}},[_vm._v(_vm._s(_vm.a == 2 ? '编辑表单' : '填写表单'))])],1)]),_vm._v(" "),_c('ul',{staticClass:"tbody vux-1px-b"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"9%"}},[_vm._v("2")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"70%"}},[_vm._v("婴儿护理记录单（1）")]),_vm._v(" "),_c('li',{staticStyle:{"width":"20%"}},[_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0','#2d8cf0'],"link":"./bb_form_b"}},[_vm._v("填写表单")])],1)]),_vm._v(" "),_c('ul',{staticClass:"tbody vux-1px-b"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"9%"}},[_vm._v("3")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"70%"}},[_vm._v("婴儿护理记录单（2）")]),_vm._v(" "),_c('li',{staticStyle:{"width":"20%"}},[_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0','#2d8cf0'],"link":"./bb_form_c"}},[_vm._v("填写表单")])],1)]),_vm._v(" "),_c('ul',{staticClass:"tbody vux-1px-b"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"9%"}},[_vm._v("4")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"70%"}},[_vm._v("新生儿满月评估表")]),_vm._v(" "),_c('li',{staticStyle:{"width":"20%"}},[_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0','#2d8cf0'],"link":"./bb_form_d"}},[_vm._v("填写表单")])],1)]),_vm._v(" "),_c('ul',{staticClass:"tbody vux-1px-b"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"9%"}},[_vm._v("5")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"70%"}},[_vm._v("新生儿入住评估单")]),_vm._v(" "),_c('li',{staticStyle:{"width":"20%"}},[_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0','#2d8cf0'],"link":"./bb_form_e"}},[_vm._v("填写表单")])],1)]),_vm._v(" "),_c('ul',{staticClass:"tbody"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"9%"}},[_vm._v("6")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"70%"}},[_vm._v("婴儿护理操作记录表")]),_vm._v(" "),_c('li',{staticStyle:{"width":"20%"}},[_c('x-button',{attrs:{"mini":"","gradients":['#2d8cf0','#2d8cf0'],"link":'./bb_form_f?id='+_vm.id}},[_vm._v("填写表单")])],1)])])],1)}
var bb_form_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"thead"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"9%"}},[_vm._v("序号")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"70%"}},[_vm._v("表单名")]),_vm._v(" "),_c('li',{staticStyle:{"width":"20%"}},[_vm._v("操作")])])}]
var bb_form_esExports = { render: bb_form_render, staticRenderFns: bb_form_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bb_form = (bb_form_esExports);
// CONCATENATED MODULE: ./src/components/bb_form.vue
function bb_form_injectStyle (ssrContext) {
  __webpack_require__("AHNf")
}
var bb_form_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bb_form___vue_template_functional__ = false
/* styles */
var bb_form___vue_styles__ = bb_form_injectStyle
/* scopeId */
var bb_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bb_form___vue_module_identifier__ = null
var bb_form_Component = bb_form_normalizeComponent(
  components_bb_form,
  selectortype_template_index_0_src_components_bb_form,
  bb_form___vue_template_functional__,
  bb_form___vue_styles__,
  bb_form___vue_scopeId__,
  bb_form___vue_module_identifier__
)

/* harmony default export */ var src_components_bb_form = (bb_form_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-date-time-m/dist/vue-date-time-m.js
var vue_date_time_m = __webpack_require__("mg6h");
var vue_date_time_m_default = /*#__PURE__*/__webpack_require__.n(vue_date_time_m);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_a.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var bb_form_a = ({
    name: 'bb_form_a',
    components: {
        DateTime: vue_date_time_m_default.a
    },
    data: function data() {
        return {
            type: '',
            form: {
                room: '',
                card: '',
                name: '',
                baby_id: '',
                sex: '',
                momName: '',
                date: '',
                wya: '200',
                wyb: '-',
                rgwya: '-',
                rgwyb: '-',
                water: '-',
                other: '',
                signature: '',
                shifts: ''
            },
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            baby_list: [],
            get_host: host.host
        };
    },
    created: function created() {
        // this.form.date = this.CurentTime()
        this.get_baby_list();
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            this.form.other = '母婴同室';
            this.apiMemberInfo();
        }
    },

    methods: {
        //  展示日期组件
        show: function show() {
            console.info(this.$refs);
            this.$refs.dateTime.show();
        },

        // 日期组件回调
        select: function select(val) {
            console.info(val);
            this.form.date = val;
        },
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            return;
                        }
                        this.form.card = item.hand_card;
                        this.form.sex = item.sex == "1" ? "男" : "女";
                        this.form.name = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        get_baby_list: function get_baby_list() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.baby_list = res.data;
                    // this.form.baby_id = res.data[0].id
                    // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.form.momName = res.data.name;
                    _this2.form.room = res.data.room_name;
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        save: function save() {
            var signature = 'signature1';
            var png = this.$refs[signature].save();
            this.form.signature = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.signature = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.signature = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getBabyFeedingRecordFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this3.form.room = data.room_number;
                    _this3.form.card = data.id_card;
                    _this3.form.name = data.baby_name;
                    _this3.form.baby_id = data.baby_id;
                    _this3.form.sex = data.sex;
                    _this3.form.momName = data.mom_name;
                    _this3.form.date = data.cat_date;
                    _this3.form.wya = data.breast_feeding_auto;
                    _this3.form.wyb = data.breast_feeding_people;
                    _this3.form.rgwya = data.people_feeding_peo;
                    _this3.form.rgwyb = data.people_feeding_formula;
                    _this3.form.water = data.drinking_water;
                    _this3.form.other = data.other_desc;
                    _this3.form.signature = data.autograph.indexOf(_this3.get_host) != -1 ? data.autograph : _this3.get_host + data.autograph;
                    _this3.form.shifts = data.shifts;
                    _this3.showSignature = true;
                    _this3.$vux.loading.hide();
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this4 = this;

            var babyName = '';
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = get_iterator_default()(this.baby_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    if (item.id == this.form.baby_id) {
                        babyName = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: babyName,
                baby_id: this.form.baby_id,
                sex: this.form.sex,
                mom_name: this.form.momName,
                cat_date: this.form.date,
                breast_feeding_auto: this.form.wya,
                breast_feeding_people: this.form.wyb,
                people_feeding_peo: this.form.rgwya,
                people_feeding_formula: this.form.rgwyb,
                drinking_water: this.form.water,
                other_desc: this.form.other,
                autograph: this.form.signature,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addBabyFeedingRecordData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'bb_form_a'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this5 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: this.form.name,
                baby_id: this.form.baby_id,
                sex: this.form.sex,
                mom_name: this.form.momName,
                cat_date: this.form.date,
                breast_feeding_auto: this.form.wya,
                breast_feeding_people: this.form.wyb,
                people_feeding_peo: this.form.rgwya,
                people_feeding_formula: this.form.rgwyb,
                drinking_water: this.form.water,
                other_desc: this.form.other,
                autograph: this.form.signature.indexOf(this.get_host) != -1 ? this.form.signature.replace(this.get_host, '') : this.form.signature,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateBabyFeedingRecordData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this5.$vux.loading.hide();
                    _this5.$router.replace({
                        path: '/success',
                        query: {
                            id: _this5.$route.query.id,
                            form_id: _this5.$route.query.form_id,
                            tabVal: _this5.$route.query.tabVal,
                            name: 'bb_form_a'
                        }
                    });
                } else {
                    _this5.$vux.loading.hide();
                    _this5.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            var form = this.form;
            if (form.card == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入手卡号'
                });
                return;
            }
            if (form.baby_id == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择宝宝'
                });
                return;
            }
            if (form.date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择日期'
                });
                return;
            }
            if (form.other == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入其他'
                });
                return;
            }
            if (form.shifts == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择班次'
                });
                return;
            }
            if (form.signature == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入签名'
                });
                return;
            }

            var time = 0;
            if (this.baby_list.length) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = get_iterator_default()(this.baby_list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var item = _step3.value;

                        if (item.id == this.form.baby_id) {
                            time = item.live_time;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            if (time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝暂未入住'
                });
                return;
            }
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_a.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_bb_form_a = ({
    name: 'bb_form_a',
    components: {
        DateTime: vue_date_time_m_default.a
    },
    data: function data() {
        return {
            type: '',
            form: {
                room: '',
                card: '',
                name: '',
                baby_id: '',
                sex: '',
                momName: '',
                date: '',
                wya: '200',
                wyb: '-',
                rgwya: '-',
                rgwyb: '-',
                water: '-',
                other: '',
                signature: '',
                shifts: ''
            },
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            baby_list: [],
            get_host: host.host
        };
    },
    created: function created() {
        // this.form.date = this.CurentTime()
        this.get_baby_list();
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            this.form.other = '母婴同室';
            this.apiMemberInfo();
        }
    },

    methods: {
        //  展示日期组件
        show: function show() {
            console.info(this.$refs);
            this.$refs.dateTime.show();
        },

        // 日期组件回调
        select: function select(val) {
            console.info(val);
            this.form.date = val;
        },
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            return;
                        }
                        this.form.card = item.hand_card;
                        this.form.sex = item.sex == "1" ? "男" : "女";
                        this.form.name = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        get_baby_list: function get_baby_list() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.baby_list = res.data;
                    // this.form.baby_id = res.data[0].id
                    // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.form.momName = res.data.name;
                    _this2.form.room = res.data.room_name;
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        save: function save() {
            var signature = 'signature1';
            var png = this.$refs[signature].save();
            this.form.signature = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.signature = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.signature = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getBabyFeedingRecordFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this3.form.room = data.room_number;
                    _this3.form.card = data.id_card;
                    _this3.form.name = data.baby_name;
                    _this3.form.baby_id = data.baby_id;
                    _this3.form.sex = data.sex;
                    _this3.form.momName = data.mom_name;
                    _this3.form.date = data.cat_date;
                    _this3.form.wya = data.breast_feeding_auto;
                    _this3.form.wyb = data.breast_feeding_people;
                    _this3.form.rgwya = data.people_feeding_peo;
                    _this3.form.rgwyb = data.people_feeding_formula;
                    _this3.form.water = data.drinking_water;
                    _this3.form.other = data.other_desc;
                    _this3.form.signature = data.autograph.indexOf(_this3.get_host) != -1 ? data.autograph : _this3.get_host + data.autograph;
                    _this3.form.shifts = data.shifts;
                    _this3.showSignature = true;
                    _this3.$vux.loading.hide();
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this4 = this;

            var babyName = '';
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = get_iterator_default()(this.baby_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    if (item.id == this.form.baby_id) {
                        babyName = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: babyName,
                baby_id: this.form.baby_id,
                sex: this.form.sex,
                mom_name: this.form.momName,
                cat_date: this.form.date,
                breast_feeding_auto: this.form.wya,
                breast_feeding_people: this.form.wyb,
                people_feeding_peo: this.form.rgwya,
                people_feeding_formula: this.form.rgwyb,
                drinking_water: this.form.water,
                other_desc: this.form.other,
                autograph: this.form.signature,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addBabyFeedingRecordData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'bb_form_a'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this5 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: this.form.name,
                baby_id: this.form.baby_id,
                sex: this.form.sex,
                mom_name: this.form.momName,
                cat_date: this.form.date,
                breast_feeding_auto: this.form.wya,
                breast_feeding_people: this.form.wyb,
                people_feeding_peo: this.form.rgwya,
                people_feeding_formula: this.form.rgwyb,
                drinking_water: this.form.water,
                other_desc: this.form.other,
                autograph: this.form.signature.indexOf(this.get_host) != -1 ? this.form.signature.replace(this.get_host, '') : this.form.signature,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateBabyFeedingRecordData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this5.$vux.loading.hide();
                    _this5.$router.replace({
                        path: '/success',
                        query: {
                            id: _this5.$route.query.id,
                            form_id: _this5.$route.query.form_id,
                            tabVal: _this5.$route.query.tabVal,
                            name: 'bb_form_a'
                        }
                    });
                } else {
                    _this5.$vux.loading.hide();
                    _this5.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            var form = this.form;
            if (form.card == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入手卡号'
                });
                return;
            }
            if (form.baby_id == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择宝宝'
                });
                return;
            }
            if (form.date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择日期'
                });
                return;
            }
            if (form.other == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入其他'
                });
                return;
            }
            if (form.shifts == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择班次'
                });
                return;
            }
            if (form.signature == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入签名'
                });
                return;
            }

            var time = 0;
            if (this.baby_list.length) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = get_iterator_default()(this.baby_list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var item = _step3.value;

                        if (item.id == this.form.baby_id) {
                            time = item.live_time;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            if (time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝暂未入住'
                });
                return;
            }
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56cb4800","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bb_form_a.vue
var bb_form_a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbFormA"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("婴儿喂养记录单")]),_vm._v(" "),_c('div',[_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(_vm.form.room),callback:function ($$v) {_vm.$set(_vm.form, "room", $$v)},expression:"form.room"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","disabled":"","placeholder":"请输入手卡号"},model:{value:(_vm.form.card),callback:function ($$v) {_vm.$set(_vm.form, "card", $$v)},expression:"form.card"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("选择宝宝：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},on:{"on-change":_vm.checkerChange},model:{value:(_vm.form.baby_id),callback:function ($$v) {_vm.$set(_vm.form, "baby_id", $$v)},expression:"form.baby_id"}},_vm._l((_vm.baby_list),function(item){return _c('checker-item',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}),1)],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","disabled":"","placeholder":"请输入性别"},model:{value:(_vm.form.sex),callback:function ($$v) {_vm.$set(_vm.form, "sex", $$v)},expression:"form.sex"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","disabled":"","placeholder":"请输入母亲姓名"},model:{value:(_vm.form.momName),callback:function ($$v) {_vm.$set(_vm.form, "momName", $$v)},expression:"form.momName"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('datetime',{attrs:{"title":"日期：","placeholder":"请选择日期"},model:{value:(_vm.form.date),callback:function ($$v) {_vm.$set(_vm.form, "date", $$v)},expression:"form.date"}})],1)]),_vm._v(" "),_c('x-input',{attrs:{"title":"母乳喂养(自喂:min)：","placeholder":"请输入(单位：min)"},model:{value:(_vm.form.wya),callback:function ($$v) {_vm.$set(_vm.form, "wya", $$v)},expression:"form.wya"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母乳喂养(人喂:ml)：","placeholder":"请输入(单位：ml)"},model:{value:(_vm.form.wyb),callback:function ($$v) {_vm.$set(_vm.form, "wyb", $$v)},expression:"form.wyb"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"人工喂养(人喂:min)：","placeholder":"请输入(单位：min)"},model:{value:(_vm.form.rgwya),callback:function ($$v) {_vm.$set(_vm.form, "rgwya", $$v)},expression:"form.rgwya"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"人工喂养(配方奶:ml)：","placeholder":"请输入(单位：ml)"},model:{value:(_vm.form.rgwyb),callback:function ($$v) {_vm.$set(_vm.form, "rgwyb", $$v)},expression:"form.rgwyb"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"饮水(ml)：","placeholder":"请输入（单位：ml）"},model:{value:(_vm.form.water),callback:function ($$v) {_vm.$set(_vm.form, "water", $$v)},expression:"form.water"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"其他：","placeholder":"请输入"},model:{value:(_vm.form.other),callback:function ($$v) {_vm.$set(_vm.form, "other", $$v)},expression:"form.other"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.signature)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.signature,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("班次：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"早班"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"中班"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"晚班"}},[_vm._v("晚班")])],1)],1)])]),_vm._v(" "),_c('x-textarea',{attrs:{"title":"注：","disabled":"","value":"1、人工喂养必须具有指征，要把控好奶粉选择、奶量及用品的清洁消毒。2、按时补充维生素D及维生素A，预防佝偻病。3、记录时间为当日上午8:30-次日上午8:30.4、做好婴儿喂养（母乳喂养）和护理的宣教"}}),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)],1)}
var bb_form_a_staticRenderFns = []
var bb_form_a_esExports = { render: bb_form_a_render, staticRenderFns: bb_form_a_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bb_form_a = (bb_form_a_esExports);
// CONCATENATED MODULE: ./src/components/bb_form_a.vue
function bb_form_a_injectStyle (ssrContext) {
  __webpack_require__("/IOa")
}
var bb_form_a_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bb_form_a___vue_template_functional__ = false
/* styles */
var bb_form_a___vue_styles__ = bb_form_a_injectStyle
/* scopeId */
var bb_form_a___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bb_form_a___vue_module_identifier__ = null
var bb_form_a_Component = bb_form_a_normalizeComponent(
  components_bb_form_a,
  selectortype_template_index_0_src_components_bb_form_a,
  bb_form_a___vue_template_functional__,
  bb_form_a___vue_styles__,
  bb_form_a___vue_scopeId__,
  bb_form_a___vue_module_identifier__
)

/* harmony default export */ var src_components_bb_form_a = (bb_form_a_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_b.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var bb_form_b = ({
    name: 'bb_form_b',
    components: {
        cfr: src_components_cfrList
    },
    data: function data() {
        return {
            get_host: host.host,
            showCfrList: false,
            list_id: '',
            cfrText: '',
            form: {
                room: '',
                card: '',
                name: '',
                baby_id: '',
                sex: '',
                momName: '',
                date: '',
                birtherDay: '',
                weight: '',
                bobyWeight: '',
                voice: '响亮',
                temperature: '',
                urinate: '',
                bowelsNum: '',
                bowelsColor: '',
                bowelsNature: '',
                fontanelle: '1',
                front_case: '',
                skin: '1',
                instruction: '',
                signature: '',
                shifts: '',
                check_id: ''
            },
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            baby_list: [],
            child_birth: ''
        };
    },
    created: function created() {
        this.get_baby_list();
        this.apiMemberInfo();
        if (this.$route.query.list_id) {
            this.apiGetCfrList();
            // this.apiDetail()
            this.list_id = this.$route.query.list_id;
        } else {
            this.list_id = '';
            this.form.instruction = '母乳喂养、母婴同室';
        }
    },

    methods: {
        GetNumberOfDays: function GetNumberOfDays(date1, date2) {
            //获得天数
            //date1：开始日期，date2结束日期
            var a1 = Date.parse(new Date(date1));
            var a2 = Date.parse(new Date(date2));
            var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24)); //核心：时间戳相减，然后除以天数
            return day;
        },
        change_date: function change_date(value) {
            console.log(this.child_birth);
            this.apiMemberInfo(value);
        },

        //获取查房人列表
        apiGetCfrList: function apiGetCfrList() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                store_id: this.$cookie.get('store_id')
            };
            Api.checkRoomApi.getCheckInfo(params).then(function (res) {
                console.info("获取查房人列表", res);
                if (res.errcode == 1) {
                    _this.nurser_name = res.data.nurser_name; //过滤了离院，
                    _this.apiDetail();
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //点击选择查房人
        selectPeople: function selectPeople() {
            this.showCfrList = true;
        },

        //赋值查房人ID
        cfrListEven: function cfrListEven(val, item) {
            this.showCfrList = val;
            console.info(item);
            if (item) {
                this.form.check_id = item.id;
                this.cfrText = item.user_name;
            }
        },

        //获取前囟input值
        onChangeFontanelle: function onChangeFontanelle(val) {
            this.form.fontanelle = val;
            this.$refs.fontanelle.focus();
            this.showFontanellePicker = false;
        },
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            return;
                        }
                        this.form.card = item.hand_card;
                        this.form.sex = item.sex == "1" ? "男" : "女";
                        this.form.name = item.name;
                        this.form.birtherDay = item.birth_day;
                        // this.form.bobyWeight = item.weight
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        get_baby_list: function get_baby_list() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.baby_list = res.data;
                    // this.form.baby_id = res.data[0].id
                    // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo(value) {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.form.momName = res.data.name;
                    _this3.form.room = res.data.room_name;
                    _this3.child_birth = _this3.formatDateTime(res.data.child_birth);
                    if (value) {
                        var day = _this3.GetNumberOfDays(_this3.child_birth, value) + 1;
                        _this3.form.birtherDay = day;
                    }
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        save: function save() {
            var signature = 'signature1';
            var png = this.$refs[signature].save();
            this.form.signature = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.signature = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.signature = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this4 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getBabyNursOneFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this4.form.room = data.room_number;
                    _this4.form.card = data.id_card;
                    _this4.form.name = data.baby_name;
                    _this4.form.baby_id = data.baby_id;
                    _this4.form.sex = data.baby_gender;
                    _this4.form.momName = data.mom_name;
                    _this4.form.date = data.cat_date;
                    _this4.change_date(data.cat_date);
                    _this4.form.birtherDay = data.birth_day_num;
                    _this4.form.temperature = data.temperature;
                    _this4.form.weight = data.weight;
                    _this4.form.bobyWeight = data.length;
                    _this4.form.voice = data.cry;
                    _this4.form.urinate = data.urine_num;
                    _this4.form.bowelsNum = data.shit_num;
                    _this4.form.bowelsColor = data.shit_colour;
                    _this4.form.bowelsNature = data.shit_nature;
                    _this4.form.fontanelle = data.front_fontanelle;
                    _this4.form.front_case = data.front_case;
                    _this4.form.skin = data.skin_colour;
                    _this4.form.instruction = data.guiding_pinions;
                    _this4.form.signature = data.autograph.indexOf(_this4.get_host) != -1 ? data.autograph : _this4.get_host + data.autograph;
                    _this4.form.shifts = data.shifts;
                    _this4.form.check_id = data.check_id;
                    _this4.showSignature = true;
                    if (_this4.nurser_name.length) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = get_iterator_default()(_this4.nurser_name), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var item = _step2.value;

                                if (item.id == data.check_id) {
                                    _this4.cfrText = item.user_name;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                    _this4.$vux.loading.hide();
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this5 = this;

            var babyName = '';
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = get_iterator_default()(this.baby_list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var item = _step3.value;

                    if (item.id == this.form.baby_id) {
                        babyName = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: babyName,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                cat_date: this.form.date,
                birth_day_num: this.form.birtherDay,
                length: this.form.bobyWeight,
                weight: this.form.weight,
                cry: this.form.voice,
                temperature: this.form.temperature,
                urine_num: this.form.urinate,
                shit_num: this.form.bowelsNum,
                shit_colour: this.form.bowelsColor,
                shit_nature: this.form.bowelsNature,
                front_fontanelle: this.form.fontanelle,
                front_case: this.form.front_case,
                skin_colour: this.form.skin,
                guiding_pinions: this.form.instruction,
                autograph: this.form.signature,
                shifts: this.form.shifts,
                check_id: this.form.check_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addBabyNursOneData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this5.$vux.loading.hide();
                    _this5.$router.replace({
                        path: '/success',
                        query: {
                            id: _this5.$route.query.id,
                            form_id: _this5.$route.query.form_id,
                            tabVal: _this5.$route.query.tabVal,
                            name: 'bb_form_b'
                        }
                    });
                } else {
                    _this5.$vux.loading.hide();
                    _this5.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this6 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: this.form.name,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                cat_date: this.form.date,
                birth_day_num: this.form.birtherDay,
                length: this.form.bobyWeight,
                weight: this.form.weight,
                cry: this.form.voice,
                temperature: this.form.temperature,
                urine_num: this.form.urinate,
                shit_num: this.form.bowelsNum,
                shit_colour: this.form.bowelsColor,
                shit_nature: this.form.bowelsNature,
                front_fontanelle: this.form.fontanelle,
                front_case: this.form.front_case,
                skin_colour: this.form.skin,
                guiding_pinions: this.form.instruction,
                autograph: this.form.signature.indexOf(this.get_host) != -1 ? this.form.signature.replace(this.get_host, '') : this.form.signature,
                shifts: this.form.shifts,
                check_id: this.form.check_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateBabyNursOneData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this6.$vux.loading.hide();
                    _this6.$router.replace({
                        path: '/success',
                        query: {
                            id: _this6.$route.query.id,
                            form_id: _this6.$route.query.form_id,
                            tabVal: _this6.$route.query.tabVal,
                            name: 'bb_form_b'
                        }
                    });
                } else {
                    _this6.$vux.loading.hide();
                    _this6.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            // 判断宝宝是否入住
            var time = 0;
            if (this.baby_list.length) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = get_iterator_default()(this.baby_list), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var item = _step4.value;

                        if (item.id == this.form.baby_id) {
                            time = item.live_time;
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            if (time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝暂未入住'
                });
                return;
            }
            var form = this.form;
            if (form.card == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入手卡号'
                });
                return;
            }
            if (form.baby_id == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择宝宝'
                });
                return;
            }
            if (form.date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择日期'
                });
                return;
            }
            if (form.birtherDay == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入出生天数'
                });
                return;
            }
            if (form.weight == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入体重'
                });
                return;
            }
            if (form.bobyWeight == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入身长'
                });
                return;
            }
            if (form.voice == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入哭声'
                });
                return;
            }
            if (form.temperature == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入体温'
                });
                return;
            }
            if (form.urinate == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入小便次数'
                });
                return;
            }
            if (form.bowelsNum == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便次数'
                });
                return;
            }
            if (form.bowelsNature == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便性质'
                });
                return;
            }
            if (form.bowelsColor == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便颜色'
                });
                return;
            }
            if (form.fontanelle == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择前囟情况'
                });
                return;
            }
            if (form.skin == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入肤色'
                });
                return;
            }
            if (form.instruction == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入指导意见'
                });
                return;
            }
            if (form.shifts == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入班次'
                });
                return;
            }
            if (form.signature == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入签名'
                });
                return;
            }
            if (form.check_id == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择查房人'
                });
                return;
            }
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_b.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_bb_form_b = ({
    name: 'bb_form_b',
    components: {
        cfr: src_components_cfrList
    },
    data: function data() {
        return {
            get_host: host.host,
            showCfrList: false,
            list_id: '',
            cfrText: '',
            form: {
                room: '',
                card: '',
                name: '',
                baby_id: '',
                sex: '',
                momName: '',
                date: '',
                birtherDay: '',
                weight: '',
                bobyWeight: '',
                voice: '响亮',
                temperature: '',
                urinate: '',
                bowelsNum: '',
                bowelsColor: '',
                bowelsNature: '',
                fontanelle: '1',
                front_case: '',
                skin: '1',
                instruction: '',
                signature: '',
                shifts: '',
                check_id: ''
            },
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            baby_list: [],
            child_birth: ''
        };
    },
    created: function created() {
        this.get_baby_list();
        this.apiMemberInfo();
        if (this.$route.query.list_id) {
            this.apiGetCfrList();
            // this.apiDetail()
            this.list_id = this.$route.query.list_id;
        } else {
            this.list_id = '';
            this.form.instruction = '母乳喂养、母婴同室';
        }
    },

    methods: {
        GetNumberOfDays: function GetNumberOfDays(date1, date2) {
            //获得天数
            //date1：开始日期，date2结束日期
            var a1 = Date.parse(new Date(date1));
            var a2 = Date.parse(new Date(date2));
            var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24)); //核心：时间戳相减，然后除以天数
            return day;
        },
        change_date: function change_date(value) {
            console.log(this.child_birth);
            this.apiMemberInfo(value);
        },

        //获取查房人列表
        apiGetCfrList: function apiGetCfrList() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                store_id: this.$cookie.get('store_id')
            };
            Api.checkRoomApi.getCheckInfo(params).then(function (res) {
                console.info("获取查房人列表", res);
                if (res.errcode == 1) {
                    _this.nurser_name = res.data.nurser_name; //过滤了离院，
                    _this.apiDetail();
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //点击选择查房人
        selectPeople: function selectPeople() {
            this.showCfrList = true;
        },

        //赋值查房人ID
        cfrListEven: function cfrListEven(val, item) {
            this.showCfrList = val;
            console.info(item);
            if (item) {
                this.form.check_id = item.id;
                this.cfrText = item.user_name;
            }
        },

        //获取前囟input值
        onChangeFontanelle: function onChangeFontanelle(val) {
            this.form.fontanelle = val;
            this.$refs.fontanelle.focus();
            this.showFontanellePicker = false;
        },
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            return;
                        }
                        this.form.card = item.hand_card;
                        this.form.sex = item.sex == "1" ? "男" : "女";
                        this.form.name = item.name;
                        this.form.birtherDay = item.birth_day;
                        // this.form.bobyWeight = item.weight
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        get_baby_list: function get_baby_list() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.baby_list = res.data;
                    // this.form.baby_id = res.data[0].id
                    // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo(value) {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.form.momName = res.data.name;
                    _this3.form.room = res.data.room_name;
                    _this3.child_birth = _this3.formatDateTime(res.data.child_birth);
                    if (value) {
                        var day = _this3.GetNumberOfDays(_this3.child_birth, value) + 1;
                        _this3.form.birtherDay = day;
                    }
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        save: function save() {
            var signature = 'signature1';
            var png = this.$refs[signature].save();
            this.form.signature = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.signature = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.signature = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this4 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getBabyNursOneFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this4.form.room = data.room_number;
                    _this4.form.card = data.id_card;
                    _this4.form.name = data.baby_name;
                    _this4.form.baby_id = data.baby_id;
                    _this4.form.sex = data.baby_gender;
                    _this4.form.momName = data.mom_name;
                    _this4.form.date = data.cat_date;
                    _this4.change_date(data.cat_date);
                    _this4.form.birtherDay = data.birth_day_num;
                    _this4.form.temperature = data.temperature;
                    _this4.form.weight = data.weight;
                    _this4.form.bobyWeight = data.length;
                    _this4.form.voice = data.cry;
                    _this4.form.urinate = data.urine_num;
                    _this4.form.bowelsNum = data.shit_num;
                    _this4.form.bowelsColor = data.shit_colour;
                    _this4.form.bowelsNature = data.shit_nature;
                    _this4.form.fontanelle = data.front_fontanelle;
                    _this4.form.front_case = data.front_case;
                    _this4.form.skin = data.skin_colour;
                    _this4.form.instruction = data.guiding_pinions;
                    _this4.form.signature = data.autograph.indexOf(_this4.get_host) != -1 ? data.autograph : _this4.get_host + data.autograph;
                    _this4.form.shifts = data.shifts;
                    _this4.form.check_id = data.check_id;
                    _this4.showSignature = true;
                    if (_this4.nurser_name.length) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = get_iterator_default()(_this4.nurser_name), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var item = _step2.value;

                                if (item.id == data.check_id) {
                                    _this4.cfrText = item.user_name;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                    _this4.$vux.loading.hide();
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this5 = this;

            var babyName = '';
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = get_iterator_default()(this.baby_list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var item = _step3.value;

                    if (item.id == this.form.baby_id) {
                        babyName = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: babyName,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                cat_date: this.form.date,
                birth_day_num: this.form.birtherDay,
                length: this.form.bobyWeight,
                weight: this.form.weight,
                cry: this.form.voice,
                temperature: this.form.temperature,
                urine_num: this.form.urinate,
                shit_num: this.form.bowelsNum,
                shit_colour: this.form.bowelsColor,
                shit_nature: this.form.bowelsNature,
                front_fontanelle: this.form.fontanelle,
                front_case: this.form.front_case,
                skin_colour: this.form.skin,
                guiding_pinions: this.form.instruction,
                autograph: this.form.signature,
                shifts: this.form.shifts,
                check_id: this.form.check_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addBabyNursOneData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this5.$vux.loading.hide();
                    _this5.$router.replace({
                        path: '/success',
                        query: {
                            id: _this5.$route.query.id,
                            form_id: _this5.$route.query.form_id,
                            tabVal: _this5.$route.query.tabVal,
                            name: 'bb_form_b'
                        }
                    });
                } else {
                    _this5.$vux.loading.hide();
                    _this5.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this6 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: this.form.name,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                cat_date: this.form.date,
                birth_day_num: this.form.birtherDay,
                length: this.form.bobyWeight,
                weight: this.form.weight,
                cry: this.form.voice,
                temperature: this.form.temperature,
                urine_num: this.form.urinate,
                shit_num: this.form.bowelsNum,
                shit_colour: this.form.bowelsColor,
                shit_nature: this.form.bowelsNature,
                front_fontanelle: this.form.fontanelle,
                front_case: this.form.front_case,
                skin_colour: this.form.skin,
                guiding_pinions: this.form.instruction,
                autograph: this.form.signature.indexOf(this.get_host) != -1 ? this.form.signature.replace(this.get_host, '') : this.form.signature,
                shifts: this.form.shifts,
                check_id: this.form.check_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateBabyNursOneData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this6.$vux.loading.hide();
                    _this6.$router.replace({
                        path: '/success',
                        query: {
                            id: _this6.$route.query.id,
                            form_id: _this6.$route.query.form_id,
                            tabVal: _this6.$route.query.tabVal,
                            name: 'bb_form_b'
                        }
                    });
                } else {
                    _this6.$vux.loading.hide();
                    _this6.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            // 判断宝宝是否入住
            var time = 0;
            if (this.baby_list.length) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = get_iterator_default()(this.baby_list), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var item = _step4.value;

                        if (item.id == this.form.baby_id) {
                            time = item.live_time;
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            if (time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝暂未入住'
                });
                return;
            }
            var form = this.form;
            if (form.card == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入手卡号'
                });
                return;
            }
            if (form.baby_id == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择宝宝'
                });
                return;
            }
            if (form.date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择日期'
                });
                return;
            }
            if (form.birtherDay == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入出生天数'
                });
                return;
            }
            if (form.weight == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入体重'
                });
                return;
            }
            if (form.bobyWeight == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入身长'
                });
                return;
            }
            if (form.voice == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入哭声'
                });
                return;
            }
            if (form.temperature == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入体温'
                });
                return;
            }
            if (form.urinate == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入小便次数'
                });
                return;
            }
            if (form.bowelsNum == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便次数'
                });
                return;
            }
            if (form.bowelsNature == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便性质'
                });
                return;
            }
            if (form.bowelsColor == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入大便颜色'
                });
                return;
            }
            if (form.fontanelle == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择前囟情况'
                });
                return;
            }
            if (form.skin == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入肤色'
                });
                return;
            }
            if (form.instruction == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入指导意见'
                });
                return;
            }
            if (form.shifts == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入班次'
                });
                return;
            }
            if (form.signature == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入签名'
                });
                return;
            }
            if (form.check_id == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择查房人'
                });
                return;
            }
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbf83932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bb_form_b.vue
var bb_form_b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbFormB"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("婴儿护理记录单（1）")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(_vm.form.room),callback:function ($$v) {_vm.$set(_vm.form, "room", $$v)},expression:"form.room"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","disabled":"","placeholder":"请输入手卡号"},model:{value:(_vm.form.card),callback:function ($$v) {_vm.$set(_vm.form, "card", $$v)},expression:"form.card"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("选择宝宝：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},on:{"on-change":_vm.checkerChange},model:{value:(_vm.form.baby_id),callback:function ($$v) {_vm.$set(_vm.form, "baby_id", $$v)},expression:"form.baby_id"}},_vm._l((_vm.baby_list),function(item){return _c('checker-item',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}),1)],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","disabled":"","placeholder":"请输入性别"},model:{value:(_vm.form.sex),callback:function ($$v) {_vm.$set(_vm.form, "sex", $$v)},expression:"form.sex"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","disabled":"","placeholder":"请输入母亲姓名"},model:{value:(_vm.form.momName),callback:function ($$v) {_vm.$set(_vm.form, "momName", $$v)},expression:"form.momName"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"日期："},on:{"on-change":_vm.change_date},model:{value:(_vm.form.date),callback:function ($$v) {_vm.$set(_vm.form, "date", $$v)},expression:"form.date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生天数(天)：","disabled":""},model:{value:(_vm.form.birtherDay),callback:function ($$v) {_vm.$set(_vm.form, "birtherDay", $$v)},expression:"form.birtherDay"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体重(g)：","placeholder":"请输入体重(单位：g)"},model:{value:(_vm.form.weight),callback:function ($$v) {_vm.$set(_vm.form, "weight", $$v)},expression:"form.weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身长(cm)：","placeholder":"请输入身长(单位：cm)"},model:{value:(_vm.form.bobyWeight),callback:function ($$v) {_vm.$set(_vm.form, "bobyWeight", $$v)},expression:"form.bobyWeight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"哭声：","placeholder":"请输入哭声"},model:{value:(_vm.form.voice),callback:function ($$v) {_vm.$set(_vm.form, "voice", $$v)},expression:"form.voice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体温(℃)：","placeholder":"请输入体温（单位：℃）"},model:{value:(_vm.form.temperature),callback:function ($$v) {_vm.$set(_vm.form, "temperature", $$v)},expression:"form.temperature"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"小便(次)：","placeholder":"请输入小便（单位：次）"},model:{value:(_vm.form.urinate),callback:function ($$v) {_vm.$set(_vm.form, "urinate", $$v)},expression:"form.urinate"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"大便次数(次)：","placeholder":"请输入大便次数（单位：次）"},model:{value:(_vm.form.bowelsNum),callback:function ($$v) {_vm.$set(_vm.form, "bowelsNum", $$v)},expression:"form.bowelsNum"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"大便颜色：","placeholder":"请输入大便颜色"},model:{value:(_vm.form.bowelsColor),callback:function ($$v) {_vm.$set(_vm.form, "bowelsColor", $$v)},expression:"form.bowelsColor"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"大便性质：","placeholder":"请输入大便性质"},model:{value:(_vm.form.bowelsNature),callback:function ($$v) {_vm.$set(_vm.form, "bowelsNature", $$v)},expression:"form.bowelsNature"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("前囟：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"flex":"none"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.fontanelle),callback:function ($$v) {_vm.$set(_vm.form, "fontanelle", $$v)},expression:"form.fontanelle"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("平坦")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("肿胀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("凹陷")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","padding-left":"10px","color":"#999"}},[_vm._v(_vm._s(_vm.form.fontanelle == '1' ? '平坦' : _vm.form.fontanelle == '2' ? '肿胀' : _vm.form.fontanelle == '3' ? '凹陷' : _vm.form.fontanelle))])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("肤色：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"flex":"none"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.skin),callback:function ($$v) {_vm.$set(_vm.form, "skin", $$v)},expression:"form.skin"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红润")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("黄染")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","padding-left":"10px","color":"#999"}},[_vm._v(_vm._s(_vm.form.skin == '1' ? '红润' : _vm.form.skin == '2' ? '黄染' : _vm.form.skin))])])]),_vm._v(" "),_c('x-textarea',{attrs:{"title":"指导意见：","placeholder":"请输入指导意见"},model:{value:(_vm.form.instruction),callback:function ($$v) {_vm.$set(_vm.form, "instruction", $$v)},expression:"form.instruction"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"5px"}},[_vm._v("签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.signature)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.signature,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px","padding-left":"5px"}},[_vm._v("班次：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"早班"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"中班"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"晚班"}},[_vm._v("晚班")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"0","line-height":"29px"}},[_vm._v("查房人：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                    "+_vm._s(_vm.cfrText)+" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople.apply(null, arguments)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('cfr',{attrs:{"list_id":_vm.list_id,"showCfrList":_vm.showCfrList},on:{"cfrListEven":_vm.cfrListEven}})],1),_vm._v(" "),_c('x-textarea',{attrs:{"title":"注：","disabled":"","value":"1、勤换尿布，选用适合婴儿的尿布和衣物。2、每次换尿布有无大小便均打钩表示。3、发现大便异常请在指导意见一栏中写明色、质、量，报告儿科健康顾问并注明报告时间和健康顾问姓名"}}),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var bb_form_b_staticRenderFns = []
var bb_form_b_esExports = { render: bb_form_b_render, staticRenderFns: bb_form_b_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bb_form_b = (bb_form_b_esExports);
// CONCATENATED MODULE: ./src/components/bb_form_b.vue
function bb_form_b_injectStyle (ssrContext) {
  __webpack_require__("vTCu")
}
var bb_form_b_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bb_form_b___vue_template_functional__ = false
/* styles */
var bb_form_b___vue_styles__ = bb_form_b_injectStyle
/* scopeId */
var bb_form_b___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bb_form_b___vue_module_identifier__ = null
var bb_form_b_Component = bb_form_b_normalizeComponent(
  components_bb_form_b,
  selectortype_template_index_0_src_components_bb_form_b,
  bb_form_b___vue_template_functional__,
  bb_form_b___vue_styles__,
  bb_form_b___vue_scopeId__,
  bb_form_b___vue_module_identifier__
)

/* harmony default export */ var src_components_bb_form_b = (bb_form_b_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_c.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var bb_form_c = ({
    name: 'bb_form_c',
    components: {
        cfr: src_components_cfrList
    },
    data: function data() {
        return {
            // showNerveReflexPicker:false,
            // options2:['正常','迟钝'],
            // showTensionOfLimbsPicker:false,
            // options1:['良好','受限'],
            list_id: '',
            showCfrList: false,
            showsignature: false,
            cfrText: '',
            form: {
                room: '',
                card: '',
                cat_date: '',
                name: '',
                baby_id: '',
                sex: '',
                momName: '',
                skin: [],
                eye: '',
                oral: '',
                umbilical: '',
                vomiting: '无',
                limbTension: '1',
                nerveReflex: '1',
                percutaneousBilirubin: '',
                guiding_pinions: '',
                autograph: '',
                shifts: '',
                check_id: ''
            },
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            baby_list: [],
            get_host: host.host
        };
    },
    created: function created() {
        this.get_baby_list();
        if (this.$route.query.list_id) {
            this.apiGetCfrList();
            this.list_id = this.$route.query.list_id;
        } else {
            this.list_id = '';
            this.apiMemberInfo();
            this.form.guiding_pinions = '母乳喂养、母婴同室';
        }
    },

    methods: {
        //获取四肢张力input值
        onChangeTensionOfLimbs: function onChangeTensionOfLimbs(val) {
            this.form.limbTension = val;
            this.$refs.limbTension.focus();
            this.showTensionOfLimbsPicker = false;
        },

        //获取神经反射input值
        onChangeNerveReflex: function onChangeNerveReflex(val) {
            this.form.nerveReflex = val;
            this.$refs.nerveReflex.focus();
            this.showNerveReflexPicker = false;
        },
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            return;
                        }
                        this.form.card = item.hand_card;
                        this.form.sex = item.sex == "1" ? "男" : "女";
                        this.form.name = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },

        //获取查房人列表
        apiGetCfrList: function apiGetCfrList() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                store_id: this.$cookie.get('store_id')
            };
            Api.checkRoomApi.getCheckInfo(params).then(function (res) {
                console.info("获取查房人列表", res);
                if (res.errcode == 1) {
                    _this.nurser_name = res.data.nurser_name; //过滤了离院，
                    _this.apiDetail();
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //点击选择查房人
        selectPeople: function selectPeople() {
            this.showCfrList = true;
        },

        //赋值查房人ID
        cfrListEven: function cfrListEven(val, item) {
            this.showCfrList = val;
            console.info(item);
            if (item) {
                this.form.check_id = item.id;
                this.cfrText = item.user_name;
            }
        },
        get_baby_list: function get_baby_list() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.baby_list = res.data;
                    // this.form.baby_id = res.data[0].id
                    // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.form.momName = res.data.name;
                    _this3.form.room = res.data.room_name;
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.autograph = encodeURI(png);
            this.showsignature = true;
        },
        edit: function edit() {
            this.showsignature = false;
            this.form.autograph = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.autograph = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this4 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getBabyNursTwoFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this4.form.room = data.room_number;
                    _this4.form.card = data.id_card;
                    _this4.form.cat_date = data.cat_date;
                    _this4.form.name = data.baby_name;
                    _this4.form.baby_id = data.baby_id;
                    _this4.form.sex = data.baby_gender;
                    _this4.form.momName = data.mom_name;
                    _this4.form.skin = data.skin;
                    _this4.form.eye = data.eye;
                    _this4.form.oral = data.oral;
                    _this4.form.umbilical = data.umbilical;
                    // this.form.skinA = data.skin_jaundice
                    // this.form.skinB = data.skin_erosion
                    // this.form.skinC = data.skin_herpes_zoster
                    // this.form.skinD = data.skin_eczema
                    // this.form.skinE = data.skin_diaper_rash
                    // this.form.eyeSituation = data.eye_normal
                    // this.form.eyeSecretions = data.eye_secretion
                    // this.form.oralSmooth = data.mouth_smooth
                    // this.form.oralBurst = data.mouth_ulceration
                    // this.form.oralThrush = data.mouth_thrush
                    // this.form.umbilicalDry = data.umb_cord_outblood
                    // this.form.umbilicalBleeding = data.umb_cord_falloff
                    // this.form.umbilicalFall = data.umb_cord_secretion
                    _this4.form.vomiting = data.vomit;
                    _this4.form.limbTension = data.tension_of_limbs;
                    // this.form.tension_of_limbs_case = data.tension_of_limbs_case
                    _this4.form.nerveReflex = data.nerve_reflex;
                    // this.form.nerve_reflex_case = data.nerve_reflex_case
                    _this4.form.percutaneousBilirubin = data.transcutaneous_bilirubin;
                    _this4.form.guiding_pinions = data.guiding_pinions;
                    _this4.form.autograph = data.autograph.indexOf(_this4.get_host) != -1 ? data.autograph : _this4.get_host + data.autograph;
                    _this4.form.shifts = data.shifts;
                    _this4.form.check_id = data.check_id;
                    _this4.showsignature = true;
                    if (_this4.nurser_name.length) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = get_iterator_default()(_this4.nurser_name), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var item = _step2.value;

                                if (item.id == data.check_id) {
                                    _this4.cfrText = item.user_name;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                    _this4.$vux.loading.hide();
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this5 = this;

            var babyName = '';
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = get_iterator_default()(this.baby_list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var item = _step3.value;

                    if (item.id == this.form.baby_id) {
                        babyName = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                cat_date: this.form.cat_date,
                baby_name: babyName,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                skin: this.form.skin,
                eye: this.form.eye,
                oral: this.form.oral,
                umbilical: this.form.umbilical,
                // skin_jaundice:this.form.skinA,
                // skin_erosion:this.form.skinB,
                // skin_herpes_zoster:this.form.skinC,
                // skin_eczema:this.form.skinD,
                // skin_diaper_rash:this.form.skinE,
                // eye_normal:this.form.eyeSituation,
                // eye_secretion:this.form.eyeSecretions,
                // mouth_smooth:this.form.oralSmooth,
                // mouth_ulceration:this.form.oralBurst,
                // mouth_thrush:this.form.oralThrush,
                // umb_cord_outblood:this.form.umbilicalDry,
                // umb_cord_falloff:this.form.umbilicalBleeding,
                // umb_cord_secretion:this.form.umbilicalFall,
                vomit: this.form.vomiting,
                tension_of_limbs: this.form.limbTension,
                // tension_of_limbs_case:this.form.tension_of_limbs_case,
                nerve_reflex: this.form.nerveReflex,
                // nerve_reflex_case:this.form.nerve_reflex_case,
                transcutaneous_bilirubin: this.form.percutaneousBilirubin,
                guiding_pinions: this.form.guiding_pinions,
                autograph: this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host, '') : this.form.autograph,
                shifts: this.form.shifts,
                check_id: this.form.check_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addBabyNursTwoData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this5.$vux.loading.hide();
                    _this5.$router.replace({
                        path: '/success',
                        query: {
                            id: _this5.$route.query.id,
                            form_id: _this5.$route.query.form_id,
                            tabVal: _this5.$route.query.tabVal,
                            name: 'bb_form_c'
                        }
                    });
                } else {
                    _this5.$vux.loading.hide();
                    _this5.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this6 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                cat_date: this.form.cat_date,
                baby_name: this.form.name,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                skin: this.form.skin,
                eye: this.form.eye,
                oral: this.form.oral,
                umbilical: this.form.umbilical,
                // skin_jaundice:this.form.skinA,
                // skin_erosion:this.form.skinB,
                // skin_herpes_zoster:this.form.skinC,
                // skin_eczema:this.form.skinD,
                // skin_diaper_rash:this.form.skinE,
                // eye_normal:this.form.eyeSituation,
                // eye_secretion:this.form.eyeSecretions,
                // mouth_smooth:this.form.oralSmooth,
                // mouth_ulceration:this.form.oralBurst,
                // mouth_thrush:this.form.oralThrush,
                // umb_cord_outblood:this.form.umbilicalDry,
                // umb_cord_falloff:this.form.umbilicalBleeding,
                // umb_cord_secretion:this.form.umbilicalFall,
                vomit: this.form.vomiting,
                tension_of_limbs: this.form.limbTension,
                // tension_of_limbs_case:this.form.tension_of_limbs_case,
                nerve_reflex: this.form.nerveReflex,
                // nerve_reflex_case:this.form.nerve_reflex_case,
                transcutaneous_bilirubin: this.form.percutaneousBilirubin,
                guiding_pinions: this.form.guiding_pinions,
                autograph: this.form.autograph,
                shifts: this.form.shifts,
                check_id: this.form.check_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateBabyNursTwoData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this6.$vux.loading.hide();
                    _this6.$router.replace({
                        path: '/success',
                        query: {
                            id: _this6.$route.query.id,
                            form_id: _this6.$route.query.form_id,
                            tabVal: _this6.$route.query.tabVal,
                            name: 'bb_form_c'
                        }
                    });
                } else {
                    _this6.$vux.loading.hide();
                    _this6.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            var form = this.form;
            console.info(form);
            if (form.card == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入手卡号'
                });
                return;
            }
            if (form.cat_date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择日期'
                });
                return;
            }
            if (form.baby_id == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择宝宝'
                });
                return;
            }
            if (form.skin.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择皮肤'
                });
                return;
            }
            if (form.eye == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择眼'
                });
                return;
            }
            if (form.oral == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择口腔'
                });
                return;
            }
            if (form.umbilical == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择脐带'
                });
                return;
            }
            if (form.vomiting == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入呕吐'
                });
                return;
            }
            if (form.limbTension == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择四肢张力'
                });
                return;
            }
            if (form.nerveReflex == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择神经反射'
                });
                return;
            }
            if (form.percutaneousBilirubin == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入经皮胆红素'
                });
                return;
            }
            if (form.guiding_pinions == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入指导意见'
                });
                return;
            }
            if (form.autograph == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入签名'
                });
                return;
            }
            if (form.shifts == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择班次'
                });
                return;
            }
            if (form.check_id == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择查房人'
                });
                return;
            }
            // 判断宝宝是否入住
            var time = 0;
            if (this.baby_list.length) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = get_iterator_default()(this.baby_list), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var item = _step4.value;

                        if (item.id == this.form.baby_id) {
                            time = item.live_time;
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            if (time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝暂未入住'
                });
                return;
            }
            // if(form.room == '' || form.card == '' || form.baby_id == ''  || form.cat_date == '' || form.sex == '' || form.shifts == '' || form.check_id == '' || form.momName == '' || form.date == '' || form.birtherDay == '' || form.weight == '' || form.bobyWeight == '' || form.voice == '' || form.temperature == '' || form.urinate == '' || form.bowelsNum == '' || form.bowelsNature == '' || form.fontanelle == '' || form.skin == '' || form.instruction == '' || form.signature == ''){
            //     this.$vux.toast.show({
            //         type: 'cancel',
            //         text: '请完善所有表单',
            //     })
            //     return
            // }
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_c.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_bb_form_c = ({
    name: 'bb_form_c',
    components: {
        cfr: src_components_cfrList
    },
    data: function data() {
        return {
            // showNerveReflexPicker:false,
            // options2:['正常','迟钝'],
            // showTensionOfLimbsPicker:false,
            // options1:['良好','受限'],
            list_id: '',
            showCfrList: false,
            showsignature: false,
            cfrText: '',
            form: {
                room: '',
                card: '',
                cat_date: '',
                name: '',
                baby_id: '',
                sex: '',
                momName: '',
                skin: [],
                eye: '',
                oral: '',
                umbilical: '',
                vomiting: '无',
                limbTension: '1',
                nerveReflex: '1',
                percutaneousBilirubin: '',
                guiding_pinions: '',
                autograph: '',
                shifts: '',
                check_id: ''
            },
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            baby_list: [],
            get_host: host.host
        };
    },
    created: function created() {
        this.get_baby_list();
        if (this.$route.query.list_id) {
            this.apiGetCfrList();
            this.list_id = this.$route.query.list_id;
        } else {
            this.list_id = '';
            this.apiMemberInfo();
            this.form.guiding_pinions = '母乳喂养、母婴同室';
        }
    },

    methods: {
        //获取四肢张力input值
        onChangeTensionOfLimbs: function onChangeTensionOfLimbs(val) {
            this.form.limbTension = val;
            this.$refs.limbTension.focus();
            this.showTensionOfLimbsPicker = false;
        },

        //获取神经反射input值
        onChangeNerveReflex: function onChangeNerveReflex(val) {
            this.form.nerveReflex = val;
            this.$refs.nerveReflex.focus();
            this.showNerveReflexPicker = false;
        },
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            return;
                        }
                        this.form.card = item.hand_card;
                        this.form.sex = item.sex == "1" ? "男" : "女";
                        this.form.name = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },

        //获取查房人列表
        apiGetCfrList: function apiGetCfrList() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                store_id: this.$cookie.get('store_id')
            };
            Api.checkRoomApi.getCheckInfo(params).then(function (res) {
                console.info("获取查房人列表", res);
                if (res.errcode == 1) {
                    _this.nurser_name = res.data.nurser_name; //过滤了离院，
                    _this.apiDetail();
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //点击选择查房人
        selectPeople: function selectPeople() {
            this.showCfrList = true;
        },

        //赋值查房人ID
        cfrListEven: function cfrListEven(val, item) {
            this.showCfrList = val;
            console.info(item);
            if (item) {
                this.form.check_id = item.id;
                this.cfrText = item.user_name;
            }
        },
        get_baby_list: function get_baby_list() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.baby_list = res.data;
                    // this.form.baby_id = res.data[0].id
                    // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.form.momName = res.data.name;
                    _this3.form.room = res.data.room_name;
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.autograph = encodeURI(png);
            this.showsignature = true;
        },
        edit: function edit() {
            this.showsignature = false;
            this.form.autograph = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.autograph = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this4 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getBabyNursTwoFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this4.form.room = data.room_number;
                    _this4.form.card = data.id_card;
                    _this4.form.cat_date = data.cat_date;
                    _this4.form.name = data.baby_name;
                    _this4.form.baby_id = data.baby_id;
                    _this4.form.sex = data.baby_gender;
                    _this4.form.momName = data.mom_name;
                    _this4.form.skin = data.skin;
                    _this4.form.eye = data.eye;
                    _this4.form.oral = data.oral;
                    _this4.form.umbilical = data.umbilical;
                    // this.form.skinA = data.skin_jaundice
                    // this.form.skinB = data.skin_erosion
                    // this.form.skinC = data.skin_herpes_zoster
                    // this.form.skinD = data.skin_eczema
                    // this.form.skinE = data.skin_diaper_rash
                    // this.form.eyeSituation = data.eye_normal
                    // this.form.eyeSecretions = data.eye_secretion
                    // this.form.oralSmooth = data.mouth_smooth
                    // this.form.oralBurst = data.mouth_ulceration
                    // this.form.oralThrush = data.mouth_thrush
                    // this.form.umbilicalDry = data.umb_cord_outblood
                    // this.form.umbilicalBleeding = data.umb_cord_falloff
                    // this.form.umbilicalFall = data.umb_cord_secretion
                    _this4.form.vomiting = data.vomit;
                    _this4.form.limbTension = data.tension_of_limbs;
                    // this.form.tension_of_limbs_case = data.tension_of_limbs_case
                    _this4.form.nerveReflex = data.nerve_reflex;
                    // this.form.nerve_reflex_case = data.nerve_reflex_case
                    _this4.form.percutaneousBilirubin = data.transcutaneous_bilirubin;
                    _this4.form.guiding_pinions = data.guiding_pinions;
                    _this4.form.autograph = data.autograph.indexOf(_this4.get_host) != -1 ? data.autograph : _this4.get_host + data.autograph;
                    _this4.form.shifts = data.shifts;
                    _this4.form.check_id = data.check_id;
                    _this4.showsignature = true;
                    if (_this4.nurser_name.length) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = get_iterator_default()(_this4.nurser_name), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var item = _step2.value;

                                if (item.id == data.check_id) {
                                    _this4.cfrText = item.user_name;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                    _this4.$vux.loading.hide();
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this5 = this;

            var babyName = '';
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = get_iterator_default()(this.baby_list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var item = _step3.value;

                    if (item.id == this.form.baby_id) {
                        babyName = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                cat_date: this.form.cat_date,
                baby_name: babyName,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                skin: this.form.skin,
                eye: this.form.eye,
                oral: this.form.oral,
                umbilical: this.form.umbilical,
                // skin_jaundice:this.form.skinA,
                // skin_erosion:this.form.skinB,
                // skin_herpes_zoster:this.form.skinC,
                // skin_eczema:this.form.skinD,
                // skin_diaper_rash:this.form.skinE,
                // eye_normal:this.form.eyeSituation,
                // eye_secretion:this.form.eyeSecretions,
                // mouth_smooth:this.form.oralSmooth,
                // mouth_ulceration:this.form.oralBurst,
                // mouth_thrush:this.form.oralThrush,
                // umb_cord_outblood:this.form.umbilicalDry,
                // umb_cord_falloff:this.form.umbilicalBleeding,
                // umb_cord_secretion:this.form.umbilicalFall,
                vomit: this.form.vomiting,
                tension_of_limbs: this.form.limbTension,
                // tension_of_limbs_case:this.form.tension_of_limbs_case,
                nerve_reflex: this.form.nerveReflex,
                // nerve_reflex_case:this.form.nerve_reflex_case,
                transcutaneous_bilirubin: this.form.percutaneousBilirubin,
                guiding_pinions: this.form.guiding_pinions,
                autograph: this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host, '') : this.form.autograph,
                shifts: this.form.shifts,
                check_id: this.form.check_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addBabyNursTwoData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this5.$vux.loading.hide();
                    _this5.$router.replace({
                        path: '/success',
                        query: {
                            id: _this5.$route.query.id,
                            form_id: _this5.$route.query.form_id,
                            tabVal: _this5.$route.query.tabVal,
                            name: 'bb_form_c'
                        }
                    });
                } else {
                    _this5.$vux.loading.hide();
                    _this5.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this6 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                cat_date: this.form.cat_date,
                baby_name: this.form.name,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                skin: this.form.skin,
                eye: this.form.eye,
                oral: this.form.oral,
                umbilical: this.form.umbilical,
                // skin_jaundice:this.form.skinA,
                // skin_erosion:this.form.skinB,
                // skin_herpes_zoster:this.form.skinC,
                // skin_eczema:this.form.skinD,
                // skin_diaper_rash:this.form.skinE,
                // eye_normal:this.form.eyeSituation,
                // eye_secretion:this.form.eyeSecretions,
                // mouth_smooth:this.form.oralSmooth,
                // mouth_ulceration:this.form.oralBurst,
                // mouth_thrush:this.form.oralThrush,
                // umb_cord_outblood:this.form.umbilicalDry,
                // umb_cord_falloff:this.form.umbilicalBleeding,
                // umb_cord_secretion:this.form.umbilicalFall,
                vomit: this.form.vomiting,
                tension_of_limbs: this.form.limbTension,
                // tension_of_limbs_case:this.form.tension_of_limbs_case,
                nerve_reflex: this.form.nerveReflex,
                // nerve_reflex_case:this.form.nerve_reflex_case,
                transcutaneous_bilirubin: this.form.percutaneousBilirubin,
                guiding_pinions: this.form.guiding_pinions,
                autograph: this.form.autograph,
                shifts: this.form.shifts,
                check_id: this.form.check_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateBabyNursTwoData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this6.$vux.loading.hide();
                    _this6.$router.replace({
                        path: '/success',
                        query: {
                            id: _this6.$route.query.id,
                            form_id: _this6.$route.query.form_id,
                            tabVal: _this6.$route.query.tabVal,
                            name: 'bb_form_c'
                        }
                    });
                } else {
                    _this6.$vux.loading.hide();
                    _this6.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            var form = this.form;
            console.info(form);
            if (form.card == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入手卡号'
                });
                return;
            }
            if (form.cat_date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择日期'
                });
                return;
            }
            if (form.baby_id == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择宝宝'
                });
                return;
            }
            if (form.skin.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择皮肤'
                });
                return;
            }
            if (form.eye == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择眼'
                });
                return;
            }
            if (form.oral == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择口腔'
                });
                return;
            }
            if (form.umbilical == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择脐带'
                });
                return;
            }
            if (form.vomiting == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入呕吐'
                });
                return;
            }
            if (form.limbTension == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择四肢张力'
                });
                return;
            }
            if (form.nerveReflex == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择神经反射'
                });
                return;
            }
            if (form.percutaneousBilirubin == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入经皮胆红素'
                });
                return;
            }
            if (form.guiding_pinions == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入指导意见'
                });
                return;
            }
            if (form.autograph == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请输入签名'
                });
                return;
            }
            if (form.shifts == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择班次'
                });
                return;
            }
            if (form.check_id == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请选择查房人'
                });
                return;
            }
            // 判断宝宝是否入住
            var time = 0;
            if (this.baby_list.length) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                    for (var _iterator4 = get_iterator_default()(this.baby_list), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        var item = _step4.value;

                        if (item.id == this.form.baby_id) {
                            time = item.live_time;
                        }
                    }
                } catch (err) {
                    _didIteratorError4 = true;
                    _iteratorError4 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                        }
                    } finally {
                        if (_didIteratorError4) {
                            throw _iteratorError4;
                        }
                    }
                }
            }
            if (time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝暂未入住'
                });
                return;
            }
            // if(form.room == '' || form.card == '' || form.baby_id == ''  || form.cat_date == '' || form.sex == '' || form.shifts == '' || form.check_id == '' || form.momName == '' || form.date == '' || form.birtherDay == '' || form.weight == '' || form.bobyWeight == '' || form.voice == '' || form.temperature == '' || form.urinate == '' || form.bowelsNum == '' || form.bowelsNature == '' || form.fontanelle == '' || form.skin == '' || form.instruction == '' || form.signature == ''){
            //     this.$vux.toast.show({
            //         type: 'cancel',
            //         text: '请完善所有表单',
            //     })
            //     return
            // }
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b56b11d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bb_form_c.vue
var bb_form_c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbFormC"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("婴儿护理记录单（2）")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(_vm.form.room),callback:function ($$v) {_vm.$set(_vm.form, "room", $$v)},expression:"form.room"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","disabled":"","placeholder":"请输入手卡号"},model:{value:(_vm.form.card),callback:function ($$v) {_vm.$set(_vm.form, "card", $$v)},expression:"form.card"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"日期："},model:{value:(_vm.form.cat_date),callback:function ($$v) {_vm.$set(_vm.form, "cat_date", $$v)},expression:"form.cat_date"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("选择宝宝：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},on:{"on-change":_vm.checkerChange},model:{value:(_vm.form.baby_id),callback:function ($$v) {_vm.$set(_vm.form, "baby_id", $$v)},expression:"form.baby_id"}},_vm._l((_vm.baby_list),function(item){return _c('checker-item',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}),1)],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","disabled":"","placeholder":"请输入性别"},model:{value:(_vm.form.sex),callback:function ($$v) {_vm.$set(_vm.form, "sex", $$v)},expression:"form.sex"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","disabled":"","placeholder":"请输入母亲姓名"},model:{value:(_vm.form.momName),callback:function ($$v) {_vm.$set(_vm.form, "momName", $$v)},expression:"form.momName"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("皮肤：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.skin),callback:function ($$v) {_vm.$set(_vm.form, "skin", $$v)},expression:"form.skin"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("黄疸")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("糜烂")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("脓疱疹")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("湿疹")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"6"}},[_vm._v("尿布疹")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("眼：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"type":"radio","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.eye),callback:function ($$v) {_vm.$set(_vm.form, "eye", $$v)},expression:"form.eye"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("分泌物")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("口腔：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"type":"radio","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.oral),callback:function ($$v) {_vm.$set(_vm.form, "oral", $$v)},expression:"form.oral"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("光滑")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("破溃")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("鹅口疮")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("脐带：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"type":"radio","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.umbilical),callback:function ($$v) {_vm.$set(_vm.form, "umbilical", $$v)},expression:"form.umbilical"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("干燥")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("出血")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("脱落")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("分泌物")])],1)],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"呕吐：","placeholder":"请输入呕吐"},model:{value:(_vm.form.vomiting),callback:function ($$v) {_vm.$set(_vm.form, "vomiting", $$v)},expression:"form.vomiting"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("四肢张力：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"flex":"none"}},[_c('checker',{attrs:{"type":"radio","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.limbTension),callback:function ($$v) {_vm.$set(_vm.form, "limbTension", $$v)},expression:"form.limbTension"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("受限")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","padding-left":"10px","color":"#999"}},[_vm._v(_vm._s(_vm.form.limbTension == '1' ? '良好' : _vm.form.limbTension == '2' ? '受限' : _vm.form.limbTension))])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("神经反射：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"flex":"none"}},[_c('checker',{attrs:{"type":"radio","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nerveReflex),callback:function ($$v) {_vm.$set(_vm.form, "nerveReflex", $$v)},expression:"form.nerveReflex"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("迟钝")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"36px","padding-left":"10px","color":"#999"}},[_vm._v(_vm._s(_vm.form.nerveReflex == '1' ? '正常' : _vm.form.nerveReflex == '2' ? '迟钝' : _vm.form.nerveReflex))])])]),_vm._v(" "),_c('x-input',{attrs:{"title":"经皮胆红素(mg/dl)：","placeholder":"请输入经皮胆红素(单位：mg/dl)"},model:{value:(_vm.form.percutaneousBilirubin),callback:function ($$v) {_vm.$set(_vm.form, "percutaneousBilirubin", $$v)},expression:"form.percutaneousBilirubin"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"指导意见：","placeholder":"请输入指导意见"},model:{value:(_vm.form.guiding_pinions),callback:function ($$v) {_vm.$set(_vm.form, "guiding_pinions", $$v)},expression:"form.guiding_pinions"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showsignature)?_c('div',[(_vm.form.autograph)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.autograph,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("班次：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"早班"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"中班"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"晚班"}},[_vm._v("晚班")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"0","line-height":"29px"}},[_vm._v("查房人：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                    "+_vm._s(_vm.cfrText)+" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople.apply(null, arguments)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('cfr',{attrs:{"list_id":_vm.list_id,"showCfrList":_vm.showCfrList},on:{"cfrListEven":_vm.cfrListEven}})],1),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var bb_form_c_staticRenderFns = []
var bb_form_c_esExports = { render: bb_form_c_render, staticRenderFns: bb_form_c_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bb_form_c = (bb_form_c_esExports);
// CONCATENATED MODULE: ./src/components/bb_form_c.vue
function bb_form_c_injectStyle (ssrContext) {
  __webpack_require__("y6ID")
}
var bb_form_c_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bb_form_c___vue_template_functional__ = false
/* styles */
var bb_form_c___vue_styles__ = bb_form_c_injectStyle
/* scopeId */
var bb_form_c___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bb_form_c___vue_module_identifier__ = null
var bb_form_c_Component = bb_form_c_normalizeComponent(
  components_bb_form_c,
  selectortype_template_index_0_src_components_bb_form_c,
  bb_form_c___vue_template_functional__,
  bb_form_c___vue_styles__,
  bb_form_c___vue_scopeId__,
  bb_form_c___vue_module_identifier__
)

/* harmony default export */ var src_components_bb_form_c = (bb_form_c_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_d.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bb_form_d = ({
    name: 'bb_form_d',
    data: function data() {
        return {
            coldArr: [],
            form: {
                room_number: '',
                baby_name: '',
                check_in_time: '',
                body_heat: '',
                weight: '',
                boby_length: '',
                nutritional_status: '',
                complexion: '',
                crying: '',
                reaction: '',
                skin_case: [],
                skin_broken_position: '',
                skin_rash_position: '',
                feeding_status: '',
                milk_brand: '',
                exc_micturition_case: '',
                exc_micturition_num: '',
                exc_defecation_case: '',
                exc_defecation_num: '',
                exc_diarrhea_num: '',
                muscle_status: '',
                muscle_limited_position: '',
                muscle_lose_position: '',
                nursing_problem_status: '',
                nursing_problem: '',
                questionText: '',
                feeding_guidance: [],
                other_desc: '',
                cold_prevention: '',
                family_sign: '',
                nurse_sign: ''
            },
            showUserSignature: false,
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.family_sign = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.family_sign = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.family_sign = '';
        },

        // 保存客户签名
        saveUserName: function saveUserName() {
            var signature = 'signature2';
            var png = this.$refs[signature].save();
            this.form.nurse_sign = encodeURI(png);
            this.showUserSignature = true;
        },

        //编辑客户签名
        editUserName: function editUserName() {
            this.showUserSignature = false;
            this.form.nurse_sign = '';
        },

        //清除客户签名
        clearUserName: function clearUserName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.nurse_sign = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            this.form.token = this.$cookie.get('token');
            this.form.number_id = this.$cookie.get('id');
            this.form.maternal_info_id = this.$route.query.id;
            this.form.store_id = this.$cookie.get('store_id');
            this.form.baby_id = this.$route.query.child_id;
            var params = this.form;
            this.form.cold_prevention = this.coldArr.join();
            console.info(params);
            if (params.room_number == '' || params.baby_name == '' || params.check_in_time == '' || params.weight == '' || params.boby_length == '' || params.nutritional_status == '' || params.complexion == '' || params.crying == '' || params.reaction == '' || params.skin_case.length == 0 || params.feeding_status == '' || params.exc_micturition_case == '' || params.exc_micturition_num == '' || params.exc_defecation_case == '' || params.exc_defecation_num == '' || params.muscle_status == '' || params.nursing_problem_status == '' || params.feeding_guidance.length == 0 || params.cold_prevention == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请完善表单'
                });
                return;
            }

            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.otherFormApi.addNewbornFullmoonAssessData(params).then(function (res) {
                _this.$vux.loading.hide();
                console.info(res);
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            form_id: res.data.id,
                            name: 'bb_form_d'
                        }
                    });
                }
            });
        },
        apiMemberInfo: function apiMemberInfo() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.form.mom_name = res.data.name;
                    _this2.form.room_number = res.data.room_name;
                    _this2.form.check_in_time = _this2.formatDateTime(res.data.live_time);
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },
        get_baby_list: function get_baby_list() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.baby_list = res.data;
                    var get_boby_id = _this3.$route.query.child_id;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = get_iterator_default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            if (item.id == get_boby_id) {
                                // this.form.bobyLength = item.weight
                                _this3.form.baby_name = item.name;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    created: function created() {
        this.apiMemberInfo();
        this.get_baby_list();
        // this.form.baby_name=this.$route.query.baby_name
        // this.form.sex=this.$route.query.baby_sex
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_d.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_bb_form_d = ({
    name: 'bb_form_d',
    data: function data() {
        return {
            coldArr: [],
            form: {
                room_number: '',
                baby_name: '',
                check_in_time: '',
                body_heat: '',
                weight: '',
                boby_length: '',
                nutritional_status: '',
                complexion: '',
                crying: '',
                reaction: '',
                skin_case: [],
                skin_broken_position: '',
                skin_rash_position: '',
                feeding_status: '',
                milk_brand: '',
                exc_micturition_case: '',
                exc_micturition_num: '',
                exc_defecation_case: '',
                exc_defecation_num: '',
                exc_diarrhea_num: '',
                muscle_status: '',
                muscle_limited_position: '',
                muscle_lose_position: '',
                nursing_problem_status: '',
                nursing_problem: '',
                questionText: '',
                feeding_guidance: [],
                other_desc: '',
                cold_prevention: '',
                family_sign: '',
                nurse_sign: ''
            },
            showUserSignature: false,
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.family_sign = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.family_sign = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.family_sign = '';
        },

        // 保存客户签名
        saveUserName: function saveUserName() {
            var signature = 'signature2';
            var png = this.$refs[signature].save();
            this.form.nurse_sign = encodeURI(png);
            this.showUserSignature = true;
        },

        //编辑客户签名
        editUserName: function editUserName() {
            this.showUserSignature = false;
            this.form.nurse_sign = '';
        },

        //清除客户签名
        clearUserName: function clearUserName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.nurse_sign = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            this.form.token = this.$cookie.get('token');
            this.form.number_id = this.$cookie.get('id');
            this.form.maternal_info_id = this.$route.query.id;
            this.form.store_id = this.$cookie.get('store_id');
            this.form.baby_id = this.$route.query.child_id;
            var params = this.form;
            this.form.cold_prevention = this.coldArr.join();
            console.info(params);
            if (params.room_number == '' || params.baby_name == '' || params.check_in_time == '' || params.weight == '' || params.boby_length == '' || params.nutritional_status == '' || params.complexion == '' || params.crying == '' || params.reaction == '' || params.skin_case.length == 0 || params.feeding_status == '' || params.exc_micturition_case == '' || params.exc_micturition_num == '' || params.exc_defecation_case == '' || params.exc_defecation_num == '' || params.muscle_status == '' || params.nursing_problem_status == '' || params.feeding_guidance.length == 0 || params.cold_prevention == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请完善表单'
                });
                return;
            }

            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.otherFormApi.addNewbornFullmoonAssessData(params).then(function (res) {
                _this.$vux.loading.hide();
                console.info(res);
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            form_id: res.data.id,
                            name: 'bb_form_d'
                        }
                    });
                }
            });
        },
        apiMemberInfo: function apiMemberInfo() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.form.mom_name = res.data.name;
                    _this2.form.room_number = res.data.room_name;
                    _this2.form.check_in_time = _this2.formatDateTime(res.data.live_time);
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },
        get_baby_list: function get_baby_list() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.baby_list = res.data;
                    var get_boby_id = _this3.$route.query.child_id;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = get_iterator_default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            if (item.id == get_boby_id) {
                                // this.form.bobyLength = item.weight
                                _this3.form.baby_name = item.name;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    created: function created() {
        this.apiMemberInfo();
        this.get_baby_list();
        // this.form.baby_name=this.$route.query.baby_name
        // this.form.sex=this.$route.query.baby_sex
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-592ce484","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bb_form_d.vue
var bb_form_d_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("新生儿满月评估表")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","placeholder":"请输入房号","readonly":""},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","placeholder":"请输入姓名","readonly":""},model:{value:(_vm.form.baby_name),callback:function ($$v) {_vm.$set(_vm.form, "baby_name", $$v)},expression:"form.baby_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"入住时间：","readonly":""},model:{value:(_vm.form.check_in_time),callback:function ($$v) {_vm.$set(_vm.form, "check_in_time", $$v)},expression:"form.check_in_time"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体温(℃)：","placeholder":"请输入体温（单位：℃）"},model:{value:(_vm.form.body_heat),callback:function ($$v) {_vm.$set(_vm.form, "body_heat", $$v)},expression:"form.body_heat"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体重(g)：","placeholder":"请输入体重(单位：g)"},model:{value:(_vm.form.weight),callback:function ($$v) {_vm.$set(_vm.form, "weight", $$v)},expression:"form.weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身长（cm）：","placeholder":"请输入身长(单位：cm)"},model:{value:(_vm.form.boby_length),callback:function ($$v) {_vm.$set(_vm.form, "boby_length", $$v)},expression:"form.boby_length"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("营养发育：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nutritional_status),callback:function ($$v) {_vm.$set(_vm.form, "nutritional_status", $$v)},expression:"form.nutritional_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("过剩")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("中等")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("差")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("面色：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.complexion),callback:function ($$v) {_vm.$set(_vm.form, "complexion", $$v)},expression:"form.complexion"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红润")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("黄染")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("哭声：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.crying),callback:function ($$v) {_vm.$set(_vm.form, "crying", $$v)},expression:"form.crying"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("响亮")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("微弱")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("反应：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.reaction),callback:function ($$v) {_vm.$set(_vm.form, "reaction", $$v)},expression:"form.reaction"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("迟钝")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("差")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("皮肤：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.skin_case),callback:function ($$v) {_vm.$set(_vm.form, "skin_case", $$v)},expression:"form.skin_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("完整")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("破损")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("红润")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("黄染")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("红臀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"6"}},[_vm._v("干燥")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"7"}},[_vm._v("皮疹")])],1)],1)]),_vm._v(" "),_c('x-input',{staticClass:"item vux-1px-t",attrs:{"title":"破损部位：","placeholder":"请输入"},model:{value:(_vm.form.skin_broken_position),callback:function ($$v) {_vm.$set(_vm.form, "skin_broken_position", $$v)},expression:"form.skin_broken_position"}}),_vm._v(" "),_c('x-input',{staticClass:"item vux-1px-t",attrs:{"title":"皮疹部位：","placeholder":"请输入"},model:{value:(_vm.form.skin_rash_position),callback:function ($$v) {_vm.$set(_vm.form, "skin_rash_position", $$v)},expression:"form.skin_rash_position"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("喂养情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.feeding_status),callback:function ($$v) {_vm.$set(_vm.form, "feeding_status", $$v)},expression:"form.feeding_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("母乳喂养")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("人工喂养")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("混合喂养")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"奶粉品牌：","placeholder":"请输入奶粉品牌"},model:{value:(_vm.form.milk_brand),callback:function ($$v) {_vm.$set(_vm.form, "milk_brand", $$v)},expression:"form.milk_brand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("排尿：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.exc_micturition_case),callback:function ($$v) {_vm.$set(_vm.form, "exc_micturition_case", $$v)},expression:"form.exc_micturition_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"5px"}},[_vm._v("排尿次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.exc_micturition_num),expression:"form.exc_micturition_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.exc_micturition_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "exc_micturition_num", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("排便：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.exc_defecation_case),callback:function ($$v) {_vm.$set(_vm.form, "exc_defecation_case", $$v)},expression:"form.exc_defecation_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("便秘")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("未排")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("腹泻")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"5px"}},[_vm._v("排便次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.exc_defecation_num),expression:"form.exc_defecation_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.exc_defecation_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "exc_defecation_num", $event.target.value)}}})])])],1),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("肌张力及活动：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.muscle_status),callback:function ($$v) {_vm.$set(_vm.form, "muscle_status", $$v)},expression:"form.muscle_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("受限")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("丧失")])],1)],1)]),_vm._v(" "),_c('x-input',{staticClass:"item vux-1px-t",attrs:{"title":"受限部位：","placeholder":"请输入部位"},model:{value:(_vm.form.muscle_limited_position),callback:function ($$v) {_vm.$set(_vm.form, "muscle_limited_position", $$v)},expression:"form.muscle_limited_position"}}),_vm._v(" "),_c('x-input',{staticClass:"item vux-1px-t",attrs:{"title":"丧失部位：","placeholder":"请输入部位"},model:{value:(_vm.form.muscle_lose_position),callback:function ($$v) {_vm.$set(_vm.form, "muscle_lose_position", $$v)},expression:"form.muscle_lose_position"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("现存护理问题：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nursing_problem_status),callback:function ($$v) {_vm.$set(_vm.form, "nursing_problem_status", $$v)},expression:"form.nursing_problem_status"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"placeholder":"问题描述"},model:{value:(_vm.form.nursing_problem),callback:function ($$v) {_vm.$set(_vm.form, "nursing_problem", $$v)},expression:"form.nursing_problem"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("喂养指导：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.feeding_guidance),callback:function ($$v) {_vm.$set(_vm.form, "feeding_guidance", $$v)},expression:"form.feeding_guidance"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("母乳")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("牛奶")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("混合喂养")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("按时添加辅食")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("少食多餐")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"其他","placeholder":"请输入"},model:{value:(_vm.form.other_desc),callback:function ($$v) {_vm.$set(_vm.form, "other_desc", $$v)},expression:"form.other_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("预防感冒：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.coldArr),callback:function ($$v) {_vm.coldArr=$$v},expression:"coldArr"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("注意保暖")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("减少探视")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("日光浴")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("少到公共场合")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("如有不适随时到医院就诊")])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("家属签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.family_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.family_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护士签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showUserSignature)?_c('div',[(_vm.form.nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.nurse_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editUserName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveUserName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearUserName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var bb_form_d_staticRenderFns = []
var bb_form_d_esExports = { render: bb_form_d_render, staticRenderFns: bb_form_d_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bb_form_d = (bb_form_d_esExports);
// CONCATENATED MODULE: ./src/components/bb_form_d.vue
function bb_form_d_injectStyle (ssrContext) {
  __webpack_require__("qspp")
}
var bb_form_d_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bb_form_d___vue_template_functional__ = false
/* styles */
var bb_form_d___vue_styles__ = bb_form_d_injectStyle
/* scopeId */
var bb_form_d___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bb_form_d___vue_module_identifier__ = null
var bb_form_d_Component = bb_form_d_normalizeComponent(
  components_bb_form_d,
  selectortype_template_index_0_src_components_bb_form_d,
  bb_form_d___vue_template_functional__,
  bb_form_d___vue_styles__,
  bb_form_d___vue_scopeId__,
  bb_form_d___vue_module_identifier__
)

/* harmony default export */ var src_components_bb_form_d = (bb_form_d_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_d_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bb_form_d_detail = ({
    name: 'bb_form_d_detail',
    data: function data() {
        return {
            get_host: host.host,
            form: {
                room_number: '',
                baby_name: '',
                check_in_time: '',
                body_heat: '',
                weight: '',
                boby_length: '',
                nutritional_status: '',
                complexion: '',
                crying: '',
                reaction: '',
                skin_case: '',
                skin_broken_position: '',
                skin_rash_position: '',
                feeding_status: '',
                milk_brand: '',
                exc_micturition_case: '',
                exc_micturition_num: '',
                exc_defecation_case: '',
                exc_defecation_num: '',
                exc_diarrhea_num: '',
                muscle_status: '',
                muscle_limited_position: '',
                muscle_lose_position: '',
                nursing_problem_status: '',
                nursing_problem: '',
                questionText: '',
                feeding_guidance: '',
                other_desc: '',
                cold_prevention: '',
                family_sign: '',
                nurse_sign: ''
            },
            coldArr: []
        };
    },

    methods: {
        submitForm: function submitForm() {
            this.$router.replace({
                path: '/bb_form_d_edit',
                query: {
                    id: this.$route.query.id,
                    form_id: this.$route.query.form_id,
                    baby_id: this.$route.query.child_id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    created: function created() {
        var _this = this;

        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.form_id
        };
        this.$vux.loading.show({
            text: '正在加载'
        });
        console.info(params);
        Api.otherFormApi.getNewbornFullmoonAssessFind(params).then(function (res) {
            _this.$vux.loading.hide();
            console.info("详情", res.data);
            if (res.errcode == 200) {
                _this.form.room_number = res.data.room_number;
                _this.form.baby_name = res.data.baby_name;
                _this.form.check_in_time = res.data.check_in_time;
                _this.form.body_heat = res.data.body_heat;
                _this.form.weight = res.data.weight;
                _this.form.boby_length = res.data.boby_length;
                _this.form.nutritional_status = res.data.nutritional_status == '1' ? '过剩' : res.data.nutritional_status == '2' ? '良好' : res.data.nutritional_status == '3' ? '中等' : res.data.nutritional_status == '4' ? '差' : '';
                _this.form.complexion = res.data.complexion == '1' ? '红润' : res.data.complexion == '2' ? '黄染' : '';
                _this.form.crying = res.data.crying == '1' ? '响亮' : res.data.crying == '2' ? '微弱' : '';
                _this.form.reaction = res.data.reaction == '1' ? '良好' : res.data.reaction == '2' ? '迟钝' : res.data.reaction == '3' ? '差' : '';
                _this.form.skin_case = res.data.skin_case == '1' ? '完整' : res.data.skin_case == '2' ? '破损' : res.data.skin_case == '3' ? '红润' : res.data.skin_case == '4' ? '黄染' : res.data.skin_case == '5' ? '红臀' : res.data.skin_case == '6' ? '干燥' : res.data.skin_case == '7' ? '皮疹' : '';
                //皮肤
                var Arr1 = res.data.skin_case;
                for (var i = 0; i < Arr1.length; i++) {
                    if (Arr1[i] == '1') {
                        Arr1[i] = '完整';
                    } else if (Arr1[i] == '2') {
                        Arr1[i] = '破损';
                    } else if (Arr1[i] == '3') {
                        Arr1[i] = '红润';
                    } else if (Arr1[i] == '4') {
                        Arr1[i] = '黄染';
                    } else if (Arr1[i] == '5') {
                        Arr1[i] = '红臀';
                    } else if (Arr1[i] == '6') {
                        Arr1[i] = '干燥';
                    } else if (Arr1[i] == '7') {
                        Arr1[i] = '皮疹';
                    }
                    _this.form.skin_case = Arr1.join();
                }
                _this.form.skin_broken_position = res.data.skin_broken_position;
                _this.form.skin_rash_position = res.data.skin_rash_position;
                _this.form.feeding_status = res.data.feeding_status == '1' ? '母乳喂养' : res.data.feeding_status == '2' ? '人工喂养' : res.data.feeding_status == '3' ? '混合喂养' : '';
                _this.form.milk_brand = res.data.milk_brand;
                _this.form.exc_micturition_case = res.data.exc_micturition_case == '1' ? '正常' : '';
                _this.form.exc_micturition_num = res.data.exc_micturition_num;
                _this.form.exc_defecation_case = res.data.exc_defecation_case == '1' ? '正常' : res.data.exc_defecation_case == '2' ? '便秘' : res.data.exc_defecation_case == '3' ? '未排' : res.data.exc_defecation_case == '4' ? '腹泻' : '';
                _this.form.exc_defecation_num = res.data.exc_defecation_num;
                _this.form.exc_diarrhea_num = res.data.exc_diarrhea_num;
                _this.form.muscle_status = res.data.muscle_status == '1' ? '良好' : res.data.muscle_status == '2' ? '受限' : res.data.muscle_status == '3' ? '丧失' : '';
                _this.form.muscle_limited_position = res.data.muscle_limited_position;
                _this.form.muscle_lose_position = res.data.muscle_lose_position;
                _this.form.nursing_problem_status = res.data.nursing_problem_status == '1' ? '有' : res.data.nursing_problem_status == '2' ? '无' : '';
                _this.form.nursing_problem = res.data.nursing_problem;
                _this.form.questionText = res.data.questionText;
                _this.form.family_sign = res.data.family_sign.indexOf(_this.get_host) != -1 ? res.data.family_sign : _this.get_host + res.data.family_sign;
                _this.form.nurse_sign = res.data.nurse_sign.indexOf(_this.get_host) != -1 ? res.data.nurse_sign : _this.get_host + res.data.nurse_sign;
                // this.form.feeding_guidance=res.data.feeding_guidance=='1'?'母乳':(res.data.feeding_guidance=='2'?'牛奶':(res.data.feeding_guidance=='3'?'混合喂养':(res.data.feeding_guidance=='4'?'按时添加辅食':(res.data.feeding_guidance=='5'?'少食多餐':''))))
                //喂养指导
                var Arr2 = res.data.feeding_guidance;
                for (var _i = 0; _i < Arr2.length; _i++) {
                    if (Arr2[_i] == '1') {
                        Arr2[_i] = '母乳';
                    } else if (Arr2[_i] == '2') {
                        Arr2[_i] = '牛奶';
                    } else if (Arr2[_i] == '3') {
                        Arr2[_i] = '混合喂养';
                    } else if (Arr2[_i] == '4') {
                        Arr2[_i] = '按时添加辅食';
                    } else if (Arr2[_i] == '5') {
                        Arr2[_i] = '少食多餐';
                    }
                    _this.form.feeding_guidance = Arr2.join();
                }
                _this.form.other_desc = res.data.other_desc;
                //预防感冒
                var Arr = res.data.cold_prevention.split(',');
                for (var _i2 = 0; _i2 < Arr.length; _i2++) {
                    if (Arr[_i2] == '1') {
                        Arr[_i2] = '注意保暖';
                    } else if (Arr[_i2] == '2') {
                        Arr[_i2] = '减少探视';
                    } else if (Arr[_i2] == '3') {
                        Arr[_i2] = '日光浴';
                    } else if (Arr[_i2] == '4') {
                        Arr[_i2] = '少到公共场合';
                    } else if (Arr[_i2] == '5') {
                        Arr[_i2] = '如有不适随时到医院就诊';
                    }
                    _this.form.cold_prevention = Arr.join();
                }
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_d_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_bb_form_d_detail = ({
    name: 'bb_form_d_detail',
    data: function data() {
        return {
            get_host: host.host,
            form: {
                room_number: '',
                baby_name: '',
                check_in_time: '',
                body_heat: '',
                weight: '',
                boby_length: '',
                nutritional_status: '',
                complexion: '',
                crying: '',
                reaction: '',
                skin_case: '',
                skin_broken_position: '',
                skin_rash_position: '',
                feeding_status: '',
                milk_brand: '',
                exc_micturition_case: '',
                exc_micturition_num: '',
                exc_defecation_case: '',
                exc_defecation_num: '',
                exc_diarrhea_num: '',
                muscle_status: '',
                muscle_limited_position: '',
                muscle_lose_position: '',
                nursing_problem_status: '',
                nursing_problem: '',
                questionText: '',
                feeding_guidance: '',
                other_desc: '',
                cold_prevention: '',
                family_sign: '',
                nurse_sign: ''
            },
            coldArr: []
        };
    },

    methods: {
        submitForm: function submitForm() {
            this.$router.replace({
                path: '/bb_form_d_edit',
                query: {
                    id: this.$route.query.id,
                    form_id: this.$route.query.form_id,
                    baby_id: this.$route.query.child_id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    created: function created() {
        var _this = this;

        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.form_id
        };
        this.$vux.loading.show({
            text: '正在加载'
        });
        console.info(params);
        Api.otherFormApi.getNewbornFullmoonAssessFind(params).then(function (res) {
            _this.$vux.loading.hide();
            console.info("详情", res.data);
            if (res.errcode == 200) {
                _this.form.room_number = res.data.room_number;
                _this.form.baby_name = res.data.baby_name;
                _this.form.check_in_time = res.data.check_in_time;
                _this.form.body_heat = res.data.body_heat;
                _this.form.weight = res.data.weight;
                _this.form.boby_length = res.data.boby_length;
                _this.form.nutritional_status = res.data.nutritional_status == '1' ? '过剩' : res.data.nutritional_status == '2' ? '良好' : res.data.nutritional_status == '3' ? '中等' : res.data.nutritional_status == '4' ? '差' : '';
                _this.form.complexion = res.data.complexion == '1' ? '红润' : res.data.complexion == '2' ? '黄染' : '';
                _this.form.crying = res.data.crying == '1' ? '响亮' : res.data.crying == '2' ? '微弱' : '';
                _this.form.reaction = res.data.reaction == '1' ? '良好' : res.data.reaction == '2' ? '迟钝' : res.data.reaction == '3' ? '差' : '';
                _this.form.skin_case = res.data.skin_case == '1' ? '完整' : res.data.skin_case == '2' ? '破损' : res.data.skin_case == '3' ? '红润' : res.data.skin_case == '4' ? '黄染' : res.data.skin_case == '5' ? '红臀' : res.data.skin_case == '6' ? '干燥' : res.data.skin_case == '7' ? '皮疹' : '';
                //皮肤
                var Arr1 = res.data.skin_case;
                for (var i = 0; i < Arr1.length; i++) {
                    if (Arr1[i] == '1') {
                        Arr1[i] = '完整';
                    } else if (Arr1[i] == '2') {
                        Arr1[i] = '破损';
                    } else if (Arr1[i] == '3') {
                        Arr1[i] = '红润';
                    } else if (Arr1[i] == '4') {
                        Arr1[i] = '黄染';
                    } else if (Arr1[i] == '5') {
                        Arr1[i] = '红臀';
                    } else if (Arr1[i] == '6') {
                        Arr1[i] = '干燥';
                    } else if (Arr1[i] == '7') {
                        Arr1[i] = '皮疹';
                    }
                    _this.form.skin_case = Arr1.join();
                }
                _this.form.skin_broken_position = res.data.skin_broken_position;
                _this.form.skin_rash_position = res.data.skin_rash_position;
                _this.form.feeding_status = res.data.feeding_status == '1' ? '母乳喂养' : res.data.feeding_status == '2' ? '人工喂养' : res.data.feeding_status == '3' ? '混合喂养' : '';
                _this.form.milk_brand = res.data.milk_brand;
                _this.form.exc_micturition_case = res.data.exc_micturition_case == '1' ? '正常' : '';
                _this.form.exc_micturition_num = res.data.exc_micturition_num;
                _this.form.exc_defecation_case = res.data.exc_defecation_case == '1' ? '正常' : res.data.exc_defecation_case == '2' ? '便秘' : res.data.exc_defecation_case == '3' ? '未排' : res.data.exc_defecation_case == '4' ? '腹泻' : '';
                _this.form.exc_defecation_num = res.data.exc_defecation_num;
                _this.form.exc_diarrhea_num = res.data.exc_diarrhea_num;
                _this.form.muscle_status = res.data.muscle_status == '1' ? '良好' : res.data.muscle_status == '2' ? '受限' : res.data.muscle_status == '3' ? '丧失' : '';
                _this.form.muscle_limited_position = res.data.muscle_limited_position;
                _this.form.muscle_lose_position = res.data.muscle_lose_position;
                _this.form.nursing_problem_status = res.data.nursing_problem_status == '1' ? '有' : res.data.nursing_problem_status == '2' ? '无' : '';
                _this.form.nursing_problem = res.data.nursing_problem;
                _this.form.questionText = res.data.questionText;
                _this.form.family_sign = res.data.family_sign.indexOf(_this.get_host) != -1 ? res.data.family_sign : _this.get_host + res.data.family_sign;
                _this.form.nurse_sign = res.data.nurse_sign.indexOf(_this.get_host) != -1 ? res.data.nurse_sign : _this.get_host + res.data.nurse_sign;
                // this.form.feeding_guidance=res.data.feeding_guidance=='1'?'母乳':(res.data.feeding_guidance=='2'?'牛奶':(res.data.feeding_guidance=='3'?'混合喂养':(res.data.feeding_guidance=='4'?'按时添加辅食':(res.data.feeding_guidance=='5'?'少食多餐':''))))
                //喂养指导
                var Arr2 = res.data.feeding_guidance;
                for (var _i = 0; _i < Arr2.length; _i++) {
                    if (Arr2[_i] == '1') {
                        Arr2[_i] = '母乳';
                    } else if (Arr2[_i] == '2') {
                        Arr2[_i] = '牛奶';
                    } else if (Arr2[_i] == '3') {
                        Arr2[_i] = '混合喂养';
                    } else if (Arr2[_i] == '4') {
                        Arr2[_i] = '按时添加辅食';
                    } else if (Arr2[_i] == '5') {
                        Arr2[_i] = '少食多餐';
                    }
                    _this.form.feeding_guidance = Arr2.join();
                }
                _this.form.other_desc = res.data.other_desc;
                //预防感冒
                var Arr = res.data.cold_prevention.split(',');
                for (var _i2 = 0; _i2 < Arr.length; _i2++) {
                    if (Arr[_i2] == '1') {
                        Arr[_i2] = '注意保暖';
                    } else if (Arr[_i2] == '2') {
                        Arr[_i2] = '减少探视';
                    } else if (Arr[_i2] == '3') {
                        Arr[_i2] = '日光浴';
                    } else if (Arr[_i2] == '4') {
                        Arr[_i2] = '少到公共场合';
                    } else if (Arr[_i2] == '5') {
                        Arr[_i2] = '如有不适随时到医院就诊';
                    }
                    _this.form.cold_prevention = Arr.join();
                }
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4319b365","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bb_form_d_detail.vue
var bb_form_d_detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("新生儿满月评估表")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","readonly":""},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","readonly":""},model:{value:(_vm.form.baby_name),callback:function ($$v) {_vm.$set(_vm.form, "baby_name", $$v)},expression:"form.baby_name"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"入住时间：","readonly":""},model:{value:(_vm.form.check_in_time),callback:function ($$v) {_vm.$set(_vm.form, "check_in_time", $$v)},expression:"form.check_in_time"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体温(℃)：","readonly":""},model:{value:(_vm.form.body_heat),callback:function ($$v) {_vm.$set(_vm.form, "body_heat", $$v)},expression:"form.body_heat"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体重(g)：","readonly":""},model:{value:(_vm.form.weight),callback:function ($$v) {_vm.$set(_vm.form, "weight", $$v)},expression:"form.weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身长（cm）：","readonly":""},model:{value:(_vm.form.boby_length),callback:function ($$v) {_vm.$set(_vm.form, "boby_length", $$v)},expression:"form.boby_length"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"营养发育：","readonly":""},model:{value:(_vm.form.nutritional_status),callback:function ($$v) {_vm.$set(_vm.form, "nutritional_status", $$v)},expression:"form.nutritional_status"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"面色：","readonly":""},model:{value:(_vm.form.complexion),callback:function ($$v) {_vm.$set(_vm.form, "complexion", $$v)},expression:"form.complexion"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"哭声：","readonly":""},model:{value:(_vm.form.crying),callback:function ($$v) {_vm.$set(_vm.form, "crying", $$v)},expression:"form.crying"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"反应：","readonly":""},model:{value:(_vm.form.reaction),callback:function ($$v) {_vm.$set(_vm.form, "reaction", $$v)},expression:"form.reaction"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"皮肤：","readonly":""},model:{value:(_vm.form.skin_case),callback:function ($$v) {_vm.$set(_vm.form, "skin_case", $$v)},expression:"form.skin_case"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"破损部位：","readonly":""},model:{value:(_vm.form.skin_broken_position),callback:function ($$v) {_vm.$set(_vm.form, "skin_broken_position", $$v)},expression:"form.skin_broken_position"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"皮疹部位：","readonly":""},model:{value:(_vm.form.skin_rash_position),callback:function ($$v) {_vm.$set(_vm.form, "skin_rash_position", $$v)},expression:"form.skin_rash_position"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("喂养情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.feeding_status),callback:function ($$v) {_vm.$set(_vm.form, "feeding_status", $$v)},expression:"form.feeding_status"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"奶粉品牌：","readonly":""},model:{value:(_vm.form.milk_brand),callback:function ($$v) {_vm.$set(_vm.form, "milk_brand", $$v)},expression:"form.milk_brand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("排尿：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.exc_micturition_case),callback:function ($$v) {_vm.$set(_vm.form, "exc_micturition_case", $$v)},expression:"form.exc_micturition_case"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"次数(次/天)：","readonly":""},model:{value:(_vm.form.exc_micturition_num),callback:function ($$v) {_vm.$set(_vm.form, "exc_micturition_num", $$v)},expression:"form.exc_micturition_num"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("排便：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.exc_defecation_case),callback:function ($$v) {_vm.$set(_vm.form, "exc_defecation_case", $$v)},expression:"form.exc_defecation_case"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"次数(次/天)：","readonly":""},model:{value:(_vm.form.exc_defecation_num),callback:function ($$v) {_vm.$set(_vm.form, "exc_defecation_num", $$v)},expression:"form.exc_defecation_num"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("肌张力及活动：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.muscle_status),callback:function ($$v) {_vm.$set(_vm.form, "muscle_status", $$v)},expression:"form.muscle_status"}})],1)]),_vm._v(" "),_c('x-input',{staticClass:"item vux-1px-t",attrs:{"title":"受限部位：","readonly":""},model:{value:(_vm.form.muscle_limited_position),callback:function ($$v) {_vm.$set(_vm.form, "muscle_limited_position", $$v)},expression:"form.muscle_limited_position"}}),_vm._v(" "),_c('x-input',{staticClass:"item vux-1px-t",attrs:{"title":"丧失部位：","readonly":""},model:{value:(_vm.form.muscle_lose_position),callback:function ($$v) {_vm.$set(_vm.form, "muscle_lose_position", $$v)},expression:"form.muscle_lose_position"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("现存护理问题：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.nursing_problem_status),callback:function ($$v) {_vm.$set(_vm.form, "nursing_problem_status", $$v)},expression:"form.nursing_problem_status"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.nursing_problem),callback:function ($$v) {_vm.$set(_vm.form, "nursing_problem", $$v)},expression:"form.nursing_problem"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("喂养指导：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.feeding_guidance),callback:function ($$v) {_vm.$set(_vm.form, "feeding_guidance", $$v)},expression:"form.feeding_guidance"}})],1)]),_vm._v(" "),_c('x-input',{staticStyle:{"padding-left":"0px"},attrs:{"title":"喂养指导其他：","readonly":""},model:{value:(_vm.form.other_desc),callback:function ($$v) {_vm.$set(_vm.form, "other_desc", $$v)},expression:"form.other_desc"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("预防感冒：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",staticStyle:{"width":"800px"},attrs:{"readonly":""},model:{value:(_vm.form.cold_prevention),callback:function ($$v) {_vm.$set(_vm.form, "cold_prevention", $$v)},expression:"form.cold_prevention"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("家属签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',[_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.family_sign,"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护士签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',[_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.nurse_sign,"alt":""}})])])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("修改")])],1)],1)}
var bb_form_d_detail_staticRenderFns = []
var bb_form_d_detail_esExports = { render: bb_form_d_detail_render, staticRenderFns: bb_form_d_detail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bb_form_d_detail = (bb_form_d_detail_esExports);
// CONCATENATED MODULE: ./src/components/bb_form_d_detail.vue
function bb_form_d_detail_injectStyle (ssrContext) {
  __webpack_require__("3Bm5")
}
var bb_form_d_detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bb_form_d_detail___vue_template_functional__ = false
/* styles */
var bb_form_d_detail___vue_styles__ = bb_form_d_detail_injectStyle
/* scopeId */
var bb_form_d_detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bb_form_d_detail___vue_module_identifier__ = null
var bb_form_d_detail_Component = bb_form_d_detail_normalizeComponent(
  components_bb_form_d_detail,
  selectortype_template_index_0_src_components_bb_form_d_detail,
  bb_form_d_detail___vue_template_functional__,
  bb_form_d_detail___vue_styles__,
  bb_form_d_detail___vue_scopeId__,
  bb_form_d_detail___vue_module_identifier__
)

/* harmony default export */ var src_components_bb_form_d_detail = (bb_form_d_detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_d_edit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bb_form_d_edit = ({
    name: 'bb_form_d_edit',
    data: function data() {
        return {
            get_host: host.host,
            coldArr: [],
            form: {
                skin_case: [],
                feeding_guidance: [],
                family_sign: '',
                nurse_sign: ''
            },
            showUserSignature: true,
            showSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.family_sign = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.family_sign = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.family_sign = '';
        },

        // 保存客户签名
        saveUserName: function saveUserName() {
            var signature = 'signature2';
            var png = this.$refs[signature].save();
            this.form.nurse_sign = encodeURI(png);
            this.showUserSignature = true;
        },

        //编辑客户签名
        editUserName: function editUserName() {
            this.showUserSignature = false;
            this.form.nurse_sign = '';
        },

        //清除客户签名
        clearUserName: function clearUserName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.nurse_sign = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            this.form.token = this.$cookie.get('token');
            this.form.number_id = this.$cookie.get('id');
            this.form.maternal_info_id = this.$route.query.id;
            this.form.id = this.$route.query.form_id;
            this.form.store_id = this.$cookie.get('store_id');
            this.form.baby_id = this.$route.query.baby_id;
            var params = this.form;
            console.info(params);
            this.form.cold_prevention = this.coldArr.join();
            if (params.room_number == '' || params.baby_name == '' || params.check_in_time == '' || params.weight == '' || params.boby_length == '' || params.nutritional_status == '' || params.complexion == '' || params.crying == '' || params.reaction == '' || params.skin_case.length == 0 || params.feeding_status == '' || params.exc_micturition_case == '' || params.exc_micturition_num == '' || params.exc_defecation_case == '' || params.exc_defecation_num == '' || params.muscle_status == '' || params.nursing_problem_status == '' || params.questionText == '' || params.feeding_guidance.length == 0 || params.cold_prevention == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请完善表单'
                });
                return;
            }
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.otherFormApi.updateNewNewbornFullmoonAssessData(params).then(function (res) {
                _this.$vux.loading.hide();
                console.info(res);
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            form_id: res.data.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'bb_form_d_edit'
                        }
                    });
                }
            });
        }
    },
    created: function created() {
        var _this2 = this;

        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.form_id
        };
        this.$vux.loading.show({
            text: '正在加载'
        });
        console.info(params);
        Api.otherFormApi.getNewbornFullmoonAssessFind(params).then(function (res) {
            _this2.$vux.loading.hide();
            console.info("详情", res.data);
            if (res.errcode == 200) {
                _this2.form = res.data;
                _this2.coldArr = res.data.cold_prevention.split(',');
                _this2.form.skin_case = res.data.skin_case;
                _this2.form.feeding_guidance = res.data.feeding_guidance;
                _this2.form.family_sign = res.data.family_sign.indexOf(_this2.get_host) != -1 ? res.data.family_sign : _this2.get_host + res.data.family_sign;
                _this2.form.nurse_sign = res.data.nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.nurse_sign : _this2.get_host + res.data.nurse_sign;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_d_edit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_bb_form_d_edit = ({
    name: 'bb_form_d_edit',
    data: function data() {
        return {
            get_host: host.host,
            coldArr: [],
            form: {
                skin_case: [],
                feeding_guidance: [],
                family_sign: '',
                nurse_sign: ''
            },
            showUserSignature: true,
            showSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.family_sign = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.family_sign = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.family_sign = '';
        },

        // 保存客户签名
        saveUserName: function saveUserName() {
            var signature = 'signature2';
            var png = this.$refs[signature].save();
            this.form.nurse_sign = encodeURI(png);
            this.showUserSignature = true;
        },

        //编辑客户签名
        editUserName: function editUserName() {
            this.showUserSignature = false;
            this.form.nurse_sign = '';
        },

        //清除客户签名
        clearUserName: function clearUserName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.nurse_sign = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            this.form.token = this.$cookie.get('token');
            this.form.number_id = this.$cookie.get('id');
            this.form.maternal_info_id = this.$route.query.id;
            this.form.id = this.$route.query.form_id;
            this.form.store_id = this.$cookie.get('store_id');
            this.form.baby_id = this.$route.query.baby_id;
            var params = this.form;
            console.info(params);
            this.form.cold_prevention = this.coldArr.join();
            if (params.room_number == '' || params.baby_name == '' || params.check_in_time == '' || params.weight == '' || params.boby_length == '' || params.nutritional_status == '' || params.complexion == '' || params.crying == '' || params.reaction == '' || params.skin_case.length == 0 || params.feeding_status == '' || params.exc_micturition_case == '' || params.exc_micturition_num == '' || params.exc_defecation_case == '' || params.exc_defecation_num == '' || params.muscle_status == '' || params.nursing_problem_status == '' || params.questionText == '' || params.feeding_guidance.length == 0 || params.cold_prevention == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请完善表单'
                });
                return;
            }
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.otherFormApi.updateNewNewbornFullmoonAssessData(params).then(function (res) {
                _this.$vux.loading.hide();
                console.info(res);
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            form_id: res.data.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'bb_form_d_edit'
                        }
                    });
                }
            });
        }
    },
    created: function created() {
        var _this2 = this;

        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.form_id
        };
        this.$vux.loading.show({
            text: '正在加载'
        });
        console.info(params);
        Api.otherFormApi.getNewbornFullmoonAssessFind(params).then(function (res) {
            _this2.$vux.loading.hide();
            console.info("详情", res.data);
            if (res.errcode == 200) {
                _this2.form = res.data;
                _this2.coldArr = res.data.cold_prevention.split(',');
                _this2.form.skin_case = res.data.skin_case;
                _this2.form.feeding_guidance = res.data.feeding_guidance;
                _this2.form.family_sign = res.data.family_sign.indexOf(_this2.get_host) != -1 ? res.data.family_sign : _this2.get_host + res.data.family_sign;
                _this2.form.nurse_sign = res.data.nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.nurse_sign : _this2.get_host + res.data.nurse_sign;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46367036","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bb_form_d_edit.vue
var bb_form_d_edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("新生儿满月评估表")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","placeholder":"请输入房号","readonly":""},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","placeholder":"请输入姓名","readonly":""},model:{value:(_vm.form.baby_name),callback:function ($$v) {_vm.$set(_vm.form, "baby_name", $$v)},expression:"form.baby_name"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"入住时间"},model:{value:(_vm.form.check_in_time),callback:function ($$v) {_vm.$set(_vm.form, "check_in_time", $$v)},expression:"form.check_in_time"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体温(℃)：","placeholder":"请输入体温（单位：℃）"},model:{value:(_vm.form.body_heat),callback:function ($$v) {_vm.$set(_vm.form, "body_heat", $$v)},expression:"form.body_heat"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体重(g)：","placeholder":"请输入体重(单位：g)"},model:{value:(_vm.form.weight),callback:function ($$v) {_vm.$set(_vm.form, "weight", $$v)},expression:"form.weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身长（cm）：","placeholder":"请输入身长(单位：cm)"},model:{value:(_vm.form.boby_length),callback:function ($$v) {_vm.$set(_vm.form, "boby_length", $$v)},expression:"form.boby_length"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("营养发育：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nutritional_status),callback:function ($$v) {_vm.$set(_vm.form, "nutritional_status", $$v)},expression:"form.nutritional_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("过剩")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("中等")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("差")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("面色：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.complexion),callback:function ($$v) {_vm.$set(_vm.form, "complexion", $$v)},expression:"form.complexion"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红润")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("黄染")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("哭声：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.crying),callback:function ($$v) {_vm.$set(_vm.form, "crying", $$v)},expression:"form.crying"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("响亮")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("微弱")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("反应：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.reaction),callback:function ($$v) {_vm.$set(_vm.form, "reaction", $$v)},expression:"form.reaction"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("迟钝")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("差")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("皮肤：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.skin_case),callback:function ($$v) {_vm.$set(_vm.form, "skin_case", $$v)},expression:"form.skin_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("完整")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("破损")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("红润")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("黄染")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("红臀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"6"}},[_vm._v("干燥")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"7"}},[_vm._v("皮疹")])],1)],1)]),_vm._v(" "),_c('x-input',{staticClass:"item vux-1px-t",attrs:{"title":"破损部位：","placeholder":"请输入"},model:{value:(_vm.form.skin_broken_position),callback:function ($$v) {_vm.$set(_vm.form, "skin_broken_position", $$v)},expression:"form.skin_broken_position"}}),_vm._v(" "),_c('x-input',{staticClass:"item vux-1px-t",attrs:{"title":"皮疹部位：","placeholder":"请输入"},model:{value:(_vm.form.skin_rash_position),callback:function ($$v) {_vm.$set(_vm.form, "skin_rash_position", $$v)},expression:"form.skin_rash_position"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("喂养情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.feeding_status),callback:function ($$v) {_vm.$set(_vm.form, "feeding_status", $$v)},expression:"form.feeding_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("母乳喂养")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("人工喂养")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("混合喂养")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"奶粉品牌：","placeholder":"请输入奶粉品牌"},model:{value:(_vm.form.milk_brand),callback:function ($$v) {_vm.$set(_vm.form, "milk_brand", $$v)},expression:"form.milk_brand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("排尿：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.exc_micturition_case),callback:function ($$v) {_vm.$set(_vm.form, "exc_micturition_case", $$v)},expression:"form.exc_micturition_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"5px"}},[_vm._v("排尿次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.exc_micturition_num),expression:"form.exc_micturition_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.exc_micturition_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "exc_micturition_num", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("排便：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.exc_defecation_case),callback:function ($$v) {_vm.$set(_vm.form, "exc_defecation_case", $$v)},expression:"form.exc_defecation_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("便秘")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("未排")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("腹泻")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"5px"}},[_vm._v("排便次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.exc_defecation_num),expression:"form.exc_defecation_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.exc_defecation_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "exc_defecation_num", $event.target.value)}}})])])],1),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("肌张力及活动：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.muscle_status),callback:function ($$v) {_vm.$set(_vm.form, "muscle_status", $$v)},expression:"form.muscle_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("受限")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("丧失")])],1)],1)]),_vm._v(" "),_c('x-input',{staticClass:"item vux-1px-t",attrs:{"title":"受限部位：","placeholder":"请输入部位"},model:{value:(_vm.form.muscle_limited_position),callback:function ($$v) {_vm.$set(_vm.form, "muscle_limited_position", $$v)},expression:"form.muscle_limited_position"}}),_vm._v(" "),_c('x-input',{staticClass:"item vux-1px-t",attrs:{"title":"丧失部位：","placeholder":"请输入部位"},model:{value:(_vm.form.muscle_lose_position),callback:function ($$v) {_vm.$set(_vm.form, "muscle_lose_position", $$v)},expression:"form.muscle_lose_position"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("现存护理问题：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nursing_problem_status),callback:function ($$v) {_vm.$set(_vm.form, "nursing_problem_status", $$v)},expression:"form.nursing_problem_status"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"placeholder":"问题描述"},model:{value:(_vm.form.nursing_problem),callback:function ($$v) {_vm.$set(_vm.form, "nursing_problem", $$v)},expression:"form.nursing_problem"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("喂养指导：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.feeding_guidance),callback:function ($$v) {_vm.$set(_vm.form, "feeding_guidance", $$v)},expression:"form.feeding_guidance"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("母乳")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("牛奶")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("混合喂养")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("按时添加辅食")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("少食多餐")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"其他","placeholder":"请输入"},model:{value:(_vm.form.other_desc),callback:function ($$v) {_vm.$set(_vm.form, "other_desc", $$v)},expression:"form.other_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("预防感冒：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.coldArr),callback:function ($$v) {_vm.coldArr=$$v},expression:"coldArr"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("注意保暖")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("减少探视")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("日光浴")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("少到公共场合")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("如有不适随时到医院就诊")])],1)],1)])],1),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("家属签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.family_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.family_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护士签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showUserSignature)?_c('div',[(_vm.form.nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.nurse_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editUserName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveUserName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearUserName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交修改")])],1)],1)}
var bb_form_d_edit_staticRenderFns = []
var bb_form_d_edit_esExports = { render: bb_form_d_edit_render, staticRenderFns: bb_form_d_edit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bb_form_d_edit = (bb_form_d_edit_esExports);
// CONCATENATED MODULE: ./src/components/bb_form_d_edit.vue
function bb_form_d_edit_injectStyle (ssrContext) {
  __webpack_require__("xkOK")
}
var bb_form_d_edit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bb_form_d_edit___vue_template_functional__ = false
/* styles */
var bb_form_d_edit___vue_styles__ = bb_form_d_edit_injectStyle
/* scopeId */
var bb_form_d_edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bb_form_d_edit___vue_module_identifier__ = null
var bb_form_d_edit_Component = bb_form_d_edit_normalizeComponent(
  components_bb_form_d_edit,
  selectortype_template_index_0_src_components_bb_form_d_edit,
  bb_form_d_edit___vue_template_functional__,
  bb_form_d_edit___vue_styles__,
  bb_form_d_edit___vue_scopeId__,
  bb_form_d_edit___vue_module_identifier__
)

/* harmony default export */ var src_components_bb_form_d_edit = (bb_form_d_edit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_e.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bb_form_e = ({
    name: 'bb_form_e',
    data: function data() {
        return {
            form: {
                room_number: '',
                is_card: '',
                entry_time: '',
                mom_name: '',
                baby_name: '',
                sex: '',
                birth_date: '',
                birth_week: '',
                blood_type: '',
                birth_weight: '',
                birth_length: '',
                apgar_score: '',
                leave_hos_summary: '',
                use_drug_history: '',
                allergy_history: '',
                new_baby_special_case: '',
                leave_hos_jaundice_num: '',
                feed_case: '',
                milk_pow_brand: '',
                micturition_case_status: '',
                micturition_num: '',
                habit_diaper_brand: '',
                defecation_case_status: '',
                defecation_num: '',
                temperature: '',
                heart_rate_num: '110',
                breathing_num: '36',
                entry_weight: '',
                spotwo: '90',
                face_colour: '',
                cry_sound: '',
                reaction: '',
                limb: '',
                limb_tension_activity: '',
                limb_tension_activity_be_position: '',
                limb_tension_activity_lose_position: '',
                birth_injury: '',
                nerve_reflex_status: '',
                nerve_reflex_abnormal_desc: '',
                nutrition_development_status: '',
                whole_body_skin_status: [],
                whole_body_skin_be_position: '',
                whole_body_skin_rash_position: '',
                whole_body_skin_remark: '',
                front_fontanelle_status: '',
                mouth_mucosa_status: '',
                eye_blood_secretion: '',
                sclera_yellow_dye: '',
                nose_shape_status: '',
                nose_shape_place_name: '',
                breathing_open_status: '',
                ear_shape_status: '',
                ear_shape_place_name: '',
                abroad_ear_way_shape_status: '',
                abroad_ear_way_shape_desc: '',
                umbilicus_abnorma_status: '',
                navelscab_case_staus: '',
                suck_case_status: '',
                hips_status: '',
                vulva_status: '',
                vulva_abnormal_case_desc: '',
                anus_status: '',
                urethra_crack_status: '',
                falsex_menstruation_status: '',
                prevention_inoculation_status: '',
                prevention_inoculation_has_name: '',
                jaundice_index_num: '',
                other_special_case: '',
                baby_nursing_abstract: '',
                autograph: '',
                customer_sign: '',
                assessment_time: '',
                prevention_inoculation_bar: [],
                baby_nursing_check: []
            },
            showUserSignature: false,
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        save: function save() {
            var signature = 'signature1';
            var sigRef = this.$refs[signature];
            var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
            if (!comp || !comp.save) return;
            var png = comp.save();
            this.form.autograph = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.autograph = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var sigRef = this.$refs[signature];
            if (Array.isArray(sigRef)) {
                sigRef.forEach(function (c) {
                    return c && c.clear && c.clear();
                });
            } else if (sigRef && sigRef.clear) {
                sigRef.clear();
            }
            this.form.autograph = '';
        },

        // 保存客户签名
        saveUserName: function saveUserName() {
            var signature = 'signature2';
            var sigRef = this.$refs[signature];
            var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
            if (!comp || !comp.save) return;
            var png = comp.save();
            this.form.customer_sign = encodeURI(png);
            this.showUserSignature = true;
        },

        //编辑客户签名
        editUserName: function editUserName() {
            this.showUserSignature = false;
            this.form.customer_sign = '';
        },

        //清除客户签名
        clearUserName: function clearUserName() {
            var signature = 'signature2';
            var sigRef = this.$refs[signature];
            if (Array.isArray(sigRef)) {
                sigRef.forEach(function (c) {
                    return c && c.clear && c.clear();
                });
            } else if (sigRef && sigRef.clear) {
                sigRef.clear();
            }
            this.form.customer_sign = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            this.form.token = this.$cookie.get('token');
            this.form.number_id = this.$cookie.get('id');
            this.form.maternal_info_id = this.$route.query.id;
            this.form.store_id = this.$cookie.get('store_id');
            this.form.baby_id = this.$route.query.child_id;
            var params = this.form;

            if (params.room_number == '' || params.is_card == '' || params.entry_time == '' || params.mom_name == '' || params.baby_name == '' || params.sex == '' || params.birth_date == '' || params.birth_week == '' || params.blood_type == '' || params.birth_weight == '' || params.birth_length == '' || params.apgar_score == '' || params.leave_hos_summary == '' || params.use_drug_history == '' || params.allergy_history == '' || params.new_baby_special_case == '' || params.leave_hos_jaundice_num == '' || params.feed_case == '' || params.micturition_case_status == '' || params.micturition_num == '' || params.habit_diaper_brand == '' || params.defecation_case_status == '' || params.temperature == '' || params.heart_rate_num == '' || params.breathing_num == '' || params.entry_weight == '' || params.spotwo == '' || params.face_colour == '' || params.cry_sound == '' || params.reaction == '' || params.limb == '' || params.limb_tension_activity == '' || params.birth_injury == '' || params.nerve_reflex_status == '' || params.nutrition_development_status == '' || params.whole_body_skin_status.length == 0 || params.front_fontanelle_status == '' || params.mouth_mucosa_status == '' || params.eye_blood_secretion == '' || params.sclera_yellow_dye == '' || params.nose_shape_status == '' || params.breathing_open_status == '' || params.ear_shape_status == '' || params.abroad_ear_way_shape_status == '' || params.umbilicus_abnorma_status == '' || params.navelscab_case_staus == '' || params.suck_case_status == '' || params.hips_status == '' || params.vulva_status == '' || params.anus_status == '' || params.urethra_crack_status == '' || params.falsex_menstruation_status == '' || params.prevention_inoculation_status == '' || params.jaundice_index_num == '' || params.other_special_case == '' || params.autograph == '' || params.assessment_time == '' || params.baby_nursing_check.length == 0 || params.customer_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请完善表单'
                });
                return;
            }
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.otherFormApi.addNewBornCheckAssessData(params).then(function (res) {
                _this.$vux.loading.hide();
                console.info(res);
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            form_id: res.data.id,
                            name: 'bb_form_e'
                        }
                    });
                }
            });
        },
        apiMemberInfo: function apiMemberInfo() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.form.mom_name = res.data.name;
                    _this2.form.room_number = res.data.room_name;
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        get_baby_list: function get_baby_list() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.baby_list = res.data;
                    var get_boby_id = _this3.$route.query.child_id;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = get_iterator_default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            if (item.id == get_boby_id) {
                                _this3.form.is_card = item.hand_card;
                                // this.form.birth_length = item.weight
                                _this3.form.baby_name = item.name;
                                _this3.form.sex = item.sex == '1' ? '男' : '女';
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    created: function created() {
        this.apiMemberInfo();
        this.get_baby_list();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_e.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_bb_form_e = ({
    name: 'bb_form_e',
    data: function data() {
        return {
            form: {
                room_number: '',
                is_card: '',
                entry_time: '',
                mom_name: '',
                baby_name: '',
                sex: '',
                birth_date: '',
                birth_week: '',
                blood_type: '',
                birth_weight: '',
                birth_length: '',
                apgar_score: '',
                leave_hos_summary: '',
                use_drug_history: '',
                allergy_history: '',
                new_baby_special_case: '',
                leave_hos_jaundice_num: '',
                feed_case: '',
                milk_pow_brand: '',
                micturition_case_status: '',
                micturition_num: '',
                habit_diaper_brand: '',
                defecation_case_status: '',
                defecation_num: '',
                temperature: '',
                heart_rate_num: '110',
                breathing_num: '36',
                entry_weight: '',
                spotwo: '90',
                face_colour: '',
                cry_sound: '',
                reaction: '',
                limb: '',
                limb_tension_activity: '',
                limb_tension_activity_be_position: '',
                limb_tension_activity_lose_position: '',
                birth_injury: '',
                nerve_reflex_status: '',
                nerve_reflex_abnormal_desc: '',
                nutrition_development_status: '',
                whole_body_skin_status: [],
                whole_body_skin_be_position: '',
                whole_body_skin_rash_position: '',
                whole_body_skin_remark: '',
                front_fontanelle_status: '',
                mouth_mucosa_status: '',
                eye_blood_secretion: '',
                sclera_yellow_dye: '',
                nose_shape_status: '',
                nose_shape_place_name: '',
                breathing_open_status: '',
                ear_shape_status: '',
                ear_shape_place_name: '',
                abroad_ear_way_shape_status: '',
                abroad_ear_way_shape_desc: '',
                umbilicus_abnorma_status: '',
                navelscab_case_staus: '',
                suck_case_status: '',
                hips_status: '',
                vulva_status: '',
                vulva_abnormal_case_desc: '',
                anus_status: '',
                urethra_crack_status: '',
                falsex_menstruation_status: '',
                prevention_inoculation_status: '',
                prevention_inoculation_has_name: '',
                jaundice_index_num: '',
                other_special_case: '',
                baby_nursing_abstract: '',
                autograph: '',
                customer_sign: '',
                assessment_time: '',
                prevention_inoculation_bar: [],
                baby_nursing_check: []
            },
            showUserSignature: false,
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        save: function save() {
            var signature = 'signature1';
            var sigRef = this.$refs[signature];
            var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
            if (!comp || !comp.save) return;
            var png = comp.save();
            this.form.autograph = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.autograph = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var sigRef = this.$refs[signature];
            if (Array.isArray(sigRef)) {
                sigRef.forEach(function (c) {
                    return c && c.clear && c.clear();
                });
            } else if (sigRef && sigRef.clear) {
                sigRef.clear();
            }
            this.form.autograph = '';
        },

        // 保存客户签名
        saveUserName: function saveUserName() {
            var signature = 'signature2';
            var sigRef = this.$refs[signature];
            var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
            if (!comp || !comp.save) return;
            var png = comp.save();
            this.form.customer_sign = encodeURI(png);
            this.showUserSignature = true;
        },

        //编辑客户签名
        editUserName: function editUserName() {
            this.showUserSignature = false;
            this.form.customer_sign = '';
        },

        //清除客户签名
        clearUserName: function clearUserName() {
            var signature = 'signature2';
            var sigRef = this.$refs[signature];
            if (Array.isArray(sigRef)) {
                sigRef.forEach(function (c) {
                    return c && c.clear && c.clear();
                });
            } else if (sigRef && sigRef.clear) {
                sigRef.clear();
            }
            this.form.customer_sign = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            this.form.token = this.$cookie.get('token');
            this.form.number_id = this.$cookie.get('id');
            this.form.maternal_info_id = this.$route.query.id;
            this.form.store_id = this.$cookie.get('store_id');
            this.form.baby_id = this.$route.query.child_id;
            var params = this.form;

            if (params.room_number == '' || params.is_card == '' || params.entry_time == '' || params.mom_name == '' || params.baby_name == '' || params.sex == '' || params.birth_date == '' || params.birth_week == '' || params.blood_type == '' || params.birth_weight == '' || params.birth_length == '' || params.apgar_score == '' || params.leave_hos_summary == '' || params.use_drug_history == '' || params.allergy_history == '' || params.new_baby_special_case == '' || params.leave_hos_jaundice_num == '' || params.feed_case == '' || params.micturition_case_status == '' || params.micturition_num == '' || params.habit_diaper_brand == '' || params.defecation_case_status == '' || params.temperature == '' || params.heart_rate_num == '' || params.breathing_num == '' || params.entry_weight == '' || params.spotwo == '' || params.face_colour == '' || params.cry_sound == '' || params.reaction == '' || params.limb == '' || params.limb_tension_activity == '' || params.birth_injury == '' || params.nerve_reflex_status == '' || params.nutrition_development_status == '' || params.whole_body_skin_status.length == 0 || params.front_fontanelle_status == '' || params.mouth_mucosa_status == '' || params.eye_blood_secretion == '' || params.sclera_yellow_dye == '' || params.nose_shape_status == '' || params.breathing_open_status == '' || params.ear_shape_status == '' || params.abroad_ear_way_shape_status == '' || params.umbilicus_abnorma_status == '' || params.navelscab_case_staus == '' || params.suck_case_status == '' || params.hips_status == '' || params.vulva_status == '' || params.anus_status == '' || params.urethra_crack_status == '' || params.falsex_menstruation_status == '' || params.prevention_inoculation_status == '' || params.jaundice_index_num == '' || params.other_special_case == '' || params.autograph == '' || params.assessment_time == '' || params.baby_nursing_check.length == 0 || params.customer_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请完善表单'
                });
                return;
            }
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.otherFormApi.addNewBornCheckAssessData(params).then(function (res) {
                _this.$vux.loading.hide();
                console.info(res);
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            form_id: res.data.id,
                            name: 'bb_form_e'
                        }
                    });
                }
            });
        },
        apiMemberInfo: function apiMemberInfo() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.form.mom_name = res.data.name;
                    _this2.form.room_number = res.data.room_name;
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        get_baby_list: function get_baby_list() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this3.baby_list = res.data;
                    var get_boby_id = _this3.$route.query.child_id;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = get_iterator_default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            if (item.id == get_boby_id) {
                                _this3.form.is_card = item.hand_card;
                                // this.form.birth_length = item.weight
                                _this3.form.baby_name = item.name;
                                _this3.form.sex = item.sex == '1' ? '男' : '女';
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    created: function created() {
        this.apiMemberInfo();
        this.get_baby_list();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d928d53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bb_form_e.vue
var bb_form_e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("新生儿入住评估单")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","placeholder":"请输入房号","readonly":""},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","disabled":""},model:{value:(_vm.form.is_card),callback:function ($$v) {_vm.$set(_vm.form, "is_card", $$v)},expression:"form.is_card"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"入所时间："},model:{value:(_vm.form.entry_time),callback:function ($$v) {_vm.$set(_vm.form, "entry_time", $$v)},expression:"form.entry_time"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","placeholder":"请输入母亲姓名","readonly":""},model:{value:(_vm.form.mom_name),callback:function ($$v) {_vm.$set(_vm.form, "mom_name", $$v)},expression:"form.mom_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","placeholder":"请输入姓名","readonly":""},model:{value:(_vm.form.baby_name),callback:function ($$v) {_vm.$set(_vm.form, "baby_name", $$v)},expression:"form.baby_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","placeholder":"请输入性别","readonly":""},model:{value:(_vm.form.sex),callback:function ($$v) {_vm.$set(_vm.form, "sex", $$v)},expression:"form.sex"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"出生日期："},model:{value:(_vm.form.birth_date),callback:function ($$v) {_vm.$set(_vm.form, "birth_date", $$v)},expression:"form.birth_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生孕周：","placeholder":"请输入出生孕周"},model:{value:(_vm.form.birth_week),callback:function ($$v) {_vm.$set(_vm.form, "birth_week", $$v)},expression:"form.birth_week"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"血型：","placeholder":"请输入血型"},model:{value:(_vm.form.blood_type),callback:function ($$v) {_vm.$set(_vm.form, "blood_type", $$v)},expression:"form.blood_type"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生体重(g)：","placeholder":"请输入出生体重(单位：g)"},model:{value:(_vm.form.birth_weight),callback:function ($$v) {_vm.$set(_vm.form, "birth_weight", $$v)},expression:"form.birth_weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身长(cm)：","placeholder":"请输入身长(单位：cm)"},model:{value:(_vm.form.birth_length),callback:function ($$v) {_vm.$set(_vm.form, "birth_length", $$v)},expression:"form.birth_length"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"Apgar评分(分)：","placeholder":"请输入Apgar评分(单位：分)"},model:{value:(_vm.form.apgar_score),callback:function ($$v) {_vm.$set(_vm.form, "apgar_score", $$v)},expression:"form.apgar_score"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("出院小结：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.leave_hos_summary),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_summary", $$v)},expression:"form.leave_hos_summary"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"用药史：","placeholder":"请输入用药史"},model:{value:(_vm.form.use_drug_history),callback:function ($$v) {_vm.$set(_vm.form, "use_drug_history", $$v)},expression:"form.use_drug_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"过敏史：","placeholder":"请输入过敏史"},model:{value:(_vm.form.allergy_history),callback:function ($$v) {_vm.$set(_vm.form, "allergy_history", $$v)},expression:"form.allergy_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"新生儿特殊情况：","placeholder":"请输入新生儿特殊情况"},model:{value:(_vm.form.new_baby_special_case),callback:function ($$v) {_vm.$set(_vm.form, "new_baby_special_case", $$v)},expression:"form.new_baby_special_case"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出院黄疸指数(TCB)：","placeholder":"请输入出院黄疸指数（单位：mg/dL）"},model:{value:(_vm.form.leave_hos_jaundice_num),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_jaundice_num", $$v)},expression:"form.leave_hos_jaundice_num"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("喂养情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.feed_case),callback:function ($$v) {_vm.$set(_vm.form, "feed_case", $$v)},expression:"form.feed_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("母乳喂养")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("人工喂养")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("混合喂养")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"奶粉品牌：","placeholder":"请输入奶粉品牌"},model:{value:(_vm.form.milk_pow_brand),callback:function ($$v) {_vm.$set(_vm.form, "milk_pow_brand", $$v)},expression:"form.milk_pow_brand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("排尿情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.micturition_case_status),callback:function ($$v) {_vm.$set(_vm.form, "micturition_case_status", $$v)},expression:"form.micturition_case_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("尿少")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("排尿次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.micturition_num),expression:"form.micturition_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.micturition_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "micturition_num", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("惯用尿布品牌：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请输入惯用尿布品牌："},model:{value:(_vm.form.habit_diaper_brand),callback:function ($$v) {_vm.$set(_vm.form, "habit_diaper_brand", $$v)},expression:"form.habit_diaper_brand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t item vux-1px-b"},[_c('div',{staticClass:"label"},[_vm._v("排便情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.defecation_case_status),callback:function ($$v) {_vm.$set(_vm.form, "defecation_case_status", $$v)},expression:"form.defecation_case_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("便秘")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("腹泻")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("未排")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item item vux-1px-b"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"5px"}},[_vm._v("排便次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.defecation_num),expression:"form.defecation_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.defecation_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "defecation_num", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"mainTitleCenter"},[_vm._v("入所检查")]),_vm._v(" "),_c('x-input',{attrs:{"title":"体温(℃)：","placeholder":"请输入体温（单位：℃）"},model:{value:(_vm.form.temperature),callback:function ($$v) {_vm.$set(_vm.form, "temperature", $$v)},expression:"form.temperature"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"心率(次/分)：","placeholder":"请输入心率（单位：次/分）"},model:{value:(_vm.form.heart_rate_num),callback:function ($$v) {_vm.$set(_vm.form, "heart_rate_num", $$v)},expression:"form.heart_rate_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"呼吸(次/分)：","placeholder":"请输入呼吸（单位：次/分）"},model:{value:(_vm.form.breathing_num),callback:function ($$v) {_vm.$set(_vm.form, "breathing_num", $$v)},expression:"form.breathing_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体重(g)：","placeholder":"请输入体重（单位：g）"},model:{value:(_vm.form.entry_weight),callback:function ($$v) {_vm.$set(_vm.form, "entry_weight", $$v)},expression:"form.entry_weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"SPO2(%)：","placeholder":"请输入心率（单位：%）"},model:{value:(_vm.form.spotwo),callback:function ($$v) {_vm.$set(_vm.form, "spotwo", $$v)},expression:"form.spotwo"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("面色：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.face_colour),callback:function ($$v) {_vm.$set(_vm.form, "face_colour", $$v)},expression:"form.face_colour"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红润")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("黄染")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("哭声：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.cry_sound),callback:function ($$v) {_vm.$set(_vm.form, "cry_sound", $$v)},expression:"form.cry_sound"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("响亮")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("微弱")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("反应：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.reaction),callback:function ($$v) {_vm.$set(_vm.form, "reaction", $$v)},expression:"form.reaction"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("差")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("四肢：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.limb),callback:function ($$v) {_vm.$set(_vm.form, "limb", $$v)},expression:"form.limb"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("白")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("紫")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("四肢张力及活动：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.limb_tension_activity),callback:function ($$v) {_vm.$set(_vm.form, "limb_tension_activity", $$v)},expression:"form.limb_tension_activity"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("受限")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"部位：","placeholder":"请输入受限部位"},model:{value:(_vm.form.limb_tension_activity_be_position),callback:function ($$v) {_vm.$set(_vm.form, "limb_tension_activity_be_position", $$v)},expression:"form.limb_tension_activity_be_position"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"丧失（部位）：","placeholder":"请输入丧失部位"},model:{value:(_vm.form.limb_tension_activity_lose_position),callback:function ($$v) {_vm.$set(_vm.form, "limb_tension_activity_lose_position", $$v)},expression:"form.limb_tension_activity_lose_position"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("产伤：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.birth_injury),callback:function ($$v) {_vm.$set(_vm.form, "birth_injury", $$v)},expression:"form.birth_injury"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("神经反射：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nerve_reflex_status),callback:function ($$v) {_vm.$set(_vm.form, "nerve_reflex_status", $$v)},expression:"form.nerve_reflex_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("异常")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"异常描述"},model:{value:(_vm.form.nerve_reflex_abnormal_desc),callback:function ($$v) {_vm.$set(_vm.form, "nerve_reflex_abnormal_desc", $$v)},expression:"form.nerve_reflex_abnormal_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("营养发育：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nutrition_development_status),callback:function ($$v) {_vm.$set(_vm.form, "nutrition_development_status", $$v)},expression:"form.nutrition_development_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("过剩")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("滞后")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("全身皮肤：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.whole_body_skin_status),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_status", $$v)},expression:"form.whole_body_skin_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红润")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("黄染")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("完整")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("破损")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("红臀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"6"}},[_vm._v("干燥")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"7"}},[_vm._v("皮疹")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"8"}},[_vm._v("脓包")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"9"}},[_vm._v("硬肿")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"10"}},[_vm._v("水肿")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("破损部位：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请输入"},model:{value:(_vm.form.whole_body_skin_be_position),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_be_position", $$v)},expression:"form.whole_body_skin_be_position"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("皮疹部位：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请输入"},model:{value:(_vm.form.whole_body_skin_rash_position),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_rash_position", $$v)},expression:"form.whole_body_skin_rash_position"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("全身皮肤备注：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请输入"},model:{value:(_vm.form.whole_body_skin_remark),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_remark", $$v)},expression:"form.whole_body_skin_remark"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("前囟：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.front_fontanelle_status),callback:function ($$v) {_vm.$set(_vm.form, "front_fontanelle_status", $$v)},expression:"form.front_fontanelle_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("平坦")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("肿胀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("凹陷")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("口腔粘膜：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.mouth_mucosa_status),callback:function ($$v) {_vm.$set(_vm.form, "mouth_mucosa_status", $$v)},expression:"form.mouth_mucosa_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("清洁")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("破溃")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("白斑")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("腭裂")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("唇裂")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("眼结膜充血和分泌物：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.eye_blood_secretion),callback:function ($$v) {_vm.$set(_vm.form, "eye_blood_secretion", $$v)},expression:"form.eye_blood_secretion"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("巩膜黄染：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.sclera_yellow_dye),callback:function ($$v) {_vm.$set(_vm.form, "sclera_yellow_dye", $$v)},expression:"form.sclera_yellow_dye"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("鼻外观畸形：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nose_shape_status),callback:function ($$v) {_vm.$set(_vm.form, "nose_shape_status", $$v)},expression:"form.nose_shape_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请描述"},model:{value:(_vm.form.nose_shape_place_name),callback:function ($$v) {_vm.$set(_vm.form, "nose_shape_place_name", $$v)},expression:"form.nose_shape_place_name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("呼吸通畅：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.breathing_open_status),callback:function ($$v) {_vm.$set(_vm.form, "breathing_open_status", $$v)},expression:"form.breathing_open_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("耳外观畸形：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.ear_shape_status),callback:function ($$v) {_vm.$set(_vm.form, "ear_shape_status", $$v)},expression:"form.ear_shape_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请描述"},model:{value:(_vm.form.ear_shape_place_name),callback:function ($$v) {_vm.$set(_vm.form, "ear_shape_place_name", $$v)},expression:"form.ear_shape_place_name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("外耳道畸形：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.abroad_ear_way_shape_status),callback:function ($$v) {_vm.$set(_vm.form, "abroad_ear_way_shape_status", $$v)},expression:"form.abroad_ear_way_shape_status"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请描述"},model:{value:(_vm.form.abroad_ear_way_shape_desc),callback:function ($$v) {_vm.$set(_vm.form, "abroad_ear_way_shape_desc", $$v)},expression:"form.abroad_ear_way_shape_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("脐部红肿及异常分泌物：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.umbilicus_abnorma_status),callback:function ($$v) {_vm.$set(_vm.form, "umbilicus_abnorma_status", $$v)},expression:"form.umbilicus_abnorma_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("脐痂脱落情况：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.navelscab_case_staus),callback:function ($$v) {_vm.$set(_vm.form, "navelscab_case_staus", $$v)},expression:"form.navelscab_case_staus"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("未")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("已")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("吸吮情况：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.suck_case_status),callback:function ($$v) {_vm.$set(_vm.form, "suck_case_status", $$v)},expression:"form.suck_case_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("较差")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("差")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("臀部：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.hips_status),callback:function ($$v) {_vm.$set(_vm.form, "hips_status", $$v)},expression:"form.hips_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("稍红")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("红臀")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("外阴：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.vulva_status),callback:function ($$v) {_vm.$set(_vm.form, "vulva_status", $$v)},expression:"form.vulva_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("异常")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请描述"},model:{value:(_vm.form.vulva_abnormal_case_desc),callback:function ($$v) {_vm.$set(_vm.form, "vulva_abnormal_case_desc", $$v)},expression:"form.vulva_abnormal_case_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("肛门：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.anus_status),callback:function ($$v) {_vm.$set(_vm.form, "anus_status", $$v)},expression:"form.anus_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("尿道下裂：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.urethra_crack_status),callback:function ($$v) {_vm.$set(_vm.form, "urethra_crack_status", $$v)},expression:"form.urethra_crack_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("假性月经：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.falsex_menstruation_status),callback:function ($$v) {_vm.$set(_vm.form, "falsex_menstruation_status", $$v)},expression:"form.falsex_menstruation_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("预防接种：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.prevention_inoculation_status),callback:function ($$v) {_vm.$set(_vm.form, "prevention_inoculation_status", $$v)},expression:"form.prevention_inoculation_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("预防接种类型：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.prevention_inoculation_bar),callback:function ($$v) {_vm.$set(_vm.form, "prevention_inoculation_bar", $$v)},expression:"form.prevention_inoculation_bar"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("乙肝疫苗")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("卡介苗")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请描述"},model:{value:(_vm.form.prevention_inoculation_has_name),callback:function ($$v) {_vm.$set(_vm.form, "prevention_inoculation_has_name", $$v)},expression:"form.prevention_inoculation_has_name"}})],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"入所黄疸指数(TCB)：","placeholder":"请输入入所黄疸指数（单位：mg/dl）"},model:{value:(_vm.form.jaundice_index_num),callback:function ($$v) {_vm.$set(_vm.form, "jaundice_index_num", $$v)},expression:"form.jaundice_index_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"其他特殊情况：","placeholder":"请输入"},model:{value:(_vm.form.other_special_case),callback:function ($$v) {_vm.$set(_vm.form, "other_special_case", $$v)},expression:"form.other_special_case"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"margin-left":"14px"}},[_c('div',{staticClass:"label",staticStyle:{"margin-left":"5px"}},[_vm._v("婴儿护理要点：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{staticStyle:{"margin-right":"10px"},attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.baby_nursing_check),callback:function ($$v) {_vm.$set(_vm.form, "baby_nursing_check", $$v)},expression:"form.baby_nursing_check"}},[_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"1"}},[_vm._v("单独睡小床，不需要用枕头")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"2"}},[_vm._v("避免阳光直射眼睛，及早晒太阳")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"3"}},[_vm._v("选择纯棉衣物，衣服单独清洗")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"4"}},[_vm._v("奶瓶清洁消毒后再用，加强生活护理")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"5"}},[_vm._v("吃奶后拍嗝，加强母乳喂养指导")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"6"}},[_vm._v("注意脐带护理、五官护理、皮肤护理")])],1)],1)]),_vm._v(" "),_c('x-textarea',{attrs:{"title":"婴儿护理要点描述（不足书写请加附页）：","placeholder":"请输入"},model:{value:(_vm.form.baby_nursing_abstract),callback:function ($$v) {_vm.$set(_vm.form, "baby_nursing_abstract", $$v)},expression:"form.baby_nursing_abstract"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护士签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.autograph)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.autograph,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("客户签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showUserSignature)?_c('div',[(_vm.form.customer_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.customer_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editUserName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveUserName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearUserName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('datetime',{attrs:{"title":"评估时间："},model:{value:(_vm.form.assessment_time),callback:function ($$v) {_vm.$set(_vm.form, "assessment_time", $$v)},expression:"form.assessment_time"}}),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var bb_form_e_staticRenderFns = []
var bb_form_e_esExports = { render: bb_form_e_render, staticRenderFns: bb_form_e_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bb_form_e = (bb_form_e_esExports);
// CONCATENATED MODULE: ./src/components/bb_form_e.vue
function bb_form_e_injectStyle (ssrContext) {
  __webpack_require__("02nE")
}
var bb_form_e_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bb_form_e___vue_template_functional__ = false
/* styles */
var bb_form_e___vue_styles__ = bb_form_e_injectStyle
/* scopeId */
var bb_form_e___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bb_form_e___vue_module_identifier__ = null
var bb_form_e_Component = bb_form_e_normalizeComponent(
  components_bb_form_e,
  selectortype_template_index_0_src_components_bb_form_e,
  bb_form_e___vue_template_functional__,
  bb_form_e___vue_styles__,
  bb_form_e___vue_scopeId__,
  bb_form_e___vue_module_identifier__
)

/* harmony default export */ var src_components_bb_form_e = (bb_form_e_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_e_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bb_form_e_detail = ({
    name: 'bb_form_e_detail',
    data: function data() {
        return {
            get_host: host.host,
            form: {
                room_number: '',
                is_card: '',
                entry_time: '',
                mom_name: '',
                baby_name: '',
                sex: '',
                birth_date: '',
                birth_week: '',
                blood_type: '',
                birth_weight: '',
                birth_length: '',
                apgar_score: '',
                leave_hos_summary: '',
                use_drug_history: '',
                allergy_history: '',
                new_baby_special_case: '',
                leave_hos_jaundice_num: '',
                feed_case: '',
                milk_pow_brand: '',
                micturition_case_status: '',
                micturition_num: '',
                habit_diaper_brand: '',
                defecation_case_status: '',
                defecation_num: '',
                temperature: '',
                heart_rate_num: '',
                breathing_num: '',
                entry_weight: '',
                spotwo: '',
                face_colour: '',
                cry_sound: '',
                reaction: '',
                limb: '',
                limb_tension_activity: '',
                limb_tension_activity_be_position: '',
                limb_tension_activity_lose_position: '',
                birth_injury: '',
                nerve_reflex_status: '',
                nerve_reflex_abnormal_desc: '',
                nutrition_development_status: '',
                whole_body_skin_status: '',
                whole_body_skin_be_position: '',
                whole_body_skin_rash_position: '',
                whole_body_skin_remark: '',
                front_fontanelle_status: '',
                mouth_mucosa_status: '',
                eye_blood_secretion: '',
                sclera_yellow_dye: '',
                nose_shape_status: '',
                nose_shape_place_name: '',
                breathing_open_status: '',
                ear_shape_status: '',
                ear_shape_place_name: '',
                abroad_ear_way_shape_status: '',
                abroad_ear_way_shape_desc: '',
                umbilicus_abnorma_status: '',
                navelscab_case_staus: '',
                suck_case_status: '',
                hips_status: '',
                vulva_status: '',
                vulva_abnormal_case_desc: '',
                anus_status: '',
                urethra_crack_status: '',
                falsex_menstruation_status: '',
                prevention_inoculation_status: '',
                prevention_inoculation_has_name: '',
                jaundice_index_num: '',
                other_special_case: '',
                baby_nursing_abstract: '',
                autograph: '',
                assessment_time: ''
            },

            showSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.autograph = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.autograph = '';
        },
        submitForm: function submitForm() {
            this.$router.replace({
                path: '/bb_form_e_edit',
                query: {
                    id: this.$route.query.id,
                    form_id: this.$route.query.form_id,
                    baby_id: this.$route.query.baby_id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info('用户基本信息', res);
                if (res.errcode == 1) {
                    _this.form.mom_name = res.data.name;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        }
    },
    created: function created() {
        var _this2 = this;

        this.apiMemberInfo();
        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.form_id
        };
        this.$vux.loading.show({
            text: '正在加载'
        });
        console.info(params);
        Api.otherFormApi.getNewBornCheckAssessFind(params).then(function (res) {
            _this2.$vux.loading.hide();
            console.info("详情", res.data);
            if (res.errcode == 200) {
                _this2.form.room_number = res.data.room_number;
                _this2.form.is_card = res.data.is_card;
                _this2.form.entry_time = res.data.entry_time;
                // this.form.mom_name=res.data.mom_name
                _this2.form.baby_name = res.data.baby_name;
                _this2.form.sex = res.data.sex;
                _this2.form.birth_date = res.data.birth_date;
                _this2.form.birth_week = res.data.birth_week;
                _this2.form.blood_type = res.data.blood_type;
                _this2.form.birth_weight = res.data.birth_weight;
                _this2.form.birth_length = res.data.birth_length;
                _this2.form.apgar_score = res.data.apgar_score;
                _this2.form.leave_hos_summary = res.data.leave_hos_summary == '1' ? '有' : '无';
                _this2.form.use_drug_history = res.data.use_drug_history;
                _this2.form.allergy_history = res.data.allergy_history;
                _this2.form.new_baby_special_case = res.data.new_baby_special_case;
                _this2.form.leave_hos_jaundice_num = res.data.leave_hos_jaundice_num;
                _this2.form.feed_case = res.data.feed_case == '1' ? '纯母乳喂养' : res.data.feed_case == '2' ? '人工喂养' : '混合喂养';
                _this2.form.milk_pow_brand = res.data.milk_pow_brand;
                _this2.form.micturition_case_status = res.data.micturition_case_status == '1' ? '正常' : '尿少';
                _this2.form.micturition_num = res.data.micturition_num;
                _this2.form.habit_diaper_brand = res.data.habit_diaper_brand;
                _this2.form.defecation_case_status = res.data.defecation_case_status == '1' ? '正常' : res.data.defecation_case_status == '2' ? '便秘' : res.data.defecation_case_status == '3' ? '腹泻' : '未排';
                _this2.form.defecation_num = res.data.defecation_num;
                _this2.form.temperature = res.data.temperature;
                _this2.form.heart_rate_num = res.data.heart_rate_num;
                _this2.form.breathing_num = res.data.breathing_num;
                _this2.form.entry_weight = res.data.entry_weight;
                _this2.form.spotwo = res.data.spotwo;
                _this2.form.face_colour = res.data.face_colour == '1' ? '红润' : '黄染';
                _this2.form.cry_sound = res.data.cry_sound == '1' ? '响' : '弱';
                _this2.form.reaction = res.data.reaction == '1' ? '好' : '差';
                _this2.form.limb = res.data.limb == '1' ? '红' : res.data.limb == '2' ? '白' : '紫';
                _this2.form.limb_tension_activity = res.data.limb_tension_activity == '1' ? '良好' : res.data.limb_tension_activity == '2' ? '受限' : '';
                _this2.form.limb_tension_activity_be_position = res.data.limb_tension_activity_be_position;
                _this2.form.limb_tension_activity_lose_position = res.data.limb_tension_activity_lose_position;
                _this2.form.birth_injury = res.data.birth_injury == '1' ? '有' : '无';
                _this2.form.nerve_reflex_status = res.data.nerve_reflex_status == '1' ? '正常' : '异常';
                _this2.form.nerve_reflex_abnormal_desc = res.data.nerve_reflex_abnormal_desc;
                _this2.form.nutrition_development_status = res.data.nutrition_development_status == '1' ? '正常' : res.data.nutrition_development_status == '2' ? '过剩' : '滞后';
                // this.form.whole_body_skin_status=res.data.whole_body_skin_status=='1'?'红润':(res.data.whole_body_skin_status=='2'?'黄染':(res.data.whole_body_skin_status=='3'?'完整':(res.data.whole_body_skin_status=='4'?'破损':(res.data.whole_body_skin_status=='5'?'红臀':(res.data.whole_body_skin_status=='6'?'干燥':(res.data.whole_body_skin_status=='7'?'皮疹':(res.data.whole_body_skin_status=='8'?'脓包':(res.data.whole_body_skin_status=='9'?'硬肿':'水肿'))))))))
                //全身皮肤
                var Arr1 = res.data.whole_body_skin_status;
                for (var i = 0; i < Arr1.length; i++) {
                    if (Arr1[i] == '1') {
                        Arr1[i] = '红润';
                    } else if (Arr1[i] == '2') {
                        Arr1[i] = '黄染';
                    } else if (Arr1[i] == '3') {
                        Arr1[i] = '完整';
                    } else if (Arr1[i] == '4') {
                        Arr1[i] = '破损';
                    } else if (Arr1[i] == '5') {
                        Arr1[i] = '红臀';
                    } else if (Arr1[i] == '6') {
                        Arr1[i] = '干燥';
                    } else if (Arr1[i] == '7') {
                        Arr1[i] = '皮疹';
                    } else if (Arr1[i] == '8') {
                        Arr1[i] = '脓包';
                    } else if (Arr1[i] == '9') {
                        Arr1[i] = '硬肿';
                    } else if (Arr1[i] == '10') {
                        Arr1[i] = '水肿';
                    }
                    _this2.form.whole_body_skin_status = Arr1.join();
                }
                _this2.form.whole_body_skin_be_position = res.data.whole_body_skin_be_position;
                _this2.form.whole_body_skin_rash_position = res.data.whole_body_skin_rash_position;
                _this2.form.whole_body_skin_remark = res.data.whole_body_skin_remark;
                _this2.form.front_fontanelle_status = res.data.front_fontanelle_status == '1' ? '平坦' : res.data.front_fontanelle_status == '2' ? '肿胀' : '凹陷';
                _this2.form.mouth_mucosa_status = res.data.mouth_mucosa_status == '1' ? '清洁' : res.data.mouth_mucosa_status == '2' ? '破溃' : res.data.mouth_mucosa_status == '3' ? '白斑' : res.data.mouth_mucosa_status == '4' ? '腭裂' : '唇裂';
                _this2.form.eye_blood_secretion = res.data.eye_blood_secretion == '1' ? '有' : '无';
                _this2.form.sclera_yellow_dye = res.data.sclera_yellow_dye == '1' ? '有' : '无';
                _this2.form.nose_shape_status = res.data.nose_shape_status == '1' ? '有' : '无';
                _this2.form.nose_shape_place_name = res.data.nose_shape_place_name;
                _this2.form.breathing_open_status = res.data.breathing_open_status == '1' ? '是' : '否';
                _this2.form.ear_shape_status = res.data.ear_shape_status == '1' ? '有' : '无';
                _this2.form.ear_shape_place_name = res.data.ear_shape_place_name;
                _this2.form.abroad_ear_way_shape_status = res.data.abroad_ear_way_shape_status == '1' ? '有' : '无';
                _this2.form.abroad_ear_way_shape_desc = res.data.abroad_ear_way_shape_desc;
                _this2.form.umbilicus_abnorma_status = res.data.umbilicus_abnorma_status == '1' ? '有' : '无';
                _this2.form.navelscab_case_staus = res.data.navelscab_case_staus == '1' ? '未' : '已';
                _this2.form.suck_case_status = res.data.suck_case_status == '1' ? '好' : res.data.suck_case_status == '2' ? '较差' : '差';
                _this2.form.hips_status = res.data.hips_status == '1' ? '正常' : res.data.hips_status == '2' ? '稍红' : '红臀';
                _this2.form.vulva_status = res.data.vulva_status == '1' ? '正常' : '异常';
                _this2.form.vulva_abnormal_case_desc = res.data.vulva_abnormal_case_desc;
                _this2.form.anus_status = res.data.anus_status == '1' ? '有' : '无';
                _this2.form.urethra_crack_status = res.data.urethra_crack_status == '1' ? '有' : '无';
                _this2.form.falsex_menstruation_status = res.data.falsex_menstruation_status == '1' ? '有' : '无';
                _this2.form.prevention_inoculation_status = res.data.prevention_inoculation_status == '1' ? '有' : '无';
                _this2.form.prevention_inoculation_has_name = res.data.prevention_inoculation_has_name;
                _this2.form.jaundice_index_num = res.data.jaundice_index_num;
                _this2.form.other_special_case = res.data.other_special_case;
                _this2.form.baby_nursing_abstract = res.data.baby_nursing_abstract;
                _this2.form.autograph = res.data.autograph.indexOf(_this2.get_host) != -1 ? res.data.autograph : _this2.get_host + res.data.autograph;
                _this2.form.customer_sign = res.data.customer_sign.indexOf(_this2.get_host) != -1 ? res.data.customer_sign : _this2.get_host + res.data.customer_sign;
                _this2.form.assessment_time = res.data.assessment_time;
                //婴儿护理要点
                var Arr2 = res.data.baby_nursing_check;
                for (var _i = 0; _i < Arr2.length; _i++) {
                    if (Arr2[_i] == '1') {
                        Arr2[_i] = '单独睡小床，不需要用枕头';
                    } else if (Arr2[_i] == '2') {
                        Arr2[_i] = '避免阳光直射眼睛，及早晒太阳';
                    } else if (Arr2[_i] == '3') {
                        Arr2[_i] = '选择纯棉衣物，衣服单独清洗';
                    } else if (Arr2[_i] == '4') {
                        Arr2[_i] = '奶瓶清洁消毒后再用，加强生活护理';
                    } else if (Arr2[_i] == '5') {
                        Arr2[_i] = '吃奶后拍嗝，加强母乳喂养指导';
                    } else if (Arr2[_i] == '6') {
                        Arr2[_i] = '注意脐带护理、五官护理、皮肤护理';
                    }
                    _this2.form.baby_nursing_check = Arr2.join();
                }
                //接种类型
                var Arr3 = res.data.prevention_inoculation_bar;
                for (var _i2 = 0; _i2 < Arr3.length; _i2++) {
                    if (Arr3[_i2] == '1') {
                        Arr3[_i2] = '乙肝疫苗';
                    } else if (Arr3[_i2] == '2') {
                        Arr3[_i2] = '卡介苗';
                    }
                    _this2.form.prevention_inoculation_bar = Arr3.join();
                }
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_e_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_bb_form_e_detail = ({
    name: 'bb_form_e_detail',
    data: function data() {
        return {
            get_host: host.host,
            form: {
                room_number: '',
                is_card: '',
                entry_time: '',
                mom_name: '',
                baby_name: '',
                sex: '',
                birth_date: '',
                birth_week: '',
                blood_type: '',
                birth_weight: '',
                birth_length: '',
                apgar_score: '',
                leave_hos_summary: '',
                use_drug_history: '',
                allergy_history: '',
                new_baby_special_case: '',
                leave_hos_jaundice_num: '',
                feed_case: '',
                milk_pow_brand: '',
                micturition_case_status: '',
                micturition_num: '',
                habit_diaper_brand: '',
                defecation_case_status: '',
                defecation_num: '',
                temperature: '',
                heart_rate_num: '',
                breathing_num: '',
                entry_weight: '',
                spotwo: '',
                face_colour: '',
                cry_sound: '',
                reaction: '',
                limb: '',
                limb_tension_activity: '',
                limb_tension_activity_be_position: '',
                limb_tension_activity_lose_position: '',
                birth_injury: '',
                nerve_reflex_status: '',
                nerve_reflex_abnormal_desc: '',
                nutrition_development_status: '',
                whole_body_skin_status: '',
                whole_body_skin_be_position: '',
                whole_body_skin_rash_position: '',
                whole_body_skin_remark: '',
                front_fontanelle_status: '',
                mouth_mucosa_status: '',
                eye_blood_secretion: '',
                sclera_yellow_dye: '',
                nose_shape_status: '',
                nose_shape_place_name: '',
                breathing_open_status: '',
                ear_shape_status: '',
                ear_shape_place_name: '',
                abroad_ear_way_shape_status: '',
                abroad_ear_way_shape_desc: '',
                umbilicus_abnorma_status: '',
                navelscab_case_staus: '',
                suck_case_status: '',
                hips_status: '',
                vulva_status: '',
                vulva_abnormal_case_desc: '',
                anus_status: '',
                urethra_crack_status: '',
                falsex_menstruation_status: '',
                prevention_inoculation_status: '',
                prevention_inoculation_has_name: '',
                jaundice_index_num: '',
                other_special_case: '',
                baby_nursing_abstract: '',
                autograph: '',
                assessment_time: ''
            },

            showSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.autograph = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.autograph = '';
        },
        submitForm: function submitForm() {
            this.$router.replace({
                path: '/bb_form_e_edit',
                query: {
                    id: this.$route.query.id,
                    form_id: this.$route.query.form_id,
                    baby_id: this.$route.query.baby_id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info('用户基本信息', res);
                if (res.errcode == 1) {
                    _this.form.mom_name = res.data.name;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        }
    },
    created: function created() {
        var _this2 = this;

        this.apiMemberInfo();
        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.form_id
        };
        this.$vux.loading.show({
            text: '正在加载'
        });
        console.info(params);
        Api.otherFormApi.getNewBornCheckAssessFind(params).then(function (res) {
            _this2.$vux.loading.hide();
            console.info("详情", res.data);
            if (res.errcode == 200) {
                _this2.form.room_number = res.data.room_number;
                _this2.form.is_card = res.data.is_card;
                _this2.form.entry_time = res.data.entry_time;
                // this.form.mom_name=res.data.mom_name
                _this2.form.baby_name = res.data.baby_name;
                _this2.form.sex = res.data.sex;
                _this2.form.birth_date = res.data.birth_date;
                _this2.form.birth_week = res.data.birth_week;
                _this2.form.blood_type = res.data.blood_type;
                _this2.form.birth_weight = res.data.birth_weight;
                _this2.form.birth_length = res.data.birth_length;
                _this2.form.apgar_score = res.data.apgar_score;
                _this2.form.leave_hos_summary = res.data.leave_hos_summary == '1' ? '有' : '无';
                _this2.form.use_drug_history = res.data.use_drug_history;
                _this2.form.allergy_history = res.data.allergy_history;
                _this2.form.new_baby_special_case = res.data.new_baby_special_case;
                _this2.form.leave_hos_jaundice_num = res.data.leave_hos_jaundice_num;
                _this2.form.feed_case = res.data.feed_case == '1' ? '纯母乳喂养' : res.data.feed_case == '2' ? '人工喂养' : '混合喂养';
                _this2.form.milk_pow_brand = res.data.milk_pow_brand;
                _this2.form.micturition_case_status = res.data.micturition_case_status == '1' ? '正常' : '尿少';
                _this2.form.micturition_num = res.data.micturition_num;
                _this2.form.habit_diaper_brand = res.data.habit_diaper_brand;
                _this2.form.defecation_case_status = res.data.defecation_case_status == '1' ? '正常' : res.data.defecation_case_status == '2' ? '便秘' : res.data.defecation_case_status == '3' ? '腹泻' : '未排';
                _this2.form.defecation_num = res.data.defecation_num;
                _this2.form.temperature = res.data.temperature;
                _this2.form.heart_rate_num = res.data.heart_rate_num;
                _this2.form.breathing_num = res.data.breathing_num;
                _this2.form.entry_weight = res.data.entry_weight;
                _this2.form.spotwo = res.data.spotwo;
                _this2.form.face_colour = res.data.face_colour == '1' ? '红润' : '黄染';
                _this2.form.cry_sound = res.data.cry_sound == '1' ? '响' : '弱';
                _this2.form.reaction = res.data.reaction == '1' ? '好' : '差';
                _this2.form.limb = res.data.limb == '1' ? '红' : res.data.limb == '2' ? '白' : '紫';
                _this2.form.limb_tension_activity = res.data.limb_tension_activity == '1' ? '良好' : res.data.limb_tension_activity == '2' ? '受限' : '';
                _this2.form.limb_tension_activity_be_position = res.data.limb_tension_activity_be_position;
                _this2.form.limb_tension_activity_lose_position = res.data.limb_tension_activity_lose_position;
                _this2.form.birth_injury = res.data.birth_injury == '1' ? '有' : '无';
                _this2.form.nerve_reflex_status = res.data.nerve_reflex_status == '1' ? '正常' : '异常';
                _this2.form.nerve_reflex_abnormal_desc = res.data.nerve_reflex_abnormal_desc;
                _this2.form.nutrition_development_status = res.data.nutrition_development_status == '1' ? '正常' : res.data.nutrition_development_status == '2' ? '过剩' : '滞后';
                // this.form.whole_body_skin_status=res.data.whole_body_skin_status=='1'?'红润':(res.data.whole_body_skin_status=='2'?'黄染':(res.data.whole_body_skin_status=='3'?'完整':(res.data.whole_body_skin_status=='4'?'破损':(res.data.whole_body_skin_status=='5'?'红臀':(res.data.whole_body_skin_status=='6'?'干燥':(res.data.whole_body_skin_status=='7'?'皮疹':(res.data.whole_body_skin_status=='8'?'脓包':(res.data.whole_body_skin_status=='9'?'硬肿':'水肿'))))))))
                //全身皮肤
                var Arr1 = res.data.whole_body_skin_status;
                for (var i = 0; i < Arr1.length; i++) {
                    if (Arr1[i] == '1') {
                        Arr1[i] = '红润';
                    } else if (Arr1[i] == '2') {
                        Arr1[i] = '黄染';
                    } else if (Arr1[i] == '3') {
                        Arr1[i] = '完整';
                    } else if (Arr1[i] == '4') {
                        Arr1[i] = '破损';
                    } else if (Arr1[i] == '5') {
                        Arr1[i] = '红臀';
                    } else if (Arr1[i] == '6') {
                        Arr1[i] = '干燥';
                    } else if (Arr1[i] == '7') {
                        Arr1[i] = '皮疹';
                    } else if (Arr1[i] == '8') {
                        Arr1[i] = '脓包';
                    } else if (Arr1[i] == '9') {
                        Arr1[i] = '硬肿';
                    } else if (Arr1[i] == '10') {
                        Arr1[i] = '水肿';
                    }
                    _this2.form.whole_body_skin_status = Arr1.join();
                }
                _this2.form.whole_body_skin_be_position = res.data.whole_body_skin_be_position;
                _this2.form.whole_body_skin_rash_position = res.data.whole_body_skin_rash_position;
                _this2.form.whole_body_skin_remark = res.data.whole_body_skin_remark;
                _this2.form.front_fontanelle_status = res.data.front_fontanelle_status == '1' ? '平坦' : res.data.front_fontanelle_status == '2' ? '肿胀' : '凹陷';
                _this2.form.mouth_mucosa_status = res.data.mouth_mucosa_status == '1' ? '清洁' : res.data.mouth_mucosa_status == '2' ? '破溃' : res.data.mouth_mucosa_status == '3' ? '白斑' : res.data.mouth_mucosa_status == '4' ? '腭裂' : '唇裂';
                _this2.form.eye_blood_secretion = res.data.eye_blood_secretion == '1' ? '有' : '无';
                _this2.form.sclera_yellow_dye = res.data.sclera_yellow_dye == '1' ? '有' : '无';
                _this2.form.nose_shape_status = res.data.nose_shape_status == '1' ? '有' : '无';
                _this2.form.nose_shape_place_name = res.data.nose_shape_place_name;
                _this2.form.breathing_open_status = res.data.breathing_open_status == '1' ? '是' : '否';
                _this2.form.ear_shape_status = res.data.ear_shape_status == '1' ? '有' : '无';
                _this2.form.ear_shape_place_name = res.data.ear_shape_place_name;
                _this2.form.abroad_ear_way_shape_status = res.data.abroad_ear_way_shape_status == '1' ? '有' : '无';
                _this2.form.abroad_ear_way_shape_desc = res.data.abroad_ear_way_shape_desc;
                _this2.form.umbilicus_abnorma_status = res.data.umbilicus_abnorma_status == '1' ? '有' : '无';
                _this2.form.navelscab_case_staus = res.data.navelscab_case_staus == '1' ? '未' : '已';
                _this2.form.suck_case_status = res.data.suck_case_status == '1' ? '好' : res.data.suck_case_status == '2' ? '较差' : '差';
                _this2.form.hips_status = res.data.hips_status == '1' ? '正常' : res.data.hips_status == '2' ? '稍红' : '红臀';
                _this2.form.vulva_status = res.data.vulva_status == '1' ? '正常' : '异常';
                _this2.form.vulva_abnormal_case_desc = res.data.vulva_abnormal_case_desc;
                _this2.form.anus_status = res.data.anus_status == '1' ? '有' : '无';
                _this2.form.urethra_crack_status = res.data.urethra_crack_status == '1' ? '有' : '无';
                _this2.form.falsex_menstruation_status = res.data.falsex_menstruation_status == '1' ? '有' : '无';
                _this2.form.prevention_inoculation_status = res.data.prevention_inoculation_status == '1' ? '有' : '无';
                _this2.form.prevention_inoculation_has_name = res.data.prevention_inoculation_has_name;
                _this2.form.jaundice_index_num = res.data.jaundice_index_num;
                _this2.form.other_special_case = res.data.other_special_case;
                _this2.form.baby_nursing_abstract = res.data.baby_nursing_abstract;
                _this2.form.autograph = res.data.autograph.indexOf(_this2.get_host) != -1 ? res.data.autograph : _this2.get_host + res.data.autograph;
                _this2.form.customer_sign = res.data.customer_sign.indexOf(_this2.get_host) != -1 ? res.data.customer_sign : _this2.get_host + res.data.customer_sign;
                _this2.form.assessment_time = res.data.assessment_time;
                //婴儿护理要点
                var Arr2 = res.data.baby_nursing_check;
                for (var _i = 0; _i < Arr2.length; _i++) {
                    if (Arr2[_i] == '1') {
                        Arr2[_i] = '单独睡小床，不需要用枕头';
                    } else if (Arr2[_i] == '2') {
                        Arr2[_i] = '避免阳光直射眼睛，及早晒太阳';
                    } else if (Arr2[_i] == '3') {
                        Arr2[_i] = '选择纯棉衣物，衣服单独清洗';
                    } else if (Arr2[_i] == '4') {
                        Arr2[_i] = '奶瓶清洁消毒后再用，加强生活护理';
                    } else if (Arr2[_i] == '5') {
                        Arr2[_i] = '吃奶后拍嗝，加强母乳喂养指导';
                    } else if (Arr2[_i] == '6') {
                        Arr2[_i] = '注意脐带护理、五官护理、皮肤护理';
                    }
                    _this2.form.baby_nursing_check = Arr2.join();
                }
                //接种类型
                var Arr3 = res.data.prevention_inoculation_bar;
                for (var _i2 = 0; _i2 < Arr3.length; _i2++) {
                    if (Arr3[_i2] == '1') {
                        Arr3[_i2] = '乙肝疫苗';
                    } else if (Arr3[_i2] == '2') {
                        Arr3[_i2] = '卡介苗';
                    }
                    _this2.form.prevention_inoculation_bar = Arr3.join();
                }
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77fde3fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bb_form_e_detail.vue
var bb_form_e_detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("新生儿入住评估单")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","readonly":""},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","readonly":""},model:{value:(_vm.form.is_card),callback:function ($$v) {_vm.$set(_vm.form, "is_card", $$v)},expression:"form.is_card"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"入所时间：","readonly":""},model:{value:(_vm.form.entry_time),callback:function ($$v) {_vm.$set(_vm.form, "entry_time", $$v)},expression:"form.entry_time"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","readonly":""},model:{value:(_vm.form.mom_name),callback:function ($$v) {_vm.$set(_vm.form, "mom_name", $$v)},expression:"form.mom_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","readonly":""},model:{value:(_vm.form.baby_name),callback:function ($$v) {_vm.$set(_vm.form, "baby_name", $$v)},expression:"form.baby_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","readonly":""},model:{value:(_vm.form.sex),callback:function ($$v) {_vm.$set(_vm.form, "sex", $$v)},expression:"form.sex"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"出生日期：","readonly":""},model:{value:(_vm.form.birth_date),callback:function ($$v) {_vm.$set(_vm.form, "birth_date", $$v)},expression:"form.birth_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生孕周：","readonly":""},model:{value:(_vm.form.birth_week),callback:function ($$v) {_vm.$set(_vm.form, "birth_week", $$v)},expression:"form.birth_week"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"血型：","readonly":""},model:{value:(_vm.form.blood_type),callback:function ($$v) {_vm.$set(_vm.form, "blood_type", $$v)},expression:"form.blood_type"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生体重(g)：","readonly":""},model:{value:(_vm.form.birth_weight),callback:function ($$v) {_vm.$set(_vm.form, "birth_weight", $$v)},expression:"form.birth_weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身长(cm)：","readonly":""},model:{value:(_vm.form.birth_length),callback:function ($$v) {_vm.$set(_vm.form, "birth_length", $$v)},expression:"form.birth_length"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"Apgar评分(分)：","readonly":""},model:{value:(_vm.form.apgar_score),callback:function ($$v) {_vm.$set(_vm.form, "apgar_score", $$v)},expression:"form.apgar_score"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出院小结：","readonly":""},model:{value:(_vm.form.leave_hos_summary),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_summary", $$v)},expression:"form.leave_hos_summary"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"用药史：","readonly":""},model:{value:(_vm.form.use_drug_history),callback:function ($$v) {_vm.$set(_vm.form, "use_drug_history", $$v)},expression:"form.use_drug_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"过敏史：","readonly":""},model:{value:(_vm.form.allergy_history),callback:function ($$v) {_vm.$set(_vm.form, "allergy_history", $$v)},expression:"form.allergy_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"新生儿特殊情况：","readonly":""},model:{value:(_vm.form.new_baby_special_case),callback:function ($$v) {_vm.$set(_vm.form, "new_baby_special_case", $$v)},expression:"form.new_baby_special_case"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出院黄疸指数(TCB)","readonly":""},model:{value:(_vm.form.leave_hos_jaundice_num),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_jaundice_num", $$v)},expression:"form.leave_hos_jaundice_num"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("喂养情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.feed_case),callback:function ($$v) {_vm.$set(_vm.form, "feed_case", $$v)},expression:"form.feed_case"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"奶粉品牌：","readonly":""},model:{value:(_vm.form.milk_pow_brand),callback:function ($$v) {_vm.$set(_vm.form, "milk_pow_brand", $$v)},expression:"form.milk_pow_brand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("排尿情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.micturition_case_status),callback:function ($$v) {_vm.$set(_vm.form, "micturition_case_status", $$v)},expression:"form.micturition_case_status"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"排尿次数(次/日)：","readonly":""},model:{value:(_vm.form.micturition_num),callback:function ($$v) {_vm.$set(_vm.form, "micturition_num", $$v)},expression:"form.micturition_num"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("惯用尿布品牌：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.habit_diaper_brand),callback:function ($$v) {_vm.$set(_vm.form, "habit_diaper_brand", $$v)},expression:"form.habit_diaper_brand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t item vux-1px-b"},[_c('div',{staticClass:"label"},[_vm._v("排便情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.defecation_case_status),callback:function ($$v) {_vm.$set(_vm.form, "defecation_case_status", $$v)},expression:"form.defecation_case_status"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"排便次数(次/日)：","readonly":""},model:{value:(_vm.form.defecation_num),callback:function ($$v) {_vm.$set(_vm.form, "defecation_num", $$v)},expression:"form.defecation_num"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"mainTitleCenter"},[_vm._v("入所检查")]),_vm._v(" "),_c('x-input',{attrs:{"title":"体温(℃)：","readonly":""},model:{value:(_vm.form.temperature),callback:function ($$v) {_vm.$set(_vm.form, "temperature", $$v)},expression:"form.temperature"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"心率(次/分)：","readonly":""},model:{value:(_vm.form.heart_rate_num),callback:function ($$v) {_vm.$set(_vm.form, "heart_rate_num", $$v)},expression:"form.heart_rate_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"呼吸(次/分)：","readonly":""},model:{value:(_vm.form.breathing_num),callback:function ($$v) {_vm.$set(_vm.form, "breathing_num", $$v)},expression:"form.breathing_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体重(g)：","readonly":""},model:{value:(_vm.form.entry_weight),callback:function ($$v) {_vm.$set(_vm.form, "entry_weight", $$v)},expression:"form.entry_weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"SPO2(%)：","readonly":""},model:{value:(_vm.form.spotwo),callback:function ($$v) {_vm.$set(_vm.form, "spotwo", $$v)},expression:"form.spotwo"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("面色：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.face_colour),callback:function ($$v) {_vm.$set(_vm.form, "face_colour", $$v)},expression:"form.face_colour"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("哭声：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.cry_sound),callback:function ($$v) {_vm.$set(_vm.form, "cry_sound", $$v)},expression:"form.cry_sound"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("反应：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.reaction),callback:function ($$v) {_vm.$set(_vm.form, "reaction", $$v)},expression:"form.reaction"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("四肢：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.limb),callback:function ($$v) {_vm.$set(_vm.form, "limb", $$v)},expression:"form.limb"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("四肢张力及活动：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.limb_tension_activity),callback:function ($$v) {_vm.$set(_vm.form, "limb_tension_activity", $$v)},expression:"form.limb_tension_activity"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"部位：","readonly":""},model:{value:(_vm.form.limb_tension_activity_be_position),callback:function ($$v) {_vm.$set(_vm.form, "limb_tension_activity_be_position", $$v)},expression:"form.limb_tension_activity_be_position"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"丧失（部位）：","readonly":""},model:{value:(_vm.form.limb_tension_activity_lose_position),callback:function ($$v) {_vm.$set(_vm.form, "limb_tension_activity_lose_position", $$v)},expression:"form.limb_tension_activity_lose_position"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("产伤：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.birth_injury),callback:function ($$v) {_vm.$set(_vm.form, "birth_injury", $$v)},expression:"form.birth_injury"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("神经反射：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.nerve_reflex_status),callback:function ($$v) {_vm.$set(_vm.form, "nerve_reflex_status", $$v)},expression:"form.nerve_reflex_status"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.nerve_reflex_abnormal_desc),callback:function ($$v) {_vm.$set(_vm.form, "nerve_reflex_abnormal_desc", $$v)},expression:"form.nerve_reflex_abnormal_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("营养发育：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.nutrition_development_status),callback:function ($$v) {_vm.$set(_vm.form, "nutrition_development_status", $$v)},expression:"form.nutrition_development_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("全身皮肤：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"readonly":""},model:{value:(_vm.form.whole_body_skin_status),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_status", $$v)},expression:"form.whole_body_skin_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("破损部位：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.whole_body_skin_be_position),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_be_position", $$v)},expression:"form.whole_body_skin_be_position"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("皮疹部位：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.whole_body_skin_rash_position),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_rash_position", $$v)},expression:"form.whole_body_skin_rash_position"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("全身皮肤备注：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.whole_body_skin_remark),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_remark", $$v)},expression:"form.whole_body_skin_remark"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("前囟：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.front_fontanelle_status),callback:function ($$v) {_vm.$set(_vm.form, "front_fontanelle_status", $$v)},expression:"form.front_fontanelle_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("口腔粘膜：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.mouth_mucosa_status),callback:function ($$v) {_vm.$set(_vm.form, "mouth_mucosa_status", $$v)},expression:"form.mouth_mucosa_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("眼结膜充血和分泌物：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.eye_blood_secretion),callback:function ($$v) {_vm.$set(_vm.form, "eye_blood_secretion", $$v)},expression:"form.eye_blood_secretion"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("巩膜黄染：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.sclera_yellow_dye),callback:function ($$v) {_vm.$set(_vm.form, "sclera_yellow_dye", $$v)},expression:"form.sclera_yellow_dye"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("鼻外观畸形：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.nose_shape_status),callback:function ($$v) {_vm.$set(_vm.form, "nose_shape_status", $$v)},expression:"form.nose_shape_status"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.nose_shape_place_name),callback:function ($$v) {_vm.$set(_vm.form, "nose_shape_place_name", $$v)},expression:"form.nose_shape_place_name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("呼吸通畅：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.breathing_open_status),callback:function ($$v) {_vm.$set(_vm.form, "breathing_open_status", $$v)},expression:"form.breathing_open_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("耳外观畸形：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.ear_shape_status),callback:function ($$v) {_vm.$set(_vm.form, "ear_shape_status", $$v)},expression:"form.ear_shape_status"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.ear_shape_place_name),callback:function ($$v) {_vm.$set(_vm.form, "ear_shape_place_name", $$v)},expression:"form.ear_shape_place_name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("外耳道畸形：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.abroad_ear_way_shape_status),callback:function ($$v) {_vm.$set(_vm.form, "abroad_ear_way_shape_status", $$v)},expression:"form.abroad_ear_way_shape_status"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.abroad_ear_way_shape_desc),callback:function ($$v) {_vm.$set(_vm.form, "abroad_ear_way_shape_desc", $$v)},expression:"form.abroad_ear_way_shape_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("脐部红肿及异常分泌物：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.umbilicus_abnorma_status),callback:function ($$v) {_vm.$set(_vm.form, "umbilicus_abnorma_status", $$v)},expression:"form.umbilicus_abnorma_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("脐痂脱落情况：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.navelscab_case_staus),callback:function ($$v) {_vm.$set(_vm.form, "navelscab_case_staus", $$v)},expression:"form.navelscab_case_staus"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("吸吮情况：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.suck_case_status),callback:function ($$v) {_vm.$set(_vm.form, "suck_case_status", $$v)},expression:"form.suck_case_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("臀部：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.hips_status),callback:function ($$v) {_vm.$set(_vm.form, "hips_status", $$v)},expression:"form.hips_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("外阴：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.vulva_status),callback:function ($$v) {_vm.$set(_vm.form, "vulva_status", $$v)},expression:"form.vulva_status"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.vulva_abnormal_case_desc),callback:function ($$v) {_vm.$set(_vm.form, "vulva_abnormal_case_desc", $$v)},expression:"form.vulva_abnormal_case_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("肛门：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.anus_status),callback:function ($$v) {_vm.$set(_vm.form, "anus_status", $$v)},expression:"form.anus_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("尿道下裂：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.urethra_crack_status),callback:function ($$v) {_vm.$set(_vm.form, "urethra_crack_status", $$v)},expression:"form.urethra_crack_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("假性月经：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.falsex_menstruation_status),callback:function ($$v) {_vm.$set(_vm.form, "falsex_menstruation_status", $$v)},expression:"form.falsex_menstruation_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("预防接种：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.prevention_inoculation_status),callback:function ($$v) {_vm.$set(_vm.form, "prevention_inoculation_status", $$v)},expression:"form.prevention_inoculation_status"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("预防接种类型：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.prevention_inoculation_bar),callback:function ($$v) {_vm.$set(_vm.form, "prevention_inoculation_bar", $$v)},expression:"form.prevention_inoculation_bar"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","readonly":""},model:{value:(_vm.form.prevention_inoculation_has_name),callback:function ($$v) {_vm.$set(_vm.form, "prevention_inoculation_has_name", $$v)},expression:"form.prevention_inoculation_has_name"}})],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"入所黄疸指数(TCB)：","readonly":""},model:{value:(_vm.form.jaundice_index_num),callback:function ($$v) {_vm.$set(_vm.form, "jaundice_index_num", $$v)},expression:"form.jaundice_index_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"其他特殊情况：","readonly":""},model:{value:(_vm.form.other_special_case),callback:function ($$v) {_vm.$set(_vm.form, "other_special_case", $$v)},expression:"form.other_special_case"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"婴儿护理要点：","readonly":""},model:{value:(_vm.form.baby_nursing_check),callback:function ($$v) {_vm.$set(_vm.form, "baby_nursing_check", $$v)},expression:"form.baby_nursing_check"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"婴儿护理要点描述（不足书写请加附页）：","readonly":""},model:{value:(_vm.form.baby_nursing_abstract),callback:function ($$v) {_vm.$set(_vm.form, "baby_nursing_abstract", $$v)},expression:"form.baby_nursing_abstract"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护士签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',[_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.autograph,"alt":""}})])])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("客户签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('div',[_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.customer_sign,"alt":""}})])])])]),_vm._v(" "),_c('datetime',{attrs:{"title":"评估时间：","readonly":""},model:{value:(_vm.form.assessment_time),callback:function ($$v) {_vm.$set(_vm.form, "assessment_time", $$v)},expression:"form.assessment_time"}}),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("修改")])],1)],1)}
var bb_form_e_detail_staticRenderFns = []
var bb_form_e_detail_esExports = { render: bb_form_e_detail_render, staticRenderFns: bb_form_e_detail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bb_form_e_detail = (bb_form_e_detail_esExports);
// CONCATENATED MODULE: ./src/components/bb_form_e_detail.vue
function bb_form_e_detail_injectStyle (ssrContext) {
  __webpack_require__("4v1l")
}
var bb_form_e_detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bb_form_e_detail___vue_template_functional__ = false
/* styles */
var bb_form_e_detail___vue_styles__ = bb_form_e_detail_injectStyle
/* scopeId */
var bb_form_e_detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bb_form_e_detail___vue_module_identifier__ = null
var bb_form_e_detail_Component = bb_form_e_detail_normalizeComponent(
  components_bb_form_e_detail,
  selectortype_template_index_0_src_components_bb_form_e_detail,
  bb_form_e_detail___vue_template_functional__,
  bb_form_e_detail___vue_styles__,
  bb_form_e_detail___vue_scopeId__,
  bb_form_e_detail___vue_module_identifier__
)

/* harmony default export */ var src_components_bb_form_e_detail = (bb_form_e_detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_e_edit.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bb_form_e_edit = ({
    name: 'bb_form_e_edit',
    data: function data() {
        return {
            get_host: host.host,
            form: {
                whole_body_skin_status: [],
                prevention_inoculation_bar: [],
                baby_nursing_check: []
            },
            showUserSignature: true,
            showSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.autograph = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.autograph = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.autograph = '';
        },

        // 保存客户签名
        saveUserName: function saveUserName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.customer_sign = encodeURI(png);
            this.showUserSignature = true;
        },

        //编辑客户签名
        editUserName: function editUserName() {
            this.showUserSignature = false;
            this.form.customer_sign = '';
        },

        //清除客户签名
        clearUserName: function clearUserName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.customer_sign = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            this.form.token = this.$cookie.get('token');
            this.form.number_id = this.$cookie.get('id');
            this.form.maternal_info_id = this.$route.query.id;
            this.form.id = this.$route.query.form_id;
            this.form.store_id = this.$cookie.get('store_id');
            this.form.baby_id = this.$route.query.child_id;
            this.form.autograph = this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host, '') : this.form.autograph;
            this.form.customer_sign = this.form.customer_sign.indexOf(this.get_host) != -1 ? this.form.customer_sign.replace(this.get_host, '') : this.form.customer_sign;
            var params = this.form;
            var msg = "";
            var keyValue = { "room_number": "房号", "assessment_time": "时间" };
            keys_default()(params).forEach(function (key) {
                if (params[key] == "") {
                    msg = key + " " + keyValue[key];
                }
            });
            if (msg != "") {
                // alert(msg);
            }
            if (params.room_number == '' || params.is_card == '' || params.entry_time == '' || params.mom_name == '' || params.baby_name == '' || params.sex == '' || params.birth_date == '' || params.birth_week == '' || params.blood_type == '' || params.birth_weight == '' || params.birth_length == '' || params.apgar_score == '' || params.leave_hos_summary == '' || params.use_drug_history == '' || params.allergy_history == '' || params.new_baby_special_case == '' || params.leave_hos_jaundice_num == '' || params.feed_case == '' || params.micturition_case_status == '' || params.micturition_num == '' || params.habit_diaper_brand == '' || params.defecation_case_status == '' || params.temperature == '' || params.heart_rate_num == '' || params.breathing_num == '' || params.entry_weight == '' || params.spotwo == '' || params.face_colour == '' || params.cry_sound == '' || params.reaction == '' || params.limb == '' || params.limb_tension_activity == '' || params.birth_injury == '' || params.nerve_reflex_status == '' || params.nutrition_development_status == '' || params.whole_body_skin_status.length == 0 || params.front_fontanelle_status == '' || params.mouth_mucosa_status == '' || params.eye_blood_secretion == '' || params.sclera_yellow_dye == '' || params.nose_shape_status == '' || params.breathing_open_status == '' || params.ear_shape_status == '' || params.abroad_ear_way_shape_status == '' || params.umbilicus_abnorma_status == '' || params.navelscab_case_staus == '' || params.suck_case_status == '' || params.hips_status == '' || params.vulva_status == '' || params.anus_status == '' || params.urethra_crack_status == '' || params.falsex_menstruation_status == '' || params.prevention_inoculation_status == '' || params.jaundice_index_num == '' || params.other_special_case == '' || params.autograph == '' || params.assessment_time == '' || params.baby_nursing_check.length == 0 || params.customer_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请完善表单'
                });
                return;
            }
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.otherFormApi.updateNewBornCheckAssessData(params).then(function (res) {
                _this.$vux.loading.hide();
                console.info(res);
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            form_id: _this.$route.query.form_id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'bb_form_e_edit'
                        }
                    });
                }
            });
        },
        apiMemberInfo: function apiMemberInfo() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.form.mom_name = res.data.name;
                    _this2.form.room_number = res.data.room_name;
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        get_baby_list: function get_baby_list() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info('宝宝信息', res);
                if (res.errcode == 1) {
                    // this.baby_list = res.data
                    // this.form.baby_id = res.data[0].id
                    // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        }
    },
    created: function created() {
        var _this4 = this;

        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.form_id
        };
        this.$vux.loading.show({
            text: '正在加载'
        });
        console.info(params);
        Api.otherFormApi.getNewBornCheckAssessFind(params).then(function (res) {
            _this4.$vux.loading.hide();
            console.info("详情", res.data);
            if (res.errcode == 200) {
                _this4.form = res.data;
                _this4.form.whole_body_skin_status = res.data.whole_body_skin_status;
                _this4.form.baby_nursing_check = res.data.baby_nursing_check;
                _this4.form.prevention_inoculation_bar = res.data.prevention_inoculation_bar;
                _this4.form.autograph = res.data.autograph.indexOf(_this4.get_host) != -1 ? res.data.autograph : _this4.get_host + res.data.autograph;
                _this4.form.customer_sign = res.data.customer_sign.indexOf(_this4.get_host) != -1 ? res.data.customer_sign : _this4.get_host + res.data.customer_sign;
            }
        });
        this.get_baby_list();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_e_edit.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_bb_form_e_edit = ({
    name: 'bb_form_e_edit',
    data: function data() {
        return {
            get_host: host.host,
            form: {
                whole_body_skin_status: [],
                prevention_inoculation_bar: [],
                baby_nursing_check: []
            },
            showUserSignature: true,
            showSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.autograph = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.autograph = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.autograph = '';
        },

        // 保存客户签名
        saveUserName: function saveUserName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.customer_sign = encodeURI(png);
            this.showUserSignature = true;
        },

        //编辑客户签名
        editUserName: function editUserName() {
            this.showUserSignature = false;
            this.form.customer_sign = '';
        },

        //清除客户签名
        clearUserName: function clearUserName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.customer_sign = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            this.form.token = this.$cookie.get('token');
            this.form.number_id = this.$cookie.get('id');
            this.form.maternal_info_id = this.$route.query.id;
            this.form.id = this.$route.query.form_id;
            this.form.store_id = this.$cookie.get('store_id');
            this.form.baby_id = this.$route.query.child_id;
            this.form.autograph = this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host, '') : this.form.autograph;
            this.form.customer_sign = this.form.customer_sign.indexOf(this.get_host) != -1 ? this.form.customer_sign.replace(this.get_host, '') : this.form.customer_sign;
            var params = this.form;
            var msg = "";
            var keyValue = { "room_number": "房号", "assessment_time": "时间" };
            keys_default()(params).forEach(function (key) {
                if (params[key] == "") {
                    msg = key + " " + keyValue[key];
                }
            });
            if (msg != "") {
                // alert(msg);
            }
            if (params.room_number == '' || params.is_card == '' || params.entry_time == '' || params.mom_name == '' || params.baby_name == '' || params.sex == '' || params.birth_date == '' || params.birth_week == '' || params.blood_type == '' || params.birth_weight == '' || params.birth_length == '' || params.apgar_score == '' || params.leave_hos_summary == '' || params.use_drug_history == '' || params.allergy_history == '' || params.new_baby_special_case == '' || params.leave_hos_jaundice_num == '' || params.feed_case == '' || params.micturition_case_status == '' || params.micturition_num == '' || params.habit_diaper_brand == '' || params.defecation_case_status == '' || params.temperature == '' || params.heart_rate_num == '' || params.breathing_num == '' || params.entry_weight == '' || params.spotwo == '' || params.face_colour == '' || params.cry_sound == '' || params.reaction == '' || params.limb == '' || params.limb_tension_activity == '' || params.birth_injury == '' || params.nerve_reflex_status == '' || params.nutrition_development_status == '' || params.whole_body_skin_status.length == 0 || params.front_fontanelle_status == '' || params.mouth_mucosa_status == '' || params.eye_blood_secretion == '' || params.sclera_yellow_dye == '' || params.nose_shape_status == '' || params.breathing_open_status == '' || params.ear_shape_status == '' || params.abroad_ear_way_shape_status == '' || params.umbilicus_abnorma_status == '' || params.navelscab_case_staus == '' || params.suck_case_status == '' || params.hips_status == '' || params.vulva_status == '' || params.anus_status == '' || params.urethra_crack_status == '' || params.falsex_menstruation_status == '' || params.prevention_inoculation_status == '' || params.jaundice_index_num == '' || params.other_special_case == '' || params.autograph == '' || params.assessment_time == '' || params.baby_nursing_check.length == 0 || params.customer_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '请完善表单'
                });
                return;
            }
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.otherFormApi.updateNewBornCheckAssessData(params).then(function (res) {
                _this.$vux.loading.hide();
                console.info(res);
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            form_id: _this.$route.query.form_id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'bb_form_e_edit'
                        }
                    });
                }
            });
        },
        apiMemberInfo: function apiMemberInfo() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.form.mom_name = res.data.name;
                    _this2.form.room_number = res.data.room_name;
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        get_baby_list: function get_baby_list() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info('宝宝信息', res);
                if (res.errcode == 1) {
                    // this.baby_list = res.data
                    // this.form.baby_id = res.data[0].id
                    // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        }
    },
    created: function created() {
        var _this4 = this;

        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.form_id
        };
        this.$vux.loading.show({
            text: '正在加载'
        });
        console.info(params);
        Api.otherFormApi.getNewBornCheckAssessFind(params).then(function (res) {
            _this4.$vux.loading.hide();
            console.info("详情", res.data);
            if (res.errcode == 200) {
                _this4.form = res.data;
                _this4.form.whole_body_skin_status = res.data.whole_body_skin_status;
                _this4.form.baby_nursing_check = res.data.baby_nursing_check;
                _this4.form.prevention_inoculation_bar = res.data.prevention_inoculation_bar;
                _this4.form.autograph = res.data.autograph.indexOf(_this4.get_host) != -1 ? res.data.autograph : _this4.get_host + res.data.autograph;
                _this4.form.customer_sign = res.data.customer_sign.indexOf(_this4.get_host) != -1 ? res.data.customer_sign : _this4.get_host + res.data.customer_sign;
            }
        });
        this.get_baby_list();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4efa2d76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bb_form_e_edit.vue
var bb_form_e_edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("新生儿入住评估单")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","placeholder":"请输入房号","readonly":""},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","placeholder":"请输入手卡号"},model:{value:(_vm.form.is_card),callback:function ($$v) {_vm.$set(_vm.form, "is_card", $$v)},expression:"form.is_card"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"入所时间："},model:{value:(_vm.form.entry_time),callback:function ($$v) {_vm.$set(_vm.form, "entry_time", $$v)},expression:"form.entry_time"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","placeholder":"请输入母亲姓名","readonly":""},model:{value:(_vm.form.mom_name),callback:function ($$v) {_vm.$set(_vm.form, "mom_name", $$v)},expression:"form.mom_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","placeholder":"请输入姓名","readonly":""},model:{value:(_vm.form.baby_name),callback:function ($$v) {_vm.$set(_vm.form, "baby_name", $$v)},expression:"form.baby_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","placeholder":"请输入性别","readonly":""},model:{value:(_vm.form.sex),callback:function ($$v) {_vm.$set(_vm.form, "sex", $$v)},expression:"form.sex"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"出生日期"},model:{value:(_vm.form.birth_date),callback:function ($$v) {_vm.$set(_vm.form, "birth_date", $$v)},expression:"form.birth_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生孕周：","placeholder":"请输入出生孕周"},model:{value:(_vm.form.birth_week),callback:function ($$v) {_vm.$set(_vm.form, "birth_week", $$v)},expression:"form.birth_week"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"血型：","placeholder":"请输入血型"},model:{value:(_vm.form.blood_type),callback:function ($$v) {_vm.$set(_vm.form, "blood_type", $$v)},expression:"form.blood_type"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生体重(g)：","placeholder":"请输入出生体重(单位：g)"},model:{value:(_vm.form.birth_weight),callback:function ($$v) {_vm.$set(_vm.form, "birth_weight", $$v)},expression:"form.birth_weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"身长(cm)：","placeholder":"请输入身长(单位：cm)"},model:{value:(_vm.form.birth_length),callback:function ($$v) {_vm.$set(_vm.form, "birth_length", $$v)},expression:"form.birth_length"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"Apgar评分(分)：","placeholder":"请输入Apgar评分(单位：分)"},model:{value:(_vm.form.apgar_score),callback:function ($$v) {_vm.$set(_vm.form, "apgar_score", $$v)},expression:"form.apgar_score"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("出院小结：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.leave_hos_summary),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_summary", $$v)},expression:"form.leave_hos_summary"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"用药史：","placeholder":"请输入用药史"},model:{value:(_vm.form.use_drug_history),callback:function ($$v) {_vm.$set(_vm.form, "use_drug_history", $$v)},expression:"form.use_drug_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"过敏史：","placeholder":"请输入过敏史"},model:{value:(_vm.form.allergy_history),callback:function ($$v) {_vm.$set(_vm.form, "allergy_history", $$v)},expression:"form.allergy_history"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"新生儿特殊情况：","placeholder":"请输入新生儿特殊情况"},model:{value:(_vm.form.new_baby_special_case),callback:function ($$v) {_vm.$set(_vm.form, "new_baby_special_case", $$v)},expression:"form.new_baby_special_case"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出院黄疸指数(TCB)","placeholder":"请输入出院黄疸指数（单位：mg/dl）"},model:{value:(_vm.form.leave_hos_jaundice_num),callback:function ($$v) {_vm.$set(_vm.form, "leave_hos_jaundice_num", $$v)},expression:"form.leave_hos_jaundice_num"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("喂养情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.feed_case),callback:function ($$v) {_vm.$set(_vm.form, "feed_case", $$v)},expression:"form.feed_case"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("母乳喂养")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("人工喂养")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("混合喂养")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"奶粉品牌：","placeholder":"请输入奶粉品牌"},model:{value:(_vm.form.milk_pow_brand),callback:function ($$v) {_vm.$set(_vm.form, "milk_pow_brand", $$v)},expression:"form.milk_pow_brand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("排尿情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.micturition_case_status),callback:function ($$v) {_vm.$set(_vm.form, "micturition_case_status", $$v)},expression:"form.micturition_case_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("尿少")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"10px"}},[_vm._v("排尿次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.micturition_num),expression:"form.micturition_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.micturition_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "micturition_num", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("惯用尿布品牌：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请输入惯用尿布品牌："},model:{value:(_vm.form.habit_diaper_brand),callback:function ($$v) {_vm.$set(_vm.form, "habit_diaper_brand", $$v)},expression:"form.habit_diaper_brand"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t item vux-1px-b"},[_c('div',{staticClass:"label"},[_vm._v("排便情况：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.defecation_case_status),callback:function ($$v) {_vm.$set(_vm.form, "defecation_case_status", $$v)},expression:"form.defecation_case_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("便秘")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("腹泻")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("未排")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item item vux-1px-b"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"5px"}},[_vm._v("排便次数（次/日）：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.defecation_num),expression:"form.defecation_num"}],staticClass:"redPlaceInput",attrs:{"type":"text","placeholder":"输入次数时请输入单位"},domProps:{"value":(_vm.form.defecation_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "defecation_num", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"mainTitleCenter"},[_vm._v("入所检查")]),_vm._v(" "),_c('x-input',{attrs:{"title":"体温(℃)：","placeholder":"请输入体温（单位：℃）"},model:{value:(_vm.form.temperature),callback:function ($$v) {_vm.$set(_vm.form, "temperature", $$v)},expression:"form.temperature"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"心率(次/分)：","placeholder":"请输入心率（单位：次/分）"},model:{value:(_vm.form.heart_rate_num),callback:function ($$v) {_vm.$set(_vm.form, "heart_rate_num", $$v)},expression:"form.heart_rate_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"呼吸(次/分)：","placeholder":"请输入呼吸（单位：次/分）"},model:{value:(_vm.form.breathing_num),callback:function ($$v) {_vm.$set(_vm.form, "breathing_num", $$v)},expression:"form.breathing_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体重(g)：","placeholder":"请输入体重（单位：g）"},model:{value:(_vm.form.entry_weight),callback:function ($$v) {_vm.$set(_vm.form, "entry_weight", $$v)},expression:"form.entry_weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"SPO2(%)：","placeholder":"请输入心率（单位：%）"},model:{value:(_vm.form.spotwo),callback:function ($$v) {_vm.$set(_vm.form, "spotwo", $$v)},expression:"form.spotwo"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("面色：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.face_colour),callback:function ($$v) {_vm.$set(_vm.form, "face_colour", $$v)},expression:"form.face_colour"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红润")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("黄染")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("哭声：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.cry_sound),callback:function ($$v) {_vm.$set(_vm.form, "cry_sound", $$v)},expression:"form.cry_sound"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("响亮")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("微弱")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("反应：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.reaction),callback:function ($$v) {_vm.$set(_vm.form, "reaction", $$v)},expression:"form.reaction"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("差")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("四肢：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.limb),callback:function ($$v) {_vm.$set(_vm.form, "limb", $$v)},expression:"form.limb"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("白")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("紫")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("四肢张力及活动：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.limb_tension_activity),callback:function ($$v) {_vm.$set(_vm.form, "limb_tension_activity", $$v)},expression:"form.limb_tension_activity"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("受限")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"部位：","placeholder":"请输入受限部位"},model:{value:(_vm.form.limb_tension_activity_be_position),callback:function ($$v) {_vm.$set(_vm.form, "limb_tension_activity_be_position", $$v)},expression:"form.limb_tension_activity_be_position"}}),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"丧失（部位）：","placeholder":"请输入丧失部位"},model:{value:(_vm.form.limb_tension_activity_lose_position),callback:function ($$v) {_vm.$set(_vm.form, "limb_tension_activity_lose_position", $$v)},expression:"form.limb_tension_activity_lose_position"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("产伤：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.birth_injury),callback:function ($$v) {_vm.$set(_vm.form, "birth_injury", $$v)},expression:"form.birth_injury"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("神经反射：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nerve_reflex_status),callback:function ($$v) {_vm.$set(_vm.form, "nerve_reflex_status", $$v)},expression:"form.nerve_reflex_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("异常")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"异常描述"},model:{value:(_vm.form.nerve_reflex_abnormal_desc),callback:function ($$v) {_vm.$set(_vm.form, "nerve_reflex_abnormal_desc", $$v)},expression:"form.nerve_reflex_abnormal_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("营养发育：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nutrition_development_status),callback:function ($$v) {_vm.$set(_vm.form, "nutrition_development_status", $$v)},expression:"form.nutrition_development_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("过剩")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("滞后")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("全身皮肤：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.whole_body_skin_status),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_status", $$v)},expression:"form.whole_body_skin_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("红润")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("黄染")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("完整")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("破损")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("红臀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"6"}},[_vm._v("干燥")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"7"}},[_vm._v("皮疹")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"8"}},[_vm._v("脓包")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"9"}},[_vm._v("硬肿")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"10"}},[_vm._v("水肿")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("破损部位：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请输入"},model:{value:(_vm.form.whole_body_skin_be_position),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_be_position", $$v)},expression:"form.whole_body_skin_be_position"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("皮疹部位：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请输入"},model:{value:(_vm.form.whole_body_skin_rash_position),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_rash_position", $$v)},expression:"form.whole_body_skin_rash_position"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("全身皮肤备注：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请输入"},model:{value:(_vm.form.whole_body_skin_remark),callback:function ($$v) {_vm.$set(_vm.form, "whole_body_skin_remark", $$v)},expression:"form.whole_body_skin_remark"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("前囟：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.front_fontanelle_status),callback:function ($$v) {_vm.$set(_vm.form, "front_fontanelle_status", $$v)},expression:"form.front_fontanelle_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("平坦")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("肿胀")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("凹陷")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("口腔粘膜：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.mouth_mucosa_status),callback:function ($$v) {_vm.$set(_vm.form, "mouth_mucosa_status", $$v)},expression:"form.mouth_mucosa_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("清洁")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("破溃")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("白斑")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("腭裂")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("唇裂")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("眼结膜充血和分泌物：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.eye_blood_secretion),callback:function ($$v) {_vm.$set(_vm.form, "eye_blood_secretion", $$v)},expression:"form.eye_blood_secretion"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("巩膜黄染：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.sclera_yellow_dye),callback:function ($$v) {_vm.$set(_vm.form, "sclera_yellow_dye", $$v)},expression:"form.sclera_yellow_dye"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("鼻外观畸形：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nose_shape_status),callback:function ($$v) {_vm.$set(_vm.form, "nose_shape_status", $$v)},expression:"form.nose_shape_status"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请描述"},model:{value:(_vm.form.nose_shape_place_name),callback:function ($$v) {_vm.$set(_vm.form, "nose_shape_place_name", $$v)},expression:"form.nose_shape_place_name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("呼吸通畅：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.breathing_open_status),callback:function ($$v) {_vm.$set(_vm.form, "breathing_open_status", $$v)},expression:"form.breathing_open_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("耳外观畸形：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.ear_shape_status),callback:function ($$v) {_vm.$set(_vm.form, "ear_shape_status", $$v)},expression:"form.ear_shape_status"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请描述"},model:{value:(_vm.form.ear_shape_place_name),callback:function ($$v) {_vm.$set(_vm.form, "ear_shape_place_name", $$v)},expression:"form.ear_shape_place_name"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("外耳道畸形：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.abroad_ear_way_shape_status),callback:function ($$v) {_vm.$set(_vm.form, "abroad_ear_way_shape_status", $$v)},expression:"form.abroad_ear_way_shape_status"}},[_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请描述"},model:{value:(_vm.form.abroad_ear_way_shape_desc),callback:function ($$v) {_vm.$set(_vm.form, "abroad_ear_way_shape_desc", $$v)},expression:"form.abroad_ear_way_shape_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("脐部红肿及异常分泌物：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.umbilicus_abnorma_status),callback:function ($$v) {_vm.$set(_vm.form, "umbilicus_abnorma_status", $$v)},expression:"form.umbilicus_abnorma_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("脐痂脱落情况：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.navelscab_case_staus),callback:function ($$v) {_vm.$set(_vm.form, "navelscab_case_staus", $$v)},expression:"form.navelscab_case_staus"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("未")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("已")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("吸吮情况：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.suck_case_status),callback:function ($$v) {_vm.$set(_vm.form, "suck_case_status", $$v)},expression:"form.suck_case_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("较差")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("差")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("臀部：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.hips_status),callback:function ($$v) {_vm.$set(_vm.form, "hips_status", $$v)},expression:"form.hips_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("稍红")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("红臀")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("外阴：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.vulva_status),callback:function ($$v) {_vm.$set(_vm.form, "vulva_status", $$v)},expression:"form.vulva_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("异常")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请描述"},model:{value:(_vm.form.vulva_abnormal_case_desc),callback:function ($$v) {_vm.$set(_vm.form, "vulva_abnormal_case_desc", $$v)},expression:"form.vulva_abnormal_case_desc"}})],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("肛门：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.anus_status),callback:function ($$v) {_vm.$set(_vm.form, "anus_status", $$v)},expression:"form.anus_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("尿道下裂：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.urethra_crack_status),callback:function ($$v) {_vm.$set(_vm.form, "urethra_crack_status", $$v)},expression:"form.urethra_crack_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("假性月经：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.falsex_menstruation_status),callback:function ($$v) {_vm.$set(_vm.form, "falsex_menstruation_status", $$v)},expression:"form.falsex_menstruation_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("预防接种：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.prevention_inoculation_status),callback:function ($$v) {_vm.$set(_vm.form, "prevention_inoculation_status", $$v)},expression:"form.prevention_inoculation_status"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("预防接种类型：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.prevention_inoculation_bar),callback:function ($$v) {_vm.$set(_vm.form, "prevention_inoculation_bar", $$v)},expression:"form.prevention_inoculation_bar"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("乙肝疫苗")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("卡介苗")])],1),_vm._v(" "),_c('x-input',{staticClass:"shengCellChange",attrs:{"title":"","placeholder":"请描述"},model:{value:(_vm.form.prevention_inoculation_has_name),callback:function ($$v) {_vm.$set(_vm.form, "prevention_inoculation_has_name", $$v)},expression:"form.prevention_inoculation_has_name"}})],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"入所黄疸指数(TCB)：","placeholder":"请输入入所黄疸指数（单位：mg/dl）"},model:{value:(_vm.form.jaundice_index_num),callback:function ($$v) {_vm.$set(_vm.form, "jaundice_index_num", $$v)},expression:"form.jaundice_index_num"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"其他特殊情况","placeholder":"请输入"},model:{value:(_vm.form.other_special_case),callback:function ($$v) {_vm.$set(_vm.form, "other_special_case", $$v)},expression:"form.other_special_case"}}),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"margin-left":"14px"}},[_c('div',{staticClass:"label",staticStyle:{"margin-left":"5px"}},[_vm._v("婴儿护理要点：")]),_vm._v(" "),_c('div',{staticClass:"value",staticStyle:{"display":"flex"}},[_c('checker',{staticStyle:{"margin-right":"10px"},attrs:{"type":"checkbox","default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.baby_nursing_check),callback:function ($$v) {_vm.$set(_vm.form, "baby_nursing_check", $$v)},expression:"form.baby_nursing_check"}},[_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"1"}},[_vm._v("单独睡小床，不需要用枕头")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"2"}},[_vm._v("避免阳光直射眼睛，及早晒太阳")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"3"}},[_vm._v("选择纯棉衣物，衣服单独清洗")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"4"}},[_vm._v("奶瓶清洁消毒后再用，加强生活护理")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"5"}},[_vm._v("吃奶后拍嗝，加强母乳喂养指导")]),_vm._v(" "),_c('checker-item',{staticStyle:{"margin":"5px"},attrs:{"value":"6"}},[_vm._v("注意脐带护理、五官护理、皮肤护理")])],1)],1)]),_vm._v(" "),_c('x-textarea',{attrs:{"title":"婴儿护理要点描述（不足书写请加附页）：","placeholder":"请输入"},model:{value:(_vm.form.baby_nursing_abstract),callback:function ($$v) {_vm.$set(_vm.form, "baby_nursing_abstract", $$v)},expression:"form.baby_nursing_abstract"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护士签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.autograph)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.autograph,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("客户签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showUserSignature)?_c('div',[(_vm.form.customer_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.customer_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editUserName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveUserName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearUserName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('datetime',{attrs:{"title":"评估时间："},model:{value:(_vm.form.assessment_time),callback:function ($$v) {_vm.$set(_vm.form, "assessment_time", $$v)},expression:"form.assessment_time"}}),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交修改")])],1)],1)}
var bb_form_e_edit_staticRenderFns = []
var bb_form_e_edit_esExports = { render: bb_form_e_edit_render, staticRenderFns: bb_form_e_edit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bb_form_e_edit = (bb_form_e_edit_esExports);
// CONCATENATED MODULE: ./src/components/bb_form_e_edit.vue
function bb_form_e_edit_injectStyle (ssrContext) {
  __webpack_require__("ezv9")
}
var bb_form_e_edit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bb_form_e_edit___vue_template_functional__ = false
/* styles */
var bb_form_e_edit___vue_styles__ = bb_form_e_edit_injectStyle
/* scopeId */
var bb_form_e_edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bb_form_e_edit___vue_module_identifier__ = null
var bb_form_e_edit_Component = bb_form_e_edit_normalizeComponent(
  components_bb_form_e_edit,
  selectortype_template_index_0_src_components_bb_form_e_edit,
  bb_form_e_edit___vue_template_functional__,
  bb_form_e_edit___vue_styles__,
  bb_form_e_edit___vue_scopeId__,
  bb_form_e_edit___vue_module_identifier__
)

/* harmony default export */ var src_components_bb_form_e_edit = (bb_form_e_edit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_f.vue



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var bb_form_f = ({
    name: 'bb_form_b',
    data: function data() {
        return {
            child_birth: '',
            get_host: host.host,
            form: {
                room: '',
                card: '',
                sex: '',
                baby_id: '',
                name: '',
                momName: '',
                date: '',
                birtherDay: '',
                temperature: '',
                weight: '',
                nursing: '1',
                bath: '1',
                swimming: '',
                touch: '',
                massage: '',
                spa: '0',
                other: '',
                signature: '',
                shifts: ''
            },
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            baby_list: []
        };
    },
    created: function created() {
        this.get_baby_list();
        this.apiMemberInfo();
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            this.form.other = '母乳喂养、母婴同室';
        }
    },

    methods: (_methods = {
        GetNumberOfDays: function GetNumberOfDays(date1, date2) {
            //获得天数
            //date1：开始日期，date2结束日期
            var a1 = Date.parse(new Date(date1));
            var a2 = Date.parse(new Date(date2));
            var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24)); //核心：时间戳相减，然后除以天数
            return day;
        },
        change_date: function change_date(value) {
            console.log(this.child_birth);
            this.apiMemberInfo(value);
        },
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            return;
                        }
                        this.form.card = item.hand_card;
                        this.form.sex = item.sex == "1" ? "男" : "女";
                        this.form.name = item.name;
                        this.form.birtherDay = item.birth_day;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        get_baby_list: function get_baby_list() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.baby_list = res.data;
                    // this.form.baby_id = res.data[0].id
                    // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo(value) {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.form.momName = res.data.name;
                    _this2.form.room = res.data.room_name;
                    _this2.child_birth = _this2.formatDateTime(res.data.child_birth);
                    if (value) {
                        var day = _this2.GetNumberOfDays(_this2.child_birth, value) + 1;
                        _this2.form.birtherDay = day;
                    }
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.signature = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.signature = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.signature = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getBabyCareOperaFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this3.form.room = data.room_number;
                    _this3.form.card = data.id_card;
                    _this3.form.name = data.baby_name;
                    _this3.form.baby_id = data.baby_id;
                    _this3.form.sex = data.baby_gender;
                    _this3.form.momName = data.mom_name;
                    _this3.form.date = data.cat_date;
                    _this3.form.birtherDay = data.birth_day_num;
                    _this3.change_date(data.cat_date);
                    _this3.form.temperature = data.temperature;
                    _this3.form.weight = data.weight;
                    _this3.form.nursing = data.umb_protection_num;
                    _this3.form.bath = data.take_shower_num;
                    _this3.form.swimming = data.swim_num;
                    _this3.form.touch = data.touch_num;
                    _this3.form.massage = data.massage_num;
                    _this3.form.spa = data.spa_num;
                    _this3.form.other = data.other_situation;
                    _this3.form.signature = data.opera_name.indexOf(_this3.get_host) != -1 ? data.opera_name : _this3.get_host + data.opera_name;
                    _this3.form.shifts = data.shifts;
                    _this3.showSignature = true;
                    _this3.$vux.loading.hide();
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this4 = this;

            var babyName = '';
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = get_iterator_default()(this.baby_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    if (item.id == this.form.baby_id) {
                        babyName = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: babyName,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                cat_date: this.form.date,
                birth_day_num: this.form.birtherDay,
                massage_num: this.form.massage,
                temperature: this.form.temperature,
                weight: this.form.weight,
                umb_protection_num: this.form.nursing,
                take_shower_num: this.form.bath,
                swim_num: this.form.swimming,
                touch_num: this.form.touch,
                spa_num: this.form.spa,
                other_situation: this.form.other,
                opera_name: this.form.signature,
                shifts: this.form.shifts
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addBabyCareOperaData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'bb_form_f'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this5 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: this.form.name,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                massage_num: this.form.massage,
                cat_date: this.form.date,
                birth_day_num: this.form.birtherDay,
                temperature: this.form.temperature,
                weight: this.form.weight,
                umb_protection_num: this.form.nursing,
                take_shower_num: this.form.bath,
                swim_num: this.form.swimming,
                touch_num: this.form.touch,
                spa_num: this.form.spa,
                other_situation: this.form.other,
                opera_name: this.form.signature.indexOf(this.get_host) != -1 ? this.form.signature.replace(this.get_host, '') : this.form.signature,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateBabyCareOperaData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this5.$vux.loading.hide();
                    _this5.$router.replace({
                        path: '/success',
                        query: {
                            id: _this5.$route.query.id,
                            form_id: _this5.$route.query.form_id,
                            tabVal: _this5.$route.query.tabVal,
                            name: 'bb_form_f'
                        }
                    });
                } else {
                    _this5.$vux.loading.hide();
                    _this5.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        }
    }, defineProperty_default()(_methods, 'edit', function edit() {
        this.showSignature = false;
    }), defineProperty_default()(_methods, 'submitForm', function submitForm() {
        var form = this.form;
        if (form.card == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入手卡号'
            });
            return;
        }
        if (form.baby_id == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择宝宝'
            });
            return;
        }
        if (form.date == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择日期'
            });
            return;
        }
        if (form.birtherDay == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入出生天数'
            });
            return;
        }
        if (form.temperature == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入体温'
            });
            return;
        }
        if (form.weight == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入体重'
            });
            return;
        }
        if (form.nursing == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入脐护'
            });
            return;
        }
        if (form.bath == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入洗澡'
            });
            return;
        }
        if (form.swimming == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入游泳'
            });
            return;
        }
        if (form.touch == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入抚触'
            });
            return;
        }
        if (form.massage == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入早教'
            });
            return;
        }
        if (form.spa == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入SPA'
            });
            return;
        }
        if (form.other == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入其他情况'
            });
            return;
        }
        if (form.shifts == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择班次'
            });
            return;
        }
        if (form.signature == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入签名'
            });
            return;
        }
        // 判断宝宝是否入住
        var time = 0;
        if (this.baby_list.length) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = get_iterator_default()(this.baby_list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var item = _step3.value;

                    if (item.id == this.form.baby_id) {
                        time = item.live_time;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
        if (time == '0') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '该宝宝暂未入住'
            });
            return;
        }
        if (this.$route.query.list_id) {
            console.info("请求更新数据");
            this.apiUpdateForm();
        } else {
            this.apiAddForm();
        }
    }), _methods)
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/bb_form_f.vue



var bb_form_f__methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_bb_form_f = ({
    name: 'bb_form_b',
    data: function data() {
        return {
            child_birth: '',
            get_host: host.host,
            form: {
                room: '',
                card: '',
                sex: '',
                baby_id: '',
                name: '',
                momName: '',
                date: '',
                birtherDay: '',
                temperature: '',
                weight: '',
                nursing: '1',
                bath: '1',
                swimming: '',
                touch: '',
                massage: '',
                spa: '0',
                other: '',
                signature: '',
                shifts: ''
            },
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            baby_list: []
        };
    },
    created: function created() {
        this.get_baby_list();
        this.apiMemberInfo();
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            this.form.other = '母乳喂养、母婴同室';
        }
    },

    methods: (bb_form_f__methods = {
        GetNumberOfDays: function GetNumberOfDays(date1, date2) {
            //获得天数
            //date1：开始日期，date2结束日期
            var a1 = Date.parse(new Date(date1));
            var a2 = Date.parse(new Date(date2));
            var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24)); //核心：时间戳相减，然后除以天数
            return day;
        },
        change_date: function change_date(value) {
            console.log(this.child_birth);
            this.apiMemberInfo(value);
        },
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            return;
                        }
                        this.form.card = item.hand_card;
                        this.form.sex = item.sex == "1" ? "男" : "女";
                        this.form.name = item.name;
                        this.form.birtherDay = item.birth_day;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        get_baby_list: function get_baby_list() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.baby_list = res.data;
                    // this.form.baby_id = res.data[0].id
                    // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },

        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo(value) {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.form.momName = res.data.name;
                    _this2.form.room = res.data.room_name;
                    _this2.child_birth = _this2.formatDateTime(res.data.child_birth);
                    if (value) {
                        var day = _this2.GetNumberOfDays(_this2.child_birth, value) + 1;
                        _this2.form.birtherDay = day;
                    }
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        save: function save() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.signature = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.signature = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.signature = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.getBabyCareOperaFind(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this3.form.room = data.room_number;
                    _this3.form.card = data.id_card;
                    _this3.form.name = data.baby_name;
                    _this3.form.baby_id = data.baby_id;
                    _this3.form.sex = data.baby_gender;
                    _this3.form.momName = data.mom_name;
                    _this3.form.date = data.cat_date;
                    _this3.form.birtherDay = data.birth_day_num;
                    _this3.change_date(data.cat_date);
                    _this3.form.temperature = data.temperature;
                    _this3.form.weight = data.weight;
                    _this3.form.nursing = data.umb_protection_num;
                    _this3.form.bath = data.take_shower_num;
                    _this3.form.swimming = data.swim_num;
                    _this3.form.touch = data.touch_num;
                    _this3.form.massage = data.massage_num;
                    _this3.form.spa = data.spa_num;
                    _this3.form.other = data.other_situation;
                    _this3.form.signature = data.opera_name.indexOf(_this3.get_host) != -1 ? data.opera_name : _this3.get_host + data.opera_name;
                    _this3.form.shifts = data.shifts;
                    _this3.showSignature = true;
                    _this3.$vux.loading.hide();
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this4 = this;

            var babyName = '';
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = get_iterator_default()(this.baby_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var item = _step2.value;

                    if (item.id == this.form.baby_id) {
                        babyName = item.name;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: babyName,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                cat_date: this.form.date,
                birth_day_num: this.form.birtherDay,
                massage_num: this.form.massage,
                temperature: this.form.temperature,
                weight: this.form.weight,
                umb_protection_num: this.form.nursing,
                take_shower_num: this.form.bath,
                swim_num: this.form.swimming,
                touch_num: this.form.touch,
                spa_num: this.form.spa,
                other_situation: this.form.other,
                opera_name: this.form.signature,
                shifts: this.form.shifts
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.addBabyCareOperaData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'bb_form_f'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this5 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id,
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                room_number: this.form.room,
                id_card: this.form.card,
                baby_name: this.form.name,
                baby_id: this.form.baby_id,
                baby_gender: this.form.sex,
                mom_name: this.form.momName,
                massage_num: this.form.massage,
                cat_date: this.form.date,
                birth_day_num: this.form.birtherDay,
                temperature: this.form.temperature,
                weight: this.form.weight,
                umb_protection_num: this.form.nursing,
                take_shower_num: this.form.bath,
                swim_num: this.form.swimming,
                touch_num: this.form.touch,
                spa_num: this.form.spa,
                other_situation: this.form.other,
                opera_name: this.form.signature.indexOf(this.get_host) != -1 ? this.form.signature.replace(this.get_host, '') : this.form.signature,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.bbFormApi.updateBabyCareOperaData(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this5.$vux.loading.hide();
                    _this5.$router.replace({
                        path: '/success',
                        query: {
                            id: _this5.$route.query.id,
                            form_id: _this5.$route.query.form_id,
                            tabVal: _this5.$route.query.tabVal,
                            name: 'bb_form_f'
                        }
                    });
                } else {
                    _this5.$vux.loading.hide();
                    _this5.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        }
    }, defineProperty_default()(bb_form_f__methods, 'edit', function edit() {
        this.showSignature = false;
    }), defineProperty_default()(bb_form_f__methods, 'submitForm', function submitForm() {
        var form = this.form;
        if (form.card == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入手卡号'
            });
            return;
        }
        if (form.baby_id == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择宝宝'
            });
            return;
        }
        if (form.date == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择日期'
            });
            return;
        }
        if (form.birtherDay == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入出生天数'
            });
            return;
        }
        if (form.temperature == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入体温'
            });
            return;
        }
        if (form.weight == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入体重'
            });
            return;
        }
        if (form.nursing == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入脐护'
            });
            return;
        }
        if (form.bath == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入洗澡'
            });
            return;
        }
        if (form.swimming == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入游泳'
            });
            return;
        }
        if (form.touch == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入抚触'
            });
            return;
        }
        if (form.massage == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入早教'
            });
            return;
        }
        if (form.spa == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入SPA'
            });
            return;
        }
        if (form.other == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入其他情况'
            });
            return;
        }
        if (form.shifts == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择班次'
            });
            return;
        }
        if (form.signature == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入签名'
            });
            return;
        }
        // 判断宝宝是否入住
        var time = 0;
        if (this.baby_list.length) {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = get_iterator_default()(this.baby_list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var item = _step3.value;

                    if (item.id == this.form.baby_id) {
                        time = item.live_time;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
        if (time == '0') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '该宝宝暂未入住'
            });
            return;
        }
        if (this.$route.query.list_id) {
            console.info("请求更新数据");
            this.apiUpdateForm();
        } else {
            this.apiAddForm();
        }
    }), bb_form_f__methods)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-443877e7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bb_form_f.vue
var bb_form_f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbFormF"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("婴儿护理操作记录表")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(_vm.form.room),callback:function ($$v) {_vm.$set(_vm.form, "room", $$v)},expression:"form.room"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","disabled":"","placeholder":"请输入手卡号"},model:{value:(_vm.form.card),callback:function ($$v) {_vm.$set(_vm.form, "card", $$v)},expression:"form.card"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("选择宝宝：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},on:{"on-change":_vm.checkerChange},model:{value:(_vm.form.baby_id),callback:function ($$v) {_vm.$set(_vm.form, "baby_id", $$v)},expression:"form.baby_id"}},_vm._l((_vm.baby_list),function(item){return _c('checker-item',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}),1)],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","disabled":"","placeholder":"请输入性别"},model:{value:(_vm.form.sex),callback:function ($$v) {_vm.$set(_vm.form, "sex", $$v)},expression:"form.sex"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","disabled":"","placeholder":"请输入母亲姓名"},model:{value:(_vm.form.momName),callback:function ($$v) {_vm.$set(_vm.form, "momName", $$v)},expression:"form.momName"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"日期："},on:{"on-change":_vm.change_date},model:{value:(_vm.form.date),callback:function ($$v) {_vm.$set(_vm.form, "date", $$v)},expression:"form.date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生天数(天)：","disabled":""},model:{value:(_vm.form.birtherDay),callback:function ($$v) {_vm.$set(_vm.form, "birtherDay", $$v)},expression:"form.birtherDay"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体温(℃)：","placeholder":"请输入体温（单位：℃）"},model:{value:(_vm.form.temperature),callback:function ($$v) {_vm.$set(_vm.form, "temperature", $$v)},expression:"form.temperature"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"体重(g)：","placeholder":"请输入体重(单位：g)"},model:{value:(_vm.form.weight),callback:function ($$v) {_vm.$set(_vm.form, "weight", $$v)},expression:"form.weight"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"脐护(次)：","placeholder":"请输入脐护次数(单位：次)"},model:{value:(_vm.form.nursing),callback:function ($$v) {_vm.$set(_vm.form, "nursing", $$v)},expression:"form.nursing"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"洗澡(次)：","placeholder":"请输入洗澡次数(单位：次)"},model:{value:(_vm.form.bath),callback:function ($$v) {_vm.$set(_vm.form, "bath", $$v)},expression:"form.bath"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"游泳(次)：","placeholder":"请输入游泳次数(单位：次)"},model:{value:(_vm.form.swimming),callback:function ($$v) {_vm.$set(_vm.form, "swimming", $$v)},expression:"form.swimming"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"抚触(次)：","placeholder":"请输入抚触次数(单位：次)"},model:{value:(_vm.form.touch),callback:function ($$v) {_vm.$set(_vm.form, "touch", $$v)},expression:"form.touch"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"早教(次)：","placeholder":"请输入早教次数(单位：次)"},model:{value:(_vm.form.massage),callback:function ($$v) {_vm.$set(_vm.form, "massage", $$v)},expression:"form.massage"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"SPA(次)：","placeholder":"请输入SPA次数(单位：次)"},model:{value:(_vm.form.spa),callback:function ($$v) {_vm.$set(_vm.form, "spa", $$v)},expression:"form.spa"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"其他情况：","placeholder":"请输入其他情况"},model:{value:(_vm.form.other),callback:function ($$v) {_vm.$set(_vm.form, "other", $$v)},expression:"form.other"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0pximportant"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0px"}},[_vm._v("操作者：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.signature)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.signature,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0px1important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px","padding-left":"0px"}},[_vm._v("班次：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"早班"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"中班"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"晚班"}},[_vm._v("晚班")])],1)],1)])]),_vm._v(" "),_c('x-textarea',{attrs:{"title":"注：","value":"1、每日皮肤做好护理（包括沐浴、脐带护理、臀部护理等）。2、每日抚触","disabled":""}}),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var bb_form_f_staticRenderFns = []
var bb_form_f_esExports = { render: bb_form_f_render, staticRenderFns: bb_form_f_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_bb_form_f = (bb_form_f_esExports);
// CONCATENATED MODULE: ./src/components/bb_form_f.vue
function bb_form_f_injectStyle (ssrContext) {
  __webpack_require__("jHXy")
}
var bb_form_f_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var bb_form_f___vue_template_functional__ = false
/* styles */
var bb_form_f___vue_styles__ = bb_form_f_injectStyle
/* scopeId */
var bb_form_f___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var bb_form_f___vue_module_identifier__ = null
var bb_form_f_Component = bb_form_f_normalizeComponent(
  components_bb_form_f,
  selectortype_template_index_0_src_components_bb_form_f,
  bb_form_f___vue_template_functional__,
  bb_form_f___vue_styles__,
  bb_form_f___vue_scopeId__,
  bb_form_f___vue_module_identifier__
)

/* harmony default export */ var src_components_bb_form_f = (bb_form_f_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_one.vue






/* harmony default export */ var christmas_form_one = ({
  name: 'christmas_form_one',
  components: {
    cfr: src_components_cfrList,
    PopupRadio: vux_src_components_popup_radio
  },
  data: function data() {
    return {
      showLochiaPicker: false,
      showOptions2: false,
      options2: ['多', '中', '少'],
      showPopupPicker: false,
      showOptions1: false,
      options1: ['脐上？指', '脐下？指', '完全入盆', '平脐', '耻骨联合上？指'],
      list_id: '',
      showCfrList: false,
      cfrText: '',
      form: {
        room: '',
        momName: '',
        live_time: '',
        child_birth: '',
        delivery_type: '',
        advisory_date: '',
        postpartum_days: '',
        healing: '',
        uterus_place: '',
        lochia_amount: '',
        lochia_color: '',
        lochia_taste: '',
        chapped_nipple: '',
        breast: '',
        milk_amount: '2',
        stool: '',
        pee: '',
        special_case: '',
        agent_id: '',
        shifts: '',
        agent_sign: ''
      },
      showSignature: false,
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      get_host: host.host
    };
  },
  created: function created() {
    this.apiMemberInfo();
    if (this.$route.query.list_id) {
      this.apiGetCfrList();
    }
  },

  methods: {
    GetNumberOfDays: function GetNumberOfDays(date1, date2) {
      //获得天数

      var a1 = Date.parse(new Date(date1));
      var a2 = Date.parse(new Date(date2));
      var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24));
      return day;
    },
    change_advisory_date: function change_advisory_date(value) {
      var day = this.GetNumberOfDays(this.form.child_birth, value) + 1;
      this.form.postpartum_days = day;
    },
    onChangeLochiaAmount: function onChangeLochiaAmount(val) {
      this.form.lochia_amount = val;
      this.$refs.lochiaAmount.focus();
      this.showOptions2 = false;
    },
    onChange: function onChange(val) {
      this.form.uterus_place = val;
      this.$refs.uterusPlace.focus();
      this.showOptions1 = false;
    },
    apiGetCfrList: function apiGetCfrList() {
      var _this = this;

      var params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id')
      };
      Api.checkRoomApi.getCheckInfo(params).then(function (res) {
        console.info("获取查房人列表", res);
        if (res.errcode == 1) {
          _this.nurser_name = res.data.nurser_name;
          _this.apiDetail(res.data.nurser_name);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    selectPeople: function selectPeople() {
      this.showCfrList = true;
    },
    cfrListEven: function cfrListEven(val, item) {
      this.showCfrList = val;
      if (item) {
        this.form.agent_id = item.id;
        this.cfrText = item.user_name;
      }
    },
    apiMemberInfo: function apiMemberInfo() {
      var _this2 = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.memberInfo(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this2.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : '';
          _this2.form.momName = res.data.name;
          _this2.form.room = res.data.room_name;

          _this2.form.child_birth = _this2.formatDateTime(res.data.child_birth);
          _this2.form.live_time = _this2.formatDateTime(res.data.live_time);
        } else {
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },
    save: function save() {
      var signature = 'signature1';
      console.info(this.$refs[signature]);
      var png = this.$refs[signature].save();
      this.form.agent_sign = encodeURI(png);
      this.showSignature = true;
    },
    edit: function edit() {
      this.showSignature = false;
      this.form.agent_sign = '';
    },
    clear: function clear() {
      var signature = 'signature1';
      var refs = this.$refs[signature].clear();
      this.form.agent_sign = '';
    },
    apiDetail: function apiDetail(nurser_name) {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token'),
        id: this.$route.query.list_id
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.chritmasFormApi.getMatarnalHeathRecord(params).then(function (res) {
        console.info('请求详情数据');
        console.info(res);
        if (res.errcode == 200) {
          var data = res.data;
          _this3.form.room = data.room;
          _this3.form.delivery_type = data.delivery_type;
          _this3.form.postpartum_days = data.postpartum_days, _this3.form.healing = data.healing, _this3.form.uterus_place = data.uterus_place, _this3.form.lochia_amount = data.lochia_amount, _this3.form.lochia_color = data.lochia_color, _this3.form.lochia_taste = data.lochia_taste, _this3.form.chapped_nipple = data.chapped_nipple, _this3.form.breast = data.breast, _this3.form.milk_amount = data.milk_amount, _this3.form.stool = data.stool, _this3.form.pee = data.pee, _this3.form.special_case = data.special_case, _this3.form.advisory_date = data.advisory_date, _this3.form.agent_sign = data.agent_sign.indexOf(_this3.get_host) != -1 ? data.agent_sign : _this3.get_host + data.agent_sign;
          _this3.form.shifts = data.shifts;
          if (nurser_name.length) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = get_iterator_default()(nurser_name), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (item.id == data.agent_id) {
                  _this3.cfrText = item.user_name;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          _this3.form.agent_id = data.agent_id;
          _this3.showSignature = true;
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiAddForm: function apiAddForm() {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        member_id: this.$cookie.get('id'),
        maternal_info_id: this.$route.query.id,
        room: this.form.room,
        delivery_type: this.form.delivery_type,
        postpartum_days: this.form.postpartum_days,
        healing: this.form.healing,
        uterus_place: this.form.uterus_place,
        lochia_amount: this.form.lochia_amount,
        lochia_color: this.form.lochia_color,
        lochia_taste: this.form.lochia_taste,
        chapped_nipple: this.form.chapped_nipple,
        breast: this.form.breast,
        milk_amount: this.form.milk_amount,
        stool: this.form.stool,
        pee: this.form.pee,
        special_case: this.form.special_case,
        advisory_date: this.form.advisory_date,
        agent_sign: this.form.agent_sign,
        agent_id: this.form.agent_id,
        shifts: this.form.shifts
      };
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.chritmasFormApi.addMatarnalHeathRecord(params).then(function (res) {
        console.info(res);
        if (res.errcode == 200) {
          _this4.$vux.loading.hide();
          _this4.$router.replace({
            path: '/success',
            query: {
              id: _this4.$route.query.id,
              form_id: _this4.$route.query.form_id,
              tabVal: _this4.$route.query.tabVal,
              name: 'christmas_form_one'
            }
          });
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiUpdateForm: function apiUpdateForm() {
      var _this5 = this;

      var params = {
        id: this.$route.query.list_id,
        token: this.$cookie.get('token'),
        member_id: this.$cookie.get('id'),
        maternal_info_id: this.$route.query.id,
        room: this.form.room,
        delivery_type: this.form.delivery_type,
        postpartum_days: this.form.postpartum_days,
        healing: this.form.healing,
        uterus_place: this.form.uterus_place,
        lochia_amount: this.form.lochia_amount,
        lochia_color: this.form.lochia_color,
        lochia_taste: this.form.lochia_taste,
        chapped_nipple: this.form.chapped_nipple,
        breast: this.form.breast,
        milk_amount: this.form.milk_amount,
        stool: this.form.stool,
        pee: this.form.pee,
        special_case: this.form.special_case,
        advisory_date: this.form.advisory_date,
        agent_sign: this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host, '') : this.form.agent_sign,
        agent_id: this.form.agent_id,
        shifts: this.form.shifts
      };
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.chritmasFormApi.updateMatarnalHeathRecord(params).then(function (res) {
        console.info(res);
        if (res.errcode == 200) {
          _this5.$vux.loading.hide();
          _this5.$router.replace({
            path: '/success',
            query: {
              id: _this5.$route.query.id,
              form_id: _this5.$route.query.form_id,
              tabVal: _this5.$route.query.tabVal,
              name: 'christmas_form_one'
            }
          });
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    submitForm: function submitForm() {
      var form = this.form;
      if (form.delivery_type == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择分娩方式'
        });
        return;
      }
      if (form.advisory_date == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择健康咨询日期'
        });
        return;
      }
      if (form.postpartum_days == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入产后天数'
        });
        return;
      }
      if (form.healing == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择术口愈合情况'
        });
        return;
      }
      if (form.uterus_place == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择宫底位置'
        });
        return;
      }
      if (form.lochia_amount == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入恶露量'
        });
        return;
      }
      if (form.lochia_color == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择恶露色'
        });
        return;
      }
      if (form.lochia_taste == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择恶露味'
        });
        return;
      }
      if (form.chapped_nipple == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择乳头皲裂'
        });
        return;
      }
      if (form.breast == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择乳房情况'
        });
        return;
      }
      if (form.milk_amount == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入乳汁量'
        });
        return;
      }
      if (form.stool == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择大便'
        });
        return;
      }
      if (form.pee == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择小便'
        });
        return;
      }
      if (form.special_case == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入特殊情况'
        });
        return;
      }
      if (form.shifts == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择班次'
        });
        return;
      }
      if (form.agent_id == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择查房人'
        });
        return;
      }
      if (form.agent_sign == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入签名'
        });
        return;
      }
      if (this.$route.query.list_id) {
        console.info("请求更新数据");
        this.apiUpdateForm();
      } else {
        this.apiAddForm();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_one.vue






/* harmony default export */ var components_christmas_form_one = ({
  name: 'christmas_form_one',
  components: {
    cfr: src_components_cfrList,
    PopupRadio: vux_src_components_popup_radio
  },
  data: function data() {
    return {
      showLochiaPicker: false,
      showOptions2: false,
      options2: ['多', '中', '少'],
      showPopupPicker: false,
      showOptions1: false,
      options1: ['脐上？指', '脐下？指', '完全入盆', '平脐', '耻骨联合上？指'],
      list_id: '',
      showCfrList: false,
      cfrText: '',
      form: {
        room: '',
        momName: '',
        live_time: '',
        child_birth: '',
        delivery_type: '',
        advisory_date: '',
        postpartum_days: '',
        healing: '',
        uterus_place: '',
        lochia_amount: '',
        lochia_color: '',
        lochia_taste: '',
        chapped_nipple: '',
        breast: '',
        milk_amount: '2',
        stool: '',
        pee: '',
        special_case: '',
        agent_id: '',
        shifts: '',
        agent_sign: ''
      },
      showSignature: false,
      option: {
        penColor: "rgb(0, 0, 0)"
      },
      get_host: host.host
    };
  },
  created: function created() {
    this.apiMemberInfo();
    if (this.$route.query.list_id) {
      this.apiGetCfrList();
    }
  },

  methods: {
    GetNumberOfDays: function GetNumberOfDays(date1, date2) {
      //获得天数

      var a1 = Date.parse(new Date(date1));
      var a2 = Date.parse(new Date(date2));
      var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24));
      return day;
    },
    change_advisory_date: function change_advisory_date(value) {
      var day = this.GetNumberOfDays(this.form.child_birth, value) + 1;
      this.form.postpartum_days = day;
    },
    onChangeLochiaAmount: function onChangeLochiaAmount(val) {
      this.form.lochia_amount = val;
      this.$refs.lochiaAmount.focus();
      this.showOptions2 = false;
    },
    onChange: function onChange(val) {
      this.form.uterus_place = val;
      this.$refs.uterusPlace.focus();
      this.showOptions1 = false;
    },
    apiGetCfrList: function apiGetCfrList() {
      var _this = this;

      var params = {
        token: this.$cookie.get('token'),
        store_id: this.$cookie.get('store_id')
      };
      Api.checkRoomApi.getCheckInfo(params).then(function (res) {
        console.info("获取查房人列表", res);
        if (res.errcode == 1) {
          _this.nurser_name = res.data.nurser_name;
          _this.apiDetail(res.data.nurser_name);
        } else {
          _this.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    selectPeople: function selectPeople() {
      this.showCfrList = true;
    },
    cfrListEven: function cfrListEven(val, item) {
      this.showCfrList = val;
      if (item) {
        this.form.agent_id = item.id;
        this.cfrText = item.user_name;
      }
    },
    apiMemberInfo: function apiMemberInfo() {
      var _this2 = this;

      var params = {
        token: this.$cookie.get('token'),
        maternal_info_id: this.$route.query.id
      };
      Api.checkRoomApi.memberInfo(params).then(function (res) {
        console.info(res);
        if (res.errcode == 1) {
          _this2.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : '';
          _this2.form.momName = res.data.name;
          _this2.form.room = res.data.room_name;

          _this2.form.child_birth = _this2.formatDateTime(res.data.child_birth);
          _this2.form.live_time = _this2.formatDateTime(res.data.live_time);
        } else {
          _this2.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    formatDateTime: function formatDateTime(inputTime) {
      var date = new Date(parseInt(inputTime) * 1000);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      h = h < 10 ? '0' + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? '0' + minute : minute;
      second = second < 10 ? '0' + second : second;
      return y + '-' + m + '-' + d;
    },
    save: function save() {
      var signature = 'signature1';
      console.info(this.$refs[signature]);
      var png = this.$refs[signature].save();
      this.form.agent_sign = encodeURI(png);
      this.showSignature = true;
    },
    edit: function edit() {
      this.showSignature = false;
      this.form.agent_sign = '';
    },
    clear: function clear() {
      var signature = 'signature1';
      var refs = this.$refs[signature].clear();
      this.form.agent_sign = '';
    },
    apiDetail: function apiDetail(nurser_name) {
      var _this3 = this;

      var params = {
        token: this.$cookie.get('token'),
        id: this.$route.query.list_id
      };
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.chritmasFormApi.getMatarnalHeathRecord(params).then(function (res) {
        console.info('请求详情数据');
        console.info(res);
        if (res.errcode == 200) {
          var data = res.data;
          _this3.form.room = data.room;
          _this3.form.delivery_type = data.delivery_type;
          _this3.form.postpartum_days = data.postpartum_days, _this3.form.healing = data.healing, _this3.form.uterus_place = data.uterus_place, _this3.form.lochia_amount = data.lochia_amount, _this3.form.lochia_color = data.lochia_color, _this3.form.lochia_taste = data.lochia_taste, _this3.form.chapped_nipple = data.chapped_nipple, _this3.form.breast = data.breast, _this3.form.milk_amount = data.milk_amount, _this3.form.stool = data.stool, _this3.form.pee = data.pee, _this3.form.special_case = data.special_case, _this3.form.advisory_date = data.advisory_date, _this3.form.agent_sign = data.agent_sign.indexOf(_this3.get_host) != -1 ? data.agent_sign : _this3.get_host + data.agent_sign;
          _this3.form.shifts = data.shifts;
          if (nurser_name.length) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = get_iterator_default()(nurser_name), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var item = _step.value;

                if (item.id == data.agent_id) {
                  _this3.cfrText = item.user_name;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }
          _this3.form.agent_id = data.agent_id;
          _this3.showSignature = true;
          _this3.$vux.loading.hide();
        } else {
          _this3.$vux.loading.hide();
          _this3.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiAddForm: function apiAddForm() {
      var _this4 = this;

      var params = {
        token: this.$cookie.get('token'),
        member_id: this.$cookie.get('id'),
        maternal_info_id: this.$route.query.id,
        room: this.form.room,
        delivery_type: this.form.delivery_type,
        postpartum_days: this.form.postpartum_days,
        healing: this.form.healing,
        uterus_place: this.form.uterus_place,
        lochia_amount: this.form.lochia_amount,
        lochia_color: this.form.lochia_color,
        lochia_taste: this.form.lochia_taste,
        chapped_nipple: this.form.chapped_nipple,
        breast: this.form.breast,
        milk_amount: this.form.milk_amount,
        stool: this.form.stool,
        pee: this.form.pee,
        special_case: this.form.special_case,
        advisory_date: this.form.advisory_date,
        agent_sign: this.form.agent_sign,
        agent_id: this.form.agent_id,
        shifts: this.form.shifts
      };
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.chritmasFormApi.addMatarnalHeathRecord(params).then(function (res) {
        console.info(res);
        if (res.errcode == 200) {
          _this4.$vux.loading.hide();
          _this4.$router.replace({
            path: '/success',
            query: {
              id: _this4.$route.query.id,
              form_id: _this4.$route.query.form_id,
              tabVal: _this4.$route.query.tabVal,
              name: 'christmas_form_one'
            }
          });
        } else {
          _this4.$vux.loading.hide();
          _this4.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    apiUpdateForm: function apiUpdateForm() {
      var _this5 = this;

      var params = {
        id: this.$route.query.list_id,
        token: this.$cookie.get('token'),
        member_id: this.$cookie.get('id'),
        maternal_info_id: this.$route.query.id,
        room: this.form.room,
        delivery_type: this.form.delivery_type,
        postpartum_days: this.form.postpartum_days,
        healing: this.form.healing,
        uterus_place: this.form.uterus_place,
        lochia_amount: this.form.lochia_amount,
        lochia_color: this.form.lochia_color,
        lochia_taste: this.form.lochia_taste,
        chapped_nipple: this.form.chapped_nipple,
        breast: this.form.breast,
        milk_amount: this.form.milk_amount,
        stool: this.form.stool,
        pee: this.form.pee,
        special_case: this.form.special_case,
        advisory_date: this.form.advisory_date,
        agent_sign: this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host, '') : this.form.agent_sign,
        agent_id: this.form.agent_id,
        shifts: this.form.shifts
      };
      console.info(params);
      this.$vux.loading.show({
        text: '正在加载'
      });
      Api.chritmasFormApi.updateMatarnalHeathRecord(params).then(function (res) {
        console.info(res);
        if (res.errcode == 200) {
          _this5.$vux.loading.hide();
          _this5.$router.replace({
            path: '/success',
            query: {
              id: _this5.$route.query.id,
              form_id: _this5.$route.query.form_id,
              tabVal: _this5.$route.query.tabVal,
              name: 'christmas_form_one'
            }
          });
        } else {
          _this5.$vux.loading.hide();
          _this5.$vux.toast.show({
            type: 'cancel',
            text: res.errinfo
          });
        }
      });
    },
    submitForm: function submitForm() {
      var form = this.form;
      if (form.delivery_type == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择分娩方式'
        });
        return;
      }
      if (form.advisory_date == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择健康咨询日期'
        });
        return;
      }
      if (form.postpartum_days == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入产后天数'
        });
        return;
      }
      if (form.healing == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择术口愈合情况'
        });
        return;
      }
      if (form.uterus_place == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择宫底位置'
        });
        return;
      }
      if (form.lochia_amount == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入恶露量'
        });
        return;
      }
      if (form.lochia_color == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择恶露色'
        });
        return;
      }
      if (form.lochia_taste == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择恶露味'
        });
        return;
      }
      if (form.chapped_nipple == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择乳头皲裂'
        });
        return;
      }
      if (form.breast == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择乳房情况'
        });
        return;
      }
      if (form.milk_amount == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入乳汁量'
        });
        return;
      }
      if (form.stool == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择大便'
        });
        return;
      }
      if (form.pee == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择小便'
        });
        return;
      }
      if (form.special_case == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入特殊情况'
        });
        return;
      }
      if (form.shifts == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择班次'
        });
        return;
      }
      if (form.agent_id == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请选择查房人'
        });
        return;
      }
      if (form.agent_sign == '') {
        this.$vux.toast.show({
          type: 'cancel',
          text: '请输入签名'
        });
        return;
      }
      if (this.$route.query.list_id) {
        console.info("请求更新数据");
        this.apiUpdateForm();
      } else {
        this.apiAddForm();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66ad3f93","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_one.vue
var christmas_form_one_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"christmas_form_one"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("(产妇)健康咨询记录表")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(_vm.form.room),callback:function ($$v) {_vm.$set(_vm.form, "room", $$v)},expression:"form.room"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":"","placeholder":"请输入姓名"},model:{value:(_vm.form.momName),callback:function ($$v) {_vm.$set(_vm.form, "momName", $$v)},expression:"form.momName"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"入住日期：","disabled":"","placeholder":"请输入入住日期"},model:{value:(_vm.form.live_time),callback:function ($$v) {_vm.$set(_vm.form, "live_time", $$v)},expression:"form.live_time"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩日期：","disabled":"","placeholder":"请输入分娩日期"},model:{value:(_vm.form.child_birth),callback:function ($$v) {_vm.$set(_vm.form, "child_birth", $$v)},expression:"form.child_birth"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","value":_vm.form.delivery_type}}),_vm._v(" "),_c('datetime',{attrs:{"title":"健康咨询日期：","placeholder":"请选择"},on:{"on-change":_vm.change_advisory_date},model:{value:(_vm.form.advisory_date),callback:function ($$v) {_vm.$set(_vm.form, "advisory_date", $$v)},expression:"form.advisory_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"产后天数：","disabled":""},model:{value:(_vm.form.postpartum_days),callback:function ($$v) {_vm.$set(_vm.form, "postpartum_days", $$v)},expression:"form.postpartum_days"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("术口愈合情况：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.healing),callback:function ($$v) {_vm.$set(_vm.form, "healing", $$v)},expression:"form.healing"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("良好")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("不良")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"46px"}},[_vm._v("宫底位置：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{ref:"uterusPlace",attrs:{"title":"","placeholder":"请输入宫底位置"},nativeOn:{"click":function($event){_vm.showOptions1 = true}},model:{value:(_vm.form.uterus_place),callback:function ($$v) {_vm.$set(_vm.form, "uterus_place", $$v)},expression:"form.uterus_place"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOptions1),expression:"showOptions1"}],staticClass:"drapList vux-1px"},_vm._l((_vm.options1),function(item,index){return _c('cell',{key:index,attrs:{"value":item,"value-align":"left"},nativeOn:{"click":function($event){return _vm.onChange(item)}}})}),1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"46px"}},[_vm._v("恶露情况(量)：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-input',{ref:"lochiaAmount",attrs:{"title":"","placeholder":"请输入恶露情况(量)"},nativeOn:{"click":function($event){_vm.showOptions2 = true}},model:{value:(_vm.form.lochia_amount),callback:function ($$v) {_vm.$set(_vm.form, "lochia_amount", $$v)},expression:"form.lochia_amount"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOptions2),expression:"showOptions2"}],staticClass:"drapList vux-1px"},_vm._l((_vm.options2),function(item,index){return _c('cell',{key:index,attrs:{"value":item,"value-align":"left"},nativeOn:{"click":function($event){return _vm.onChangeLochiaAmount(item)}}})}),1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("恶露情况(色)：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.lochia_color),callback:function ($$v) {_vm.$set(_vm.form, "lochia_color", $$v)},expression:"form.lochia_color"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("暗红")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("鲜红")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("白色")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("正常")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("恶露情况(味)：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.lochia_taste),callback:function ($$v) {_vm.$set(_vm.form, "lochia_taste", $$v)},expression:"form.lochia_taste"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("乳头皲裂：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.chapped_nipple),callback:function ($$v) {_vm.$set(_vm.form, "chapped_nipple", $$v)},expression:"form.chapped_nipple"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("乳房情况：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.breast),callback:function ($$v) {_vm.$set(_vm.form, "breast", $$v)},expression:"form.breast"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("左硬结")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("右硬结")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("无异常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"5"}},[_vm._v("双侧硬结")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("乳汁量：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.milk_amount),callback:function ($$v) {_vm.$set(_vm.form, "milk_amount", $$v)},expression:"form.milk_amount"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("多")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("中")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("少")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"4"}},[_vm._v("回奶")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("大便：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.stool),callback:function ($$v) {_vm.$set(_vm.form, "stool", $$v)},expression:"form.stool"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("正常")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("异常")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("小便：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.pee),callback:function ($$v) {_vm.$set(_vm.form, "pee", $$v)},expression:"form.pee"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("有")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("无")])],1)],1)])]),_vm._v(" "),_c('x-textarea',{attrs:{"title":"特殊情况：","placeholder":"请输入特殊情况"},model:{value:(_vm.form.special_case),callback:function ($$v) {_vm.$set(_vm.form, "special_case", $$v)},expression:"form.special_case"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px","padding-left":"5px"}},[_vm._v("班次：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("晚班")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"0","line-height":"29px"}},[_vm._v("查房人：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                    "+_vm._s(_vm.cfrText)+" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople.apply(null, arguments)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('cfr',{attrs:{"list_id":_vm.list_id,"showCfrList":_vm.showCfrList},on:{"cfrListEven":_vm.cfrListEven}})],1),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0pximportant"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0px"}},[_vm._v("签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.agent_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.agent_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var christmas_form_one_staticRenderFns = []
var christmas_form_one_esExports = { render: christmas_form_one_render, staticRenderFns: christmas_form_one_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_one = (christmas_form_one_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_one.vue
function christmas_form_one_injectStyle (ssrContext) {
  __webpack_require__("+g8E")
}
var christmas_form_one_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_one___vue_template_functional__ = false
/* styles */
var christmas_form_one___vue_styles__ = christmas_form_one_injectStyle
/* scopeId */
var christmas_form_one___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_one___vue_module_identifier__ = null
var christmas_form_one_Component = christmas_form_one_normalizeComponent(
  components_christmas_form_one,
  selectortype_template_index_0_src_components_christmas_form_one,
  christmas_form_one___vue_template_functional__,
  christmas_form_one___vue_styles__,
  christmas_form_one___vue_scopeId__,
  christmas_form_one___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_one = (christmas_form_one_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_two.vue



var christmas_form_two__methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_two = ({
    name: 'christmas_form_two',
    components: {
        cfr: src_components_cfrList
    },
    data: function data() {
        return {
            child_birth: '',
            showPopupPicker: false,
            options1: ['加强脐带部护理', '加强母乳喂养'],
            list_id: '',
            showCfrList: false,
            cfrText: '',
            form: {
                room: '',
                baby_id: '',
                live_time: '',
                agent_id: '',
                birth_day: '',
                jaundice: '',
                head_face: '正常',
                heart_rate: '',
                breathing: '',
                limbs: '正常',
                abdomen: '平软',
                hip: '正常',
                genitals: '正常',
                special_case: '',
                // deal_desc:'',
                deal: '',
                advisory_date: '',
                shifts: '',
                agent_sign: ''
            },
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            baby_list: [],
            get_host: host.host
        };
    },
    created: function created() {
        this.get_baby_list();
        this.apiMemberInfo();
        if (this.$route.query.list_id) {
            this.apiGetCfrList();
        }
    },

    methods: (christmas_form_two__methods = {
        GetNumberOfDays: function GetNumberOfDays(date1, date2) {
            //获得天数
            //date1：开始日期，date2结束日期
            var a1 = Date.parse(new Date(date1));
            var a2 = Date.parse(new Date(date2));
            var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24)); //核心：时间戳相减，然后除以天数
            return day;
        },
        change_advisory_date: function change_advisory_date(value) {
            var day = this.GetNumberOfDays(this.child_birth, value) + 1;
            this.form.birth_day = day;
        },

        //获取宫底位置input值
        onChange: function onChange(val) {
            this.form.deal = val;
            this.$refs.deal.focus();
            this.showPopupPicker = false;
        },

        //获取查房人列表
        apiGetCfrList: function apiGetCfrList() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                store_id: this.$cookie.get('store_id')
            };
            Api.checkRoomApi.getCheckInfo(params).then(function (res) {
                console.info("获取查房人列表", res);
                if (res.errcode == 1) {
                    _this.nurser_name = res.data.nurser_name; //过滤了离院，
                    _this.apiDetail(res.data.nurser_name);
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //点击选择查房人
        selectPeople: function selectPeople() {
            this.showCfrList = true;
        },

        //赋值查房人ID
        cfrListEven: function cfrListEven(val, item) {
            this.showCfrList = val;
            if (item) {
                this.form.agent_id = item.id;
                this.cfrText = item.user_name;
            }
        },

        //选择宝宝
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            this.form.live_time = '';
                            return;
                        }
                        this.form.live_time = this.formatDateTime(item.live_time);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },

        //获取宝宝
        get_baby_list: function get_baby_list() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.baby_list = res.data;
                    console.info(_this2.form.baby_id);
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = get_iterator_default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var item = _step2.value;

                            if (item.id == _this2.form.baby_id) {
                                _this2.form.live_time = _this2.formatDateTime(item.live_time);
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        }
    }, defineProperty_default()(christmas_form_two__methods, 'formatDateTime', function formatDateTime(inputTime) {
        var date = new Date(parseInt(inputTime) * 1000);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        var d = date.getDate();
        d = d < 10 ? '0' + d : d;
        var h = date.getHours();
        h = h < 10 ? '0' + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? '0' + minute : minute;
        second = second < 10 ? '0' + second : second;
        return y + '-' + m + '-' + d;
    }), defineProperty_default()(christmas_form_two__methods, 'apiMemberInfo', function apiMemberInfo() {
        var _this3 = this;

        var params = {
            token: this.$cookie.get('token'),
            maternal_info_id: this.$route.query.id
        };
        Api.checkRoomApi.memberInfo(params).then(function (res) {
            console.info(res);
            if (res.errcode == 1) {
                _this3.form.momName = res.data.name;
                _this3.form.room = res.data.room_name;
                _this3.child_birth = _this3.formatDateTime(res.data.child_birth);
            } else {
                _this3.$vux.toast.show({
                    type: 'cancel',
                    text: res.errinfo
                });
            }
        });
    }), defineProperty_default()(christmas_form_two__methods, 'save', function save() {
        var signature = 'signature1';
        var png = this.$refs[signature].save();
        this.form.agent_sign = encodeURI(png);
        this.showSignature = true;
    }), defineProperty_default()(christmas_form_two__methods, 'edit', function edit() {
        this.showSignature = false;
        this.form.agent_sign = '';
    }), defineProperty_default()(christmas_form_two__methods, 'clear', function clear() {
        var signature = 'signature1';
        var refs = this.$refs[signature].clear();
        this.form.agent_sign = '';
    }), defineProperty_default()(christmas_form_two__methods, 'apiDetail', function apiDetail(name) {
        var _this4 = this;

        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.list_id
        };
        this.$vux.loading.show({
            text: '正在加载'
        });
        Api.chritmasFormApi.getBabyHeathRecord(params).then(function (res) {
            console.info(res);
            if (res.errcode == 200) {
                var data = res.data;
                _this4.form.room = data.room;
                _this4.form.baby_id = data.baby_id, _this4.form.agent_id = data.agent_id, _this4.form.birth_day = data.birth_day, _this4.form.jaundice = data.jaundice, _this4.form.head_face = data.head_face,
                // this.form.heart_lung=data.heart_lung,
                _this4.form.heart_rate = data.heart_rate, _this4.form.breathing = data.breathing, _this4.form.limbs = data.limbs, _this4.form.abdomen = data.abdomen, _this4.form.hip = data.hip, _this4.form.genitals = data.genitals, _this4.form.special_case = data.special_case,
                // this.form.deal_desc=data.deal_desc,
                _this4.form.deal = data.deal, _this4.form.advisory_date = data.advisory_date, _this4.form.shifts = data.shifts, _this4.form.agent_sign = data.agent_sign.indexOf(_this4.get_host) != -1 ? data.agent_sign : _this4.get_host + data.agent_sign;
                _this4.showSignature = true;
                if (name.length) {
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = get_iterator_default()(name), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var item = _step3.value;

                            if (item.id == data.agent_id) {
                                _this4.cfrText = item.user_name;
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
                _this4.$vux.loading.hide();
            } else {
                _this4.$vux.loading.hide();
                _this4.$vux.toast.show({
                    type: 'cancel',
                    text: res.errinfo
                });
            }
        });
    }), defineProperty_default()(christmas_form_two__methods, 'apiAddForm', function apiAddForm() {
        var _this5 = this;

        var babyName = '';
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = get_iterator_default()(this.baby_list), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var item = _step4.value;

                if (item.id == this.form.baby_id) {
                    babyName = item.name;
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        var params = {
            token: this.$cookie.get('token'),
            maternal_info_id: this.$route.query.id,
            room: this.form.room,
            baby_id: this.form.baby_id,
            agent_id: this.form.agent_id,
            birth_day: this.form.birth_day,
            jaundice: this.form.jaundice,
            head_face: this.form.head_face,
            // heart_lung:this.form.heart_lung,
            heart_rate: this.form.heart_rate,
            breathing: this.form.breathing,
            limbs: this.form.limbs,
            abdomen: this.form.abdomen,
            hip: this.form.hip,
            genitals: this.form.genitals,
            special_case: this.form.special_case,
            deal: this.form.deal,
            advisory_date: this.form.advisory_date,
            shifts: this.form.shifts,
            agent_sign: this.form.agent_sign
        };
        console.info(params);
        this.$vux.loading.show({
            text: '正在加载'
        });
        Api.chritmasFormApi.addBabyHeathRecord(params).then(function (res) {
            console.info(res);
            if (res.errcode == 200) {
                _this5.$vux.loading.hide();
                _this5.$router.replace({
                    path: '/success',
                    query: {
                        id: _this5.$route.query.id,
                        form_id: _this5.$route.query.form_id,
                        tabVal: _this5.$route.query.tabVal,
                        name: 'christmas_form_two'
                    }
                });
            } else {
                _this5.$vux.loading.hide();
                _this5.$vux.toast.show({
                    type: 'cancel',
                    text: res.errinfo
                });
            }
        });
    }), defineProperty_default()(christmas_form_two__methods, 'apiUpdateForm', function apiUpdateForm() {
        var _this6 = this;

        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.list_id,
            maternal_info_id: this.$route.query.id,
            room: this.form.room,
            baby_id: this.form.baby_id,
            agent_id: this.form.agent_id,
            birth_day: this.form.birth_day,
            jaundice: this.form.jaundice,
            head_face: this.form.head_face,
            heart_rate: this.form.heart_rate,
            breathing: this.form.breathing,
            // heart_lung:this.form.heart_lung,

            limbs: this.form.limbs,
            abdomen: this.form.abdomen,
            hip: this.form.hip,
            genitals: this.form.genitals,
            special_case: this.form.special_case,
            // deal_desc:this.form.deal_desc,
            deal: this.form.deal,
            advisory_date: this.form.advisory_date,
            shifts: this.form.shifts,
            agent_sign: this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host, '') : this.form.agent_sign
        };
        console.info(params);
        this.$vux.loading.show({
            text: '正在加载'
        });
        Api.chritmasFormApi.updateBabyHeathRecord(params).then(function (res) {
            console.info(res);
            if (res.errcode == 200) {
                _this6.$vux.loading.hide();
                _this6.$router.replace({
                    path: '/success',
                    query: {
                        id: _this6.$route.query.id,
                        form_id: _this6.$route.query.form_id,
                        tabVal: _this6.$route.query.tabVal,
                        name: 'christmas_form_two'
                    }
                });
            } else {
                _this6.$vux.loading.hide();
                _this6.$vux.toast.show({
                    type: 'cancel',
                    text: res.errinfo
                });
            }
        });
    }), defineProperty_default()(christmas_form_two__methods, 'submitForm', function submitForm() {
        var form = this.form;
        if (form.baby_id == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择宝宝'
            });
            return;
        }
        if (form.advisory_date == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择健康咨询日期'
            });
            return;
        }
        if (form.birth_day == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入出生天数'
            });
            return;
        }
        if (form.jaundice == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入黄疸'
            });
            return;
        }
        if (form.head_face == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入头面部'
            });
            return;
        }
        if (form.heart_lung == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入心肺'
            });
            return;
        }
        if (form.limbs == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入四肢'
            });
            return;
        }
        if (form.abdomen == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入腹部'
            });
            return;
        }
        if (form.hip == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入臀部'
            });
            return;
        }
        if (form.genitals == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入生殖器'
            });
            return;
        }
        if (form.special_case == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入特殊情况'
            });
            return;
        }
        if (form.deal == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择处理'
            });
            return;
        }
        if (form.shifts == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择班次'
            });
            return;
        }
        if (form.agent_id == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择查房人'
            });
            return;
        }
        if (form.agent_sign == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入签名'
            });
            return;
        }

        // 判断宝宝是否入住
        var time = 0;
        if (this.baby_list.length) {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = get_iterator_default()(this.baby_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var item = _step5.value;

                    if (item.id == this.form.baby_id) {
                        time = item.live_time;
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        }
        if (time == '0') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '该宝宝暂未入住'
            });
            return;
        }
        if (this.$route.query.list_id) {
            console.info("请求更新数据");
            this.apiUpdateForm();
        } else {
            console.info("请求添加数据");
            this.apiAddForm();
        }
    }), christmas_form_two__methods)
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_two.vue



var components_christmas_form_two__methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_two = ({
    name: 'christmas_form_two',
    components: {
        cfr: src_components_cfrList
    },
    data: function data() {
        return {
            child_birth: '',
            showPopupPicker: false,
            options1: ['加强脐带部护理', '加强母乳喂养'],
            list_id: '',
            showCfrList: false,
            cfrText: '',
            form: {
                room: '',
                baby_id: '',
                live_time: '',
                agent_id: '',
                birth_day: '',
                jaundice: '',
                head_face: '正常',
                heart_rate: '',
                breathing: '',
                limbs: '正常',
                abdomen: '平软',
                hip: '正常',
                genitals: '正常',
                special_case: '',
                // deal_desc:'',
                deal: '',
                advisory_date: '',
                shifts: '',
                agent_sign: ''
            },
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            baby_list: [],
            get_host: host.host
        };
    },
    created: function created() {
        this.get_baby_list();
        this.apiMemberInfo();
        if (this.$route.query.list_id) {
            this.apiGetCfrList();
        }
    },

    methods: (components_christmas_form_two__methods = {
        GetNumberOfDays: function GetNumberOfDays(date1, date2) {
            //获得天数
            //date1：开始日期，date2结束日期
            var a1 = Date.parse(new Date(date1));
            var a2 = Date.parse(new Date(date2));
            var day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24)); //核心：时间戳相减，然后除以天数
            return day;
        },
        change_advisory_date: function change_advisory_date(value) {
            var day = this.GetNumberOfDays(this.child_birth, value) + 1;
            this.form.birth_day = day;
        },

        //获取宫底位置input值
        onChange: function onChange(val) {
            this.form.deal = val;
            this.$refs.deal.focus();
            this.showPopupPicker = false;
        },

        //获取查房人列表
        apiGetCfrList: function apiGetCfrList() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                store_id: this.$cookie.get('store_id')
            };
            Api.checkRoomApi.getCheckInfo(params).then(function (res) {
                console.info("获取查房人列表", res);
                if (res.errcode == 1) {
                    _this.nurser_name = res.data.nurser_name; //过滤了离院，
                    _this.apiDetail(res.data.nurser_name);
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //点击选择查房人
        selectPeople: function selectPeople() {
            this.showCfrList = true;
        },

        //赋值查房人ID
        cfrListEven: function cfrListEven(val, item) {
            this.showCfrList = val;
            if (item) {
                this.form.agent_id = item.id;
                this.cfrText = item.user_name;
            }
        },

        //选择宝宝
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            this.form.live_time = '';
                            return;
                        }
                        this.form.live_time = this.formatDateTime(item.live_time);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '-' + m + '-' + d;
        },

        //获取宝宝
        get_baby_list: function get_baby_list() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.baby_list = res.data;
                    console.info(_this2.form.baby_id);
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = get_iterator_default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var item = _step2.value;

                            if (item.id == _this2.form.baby_id) {
                                _this2.form.live_time = _this2.formatDateTime(item.live_time);
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        }
    }, defineProperty_default()(components_christmas_form_two__methods, 'formatDateTime', function formatDateTime(inputTime) {
        var date = new Date(parseInt(inputTime) * 1000);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        var d = date.getDate();
        d = d < 10 ? '0' + d : d;
        var h = date.getHours();
        h = h < 10 ? '0' + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? '0' + minute : minute;
        second = second < 10 ? '0' + second : second;
        return y + '-' + m + '-' + d;
    }), defineProperty_default()(components_christmas_form_two__methods, 'apiMemberInfo', function apiMemberInfo() {
        var _this3 = this;

        var params = {
            token: this.$cookie.get('token'),
            maternal_info_id: this.$route.query.id
        };
        Api.checkRoomApi.memberInfo(params).then(function (res) {
            console.info(res);
            if (res.errcode == 1) {
                _this3.form.momName = res.data.name;
                _this3.form.room = res.data.room_name;
                _this3.child_birth = _this3.formatDateTime(res.data.child_birth);
            } else {
                _this3.$vux.toast.show({
                    type: 'cancel',
                    text: res.errinfo
                });
            }
        });
    }), defineProperty_default()(components_christmas_form_two__methods, 'save', function save() {
        var signature = 'signature1';
        var png = this.$refs[signature].save();
        this.form.agent_sign = encodeURI(png);
        this.showSignature = true;
    }), defineProperty_default()(components_christmas_form_two__methods, 'edit', function edit() {
        this.showSignature = false;
        this.form.agent_sign = '';
    }), defineProperty_default()(components_christmas_form_two__methods, 'clear', function clear() {
        var signature = 'signature1';
        var refs = this.$refs[signature].clear();
        this.form.agent_sign = '';
    }), defineProperty_default()(components_christmas_form_two__methods, 'apiDetail', function apiDetail(name) {
        var _this4 = this;

        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.list_id
        };
        this.$vux.loading.show({
            text: '正在加载'
        });
        Api.chritmasFormApi.getBabyHeathRecord(params).then(function (res) {
            console.info(res);
            if (res.errcode == 200) {
                var data = res.data;
                _this4.form.room = data.room;
                _this4.form.baby_id = data.baby_id, _this4.form.agent_id = data.agent_id, _this4.form.birth_day = data.birth_day, _this4.form.jaundice = data.jaundice, _this4.form.head_face = data.head_face,
                // this.form.heart_lung=data.heart_lung,
                _this4.form.heart_rate = data.heart_rate, _this4.form.breathing = data.breathing, _this4.form.limbs = data.limbs, _this4.form.abdomen = data.abdomen, _this4.form.hip = data.hip, _this4.form.genitals = data.genitals, _this4.form.special_case = data.special_case,
                // this.form.deal_desc=data.deal_desc,
                _this4.form.deal = data.deal, _this4.form.advisory_date = data.advisory_date, _this4.form.shifts = data.shifts, _this4.form.agent_sign = data.agent_sign.indexOf(_this4.get_host) != -1 ? data.agent_sign : _this4.get_host + data.agent_sign;
                _this4.showSignature = true;
                if (name.length) {
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = get_iterator_default()(name), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var item = _step3.value;

                            if (item.id == data.agent_id) {
                                _this4.cfrText = item.user_name;
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
                _this4.$vux.loading.hide();
            } else {
                _this4.$vux.loading.hide();
                _this4.$vux.toast.show({
                    type: 'cancel',
                    text: res.errinfo
                });
            }
        });
    }), defineProperty_default()(components_christmas_form_two__methods, 'apiAddForm', function apiAddForm() {
        var _this5 = this;

        var babyName = '';
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = get_iterator_default()(this.baby_list), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var item = _step4.value;

                if (item.id == this.form.baby_id) {
                    babyName = item.name;
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        var params = {
            token: this.$cookie.get('token'),
            maternal_info_id: this.$route.query.id,
            room: this.form.room,
            baby_id: this.form.baby_id,
            agent_id: this.form.agent_id,
            birth_day: this.form.birth_day,
            jaundice: this.form.jaundice,
            head_face: this.form.head_face,
            // heart_lung:this.form.heart_lung,
            heart_rate: this.form.heart_rate,
            breathing: this.form.breathing,
            limbs: this.form.limbs,
            abdomen: this.form.abdomen,
            hip: this.form.hip,
            genitals: this.form.genitals,
            special_case: this.form.special_case,
            deal: this.form.deal,
            advisory_date: this.form.advisory_date,
            shifts: this.form.shifts,
            agent_sign: this.form.agent_sign
        };
        console.info(params);
        this.$vux.loading.show({
            text: '正在加载'
        });
        Api.chritmasFormApi.addBabyHeathRecord(params).then(function (res) {
            console.info(res);
            if (res.errcode == 200) {
                _this5.$vux.loading.hide();
                _this5.$router.replace({
                    path: '/success',
                    query: {
                        id: _this5.$route.query.id,
                        form_id: _this5.$route.query.form_id,
                        tabVal: _this5.$route.query.tabVal,
                        name: 'christmas_form_two'
                    }
                });
            } else {
                _this5.$vux.loading.hide();
                _this5.$vux.toast.show({
                    type: 'cancel',
                    text: res.errinfo
                });
            }
        });
    }), defineProperty_default()(components_christmas_form_two__methods, 'apiUpdateForm', function apiUpdateForm() {
        var _this6 = this;

        var params = {
            token: this.$cookie.get('token'),
            id: this.$route.query.list_id,
            maternal_info_id: this.$route.query.id,
            room: this.form.room,
            baby_id: this.form.baby_id,
            agent_id: this.form.agent_id,
            birth_day: this.form.birth_day,
            jaundice: this.form.jaundice,
            head_face: this.form.head_face,
            heart_rate: this.form.heart_rate,
            breathing: this.form.breathing,
            // heart_lung:this.form.heart_lung,

            limbs: this.form.limbs,
            abdomen: this.form.abdomen,
            hip: this.form.hip,
            genitals: this.form.genitals,
            special_case: this.form.special_case,
            // deal_desc:this.form.deal_desc,
            deal: this.form.deal,
            advisory_date: this.form.advisory_date,
            shifts: this.form.shifts,
            agent_sign: this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host, '') : this.form.agent_sign
        };
        console.info(params);
        this.$vux.loading.show({
            text: '正在加载'
        });
        Api.chritmasFormApi.updateBabyHeathRecord(params).then(function (res) {
            console.info(res);
            if (res.errcode == 200) {
                _this6.$vux.loading.hide();
                _this6.$router.replace({
                    path: '/success',
                    query: {
                        id: _this6.$route.query.id,
                        form_id: _this6.$route.query.form_id,
                        tabVal: _this6.$route.query.tabVal,
                        name: 'christmas_form_two'
                    }
                });
            } else {
                _this6.$vux.loading.hide();
                _this6.$vux.toast.show({
                    type: 'cancel',
                    text: res.errinfo
                });
            }
        });
    }), defineProperty_default()(components_christmas_form_two__methods, 'submitForm', function submitForm() {
        var form = this.form;
        if (form.baby_id == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择宝宝'
            });
            return;
        }
        if (form.advisory_date == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择健康咨询日期'
            });
            return;
        }
        if (form.birth_day == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入出生天数'
            });
            return;
        }
        if (form.jaundice == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入黄疸'
            });
            return;
        }
        if (form.head_face == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入头面部'
            });
            return;
        }
        if (form.heart_lung == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入心肺'
            });
            return;
        }
        if (form.limbs == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入四肢'
            });
            return;
        }
        if (form.abdomen == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入腹部'
            });
            return;
        }
        if (form.hip == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入臀部'
            });
            return;
        }
        if (form.genitals == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入生殖器'
            });
            return;
        }
        if (form.special_case == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入特殊情况'
            });
            return;
        }
        if (form.deal == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择处理'
            });
            return;
        }
        if (form.shifts == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择班次'
            });
            return;
        }
        if (form.agent_id == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请选择查房人'
            });
            return;
        }
        if (form.agent_sign == '') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '请输入签名'
            });
            return;
        }

        // 判断宝宝是否入住
        var time = 0;
        if (this.baby_list.length) {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = get_iterator_default()(this.baby_list), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var item = _step5.value;

                    if (item.id == this.form.baby_id) {
                        time = item.live_time;
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }
        }
        if (time == '0') {
            this.$vux.toast.show({
                type: 'cancel',
                text: '该宝宝暂未入住'
            });
            return;
        }
        if (this.$route.query.list_id) {
            console.info("请求更新数据");
            this.apiUpdateForm();
        } else {
            console.info("请求添加数据");
            this.apiAddForm();
        }
    }), components_christmas_form_two__methods)
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17e49444","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_two.vue
var christmas_form_two_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"christmasFormTwo"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("(新生儿)健康咨询记录表")]),_vm._v(" "),_c('div',[_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(_vm.form.room),callback:function ($$v) {_vm.$set(_vm.form, "room", $$v)},expression:"form.room"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("选择宝宝：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},on:{"on-change":_vm.checkerChange},model:{value:(_vm.form.baby_id),callback:function ($$v) {_vm.$set(_vm.form, "baby_id", $$v)},expression:"form.baby_id"}},_vm._l((_vm.baby_list),function(item){return _c('checker-item',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}),1)],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"入住日期：","disabled":"","placeholder":"请选择宝宝"},model:{value:(_vm.form.live_time),callback:function ($$v) {_vm.$set(_vm.form, "live_time", $$v)},expression:"form.live_time"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"健康咨询日期：","placeholder":"请选择"},on:{"on-change":_vm.change_advisory_date},model:{value:(_vm.form.advisory_date),callback:function ($$v) {_vm.$set(_vm.form, "advisory_date", $$v)},expression:"form.advisory_date"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"出生天数：","disabled":""},model:{value:(_vm.form.birth_day),callback:function ($$v) {_vm.$set(_vm.form, "birth_day", $$v)},expression:"form.birth_day"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"黄疸(TCB)：","placeholder":"请输入(单位：mg/dL)"},model:{value:(_vm.form.jaundice),callback:function ($$v) {_vm.$set(_vm.form, "jaundice", $$v)},expression:"form.jaundice"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"一般情况(头面部)：","placeholder":"请输入头面部"},model:{value:(_vm.form.head_face),callback:function ($$v) {_vm.$set(_vm.form, "head_face", $$v)},expression:"form.head_face"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"一般情况(心率)：","placeholder":"请输入心率"},model:{value:(_vm.form.heart_rate),callback:function ($$v) {_vm.$set(_vm.form, "heart_rate", $$v)},expression:"form.heart_rate"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"一般情况(呼吸)：","placeholder":"请输入呼吸"},model:{value:(_vm.form.breathing),callback:function ($$v) {_vm.$set(_vm.form, "breathing", $$v)},expression:"form.breathing"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"一般情况(四肢)：","placeholder":"请输入四肢"},model:{value:(_vm.form.limbs),callback:function ($$v) {_vm.$set(_vm.form, "limbs", $$v)},expression:"form.limbs"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"一般情况(腹部)：","placeholder":"请输入腹部"},model:{value:(_vm.form.abdomen),callback:function ($$v) {_vm.$set(_vm.form, "abdomen", $$v)},expression:"form.abdomen"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"一般情况(臀部)：","placeholder":"请输入臀部"},model:{value:(_vm.form.hip),callback:function ($$v) {_vm.$set(_vm.form, "hip", $$v)},expression:"form.hip"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"一般情况(生殖器)：","placeholder":"请输入生殖器"},model:{value:(_vm.form.genitals),callback:function ($$v) {_vm.$set(_vm.form, "genitals", $$v)},expression:"form.genitals"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"特殊情况：","placeholder":"请输入特殊情况"},model:{value:(_vm.form.special_case),callback:function ($$v) {_vm.$set(_vm.form, "special_case", $$v)},expression:"form.special_case"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"48px","padding-left":"5px"}},[_vm._v("处理：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('x-textarea',{ref:"deal",attrs:{"title":"","placeholder":"请输入"},nativeOn:{"click":function($event){_vm.showPopupPicker = true}},model:{value:(_vm.form.deal),callback:function ($$v) {_vm.$set(_vm.form, "deal", $$v)},expression:"form.deal"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPopupPicker),expression:"showPopupPicker"}],staticClass:"drapList vux-1px"},_vm._l((_vm.options1),function(item,index){return _c('cell',{key:index,attrs:{"value":item,"value-align":"left"},nativeOn:{"click":function($event){return _vm.onChange(item)}}})}),1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px","padding-left":"5px"}},[_vm._v("班次：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("晚班")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"0","line-height":"29px"}},[_vm._v("查房人：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                        "+_vm._s(_vm.cfrText)+" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople.apply(null, arguments)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('cfr',{attrs:{"list_id":_vm.list_id,"showCfrList":_vm.showCfrList},on:{"cfrListEven":_vm.cfrListEven}})],1),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.agent_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.agent_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)],1)}
var christmas_form_two_staticRenderFns = []
var christmas_form_two_esExports = { render: christmas_form_two_render, staticRenderFns: christmas_form_two_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_two = (christmas_form_two_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_two.vue
function christmas_form_two_injectStyle (ssrContext) {
  __webpack_require__("+N3V")
}
var christmas_form_two_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_two___vue_template_functional__ = false
/* styles */
var christmas_form_two___vue_styles__ = christmas_form_two_injectStyle
/* scopeId */
var christmas_form_two___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_two___vue_module_identifier__ = null
var christmas_form_two_Component = christmas_form_two_normalizeComponent(
  components_christmas_form_two,
  selectortype_template_index_0_src_components_christmas_form_two,
  christmas_form_two___vue_template_functional__,
  christmas_form_two___vue_styles__,
  christmas_form_two___vue_scopeId__,
  christmas_form_two___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_two = (christmas_form_two_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_three.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_three = ({
    name: 'christmas_form_three',
    components: {
        cfr: src_components_cfrList
    },
    data: function data() {
        return {
            get_host: host.host,
            list_id: '',
            showCfrList: false,
            cfrText: '',
            form: {
                room: '',
                momName: '',
                delivery_type: '',
                record_date: '',
                record_hour: '',
                detail: '',
                agent_id: '',
                agent_sign: '',
                shifts: ''
            },
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },
    created: function created() {
        this.apiMemberInfo();
        if (this.$route.query.list_id) {
            this.apiDetail();
        }
    },

    methods: {
        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.form.momName = res.data.name;
                    _this.form.room = res.data.room_name;
                    _this.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //点击选择查房人
        selectPeople: function selectPeople() {
            this.showCfrList = true;
        },

        //赋值查房人ID
        cfrListEven: function cfrListEven(val, item) {
            this.showCfrList = val;
            if (item) {
                this.form.agent_id = item.id;
                this.cfrText = item.user_name;
            }
        },
        save: function save() {
            var signature = 'signature1';
            var png = this.$refs[signature].save();
            this.form.agent_sign = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.agent_sign = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.agent_sign = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.getMatarnalSpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this2.form.room = data.room;
                    _this2.form.delivery_type = data.delivery_type;
                    _this2.form.record_date = data.record_date, _this2.form.record_hour = data.record_hour, _this2.form.detail = data.detail, _this2.form.agent_id = data.agent_id, _this2.form.agent_sign = data.agent_sign.indexOf(_this2.get_host) != -1 ? data.agent_sign : _this2.get_host + data.agent_sign;
                    _this2.form.shifts = data.shifts;
                    _this2.showSignature = true;
                    _this2.$vux.loading.hide();
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room: this.form.room,
                delivery_type: this.form.delivery_type,
                record_date: this.form.record_date,
                record_hour: this.form.record_hour,
                detail: this.form.detail,
                agent_id: this.form.agent_id,
                agent_sign: this.form.agent_sign,
                shifts: this.form.shifts
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.addMatarnalSpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this3.$vux.loading.hide();
                    _this3.$router.replace({
                        path: '/success',
                        query: {
                            id: _this3.$route.query.id,
                            form_id: _this3.$route.query.form_id,
                            tabVal: _this3.$route.query.tabVal,
                            name: 'christmas_form_three'
                        }
                    });
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this4 = this;

            var params = {
                id: this.$route.query.list_id,
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room: this.form.room,
                delivery_type: this.form.delivery_type,
                record_date: this.form.record_date,
                record_hour: this.form.record_hour,
                detail: this.form.detail,
                agent_id: this.form.agent_id,
                agent_sign: this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host, '') : this.form.agent_sign,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.updateMatarnalSpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'christmas_form_three'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_three.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_three = ({
    name: 'christmas_form_three',
    components: {
        cfr: src_components_cfrList
    },
    data: function data() {
        return {
            get_host: host.host,
            list_id: '',
            showCfrList: false,
            cfrText: '',
            form: {
                room: '',
                momName: '',
                delivery_type: '',
                record_date: '',
                record_hour: '',
                detail: '',
                agent_id: '',
                agent_sign: '',
                shifts: ''
            },
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },
    created: function created() {
        this.apiMemberInfo();
        if (this.$route.query.list_id) {
            this.apiDetail();
        }
    },

    methods: {
        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.form.momName = res.data.name;
                    _this.form.room = res.data.room_name;
                    _this.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //点击选择查房人
        selectPeople: function selectPeople() {
            this.showCfrList = true;
        },

        //赋值查房人ID
        cfrListEven: function cfrListEven(val, item) {
            this.showCfrList = val;
            if (item) {
                this.form.agent_id = item.id;
                this.cfrText = item.user_name;
            }
        },
        save: function save() {
            var signature = 'signature1';
            var png = this.$refs[signature].save();
            this.form.agent_sign = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.agent_sign = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.agent_sign = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.getMatarnalSpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this2.form.room = data.room;
                    _this2.form.delivery_type = data.delivery_type;
                    _this2.form.record_date = data.record_date, _this2.form.record_hour = data.record_hour, _this2.form.detail = data.detail, _this2.form.agent_id = data.agent_id, _this2.form.agent_sign = data.agent_sign.indexOf(_this2.get_host) != -1 ? data.agent_sign : _this2.get_host + data.agent_sign;
                    _this2.form.shifts = data.shifts;
                    _this2.showSignature = true;
                    _this2.$vux.loading.hide();
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room: this.form.room,
                delivery_type: this.form.delivery_type,
                record_date: this.form.record_date,
                record_hour: this.form.record_hour,
                detail: this.form.detail,
                agent_id: this.form.agent_id,
                agent_sign: this.form.agent_sign,
                shifts: this.form.shifts
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.addMatarnalSpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this3.$vux.loading.hide();
                    _this3.$router.replace({
                        path: '/success',
                        query: {
                            id: _this3.$route.query.id,
                            form_id: _this3.$route.query.form_id,
                            tabVal: _this3.$route.query.tabVal,
                            name: 'christmas_form_three'
                        }
                    });
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this4 = this;

            var params = {
                id: this.$route.query.list_id,
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room: this.form.room,
                delivery_type: this.form.delivery_type,
                record_date: this.form.record_date,
                record_hour: this.form.record_hour,
                detail: this.form.detail,
                agent_id: this.form.agent_id,
                agent_sign: this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host, '') : this.form.agent_sign,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.updateMatarnalSpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'christmas_form_three'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c2209f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_three.vue
var christmas_form_three_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"christmas_form_three"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("产妇特殊护理记录表")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(_vm.form.room),callback:function ($$v) {_vm.$set(_vm.form, "room", $$v)},expression:"form.room"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"姓名：","disabled":"","placeholder":"请输入姓名"},model:{value:(_vm.form.momName),callback:function ($$v) {_vm.$set(_vm.form, "momName", $$v)},expression:"form.momName"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","value":_vm.form.delivery_type}}),_vm._v(" "),_c('datetime',{attrs:{"title":"日期：","placeholder":"请选择"},model:{value:(_vm.form.record_date),callback:function ($$v) {_vm.$set(_vm.form, "record_date", $$v)},expression:"form.record_date"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"时间：","format":"HH:mm","placeholder":"请选择"},model:{value:(_vm.form.record_hour),callback:function ($$v) {_vm.$set(_vm.form, "record_hour", $$v)},expression:"form.record_hour"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"护理记录：","placeholder":"请输入其他情况"},model:{value:(_vm.form.detail),callback:function ($$v) {_vm.$set(_vm.form, "detail", $$v)},expression:"form.detail"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"0","line-height":"29px"}},[_vm._v("查房人：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                    "+_vm._s(_vm.cfrText)+" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople.apply(null, arguments)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('cfr',{attrs:{"list_id":_vm.list_id,"showCfrList":_vm.showCfrList},on:{"cfrListEven":_vm.cfrListEven}})],1),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0px1important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px","padding-left":"0px"}},[_vm._v("班次：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("晚班")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0pximportant"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0px"}},[_vm._v("签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.agent_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.agent_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var christmas_form_three_staticRenderFns = []
var christmas_form_three_esExports = { render: christmas_form_three_render, staticRenderFns: christmas_form_three_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_three = (christmas_form_three_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_three.vue
function christmas_form_three_injectStyle (ssrContext) {
  __webpack_require__("6L1p")
}
var christmas_form_three_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_three___vue_template_functional__ = false
/* styles */
var christmas_form_three___vue_styles__ = christmas_form_three_injectStyle
/* scopeId */
var christmas_form_three___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_three___vue_module_identifier__ = null
var christmas_form_three_Component = christmas_form_three_normalizeComponent(
  components_christmas_form_three,
  selectortype_template_index_0_src_components_christmas_form_three,
  christmas_form_three___vue_template_functional__,
  christmas_form_three___vue_styles__,
  christmas_form_three___vue_scopeId__,
  christmas_form_three___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_three = (christmas_form_three_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_four.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_four = ({
    name: 'christmas_form_three',
    components: {
        cfr: src_components_cfrList
    },
    data: function data() {
        var _form;

        return {
            list_id: '',
            showCfrList: false,
            cfrText: '',
            form: (_form = {
                room: '',
                hand_card: '',
                baby_id: '',
                momName: '',
                sex: ''
            }, defineProperty_default()(_form, 'momName', ''), defineProperty_default()(_form, 'birth_type', ''), defineProperty_default()(_form, 'record_date', ''), defineProperty_default()(_form, 'record_hour', ''), defineProperty_default()(_form, 'detail', ''), defineProperty_default()(_form, 'agent_id', ''), defineProperty_default()(_form, 'agent_sign', ''), defineProperty_default()(_form, 'shifts', ''), _form),
            baby_list: [],
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            get_host: host.host
        };
    },
    created: function created() {
        this.get_baby_list();
        this.apiMemberInfo();
        if (this.$route.query.list_id) {
            this.apiGetCfrList();
        }
    },

    methods: {
        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.form.momName = res.data.name;
                    _this.form.room = res.data.room_name;
                    _this.form.birth_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //获取宝宝
        get_baby_list: function get_baby_list() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.baby_list = res.data;
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //选择宝宝
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            return;
                        }
                        this.form.hand_card = item.hand_card;
                        this.form.sex = item.sex == '1' ? '男' : '女';
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        apiGetCfrList: function apiGetCfrList() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                store_id: this.$cookie.get('store_id')
            };
            Api.checkRoomApi.getCheckInfo(params).then(function (res) {
                console.info("获取查房人列表", res);
                if (res.errcode == 1) {
                    _this3.nurser_name = res.data.nurser_name; //过滤了离院，
                    _this3.apiDetail(res.data.nurser_name);
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //点击选择查房人
        selectPeople: function selectPeople() {
            this.showCfrList = true;
        },

        //赋值查房人ID
        cfrListEven: function cfrListEven(val, item) {
            this.showCfrList = val;
            if (item) {
                this.form.agent_id = item.id;
                this.cfrText = item.user_name;
            }
        },
        save: function save() {
            var signature = 'signature1';
            var png = this.$refs[signature].save();
            this.form.agent_sign = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.agent_sign = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.agent_sign = '';
        },

        //请求详情数据
        apiDetail: function apiDetail(name) {
            var _this4 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.getBabySpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this4.form.room = data.room;
                    _this4.form.hand_card = data.hand_card;
                    _this4.form.baby_id = data.baby_id;
                    _this4.form.record_date = data.record_date, _this4.form.record_hour = data.record_hour, _this4.form.detail = data.detail, _this4.form.agent_id = data.agent_id, _this4.form.agent_sign = data.agent_sign.indexOf(_this4.get_host) != -1 ? data.agent_sign : _this4.get_host + data.agent_sign;
                    _this4.form.shifts = data.shifts;
                    if (name.length) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = get_iterator_default()(name), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var item = _step2.value;

                                if (item.id == data.agent_id) {
                                    _this4.cfrText = item.user_name;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                    _this4.showSignature = true;
                    _this4.$vux.loading.hide();
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this5 = this;

            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room: this.form.room,
                hand_card: this.form.hand_card,
                baby_id: this.form.baby_id,
                record_date: this.form.record_date,
                record_hour: this.form.record_hour,
                detail: this.form.detail,
                agent_id: this.form.agent_id,
                agent_sign: this.form.agent_sign,
                shifts: this.form.shifts
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.addBabySpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this5.$vux.loading.hide();
                    _this5.$router.replace({
                        path: '/success',
                        query: {
                            id: _this5.$route.query.id,
                            form_id: _this5.$route.query.form_id,
                            tabVal: _this5.$route.query.tabVal,
                            name: 'christmas_form_four'
                        }
                    });
                } else {
                    _this5.$vux.loading.hide();
                    _this5.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this6 = this;

            var params = {
                id: this.$route.query.list_id,
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room: this.form.room,
                hand_card: this.form.hand_card,
                baby_id: this.form.baby_id,
                record_date: this.form.record_date,
                record_hour: this.form.record_hour,
                detail: this.form.detail,
                agent_id: this.form.agent_id,
                agent_sign: this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host, '') : this.form.agent_sign,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.updateBabySpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this6.$vux.loading.hide();
                    _this6.$router.replace({
                        path: '/success',
                        query: {
                            id: _this6.$route.query.id,
                            form_id: _this6.$route.query.form_id,
                            tabVal: _this6.$route.query.tabVal,
                            name: 'christmas_form_four'
                        }
                    });
                } else {
                    _this6.$vux.loading.hide();
                    _this6.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            // 判断宝宝是否入住
            var time = 0;
            if (this.baby_list.length) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = get_iterator_default()(this.baby_list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var item = _step3.value;

                        if (item.id == this.form.baby_id) {
                            time = item.live_time;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            if (time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝暂未入住'
                });
                return;
            }
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_four.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_four = ({
    name: 'christmas_form_three',
    components: {
        cfr: src_components_cfrList
    },
    data: function data() {
        var _form;

        return {
            list_id: '',
            showCfrList: false,
            cfrText: '',
            form: (_form = {
                room: '',
                hand_card: '',
                baby_id: '',
                momName: '',
                sex: ''
            }, defineProperty_default()(_form, 'momName', ''), defineProperty_default()(_form, 'birth_type', ''), defineProperty_default()(_form, 'record_date', ''), defineProperty_default()(_form, 'record_hour', ''), defineProperty_default()(_form, 'detail', ''), defineProperty_default()(_form, 'agent_id', ''), defineProperty_default()(_form, 'agent_sign', ''), defineProperty_default()(_form, 'shifts', ''), _form),
            baby_list: [],
            showSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            get_host: host.host
        };
    },
    created: function created() {
        this.get_baby_list();
        this.apiMemberInfo();
        if (this.$route.query.list_id) {
            this.apiGetCfrList();
        }
    },

    methods: {
        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.form.momName = res.data.name;
                    _this.form.room = res.data.room_name;
                    _this.form.birth_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : '';
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //获取宝宝
        get_baby_list: function get_baby_list() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.monthLiveApi.babyList(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this2.baby_list = res.data;
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //选择宝宝
        checkerChange: function checkerChange(value) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = get_iterator_default()(this.baby_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.id == value) {
                        if (item.live_time == '0') {
                            this.$vux.toast.show({
                                type: 'cancel',
                                text: item.name + '暂未入住'
                            });
                            return;
                        }
                        this.form.hand_card = item.hand_card;
                        this.form.sex = item.sex == '1' ? '男' : '女';
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        apiGetCfrList: function apiGetCfrList() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                store_id: this.$cookie.get('store_id')
            };
            Api.checkRoomApi.getCheckInfo(params).then(function (res) {
                console.info("获取查房人列表", res);
                if (res.errcode == 1) {
                    _this3.nurser_name = res.data.nurser_name; //过滤了离院，
                    _this3.apiDetail(res.data.nurser_name);
                } else {
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //点击选择查房人
        selectPeople: function selectPeople() {
            this.showCfrList = true;
        },

        //赋值查房人ID
        cfrListEven: function cfrListEven(val, item) {
            this.showCfrList = val;
            if (item) {
                this.form.agent_id = item.id;
                this.cfrText = item.user_name;
            }
        },
        save: function save() {
            var signature = 'signature1';
            var png = this.$refs[signature].save();
            this.form.agent_sign = encodeURI(png);
            this.showSignature = true;
        },
        edit: function edit() {
            this.showSignature = false;
            this.form.agent_sign = '';
        },
        clear: function clear() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.agent_sign = '';
        },

        //请求详情数据
        apiDetail: function apiDetail(name) {
            var _this4 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.getBabySpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this4.form.room = data.room;
                    _this4.form.hand_card = data.hand_card;
                    _this4.form.baby_id = data.baby_id;
                    _this4.form.record_date = data.record_date, _this4.form.record_hour = data.record_hour, _this4.form.detail = data.detail, _this4.form.agent_id = data.agent_id, _this4.form.agent_sign = data.agent_sign.indexOf(_this4.get_host) != -1 ? data.agent_sign : _this4.get_host + data.agent_sign;
                    _this4.form.shifts = data.shifts;
                    if (name.length) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = get_iterator_default()(name), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var item = _step2.value;

                                if (item.id == data.agent_id) {
                                    _this4.cfrText = item.user_name;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                    _this4.showSignature = true;
                    _this4.$vux.loading.hide();
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this5 = this;

            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room: this.form.room,
                hand_card: this.form.hand_card,
                baby_id: this.form.baby_id,
                record_date: this.form.record_date,
                record_hour: this.form.record_hour,
                detail: this.form.detail,
                agent_id: this.form.agent_id,
                agent_sign: this.form.agent_sign,
                shifts: this.form.shifts
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.addBabySpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this5.$vux.loading.hide();
                    _this5.$router.replace({
                        path: '/success',
                        query: {
                            id: _this5.$route.query.id,
                            form_id: _this5.$route.query.form_id,
                            tabVal: _this5.$route.query.tabVal,
                            name: 'christmas_form_four'
                        }
                    });
                } else {
                    _this5.$vux.loading.hide();
                    _this5.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this6 = this;

            var params = {
                id: this.$route.query.list_id,
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room: this.form.room,
                hand_card: this.form.hand_card,
                baby_id: this.form.baby_id,
                record_date: this.form.record_date,
                record_hour: this.form.record_hour,
                detail: this.form.detail,
                agent_id: this.form.agent_id,
                agent_sign: this.form.agent_sign.indexOf(this.get_host) != -1 ? this.form.agent_sign.replace(this.get_host, '') : this.form.agent_sign,
                shifts: this.form.shifts
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.chritmasFormApi.updateBabySpecialNursingRecord(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this6.$vux.loading.hide();
                    _this6.$router.replace({
                        path: '/success',
                        query: {
                            id: _this6.$route.query.id,
                            form_id: _this6.$route.query.form_id,
                            tabVal: _this6.$route.query.tabVal,
                            name: 'christmas_form_four'
                        }
                    });
                } else {
                    _this6.$vux.loading.hide();
                    _this6.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            // 判断宝宝是否入住
            var time = 0;
            if (this.baby_list.length) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = get_iterator_default()(this.baby_list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var item = _step3.value;

                        if (item.id == this.form.baby_id) {
                            time = item.live_time;
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            if (time == '0') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '该宝宝暂未入住'
                });
                return;
            }
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c730d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_four.vue
var christmas_form_four_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"christmas_form_four"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("宝宝特殊护理记录表")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"房号：","disabled":"","placeholder":"请输入房号"},model:{value:(_vm.form.room),callback:function ($$v) {_vm.$set(_vm.form, "room", $$v)},expression:"form.room"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手卡号：","disabled":"","placeholder":"请输入手卡号"},model:{value:(_vm.form.hand_card),callback:function ($$v) {_vm.$set(_vm.form, "hand_card", $$v)},expression:"form.hand_card"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("选择宝宝：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},on:{"on-change":_vm.checkerChange},model:{value:(_vm.form.baby_id),callback:function ($$v) {_vm.$set(_vm.form, "baby_id", $$v)},expression:"form.baby_id"}},_vm._l((_vm.baby_list),function(item){return _c('checker-item',{key:item.id,attrs:{"value":item.id}},[_vm._v(_vm._s(item.name))])}),1)],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"性别：","disabled":"","placeholder":"请输入性别"},model:{value:(_vm.form.sex),callback:function ($$v) {_vm.$set(_vm.form, "sex", $$v)},expression:"form.sex"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"母亲姓名：","disabled":"","placeholder":"请输入母亲姓名"},model:{value:(_vm.form.momName),callback:function ($$v) {_vm.$set(_vm.form, "momName", $$v)},expression:"form.momName"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"分娩方式：","disabled":"","placeholder":"请输入分娩方式"},model:{value:(_vm.form.birth_type),callback:function ($$v) {_vm.$set(_vm.form, "birth_type", $$v)},expression:"form.birth_type"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"日期：","placeholder":"请选择"},model:{value:(_vm.form.record_date),callback:function ($$v) {_vm.$set(_vm.form, "record_date", $$v)},expression:"form.record_date"}}),_vm._v(" "),_c('datetime',{attrs:{"title":"时间：","format":"HH:mm","placeholder":"请选择"},model:{value:(_vm.form.record_hour),callback:function ($$v) {_vm.$set(_vm.form, "record_hour", $$v)},expression:"form.record_hour"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"护理记录：","placeholder":"请输入其他情况"},model:{value:(_vm.form.detail),callback:function ($$v) {_vm.$set(_vm.form, "detail", $$v)},expression:"form.detail"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label",staticStyle:{"margin-top":"0","line-height":"29px"}},[_vm._v("查房人：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                    "+_vm._s(_vm.cfrText)+" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.selectPeople.apply(null, arguments)}}},[_vm._v("选择查房人")])],1)]),_vm._v(" "),_c('cfr',{attrs:{"list_id":_vm.list_id,"showCfrList":_vm.showCfrList},on:{"cfrListEven":_vm.cfrListEven}})],1),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0px1important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px","padding-left":"0px"}},[_vm._v("班次：")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.shifts),callback:function ($$v) {_vm.$set(_vm.form, "shifts", $$v)},expression:"form.shifts"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("早班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("中班")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"3"}},[_vm._v("晚班")])],1)],1)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0pximportant"}},[_c('div',{staticClass:"label",staticStyle:{"padding-left":"0px"}},[_vm._v("签名：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.agent_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.agent_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var christmas_form_four_staticRenderFns = []
var christmas_form_four_esExports = { render: christmas_form_four_render, staticRenderFns: christmas_form_four_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_four = (christmas_form_four_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_four.vue
function christmas_form_four_injectStyle (ssrContext) {
  __webpack_require__("oPtZ")
}
var christmas_form_four_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_four___vue_template_functional__ = false
/* styles */
var christmas_form_four___vue_styles__ = christmas_form_four_injectStyle
/* scopeId */
var christmas_form_four___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_four___vue_module_identifier__ = null
var christmas_form_four_Component = christmas_form_four_normalizeComponent(
  components_christmas_form_four,
  selectortype_template_index_0_src_components_christmas_form_four,
  christmas_form_four___vue_template_functional__,
  christmas_form_four___vue_styles__,
  christmas_form_four___vue_scopeId__,
  christmas_form_four___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_four = (christmas_form_four_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_five.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var christmas_form_five = ({
    name: 'christmas_form_five',
    data: function data() {
        return {};
    },

    methods: {
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_five.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_christmas_form_five = ({
    name: 'christmas_form_five',
    data: function data() {
        return {};
    },

    methods: {
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        }
    },
    created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a807db7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_five.vue
var christmas_form_five_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("出所指导")]),_vm._v(" "),_c('group',{staticClass:"formFive"},[_c('flexbox',[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainTitle"},[_vm._v("产妇：")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainText"},[_vm._v("（1）注意产后6-8周卫生。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainText"},[_vm._v("（2）注意合理健康饮食和休养。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainText"},[_vm._v("（3）坚持母乳喂养。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainText"},[_vm._v("（4）加强产后康复训练。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainText"},[_vm._v("（5）按要求到社区卫生服务中心做好产后42天健康检查。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainText"},[_vm._v("（6）产后6-8周禁止性生活，知情选择避孕措施。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainTitle"},[_vm._v("婴儿：")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainText"},[_vm._v("（1）加强婴儿护理，勤换尿布，预防红臀，每天洗澡的室温28℃，水温38~42℃。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainText"},[_vm._v("（2）坚持母乳喂养，按需哺乳。6个月后添加辅食。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainText"},[_vm._v("（3）按要求定期到社区服务中心儿童健康检查。")])])],1),_vm._v(" "),_c('flexbox',{staticClass:"vux-1px-t"},[_c('flexbox-item',[_c('div',{staticClass:"flex-demo mainText"},[_vm._v("（4）按照计划免疫接种。")])])],1)],1)],1)}
var christmas_form_five_staticRenderFns = []
var christmas_form_five_esExports = { render: christmas_form_five_render, staticRenderFns: christmas_form_five_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_five = (christmas_form_five_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_five.vue
function christmas_form_five_injectStyle (ssrContext) {
  __webpack_require__("vngD")
}
var christmas_form_five_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_five___vue_template_functional__ = false
/* styles */
var christmas_form_five___vue_styles__ = christmas_form_five_injectStyle
/* scopeId */
var christmas_form_five___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_five___vue_module_identifier__ = null
var christmas_form_five_Component = christmas_form_five_normalizeComponent(
  components_christmas_form_five,
  selectortype_template_index_0_src_components_christmas_form_five,
  christmas_form_five___vue_template_functional__,
  christmas_form_five___vue_styles__,
  christmas_form_five___vue_scopeId__,
  christmas_form_five___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_five = (christmas_form_five_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_six.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_six = ({
    name: 'christmas_form_six',
    data: function data() {
        return {
            num: 0,
            host: api_const["host"],
            form: {
                prove: [],
                intermediate_nurse_sign: '',
                senior_nurse: ''
            },

            showSignature: false,
            showCSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            if (this.form.prove.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张图片'
                });
                return;
            }
            if (this.form.intermediate_nurse_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少中级护理师签字'
                });
                return;
            }
            if (this.form.senior_nurse == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少护理长签字'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse
            };
            var files = this.form.prove;
            Api.otherFormApi.updateMaternalLeaveProveRecor(params, files, 'prove').then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_six'
                        }
                    });
                }
                // this.$router.push({
                //     path:'christmas_form_six_detail', 
                //     query:{
                //         id:this.$route.query.id,
                //         tabVal: this.$route.query.tabVal,
                //     }
                // })
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.prove.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.num++;
                console.info("rst", rst);
                that.form.prove.push(rst);
                console.info(that.form.prove);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(file) {
            if (this.num == 0) {
                this.num = 0;
            } else {
                this.num--;
            }
            console.info(file);
            for (var i = 0; i < this.form.prove.length; i++) {
                console.info(this.form.prove[i].id);
                if (file.id == this.form.prove[i].id) {
                    this.form.prove.splice(i, 1);
                }
            }
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_six.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_six = ({
    name: 'christmas_form_six',
    data: function data() {
        return {
            num: 0,
            host: api_const["host"],
            form: {
                prove: [],
                intermediate_nurse_sign: '',
                senior_nurse: ''
            },

            showSignature: false,
            showCSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            if (this.form.prove.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张图片'
                });
                return;
            }
            if (this.form.intermediate_nurse_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少中级护理师签字'
                });
                return;
            }
            if (this.form.senior_nurse == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少护理长签字'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse
            };
            var files = this.form.prove;
            Api.otherFormApi.updateMaternalLeaveProveRecor(params, files, 'prove').then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_six'
                        }
                    });
                }
                // this.$router.push({
                //     path:'christmas_form_six_detail', 
                //     query:{
                //         id:this.$route.query.id,
                //         tabVal: this.$route.query.tabVal,
                //     }
                // })
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.prove.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.num++;
                console.info("rst", rst);
                that.form.prove.push(rst);
                console.info(that.form.prove);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(file) {
            if (this.num == 0) {
                this.num = 0;
            } else {
                this.num--;
            }
            console.info(file);
            for (var i = 0; i < this.form.prove.length; i++) {
                console.info(this.form.prove[i].id);
                if (file.id == this.form.prove[i].id) {
                    this.form.prove.splice(i, 1);
                }
            }
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b2ecc9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_six.vue
var christmas_form_six_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("出院证明")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v("出院记录粘贴处：")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png"},on:{"change":_vm.fileImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})])]),_vm._v(" "),(_vm.form.prove.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm.form.prove),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":item.base64,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(item)}}})])}),0):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCSignature)?_c('div',[(_vm.form.intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.intermediate_nurse_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editCName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveCName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearCName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.senior_nurse,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var christmas_form_six_staticRenderFns = []
var christmas_form_six_esExports = { render: christmas_form_six_render, staticRenderFns: christmas_form_six_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_six = (christmas_form_six_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_six.vue
function christmas_form_six_injectStyle (ssrContext) {
  __webpack_require__("PMTo")
}
var christmas_form_six_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_six___vue_template_functional__ = false
/* styles */
var christmas_form_six___vue_styles__ = christmas_form_six_injectStyle
/* scopeId */
var christmas_form_six___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_six___vue_module_identifier__ = null
var christmas_form_six_Component = christmas_form_six_normalizeComponent(
  components_christmas_form_six,
  selectortype_template_index_0_src_components_christmas_form_six,
  christmas_form_six___vue_template_functional__,
  christmas_form_six___vue_styles__,
  christmas_form_six___vue_scopeId__,
  christmas_form_six___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_six = (christmas_form_six_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_six_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_six_detail = ({
    name: 'christmas_form_six_detail',
    data: function data() {
        return {
            get_host: host.host,
            host: api_const["host"],
            form: {
                // prove:[],
                // intermediate_nurse_sign:'',
                // senior_nurse:''
            },

            showSignature: true,
            showCSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_six_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse
            };
            var prove = this.form.prove;
            Api.otherFormApi.updateMaternalLeaveProveRecor(params, prove).then(function (res) {
                console.info(res);
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.prove.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                console.info("rst", rst);
                that.form.prove.push(rst);
                console.info(that.form.prove);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(index, id) {
            console.info(index, id);
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {
        var _this = this;

        var params = {
            token: this.$cookie.get('token'),
            number_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id')
        };
        Api.otherFormApi.getMaternalLeaveProveRecord(params).then(function (res) {
            console.info("出院证明详情", res);
            if (res.errcode == 200) {
                _this.form = res.data;
                _this.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this.get_host) != -1 ? res.data.intermediate_nurse_sign : _this.get_host + res.data.intermediate_nurse_sign;
                _this.form.senior_nurse = res.data.senior_nurse.indexOf(_this.get_host) != -1 ? res.data.senior_nurse : _this.get_host + res.data.senior_nurse;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_six_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_six_detail = ({
    name: 'christmas_form_six_detail',
    data: function data() {
        return {
            get_host: host.host,
            host: api_const["host"],
            form: {
                // prove:[],
                // intermediate_nurse_sign:'',
                // senior_nurse:''
            },

            showSignature: true,
            showCSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_six_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse
            };
            var prove = this.form.prove;
            Api.otherFormApi.updateMaternalLeaveProveRecor(params, prove).then(function (res) {
                console.info(res);
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.prove.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                console.info("rst", rst);
                that.form.prove.push(rst);
                console.info(that.form.prove);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(index, id) {
            console.info(index, id);
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {
        var _this = this;

        var params = {
            token: this.$cookie.get('token'),
            number_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id')
        };
        Api.otherFormApi.getMaternalLeaveProveRecord(params).then(function (res) {
            console.info("出院证明详情", res);
            if (res.errcode == 200) {
                _this.form = res.data;
                _this.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this.get_host) != -1 ? res.data.intermediate_nurse_sign : _this.get_host + res.data.intermediate_nurse_sign;
                _this.form.senior_nurse = res.data.senior_nurse.indexOf(_this.get_host) != -1 ? res.data.senior_nurse : _this.get_host + res.data.senior_nurse;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a137b3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_six_detail.vue
var christmas_form_six_detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("出院证明")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v("出院记录粘贴处：")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm.form.prove),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCSignature)?_c('div',[(_vm.form.intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.intermediate_nurse_sign,"alt":""}}):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.senior_nurse,"alt":""}}):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.goEdit.apply(null, arguments)}}},[_vm._v("修改")])],1)],1)}
var christmas_form_six_detail_staticRenderFns = []
var christmas_form_six_detail_esExports = { render: christmas_form_six_detail_render, staticRenderFns: christmas_form_six_detail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_six_detail = (christmas_form_six_detail_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_six_detail.vue
function christmas_form_six_detail_injectStyle (ssrContext) {
  __webpack_require__("lWZV")
}
var christmas_form_six_detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_six_detail___vue_template_functional__ = false
/* styles */
var christmas_form_six_detail___vue_styles__ = christmas_form_six_detail_injectStyle
/* scopeId */
var christmas_form_six_detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_six_detail___vue_module_identifier__ = null
var christmas_form_six_detail_Component = christmas_form_six_detail_normalizeComponent(
  components_christmas_form_six_detail,
  selectortype_template_index_0_src_components_christmas_form_six_detail,
  christmas_form_six_detail___vue_template_functional__,
  christmas_form_six_detail___vue_styles__,
  christmas_form_six_detail___vue_scopeId__,
  christmas_form_six_detail___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_six_detail = (christmas_form_six_detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_six_edit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_six_edit = ({
    name: 'christmas_form_six_detail',
    data: function data() {
        return {
            get_host: host.host,
            host: api_const["host"],
            newFile: [],
            form: {
                prove: []
                // intermediate_nurse_sign:'',
                // senior_nurse:''
            },

            showSignature: true,
            showCSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_six_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            console.info("this.form.prove", this.form.prove);
            console.info("this.newFile", this.newFile);
            if (this.form.prove.length == 0 && this.newFile.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张图片'
                });
                return;
            }
            if (this.form.intermediate_nurse_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少中级护理师签字'
                });
                return;
            }
            if (this.form.senior_nurse == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少护理长签字'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign.indexOf(this.get_host) != -1 ? this.form.intermediate_nurse_sign.replace(this.get_host, '') : this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse.indexOf(this.get_host) != -1 ? this.form.senior_nurse.replace(this.get_host, '') : this.form.senior_nurse,
                prove: this.form.prove
            };
            console.log(params);
            var files = this.newFile;
            Api.otherFormApi.updateMaternalLeaveProveRecor(params, files, 'prove').then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_six_edit'
                        }
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                var newLen = that.newFile.length + that.form.prove.length;
                if (newLen == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }

                that.newFile.push(rst);
                console.info(that.newFile);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(file) {
            if (file.base64) {
                for (var i = 0; i < this.newFile.length; i++) {
                    if (file.base64 == this.newFile[i].base64) {
                        this.newFile.splice(i, 1);
                    }
                }
            } else {
                for (var i = 0; i < this.form.prove.length; i++) {
                    if (file == this.form.prove[i]) {
                        this.form.prove.splice(i, 1);
                    }
                }
            }
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {
        var _this2 = this;

        var params = {
            token: this.$cookie.get('token'),
            number_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id')
        };
        Api.otherFormApi.getMaternalLeaveProveRecord(params).then(function (res) {
            console.info("出院证明详情", res);
            if (res.errcode == 200) {
                _this2.form = res.data;
                _this2.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.intermediate_nurse_sign : _this2.get_host + res.data.intermediate_nurse_sign;
                _this2.form.senior_nurse = res.data.senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.senior_nurse : _this2.get_host + res.data.senior_nurse;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_six_edit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_six_edit = ({
    name: 'christmas_form_six_detail',
    data: function data() {
        return {
            get_host: host.host,
            host: api_const["host"],
            newFile: [],
            form: {
                prove: []
                // intermediate_nurse_sign:'',
                // senior_nurse:''
            },

            showSignature: true,
            showCSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_six_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            console.info("this.form.prove", this.form.prove);
            console.info("this.newFile", this.newFile);
            if (this.form.prove.length == 0 && this.newFile.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张图片'
                });
                return;
            }
            if (this.form.intermediate_nurse_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少中级护理师签字'
                });
                return;
            }
            if (this.form.senior_nurse == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少护理长签字'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign.indexOf(this.get_host) != -1 ? this.form.intermediate_nurse_sign.replace(this.get_host, '') : this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse.indexOf(this.get_host) != -1 ? this.form.senior_nurse.replace(this.get_host, '') : this.form.senior_nurse,
                prove: this.form.prove
            };
            console.log(params);
            var files = this.newFile;
            Api.otherFormApi.updateMaternalLeaveProveRecor(params, files, 'prove').then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_six_edit'
                        }
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                var newLen = that.newFile.length + that.form.prove.length;
                if (newLen == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }

                that.newFile.push(rst);
                console.info(that.newFile);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(file) {
            if (file.base64) {
                for (var i = 0; i < this.newFile.length; i++) {
                    if (file.base64 == this.newFile[i].base64) {
                        this.newFile.splice(i, 1);
                    }
                }
            } else {
                for (var i = 0; i < this.form.prove.length; i++) {
                    if (file == this.form.prove[i]) {
                        this.form.prove.splice(i, 1);
                    }
                }
            }
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {
        var _this2 = this;

        var params = {
            token: this.$cookie.get('token'),
            number_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id')
        };
        Api.otherFormApi.getMaternalLeaveProveRecord(params).then(function (res) {
            console.info("出院证明详情", res);
            if (res.errcode == 200) {
                _this2.form = res.data;
                _this2.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.intermediate_nurse_sign : _this2.get_host + res.data.intermediate_nurse_sign;
                _this2.form.senior_nurse = res.data.senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.senior_nurse : _this2.get_host + res.data.senior_nurse;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507ab6a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_six_edit.vue
var christmas_form_six_edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("出院证明")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"9em"}},[_vm._v("出院记录粘贴处：")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png"},on:{"change":_vm.fileImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_vm._l((_vm.form.prove),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(item)}}})])}),_vm._v(" "),_vm._l((_vm.newFile),function(item,index){return (_vm.newFile.length)?_c('a',{staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":item.base64,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(item)}}})]):_vm._e()})],2)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCSignature)?_c('div',[(_vm.form.intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.intermediate_nurse_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editCName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveCName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearCName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.senior_nurse,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var christmas_form_six_edit_staticRenderFns = []
var christmas_form_six_edit_esExports = { render: christmas_form_six_edit_render, staticRenderFns: christmas_form_six_edit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_six_edit = (christmas_form_six_edit_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_six_edit.vue
function christmas_form_six_edit_injectStyle (ssrContext) {
  __webpack_require__("jqw6")
}
var christmas_form_six_edit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_six_edit___vue_template_functional__ = false
/* styles */
var christmas_form_six_edit___vue_styles__ = christmas_form_six_edit_injectStyle
/* scopeId */
var christmas_form_six_edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_six_edit___vue_module_identifier__ = null
var christmas_form_six_edit_Component = christmas_form_six_edit_normalizeComponent(
  components_christmas_form_six_edit,
  selectortype_template_index_0_src_components_christmas_form_six_edit,
  christmas_form_six_edit___vue_template_functional__,
  christmas_form_six_edit___vue_styles__,
  christmas_form_six_edit___vue_scopeId__,
  christmas_form_six_edit___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_six_edit = (christmas_form_six_edit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_seven.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_seven = ({
    name: 'christmas_form_seven',
    data: function data() {
        return {
            num: 0,
            host: api_const["host"],
            form: {
                hecklist: [],
                intermediate_nurse_sign: '',
                senior_nurse: ''
            },

            showSignature: false,
            showCSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            if (this.form.hecklist.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张图片'
                });
                return;
            }
            if (this.form.intermediate_nurse_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少中级护理师签字'
                });
                return;
            }
            if (this.form.senior_nurse == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少护理长签字'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse
            };
            var files = this.form.hecklist;
            Api.otherFormApi.updateMaternalHospitalChecklistRecord(params, files, 'hecklist').then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_seven'
                        }
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.hecklist.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '一次最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.num++;
                console.info("rst", rst);
                that.form.hecklist.push(rst);
                console.info(that.form.hecklist);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(file) {
            if (this.num == 0) {
                this.num = 0;
            } else {
                this.num--;
            }
            console.info(file);
            for (var i = 0; i < this.form.hecklist.length; i++) {
                console.info(this.form.hecklist[i].id);
                if (file.id == this.form.hecklist[i].id) {
                    this.form.hecklist.splice(i, 1);
                }
            }
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_seven.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_seven = ({
    name: 'christmas_form_seven',
    data: function data() {
        return {
            num: 0,
            host: api_const["host"],
            form: {
                hecklist: [],
                intermediate_nurse_sign: '',
                senior_nurse: ''
            },

            showSignature: false,
            showCSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            if (this.form.hecklist.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张图片'
                });
                return;
            }
            if (this.form.intermediate_nurse_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少中级护理师签字'
                });
                return;
            }
            if (this.form.senior_nurse == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少护理长签字'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse
            };
            var files = this.form.hecklist;
            Api.otherFormApi.updateMaternalHospitalChecklistRecord(params, files, 'hecklist').then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_seven'
                        }
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.hecklist.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '一次最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.num++;
                console.info("rst", rst);
                that.form.hecklist.push(rst);
                console.info(that.form.hecklist);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(file) {
            if (this.num == 0) {
                this.num = 0;
            } else {
                this.num--;
            }
            console.info(file);
            for (var i = 0; i < this.form.hecklist.length; i++) {
                console.info(this.form.hecklist[i].id);
                if (file.id == this.form.hecklist[i].id) {
                    this.form.hecklist.splice(i, 1);
                }
            }
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-464a6b4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_seven.vue
var christmas_form_seven_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("月子期间医院就诊检查单黏贴处")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"15em"}},[_vm._v("月子期间医院就诊检查单黏贴处：")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png"},on:{"change":_vm.fileImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})]),_vm._v(" "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("本次操作只能添加6张新图片，若有其他图片，请提交后重新编辑上传")])]),_vm._v(" "),(_vm.form.hecklist.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm.form.hecklist),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":item.base64,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(item)}}})])}),0):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCSignature)?_c('div',[(_vm.form.intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.intermediate_nurse_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editCName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveCName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearCName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.senior_nurse,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var christmas_form_seven_staticRenderFns = []
var christmas_form_seven_esExports = { render: christmas_form_seven_render, staticRenderFns: christmas_form_seven_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_seven = (christmas_form_seven_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_seven.vue
function christmas_form_seven_injectStyle (ssrContext) {
  __webpack_require__("PJ5E")
}
var christmas_form_seven_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_seven___vue_template_functional__ = false
/* styles */
var christmas_form_seven___vue_styles__ = christmas_form_seven_injectStyle
/* scopeId */
var christmas_form_seven___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_seven___vue_module_identifier__ = null
var christmas_form_seven_Component = christmas_form_seven_normalizeComponent(
  components_christmas_form_seven,
  selectortype_template_index_0_src_components_christmas_form_seven,
  christmas_form_seven___vue_template_functional__,
  christmas_form_seven___vue_styles__,
  christmas_form_seven___vue_scopeId__,
  christmas_form_seven___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_seven = (christmas_form_seven_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_seven_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_seven_detail = ({
    name: 'christmas_form_seven_detail',
    data: function data() {
        return {
            get_host: host.host,
            host: api_const["host"],
            form: {
                // hecklist:[],
                // intermediate_nurse_sign:'',
                // senior_nurse:''
            },

            showSignature: true,
            showCSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_seven_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse
            };
            var hecklist = this.form.hecklist;
            Api.otherFormApi.updateMaternalLeavehecklistRecor(params, hecklist).then(function (res) {
                console.info(res);
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.hecklist.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '一次最多上传6张图片'
                    });
                    return;
                }
                console.info("rst", rst);
                that.form.hecklist.push(rst);
                console.info(that.form.hecklist);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(index, id) {
            console.info(index, id);
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {
        var _this = this;

        var params = {
            token: this.$cookie.get('token'),
            number_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id')
        };
        Api.otherFormApi.getMaternalHospitalChecklistRecord(params).then(function (res) {
            console.info("医院就诊详情", res);
            if (res.errcode == 200) {
                _this.form = res.data;
                _this.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this.get_host) != -1 ? res.data.intermediate_nurse_sign : _this.get_host + res.data.intermediate_nurse_sign;
                _this.form.senior_nurse = res.data.senior_nurse.indexOf(_this.get_host) != -1 ? res.data.senior_nurse : _this.get_host + res.data.senior_nurse;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_seven_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_seven_detail = ({
    name: 'christmas_form_seven_detail',
    data: function data() {
        return {
            get_host: host.host,
            host: api_const["host"],
            form: {
                // hecklist:[],
                // intermediate_nurse_sign:'',
                // senior_nurse:''
            },

            showSignature: true,
            showCSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_seven_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var params = {
                token: this.$cookie.get('token'),
                number_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse
            };
            var hecklist = this.form.hecklist;
            Api.otherFormApi.updateMaternalLeavehecklistRecor(params, hecklist).then(function (res) {
                console.info(res);
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.hecklist.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '一次最多上传6张图片'
                    });
                    return;
                }
                console.info("rst", rst);
                that.form.hecklist.push(rst);
                console.info(that.form.hecklist);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(index, id) {
            console.info(index, id);
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {
        var _this = this;

        var params = {
            token: this.$cookie.get('token'),
            number_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id')
        };
        Api.otherFormApi.getMaternalHospitalChecklistRecord(params).then(function (res) {
            console.info("医院就诊详情", res);
            if (res.errcode == 200) {
                _this.form = res.data;
                _this.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this.get_host) != -1 ? res.data.intermediate_nurse_sign : _this.get_host + res.data.intermediate_nurse_sign;
                _this.form.senior_nurse = res.data.senior_nurse.indexOf(_this.get_host) != -1 ? res.data.senior_nurse : _this.get_host + res.data.senior_nurse;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaaef83c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_seven_detail.vue
var christmas_form_seven_detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("月子期间医院就诊检查单黏贴处")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"15em"}},[_vm._v("月子期间医院就诊检查单黏贴处：")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm.form.hecklist),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCSignature)?_c('div',[(_vm.form.intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.intermediate_nurse_sign,"alt":""}}):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.senior_nurse,"alt":""}}):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.goEdit.apply(null, arguments)}}},[_vm._v("修改")])],1)],1)}
var christmas_form_seven_detail_staticRenderFns = []
var christmas_form_seven_detail_esExports = { render: christmas_form_seven_detail_render, staticRenderFns: christmas_form_seven_detail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_seven_detail = (christmas_form_seven_detail_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_seven_detail.vue
function christmas_form_seven_detail_injectStyle (ssrContext) {
  __webpack_require__("xqHI")
}
var christmas_form_seven_detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_seven_detail___vue_template_functional__ = false
/* styles */
var christmas_form_seven_detail___vue_styles__ = christmas_form_seven_detail_injectStyle
/* scopeId */
var christmas_form_seven_detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_seven_detail___vue_module_identifier__ = null
var christmas_form_seven_detail_Component = christmas_form_seven_detail_normalizeComponent(
  components_christmas_form_seven_detail,
  selectortype_template_index_0_src_components_christmas_form_seven_detail,
  christmas_form_seven_detail___vue_template_functional__,
  christmas_form_seven_detail___vue_styles__,
  christmas_form_seven_detail___vue_scopeId__,
  christmas_form_seven_detail___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_seven_detail = (christmas_form_seven_detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_seven_edit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_seven_edit = ({
    name: 'christmas_form_seven_detail',
    data: function data() {
        return {
            get_host: host.host,
            host: api_const["host"],
            newFile: [],
            form: {
                hecklist: []
                // intermediate_nurse_sign:'',
                // senior_nurse:''
            },

            showSignature: true,
            showCSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_seven_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            console.info("this.form.hecklist", this.form.hecklist);
            console.info("this.newFile", this.newFile);
            if (this.form.hecklist.length == 0 && this.newFile.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张图片'
                });
                return;
            }
            if (this.form.intermediate_nurse_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少中级护理师签字'
                });
                return;
            }
            if (this.form.senior_nurse == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少护理长签字'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign.indexOf(this.get_host) != -1 ? this.form.intermediate_nurse_sign.replace(this.get_host, '') : this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse.indexOf(this.get_host) != -1 ? this.form.senior_nurse.replace(this.get_host, '') : this.form.senior_nurse,
                hecklist: this.form.hecklist
            };
            console.log(params);
            var files = this.newFile;
            Api.otherFormApi.updateMaternalHospitalChecklistRecord(params, files, 'hecklist').then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_seven_edit'
                        }
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                var newLen = that.newFile.length + that.form.hecklist.length;
                if (that.newFile.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '一次最多上传6张图片'
                    });
                    return;
                }
                if (newLen == 30) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传30张图片'
                    });
                    return;
                }
                that.newFile.push(rst);
                console.info(that.newFile);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(file) {
            if (file.base64) {
                for (var i = 0; i < this.newFile.length; i++) {
                    if (file.base64 == this.newFile[i].base64) {
                        this.newFile.splice(i, 1);
                    }
                }
            } else {
                for (var i = 0; i < this.form.hecklist.length; i++) {
                    if (file == this.form.hecklist[i]) {
                        this.form.hecklist.splice(i, 1);
                    }
                }
            }
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {
        var _this2 = this;

        var params = {
            token: this.$cookie.get('token'),
            number_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id')
        };
        Api.otherFormApi.getMaternalHospitalChecklistRecord(params).then(function (res) {
            console.info("出院就诊详情", res);
            if (res.errcode == 200) {
                _this2.form = res.data;
                _this2.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.intermediate_nurse_sign : _this2.get_host + res.data.intermediate_nurse_sign;
                _this2.form.senior_nurse = res.data.senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.senior_nurse : _this2.get_host + res.data.senior_nurse;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_seven_edit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_seven_edit = ({
    name: 'christmas_form_seven_detail',
    data: function data() {
        return {
            get_host: host.host,
            host: api_const["host"],
            newFile: [],
            form: {
                hecklist: []
                // intermediate_nurse_sign:'',
                // senior_nurse:''
            },

            showSignature: true,
            showCSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_seven_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal
                }
            });
        },
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },
        submitForm: function submitForm() {
            var _this = this;

            console.info("this.form.hecklist", this.form.hecklist);
            console.info("this.newFile", this.newFile);
            if (this.form.hecklist.length == 0 && this.newFile.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张图片'
                });
                return;
            }
            if (this.form.intermediate_nurse_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少中级护理师签字'
                });
                return;
            }
            if (this.form.senior_nurse == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少护理长签字'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                intermediate_nurse_sign: this.form.intermediate_nurse_sign.indexOf(this.get_host) != -1 ? this.form.intermediate_nurse_sign.replace(this.get_host, '') : this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse.indexOf(this.get_host) != -1 ? this.form.senior_nurse.replace(this.get_host, '') : this.form.senior_nurse,
                hecklist: this.form.hecklist
            };
            console.log(params);
            var files = this.newFile;
            Api.otherFormApi.updateMaternalHospitalChecklistRecord(params, files, 'hecklist').then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_seven_edit'
                        }
                    });
                }
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //图片上传
        fileImage: function fileImage(e) {
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                var newLen = that.newFile.length + that.form.hecklist.length;
                if (that.newFile.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '一次最多上传6张图片'
                    });
                    return;
                }
                if (newLen == 30) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传30张图片'
                    });
                    return;
                }
                that.newFile.push(rst);
                console.info(that.newFile);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //删除图片
        delImg: function delImg(file) {
            if (file.base64) {
                for (var i = 0; i < this.newFile.length; i++) {
                    if (file.base64 == this.newFile[i].base64) {
                        this.newFile.splice(i, 1);
                    }
                }
            } else {
                for (var i = 0; i < this.form.hecklist.length; i++) {
                    if (file == this.form.hecklist[i]) {
                        this.form.hecklist.splice(i, 1);
                    }
                }
            }
        },

        //转base64
        convertBase64UrlToBlob: function convertBase64UrlToBlob(urlData) {
            var bytes = window.atob(urlData.split(',')[1]); //去掉url的头，并转换为byte
            //处理异常,将ascii码小于0的转换为大于0
            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
                ia[i] = bytes.charCodeAt(i);
            }
            return new Blob([ab], {
                type: 'image/png'
            });
        }
    },
    created: function created() {
        var _this2 = this;

        var params = {
            token: this.$cookie.get('token'),
            number_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id')
        };
        Api.otherFormApi.getMaternalHospitalChecklistRecord(params).then(function (res) {
            console.info("出院就诊详情", res);
            if (res.errcode == 200) {
                _this2.form = res.data;
                _this2.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.intermediate_nurse_sign : _this2.get_host + res.data.intermediate_nurse_sign;
                _this2.form.senior_nurse = res.data.senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.senior_nurse : _this2.get_host + res.data.senior_nurse;
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5262718e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_seven_edit.vue
var christmas_form_seven_edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("月子期间医院就诊检查单黏贴处")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"15em"}},[_vm._v("月子期间医院就诊检查单黏贴处：")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png"},on:{"change":_vm.fileImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})]),_vm._v(" "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("本次操作只能添加6张新图片，若有其他图片，请提交后重新编辑上传")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_vm._l((_vm.form.hecklist),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(item)}}})])}),_vm._v(" "),_vm._l((_vm.newFile),function(item,index){return (_vm.newFile.length)?_c('a',{staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":item.base64,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(item)}}})]):_vm._e()})],2)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCSignature)?_c('div',[(_vm.form.intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.intermediate_nurse_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editCName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveCName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearCName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.senior_nurse,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var christmas_form_seven_edit_staticRenderFns = []
var christmas_form_seven_edit_esExports = { render: christmas_form_seven_edit_render, staticRenderFns: christmas_form_seven_edit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_seven_edit = (christmas_form_seven_edit_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_seven_edit.vue
function christmas_form_seven_edit_injectStyle (ssrContext) {
  __webpack_require__("DW6m")
}
var christmas_form_seven_edit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_seven_edit___vue_template_functional__ = false
/* styles */
var christmas_form_seven_edit___vue_styles__ = christmas_form_seven_edit_injectStyle
/* scopeId */
var christmas_form_seven_edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_seven_edit___vue_module_identifier__ = null
var christmas_form_seven_edit_Component = christmas_form_seven_edit_normalizeComponent(
  components_christmas_form_seven_edit,
  selectortype_template_index_0_src_components_christmas_form_seven_edit,
  christmas_form_seven_edit___vue_template_functional__,
  christmas_form_seven_edit___vue_styles__,
  christmas_form_seven_edit___vue_scopeId__,
  christmas_form_seven_edit___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_seven_edit = (christmas_form_seven_edit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_eight.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_eight = ({
    name: 'christmas_form_eight',
    data: function data() {
        return {
            n: 0,
            m: 0,
            host: api_const["host"],
            form: {
                prove: [],
                intermediate_nurse_sign: '', //中级护理师签字
                senior_nurse: '', //护理长签字
                in_record_date: '', //入会时间
                out_record_date: '', //出会时间
                in_family: '', //入会母亲家属签名
                out_family: '', //出会母亲家属签名
                infoot: [], //出会足印图片
                outfoot: [], //入会足印图片
                into_intermediate_nurse_sign: '',
                into_senior_nurse: ''
            },
            showSignature: false,
            showCSignature: false,
            showInMotherSignature: false,
            showOutMotherSignature: false,
            showIntoSignature: false,
            showCIntoSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        //入会中级护理师签名
        saveCIntoName: function saveCIntoName() {
            var signature = 'signature5';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.into_intermediate_nurse_sign = encodeURI(png);
            this.showCIntoSignature = true;
        },
        editCIntoName: function editCIntoName() {
            this.showCIntoSignature = false;
            this.form.into_intermediate_nurse_sign = '';
        },
        clearCIntoName: function clearCIntoName() {
            var signature = 'signature5';
            var refs = this.$refs[signature].clear();
            this.form.into_intermediate_nurse_sign = '';
        },

        //入会护理长签字
        saveIntoName: function saveIntoName() {
            var signature = 'signature6';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.into_senior_nurse = encodeURI(png);
            this.showIntoSignature = true;
        },
        editIntoName: function editIntoName() {
            this.showIntoSignature = false;
            this.form.into_senior_nurse = '';
        },
        clearIntoName: function clearIntoName() {
            var signature = 'signature6';
            var refs = this.$refs[signature].clear();
            this.form.into_senior_nurse = '';
        },

        //入会母亲签名
        saveInMotherName: function saveInMotherName() {
            var signature = 'signature3';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.in_family = encodeURI(png);
            this.showInMotherSignature = true;
        },
        editInMotherName: function editInMotherName() {
            this.showInMotherSignature = false;
            this.form.in_family = '';
        },
        clearInMotherName: function clearInMotherName() {
            var signature = 'signature3';
            var refs = this.$refs[signature].clear();
            this.form.in_family = '';
        },

        //出会母亲签名
        saveOutMotherName: function saveOutMotherName() {
            var signature = 'signature4';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.out_family = encodeURI(png);
            this.showOutMotherSignature = true;
        },
        editOutMotherName: function editOutMotherName() {
            this.showOutMotherSignature = false;
            this.form.out_family = '';
        },
        clearOutMotherName: function clearOutMotherName() {
            var signature = 'signature4';
            var refs = this.$refs[signature].clear();
            this.form.out_family = '';
        },

        //出会中级护理师签名
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },

        //出会护理长签字
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },


        //提交
        submitForm: function submitForm() {
            var _this = this;

            // if(this.form.infoot.length==0){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '至少上传一张入会所脚印的图片',
            //     })
            //     return
            // }
            // if(this.form.in_family==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少入会所母亲或家属的签字',
            //     })
            //     return
            // }
            // if(this.form.in_record_date==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '入会所时间不能为空',
            //     })
            //     return
            // }
            // if(this.form.outfoot.length==0){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '至少上传一张出会所脚印的图片',
            //     })
            //     return
            // }
            // if(this.form.out_family==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少出会所母亲或家属的签字',
            //     })
            //     return
            // }
            // if(this.form.out_record_date==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '出会所时间不能为空',
            //     })
            //     return
            // }
            // if(this.form.intermediate_nurse_sign==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少中级护理师签字',

            //     })
            //     return
            // }
            // if(this.form.senior_nurse==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少护理长签字',
            //     })
            //     return
            // }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                baby_id: this.$route.query.child_id,
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse,
                in_record_date: this.form.in_record_date,
                out_record_date: this.form.out_record_date,
                in_family: this.form.in_family,
                out_family: this.form.out_family,
                into_intermediate_nurse_sign: this.form.into_intermediate_nurse_sign,
                into_senior_nurse: this.form.into_senior_nurse
            };
            var filesIn = this.form.infoot;
            var filseOut = this.form.outfoot;
            Api.otherFormApi.updateBabyFootRecord(params, filesIn, filseOut).then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            child_id: _this.$route.query.child_id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_eight'
                        }
                    });
                }
                // this.$router.push({
                //     path:'christmas_form_six_detail', 
                //     query:{
                //         id:this.$route.query.id,
                //         tabVal: this.$route.query.tabVal,
                //     }
                // })
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //入会图片上传
        fileInImage: function fileInImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.infoot.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.n++;
                console.info("rst", rst);
                that.form.infoot.push(rst);
                console.info(that.form.infoot);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //入会删除图片
        delInImg: function delInImg(file) {
            if (this.n == 0) {
                this.n = 0;
            } else {
                this.n--;
            }
            console.info(file);
            for (var i = 0; i < this.form.infoot.length; i++) {
                console.info(this.form.infoot[i].id);
                if (file.id == this.form.infoot[i].id) {
                    this.form.infoot.splice(i, 1);
                }
            }
        },

        //出会图片上传
        fileOutImage: function fileOutImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.outfoot.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.m++;
                console.info("rst", rst);
                that.form.outfoot.push(rst);
                console.info(that.form.outfoot);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //出会删除图片
        delOutImg: function delOutImg(file) {
            if (this.m == 0) {
                this.m = 0;
            } else {
                this.m--;
            }
            console.info(file);
            for (var i = 0; i < this.form.outfoot.length; i++) {
                console.info(this.form.outfoot[i].id);
                if (file.id == this.form.outfoot[i].id) {
                    this.form.outfoot.splice(i, 1);
                }
            }
        }
    },
    created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_eight.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_eight = ({
    name: 'christmas_form_eight',
    data: function data() {
        return {
            n: 0,
            m: 0,
            host: api_const["host"],
            form: {
                prove: [],
                intermediate_nurse_sign: '', //中级护理师签字
                senior_nurse: '', //护理长签字
                in_record_date: '', //入会时间
                out_record_date: '', //出会时间
                in_family: '', //入会母亲家属签名
                out_family: '', //出会母亲家属签名
                infoot: [], //出会足印图片
                outfoot: [], //入会足印图片
                into_intermediate_nurse_sign: '',
                into_senior_nurse: ''
            },
            showSignature: false,
            showCSignature: false,
            showInMotherSignature: false,
            showOutMotherSignature: false,
            showIntoSignature: false,
            showCIntoSignature: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        //入会中级护理师签名
        saveCIntoName: function saveCIntoName() {
            var signature = 'signature5';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.into_intermediate_nurse_sign = encodeURI(png);
            this.showCIntoSignature = true;
        },
        editCIntoName: function editCIntoName() {
            this.showCIntoSignature = false;
            this.form.into_intermediate_nurse_sign = '';
        },
        clearCIntoName: function clearCIntoName() {
            var signature = 'signature5';
            var refs = this.$refs[signature].clear();
            this.form.into_intermediate_nurse_sign = '';
        },

        //入会护理长签字
        saveIntoName: function saveIntoName() {
            var signature = 'signature6';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.into_senior_nurse = encodeURI(png);
            this.showIntoSignature = true;
        },
        editIntoName: function editIntoName() {
            this.showIntoSignature = false;
            this.form.into_senior_nurse = '';
        },
        clearIntoName: function clearIntoName() {
            var signature = 'signature6';
            var refs = this.$refs[signature].clear();
            this.form.into_senior_nurse = '';
        },

        //入会母亲签名
        saveInMotherName: function saveInMotherName() {
            var signature = 'signature3';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.in_family = encodeURI(png);
            this.showInMotherSignature = true;
        },
        editInMotherName: function editInMotherName() {
            this.showInMotherSignature = false;
            this.form.in_family = '';
        },
        clearInMotherName: function clearInMotherName() {
            var signature = 'signature3';
            var refs = this.$refs[signature].clear();
            this.form.in_family = '';
        },

        //出会母亲签名
        saveOutMotherName: function saveOutMotherName() {
            var signature = 'signature4';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.out_family = encodeURI(png);
            this.showOutMotherSignature = true;
        },
        editOutMotherName: function editOutMotherName() {
            this.showOutMotherSignature = false;
            this.form.out_family = '';
        },
        clearOutMotherName: function clearOutMotherName() {
            var signature = 'signature4';
            var refs = this.$refs[signature].clear();
            this.form.out_family = '';
        },

        //出会中级护理师签名
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },

        //出会护理长签字
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },


        //提交
        submitForm: function submitForm() {
            var _this = this;

            // if(this.form.infoot.length==0){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '至少上传一张入会所脚印的图片',
            //     })
            //     return
            // }
            // if(this.form.in_family==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少入会所母亲或家属的签字',
            //     })
            //     return
            // }
            // if(this.form.in_record_date==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '入会所时间不能为空',
            //     })
            //     return
            // }
            // if(this.form.outfoot.length==0){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '至少上传一张出会所脚印的图片',
            //     })
            //     return
            // }
            // if(this.form.out_family==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少出会所母亲或家属的签字',
            //     })
            //     return
            // }
            // if(this.form.out_record_date==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '出会所时间不能为空',
            //     })
            //     return
            // }
            // if(this.form.intermediate_nurse_sign==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少中级护理师签字',

            //     })
            //     return
            // }
            // if(this.form.senior_nurse==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少护理长签字',
            //     })
            //     return
            // }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                baby_id: this.$route.query.child_id,
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse,
                in_record_date: this.form.in_record_date,
                out_record_date: this.form.out_record_date,
                in_family: this.form.in_family,
                out_family: this.form.out_family,
                into_intermediate_nurse_sign: this.form.into_intermediate_nurse_sign,
                into_senior_nurse: this.form.into_senior_nurse
            };
            var filesIn = this.form.infoot;
            var filseOut = this.form.outfoot;
            Api.otherFormApi.updateBabyFootRecord(params, filesIn, filseOut).then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            child_id: _this.$route.query.child_id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_eight'
                        }
                    });
                }
                // this.$router.push({
                //     path:'christmas_form_six_detail', 
                //     query:{
                //         id:this.$route.query.id,
                //         tabVal: this.$route.query.tabVal,
                //     }
                // })
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //入会图片上传
        fileInImage: function fileInImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.infoot.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.n++;
                console.info("rst", rst);
                that.form.infoot.push(rst);
                console.info(that.form.infoot);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //入会删除图片
        delInImg: function delInImg(file) {
            if (this.n == 0) {
                this.n = 0;
            } else {
                this.n--;
            }
            console.info(file);
            for (var i = 0; i < this.form.infoot.length; i++) {
                console.info(this.form.infoot[i].id);
                if (file.id == this.form.infoot[i].id) {
                    this.form.infoot.splice(i, 1);
                }
            }
        },

        //出会图片上传
        fileOutImage: function fileOutImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.outfoot.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.m++;
                console.info("rst", rst);
                that.form.outfoot.push(rst);
                console.info(that.form.outfoot);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //出会删除图片
        delOutImg: function delOutImg(file) {
            if (this.m == 0) {
                this.m = 0;
            } else {
                this.m--;
            }
            console.info(file);
            for (var i = 0; i < this.form.outfoot.length; i++) {
                console.info(this.form.outfoot[i].id);
                if (file.id == this.form.outfoot[i].id) {
                    this.form.outfoot.splice(i, 1);
                }
            }
        }
    },
    created: function created() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1056eda3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_eight.vue
var christmas_form_eight_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("宝宝足印（入会所）（出会所）")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"11em"}},[_vm._v("宝宝足印/入会所脚印")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png"},on:{"change":_vm.fileInImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})])]),_vm._v(" "),(_vm.form.infoot.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm.form.infoot),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":item.base64,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delInImg(item)}}})])}),0):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_vm._v("(入会)（此脚印为本人宝宝的脚印）母亲或家属确认签字：")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"label"}),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showInMotherSignature)?_c('div',[(_vm.form.in_family)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.in_family,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editInMotherName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature3",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveInMotherName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearInMotherName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('datetime',{attrs:{"title":"入会所时间："},model:{value:(_vm.form.in_record_date),callback:function ($$v) {_vm.$set(_vm.form, "in_record_date", $$v)},expression:"form.in_record_date"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（入会）中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCIntoSignature)?_c('div',[(_vm.form.into_intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.into_intermediate_nurse_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editCIntoName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature5",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveCIntoName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearCIntoName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（入会）护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showIntoSignature)?_c('div',[(_vm.form.into_senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.into_senior_nurse,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editIntoName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature6",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveIntoName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearIntoName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"vux-1px-t",staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"11em"}},[_vm._v("宝宝足印/出会所脚印")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png"},on:{"change":_vm.fileOutImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})])]),_vm._v(" "),(_vm.form.outfoot.length)?_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm.form.outfoot),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":item.base64,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delOutImg(item)}}})])}),0):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_vm._v("(出会)（此脚印为本人宝宝的脚印）母亲或家属确认签字：")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"label"}),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showOutMotherSignature)?_c('div',[(_vm.form.out_family)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.out_family,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editOutMotherName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature4",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveOutMotherName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearOutMotherName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('datetime',{attrs:{"title":"出会所时间："},model:{value:(_vm.form.out_record_date),callback:function ($$v) {_vm.$set(_vm.form, "out_record_date", $$v)},expression:"form.out_record_date"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（出会）中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCSignature)?_c('div',[(_vm.form.intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.intermediate_nurse_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editCName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveCName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearCName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（出会）护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.senior_nurse,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var christmas_form_eight_staticRenderFns = []
var christmas_form_eight_esExports = { render: christmas_form_eight_render, staticRenderFns: christmas_form_eight_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_eight = (christmas_form_eight_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_eight.vue
function christmas_form_eight_injectStyle (ssrContext) {
  __webpack_require__("KOQG")
}
var christmas_form_eight_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_eight___vue_template_functional__ = false
/* styles */
var christmas_form_eight___vue_styles__ = christmas_form_eight_injectStyle
/* scopeId */
var christmas_form_eight___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_eight___vue_module_identifier__ = null
var christmas_form_eight_Component = christmas_form_eight_normalizeComponent(
  components_christmas_form_eight,
  selectortype_template_index_0_src_components_christmas_form_eight,
  christmas_form_eight___vue_template_functional__,
  christmas_form_eight___vue_styles__,
  christmas_form_eight___vue_scopeId__,
  christmas_form_eight___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_eight = (christmas_form_eight_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_eight_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_eight_detail = ({
    name: 'christmas_form_eight_detail',
    data: function data() {
        return {
            get_host: host.host,
            n: 0,
            m: 0,
            host: api_const["host"],
            form: {
                intermediate_nurse_sign: '', //中级护理师签字
                senior_nurse: '', //护理长签字
                in_record_date: '', //入会时间
                out_record_date: '', //出会时间
                in_family: '', //入会母亲家属签名
                out_family: '', //出会母亲家属签名
                infoot: [], //出会足印图片
                outfoot: [] //入会足印图片
            },
            showSignature: true,
            showCSignature: true,
            showInMotherSignature: true,
            showOutMotherSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_eight_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal,
                    child_id: this.$route.query.child_id
                }
            });
        },

        //入会母亲签名
        saveInMotherName: function saveInMotherName() {
            var signature = 'signature3';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.in_family = encodeURI(png);
            this.showInMotherSignature = true;
        },
        editInMotherName: function editInMotherName() {
            this.showInMotherSignature = false;
        },
        clearInMotherName: function clearInMotherName() {
            var signature = 'signature3';
            var refs = this.$refs[signature].clear();
            this.form.in_family = '';
        },

        //出会母亲签名
        saveOutMotherName: function saveOutMotherName() {
            var signature = 'signature4';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.out_family = encodeURI(png);
            this.showOutMotherSignature = true;
        },
        editOutMotherName: function editOutMotherName() {
            this.showOutMotherSignature = false;
        },
        clearOutMotherName: function clearOutMotherName() {
            var signature = 'signature4';
            var refs = this.$refs[signature].clear();
            this.form.out_family = '';
        },

        //中级护理师签名
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },

        //护理长签字
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },

        //提交
        submitForm: function submitForm() {
            var _this = this;

            //   intermediate_nurse_sign:'',//中级护理师签字
            //     senior_nurse:'',//护理长签字
            //     in_record_date:'',//入会时间
            //     out_record_date:'',//出会时间
            //     in_family:'',//入会母亲家属签名
            //     out_family:'',//出会母亲家属签名
            //     infoot:[],//出会足印图片
            //     outfoot:[],//入会足印图片
            if (this.form.infoot.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张入会所脚印的图片'
                });
                return;
            }
            if (this.form.in_family == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少入会所母亲或家属的签字'
                });
                return;
            }
            if (this.form.in_record_date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '入会所时间不能为空'
                });
                return;
            }
            if (this.form.outfoot.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张出会所脚印的图片'
                });
                return;
            }
            if (this.form.out_family == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少出会所母亲或家属的签字'
                });
                return;
            }
            if (this.form.out_record_date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '出会所时间不能为空'
                });
                return;
            }
            if (this.form.intermediate_nurse_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少中级护理师签字'

                });
                return;
            }
            if (this.form.senior_nurse == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少护理长签字'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                baby_id: this.$route.query.child_id,
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse,
                in_record_date: this.form.in_record_date,
                out_record_date: this.form.out_record_date,
                in_family: this.form.in_family,
                out_family: this.form.out_family
            };
            var filesIn = this.form.infoot;
            var filseOut = this.form.outfoot;
            Api.otherFormApi.updateBabyFootRecord(params, filesIn, filseOut).then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_eight'
                        }
                    });
                }
                // this.$router.push({
                //     path:'christmas_form_six_detail', 
                //     query:{
                //         id:this.$route.query.id,
                //         tabVal: this.$route.query.tabVal,
                //     }
                // })
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //入会图片上传
        fileInImage: function fileInImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.infoot.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.n++;
                console.info("rst", rst);
                that.form.infoot.push(rst);
                console.info(that.form.infoot);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //入会删除图片
        delInImg: function delInImg(file) {
            if (this.n == 0) {
                this.n = 0;
            } else {
                this.n--;
            }
            console.info(file);
            for (var i = 0; i < this.form.infoot.length; i++) {
                console.info(this.form.infoot[i].id);
                if (file.id == this.form.infoot[i].id) {
                    this.form.infoot.splice(i, 1);
                }
            }
        },

        //出会图片上传
        fileOutImage: function fileOutImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.outfoot.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.m++;
                console.info("rst", rst);
                that.form.outfoot.push(rst);
                console.info(that.form.outfoot);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //出会删除图片
        delOutImg: function delOutImg(file) {
            if (this.m == 0) {
                this.m = 0;
            } else {
                this.m--;
            }
            console.info(file);
            for (var i = 0; i < this.form.outfoot.length; i++) {
                console.info(this.form.outfoot[i].id);
                if (file.id == this.form.outfoot[i].id) {
                    this.form.outfoot.splice(i, 1);
                }
            }
        }
    },
    created: function created() {
        var _this2 = this;

        var params = {
            token: this.$cookie.get('token'),
            member_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id'),
            baby_id: this.$route.query.child_id
        };

        Api.otherFormApi.getBabyFootRecord(params).then(function (res) {
            console.info("宝宝足印详情", res);
            _this2.form = res.data;
            _this2.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.intermediate_nurse_sign : _this2.get_host + res.data.intermediate_nurse_sign;
            _this2.form.senior_nurse = res.data.senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.senior_nurse : _this2.get_host + res.data.senior_nurse;
            _this2.form.in_family = res.data.in_family.indexOf(_this2.get_host) != -1 ? res.data.in_family : _this2.get_host + res.data.in_family;
            _this2.form.out_family = res.data.out_family.indexOf(_this2.get_host) != -1 ? res.data.out_family : _this2.get_host + res.data.out_family;
            _this2.form.into_intermediate_nurse_sign = res.data.into_intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.into_intermediate_nurse_sign : _this2.get_host + res.data.into_intermediate_nurse_sign;
            _this2.form.into_senior_nurse = res.data.into_senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.into_senior_nurse : _this2.get_host + res.data.into_senior_nurse;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_eight_detail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_eight_detail = ({
    name: 'christmas_form_eight_detail',
    data: function data() {
        return {
            get_host: host.host,
            n: 0,
            m: 0,
            host: api_const["host"],
            form: {
                intermediate_nurse_sign: '', //中级护理师签字
                senior_nurse: '', //护理长签字
                in_record_date: '', //入会时间
                out_record_date: '', //出会时间
                in_family: '', //入会母亲家属签名
                out_family: '', //出会母亲家属签名
                infoot: [], //出会足印图片
                outfoot: [] //入会足印图片
            },
            showSignature: true,
            showCSignature: true,
            showInMotherSignature: true,
            showOutMotherSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_eight_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal,
                    child_id: this.$route.query.child_id
                }
            });
        },

        //入会母亲签名
        saveInMotherName: function saveInMotherName() {
            var signature = 'signature3';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.in_family = encodeURI(png);
            this.showInMotherSignature = true;
        },
        editInMotherName: function editInMotherName() {
            this.showInMotherSignature = false;
        },
        clearInMotherName: function clearInMotherName() {
            var signature = 'signature3';
            var refs = this.$refs[signature].clear();
            this.form.in_family = '';
        },

        //出会母亲签名
        saveOutMotherName: function saveOutMotherName() {
            var signature = 'signature4';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.out_family = encodeURI(png);
            this.showOutMotherSignature = true;
        },
        editOutMotherName: function editOutMotherName() {
            this.showOutMotherSignature = false;
        },
        clearOutMotherName: function clearOutMotherName() {
            var signature = 'signature4';
            var refs = this.$refs[signature].clear();
            this.form.out_family = '';
        },

        //中级护理师签名
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },

        //护理长签字
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },

        //提交
        submitForm: function submitForm() {
            var _this = this;

            //   intermediate_nurse_sign:'',//中级护理师签字
            //     senior_nurse:'',//护理长签字
            //     in_record_date:'',//入会时间
            //     out_record_date:'',//出会时间
            //     in_family:'',//入会母亲家属签名
            //     out_family:'',//出会母亲家属签名
            //     infoot:[],//出会足印图片
            //     outfoot:[],//入会足印图片
            if (this.form.infoot.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张入会所脚印的图片'
                });
                return;
            }
            if (this.form.in_family == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少入会所母亲或家属的签字'
                });
                return;
            }
            if (this.form.in_record_date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '入会所时间不能为空'
                });
                return;
            }
            if (this.form.outfoot.length == 0) {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '至少上传一张出会所脚印的图片'
                });
                return;
            }
            if (this.form.out_family == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少出会所母亲或家属的签字'
                });
                return;
            }
            if (this.form.out_record_date == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '出会所时间不能为空'
                });
                return;
            }
            if (this.form.intermediate_nurse_sign == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少中级护理师签字'

                });
                return;
            }
            if (this.form.senior_nurse == '') {
                this.$vux.toast.show({
                    type: 'cancel',
                    text: '缺少护理长签字'
                });
                return;
            }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                baby_id: this.$route.query.child_id,
                intermediate_nurse_sign: this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse,
                in_record_date: this.form.in_record_date,
                out_record_date: this.form.out_record_date,
                in_family: this.form.in_family,
                out_family: this.form.out_family
            };
            var filesIn = this.form.infoot;
            var filseOut = this.form.outfoot;
            Api.otherFormApi.updateBabyFootRecord(params, filesIn, filseOut).then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_eight'
                        }
                    });
                }
                // this.$router.push({
                //     path:'christmas_form_six_detail', 
                //     query:{
                //         id:this.$route.query.id,
                //         tabVal: this.$route.query.tabVal,
                //     }
                // })
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //入会图片上传
        fileInImage: function fileInImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.infoot.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.n++;
                console.info("rst", rst);
                that.form.infoot.push(rst);
                console.info(that.form.infoot);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //入会删除图片
        delInImg: function delInImg(file) {
            if (this.n == 0) {
                this.n = 0;
            } else {
                this.n--;
            }
            console.info(file);
            for (var i = 0; i < this.form.infoot.length; i++) {
                console.info(this.form.infoot[i].id);
                if (file.id == this.form.infoot[i].id) {
                    this.form.infoot.splice(i, 1);
                }
            }
        },

        //出会图片上传
        fileOutImage: function fileOutImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                if (that.form.outfoot.length == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                rst.id = that.m++;
                console.info("rst", rst);
                that.form.outfoot.push(rst);
                console.info(that.form.outfoot);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //出会删除图片
        delOutImg: function delOutImg(file) {
            if (this.m == 0) {
                this.m = 0;
            } else {
                this.m--;
            }
            console.info(file);
            for (var i = 0; i < this.form.outfoot.length; i++) {
                console.info(this.form.outfoot[i].id);
                if (file.id == this.form.outfoot[i].id) {
                    this.form.outfoot.splice(i, 1);
                }
            }
        }
    },
    created: function created() {
        var _this2 = this;

        var params = {
            token: this.$cookie.get('token'),
            member_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id'),
            baby_id: this.$route.query.child_id
        };

        Api.otherFormApi.getBabyFootRecord(params).then(function (res) {
            console.info("宝宝足印详情", res);
            _this2.form = res.data;
            _this2.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.intermediate_nurse_sign : _this2.get_host + res.data.intermediate_nurse_sign;
            _this2.form.senior_nurse = res.data.senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.senior_nurse : _this2.get_host + res.data.senior_nurse;
            _this2.form.in_family = res.data.in_family.indexOf(_this2.get_host) != -1 ? res.data.in_family : _this2.get_host + res.data.in_family;
            _this2.form.out_family = res.data.out_family.indexOf(_this2.get_host) != -1 ? res.data.out_family : _this2.get_host + res.data.out_family;
            _this2.form.into_intermediate_nurse_sign = res.data.into_intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.into_intermediate_nurse_sign : _this2.get_host + res.data.into_intermediate_nurse_sign;
            _this2.form.into_senior_nurse = res.data.into_senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.into_senior_nurse : _this2.get_host + res.data.into_senior_nurse;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c257c4b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_eight_detail.vue
var christmas_form_eight_detail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("宝宝足印（入会所）（出会所）")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"11em"}},[_vm._v("宝宝足印/入会所脚印")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm.form.infoot),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_vm._v("（入会）（此脚印为本人宝宝的脚印）母亲或家属确认签字：")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"label"}),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showInMotherSignature)?_c('div',[(_vm.form.in_family)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.in_family,"alt":""}}):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('datetime',{attrs:{"title":"入会所时间：","readonly":""},model:{value:(_vm.form.in_record_date),callback:function ($$v) {_vm.$set(_vm.form, "in_record_date", $$v)},expression:"form.in_record_date"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（入会）中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCSignature)?_c('div',[(_vm.form.into_intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.into_intermediate_nurse_sign,"alt":""}}):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（入会）护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.into_senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.into_senior_nurse,"alt":""}}):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"vux-1px-t",staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"11em"}},[_vm._v("宝宝足印/出会所脚印")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"margin-top":"10px"}},_vm._l((_vm.form.outfoot),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}})])}),0)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_vm._v("（出会）（此脚印为本人宝宝的脚印）母亲或家属确认签字：")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"label"}),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showOutMotherSignature)?_c('div',[(_vm.form.out_family)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.out_family,"alt":""}}):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('datetime',{attrs:{"title":"出会所时间：","readonly":""},model:{value:(_vm.form.out_record_date),callback:function ($$v) {_vm.$set(_vm.form, "out_record_date", $$v)},expression:"form.out_record_date"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（出会）中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCSignature)?_c('div',[(_vm.form.intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.intermediate_nurse_sign,"alt":""}}):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（出会）护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.senior_nurse,"alt":""}}):_vm._e()]):_vm._e()])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.goEdit.apply(null, arguments)}}},[_vm._v("修改")])],1)],1)}
var christmas_form_eight_detail_staticRenderFns = []
var christmas_form_eight_detail_esExports = { render: christmas_form_eight_detail_render, staticRenderFns: christmas_form_eight_detail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_eight_detail = (christmas_form_eight_detail_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_eight_detail.vue
function christmas_form_eight_detail_injectStyle (ssrContext) {
  __webpack_require__("7Hiq")
}
var christmas_form_eight_detail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_eight_detail___vue_template_functional__ = false
/* styles */
var christmas_form_eight_detail___vue_styles__ = christmas_form_eight_detail_injectStyle
/* scopeId */
var christmas_form_eight_detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_eight_detail___vue_module_identifier__ = null
var christmas_form_eight_detail_Component = christmas_form_eight_detail_normalizeComponent(
  components_christmas_form_eight_detail,
  selectortype_template_index_0_src_components_christmas_form_eight_detail,
  christmas_form_eight_detail___vue_template_functional__,
  christmas_form_eight_detail___vue_styles__,
  christmas_form_eight_detail___vue_scopeId__,
  christmas_form_eight_detail___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_eight_detail = (christmas_form_eight_detail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_eight_edit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var christmas_form_eight_edit = ({
    name: 'christmas_form_eight_eight',
    data: function data() {
        return {
            get_host: host.host,
            n: 0,
            m: 0,
            host: api_const["host"],
            newInFile: [],
            newOutFile: [],
            form: {
                intermediate_nurse_sign: '', //中级护理师签字
                senior_nurse: '', //护理长签字
                in_record_date: '', //入会时间
                out_record_date: '', //出会时间
                in_family: '', //入会母亲家属签名
                out_family: '', //出会母亲家属签名
                infoot: [], //出会足印图片
                outfoot: [], //入会足印图片
                into_intermediate_nurse_sign: '',
                into_senior_nurse: ''
            },
            showSignature: true,
            showCSignature: true,
            showInMotherSignature: true,
            showOutMotherSignature: true,
            showIntoSignature: true,
            showCIntoSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_eight_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal,
                    child_id: this.$route.query.child_id
                }
            });
        },

        //入会中级护理师签名
        saveCIntoName: function saveCIntoName() {
            var signature = 'signature5';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.into_intermediate_nurse_sign = encodeURI(png);
            this.showCIntoSignature = true;
        },
        editCIntoName: function editCIntoName() {
            this.showCIntoSignature = false;
            this.form.into_intermediate_nurse_sign = '';
        },
        clearCIntoName: function clearCIntoName() {
            var signature = 'signature5';
            var refs = this.$refs[signature].clear();
            this.form.into_intermediate_nurse_sign = '';
        },

        //入会护理长签字
        saveIntoName: function saveIntoName() {
            var signature = 'signature6';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.into_senior_nurse = encodeURI(png);
            this.showIntoSignature = true;
        },
        editIntoName: function editIntoName() {
            this.showIntoSignature = false;
            this.form.into_senior_nurse = '';
        },
        clearIntoName: function clearIntoName() {
            var signature = 'signature6';
            var refs = this.$refs[signature].clear();
            this.form.into_senior_nurse = '';
        },

        //入会母亲签名
        saveInMotherName: function saveInMotherName() {
            var signature = 'signature3';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.in_family = encodeURI(png);
            this.showInMotherSignature = true;
        },
        editInMotherName: function editInMotherName() {
            this.showInMotherSignature = false;
            this.form.in_family = '';
        },
        clearInMotherName: function clearInMotherName() {
            var signature = 'signature3';
            var refs = this.$refs[signature].clear();
            this.form.in_family = '';
        },

        //出会母亲签名
        saveOutMotherName: function saveOutMotherName() {
            var signature = 'signature4';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.out_family = encodeURI(png);
            this.showOutMotherSignature = true;
        },
        editOutMotherName: function editOutMotherName() {
            this.showOutMotherSignature = false;
            this.form.out_family = '';
        },
        clearOutMotherName: function clearOutMotherName() {
            var signature = 'signature4';
            var refs = this.$refs[signature].clear();
            this.form.out_family = '';
        },

        //中级护理师签名
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },

        //护理长签字
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },

        //提交
        submitForm: function submitForm() {
            var _this = this;

            // if(this.form.infoot.length==0&&this.newInFile.length==0){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '至少上传一张入会所脚印的图片',
            //     })
            //     return
            // }
            // if(this.form.in_family==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少入会所母亲或家属的签字',
            //     })
            //     return
            // }
            // if(this.form.in_record_date==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '入会所时间不能为空',
            //     })
            //     return
            // }
            // if(this.form.outfoot.length==0&&this.newOutFile.length==0){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '至少上传一张出会所脚印的图片',
            //     })
            //     return
            // }
            // if(this.form.out_family==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少出会所母亲或家属的签字',
            //     })
            //     return
            // }
            // if(this.form.out_record_date==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '出会所时间不能为空',
            //     })
            //     return
            // }
            // if(this.form.intermediate_nurse_sign==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少中级护理师签字',

            //     })
            //     return
            // }
            // if(this.form.senior_nurse==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少护理长签字',
            //     })
            //     return
            // }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                baby_id: this.$route.query.child_id,
                intermediate_nurse_sign: this.form.intermediate_nurse_sign.indexOf(this.get_host) != -1 ? this.form.intermediate_nurse_sign.replace(this.get_host, '') : this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse.indexOf(this.get_host) != -1 ? this.form.senior_nurse.replace(this.get_host, '') : this.form.senior_nurse,
                in_record_date: this.form.in_record_date,
                out_record_date: this.form.out_record_date,
                in_family: this.form.in_family.indexOf(this.get_host) != -1 ? this.form.in_family.replace(this.get_host, '') : this.form.in_family,
                out_family: this.form.out_family.indexOf(this.get_host) != -1 ? this.form.out_family.replace(this.get_host, '') : this.form.out_family,
                infoot: this.form.infoot,
                outfoot: this.form.outfoot,
                into_intermediate_nurse_sign: this.form.into_intermediate_nurse_sign.indexOf(this.get_host) != -1 ? this.form.into_intermediate_nurse_sign.replace(this.get_host, '') : this.form.into_intermediate_nurse_sign,
                into_senior_nurse: this.form.into_senior_nurse.indexOf(this.get_host) != -1 ? this.form.into_senior_nurse.replace(this.get_host, '') : this.form.into_senior_nurse
            };
            console.log(params);
            var filesIn = this.newInFile;
            var filseOut = this.newOutFile;
            Api.otherFormApi.updateBabyFootRecord(params, filesIn, filseOut).then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            child_id: _this.$route.query.child_id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_eight'
                        }
                    });
                }
                // this.$router.push({
                //     path:'christmas_form_six_detail', 
                //     query:{
                //         id:this.$route.query.id,
                //         tabVal: this.$route.query.tabVal,
                //     }
                // })
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //入会图片上传
        fileInImage: function fileInImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                var newLen = that.newInFile.length + that.form.infoot.length;
                if (newLen == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                // rst.id=that.n++
                console.info("rst", rst);
                that.newInFile.push(rst);
                console.info(that.newInFile);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //入会删除图片
        delInImg: function delInImg(file) {
            if (file.base64) {
                for (var i = 0; i < this.newInFile.length; i++) {
                    if (file.base64 == this.newInFile[i].base64) {
                        this.newInFile.splice(i, 1);
                    }
                }
            } else {
                for (var i = 0; i < this.form.infoot.length; i++) {
                    if (file == this.form.infoot[i]) {
                        this.form.infoot.splice(i, 1);
                    }
                }
            }
            // if(this.n==0){
            //     this.n=0
            // }else{
            //     this.n--
            // }
            // console.info(file)

            // for(var i=0;i<this.form.infoot.length;i++){
            //     console.info(this.form.infoot[i].id)
            //     if(file.id==this.form.infoot[i].id){
            //         this.form.infoot.splice(i,1)
            //     }
            // }
        },

        //出会图片上传
        fileOutImage: function fileOutImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;

            lrz(file).then(function (rst) {
                // 处理成功会执行
                var newLen = that.newOutFile.length + that.form.outfoot.length;
                if (newLen == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                // rst.id=that.m++
                console.info("rst", rst);
                that.newOutFile.push(rst);
                console.info(that.newOutFile);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //出会删除图片
        delOutImg: function delOutImg(file) {
            if (file.base64) {
                for (var i = 0; i < this.newOutFile.length; i++) {
                    if (file.base64 == this.newOutFile[i].base64) {
                        this.newOutFile.splice(i, 1);
                    }
                }
            } else {
                for (var i = 0; i < this.form.outfoot.length; i++) {
                    if (file == this.form.outfoot[i]) {
                        this.form.outfoot.splice(i, 1);
                    }
                }
            }

            // if(this.m==0){
            //     this.m=0
            // }else{
            //     this.m--
            // }
            // console.info(file)
            // for(var i=0;i<this.form.outfoot.length;i++){
            //     console.info(this.form.outfoot[i].id)
            //     if(file.id==this.form.outfoot[i].id){
            //         this.form.outfoot.splice(i,1)
            //     }
            // }
        }
    },
    created: function created() {
        var _this2 = this;

        var params = {
            token: this.$cookie.get('token'),
            member_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id'),
            baby_id: this.$route.query.child_id
        };

        Api.otherFormApi.getBabyFootRecord(params).then(function (res) {
            console.info("宝宝足印详情", res);
            _this2.form = res.data;
            _this2.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.intermediate_nurse_sign : _this2.get_host + res.data.intermediate_nurse_sign;
            _this2.form.senior_nurse = res.data.senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.senior_nurse : _this2.get_host + res.data.senior_nurse;
            _this2.form.in_family = res.data.in_family.indexOf(_this2.get_host) != -1 ? res.data.in_family : _this2.get_host + res.data.in_family;
            _this2.form.out_family = res.data.out_family.indexOf(_this2.get_host) != -1 ? res.data.out_family : _this2.get_host + res.data.out_family;
            _this2.form.into_intermediate_nurse_sign = res.data.into_intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.into_intermediate_nurse_sign : _this2.get_host + res.data.into_intermediate_nurse_sign;
            _this2.form.into_senior_nurse = res.data.into_senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.into_senior_nurse : _this2.get_host + res.data.into_senior_nurse;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/christmas_form_eight_edit.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_christmas_form_eight_edit = ({
    name: 'christmas_form_eight_eight',
    data: function data() {
        return {
            get_host: host.host,
            n: 0,
            m: 0,
            host: api_const["host"],
            newInFile: [],
            newOutFile: [],
            form: {
                intermediate_nurse_sign: '', //中级护理师签字
                senior_nurse: '', //护理长签字
                in_record_date: '', //入会时间
                out_record_date: '', //出会时间
                in_family: '', //入会母亲家属签名
                out_family: '', //出会母亲家属签名
                infoot: [], //出会足印图片
                outfoot: [], //入会足印图片
                into_intermediate_nurse_sign: '',
                into_senior_nurse: ''
            },
            showSignature: true,
            showCSignature: true,
            showInMotherSignature: true,
            showOutMotherSignature: true,
            showIntoSignature: true,
            showCIntoSignature: true,
            option: {
                penColor: "rgb(0, 0, 0)"
            }
        };
    },

    methods: {
        goEdit: function goEdit() {
            this.$router.push({
                path: 'christmas_form_eight_edit',
                query: {
                    id: this.$route.query.id,
                    tabVal: this.$route.query.tabVal,
                    child_id: this.$route.query.child_id
                }
            });
        },

        //入会中级护理师签名
        saveCIntoName: function saveCIntoName() {
            var signature = 'signature5';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.into_intermediate_nurse_sign = encodeURI(png);
            this.showCIntoSignature = true;
        },
        editCIntoName: function editCIntoName() {
            this.showCIntoSignature = false;
            this.form.into_intermediate_nurse_sign = '';
        },
        clearCIntoName: function clearCIntoName() {
            var signature = 'signature5';
            var refs = this.$refs[signature].clear();
            this.form.into_intermediate_nurse_sign = '';
        },

        //入会护理长签字
        saveIntoName: function saveIntoName() {
            var signature = 'signature6';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.into_senior_nurse = encodeURI(png);
            this.showIntoSignature = true;
        },
        editIntoName: function editIntoName() {
            this.showIntoSignature = false;
            this.form.into_senior_nurse = '';
        },
        clearIntoName: function clearIntoName() {
            var signature = 'signature6';
            var refs = this.$refs[signature].clear();
            this.form.into_senior_nurse = '';
        },

        //入会母亲签名
        saveInMotherName: function saveInMotherName() {
            var signature = 'signature3';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.in_family = encodeURI(png);
            this.showInMotherSignature = true;
        },
        editInMotherName: function editInMotherName() {
            this.showInMotherSignature = false;
            this.form.in_family = '';
        },
        clearInMotherName: function clearInMotherName() {
            var signature = 'signature3';
            var refs = this.$refs[signature].clear();
            this.form.in_family = '';
        },

        //出会母亲签名
        saveOutMotherName: function saveOutMotherName() {
            var signature = 'signature4';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.out_family = encodeURI(png);
            this.showOutMotherSignature = true;
        },
        editOutMotherName: function editOutMotherName() {
            this.showOutMotherSignature = false;
            this.form.out_family = '';
        },
        clearOutMotherName: function clearOutMotherName() {
            var signature = 'signature4';
            var refs = this.$refs[signature].clear();
            this.form.out_family = '';
        },

        //中级护理师签名
        saveCName: function saveCName() {
            var signature = 'signature1';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.intermediate_nurse_sign = encodeURI(png);
            this.showCSignature = true;
        },
        editCName: function editCName() {
            this.showCSignature = false;
            this.form.intermediate_nurse_sign = '';
        },
        clearCName: function clearCName() {
            var signature = 'signature1';
            var refs = this.$refs[signature].clear();
            this.form.intermediate_nurse_sign = '';
        },

        //护理长签字
        saveName: function saveName() {
            var signature = 'signature2';
            console.info(this.$refs[signature]);
            var png = this.$refs[signature].save();
            this.form.senior_nurse = encodeURI(png);
            this.showSignature = true;
        },
        editName: function editName() {
            this.showSignature = false;
            this.form.senior_nurse = '';
        },
        clearName: function clearName() {
            var signature = 'signature2';
            var refs = this.$refs[signature].clear();
            this.form.senior_nurse = '';
        },

        //提交
        submitForm: function submitForm() {
            var _this = this;

            // if(this.form.infoot.length==0&&this.newInFile.length==0){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '至少上传一张入会所脚印的图片',
            //     })
            //     return
            // }
            // if(this.form.in_family==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少入会所母亲或家属的签字',
            //     })
            //     return
            // }
            // if(this.form.in_record_date==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '入会所时间不能为空',
            //     })
            //     return
            // }
            // if(this.form.outfoot.length==0&&this.newOutFile.length==0){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '至少上传一张出会所脚印的图片',
            //     })
            //     return
            // }
            // if(this.form.out_family==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少出会所母亲或家属的签字',
            //     })
            //     return
            // }
            // if(this.form.out_record_date==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '出会所时间不能为空',
            //     })
            //     return
            // }
            // if(this.form.intermediate_nurse_sign==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少中级护理师签字',

            //     })
            //     return
            // }
            // if(this.form.senior_nurse==''){
            //     this.$vux.toast.show({
            //             type: 'cancel',
            //             text: '缺少护理长签字',
            //     })
            //     return
            // }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                store_id: this.$cookie.get('store_id'),
                baby_id: this.$route.query.child_id,
                intermediate_nurse_sign: this.form.intermediate_nurse_sign.indexOf(this.get_host) != -1 ? this.form.intermediate_nurse_sign.replace(this.get_host, '') : this.form.intermediate_nurse_sign,
                senior_nurse: this.form.senior_nurse.indexOf(this.get_host) != -1 ? this.form.senior_nurse.replace(this.get_host, '') : this.form.senior_nurse,
                in_record_date: this.form.in_record_date,
                out_record_date: this.form.out_record_date,
                in_family: this.form.in_family.indexOf(this.get_host) != -1 ? this.form.in_family.replace(this.get_host, '') : this.form.in_family,
                out_family: this.form.out_family.indexOf(this.get_host) != -1 ? this.form.out_family.replace(this.get_host, '') : this.form.out_family,
                infoot: this.form.infoot,
                outfoot: this.form.outfoot,
                into_intermediate_nurse_sign: this.form.into_intermediate_nurse_sign.indexOf(this.get_host) != -1 ? this.form.into_intermediate_nurse_sign.replace(this.get_host, '') : this.form.into_intermediate_nurse_sign,
                into_senior_nurse: this.form.into_senior_nurse.indexOf(this.get_host) != -1 ? this.form.into_senior_nurse.replace(this.get_host, '') : this.form.into_senior_nurse
            };
            console.log(params);
            var filesIn = this.newInFile;
            var filseOut = this.newOutFile;
            Api.otherFormApi.updateBabyFootRecord(params, filesIn, filseOut).then(function (res) {
                if (res.errcode == 200) {
                    _this.$router.replace({
                        path: '/success',
                        query: {
                            id: _this.$route.query.id,
                            child_id: _this.$route.query.child_id,
                            tabVal: _this.$route.query.tabVal,
                            name: 'christmas_form_eight'
                        }
                    });
                }
                // this.$router.push({
                //     path:'christmas_form_six_detail', 
                //     query:{
                //         id:this.$route.query.id,
                //         tabVal: this.$route.query.tabVal,
                //     }
                // })
            });
        },
        goBack: function goBack() {
            this.$router.push({
                path: './maternal_service',
                query: {
                    tabVal: this.$route.query.tabVal,
                    id: this.$route.query.id
                }
            });
        },

        //入会图片上传
        fileInImage: function fileInImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;
            lrz(file).then(function (rst) {
                // 处理成功会执行
                var newLen = that.newInFile.length + that.form.infoot.length;
                if (newLen == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                // rst.id=that.n++
                console.info("rst", rst);
                that.newInFile.push(rst);
                console.info(that.newInFile);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //入会删除图片
        delInImg: function delInImg(file) {
            if (file.base64) {
                for (var i = 0; i < this.newInFile.length; i++) {
                    if (file.base64 == this.newInFile[i].base64) {
                        this.newInFile.splice(i, 1);
                    }
                }
            } else {
                for (var i = 0; i < this.form.infoot.length; i++) {
                    if (file == this.form.infoot[i]) {
                        this.form.infoot.splice(i, 1);
                    }
                }
            }
            // if(this.n==0){
            //     this.n=0
            // }else{
            //     this.n--
            // }
            // console.info(file)

            // for(var i=0;i<this.form.infoot.length;i++){
            //     console.info(this.form.infoot[i].id)
            //     if(file.id==this.form.infoot[i].id){
            //         this.form.infoot.splice(i,1)
            //     }
            // }
        },

        //出会图片上传
        fileOutImage: function fileOutImage(e) {
            console.info(e.target.files);
            var file = e.target.files[0];
            var that = this;

            lrz(file).then(function (rst) {
                // 处理成功会执行
                var newLen = that.newOutFile.length + that.form.outfoot.length;
                if (newLen == 6) {
                    that.$vux.toast.show({
                        type: 'cancel',
                        text: '最多上传6张图片'
                    });
                    return;
                }
                // rst.id=that.m++
                console.info("rst", rst);
                that.newOutFile.push(rst);
                console.info(that.newOutFile);
            }).catch(function (err) {
                console.info(err);
                that.$vux.toast.show({
                    type: 'cancel',
                    text: '网络错误'
                });
                // 处理失败会执行
            });
        },

        //出会删除图片
        delOutImg: function delOutImg(file) {
            if (file.base64) {
                for (var i = 0; i < this.newOutFile.length; i++) {
                    if (file.base64 == this.newOutFile[i].base64) {
                        this.newOutFile.splice(i, 1);
                    }
                }
            } else {
                for (var i = 0; i < this.form.outfoot.length; i++) {
                    if (file == this.form.outfoot[i]) {
                        this.form.outfoot.splice(i, 1);
                    }
                }
            }

            // if(this.m==0){
            //     this.m=0
            // }else{
            //     this.m--
            // }
            // console.info(file)
            // for(var i=0;i<this.form.outfoot.length;i++){
            //     console.info(this.form.outfoot[i].id)
            //     if(file.id==this.form.outfoot[i].id){
            //         this.form.outfoot.splice(i,1)
            //     }
            // }
        }
    },
    created: function created() {
        var _this2 = this;

        var params = {
            token: this.$cookie.get('token'),
            member_id: this.$cookie.get('id'),
            maternal_info_id: this.$route.query.id,
            store_id: this.$cookie.get('store_id'),
            baby_id: this.$route.query.child_id
        };

        Api.otherFormApi.getBabyFootRecord(params).then(function (res) {
            console.info("宝宝足印详情", res);
            _this2.form = res.data;
            _this2.form.intermediate_nurse_sign = res.data.intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.intermediate_nurse_sign : _this2.get_host + res.data.intermediate_nurse_sign;
            _this2.form.senior_nurse = res.data.senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.senior_nurse : _this2.get_host + res.data.senior_nurse;
            _this2.form.in_family = res.data.in_family.indexOf(_this2.get_host) != -1 ? res.data.in_family : _this2.get_host + res.data.in_family;
            _this2.form.out_family = res.data.out_family.indexOf(_this2.get_host) != -1 ? res.data.out_family : _this2.get_host + res.data.out_family;
            _this2.form.into_intermediate_nurse_sign = res.data.into_intermediate_nurse_sign.indexOf(_this2.get_host) != -1 ? res.data.into_intermediate_nurse_sign : _this2.get_host + res.data.into_intermediate_nurse_sign;
            _this2.form.into_senior_nurse = res.data.into_senior_nurse.indexOf(_this2.get_host) != -1 ? res.data.into_senior_nurse : _this2.get_host + res.data.into_senior_nurse;
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24a5207f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/christmas_form_eight_edit.vue
var christmas_form_eight_edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('x-header',{attrs:{"left-options":{showBack: true,preventGoBack:true}},on:{"on-click-back":_vm.goBack}},[_vm._v("宝宝足印（入会所）（出会所）")]),_vm._v(" "),_c('group',{staticClass:"editContent"},[_c('div',{staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"11em"}},[_vm._v("宝宝足印/入会所脚印")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png"},on:{"change":_vm.fileInImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_vm._l((_vm.form.infoot),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delInImg(item)}}})])}),_vm._v(" "),_vm._l((_vm.newInFile),function(item,index){return (_vm.newInFile.length)?_c('a',{staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":item.base64,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(item)}}})]):_vm._e()})],2)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_vm._v("（入会）（此脚印为本人宝宝的脚印）母亲或家属确认签字：")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"label"}),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showInMotherSignature)?_c('div',[(_vm.form.in_family)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.in_family,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editInMotherName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature3",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveInMotherName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearInMotherName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('datetime',{attrs:{"title":"入会所时间："},model:{value:(_vm.form.in_record_date),callback:function ($$v) {_vm.$set(_vm.form, "in_record_date", $$v)},expression:"form.in_record_date"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（入会）中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCIntoSignature)?_c('div',[(_vm.form.into_intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.into_intermediate_nurse_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editCIntoName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature5",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveCIntoName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearCIntoName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（入会）护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showIntoSignature)?_c('div',[(_vm.form.into_senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.into_senior_nurse,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editIntoName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature6",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveIntoName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearIntoName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"vux-1px-t",staticStyle:{"display":"flex","padding":"9px 15px"}},[_c('div',{staticStyle:{"line-height":"36px","width":"11em"}},[_vm._v("宝宝足印/出会所脚印")]),_vm._v(" "),_c('div',[_c('div',{staticStyle:{"position":"relative"}},[_c('input',{staticClass:"addFile",attrs:{"type":"file","accept":"image/jpeg,image/jpg,image/png"},on:{"change":_vm.fileOutImage}}),_vm._v(" "),_c('label',{staticStyle:{"display":"block","width":"84px","height":"84px","line-height":"84px","text-align":"center","background":"#eee"},attrs:{"for":"file"}},[_c('img',{attrs:{"src":__webpack_require__("Zarb"),"alt":""}})])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_vm._l((_vm.form.outfoot),function(item,index){return _c('a',{key:index,staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.host+item,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delOutImg(item)}}})])}),_vm._v(" "),_vm._l((_vm.newOutFile),function(item,index){return (_vm.newOutFile.length)?_c('a',{staticClass:"imgObj",attrs:{"href":"javascript:;"}},[_c('img',{staticClass:"img",attrs:{"src":item.base64,"width":"84","height":"84","alt":""}}),_vm._v(" "),_c('img',{staticClass:"del",attrs:{"src":__webpack_require__("Ub/c"),"alt":""},on:{"click":function($event){return _vm.delImg(item)}}})]):_vm._e()})],2)])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_vm._v("（出会）（此脚印为本人宝宝的脚印）母亲或家属确认签字：")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"label"}),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showOutMotherSignature)?_c('div',[(_vm.form.out_family)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.out_family,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editOutMotherName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature4",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveOutMotherName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearOutMotherName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('datetime',{attrs:{"title":"出会所时间："},model:{value:(_vm.form.out_record_date),callback:function ($$v) {_vm.$set(_vm.form, "out_record_date", $$v)},expression:"form.out_record_date"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（出会）中级护理师签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showCSignature)?_c('div',[(_vm.form.intermediate_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.intermediate_nurse_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editCName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature1",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveCName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearCName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("（出会）护理长签字：")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.showSignature)?_c('div',[(_vm.form.senior_nurse)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.senior_nurse,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editName.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"signature2",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.saveName.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.clearName.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)}
var christmas_form_eight_edit_staticRenderFns = []
var christmas_form_eight_edit_esExports = { render: christmas_form_eight_edit_render, staticRenderFns: christmas_form_eight_edit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_christmas_form_eight_edit = (christmas_form_eight_edit_esExports);
// CONCATENATED MODULE: ./src/components/christmas_form_eight_edit.vue
function christmas_form_eight_edit_injectStyle (ssrContext) {
  __webpack_require__("R37A")
}
var christmas_form_eight_edit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var christmas_form_eight_edit___vue_template_functional__ = false
/* styles */
var christmas_form_eight_edit___vue_styles__ = christmas_form_eight_edit_injectStyle
/* scopeId */
var christmas_form_eight_edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var christmas_form_eight_edit___vue_module_identifier__ = null
var christmas_form_eight_edit_Component = christmas_form_eight_edit_normalizeComponent(
  components_christmas_form_eight_edit,
  selectortype_template_index_0_src_components_christmas_form_eight_edit,
  christmas_form_eight_edit___vue_template_functional__,
  christmas_form_eight_edit___vue_styles__,
  christmas_form_eight_edit___vue_scopeId__,
  christmas_form_eight_edit___vue_module_identifier__
)

/* harmony default export */ var src_components_christmas_form_eight_edit = (christmas_form_eight_edit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/medicine_commissioned.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var medicine_commissioned = ({
    name: 'medicine_commissioned',
    components: {
        DateTime: vue_date_time_m_default.a
    },
    data: function data() {
        return {
            options: ['雅培金装喜康宝（母乳营养补充剂）', '鱼腥草滴眼液', '布拉氏酵母菌', '茵栀黄口服液', '伊可新维生素AD滴剂胶囊型', '左氧佛沙星滴眼液', 'Baby Ddrops婴儿维生素d3滴剂', '小儿伪麻美芬滴剂（艾畅）', '鲁米那', '枯草杆菌二联活菌散', '肝泰乐'],
            form: {
                room_number: '',
                maternal_name: '',
                entrust_man: '',
                drug_matter: [{
                    drug_name: '',
                    use_method: '',
                    take_dost: ''
                }, {
                    drug_name: '',
                    use_method: '',
                    take_dost: ''
                }, {
                    drug_name: '',
                    use_method: '',
                    take_dost: ''
                }, {
                    drug_name: '',
                    use_method: '',
                    take_dost: ''
                }, {
                    drug_name: '',
                    use_method: '',
                    take_dost: ''
                }],
                family_sign: '',
                nurse_sign: [{
                    sign_show: false,
                    src: ''
                }, {
                    sign_show: false,
                    src: ''
                }, {
                    sign_show: false,
                    src: ''
                }, {
                    sign_show: false,
                    src: ''
                }],
                group_nurse_sign: '',
                nurse_long_sign: ''
            },
            family_sign_show: false,
            group_nurse_sign_show: false,
            nurse_long_sign_show: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            get_host: host.host
        };
    },
    created: function created() {
        // this.get_baby_list()
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            this.apiMemberInfo();
        }
    },

    methods: {
        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.form.room_number = res.data.room_name;
                    _this.form.maternal_name = res.data.name;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 家属签名操作
        family_sign_save: function family_sign_save() {
            var signature = 'family_sign_signature';
            var sigRef = this.$refs[signature];
            var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
            if (!comp || !comp.save) return;
            var png = comp.save();
            this.form.family_sign = encodeURI(png);
            this.family_sign_show = true;
        },
        family_sign_edit: function family_sign_edit() {
            this.family_sign_show = false;
            this.form.family_sign = '';
        },
        family_sign_clear: function family_sign_clear() {
            var signature = 'family_sign_signature';
            var sigRef = this.$refs[signature];
            if (Array.isArray(sigRef)) {
                sigRef.forEach(function (c) {
                    return c && c.clear && c.clear();
                });
            } else if (sigRef && sigRef.clear) {
                sigRef.clear();
            }
            this.form.family_sign = '';
        },

        //责任护士签名操作
        nurse_sign_save: function nurse_sign_save(index) {
            var signature = 'nurse_sign_signature_' + index;
            console.log(this.$refs);
            var png = this.$refs[signature][0].save();
            this.form.nurse_sign[index].src = encodeURI(png);
            this.form.nurse_sign[index].sign_show = true;
        },
        nurse_sign_edit: function nurse_sign_edit(index) {
            this.form.nurse_sign[index].sign_show = false;
            this.form.nurse_sign[index].src = '';
        },
        nurse_sign_clear: function nurse_sign_clear(index) {
            var signature = 'nurse_sign_signature_' + index;
            var refs = this.$refs[signature][0].clear();
            this.form.nurse_sign[index].src = '';
        },

        // 护士组长签名操作
        group_nurse_sign_save: function group_nurse_sign_save() {
            var signature = 'group_nurse_sign_signature';
            var sigRef = this.$refs[signature];
            var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
            if (!comp || !comp.save) return;
            var png = comp.save();
            this.form.group_nurse_sign = encodeURI(png);
            this.group_nurse_sign_show = true;
        },
        group_nurse_sign_edit: function group_nurse_sign_edit() {
            this.group_nurse_sign_show = false;
            this.form.group_nurse_sign = '';
        },
        group_nurse_sign_clear: function group_nurse_sign_clear() {
            var signature = 'group_nurse_sign_signature';
            var sigRef = this.$refs[signature];
            if (Array.isArray(sigRef)) {
                sigRef.forEach(function (c) {
                    return c && c.clear && c.clear();
                });
            } else if (sigRef && sigRef.clear) {
                sigRef.clear();
            }
            this.form.group_nurse_sign = '';
        },

        // 护士长签名操作
        nurse_long_sign_save: function nurse_long_sign_save() {
            var signature = 'nurse_long_sign_signature';
            var sigRef = this.$refs[signature];
            var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
            if (!comp || !comp.save) return;
            var png = comp.save();
            this.form.nurse_long_sign = encodeURI(png);
            this.nurse_long_sign_show = true;
        },
        nurse_long_sign_edit: function nurse_long_sign_edit() {
            this.nurse_long_sign_show = false;
            this.form.nurse_long_sign = '';
        },
        nurse_long_sign_clear: function nurse_long_sign_clear() {
            var signature = 'nurse_long_sign_signature';
            var sigRef = this.$refs[signature];
            if (Array.isArray(sigRef)) {
                sigRef.forEach(function (c) {
                    return c && c.clear && c.clear();
                });
            } else if (sigRef && sigRef.clear) {
                sigRef.clear();
            }
            this.form.nurse_long_sign = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.detailFeedDrugEntrustDetail(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    var nurse_sign = [];
                    if (data.nurse_sign.length == 0) {
                        nurse_sign = [{
                            sign_show: false,
                            src: ''
                        }, {
                            sign_show: false,
                            src: ''
                        }, {
                            sign_show: false,
                            src: ''
                        }, {
                            sign_show: false,
                            src: ''
                        }];
                    }
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = get_iterator_default()(data.nurse_sign), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            var obj = {
                                sign_show: item == '' ? false : true,
                                src: item.indexOf(_this2.get_host) != -1 ? item : _this2.get_host + item
                            };
                            nurse_sign.push(obj);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.form.room_number = data.room_number;
                    _this2.form.maternal_name = data.maternal_name;
                    _this2.form.entrust_man = data.entrust_man;
                    _this2.form.drug_matter = data.drug_matter;
                    _this2.form.entrust_time = data.entrust_time;
                    _this2.family_sign_show = data.family_sign == '' ? false : true;
                    _this2.form.family_sign = data.family_sign.indexOf(_this2.get_host) != -1 ? data.family_sign : _this2.get_host + data.family_sign;
                    _this2.form.nurse_sign = nurse_sign;
                    if (data.group_nurse_sign == '') {
                        _this2.group_nurse_sign_show = false;
                        _this2.form.group_nurse_sign = '';
                    } else {
                        _this2.group_nurse_sign_show = true;
                        _this2.form.group_nurse_sign = data.group_nurse_sign.indexOf(_this2.get_host) != -1 ? data.group_nurse_sign : _this2.get_host + data.group_nurse_sign;
                    }
                    if (data.nurse_long_sign == '') {
                        _this2.nurse_long_sign_show = false;
                        _this2.form.nurse_long_sign = '';
                    } else {
                        _this2.nurse_long_sign_show = true;
                        _this2.form.nurse_long_sign = data.nurse_long_sign.indexOf(_this2.get_host) != -1 ? data.nurse_long_sign : _this2.get_host + data.nurse_long_sign;
                    }
                    _this2.$vux.loading.hide();
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this3 = this;

            var nurse_sign = [];
            if (this.form.nurse_sign.length) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = get_iterator_default()(this.form.nurse_sign), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var item = _step2.value;

                        nurse_sign.push(item.src);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room_number: this.form.room_number,
                maternal_name: this.form.maternal_name,
                entrust_man: this.form.entrust_man,
                drug_matter: this.form.drug_matter,
                entrust_time: this.form.entrust_time,
                family_sign: this.form.family_sign,
                nurse_sign: nurse_sign,
                group_nurse_sign: this.form.group_nurse_sign,
                nurse_long_sign: this.form.nurse_long_sign
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.addFeedDrugEntrust(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this3.$vux.loading.hide();
                    _this3.$router.replace({
                        path: '/success',
                        query: {
                            id: _this3.$route.query.id,
                            form_id: _this3.$route.query.form_id,
                            tabVal: _this3.$route.query.tabVal,
                            name: 'medicine_commissioned'
                        }
                    });
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this4 = this;

            var nurse_sign = [];
            if (this.form.nurse_sign.length) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = get_iterator_default()(this.form.nurse_sign), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var item = _step3.value;

                        nurse_sign.push(item.src.indexOf(this.get_host) != -1 ? item.src.replace(this.get_host, '') : item.src);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room_number: this.form.room_number,
                maternal_name: this.form.maternal_name,
                entrust_man: this.form.entrust_man,
                drug_matter: this.form.drug_matter,
                entrust_time: this.form.entrust_time,
                family_sign: this.form.family_sign.indexOf(this.get_host) != -1 ? this.form.family_sign.replace(this.get_host, '') : this.form.family_sign,
                nurse_sign: nurse_sign,
                group_nurse_sign: this.form.group_nurse_sign.indexOf(this.get_host) != -1 ? this.form.group_nurse_sign.replace(this.get_host, '') : this.form.group_nurse_sign,
                nurse_long_sign: this.form.nurse_long_sign.indexOf(this.get_host) != -1 ? this.form.nurse_long_sign.replace(this.get_host, '') : this.form.nurse_long_sign,
                id: this.$route.query.list_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.updateFeedDrugEntrust(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'medicine_commissioned'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/medicine_commissioned.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_medicine_commissioned = ({
    name: 'medicine_commissioned',
    components: {
        DateTime: vue_date_time_m_default.a
    },
    data: function data() {
        return {
            options: ['雅培金装喜康宝（母乳营养补充剂）', '鱼腥草滴眼液', '布拉氏酵母菌', '茵栀黄口服液', '伊可新维生素AD滴剂胶囊型', '左氧佛沙星滴眼液', 'Baby Ddrops婴儿维生素d3滴剂', '小儿伪麻美芬滴剂（艾畅）', '鲁米那', '枯草杆菌二联活菌散', '肝泰乐'],
            form: {
                room_number: '',
                maternal_name: '',
                entrust_man: '',
                drug_matter: [{
                    drug_name: '',
                    use_method: '',
                    take_dost: ''
                }, {
                    drug_name: '',
                    use_method: '',
                    take_dost: ''
                }, {
                    drug_name: '',
                    use_method: '',
                    take_dost: ''
                }, {
                    drug_name: '',
                    use_method: '',
                    take_dost: ''
                }, {
                    drug_name: '',
                    use_method: '',
                    take_dost: ''
                }],
                family_sign: '',
                nurse_sign: [{
                    sign_show: false,
                    src: ''
                }, {
                    sign_show: false,
                    src: ''
                }, {
                    sign_show: false,
                    src: ''
                }, {
                    sign_show: false,
                    src: ''
                }],
                group_nurse_sign: '',
                nurse_long_sign: ''
            },
            family_sign_show: false,
            group_nurse_sign_show: false,
            nurse_long_sign_show: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            get_host: host.host
        };
    },
    created: function created() {
        // this.get_baby_list()
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            this.apiMemberInfo();
        }
    },

    methods: {
        //请求用户基本信息
        apiMemberInfo: function apiMemberInfo() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.memberInfo(params).then(function (res) {
                console.info(res);
                if (res.errcode == 1) {
                    _this.form.room_number = res.data.room_name;
                    _this.form.maternal_name = res.data.name;
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 家属签名操作
        family_sign_save: function family_sign_save() {
            var signature = 'family_sign_signature';
            var sigRef = this.$refs[signature];
            var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
            if (!comp || !comp.save) return;
            var png = comp.save();
            this.form.family_sign = encodeURI(png);
            this.family_sign_show = true;
        },
        family_sign_edit: function family_sign_edit() {
            this.family_sign_show = false;
            this.form.family_sign = '';
        },
        family_sign_clear: function family_sign_clear() {
            var signature = 'family_sign_signature';
            var sigRef = this.$refs[signature];
            if (Array.isArray(sigRef)) {
                sigRef.forEach(function (c) {
                    return c && c.clear && c.clear();
                });
            } else if (sigRef && sigRef.clear) {
                sigRef.clear();
            }
            this.form.family_sign = '';
        },

        //责任护士签名操作
        nurse_sign_save: function nurse_sign_save(index) {
            var signature = 'nurse_sign_signature_' + index;
            console.log(this.$refs);
            var png = this.$refs[signature][0].save();
            this.form.nurse_sign[index].src = encodeURI(png);
            this.form.nurse_sign[index].sign_show = true;
        },
        nurse_sign_edit: function nurse_sign_edit(index) {
            this.form.nurse_sign[index].sign_show = false;
            this.form.nurse_sign[index].src = '';
        },
        nurse_sign_clear: function nurse_sign_clear(index) {
            var signature = 'nurse_sign_signature_' + index;
            var refs = this.$refs[signature][0].clear();
            this.form.nurse_sign[index].src = '';
        },

        // 护士组长签名操作
        group_nurse_sign_save: function group_nurse_sign_save() {
            var signature = 'group_nurse_sign_signature';
            var sigRef = this.$refs[signature];
            var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
            if (!comp || !comp.save) return;
            var png = comp.save();
            this.form.group_nurse_sign = encodeURI(png);
            this.group_nurse_sign_show = true;
        },
        group_nurse_sign_edit: function group_nurse_sign_edit() {
            this.group_nurse_sign_show = false;
            this.form.group_nurse_sign = '';
        },
        group_nurse_sign_clear: function group_nurse_sign_clear() {
            var signature = 'group_nurse_sign_signature';
            var sigRef = this.$refs[signature];
            if (Array.isArray(sigRef)) {
                sigRef.forEach(function (c) {
                    return c && c.clear && c.clear();
                });
            } else if (sigRef && sigRef.clear) {
                sigRef.clear();
            }
            this.form.group_nurse_sign = '';
        },

        // 护士长签名操作
        nurse_long_sign_save: function nurse_long_sign_save() {
            var signature = 'nurse_long_sign_signature';
            var sigRef = this.$refs[signature];
            var comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef;
            if (!comp || !comp.save) return;
            var png = comp.save();
            this.form.nurse_long_sign = encodeURI(png);
            this.nurse_long_sign_show = true;
        },
        nurse_long_sign_edit: function nurse_long_sign_edit() {
            this.nurse_long_sign_show = false;
            this.form.nurse_long_sign = '';
        },
        nurse_long_sign_clear: function nurse_long_sign_clear() {
            var signature = 'nurse_long_sign_signature';
            var sigRef = this.$refs[signature];
            if (Array.isArray(sigRef)) {
                sigRef.forEach(function (c) {
                    return c && c.clear && c.clear();
                });
            } else if (sigRef && sigRef.clear) {
                sigRef.clear();
            }
            this.form.nurse_long_sign = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.detailFeedDrugEntrustDetail(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    var nurse_sign = [];
                    if (data.nurse_sign.length == 0) {
                        nurse_sign = [{
                            sign_show: false,
                            src: ''
                        }, {
                            sign_show: false,
                            src: ''
                        }, {
                            sign_show: false,
                            src: ''
                        }, {
                            sign_show: false,
                            src: ''
                        }];
                    }
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = get_iterator_default()(data.nurse_sign), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var item = _step.value;

                            var obj = {
                                sign_show: item == '' ? false : true,
                                src: item.indexOf(_this2.get_host) != -1 ? item : _this2.get_host + item
                            };
                            nurse_sign.push(obj);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    _this2.form.room_number = data.room_number;
                    _this2.form.maternal_name = data.maternal_name;
                    _this2.form.entrust_man = data.entrust_man;
                    _this2.form.drug_matter = data.drug_matter;
                    _this2.form.entrust_time = data.entrust_time;
                    _this2.family_sign_show = data.family_sign == '' ? false : true;
                    _this2.form.family_sign = data.family_sign.indexOf(_this2.get_host) != -1 ? data.family_sign : _this2.get_host + data.family_sign;
                    _this2.form.nurse_sign = nurse_sign;
                    if (data.group_nurse_sign == '') {
                        _this2.group_nurse_sign_show = false;
                        _this2.form.group_nurse_sign = '';
                    } else {
                        _this2.group_nurse_sign_show = true;
                        _this2.form.group_nurse_sign = data.group_nurse_sign.indexOf(_this2.get_host) != -1 ? data.group_nurse_sign : _this2.get_host + data.group_nurse_sign;
                    }
                    if (data.nurse_long_sign == '') {
                        _this2.nurse_long_sign_show = false;
                        _this2.form.nurse_long_sign = '';
                    } else {
                        _this2.nurse_long_sign_show = true;
                        _this2.form.nurse_long_sign = data.nurse_long_sign.indexOf(_this2.get_host) != -1 ? data.nurse_long_sign : _this2.get_host + data.nurse_long_sign;
                    }
                    _this2.$vux.loading.hide();
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this3 = this;

            var nurse_sign = [];
            if (this.form.nurse_sign.length) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = get_iterator_default()(this.form.nurse_sign), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var item = _step2.value;

                        nurse_sign.push(item.src);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room_number: this.form.room_number,
                maternal_name: this.form.maternal_name,
                entrust_man: this.form.entrust_man,
                drug_matter: this.form.drug_matter,
                entrust_time: this.form.entrust_time,
                family_sign: this.form.family_sign,
                nurse_sign: nurse_sign,
                group_nurse_sign: this.form.group_nurse_sign,
                nurse_long_sign: this.form.nurse_long_sign
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.addFeedDrugEntrust(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this3.$vux.loading.hide();
                    _this3.$router.replace({
                        path: '/success',
                        query: {
                            id: _this3.$route.query.id,
                            form_id: _this3.$route.query.form_id,
                            tabVal: _this3.$route.query.tabVal,
                            name: 'medicine_commissioned'
                        }
                    });
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this4 = this;

            var nurse_sign = [];
            if (this.form.nurse_sign.length) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = get_iterator_default()(this.form.nurse_sign), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var item = _step3.value;

                        nurse_sign.push(item.src.indexOf(this.get_host) != -1 ? item.src.replace(this.get_host, '') : item.src);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                room_number: this.form.room_number,
                maternal_name: this.form.maternal_name,
                entrust_man: this.form.entrust_man,
                drug_matter: this.form.drug_matter,
                entrust_time: this.form.entrust_time,
                family_sign: this.form.family_sign.indexOf(this.get_host) != -1 ? this.form.family_sign.replace(this.get_host, '') : this.form.family_sign,
                nurse_sign: nurse_sign,
                group_nurse_sign: this.form.group_nurse_sign.indexOf(this.get_host) != -1 ? this.form.group_nurse_sign.replace(this.get_host, '') : this.form.group_nurse_sign,
                nurse_long_sign: this.form.nurse_long_sign.indexOf(this.get_host) != -1 ? this.form.nurse_long_sign.replace(this.get_host, '') : this.form.nurse_long_sign,
                id: this.$route.query.list_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.updateFeedDrugEntrust(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this4.$vux.loading.hide();
                    _this4.$router.replace({
                        path: '/success',
                        query: {
                            id: _this4.$route.query.id,
                            form_id: _this4.$route.query.form_id,
                            tabVal: _this4.$route.query.tabVal,
                            name: 'medicine_commissioned'
                        }
                    });
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a95d5f56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicine_commissioned.vue
var medicine_commissioned_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"medicine_commissioned"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("喂药委托书")]),_vm._v(" "),_c('div',[_c('group',{staticClass:"editContent"},[_c('x-input',{attrs:{"title":"本人为","placeholder":"房号"},model:{value:(_vm.form.room_number),callback:function ($$v) {_vm.$set(_vm.form, "room_number", $$v)},expression:"form.room_number"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"入住产妇","placeholder":"姓名"},model:{value:(_vm.form.maternal_name),callback:function ($$v) {_vm.$set(_vm.form, "maternal_name", $$v)},expression:"form.maternal_name"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("现正式委托责任护士遵医嘱为本人之")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.entrust_man),callback:function ($$v) {_vm.$set(_vm.form, "entrust_man", $$v)},expression:"form.entrust_man"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("子")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("女")])],1)],1)])]),_vm._v(" "),_c('x-input',{staticClass:"title",attrs:{"title":"以下喂服新生儿药物","disabled":""}}),_vm._v(" "),_vm._l((_vm.form.drug_matter),function(item,index){return _c('div',{key:index,staticClass:"vux-1px-t"},[(index == 0 || index == 1 || index == 2)?_c('selector',{attrs:{"title":(index+1)+'.'+'药名',"options":_vm.options,"placeholder":"请选择药名"},model:{value:(item.drug_name),callback:function ($$v) {_vm.$set(item, "drug_name", $$v)},expression:"item.drug_name"}}):_c('x-input',{attrs:{"title":(index+1)+'.'+'药名',"placeholder":"请输入药名"},model:{value:(item.drug_name),callback:function ($$v) {_vm.$set(item, "drug_name", $$v)},expression:"item.drug_name"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"使用方法","placeholder":"请输入使用方法"},model:{value:(item.use_method),callback:function ($$v) {_vm.$set(item, "use_method", $$v)},expression:"item.use_method"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"服用剂量","placeholder":"请输入服用剂量"},model:{value:(item.take_dost),callback:function ($$v) {_vm.$set(item, "take_dost", $$v)},expression:"item.take_dost"}})],1)}),_vm._v(" "),_c('datetime',{attrs:{"title":"喂药时间","placeholder":"喂药时间"},model:{value:(_vm.form.entrust_time),callback:function ($$v) {_vm.$set(_vm.form, "entrust_time", $$v)},expression:"form.entrust_time"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("家属签名")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.family_sign_show)?_c('div',[(_vm.form.family_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.family_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.family_sign_edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"family_sign_signature",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.family_sign_save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.family_sign_clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_vm._l((_vm.form.nurse_sign),function(item,index){return _c('div',{key:index+'a',staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("责任护士签名")]),_vm._v(" "),_c('div',{staticClass:"value"},[(item.sign_show)?_c('div',[(item.sign_show)?_c('img',{staticClass:"showImage",attrs:{"src":item.src,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.nurse_sign_edit(index)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:'nurse_sign_signature_'+index,refInFor:true,staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.nurse_sign_save(index)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.nurse_sign_clear(index)}}},[_vm._v("清除")])],1)],1)])])])}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护士组长签名")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.group_nurse_sign_show)?_c('div',[(_vm.form.group_nurse_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.group_nurse_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.group_nurse_sign_edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"group_nurse_sign_signature",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.group_nurse_sign_save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.group_nurse_sign_clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护士长签名")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.nurse_long_sign_show)?_c('div',[(_vm.form.nurse_long_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.nurse_long_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.nurse_long_sign_edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"nurse_long_sign_signature",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.nurse_long_sign_save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.nurse_long_sign_clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],2)],1)],1)}
var medicine_commissioned_staticRenderFns = []
var medicine_commissioned_esExports = { render: medicine_commissioned_render, staticRenderFns: medicine_commissioned_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_medicine_commissioned = (medicine_commissioned_esExports);
// CONCATENATED MODULE: ./src/components/medicine_commissioned.vue
function medicine_commissioned_injectStyle (ssrContext) {
  __webpack_require__("P5P0")
}
var medicine_commissioned_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var medicine_commissioned___vue_template_functional__ = false
/* styles */
var medicine_commissioned___vue_styles__ = medicine_commissioned_injectStyle
/* scopeId */
var medicine_commissioned___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var medicine_commissioned___vue_module_identifier__ = null
var medicine_commissioned_Component = medicine_commissioned_normalizeComponent(
  components_medicine_commissioned,
  selectortype_template_index_0_src_components_medicine_commissioned,
  medicine_commissioned___vue_template_functional__,
  medicine_commissioned___vue_styles__,
  medicine_commissioned___vue_scopeId__,
  medicine_commissioned___vue_module_identifier__
)

/* harmony default export */ var src_components_medicine_commissioned = (medicine_commissioned_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/basic_nursing.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var basic_nursing = ({
    name: 'basic_nursing',
    components: {
        DateTime: vue_date_time_m_default.a
    },
    data: function data() {
        return {
            form: {
                base_sense: '您好，欢迎入住月子会所，我是你的护士，你入住期间，有任何问题，都可以直接联系我们，你月子期间我们也给你制定了学习的内容，请您确认是否掌握以下月子常识，谢谢你的配合！',
                feed_raise_posture: '',
                hiccup_method: '',
                nursing_guidance: '',
                preven_mastitis: '',
                change_diapers: '',
                wash_ass: '',
                milk_feed_method: '',
                baby_sun_method: '',
                breast_milk_method: '',
                puerperal_guidance: '',
                milk_punch_method: '',
                baby_undress: '',
                return_milk_guidance: '',
                baby_after_hair: '',
                baby_bath: '',
                meeting_guidance: '',
                valuable_proposal: '',
                illness_phenomenon: '',
                maternal_sign: '',
                nursing_sign: ''
            },
            maternal_sign_show: false,
            nursing_sign_show: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            get_host: host.host
        };
    },
    created: function created() {
        // this.get_baby_list()
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            // this.apiMemberInfo()
        }
    },

    methods: {
        //请求用户基本信息
        // apiMemberInfo(){
        //     let params = {
        //         token: this.$cookie.get('token'),
        //         maternal_info_id: this.$route.query.id
        //     }
        //     Api.checkRoomApi.memberInfo(params).then ( res => {
        //         console.info(res)
        //         if(res.errcode == 1){
        //             this.form.room_number = res.data.room_name
        //             this.form.maternal_name = res.data.name
        //         }else{
        //             this.$vux.toast.show({
        //                 type: 'cancel',
        //                 text: res.errinfo,
        //             })
        //         }
        //     })
        // },
        // 家属签名操作
        maternal_sign_save: function maternal_sign_save() {
            var signature = 'maternal_sign_signature';
            var png = this.$refs[signature].save();
            this.form.maternal_sign = encodeURI(png);
            this.maternal_sign_show = true;
        },
        maternal_sign_edit: function maternal_sign_edit() {
            this.maternal_sign_show = false;
            this.form.maternal_sign = '';
        },
        maternal_sign_clear: function maternal_sign_clear() {
            var signature = 'maternal_sign_signature';
            var refs = this.$refs[signature].clear();
            this.form.maternal_sign = '';
        },

        // 护士组长签名操作
        nursing_sign_save: function nursing_sign_save() {
            var signature = 'nursing_sign_signature';
            var png = this.$refs[signature].save();
            this.form.nursing_sign = encodeURI(png);
            this.nursing_sign_show = true;
        },
        nursing_sign_edit: function nursing_sign_edit() {
            this.nursing_sign_show = false;
            this.form.nursing_sign = '';
        },
        nursing_sign_clear: function nursing_sign_clear() {
            var signature = 'nursing_sign_signature';
            var refs = this.$refs[signature].clear();
            this.form.nursing_sign = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.confinementSenseDetail(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this.form.base_sense = data.base_sense;
                    _this.form.feed_raise_posture = data.feed_raise_posture;
                    _this.form.hiccup_method = data.hiccup_method;
                    _this.form.nursing_guidance = data.nursing_guidance;
                    _this.form.preven_mastitis = data.preven_mastitis;
                    _this.form.change_diapers = data.change_diapers;
                    _this.form.wash_ass = data.wash_ass;
                    _this.form.milk_feed_method = data.milk_feed_method;
                    _this.form.baby_sun_method = data.baby_sun_method;
                    _this.form.breast_milk_method = data.breast_milk_method;
                    _this.form.puerperal_guidance = data.puerperal_guidance;
                    _this.form.milk_punch_method = data.milk_punch_method;
                    _this.form.baby_undress = data.baby_undress;
                    _this.form.return_milk_guidance = data.return_milk_guidance;
                    _this.form.baby_after_hair = data.baby_after_hair;
                    _this.form.baby_bath = data.baby_bath;
                    _this.form.meeting_guidance = data.meeting_guidance;
                    _this.form.valuable_proposal = data.valuable_proposal;
                    _this.form.illness_phenomenon = data.illness_phenomenon;
                    if (data.maternal_sign == '') {
                        _this.maternal_sign_show = false;
                        _this.form.maternal_sign = '';
                    } else {
                        _this.maternal_sign_show = true;
                        _this.form.maternal_sign = data.maternal_sign.indexOf(_this.get_host) != -1 ? data.maternal_sign : _this.get_host + data.maternal_sign;
                    }
                    if (data.nursing_sign == '') {
                        _this.nursing_sign_show = false;
                        _this.form.nursing_sign = '';
                    } else {
                        _this.nursing_sign_show = true;
                        _this.form.nursing_sign = data.nursing_sign.indexOf(_this.get_host) != -1 ? data.nursing_sign : _this.get_host + data.nursing_sign;
                    }
                    _this.$vux.loading.hide();
                } else {
                    _this.$vux.loading.hide();
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                base_sense: this.form.base_sense,
                feed_raise_posture: this.form.feed_raise_posture,
                hiccup_method: this.form.hiccup_method,
                nursing_guidance: this.form.nursing_guidance,
                preven_mastitis: this.form.preven_mastitis,
                change_diapers: this.form.change_diapers,
                wash_ass: this.form.wash_ass,
                milk_feed_method: this.form.milk_feed_method,
                puerperal_guidance: this.form.puerperal_guidance,
                milk_punch_method: this.form.milk_punch_method,
                baby_sun_method: this.form.baby_sun_method,
                breast_milk_method: this.form.breast_milk_method,
                baby_undress: this.form.baby_undress,
                return_milk_guidance: this.form.return_milk_guidance,
                baby_after_hair: this.form.baby_after_hair,
                baby_bath: this.form.baby_bath,
                meeting_guidance: this.form.meeting_guidance,
                valuable_proposal: this.form.valuable_proposal,
                illness_phenomenon: this.form.illness_phenomenon,
                maternal_sign: this.form.maternal_sign,
                nursing_sign: this.form.nursing_sign
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.addConfinementSense(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this2.$vux.loading.hide();
                    _this2.$router.replace({
                        path: '/success',
                        query: {
                            id: _this2.$route.query.id,
                            form_id: _this2.$route.query.form_id,
                            tabVal: _this2.$route.query.tabVal,
                            name: 'basic_nursing'
                        }
                    });
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                base_sense: this.form.base_sense,
                feed_raise_posture: this.form.feed_raise_posture,
                hiccup_method: this.form.hiccup_method,
                nursing_guidance: this.form.nursing_guidance,
                preven_mastitis: this.form.preven_mastitis,
                change_diapers: this.form.change_diapers,
                wash_ass: this.form.wash_ass,
                milk_feed_method: this.form.milk_feed_method,
                puerperal_guidance: this.form.puerperal_guidance,
                milk_punch_method: this.form.milk_punch_method,
                baby_sun_method: this.form.baby_sun_method,
                breast_milk_method: this.form.breast_milk_method,
                baby_undress: this.form.baby_undress,
                return_milk_guidance: this.form.return_milk_guidance,
                baby_after_hair: this.form.baby_after_hair,
                baby_bath: this.form.baby_bath,
                meeting_guidance: this.form.meeting_guidance,
                valuable_proposal: this.form.valuable_proposal,
                illness_phenomenon: this.form.illness_phenomenon,
                maternal_sign: this.form.maternal_sign.indexOf(this.get_host) != -1 ? this.form.maternal_sign.replace(this.get_host, '') : this.form.maternal_sign,
                nursing_sign: this.form.nursing_sign.indexOf(this.get_host) != -1 ? this.form.nursing_sign.replace(this.get_host, '') : this.form.nursing_sign,
                id: this.$route.query.list_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.updateConfinementSense(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this3.$vux.loading.hide();
                    _this3.$router.replace({
                        path: '/success',
                        query: {
                            id: _this3.$route.query.id,
                            form_id: _this3.$route.query.form_id,
                            tabVal: _this3.$route.query.tabVal,
                            name: 'basic_nursing'
                        }
                    });
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/basic_nursing.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_basic_nursing = ({
    name: 'basic_nursing',
    components: {
        DateTime: vue_date_time_m_default.a
    },
    data: function data() {
        return {
            form: {
                base_sense: '您好，欢迎入住月子会所，我是你的护士，你入住期间，有任何问题，都可以直接联系我们，你月子期间我们也给你制定了学习的内容，请您确认是否掌握以下月子常识，谢谢你的配合！',
                feed_raise_posture: '',
                hiccup_method: '',
                nursing_guidance: '',
                preven_mastitis: '',
                change_diapers: '',
                wash_ass: '',
                milk_feed_method: '',
                baby_sun_method: '',
                breast_milk_method: '',
                puerperal_guidance: '',
                milk_punch_method: '',
                baby_undress: '',
                return_milk_guidance: '',
                baby_after_hair: '',
                baby_bath: '',
                meeting_guidance: '',
                valuable_proposal: '',
                illness_phenomenon: '',
                maternal_sign: '',
                nursing_sign: ''
            },
            maternal_sign_show: false,
            nursing_sign_show: false,
            option: {
                penColor: "rgb(0, 0, 0)"
            },
            get_host: host.host
        };
    },
    created: function created() {
        // this.get_baby_list()
        if (this.$route.query.list_id) {
            this.apiDetail();
        } else {
            // this.apiMemberInfo()
        }
    },

    methods: {
        //请求用户基本信息
        // apiMemberInfo(){
        //     let params = {
        //         token: this.$cookie.get('token'),
        //         maternal_info_id: this.$route.query.id
        //     }
        //     Api.checkRoomApi.memberInfo(params).then ( res => {
        //         console.info(res)
        //         if(res.errcode == 1){
        //             this.form.room_number = res.data.room_name
        //             this.form.maternal_name = res.data.name
        //         }else{
        //             this.$vux.toast.show({
        //                 type: 'cancel',
        //                 text: res.errinfo,
        //             })
        //         }
        //     })
        // },
        // 家属签名操作
        maternal_sign_save: function maternal_sign_save() {
            var signature = 'maternal_sign_signature';
            var png = this.$refs[signature].save();
            this.form.maternal_sign = encodeURI(png);
            this.maternal_sign_show = true;
        },
        maternal_sign_edit: function maternal_sign_edit() {
            this.maternal_sign_show = false;
            this.form.maternal_sign = '';
        },
        maternal_sign_clear: function maternal_sign_clear() {
            var signature = 'maternal_sign_signature';
            var refs = this.$refs[signature].clear();
            this.form.maternal_sign = '';
        },

        // 护士组长签名操作
        nursing_sign_save: function nursing_sign_save() {
            var signature = 'nursing_sign_signature';
            var png = this.$refs[signature].save();
            this.form.nursing_sign = encodeURI(png);
            this.nursing_sign_show = true;
        },
        nursing_sign_edit: function nursing_sign_edit() {
            this.nursing_sign_show = false;
            this.form.nursing_sign = '';
        },
        nursing_sign_clear: function nursing_sign_clear() {
            var signature = 'nursing_sign_signature';
            var refs = this.$refs[signature].clear();
            this.form.nursing_sign = '';
        },

        //请求详情数据
        apiDetail: function apiDetail() {
            var _this = this;

            var params = {
                token: this.$cookie.get('token'),
                id: this.$route.query.list_id
            };
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.confinementSenseDetail(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    var data = res.data;
                    _this.form.base_sense = data.base_sense;
                    _this.form.feed_raise_posture = data.feed_raise_posture;
                    _this.form.hiccup_method = data.hiccup_method;
                    _this.form.nursing_guidance = data.nursing_guidance;
                    _this.form.preven_mastitis = data.preven_mastitis;
                    _this.form.change_diapers = data.change_diapers;
                    _this.form.wash_ass = data.wash_ass;
                    _this.form.milk_feed_method = data.milk_feed_method;
                    _this.form.baby_sun_method = data.baby_sun_method;
                    _this.form.breast_milk_method = data.breast_milk_method;
                    _this.form.puerperal_guidance = data.puerperal_guidance;
                    _this.form.milk_punch_method = data.milk_punch_method;
                    _this.form.baby_undress = data.baby_undress;
                    _this.form.return_milk_guidance = data.return_milk_guidance;
                    _this.form.baby_after_hair = data.baby_after_hair;
                    _this.form.baby_bath = data.baby_bath;
                    _this.form.meeting_guidance = data.meeting_guidance;
                    _this.form.valuable_proposal = data.valuable_proposal;
                    _this.form.illness_phenomenon = data.illness_phenomenon;
                    if (data.maternal_sign == '') {
                        _this.maternal_sign_show = false;
                        _this.form.maternal_sign = '';
                    } else {
                        _this.maternal_sign_show = true;
                        _this.form.maternal_sign = data.maternal_sign.indexOf(_this.get_host) != -1 ? data.maternal_sign : _this.get_host + data.maternal_sign;
                    }
                    if (data.nursing_sign == '') {
                        _this.nursing_sign_show = false;
                        _this.form.nursing_sign = '';
                    } else {
                        _this.nursing_sign_show = true;
                        _this.form.nursing_sign = data.nursing_sign.indexOf(_this.get_host) != -1 ? data.nursing_sign : _this.get_host + data.nursing_sign;
                    }
                    _this.$vux.loading.hide();
                } else {
                    _this.$vux.loading.hide();
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //请求添加数据
        apiAddForm: function apiAddForm() {
            var _this2 = this;

            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                base_sense: this.form.base_sense,
                feed_raise_posture: this.form.feed_raise_posture,
                hiccup_method: this.form.hiccup_method,
                nursing_guidance: this.form.nursing_guidance,
                preven_mastitis: this.form.preven_mastitis,
                change_diapers: this.form.change_diapers,
                wash_ass: this.form.wash_ass,
                milk_feed_method: this.form.milk_feed_method,
                puerperal_guidance: this.form.puerperal_guidance,
                milk_punch_method: this.form.milk_punch_method,
                baby_sun_method: this.form.baby_sun_method,
                breast_milk_method: this.form.breast_milk_method,
                baby_undress: this.form.baby_undress,
                return_milk_guidance: this.form.return_milk_guidance,
                baby_after_hair: this.form.baby_after_hair,
                baby_bath: this.form.baby_bath,
                meeting_guidance: this.form.meeting_guidance,
                valuable_proposal: this.form.valuable_proposal,
                illness_phenomenon: this.form.illness_phenomenon,
                maternal_sign: this.form.maternal_sign,
                nursing_sign: this.form.nursing_sign
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.addConfinementSense(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this2.$vux.loading.hide();
                    _this2.$router.replace({
                        path: '/success',
                        query: {
                            id: _this2.$route.query.id,
                            form_id: _this2.$route.query.form_id,
                            tabVal: _this2.$route.query.tabVal,
                            name: 'basic_nursing'
                        }
                    });
                } else {
                    _this2.$vux.loading.hide();
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        // 请求更新数据
        apiUpdateForm: function apiUpdateForm() {
            var _this3 = this;

            var params = {
                token: this.$cookie.get('token'),
                member_id: this.$cookie.get('id'),
                maternal_info_id: this.$route.query.id,
                base_sense: this.form.base_sense,
                feed_raise_posture: this.form.feed_raise_posture,
                hiccup_method: this.form.hiccup_method,
                nursing_guidance: this.form.nursing_guidance,
                preven_mastitis: this.form.preven_mastitis,
                change_diapers: this.form.change_diapers,
                wash_ass: this.form.wash_ass,
                milk_feed_method: this.form.milk_feed_method,
                puerperal_guidance: this.form.puerperal_guidance,
                milk_punch_method: this.form.milk_punch_method,
                baby_sun_method: this.form.baby_sun_method,
                breast_milk_method: this.form.breast_milk_method,
                baby_undress: this.form.baby_undress,
                return_milk_guidance: this.form.return_milk_guidance,
                baby_after_hair: this.form.baby_after_hair,
                baby_bath: this.form.baby_bath,
                meeting_guidance: this.form.meeting_guidance,
                valuable_proposal: this.form.valuable_proposal,
                illness_phenomenon: this.form.illness_phenomenon,
                maternal_sign: this.form.maternal_sign.indexOf(this.get_host) != -1 ? this.form.maternal_sign.replace(this.get_host, '') : this.form.maternal_sign,
                nursing_sign: this.form.nursing_sign.indexOf(this.get_host) != -1 ? this.form.nursing_sign.replace(this.get_host, '') : this.form.nursing_sign,
                id: this.$route.query.list_id
            };
            console.info(params);
            this.$vux.loading.show({
                text: '正在加载'
            });
            Api.checkRoomApi.updateConfinementSense(params).then(function (res) {
                console.info(res);
                if (res.errcode == 200) {
                    _this3.$vux.loading.hide();
                    _this3.$router.replace({
                        path: '/success',
                        query: {
                            id: _this3.$route.query.id,
                            form_id: _this3.$route.query.form_id,
                            tabVal: _this3.$route.query.tabVal,
                            name: 'basic_nursing'
                        }
                    });
                } else {
                    _this3.$vux.loading.hide();
                    _this3.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },
        submitForm: function submitForm() {
            if (this.$route.query.list_id) {
                console.info("请求更新数据");
                this.apiUpdateForm();
            } else {
                console.info("请求添加数据");
                this.apiAddForm();
            }
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-556e5bbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic_nursing.vue
var basic_nursing_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic_nursing"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("月子基本护理常识")]),_vm._v(" "),_c('div',[_c('group',{staticClass:"editContent"},[_c('x-textarea',{attrs:{"autosize":""},model:{value:(_vm.form.base_sense),callback:function ($$v) {_vm.$set(_vm.form, "base_sense", $$v)},expression:"form.base_sense"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("1.母乳喂养的姿势")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.feed_raise_posture),callback:function ($$v) {_vm.$set(_vm.form, "feed_raise_posture", $$v)},expression:"form.feed_raise_posture"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("2.宝宝拍嗝的方法")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.hiccup_method),callback:function ($$v) {_vm.$set(_vm.form, "hiccup_method", $$v)},expression:"form.hiccup_method"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("3.产妇乳房护理指导")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.nursing_guidance),callback:function ($$v) {_vm.$set(_vm.form, "nursing_guidance", $$v)},expression:"form.nursing_guidance"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("4.如何预防乳腺炎")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.preven_mastitis),callback:function ($$v) {_vm.$set(_vm.form, "preven_mastitis", $$v)},expression:"form.preven_mastitis"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("5.如何更换尿片")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.change_diapers),callback:function ($$v) {_vm.$set(_vm.form, "change_diapers", $$v)},expression:"form.change_diapers"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("6.如何洗屁股")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.wash_ass),callback:function ($$v) {_vm.$set(_vm.form, "wash_ass", $$v)},expression:"form.wash_ass"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("7.奶瓶的喂养方法")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.milk_feed_method),callback:function ($$v) {_vm.$set(_vm.form, "milk_feed_method", $$v)},expression:"form.milk_feed_method"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("8.宝宝晒太阳的方法")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.baby_sun_method),callback:function ($$v) {_vm.$set(_vm.form, "baby_sun_method", $$v)},expression:"form.baby_sun_method"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("9.母乳的存放和解冻方法")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.breast_milk_method),callback:function ($$v) {_vm.$set(_vm.form, "breast_milk_method", $$v)},expression:"form.breast_milk_method"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("10.产褥操的指导")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.puerperal_guidance),callback:function ($$v) {_vm.$set(_vm.form, "puerperal_guidance", $$v)},expression:"form.puerperal_guidance"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("11.奶粉的冲调方法")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.milk_punch_method),callback:function ($$v) {_vm.$set(_vm.form, "milk_punch_method", $$v)},expression:"form.milk_punch_method"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("12.如何给宝宝穿脱衣服")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.baby_undress),callback:function ($$v) {_vm.$set(_vm.form, "baby_undress", $$v)},expression:"form.baby_undress"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("13.回奶观察指导")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.return_milk_guidance),callback:function ($$v) {_vm.$set(_vm.form, "return_milk_guidance", $$v)},expression:"form.return_milk_guidance"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("14.宝宝理胎发后如何处理")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.baby_after_hair),callback:function ($$v) {_vm.$set(_vm.form, "baby_after_hair", $$v)},expression:"form.baby_after_hair"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("15.如何给宝宝洗澡")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.baby_bath),callback:function ($$v) {_vm.$set(_vm.form, "baby_bath", $$v)},expression:"form.baby_bath"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"item vux-1px-t",staticStyle:{"padding-left":"0!important"}},[_c('div',{staticClass:"label",staticStyle:{"line-height":"36px"}},[_vm._v("16.出会所指导")]),_vm._v(" "),_c('div',{staticClass:"value"},[_c('checker',{attrs:{"default-item-class":"demo1-item","selected-item-class":"demo1-item-selected"},model:{value:(_vm.form.meeting_guidance),callback:function ($$v) {_vm.$set(_vm.form, "meeting_guidance", $$v)},expression:"form.meeting_guidance"}},[_c('checker-item',{attrs:{"value":"1"}},[_vm._v("是")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"2"}},[_vm._v("否")])],1)],1)])]),_vm._v(" "),_c('x-input',{attrs:{"title":"您有宝贵的建议吗？","placeholder":"请输入"},model:{value:(_vm.form.valuable_proposal),callback:function ($$v) {_vm.$set(_vm.form, "valuable_proposal", $$v)},expression:"form.valuable_proposal"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"月子期间有出现病理现象","placeholder":"请输入"},model:{value:(_vm.form.illness_phenomenon),callback:function ($$v) {_vm.$set(_vm.form, "illness_phenomenon", $$v)},expression:"form.illness_phenomenon"}}),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("产妇确认签名")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.maternal_sign_show)?_c('div',[(_vm.form.maternal_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.maternal_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.maternal_sign_edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"maternal_sign_signature",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.maternal_sign_save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.maternal_sign_clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"listItem"},[_c('div',{staticClass:"item vux-1px-t"},[_c('div',{staticClass:"label"},[_vm._v("护士签名")]),_vm._v(" "),_c('div',{staticClass:"value"},[(_vm.nursing_sign_show)?_c('div',[(_vm.form.nursing_sign)?_c('img',{staticClass:"showImage",attrs:{"src":_vm.form.nursing_sign,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.nursing_sign_edit.apply(null, arguments)}}},[_vm._v("编辑签名")])],1)]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"htbg",staticStyle:{"display":"flex"}},[_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}}),_vm._v(" "),_c('img',{staticStyle:{"width":"25%","height":"200px"},attrs:{"src":__webpack_require__("nH59"),"alt":""}})]),_vm._v(" "),_c('vueSignature',{ref:"nursing_sign_signature",staticStyle:{"position":"absolute","left":"0","top":"0","opacity":"0.5"},attrs:{"sigOption":_vm.option,"w":'100%',"h":'200px'}}),_vm._v(" "),_c('div',{staticClass:"oBtn"},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.nursing_sign_save.apply(null, arguments)}}},[_vm._v("保存签名")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"0"},attrs:{"type":"warn","mini":""},nativeOn:{"click":function($event){return _vm.nursing_sign_clear.apply(null, arguments)}}},[_vm._v("清除")])],1)],1)])])]),_vm._v(" "),_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0']},nativeOn:{"click":function($event){return _vm.submitForm.apply(null, arguments)}}},[_vm._v("提交")])],1)],1)],1)}
var basic_nursing_staticRenderFns = []
var basic_nursing_esExports = { render: basic_nursing_render, staticRenderFns: basic_nursing_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_basic_nursing = (basic_nursing_esExports);
// CONCATENATED MODULE: ./src/components/basic_nursing.vue
function basic_nursing_injectStyle (ssrContext) {
  __webpack_require__("Q1vz")
}
var basic_nursing_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var basic_nursing___vue_template_functional__ = false
/* styles */
var basic_nursing___vue_styles__ = basic_nursing_injectStyle
/* scopeId */
var basic_nursing___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var basic_nursing___vue_module_identifier__ = null
var basic_nursing_Component = basic_nursing_normalizeComponent(
  components_basic_nursing,
  selectortype_template_index_0_src_components_basic_nursing,
  basic_nursing___vue_template_functional__,
  basic_nursing___vue_styles__,
  basic_nursing___vue_scopeId__,
  basic_nursing___vue_module_identifier__
)

/* harmony default export */ var src_components_basic_nursing = (basic_nursing_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/new_check_room_record.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var new_check_room_record = ({
    name: "check_room_record",
    data: function data() {
        return {
            showShift: true,
            maxDate: '',
            shifts_value: '',
            shifts: ['早班', '中班', '晚班', '无班次'],
            agent_value: '',
            agent_options: [],
            start_date: '',
            end_date: '',
            form_type: '',
            form_type_options: [],
            keyword: '',
            page: 1,
            id: this.$route.query.id,
            tabVal: this.$route.query.tabVal,
            listData: [],
            pullupDefaultConfig: {
                content: '上拉加载更多',
                pullUpHeight: 60,
                height: 40,
                autoRefresh: false,
                downContent: '释放后加载',
                upContent: '上拉加载更多',
                loadingContent: '加载中...',
                clsPrefix: 'xs-plugin-pullup-'
            },
            pulldownDefaultConfig: {
                content: '下拉刷新',
                height: 40,
                autoRefresh: false,
                downContent: '下拉刷新',
                upContent: '释放后刷新',
                loadingContent: '正在刷新...',
                clsPrefix: 'xs-plugin-pulldown-'
            }
        };
    },

    methods: {
        formChange: function formChange(value) {
            console.log(value);
            if (value == 12 || value == 13) {
                this.showShift = false;
                this.shifts_value = '';
            } else {
                this.showShift = true;
            }
        },

        //查房人
        apiGetAgentList: function apiGetAgentList() {
            var _this = this;

            var that = this;
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.getAgentListFn(params).then(function (res) {
                console.log('查房人', res);
                if (res.errcode == 200) {
                    if (res.data.length) {
                        _this.agent_options = [];
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                _this.agent_options.push({
                                    key: item.agent_id,
                                    value: item.agent_name
                                });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //所用表格
        apiGetFormTypeList: function apiGetFormTypeList() {
            var _this2 = this;

            var that = this;
            var params = {
                token: this.$cookie.get('token')
            };
            Api.checkRoomApi.getFormTypeListFn(params).then(function (res) {
                console.log('表格列表', res);
                if (res.errcode == 200) {
                    if (res.data.length) {
                        _this2.form_type_options = [];
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = get_iterator_default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var item = _step2.value;

                                _this2.form_type_options.push({
                                    key: item.form_id,
                                    value: item.form_name
                                });
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日';
        },
        cInput: function cInput() {
            this.keyword = '';
            this.refresh();
        },
        searchBtn: function searchBtn() {
            var _this3 = this;

            this.$nextTick(function () {
                _this3.$refs.scrollerBottom.reset({ top: 0 });
                _this3.refresh();
            });
        },
        clearBtn: function clearBtn() {
            var that = this;
            that.agent_value = '';
            that.form_type = '';
            that.start_date = '';
            that.end_date = '';
            this.shifts_value = '';
            this.refresh();
            this.$vux.toast.show({
                type: 'success',
                text: '已清空'
            });
        },
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this4 = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id,
                form_id: this.form_type,
                agent_id: this.agent_value,
                start_date: this.start_date,
                end_date: this.end_date,
                shifts: this.shifts_value,
                page: this.page,
                limit: 10
            };
            console.log(params);
            Api.checkRoomApi.getFormDataListFn(params).then(function (res) {
                console.info('列表数据', res);
                if (res.errcode == 200) {
                    _this4.page++;
                    _this4.$nextTick(function () {
                        _this4.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = get_iterator_default()(res.data.list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var item = _step3.value;

                                _this4.listData.push(item);
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }

                        if (str == 'refresh') {
                            _this4.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
                            _this4.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
                        } else {
                            _this4.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
                            _this4.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
                        }
                        if (res.data.list.length != 10) {
                            _this4.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行   
                        }
                    } else {
                        // this.listData = res.data.list
                        _this4.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
                        _this4.$vux.toast.show({
                            type: 'cancel',
                            text: '暂无更多数据'
                        });
                    }
                    _this4.$vux.loading.hide();
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData = [];
            this.page = 1;
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        },
        getNowFormatDate: function getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        editFormDetailList: function editFormDetailList(answer_id, form_id) {
            console.log("_____");
            var get_form_id = '';
            if (form_id < 10) {
                get_form_id = '100' + form_id;
            }
            if (form_id >= 10 && form_id < 20) {
                get_form_id = '10' + form_id;
            }
            var query = {
                id: this.$route.query.id,
                form_id: get_form_id,
                tabVal: this.$route.query.tabVal,
                start_date: this.start_date,
                end_date: this.end_date,
                shifts_value: this.shifts_value
            };
            this.$router.push({
                path: './check_room_service',
                query: query
            });
        }
    },
    created: function created() {
        this.start_date = this.getNowFormatDate();
        this.end_date = this.getNowFormatDate();
        this.maxDate = this.getNowFormatDate();
        // this.$nextTick(() => {
        //     this.$refs.scrollerBottom.reset({top: 0})
        // })
        this.apiGetFormTypeList();
        this.apiGetAgentList();
        // this.apiFormList()
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/new_check_room_record.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_new_check_room_record = ({
    name: "check_room_record",
    data: function data() {
        return {
            showShift: true,
            maxDate: '',
            shifts_value: '',
            shifts: ['早班', '中班', '晚班', '无班次'],
            agent_value: '',
            agent_options: [],
            start_date: '',
            end_date: '',
            form_type: '',
            form_type_options: [],
            keyword: '',
            page: 1,
            id: this.$route.query.id,
            tabVal: this.$route.query.tabVal,
            listData: [],
            pullupDefaultConfig: {
                content: '上拉加载更多',
                pullUpHeight: 60,
                height: 40,
                autoRefresh: false,
                downContent: '释放后加载',
                upContent: '上拉加载更多',
                loadingContent: '加载中...',
                clsPrefix: 'xs-plugin-pullup-'
            },
            pulldownDefaultConfig: {
                content: '下拉刷新',
                height: 40,
                autoRefresh: false,
                downContent: '下拉刷新',
                upContent: '释放后刷新',
                loadingContent: '正在刷新...',
                clsPrefix: 'xs-plugin-pulldown-'
            }
        };
    },

    methods: {
        formChange: function formChange(value) {
            console.log(value);
            if (value == 12 || value == 13) {
                this.showShift = false;
                this.shifts_value = '';
            } else {
                this.showShift = true;
            }
        },

        //查房人
        apiGetAgentList: function apiGetAgentList() {
            var _this = this;

            var that = this;
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id
            };
            Api.checkRoomApi.getAgentListFn(params).then(function (res) {
                console.log('查房人', res);
                if (res.errcode == 200) {
                    if (res.data.length) {
                        _this.agent_options = [];
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                            for (var _iterator = get_iterator_default()(res.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                var item = _step.value;

                                _this.agent_options.push({
                                    key: item.agent_id,
                                    value: item.agent_name
                                });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }
                            } finally {
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } else {
                    _this.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //所用表格
        apiGetFormTypeList: function apiGetFormTypeList() {
            var _this2 = this;

            var that = this;
            var params = {
                token: this.$cookie.get('token')
            };
            Api.checkRoomApi.getFormTypeListFn(params).then(function (res) {
                console.log('表格列表', res);
                if (res.errcode == 200) {
                    if (res.data.length) {
                        _this2.form_type_options = [];
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = get_iterator_default()(res.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var item = _step2.value;

                                _this2.form_type_options.push({
                                    key: item.form_id,
                                    value: item.form_name
                                });
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } else {
                    _this2.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //时间戳转日期格式    
        formatDateTime: function formatDateTime(inputTime) {
            var date = new Date(parseInt(inputTime) * 1000);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            var d = date.getDate();
            d = d < 10 ? '0' + d : d;
            var h = date.getHours();
            h = h < 10 ? '0' + h : h;
            var minute = date.getMinutes();
            var second = date.getSeconds();
            minute = minute < 10 ? '0' + minute : minute;
            second = second < 10 ? '0' + second : second;
            return y + '年' + m + '月' + d + '日';
        },
        cInput: function cInput() {
            this.keyword = '';
            this.refresh();
        },
        searchBtn: function searchBtn() {
            var _this3 = this;

            this.$nextTick(function () {
                _this3.$refs.scrollerBottom.reset({ top: 0 });
                _this3.refresh();
            });
        },
        clearBtn: function clearBtn() {
            var that = this;
            that.agent_value = '';
            that.form_type = '';
            that.start_date = '';
            that.end_date = '';
            this.shifts_value = '';
            this.refresh();
            this.$vux.toast.show({
                type: 'success',
                text: '已清空'
            });
        },
        apiCheckRoomRecord: function apiCheckRoomRecord(str) {
            var _this4 = this;

            this.$vux.loading.show({
                text: '正在加载'
            });
            var params = {
                token: this.$cookie.get('token'),
                maternal_info_id: this.$route.query.id,
                form_id: this.form_type,
                agent_id: this.agent_value,
                start_date: this.start_date,
                end_date: this.end_date,
                shifts: this.shifts_value,
                page: this.page,
                limit: 10
            };
            console.log(params);
            Api.checkRoomApi.getFormDataListFn(params).then(function (res) {
                console.info('列表数据', res);
                if (res.errcode == 200) {
                    _this4.page++;
                    _this4.$nextTick(function () {
                        _this4.$refs.scrollerBottom.reset();
                    });
                    if (res.data.list.length) {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = get_iterator_default()(res.data.list), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var item = _step3.value;

                                _this4.listData.push(item);
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }

                        if (str == 'refresh') {
                            _this4.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
                            _this4.$refs.scrollerBottom.donePulldown(); //设置下拉刷新操作完成，在数据加载后执行
                        } else {
                            _this4.$refs.scrollerBottom.enablePullup(); //启用上拉加载插件
                            _this4.$refs.scrollerBottom.donePullup(); //设置上拉加载操作完成，在数据加载后执行
                        }
                        if (res.data.list.length != 10) {
                            _this4.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行   
                        }
                    } else {
                        // this.listData = res.data.list
                        _this4.$refs.scrollerBottom.disablePullup(); // 禁用上拉加载，在没有更多数据时执行
                        _this4.$vux.toast.show({
                            type: 'cancel',
                            text: '暂无更多数据'
                        });
                    }
                    _this4.$vux.loading.hide();
                } else {
                    _this4.$vux.loading.hide();
                    _this4.$vux.toast.show({
                        type: 'cancel',
                        text: res.errinfo
                    });
                }
            });
        },

        //下拉刷新
        refresh: function refresh() {
            this.listData = [];
            this.page = 1;
            this.apiCheckRoomRecord('refresh');
        },

        //上拉加载
        loadMore: function loadMore() {
            this.apiCheckRoomRecord();
        },
        getNowFormatDate: function getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        },
        editFormDetailList: function editFormDetailList(answer_id, form_id) {
            console.log("_____");
            var get_form_id = '';
            if (form_id < 10) {
                get_form_id = '100' + form_id;
            }
            if (form_id >= 10 && form_id < 20) {
                get_form_id = '10' + form_id;
            }
            var query = {
                id: this.$route.query.id,
                form_id: get_form_id,
                tabVal: this.$route.query.tabVal,
                start_date: this.start_date,
                end_date: this.end_date,
                shifts_value: this.shifts_value
            };
            this.$router.push({
                path: './check_room_service',
                query: query
            });
        }
    },
    created: function created() {
        this.start_date = this.getNowFormatDate();
        this.end_date = this.getNowFormatDate();
        this.maxDate = this.getNowFormatDate();
        // this.$nextTick(() => {
        //     this.$refs.scrollerBottom.reset({top: 0})
        // })
        this.apiGetFormTypeList();
        this.apiGetAgentList();
        // this.apiFormList()
        this.apiCheckRoomRecord();
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da4577be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new_check_room_record.vue
var new_check_room_record_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check_room_record"},[_c('x-header',{attrs:{"left-options":{showBack: true}}},[_vm._v("查房记录（新）")]),_vm._v(" "),_c('div',{staticClass:"main1"},[_c('flexbox',[_c('flexbox-item',[_c('group',[_c('selector',{attrs:{"placeholder":"全部查房/填写人","options":_vm.agent_options},model:{value:(_vm.agent_value),callback:function ($$v) {_vm.agent_value=$$v},expression:"agent_value"}})],1)],1),_vm._v(" "),_c('flexbox-item',{staticClass:"date"},[_c('group',[_c('datetime',{attrs:{"placeholder":"请选择开始日期","end-date":_vm.maxDate},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}})],1)],1),_vm._v(" "),_c('flexbox-item',{staticClass:"date"},[_c('group',[_c('datetime',{attrs:{"placeholder":"请选择结束日期","start-date":_vm.start_date,"end-date":_vm.maxDate},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}})],1)],1),_vm._v(" "),_c('flexbox-item',[_c('group',{directives:[{name:"show",rawName:"v-show",value:(_vm.showShift),expression:"showShift"}]},[_c('selector',{attrs:{"placeholder":"全部班次","options":_vm.shifts},model:{value:(_vm.shifts_value),callback:function ($$v) {_vm.shifts_value=$$v},expression:"shifts_value"}})],1)],1)],1),_vm._v(" "),_c('flexbox',[_c('flexbox-item',{staticStyle:{"flex":".33"}},[_c('group',[_c('selector',{attrs:{"placeholder":"全部表格","options":_vm.form_type_options},on:{"on-change":_vm.formChange},model:{value:(_vm.form_type),callback:function ($$v) {_vm.form_type=$$v},expression:"form_type"}})],1)],1),_vm._v(" "),_c('flexbox-item',{staticStyle:{"margin-left":"0px"}},[_c('x-button',{staticStyle:{"margin-top":"18px","margin-left":"20px"},attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.searchBtn.apply(null, arguments)}}},[_vm._v("搜索")]),_vm._v(" "),_c('x-button',{staticStyle:{"margin-top":"18px"},attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.clearBtn.apply(null, arguments)}}},[_vm._v("清空筛选")])],1)],1),_vm._v(" "),_c('div',{staticClass:"sheng-table vux-1px"},[_vm._m(0),_vm._v(" "),_c('scroller',{ref:"scrollerBottom",staticClass:"tbody",attrs:{"use-pullup":"","pullup-config":_vm.pullupDefaultConfig,"use-pulldown":"","pulldown-config":_vm.pulldownDefaultConfig,"lock-x":"","height":"-240"},on:{"on-pullup-loading":_vm.loadMore,"on-pulldown-loading":_vm.refresh}},[_c('div',_vm._l((_vm.listData),function(item,index){return _c('li',{key:index,staticClass:"vux-1px-b"},[_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v(_vm._s(item.date))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v(_vm._s(item.form_type))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v(_vm._s(item.shifts))]),_vm._v(" "),_c('div',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v(_vm._s(item.agent_name))]),_vm._v(" "),_c('div',{staticStyle:{"width":"20%"}},[_c('x-button',{attrs:{"gradients":['#2d8cf0','#2d8cf0'],"mini":""},nativeOn:{"click":function($event){return _vm.editFormDetailList(item.answer_id,item.form_id)}}},[_vm._v("查看")])],1)])}),0)])],1)],1)],1)}
var new_check_room_record_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"thead"},[_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"10%"}},[_vm._v("序号")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v("日期")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"20%"}},[_vm._v("所用表格")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v("班次")]),_vm._v(" "),_c('li',{staticClass:"vux-1px-r",staticStyle:{"width":"15%"}},[_vm._v("查房/填写人")]),_vm._v(" "),_c('li',{staticStyle:{"width":"20%"}},[_vm._v("操作")])])}]
var new_check_room_record_esExports = { render: new_check_room_record_render, staticRenderFns: new_check_room_record_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_new_check_room_record = (new_check_room_record_esExports);
// CONCATENATED MODULE: ./src/components/new_check_room_record.vue
function new_check_room_record_injectStyle (ssrContext) {
  __webpack_require__("tTNl")
}
var new_check_room_record_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var new_check_room_record___vue_template_functional__ = false
/* styles */
var new_check_room_record___vue_styles__ = new_check_room_record_injectStyle
/* scopeId */
var new_check_room_record___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var new_check_room_record___vue_module_identifier__ = null
var new_check_room_record_Component = new_check_room_record_normalizeComponent(
  components_new_check_room_record,
  selectortype_template_index_0_src_components_new_check_room_record,
  new_check_room_record___vue_template_functional__,
  new_check_room_record___vue_styles__,
  new_check_room_record___vue_scopeId__,
  new_check_room_record___vue_module_identifier__
)

/* harmony default export */ var src_components_new_check_room_record = (new_check_room_record_Component.exports);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/router/index.js



































// 旧的 VUX 版本 - 已迁移到 Vant



// 新的 Vant 版本





























































vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
var router_router = new vue_router_esm["a" /* default */]({
    routes: [{
        path: '/',
        component: src_components_login //login
    }, {
        path: '/month_live',
        component: src_components_month_live
    }, {
        path: '/designForm',
        component: src_components_design_form
    }, {
        path: '/sy_header',
        component: design_components_control_sy_header
    }, {
        path: '/form_add',
        component: src_components_design_form_add
    }, {
        path: '/form1',
        component: src_components_design_form
    }, {
        path: '/form',
        component: src_components_design_form_design
    }, {
        path: '/sy_cover',
        component: design_components_control_sy_cover
    }, {
        path: '/pathsy_description_text',
        component: design_components_control_sy_description_text
    }, {
        path: '/sy_address',
        component: design_components_control_sy_address
    }, {
        path: '/sy_check',
        component: design_components_control_sy_check
    }, {
        path: '/sy_date',
        component: design_components_control_sy_date
    }, {
        path: '/sy_fileupload',
        component: design_components_control_sy_fileupload
    }, {
        path: '/sy_input',
        component: design_components_control_sy_input
    }, {
        path: '/sy_rater',
        component: design_components_control_sy_rater
    }, {
        path: '/sy_mobile',
        component: design_components_control_sy_mobile
    }, {
        path: '/sy_number',
        component: design_components_control_sy_number
    }, {
        path: '/sy_picker',
        component: design_components_control_sy_picker
    }, {
        path: '/sy_range',
        component: design_components_control_sy_range
    }, {
        path: '/sy_select_text',
        component: design_components_control_sy_select_text
    }, {
        path: '/sy_sign',
        component: design_components_control_sy_sign
    }, {
        path: '/sy_switch',
        component: design_components_control_sy_switch
    }, {
        path: '/sy_text',
        component: design_components_control_sy_text
    }, {
        path: '/sy_address_attr',
        component: design_components_control_attribute_sy_address_attr
    }, {
        path: '/success',
        component: src_components_success
    }, {
        path: '/maternal_file',
        component: src_components_maternal_file
    }, {
        path: '/maternal_service',
        component: src_components_maternal_service
    }, {
        // 旧的 VUX 版本路由 - 已迁移到 Vant
        // {
        //     path: '/maternal_special',
        //     component: maternalSpecial
        // }
        // 新的 Vant 版本路由
        path: '/maternal_special',
        component: src_components_maternal_special
    }, {
        path: '/maternal_special_vant',
        component: src_componentsVant_ssReport_maternal_special
    }, {
        path: '/maternal_special_room',
        component: src_components_maternal_special_room
    }, {
        path: '/maternal_special_meal',
        component: src_components_maternal_special_meal
    }, {
        path: '/maternal_special_room_vant',
        component: src_componentsVant_ssReport_maternal_special_room
    }, {
        path: '/maternal_special_meal_vant',
        component: src_componentsVant_ssReport_maternal_special_meal
    }, {
        path: '/batch_service',
        component: src_components_batch_service
    }, {
        path: '/batch_record',
        component: src_components_batch_record
    }, {
        path: '/batch_record_detail',
        component: src_components_batch_record_detail
    }, {
        path: '/batch_success',
        component: src_components_batch_success
    }, {
        path: '/batch_table',
        component: src_components_batch_table
    }, {
        path: '/maternal_info_detail',
        component: src_components_maternal_info_detail
    }, {
        path: '/check_room_service',
        component: src_components_check_room_service
    }, {
        path: '/check_room_record',
        component: src_components_check_room_record
    }, {
        path: '/add_from_record',
        component: src_components_add_from_record
    }, {
        path: '/detail_other_form',
        component: src_components_detail_other_form
    }, {
        path: '/base_info_header',
        component: src_components_base_info_header
    }, {
        path: '/baby_live',
        component: src_components_baby_live
    }, {
        path: '/baby_medication_list',
        component: src_components_baby_medication_list
    }, {
        path: '/baby_sign_list',
        component: src_components_baby_sign_list
    }, {
        path: '/baby_breast_milk_list',
        component: src_components_baby_breast_milk_list
    }, {
        path: '/baby_feed_list',
        component: src_components_baby_feed_list
    }, {
        path: '/other_form_list',
        component: src_components_other_form_list
    }, {
        path: '/other_form_detail',
        component: src_components_other_form_detail
    }, {
        path: '/leave_custom_list',
        component: src_components_leave_custom_list
    }, {
        path: '/maternal_form_list',
        component: src_components_maternal_form_list
    }, {
        path: '/maternal_form_a',
        component: src_components_maternal_form_a
    }, {
        path: '/maternal_form_a_detail',
        component: src_components_maternal_form_a_detail
    }, {
        path: '/maternal_form_a_edit',
        component: src_components_maternal_form_a_edit
    }, {
        path: '/maternal_form_b',
        component: src_components_maternal_form_b
    }, {
        path: '/maternal_form_c',
        component: src_components_maternal_form_c
    }, {
        path: '/maternal_form_d',
        component: src_components_maternal_form_d
    }, {
        path: '/bb_form',
        component: src_components_bb_form
    }, {
        path: '/bb_form_a',
        component: src_components_bb_form_a
    }, {
        path: '/bb_form_b',
        component: src_components_bb_form_b
    }, {
        path: '/bb_form_c',
        component: src_components_bb_form_c
    }, {
        path: '/bb_form_d',
        component: src_components_bb_form_d
    }, {
        path: '/bb_form_d_detail',
        component: src_components_bb_form_d_detail
    }, {
        path: '/bb_form_d_edit',
        component: src_components_bb_form_d_edit
    }, {
        path: '/bb_form_e',
        component: src_components_bb_form_e
    }, {
        path: '/bb_form_e_detail',
        component: src_components_bb_form_e_detail
    }, {
        path: '/bb_form_e_edit',
        component: src_components_bb_form_e_edit
    }, {
        path: '/bb_form_f',
        component: src_components_bb_form_f
    }, {
        path: '/bb_form_f',
        component: src_components_bb_form_f
    }, {
        path: '/bb_form_f',
        component: src_components_bb_form_f
    }, {
        path: '/bb_form_f',
        component: src_components_bb_form_f
    }, {
        path: '/christmas_form_one',
        component: src_components_christmas_form_one
    }, {
        path: '/christmas_form_two',
        component: src_components_christmas_form_two
    }, {
        path: '/christmas_form_three',
        component: src_components_christmas_form_three
    }, {
        path: '/christmas_form_four',
        component: src_components_christmas_form_four
    }, {
        path: '/christmas_form_five',
        component: src_components_christmas_form_five
    }, {
        path: '/christmas_form_six',
        component: src_components_christmas_form_six
    }, {
        path: '/christmas_form_six_detail',
        component: src_components_christmas_form_six_detail
    }, {
        path: '/christmas_form_six_edit',
        component: src_components_christmas_form_six_edit
    }, {
        path: '/christmas_form_seven',
        component: src_components_christmas_form_seven
    }, {
        path: '/christmas_form_seven_detail',
        component: src_components_christmas_form_seven_detail
    }, {
        path: '/christmas_form_seven_edit',
        component: src_components_christmas_form_seven_edit
    }, {
        path: '/christmas_form_eight',
        component: src_components_christmas_form_eight
    }, {
        path: '/christmas_form_eight_detail',
        component: src_components_christmas_form_eight_detail
    }, {
        path: '/christmas_form_eight_edit',
        component: src_components_christmas_form_eight_edit
    }, {
        path: '/medicine_commissioned',
        component: src_components_medicine_commissioned
    }, {
        path: '/basic_nursing',
        component: src_components_basic_nursing
    }, {
        path: '/new_check_room_record',
        component: src_components_new_check_room_record
    }]
});

router_router.beforeEach(function (to, from, next) {
    var param = {
        token: js_cookie_default.a.get('token')
    };
    var parseData = stringify_default()(param);
    var formData = new FormData();
    formData.append("data", encodeURI(base64["Base64"].encode(parseData)));
    plugin_axios.post(window.host.checkLoginUrl, formData).then(function (response) {
        var data = base64["Base64"].decode(response.data);
        var jsonData = JSON.parse(data);
        console.log(jsonData);
        if (jsonData.errcode !== 1) {
            js_cookie_default.a.set('token', '');
            js_cookie_default.a.set('id', '');
            if (to.fullPath !== '/') {
                next({ path: '/', replace: true });
            }
            next();
        } else {
            next();
        }
    }).catch(function (error) {
        next();
    });
});
/* harmony default export */ var src_router = (router_router);
// EXTERNAL MODULE: ./node_modules/vue-cookie/src/vue-cookie.js
var vue_cookie = __webpack_require__("K/Lq");
var vue_cookie_default = /*#__PURE__*/__webpack_require__.n(vue_cookie);

// CONCATENATED MODULE: ./src/store/utils.js






/**
 * Vuex Store 通用工具函数
 * 参考 aegismaternity 项目的 Redux 规划模式，适配 Vuex
 */

/**
 * 创建服务类型映射函数（参考 switchPayload 模式）
 * @param {Object} serviceMap - 服务类型到 API 方法的映射
 * @returns {Function} 返回服务类型映射函数
 */
function createServiceSwitch(serviceMap) {
  return function (serviceType, query) {
    var service = serviceMap[serviceType] || serviceMap.default || serviceMap.undefined;
    if (typeof service === 'function') {
      return service(query);
    }
    console.error('Redux: \u8BF7\u6C42\u672A\u5B9A\u4E49 serviceType \u7C7B\u578B: ' + serviceType);
    return promise_default.a.reject(new Error('\u672A\u5B9A\u4E49\u7684\u670D\u52A1\u7C7B\u578B: ' + serviceType));
  };
}

/**
 * 创建通用的异步 Action（参考 createAsyncThunk 模式）
 * @param {Function|Object} apiMethodOrSwitch - API 方法或服务映射对象
 * @param {String} mutationType - Mutation 类型
 * @param {Function} transformData - 数据转换函数（可选）
 * @param {Object} options - 配置选项
 * @returns {Function} Action 函数
 */
function createAsyncAction(apiMethodOrSwitch, mutationType) {
  var _this = this;

  var transformData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$pendingMutat = options.pendingMutation,
      pendingMutation = _options$pendingMutat === undefined ? null : _options$pendingMutat,
      _options$errorMutatio = options.errorMutation,
      errorMutation = _options$errorMutatio === undefined ? null : _options$errorMutatio,
      _options$serviceType = options.serviceType,
      serviceType = _options$serviceType === undefined ? null : _options$serviceType;


  return function () {
    var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var apiMethod, switchFn, _serviceType, res, data, error, errorMsg;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              // 支持服务类型切换
              apiMethod = void 0;

              if (!(typeof apiMethodOrSwitch === 'function')) {
                _context.next = 6;
                break;
              }

              apiMethod = apiMethodOrSwitch;
              _context.next = 13;
              break;

            case 6:
              if (!((typeof apiMethodOrSwitch === 'undefined' ? 'undefined' : typeof_default()(apiMethodOrSwitch)) === 'object')) {
                _context.next = 12;
                break;
              }

              switchFn = createServiceSwitch(apiMethodOrSwitch);
              _serviceType = params.serviceType || 'default';

              apiMethod = switchFn(_serviceType, params.query || params);
              _context.next = 13;
              break;

            case 12:
              throw new Error('apiMethodOrSwitch 必须是函数或对象');

            case 13:

              // 触发 pending 状态
              if (pendingMutation) {
                commit(pendingMutation, { serviceType: params.serviceType, query: params.query });
              }

              // 调用 API
              _context.next = 16;
              return apiMethod(params.query || params);

            case 16:
              res = _context.sent;

              if (!(res.errcode === 1)) {
                _context.next = 23;
                break;
              }

              data = transformData ? transformData(res.data, params) : res.data;

              commit(mutationType, extends_default()({
                data: data,
                serviceType: params.serviceType,
                query: params.query || params
              }, params));
              return _context.abrupt('return', { success: true, data: res.data, errcode: 1 });

            case 23:
              error = res.errinfo || '操作失败';

              if (errorMutation) {
                commit(errorMutation, { error: error, serviceType: params.serviceType });
              }
              return _context.abrupt('return', { success: false, message: error, errcode: res.errcode });

            case 26:
              _context.next = 34;
              break;

            case 28:
              _context.prev = 28;
              _context.t0 = _context['catch'](0);

              console.error('[Async Action Error]:', _context.t0);
              errorMsg = _context.t0.message || '网络错误，请重试';

              if (errorMutation) {
                commit(errorMutation, { error: errorMsg, serviceType: params.serviceType });
              }
              return _context.abrupt('return', { success: false, message: errorMsg, error: _context.t0 });

            case 34:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 28]]);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();
}

/**
 * 创建数据格式化函数（参考 formatData 模式）
 * @param {Object} config - 配置对象
 * @param {Array} config.keyConfig - 字段映射配置
 * @param {Object} config.defaultKey - 默认字段映射
 * @param {Function} config.processor - 数据处理函数
 * @returns {Function} 数据格式化函数
 */
function createDataFormatter(_ref3) {
  var _ref3$keyConfig = _ref3.keyConfig,
      keyConfig = _ref3$keyConfig === undefined ? [] : _ref3$keyConfig,
      _ref3$defaultKey = _ref3.defaultKey,
      defaultKey = _ref3$defaultKey === undefined ? {} : _ref3$defaultKey,
      _ref3$processor = _ref3.processor,
      processor = _ref3$processor === undefined ? null : _ref3$processor;

  return function (_ref4) {
    var data = _ref4.data,
        _ref4$serviceType = _ref4.serviceType,
        serviceType = _ref4$serviceType === undefined ? 'default' : _ref4$serviceType,
        _ref4$dataType = _ref4.dataType,
        dataType = _ref4$dataType === undefined ? 'default' : _ref4$dataType,
        _ref4$query = _ref4.query,
        query = _ref4$query === undefined ? {} : _ref4$query;

    if (!Array.isArray(data) && (typeof data === 'undefined' ? 'undefined' : typeof_default()(data)) !== 'object') {
      return data;
    }

    // 获取字段映射
    var fieldMap = keyConfig.find(function (kc) {
      return kc.key === serviceType;
    }) || defaultKey;

    // 如果提供了自定义处理器
    if (processor) {
      return processor({ data: data, serviceType: serviceType, dataType: dataType, query: query, fieldMap: fieldMap });
    }

    // 默认处理：直接返回数据
    return data;
  };
}

/**
 * 创建通用的列表 Action（带加载状态和错误处理）
 * @param {Function|Object} apiMethodOrSwitch - API 方法或服务映射
 * @param {String} setListMutation - 设置列表的 mutation
 * @param {Object} options - 配置选项
 * @returns {Function} Action 函数
 */
function createListAction(apiMethodOrSwitch, setListMutation) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$pendingMutat2 = options.pendingMutation,
      pendingMutation = _options$pendingMutat2 === undefined ? 'SET_LOADING' : _options$pendingMutat2,
      _options$errorMutatio2 = options.errorMutation,
      errorMutation = _options$errorMutatio2 === undefined ? 'SET_ERROR' : _options$errorMutatio2,
      _options$transformDat = options.transformData,
      transformData = _options$transformDat === undefined ? null : _options$transformDat;


  return createAsyncAction(apiMethodOrSwitch, setListMutation, transformData, {
    pendingMutation: pendingMutation,
    errorMutation: errorMutation
  });
}

/**
 * 创建通用的提交 Action
 * @param {Function} apiMethod - API 方法
 * @param {String} successMessage - 成功提示信息
 * @param {Function} onSuccess - 成功回调（可选）
 * @returns {Function} Action 函数
 */
function createSubmitAction(apiMethod) {
  var _this2 = this;

  var successMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '操作成功';
  var onSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return function () {
    var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(_ref6, params) {
      var commit = _ref6.commit;
      var res;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return apiMethod(params);

            case 3:
              res = _context2.sent;

              if (!(res.errcode === 1)) {
                _context2.next = 9;
                break;
              }

              if (onSuccess) {
                onSuccess({ commit: commit }, res.data);
              }
              return _context2.abrupt('return', { success: true, data: res.data, message: successMessage, errcode: 1 });

            case 9:
              return _context2.abrupt('return', { success: false, message: res.errinfo || '操作失败', errcode: res.errcode });

            case 10:
              _context2.next = 16;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](0);

              console.error('[Submit Action Error]:', _context2.t0);
              return _context2.abrupt('return', { success: false, message: _context2.t0.message || '网络错误，请重试', error: _context2.t0 });

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 12]]);
    }));

    return function (_x8, _x9) {
      return _ref5.apply(this, arguments);
    };
  }();
}

/**
 * 从 Cookie 恢复数据到 Store
 * @param {Object} store - Vuex store 实例
 * @param {Object} cookieMap - Cookie 键名到 state 键名的映射
 * @param {Object} cookies - Cookie 对象
 */
function restoreFromCookie(store, options, cookieMap, cookies) {
  var _ref7 = options || {},
      _ref7$module = _ref7.module,
      module = _ref7$module === undefined ? null : _ref7$module,
      _ref7$mutation = _ref7.mutation,
      mutation = _ref7$mutation === undefined ? null : _ref7$mutation;

  var payload = {};
  keys_default()(cookieMap).forEach(function (cookieKey) {
    var stateKey = cookieMap[cookieKey];
    var value = cookies.get(cookieKey);
    if (value) {
      payload[stateKey] = value;
    }
  });

  if (keys_default()(payload).length > 0) {
    // 必须显式传入 mutation，避免与具体业务（如登录）强绑定
    if (!mutation) {
      console.error('[restoreFromCookie] mutation 未指定，已跳过提交。');
      return;
    }
    var type = module ? module + '/' + mutation : mutation;
    store.commit(type, payload);
  }
}

/**
 * 同步 Store 数据到 Cookie
 * @param {Object} store - Vuex store 实例
 * @param {Object} cookieMap - state 键名到 Cookie 键名的映射
 * @param {Object} cookies - Cookie 对象
 */
function syncToCookie(store, cookieMap, cookies) {
  var state = store.state;
  keys_default()(cookieMap).forEach(function (stateKey) {
    var cookieKey = cookieMap[stateKey];
    var value = state[stateKey];
    if (value !== undefined && value !== null && value !== '') {
      cookies.set(cookieKey, value);
    }
  });
}
// CONCATENATED MODULE: ./src/store/common/app.js

/**
 * App 模块 - 应用全局状态
 * 参考 aegismaternity 项目的 appSlice.js
 */



// 初始状态
var initialState = {
  fetching: false,
  error: null,
  user: {
    id: '',
    token: '',
    store_id: '',
    department_id: '',
    department_name: '',
    username: '',
    user_name: ''
  }

  // Mutations
};var mutations = {
  SET_FETCHING: function SET_FETCHING(state, fetching) {
    state.fetching = fetching;
  },
  SET_ERROR: function SET_ERROR(state, error) {
    state.error = error;
  },
  SET_USER_INFO: function SET_USER_INFO(state, userInfo) {
    state.user = extends_default()({}, state.user, userInfo.data);
  }
};

// Actions
var actions = {
  // 登录
  login: createAsyncAction(repository.loginApi.login, 'SET_USER_INFO', function (data) {
    return extends_default()({}, data);
  }, {
    pendingMutation: 'SET_FETCHING',
    errorMutation: 'SET_ERROR'
  })

  // Getters
};var getters = {
  // 一次性返回完整 user 对象，组件里直接用 this.$store.getters['app/userInfo'] 即可
  userInfo: function userInfo(state) {
    return state.user;
  },
  isLoggedIn: function isLoggedIn(state) {
    return !!state.user.token;
  },
  fetching: function fetching(state) {
    return state.fetching;
  },
  error: function error(state) {
    return state.error;
  }
};

/* harmony default export */ var app = ({
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters
});
// CONCATENATED MODULE: ./src/store/common/userInfo.js

/**
 * 用户信息相关通用方法
 * 可以通过 @common/userInfo 引用
 */


/**
 * 生成「获取用户信息」的完整 URL
 * @param {Object} params - 参数对象（如 { id, token, store_id }）
 * @returns {string} 完整的请求 URL
 */
function getUserInfoUrl() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var base = api_const["getUserInfoUrl"] || '';

  var keys = keys_default()(params).filter(function (k) {
    var v = params[k];
    return v !== undefined && v !== null && v !== '';
  });

  if (!keys.length) {
    return base;
  }

  var hasQuery = base.indexOf('?') !== -1;
  var sep = hasQuery ? '&' : '?';
  var query = keys.map(function (k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
  }).join('&');

  return '' + base + sep + query;
}

/* harmony default export */ var common_userInfo = ({
  getUserInfoUrl: getUserInfoUrl
});
// CONCATENATED MODULE: ./src/store/index.js
/**
 * Vuex Store 主入口
 * 参考 aegismaternity 项目的 store.js 组织方式
 */





// 使用 Vuex
vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/**
 * 创建 store 实例
 * 使用模块化组织，参考 aegismaternity 的 combineReducers 方式
 */
var store_store = new vuex_esm["a" /* default */].Store({
  // Vuex 模块统一在 modules 下挂载
  modules: {
    app: app
  },
  // 严格模式：在开发环境下，如果 state 被 mutation 之外的方式修改，会抛出错误
  strict: "production" !== 'production'
});

// 挂载非 Vuex 的工具方法模块（如用户信息相关方法）
// 使用方式：this.$store.$userInfo.getUserInfoUrl(id)
store_store.$userInfo = common_userInfo;

/* harmony default export */ var src_store = (store_store);
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./src/libs/util.js
var util = {};

var dataURItoBlob = function dataURItoBlob(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
};

var convertImgToDataURLviaCanvas = function convertImgToDataURLviaCanvas(url, callback, outputFormat) {
    var img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
        var canvas = document.createElement('CANVAS');
        var ctx = canvas.getContext('2d');
        var dataURL;
        canvas.height = this.height;
        canvas.width = this.width;
        ctx.drawImage(this, 0, 0);
        dataURL = canvas.toDataURL(outputFormat);
        callback(dataURL);
        canvas = null;
    };
    img.src = url;
};

var convertFileToDataURLviaFileReader = function convertFileToDataURLviaFileReader(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.send();
};

util.dataURItoBlob = dataURItoBlob;
util.convertImgToDataURLviaCanvas = convertImgToDataURLviaCanvas;
util.convertFileToDataURLviaFileReader = convertFileToDataURLviaFileReader;
/* harmony default export */ var libs_util = (util);
// EXTERNAL MODULE: ./node_modules/vue-signature/src/main.js
var main = __webpack_require__("lxyI");

// CONCATENATED MODULE: ./src/libs/py.js

var PinYin = {
    "a": "\u554A\u963F\u9515",
    "ai": "\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u8BF6\u6371\u55F3\u55CC\u5AD2\u7477\u66A7\u7839\u953F\u972D",
    "an": "\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u8C19\u57EF\u63DE\u72B4\u5EB5\u6849\u94F5\u9E4C\u9878\u9EEF",
    "ang": "\u80AE\u6602\u76CE",
    "ao": "\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u5773\u62D7\u55F7\u5662\u5C99\u5ED2\u9068\u5AAA\u9A9C\u8071\u87AF\u93CA\u9CCC\u93D6",
    "ba": "\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u8307\u83DD\u8406\u636D\u5C9C\u705E\u6777\u94AF\u7C91\u9C85\u9B43",
    "bai": "\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u859C\u63B0\u97B4",
    "ban": "\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u962A\u5742\u8C73\u94A3\u7622\u764D\u8228",
    "bang": "\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u84A1\u8783",
    "bao": "\u82DE\u80DE\u5305\u8912\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u52F9\u8446\u5B80\u5B62\u7172\u9E28\u8913\u8DB5\u9F85",
    "bo": "\u5265\u8584\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u4EB3\u8543\u5575\u997D\u6A97\u64D8\u7934\u94B9\u9E41\u7C38\u8DDB",
    "bei": "\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5B5B\u9642\u90B6\u57E4\u84D3\u5457\u602B\u6096\u789A\u9E4E\u8919\u943E",
    "ben": "\u5954\u82EF\u672C\u7B28\u755A\u574C\u951B",
    "beng": "\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u552A\u5623\u750F",
    "bi": "\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u5315\u4EF3\u4FFE\u8298\u835C\u8378\u5421\u54D4\u72F4\u5EB3\u610E\u6ED7\u6FDE\u5F3C\u59A3\u5A62\u5B16\u74A7\u8D32\u7540\u94CB\u79D5\u88E8\u7B5A\u7B85\u7BE6\u822D\u895E\u8DF8\u9AC0",
    "bian": "\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u533E\u5F01\u82C4\u5FED\u6C74\u7F0F\u7178\u782D\u78A5\u7A39\u7A86\u8759\u7B3E\u9CCA",
    "biao": "\u6807\u5F6A\u8198\u8868\u5A4A\u9AA0\u98D1\u98D9\u98DA\u706C\u9556\u9573\u762D\u88F1\u9CD4",
    "bie": "\u9CD6\u618B\u522B\u762A\u8E69\u9CD8",
    "bin": "\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u50A7\u6D5C\u7F24\u73A2\u6BA1\u8191\u9554\u9ACC\u9B13",
    "bing": "\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3\u75C5\u5E76\u7980\u90B4\u6452\u7EE0\u678B\u69DF\u71F9",
    "bu": "\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u62CA\u535F\u900B\u74FF\u6661\u949A\u91AD",
    "ca": "\u64E6\u5693\u7924",
    "cai": "\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521",
    "can": "\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u9A96\u74A8\u7CB2\u9EEA",
    "cang": "\u82CD\u8231\u4ED3\u6CA7\u85CF\u4F27",
    "cao": "\u64CD\u7CD9\u69FD\u66F9\u8349\u8279\u5608\u6F15\u87AC\u825A",
    "ce": "\u5395\u7B56\u4FA7\u518C\u6D4B\u5202\u5E3B\u607B",
    "ceng": "\u5C42\u8E6D\u564C",
    "cha": "\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u7339\u9987\u6C4A\u59F9\u6748\u6942\u69CE\u6AAB\u9497\u9538\u9572\u8869",
    "chai": "\u62C6\u67F4\u8C7A\u4FAA\u8308\u7625\u867F\u9F87",
    "chan": "\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u5181\u8C04\u8C36\u8487\u5EDB\u5FCF\u6F7A\u6FB6\u5B71\u7FBC\u5A75\u5B17\u9AA3\u89C7\u7985\u9561\u88E3\u87FE\u8E94",
    "chang": "\u660C\u7316\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u4F25\u9B2F\u82CC\u83D6\u5F9C\u6005\u60DD\u960A\u5A3C\u5AE6\u6636\u6C05\u9CB3",
    "chao": "\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u600A\u7EC9\u6641\u8016",
    "che": "\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u577C\u5C6E\u7817",
    "chen": "\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u79F0\u8C0C\u62BB\u55D4\u5BB8\u741B\u6987\u809C\u80C2\u789C\u9F80",
    "cheng": "\u6491\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u57D5\u5D4A\u5FB5\u6D48\u67A8\u67FD\u6A18\u665F\u584D\u77A0\u94D6\u88CE\u86CF\u9172",
    "chi": "\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u50BA\u5880\u82AA\u830C\u640B\u53F1\u54E7\u557B\u55E4\u5F73\u996C\u6CB2\u5AB8\u6555\u80DD\u7719\u7735\u9E31\u761B\u892B\u86A9\u87AD\u7B1E\u7BEA\u8C49\u8E05\u8E1F\u9B51",
    "chong": "\u5145\u51B2\u866B\u5D07\u5BA0\u833A\u5FE1\u61A7\u94F3\u825F",
    "chou": "\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u4FE6\u5733\u5E31\u60C6\u6EB4\u59AF\u7633\u96E0\u9C8B",
    "chu": "\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A\u7840\u50A8\u77D7\u6410\u89E6\u5904\u4E8D\u520D\u61B7\u7ECC\u6775\u696E\u6A17\u870D\u8E70\u9EDC",
    "chuan": "\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u63BE\u821B\u60F4\u9044\u5DDB\u6C1A\u948F\u9569\u8221",
    "chuang": "\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u6006",
    "chui": "\u5439\u708A\u6376\u9524\u5782\u9672\u68F0\u69CC",
    "chun": "\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u4FC3\u83BC\u6C8C\u80AB\u6710\u9E51\u877D",
    "chuo": "\u6233\u7EF0\u851F\u8FB6\u8F8D\u955E\u8E14\u9F8A",
    "ci": "\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u8360\u5472\u5D6F\u9E5A\u8785\u7CCD\u8D91",
    "cong": "\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u506C\u82C1\u6DD9\u9AA2\u742E\u7481\u679E",
    "cu": "\u51D1\u7C97\u918B\u7C07\u731D\u6B82\u8E59",
    "cuan": "\u8E7F\u7BE1\u7A9C\u6C46\u64BA\u6615\u7228",
    "cui": "\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u8403\u60B4\u7480\u69B1\u96B9",
    "cun": "\u6751\u5B58\u5BF8\u78CB\u5FD6\u76B4",
    "cuo": "\u64AE\u6413\u63AA\u632B\u9519\u539D\u811E\u9509\u77EC\u75E4\u9E7E\u8E49\u8E9C",
    "da": "\u642D\u8FBE\u7B54\u7629\u6253\u5927\u8037\u54D2\u55D2\u601B\u59B2\u75B8\u8921\u7B2A\u977C\u9791",
    "dai": "\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E\u6020\u57ED\u7519\u5454\u5CB1\u8FE8\u902F\u9A80\u7ED0\u73B3\u9EDB",
    "dan": "\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u4EBB\u510B\u5369\u840F\u5556\u6FB9\u6A90\u6B9A\u8D55\u7708\u7605\u8043\u7BAA",
    "dang": "\u5F53\u6321\u515A\u8361\u6863\u8C20\u51FC\u83EA\u5B95\u7800\u94DB\u88C6",
    "dao": "\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u53E8\u5541\u5FC9\u6D2E\u6C18\u7118\u5FD1\u7E9B",
    "de": "\u5FB7\u5F97\u7684\u951D",
    "deng": "\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5654\u5D9D\u6225\u78F4\u956B\u7C26",
    "di": "\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u6C10\u7C74\u8BCB\u8C1B\u90B8\u577B\u839C\u837B\u5600\u5A23\u67E2\u68E3\u89CC\u7825\u78B2\u7747\u955D\u7F9D\u9AB6",
    "dian": "\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u4E36\u963D\u576B\u57DD\u5DC5\u73B7\u765C\u766B\u7C1F\u8E2E",
    "diao": "\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8F7A\u94DE\u8729\u7C9C\u8C82",
    "die": "\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0\u4F5A\u57A4\u581E\u63F2\u558B\u6E2B\u8F76\u7252\u74DE\u8936\u800B\u8E40\u9CBD\u9CCE",
    "ding": "\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4EC3\u5576\u738E\u815A\u7887\u753A\u94E4\u7594\u8035\u914A",
    "dong": "\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u578C\u549A\u5CBD\u5CD2\u5902\u6C21\u80E8\u80F4\u7850\u9E2B",
    "dou": "\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u8538\u94AD\u7AA6\u7AAC\u86AA\u7BFC\u9161",
    "du": "\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u828F\u561F\u6E0E\u691F\u6A50\u724D\u8839\u7B03\u9AD1\u9EE9",
    "duan": "\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5F56\u6934\u7145\u7C16",
    "dui": "\u5806\u5151\u961F\u5BF9\u603C\u619D\u7893",
    "dun": "\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u7096\u7818\u7905\u76F9\u9566\u8DB8",
    "duo": "\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u5484\u54DA\u7F0D\u67C1\u94CE\u88F0\u8E31",
    "e": "\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u5669\u8C14\u57A9\u57AD\u82CA\u83AA\u843C\u5443\u6115\u5C59\u5A40\u8F6D\u66F7\u816D\u786A\u9507\u9537\u9E57\u989A\u9CC4",
    "en": "\u6069\u84BD\u6441\u5514\u55EF",
    "er": "\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C\u8D30\u8FE9\u73E5\u94D2\u9E38\u9C95",
    "fa": "\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u57A1\u781D",
    "fan": "\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u8629\u5E61\u72AD\u68B5\u6535\u71D4\u7548\u8E6F",
    "fang": "\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u531A\u90A1\u5F77\u94AB\u822B\u9C82",
    "fei": "\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82BE\u72D2\u60B1\u6DDD\u5983\u7ECB\u7EEF\u69A7\u8153\u6590\u6249\u7953\u7829\u9544\u75F1\u871A\u7BDA\u7FE1\u970F\u9CB1",
    "fen": "\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u507E\u7035\u68FC\u610D\u9CBC\u9F22",
    "feng": "\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4FF8\u9146\u8451\u6CA3\u781C",
    "fu": "\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5310\u51EB\u90DB\u8299\u82FB\u832F\u83A9\u83D4\u544B\u5E5E\u6ECF\u8274\u5B5A\u9A78\u7EC2\u6874\u8D59\u9EFB\u9EFC\u7F58\u7A03\u99A5\u864D\u86A8\u8709\u8760\u876E\u9EB8\u8DBA\u8DD7\u9CC6",
    "ga": "\u5676\u560E\u86E4\u5C2C\u5477\u5C15\u5C1C\u65EE\u9486",
    "gai": "\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u4E10\u9654\u5793\u6224\u8D45\u80F2",
    "gan": "\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5769\u82F7\u5C34\u64C0\u6CD4\u6DE6\u6F89\u7EC0\u6A44\u65F0\u77F8\u75B3\u9150",
    "gang": "\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6206\u7F61\u9883\u7B7B",
    "gong": "\u6760\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u857B\u5EFE\u54A3\u73D9\u80B1\u86A3\u86E9\u89E5",
    "gao": "\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u777E\u8BF0\u90DC\u84BF\u85C1\u7F1F\u69D4\u69C1\u6772\u9506",
    "ge": "\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u9601\u9694\u94EC\u4E2A\u5404\u9B32\u4EE1\u54FF\u5865\u55DD\u7EA5\u643F\u8188\u784C\u94EA\u9549\u88BC\u988C\u867C\u8238\u9ABC\u9AC2",
    "gei": "\u7ED9",
    "gen": "\u6839\u8DDF\u4E98\u831B\u54CF\u826E",
    "geng": "\u8015\u66F4\u5E9A\u7FB9\u57C2\u803F\u6897\u54FD\u8D53\u9CA0",
    "gou": "\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u4F5D\u8BDF\u5CA3\u9058\u5ABE\u7F11\u89CF\u5F40\u9E32\u7B31\u7BDD\u97B2",
    "gu": "\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u560F\u8BC2\u83F0\u54CC\u5D2E\u6C69\u688F\u8F71\u726F\u727F\u80CD\u81CC\u6BC2\u77BD\u7F5F\u94B4\u9522\u74E0\u9E2A\u9E44\u75FC\u86C4\u9164\u89DA\u9CB4\u9AB0\u9E58",
    "gua": "\u522E\u74DC\u5250\u5BE1\u6302\u8902\u5366\u8BD6\u5471\u681D\u9E39",
    "guai": "\u4E56\u62D0\u602A\u54D9",
    "guan": "\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u500C\u839E\u63BC\u6DAB\u76E5\u9E73\u9CCF",
    "guang": "\u5149\u5E7F\u901B\u72B7\u6844\u80F1\u7592",
    "gui": "\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u5326\u523F\u5E8B\u5B84\u59AB\u6867\u7085\u6677\u7688\u7C0B\u9C91\u9CDC",
    "gun": "\u8F8A\u6EDA\u68CD\u4E28\u886E\u7EF2\u78D9\u9CA7",
    "guo": "\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u9998\u8803\u57DA\u63B4\u5459\u56D7\u5E3C\u5D1E\u7313\u6901\u8662\u951E\u8052\u872E\u873E\u8748",
    "ha": "\u54C8",
    "hai": "\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u54B4\u55E8\u988F\u91A2",
    "han": "\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u9097\u83E1\u6496\u961A\u701A\u6657\u7113\u9894\u86B6\u9F3E",
    "hen": "\u592F\u75D5\u5F88\u72E0\u6068",
    "hang": "\u676D\u822A\u6C86\u7ED7\u73E9\u6841",
    "hao": "\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u8585\u55E5\u5686\u6FE0\u704F\u660A\u7693\u98A2\u869D",
    "he": "\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u8BC3\u52BE\u58D1\u85FF\u55D1\u55EC\u9616\u76CD\u86B5\u7FEE",
    "hei": "\u563F\u9ED1",
    "heng": "\u54FC\u4EA8\u6A2A\u8861\u6052\u8A07\u8605",
    "hong": "\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u9EC9\u8BA7\u836D\u85A8\u95F3\u6CD3",
    "hou": "\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u5820\u5F8C\u9005\u760A\u7BCC\u7CC7\u9C8E\u9ABA",
    "hu": "\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u51B1\u553F\u56EB\u5CB5\u7322\u6019\u60DA\u6D52\u6EF9\u7425\u69F2\u8F77\u89F3\u70C0\u7173\u623D\u6248\u795C\u9E55\u9E71\u7B0F\u9190\u659B",
    "hua": "\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u5290\u6D4D\u9A85\u6866\u94E7\u7A1E",
    "huai": "\u69D0\u5F8A\u6000\u6DEE\u574F\u8FD8\u8E1D",
    "huan": "\u6B22\u73AF\u6853\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u90C7\u5942\u57B8\u64D0\u571C\u6D39\u6D63\u6F36\u5BF0\u902D\u7F33\u953E\u9CA9\u9B1F",
    "huang": "\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u968D\u5FA8\u6E5F\u6F62\u9051\u749C\u8093\u7640\u87E5\u7BC1\u9CC7",
    "hui": "\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8BD9\u8334\u835F\u8559\u54D5\u5599\u96B3\u6D04\u5F57\u7F0B\u73F2\u6656\u605A\u867A\u87EA\u9EBE",
    "hun": "\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8BE8\u9984\u960D\u6EB7\u7F17",
    "huo": "\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u6509\u56AF\u5925\u94AC\u952A\u956C\u8020\u8816",
    "ji": "\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5C45\u4E0C\u4E69\u525E\u4F76\u4F74\u8114\u58BC\u82A8\u82B0\u8401\u84BA\u857A\u638E\u53FD\u54AD\u54DC\u5527\u5C8C\u5D74\u6D0E\u5F50\u5C50\u9AA5\u757F\u7391\u696B\u6B9B\u621F\u6222\u8D4D\u89CA\u7284\u9F51\u77F6\u7F81\u5D47\u7A37\u7620\u7635\u866E\u7B08\u7B04\u66A8\u8DFB\u8DFD\u9701\u9C9A\u9CAB\u9AFB\u9E82",
    "jia": "\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u4F3D\u90CF\u62EE\u5CAC\u6D43\u8FE6\u73C8\u621B\u80DB\u605D\u94D7\u9553\u75C2\u86F1\u7B33\u8888\u8DCF",
    "jian": "\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50ED\u8C0F\u8C2B\u83C5\u84B9\u641B\u56DD\u6E54\u8E47\u8B07\u7F23\u67A7\u67D9\u6957\u620B\u622C\u726E\u728D\u6BFD\u8171\u7751\u950F\u9E63\u88E5\u7B15\u7BB4\u7FE6\u8DBC\u8E3A\u9CA3\u97AF",
    "jiang": "\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8333\u6D1A\u7EDB\u7F30\u729F\u7913\u8029\u7CE8\u8C47",
    "jiao": "\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u4F7C\u50EC\u832D\u6322\u564D\u5CE4\u5FBC\u59E3\u7E9F\u656B\u768E\u9E6A\u86DF\u91AE\u8DE4\u9C9B",
    "jie": "\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5048\u8BA6\u8BD8\u5588\u55DF\u736C\u5A55\u5B51\u6840\u7352\u78A3\u9534\u7596\u88B7\u9889\u86A7\u7FAF\u9C92\u9AB1\u9AEB",
    "jin": "\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78\u5C3D\u537A\u8369\u5807\u5664\u9991\u5ED1\u5997\u7F19\u747E\u69FF\u8D46\u89D0\u9485\u9513\u887F\u77DC",
    "jing": "\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u522D\u5106\u9631\u83C1\u734D\u61AC\u6CFE\u8FF3\u5F2A\u5A67\u80BC\u80EB\u8148\u65CC",
    "jiong": "\u70AF\u7A98\u5182\u8FE5\u6243",
    "jiu": "\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u50E6\u557E\u9604\u67E9\u6855\u9E6B\u8D73\u9B0F",
    "ju": "\u97A0\u62D8\u72D9\u75BD\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u5028\u8BB5\u82E3\u82F4\u8392\u63AC\u907D\u5C66\u741A\u67B8\u6910\u6998\u6989\u6A58\u728B\u98D3\u949C\u9514\u7AAD\u88FE\u8D84\u91B5\u8E3D\u9F83\u96CE\u97AB",
    "juan": "\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u9104\u72F7\u6D93\u684A\u8832\u9529\u954C\u96BD",
    "jue": "\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u53A5\u5282\u8C32\u77CD\u8568\u5658\u5D1B\u7357\u5B53\u73CF\u6877\u6A5B\u721D\u9562\u8E76\u89D6",
    "jun": "\u5747\u83CC\u94A7\u519B\u541B\u5CFB\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u6343\u72FB\u76B2\u7B60\u9E87",
    "ka": "\u5580\u5496\u5361\u4F67\u5494\u80E9",
    "ke": "\u54AF\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u5CA2\u606A\u6E98\u9A92\u7F02\u73C2\u8F72\u6C2A\u778C\u94B6\u75B4\u7AA0\u874C\u9AC1",
    "kai": "\u5F00\u63E9\u6977\u51EF\u6168\u5240\u57B2\u8488\u5FFE\u607A\u94E0\u950E",
    "kan": "\u520A\u582A\u52D8\u574E\u780D\u770B\u4F83\u51F5\u83B0\u83B6\u6221\u9F9B\u77B0",
    "kang": "\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u5751\u4F09\u95F6\u94AA",
    "kao": "\u8003\u62F7\u70E4\u9760\u5C3B\u6832\u7292\u94D0",
    "ken": "\u80AF\u5543\u57A6\u6073\u57A0\u88C9\u9880",
    "keng": "\u542D\u5FD0\u94FF",
    "kong": "\u7A7A\u6050\u5B54\u63A7\u5025\u5D06\u7B9C",
    "kou": "\u62A0\u53E3\u6263\u5BC7\u82A4\u853B\u53E9\u770D\u7B58",
    "ku": "\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5233\u5800\u55BE\u7ED4\u9AB7",
    "kua": "\u5938\u57AE\u630E\u8DE8\u80EF\u4F89",
    "kuai": "\u5757\u7B77\u4FA9\u5FEB\u84AF\u90D0\u8489\u72EF\u810D",
    "kuan": "\u5BBD\u6B3E\u9ACB",
    "kuang": "\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u8BD3\u8BF3\u909D\u5739\u593C\u54D0\u7EA9\u8D36",
    "kui": "\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080\u9988\u6127\u6E83\u9997\u532E\u5914\u9697\u63C6\u55B9\u559F\u609D\u6126\u9615\u9035\u668C\u777D\u8069\u8770\u7BD1\u81FE\u8DEC",
    "kun": "\u5764\u6606\u6346\u56F0\u6083\u9603\u7428\u951F\u918C\u9CB2\u9AE1",
    "kuo": "\u62EC\u6269\u5ED3\u9614\u86DE",
    "la": "\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u524C\u647A\u908B\u65EF\u782C\u760C",
    "lai": "\u83B1\u6765\u8D56\u5D03\u5F95\u6D9E\u6FD1\u8D49\u7750\u94FC\u765E\u7C41",
    "lan": "\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u5549\u5C9A\u61D4\u6F24\u6984\u6593\u7F71\u9567\u8934",
    "lang": "\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u83A8\u8497\u5577\u9606\u9512\u7A02\u8782",
    "lao": "\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u5520\u5D02\u6833\u94D1\u94F9\u75E8\u91AA",
    "le": "\u52D2\u4E50\u808B\u4EC2\u53FB\u561E\u6CD0\u9CD3",
    "lei": "\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u7C7B\u6CEA\u7FB8\u8BD4\u837D\u54A7\u6F2F\u5AD8\u7F27\u6A91\u8012\u9179",
    "ling": "\u68F1\u51B7\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u9143\u5844\u82D3\u5464\u56F9\u6CE0\u7EEB\u67C3\u68C2\u74F4\u8046\u86C9\u7FCE\u9CAE",
    "leng": "\u695E\u6123",
    "li": "\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FEA\u4FDA\u90E6\u575C\u82C8\u8385\u84E0\u85DC\u6369\u5456\u5533\u55B1\u7301\u6EA7\u6FA7\u9026\u5A0C\u5AE0\u9A8A\u7F21\u73DE\u67A5\u680E\u8F79\u623E\u783A\u8A48\u7F79\u9502\u9E42\u75A0\u75AC\u86CE\u870A\u8821\u7B20\u7BE5\u7C9D\u91B4\u8DDE\u96F3\u9CA1\u9CE2\u9EE7",
    "lian": "\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u631B\u8539\u5941\u6F4B\u6FC2\u5A08\u740F\u695D\u6B93\u81C1\u81A6\u88E2\u880A\u9CA2",
    "liang": "\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u589A\u690B\u8E09\u9753\u9B49",
    "liao": "\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u84FC\u5C25\u5639\u7360\u5BEE\u7F2D\u948C\u9E69\u8022",
    "lie": "\u5217\u88C2\u70C8\u52A3\u730E\u51BD\u57D2\u6D0C\u8D94\u8E90\u9B23",
    "lin": "\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u853A\u5D99\u5EEA\u9074\u6AA9\u8F9A\u77B5\u7CBC\u8E8F\u9E9F",
    "liu": "\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u62A1\u507B\u848C\u6CD6\u6D4F\u905B\u9A9D\u7EFA\u65D2\u7198\u950D\u954F\u9E68\u938F",
    "long": "\u9F99\u804B\u5499\u7B3C\u7ABF\u9686\u5784\u62E2\u9647\u5F04\u5785\u830F\u6CF7\u73D1\u680A\u80E7\u783B\u7643",
    "lou": "\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u55BD\u5D5D\u9542\u7618\u8027\u877C\u9AC5",
    "lu": "\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u5786\u6445\u64B8\u565C\u6CF8\u6E0C\u6F09\u7490\u680C\u6A79\u8F73\u8F82\u8F98\u6C07\u80EA\u9565\u9E2C\u9E6D\u7C0F\u823B\u9C88",
    "lv": "\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u634B\u95FE\u6988\u8182\u7A06\u891B",
    "luan": "\u5CE6\u5B6A\u6EE6\u5375\u4E71\u683E\u9E3E\u92AE",
    "lue": "\u63A0\u7565\u950A",
    "lun": "\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u56F5",
    "luo": "\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u502E\u8366\u645E\u7321\u6CFA\u6924\u8136\u9559\u7630\u96D2",
    "ma": "\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u551B\u72B8\u5B37\u6769\u9EBD",
    "mai": "\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u52A2\u836C\u54AA\u973E",
    "man": "\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B\u8C29\u5881\u5E54\u7F26\u71B3\u9558\u989F\u87A8\u9CD7\u9794",
    "mang": "\u8292\u832B\u76F2\u5FD9\u83BD\u9099\u6F2D\u6726\u786D\u87D2",
    "meng": "\u6C13\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u52D0\u750D\u77A2\u61F5\u791E\u867B\u8722\u8813\u824B\u8268\u9EFE",
    "miao": "\u732B\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u55B5\u9088\u7F08\u7F2A\u676A\u6DFC\u7707\u9E4B\u8731",
    "mao": "\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4F94\u88A4\u52D6\u8306\u5CC1\u7441\u6634\u7266\u8004\u65C4\u61CB\u7780\u86D1\u8765\u87CA\u9AE6",
    "me": "\u4E48",
    "mei": "\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u5776\u8393\u5D4B\u7338\u6D7C\u6E44\u6963\u9545\u9E5B\u8882\u9B45",
    "men": "\u95E8\u95F7\u4EEC\u626A\u739F\u7116\u61D1\u9494",
    "mi": "\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u8288\u5196\u8C27\u863C\u5627\u7315\u736F\u6C68\u5B93\u5F2D\u8112\u6549\u7CF8\u7E3B\u9E8B",
    "mian": "\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u6C94\u6E4E\u817C\u7704",
    "mie": "\u8511\u706D\u54A9\u881B\u7BFE",
    "min": "\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u82E0\u5CB7\u95F5\u6CEF\u73C9",
    "ming": "\u660E\u879F\u9E23\u94ED\u540D\u547D\u51A5\u8317\u6E9F\u669D\u7791\u9169",
    "miu": "\u8C2C",
    "mo": "\u6478\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C1F\u8309\u84E6\u998D\u5AEB\u9546\u79E3\u763C\u8031\u87C6\u8C8A\u8C98",
    "mou": "\u8C0B\u725F\u67D0\u53B6\u54DE\u5A7A\u7738\u936A",
    "mu": "\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u4EEB\u82DC\u5452\u6C90\u6BEA\u94BC",
    "na": "\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u5185\u637A\u80AD\u954E\u8872\u7BAC",
    "nai": "\u6C16\u4E43\u5976\u8010\u5948\u9F10\u827F\u8418\u67F0",
    "nan": "\u5357\u7537\u96BE\u56CA\u5583\u56E1\u6960\u8169\u877B\u8D67",
    "nao": "\u6320\u8111\u607C\u95F9\u5B6C\u57B4\u7331\u7459\u7847\u94D9\u86F2",
    "ne": "\u6DD6\u5462\u8BB7",
    "nei": "\u9981",
    "nen": "\u5AE9\u80FD\u6798\u6041",
    "ni": "\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u4F32\u576D\u730A\u6029\u6EE0\u6635\u65CE\u7962\u615D\u7768\u94CC\u9CB5",
    "nian": "\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5EFF\u8F87\u9ECF\u9C87\u9CB6",
    "niang": "\u5A18\u917F",
    "niao": "\u9E1F\u5C3F\u8311\u5B32\u8132\u8885",
    "nie": "\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u4E5C\u9667\u8616\u55EB\u8080\u989E\u81EC\u8E51",
    "nin": "\u60A8\u67E0",
    "ning": "\u72DE\u51DD\u5B81\u62E7\u6CDE\u4F5E\u84E5\u549B\u752F\u804D",
    "niu": "\u725B\u626D\u94AE\u7EBD\u72C3\u5FF8\u599E\u86B4",
    "nong": "\u8113\u6D53\u519C\u4FAC",
    "nu": "\u5974\u52AA\u6012\u5476\u5E11\u5F29\u80EC\u5B65\u9A7D",
    "nv": "\u5973\u6067\u9495\u8844",
    "nuan": "\u6696",
    "nuenue": "\u8650",
    "nue": "\u759F\u8C11",
    "nuo": "\u632A\u61E6\u7CEF\u8BFA\u50A9\u6426\u558F\u9518",
    "ou": "\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u6004\u74EF\u8026",
    "pa": "\u556A\u8DB4\u722C\u5E15\u6015\u7436\u8469\u7B62",
    "pai": "\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u4FF3\u848E",
    "pan": "\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u723F\u6CEE\u88A2\u897B\u87E0\u8E52",
    "pang": "\u4E53\u5E9E\u65C1\u802A\u80D6\u6EC2\u9004",
    "pao": "\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u530F\u72CD\u5E96\u812C\u75B1",
    "pei": "\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u638A\u8F94\u5E14\u6DE0\u65C6\u952B\u9185\u9708",
    "pen": "\u55B7\u76C6\u6E53",
    "peng": "\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u580B\u562D\u6026\u87DB",
    "pi": "\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u4E15\u9674\u90B3\u90EB\u572E\u9F19\u64D7\u567C\u5E80\u5AB2\u7EB0\u6787\u7513\u7765\u7F74\u94CD\u75E6\u7656\u758B\u868D\u8C94",
    "pian": "\u7BC7\u504F\u7247\u9A97\u8C1D\u9A88\u728F\u80FC\u890A\u7FE9\u8E41",
    "piao": "\u98D8\u6F02\u74E2\u7968\u527D\u560C\u5AD6\u7F25\u6B8D\u779F\u87B5",
    "pie": "\u6487\u77A5\u4E3F\u82E4\u6C15",
    "pin": "\u62FC\u9891\u8D2B\u54C1\u8058\u62DA\u59D8\u5AD4\u6980\u725D\u98A6",
    "ping": "\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u4FDC\u5A09\u67B0\u9C86",
    "po": "\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u53F5\u9131\u6EA5\u73C0\u948B\u94B7\u76A4\u7B38",
    "pou": "\u5256\u88D2\u8E23",
    "pu": "\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u530D\u5657\u6FEE\u749E\u6C06\u9564\u9568\u8E7C",
    "qi": "\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u4E9F\u4E93\u573B\u8291\u840B\u847A\u5601\u5C7A\u5C90\u6C54\u6DC7\u9A90\u7EEE\u742A\u7426\u675E\u6864\u69ED\u6B39\u797A\u61A9\u789B\u86F4\u871E\u7DA6\u7DAE\u8DBF\u8E4A\u9CCD\u9E92",
    "qia": "\u6390\u6070\u6D3D\u845C",
    "qian": "\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u4F65\u9621\u828A\u82A1\u8368\u63AE\u5C8D\u60AD\u614A\u9A9E\u6434\u8930\u7F31\u6920\u80B7\u6106\u94A4\u8654\u7B9D",
    "qiang": "\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u5AF1\u6A2F\u6217\u709D\u9516\u9535\u956A\u8941\u8723\u7F9F\u8DEB\u8DC4",
    "qiao": "\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5281\u8BEE\u8C2F\u835E\u6100\u6194\u7F32\u6A35\u6BF3\u7857\u8DF7\u9792",
    "qie": "\u5207\u8304\u4E14\u602F\u7A83\u90C4\u553C\u60EC\u59BE\u6308\u9532\u7BA7",
    "qin": "\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u82A9\u84C1\u8572\u63FF\u5423\u55EA\u5659\u6EB1\u6A8E\u8793\u887E",
    "qing": "\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u5029\u82D8\u570A\u6AA0\u78EC\u873B\u7F44\u7B90\u8B26\u9CAD\u9EE5",
    "qiong": "\u743C\u7A77\u909B\u8315\u7A79\u7B47\u928E",
    "qiu": "\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u4FC5\u6C3D\u5DEF\u827D\u72B0\u6E6B\u9011\u9052\u6978\u8D47\u9E20\u866C\u86AF\u8764\u88D8\u7CD7\u9CC5\u9F3D",
    "qu": "\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20\u53D6\u5A36\u9F8B\u8DA3\u53BB\u8BCE\u52AC\u8556\u8627\u5C96\u8862\u9612\u74A9\u89D1\u6C0D\u795B\u78F2\u766F\u86D0\u883C\u9EB4\u77BF\u9EE2",
    "quan": "\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u8BE0\u8343\u737E\u609B\u7EFB\u8F81\u754E\u94E8\u8737\u7B4C\u9B08",
    "que": "\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u9619\u60AB",
    "qun": "\u88D9\u7FA4\u9021",
    "ran": "\u7136\u71C3\u5189\u67D3\u82D2\u9AEF",
    "rang": "\u74E4\u58E4\u6518\u56B7\u8BA9\u79B3\u7A70",
    "rao": "\u9976\u6270\u7ED5\u835B\u5A06\u6861",
    "ruo": "\u60F9\u82E5\u5F31",
    "re": "\u70ED\u504C",
    "ren": "\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u4EDE\u834F\u845A\u996A\u8F6B\u7A14\u887D",
    "reng": "\u6254\u4ECD",
    "ri": "\u65E5",
    "rong": "\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u5D58\u72E8\u7F1B\u6995\u877E",
    "rou": "\u63C9\u67D4\u8089\u7CC5\u8E42\u97A3",
    "ru": "\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u84D0\u85B7\u5685\u6D33\u6EBD\u6FE1\u94F7\u8966\u98A5",
    "ruan": "\u8F6F\u962E\u670A",
    "rui": "\u854A\u745E\u9510\u82AE\u8564\u777F\u868B",
    "run": "\u95F0\u6DA6",
    "sa": "\u6492\u6D12\u8428\u5345\u4EE8\u6332\u98D2",
    "sai": "\u816E\u9CC3\u585E\u8D5B\u567B",
    "san": "\u4E09\u53C1\u4F1E\u6563\u5F61\u9993\u6C35\u6BF5\u7CC1\u9730",
    "sang": "\u6851\u55D3\u4E27\u6421\u78C9\u98A1",
    "sao": "\u6414\u9A9A\u626B\u5AC2\u57FD\u81CA\u7619\u9CCB",
    "se": "\u745F\u8272\u6DA9\u556C\u94E9\u94EF\u7A51",
    "sen": "\u68EE",
    "seng": "\u50E7",
    "sha": "\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u810E\u6B43\u75E7\u88DF\u970E\u9CA8",
    "shai": "\u7B5B\u6652\u917E",
    "shan": "\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5261\u8BAA\u912F\u57CF\u829F\u6F78\u59D7\u9A9F\u81BB\u9490\u759D\u87EE\u8222\u8DDA\u9CDD",
    "shang": "\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u57A7\u7EF1\u6B87\u71B5\u89DE",
    "shao": "\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u52AD\u82D5\u6F72\u86F8\u7B24\u7B72\u8244",
    "she": "\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u538D\u4F58\u731E\u7572\u9E9D",
    "shen": "\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u8BDC\u8C02\u5432\u54C2\u6E16\u6939\u77E7\u8703",
    "sheng": "\u58F0\u751F\u7525\u7272\u5347\u7EF3\u7701\u76DB\u5269\u80DC\u5723\u4E1E\u6E11\u5AB5\u771A\u7B19",
    "shi": "\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u8C25\u57D8\u83B3\u84CD\u5F11\u5511\u9963\u8F7C\u8006\u8D33\u70BB\u793B\u94C8\u94CA\u87AB\u8210\u7B6E\u8C55\u9CA5\u9CBA",
    "shou": "\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u624C\u72E9\u7EF6\u824F",
    "shu": "\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31\u6055\u500F\u587E\u83FD\u5FC4\u6CAD\u6D91\u6F8D\u59DD\u7EBE\u6BF9\u8167\u6BB3\u956F\u79EB\u9E6C",
    "shua": "\u5237\u800D\u5530\u6DAE",
    "shuai": "\u6454\u8870\u7529\u5E05\u87C0",
    "shuan": "\u6813\u62F4\u95E9",
    "shuang": "\u971C\u53CC\u723D\u5B40",
    "shui": "\u8C01\u6C34\u7761\u7A0E",
    "shun": "\u542E\u77AC\u987A\u821C\u6042",
    "shuo": "\u8BF4\u7855\u6714\u70C1\u84B4\u6420\u55CD\u6FEF\u5981\u69CA\u94C4",
    "si": "\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u53AE\u4FDF\u5155\u83E5\u549D\u6C5C\u6CD7\u6F8C\u59D2\u9A77\u7F0C\u7940\u7960\u9536\u9E36\u801C\u86F3\u7B25",
    "song": "\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u51C7\u83D8\u5D27\u5D69\u5FEA\u609A\u6DDE\u7AE6",
    "sou": "\u641C\u8258\u64DE\u55FD\u53DF\u55D6\u55FE\u998A\u6EB2\u98D5\u778D\u953C\u878B",
    "su": "\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u5919\u8C21\u850C\u55C9\u612B\u7C0C\u89EB\u7A23",
    "suan": "\u9178\u849C\u7B97",
    "sui": "\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u84D1\u51AB\u8C07\u6FC9\u9083\u71E7\u772D\u7762",
    "sun": "\u5B59\u635F\u7B0B\u836A\u72F2\u98E7\u69AB\u8DE3\u96BC",
    "suo": "\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u5522\u55E6\u5A11\u686B\u7743\u7FA7",
    "ta": "\u584C\u4ED6\u5B83\u5979\u5854\u736D\u631E\u8E4B\u8E0F\u95FC\u6EBB\u9062\u69BB\u6C93",
    "tai": "\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u90B0\u85B9\u80BD\u70B1\u949B\u8DC6\u9C90",
    "tan": "\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u90EF\u8548\u6619\u94BD\u952C\u8983",
    "tang": "\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u50A5\u9967\u6E8F\u746D\u94F4\u9557\u8025\u8797\u87B3\u7FB0\u91A3",
    "thang": "\u5018\u8EBA\u6DCC",
    "theng": "\u8D9F\u70EB",
    "tao": "\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u6311\u9F17\u5555\u97EC\u9955",
    "te": "\u7279",
    "teng": "\u85E4\u817E\u75BC\u8A8A\u6ED5",
    "ti": "\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u8351\u608C\u9016\u7EE8\u7F07\u9E48\u88FC\u918D",
    "tian": "\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u63AD\u5FDD\u9617\u6B84\u754B\u94BF\u86BA",
    "tiao": "\u6761\u8FE2\u773A\u8DF3\u4F7B\u7967\u94EB\u7A95\u9F86\u9CA6",
    "tie": "\u8D34\u94C1\u5E16\u841C\u992E",
    "ting": "\u5385\u542C\u70C3\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u839B\u8476\u5A77\u6883\u8713\u9706",
    "tong": "\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u4F5F\u50EE\u4EDD\u833C\u55F5\u6078\u6F7C\u783C",
    "tou": "\u5077\u6295\u5934\u900F\u4EA0",
    "tu": "\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u580D\u837C\u83DF\u948D\u9174",
    "tuan": "\u6E4D\u56E2\u7583",
    "tui": "\u63A8\u9893\u817F\u8715\u892A\u9000\u5FD2\u717A",
    "tun": "\u541E\u5C6F\u81C0\u9968\u66BE\u8C5A\u7A80",
    "tuo": "\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u4E47\u4F57\u5768\u5EB9\u6CB1\u67DD\u7823\u7BA8\u8204\u8DCE\u9F0D",
    "wa": "\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u4F64\u5A32\u817D",
    "wai": "\u6B6A\u5916",
    "wan": "\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u525C\u8284\u82CB\u83C0\u7EA8\u7EFE\u742C\u8118\u7579\u873F\u7BA2",
    "wang": "\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u7F54\u5C22\u60D8\u8F8B\u9B4D",
    "wei": "\u5A01\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u502D\u504E\u8BFF\u9688\u8473\u8587\u5E0F\u5E37\u5D34\u5D6C\u7325\u732C\u95F1\u6CA9\u6D27\u6DA0\u9036\u5A13\u73AE\u97EA\u8ECE\u709C\u7168\u71A8\u75FF\u8249\u9C94",
    "wen": "\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u520E\u6120\u960C\u6C76\u74BA\u97EB\u6B81\u96EF",
    "weng": "\u55E1\u7FC1\u74EE\u84CA\u8579",
    "wo": "\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u83B4\u5E44\u6E25\u674C\u809F\u9F8C",
    "wu": "\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u5140\u4EF5\u9622\u90AC\u572C\u82B4\u5E91\u6003\u5FE4\u6D6F\u5BE4\u8FD5\u59A9\u9A9B\u727E\u7110\u9E49\u9E5C\u8708\u92C8\u9F2F",
    "xi": "\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u50D6\u516E\u96B0\u90D7\u831C\u8478\u84F0\u595A\u550F\u5F99\u9969\u960B\u6D60\u6DC5\u5C63\u5B09\u73BA\u6A28\u66E6\u89CB\u6B37\u71B9\u798A\u79A7\u94B8\u7699\u7A78\u8725\u87CB\u823E\u7FB2\u7C9E\u7FD5\u91AF\u9F37",
    "xia": "\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u846D\u55C4\u72CE\u9050\u7455\u7856\u7615\u7F45\u9EE0",
    "xian": "\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u51BC\u85D3\u5C98\u7303\u66B9\u5A34\u6C19\u7946\u9E47\u75EB\u86AC\u7B45\u7C7C\u9170\u8DF9",
    "xiang": "\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8297\u8459\u9977\u5EA0\u9AA7\u7F03\u87D3\u9C9E\u98E8",
    "xiao": "\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u54D3\u54BB\u5D24\u6F47\u900D\u9A81\u7EE1\u67AD\u67B5\u7B71\u7BAB\u9B48",
    "xie": "\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u5055\u4EB5\u52F0\u71EE\u85A4\u64B7\u5EE8\u7023\u9082\u7EC1\u7F2C\u69AD\u698D\u6B59\u8E9E",
    "xin": "\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u56DF\u99A8\u8398\u6B46\u94FD\u946B",
    "xing": "\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u9649\u8347\u8365\u64E4\u60BB\u784E",
    "xiong": "\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u828E",
    "xiu": "\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u83A0\u5CAB\u9990\u5EA5\u9E3A\u8C85\u9AF9",
    "xu": "\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8BB4\u8BE9\u5729\u84FF\u6035\u6D2B\u6E86\u987C\u6829\u7166\u7809\u76F1\u80E5\u7CC8\u9191",
    "xuan": "\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384\u9009\u7663\u7729\u7EDA\u5107\u8C16\u8431\u63CE\u9994\u6CEB\u6D35\u6E32\u6F29\u7487\u6966\u6684\u70AB\u714A\u78B9\u94C9\u955F\u75C3",
    "xue": "\u9774\u859B\u5B66\u7A74\u96EA\u8840\u5671\u6CF6\u9CD5",
    "xun": "\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u5DFD\u57D9\u8340\u85B0\u5CCB\u5F87\u6D54\u66DB\u7AA8\u91BA\u9C9F",
    "ya": "\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u4F22\u63E0\u5416\u5C88\u8FD3\u5A05\u740A\u6860\u6C29\u7811\u775A\u75D6",
    "yan": "\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u53A3\u9765\u8D5D\u4FE8\u5043\u5156\u8BA0\u8C33\u90FE\u9122\u82AB\u83F8\u5D26\u6079\u95EB\u960F\u6D07\u6E6E\u6EDF\u598D\u5AE3\u7430\u664F\u80ED\u814C\u7131\u7F68\u7B75\u917D\u9B47\u990D\u9F39",
    "yang": "\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u5F89\u600F\u6CF1\u7080\u70CA\u6059\u86D8\u9785",
    "yao": "\u9080\u8170\u5996\u7476\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u592D\u723B\u5406\u5D3E\u5FAD\u7039\u5E7A\u73E7\u6773\u66DC\u80B4\u9E5E\u7A88\u7E47\u9CD0",
    "ye": "\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u8C12\u90BA\u63F6\u9980\u6654\u70E8\u94D8",
    "yi": "\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u5208\u5293\u4F7E\u8BD2\u572A\u572F\u57F8\u61FF\u82E1\u858F\u5F08\u5955\u6339\u5F0B\u5453\u54A6\u54BF\u566B\u5CC4\u5DB7\u7317\u9974\u603F\u6021\u6092\u6F2A\u8FE4\u9A7F\u7F22\u6BAA\u8D3B\u65D6\u71A0\u9487\u9552\u9571\u75CD\u7617\u7654\u7FCA\u8864\u8734\u8223\u7FBF\u7FF3\u914F\u9EDF",
    "yin": "\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690\u5370\u80E4\u911E\u5819\u831A\u5591\u72FA\u5924\u6C24\u94DF\u763E\u8693\u972A\u9F88",
    "ying": "\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u5B34\u90E2\u8314\u83BA\u8426\u6484\u5624\u81BA\u6EE2\u6F46\u701B\u745B\u748E\u6979\u9E66\u763F\u988D\u7F42",
    "yo": "\u54DF\u5537",
    "yong": "\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u4FD1\u58C5\u5889\u6175\u9095\u955B\u752C\u9CD9\u9954",
    "you": "\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u5363\u6538\u4F91\u83B8\u5466\u56FF\u5BA5\u67DA\u7337\u7256\u94D5\u75A3\u8763\u9C7F\u9EDD\u9F2C",
    "yu": "\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u79BA\u6BD3\u4F1B\u4FE3\u8C00\u8C15\u8438\u84E3\u63C4\u5581\u5704\u5709\u5D5B\u72F3\u996B\u5EBE\u9608\u59AA\u59A4\u7EA1\u745C\u6631\u89CE\u8174\u6B24\u65BC\u715C\u71E0\u807F\u94B0\u9E46\u7610\u7600\u7AB3\u8753\u7AFD\u8201\u96E9\u9F89",
    "yuan": "\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u586C\u6C85\u5A9B\u7457\u6A7C\u7230\u7722\u9E22\u8788\u9F0B",
    "yue": "\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u9FA0\u6A3E\u5216\u94BA",
    "yun": "\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u90D3\u82B8\u72C1\u607D\u7EAD\u6B92\u6600\u6C32",
    "za": "\u531D\u7838\u6742\u62F6\u5482",
    "zai": "\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u5D3D\u753E",
    "zan": "\u6512\u6682\u8D5E\u74D2\u661D\u7C2A\u7CCC\u8DB1\u933E",
    "zang": "\u8D43\u810F\u846C\u5958\u6215\u81E7",
    "zao": "\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u5523\u7F2B",
    "ze": "\u8D23\u62E9\u5219\u6CFD\u4EC4\u8D5C\u5567\u8FEE\u6603\u7B2E\u7BA6\u8234",
    "zei": "\u8D3C",
    "zen": "\u600E\u8C2E",
    "zeng": "\u589E\u618E\u66FE\u8D60\u7F2F\u7511\u7F7E\u9503",
    "zha": "\u624E\u55B3\u6E23\u672D\u8F67\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u63F8\u5412\u54A4\u54F3\u600D\u781F\u75C4\u86B1\u9F44",
    "zhai": "\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u7826",
    "zhan": "\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u8C35\u640C\u65C3",
    "zhang": "\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u4EC9\u9123\u5E5B\u5D82\u7350\u5ADC\u748B\u87D1",
    "zhao": "\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u722A\u8BCF\u68F9\u948A\u7B0A",
    "zhe": "\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u8C2A\u966C\u67D8\u8F84\u78D4\u9E67\u891A\u8707\u8D6D",
    "zhen": "\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u7F1C\u6862\u699B\u8F78\u8D48\u80D7\u6715\u796F\u755B\u9E29",
    "zheng": "\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F\u5E27\u75C7\u90D1\u8BC1\u8BE4\u5CE5\u94B2\u94EE\u7B5D",
    "zhi": "\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u536E\u965F\u90C5\u57F4\u82B7\u646D\u5E19\u5FEE\u5F58\u54AB\u9A98\u6809\u67B3\u6800\u684E\u8F75\u8F7E\u6534\u8D3D\u81A3\u7949\u7957\u9EF9\u96C9\u9E37\u75E3\u86ED\u7D77\u916F\u8DD6\u8E2C\u8E2F\u8C78\u89EF",
    "zhong": "\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u51A2\u953A\u87BD\u8202\u822F\u8E35",
    "zhou": "\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u5544\u7740\u501C\u8BF9\u836E\u9B3B\u7EA3\u80C4\u78A1\u7C40\u8233\u914E\u9CB7",
    "zhu": "\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51\u4F4F\u6CE8\u795D\u9A7B\u4F2B\u4F8F\u90BE\u82CE\u8331\u6D19\u6E1A\u6F74\u9A7A\u677C\u69E0\u6A65\u70B7\u94E2\u75B0\u7603\u86B0\u7AFA\u7BB8\u7FE5\u8E85\u9E88",
    "zhua": "\u6293",
    "zhuai": "\u62FD",
    "zhuan": "\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u629F\u556D\u989B",
    "zhuang": "\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u4E2C",
    "zhui": "\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8411\u9A93\u7F12",
    "zhun": "\u8C06\u51C6",
    "zhuo": "\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u707C\u6D4A\u502C\u8BFC\u5EF4\u855E\u64E2\u555C\u6D5E\u6DBF\u6753\u712F\u799A\u65AB",
    "zi": "\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u8C18\u5D6B\u59CA\u5B73\u7F01\u6893\u8F8E\u8D40\u6063\u7726\u9531\u79ED\u8014\u7B2B\u7CA2\u89DC\u8A3E\u9CBB\u9AED",
    "zong": "\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u8159\u7CBD",
    "zou": "\u90B9\u8D70\u594F\u63CD\u9139\u9CB0",
    "zu": "\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u4FCE\u83F9\u5550\u5F82\u9A75\u8E74",
    "zuan": "\u94BB\u7E82\u6525\u7F35",
    "zui": "\u5634\u9189\u6700\u7F6A",
    "zun": "\u5C0A\u9075\u6499\u6A3D\u9CDF",
    "zuo": "\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7\u961D\u963C\u80D9\u795A\u9162",
    "cou": "\u85AE\u6971\u8F8F\u8160",
    "nang": "\u652E\u54DD\u56D4\u9995\u66E9",
    "o": "\u5594",
    "dia": "\u55F2",
    "chuai": "\u562C\u81AA\u8E39",
    "cen": "\u5C91\u6D94",
    "diu": "\u94E5",
    "nou": "\u8028",
    "fou": "\u7F36",
    "bia": "\u9ADF"
};

var py_py = {};

py_py.ConvertPinyin = function (l1) {
    var l2 = l1.length;
    var I1 = "";
    var reg = new RegExp('[a-zA-Z0-9\- ]');
    for (var i = 0; i < l2; i++) {
        var val = l1.substr(i, 1);
        var name = py_py.arraySearch(val, PinYin);
        if (reg.test(val)) {
            I1 += val;
        } else if (name !== false) {
            I1 += name;
        }
    }
    I1 = I1.replace(/ /g, '-');
    while (I1.indexOf('--') > 0) {
        I1 = I1.replace('--', '-');
    }
    return I1;
};

py_py.arraySearch = function arraySearch(l1) {
    for (var name in PinYin) {
        if (PinYin[name].indexOf(l1) != -1) {
            return name;
            break;
        }
    }
    return false;
};

/* harmony default export */ var libs_py = (py_py);
// EXTERNAL MODULE: ./node_modules/mint-ui/lib/style.css
var lib_style = __webpack_require__("d8/S");
var style_default = /*#__PURE__*/__webpack_require__.n(lib_style);

// EXTERNAL MODULE: ./src/libs/lrz.bundle.js
var lrz_bundle = __webpack_require__("pUzx");

// EXTERNAL MODULE: ./static/js/config.js
var js_config = __webpack_require__("wAX/");
var config_default = /*#__PURE__*/__webpack_require__.n(js_config);

// EXTERNAL MODULE: ./node_modules/vux-blazy/blazy.js
var blazy = __webpack_require__("iRq5");
var blazy_default = /*#__PURE__*/__webpack_require__.n(blazy);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/webp-support.js
var webp_support = __webpack_require__("p3QP");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        separator: _this.separator,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    },
    separator: String
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var components_x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        separator: _this.separator,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    },
    separator: String
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2866cbf8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-img/index.vue
var x_img_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vux-x-img",attrs:{"src":_vm.defaultSrc,"data-src":_vm.currentSrc}})}
var x_img_staticRenderFns = []
var x_img_esExports = { render: x_img_render, staticRenderFns: x_img_staticRenderFns }
/* harmony default export */ var src_components_x_img = (x_img_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-img/index.vue
function x_img_injectStyle (ssrContext) {
  __webpack_require__("IUU3")
}
var x_img_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_img___vue_template_functional__ = false
/* styles */
var x_img___vue_styles__ = x_img_injectStyle
/* scopeId */
var x_img___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_img___vue_module_identifier__ = null
var x_img_Component = x_img_normalizeComponent(
  components_x_img,
  src_components_x_img,
  x_img___vue_template_functional__,
  x_img___vue_styles__,
  x_img___vue_scopeId__,
  x_img___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_img = (x_img_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c83ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var x_dialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var x_dialog_staticRenderFns = []
var x_dialog_esExports = { render: x_dialog_render, staticRenderFns: x_dialog_staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (x_dialog_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function x_dialog_injectStyle (ssrContext) {
  __webpack_require__("7DAO")
}
var x_dialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_dialog___vue_template_functional__ = false
/* styles */
var x_dialog___vue_styles__ = x_dialog_injectStyle
/* scopeId */
var x_dialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_dialog___vue_module_identifier__ = null
var x_dialog_Component = x_dialog_normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  x_dialog___vue_template_functional__,
  x_dialog___vue_styles__,
  x_dialog___vue_scopeId__,
  x_dialog___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (x_dialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a6d97f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var confirm_staticRenderFns = []
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (confirm_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function confirm_injectStyle (ssrContext) {
  __webpack_require__("6f65")
}
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = confirm_injectStyle
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = (confirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26523019","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]}),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){return _vm.$emit('on-click-title')}}},[_vm._t("default",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])]})],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){return _vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("0sQS")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [libs_base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [libs_base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8c8891a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"touchstart":function($event){return _vm.clear.apply(null, arguments)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("+LB2")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var components_selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var components_selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: components_selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0012d80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/selector/index.vue
var selector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-selector weui-cell",class:{
    'weui-cell_select': !_vm.readonly,
    'weui-cell_select-after': _vm.title
  }},[(_vm.title)?_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.cleanStyle({
        width: _vm.$parent.labelWidth,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      })),attrs:{"for":("vux-selector-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"weui-cell__bd"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-select",style:(_vm.cleanStyle({
        direction: _vm.direction,
        color: _vm.color
      })),attrs:{"id":("vux-selector-" + _vm.uuid),"name":_vm.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.showPlaceholder)?_c('option',{domProps:{"value":_vm.value === null ? 'null' : '',"selected":_vm.isEmptyValue(_vm.value) && !!_vm.placeholder}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.fixIos)?_c('option',{attrs:{"disabled":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.processOptions),function(one){return _c('option',{domProps:{"value":one.key}},[_vm._v(_vm._s(_vm.direction === 'rtl' ? one.value + '‎' : one.value))])})],2)]):_c('div',{staticClass:"weui-cell__ft vux-selector-readonly"},[_vm._v("\n    "+_vm._s(_vm._f("findByKey")(_vm.value,_vm.processOptions))+"\n  ")])])}
var selector_staticRenderFns = []
var selector_esExports = { render: selector_render, staticRenderFns: selector_staticRenderFns }
/* harmony default export */ var src_components_selector = (selector_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/selector/index.vue
function selector_injectStyle (ssrContext) {
  __webpack_require__("G6U3")
}
var selector_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var selector___vue_template_functional__ = false
/* styles */
var selector___vue_styles__ = selector_injectStyle
/* scopeId */
var selector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var selector___vue_module_identifier__ = null
var selector_Component = selector_normalizeComponent(
  components_selector,
  src_components_selector,
  selector___vue_template_functional__,
  selector___vue_styles__,
  selector___vue_scopeId__,
  selector___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_selector = (selector_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab = ({
  name: 'button-tab',
  mixins: [multi_items["b" /* parentMixin */]],
  props: {
    height: Number
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ac43c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab.vue
var button_tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-button-group"},[_vm._t("default")],2)}
var button_tab_staticRenderFns = []
var button_tab_esExports = { render: button_tab_render, staticRenderFns: button_tab_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab = (button_tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab.vue
function button_tab_injectStyle (ssrContext) {
  __webpack_require__("P7KP")
}
var button_tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab___vue_template_functional__ = false
/* styles */
var button_tab___vue_styles__ = button_tab_injectStyle
/* scopeId */
var button_tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab___vue_module_identifier__ = null
var button_tab_Component = button_tab_normalizeComponent(
  button_tab_button_tab,
  components_button_tab_button_tab,
  button_tab___vue_template_functional__,
  button_tab___vue_styles__,
  button_tab___vue_scopeId__,
  button_tab___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab = (button_tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039300f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("9lt8")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c3c9c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
//
//
//
//
//
//



/* harmony default export */ var button_tab_button_tab_item = ({
  name: 'button-tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  computed: {
    classes: function classes() {
      return {
        'vux-button-group-current': this.currentIndex === this.$parent.currentIndex,
        'vux-button-tab-item-first': this.currentIndex === 0,
        'vux-button-tab-item-last': this.currentIndex === this.$parent.$children.length - 1,
        'vux-button-tab-item-middle': this.currentIndex > 0 && this.currentIndex !== this.$parent.$children.length - 1
      };
    },
    style: function style() {
      if (this.$parent.height) {
        return {
          height: this.$parent.height + 'px',
          lineHeight: this.$parent.height + 'px'
        };
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350dcdc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-button-tab-item",class:_vm.classes,style:(_vm.style),attrs:{"href":"javascript:"},on:{"click":_vm.onItemClick}},[_vm._t("default")],2)}
var button_tab_item_staticRenderFns = []
var button_tab_item_esExports = { render: button_tab_item_render, staticRenderFns: button_tab_item_staticRenderFns }
/* harmony default export */ var components_button_tab_button_tab_item = (button_tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/button-tab/button-tab-item.vue
var button_tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var button_tab_item___vue_template_functional__ = false
/* styles */
var button_tab_item___vue_styles__ = null
/* scopeId */
var button_tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var button_tab_item___vue_module_identifier__ = null
var button_tab_item_Component = button_tab_item_normalizeComponent(
  button_tab_button_tab_item,
  components_button_tab_button_tab_item,
  button_tab_item___vue_template_functional__,
  button_tab_item___vue_styles__,
  button_tab_item___vue_scopeId__,
  button_tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_button_tab_button_tab_item = (button_tab_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'search'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    type: {
      type: String,
      default: 'search'
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d29452ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/search/index.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-search-box",class:{ 'vux-search-fixed':_vm.isFixed },style:({ top: _vm.isFixed ? _vm.top : '', position: _vm.fixPosition })},[_c('div',{staticClass:"weui-search-bar",class:{'weui-search-bar_focusing': !_vm.isCancel || _vm.currentValue}},[_vm._t("left"),_vm._v(" "),_c('form',{staticClass:"weui-search-bar__form",attrs:{"action":"."},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('on-submit', _vm.value)}}},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFixed && _vm.autoFixed),expression:"!isFixed && autoFixed"}],staticClass:"vux-search-mask",attrs:{"for":("search_input_" + _vm.uuid)},on:{"click":_vm.touch}}),_vm._v(" "),_c('div',{staticClass:"weui-search-bar__box"},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),((_vm.type)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":function($event){return _vm.onComposition($event, 'input')},"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}):((_vm.type)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":"radio"},domProps:{"checked":_vm._q(_vm.currentValue,null)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":function($event){return _vm.onComposition($event, 'input')},"change":function($event){_vm.currentValue=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required,"type":_vm.type},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){return _vm.onComposition($event, 'input')}]}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-icon-clear",attrs:{"href":"javascript:"},on:{"click":_vm.clear}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFocus && !_vm.value),expression:"!isFocus && !value"}],staticClass:"weui-search-bar__label",attrs:{"for":("search_input_" + _vm.uuid)}},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.placeholder || '搜索'))])])]),_vm._v(" "),_c('a',{staticClass:"weui-search-bar__cancel-btn",attrs:{"href":"javascript:"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText || '取消')+"\n    ")]),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFixed),expression:"isFixed"}],staticClass:"weui-cells vux-search_show"},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.results),function(item){return _c('div',{staticClass:"weui-cell weui-cell_access",on:{"click":function($event){return _vm.handleResultClick(item)}}},[_c('div',{staticClass:"weui-cell__bd weui-cell_primary"},[_c('p',[_vm._v(_vm._s(item.title))])])])})],2)])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var src_components_search = (search_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/search/index.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("fFU4")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  components_search,
  src_components_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_search = (search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-table/index.vue
//
//
//
//
//
//

/* harmony default export */ var x_table = ({
  name: 'x-table',
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-table/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_x_table = ({
  name: 'x-table',
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2264b9b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-table/index.vue
var x_table_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"vux-table",class:{'vux-table-bordered': _vm.fullBordered, 'vux-table-no-cell-bordered': !_vm.cellBordered, 'vux-table-no-content-bordered': !_vm.contentBordered}},[_vm._t("default")],2)}
var x_table_staticRenderFns = []
var x_table_esExports = { render: x_table_render, staticRenderFns: x_table_staticRenderFns }
/* harmony default export */ var src_components_x_table = (x_table_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-table/index.vue
function x_table_injectStyle (ssrContext) {
  __webpack_require__("sVzw")
}
var x_table_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_table___vue_template_functional__ = false
/* styles */
var x_table___vue_styles__ = x_table_injectStyle
/* scopeId */
var x_table___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_table___vue_module_identifier__ = null
var x_table_Component = x_table_normalizeComponent(
  components_x_table,
  src_components_x_table,
  x_table___vue_template_functional__,
  x_table___vue_styles__,
  x_table___vue_scopeId__,
  x_table___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_table = (x_table_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 3 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: vux_src_components_group,
    InlineDesc: vux_src_components_inline_desc,
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: vux_src_components_group,
    InlineDesc: vux_src_components_inline_desc,
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3077eb4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",function(){return [_c('div',[_vm._t("title",function(){return [_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)]})],2)}
var datetime_staticRenderFns = []
var datetime_esExports = { render: datetime_render, staticRenderFns: datetime_staticRenderFns }
/* harmony default export */ var src_components_datetime = (datetime_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function datetime_injectStyle (ssrContext) {
  __webpack_require__("T5Vs")
}
var datetime_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datetime___vue_template_functional__ = false
/* styles */
var datetime___vue_styles__ = datetime_injectStyle
/* scopeId */
var datetime___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datetime___vue_module_identifier__ = null
var datetime_Component = datetime_normalizeComponent(
  components_datetime,
  src_components_datetime,
  datetime___vue_template_functional__,
  datetime___vue_styles__,
  datetime___vue_scopeId__,
  datetime___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = (datetime_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime-view/index.vue
//
//
//
//





/* harmony default export */ var datetime_view = ({
  name: 'datetime-view',
  extends: vux_src_components_datetime,
  methods: {
    render: function render() {
      var _this = this;

      this.$nextTick(function () {
        _this.picker && _this.picker.destroy();
        _this.picker = new datetimepicker["a" /* default */](object_assign_default()(_this.pickerOptions, {
          renderInline: true
        }));
        // #2797
        _this.$nextTick(function () {
          _this.picker.show();
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime-view/index.vue
//
//
//
//





/* harmony default export */ var components_datetime_view = ({
  name: 'datetime-view',
  extends: vux_src_components_datetime,
  methods: {
    render: function render() {
      var _this = this;

      this.$nextTick(function () {
        _this.picker && _this.picker.destroy();
        _this.picker = new datetimepicker["a" /* default */](object_assign_default()(_this.pickerOptions, {
          renderInline: true
        }));
        // #2797
        _this.$nextTick(function () {
          _this.picker.show();
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60c323ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime-view/index.vue
var datetime_view_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var datetime_view_staticRenderFns = []
var datetime_view_esExports = { render: datetime_view_render, staticRenderFns: datetime_view_staticRenderFns }
/* harmony default export */ var src_components_datetime_view = (datetime_view_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime-view/index.vue
var datetime_view_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datetime_view___vue_template_functional__ = false
/* styles */
var datetime_view___vue_styles__ = null
/* scopeId */
var datetime_view___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datetime_view___vue_module_identifier__ = null
var datetime_view_Component = datetime_view_normalizeComponent(
  components_datetime_view,
  src_components_datetime_view,
  datetime_view___vue_template_functional__,
  datetime_view___vue_styles__,
  datetime_view___vue_scopeId__,
  datetime_view___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_datetime_view = (datetime_view_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group-title/index.vue
//
//
//
//
//
//

/* harmony default export */ var group_title = ({
  name: 'group-title'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group-title/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_group_title = ({
  name: 'group-title'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3c88812","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group-title/index.vue
var group_title_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells__title"},[_vm._t("default")],2)}
var group_title_staticRenderFns = []
var group_title_esExports = { render: group_title_render, staticRenderFns: group_title_staticRenderFns }
/* harmony default export */ var src_components_group_title = (group_title_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group-title/index.vue
function group_title_injectStyle (ssrContext) {
  __webpack_require__("4WEX")
}
var group_title_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group_title___vue_template_functional__ = false
/* styles */
var group_title___vue_styles__ = group_title_injectStyle
/* scopeId */
var group_title___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group_title___vue_module_identifier__ = null
var group_title_Component = group_title_normalizeComponent(
  components_group_title,
  src_components_group_title,
  group_title___vue_template_functional__,
  group_title___vue_styles__,
  group_title___vue_scopeId__,
  group_title___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group_title = (group_title_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/msg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_msg = ({
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick: function onClick(handler, link) {
      typeof handler === 'function' && handler();
      link && Object(router["b" /* go */])(link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/msg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_msg = ({
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick: function onClick(handler, link) {
      typeof handler === 'function' && handler();
      link && Object(router["b" /* go */])(link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fb41afc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/msg/index.vue
var msg_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-msg"},[_c('div',{staticClass:"weui-msg__icon-area"},[_c('i',{staticClass:"weui-icon_msg",class:("weui-icon-" + (_vm.icon || 'success'))})]),_vm._v(" "),_c('div',{staticClass:"weui-msg__text-area"},[_c('h2',{staticClass:"weui-msg__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-msg__desc"},[_vm._t("description")],2),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"weui-msg__desc",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-msg__opr-area"},[_c('p',{staticClass:"weui-btn-area"},[_vm._t("buttons",function(){return _vm._l((_vm.buttons),function(button){return _c('a',{staticClass:"weui-btn",class:("weui-btn_" + (button.type)),attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onClick(button.onClick, button.link)}}},[_vm._v(_vm._s(button.text))])})})],2)])])}
var msg_staticRenderFns = []
var msg_esExports = { render: msg_render, staticRenderFns: msg_staticRenderFns }
/* harmony default export */ var vux_src_components_msg = (msg_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/msg/index.vue
function msg_injectStyle (ssrContext) {
  __webpack_require__("Te/k")
}
var msg_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var msg___vue_template_functional__ = false
/* styles */
var msg___vue_styles__ = msg_injectStyle
/* scopeId */
var msg___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var msg___vue_module_identifier__ = null
var msg_Component = msg_normalizeComponent(
  src_components_msg,
  vux_src_components_msg,
  msg___vue_template_functional__,
  msg___vue_styles__,
  msg___vue_scopeId__,
  msg___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_msg = (msg_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e261fb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/panel/index.vue
var panel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header)},on:{"click":_vm.onClickHeader}},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_vm._t("body",function(){return [(_vm.type === '1')?_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-media-box weui-media-box_appmsg",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])])}):_vm._e(),_vm._v(" "),(_vm.type === '2')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])}):_vm._e(),_vm._v(" "),(_vm.type === '3')?[_c('div',{staticClass:"weui-media-box weui-media-box_small-appmsg"},[_c('div',{staticClass:"weui-cells"},_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-cell__hd"},[_c('img',{staticStyle:{"width":"20px","margin-right":"5px","display":"block"},attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(item.title)}})]),_vm._v(" "),_c('span',{staticClass:"weui-cell__ft"})])}),0)])]:_vm._e(),_vm._v(" "),(_vm.type === '4')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}}),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e(),_vm._v(" "),(_vm.type === '5')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-media-box_appmsg"},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])]),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title && _vm.type !== '3')?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":_vm.getUrl(_vm.footer.url)},on:{"click":function($event){$event.preventDefault();return _vm.onClickFooter.apply(null, arguments)}}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()])])}
var panel_staticRenderFns = []
var panel_esExports = { render: panel_render, staticRenderFns: panel_staticRenderFns }
/* harmony default export */ var src_components_panel = (panel_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/panel/index.vue
function panel_injectStyle (ssrContext) {
  __webpack_require__("2tP1")
}
var panel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var panel___vue_template_functional__ = false
/* styles */
var panel___vue_styles__ = panel_injectStyle
/* scopeId */
var panel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var panel___vue_module_identifier__ = null
var panel_Component = panel_normalizeComponent(
  components_panel,
  src_components_panel,
  panel___vue_template_functional__,
  panel___vue_styles__,
  panel___vue_scopeId__,
  panel___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_panel = (panel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/xscroll.js
var xscroll = __webpack_require__("WTNC");
var xscroll_default = /*#__PURE__*/__webpack_require__.n(xscroll);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pulldown.js
var pulldown = __webpack_require__("ypEt");
var pulldown_default = /*#__PURE__*/__webpack_require__.n(pulldown);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pullup.js
var pullup = __webpack_require__("qbvd");
var pullup_default = /*#__PURE__*/__webpack_require__.n(pullup);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var scroller_pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var scroller_pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', scroller_pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(scroller_pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(scroller_pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function scroller_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var components_scroller_pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var components_scroller_pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var src_components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', components_scroller_pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(components_scroller_pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(components_scroller_pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function components_scroller_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7769fa5b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/scroller/index.vue
var scroller_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles)},[_c('div',{staticClass:"xs-container"},[_vm._t("default"),_vm._v(" "),_vm._t("pulldown"),_vm._v(" "),_vm._t("pullup")],2)])}
var scroller_staticRenderFns = []
var scroller_esExports = { render: scroller_render, staticRenderFns: scroller_staticRenderFns }
/* harmony default export */ var vux_src_components_scroller = (scroller_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/scroller/index.vue
function scroller_injectStyle (ssrContext) {
  __webpack_require__("CMiz")
}
var scroller_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scroller___vue_template_functional__ = false
/* styles */
var scroller___vue_styles__ = scroller_injectStyle
/* scopeId */
var scroller___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var scroller___vue_module_identifier__ = null
var scroller_Component = scroller_normalizeComponent(
  src_components_scroller,
  vux_src_components_scroller,
  scroller___vue_template_functional__,
  scroller___vue_styles__,
  scroller___vue_scopeId__,
  scroller___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_scroller = (scroller_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var plugins_toast = __webpack_require__("3BeM");

// CONCATENATED MODULE: ./src/main.js



















console.log(config_default.a);






































vue_esm["a" /* default */].prototype.$http = plugin_axios;
vue_esm["a" /* default */].use(vue_cookie_default.a);
vue_esm["a" /* default */].use(base64_default.a);
vue_esm["a" /* default */].use(lrz_bundle);
vue_esm["a" /* default */].use(plugins_toast["a" /* default */]);
vue_esm["a" /* default */].component('vueSignature', main["a" /* default */]);
vue_esm["a" /* default */].use(loading["a" /* default */]);
vue_esm["a" /* default */].component('flexbox', flexbox_flexbox["a" /* default */]);
vue_esm["a" /* default */].component('flexbox-item', flexbox_item["a" /* default */]);
vue_esm["a" /* default */].component('group', vux_src_components_group);
vue_esm["a" /* default */].component('cell', vux_src_components_cell);
vue_esm["a" /* default */].component('cell-box', vux_src_components_cell_box);
vue_esm["a" /* default */].component('x-button', vux_src_components_x_button);
vue_esm["a" /* default */].component('x-input', vux_src_components_x_input);
vue_esm["a" /* default */].component('selector', vux_src_components_selector);
vue_esm["a" /* default */].component('button-tab', src_components_button_tab_button_tab);
vue_esm["a" /* default */].component('button-tab-item', src_components_button_tab_button_tab_item);
vue_esm["a" /* default */].component('checker', src_components_checker_checker);
vue_esm["a" /* default */].component('checker-item', src_components_checker_checker_item);
vue_esm["a" /* default */].component('x-dialog', vux_src_components_x_dialog);
vue_esm["a" /* default */].component('toast', toast["a" /* default */]);
vue_esm["a" /* default */].component('search', vux_src_components_search);
vue_esm["a" /* default */].component('x-table', vux_src_components_x_table);
vue_esm["a" /* default */].component('load-more', vux_src_components_load_more);
vue_esm["a" /* default */].component('grid', src_components_grid_grid);
vue_esm["a" /* default */].component('grid-item', src_components_grid_grid_item);
vue_esm["a" /* default */].component('group-title', vux_src_components_group_title);
vue_esm["a" /* default */].component('icon', vux_src_components_icon);
vue_esm["a" /* default */].component('x-icon', vux_src_components_icon);
vue_esm["a" /* default */].component('popup-picker', vux_src_components_popup_picker);
vue_esm["a" /* default */].component('msg', node_modules_vux_src_components_msg);
vue_esm["a" /* default */].component('datetime', vux_src_components_datetime);
vue_esm["a" /* default */].component('x-textarea', vux_src_components_x_textarea);
vue_esm["a" /* default */].component('panel', vux_src_components_panel);
vue_esm["a" /* default */].component('scroller', node_modules_vux_src_components_scroller);
vue_esm["a" /* default */].component('datetime-view', vux_src_components_datetime_view);
vue_esm["a" /* default */].component('tab', src_components_tab_tab);
vue_esm["a" /* default */].component('tab-item', src_components_tab_tab_item);
vue_esm["a" /* default */].component('x-img', vux_src_components_x_img);
vue_esm["a" /* default */].component('confirm', node_modules_vux_src_components_confirm);
vue_esm["a" /* default */].directive('transfer-dom', transfer_dom["a" /* default */]);
vue_esm["a" /* default */].component('x-header', vux_src_components_x_header);
vue_esm["a" /* default */].component('data-time', vue_date_time_m_default.a);

window.host = api_const_default.a;
window.axios = plugin_axios;
window.Api = repository;
window.py = libs_py;
window.Util = libs_util;
window.Conf = config_default.a;

restoreFromCookie(src_store, { module: 'app', mutation: 'SET_USER_INFO' }, { token: 'token', id: 'id', store_id: 'store_id' }, vue_esm["a" /* default */].cookie);

fastclick_default.a.attach(document.body);
vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].directive('drag', { bind: function bind(el, binding) {
    var oDiv = el;
    var flag = false;
    var cur = {
      x: 0,
      y: 0
    };
    var nx, ny, dx, dy, x, y;
    function down() {
      flag = true;
      var touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      cur.x = touch.clientX;
      cur.y = touch.clientY;
      dx = oDiv.offsetLeft;
      dy = oDiv.offsetTop;
      return false;
    }
    function move() {
      if (flag) {
        var touch;
        if (event.touches) {
          touch = event.touches[0];
        } else {
          touch = event;
        }
        nx = touch.clientX - cur.x;
        ny = touch.clientY - cur.y;
        x = dx + nx;
        y = dy + ny;
        if (x < 0) {
          x = 0;
        } else if (x > document.documentElement.clientWidth - oDiv.offsetWidth) {
          x = document.documentElement.clientWidth - oDiv.offsetWidth;
        }
        if (y < 0) {
          y = 0;
        } else if (y > document.documentElement.clientHeight - oDiv.offsetHeight) {
          y = document.documentElement.clientHeight - oDiv.offsetHeight;
        }
        oDiv.style.left = x + "px";
        oDiv.style.top = y + "px";

        document.addEventListener("touchmove", function () {
          event.preventDefault();
        }, false);
        return false;
      }
    }

    function end() {
      flag = false;
    }
    oDiv.addEventListener("mousedown", function () {
      down();
    }, false);
    oDiv.addEventListener("touchstart", function () {
      down();
    }, false);
    oDiv.addEventListener("mousemove", function () {
      move();
    }, false);
    oDiv.addEventListener("touchmove", function () {
      move();
    }, false);
    document.body.addEventListener("mouseup", function () {
      end();
    }, false);
    oDiv.addEventListener("touchend", function () {
      end();
    }, false);
  }
});
new vue_esm["a" /* default */]({
  router: src_router,
  store: src_store,
  axios: plugin_axios,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "Ne3k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Otsi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P3La":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P5P0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P7KP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PJ5E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PMTo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q1vz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q68+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAMWklEQVR4XuWbeZQU1RXGf7d6GFwGF5RoosQt7hoXjEsQusAt6oknbsRdunqQGDf0YFwwBxB3E/eoRLobXFBwiUuOGjVO9UhEQ4x71BNFRqM5QpQIo8hMd92cV9Pd1PRU91TPtJPkWP/Mmar77rv3e/e9d9/3bgvf8Ee+4f4z4AAcO19jn61ig3wnG+ZhaIPF2rkYy7FYtulglt4/TvIDOShfOwCjM7qrpfwQ5Qcq7I2yswhWmJOqeMC7CG+gvCLQMmwIC79OUOoOgBnhT1ZyuAiHCxwObNavEVXaEZ5U4U7ZkifcMZLrl76yxnUD4MCZun5uEBNQzkHYvJ5GFnUpLBXltoYc1z8zUT6vRx91AcBO6YkId9fDoCg6VFkpwk0rO7nipYnyZZQ2lWT6D4Cq2Gk+6GXUP0J5QaENoc0yf5UlatHmJuTfReP2m6VDG2OMEGUfhUOB/YTKC7XCBxac3eLII30FoS4AxDO0CQwPGqFKJ8JjKqRa23iSaWIWuJoee6ZurA0cKcLRKAcgNIQunjC3o4nmheNkVU0dUAXdWhTZKR2vwo0C6xXanU8ns92J8q9a9FSTte/QzdXiCoSTwqJClbdEOcJtlndr6bP/EVDobWRKhwzKMbieToc5Mma2jlCPmcCIkO+f5mOMfe5UeS0qCL0CMGKmrjOkgZ1yg1i64BT5IKrir1VOVeJpmkW4Hli329SDFRYc3OLIi1FsqAxA1+I2FZgSmHvZVY0c8eJJsiKK8q9bZnRGtxXlQYFdy0FQYa/WhPy9NxsqAhBP6+kCt5YrUPhreyf7vjRROntTPhDfD75T112d4wmBUWX9LckNZs8FJ8ryanZUBMBO6dsI24euuspR2aT8biAcjNLHoTfp4C+beEjgsG7yygLXYTQiWklPOABmjmXIV9yDlYvcpFwVxbiBktlvvq49uJ3ngd3LpsPUrCOX1gYAEE/rlwJr/z9EQNHGUXfpt2MdvIywSfGdf8Cy2DebkEVhvlSeAmkNDxulbfUQduxL0jEQ0WCn9UCFp8qi90XXkX0jA2DP0l2weL3HAqi8ZsU4oWW8vFkPZ8yIsZrhg/O8U6/DjbErntarBX5RZuNxriPzyu0OjQA7pc8gHBAU9pSftjrcX21BiQKKndENUM5EORXhe6VQhUWipFfmSPV3h/EXxXV5S4StAvr/lnVk514BGJXWnWJQPsKXuI5cHsXBSjL+cbmRSaqcF0iZe4ibAw5weXsnmf4AEc/oQaI8VbYrjHKTsiD4rkcExFP6WxEmBJD7cJ12tn3ibFndFwD8FFk4B2Uywvo16FiCchlbM6evJIid1heAfQJ9znMdOa4iACbtbWpgmQjrlISUc92k3FCD4b6oPV+btJ2zjOMiDK21fWAAFosyY9gQ7qqVGotn9FhR5gd2hE4ZwlB3nLQX33WLAHOqQ8gEtxBP2PQ5R5ZFdcAHcZA/xy/oj+Mhc+Ndtbg028Y9UY/Whp5b2s4ygQ0DA9rsJiUVCkA8rWmBRAD9x7KOHBHFeT8RWcnPgQsRNo7Spk8yyjuexaWtbdwXBQg7pbcgnBHw6aGsI0eHA5DSd0TYLmDYBNeRWdUMtTO6Fh4/U+EigW/1yak+NPLP/8J0N8H8ajtT+WKo8GHWke/2AOCAObpRPk93AkPY0U3I25XsG5PS3Tx4XITv9MGHujRR5WVPOKTSNN3nbl1vrdUsD1LxHQ1s8vwpstQYUFoDxqT1EIUnA6GyPOtI5cVrmlr2cBYjbFEXT/qjRHnYTcqRlVTYKX0dYZfid085pDUp/hZZAiCe1oRAOgDA81lHRlZSOiqtw2Lgo/jffsrDutyeeFrNSXENQMrpblJuLwfAzOErAo0fcB05tur8r3JkHkhQVLk2m5Ty1LdkQjyt1wmcGxjca7KOXFAOgCE1zy4JKTdnk1L6P8yhMSnd3hOuEDhqIB0OONIhyq3DhjC5Wo4QT+n5IlwTaHdb1hGzYwWmQErvFOHkAABTskkJRkRFH+2M7q4e00WItGX2FyxDuYuQtmLMePZU+ag3ffGUnmUuUgJys1xH/Gy3tAbYKZ2FkCwJCRe6Cbm6N+XB7z5jm2c64t8J1v9Rcgizcw3MqIWgjaf1NMFnkv1HlTuzSTm1HIDyhKEqk1LNu1GzdO+Y+ED8qC4oKDkV7tI8M1onyPu16rTTOhm4NgDArdmk+MlRcBcwc/migPJfu46YhtVCv+toKyxwE+KWC9oZ3VeVSwUOqtXogrypFbjbyzO9h+PT1Bo9nGNiwuctCZ6qlgzZaTX0nb/odYUA092kTCsHoHuYwP1ZR8ZVBSClixD2Kshk8TjTbZY3ytuMma0jPc8HYmwUIAyNJcJcPKaH3fSYnMVTrhdhxy5/KC1qYfrLp7cKZ2QT4jPeayKg7PyssCjryN6VDC6c9lYEqScFFbjHg4tbHfmwR0SkdH/gSgTzt8fj83fCPEuZ3pKUd3q072KqbjGkT7dvyj/cpHS7mwx+t9NqorPURoUjsgl5rBsAPqHYycelKFE623OsW42UiKd1rsDxPT1hNcLNqxqZEXaJYhsghInadVbfHMVQ8E+LkAlLvcfO0c3yeWYA40OZamGSm5AbKw1WD4K3k2HFK7zux+G0mgVmyxIIwt6V2FRfZppa8S040RAXAqUDxpqpxnKTXC1r4qY3x0lHlPAPyhTIFJPgmLVorRCg3/BgSmtSHq0YqRndAeWtwPclriMlqqwbAPGUzhHhlJJwxK1wxEwd1NToV4dMDT0Rql8XcImb4J4onKLdog0splnFXzeGhTj3nunLdZjbmz47pZPoukP0H4V7s46cUPy/GwCjUzrOEoLM6SuuI3tEHTnDCTS2c5YoF4fSX8obIpzZ4ki2Yrhm9Md4/KrsWN5lvPKxwAy2ZlZUmszuvlCDx/Fus9wXCkDBgU+7XYh47Bq2slcDpVAvNNknQIP02ppGf8BjclCvySbxMLlI2AHsU+Cqtdu5uRZucuxs3cbzKNULKHR0NLFB8E6jBylqp/RuhBMDDpbSxqiRUJQrnBinKJiL1sby9qr8GcEQl/sL7BnyfaUJX2ni2iCPV9WOrms9Mx3PEOH7QVmFx7OOdMtSwwDYC2HNNZKyOuaxxR8nyCe1AlCUH53W4ZYyFWE8EIug5ytVbu1QLl/YLJ9FkC+JxNNafqotfQtuf6FToPjSTuvTwIGlhUO5K5uUNYtjLRYFZPefo9vFcswQITzBMikvZLxGpj53svyz1m7MYjxkEKZ2oeeOAazspLF8Ww+9GTKZm3p0u0BQZWw2KS21GhUm79f7xDhKFLPAbqqwWGDRauXRWkc8qL9QPvOXSjZ6MLLVEXODXHoqF0ikdF5wpFR5f50v2LGWRageYNWiY/QdupUVY3HFNh7blqfWFQEYO0u3yFu8FdwRFK7MOnJxLUYNtKyd0iVhPKUqr2WTslu5PVWLpOy0NgN3BNYCz4JxLUl5cKAdi9qfv50qzwAbBez+2ILDWpLyak0AGGE7pfcirLlP6yIljnQd+X1UowZazuw60pU+b4XyWHuOeyqV1PZaJlc49b0osNOa/YScCMf0p0R1oEGp1F+vAJiGBURfCubl/pkdzijSy/8rDtVqRyQAjNJRad0zhn/fXppb5r3C3MENnPbUKfJFrZ33R97O6A7qcSPCEs1zQ+sECZ74IquODEAxEqwuEHbo1oPS5lmc15qQhyL33EfBQrJzgcIvi+m1qV3MOhJWOttrLzUBYLT5hYmdzK1AgT8jFpPqVUNUbr3PMXqki1RY4PunriN9upGuGYBip3ZGL8DjsvIS9gKfl0aZ4zr8qbfzem9DtPN8bRzWzpEKhrMM5RQVSjc9vemreRusprCQej4QZJGC8uYnLiiPqMXDX3TwdKSaH1UZO4etPY89VNnPp8EqVJgYfgCLSdmE3F+r40X5PkdAKRJMKcxKzAXKBBEGVTHkK+BVcwQW8E94CpYI66F+7dAGKn59wS7ViqgK+vMKv5EmpkQ+JlcwrN8AFPUaUtXq8IskEghNfR2Rau0UVokyz7O4rjUhPeoY+9Jn3QAodl5glX4i6nOLYxAG98Wwsl3GUOS3YzE7+Bujfuut109mKhliCha/aGKkZYBQv0BhFxW2qfZDKMDcBr2usBBhYUx4/tnx8l49nA3TUfcI6M1Qn/FdwsYeDIspQ/PQaXmsyDWyoiHPCnc8n/d35+jNhuD3AQegFuMGQvYbD8B/AM4A5X2b7BBuAAAAAElFTkSuQmCC"

/***/ }),

/***/ "Q7uw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QJDj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QQJx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QlJb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R37A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RSXB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RsuY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/baby_6.7237a40.png";

/***/ }),

/***/ "T2s0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T5Vs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Te/k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UGZS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UNFf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ub/c":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAoElEQVQ4T82SUQ3DMAxEXSMohEE4KIMwCIUyCIMwKAdhEIrgVLlKJitLt1X9aT6b3pPfOYMdPMPBvJ0QAGAMLZJz1tv6/qEA4OLuD0nXComwuz8l3Ui+MrjbAQC4+z0g8XMJTyTZlr5ZYoVEQFI3HHffAOvYBfDW+WuC5DwVhVWnLbY7QQ5X59xJC+ltIdY4tm3Hdsxs/gnY+7RP+JT3KixBJlkRmxEskgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "UeZg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/baby_2.a4c5fe2.png";

/***/ }),

/***/ "UiQC":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Uz5z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VDa7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vizg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/baby_1.5ed846c.png";

/***/ }),

/***/ "W9Hj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/baby_5.339e103.png";

/***/ }),

/***/ "WZDK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wh6R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpgC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XDUe":
/***/ (function(module, exports) {

module.exports = [{"name":"actionsheet","icon":"&#xe624;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"alert","icon":"&#xe603;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"badge","icon":"&#xe65b;","color":"#f74c31","category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"blur","icon":"&#xe640;","category_en":"Deprecated","category_zh-CN":"不再维护","category_order":998,"hasHome":false},{"name":"button-tab","icon":"&#xe659;","items":["button-tab","button-tab-item"],"category_en":"Navigation","category_zh-CN":"导航","category_order":998,"hasHome":false},{"name":"calendar","icon":"&#xe62b;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"card","icon":"&#xe658;","category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"cell-box","icon":"&#xe62a;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"cell-form-preview","icon":"&#xe62a;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"cell","icon":"&#xe62a;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"check-icon","icon":"&#xe619;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"checker","icon":"&#xe655;","items":["checker","checker-item"],"category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"checklist","icon":"&#xe61d;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"clocker","icon":"&#xe620;","category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"color-picker","icon":"&#xe63f;","color":"#f2c400","category_en":"Deprecated","category_zh-CN":"不再维护","category_order":999,"hasHome":false},{"name":"confirm","icon":"&#xe608;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"countdown","icon":"&#xe653;","category_en":"Deprecated","category_zh-CN":"不再维护","category_order":998,"hasHome":true},{"name":"countup","icon":"&#xe63e;","category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"datetime-range","icon":"&#xe60a;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"datetime-view","icon":"&#xe60a;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"datetime","icon":"&#xe60a;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"divider","icon":"&#xe65d;","category_en":"Layout","category_zh-CN":"布局","category_order":998,"hasHome":false},{"name":"drawer","icon":"&#xe62a;","category_en":"Navigation","category_zh-CN":"导航","category_order":998,"hasHome":false},{"name":"flexbox","icon":"&#xe61f;","items":["flexbox","flexbox-item"],"category_en":"Layout","category_zh-CN":"布局","category_order":2,"hasHome":false},{"name":"flow","icon":"&#xe656;","items":["flow","flow-state","flow-line"],"category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"form-preview","icon":"&#xe699;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"grid","icon":"&#xe661;","items":["grid","grid-item"],"category_en":"Layout","category_zh-CN":"布局","category_order":998,"hasHome":false},{"name":"group","icon":"&#xe62a;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"icon","icon":"&#xe619;","category_en":"Basic","category_zh-CN":"基础组件","category_order":998,"hasHome":false},{"name":"inline-calendar","icon":"&#xe62b;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"inline-loading","icon":"&#xe610;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"inline-x-number","icon":"&#xe605;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"inline-x-switch","icon":"&#xe61c;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"load-more","icon":"&#xe610;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"loading","icon":"&#xe610;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"marquee","icon":"&#xe662;","items":["marquee","marquee-item"],"category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"masker","icon":"&#xe651;","category_en":"Deprecated","category_zh-CN":"不再维护","category_order":998,"hasHome":false},{"name":"msg","icon":"&#xe619;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"panel","icon":"&#xe658;","category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"picker","icon":"&#xe627;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"popover","icon":"&#xe65f;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"popup-header","icon":"&#xe654;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"popup-picker","icon":"&#xe626;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"popup-radio","icon":"&#xe60f;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"popup","icon":"&#xe61e;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"previewer","icon":"&#xe65c;","category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"qrcode","icon":"&#xe65a;","category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"radio","icon":"&#xe60f;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"range","icon":"&#xe60b;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"rater","icon":"&#xe606;","color":"#FF9900","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"scroller","icon":"&#xe641;","category_en":"Deprecated","category_zh-CN":"不再维护","category_order":999,"hasHome":false},{"name":"search","icon":"&#xe63b;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"selector","icon":"&#xe607;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"spinner","icon":"&#xe610;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"step","icon":"&#xe65e;","items":["step","step-item"],"category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"sticky","icon":"&#xe623;","category_en":"Layout","category_zh-CN":"布局","category_order":998,"hasHome":false},{"name":"swipeout","icon":"&#xe641;","items":["swipeout","swipeout-item","swipeout-button"],"category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"swiper","icon":"&#xe612;","category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"tab","icon":"&#xe615;","items":["tab","tab-item"],"category_en":"Navigation","category_zh-CN":"导航","category_order":998,"hasHome":false},{"name":"tabbar","icon":"&#xe657;","items":["tabbar","tabbar-item"],"category_en":"Navigation","category_zh-CN":"导航","category_order":998,"hasHome":false},{"name":"timeline","icon":"&#xe656;","category_en":"DataDisplay","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"toast","icon":"&#xe625;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"uploader","icon":"&#xe699;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"v-chart","icon":"&#xe663;","items":["v-chart","v-line","v-area","v-bar","v-pie","v-point","v-scale","v-axis","v-guide","v-tooltip","v-legend","v-guide"],"category_en":"Chart","category_zh-CN":"图表","category_order":998,"hasHome":true},{"name":"view-box","icon":"&#xe641;","category_en":"Layout","category_zh-CN":"布局","category_order":998,"hasHome":false},{"name":"wechat-emotion","icon":"&#xe63c;","category_en":"Deprecated","category_zh-CN":"不再维护","category_order":999,"hasHome":false},{"name":"x-address","icon":"&#xe61b;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"x-button","icon":"&#xe616;","category_en":"Basic","category_zh-CN":"基础组件","category_order":998,"hasHome":false},{"name":"x-circle","icon":"&#xe63d;","category_en":"Chart","category_zh-CN":"图表","category_order":998,"hasHome":true},{"name":"x-dialog","icon":"&#xe608;","category_en":"Feedback","category_zh-CN":"弹窗提示","category_order":998,"hasHome":false},{"name":"x-form","icon":"&#xe699;","items":["x-form","x-form-field"],"category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"x-header","icon":"&#xe654;","category_en":"Navigation","category_zh-CN":"导航","category_order":998,"hasHome":false},{"name":"x-icon","icon":"&#xe619;","category_en":"Basic","category_zh-CN":"基础组件","category_order":1,"hasHome":false},{"name":"x-img","icon":"&#xe602;","category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"x-input","icon":"&#xe614;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"x-number","icon":"&#xe605;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"x-progress","icon":"&#xe618;","category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"x-switch","icon":"&#xe61c;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false},{"name":"x-table","icon":"&#xe66d;","category_en":"Data Display","category_zh-CN":"数据展示","category_order":998,"hasHome":false},{"name":"x-textarea","icon":"&#xe611;","category_en":"Form","category_zh-CN":"表单","category_order":998,"hasHome":false}]

/***/ }),

/***/ "XGdK":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "XMBc":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABVUlEQVR4Xu2aMU7DQBBF/6eh5BAUNHAFElHRwBEieVPTc4X0tAm5A0gJ3aalTBoKDsEJMrTISGhkXNgz3/UWO2/fnx1pTST/mLx+CIAMSE5AEUgugJqgIqAIJCegCCQXQLeAIqAItAjcrO38eMRnODCGdZ2zadf1KwIC8MMAM2wIvI/chkcQp+howEMtfBozgOnSvkCcCYAM6NYEFQH1gFYTnKysITADsagNt0NvkL03wcnK9gSuDHjZFd6nAzBd2geICwBvtfBWAAZOoPcIyABFQD1ATVC3gK5BzQEahDQJJh6FDyAuAbzWwruBT8LofRS+frZyYpiZYbGbc5MOwNALbu+vdwMEYGQEZIDeBf7xMKKnsZHl/c/tdnwZioPACyBOxb5K9IuMj1PcVTIg7tn6KpMBPk5xV8mAuGfrq0wG+DjFXSUD4p6trzIZ4OMUd1V6A74B56TeUC2MSZEAAAAASUVORK5CYII="

/***/ }),

/***/ "XNOG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XZOv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YRdQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YqUT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f37d428","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("M5Ib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zarb":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAR0lEQVQ4T2NkwANSUlIcQNJz5sw5gEsZ46gBDIMgDEBRxcjI+B9HbBhAxS/gjEZYXGNTwMTEBDbg379/uA0YTQeDIR1QGgsASblA6wZ2o+EAAAAASUVORK5CYII="

/***/ }),

/***/ "ap5H":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "at4z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/menu_2.450b8c2.png";

/***/ }),

/***/ "bsmt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cu/V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d8/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eDIT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eh36":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ezv9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fFU4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fPd8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fwaT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g016":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gA6p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gZ0m":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAADwElEQVR4Xu2az2tUVxTHP2di6MIUsa31RwNV2kU3tSBIU2WSF1EkKFm6K8UZg/0HXLQK6iK6cVVcCJoZ0bVIlwWJb0xodCEJipBFaCnUHyWpIIq0JnlH3jiTH+Pk3ZfkhffezH3bdzn3fL/ne889994jNPknTY4fS4BVQJMzYJdAkwvAJsFQS8Ap6haUy8B3wMcJV82/wAhCn3tUnpl8NRKQLeimFngAbDEZS9j/Z7Owcygnk0F+GQlwCnoV+CFh4EK5o8q1Ul4CfTcTMKCTCJ+UZ1T+AS6Fmj2+QT8ibK74O+XmZdNqFaBVA6qcK+XlZHzYzDN3DWi/CD9XR7o5CQyyWQEFnSMA5ayblzNmN+Ib4QzoGYTTloAKA1YBdgnYHGCTYGTboN0F7DYYXx3gXNEvaeGV6YDTkHVAd0G/9ZRBgUkydASR0HAE+OBVuYXQVqnvJ2aFPUud8hqKgGxBd7UopTnw8+n8lJuT/nrZvWEIqIAfRNhQA/Q3dnDY7ZaZhiWgs6hfZzyG6oGfbKP30RF5s9TennoF+OBFKQlsXAhSYXCqjZ4g8P74VBPgFPUrVX6vBY8yTIYD7lH5z3TQTi0BFfB3BBbf4CjDL2c4eP+4vDaBT60C/CJHM+XI115f3Xs5zb6w4BNBgHNb18mfHLqdk19DRcyv8DIM1bl1vkcb+90j8iqMneqYWJeAD17/4IYIvcAFNycngpx3irodZaQWvCqj8iGdywUfqwJqwFdxL0lCGfy7ra59UbZXRltn6L51XF4sJ/KxK2DfVf3Cm2WsTtX2HgnOZW0nU369WQweHrZOk10p+FgV4E/eVdTd4uFXb+/q9vlvjoQK+GGEz2v2+YdvPJyRY/J8JZGPXQFVBwJIuIjQj8fdWvDA+P8ee1cLPnYFGElQXtQpb8dnodP0hhdWFbHuAgudDFDC/DAl8GgbFvTCcYkhwJAT/HfGCTJkTTc8yyUhUQQsSYLyl+lmZ7nAE5ME6znuFLUD5aZf8JSLHI9et0/+XinIwOIqqW+DPb/oB6/Xs6uU83cBmX9wjZiFxC2BiPEZzVkCkroEjKGLaIBVgFWA7RCxLTK2R2itmqQUzpdyMteCFlHijtRMV0HPCfxUNbrqJqmuAX0swraywZQ1SqrypJSXz4IYDtMn2Nytsnuu6aet04yJsDVSra6xMVWeesI3posWowJ8P7PXdWtmmisoHSJ8tMa+r8q8Ks8R7nqtHBv6Xp6ajIUiwGQkzf8tAWmOXhS+WwVEwWKabVgFpDl6Ufje9Ap4C55/sl8rMMAbAAAAAElFTkSuQmCC"

/***/ }),

/***/ "gZbD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gsj7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hK0y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hW8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hqDL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hvNj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i/tN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "i9fr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iJRN":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ibYt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jHXy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jqw6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kalI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAECUlEQVRoQ+2Y644URRTH/9Xb3cSErAufNO6UQbM71fAEqMQQLi/gXYL4At4iAXkBLxgI4AuoMcjNB/AaosATqNOzIMbqWYyJIgFWQlVPHzNxp3u2d3areop22WTn087UOf9zfnWqzulehlX+Yas8f6wBrHQFnSsQ85BcIIRUTjk4OfcSXwNYq4DLAb4PfJ3vwEozrAHcdxVwbYt1A5XnxqIjNAyAzY8q+p8O3HLxqgHQfObsv8yJCGz+77p2ekGMUvxezGoAdWXpoGsEGNRu8eASA9va/81Dtntapl87xDe6thr+bsa8LwtDuiSkfnIpx2VPdYuH5xjwTN+ZgV5tSv2JMQsHgzYP9hHYx30JAr6IpHp2JIA2D04Q2GsFQHaoKdP3HfIzura4f4jBe3dg0z5qSv36SABlMYBOCKnfMGbhYFB105Y9QuVyAjgnpHrOIT+j65Bju68p9acjVWCG+7syeF8NXKiLQuqnjFk4GMQ8uAiwJwYax65pmX4zEsBlHm7pAj8OOF8VUj0+TKw8AMvtzrTe14x5eBXApv73MWDLlFQ/jwSQTGLjnBf+VXQE0pHUYZ0ALR4oBhb0YzwAtfFRib9HAug5tRqBZoz5fYF1N9WGTTdwoyxo2mHTek/vN44NdxBezzeMKI0SncMMgzA+3ZRL6mm1efp3tOoAqHJkizZruHDlS8W62c7mbPptHQAz3N+ZwSsmPdEFkehty6VoU4GzAIpJmGGv6KjP6gBo8+AVAismPdEZkegXHAGC4wArJmGWHRCd9MM6AGLuHwS8YtJndFx09JtOAG3uv0Pw3stFiI6JRL9VD8CizTooOulhR4BFZT0tEv1iPQDhGQDFpF/iuA7GNt6B8sUiou+jRD9dD0BwAWDFo3M32yFm0++cKnCZh5u7wE9Fb8aVKFFT9QCEvwB4LG+RqYqa1xA7AQwZLnNRotfXAVCewmO31YNT13HTCWDYNMY/alz8iVuDwqZJa1r/dQITd8fD/JGBLKZwL77xDvSMYr6wtEiVENfQvpcAtke1XA1LgIWXi7Jse9RJzxuGeKXl9iP+Dhrz8sfmpZrFiAAL2xsRXo4S9XmlDA3GbR7sJbD8xYWITkWJfskUw64Ck8ExeCx/lSTK9kdJesQkXmU9nvQPwPM+KLodHY0S/bZJww6gNOKJ6EiU6P0m8Srr8YibZAVQLi+ITopE76mSoMk2bgSnwdjzeQUy7Ik66qTJzw6gdMFAdF4kertJvMp63Ah+AGP5+7Zto7ACmHkYURaES76XVknU1pa6qhnNYsZkbwVQHjIm0XuxPnFXrX/oD8yZtKwAhk5jk7LTOt0SUo/bSFgDxI3wChiG/kvFJlBFm7aQStj4WAPYiK2EzaoH+BcNOSlPOXrH2wAAAABJRU5ErkJggg=="

/***/ }),

/***/ "kbqr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kwyy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lWZV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lvdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m1Fl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner.a0502e8.jpeg";

/***/ }),

/***/ "n37m":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/baby_4.dc6d28a.png";

/***/ }),

/***/ "nH59":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "nLpc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "np8t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nsZj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oHqA":
/***/ (function(module, exports, __webpack_require__) {


var pad = {};
// 使用环境变量配置 API 地址（不包含路径）
// development/test 环境: 使用相对路径 /api.php（走代理或同域）
// production 环境: https://test.erp.duobaby.net
var apiHost = 'https://test.erp.duobaby.net';
// pad.host 保留用于兼容性
pad.host = apiHost;
// pad.baseUrl 是完整的 API 基础路径
// 开发环境和测试环境：使用相对路径走代理 /api.php（避免跨域）
// 生产环境：使用完整路径 https://test.erp.duobaby.net/api.php
var isDevelopment = "production" === 'development';
var isTest = "production" === 'test';
// 判断是否使用完整路径：
// 1. 生产环境：使用完整路径
// 2. 开发环境但 API_BASE_URL 以 http 开头：使用完整路径（用于本地运行正式环境）
// 3. 其他情况：使用相对路径（走代理）
var useFullPath = !isDevelopment || apiHost && apiHost.startsWith('http');
// 开发环境和测试环境使用相对路径，生产环境使用完整路径
pad.baseUrl = useFullPath ? apiHost + '/api.php' : '/api.php';

console.log('apiHost', apiHost, 'pad', pad);
// baseRequestUrl 用于 axios baseURL 配置（开发环境和测试环境使用相对路径时为空字符串）
pad.baseRequestUrl = useFullPath ? apiHost : '';
pad.loginUrl = pad.baseUrl + '/Login/login'; //登录
// pad.loginUrl = pad.baseUrl + '/Login/externalLogin'//外部登录
pad.checkLoginUrl = pad.baseUrl + '/Login/CheckLogin'; //监听用户状态
pad.getUserInfoUrl = pad.baseUrl + '/Erp2Member/agentInfo'; //获取用户信息

pad.getFormTypeList = pad.baseUrl + '/FormRecordNurs/getFormTypeList'; //获取所用表格列表
pad.getAgentList = pad.baseUrl + '/FormRecordNurs/getAgentList'; //获取查房/填写人列表
pad.getFormDataList = pad.baseUrl + '/FormRecordNurs/getFormDataList'; //获取查房记录相关表格数据列表
pad.momEvaluationSheetUrl = pad.baseUrl + '/Form/mom_evaluation_sheet'; //妈妈入住评估表
pad.setMomEvaluationSheetUrl = pad.baseUrl + '/Form/set_mom_evaluation_sheet'; //提交妈妈入住评估表
pad.member_listUrl = pad.baseUrl + '/Member/member_list'; //孕妇列表
pad.detial_memberUrl = pad.baseUrl + '/Member/detial_member'; //孕妇详情
pad.babyListUrl = pad.baseUrl + '/Child/get_child_list'; //获取宝宝列表
pad.roundFormListUrl = pad.baseUrl + '/Data/get_round_form_list'; //获取所有查房表
pad.livingMemberTopUrl = pad.baseUrl + '/Member/living_member_top';
pad.getGroupListUrl = pad.baseUrl + '/Form/get_round_list'; //获取查房表记录
pad.roundAllListUrl = pad.baseUrl + '/Form/round_all_list'; //所有查房记录
pad.addRecordFormUrl = pad.baseUrl + '/Form/get_form_detail'; //添加/编辑记录表单
pad.setOtherFormUrl = pad.baseUrl + '/Form/set_other_form'; //其他表单答案上传
pad.setRoundRecordUrl = pad.baseUrl + '/Form/set_round_record'; //查房记录答案上传
pad.detailOtherFormUrl = pad.baseUrl + '/Form/detail_other_form'; //其他表单详情
pad.babyEvaluationSheetUrl = pad.baseUrl + '/Form/baby_evaluation_sheet'; //宝宝入住评估
pad.setBabyEvaluationSheetUrl = pad.baseUrl + '/Form/set_bady_evaluation_sheet'; //宝宝入住评估答案上传
pad.getBabeMedicationListUrl = pad.baseUrl + '/BabeService/getBabeMedicationList'; //获取宝宝服药登记列表
pad.addBabeMedicationListUrl = pad.baseUrl + '/BabeService/addBabeMedication'; //添加宝宝服药登记列表
pad.getBabeSignListUrl = pad.baseUrl + '/BabeService/getBabeSignList'; //获得宝宝体质记录信息
pad.addBabeSignUrl = pad.baseUrl + '/BabeService/addBabeSign'; //添加宝宝体质记录
pad.getBreastMilkRecoredUrl = pad.baseUrl + '/BabeService/getBreastMilkRecored'; //获得母乳存放记录
pad.addBreastMilkUrl = pad.baseUrl + '/BabeService/storeBreastMilk'; //添加母乳存放记录
pad.getBabeFeedRecoredUrl = pad.baseUrl + '/BabeService/getBabeFeedRecored'; //获得宝宝喂养记录
pad.addBabeFeedRecoredUrl = pad.baseUrl + '/BabeService/addBabeFeedRecored'; //添加宝宝喂养记录
pad.otherFormListUrl = pad.baseUrl + '/Form/other_form_list'; //其他表单列表
pad.columnListUrl = pad.baseUrl + '/Form/column_list'; //获取对应字段答案
pad.leaveMemberUrl = pad.baseUrl + '/Member/leave_member'; //30天内离院的客户
pad.addBabyCareOperaDataUrl = pad.baseUrl + '/formRecord/addBabyCareOperaData'; //婴儿护理操作记录表添加
pad.getBabyCareOperalistUrl = pad.baseUrl + '/formRecord/getBabyCareOperaList'; //婴儿护理操作记录表查询list数据
pad.getBabyCareOperaFindUrl = pad.baseUrl + '/formRecord/getBabyCareOperaFind'; //婴儿护理操作记录表详情数据
pad.updateBabyCareOperaDataUrl = pad.baseUrl + '/formRecord/updateBabyCareOperaData'; //婴儿护理操作记录表数据更新
pad.addBabyNursOneDataUrl = pad.baseUrl + '/FormRecordNurs/addBabyNursOneData'; //婴儿护理记录单（1）添加数据
pad.getBabyNursOneDataListUrl = pad.baseUrl + '/FormRecordNurs/getBabyNursOneDataList'; //婴儿护理记录单（1）查询list数据
pad.getBabyNursOneFindUrl = pad.baseUrl + '/FormRecordNurs/getBabyNursOneFind'; //婴儿护理记录单（1）详情数据
pad.updateBabyNursOneDataUrl = pad.baseUrl + '/FormRecordNurs/updateBabyNursOneData'; //婴儿护理记录单（1）更新
pad.addBabyNursTwoDataUrl = pad.baseUrl + '/FormRecordNurs/addBabyNursTwoData'; //婴儿护理记录单（2）添加数据
pad.getBabyNursTwoDataListUrl = pad.baseUrl + '/FormRecordNurs/getBabyNursTwoList'; //婴儿护理记录单（2）查询list数据
pad.getBabyNursTwoFindUrl = pad.baseUrl + '/FormRecordNurs/getBabyNursTwoFind'; //婴儿护理记录单（2）详情数据
pad.updateBabyNursTwoDataUrl = pad.baseUrl + '/FormRecordNurs/updateBabyNursTwoDate'; //婴儿护理记录单（2）更新
pad.addBabyFeedingRecordDataUrl = pad.baseUrl + '/FormRecord/addBabyFeedingRecordData'; //婴儿喂养记录单添加数据添加数据
pad.getBabyFeedingRecordListUrl = pad.baseUrl + '/FormRecord/getBabyFeedingRecordList'; //婴儿喂养记录单添加数据查询list数据
pad.getBabyFeedingRecordFindUrl = pad.baseUrl + '/FormRecord/getBabyFeedingRecordFind'; //婴儿喂养记录单添加数据详情数据
pad.updateBabyFeedingRecordDataUrl = pad.baseUrl + '/FormRecord/updateBabyFeedingRecordData'; //婴儿喂养记录单添加数据更新
pad.addMaternalEverydayPhysiologyUrl = pad.baseUrl + '/formRecord/addMaternalEverydayPhysiology'; //产妇每日生理护理记录添加数据
pad.getMaternalEverydayPhysiologyListUrl = pad.baseUrl + '/formRecord/getMaternalEverydayPhysiologyList'; //产妇每日生理护理记录查询list数据
pad.getMaternalEverydayPhysiologyFindUrl = pad.baseUrl + '/formRecord/getMaternalEverydayPhysiologyFind'; //产妇每日生理护理记录详情数据
pad.updateMaternalEverydayPhysiologyUrl = pad.baseUrl + '/formRecord/updateMaternalEverydayPhysiology'; //产妇每日生理护理记录数据更新
pad.addMaternalMealRecordsDataUrl = pad.baseUrl + '/FormRecord/addMaternalMealRecordsData'; //产妇膳食记录添加数据
pad.getMaternalMealRecordsListUrl = pad.baseUrl + '/FormRecord/getMaternalMealRecordsList'; //产妇膳食记录查询list数据
pad.getMaternalMealRecordsFindUrl = pad.baseUrl + '/FormRecord/getMaternalMealRecordsFind'; //产妇膳食记录单详情数据
pad.updateMaternalMealRecordsDataUrl = pad.baseUrl + '/FormRecord/updateMaternalMealRecordsData'; //产妇膳食记录更新
pad.addMaterRehNursEvalDataUrl = pad.baseUrl + '/FormRecord/addMaterRehNursEvalData'; //产妇康复护理评估记录单添加数据
pad.getMaterRehNursEvalListUrl = pad.baseUrl + '/FormRecord/getMaterRehNursEvalList'; //产妇康复护理评估记录单查询list数据
pad.getMaterRehNursEvalFindUrl = pad.baseUrl + '/FormRecord/getMaterRehNursEvalFind'; //产妇康复护理评估记录单详情数据
pad.updateMaterRehNursEvalDataUrl = pad.baseUrl + '/FormRecord/updateMaterRehNursEvalData'; //产妇康复护理评估记录单记录更新
pad.getFormStatusUrl = pad.baseUrl + '/FormRecord/getFormStatus'; //获取固定表单数据状态
pad.addNewBornCheckAssessDataUrl = pad.baseUrl + '/formRecord/addNewBornCheckAssessData'; //新生儿入住评估单添加
pad.getNewBornCheckAssessFindUrl = pad.baseUrl + '/formRecord/getNewBornCheckAssessFind'; //新生儿入住评估单详情数据
pad.updateNewBornCheckAssessDataUrl = pad.baseUrl + '/formRecord/updateNewBornCheckAssessData'; //新生儿入住评估单更新数据
pad.addNewbornFullmoonAssessDataUrl = pad.baseUrl + '/FormRecord/addNewbornFullmoonAssessData'; //新生儿满月评估单添加数据
pad.getNewbornFullmoonAssessFindUrl = pad.baseUrl + '/FormRecord/getNewbornFullmoonAssessFind'; //新生儿满月评估单详情数据
pad.updateNewNewbornFullmoonAssessDataUrl = pad.baseUrl + '/FormRecord/updateNewNewbornFullmoonAssessData'; //新生儿满月评估更新数据
pad.addMaterCheckAssessDataUrl = pad.baseUrl + '/formRecord/addMaterCheckAssessData'; //母亲入住评估单添加数据
pad.getMaterCheckAssessFindUrl = pad.baseUrl + '/formRecord/getMaterCheckAssessFind'; //母亲入住评估单详情数据
pad.updateMaterCheckAssessDataUrl = pad.baseUrl + '/formRecord/updateMaterCheckAssessData'; //母亲入住评估单更新数据
pad.updateMaternalLeaveProveRecordUrl = pad.baseUrl + '/formRecord/updateMaternalLeaveProveRecord'; //出院证明编辑/填写
pad.MaternalLeaveProveRecordUrl = pad.baseUrl + '/formRecord/MaternalLeaveProveRecord'; //出院证明详情
pad.updateMaternalHospitalChecklistRecordUrl = pad.baseUrl + '/formRecord/updateMaternalHospitalChecklistRecord'; //医院就诊单编辑
pad.MaternalHospitalChecklistRecordUrl = pad.baseUrl + '/formRecord/MaternalHospitalChecklistRecord'; //医院就诊单详情
pad.updateBabyFootRecordUrl = pad.baseUrl + '/formRecord/updateBabyFootRecord'; //宝宝足印编辑
pad.getBabyFootRecordUrl = pad.baseUrl + '/formRecord/getBabyFootRecord'; //宝宝足印详情

pad.matarnalHeathRecordUrl = pad.baseUrl + '//formRecord/MatarnalHeathRecord'; //（产妇）健康咨询记录表列表
pad.addMatarnalHeathRecordUrl = pad.baseUrl + '/formRecord/addMatarnalHeathRecord'; //（产妇）健康咨询记录表列表添加
pad.updateMatarnalHeathRecordUrl = pad.baseUrl + '/formRecord/updateMatarnalHeathRecord'; //（产妇）健康咨询记录表列表编辑
pad.getMatarnalHeathRecordUrl = pad.baseUrl + '/formRecord/getMatarnalHeathRecord'; //（产妇）健康咨询记录表列表详情

pad.BabyHeathRecordUrl = pad.baseUrl + '//formRecord/BabyHeathRecord'; //（新生儿）健康咨询记录表列表列表
pad.addBabyHeathRecordUrl = pad.baseUrl + '/formRecord/addBabyHeathRecord'; //（新生儿）健康咨询记录表列表添加
pad.updateBabyHeathRecordUrl = pad.baseUrl + '/formRecord/updateBabyHeathRecord'; //（新生儿）健康咨询记录表列表编辑
pad.getBabyHeathRecordUrl = pad.baseUrl + '/formRecord/getBabyHeathRecord'; //（新生儿）健康咨询记录表列表详情

pad.MatarnalSpecialNursingRecordUrl = pad.baseUrl + '//formRecord/MatarnalSpecialNursingRecord'; //产妇特殊护理记录列表列表
pad.addMatarnalSpecialNursingRecordUrl = pad.baseUrl + '/formRecord/addMatarnalSpecialNursingRecord'; //产妇特殊护理记录列表添加
pad.updateMatarnalSpecialNursingRecordUrl = pad.baseUrl + '/formRecord/updateMatarnalSpecialNursingRecord'; //产妇特殊护理记录列表编辑
pad.getMatarnalSpecialNursingRecordUrl = pad.baseUrl + '/formRecord/getMatarnalSpecialNursingRecord'; //产妇特殊护理记录列表详情

pad.babySpecialNursingRecordUrl = pad.baseUrl + '/formRecord/babySpecialNursingRecord'; //婴儿特殊护理记录列表列表
pad.addBabySpecialNursingRecordUrl = pad.baseUrl + '/formRecord/addBabySpecialNursingRecord'; //婴儿特殊护理记录列表添加
pad.updateBabySpecialNursingRecordUrl = pad.baseUrl + '/formRecord/updateBabySpecialNursingRecord'; //婴儿特殊护理记录列表编辑
pad.getBabySpecialNursingRecordUrl = pad.baseUrl + '/formRecord/getBabySpecialNursingRecord'; //婴儿特殊护理记录列表详情
pad.getCheckInfoUrl = pad.baseUrl + '/Form/get_check_info'; //获取查房人列表

pad.feedDrugEntrustUrl = pad.baseUrl + '/FormRecord/feedDrugEntrust'; //喂药委托书列表
pad.updateFeedDrugEntrustUrl = pad.baseUrl + '/FormRecord/updateFeedDrugEntrust'; //更新喂药委托书列表
pad.addFeedDrugEntrustUrl = pad.baseUrl + '/FormRecord/addFeedDrugEntrust'; //添加喂药委托书列表
pad.detailFeedDrugEntrustDetailUrl = pad.baseUrl + '/FormRecord/feedDrugEntrustDetail'; //详情喂药委托书列表

pad.confinementSenseListUrl = pad.baseUrl + '/FormRecord/confinement_sense_list'; //月子基本护理常识
pad.updateConfinementSenseUrl = pad.baseUrl + '/FormRecord/update_confinement_sense'; //更新月子基本护理常识
pad.addConfinementSenseUrl = pad.baseUrl + '/FormRecord/add_confinement_sense'; //添加月子基本护理常识
pad.confinementSenseDetailUrl = pad.baseUrl + '/FormRecord/confinement_sense_detail'; //详情月子基本护理常识


pad.getBatchMatarnalHeathRecordList = pad.baseUrl + '/formRecord/getBatchMatarnalHeathRecordList'; //健康咨询批处理 宝妈列表
pad.getBatchBabyHeathRecordList = pad.baseUrl + '/formRecord/getBatchBabyHeathRecordList'; //健康咨询批处理 宝宝列表

pad.batchMatarnalHeathRecord = pad.baseUrl + '/formRecord/BatchMatarnalHeathRecord'; //《新生儿健康咨询记录表》
pad.batchBabyHeathRecord = pad.baseUrl + '/formRecord/BatchBabyHeathRecord'; //《产妇健康咨询记录表》
pad.batchHeathRecord = pad.baseUrl + '/formRecord/BatchHeathRecord'; //健康咨询批处理 处理记录列表
pad.batchAddBabyCareOpera = pad.baseUrl + '/formRecordNurs/batchAddBabyCareOpera'; //婴儿护理操作记录表 处理记录列表

pad.batchAddBabyNursOne = pad.baseUrl + '/formRecordNurs/batchAddBabyNursOne'; //批量保存婴儿护理记录单（1）
pad.batchAddBabyNursTwo = pad.baseUrl + '/formRecordNurs/batchAddBabyNursTwo'; //批量保存婴儿护理记录单（2)
pad.batchAddMaternalEverydayPhysiology = pad.baseUrl + '/formRecord/batchAddMaternalEverydayPhysiology'; //产妇每日生理护理记录批处理
pad.batchAddMaterRehNursEvalData = pad.baseUrl + '/formRecord/batchAddMaterRehNursEvalData'; //产妇康复护理评估记录批处理


pad.batchHeathRecordDetail = pad.baseUrl + '/formRecord/BatchHeathRecordDetail'; //健康咨询批处理 记录详情
//护理特情上报
pad.getSpecialReport = pad.baseUrl + '/Member/specialReport'; //特情上报
pad.getDepartmentList = pad.baseUrl + '/Member/getDepartmentList'; //特情上报
pad.specialReportAdd = pad.baseUrl + '/Member/specialReportAdd'; //特情上报
pad.getPositionList = pad.baseUrl + '/Member/getPositionList'; //获取上报职位
pad.getMaternalAgentList = pad.baseUrl + '/Member/getAgentList'; //上报人

//客房部特情上报
pad.getSpecialReportRoom = pad.baseUrl + '/Member/specialReportRoom'; //特情上报
pad.specialReportAddRoom = pad.baseUrl + '/Member/specialReportAddRoom'; //特情上报
//餐饮部特情上报
pad.getSpecialReportMeal = pad.baseUrl + '/Member/specialReportMeal'; //特情上报
pad.specialReportAddMeal = pad.baseUrl + '/Member/specialReportAddMeal'; //特情上报

module.exports = pad;

/***/ }),

/***/ "oPtZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oV47":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAJiElEQVR4Xu2aC3CU1RXHf2cDhPdDFDAoj2RTLQIFCxgEpBRKVZRXLQyPGQGpqBQp1ibLw3YtEjagTi1WfFAQp6SIj4oUdVDAIvLwURkoCu6GVxF5P5SaAMnezt0vYZdNdr/7bTYOM8md2Zmd7zvnf873/849955zP6GaD6nmz08NATURUM0ZqJkC1TwAapJgzRSomQLVnIHvbQq086q6tVLJwkVPFD0RGpdyXwicEDih4BBBthafY8s+rxR9H++mSgnImK9auEoYpWCEQA+EWkYPpShWwicoVuHi5UC2FBjpJSBUJQS489Q1Cma64B6gdgJ+RatsQzHV75ENScC6BCKpBLSZq5qlupiuFFNEqOvE2eb1YVIWBI7DF0dhx+Hy2kqRT5DfBGbIMSfY8WSTRkD7+apzSglrRGiZiHMZzeHFEWHNQ2dgxQ54zw9nIrOB4kSxi2F7s+WDROxE6ySFgHSfGuSCFSLUT9SpLmmwYEh57XPF8K4f8j+D/56x7isoUQpPgUceT9RemV6lCcjIUzMFZguV21UOzIRHBsR+HE3Ec1vhle1hGaVYGPDIA5UhoVIEuOepaaJ4sjIOlOmO7wYTutsjbd4Pj6wBTUgoGipJQsIEpOep/i4VmvMue7fjS2S1gVn9oYlh2vz8CPx2NZw9Z+EGYVZBjsxJxI+ECGg/R7WslcJOhOaJGNU6DerAXZ3hjuuhVSPnKIETcN/rViQoRVC5uKUgWz50ipQQAe48tU6gn1NjkfITusH4iJAvUbDObyW6tCbQp51FUryxaT/kvHVxKhwpqkOHgw/JSSd+OSYgc64ah4slToxUJNskFcZ1B7386XHgNDz+L+t/w1RYMQYapdpbWbjFWiFCU0Exr8AjOfZaYQlHBNzgVXXO1+Mr4EonRpzKTusNwzuZaZUE4d7X4ctjoeWxsLgOafumyWkzbYdLV6ZPTUJ41hQ8EbmOLeGZ4c4c00lx0usXp0JuwCMzTW07igC3T+0W4Qem4E7ltDOLfwnuBOLrwZXw2aGQxeP+pqQxSS6Y2DcmIH2u6p7i4iMNOq5baL7x5k44ncSitV8G/HGgidvlZRZ/DEs+Kb0u3OnPln+aIBkTkJmnHgNCobXoLrjuKogMPRNj8WTq1oaXR8MVDjfT+kU8vxWWlSbCkA3Fi36PjDfxyZgAd57aKNBLL03v6CLXyrr0NcwIKQKdrobD31q/6NGjDTwxyMTlsExxEGa8DZsPlNPb68+RdBM0MwK8ypVZDx3stW9pD3NuDUP3WWhiBu7vCaO7WLKnCmHfKXhuC+w8Yl2LVQzFQ5/xDnywt2KJ04U0OuaVs3beGRHQLlddXzuFLzTYXZ1gau8w7M//Ct+dj22mQwtonAoz+kOzepfK7T8Ndy/XpR20bgzLx9i5G77/9i7IXR9bviRIjz3T5WM7RCMCdLmbIoSSyqSbYOyNYdiRy+DQN7HNPDccOsTpEMxdD2/tgmubQP5oO3fD90fnh8vjirSUYnDAI6vsEI0IcOepMQJ/02Az+sFt14dhp74J/9ZboxjDdxv0ahf7/v/Ow+Q3oGVDyLvdzl3r/rfn4PbFNrKKMX6P5NshmhEwT00UxQsazPsz6O8Ow77wEbz0aWwz0YRVJKlzwoUSaNHQzl3r/onvYOjS+LJK+FUgWxbZIRoRkOlToxGWabDf9YXBHcKwOvzHLrceoKIxpReM6GznhvP7I/NBt81ijmRGQOY8dUeoRQ3c093aCEUOnYm978L5Cki4LwvGdHX+gHYanxyEaXFmuFIMDXhkpR2OUQSk+1SnFCHUjIrVutJv4/BZ2LAHVu+GotKN6M1trQgInIQdX1sNzr7pMKwj6L1BZcarO+CpjRUjBIN0K5gucSanpWfkgvvPKlUKQ/sA2jSFZaPiu73tEDy0Ci4EY8ulX2H1AN0Jt1Qs7He+hDlry9upU0jqTq/EWaAdEKBF3T61XYRQkbpiLFxt08VZ8CGsiGhgVkSFZn94R5jSu3LR8OyWqK0wbPfnyI9MossoAkoJeFqEyfr/1F5WOyve0Juj1/5jEaUPPR59z8reFQ09JX4/AOqkmLhcXkZvyaeuhG1fW/cUPB3IkSkmaMYERG6GOreCvwwzgQ/LDFkKJ2MQoKXSGsP9WdA3w3BeRpnfegAeXm1dLBEG7cmW0mZZfD+NCcCrXO66HBbhKg2pCdBEmAwF3GJYM9zQEp4dboJ6qYzuDeoeoVIcCxTRCq/EyUBhXXMCgEyfmo0wS6v/sAU8/wszR3X7+ja7nVsElN47aHz9q2XQdNcd4vErSgEUj/k98oiZZw6jzZ2rrhIXBxFC/dpHB8JPM+xN6Tk6cFH4MMNew5K4sgE8NdhaeWINjT3xVfAft3qC54O0PjBdTpnacBQBGtTtU3NEmKH/6+bF0pHQ1OBA45nN8Pdtpm6F5UZ1gQd6xtbL3wYLN1v3lcJRP1DrOCYg1Bmuy26EUInT/VqYd7t9qOpdou7bldX/plTk3gp92lcsveuodTiiy2mlCKQWcYPJ2h+J5pgArZyZq27CxcayLz50taebJHY7O50LdOW3x/DoYnRXa2WoaOgl9d7X4KhueSiKcdHdny2OYywhArRDGT71sEuYX+ac3iLPGmAfUoUXIHcdvL8nfgxEd54ipfXDT/4HfBXuQ2T7c+SiL6bRldAUiAR356kFAr8uu6a7up6fQH2bIy0tv+RjWFzWxY3yWOu/MgYaV5Bb9NFZ9mo4GP5W4JVAjkR8WuHk8e1fmC2a26eeFGFamaDO3Lpk1kWQ3Zj9Hqzxl5eKbruVSawNgO/9cKEFrFX1GBR4UErPie0slr+f8BSIigSvwB8ir2VdC6O6wo2tYzulixhdzESPP90JP74mfFVXmvM2wKcHw9cUPBEoJNt0wxPLi6QQoMHdc9VAcYWaJpec67RtZnWDdSaPPuzUh6ErP7/UtdopsGaitaroj6V0QbU+YGV6PUo/j5lQ4JGXnL/vKoqAMli9USKFRQKDo01ppq9rYTU/9fF3WiPYcgDWR30B2K6ZRZZusujWeeRQoLPGlECObEnGw2uMpEVApEMZeWqoC3z6mZPk6O4geApy5I0k4V2EqRICQuhe5cpIZYgId4ug+71OP5i8oBS6olsSKGJVZed6leeAeG+m5XzVoEGQrBS4WUFbUbRVkCaCXisahOa24hsRtirFxqBiU9E5Nh3ySpwCOjmxUHURkBz/qhylhoAqp/gyN1ATAZf5C6py92oioMopvswNVPsI+D96Qd9frg5jtAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "pUzx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


!function (e, t) {
  if ("object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(exports)) && "object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(module))) module.exports = t();else if ("function" == typeof define && __webpack_require__("nErl")) define([], t);else {
    var n = t();for (var r in n) {
      ("object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(exports)) ? exports : e)[r] = n[r];
    }
  }
}(this, function () {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;var i = r[n] = { exports: {}, id: n, loaded: !1 };return e[n].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
    }var n = window.webpackJsonp;window.webpackJsonp = function (r, o) {
      for (var a, s, u = 0, l = []; u < r.length; u++) {
        s = r[u], i[s] && l.push.apply(l, i[s]), i[s] = 0;
      }for (a in o) {
        e[a] = o[a];
      }for (n && n(r, o); l.length;) {
        l.shift().call(null, t);
      }
    };var r = {},
        i = { 0: 0 };return t.e = function (e, n) {
      if (0 === i[e]) return n.call(null, t);if (void 0 !== i[e]) i[e].push(n);else {
        i[e] = [n];var r = document.getElementsByTagName("head")[0],
            o = document.createElement("script");o.type = "text/javascript", o.charset = "utf-8", o.async = !0, o.src = t.p + "" + ({}[e] || e) + ".chunk.js", r.appendChild(o);
      }
    }, t.m = e, t.c = r, t.p = "", t(0);
  }([function (e, t, n) {
    function r(e, t) {
      var n = this;if (!e) throw new Error("没有收到图片，可能的解决方案：https://github.com/think2011/localResizeIMG/issues/7");t = t || {}, n.defaults = { width: null, height: null, fieldName: "file", quality: .7 }, n.file = e;for (var r in t) {
        t.hasOwnProperty(r) && (n.defaults[r] = t[r]);
      }return this.init();
    }function i(e) {
      var t = null;return t = e ? [].filter.call(document.scripts, function (t) {
        return -1 !== t.src.indexOf(e);
      })[0] : document.scripts[document.scripts.length - 1], t ? t.src.substr(0, t.src.lastIndexOf("/")) : null;
    }function o(e) {
      var t;t = e.split(",")[0].indexOf("base64") >= 0 ? atob(e.split(",")[1]) : unescape(e.split(",")[1]);for (var n = e.split(",")[0].split(":")[1].split(";")[0], r = new Uint8Array(t.length), i = 0; i < t.length; i++) {
        r[i] = t.charCodeAt(i);
      }return new s.Blob([r.buffer], { type: n });
    }n.p = i("lrz") + "/", window.URL = window.URL || window.webkitURL;var a = n(1),
        s = n(4),
        u = n(5),
        l = function (e) {
      var t = /OS (\d)_.* like Mac OS X/g.exec(e),
          n = /Android (\d.*?);/g.exec(e) || /Android\/(\d.*?) /g.exec(e);return { oldIOS: t ? +t.pop() < 8 : !1, oldAndroid: n ? +n.pop().substr(0, 3) < 4.5 : !1, iOS: /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(e), android: /Android/g.test(e), mQQBrowser: /MQQBrowser/g.test(e) };
    }(navigator.userAgent);r.prototype.init = function () {
      var e = this,
          t = e.file,
          n = "string" == typeof t,
          r = /^data:/.test(t),
          i = new Image(),
          u = document.createElement("canvas"),
          l = n ? t : URL.createObjectURL(t);if (e.img = i, e.blob = l, e.canvas = u, n ? e.fileName = r ? "base64.jpg" : t.split("/").pop() : e.fileName = t.name, !document.createElement("canvas").getContext) throw new Error("浏览器不支持canvas");return new a(function (n, a) {
        i.onerror = function () {
          var e = new Error("加载图片文件失败");throw a(e), e;
        }, i.onload = function () {
          e._getBase64().then(function (e) {
            if (e.length < 10) {
              var t = new Error("生成base64失败");throw a(t), t;
            }return e;
          }).then(function (r) {
            var i = null;"object" == __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(e.file) && r.length > e.file.size ? (i = new FormData(), t = e.file) : (i = new s.FormData(), t = o(r)), i.append(e.defaults.fieldName, t, e.fileName.replace(/\..+/g, ".jpg")), n({ formData: i, fileLen: +t.size, base64: r, base64Len: r.length, origin: e.file, file: t });for (var a in e) {
              e.hasOwnProperty(a) && (e[a] = null);
            }URL.revokeObjectURL(e.blob);
          });
        }, !r && (i.crossOrigin = "*"), i.src = l;
      });
    }, r.prototype._getBase64 = function () {
      var e = this,
          t = e.img,
          n = e.file,
          r = e.canvas;return new a(function (i) {
        try {
          u.getData("object" == (typeof n === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(n)) ? n : t, function () {
            e.orientation = u.getTag(this, "Orientation"), e.resize = e._getResize(), e.ctx = r.getContext("2d"), r.width = e.resize.width, r.height = e.resize.height, e.ctx.fillStyle = "#fff", e.ctx.fillRect(0, 0, r.width, r.height), l.oldIOS ? e._createBase64ForOldIOS().then(i) : e._createBase64().then(i);
          });
        } catch (o) {
          throw new Error(o);
        }
      });
    }, r.prototype._createBase64ForOldIOS = function () {
      var e = this,
          t = e.img,
          r = e.canvas,
          i = e.defaults,
          o = e.orientation;return new a(function (e) {
        n.e(1, function (n) {
          var a = [n(6)];(function (n) {
            var a = new n(t);"5678".indexOf(o) > -1 ? a.render(r, { width: r.height, height: r.width, orientation: o }) : a.render(r, { width: r.width, height: r.height, orientation: o }), e(r.toDataURL("image/jpeg", i.quality));
          }).apply(null, a);
        });
      });
    }, r.prototype._createBase64 = function () {
      var e = this,
          t = e.resize,
          r = e.img,
          i = e.canvas,
          o = e.ctx,
          s = e.defaults,
          u = e.orientation;switch (u) {case 3:
          o.rotate(180 * Math.PI / 180), o.drawImage(r, -t.width, -t.height, t.width, t.height);break;case 6:
          o.rotate(90 * Math.PI / 180), o.drawImage(r, 0, -t.width, t.height, t.width);break;case 8:
          o.rotate(270 * Math.PI / 180), o.drawImage(r, -t.height, 0, t.height, t.width);break;case 2:
          o.translate(t.width, 0), o.scale(-1, 1), o.drawImage(r, 0, 0, t.width, t.height);break;case 4:
          o.translate(t.width, 0), o.scale(-1, 1), o.rotate(180 * Math.PI / 180), o.drawImage(r, -t.width, -t.height, t.width, t.height);break;case 5:
          o.translate(t.width, 0), o.scale(-1, 1), o.rotate(90 * Math.PI / 180), o.drawImage(r, 0, -t.width, t.height, t.width);break;case 7:
          o.translate(t.width, 0), o.scale(-1, 1), o.rotate(270 * Math.PI / 180), o.drawImage(r, -t.height, 0, t.height, t.width);break;default:
          o.drawImage(r, 0, 0, t.width, t.height);}return new a(function (e) {
        l.oldAndroid || l.mQQBrowser || !navigator.userAgent ? n.e(2, function (t) {
          var n = [t(7)];(function (t) {
            var n = new t(),
                r = o.getImageData(0, 0, i.width, i.height);e(n.encode(r, 100 * s.quality));
          }).apply(null, n);
        }) : e(i.toDataURL("image/jpeg", s.quality));
      });
    }, r.prototype._getResize = function () {
      var e = this,
          t = e.img,
          n = e.defaults,
          r = n.width,
          i = n.height,
          o = e.orientation,
          a = { width: t.width, height: t.height };if ("5678".indexOf(o) > -1 && (a.width = t.height, a.height = t.width), a.width < r || a.height < i) return a;var s = a.width / a.height;for (r && i ? s >= r / i ? a.width > r && (a.width = r, a.height = Math.ceil(r / s)) : a.height > i && (a.height = i, a.width = Math.ceil(i * s)) : r ? r < a.width && (a.width = r, a.height = Math.ceil(r / s)) : i && i < a.height && (a.width = Math.ceil(i * s), a.height = i); a.width >= 3264 || a.height >= 2448;) {
        a.width *= .8, a.height *= .8;
      }return a;
    }, window.lrz = function (e, t) {
      return new r(e, t);
    }, window.lrz.version = "4.9.40", e.exports = window.lrz;
  }, function (e, t, n) {
    (function (t) {
      !function (n) {
        function r(e, t) {
          return function () {
            e.apply(t, arguments);
          };
        }function i(e) {
          if ("object" != __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this)) throw new TypeError("Promises must be constructed via new");if ("function" != typeof e) throw new TypeError("not a function");this._state = null, this._value = null, this._deferreds = [], c(e, r(a, this), r(s, this));
        }function o(e) {
          var t = this;return null === this._state ? void this._deferreds.push(e) : void f(function () {
            var n = t._state ? e.onFulfilled : e.onRejected;if (null === n) return void (t._state ? e.resolve : e.reject)(t._value);var r;try {
              r = n(t._value);
            } catch (i) {
              return void e.reject(i);
            }e.resolve(r);
          });
        }function a(e) {
          try {
            if (e === this) throw new TypeError("A promise cannot be resolved with itself.");if (e && ("object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(e)) || "function" == typeof e)) {
              var t = e.then;if ("function" == typeof t) return void c(r(t, e), r(a, this), r(s, this));
            }this._state = !0, this._value = e, u.call(this);
          } catch (n) {
            s.call(this, n);
          }
        }function s(e) {
          this._state = !1, this._value = e, u.call(this);
        }function u() {
          for (var e = 0, t = this._deferreds.length; t > e; e++) {
            o.call(this, this._deferreds[e]);
          }this._deferreds = null;
        }function l(e, t, n, r) {
          this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.resolve = n, this.reject = r;
        }function c(e, t, n) {
          var r = !1;try {
            e(function (e) {
              r || (r = !0, t(e));
            }, function (e) {
              r || (r = !0, n(e));
            });
          } catch (i) {
            if (r) return;r = !0, n(i);
          }
        }var f = "function" == typeof t && t || function (e) {
          setTimeout(e, 1);
        },
            d = Array.isArray || function (e) {
          return "[object Array]" === Object.prototype.toString.call(e);
        };i.prototype["catch"] = function (e) {
          return this.then(null, e);
        }, i.prototype.then = function (e, t) {
          var n = this;return new i(function (r, i) {
            o.call(n, new l(e, t, r, i));
          });
        }, i.all = function () {
          var e = Array.prototype.slice.call(1 === arguments.length && d(arguments[0]) ? arguments[0] : arguments);return new i(function (t, n) {
            function r(o, a) {
              try {
                if (a && ("object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(a)) || "function" == typeof a)) {
                  var s = a.then;if ("function" == typeof s) return void s.call(a, function (e) {
                    r(o, e);
                  }, n);
                }e[o] = a, 0 === --i && t(e);
              } catch (u) {
                n(u);
              }
            }if (0 === e.length) return t([]);for (var i = e.length, o = 0; o < e.length; o++) {
              r(o, e[o]);
            }
          });
        }, i.resolve = function (e) {
          return e && "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(e)) && e.constructor === i ? e : new i(function (t) {
            t(e);
          });
        }, i.reject = function (e) {
          return new i(function (t, n) {
            n(e);
          });
        }, i.race = function (e) {
          return new i(function (t, n) {
            for (var r = 0, i = e.length; i > r; r++) {
              e[r].then(t, n);
            }
          });
        }, i._setImmediateFn = function (e) {
          f = e;
        }, i.prototype.always = function (e) {
          var t = this.constructor;return this.then(function (n) {
            return t.resolve(e()).then(function () {
              return n;
            });
          }, function (n) {
            return t.resolve(e()).then(function () {
              throw n;
            });
          });
        }, "undefined" != typeof e && e.exports ? e.exports = i : n.Promise || (n.Promise = i);
      }(this);
    }).call(t, n(2).setImmediate);
  }, function (e, t, n) {
    (function (e, r) {
      function i(e, t) {
        this._id = e, this._clearFn = t;
      }var o = n(3).nextTick,
          a = Function.prototype.apply,
          s = Array.prototype.slice,
          u = {},
          l = 0;t.setTimeout = function () {
        return new i(a.call(setTimeout, window, arguments), clearTimeout);
      }, t.setInterval = function () {
        return new i(a.call(setInterval, window, arguments), clearInterval);
      }, t.clearTimeout = t.clearInterval = function (e) {
        e.close();
      }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
        this._clearFn.call(window, this._id);
      }, t.enroll = function (e, t) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
      }, t.unenroll = function (e) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
      }, t._unrefActive = t.active = function (e) {
        clearTimeout(e._idleTimeoutId);var t = e._idleTimeout;t >= 0 && (e._idleTimeoutId = setTimeout(function () {
          e._onTimeout && e._onTimeout();
        }, t));
      }, t.setImmediate = "function" == typeof e ? e : function (e) {
        var n = l++,
            r = arguments.length < 2 ? !1 : s.call(arguments, 1);return u[n] = !0, o(function () {
          u[n] && (r ? e.apply(null, r) : e.call(null), t.clearImmediate(n));
        }), n;
      }, t.clearImmediate = "function" == typeof r ? r : function (e) {
        delete u[e];
      };
    }).call(t, n(2).setImmediate, n(2).clearImmediate);
  }, function (e, t) {
    function n() {
      l = !1, a.length ? u = a.concat(u) : c = -1, u.length && r();
    }function r() {
      if (!l) {
        var e = setTimeout(n);l = !0;for (var t = u.length; t;) {
          for (a = u, u = []; ++c < t;) {
            a && a[c].run();
          }c = -1, t = u.length;
        }a = null, l = !1, clearTimeout(e);
      }
    }function i(e, t) {
      this.fun = e, this.array = t;
    }function o() {}var a,
        s = e.exports = {},
        u = [],
        l = !1,
        c = -1;s.nextTick = function (e) {
      var t = new Array(arguments.length - 1);if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }u.push(new i(e, t)), 1 !== u.length || l || setTimeout(r, 0);
    }, i.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = o, s.addListener = o, s.once = o, s.off = o, s.removeListener = o, s.removeAllListeners = o, s.emit = o, s.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, s.cwd = function () {
      return "/";
    }, s.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, s.umask = function () {
      return 0;
    };
  }, function (e, t) {
    function n() {
      var e = ~navigator.userAgent.indexOf("Android") && ~navigator.vendor.indexOf("Google") && !~navigator.userAgent.indexOf("Chrome");return e && navigator.userAgent.match(/AppleWebKit\/(\d+)/).pop() <= 534 || /MQQBrowser/g.test(navigator.userAgent);
    }var r = function () {
      try {
        return new Blob(), !0;
      } catch (e) {
        return !1;
      }
    }() ? window.Blob : function (e, t) {
      var n = new (window.BlobBuilder || window.WebKitBlobBuilder || window.MSBlobBuilder || window.MozBlobBuilder)();return e.forEach(function (e) {
        n.append(e);
      }), n.getBlob(t ? t.type : void 0);
    },
        i = function () {
      function e() {
        var e = this,
            n = [],
            i = Array(21).join("-") + (+new Date() * (1e16 * Math.random())).toString(36),
            o = XMLHttpRequest.prototype.send;this.getParts = function () {
          return n.toString();
        }, this.append = function (e, t, r) {
          n.push("--" + i + '\r\nContent-Disposition: form-data; name="' + e + '"'), t instanceof Blob ? (n.push('; filename="' + (r || "blob") + '"\r\nContent-Type: ' + t.type + "\r\n\r\n"), n.push(t)) : n.push("\r\n\r\n" + t), n.push("\r\n");
        }, t++, XMLHttpRequest.prototype.send = function (a) {
          var s,
              u,
              l = this;a === e ? (n.push("--" + i + "--\r\n"), u = new r(n), s = new FileReader(), s.onload = function () {
            o.call(l, s.result);
          }, s.onerror = function (e) {
            throw e;
          }, s.readAsArrayBuffer(u), this.setRequestHeader("Content-Type", "multipart/form-data; boundary=" + i), t--, 0 == t && (XMLHttpRequest.prototype.send = o)) : o.call(this, a);
        };
      }var t = 0;return e.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(FormData.prototype), e;
    }();e.exports = { Blob: r, FormData: n() ? i : FormData };
  }, function (e, t, n) {
    var r, i;(function () {
      function n(e) {
        return !!e.exifdata;
      }function o(e, t) {
        t = t || e.match(/^data\:([^\;]+)\;base64,/im)[1] || "", e = e.replace(/^data\:([^\;]+)\;base64,/gim, "");for (var n = atob(e), r = n.length, i = new ArrayBuffer(r), o = new Uint8Array(i), a = 0; r > a; a++) {
          o[a] = n.charCodeAt(a);
        }return i;
      }function a(e, t) {
        var n = new XMLHttpRequest();n.open("GET", e, !0), n.responseType = "blob", n.onload = function (e) {
          (200 == this.status || 0 === this.status) && t(this.response);
        }, n.send();
      }function s(e, t) {
        function n(n) {
          var r = u(n),
              i = l(n);e.exifdata = r || {}, e.iptcdata = i || {}, t && t.call(e);
        }if (e.src) {
          if (/^data\:/i.test(e.src)) {
            var r = o(e.src);n(r);
          } else if (/^blob\:/i.test(e.src)) {
            var i = new FileReader();i.onload = function (e) {
              n(e.target.result);
            }, a(e.src, function (e) {
              i.readAsArrayBuffer(e);
            });
          } else {
            var s = new XMLHttpRequest();s.onload = function () {
              200 == this.status || 0 === this.status ? n(s.response) : t(new Error("Could not load image")), s = null;
            }, s.open("GET", e.src, !0), s.responseType = "arraybuffer", s.send(null);
          }
        } else if (window.FileReader && (e instanceof window.Blob || e instanceof window.File)) {
          var i = new FileReader();i.onload = function (e) {
            p && console.log("Got file of length " + e.target.result.byteLength), n(e.target.result);
          }, i.readAsArrayBuffer(e);
        }
      }function u(e) {
        var t = new DataView(e);if (p && console.log("Got file of length " + e.byteLength), 255 != t.getUint8(0) || 216 != t.getUint8(1)) return p && console.log("Not a valid JPEG"), !1;for (var n, r = 2, i = e.byteLength; i > r;) {
          if (255 != t.getUint8(r)) return p && console.log("Not a valid marker at offset " + r + ", found: " + t.getUint8(r)), !1;if (n = t.getUint8(r + 1), p && console.log(n), 225 == n) return p && console.log("Found 0xFFE1 marker"), g(t, r + 4, t.getUint16(r + 2) - 2);r += 2 + t.getUint16(r + 2);
        }
      }function l(e) {
        var t = new DataView(e);if (p && console.log("Got file of length " + e.byteLength), 255 != t.getUint8(0) || 216 != t.getUint8(1)) return p && console.log("Not a valid JPEG"), !1;for (var n = 2, r = e.byteLength, i = function i(e, t) {
          return 56 === e.getUint8(t) && 66 === e.getUint8(t + 1) && 73 === e.getUint8(t + 2) && 77 === e.getUint8(t + 3) && 4 === e.getUint8(t + 4) && 4 === e.getUint8(t + 5);
        }; r > n;) {
          if (i(t, n)) {
            var o = t.getUint8(n + 7);o % 2 !== 0 && (o += 1), 0 === o && (o = 4);var a = n + 8 + o,
                s = t.getUint16(n + 6 + o);return c(e, a, s);
          }n++;
        }
      }function c(e, t, n) {
        for (var r, i, o, a, s, u = new DataView(e), l = {}, c = t; t + n > c;) {
          28 === u.getUint8(c) && 2 === u.getUint8(c + 1) && (a = u.getUint8(c + 2), a in b && (o = u.getInt16(c + 3), s = o + 5, i = b[a], r = h(u, c + 5, o), l.hasOwnProperty(i) ? l[i] instanceof Array ? l[i].push(r) : l[i] = [l[i], r] : l[i] = r)), c++;
        }return l;
      }function f(e, t, n, r, i) {
        var o,
            a,
            s,
            u = e.getUint16(n, !i),
            l = {};for (s = 0; u > s; s++) {
          o = n + 12 * s + 2, a = r[e.getUint16(o, !i)], !a && p && console.log("Unknown tag: " + e.getUint16(o, !i)), l[a] = d(e, o, t, n, i);
        }return l;
      }function d(e, t, n, r, i) {
        var o,
            a,
            s,
            u,
            l,
            c,
            f = e.getUint16(t + 2, !i),
            d = e.getUint32(t + 4, !i),
            g = e.getUint32(t + 8, !i) + n;switch (f) {case 1:case 7:
            if (1 == d) return e.getUint8(t + 8, !i);for (o = d > 4 ? g : t + 8, a = [], u = 0; d > u; u++) {
              a[u] = e.getUint8(o + u);
            }return a;case 2:
            return o = d > 4 ? g : t + 8, h(e, o, d - 1);case 3:
            if (1 == d) return e.getUint16(t + 8, !i);for (o = d > 2 ? g : t + 8, a = [], u = 0; d > u; u++) {
              a[u] = e.getUint16(o + 2 * u, !i);
            }return a;case 4:
            if (1 == d) return e.getUint32(t + 8, !i);for (a = [], u = 0; d > u; u++) {
              a[u] = e.getUint32(g + 4 * u, !i);
            }return a;case 5:
            if (1 == d) return l = e.getUint32(g, !i), c = e.getUint32(g + 4, !i), s = new Number(l / c), s.numerator = l, s.denominator = c, s;for (a = [], u = 0; d > u; u++) {
              l = e.getUint32(g + 8 * u, !i), c = e.getUint32(g + 4 + 8 * u, !i), a[u] = new Number(l / c), a[u].numerator = l, a[u].denominator = c;
            }return a;case 9:
            if (1 == d) return e.getInt32(t + 8, !i);for (a = [], u = 0; d > u; u++) {
              a[u] = e.getInt32(g + 4 * u, !i);
            }return a;case 10:
            if (1 == d) return e.getInt32(g, !i) / e.getInt32(g + 4, !i);for (a = [], u = 0; d > u; u++) {
              a[u] = e.getInt32(g + 8 * u, !i) / e.getInt32(g + 4 + 8 * u, !i);
            }return a;}
      }function h(e, t, n) {
        var r,
            i = "";for (r = t; t + n > r; r++) {
          i += String.fromCharCode(e.getUint8(r));
        }return i;
      }function g(e, t) {
        if ("Exif" != h(e, t, 4)) return p && console.log("Not valid EXIF data! " + h(e, t, 4)), !1;var n,
            r,
            i,
            o,
            a,
            s = t + 6;if (18761 == e.getUint16(s)) n = !1;else {
          if (19789 != e.getUint16(s)) return p && console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)"), !1;n = !0;
        }if (42 != e.getUint16(s + 2, !n)) return p && console.log("Not valid TIFF data! (no 0x002A)"), !1;var u = e.getUint32(s + 4, !n);if (8 > u) return p && console.log("Not valid TIFF data! (First offset less than 8)", e.getUint32(s + 4, !n)), !1;if (r = f(e, s, s + u, y, n), r.ExifIFDPointer) {
          o = f(e, s, s + r.ExifIFDPointer, w, n);for (i in o) {
            switch (i) {case "LightSource":case "Flash":case "MeteringMode":case "ExposureProgram":case "SensingMethod":case "SceneCaptureType":case "SceneType":case "CustomRendered":case "WhiteBalance":case "GainControl":case "Contrast":case "Saturation":case "Sharpness":case "SubjectDistanceRange":case "FileSource":
                o[i] = S[i][o[i]];break;case "ExifVersion":case "FlashpixVersion":
                o[i] = String.fromCharCode(o[i][0], o[i][1], o[i][2], o[i][3]);break;case "ComponentsConfiguration":
                o[i] = S.Components[o[i][0]] + S.Components[o[i][1]] + S.Components[o[i][2]] + S.Components[o[i][3]];}r[i] = o[i];
          }
        }if (r.GPSInfoIFDPointer) {
          a = f(e, s, s + r.GPSInfoIFDPointer, v, n);for (i in a) {
            switch (i) {case "GPSVersionID":
                a[i] = a[i][0] + "." + a[i][1] + "." + a[i][2] + "." + a[i][3];}r[i] = a[i];
          }
        }return r;
      }var p = !1,
          m = function m(e) {
        return e instanceof m ? e : this instanceof m ? void (this.EXIFwrapped = e) : new m(e);
      };"undefined" != typeof e && e.exports && (t = e.exports = m), t.EXIF = m;var w = m.Tags = { 36864: "ExifVersion", 40960: "FlashpixVersion", 40961: "ColorSpace", 40962: "PixelXDimension", 40963: "PixelYDimension", 37121: "ComponentsConfiguration", 37122: "CompressedBitsPerPixel", 37500: "MakerNote", 37510: "UserComment", 40964: "RelatedSoundFile", 36867: "DateTimeOriginal", 36868: "DateTimeDigitized", 37520: "SubsecTime", 37521: "SubsecTimeOriginal", 37522: "SubsecTimeDigitized", 33434: "ExposureTime", 33437: "FNumber", 34850: "ExposureProgram", 34852: "SpectralSensitivity", 34855: "ISOSpeedRatings", 34856: "OECF", 37377: "ShutterSpeedValue", 37378: "ApertureValue", 37379: "BrightnessValue", 37380: "ExposureBias", 37381: "MaxApertureValue", 37382: "SubjectDistance", 37383: "MeteringMode", 37384: "LightSource", 37385: "Flash", 37396: "SubjectArea", 37386: "FocalLength", 41483: "FlashEnergy", 41484: "SpatialFrequencyResponse", 41486: "FocalPlaneXResolution", 41487: "FocalPlaneYResolution", 41488: "FocalPlaneResolutionUnit", 41492: "SubjectLocation", 41493: "ExposureIndex", 41495: "SensingMethod", 41728: "FileSource", 41729: "SceneType", 41730: "CFAPattern", 41985: "CustomRendered", 41986: "ExposureMode", 41987: "WhiteBalance", 41988: "DigitalZoomRation", 41989: "FocalLengthIn35mmFilm", 41990: "SceneCaptureType", 41991: "GainControl", 41992: "Contrast", 41993: "Saturation", 41994: "Sharpness", 41995: "DeviceSettingDescription", 41996: "SubjectDistanceRange", 40965: "InteroperabilityIFDPointer", 42016: "ImageUniqueID" },
          y = m.TiffTags = { 256: "ImageWidth", 257: "ImageHeight", 34665: "ExifIFDPointer", 34853: "GPSInfoIFDPointer", 40965: "InteroperabilityIFDPointer", 258: "BitsPerSample", 259: "Compression", 262: "PhotometricInterpretation", 274: "Orientation", 277: "SamplesPerPixel", 284: "PlanarConfiguration", 530: "YCbCrSubSampling", 531: "YCbCrPositioning", 282: "XResolution", 283: "YResolution", 296: "ResolutionUnit", 273: "StripOffsets", 278: "RowsPerStrip", 279: "StripByteCounts", 513: "JPEGInterchangeFormat", 514: "JPEGInterchangeFormatLength", 301: "TransferFunction", 318: "WhitePoint", 319: "PrimaryChromaticities", 529: "YCbCrCoefficients", 532: "ReferenceBlackWhite", 306: "DateTime", 270: "ImageDescription", 271: "Make", 272: "Model", 305: "Software", 315: "Artist", 33432: "Copyright" },
          v = m.GPSTags = { 0: "GPSVersionID", 1: "GPSLatitudeRef", 2: "GPSLatitude", 3: "GPSLongitudeRef", 4: "GPSLongitude", 5: "GPSAltitudeRef", 6: "GPSAltitude", 7: "GPSTimeStamp", 8: "GPSSatellites", 9: "GPSStatus", 10: "GPSMeasureMode", 11: "GPSDOP", 12: "GPSSpeedRef", 13: "GPSSpeed", 14: "GPSTrackRef", 15: "GPSTrack", 16: "GPSImgDirectionRef", 17: "GPSImgDirection", 18: "GPSMapDatum", 19: "GPSDestLatitudeRef", 20: "GPSDestLatitude", 21: "GPSDestLongitudeRef", 22: "GPSDestLongitude", 23: "GPSDestBearingRef", 24: "GPSDestBearing", 25: "GPSDestDistanceRef", 26: "GPSDestDistance", 27: "GPSProcessingMethod", 28: "GPSAreaInformation", 29: "GPSDateStamp", 30: "GPSDifferential" },
          S = m.StringValues = { ExposureProgram: { 0: "Not defined", 1: "Manual", 2: "Normal program", 3: "Aperture priority", 4: "Shutter priority", 5: "Creative program", 6: "Action program", 7: "Portrait mode", 8: "Landscape mode" }, MeteringMode: { 0: "Unknown", 1: "Average", 2: "CenterWeightedAverage", 3: "Spot", 4: "MultiSpot", 5: "Pattern", 6: "Partial", 255: "Other" }, LightSource: { 0: "Unknown", 1: "Daylight", 2: "Fluorescent", 3: "Tungsten (incandescent light)", 4: "Flash", 9: "Fine weather", 10: "Cloudy weather", 11: "Shade", 12: "Daylight fluorescent (D 5700 - 7100K)", 13: "Day white fluorescent (N 4600 - 5400K)", 14: "Cool white fluorescent (W 3900 - 4500K)", 15: "White fluorescent (WW 3200 - 3700K)", 17: "Standard light A", 18: "Standard light B", 19: "Standard light C", 20: "D55", 21: "D65", 22: "D75", 23: "D50", 24: "ISO studio tungsten", 255: "Other" }, Flash: { 0: "Flash did not fire", 1: "Flash fired", 5: "Strobe return light not detected", 7: "Strobe return light detected", 9: "Flash fired, compulsory flash mode", 13: "Flash fired, compulsory flash mode, return light not detected", 15: "Flash fired, compulsory flash mode, return light detected", 16: "Flash did not fire, compulsory flash mode", 24: "Flash did not fire, auto mode", 25: "Flash fired, auto mode", 29: "Flash fired, auto mode, return light not detected", 31: "Flash fired, auto mode, return light detected", 32: "No flash function", 65: "Flash fired, red-eye reduction mode", 69: "Flash fired, red-eye reduction mode, return light not detected", 71: "Flash fired, red-eye reduction mode, return light detected", 73: "Flash fired, compulsory flash mode, red-eye reduction mode", 77: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected", 79: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected", 89: "Flash fired, auto mode, red-eye reduction mode", 93: "Flash fired, auto mode, return light not detected, red-eye reduction mode", 95: "Flash fired, auto mode, return light detected, red-eye reduction mode" }, SensingMethod: { 1: "Not defined", 2: "One-chip color area sensor", 3: "Two-chip color area sensor", 4: "Three-chip color area sensor", 5: "Color sequential area sensor", 7: "Trilinear sensor", 8: "Color sequential linear sensor" }, SceneCaptureType: { 0: "Standard", 1: "Landscape", 2: "Portrait", 3: "Night scene" }, SceneType: { 1: "Directly photographed" }, CustomRendered: { 0: "Normal process", 1: "Custom process" }, WhiteBalance: { 0: "Auto white balance", 1: "Manual white balance" }, GainControl: { 0: "None", 1: "Low gain up", 2: "High gain up", 3: "Low gain down", 4: "High gain down" }, Contrast: { 0: "Normal", 1: "Soft", 2: "Hard" }, Saturation: { 0: "Normal", 1: "Low saturation", 2: "High saturation" }, Sharpness: { 0: "Normal", 1: "Soft", 2: "Hard" }, SubjectDistanceRange: { 0: "Unknown", 1: "Macro", 2: "Close view", 3: "Distant view" }, FileSource: { 3: "DSC" }, Components: { 0: "", 1: "Y", 2: "Cb", 3: "Cr", 4: "R", 5: "G", 6: "B" } },
          b = { 120: "caption", 110: "credit", 25: "keywords", 55: "dateCreated", 80: "byline", 85: "bylineTitle", 122: "captionWriter", 105: "headline", 116: "copyright", 15: "category" };m.getData = function (e, t) {
        return (e instanceof Image || e instanceof HTMLImageElement) && !e.complete ? !1 : (n(e) ? t && t.call(e) : s(e, t), !0);
      }, m.getTag = function (e, t) {
        return n(e) ? e.exifdata[t] : void 0;
      }, m.getAllTags = function (e) {
        if (!n(e)) return {};var t,
            r = e.exifdata,
            i = {};for (t in r) {
          r.hasOwnProperty(t) && (i[t] = r[t]);
        }return i;
      }, m.pretty = function (e) {
        if (!n(e)) return "";var t,
            r = e.exifdata,
            i = "";for (t in r) {
          r.hasOwnProperty(t) && (i += "object" == __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(r[t]) ? r[t] instanceof Number ? t + " : " + r[t] + " [" + r[t].numerator + "/" + r[t].denominator + "]\r\n" : t + " : [" + r[t].length + " values]\r\n" : t + " : " + r[t] + "\r\n");
        }return i;
      }, m.readFromBinaryFile = function (e) {
        return u(e);
      }, r = [], i = function () {
        return m;
      }.apply(t, r), !(void 0 !== i && (e.exports = i));
    }).call(this);
  }]);
});
//# sourceMappingURL=lrz.bundle.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "pf3F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pjcA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ptd0":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "px3J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qpP9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qspp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r4pl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("3Ziz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s8bT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sVG7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sVzw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "skRI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "t2ar":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t3On":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "tTNl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tZYb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "twwr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ujcB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uu8v":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAACCElEQVR4Xu2Yu0oDURCG/xGTEFkLeysRX0AstFpBwQsWNvYiopVNOisFS7GwCxIfIK14Q4u10UYfQLC0sHcxxARHVtkQk7jZhRyyh5lTn50z883/n8sShA8SXj8UgCpAOAG1gHAB6CaoFlALCCegFhAuAD0F1AJqAeEE1ALCBaCngFpALSCcQGILTBY5M5zFrrdO+2li55Z4D2M48GapniSvRACC4p0Mzokx4m3QVJKFTM91T/kRjLf3OlaftqgWd73YABrFA/NgPKYSADDJwI1fw3JcCLEALB5z7sPBGQXFByPFAH7Tiw+hK4Cg+IqDKwBuQ1YpBxBCGPKxcrlD1Sg7RALoWLwFCmgq2Mv7WIiC8C+A6TLncz4u/nQ+jMx4xgC24240jXl1vHib9Br1nXvCoxjEeNLY/IUiESY6fBcJoSOAoPisj1sCZpImEjWfGYW7DTqKBFDiAgiHvVwXgFd1sPSwRpXWuG0A3DI77OO618X/OKd/AIKN8f7TwVwrhDYAprpvDYAgUVMQ+qiA+BYIPSJ6EwwhiD4GIyFIuQg1QxB7FQ4hiH4MtUGQ+BxuhiD2h0iPr6epCNf1OZyKLA0moQAMwrUitCrAijYZTFIVYBCuFaFVAVa0yWCSqgCDcK0IrQqwok0Gk1QFGIRrRWhVgBVtMpikKsAgXCtCqwKsaJPBJMUr4BuuHgtQuRiVWAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "uwyH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vT6z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vTCu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vngD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wAX/":
/***/ (function(module, exports) {

// 注意：此文件已不再使用，API 地址现在通过环境变量配置
// 开发/测试环境: 'http://8.130.210.205'
// 正式环境: https://test.erp.duobaby.net/api
// 如需修改 API 地址，请修改 config/dev.env.js 或 config/prod.env.js
window.g={
  baseUrl:""
}



/***/ }),

/***/ "wntg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xAxC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xhby":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xkOK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xqHI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y6ID":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yphJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z/9y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z8tP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zOyP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zQxN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e7c2f1785d9ddd1d2c3c.js